import React from 'react';

interface SalesmateBGIconProps {
  className?: string;
  [x: string]: unknown;
}

const SalesmateBGIcon: React.FC<SalesmateBGIconProps> = () => {
  return (
    <svg width="1452" height="679" viewBox="0 0 1452 679" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_710_15868"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="1452"
        height="679"
      >
        <path d="M1451.36 0H0V679H1451.36V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_710_15868)">
        <g style={{ mixBlendMode: 'overlay' }}>
          <path
            d="M620.355 215.818C618.085 215.818 616.243 217.66 616.243 219.931C616.243 222.201 618.085 224.043 620.355 224.043C622.626 224.043 624.468 222.209 624.468 219.931C624.468 217.652 622.626 215.818 620.355 215.818Z"
            fill="white"
          />
          <path
            d="M627.706 226.215C625.427 226.215 623.585 228.069 623.585 230.336C623.585 232.602 625.427 234.456 627.706 234.456C629.985 234.456 631.826 232.614 631.826 230.336C631.826 228.057 629.985 226.215 627.706 226.215Z"
            fill="white"
          />
          <path
            d="M614.529 223.844C612.25 223.844 610.408 225.686 610.408 227.964C610.408 230.243 612.25 232.085 614.529 232.085C616.808 232.085 618.65 230.231 618.65 227.964C618.65 225.698 616.795 223.844 614.529 223.844Z"
            fill="white"
          />
          <path
            d="M607.098 213.678C604.827 213.678 602.985 215.52 602.985 217.79C602.985 220.06 604.827 221.902 607.098 221.902C609.368 221.902 611.21 220.06 611.21 217.79C611.21 215.52 609.368 213.678 607.098 213.678Z"
            fill="white"
          />
          <path
            d="M612.917 206.305C610.646 206.305 608.817 208.138 608.817 210.404C608.817 212.67 610.651 214.504 612.917 214.504C615.183 214.504 617.016 212.67 617.016 210.404C617.016 208.138 615.183 206.305 612.917 206.305Z"
            fill="white"
          />
          <path
            d="M626.166 208.432C623.895 208.432 622.054 210.273 622.054 212.544C622.054 214.814 623.895 216.656 626.166 216.656C628.436 216.656 630.278 214.814 630.278 212.544C630.278 210.273 628.436 208.432 626.166 208.432Z"
            fill="white"
          />
          <path
            d="M633.54 218.162C631.27 218.162 629.428 220.004 629.428 222.274C629.428 224.545 631.27 226.386 633.54 226.386C635.81 226.386 637.652 224.545 637.652 222.274C637.652 220.004 635.819 218.162 633.54 218.162Z"
            fill="white"
          />
          <path
            d="M635.065 237.293C632.786 237.293 630.944 239.148 630.944 241.426C630.944 243.705 632.786 245.547 635.065 245.547C637.344 245.547 639.198 243.693 639.198 241.426C639.198 239.16 637.344 237.293 635.065 237.293Z"
            fill="white"
          />
          <path
            d="M621.895 234.785C619.616 234.785 617.774 236.627 617.774 238.906C617.774 241.185 619.616 243.027 621.895 243.027C624.174 243.027 626.016 241.185 626.016 238.906C626.016 236.627 624.174 234.785 621.895 234.785Z"
            fill="white"
          />
          <path
            d="M608.648 232.371C606.369 232.371 604.527 234.213 604.527 236.492C604.527 238.771 606.369 240.612 608.648 240.612C610.927 240.612 612.769 238.758 612.769 236.492C612.769 234.226 610.914 232.371 608.648 232.371Z"
            fill="white"
          />
          <path
            d="M601.195 221.68C598.925 221.68 597.074 223.521 597.074 225.8C597.074 228.079 598.925 229.921 601.195 229.921C603.465 229.921 605.316 228.079 605.316 225.8C605.316 223.521 603.474 221.68 601.195 221.68Z"
            fill="white"
          />
          <path
            d="M593.65 211.801C591.38 211.801 589.538 213.634 589.538 215.9C589.538 218.166 591.38 220 593.65 220C595.921 220 597.75 218.166 597.75 215.9C597.75 213.634 595.908 211.801 593.65 211.801Z"
            fill="white"
          />
          <path
            d="M599.518 204.443C597.261 204.443 595.419 206.277 595.419 208.543C595.419 210.809 597.261 212.642 599.518 212.642C601.776 212.642 603.631 210.809 603.631 208.543C603.631 206.277 601.789 204.443 599.518 204.443Z"
            fill="white"
          />
          <path
            d="M605.18 197.961C602.922 197.961 601.08 199.803 601.08 202.06C601.08 204.318 602.922 206.173 605.18 206.173C607.437 206.173 609.292 204.331 609.292 202.06C609.292 199.79 607.45 197.961 605.18 197.961Z"
            fill="white"
          />
          <path
            d="M618.557 199.803C616.3 199.803 614.458 201.645 614.458 203.915C614.458 206.185 616.3 208.014 618.557 208.014C620.815 208.014 622.657 206.173 622.657 203.915C622.657 201.657 620.824 199.803 618.557 199.803Z"
            fill="white"
          />
          <path
            d="M635.692 207.612C636.561 205.514 635.564 203.108 633.466 202.239C631.368 201.37 628.962 202.366 628.093 204.465C627.224 206.563 628.22 208.968 630.319 209.837C632.417 210.706 634.822 209.71 635.692 207.612Z"
            fill="white"
          />
          <path
            d="M639.436 210.812C637.158 210.812 635.324 212.654 635.324 214.925C635.324 217.195 637.158 219.037 639.436 219.037C641.715 219.037 643.549 217.195 643.549 214.925C643.549 212.654 641.707 210.812 639.436 210.812Z"
            fill="white"
          />
          <path
            d="M646.74 220.629C644.461 220.629 642.606 222.471 642.606 224.75C642.606 227.028 644.461 228.883 646.74 228.883C649.019 228.883 650.873 227.033 650.873 224.75C650.873 222.466 649.019 220.629 646.74 220.629Z"
            fill="white"
          />
          <path
            d="M640.87 228.717C638.591 228.717 636.736 230.559 636.736 232.837C636.736 235.116 638.591 236.971 640.87 236.971C643.149 236.971 644.99 235.116 644.99 232.837C644.99 230.559 643.149 228.717 640.87 228.717Z"
            fill="white"
          />
          <path
            d="M642.453 249.082C640.174 249.082 638.319 250.937 638.319 253.215C638.319 255.494 640.174 257.336 642.453 257.336C644.732 257.336 646.586 255.494 646.586 253.215C646.586 250.937 644.732 249.082 642.453 249.082Z"
            fill="white"
          />
          <path
            d="M629.255 246.545C626.976 246.545 625.134 248.387 625.134 250.666C625.134 252.944 626.976 254.786 629.255 254.786C631.533 254.786 633.375 252.932 633.375 250.666C633.375 248.399 631.521 246.545 629.255 246.545Z"
            fill="white"
          />
          <path
            d="M616.015 243.965C613.736 243.965 611.895 245.807 611.895 248.086C611.895 250.364 613.736 252.206 616.015 252.206C618.294 252.206 620.136 250.364 620.136 248.086C620.136 245.807 618.294 243.965 616.015 243.965Z"
            fill="white"
          />
          <path
            d="M602.65 241.537C600.371 241.537 598.529 243.379 598.529 245.658C598.529 247.937 600.371 249.778 602.65 249.778C604.929 249.778 606.771 247.937 606.771 245.658C606.771 243.379 604.916 241.537 602.65 241.537Z"
            fill="white"
          />
          <path
            d="M595.22 230.184C592.941 230.184 591.1 232.025 591.1 234.296C591.1 236.566 592.941 238.416 595.22 238.416C597.499 238.416 599.332 236.575 599.332 234.296C599.332 232.017 597.491 230.184 595.22 230.184Z"
            fill="white"
          />
          <path
            d="M587.674 219.775C585.403 219.775 583.562 221.617 583.562 223.896C583.562 226.175 585.403 228.008 587.674 228.008C589.944 228.008 591.786 226.166 591.786 223.896C591.786 221.626 589.944 219.775 587.674 219.775Z"
            fill="white"
          />
          <path
            d="M580.049 210.357C577.778 210.357 575.949 212.191 575.949 214.457C575.949 216.723 577.782 218.556 580.049 218.556C582.315 218.556 584.148 216.715 584.148 214.457C584.148 212.199 582.306 210.357 580.049 210.357Z"
            fill="white"
          />
          <path
            d="M585.938 202.893C583.681 202.893 581.839 204.726 581.839 206.992C581.839 209.258 583.681 211.092 585.938 211.092C588.196 211.092 590.038 209.258 590.038 206.992C590.038 204.726 588.204 202.893 585.938 202.893Z"
            fill="white"
          />
          <path
            d="M591.63 196.438C589.359 196.438 587.53 198.279 587.53 200.537C587.53 202.795 589.364 204.649 591.63 204.649C593.896 204.649 595.729 202.807 595.729 200.537C595.729 198.267 593.896 196.438 591.63 196.438Z"
            fill="white"
          />
          <path
            d="M597.024 190.891C594.774 190.891 592.945 192.711 592.945 194.969C592.945 197.227 594.779 199.06 597.024 199.06C599.268 199.06 601.115 197.227 601.115 194.969C601.115 192.711 599.281 190.891 597.024 190.891Z"
            fill="white"
          />
          <path
            d="M610.574 192.381C608.317 192.381 606.483 194.214 606.483 196.476C606.483 198.738 608.317 200.571 610.574 200.571C612.832 200.571 614.665 198.738 614.665 196.476C614.665 194.214 612.832 192.381 610.574 192.381Z"
            fill="white"
          />
          <path
            d="M624.009 194.225C621.751 194.225 619.918 196.058 619.918 198.316C619.918 200.573 621.751 202.415 624.009 202.415C626.267 202.415 628.1 200.582 628.1 198.316C628.1 196.049 626.267 194.225 624.009 194.225Z"
            fill="white"
          />
          <path
            d="M637.517 204.641C639.776 204.641 641.608 202.809 641.608 200.55C641.608 198.291 639.776 196.459 637.517 196.459C635.257 196.459 633.426 198.291 633.426 200.55C633.426 202.809 635.257 204.641 637.517 204.641Z"
            fill="white"
          />
          <path
            d="M645.27 204.443C642.992 204.443 641.158 206.277 641.158 208.556C641.158 210.834 642.992 212.668 645.27 212.668C647.549 212.668 649.383 210.826 649.383 208.556C649.383 206.285 647.541 204.443 645.27 204.443Z"
            fill="white"
          />
          <path
            d="M652.671 213.268C650.393 213.268 648.551 215.109 648.551 217.38C648.551 219.65 650.393 221.5 652.671 221.5C654.95 221.5 656.784 219.659 656.784 217.38C656.784 215.101 654.942 213.268 652.671 213.268Z"
            fill="white"
          />
          <path
            d="M659.873 222.961C657.594 222.961 655.739 224.803 655.739 227.082C655.739 229.36 657.594 231.215 659.873 231.215C662.152 231.215 664.006 229.373 664.006 227.082C664.006 224.79 662.156 222.961 659.873 222.961Z"
            fill="white"
          />
          <path
            d="M653.982 231.076C651.703 231.076 649.849 232.918 649.849 235.197C649.849 237.476 651.699 239.33 653.982 239.33C656.265 239.33 658.115 237.488 658.115 235.197C658.115 232.905 656.261 231.076 653.982 231.076Z"
            fill="white"
          />
          <path
            d="M648.208 239.768C645.929 239.768 644.074 241.609 644.074 243.888C644.074 246.167 645.924 248.022 648.208 248.022C650.491 248.022 652.341 246.171 652.341 243.888C652.341 241.605 650.487 239.768 648.208 239.768Z"
            fill="white"
          />
          <path
            d="M649.875 261.5C647.604 261.5 645.763 263.355 645.763 265.621C645.763 267.887 647.604 269.741 649.875 269.741C652.145 269.741 653.996 267.9 653.996 265.621C653.996 263.342 652.154 261.5 649.875 261.5Z"
            fill="white"
          />
          <path
            d="M636.634 259.127C634.355 259.127 632.514 260.969 632.514 263.239C632.514 265.51 634.355 267.36 636.634 267.36C638.913 267.36 640.755 265.518 640.755 263.239C640.755 260.96 638.905 259.127 636.634 259.127Z"
            fill="white"
          />
          <path
            d="M623.351 256.557C621.073 256.557 619.239 258.398 619.239 260.669C619.239 262.939 621.073 264.781 623.351 264.781C625.63 264.781 627.464 262.939 627.464 260.669C627.464 258.398 625.622 256.557 623.351 256.557Z"
            fill="white"
          />
          <path
            d="M609.988 253.988C607.718 253.988 605.876 255.822 605.876 258.088C605.876 260.354 607.718 262.2 609.988 262.2C612.259 262.2 614.1 260.367 614.1 258.088C614.1 255.809 612.259 253.988 609.988 253.988Z"
            fill="white"
          />
          <path
            d="M596.493 259.795C598.764 259.795 600.605 257.954 600.605 255.683C600.605 253.411 598.764 251.57 596.493 251.57C594.222 251.57 592.381 253.411 592.381 255.683C592.381 257.954 594.222 259.795 596.493 259.795Z"
            fill="white"
          />
          <path
            d="M589.113 239.322C586.834 239.322 584.992 241.164 584.992 243.443C584.992 245.722 586.834 247.555 589.113 247.555C591.392 247.555 593.234 245.713 593.234 243.443C593.234 241.173 591.392 239.322 589.113 239.322Z"
            fill="white"
          />
          <path
            d="M581.64 228.33C579.361 228.33 577.52 230.172 577.52 232.442C577.52 234.713 579.361 236.554 581.64 236.554C583.919 236.554 585.752 234.713 585.752 232.442C585.752 230.172 583.911 228.33 581.64 228.33Z"
            fill="white"
          />
          <path
            d="M574.06 218.457C571.79 218.457 569.948 220.299 569.948 222.569C569.948 224.84 571.79 226.69 574.06 226.69C576.331 226.69 578.173 224.848 578.173 222.569C578.173 220.29 576.331 218.457 574.06 218.457Z"
            fill="white"
          />
          <path
            d="M566.379 209.586C564.108 209.586 562.267 211.428 562.267 213.698C562.267 215.969 564.108 217.81 566.379 217.81C568.649 217.81 570.491 215.969 570.491 213.698C570.491 211.428 568.658 209.586 566.379 209.586Z"
            fill="white"
          />
          <path
            d="M572.29 202.033C570.033 202.033 568.199 203.867 568.199 206.133C568.199 208.399 570.033 210.224 572.29 210.224C574.548 210.224 576.39 208.39 576.39 206.133C576.39 203.875 574.548 202.033 572.29 202.033Z"
            fill="white"
          />
          <path
            d="M577.964 195.482C575.706 195.482 573.864 197.32 573.864 199.582C573.864 201.844 575.706 203.673 577.964 203.673C580.221 203.673 582.055 201.84 582.055 199.582C582.055 197.324 580.221 195.482 577.964 195.482Z"
            fill="white"
          />
          <path
            d="M583.337 189.809C581.079 189.809 579.246 191.642 579.246 193.9C579.246 196.157 581.079 197.978 583.337 197.978C585.595 197.978 587.415 196.153 587.415 193.9C587.415 191.646 585.582 189.809 583.337 189.809Z"
            fill="white"
          />
          <path
            d="M588.362 184.906C586.105 184.906 584.284 186.727 584.284 188.976C584.284 191.225 586.105 193.054 588.362 193.054C590.62 193.054 592.432 191.229 592.432 188.976C592.432 186.723 590.612 184.906 588.362 184.906Z"
            fill="white"
          />
          <path
            d="M602.098 186.023C599.849 186.023 598.028 187.844 598.028 190.093C598.028 192.342 599.849 194.167 602.098 194.167C604.347 194.167 606.176 192.342 606.176 190.093C606.176 187.844 604.343 186.023 602.098 186.023Z"
            fill="white"
          />
          <path
            d="M615.712 187.508C613.463 187.508 611.634 189.333 611.634 191.582C611.634 193.831 613.467 195.66 615.712 195.66C617.957 195.66 619.79 193.835 619.79 191.582C619.79 189.328 617.957 187.508 615.712 187.508Z"
            fill="white"
          />
          <path
            d="M629.348 189.299C627.099 189.299 625.27 191.132 625.27 193.386C625.27 195.639 627.103 197.472 629.348 197.472C631.593 197.472 633.426 195.639 633.426 193.386C633.426 191.132 631.605 189.299 629.348 189.299Z"
            fill="white"
          />
          <path
            d="M643.098 191.621C640.84 191.621 639.02 193.446 639.02 195.699C639.02 197.953 640.84 199.778 643.098 199.778C645.355 199.778 647.176 197.957 647.176 195.699C647.176 193.442 645.355 191.621 643.098 191.621Z"
            fill="white"
          />
          <path
            d="M651.05 199.01C648.792 199.01 646.95 200.852 646.95 203.109C646.95 205.367 648.792 207.209 651.05 207.209C653.307 207.209 655.149 205.375 655.149 203.109C655.149 200.843 653.316 199.01 651.05 199.01Z"
            fill="white"
          />
          <path
            d="M658.604 207.006C656.325 207.006 654.492 208.848 654.492 211.118C654.492 213.388 656.325 215.23 658.604 215.23C660.883 215.23 662.704 213.388 662.704 211.118C662.704 208.848 660.871 207.006 658.604 207.006Z"
            fill="white"
          />
          <path
            d="M665.87 215.727C663.591 215.727 661.749 217.568 661.749 219.847C661.749 222.126 663.591 223.959 665.87 223.959C668.149 223.959 669.99 222.118 669.99 219.847C669.99 217.577 668.136 215.727 665.87 215.727Z"
            fill="white"
          />
          <path
            d="M673 225.32C670.721 225.32 668.866 227.171 668.866 229.454C668.866 231.737 670.721 233.587 673 233.587C675.279 233.587 677.12 231.737 677.12 229.454C677.12 227.171 675.279 225.32 673 225.32Z"
            fill="white"
          />
          <path
            d="M667.058 233.305C664.779 233.305 662.938 235.159 662.938 237.438C662.938 239.717 664.779 241.559 667.058 241.559C669.337 241.559 671.192 239.717 671.192 237.438C671.192 235.159 669.337 233.305 667.058 233.305Z"
            fill="white"
          />
          <path
            d="M661.278 241.996C658.999 241.996 657.145 243.838 657.145 246.117C657.145 248.396 658.999 250.25 661.278 250.25C663.557 250.25 665.411 248.408 665.411 246.117C665.411 243.825 663.557 241.996 661.278 241.996Z"
            fill="white"
          />
          <path
            d="M655.587 251.375C653.308 251.375 651.453 253.23 651.453 255.508C651.453 257.787 653.303 259.642 655.587 259.642C657.87 259.642 659.72 257.792 659.72 255.508C659.72 253.225 657.87 251.375 655.587 251.375Z"
            fill="white"
          />
          <path
            d="M657.365 274.52C655.086 274.52 653.244 276.361 653.244 278.64C653.244 280.919 655.086 282.761 657.365 282.761C659.644 282.761 661.485 280.906 661.485 278.64C661.485 276.374 659.631 274.52 657.365 274.52Z"
            fill="white"
          />
          <path
            d="M644.056 272.471C641.777 272.471 639.936 274.312 639.936 276.583C639.936 278.853 641.777 280.704 644.056 280.704C646.335 280.704 648.168 278.862 648.168 276.583C648.168 274.304 646.327 272.471 644.056 272.471Z"
            fill="white"
          />
          <path
            d="M630.68 270.084C628.409 270.084 626.567 271.926 626.567 274.196C626.567 276.467 628.409 278.308 630.68 278.308C632.95 278.308 634.8 276.467 634.8 274.196C634.8 271.926 632.958 270.084 630.68 270.084Z"
            fill="white"
          />
          <path
            d="M617.275 275.736C619.546 275.736 621.387 273.895 621.387 271.624C621.387 269.353 619.546 267.512 617.275 267.512C615.004 267.512 613.163 269.353 613.163 271.624C613.163 273.895 615.004 275.736 617.275 275.736Z"
            fill="white"
          />
          <path
            d="M603.775 265.008C601.505 265.008 599.663 266.85 599.663 269.12C599.663 271.39 601.505 273.232 603.775 273.232C606.046 273.232 607.887 271.399 607.887 269.12C607.887 266.841 606.046 265.008 603.775 265.008Z"
            fill="white"
          />
          <path
            d="M590.152 262.666C587.895 262.666 586.053 264.499 586.053 266.765C586.053 269.032 587.895 270.865 590.152 270.865C592.41 270.865 594.264 269.032 594.264 266.765C594.264 264.499 592.423 262.666 590.152 262.666Z"
            fill="white"
          />
          <path
            d="M582.867 249.426C580.597 249.426 578.755 251.259 578.755 253.525C578.755 255.791 580.597 257.625 582.867 257.625C585.137 257.625 586.967 255.791 586.967 253.525C586.967 251.259 585.125 249.426 582.867 249.426Z"
            fill="white"
          />
          <path
            d="M575.478 237.582C573.208 237.582 571.366 239.424 571.366 241.694C571.366 243.965 573.208 245.815 575.478 245.815C577.749 245.815 579.591 243.973 579.591 241.694C579.591 239.415 577.749 237.582 575.478 237.582Z"
            fill="white"
          />
          <path
            d="M568.924 235.255C571.134 234.733 572.503 232.519 571.981 230.308C571.46 228.098 569.245 226.729 567.034 227.251C564.824 227.772 563.455 229.987 563.977 232.198C564.499 234.408 566.713 235.777 568.924 235.255Z"
            fill="white"
          />
          <path
            d="M560.352 217.861C558.082 217.861 556.24 219.703 556.24 221.974C556.24 224.244 558.082 226.086 560.352 226.086C562.623 226.086 564.473 224.244 564.473 221.974C564.473 219.703 562.631 217.861 560.352 217.861Z"
            fill="white"
          />
          <path
            d="M552.613 209.586C550.343 209.586 548.501 211.419 548.501 213.685C548.501 215.952 550.343 217.798 552.613 217.798C554.884 217.798 556.713 215.956 556.713 213.685C556.713 211.415 554.871 209.586 552.613 209.586Z"
            fill="white"
          />
          <path
            d="M558.554 201.883C556.296 201.883 554.463 203.716 554.463 205.974C554.463 208.231 556.296 210.073 558.554 210.073C560.812 210.073 562.653 208.231 562.653 205.974C562.653 203.716 560.82 201.883 558.554 201.883Z"
            fill="white"
          />
          <path
            d="M564.266 195.207C562.008 195.207 560.175 197.045 560.175 199.302C560.175 201.56 562.008 203.402 564.266 203.402C566.523 203.402 568.365 201.56 568.365 199.302C568.365 197.045 566.532 195.207 564.266 195.207Z"
            fill="white"
          />
          <path
            d="M569.63 189.479C567.381 189.479 565.552 191.312 565.552 193.557C565.552 195.802 567.385 197.648 569.63 197.648C571.875 197.648 573.721 195.814 573.721 193.557C573.721 191.299 571.888 189.479 569.63 189.479Z"
            fill="white"
          />
          <path
            d="M574.591 184.514C572.342 184.514 570.521 186.334 570.521 188.583C570.521 190.833 572.342 192.653 574.591 192.653C576.84 192.653 578.661 190.833 578.661 188.583C578.661 186.334 576.84 184.514 574.591 184.514Z"
            fill="white"
          />
          <path
            d="M579.191 180.059C576.942 180.059 575.134 181.871 575.134 184.111C575.134 186.352 576.946 188.164 579.191 188.164C581.436 188.164 583.239 186.352 583.239 184.111C583.239 181.871 581.427 180.059 579.191 180.059Z"
            fill="white"
          />
          <path
            d="M593.068 180.541C590.831 180.541 589.011 182.357 589.011 184.594C589.011 186.83 590.831 188.651 593.068 188.651C595.304 188.651 597.125 186.835 597.125 184.594C597.125 182.353 595.304 180.541 593.068 180.541Z"
            fill="white"
          />
          <path
            d="M606.912 181.59C604.675 181.59 602.854 183.41 602.854 185.647C602.854 187.883 604.675 189.708 606.912 189.708C609.148 189.708 610.969 187.892 610.969 185.647C610.969 183.402 609.156 181.59 606.912 181.59Z"
            fill="white"
          />
          <path
            d="M620.707 182.982C618.458 182.982 616.638 184.799 616.638 187.044C616.638 189.289 618.458 191.109 620.707 191.109C622.957 191.109 624.764 189.293 624.764 187.044C624.764 184.795 622.944 182.982 620.707 182.982Z"
            fill="white"
          />
          <path
            d="M634.657 184.746C632.42 184.746 630.6 186.562 630.6 188.812C630.6 191.061 632.42 192.869 634.657 192.869C636.893 192.869 638.726 191.052 638.726 188.812C638.726 186.571 636.906 184.746 634.657 184.746Z"
            fill="white"
          />
          <path
            d="M648.687 187.021C646.438 187.021 644.617 188.838 644.617 191.079C644.617 193.319 646.438 195.148 648.687 195.148C650.936 195.148 652.744 193.328 652.744 191.079C652.744 188.829 650.923 187.021 648.687 187.021Z"
            fill="white"
          />
          <path
            d="M656.814 194.123C654.556 194.123 652.723 195.956 652.723 198.214C652.723 200.472 654.556 202.305 656.814 202.305C659.071 202.305 660.905 200.472 660.905 198.214C660.905 195.956 659.071 194.123 656.814 194.123Z"
            fill="white"
          />
          <path
            d="M664.528 201.646C662.271 201.646 660.429 203.488 660.429 205.746C660.429 208.004 662.271 209.845 664.528 209.845C666.786 209.845 668.628 208.012 668.628 205.746C668.628 203.48 666.794 201.646 664.528 201.646Z"
            fill="white"
          />
          <path
            d="M671.904 209.699C669.634 209.699 667.792 211.541 667.792 213.82C667.792 216.099 669.634 217.941 671.904 217.941C674.175 217.941 676.025 216.086 676.025 213.82C676.025 211.554 674.183 209.699 671.904 209.699Z"
            fill="white"
          />
          <path
            d="M679.076 218.471C676.797 218.471 674.955 220.312 674.955 222.591C674.955 224.87 676.797 226.704 679.076 226.704C681.355 226.704 683.188 224.862 683.188 222.591C683.188 220.321 681.346 218.471 679.076 218.471Z"
            fill="white"
          />
          <path
            d="M686.146 228.08C683.867 228.08 682.013 229.935 682.013 232.222C682.013 234.509 683.867 236.355 686.146 236.355C688.425 236.355 690.288 234.501 690.288 232.222C690.288 229.943 688.433 228.08 686.146 228.08Z"
            fill="white"
          />
          <path
            d="M680.159 235.697C677.867 235.697 676.017 237.552 676.017 239.839C676.017 242.127 677.871 243.973 680.159 243.973C682.446 243.973 684.292 242.118 684.292 239.839C684.292 237.56 682.437 235.697 680.159 235.697Z"
            fill="white"
          />
          <path
            d="M674.353 244.16C672.061 244.16 670.211 246.015 670.211 248.302C670.211 250.589 672.061 252.435 674.353 252.435C676.644 252.435 678.486 250.585 678.486 248.302C678.486 246.019 676.636 244.16 674.353 244.16Z"
            fill="white"
          />
          <path
            d="M668.678 253.453C666.399 253.453 664.545 255.303 664.545 257.587C664.545 259.87 666.395 261.72 668.678 261.72C670.962 261.72 672.812 259.87 672.812 257.587C672.812 255.303 670.957 253.453 668.678 253.453Z"
            fill="white"
          />
          <path
            d="M663.06 263.57C660.781 263.57 658.939 265.412 658.939 267.691C658.939 269.97 660.781 271.812 663.06 271.812C665.339 271.812 667.181 269.97 667.181 267.691C667.181 265.412 665.331 263.57 663.06 263.57Z"
            fill="white"
          />
          <path
            d="M664.911 288.012C662.632 288.012 660.79 289.866 660.79 292.132C660.79 294.399 662.632 296.253 664.911 296.253C667.19 296.253 669.031 294.411 669.031 292.132C669.031 289.854 667.177 288.012 664.911 288.012Z"
            fill="white"
          />
          <path
            d="M651.488 286.375C649.209 286.375 647.367 288.217 647.367 290.496C647.367 292.775 649.209 294.616 651.488 294.616C653.767 294.616 655.609 292.762 655.609 290.496C655.609 288.23 653.767 286.375 651.488 286.375Z"
            fill="white"
          />
          <path
            d="M638.017 284.398C635.747 284.398 633.905 286.232 633.905 288.511C633.905 290.79 635.747 292.623 638.017 292.623C640.288 292.623 642.138 290.781 642.138 288.511C642.138 286.24 640.296 284.398 638.017 284.398Z"
            fill="white"
          />
          <path
            d="M624.531 282.098C622.261 282.098 620.419 283.939 620.419 286.21C620.419 288.48 622.261 290.331 624.531 290.331C626.802 290.331 628.643 288.489 628.643 286.21C628.643 283.931 626.802 282.098 624.531 282.098Z"
            fill="white"
          />
          <path
            d="M610.975 279.672C608.705 279.672 606.863 281.505 606.863 283.784C606.863 286.063 608.705 287.896 610.975 287.896C613.246 287.896 615.088 286.054 615.088 283.784C615.088 281.514 613.254 279.672 610.975 279.672Z"
            fill="white"
          />
          <path
            d="M597.354 277.318C595.084 277.318 593.242 279.152 593.242 281.418C593.242 283.684 595.084 285.517 597.354 285.517C599.625 285.517 601.454 283.684 601.454 281.418C601.454 279.152 599.621 277.318 597.354 277.318Z"
            fill="white"
          />
          <path
            d="M583.639 275.137C581.381 275.137 579.539 276.979 579.539 279.249C579.539 281.519 581.381 283.348 583.639 283.348C585.896 283.348 587.751 281.507 587.751 279.249C587.751 276.991 585.909 275.137 583.639 275.137Z"
            fill="white"
          />
          <path
            d="M576.454 260.666C574.196 260.666 572.354 262.499 572.354 264.765C572.354 267.032 574.196 268.865 576.454 268.865C578.712 268.865 580.566 267.032 580.566 264.765C580.566 262.499 578.724 260.666 576.454 260.666Z"
            fill="white"
          />
          <path
            d="M569.172 247.812C566.901 247.812 565.072 249.646 565.072 251.912C565.072 254.178 566.906 256.011 569.172 256.011C571.438 256.011 573.271 254.178 573.271 251.912C573.271 249.646 571.438 247.812 569.172 247.812Z"
            fill="white"
          />
          <path
            d="M561.758 236.543C559.487 236.543 557.646 238.385 557.646 240.655C557.646 242.926 559.487 244.767 561.758 244.767C564.028 244.767 565.87 242.926 565.87 240.655C565.87 238.385 564.037 236.543 561.758 236.543Z"
            fill="white"
          />
          <path
            d="M554.225 226.674C551.955 226.674 550.113 228.516 550.113 230.786C550.113 233.056 551.955 234.898 554.225 234.898C556.496 234.898 558.338 233.065 558.338 230.786C558.338 228.507 556.496 226.674 554.225 226.674Z"
            fill="white"
          />
          <path
            d="M546.544 217.941C544.273 217.941 542.444 219.783 542.444 222.054C542.444 224.324 544.278 226.153 546.544 226.153C548.81 226.153 550.656 224.32 550.656 222.054C550.656 219.787 548.814 217.941 546.544 217.941Z"
            fill="white"
          />
          <path
            d="M538.735 210.109C536.465 210.109 534.636 211.943 534.636 214.209C534.636 216.475 536.469 218.308 538.735 218.308C541.001 218.308 542.835 216.475 542.835 214.209C542.835 211.943 541.001 210.109 538.735 210.109Z"
            fill="white"
          />
          <path
            d="M544.701 202.32C542.444 202.32 540.61 204.154 540.61 206.411C540.61 208.669 542.444 210.511 544.701 210.511C546.959 210.511 548.792 208.677 548.792 206.411C548.792 204.145 546.959 202.32 544.701 202.32Z"
            fill="white"
          />
          <path
            d="M550.457 195.578C548.199 195.578 546.357 197.416 546.357 199.678C546.357 201.94 548.199 203.769 550.457 203.769C552.715 203.769 554.548 201.935 554.548 199.678C554.548 197.42 552.715 195.578 550.457 195.578Z"
            fill="white"
          />
          <path
            d="M555.859 189.789C553.609 189.789 551.78 191.622 551.78 193.867C551.78 196.112 553.614 197.946 555.859 197.946C558.103 197.946 559.937 196.121 559.937 193.867C559.937 191.614 558.103 189.789 555.859 189.789Z"
            fill="white"
          />
          <path
            d="M560.846 184.742C558.597 184.742 556.776 186.563 556.776 188.812C556.776 191.061 558.597 192.882 560.846 192.882C563.095 192.882 564.916 191.061 564.916 188.812C564.916 186.563 563.095 184.742 560.846 184.742Z"
            fill="white"
          />
          <path
            d="M565.39 180.275C563.154 180.275 561.342 182.092 561.342 184.328C561.342 186.565 563.154 188.377 565.39 188.377C567.627 188.377 569.439 186.565 569.439 184.328C569.439 182.092 567.627 180.275 565.39 180.275Z"
            fill="white"
          />
          <path
            d="M569.524 176.166C567.296 176.166 565.484 177.974 565.484 180.206C565.484 182.438 567.296 184.246 569.524 184.246C571.752 184.246 573.564 182.434 573.564 180.206C573.564 177.978 571.752 176.166 569.524 176.166Z"
            fill="white"
          />
          <path
            d="M583.46 183.991C585.691 183.991 587.5 182.18 587.5 179.947C587.5 177.713 585.691 175.902 583.46 175.902C581.229 175.902 579.42 177.713 579.42 179.947C579.42 182.18 581.229 183.991 583.46 183.991Z"
            fill="white"
          />
          <path
            d="M597.519 176.396C595.283 176.396 593.471 178.209 593.471 180.437C593.471 182.664 595.283 184.481 597.519 184.481C599.756 184.481 601.559 182.673 601.559 180.437C601.559 178.2 599.747 176.396 597.519 176.396Z"
            fill="white"
          />
          <path
            d="M611.55 177.332C609.322 177.332 607.51 179.144 607.51 181.376C607.51 183.609 609.322 185.421 611.55 185.421C613.778 185.421 615.598 183.609 615.598 181.376C615.598 179.144 613.786 177.332 611.55 177.332Z"
            fill="white"
          />
          <path
            d="M625.707 178.559C623.47 178.559 621.658 180.375 621.658 182.607C621.658 184.839 623.47 186.656 625.707 186.656C627.943 186.656 629.755 184.844 629.755 182.607C629.755 180.371 627.943 178.559 625.707 178.559Z"
            fill="white"
          />
          <path
            d="M640.038 180.326C637.801 180.326 635.989 182.142 635.989 184.379C635.989 186.615 637.801 188.427 640.038 188.427C642.274 188.427 644.095 186.615 644.095 184.379C644.095 182.142 642.274 180.326 640.038 180.326Z"
            fill="white"
          />
          <path
            d="M654.369 182.451C652.119 182.451 650.312 184.263 650.312 186.5C650.312 188.736 652.124 190.557 654.369 190.557C656.613 190.557 658.417 188.74 658.417 186.5C658.417 184.259 656.605 182.451 654.369 182.451Z"
            fill="white"
          />
          <path
            d="M662.631 189.424C660.382 189.424 658.562 191.244 658.562 193.494C658.562 195.743 660.382 197.563 662.631 197.563C664.881 197.563 666.71 195.743 666.71 193.494C666.71 191.244 664.876 189.424 662.631 189.424Z"
            fill="white"
          />
          <path
            d="M670.482 196.744C668.225 196.744 666.383 198.586 666.383 200.844C666.383 203.101 668.225 204.943 670.482 204.943C672.74 204.943 674.582 203.11 674.582 200.844C674.582 198.577 672.748 196.744 670.482 196.744Z"
            fill="white"
          />
          <path
            d="M677.986 204.541C675.716 204.541 673.874 206.383 673.874 208.653C673.874 210.924 675.716 212.753 677.986 212.753C680.257 212.753 682.086 210.919 682.086 208.653C682.086 206.387 680.252 204.541 677.986 204.541Z"
            fill="white"
          />
          <path
            d="M685.216 212.844C682.938 212.844 681.096 214.686 681.096 216.956C681.096 219.226 682.938 221.077 685.216 221.077C687.495 221.077 689.337 219.235 689.337 216.956C689.337 214.677 687.487 212.844 685.216 212.844Z"
            fill="white"
          />
          <path
            d="M692.266 221.572C689.987 221.572 688.146 223.427 688.146 225.706C688.146 227.985 689.987 229.826 692.266 229.826C694.545 229.826 696.4 227.972 696.4 225.706C696.4 223.44 694.549 221.572 692.266 221.572Z"
            fill="white"
          />
          <path
            d="M699.246 230.922C696.955 230.922 695.104 232.776 695.104 235.055C695.104 237.334 696.955 239.197 699.246 239.197C701.538 239.197 703.38 237.343 703.38 235.055C703.38 232.768 701.525 230.922 699.246 230.922Z"
            fill="white"
          />
          <path
            d="M693.263 238.355C690.972 238.355 689.13 240.206 689.13 242.489C689.13 244.772 690.972 246.622 693.263 246.622C695.555 246.622 697.397 244.772 697.397 242.489C697.397 240.206 695.546 238.355 693.263 238.355Z"
            fill="white"
          />
          <path
            d="M687.457 246.607C685.178 246.607 683.323 248.462 683.323 250.749C683.323 253.037 685.178 254.883 687.457 254.883C689.736 254.883 691.599 253.032 691.599 250.749C691.599 248.466 689.744 246.607 687.457 246.607Z"
            fill="white"
          />
          <path
            d="M681.805 255.607C679.513 255.607 677.663 257.462 677.663 259.749C677.663 262.037 679.518 263.883 681.805 263.883C684.092 263.883 685.938 262.028 685.938 259.749C685.938 257.47 684.084 255.607 681.805 255.607Z"
            fill="white"
          />
          <path
            d="M676.237 265.496C673.958 265.496 672.104 267.351 672.104 269.63C672.104 271.908 673.954 273.75 676.237 273.75C678.52 273.75 680.358 271.908 680.358 269.63C680.358 267.351 678.516 265.496 676.237 265.496Z"
            fill="white"
          />
          <path
            d="M670.648 276.303C668.369 276.303 666.527 278.145 666.527 280.423C666.527 282.702 668.369 284.544 670.648 284.544C672.927 284.544 674.769 282.694 674.769 280.423C674.769 278.153 672.927 276.303 670.648 276.303Z"
            fill="white"
          />
          <path
            d="M672.46 301.777C670.189 301.777 668.348 303.619 668.348 305.89C668.348 308.16 670.189 310.002 672.46 310.002C674.73 310.002 676.572 308.16 676.572 305.89C676.572 303.619 674.73 301.777 672.46 301.777Z"
            fill="white"
          />
          <path
            d="M658.897 300.68C656.627 300.68 654.785 302.521 654.785 304.792C654.785 307.062 656.627 308.891 658.897 308.891C661.168 308.891 663.01 307.058 663.01 304.792C663.01 302.526 661.168 300.68 658.897 300.68Z"
            fill="white"
          />
          <path
            d="M645.312 299.248C643.055 299.248 641.213 301.09 641.213 303.36C641.213 305.631 643.055 307.46 645.312 307.46C647.57 307.46 649.425 305.618 649.425 303.36C649.425 301.103 647.583 299.248 645.312 299.248Z"
            fill="white"
          />
          <path
            d="M631.721 297.471C629.45 297.471 627.621 299.304 627.621 301.57C627.621 303.836 629.454 305.67 631.721 305.67C633.987 305.67 635.82 303.828 635.82 301.57C635.82 299.312 633.987 297.471 631.721 297.471Z"
            fill="white"
          />
          <path
            d="M618.099 295.369C615.841 295.369 613.999 297.202 613.999 299.469C613.999 301.735 615.841 303.568 618.099 303.568C620.356 303.568 622.198 301.726 622.198 299.469C622.198 297.211 620.365 295.369 618.099 295.369Z"
            fill="white"
          />
          <path
            d="M604.433 293.205C602.175 293.205 600.342 295.038 600.342 297.296C600.342 299.554 602.175 301.387 604.433 301.387C606.69 301.387 608.524 299.554 608.524 297.296C608.524 295.038 606.69 293.205 604.433 293.205Z"
            fill="white"
          />
          <path
            d="M590.705 291.1C588.434 291.1 586.605 292.933 586.605 295.199C586.605 297.465 588.439 299.29 590.705 299.29C592.971 299.29 594.796 297.457 594.796 295.199C594.796 292.941 592.963 291.1 590.705 291.1Z"
            fill="white"
          />
          <path
            d="M576.933 289.229C574.663 289.229 572.834 291.062 572.834 293.319C572.834 295.577 574.667 297.41 576.933 297.41C579.2 297.41 581.024 295.577 581.024 293.319C581.024 291.062 579.191 289.229 576.933 289.229Z"
            fill="white"
          />
          <path
            d="M569.889 273.355C567.618 273.355 565.776 275.197 565.776 277.468C565.776 279.738 567.618 281.567 569.889 281.567C572.159 281.567 573.988 279.725 573.988 277.468C573.988 275.21 572.146 273.355 569.889 273.355Z"
            fill="white"
          />
          <path
            d="M562.708 259.283C560.437 259.283 558.596 261.125 558.596 263.395C558.596 265.666 560.437 267.495 562.708 267.495C564.978 267.495 566.807 265.653 566.807 263.395C566.807 261.138 564.966 259.283 562.708 259.283Z"
            fill="white"
          />
          <path
            d="M555.401 246.98C553.131 246.98 551.302 248.814 551.302 251.08C551.302 253.346 553.135 255.179 555.401 255.179C557.667 255.179 559.501 253.346 559.501 251.08C559.501 248.814 557.659 246.98 555.401 246.98Z"
            fill="white"
          />
          <path
            d="M547.957 236.24C545.686 236.24 543.857 238.074 543.857 240.34C543.857 242.606 545.691 244.452 547.957 244.452C550.223 244.452 552.069 242.61 552.069 240.34C552.069 238.069 550.227 236.24 547.957 236.24Z"
            fill="white"
          />
          <path
            d="M540.382 226.818C538.124 226.818 536.282 228.66 536.282 230.931C536.282 233.201 538.124 235.03 540.382 235.03C542.639 235.03 544.494 233.197 544.494 230.931C544.494 228.664 542.652 226.818 540.382 226.818Z"
            fill="white"
          />
          <path
            d="M532.688 218.629C530.418 218.629 528.576 220.462 528.576 222.728C528.576 224.995 530.418 226.828 532.688 226.828C534.959 226.828 536.788 224.995 536.788 222.728C536.788 220.462 534.955 218.629 532.688 218.629Z"
            fill="white"
          />
          <path
            d="M524.884 211.398C522.613 211.398 520.771 213.232 520.771 215.498C520.771 217.764 522.613 219.597 524.884 219.597C527.154 219.597 528.983 217.764 528.983 215.498C528.983 213.232 527.15 211.398 524.884 211.398Z"
            fill="white"
          />
          <path
            d="M530.809 203.383C528.551 203.383 526.718 205.216 526.718 207.474C526.718 209.731 528.551 211.565 530.809 211.565C533.066 211.565 534.908 209.731 534.908 207.474C534.908 205.216 533.066 203.383 530.809 203.383Z"
            fill="white"
          />
          <path
            d="M536.549 196.426C534.291 196.426 532.458 198.251 532.458 200.513C532.458 202.774 534.291 204.603 536.549 204.603C538.807 204.603 540.64 202.77 540.64 200.513C540.64 198.255 538.807 196.426 536.549 196.426Z"
            fill="white"
          />
          <path
            d="M541.965 190.547C539.716 190.547 537.896 192.372 537.896 194.625C537.896 196.879 539.716 198.703 541.965 198.703C544.214 198.703 546.043 196.87 546.043 194.625C546.043 192.38 544.223 190.547 541.965 190.547Z"
            fill="white"
          />
          <path
            d="M546.99 185.488C544.741 185.488 542.92 187.309 542.92 189.558C542.92 191.807 544.741 193.624 546.99 193.624C549.239 193.624 551.059 191.803 551.059 189.558C551.059 187.313 549.239 185.488 546.99 185.488Z"
            fill="white"
          />
          <path
            d="M551.56 181.014C549.324 181.014 547.499 182.83 547.499 185.062C547.499 187.294 549.32 189.115 551.56 189.115C553.801 189.115 555.609 187.299 555.609 185.062C555.609 182.826 553.788 181.014 551.56 181.014Z"
            fill="white"
          />
          <path
            d="M555.66 176.922C553.432 176.922 551.633 178.73 551.633 180.953C551.633 183.177 553.432 184.985 555.66 184.985C557.888 184.985 559.7 183.181 559.7 180.953C559.7 178.725 557.888 176.922 555.66 176.922Z"
            fill="white"
          />
          <path
            d="M559.356 173.043C557.141 173.043 555.329 174.842 555.329 177.07C555.329 179.298 557.141 181.089 559.356 181.089C561.572 181.089 563.375 179.29 563.375 177.07C563.375 174.851 561.576 173.043 559.356 173.043Z"
            fill="white"
          />
          <path
            d="M573.335 172.203C571.107 172.203 569.308 174.002 569.308 176.23C569.308 178.458 571.107 180.249 573.335 180.249C575.563 180.249 577.354 178.45 577.354 176.23C577.354 174.011 575.554 172.203 573.335 172.203Z"
            fill="white"
          />
          <path
            d="M587.509 171.879C585.281 171.879 583.481 173.678 583.481 175.902C583.481 178.126 585.281 179.925 587.509 179.925C589.737 179.925 591.528 178.126 591.528 175.902C591.528 173.678 589.728 171.879 587.509 171.879Z"
            fill="white"
          />
          <path
            d="M601.832 172.266C599.604 172.266 597.805 174.073 597.805 176.297C597.805 178.521 599.604 180.325 601.832 180.325C604.06 180.325 605.859 178.517 605.859 176.297C605.859 174.078 604.06 172.266 601.832 172.266Z"
            fill="white"
          />
          <path
            d="M616.213 173.033C613.985 173.033 612.186 174.845 612.186 177.073C612.186 179.301 613.985 181.101 616.213 181.101C618.441 181.101 620.24 179.297 620.24 177.073C620.24 174.85 618.441 173.033 616.213 173.033Z"
            fill="white"
          />
          <path
            d="M630.846 174.117C628.618 174.117 626.806 175.921 626.806 178.149C626.806 180.377 628.618 182.18 630.846 182.18C633.074 182.18 634.873 180.381 634.873 178.149C634.873 175.917 633.074 174.117 630.846 174.117Z"
            fill="white"
          />
          <path
            d="M645.593 175.803C643.356 175.803 641.553 177.602 641.553 179.834C641.553 182.067 643.352 183.874 645.593 183.874C647.833 183.874 649.62 182.071 649.62 179.834C649.62 177.598 647.821 175.803 645.593 175.803Z"
            fill="white"
          />
          <path
            d="M660.23 177.729C658.003 177.729 656.19 179.541 656.19 181.769C656.19 183.997 658.003 185.809 660.23 185.809C662.458 185.809 664.271 183.997 664.271 181.769C664.271 179.541 662.458 177.729 660.23 177.729Z"
            fill="white"
          />
          <path
            d="M668.578 184.723C666.341 184.723 664.521 186.543 664.521 188.78C664.521 191.016 666.341 192.832 668.578 192.832C670.814 192.832 672.639 191.016 672.639 188.78C672.639 186.543 670.818 184.723 668.578 184.723Z"
            fill="white"
          />
          <path
            d="M676.503 192.068C674.254 192.068 672.434 193.889 672.434 196.138C672.434 198.387 674.254 200.208 676.503 200.208C678.753 200.208 680.573 198.387 680.573 196.138C680.573 193.889 678.753 192.068 676.503 192.068Z"
            fill="white"
          />
          <path
            d="M684.084 199.803C681.826 199.803 679.984 201.636 679.984 203.902C679.984 206.168 681.826 208.002 684.084 208.002C686.342 208.002 688.183 206.16 688.183 203.902C688.183 201.645 686.35 199.803 684.084 199.803Z"
            fill="white"
          />
          <path
            d="M691.379 207.809C689.108 207.809 687.267 209.65 687.267 211.921C687.267 214.191 689.108 216.033 691.379 216.033C693.649 216.033 695.478 214.191 695.478 211.921C695.478 209.65 693.645 207.809 691.379 207.809Z"
            fill="white"
          />
          <path
            d="M698.445 216.07C696.166 216.07 694.324 217.912 694.324 220.191C694.324 222.47 696.166 224.312 698.445 224.312C700.724 224.312 702.566 222.457 702.566 220.191C702.566 217.925 700.711 216.07 698.445 216.07Z"
            fill="white"
          />
          <path
            d="M705.387 224.668C703.108 224.668 701.254 226.51 701.254 228.789C701.254 231.068 703.104 232.909 705.387 232.909C707.671 232.909 709.508 231.068 709.508 228.789C709.508 226.51 707.666 224.668 705.387 224.668Z"
            fill="white"
          />
          <path
            d="M712.322 233.775C710.043 233.775 708.188 235.626 708.188 237.917C708.188 240.209 710.043 242.051 712.322 242.051C714.601 242.051 716.464 240.2 716.464 237.917C716.464 235.634 714.609 233.775 712.322 233.775Z"
            fill="white"
          />
          <path
            d="M706.325 240.934C704.034 240.934 702.184 242.788 702.184 245.067C702.184 247.346 704.034 249.209 706.325 249.209C708.617 249.209 710.459 247.354 710.459 245.067C710.459 242.78 708.609 240.934 706.325 240.934Z"
            fill="white"
          />
          <path
            d="M700.537 249.031C698.246 249.031 696.396 250.882 696.396 253.173C696.396 255.465 698.25 257.307 700.537 257.307C702.825 257.307 704.679 255.456 704.679 253.173C704.679 250.89 702.829 249.031 700.537 249.031Z"
            fill="white"
          />
          <path
            d="M694.938 257.898C692.659 257.898 690.805 259.753 690.805 262.032C690.805 264.311 692.659 266.174 694.938 266.174C697.217 266.174 699.08 264.319 699.08 262.032C699.08 259.744 697.226 257.898 694.938 257.898Z"
            fill="white"
          />
          <path
            d="M689.444 267.559C687.165 267.559 685.311 269.4 685.311 271.692C685.311 273.984 687.161 275.825 689.444 275.825C691.727 275.825 693.586 273.975 693.586 271.692C693.586 269.409 691.731 267.559 689.444 267.559Z"
            fill="white"
          />
          <path
            d="M683.948 278.039C681.669 278.039 679.827 279.881 679.827 282.16C679.827 284.439 681.669 286.28 683.948 286.28C686.227 286.28 688.081 284.439 688.081 282.16C688.081 279.881 686.227 278.039 683.948 278.039Z"
            fill="white"
          />
          <path
            d="M678.338 289.436C676.06 289.436 674.218 291.277 674.218 293.556C674.218 295.835 676.06 297.677 678.338 297.677C680.617 297.677 682.459 295.835 682.459 293.556C682.459 291.277 680.609 289.436 678.338 289.436Z"
            fill="white"
          />
          <path
            d="M679.908 315.484C677.638 315.484 675.809 317.318 675.809 319.584C675.809 321.85 677.642 323.675 679.908 323.675C682.174 323.675 683.999 321.842 683.999 319.584C683.999 317.326 682.166 315.484 679.908 315.484Z"
            fill="white"
          />
          <path
            d="M666.192 315.018C663.935 315.018 662.102 316.851 662.102 319.109C662.102 321.366 663.935 323.208 666.192 323.208C668.45 323.208 670.292 321.375 670.292 319.109C670.292 316.842 668.459 315.018 666.192 315.018Z"
            fill="white"
          />
          <path
            d="M652.498 314.27C650.241 314.27 648.407 316.103 648.407 318.361C648.407 320.618 650.241 322.46 652.498 322.46C654.756 322.46 656.589 320.627 656.589 318.361C656.589 316.094 654.756 314.27 652.498 314.27Z"
            fill="white"
          />
          <path
            d="M638.79 321.366C641.05 321.366 642.881 319.534 642.881 317.275C642.881 315.015 641.05 313.184 638.79 313.184C636.531 313.184 634.699 315.015 634.699 317.275C634.699 319.534 636.531 321.366 638.79 321.366Z"
            fill="white"
          />
          <path
            d="M625.084 311.729C622.835 311.729 621.006 313.562 621.006 315.819C621.006 318.077 622.839 319.898 625.084 319.898C627.329 319.898 629.175 318.077 629.175 315.819C629.175 313.562 627.342 311.729 625.084 311.729Z"
            fill="white"
          />
          <path
            d="M611.363 310.002C609.106 310.002 607.272 311.835 607.272 314.08C607.272 316.325 609.106 318.171 611.363 318.171C613.621 318.171 615.442 316.338 615.442 314.08C615.442 311.823 613.608 310.002 611.363 310.002Z"
            fill="white"
          />
          <path
            d="M597.592 308.24C595.343 308.24 593.514 310.061 593.514 312.318C593.514 314.576 595.347 316.397 597.592 316.397C599.837 316.397 601.683 314.576 601.683 312.318C601.683 310.061 599.85 308.24 597.592 308.24Z"
            fill="white"
          />
          <path
            d="M583.804 306.568C581.555 306.568 579.726 308.402 579.726 310.647C579.726 312.892 581.559 314.725 583.804 314.725C586.049 314.725 587.882 312.904 587.882 310.647C587.882 308.389 586.062 306.568 583.804 306.568Z"
            fill="white"
          />
          <path
            d="M570.004 305.1C567.746 305.1 565.926 306.933 565.926 309.178C565.926 311.423 567.746 313.256 570.004 313.256C572.262 313.256 574.074 311.423 574.074 309.178C574.074 306.933 572.253 305.1 570.004 305.1Z"
            fill="white"
          />
          <path
            d="M563.132 287.811C560.874 287.811 559.041 289.644 559.041 291.889C559.041 294.134 560.874 295.98 563.132 295.98C565.39 295.98 567.21 294.146 567.21 291.889C567.21 289.631 565.377 287.811 563.132 287.811Z"
            fill="white"
          />
          <path
            d="M556.075 272.283C553.818 272.283 551.984 274.117 551.984 276.383C551.984 278.649 553.818 280.474 556.075 280.474C558.333 280.474 560.175 278.64 560.175 276.383C560.175 274.125 558.342 272.283 556.075 272.283Z"
            fill="white"
          />
          <path
            d="M548.895 258.648C546.625 258.648 544.796 260.482 544.796 262.739C544.796 264.997 546.629 266.839 548.895 266.839C551.162 266.839 552.986 265.006 552.986 262.739C552.986 260.473 551.153 258.648 548.895 258.648Z"
            fill="white"
          />
          <path
            d="M541.57 246.76C539.3 246.76 537.458 248.593 537.458 250.859C537.458 253.125 539.3 254.971 541.57 254.971C543.841 254.971 545.682 253.13 545.682 250.859C545.682 248.589 543.841 246.76 541.57 246.76Z"
            fill="white"
          />
          <path
            d="M534.118 236.535C531.86 236.535 530.019 238.377 530.019 240.647C530.019 242.918 531.86 244.747 534.118 244.747C536.376 244.747 538.23 242.914 538.23 240.647C538.23 238.381 536.388 236.535 534.118 236.535Z"
            fill="white"
          />
          <path
            d="M526.552 227.729C524.281 227.729 522.452 229.562 522.452 231.828C522.452 234.094 524.285 235.927 526.552 235.927C528.818 235.927 530.651 234.094 530.651 231.828C530.651 229.562 528.818 227.729 526.552 227.729Z"
            fill="white"
          />
          <path
            d="M518.836 220.127C516.578 220.127 514.736 221.96 514.736 224.226C514.736 226.493 516.578 228.326 518.836 228.326C521.093 228.326 522.948 226.493 522.948 224.226C522.948 221.96 521.106 220.127 518.836 220.127Z"
            fill="white"
          />
          <path
            d="M510.99 213.52C508.72 213.52 506.891 215.353 506.891 217.619C506.891 219.885 508.724 221.71 510.99 221.71C513.256 221.71 515.081 219.877 515.081 217.619C515.081 215.361 513.248 213.52 510.99 213.52Z"
            fill="white"
          />
          <path
            d="M516.932 205.223C514.674 205.223 512.841 207.056 512.841 209.301C512.841 211.546 514.674 213.392 516.932 213.392C519.189 213.392 521.01 211.559 521.01 209.301C521.01 207.043 519.189 205.223 516.932 205.223Z"
            fill="white"
          />
          <path
            d="M522.669 198.014C520.411 198.014 518.578 199.847 518.578 202.092C518.578 204.337 520.411 206.183 522.669 206.183C524.927 206.183 526.76 204.35 526.76 202.092C526.76 199.834 524.927 198.014 522.669 198.014Z"
            fill="white"
          />
          <path
            d="M528.071 191.932C525.822 191.932 523.993 193.756 523.993 196.01C523.993 198.263 525.826 200.08 528.071 200.08C530.316 200.08 532.15 198.259 532.15 196.01C532.15 193.761 530.316 191.932 528.071 191.932Z"
            fill="white"
          />
          <path
            d="M533.088 186.691C530.838 186.691 529.026 188.503 529.026 190.748C529.026 192.993 530.838 194.805 533.088 194.805C535.337 194.805 537.145 192.985 537.145 190.748C537.145 188.512 535.324 186.691 533.088 186.691Z"
            fill="white"
          />
          <path
            d="M541.445 187.654C542.266 185.575 541.245 183.223 539.165 182.402C537.086 181.581 534.734 182.602 533.913 184.681C533.092 186.761 534.113 189.113 536.193 189.934C538.272 190.755 540.624 189.734 541.445 187.654Z"
            fill="white"
          />
          <path
            d="M541.757 178.008C539.529 178.008 537.729 179.807 537.729 182.035C537.729 184.263 539.529 186.075 541.757 186.075C543.985 186.075 545.797 184.263 545.797 182.035C545.797 179.807 543.985 178.008 541.757 178.008Z"
            fill="white"
          />
          <path
            d="M545.411 174.23C543.196 174.23 541.393 176.03 541.393 178.249C541.393 180.469 543.192 182.26 545.411 182.26C547.631 182.26 549.43 180.465 549.43 178.249C549.43 176.034 547.631 174.23 545.411 174.23Z"
            fill="white"
          />
          <path
            d="M548.658 170.568C546.451 170.568 544.66 172.359 544.66 174.566C544.66 176.773 546.451 178.572 548.658 178.572C550.865 178.572 552.655 176.781 552.655 174.566C552.655 172.351 550.865 170.568 548.658 170.568Z"
            fill="white"
          />
          <path
            d="M562.717 169.24C560.502 169.24 558.711 171.035 558.711 173.242C558.711 175.449 560.502 177.248 562.717 177.248C564.932 177.248 566.723 175.457 566.723 173.242C566.723 171.027 564.924 169.24 562.717 169.24Z"
            fill="white"
          />
          <path
            d="M576.947 168.236C574.731 168.236 572.94 170.027 572.94 172.242C572.94 174.458 574.731 176.249 576.947 176.249C579.162 176.249 580.953 174.453 580.953 172.242C580.953 170.031 579.153 168.236 576.947 168.236Z"
            fill="white"
          />
          <path
            d="M591.472 167.818C589.257 167.818 587.453 169.618 587.453 171.833C587.453 174.048 589.252 175.843 591.472 175.843C593.691 175.843 595.478 174.048 595.478 171.833C595.478 169.618 593.679 167.818 591.472 167.818Z"
            fill="white"
          />
          <path
            d="M606.169 168.047C603.954 168.047 602.15 169.846 602.15 172.066C602.15 174.285 603.95 176.072 606.169 176.072C608.389 176.072 610.175 174.277 610.175 172.066C610.175 169.855 608.384 168.047 606.169 168.047Z"
            fill="white"
          />
          <path
            d="M622.005 176.525C624.165 176.015 625.503 173.85 624.993 171.69C624.483 169.53 622.319 168.192 620.158 168.702C617.998 169.212 616.66 171.376 617.17 173.536C617.68 175.697 619.845 177.034 622.005 176.525Z"
            fill="white"
          />
          <path
            d="M636.249 169.523C634.034 169.523 632.23 171.319 632.23 173.542C632.23 175.766 634.03 177.561 636.249 177.561C638.469 177.561 640.268 175.762 640.268 173.542C640.268 171.323 638.477 169.523 636.249 169.523Z"
            fill="white"
          />
          <path
            d="M651.403 171.014C649.187 171.014 647.384 172.813 647.384 175.033C647.384 177.252 649.183 179.051 651.403 179.051C653.622 179.051 655.43 177.256 655.43 175.033C655.43 172.809 653.631 171.014 651.403 171.014Z"
            fill="white"
          />
          <path
            d="M666.349 172.674C664.121 172.674 662.321 174.477 662.321 176.697C662.321 178.916 664.121 180.724 666.349 180.724C668.577 180.724 670.367 178.925 670.367 176.697C670.367 174.469 668.568 172.674 666.349 172.674Z"
            fill="white"
          />
          <path
            d="M674.683 179.842C672.447 179.842 670.635 181.654 670.635 183.886C670.635 186.118 672.447 187.93 674.683 187.93C676.92 187.93 678.723 186.118 678.723 183.886C678.723 181.654 676.911 179.842 674.683 179.842Z"
            fill="white"
          />
          <path
            d="M682.628 187.352C680.391 187.352 678.566 189.172 678.566 191.417C678.566 193.662 680.387 195.483 682.628 195.483C684.868 195.483 686.697 193.662 686.697 191.417C686.697 189.172 684.877 187.352 682.628 187.352Z"
            fill="white"
          />
          <path
            d="M690.234 195.119C687.984 195.119 686.155 196.944 686.155 199.197C686.155 201.451 687.989 203.276 690.234 203.276C692.478 203.276 694.312 201.442 694.312 199.197C694.312 196.952 692.491 195.119 690.234 195.119Z"
            fill="white"
          />
          <path
            d="M697.55 203.008C695.279 203.008 693.438 204.85 693.438 207.12C693.438 209.39 695.279 211.232 697.55 211.232C699.82 211.232 701.662 209.39 701.662 207.12C701.662 204.85 699.82 203.008 697.55 203.008Z"
            fill="white"
          />
          <path
            d="M704.649 211.055C702.379 211.055 700.537 212.888 700.537 215.154C700.537 217.42 702.379 219.266 704.649 219.266C706.92 219.266 708.761 217.425 708.761 215.154C708.761 212.884 706.92 211.055 704.649 211.055Z"
            fill="white"
          />
          <path
            d="M711.613 219.252C709.334 219.252 707.479 221.094 707.479 223.373C707.479 225.652 709.334 227.506 711.613 227.506C713.892 227.506 715.734 225.656 715.734 223.373C715.734 221.089 713.879 219.252 711.613 219.252Z"
            fill="white"
          />
          <path
            d="M718.502 227.809C716.223 227.809 714.381 229.659 714.381 231.942C714.381 234.225 716.223 236.063 718.502 236.063C720.78 236.063 722.622 234.208 722.622 231.942C722.622 229.676 720.78 227.809 718.502 227.809Z"
            fill="white"
          />
          <path
            d="M725.456 236.865C723.165 236.865 721.314 238.715 721.314 241.007C721.314 243.299 723.169 245.149 725.456 245.149C727.744 245.149 729.598 243.294 729.598 241.007C729.598 238.72 727.748 236.865 725.456 236.865Z"
            fill="white"
          />
          <path
            d="M719.416 243.607C717.125 243.607 715.262 245.462 715.262 247.749C715.262 250.037 717.125 251.891 719.416 251.891C721.708 251.891 723.558 250.037 723.558 247.749C723.558 245.462 721.695 243.607 719.416 243.607Z"
            fill="white"
          />
          <path
            d="M713.62 251.438C711.329 251.438 709.479 253.292 709.479 255.579C709.479 257.867 711.333 259.721 713.62 259.721C715.908 259.721 717.762 257.871 717.762 255.579C717.762 253.288 715.912 251.438 713.62 251.438Z"
            fill="white"
          />
          <path
            d="M708.065 260.094C705.773 260.094 703.923 261.948 703.923 264.236C703.923 266.523 705.773 268.369 708.065 268.369C710.356 268.369 712.198 266.515 712.198 264.236C712.198 261.957 710.344 260.094 708.065 260.094Z"
            fill="white"
          />
          <path
            d="M702.65 269.545C700.358 269.545 698.508 271.395 698.508 273.678C698.508 275.961 700.362 277.82 702.65 277.82C704.937 277.82 706.792 275.97 706.792 273.678C706.792 271.387 704.941 269.545 702.65 269.545Z"
            fill="white"
          />
          <path
            d="M697.282 279.785C695.003 279.785 693.148 281.627 693.148 283.906C693.148 286.185 694.999 288.039 697.282 288.039C699.565 288.039 701.403 286.185 701.403 283.906C701.403 281.627 699.561 279.785 697.282 279.785Z"
            fill="white"
          />
          <path
            d="M691.787 290.842C689.508 290.842 687.666 292.684 687.666 294.962C687.666 297.241 689.508 299.096 691.787 299.096C694.066 299.096 695.92 297.241 695.92 294.962C695.92 292.684 694.066 290.842 691.787 290.842Z"
            fill="white"
          />
          <path
            d="M686.04 310.961C688.311 310.961 690.152 309.12 690.152 306.849C690.152 304.577 688.311 302.736 686.04 302.736C683.769 302.736 681.928 304.577 681.928 306.849C681.928 309.12 683.769 310.961 686.04 310.961Z"
            fill="white"
          />
          <path
            d="M687.135 328.695C684.877 328.695 683.044 330.529 683.044 332.786C683.044 335.044 684.877 336.877 687.135 336.877C689.393 336.877 691.226 335.044 691.226 332.786C691.226 330.529 689.405 328.695 687.135 328.695Z"
            fill="white"
          />
          <path
            d="M673.301 328.963C671.043 328.963 669.21 330.796 669.21 333.054C669.21 335.312 671.043 337.132 673.301 337.132C675.559 337.132 677.379 335.299 677.379 333.054C677.379 330.809 675.546 328.963 673.301 328.963Z"
            fill="white"
          />
          <path
            d="M659.47 329.006C657.221 329.006 655.392 330.839 655.392 333.084C655.392 335.329 657.225 337.175 659.47 337.175C661.715 337.175 663.561 335.342 663.561 333.084C663.561 330.826 661.728 329.006 659.47 329.006Z"
            fill="white"
          />
          <path
            d="M645.657 328.746C643.408 328.746 641.587 330.567 641.587 332.816C641.587 335.065 643.408 336.894 645.657 336.894C647.906 336.894 649.735 335.061 649.735 332.816C649.735 330.571 647.914 328.746 645.657 328.746Z"
            fill="white"
          />
          <path
            d="M631.869 328.143C629.62 328.143 627.791 329.963 627.791 332.212C627.791 334.462 629.624 336.291 631.869 336.291C634.114 336.291 635.948 334.457 635.948 332.212C635.948 329.967 634.114 328.143 631.869 328.143Z"
            fill="white"
          />
          <path
            d="M618.077 327.133C615.827 327.133 614.007 328.953 614.007 331.211C614.007 333.469 615.827 335.281 618.077 335.281C620.326 335.281 622.155 333.46 622.155 331.211C622.155 328.962 620.334 327.133 618.077 327.133Z"
            fill="white"
          />
          <path
            d="M604.277 325.959C602.04 325.959 600.22 327.78 600.22 330.029C600.22 332.278 602.04 334.098 604.277 334.098C606.513 334.098 608.347 332.278 608.347 330.029C608.347 327.78 606.526 325.959 604.277 325.959Z"
            fill="white"
          />
          <path
            d="M590.462 324.781C588.213 324.781 586.393 326.602 586.393 328.851C586.393 331.1 588.213 332.921 590.462 332.921C592.712 332.921 594.532 331.1 594.532 328.851C594.532 326.602 592.712 324.781 590.462 324.781Z"
            fill="white"
          />
          <path
            d="M576.645 323.668C574.408 323.668 572.588 325.489 572.588 327.738C572.588 329.987 574.408 331.795 576.645 331.795C578.881 331.795 580.715 329.974 580.715 327.738C580.715 325.501 578.894 323.668 576.645 323.668Z"
            fill="white"
          />
          <path
            d="M562.823 322.805C560.573 322.805 558.766 324.617 558.766 326.862C558.766 329.107 560.578 330.923 562.823 330.923C565.068 330.923 566.884 329.102 566.884 326.862C566.884 324.621 565.063 322.805 562.823 322.805Z"
            fill="white"
          />
          <path
            d="M556.168 304.162C553.919 304.162 552.09 305.983 552.09 308.232C552.09 310.481 553.923 312.31 556.168 312.31C558.413 312.31 560.246 310.49 560.246 308.232C560.246 305.974 558.413 304.162 556.168 304.162Z"
            fill="white"
          />
          <path
            d="M549.302 287.053C547.044 287.053 545.211 288.873 545.211 291.131C545.211 293.389 547.044 295.222 549.302 295.222C551.56 295.222 553.38 293.389 553.38 291.131C553.38 288.873 551.56 287.053 549.302 287.053Z"
            fill="white"
          />
          <path
            d="M542.253 271.826C539.982 271.826 538.153 273.668 538.153 275.926C538.153 278.183 539.987 280.017 542.253 280.017C544.519 280.017 546.344 278.183 546.344 275.926C546.344 273.668 544.51 271.826 542.253 271.826Z"
            fill="white"
          />
          <path
            d="M535.052 258.625C532.794 258.625 530.961 260.458 530.961 262.724C530.961 264.991 532.794 266.815 535.052 266.815C537.31 266.815 539.151 264.982 539.151 262.724C539.151 260.467 537.318 258.625 535.052 258.625Z"
            fill="white"
          />
          <path
            d="M527.736 247.295C525.466 247.295 523.637 249.137 523.637 251.394C523.637 253.652 525.47 255.507 527.736 255.507C530.002 255.507 531.836 253.665 531.836 251.394C531.836 249.124 530.002 247.295 527.736 247.295Z"
            fill="white"
          />
          <path
            d="M520.284 237.666C518.014 237.666 516.185 239.499 516.185 241.765C516.185 244.032 518.018 245.878 520.284 245.878C522.55 245.878 524.384 244.036 524.384 241.765C524.384 239.495 522.55 237.666 520.284 237.666Z"
            fill="white"
          />
          <path
            d="M512.687 229.506C510.417 229.506 508.575 231.339 508.575 233.605C508.575 235.871 510.417 237.705 512.687 237.705C514.958 237.705 516.787 235.871 516.787 233.605C516.787 231.339 514.945 229.506 512.687 229.506Z"
            fill="white"
          />
          <path
            d="M504.913 222.49C502.656 222.49 500.822 224.332 500.822 226.59C500.822 228.847 502.656 230.689 504.913 230.689C507.171 230.689 509.013 228.847 509.013 226.59C509.013 224.332 507.179 222.49 504.913 222.49Z"
            fill="white"
          />
          <path
            d="M496.981 216.309C494.724 216.309 492.882 218.142 492.882 220.408C492.882 222.674 494.724 224.499 496.981 224.499C499.239 224.499 501.081 222.666 501.081 220.408C501.081 218.15 499.239 216.309 496.981 216.309Z"
            fill="white"
          />
          <path
            d="M502.956 207.83C500.699 207.83 498.865 209.663 498.865 211.921C498.865 214.179 500.699 216.012 502.956 216.012C505.214 216.012 507.034 214.179 507.034 211.921C507.034 209.663 505.214 207.83 502.956 207.83Z"
            fill="white"
          />
          <path
            d="M508.719 200.312C506.47 200.312 504.641 202.146 504.641 204.403C504.641 206.661 506.474 208.494 508.719 208.494C510.964 208.494 512.81 206.661 512.81 204.403C512.81 202.146 510.977 200.312 508.719 200.312Z"
            fill="white"
          />
          <path
            d="M514.185 193.953C511.935 193.953 510.106 195.778 510.106 198.027C510.106 200.276 511.94 202.101 514.185 202.101C516.43 202.101 518.254 200.281 518.254 198.027C518.254 195.774 516.434 193.953 514.185 193.953Z"
            fill="white"
          />
          <path
            d="M519.222 188.52C516.986 188.52 515.165 190.336 515.165 192.577C515.165 194.817 516.986 196.634 519.222 196.634C521.459 196.634 523.279 194.813 523.279 192.577C523.279 190.34 521.467 188.52 519.222 188.52Z"
            fill="white"
          />
          <path
            d="M523.802 183.818C521.566 183.818 519.754 185.63 519.754 187.867C519.754 190.103 521.566 191.907 523.802 191.907C526.039 191.907 527.843 190.095 527.843 187.867C527.843 185.639 526.03 183.818 523.802 183.818Z"
            fill="white"
          />
          <path
            d="M527.893 179.621C525.665 179.621 523.865 181.42 523.865 183.648C523.865 185.876 525.665 187.68 527.893 187.68C530.121 187.68 531.92 185.872 531.92 183.648C531.92 181.425 530.121 179.621 527.893 179.621Z"
            fill="white"
          />
          <path
            d="M531.512 175.779C529.297 175.779 527.493 177.57 527.493 179.785C527.493 182.001 529.293 183.804 531.512 183.804C533.731 183.804 535.531 182.009 535.531 179.785C535.531 177.562 533.731 175.779 531.512 175.779Z"
            fill="white"
          />
          <path
            d="M537.514 178.975C539.076 177.414 539.076 174.883 537.514 173.322C535.953 171.761 533.422 171.761 531.861 173.322C530.3 174.883 530.3 177.414 531.861 178.975C533.422 180.536 535.953 180.536 537.514 178.975Z"
            fill="white"
          />
          <path
            d="M537.487 168.609C535.293 168.609 533.523 170.388 533.523 172.573C533.523 174.759 535.293 176.549 537.487 176.549C539.681 176.549 541.451 174.771 541.451 172.573C541.451 170.375 539.681 168.609 537.487 168.609Z"
            fill="white"
          />
          <path
            d="M551.602 166.908C549.408 166.908 547.626 168.682 547.626 170.88C547.626 173.079 549.404 174.853 551.602 174.853C553.801 174.853 555.566 173.079 555.566 170.88C555.566 168.682 553.788 166.908 551.602 166.908Z"
            fill="white"
          />
          <path
            d="M565.883 173.336C568.079 173.336 569.859 171.555 569.859 169.359C569.859 167.163 568.079 165.383 565.883 165.383C563.687 165.383 561.906 167.163 561.906 169.359C561.906 171.555 563.687 173.336 565.883 173.336Z"
            fill="white"
          />
          <path
            d="M580.515 164.166C578.317 164.166 576.539 165.944 576.539 168.142C576.539 170.341 578.317 172.119 580.515 172.119C582.714 172.119 584.5 170.341 584.5 168.142C584.5 165.944 582.722 164.166 580.515 164.166Z"
            fill="white"
          />
          <path
            d="M598.335 170.425C599.887 168.872 599.887 166.354 598.335 164.802C596.782 163.249 594.264 163.249 592.711 164.802C591.158 166.354 591.158 168.872 592.711 170.425C594.264 171.978 596.782 171.978 598.335 170.425Z"
            fill="white"
          />
          <path
            d="M610.76 163.611C608.566 163.611 606.775 165.389 606.775 167.588C606.775 169.786 608.566 171.573 610.76 171.573C612.954 171.573 614.745 169.794 614.745 167.588C614.745 165.381 612.954 163.611 610.76 163.611Z"
            fill="white"
          />
          <path
            d="M626.339 163.846C624.133 163.846 622.354 165.632 622.354 167.831C622.354 170.029 624.133 171.811 626.339 171.811C628.546 171.811 630.324 170.033 630.324 167.831C630.324 165.628 628.533 163.846 626.339 163.846Z"
            fill="white"
          />
          <path
            d="M642.037 164.648C639.843 164.648 638.052 166.435 638.052 168.642C638.052 170.849 639.843 172.627 642.037 172.627C644.231 172.627 646.034 170.849 646.034 168.642C646.034 166.435 644.243 164.648 642.037 164.648Z"
            fill="white"
          />
          <path
            d="M657.564 165.824C655.357 165.824 653.566 167.611 653.566 169.818C653.566 172.024 655.357 173.802 657.564 173.802C659.771 173.802 661.549 172.024 661.549 169.818C661.549 167.611 659.758 165.824 657.564 165.824Z"
            fill="white"
          />
          <path
            d="M672.749 167.148C670.542 167.148 668.751 168.935 668.751 171.142C668.751 173.349 670.542 175.139 672.749 175.139C674.955 175.139 676.746 173.349 676.746 171.142C676.746 168.935 674.955 167.148 672.749 167.148Z"
            fill="white"
          />
          <path
            d="M680.994 174.617C678.779 174.617 676.967 176.417 676.967 178.645C676.967 180.872 678.779 182.672 680.994 182.672C683.209 182.672 685.021 180.872 685.021 178.645C685.021 176.417 683.222 174.617 680.994 174.617Z"
            fill="white"
          />
          <path
            d="M688.884 182.379C686.647 182.379 684.835 184.191 684.835 186.427C684.835 188.664 686.647 190.467 688.884 190.467C691.12 190.467 692.932 188.655 692.932 186.427C692.932 184.199 691.12 182.379 688.884 182.379Z"
            fill="white"
          />
          <path
            d="M696.459 190.268C694.21 190.268 692.397 192.088 692.397 194.325C692.397 196.561 694.21 198.39 696.459 198.39C698.708 198.39 700.516 196.574 700.516 194.325C700.516 192.075 698.695 190.268 696.459 190.268Z"
            fill="white"
          />
          <path
            d="M703.766 198.209C701.517 198.209 699.696 200.042 699.696 202.287C699.696 204.532 701.517 206.365 703.766 206.365C706.015 206.365 707.844 204.545 707.844 202.287C707.844 200.03 706.024 198.209 703.766 198.209Z"
            fill="white"
          />
          <path
            d="M710.883 206.189C708.612 206.189 706.783 208.023 706.783 210.289C706.783 212.555 708.617 214.401 710.883 214.401C713.149 214.401 714.995 212.559 714.995 210.289C714.995 208.019 713.153 206.189 710.883 206.189Z"
            fill="white"
          />
          <path
            d="M717.868 214.287C715.598 214.287 713.756 216.129 713.756 218.408C713.756 220.687 715.598 222.52 717.868 222.52C720.138 222.52 721.989 220.678 721.989 218.408C721.989 216.137 720.134 214.287 717.868 214.287Z"
            fill="white"
          />
          <path
            d="M724.769 222.617C722.49 222.617 720.648 224.472 720.648 226.738C720.648 229.004 722.49 230.871 724.769 230.871C727.048 230.871 728.903 229.017 728.903 226.738C728.903 224.459 727.048 222.617 724.769 222.617Z"
            fill="white"
          />
          <path
            d="M731.657 231.225C729.378 231.225 727.523 233.075 727.523 235.358C727.523 237.641 729.378 239.491 731.657 239.491C733.936 239.491 735.79 237.637 735.79 235.358C735.79 233.079 733.948 231.225 731.657 231.225Z"
            fill="white"
          />
          <path
            d="M738.62 240.123C736.329 240.123 734.479 241.978 734.479 244.265C734.479 246.552 736.333 248.407 738.62 248.407C740.908 248.407 742.775 246.552 742.775 244.265C742.775 241.978 740.912 240.123 738.62 240.123Z"
            fill="white"
          />
          <path
            d="M732.594 246.607C730.315 246.607 728.452 248.462 728.452 250.749C728.452 253.037 730.315 254.891 732.594 254.891C734.873 254.891 736.749 253.037 736.749 250.749C736.749 248.462 734.886 246.607 732.594 246.607Z"
            fill="white"
          />
          <path
            d="M726.797 254.061C724.506 254.061 722.655 255.915 722.655 258.202C722.655 260.49 724.506 262.344 726.797 262.344C729.089 262.344 730.939 260.494 730.939 258.202C730.939 255.911 729.085 254.061 726.797 254.061Z"
            fill="white"
          />
          <path
            d="M721.238 262.332C718.946 262.332 717.096 264.195 717.096 266.474C717.096 268.753 718.95 270.629 721.238 270.629C723.525 270.629 725.38 268.766 725.38 266.474C725.38 264.182 723.525 262.332 721.238 262.332Z"
            fill="white"
          />
          <path
            d="M715.879 271.459C713.6 271.459 711.745 273.309 711.745 275.601C711.745 277.893 713.6 279.734 715.879 279.734C718.157 279.734 720.02 277.88 720.02 275.601C720.02 273.322 718.17 271.459 715.879 271.459Z"
            fill="white"
          />
          <path
            d="M710.603 281.41C708.324 281.41 706.47 283.252 706.47 285.531C706.47 287.81 708.32 289.664 710.603 289.664C712.886 289.664 714.724 287.81 714.724 285.531C714.724 283.252 712.882 281.41 710.603 281.41Z"
            fill="white"
          />
          <path
            d="M705.244 292.117C702.965 292.117 701.11 293.959 701.11 296.238C701.11 298.517 702.965 300.371 705.244 300.371C707.523 300.371 709.377 298.521 709.377 296.238C709.377 293.955 707.523 292.117 705.244 292.117Z"
            fill="white"
          />
          <path
            d="M699.633 303.602C697.362 303.602 695.521 305.443 695.521 307.714C695.521 309.984 697.362 311.834 699.633 311.834C701.903 311.834 703.753 309.993 703.753 307.714C703.753 305.435 701.912 303.602 699.633 303.602Z"
            fill="white"
          />
          <path
            d="M693.628 315.818C691.37 315.818 689.528 317.66 689.528 319.918C689.528 322.175 691.37 324.017 693.628 324.017C695.885 324.017 697.727 322.184 697.727 319.918C697.727 317.652 695.894 315.818 693.628 315.818Z"
            fill="white"
          />
          <path
            d="M694.087 340.986C691.838 340.986 690.018 342.807 690.018 345.065C690.018 347.322 691.838 349.134 694.087 349.134C696.337 349.134 698.166 347.314 698.166 345.065C698.166 342.815 696.332 340.986 694.087 340.986Z"
            fill="white"
          />
          <path
            d="M680.137 342.047C677.888 342.047 676.059 343.867 676.059 346.117C676.059 348.366 677.892 350.186 680.137 350.186C682.382 350.186 684.207 348.366 684.207 346.117C684.207 343.867 682.386 342.047 680.137 342.047Z"
            fill="white"
          />
          <path
            d="M666.201 342.92C663.951 342.92 662.131 344.741 662.131 346.99C662.131 349.239 663.951 351.059 666.201 351.059C668.45 351.059 670.262 349.239 670.262 346.99C670.262 344.741 668.45 342.92 666.201 342.92Z"
            fill="white"
          />
          <path
            d="M652.286 343.514C650.036 343.514 648.216 345.334 648.216 347.583C648.216 349.833 650.036 351.64 652.286 351.64C654.535 351.64 656.355 349.828 656.355 347.583C656.355 345.338 654.535 343.514 652.286 343.514Z"
            fill="white"
          />
          <path
            d="M638.404 343.85C636.167 343.85 634.347 345.662 634.347 347.911C634.347 350.16 636.167 351.981 638.404 351.981C640.64 351.981 642.473 350.16 642.473 347.911C642.473 345.662 640.653 343.85 638.404 343.85Z"
            fill="white"
          />
          <path
            d="M624.548 343.816C622.312 343.816 620.491 345.628 620.491 347.873C620.491 350.118 622.312 351.93 624.548 351.93C626.785 351.93 628.618 350.11 628.618 347.873C628.618 345.637 626.797 343.816 624.548 343.816Z"
            fill="white"
          />
          <path
            d="M610.718 343.441C608.469 343.441 606.661 345.262 606.661 347.498C606.661 349.735 608.473 351.555 610.718 351.555C612.963 351.555 614.775 349.735 614.775 347.498C614.775 345.262 612.955 343.441 610.718 343.441Z"
            fill="white"
          />
          <path
            d="M596.875 342.975C594.638 342.975 592.813 344.795 592.813 347.032C592.813 349.268 594.634 351.089 596.875 351.089C599.115 351.089 600.932 349.268 600.932 347.032C600.932 344.795 599.111 342.975 596.875 342.975Z"
            fill="white"
          />
          <path
            d="M583.031 342.535C580.795 342.535 578.982 344.347 578.982 346.584C578.982 348.82 580.795 350.641 583.031 350.641C585.267 350.641 587.088 348.829 587.088 346.584C587.088 344.339 585.276 342.535 583.031 342.535Z"
            fill="white"
          />
          <path
            d="M569.202 342.109C566.974 342.109 565.153 343.921 565.153 346.158C565.153 348.394 566.974 350.206 569.202 350.206C571.43 350.206 573.259 348.394 573.259 346.158C573.259 343.921 571.438 342.109 569.202 342.109Z"
            fill="white"
          />
          <path
            d="M555.358 341.996C553.122 341.996 551.31 343.808 551.31 346.045C551.31 348.281 553.122 350.093 555.358 350.093C557.595 350.093 559.407 348.281 559.407 346.045C559.407 343.808 557.595 341.996 555.358 341.996Z"
            fill="white"
          />
          <path
            d="M548.98 322.426C546.731 322.426 544.923 324.246 544.923 326.483C544.923 328.719 546.735 330.553 548.98 330.553C551.225 330.553 553.037 328.732 553.037 326.483C553.037 324.234 551.216 322.426 548.98 322.426Z"
            fill="white"
          />
          <path
            d="M542.338 303.795C540.089 303.795 538.269 305.628 538.269 307.865C538.269 310.101 540.089 311.934 542.338 311.934C544.587 311.934 546.408 310.114 546.408 307.865C546.408 305.616 544.575 303.795 542.338 303.795Z"
            fill="white"
          />
          <path
            d="M535.468 286.906C533.21 286.906 531.377 288.74 531.377 290.997C531.377 293.255 533.21 295.088 535.468 295.088C537.726 295.088 539.546 293.255 539.546 290.997C539.546 288.74 537.713 286.906 535.468 286.906Z"
            fill="white"
          />
          <path
            d="M528.423 272.105C526.152 272.105 524.323 273.939 524.323 276.196C524.323 278.454 526.157 280.296 528.423 280.296C530.689 280.296 532.514 278.454 532.514 276.196C532.514 273.939 530.68 272.105 528.423 272.105Z"
            fill="white"
          />
          <path
            d="M521.222 267.619C523.481 267.619 525.313 265.788 525.313 263.528C525.313 261.269 523.481 259.438 521.222 259.438C518.962 259.438 517.131 261.269 517.131 263.528C517.131 265.788 518.962 267.619 521.222 267.619Z"
            fill="white"
          />
          <path
            d="M513.884 248.752C511.613 248.752 509.771 250.585 509.771 252.851C509.771 255.118 511.613 256.951 513.884 256.951C516.154 256.951 517.983 255.118 517.983 252.851C517.983 250.585 516.141 248.752 513.884 248.752Z"
            fill="white"
          />
          <path
            d="M506.39 239.736C504.119 239.736 502.277 241.578 502.277 243.849C502.277 246.119 504.119 247.948 506.39 247.948C508.66 247.948 510.489 246.115 510.489 243.849C510.489 241.582 508.647 239.736 506.39 239.736Z"
            fill="white"
          />
          <path
            d="M498.717 232.076C496.459 232.076 494.626 233.909 494.626 236.167C494.626 238.425 496.459 240.267 498.717 240.267C500.975 240.267 502.816 238.433 502.816 236.167C502.816 233.901 500.983 232.076 498.717 232.076Z"
            fill="white"
          />
          <path
            d="M490.883 225.428C488.625 225.428 486.783 227.27 486.783 229.527C486.783 231.785 488.625 233.627 490.883 233.627C493.14 233.627 494.982 231.785 494.982 229.527C494.982 227.27 493.14 225.428 490.883 225.428Z"
            fill="white"
          />
          <path
            d="M482.888 219.691C480.63 219.691 478.788 221.525 478.788 223.782C478.788 226.04 480.63 227.882 482.888 227.882C485.145 227.882 486.987 226.049 486.987 223.782C486.987 221.516 485.154 219.691 482.888 219.691Z"
            fill="white"
          />
          <path
            d="M488.862 210.947C486.605 210.947 484.771 212.781 484.771 215.038C484.771 217.296 486.605 219.116 488.862 219.116C491.12 219.116 492.941 217.296 492.941 215.038C492.941 212.781 491.12 210.947 488.862 210.947Z"
            fill="white"
          />
          <path
            d="M494.66 203.152C492.403 203.152 490.582 204.986 490.582 207.231C490.582 209.476 492.403 211.309 494.66 211.309C496.918 211.309 498.739 209.488 498.739 207.231C498.739 204.973 496.905 203.152 494.66 203.152Z"
            fill="white"
          />
          <path
            d="M500.814 204.666C503.034 204.311 504.545 202.224 504.19 200.004C503.835 197.785 501.748 196.273 499.528 196.629C497.309 196.984 495.798 199.071 496.153 201.29C496.508 203.51 498.595 205.021 500.814 204.666Z"
            fill="white"
          />
          <path
            d="M505.286 190.906C503.036 190.906 501.216 192.731 501.216 194.98C501.216 197.229 503.036 199.054 505.286 199.054C507.535 199.054 509.355 197.221 509.355 194.98C509.355 192.74 507.535 190.906 505.286 190.906Z"
            fill="white"
          />
          <path
            d="M509.938 186.037C507.711 186.037 505.898 187.845 505.898 190.081C505.898 192.318 507.711 194.121 509.938 194.121C512.166 194.121 513.987 192.309 513.987 190.081C513.987 187.853 512.175 186.037 509.938 186.037Z"
            fill="white"
          />
          <path
            d="M514.101 181.717C511.873 181.717 510.073 183.525 510.073 185.74C510.073 187.955 511.873 189.767 514.101 189.767C516.329 189.767 518.128 187.968 518.128 185.74C518.128 183.512 516.316 181.717 514.101 181.717Z"
            fill="white"
          />
          <path
            d="M517.745 177.82C515.53 177.82 513.739 179.62 513.739 181.839C513.739 184.059 515.53 185.858 517.745 185.858C519.961 185.858 521.764 184.059 521.764 181.839C521.764 179.62 519.965 177.82 517.745 177.82Z"
            fill="white"
          />
          <path
            d="M520.899 174.219C518.692 174.219 516.901 176.01 516.901 178.216C516.901 180.423 518.692 182.214 520.899 182.214C523.106 182.214 524.897 180.427 524.897 178.216C524.897 176.005 523.106 174.219 520.899 174.219Z"
            fill="white"
          />
          <path
            d="M523.615 170.777C521.429 170.777 519.651 172.555 519.651 174.741C519.651 176.927 521.429 178.705 523.615 178.705C525.801 178.705 527.579 176.927 527.579 174.741C527.579 172.555 525.801 170.777 523.615 170.777Z"
            fill="white"
          />
          <path
            d="M525.979 167.328C523.793 167.328 522.032 169.098 522.032 171.279C522.032 173.46 523.789 175.23 525.979 175.23C528.169 175.23 529.921 173.46 529.921 171.279C529.921 169.098 528.152 167.328 525.979 167.328Z"
            fill="white"
          />
          <path
            d="M540.017 165.031C537.831 165.031 536.062 166.801 536.062 168.986C536.062 171.172 537.831 172.937 540.017 172.937C542.202 172.937 543.972 171.168 543.972 168.986C543.972 166.805 542.202 165.031 540.017 165.031Z"
            fill="white"
          />
          <path
            d="M554.382 163.125C552.196 163.125 550.427 164.895 550.427 167.076C550.427 169.257 552.196 171.031 554.382 171.031C556.567 171.031 558.337 169.257 558.337 167.076C558.337 164.895 556.567 163.125 554.382 163.125Z"
            fill="white"
          />
          <path
            d="M569.066 161.326C566.88 161.326 565.11 163.096 565.11 165.286C565.11 167.475 566.88 169.245 569.066 169.245C571.251 169.245 573.021 167.475 573.021 165.286C573.021 163.096 571.251 161.326 569.066 161.326Z"
            fill="white"
          />
          <path
            d="M584.27 159.865C582.085 159.865 580.307 161.635 580.307 163.82C580.307 166.006 582.085 167.784 584.27 167.784C586.456 167.784 588.225 166.006 588.225 163.82C588.225 161.635 586.456 159.865 584.27 159.865Z"
            fill="white"
          />
          <path
            d="M599.875 159.141C597.69 159.141 595.92 160.91 595.92 163.1C595.92 165.29 597.69 167.059 599.875 167.059C602.061 167.059 603.839 165.286 603.839 163.1C603.839 160.915 602.061 159.141 599.875 159.141Z"
            fill="white"
          />
          <path
            d="M615.84 158.775C613.654 158.775 611.876 160.554 611.876 162.739C611.876 164.925 613.654 166.711 615.84 166.711C618.025 166.711 619.803 164.937 619.803 162.739C619.803 160.541 618.034 158.775 615.84 158.775Z"
            fill="white"
          />
          <path
            d="M632.098 158.725C629.904 158.725 628.135 160.503 628.135 162.688C628.135 164.874 629.904 166.66 632.098 166.66C634.292 166.66 636.062 164.887 636.062 162.688C636.062 160.49 634.284 158.725 632.098 158.725Z"
            fill="white"
          />
          <path
            d="M648.279 159.242C646.081 159.242 644.315 161.016 644.315 163.206C644.315 165.396 646.085 167.182 648.279 167.182C650.473 167.182 652.255 165.404 652.255 163.206C652.255 161.008 650.477 159.242 648.279 159.242Z"
            fill="white"
          />
          <path
            d="M664.113 159.994C661.915 159.994 660.137 161.772 660.137 163.971C660.137 166.169 661.915 167.947 664.113 167.947C666.311 167.947 668.077 166.169 668.077 163.971C668.077 161.772 666.299 159.994 664.113 159.994Z"
            fill="white"
          />
          <path
            d="M679.462 160.932C677.268 160.932 675.485 162.718 675.485 164.917C675.485 167.115 677.263 168.893 679.462 168.893C681.66 168.893 683.447 167.115 683.447 164.917C683.447 162.718 681.668 160.932 679.462 160.932Z"
            fill="white"
          />
          <path
            d="M690.356 175.674C691.917 174.113 691.917 171.582 690.356 170.021C688.795 168.46 686.264 168.46 684.703 170.021C683.142 171.582 683.142 174.113 684.703 175.674C686.264 177.236 688.795 177.236 690.356 175.674Z"
            fill="white"
          />
          <path
            d="M695.283 176.918C693.055 176.918 691.256 178.722 691.256 180.945C691.256 183.169 693.055 184.973 695.283 184.973C697.511 184.973 699.31 183.173 699.31 180.945C699.31 178.717 697.511 176.918 695.283 176.918Z"
            fill="white"
          />
          <path
            d="M702.765 185.066C700.537 185.066 698.725 186.878 698.725 189.106C698.725 191.334 700.537 193.155 702.765 193.155C704.993 193.155 706.813 191.343 706.813 189.106C706.813 186.87 705.001 185.066 702.765 185.066Z"
            fill="white"
          />
          <path
            d="M710.051 193.166C707.793 193.166 705.973 194.991 705.973 197.24C705.973 199.489 707.793 201.318 710.051 201.318C712.309 201.318 714.121 199.498 714.121 197.24C714.121 194.982 712.3 193.166 710.051 193.166Z"
            fill="white"
          />
          <path
            d="M717.159 201.311C714.902 201.311 713.068 203.144 713.068 205.402C713.068 207.659 714.902 209.492 717.159 209.492C719.417 209.492 721.25 207.659 721.25 205.402C721.25 203.144 719.417 201.311 717.159 201.311Z"
            fill="white"
          />
          <path
            d="M724.153 209.502C721.883 209.502 720.041 211.344 720.041 213.614C720.041 215.885 721.883 217.726 724.153 217.726C726.424 217.726 728.253 215.885 728.253 213.614C728.253 211.344 726.411 209.502 724.153 209.502Z"
            fill="white"
          />
          <path
            d="M731.066 217.787C728.787 217.787 726.945 219.629 726.945 221.908C726.945 224.187 728.787 226.02 731.066 226.02C733.345 226.02 735.178 224.178 735.178 221.908C735.178 219.637 733.336 217.787 731.066 217.787Z"
            fill="white"
          />
          <path
            d="M737.923 226.104C735.645 226.104 733.79 227.958 733.79 230.237C733.79 232.516 735.645 234.37 737.923 234.37C740.202 234.37 742.057 232.529 742.057 230.237C742.057 227.945 740.207 226.104 737.923 226.104Z"
            fill="white"
          />
          <path
            d="M744.803 234.555C742.511 234.555 740.661 236.405 740.661 238.697C740.661 240.988 742.511 242.838 744.803 242.838C747.095 242.838 748.945 240.984 748.945 238.697C748.945 236.409 747.09 234.555 744.803 234.555Z"
            fill="white"
          />
          <path
            d="M751.81 243.264C749.518 243.264 747.655 245.118 747.655 247.406C747.655 249.693 749.518 251.547 751.81 251.547C754.101 251.547 755.952 249.697 755.952 247.406C755.952 245.114 754.101 243.264 751.81 243.264Z"
            fill="white"
          />
          <path
            d="M745.801 249.551C743.509 249.551 741.659 251.414 741.659 253.705C741.659 255.997 743.509 257.847 745.801 257.847C748.093 257.847 749.956 255.993 749.956 253.705C749.956 251.418 748.093 249.551 745.801 249.551Z"
            fill="white"
          />
          <path
            d="M740.059 256.82C737.767 256.82 735.917 258.683 735.917 260.975C735.917 263.267 737.767 265.117 740.059 265.117C742.351 265.117 744.214 263.262 744.214 260.975C744.214 258.688 742.351 256.82 740.059 256.82Z"
            fill="white"
          />
          <path
            d="M734.542 264.809C732.251 264.809 730.4 266.663 730.4 268.95C730.4 271.238 732.255 273.092 734.542 273.092C736.83 273.092 738.693 271.238 738.693 268.95C738.693 266.663 736.83 264.809 734.542 264.809Z"
            fill="white"
          />
          <path
            d="M729.212 273.488C726.921 273.488 725.07 275.351 725.07 277.643C725.07 279.935 726.925 281.785 729.212 281.785C731.5 281.785 733.363 279.93 733.363 277.643C733.363 275.356 731.5 273.488 729.212 273.488Z"
            fill="white"
          />
          <path
            d="M723.988 282.982C721.696 282.982 719.854 284.833 719.854 287.116C719.854 289.399 721.696 291.249 723.988 291.249C726.28 291.249 728.121 289.399 728.121 287.116C728.121 284.833 726.267 282.982 723.988 282.982Z"
            fill="white"
          />
          <path
            d="M718.721 293.264C716.442 293.264 714.588 295.114 714.588 297.397C714.588 299.68 716.442 301.518 718.721 301.518C721 301.518 722.855 299.676 722.855 297.397C722.855 295.118 721 293.264 718.721 293.264Z"
            fill="white"
          />
          <path
            d="M713.235 304.297C710.965 304.297 709.114 306.139 709.114 308.418C709.114 310.696 710.965 312.53 713.235 312.53C715.505 312.53 717.356 310.688 717.356 308.418C717.356 306.147 715.505 304.297 713.235 304.297Z"
            fill="white"
          />
          <path
            d="M707.364 316.02C705.094 316.02 703.265 317.861 703.265 320.119C703.265 322.377 705.098 324.218 707.364 324.218C709.63 324.218 711.464 322.385 711.464 320.119C711.464 317.853 709.622 316.02 707.364 316.02Z"
            fill="white"
          />
          <path
            d="M700.987 328.299C698.73 328.299 696.896 330.132 696.896 332.39C696.896 334.647 698.73 336.481 700.987 336.481C703.245 336.481 705.078 334.647 705.078 332.39C705.078 330.132 703.245 328.299 700.987 328.299Z"
            fill="white"
          />
          <path
            d="M700.758 351.957C698.522 351.957 696.701 353.769 696.701 356.014C696.701 358.259 698.522 360.084 700.758 360.084C702.995 360.084 704.828 358.263 704.828 356.014C704.828 353.765 703.007 351.957 700.758 351.957Z"
            fill="white"
          />
          <path
            d="M686.715 353.775C684.466 353.775 682.658 355.596 682.658 357.832C682.658 360.069 684.47 361.894 686.715 361.894C688.96 361.894 690.776 360.082 690.776 357.832C690.776 355.583 688.956 353.775 686.715 353.775Z"
            fill="white"
          />
          <path
            d="M672.686 355.463C670.437 355.463 668.629 357.283 668.629 359.52C668.629 361.756 670.441 363.581 672.686 363.581C674.931 363.581 676.734 361.761 676.734 359.52C676.734 357.279 674.922 355.463 672.686 355.463Z"
            fill="white"
          />
          <path
            d="M658.676 356.92C656.44 356.92 654.619 358.732 654.619 360.977C654.619 363.222 656.44 365.025 658.676 365.025C660.913 365.025 662.733 363.213 662.733 360.977C662.733 358.74 660.913 356.92 658.676 356.92Z"
            fill="white"
          />
          <path
            d="M644.711 358.139C642.474 358.139 640.662 359.951 640.662 362.187C640.662 364.424 642.474 366.236 644.711 366.236C646.947 366.236 648.759 364.424 648.759 362.187C648.759 359.951 646.947 358.139 644.711 358.139Z"
            fill="white"
          />
          <path
            d="M630.796 359.107C628.559 359.107 626.747 360.919 626.747 363.156C626.747 365.392 628.559 367.205 630.796 367.205C633.032 367.205 634.844 365.384 634.844 363.156C634.844 360.928 633.032 359.107 630.796 359.107Z"
            fill="white"
          />
          <path
            d="M616.91 359.688C614.673 359.688 612.861 361.5 612.861 363.736C612.861 365.972 614.673 367.785 616.91 367.785C619.146 367.785 620.958 365.972 620.958 363.736C620.958 361.5 619.146 359.688 616.91 359.688Z"
            fill="white"
          />
          <path
            d="M603.036 360.082C600.808 360.082 598.996 361.881 598.996 364.122C598.996 366.363 600.808 368.162 603.036 368.162C605.264 368.162 607.085 366.35 607.085 364.122C607.085 361.894 605.273 360.082 603.036 360.082Z"
            fill="white"
          />
          <path
            d="M589.185 360.459C586.949 360.459 585.137 362.271 585.137 364.508C585.137 366.744 586.949 368.548 589.185 368.548C591.422 368.548 593.225 366.735 593.225 364.508C593.225 362.28 591.413 360.459 589.185 360.459Z"
            fill="white"
          />
          <path
            d="M575.333 360.803C573.105 360.803 571.293 362.615 571.293 364.843C571.293 367.071 573.105 368.891 575.333 368.891C577.561 368.891 579.373 367.079 579.373 364.843C579.373 362.606 577.574 360.803 575.333 360.803Z"
            fill="white"
          />
          <path
            d="M561.491 361.219C559.263 361.219 557.451 363.031 557.451 365.259C557.451 367.487 559.263 369.286 561.491 369.286C563.719 369.286 565.519 367.487 565.519 365.259C565.519 363.031 563.719 361.219 561.491 361.219Z"
            fill="white"
          />
          <path
            d="M547.614 361.943C545.386 361.943 543.574 363.743 543.574 365.971C543.574 368.199 545.386 370.011 547.614 370.011C549.842 370.011 551.642 368.199 551.642 365.971C551.642 363.743 549.842 361.943 547.614 361.943Z"
            fill="white"
          />
          <path
            d="M541.493 342.332C539.256 342.332 537.444 344.144 537.444 346.381C537.444 348.617 539.256 350.429 541.493 350.429C543.729 350.429 545.541 348.617 545.541 346.381C545.541 344.144 543.729 342.332 541.493 342.332Z"
            fill="white"
          />
          <path
            d="M535.123 322.627C532.887 322.627 531.066 324.439 531.066 326.684C531.066 328.929 532.887 330.745 535.123 330.745C537.36 330.745 539.18 328.925 539.18 326.684C539.18 324.443 537.36 322.627 535.123 322.627Z"
            fill="white"
          />
          <path
            d="M528.487 304.1C526.238 304.1 524.417 305.92 524.417 308.169C524.417 310.419 526.238 312.239 528.487 312.239C530.736 312.239 532.557 310.419 532.557 308.169C532.557 305.92 530.736 304.1 528.487 304.1Z"
            fill="white"
          />
          <path
            d="M521.616 287.561C519.367 287.561 517.538 289.381 517.538 291.639C517.538 293.896 519.371 295.717 521.616 295.717C523.861 295.717 525.695 293.884 525.695 291.639C525.695 289.394 523.874 287.561 521.616 287.561Z"
            fill="white"
          />
          <path
            d="M518.592 277.761C518.804 275.511 517.152 273.516 514.903 273.304C512.653 273.092 510.658 274.744 510.446 276.993C510.234 279.243 511.886 281.238 514.135 281.45C516.385 281.662 518.38 280.01 518.592 277.761Z"
            fill="white"
          />
          <path
            d="M507.336 261.264C505.078 261.264 503.245 263.097 503.245 265.355C503.245 267.612 505.078 269.446 507.336 269.446C509.594 269.446 511.427 267.612 511.427 265.355C511.427 263.097 509.594 261.264 507.336 261.264Z"
            fill="white"
          />
          <path
            d="M499.947 251.104C497.69 251.104 495.856 252.937 495.856 255.203C495.856 257.469 497.69 259.294 499.947 259.294C502.205 259.294 504.047 257.461 504.047 255.203C504.047 252.945 502.214 251.104 499.947 251.104Z"
            fill="white"
          />
          <path
            d="M492.402 242.504C490.132 242.504 488.303 244.337 488.303 246.595C488.303 248.853 490.136 250.694 492.402 250.694C494.668 250.694 496.493 248.861 496.493 246.595C496.493 244.329 494.66 242.504 492.402 242.504Z"
            fill="white"
          />
          <path
            d="M484.67 235.252C482.412 235.252 480.579 237.085 480.579 239.351C480.579 241.618 482.412 243.442 484.67 243.442C486.928 243.442 488.77 241.609 488.77 239.351C488.77 237.094 486.936 235.252 484.67 235.252Z"
            fill="white"
          />
          <path
            d="M476.781 229.068C474.524 229.068 472.69 230.902 472.69 233.159C472.69 235.417 474.524 237.259 476.781 237.259C479.039 237.259 480.881 235.425 480.881 233.159C480.881 230.893 479.039 229.068 476.781 229.068Z"
            fill="white"
          />
          <path
            d="M468.7 223.771C466.443 223.771 464.609 225.605 464.609 227.862C464.609 230.12 466.443 231.962 468.7 231.962C470.958 231.962 472.8 230.129 472.8 227.862C472.8 225.596 470.966 223.771 468.7 223.771Z"
            fill="white"
          />
          <path
            d="M474.719 214.768C472.461 214.768 470.628 216.588 470.628 218.846C470.628 221.104 472.461 222.937 474.719 222.937C476.977 222.937 478.81 221.104 478.81 218.846C478.81 216.588 476.977 214.768 474.719 214.768Z"
            fill="white"
          />
          <path
            d="M480.516 206.611C478.267 206.611 476.438 208.432 476.438 210.69C476.438 212.947 478.271 214.759 480.516 214.759C482.761 214.759 484.594 212.939 484.594 210.69C484.594 208.44 482.773 206.611 480.516 206.611Z"
            fill="white"
          />
          <path
            d="M486.053 199.574C483.817 199.574 481.996 201.395 481.996 203.644C481.996 205.893 483.817 207.701 486.053 207.701C488.29 207.701 490.123 205.88 490.123 203.644C490.123 201.408 488.302 199.574 486.053 199.574Z"
            fill="white"
          />
          <path
            d="M491.227 193.641C488.991 193.641 487.17 195.461 487.17 197.702C487.17 199.943 488.991 201.772 491.227 201.772C493.463 201.772 495.297 199.951 495.297 197.702C495.297 195.453 493.476 193.641 491.227 193.641Z"
            fill="white"
          />
          <path
            d="M495.972 188.611C493.744 188.611 491.932 190.423 491.932 192.651C491.932 194.879 493.744 196.683 495.972 196.683C498.2 196.683 500.012 194.879 500.012 192.651C500.012 190.423 498.2 188.611 495.972 188.611Z"
            fill="white"
          />
          <path
            d="M500.228 184.191C498.001 184.191 496.201 185.991 496.201 188.214C496.201 190.438 498.001 192.238 500.228 192.238C502.456 192.238 504.256 190.438 504.256 188.214C504.256 185.991 502.444 184.191 500.228 184.191Z"
            fill="white"
          />
          <path
            d="M503.966 180.223C501.759 180.223 499.96 182.022 499.96 184.229C499.96 186.436 501.759 188.235 503.966 188.235C506.173 188.235 507.972 186.444 507.972 184.229C507.972 182.014 506.181 180.223 503.966 180.223Z"
            fill="white"
          />
          <path
            d="M507.2 176.59C504.993 176.59 503.202 178.381 503.202 180.583C503.202 182.786 504.993 184.577 507.2 184.577C509.407 184.577 511.185 182.786 511.185 180.583C511.185 178.381 509.394 176.59 507.2 176.59Z"
            fill="white"
          />
          <path
            d="M509.936 173.178C507.751 173.178 505.973 174.956 505.973 177.141C505.973 179.327 507.751 181.105 509.936 181.105C512.122 181.105 513.9 179.327 513.9 177.141C513.9 174.956 512.122 173.178 509.936 173.178Z"
            fill="white"
          />
          <path
            d="M512.25 169.855C510.073 169.855 508.308 171.621 508.308 173.806C508.308 175.992 510.077 177.749 512.25 177.749C514.423 177.749 516.192 175.979 516.192 173.806C516.192 171.634 514.436 169.855 512.25 169.855Z"
            fill="white"
          />
          <path
            d="M514.227 166.537C512.063 166.537 510.302 168.298 510.302 170.454C510.302 172.61 512.059 174.371 514.227 174.371C516.396 174.371 518.14 172.618 518.14 170.454C518.14 168.29 516.392 166.537 514.227 166.537Z"
            fill="white"
          />
          <path
            d="M528.109 163.826C525.945 163.826 524.184 165.579 524.184 167.743C524.184 169.907 525.945 171.656 528.109 171.656C530.273 171.656 532.022 169.907 532.022 167.743C532.022 165.579 530.273 163.826 528.109 163.826Z"
            fill="white"
          />
          <path
            d="M542.444 161.326C540.28 161.326 538.519 163.083 538.519 165.252C538.519 167.42 540.275 169.181 542.444 169.181C544.613 169.181 546.369 167.429 546.369 165.252C546.369 163.075 544.608 161.326 542.444 161.326Z"
            fill="white"
          />
          <path
            d="M557.201 159.127C555.037 159.127 553.275 160.888 553.275 163.052C553.275 165.217 555.032 166.978 557.201 166.978C559.369 166.978 561.126 165.225 561.126 163.052C561.126 160.88 559.378 159.127 557.201 159.127Z"
            fill="white"
          />
          <path
            d="M572.498 156.984C570.321 156.984 568.564 158.746 568.564 160.914C568.564 163.083 570.321 164.844 572.498 164.844C574.675 164.844 576.424 163.087 576.424 160.914C576.424 158.741 574.663 156.984 572.498 156.984Z"
            fill="white"
          />
          <path
            d="M591.196 161.973C592.732 160.437 592.732 157.946 591.196 156.41C589.659 154.873 587.169 154.873 585.632 156.41C584.096 157.946 584.096 160.437 585.632 161.973C587.169 163.509 589.659 163.509 591.196 161.973Z"
            fill="white"
          />
          <path
            d="M604.785 154.227C602.608 154.227 600.851 155.983 600.851 158.161C600.851 160.338 602.608 162.099 604.785 162.099C606.962 162.099 608.719 160.333 608.719 158.161C608.719 155.988 606.957 154.227 604.785 154.227Z"
            fill="white"
          />
          <path
            d="M621.574 153.449C619.397 153.449 617.64 155.215 617.64 157.387C617.64 159.56 619.397 161.321 621.574 161.321C623.751 161.321 625.508 159.56 625.508 157.387C625.508 155.215 623.746 153.449 621.574 153.449Z"
            fill="white"
          />
          <path
            d="M638.448 153.072C636.283 153.072 634.514 154.838 634.514 157.01C634.514 159.183 636.283 160.949 638.448 160.949C640.612 160.949 642.394 159.179 642.394 157.01C642.394 154.842 640.625 153.072 638.448 153.072Z"
            fill="white"
          />
          <path
            d="M655.015 153.135C652.829 153.135 651.072 154.904 651.072 157.077C651.072 159.25 652.833 161.028 655.015 161.028C657.196 161.028 658.961 159.263 658.961 157.077C658.961 154.892 657.192 153.135 655.015 153.135Z"
            fill="white"
          />
          <path
            d="M671.052 153.33C668.866 153.33 667.088 155.1 667.088 157.285C667.088 159.471 668.866 161.24 671.052 161.24C673.237 161.24 675.007 159.471 675.007 157.285C675.007 155.1 673.229 153.33 671.052 153.33Z"
            fill="white"
          />
          <path
            d="M686.477 153.814C684.292 153.814 682.514 155.588 682.514 157.774C682.514 159.959 684.292 161.738 686.477 161.738C688.663 161.738 690.441 159.959 690.441 157.774C690.441 155.588 688.663 153.814 686.477 153.814Z"
            fill="white"
          />
          <path
            d="M694.294 162.26C692.088 162.26 690.31 164.046 690.31 166.245C690.31 168.443 692.088 170.221 694.294 170.221C696.501 170.221 698.271 168.443 698.271 166.245C698.271 164.046 696.493 162.26 694.294 162.26Z"
            fill="white"
          />
          <path
            d="M701.84 170.816C699.634 170.816 697.843 172.607 697.843 174.814C697.843 177.021 699.634 178.812 701.84 178.812C704.047 178.812 705.846 177.021 705.846 174.814C705.846 172.607 704.056 170.816 701.84 170.816Z"
            fill="white"
          />
          <path
            d="M709.198 179.311C706.97 179.311 705.171 181.123 705.171 183.351C705.171 185.579 706.97 187.378 709.198 187.378C711.426 187.378 713.238 185.579 713.238 183.351C713.238 181.123 711.426 179.311 709.198 179.311Z"
            fill="white"
          />
          <path
            d="M716.392 187.773C714.156 187.773 712.335 189.586 712.335 191.83C712.335 194.075 714.156 195.887 716.392 195.887C718.628 195.887 720.462 194.067 720.462 191.83C720.462 189.594 718.641 187.773 716.392 187.773Z"
            fill="white"
          />
          <path
            d="M723.457 196.219C721.208 196.219 719.388 198.044 719.388 200.293C719.388 202.542 721.208 204.371 723.457 204.371C725.707 204.371 727.536 202.55 727.536 200.293C727.536 198.035 725.715 196.219 723.457 196.219Z"
            fill="white"
          />
          <path
            d="M730.439 204.648C728.169 204.648 726.34 206.482 726.34 208.748C726.34 211.014 728.173 212.839 730.439 212.839C732.705 212.839 734.53 211.006 734.53 208.748C734.53 206.49 732.697 204.648 730.439 204.648Z"
            fill="white"
          />
          <path
            d="M737.339 212.977C735.069 212.977 733.219 214.818 733.219 217.089C733.219 219.359 735.073 221.201 737.339 221.201C739.606 221.201 741.452 219.359 741.452 217.089C741.452 214.818 739.61 212.977 737.339 212.977Z"
            fill="white"
          />
          <path
            d="M744.188 221.232C741.918 221.232 740.067 223.083 740.067 225.366C740.067 227.649 741.918 229.487 744.188 229.487C746.458 229.487 748.321 227.632 748.321 225.366C748.321 223.1 746.467 221.232 744.188 221.232Z"
            fill="white"
          />
          <path
            d="M751.046 229.463C748.767 229.463 746.912 231.317 746.912 233.596C746.912 235.875 748.767 237.73 751.046 237.73C753.324 237.73 755.179 235.888 755.179 233.596C755.179 231.305 753.324 229.463 751.046 229.463Z"
            fill="white"
          />
          <path
            d="M757.98 237.791C755.688 237.791 753.838 239.646 753.838 241.933C753.838 244.22 755.692 246.075 757.98 246.075C760.267 246.075 762.122 244.22 762.122 241.933C762.122 239.646 760.271 237.791 757.98 237.791Z"
            fill="white"
          />
          <path
            d="M765.088 246.4C762.788 246.4 760.934 248.255 760.934 250.542C760.934 252.83 762.784 254.697 765.088 254.697C767.393 254.697 769.23 252.842 769.23 250.542C769.23 248.242 767.38 246.4 765.088 246.4Z"
            fill="white"
          />
          <path
            d="M759.083 252.443C756.792 252.443 754.941 254.306 754.941 256.598C754.941 258.89 756.792 260.74 759.083 260.74C761.375 260.74 763.238 258.89 763.238 256.598C763.238 254.306 761.375 252.443 759.083 252.443Z"
            fill="white"
          />
          <path
            d="M753.359 259.479C751.067 259.479 749.217 261.333 749.217 263.62C749.217 265.908 751.067 267.762 753.359 267.762C755.65 267.762 757.513 265.908 757.513 263.62C757.513 261.333 755.65 259.479 753.359 259.479Z"
            fill="white"
          />
          <path
            d="M747.906 267.203C745.614 267.203 743.751 269.066 743.751 271.358C743.751 273.649 745.614 275.5 747.906 275.5C750.197 275.5 752.048 273.645 752.048 271.358C752.048 269.07 750.197 267.203 747.906 267.203Z"
            fill="white"
          />
          <path
            d="M742.648 275.58C740.356 275.58 738.493 277.443 738.493 279.735C738.493 282.026 740.356 283.877 742.648 283.877C744.939 283.877 746.79 282.026 746.79 279.735C746.79 277.443 744.935 275.58 742.648 275.58Z"
            fill="white"
          />
          <path
            d="M737.474 284.658C735.195 284.658 733.341 286.5 733.341 288.792C733.341 291.083 735.195 292.925 737.474 292.925C739.753 292.925 741.616 291.071 741.616 288.792C741.616 286.513 739.762 284.658 737.474 284.658Z"
            fill="white"
          />
          <path
            d="M732.272 294.389C729.993 294.389 728.139 296.239 728.139 298.531C728.139 300.822 729.989 302.664 732.272 302.664C734.555 302.664 736.405 300.814 736.405 298.531C736.405 296.247 734.564 294.389 732.272 294.389Z"
            fill="white"
          />
          <path
            d="M726.87 304.869C724.591 304.869 722.749 306.711 722.749 308.99C722.749 311.269 724.591 313.11 726.87 313.11C729.149 313.11 730.99 311.256 730.99 308.99C730.99 306.724 729.149 304.869 726.87 304.869Z"
            fill="white"
          />
          <path
            d="M721.106 316.027C718.836 316.027 716.994 317.869 716.994 320.14C716.994 322.41 718.836 324.239 721.106 324.239C723.377 324.239 725.219 322.397 725.219 320.14C725.219 317.882 723.377 316.027 721.106 316.027Z"
            fill="white"
          />
          <path
            d="M714.851 327.736C712.58 327.736 710.76 329.57 710.76 331.827C710.76 334.085 712.58 335.918 714.851 335.918C717.121 335.918 718.942 334.098 718.942 331.827C718.942 329.557 717.108 327.736 714.851 327.736Z"
            fill="white"
          />
          <path
            d="M708.053 339.809C705.795 339.809 703.975 341.629 703.975 343.887C703.975 346.145 705.795 347.957 708.053 347.957C710.311 347.957 712.123 346.136 712.123 343.887C712.123 341.638 710.302 339.809 708.053 339.809Z"
            fill="white"
          />
          <path
            d="M707.229 361.342C705.001 361.342 703.181 363.154 703.181 365.382C703.181 367.61 705.001 369.43 707.229 369.43C709.457 369.43 711.278 367.618 711.278 365.382C711.278 363.145 709.466 361.342 707.229 361.342Z"
            fill="white"
          />
          <path
            d="M693.106 363.82C690.87 363.82 689.058 365.632 689.058 367.869C689.058 370.105 690.87 371.917 693.106 371.917C695.343 371.917 697.155 370.105 697.155 367.869C697.155 365.632 695.343 363.82 693.106 363.82Z"
            fill="white"
          />
          <path
            d="M678.982 366.227C676.754 366.227 674.942 368.039 674.942 370.267C674.942 372.495 676.754 374.315 678.982 374.315C681.21 374.315 683.031 372.503 683.031 370.267C683.031 368.03 681.219 366.227 678.982 366.227Z"
            fill="white"
          />
          <path
            d="M664.901 368.441C662.665 368.441 660.861 370.253 660.861 372.481C660.861 374.709 662.661 376.521 664.901 376.521C667.142 376.521 668.941 374.722 668.941 372.481C668.941 370.241 667.129 368.441 664.901 368.441Z"
            fill="white"
          />
          <path
            d="M650.851 370.428C648.623 370.428 646.811 372.24 646.811 374.468C646.811 376.696 648.623 378.508 650.851 378.508C653.079 378.508 654.891 376.696 654.891 374.468C654.891 372.24 653.079 370.428 650.851 370.428Z"
            fill="white"
          />
          <path
            d="M636.851 372.248C634.623 372.248 632.823 374.06 632.823 376.288C632.823 378.516 634.623 380.315 636.851 380.315C639.079 380.315 640.891 378.516 640.891 376.288C640.891 374.06 639.079 372.248 636.851 372.248Z"
            fill="white"
          />
          <path
            d="M622.914 373.789C620.686 373.789 618.874 375.601 618.874 377.829C618.874 380.057 620.686 381.856 622.914 381.856C625.142 381.856 626.941 380.057 626.941 377.829C626.941 375.601 625.142 373.789 622.914 373.789Z"
            fill="white"
          />
          <path
            d="M609.012 375.049C606.784 375.049 604.984 376.861 604.984 379.076C604.984 381.291 606.784 383.116 609.012 383.116C611.24 383.116 613.039 381.304 613.039 379.076C613.039 376.848 611.24 375.049 609.012 375.049Z"
            fill="white"
          />
          <path
            d="M595.127 376.246C592.899 376.246 591.1 378.045 591.1 380.273C591.1 382.501 592.899 384.301 595.127 384.301C597.355 384.301 599.154 382.489 599.154 380.273C599.154 378.058 597.342 376.246 595.127 376.246Z"
            fill="white"
          />
          <path
            d="M581.253 377.441C579.038 377.441 577.226 379.254 577.226 381.469C577.226 383.684 579.038 385.496 581.253 385.496C583.468 385.496 585.28 383.697 585.28 381.469C585.28 379.241 583.481 377.441 581.253 377.441Z"
            fill="white"
          />
          <path
            d="M567.402 378.59C565.174 378.59 563.383 380.389 563.383 382.609C563.383 384.828 565.174 386.628 567.402 386.628C569.63 386.628 571.42 384.837 571.42 382.609C571.42 380.381 569.621 378.59 567.402 378.59Z"
            fill="white"
          />
          <path
            d="M553.517 379.869C551.302 379.869 549.498 381.668 549.498 383.888C549.498 386.107 551.297 387.907 553.517 387.907C555.736 387.907 557.536 386.116 557.536 383.888C557.536 381.66 555.736 379.869 553.517 379.869Z"
            fill="white"
          />
          <path
            d="M539.592 381.453C537.377 381.453 535.586 383.252 535.586 385.472C535.586 387.691 537.377 389.478 539.592 389.478C541.807 389.478 543.611 387.687 543.611 385.472C543.611 383.257 541.82 381.453 539.592 381.453Z"
            fill="white"
          />
          <path
            d="M533.712 363.068C531.475 363.068 529.663 364.88 529.663 367.108C529.663 369.336 531.475 371.157 533.712 371.157C535.948 371.157 537.752 369.345 537.752 367.108C537.752 364.872 535.94 363.068 533.712 363.068Z"
            fill="white"
          />
          <path
            d="M527.613 343.184C525.377 343.184 523.564 344.996 523.564 347.232C523.564 349.469 525.377 351.289 527.613 351.289C529.849 351.289 531.67 349.469 531.67 347.232C531.67 344.996 529.849 343.184 527.613 343.184Z"
            fill="white"
          />
          <path
            d="M521.251 323.467C519.002 323.467 517.182 325.287 517.182 327.537C517.182 329.786 519.002 331.594 521.251 331.594C523.501 331.594 525.321 329.773 525.321 327.537C525.321 325.3 523.501 323.467 521.251 323.467Z"
            fill="white"
          />
          <path
            d="M514.614 305.279C512.364 305.279 510.544 307.1 510.544 309.349C510.544 311.598 512.364 313.419 514.614 313.419C516.863 313.419 518.683 311.598 518.683 309.349C518.683 307.1 516.863 305.279 514.614 305.279Z"
            fill="white"
          />
          <path
            d="M507.721 289.25C505.472 289.25 503.651 291.071 503.651 293.32C503.651 295.569 505.472 297.398 507.721 297.398C509.97 297.398 511.799 295.577 511.799 293.32C511.799 291.062 509.979 289.25 507.721 289.25Z"
            fill="white"
          />
          <path
            d="M500.644 275.508C498.386 275.508 496.553 277.341 496.553 279.599C496.553 281.856 498.386 283.677 500.644 283.677C502.901 283.677 504.722 281.844 504.722 279.599C504.722 277.354 502.889 275.508 500.644 275.508Z"
            fill="white"
          />
          <path
            d="M493.369 263.871C491.112 263.871 489.278 265.713 489.278 267.971C489.278 270.228 491.112 272.07 493.369 272.07C495.627 272.07 497.469 270.237 497.469 267.971C497.469 265.704 495.635 263.871 493.369 263.871Z"
            fill="white"
          />
          <path
            d="M485.939 254.154C483.682 254.154 481.84 255.988 481.84 258.245C481.84 260.503 483.682 262.345 485.939 262.345C488.197 262.345 490.039 260.511 490.039 258.245C490.039 255.979 488.197 254.154 485.939 254.154Z"
            fill="white"
          />
          <path
            d="M478.329 245.992C476.059 245.992 474.229 247.826 474.229 250.092C474.229 252.358 476.063 254.183 478.329 254.183C480.595 254.183 482.42 252.349 482.42 250.092C482.42 247.834 480.587 245.992 478.329 245.992Z"
            fill="white"
          />
          <path
            d="M470.526 239.186C468.268 239.186 466.435 241.019 466.435 243.277C466.435 245.534 468.268 247.376 470.526 247.376C472.783 247.376 474.625 245.543 474.625 243.277C474.625 241.01 472.792 239.186 470.526 239.186Z"
            fill="white"
          />
          <path
            d="M462.523 233.461C460.265 233.461 458.432 235.294 458.432 237.552C458.432 239.81 460.265 241.651 462.523 241.651C464.78 241.651 466.622 239.818 466.622 237.552C466.622 235.286 464.78 233.461 462.523 233.461Z"
            fill="white"
          />
          <path
            d="M454.319 228.518C452.061 228.518 450.228 230.351 450.228 232.609C450.228 234.866 452.061 236.7 454.319 236.7C456.576 236.7 458.409 234.866 458.409 232.609C458.409 230.351 456.576 228.518 454.319 228.518Z"
            fill="white"
          />
          <path
            d="M460.417 219.275C458.159 219.275 456.326 221.109 456.326 223.366C456.326 225.624 458.159 227.457 460.417 227.457C462.675 227.457 464.508 225.624 464.508 223.366C464.508 221.109 462.675 219.275 460.417 219.275Z"
            fill="white"
          />
          <path
            d="M466.287 210.73C464.037 210.73 462.217 212.564 462.217 214.809C462.217 217.054 464.037 218.887 466.287 218.887C468.536 218.887 470.365 217.066 470.365 214.809C470.365 212.551 468.544 210.73 466.287 210.73Z"
            fill="white"
          />
          <path
            d="M471.897 203.229C469.648 203.229 467.827 205.062 467.827 207.307C467.827 209.552 469.648 211.377 471.897 211.377C474.146 211.377 475.975 209.556 475.975 207.307C475.975 205.058 474.142 203.229 471.897 203.229Z"
            fill="white"
          />
          <path
            d="M477.134 196.932C474.897 196.932 473.072 198.752 473.072 200.989C473.072 203.225 474.893 205.05 477.134 205.05C479.374 205.05 481.203 203.238 481.203 200.989C481.203 198.739 479.383 196.932 477.134 196.932Z"
            fill="white"
          />
          <path
            d="M481.941 191.572C479.713 191.572 477.901 193.376 477.901 195.612C477.901 197.849 479.713 199.64 481.941 199.64C484.169 199.64 485.981 197.84 485.981 195.612C485.981 193.384 484.169 191.572 481.941 191.572Z"
            fill="white"
          />
          <path
            d="M486.282 186.906C484.055 186.906 482.264 188.701 482.264 190.925C482.264 193.149 484.055 194.944 486.282 194.944C488.51 194.944 490.301 193.145 490.301 190.925C490.301 188.706 488.502 186.906 486.282 186.906Z"
            fill="white"
          />
          <path
            d="M490.123 182.787C487.908 182.787 486.104 184.586 486.104 186.793C486.104 189 487.904 190.799 490.123 190.799C492.343 190.799 494.129 189.008 494.129 186.793C494.129 184.578 492.33 182.787 490.123 182.787Z"
            fill="white"
          />
          <path
            d="M493.454 179.092C491.247 179.092 489.456 180.883 489.456 183.089C489.456 185.296 491.247 187.074 493.454 187.074C495.66 187.074 497.439 185.288 497.439 183.089C497.439 180.891 495.648 179.092 493.454 179.092Z"
            fill="white"
          />
          <path
            d="M496.273 175.699C494.087 175.699 492.317 177.477 492.317 179.663C492.317 181.848 494.087 183.627 496.273 183.627C498.458 183.627 500.236 181.853 500.236 179.663C500.236 177.473 498.467 175.699 496.273 175.699Z"
            fill="white"
          />
          <path
            d="M498.637 172.461C496.46 172.461 494.694 174.218 494.694 176.408C494.694 178.597 496.464 180.35 498.637 180.35C500.81 180.35 502.584 178.58 502.584 176.408C502.584 174.235 500.822 172.461 498.637 172.461Z"
            fill="white"
          />
          <path
            d="M500.592 169.273C498.428 169.273 496.68 171.022 496.68 173.186C496.68 175.35 498.428 177.112 500.592 177.112C502.757 177.112 504.518 175.355 504.518 173.186C504.518 171.018 502.761 169.273 500.592 169.273Z"
            fill="white"
          />
          <path
            d="M502.247 166.045C500.091 166.045 498.343 167.789 498.343 169.945C498.343 172.101 500.091 173.849 502.247 173.849C504.403 173.849 506.139 172.101 506.139 169.945C506.139 167.789 504.403 166.045 502.247 166.045Z"
            fill="white"
          />
          <path
            d="M515.997 163.111C513.841 163.111 512.093 164.86 512.093 167.016C512.093 169.171 513.841 170.92 515.997 170.92C518.153 170.92 519.889 169.171 519.889 167.016C519.889 164.86 518.149 163.111 515.997 163.111Z"
            fill="white"
          />
          <path
            d="M530.18 160.133C528.024 160.133 526.275 161.877 526.275 164.029C526.275 166.18 528.024 167.933 530.18 167.933C532.335 167.933 534.084 166.189 534.084 164.029C534.084 161.869 532.335 160.133 530.18 160.133Z"
            fill="white"
          />
          <path
            d="M544.961 157.371C542.796 157.371 541.048 159.124 541.048 161.284C541.048 163.444 542.796 165.188 544.961 165.188C547.125 165.188 548.865 163.44 548.865 161.284C548.865 159.128 547.116 157.371 544.961 157.371Z"
            fill="white"
          />
          <path
            d="M560.31 154.785C558.146 154.785 556.397 156.534 556.397 158.689C556.397 160.845 558.146 162.598 560.31 162.598C562.474 162.598 564.214 160.849 564.214 158.689C564.214 156.529 562.466 154.785 560.31 154.785Z"
            fill="white"
          />
          <path
            d="M576.424 152.217C574.259 152.217 572.511 153.978 572.511 156.13C572.511 158.281 574.259 160.042 576.424 160.042C578.588 160.042 580.336 158.294 580.336 156.13C580.336 153.965 578.588 152.217 576.424 152.217Z"
            fill="white"
          />
          <path
            d="M593.191 150.219C591.027 150.219 589.278 151.967 589.278 154.131C589.278 156.296 591.027 158.044 593.191 158.044C595.355 158.044 597.104 156.296 597.104 154.131C597.104 151.967 595.355 150.219 593.191 150.219Z"
            fill="white"
          />
          <path
            d="M610.489 148.729C608.325 148.729 606.563 150.481 606.563 152.646C606.563 154.81 608.32 156.562 610.489 156.562C612.658 156.562 614.402 154.81 614.402 152.646C614.402 150.481 612.653 148.729 610.489 148.729Z"
            fill="white"
          />
          <path
            d="M628.049 147.439C625.885 147.439 624.137 149.201 624.137 151.365C624.137 153.529 625.885 155.29 628.049 155.29C630.214 155.29 631.975 153.529 631.975 151.365C631.975 149.201 630.214 147.439 628.049 147.439Z"
            fill="white"
          />
          <path
            d="M645.427 146.604C643.263 146.604 641.502 148.356 641.502 150.521C641.502 152.685 643.259 154.446 645.427 154.446C647.596 154.446 649.34 152.685 649.34 150.521C649.34 148.356 647.592 146.604 645.427 146.604Z"
            fill="white"
          />
          <path
            d="M662.237 146.035C660.06 146.035 658.303 147.796 658.303 149.969C658.303 152.142 660.06 153.895 662.237 153.895C664.414 153.895 666.162 152.138 666.162 149.969C666.162 147.801 664.405 146.035 662.237 146.035Z"
            fill="white"
          />
          <path
            d="M678.359 145.598C676.195 145.598 674.434 147.359 674.434 149.532C674.434 151.704 676.191 153.457 678.359 153.457C680.528 153.457 682.285 151.7 682.285 149.532C682.285 147.363 680.523 145.598 678.359 145.598Z"
            fill="white"
          />
          <path
            d="M693.751 145.547C691.574 145.547 689.817 147.304 689.817 149.481C689.817 151.658 691.579 153.411 693.751 153.411C695.924 153.411 697.685 151.645 697.685 149.481C697.685 147.317 695.928 145.547 693.751 145.547Z"
            fill="white"
          />
          <path
            d="M701.259 154.713C699.073 154.713 697.304 156.483 697.304 158.668C697.304 160.854 699.073 162.632 701.259 162.632C703.444 162.632 705.223 160.858 705.223 158.668C705.223 156.478 703.453 154.713 701.259 154.713Z"
            fill="white"
          />
          <path
            d="M708.583 163.842C706.376 163.842 704.598 165.628 704.598 167.827C704.598 170.025 706.376 171.812 708.583 171.812C710.789 171.812 712.567 170.021 712.567 167.827C712.567 165.633 710.777 163.842 708.583 163.842Z"
            fill="white"
          />
          <path
            d="M715.755 172.885C713.536 172.885 711.736 174.684 711.736 176.904C711.736 179.123 713.536 180.91 715.755 180.91C717.975 180.91 719.774 179.119 719.774 176.904C719.774 174.688 717.975 172.885 715.755 172.885Z"
            fill="white"
          />
          <path
            d="M722.82 181.859C720.592 181.859 718.78 183.671 718.78 185.899C718.78 188.127 720.592 189.931 722.82 189.931C725.048 189.931 726.848 188.123 726.848 185.899C726.848 183.676 725.048 181.859 722.82 181.859Z"
            fill="white"
          />
          <path
            d="M729.793 190.758C727.557 190.758 725.736 192.574 725.736 194.815C725.736 197.056 727.557 198.885 729.793 198.885C732.03 198.885 733.863 197.064 733.863 194.815C733.863 192.566 732.043 190.758 729.793 190.758Z"
            fill="white"
          />
          <path
            d="M736.715 199.502C734.466 199.502 732.646 201.323 732.646 203.58C732.646 205.838 734.466 207.658 736.715 207.658C738.964 207.658 740.793 205.825 740.793 203.58C740.793 201.335 738.973 199.502 736.715 199.502Z"
            fill="white"
          />
          <path
            d="M743.598 208.045C741.34 208.045 739.507 209.878 739.507 212.136C739.507 214.394 741.34 216.235 743.598 216.235C745.855 216.235 747.697 214.402 747.697 212.136C747.697 209.87 745.864 208.045 743.598 208.045Z"
            fill="white"
          />
          <path
            d="M750.456 216.373C748.186 216.373 746.344 218.215 746.344 220.485C746.344 222.756 748.186 224.597 750.456 224.597C752.726 224.597 754.577 222.756 754.577 220.485C754.577 218.215 752.735 216.373 750.456 216.373Z"
            fill="white"
          />
          <path
            d="M757.314 224.574C755.035 224.574 753.181 226.429 753.181 228.716C753.181 231.004 755.035 232.85 757.314 232.85C759.593 232.85 761.447 230.995 761.447 228.716C761.447 226.437 759.606 224.574 757.314 224.574Z"
            fill="white"
          />
          <path
            d="M764.223 232.795C761.944 232.795 760.09 234.649 760.09 236.928C760.09 239.207 761.94 241.07 764.223 241.07C766.506 241.07 768.357 239.22 768.357 236.928C768.357 234.637 766.515 232.795 764.223 232.795Z"
            fill="white"
          />
          <path
            d="M771.258 241.143C768.966 241.143 767.116 243.006 767.116 245.297C767.116 247.589 768.971 249.439 771.258 249.439C773.545 249.439 775.413 247.589 775.413 245.297C775.413 243.006 773.55 241.143 771.258 241.143Z"
            fill="white"
          />
          <path
            d="M778.525 249.707C776.233 249.707 774.37 251.562 774.37 253.849C774.37 256.136 776.233 258.004 778.525 258.004C780.816 258.004 782.679 256.149 782.679 253.849C782.679 251.549 780.816 249.707 778.525 249.707Z"
            fill="white"
          />
          <path
            d="M772.533 255.475C770.241 255.475 768.391 257.325 768.391 259.629C768.391 261.934 770.245 263.784 772.533 263.784C774.82 263.784 776.687 261.921 776.687 259.629C776.687 257.338 774.833 255.475 772.533 255.475Z"
            fill="white"
          />
          <path
            d="M766.808 262.137C764.521 262.137 762.653 263.987 762.653 266.291C762.653 268.596 764.516 270.446 766.808 270.446C769.1 270.446 770.963 268.583 770.963 266.291C770.963 264 769.1 262.137 766.808 262.137Z"
            fill="white"
          />
          <path
            d="M761.363 269.504C759.062 269.504 757.208 271.367 757.208 273.659C757.208 275.95 759.058 277.813 761.363 277.813C763.667 277.813 765.505 275.95 765.505 273.659C765.505 271.367 763.65 269.504 761.363 269.504Z"
            fill="white"
          />
          <path
            d="M756.139 277.527C753.847 277.527 751.984 279.39 751.984 281.682C751.984 283.974 753.847 285.824 756.139 285.824C758.431 285.824 760.281 283.969 760.281 281.682C760.281 279.395 758.431 277.527 756.139 277.527Z"
            fill="white"
          />
          <path
            d="M751.03 286.199C748.751 286.199 746.896 288.049 746.896 290.333C746.896 292.616 748.751 294.475 751.03 294.475C753.309 294.475 755.172 292.624 755.172 290.333C755.172 288.041 753.322 286.199 751.03 286.199Z"
            fill="white"
          />
          <path
            d="M745.894 295.484C743.602 295.484 741.752 297.335 741.752 299.618C741.752 301.901 743.602 303.751 745.894 303.751C748.185 303.751 750.027 301.897 750.027 299.618C750.027 297.339 748.173 295.484 745.894 295.484Z"
            fill="white"
          />
          <path
            d="M740.555 305.402C738.276 305.402 736.435 307.244 736.435 309.523C736.435 311.802 738.276 313.644 740.555 313.644C742.834 313.644 744.676 311.802 744.676 309.523C744.676 307.244 742.834 305.402 740.555 305.402Z"
            fill="white"
          />
          <path
            d="M734.865 315.922C732.595 315.922 730.766 317.764 730.766 320.034C730.766 322.304 732.599 324.134 734.865 324.134C737.131 324.134 738.977 322.3 738.977 320.034C738.977 317.768 737.136 315.922 734.865 315.922Z"
            fill="white"
          />
          <path
            d="M728.702 326.998C726.445 326.998 724.611 328.831 724.611 331.089C724.611 333.347 726.445 335.18 728.702 335.18C730.96 335.18 732.793 333.347 732.793 331.089C732.793 328.831 730.96 326.998 728.702 326.998Z"
            fill="white"
          />
          <path
            d="M722.011 338.447C719.753 338.447 717.92 340.281 717.92 342.538C717.92 344.796 719.753 346.629 722.011 346.629C724.269 346.629 726.102 344.796 726.102 342.538C726.102 340.281 724.269 338.447 722.011 338.447Z"
            fill="white"
          />
          <path
            d="M714.809 350.021C712.573 350.021 710.752 351.842 710.752 354.083C710.752 356.323 712.573 358.153 714.809 358.153C717.045 358.153 718.879 356.332 718.879 354.083C718.879 351.834 717.058 350.021 714.809 350.021Z"
            fill="white"
          />
          <path
            d="M713.6 368.994C711.372 368.994 709.572 370.793 709.572 373.021C709.572 375.249 711.372 377.049 713.6 377.049C715.828 377.049 717.627 375.249 717.627 373.021C717.627 370.793 715.828 368.994 713.6 368.994Z"
            fill="white"
          />
          <path
            d="M699.404 372.043C697.188 372.043 695.385 373.842 695.385 376.062C695.385 378.281 697.184 380.081 699.404 380.081C701.623 380.081 703.422 378.281 703.422 376.062C703.422 373.842 701.632 372.043 699.404 372.043Z"
            fill="white"
          />
          <path
            d="M685.217 374.998C682.989 374.998 681.198 376.797 681.198 379.017C681.198 381.236 682.989 383.036 685.217 383.036C687.445 383.036 689.236 381.236 689.236 379.017C689.236 376.797 687.437 374.998 685.217 374.998Z"
            fill="white"
          />
          <path
            d="M671.043 377.82C668.828 377.82 667.037 379.62 667.037 381.839C667.037 384.059 668.828 385.845 671.043 385.845C673.258 385.845 675.062 384.054 675.062 381.839C675.062 379.624 673.263 377.82 671.043 377.82Z"
            fill="white"
          />
          <path
            d="M656.906 380.432C654.691 380.432 652.9 382.231 652.9 384.45C652.9 386.67 654.691 388.457 656.906 388.457C659.122 388.457 660.925 386.666 660.925 384.45C660.925 382.235 659.126 380.432 656.906 380.432Z"
            fill="white"
          />
          <path
            d="M642.826 382.887C640.611 382.887 638.82 384.678 638.82 386.893C638.82 389.108 640.611 390.912 642.826 390.912C645.042 390.912 646.845 389.112 646.845 386.893C646.845 384.673 645.046 382.887 642.826 382.887Z"
            fill="white"
          />
          <path
            d="M628.808 385.189C626.601 385.189 624.811 386.989 624.811 389.196C624.811 391.402 626.601 393.202 628.808 393.202C631.015 393.202 632.814 391.402 632.814 389.196C632.814 386.989 631.023 385.189 628.808 385.189Z"
            fill="white"
          />
          <path
            d="M614.851 387.209C612.644 387.209 610.854 389 610.854 391.215C610.854 393.43 612.644 395.221 614.851 395.221C617.058 395.221 618.857 393.422 618.857 391.215C618.857 389.008 617.066 387.209 614.851 387.209Z"
            fill="white"
          />
          <path
            d="M600.924 389.078C598.717 389.078 596.918 390.877 596.918 393.084C596.918 395.291 598.717 397.09 600.924 397.09C603.131 397.09 604.93 395.299 604.93 393.084C604.93 390.869 603.139 389.078 600.924 389.078Z"
            fill="white"
          />
          <path
            d="M587.021 399.001C589.229 399.001 591.019 397.211 591.019 395.003C591.019 392.796 589.229 391.006 587.021 391.006C584.813 391.006 583.023 392.796 583.023 395.003C583.023 397.211 584.813 399.001 587.021 399.001Z"
            fill="white"
          />
          <path
            d="M576.83 398.403C577.674 396.364 576.706 394.025 574.666 393.18C572.626 392.335 570.288 393.304 569.443 395.344C568.598 397.384 569.567 399.722 571.606 400.567C573.646 401.412 575.985 400.443 576.83 398.403Z"
            fill="white"
          />
          <path
            d="M559.241 394.752C557.034 394.752 555.256 396.543 555.256 398.75C555.256 400.956 557.034 402.734 559.241 402.734C561.447 402.734 563.238 400.944 563.238 398.75C563.238 396.556 561.447 394.752 559.241 394.752Z"
            fill="white"
          />
          <path
            d="M545.313 396.793C543.106 396.793 541.315 398.584 541.315 400.791C541.315 402.997 543.106 404.775 545.313 404.775C547.52 404.775 549.298 402.985 549.298 400.791C549.298 398.597 547.507 396.793 545.313 396.793Z"
            fill="white"
          />
          <path
            d="M531.326 399.061C529.119 399.061 527.328 400.851 527.328 403.058C527.328 405.265 529.119 407.064 531.326 407.064C533.533 407.064 535.323 405.265 535.323 403.058C535.323 400.851 533.533 399.061 531.326 399.061Z"
            fill="white"
          />
          <path
            d="M525.635 383.346C523.42 383.346 521.616 385.137 521.616 387.352C521.616 389.567 523.416 391.358 525.635 391.358C527.855 391.358 529.641 389.567 529.641 387.352C529.641 385.137 527.85 383.346 525.635 383.346Z"
            fill="white"
          />
          <path
            d="M519.766 364.674C517.538 364.674 515.726 366.486 515.726 368.714C515.726 370.942 517.538 372.754 519.766 372.754C521.994 372.754 523.806 370.942 523.806 368.714C523.806 366.486 521.994 364.674 519.766 364.674Z"
            fill="white"
          />
          <path
            d="M513.676 344.752C511.439 344.752 509.627 346.573 509.627 348.809C509.627 351.045 511.439 352.858 513.676 352.858C515.912 352.858 517.724 351.045 517.724 348.809C517.724 346.573 515.912 344.752 513.676 344.752Z"
            fill="white"
          />
          <path
            d="M507.315 325.293C505.066 325.293 503.245 327.114 503.245 329.363C503.245 331.612 505.066 333.42 507.315 333.42C509.564 333.42 511.372 331.608 511.372 329.363C511.372 327.118 509.551 325.293 507.315 325.293Z"
            fill="white"
          />
          <path
            d="M500.665 307.494C498.416 307.494 496.608 309.315 496.608 311.551C496.608 313.788 498.421 315.608 500.665 315.608C502.91 315.608 504.722 313.796 504.722 311.551C504.722 309.306 502.902 307.494 500.665 307.494Z"
            fill="white"
          />
          <path
            d="M493.756 291.838C491.498 291.838 489.678 293.671 489.678 295.929C489.678 298.187 491.498 300.02 493.756 300.02C496.014 300.02 497.847 298.187 497.847 295.929C497.847 293.671 496.014 291.838 493.756 291.838Z"
            fill="white"
          />
          <path
            d="M486.635 278.516C484.377 278.516 482.544 280.349 482.544 282.607C482.544 284.864 484.377 286.698 486.635 286.698C488.893 286.698 490.726 284.864 490.726 282.607C490.726 280.349 488.893 278.516 486.635 278.516Z"
            fill="white"
          />
          <path
            d="M479.327 267.309C477.057 267.309 475.228 269.142 475.228 271.408C475.228 273.674 477.061 275.508 479.327 275.508C481.593 275.508 483.418 273.666 483.418 271.408C483.418 269.15 481.585 267.309 479.327 267.309Z"
            fill="white"
          />
          <path
            d="M471.817 258.002C469.559 258.002 467.726 259.835 467.726 262.101C467.726 264.368 469.559 266.201 471.817 266.201C474.074 266.201 475.916 264.359 475.916 262.101C475.916 259.844 474.083 258.002 471.817 258.002Z"
            fill="white"
          />
          <path
            d="M464.114 250.312C461.844 250.312 460.015 252.146 460.015 254.412C460.015 256.678 461.848 258.503 464.114 258.503C466.38 258.503 468.205 256.67 468.205 254.412C468.205 252.154 466.372 250.312 464.114 250.312Z"
            fill="white"
          />
          <path
            d="M456.182 243.881C453.924 243.881 452.104 245.714 452.104 247.972C452.104 250.23 453.924 252.063 456.182 252.063C458.439 252.063 460.273 250.23 460.273 247.972C460.273 245.714 458.439 243.881 456.182 243.881Z"
            fill="white"
          />
          <path
            d="M448.056 238.363C445.798 238.363 443.965 240.197 443.965 242.454C443.965 244.712 445.798 246.545 448.056 246.545C450.314 246.545 452.147 244.712 452.147 242.454C452.147 240.197 450.314 238.363 448.056 238.363Z"
            fill="white"
          />
          <path
            d="M439.736 233.553C437.479 233.553 435.646 235.386 435.646 237.644C435.646 239.901 437.479 241.735 439.736 241.735C441.994 241.735 443.815 239.901 443.815 237.644C443.815 235.386 441.994 233.553 439.736 233.553Z"
            fill="white"
          />
          <path
            d="M445.9 224.176C443.642 224.176 441.809 226.009 441.809 228.254C441.809 230.499 443.642 232.345 445.9 232.345C448.157 232.345 449.978 230.512 449.978 228.254C449.978 225.996 448.145 224.176 445.9 224.176Z"
            fill="white"
          />
          <path
            d="M451.861 215.455C449.612 215.455 447.783 217.288 447.783 219.533C447.783 221.778 449.616 223.603 451.861 223.603C454.106 223.603 455.931 221.783 455.931 219.533C455.931 217.284 454.111 215.455 451.861 215.455Z"
            fill="white"
          />
          <path
            d="M457.565 207.535C455.316 207.535 453.495 209.356 453.495 211.605C453.495 213.854 455.316 215.683 457.565 215.683C459.814 215.683 461.643 213.85 461.643 211.605C461.643 209.36 459.81 207.535 457.565 207.535Z"
            fill="white"
          />
          <path
            d="M462.938 200.75C460.701 200.75 458.881 202.571 458.881 204.82C458.881 207.069 460.701 208.877 462.938 208.877C465.174 208.877 467.008 207.056 467.008 204.82C467.008 202.583 465.187 200.75 462.938 200.75Z"
            fill="white"
          />
          <path
            d="M467.89 194.996C465.654 194.996 463.842 196.808 463.842 199.045C463.842 201.281 465.654 203.093 467.89 203.093C470.127 203.093 471.93 201.281 471.93 199.045C471.93 196.808 470.118 194.996 467.89 194.996Z"
            fill="white"
          />
          <path
            d="M472.973 198.103C475.165 197.753 476.658 195.693 476.308 193.501C475.957 191.309 473.897 189.816 471.705 190.167C469.513 190.517 468.02 192.578 468.371 194.769C468.721 196.961 470.782 198.454 472.973 198.103Z"
            fill="white"
          />
          <path
            d="M476.289 185.781C474.074 185.781 472.283 187.572 472.283 189.779C472.283 191.986 474.074 193.785 476.289 193.785C478.505 193.785 480.287 191.994 480.287 189.779C480.287 187.564 478.496 185.781 476.289 185.781Z"
            fill="white"
          />
          <path
            d="M479.727 181.92C477.52 181.92 475.742 183.711 475.742 185.918C475.742 188.124 477.52 189.902 479.727 189.902C481.934 189.902 483.712 188.112 483.712 185.918C483.712 183.724 481.934 181.92 479.727 181.92Z"
            fill="white"
          />
          <path
            d="M482.649 178.424C480.464 178.424 478.694 180.193 478.694 182.379C478.694 184.565 480.464 186.334 482.649 186.334C484.835 186.334 486.605 184.565 486.605 182.379C486.605 180.193 484.835 178.424 482.649 178.424Z"
            fill="white"
          />
          <path
            d="M485.094 175.137C482.917 175.137 481.16 176.906 481.16 179.079C481.16 181.252 482.917 183.013 485.094 183.013C487.271 183.013 489.037 181.252 489.037 179.079C489.037 176.906 487.267 175.137 485.094 175.137Z"
            fill="white"
          />
          <path
            d="M487.093 171.99C484.938 171.99 483.181 173.743 483.181 175.903C483.181 178.063 484.942 179.816 487.093 179.816C489.245 179.816 491.006 178.063 491.006 175.903C491.006 173.743 489.258 171.99 487.093 171.99Z"
            fill="white"
          />
          <path
            d="M488.728 168.881C486.572 168.881 484.823 170.617 484.823 172.772C484.823 174.928 486.572 176.664 488.728 176.664C490.883 176.664 492.619 174.92 492.619 172.772C492.619 170.625 490.871 168.881 488.728 168.881Z"
            fill="white"
          />
          <path
            d="M490.089 165.73C487.955 165.73 486.24 167.453 486.24 169.58C486.24 171.706 487.959 173.424 490.089 173.424C492.22 173.424 493.938 171.706 493.938 169.58C493.938 167.453 492.211 165.73 490.089 165.73Z"
            fill="white"
          />
          <path
            d="M503.738 162.709C501.603 162.709 499.876 164.436 499.876 166.571C499.876 168.705 501.603 170.42 503.738 170.42C505.872 170.42 507.587 168.693 507.587 166.571C507.587 164.449 505.86 162.709 503.738 162.709Z"
            fill="white"
          />
          <path
            d="M517.746 159.51C515.624 159.51 513.896 161.233 513.896 163.367C513.896 165.502 515.624 167.216 517.746 167.216C519.867 167.216 521.607 165.493 521.607 163.367C521.607 161.241 519.88 159.51 517.746 159.51Z"
            fill="white"
          />
          <path
            d="M532.408 156.178C530.286 156.178 528.559 157.901 528.559 160.035C528.559 162.17 530.286 163.884 532.408 163.884C534.53 163.884 536.27 162.161 536.27 160.035C536.27 157.909 534.542 156.178 532.408 156.178Z"
            fill="white"
          />
          <path
            d="M547.826 160.796C549.958 160.796 551.687 159.067 551.687 156.934C551.687 154.801 549.958 153.072 547.826 153.072C545.693 153.072 543.964 154.801 543.964 156.934C543.964 159.067 545.693 160.796 547.826 160.796Z"
            fill="white"
          />
          <path
            d="M564.006 149.969C561.872 149.969 560.145 151.696 560.145 153.835C560.145 155.974 561.872 157.701 564.006 157.701C566.141 157.701 567.877 155.974 567.877 153.835C567.877 151.696 566.149 149.969 564.006 149.969Z"
            fill="white"
          />
          <path
            d="M581.11 146.953C578.975 146.953 577.248 148.68 577.248 150.819C577.248 152.958 578.975 154.685 581.11 154.685C583.244 154.685 584.98 152.958 584.98 150.819C584.98 148.68 583.253 146.953 581.11 146.953Z"
            fill="white"
          />
          <path
            d="M598.866 144.559C596.731 144.559 595.004 146.286 595.004 148.42C595.004 150.555 596.731 152.291 598.866 152.291C601 152.291 602.736 150.563 602.736 148.42C602.736 146.277 600.996 144.559 598.866 144.559Z"
            fill="white"
          />
          <path
            d="M617.101 142.467C614.958 142.467 613.23 144.207 613.23 146.346C613.23 148.484 614.958 150.224 617.101 150.224C619.244 150.224 620.971 148.484 620.971 146.346C620.971 144.207 619.244 142.467 617.101 142.467Z"
            fill="white"
          />
          <path
            d="M635.302 140.568C633.159 140.568 631.432 142.304 631.432 144.451C631.432 146.599 633.159 148.322 635.302 148.322C637.445 148.322 639.172 146.586 639.172 144.451C639.172 142.317 637.445 140.568 635.302 140.568Z"
            fill="white"
          />
          <path
            d="M652.986 139.062C650.842 139.062 649.103 140.798 649.103 142.946C649.103 145.093 650.842 146.829 652.986 146.829C655.129 146.829 656.869 145.089 656.869 142.946C656.869 140.802 655.129 139.062 652.986 139.062Z"
            fill="white"
          />
          <path
            d="M669.897 137.697C667.742 137.697 666.006 139.441 666.006 141.589C666.006 143.736 667.746 145.48 669.897 145.48C672.049 145.48 673.789 143.736 673.789 141.589C673.789 139.441 672.04 137.697 669.897 137.697Z"
            fill="white"
          />
          <path
            d="M685.989 136.543C683.833 136.543 682.085 138.283 682.085 140.434C682.085 142.586 683.833 144.339 685.989 144.339C688.145 144.339 689.881 142.59 689.881 140.434C689.881 138.279 688.141 136.543 685.989 136.543Z"
            fill="white"
          />
          <path
            d="M701.237 135.961C699.081 135.961 697.346 137.709 697.346 139.865C697.346 142.021 699.086 143.757 701.237 143.757C703.389 143.757 705.141 142.017 705.141 139.865C705.141 137.714 703.393 135.961 701.237 135.961Z"
            fill="white"
          />
          <path
            d="M708.44 145.965C706.263 145.965 704.506 147.73 704.506 149.899C704.506 152.067 706.267 153.833 708.44 153.833C710.613 153.833 712.365 152.076 712.365 149.899C712.365 147.722 710.608 145.965 708.44 145.965Z"
            fill="white"
          />
          <path
            d="M715.484 155.861C713.299 155.861 711.521 157.639 711.521 159.833C711.521 162.028 713.299 163.806 715.484 163.806C717.67 163.806 719.461 162.028 719.461 159.833C719.461 157.639 717.682 155.861 715.484 155.861Z"
            fill="white"
          />
          <path
            d="M722.44 165.641C720.246 165.641 718.455 167.427 718.455 169.625C718.455 171.824 720.246 173.61 722.44 173.61C724.634 173.61 726.425 171.832 726.425 169.625C726.425 167.419 724.647 165.641 722.44 165.641Z"
            fill="white"
          />
          <path
            d="M730.248 183.245C732.408 182.735 733.746 180.571 733.236 178.411C732.726 176.251 730.562 174.913 728.402 175.423C726.241 175.932 724.904 178.097 725.413 180.257C725.923 182.417 728.088 183.755 730.248 183.245Z"
            fill="white"
          />
          <path
            d="M736.177 184.73C733.949 184.73 732.137 186.543 732.137 188.771C732.137 190.998 733.949 192.811 736.177 192.811C738.405 192.811 740.217 191.003 740.217 188.771C740.217 186.538 738.417 184.73 736.177 184.73Z"
            fill="white"
          />
          <path
            d="M743.012 193.924C740.763 193.924 738.942 195.744 738.942 197.994C738.942 200.243 740.763 202.063 743.012 202.063C745.261 202.063 747.082 200.243 747.082 197.994C747.082 195.744 745.261 193.924 743.012 193.924Z"
            fill="white"
          />
          <path
            d="M749.85 210.969C752.109 210.969 753.941 209.137 753.941 206.878C753.941 204.619 752.109 202.787 749.85 202.787C747.59 202.787 745.759 204.619 745.759 206.878C745.759 209.137 747.59 210.969 749.85 210.969Z"
            fill="white"
          />
          <path
            d="M756.698 211.377C754.441 211.377 752.607 213.21 752.607 215.468C752.607 217.726 754.441 219.567 756.698 219.567C758.956 219.567 760.798 217.734 760.798 215.468C760.798 213.202 758.965 211.377 756.698 211.377Z"
            fill="white"
          />
          <path
            d="M763.578 219.744C761.299 219.744 759.457 221.586 759.457 223.865C759.457 226.144 761.299 227.977 763.578 227.977C765.857 227.977 767.69 226.135 767.69 223.865C767.69 221.594 765.848 219.744 763.578 219.744Z"
            fill="white"
          />
          <path
            d="M770.499 228.039C768.207 228.039 766.365 229.894 766.365 232.172C766.365 234.451 768.207 236.314 770.499 236.314C772.79 236.314 774.632 234.46 774.632 232.172C774.632 229.885 772.778 228.039 770.499 228.039Z"
            fill="white"
          />
          <path
            d="M777.505 236.314C775.227 236.314 773.372 238.165 773.372 240.448C773.372 242.731 775.222 244.59 777.505 244.59C779.789 244.59 781.639 242.735 781.639 240.448C781.639 238.161 779.789 236.314 777.505 236.314Z"
            fill="white"
          />
          <path
            d="M784.656 244.555C782.369 244.555 780.506 246.418 780.506 248.709C780.506 251.001 782.369 252.864 784.656 252.864C786.944 252.864 788.811 251.001 788.811 248.709C788.811 246.418 786.948 244.555 784.656 244.555Z"
            fill="white"
          />
          <path
            d="M792.045 252.902C789.754 252.902 787.891 254.765 787.891 257.057C787.891 259.349 789.754 261.212 792.045 261.212C794.337 261.212 796.2 259.349 796.2 257.057C796.2 254.765 794.337 252.902 792.045 252.902Z"
            fill="white"
          />
          <path
            d="M786.134 258.533C783.834 258.533 781.979 260.396 781.979 262.688C781.979 264.979 783.834 266.842 786.134 266.842C788.434 266.842 790.289 264.988 790.289 262.688C790.289 260.388 788.426 258.533 786.134 258.533Z"
            fill="white"
          />
          <path
            d="M780.451 264.924C778.159 264.924 776.296 266.787 776.296 269.087C776.296 271.387 778.159 273.242 780.451 273.242C782.742 273.242 784.605 271.379 784.605 269.087C784.605 266.795 782.742 264.924 780.451 264.924Z"
            fill="white"
          />
          <path
            d="M774.997 271.867C772.71 271.867 770.847 273.722 770.847 276.022C770.847 278.322 772.71 280.176 774.997 280.176C777.284 280.176 779.152 278.313 779.152 276.022C779.152 273.73 777.301 271.867 774.997 271.867Z"
            fill="white"
          />
          <path
            d="M769.761 279.393C767.461 279.393 765.606 281.256 765.606 283.547C765.606 285.839 767.461 287.702 769.761 287.702C772.061 287.702 773.916 285.839 773.916 283.547C773.916 281.256 772.053 279.393 769.761 279.393Z"
            fill="white"
          />
          <path
            d="M764.66 287.582C762.369 287.582 760.519 289.437 760.519 291.715C760.519 293.994 762.369 295.857 764.66 295.857C766.952 295.857 768.794 294.003 768.794 291.715C768.794 289.428 766.939 287.582 764.66 287.582Z"
            fill="white"
          />
          <path
            d="M759.55 296.379C757.272 296.379 755.417 298.221 755.417 300.512C755.417 302.804 757.272 304.646 759.55 304.646C761.829 304.646 763.692 302.795 763.692 300.512C763.692 298.229 761.838 296.379 759.55 296.379Z"
            fill="white"
          />
          <path
            d="M754.275 305.766C751.996 305.766 750.154 307.607 750.154 309.886C750.154 312.165 751.996 314.007 754.275 314.007C756.554 314.007 758.396 312.165 758.396 309.886C758.396 307.607 756.554 305.766 754.275 305.766Z"
            fill="white"
          />
          <path
            d="M748.652 315.691C746.382 315.691 744.54 317.533 744.54 319.804C744.54 322.074 746.382 323.916 748.652 323.916C750.923 323.916 752.752 322.074 752.752 319.804C752.752 317.533 750.918 315.691 748.652 315.691Z"
            fill="white"
          />
          <path
            d="M742.567 326.111C740.297 326.111 738.455 327.953 738.455 330.224C738.455 332.494 740.297 334.336 742.567 334.336C744.838 334.336 746.667 332.494 746.667 330.224C746.667 327.953 744.833 326.111 742.567 326.111Z"
            fill="white"
          />
          <path
            d="M735.955 336.914C733.684 336.914 731.855 338.747 731.855 341.005C731.855 343.263 733.689 345.096 735.955 345.096C738.221 345.096 740.046 343.263 740.046 341.005C740.046 338.747 738.213 336.914 735.955 336.914Z"
            fill="white"
          />
          <path
            d="M728.847 347.885C726.598 347.885 724.777 349.705 724.777 351.955C724.777 354.204 726.598 356.033 728.847 356.033C731.096 356.033 732.925 354.199 732.925 351.955C732.925 349.71 731.092 347.885 728.847 347.885Z"
            fill="white"
          />
          <path
            d="M721.352 358.697C719.116 358.697 717.304 360.509 717.304 362.746C717.304 364.982 719.116 366.794 721.352 366.794C723.589 366.794 725.401 364.982 725.401 362.746C725.401 360.509 723.589 358.697 721.352 358.697Z"
            fill="white"
          />
          <path
            d="M719.96 374.934C717.745 374.934 715.954 376.733 715.954 378.94C715.954 381.146 717.745 382.959 719.96 382.959C722.175 382.959 723.966 381.159 723.966 378.94C723.966 376.72 722.167 374.934 719.96 374.934Z"
            fill="white"
          />
          <path
            d="M705.711 378.432C703.504 378.432 701.705 380.222 701.705 382.429C701.705 384.636 703.504 386.435 705.711 386.435C707.918 386.435 709.717 384.644 709.717 382.429C709.717 380.214 707.918 378.432 705.711 378.432Z"
            fill="white"
          />
          <path
            d="M691.452 381.771C689.245 381.771 687.454 383.562 687.454 385.778C687.454 387.993 689.245 389.775 691.452 389.775C693.658 389.775 695.449 387.984 695.449 385.778C695.449 383.571 693.658 381.771 691.452 381.771Z"
            fill="white"
          />
          <path
            d="M677.192 385.031C674.985 385.031 673.194 386.822 673.194 389.029C673.194 391.236 674.985 393.035 677.192 393.035C679.399 393.035 681.198 391.244 681.198 389.029C681.198 386.814 679.407 385.031 677.192 385.031Z"
            fill="white"
          />
          <path
            d="M662.967 388.111C660.761 388.111 658.982 389.902 658.982 392.109C658.982 394.316 660.761 396.107 662.967 396.107C665.174 396.107 666.965 394.316 666.965 392.109C666.965 389.902 665.174 388.111 662.967 388.111Z"
            fill="white"
          />
          <path
            d="M649.44 398.949C651.619 398.595 653.099 396.541 652.745 394.362C652.392 392.183 650.338 390.703 648.159 391.057C645.98 391.41 644.5 393.464 644.853 395.643C645.207 397.823 647.261 399.302 649.44 398.949Z"
            fill="white"
          />
          <path
            d="M634.666 393.938C632.459 393.938 630.668 395.716 630.668 397.922C630.668 400.129 632.459 401.92 634.666 401.92C636.872 401.92 638.663 400.129 638.663 397.922C638.663 395.716 636.872 393.938 634.666 393.938Z"
            fill="white"
          />
          <path
            d="M620.614 396.688C618.42 396.688 616.629 398.478 616.629 400.672C616.629 402.866 618.42 404.67 620.614 404.67C622.808 404.67 624.611 402.879 624.611 400.672C624.611 398.466 622.821 396.688 620.614 396.688Z"
            fill="white"
          />
          <path
            d="M606.626 399.279C604.42 399.279 602.629 401.07 602.629 403.264C602.629 405.458 604.42 407.249 606.626 407.249C608.833 407.249 610.611 405.471 610.611 403.264C610.611 401.057 608.821 399.279 606.626 399.279Z"
            fill="white"
          />
          <path
            d="M592.652 401.912C590.458 401.912 588.676 403.69 588.676 405.897C588.676 408.104 590.454 409.873 592.652 409.873C594.85 409.873 596.637 408.095 596.637 405.897C596.637 403.699 594.859 401.912 592.652 401.912Z"
            fill="white"
          />
          <path
            d="M578.715 404.598C576.521 404.598 574.73 406.376 574.73 408.574C574.73 410.772 576.521 412.559 578.715 412.559C580.909 412.559 582.692 410.781 582.692 408.574C582.692 406.367 580.914 404.598 578.715 404.598Z"
            fill="white"
          />
          <path
            d="M564.788 407.25C562.594 407.25 560.803 409.041 560.803 411.235C560.803 413.429 562.594 415.211 564.788 415.211C566.982 415.211 568.764 413.433 568.764 411.235C568.764 409.037 566.986 407.25 564.788 407.25Z"
            fill="white"
          />
          <path
            d="M550.822 410.061C548.637 410.061 546.858 411.839 546.858 414.037C546.858 416.235 548.637 418.001 550.822 418.001C553.008 418.001 554.798 416.231 554.798 414.037C554.798 411.843 553.02 410.061 550.822 410.061Z"
            fill="white"
          />
          <path
            d="M536.813 413.133C534.619 413.133 532.837 414.911 532.837 417.109C532.837 419.307 534.615 421.086 536.813 421.086C539.012 421.086 540.777 419.307 540.777 417.109C540.777 414.911 538.999 413.133 536.813 413.133Z"
            fill="white"
          />
          <path
            d="M522.72 416.535C520.521 416.535 518.756 418.313 518.756 420.512C518.756 422.71 520.525 424.488 522.72 424.488C524.914 424.488 526.696 422.71 526.696 420.512C526.696 418.313 524.918 416.535 522.72 416.535Z"
            fill="white"
          />
          <path
            d="M517.275 401.633C515.068 401.633 513.29 403.411 513.29 405.618C513.29 407.824 515.068 409.615 517.275 409.615C519.482 409.615 521.273 407.824 521.273 405.618C521.273 403.411 519.482 401.633 517.275 401.633Z"
            fill="white"
          />
          <path
            d="M511.592 385.719C509.377 385.719 507.573 387.518 507.573 389.725C507.573 391.932 509.373 393.744 511.592 393.744C513.812 393.744 515.598 391.944 515.598 389.725C515.598 387.505 513.799 385.719 511.592 385.719Z"
            fill="white"
          />
          <path
            d="M505.724 367.045C503.496 367.045 501.684 368.857 501.684 371.085C501.684 373.313 503.496 375.125 505.724 375.125C507.952 375.125 509.764 373.313 509.764 371.085C509.764 368.857 507.964 367.045 505.724 367.045Z"
            fill="white"
          />
          <path
            d="M499.646 347.303C497.41 347.303 495.598 349.115 495.598 351.351C495.598 353.588 497.41 355.4 499.646 355.4C501.883 355.4 503.695 353.588 503.695 351.351C503.695 349.115 501.883 347.303 499.646 347.303Z"
            fill="white"
          />
          <path
            d="M493.286 328.123C491.036 328.123 489.216 329.944 489.216 332.18C489.216 334.417 491.036 336.25 493.286 336.25C495.535 336.25 497.343 334.429 497.343 332.18C497.343 329.931 495.522 328.123 493.286 328.123Z"
            fill="white"
          />
          <path
            d="M486.625 310.637C484.376 310.637 482.556 312.457 482.556 314.715C482.556 316.973 484.376 318.785 486.625 318.785C488.875 318.785 490.695 316.964 490.695 314.715C490.695 312.466 488.875 310.637 486.625 310.637Z"
            fill="white"
          />
          <path
            d="M479.692 295.355C477.435 295.355 475.614 297.189 475.614 299.434C475.614 301.679 477.435 303.525 479.692 303.525C481.95 303.525 483.771 301.691 483.771 299.434C483.771 297.176 481.937 295.355 479.692 295.355Z"
            fill="white"
          />
          <path
            d="M472.521 282.422C470.263 282.422 468.43 284.255 468.43 286.5C468.43 288.745 470.263 290.591 472.521 290.591C474.778 290.591 476.599 288.758 476.599 286.5C476.599 284.242 474.778 282.422 472.521 282.422Z"
            fill="white"
          />
          <path
            d="M465.123 271.646C462.866 271.646 461.032 273.48 461.032 275.746C461.032 278.012 462.866 279.837 465.123 279.837C467.381 279.837 469.223 278.004 469.223 275.746C469.223 273.488 467.389 271.646 465.123 271.646Z"
            fill="white"
          />
          <path
            d="M457.524 262.74C455.266 262.74 453.433 264.574 453.433 266.831C453.433 269.089 455.266 270.922 457.524 270.922C459.781 270.922 461.602 269.089 461.602 266.831C461.602 264.574 459.781 262.74 457.524 262.74Z"
            fill="white"
          />
          <path
            d="M449.697 255.279C447.44 255.279 445.606 257.113 445.606 259.37C445.606 261.628 447.44 263.461 449.697 263.461C451.955 263.461 453.776 261.628 453.776 259.37C453.776 257.113 451.955 255.279 449.697 255.279Z"
            fill="white"
          />
          <path
            d="M441.651 248.959C439.381 248.959 437.552 250.792 437.552 253.058C437.552 255.325 439.385 257.158 441.651 257.158C443.917 257.158 445.751 255.316 445.751 253.058C445.751 250.801 443.909 248.959 441.651 248.959Z"
            fill="white"
          />
          <path
            d="M433.418 243.6C431.16 243.6 429.327 245.433 429.327 247.699C429.327 249.965 431.16 251.79 433.418 251.79C435.676 251.79 437.518 249.957 437.518 247.699C437.518 245.441 435.684 243.6 433.418 243.6Z"
            fill="white"
          />
          <path
            d="M425.041 238.947C422.783 238.947 420.963 240.781 420.963 243.038C420.963 245.296 422.783 247.116 425.041 247.116C427.299 247.116 429.119 245.283 429.119 243.038C429.119 240.793 427.286 238.947 425.041 238.947Z"
            fill="white"
          />
          <path
            d="M431.245 229.412C428.988 229.412 427.167 231.245 427.167 233.49C427.167 235.735 428.988 237.569 431.245 237.569C433.503 237.569 435.323 235.748 435.323 233.49C435.323 231.233 433.49 229.412 431.245 229.412Z"
            fill="white"
          />
          <path
            d="M437.251 228.602C439.499 228.602 441.321 226.78 441.321 224.533C441.321 222.285 439.499 220.463 437.251 220.463C435.004 220.463 433.182 222.285 433.182 224.533C433.182 226.78 435.004 228.602 437.251 228.602Z"
            fill="white"
          />
          <path
            d="M443.035 212.188C440.785 212.188 438.965 214.021 438.965 216.266C438.965 218.511 440.785 220.336 443.035 220.336C445.284 220.336 447.104 218.515 447.104 216.266C447.104 214.017 445.284 212.188 443.035 212.188Z"
            fill="white"
          />
          <path
            d="M448.543 204.994C446.294 204.994 444.486 206.815 444.486 209.051C444.486 211.288 446.298 213.1 448.543 213.1C450.788 213.1 452.592 211.288 452.592 209.051C452.592 206.815 450.78 204.994 448.543 204.994Z"
            fill="white"
          />
          <path
            d="M453.652 198.875C451.424 198.875 449.612 200.687 449.612 202.915C449.612 205.143 451.424 206.955 453.652 206.955C455.88 206.955 457.692 205.143 457.692 202.915C457.692 200.687 455.88 198.875 453.652 198.875Z"
            fill="white"
          />
          <path
            d="M458.295 193.629C456.067 193.629 454.268 195.428 454.268 197.656C454.268 199.884 456.067 201.684 458.295 201.684C460.523 201.684 462.322 199.884 462.322 197.656C462.322 195.428 460.523 193.629 458.295 193.629Z"
            fill="white"
          />
          <path
            d="M462.429 189.082C460.223 189.082 458.432 190.873 458.432 193.08C458.432 195.286 460.223 197.086 462.429 197.086C464.636 197.086 466.427 195.295 466.427 193.08C466.427 190.864 464.636 189.082 462.429 189.082Z"
            fill="white"
          />
          <path
            d="M466.04 185.043C463.833 185.043 462.055 186.821 462.055 189.024C462.055 191.226 463.833 193.004 466.04 193.004C468.246 193.004 470.016 191.226 470.016 189.024C470.016 186.821 468.238 185.043 466.04 185.043Z"
            fill="white"
          />
          <path
            d="M469.121 181.424C466.936 181.424 465.166 183.193 465.166 185.379C465.166 187.565 466.936 189.334 469.121 189.334C471.307 189.334 473.076 187.565 473.076 185.379C473.076 183.193 471.307 181.424 469.121 181.424Z"
            fill="white"
          />
          <path
            d="M471.689 178.08C469.512 178.08 467.742 179.85 467.742 182.027C467.742 184.204 469.512 185.961 471.689 185.961C473.866 185.961 475.623 184.204 475.623 182.027C475.623 179.85 473.862 178.08 471.689 178.08Z"
            fill="white"
          />
          <path
            d="M473.772 174.957C471.617 174.957 469.868 176.705 469.868 178.861C469.868 181.017 471.617 182.774 473.772 182.774C475.928 182.774 477.685 181.026 477.685 178.861C477.685 176.697 475.937 174.957 473.772 174.957Z"
            fill="white"
          />
          <path
            d="M475.448 171.896C473.292 171.896 471.557 173.641 471.557 175.788C471.557 177.935 473.297 179.68 475.448 179.68C477.6 179.68 479.34 177.94 479.34 175.788C479.34 173.636 477.604 171.896 475.448 171.896Z"
            fill="white"
          />
          <path
            d="M476.781 168.881C474.659 168.881 472.94 170.6 472.94 172.726C472.94 174.852 474.659 176.571 476.781 176.571C478.903 176.571 480.63 174.852 480.63 172.726C480.63 170.6 478.903 168.881 476.781 168.881Z"
            fill="white"
          />
          <path
            d="M477.893 165.756C475.792 165.756 474.082 167.462 474.082 169.575C474.082 171.689 475.788 173.386 477.893 173.386C479.998 173.386 481.712 171.68 481.712 169.575C481.712 167.47 480.006 165.756 477.893 165.756Z"
            fill="white"
          />
          <path
            d="M491.341 162.416C489.227 162.416 487.521 164.126 487.521 166.235C487.521 168.345 489.227 170.055 491.341 170.055C493.454 170.055 495.16 168.349 495.16 166.235C495.16 164.122 493.442 162.416 491.341 162.416Z"
            fill="white"
          />
          <path
            d="M505.243 159.127C503.13 159.127 501.424 160.837 501.424 162.946C501.424 165.055 503.13 166.766 505.243 166.766C507.357 166.766 509.063 165.06 509.063 162.946C509.063 160.833 507.344 159.127 505.243 159.127Z"
            fill="white"
          />
          <path
            d="M519.724 155.537C517.602 155.537 515.892 157.256 515.892 159.365C515.892 161.474 517.598 163.197 519.724 163.197C521.85 163.197 523.543 161.478 523.543 159.365C523.543 157.252 521.837 155.537 519.724 155.537Z"
            fill="white"
          />
          <path
            d="M535.064 151.783C532.951 151.783 531.232 153.502 531.232 155.611C531.232 157.72 532.951 159.443 535.064 159.443C537.178 159.443 538.892 157.724 538.892 155.611C538.892 153.498 537.174 151.783 535.064 151.783Z"
            fill="white"
          />
          <path
            d="M551.311 148.221C549.197 148.221 547.479 149.931 547.479 152.053C547.479 154.175 549.197 155.881 551.311 155.881C553.424 155.881 555.151 154.17 555.151 152.053C555.151 149.935 553.433 148.221 551.311 148.221Z"
            fill="white"
          />
          <path
            d="M568.606 144.496C566.484 144.496 564.766 146.215 564.766 148.324C564.766 150.433 566.484 152.165 568.606 152.165C570.728 152.165 572.434 150.446 572.434 148.324C572.434 146.202 570.715 144.496 568.606 144.496Z"
            fill="white"
          />
          <path
            d="M586.792 140.971C584.67 140.971 582.951 142.694 582.951 144.807C582.951 146.92 584.67 148.648 586.792 148.648C588.914 148.648 590.632 146.929 590.632 144.807C590.632 142.685 588.914 140.971 586.792 140.971Z"
            fill="white"
          />
          <path
            d="M605.63 145.671C607.751 145.671 609.47 143.952 609.47 141.831C609.47 139.71 607.751 137.99 605.63 137.99C603.509 137.99 601.789 139.71 601.789 141.831C601.789 143.952 603.509 145.671 605.63 145.671Z"
            fill="white"
          />
          <path
            d="M624.646 135.129C622.524 135.129 620.797 136.856 620.797 138.991C620.797 141.125 622.524 142.84 624.646 142.84C626.768 142.84 628.508 141.117 628.508 138.991C628.508 136.865 626.781 135.129 624.646 135.129Z"
            fill="white"
          />
          <path
            d="M643.263 132.473C641.129 132.473 639.401 134.2 639.401 136.322C639.401 138.444 641.129 140.184 643.263 140.184C645.398 140.184 647.125 138.456 647.125 136.322C647.125 134.187 645.398 132.473 643.263 132.473Z"
            fill="white"
          />
          <path
            d="M661.048 130.096C658.914 130.096 657.187 131.827 657.187 133.962C657.187 136.096 658.914 137.824 661.048 137.824C663.183 137.824 664.91 136.096 664.91 133.962C664.91 131.827 663.183 130.096 661.048 130.096Z"
            fill="white"
          />
          <path
            d="M677.922 127.814C675.787 127.814 674.052 129.546 674.052 131.681C674.052 133.815 675.792 135.547 677.922 135.547C680.052 135.547 681.784 133.815 681.784 131.681C681.784 129.546 680.057 127.814 677.922 127.814Z"
            fill="white"
          />
          <path
            d="M693.844 125.934C691.709 125.934 689.974 127.665 689.974 129.8C689.974 131.934 691.709 133.67 693.844 133.67C695.979 133.67 697.714 131.943 697.714 129.8C697.714 127.657 695.987 125.934 693.844 125.934Z"
            fill="white"
          />
          <path
            d="M708.898 124.852C706.763 124.852 705.027 126.583 705.027 128.722C705.027 130.861 706.767 132.588 708.898 132.588C711.028 132.588 712.768 130.861 712.768 128.722C712.768 126.583 711.028 124.852 708.898 124.852Z"
            fill="white"
          />
          <path
            d="M715.776 135.875C713.621 135.875 711.872 137.623 711.872 139.779C711.872 141.935 713.621 143.683 715.776 143.683C717.932 143.683 719.681 141.935 719.681 139.779C719.681 137.623 717.932 135.875 715.776 135.875Z"
            fill="white"
          />
          <path
            d="M722.54 146.73C720.363 146.73 718.606 148.5 718.606 150.673C718.606 152.846 720.368 154.611 722.54 154.611C724.713 154.611 726.483 152.846 726.483 150.673C726.483 148.5 724.726 146.73 722.54 146.73Z"
            fill="white"
          />
          <path
            d="M729.242 157.418C727.056 157.418 725.278 159.192 725.278 161.39C725.278 163.588 727.056 165.354 729.242 165.354C731.427 165.354 733.218 163.58 733.218 161.39C733.218 159.2 731.44 157.418 729.242 157.418Z"
            fill="white"
          />
          <path
            d="M735.926 167.883C733.72 167.883 731.929 169.674 731.929 171.88C731.929 174.087 733.72 175.874 735.926 175.874C738.133 175.874 739.911 174.087 739.911 171.88C739.911 169.674 738.133 167.883 735.926 167.883Z"
            fill="white"
          />
          <path
            d="M742.605 178.055C740.377 178.055 738.578 179.854 738.578 182.078C738.578 184.301 740.377 186.097 742.605 186.097C744.833 186.097 746.624 184.297 746.624 182.078C746.624 179.858 744.825 178.055 742.605 178.055Z"
            fill="white"
          />
          <path
            d="M749.331 187.803C747.094 187.803 745.282 189.615 745.282 191.851C745.282 194.088 747.094 195.904 749.331 195.904C751.567 195.904 753.379 194.088 753.379 191.851C753.379 189.615 751.567 187.803 749.331 187.803Z"
            fill="white"
          />
          <path
            d="M756.105 197.139C753.856 197.139 752.035 198.959 752.035 201.208C752.035 203.458 753.856 205.278 756.105 205.278C758.354 205.278 760.175 203.458 760.175 201.208C760.175 198.959 758.354 197.139 756.105 197.139Z"
            fill="white"
          />
          <path
            d="M762.933 206.117C760.675 206.117 758.842 207.95 758.842 210.195C758.842 212.44 760.675 214.286 762.933 214.286C765.19 214.286 767.011 212.453 767.011 210.195C767.011 207.938 765.19 206.117 762.933 206.117Z"
            fill="white"
          />
          <path
            d="M769.804 214.822C767.546 214.822 765.704 216.664 765.704 218.922C765.704 221.179 767.546 223.034 769.804 223.034C772.061 223.034 773.916 221.192 773.916 218.922C773.916 216.651 772.074 214.822 769.804 214.822Z"
            fill="white"
          />
          <path
            d="M776.734 223.312C774.455 223.312 772.613 225.167 772.613 227.433C772.613 229.699 774.455 231.567 776.734 231.567C779.013 231.567 780.855 229.716 780.855 227.433C780.855 225.15 779.013 223.312 776.734 223.312Z"
            fill="white"
          />
          <path
            d="M783.727 231.607C781.448 231.607 779.594 233.449 779.594 235.741C779.594 238.032 781.448 239.874 783.727 239.874C786.006 239.874 787.861 238.024 787.861 235.741C787.861 233.458 786.019 231.607 783.727 231.607Z"
            fill="white"
          />
          <path
            d="M790.826 239.768C788.535 239.768 786.685 241.618 786.685 243.909C786.685 246.201 788.539 248.051 790.826 248.051C793.114 248.051 794.968 246.197 794.968 243.909C794.968 241.622 793.114 239.768 790.826 239.768Z"
            fill="white"
          />
          <path
            d="M798.114 247.863C795.814 247.863 793.959 249.718 793.959 252.018C793.959 254.318 795.814 256.16 798.114 256.16C800.414 256.16 802.268 254.305 802.268 252.018C802.268 249.731 800.405 247.863 798.114 247.863Z"
            fill="white"
          />
          <path
            d="M805.679 256.018C803.379 256.018 801.524 257.872 801.524 260.172C801.524 262.472 803.375 264.327 805.679 264.327C807.983 264.327 809.834 262.464 809.834 260.172C809.834 257.881 807.971 256.018 805.679 256.018Z"
            fill="white"
          />
          <path
            d="M799.82 261.436C797.52 261.436 795.665 263.299 795.665 265.599C795.665 267.899 797.515 269.753 799.82 269.753C802.124 269.753 803.97 267.89 803.97 265.599C803.97 263.307 802.107 261.436 799.82 261.436Z"
            fill="white"
          />
          <path
            d="M794.187 267.57C791.895 267.57 790.032 269.421 790.032 271.725C790.032 274.029 791.895 275.88 794.187 275.88C796.478 275.88 798.341 274.017 798.341 271.725C798.341 269.433 796.491 267.57 794.187 267.57Z"
            fill="white"
          />
          <path
            d="M788.786 274.166C786.499 274.166 784.632 276.029 784.632 278.321C784.632 280.612 786.495 282.475 788.786 282.475C791.078 282.475 792.95 280.621 792.95 278.321C792.95 276.021 791.087 274.166 788.786 274.166Z"
            fill="white"
          />
          <path
            d="M783.562 281.266C781.27 281.266 779.407 283.129 779.407 285.42C779.407 287.712 781.27 289.575 783.562 289.575C785.853 289.575 787.717 287.712 787.717 285.42C787.717 283.129 785.862 281.266 783.562 281.266Z"
            fill="white"
          />
          <path
            d="M778.431 288.883C776.139 288.883 774.276 290.733 774.276 293.037C774.276 295.342 776.139 297.192 778.431 297.192C780.723 297.192 782.586 295.329 782.586 293.037C782.586 290.746 780.723 288.883 778.431 288.883Z"
            fill="white"
          />
          <path
            d="M773.3 297.096C771.008 297.096 769.158 298.95 769.158 301.229C769.158 303.508 771.013 305.371 773.3 305.371C775.587 305.371 777.434 303.521 777.434 301.229C777.434 298.937 775.579 297.096 773.3 297.096Z"
            fill="white"
          />
          <path
            d="M768.025 305.902C765.746 305.902 763.892 307.757 763.892 310.036C763.892 312.315 765.742 314.156 768.025 314.156C770.308 314.156 772.146 312.315 772.146 310.036C772.146 307.757 770.304 305.902 768.025 305.902Z"
            fill="white"
          />
          <path
            d="M762.432 315.256C760.161 315.256 758.319 317.098 758.319 319.377C758.319 321.655 760.161 323.489 762.432 323.489C764.702 323.489 766.544 321.647 766.544 319.377C766.544 317.106 764.702 315.256 762.432 315.256Z"
            fill="white"
          />
          <path
            d="M756.41 325.084C754.14 325.084 752.298 326.917 752.298 329.183C752.298 331.45 754.14 333.296 756.41 333.296C758.68 333.296 760.522 331.454 760.522 329.183C760.522 326.913 758.68 325.084 756.41 325.084Z"
            fill="white"
          />
          <path
            d="M749.884 335.238C747.613 335.238 745.784 337.08 745.784 339.338C745.784 341.595 747.617 343.437 749.884 343.437C752.15 343.437 753.975 341.604 753.975 339.338C753.975 337.072 752.141 335.238 749.884 335.238Z"
            fill="white"
          />
          <path
            d="M742.855 345.598C740.605 345.598 738.776 347.418 738.776 349.676C738.776 351.934 740.61 353.754 742.855 353.754C745.1 353.754 746.946 351.921 746.946 349.676C746.946 347.431 745.112 345.598 742.855 345.598Z"
            fill="white"
          />
          <path
            d="M735.446 355.881C733.21 355.881 731.397 357.693 731.397 359.929C731.397 362.166 733.21 363.986 735.446 363.986C737.682 363.986 739.503 362.174 739.503 359.929C739.503 357.684 737.682 355.881 735.446 355.881Z"
            fill="white"
          />
          <path
            d="M727.777 365.756C725.549 365.756 723.737 367.568 723.737 369.796C723.737 372.024 725.549 373.836 727.777 373.836C730.005 373.836 731.817 372.037 731.817 369.796C731.817 367.555 730.005 365.756 727.777 365.756Z"
            fill="white"
          />
          <path
            d="M726.368 379.318C724.161 379.318 722.37 381.109 722.37 383.316C722.37 385.523 724.161 387.301 726.368 387.301C728.574 387.301 730.353 385.523 730.353 383.316C730.353 381.109 728.574 379.318 726.368 379.318Z"
            fill="white"
          />
          <path
            d="M712.08 383.166C709.886 383.166 708.095 384.957 708.095 387.164C708.095 389.37 709.886 391.149 712.08 391.149C714.274 391.149 716.077 389.37 716.077 387.164C716.077 384.957 714.286 383.166 712.08 383.166Z"
            fill="white"
          />
          <path
            d="M697.761 386.914C695.555 386.914 693.776 388.692 693.776 390.899C693.776 393.106 695.555 394.884 697.761 394.884C699.968 394.884 701.746 393.093 701.746 390.899C701.746 388.705 699.955 386.914 697.761 386.914Z"
            fill="white"
          />
          <path
            d="M683.405 390.684C681.211 390.684 679.42 392.474 679.42 394.668C679.42 396.862 681.211 398.653 683.405 398.653C685.599 398.653 687.39 396.862 687.39 394.668C687.39 392.474 685.599 390.684 683.405 390.684Z"
            fill="white"
          />
          <path
            d="M669.056 394.473C666.862 394.473 665.08 396.251 665.08 398.458C665.08 400.664 666.858 402.442 669.056 402.442C671.255 402.442 673.041 400.652 673.041 398.458C673.041 396.264 671.263 394.473 669.056 394.473Z"
            fill="white"
          />
          <path
            d="M654.733 406.181C656.929 406.181 658.71 404.401 658.71 402.205C658.71 400.009 656.929 398.229 654.733 398.229C652.537 398.229 650.757 400.009 650.757 402.205C650.757 404.401 652.537 406.181 654.733 406.181Z"
            fill="white"
          />
          <path
            d="M640.454 402.027C638.268 402.027 636.49 403.797 636.49 405.991C636.49 408.185 638.268 409.955 640.454 409.955C642.639 409.955 644.43 408.177 644.43 405.991C644.43 403.805 642.652 402.027 640.454 402.027Z"
            fill="white"
          />
          <path
            d="M626.259 405.818C624.073 405.818 622.295 407.588 622.295 409.774C622.295 411.959 624.073 413.737 626.259 413.737C628.444 413.737 630.222 411.968 630.222 409.774C630.222 407.58 628.444 405.818 626.259 405.818Z"
            fill="white"
          />
          <path
            d="M612.135 409.436C609.949 409.436 608.171 411.214 608.171 413.399C608.171 415.585 609.949 417.354 612.135 417.354C614.32 417.354 616.09 415.585 616.09 413.399C616.09 411.214 614.32 409.436 612.135 409.436Z"
            fill="white"
          />
          <path
            d="M598.042 413.018C595.848 413.018 594.065 414.796 594.065 416.994C594.065 419.192 595.844 420.958 598.042 420.958C600.24 420.958 602.005 419.18 602.005 416.994C602.005 414.808 600.236 413.018 598.042 413.018Z"
            fill="white"
          />
          <path
            d="M583.99 416.734C581.796 416.734 580.026 418.504 580.026 420.69C580.026 422.875 581.796 424.653 583.99 424.653C586.184 424.653 587.954 422.884 587.954 420.69C587.954 418.496 586.176 416.734 583.99 416.734Z"
            fill="white"
          />
          <path
            d="M569.961 420.471C567.776 420.471 566.006 422.24 566.006 424.426C566.006 426.611 567.776 428.39 569.961 428.39C572.147 428.39 573.925 426.62 573.925 424.426C573.925 422.232 572.155 420.471 569.961 420.471Z"
            fill="white"
          />
          <path
            d="M555.931 424.311C553.737 424.311 551.968 426.08 551.968 428.266C551.968 430.451 553.737 432.229 555.931 432.229C558.125 432.229 559.887 430.46 559.887 428.266C559.887 426.072 558.117 424.311 555.931 424.311Z"
            fill="white"
          />
          <path
            d="M541.829 428.445C539.644 428.445 537.874 430.215 537.874 432.4C537.874 434.586 539.644 436.356 541.829 436.356C544.015 436.356 545.793 434.586 545.793 432.4C545.793 430.215 544.015 428.445 541.829 428.445Z"
            fill="white"
          />
          <path
            d="M531.293 438.471C532.161 436.467 531.241 434.138 529.236 433.27C527.232 432.401 524.903 433.322 524.035 435.326C523.166 437.33 524.087 439.659 526.091 440.528C528.095 441.396 530.424 440.476 531.293 438.471Z"
            fill="white"
          />
          <path
            d="M513.404 437.945C511.219 437.945 509.449 439.715 509.449 441.901C509.449 444.086 511.219 445.847 513.404 445.847C515.59 445.847 517.347 444.078 517.347 441.901C517.347 439.723 515.577 437.945 513.404 437.945Z"
            fill="white"
          />
          <path
            d="M508.523 420.49C506.338 420.49 504.56 422.26 504.56 424.454C504.56 426.648 506.338 428.418 508.523 428.418C510.709 428.418 512.487 426.639 512.487 424.454C512.487 422.268 510.709 420.49 508.523 420.49Z"
            fill="white"
          />
          <path
            d="M503.122 404.764C500.915 404.764 499.124 406.542 499.124 408.749C499.124 410.955 500.915 412.746 503.122 412.746C505.328 412.746 507.106 410.955 507.106 408.749C507.106 406.542 505.316 404.764 503.122 404.764Z"
            fill="white"
          />
          <path
            d="M497.427 388.82C495.212 388.82 493.421 390.611 493.421 392.826C493.421 395.042 495.212 396.833 497.427 396.833C499.642 396.833 501.433 395.042 501.433 392.826C501.433 390.611 499.642 388.82 497.427 388.82Z"
            fill="white"
          />
          <path
            d="M491.57 370.326C489.342 370.326 487.53 372.138 487.53 374.366C487.53 376.594 489.342 378.406 491.57 378.406C493.798 378.406 495.61 376.594 495.61 374.366C495.61 372.138 493.798 370.326 491.57 370.326Z"
            fill="white"
          />
          <path
            d="M485.489 350.822C483.261 350.822 481.449 352.634 481.449 354.871C481.449 357.107 483.261 358.911 485.489 358.911C487.717 358.911 489.538 357.099 489.538 354.871C489.538 352.643 487.726 350.822 485.489 350.822Z"
            fill="white"
          />
          <path
            d="M479.133 331.9C476.883 331.9 475.071 333.721 475.071 335.957C475.071 338.194 476.883 340.014 479.133 340.014C481.382 340.014 483.19 338.202 483.19 335.957C483.19 333.712 481.369 331.9 479.133 331.9Z"
            fill="white"
          />
          <path
            d="M472.448 314.736C470.199 314.736 468.378 316.557 468.378 318.806C468.378 321.055 470.199 322.876 472.448 322.876C474.697 322.876 476.517 321.055 476.517 318.806C476.517 316.557 474.697 314.736 472.448 314.736Z"
            fill="white"
          />
          <path
            d="M465.468 299.855C463.219 299.855 461.39 301.676 461.39 303.934C461.39 306.191 463.223 308.012 465.468 308.012C467.713 308.012 469.559 306.191 469.559 303.934C469.559 301.676 467.726 299.855 465.468 299.855Z"
            fill="white"
          />
          <path
            d="M458.231 287.293C455.973 287.293 454.14 289.114 454.14 291.371C454.14 293.629 455.973 295.449 458.231 295.449C460.488 295.449 462.309 293.629 462.309 291.371C462.309 289.114 460.476 287.293 458.231 287.293Z"
            fill="white"
          />
          <path
            d="M450.749 276.77C448.492 276.77 446.658 278.603 446.658 280.861C446.658 283.118 448.492 284.951 450.749 284.951C453.007 284.951 454.84 283.118 454.84 280.861C454.84 278.603 453.007 276.77 450.749 276.77Z"
            fill="white"
          />
          <path
            d="M443.035 267.975C440.778 267.975 438.944 269.808 438.944 272.066C438.944 274.323 440.778 276.157 443.035 276.157C445.293 276.157 447.126 274.323 447.126 272.066C447.126 269.808 445.293 267.975 443.035 267.975Z"
            fill="white"
          />
          <path
            d="M435.116 260.617C432.846 260.617 431.017 262.451 431.017 264.717C431.017 266.983 432.85 268.816 435.116 268.816C437.382 268.816 439.207 266.974 439.207 264.717C439.207 262.459 437.374 260.617 435.116 260.617Z"
            fill="white"
          />
          <path
            d="M426.989 254.412C424.731 254.412 422.89 256.245 422.89 258.503C422.89 260.761 424.731 262.603 426.989 262.603C429.247 262.603 431.089 260.769 431.089 258.503C431.089 256.237 429.255 254.412 426.989 254.412Z"
            fill="white"
          />
          <path
            d="M418.683 249.154C416.426 249.154 414.584 250.988 414.584 253.254C414.584 255.52 416.426 257.353 418.683 257.353C420.941 257.353 422.783 255.511 422.783 253.254C422.783 250.996 420.95 249.154 418.683 249.154Z"
            fill="white"
          />
          <path
            d="M410.243 244.596C407.994 244.596 406.165 246.416 406.165 248.674C406.165 250.932 407.998 252.752 410.243 252.752C412.488 252.752 414.322 250.932 414.322 248.674C414.322 246.416 412.501 244.596 410.243 244.596Z"
            fill="white"
          />
          <path
            d="M416.485 234.951C414.228 234.951 412.407 236.772 412.407 239.029C412.407 241.287 414.228 243.108 416.485 243.108C418.743 243.108 420.564 241.287 420.564 239.029C420.564 236.772 418.743 234.951 416.485 234.951Z"
            fill="white"
          />
          <path
            d="M422.563 225.832C420.313 225.832 418.484 227.653 418.484 229.902C418.484 232.151 420.318 233.972 422.563 233.972C424.808 233.972 426.632 232.151 426.632 229.902C426.632 227.653 424.812 225.832 422.563 225.832Z"
            fill="white"
          />
          <path
            d="M428.414 217.297C426.165 217.297 424.345 219.117 424.345 221.367C424.345 223.616 426.165 225.424 428.414 225.424C430.664 225.424 432.472 223.603 432.472 221.367C432.472 219.13 430.651 217.297 428.414 217.297Z"
            fill="white"
          />
          <path
            d="M433.991 209.594C431.754 209.594 429.942 211.414 429.942 213.651C429.942 215.887 431.754 217.708 433.991 217.708C436.227 217.708 438.048 215.887 438.048 213.651C438.048 211.414 436.227 209.594 433.991 209.594Z"
            fill="white"
          />
          <path
            d="M439.25 202.979C437.014 202.979 435.21 204.778 435.21 207.006C435.21 209.234 437.009 211.046 439.25 211.046C441.491 211.046 443.277 209.247 443.277 207.006C443.277 204.765 441.478 202.979 439.25 202.979Z"
            fill="white"
          />
          <path
            d="M444.066 197.369C441.838 197.369 440.039 199.168 440.039 201.388C440.039 203.607 441.838 205.407 444.066 205.407C446.294 205.407 448.085 203.616 448.085 201.388C448.085 199.16 446.286 197.369 444.066 197.369Z"
            fill="white"
          />
          <path
            d="M448.399 192.559C446.192 192.559 444.393 194.354 444.393 196.565C444.393 198.776 446.192 200.584 448.399 200.584C450.605 200.584 452.417 198.784 452.417 196.565C452.417 194.345 450.618 192.559 448.399 192.559Z"
            fill="white"
          />
          <path
            d="M452.226 188.342C450.019 188.342 448.241 190.133 448.241 192.327C448.241 194.521 450.019 196.312 452.226 196.312C454.433 196.312 456.211 194.525 456.211 192.327C456.211 190.128 454.42 188.342 452.226 188.342Z"
            fill="white"
          />
          <path
            d="M455.516 184.586C453.339 184.586 451.573 186.356 451.573 188.537C451.573 190.718 453.343 192.488 455.516 192.488C457.689 192.488 459.471 190.718 459.471 188.537C459.471 186.356 457.701 184.586 455.516 184.586Z"
            fill="white"
          />
          <path
            d="M458.287 181.141C456.11 181.141 454.354 182.906 454.354 185.079C454.354 187.252 456.11 189.017 458.287 189.017C460.465 189.017 462.221 187.247 462.221 185.079C462.221 182.91 460.465 181.141 458.287 181.141Z"
            fill="white"
          />
          <path
            d="M460.553 177.967C458.397 177.967 456.648 179.715 456.648 181.871C456.648 184.027 458.397 185.775 460.553 185.775C462.708 185.775 464.457 184.027 464.457 181.871C464.457 179.715 462.708 177.967 460.553 177.967Z"
            fill="white"
          />
          <path
            d="M462.353 174.922C460.21 174.922 458.47 176.666 458.47 178.809C458.47 180.952 460.21 182.696 462.353 182.696C464.496 182.696 466.244 180.952 466.244 178.809C466.244 176.666 464.496 174.922 462.353 174.922Z"
            fill="white"
          />
          <path
            d="M463.757 171.979C461.635 171.979 459.916 173.701 459.916 175.823C459.916 177.945 461.635 179.664 463.757 179.664C465.879 179.664 467.597 177.941 467.597 175.823C467.597 173.706 465.879 171.979 463.757 171.979Z"
            fill="white"
          />
          <path
            d="M464.852 168.994C462.751 168.994 461.041 170.7 461.041 172.814C461.041 174.927 462.747 176.624 464.852 176.624C466.957 176.624 468.671 174.918 468.671 172.814C468.671 170.709 466.965 168.994 464.852 168.994Z"
            fill="white"
          />
          <path
            d="M465.755 165.902C463.663 165.902 461.957 167.604 461.957 169.696C461.957 171.788 463.663 173.494 465.755 173.494C467.847 173.494 469.553 171.797 469.553 169.696C469.553 167.596 467.856 165.902 465.755 165.902Z"
            fill="white"
          />
          <path
            d="M478.946 162.438C476.845 162.438 475.147 164.135 475.147 166.236C475.147 168.336 476.845 170.03 478.946 170.03C481.046 170.03 482.735 168.328 482.735 166.236C482.735 164.143 481.038 162.438 478.946 162.438Z"
            fill="white"
          />
          <path
            d="M492.661 158.84C490.569 158.84 488.871 160.537 488.871 162.63C488.871 164.722 490.569 166.423 492.661 166.423C494.753 166.423 496.45 164.722 496.45 162.63C496.45 160.537 494.753 158.84 492.661 158.84Z"
            fill="white"
          />
          <path
            d="M507.005 155.172C504.913 155.172 503.216 156.869 503.216 158.966C503.216 161.062 504.913 162.76 507.005 162.76C509.098 162.76 510.795 161.062 510.795 158.966C510.795 156.869 509.098 155.172 507.005 155.172Z"
            fill="white"
          />
          <path
            d="M522.19 151.082C520.089 151.082 518.392 152.784 518.392 154.88C518.392 156.977 520.089 158.67 522.19 158.67C524.29 158.67 525.979 156.972 525.979 154.88C525.979 152.788 524.282 151.082 522.19 151.082Z"
            fill="white"
          />
          <path
            d="M538.448 146.805C536.355 146.805 534.649 148.511 534.649 150.603C534.649 152.695 536.355 154.401 538.448 154.401C540.54 154.401 542.246 152.704 542.246 150.603C542.246 148.502 540.548 146.805 538.448 146.805Z"
            fill="white"
          />
          <path
            d="M555.808 142.607C553.694 142.607 551.988 144.318 551.988 146.423C551.988 148.527 553.694 150.242 555.808 150.242C557.921 150.242 559.619 148.536 559.619 146.423C559.619 144.309 557.913 142.607 555.808 142.607Z"
            fill="white"
          />
          <path
            d="M574.354 138.168C572.24 138.168 570.534 139.878 570.534 141.987C570.534 144.096 572.24 145.802 574.354 145.802C576.467 145.802 578.164 144.092 578.164 141.987C578.164 139.882 576.458 138.168 574.354 138.168Z"
            fill="white"
          />
          <path
            d="M593.692 134.059C591.579 134.059 589.873 135.769 589.873 137.882C589.873 139.996 591.579 141.702 593.692 141.702C595.806 141.702 597.512 139.991 597.512 137.882C597.512 135.773 595.806 134.059 593.692 134.059Z"
            fill="white"
          />
          <path
            d="M613.489 130.266C611.376 130.266 609.67 131.972 609.67 134.085C609.67 136.198 611.376 137.904 613.489 137.904C615.603 137.904 617.317 136.198 617.317 134.085C617.317 131.972 615.598 130.266 613.489 130.266Z"
            fill="white"
          />
          <path
            d="M633.045 126.445C630.932 126.445 629.226 128.151 629.226 130.265C629.226 132.378 630.932 134.088 633.045 134.088C635.158 134.088 636.864 132.378 636.864 130.265C636.864 128.151 635.158 126.445 633.045 126.445Z"
            fill="white"
          />
          <path
            d="M651.797 122.805C649.683 122.805 647.969 124.523 647.969 126.633C647.969 128.742 649.687 130.465 651.797 130.465C653.906 130.465 655.629 128.746 655.629 126.633C655.629 124.519 653.91 122.805 651.797 122.805Z"
            fill="white"
          />
          <path
            d="M669.502 119.391C667.389 119.391 665.67 121.109 665.67 123.223C665.67 125.336 667.389 127.059 669.502 127.059C671.615 127.059 673.343 125.349 673.343 123.223C673.343 121.097 671.624 119.391 669.502 119.391Z"
            fill="white"
          />
          <path
            d="M686.184 116.143C684.062 116.143 682.344 117.861 682.344 119.979C682.344 122.097 684.062 123.815 686.184 123.815C688.306 123.815 690.016 122.097 690.016 119.979C690.016 117.861 688.298 116.143 686.184 116.143Z"
            fill="white"
          />
          <path
            d="M701.84 113.742C699.726 113.742 698.012 115.461 698.012 117.583C698.012 119.705 699.73 121.415 701.84 121.415C703.949 121.415 705.68 119.696 705.68 117.583C705.68 115.469 703.961 113.742 701.84 113.742Z"
            fill="white"
          />
          <path
            d="M716.65 112.166C714.537 112.166 712.81 113.889 712.81 116.007C712.81 118.124 714.537 119.851 716.65 119.851C718.764 119.851 720.491 118.128 720.491 116.007C720.491 113.885 718.772 112.166 716.65 112.166Z"
            fill="white"
          />
          <path
            d="M723.25 124.346C721.107 124.346 719.367 126.086 719.367 128.224C719.367 130.363 721.107 132.103 723.25 132.103C725.393 132.103 727.121 130.363 727.121 128.224C727.121 126.086 725.381 124.346 723.25 124.346Z"
            fill="white"
          />
          <path
            d="M733.34 141.742C734.165 139.75 733.219 137.466 731.227 136.641C729.235 135.816 726.951 136.762 726.126 138.754C725.301 140.746 726.247 143.03 728.239 143.855C730.231 144.681 732.515 143.735 733.34 141.742Z"
            fill="white"
          />
          <path
            d="M736.163 148.129C733.986 148.129 732.221 149.899 732.221 152.076C732.221 154.253 733.99 156.014 736.163 156.014C738.336 156.014 740.11 154.248 740.11 152.076C740.11 149.903 738.34 148.129 736.163 148.129Z"
            fill="white"
          />
          <path
            d="M742.597 167.562C744.793 167.562 746.573 165.782 746.573 163.586C746.573 161.39 744.793 159.609 742.597 159.609C740.4 159.609 738.62 161.39 738.62 163.586C738.62 165.782 740.4 167.562 742.597 167.562Z"
            fill="white"
          />
          <path
            d="M749.089 170.602C746.883 170.602 745.104 172.388 745.104 174.595C745.104 176.802 746.883 178.593 749.089 178.593C751.296 178.593 753.087 176.802 753.087 174.595C753.087 172.388 751.296 170.602 749.089 170.602Z"
            fill="white"
          />
          <path
            d="M755.68 181.045C753.465 181.045 751.661 182.844 751.661 185.068C751.661 187.292 753.46 189.091 755.68 189.091C757.899 189.091 759.707 187.292 759.707 185.068C759.707 182.844 757.908 181.045 755.68 181.045Z"
            fill="white"
          />
          <path
            d="M762.361 190.998C760.125 190.998 758.312 192.81 758.312 195.047C758.312 197.283 760.125 199.095 762.361 199.095C764.598 199.095 766.418 197.283 766.418 195.047C766.418 192.81 764.598 190.998 762.361 190.998Z"
            fill="white"
          />
          <path
            d="M769.137 200.52C766.888 200.52 765.067 202.34 765.067 204.589C765.067 206.838 766.888 208.659 769.137 208.659C771.386 208.659 773.207 206.838 773.207 204.589C773.207 202.34 771.386 200.52 769.137 200.52Z"
            fill="white"
          />
          <path
            d="M775.995 209.67C773.738 209.67 771.904 211.503 771.904 213.748C771.904 215.993 773.738 217.839 775.995 217.839C778.253 217.839 780.074 216.006 780.074 213.748C780.074 211.49 778.24 209.67 775.995 209.67Z"
            fill="white"
          />
          <path
            d="M782.916 218.457C780.645 218.457 778.804 220.29 778.804 222.556C778.804 224.823 780.645 226.656 782.916 226.656C785.186 226.656 787.015 224.823 787.015 222.556C787.015 220.29 785.182 218.457 782.916 218.457Z"
            fill="white"
          />
          <path
            d="M789.911 226.914C787.632 226.914 785.79 228.764 785.79 231.047C785.79 233.331 787.632 235.168 789.911 235.168C792.19 235.168 794.031 233.318 794.031 231.047C794.031 228.777 792.181 226.914 789.911 226.914Z"
            fill="white"
          />
          <path
            d="M796.998 235.127C794.707 235.127 792.856 236.981 792.856 239.26C792.856 241.539 794.711 243.402 796.998 243.402C799.286 243.402 801.14 241.552 801.14 239.26C801.14 236.969 799.286 235.127 796.998 235.127Z"
            fill="white"
          />
          <path
            d="M804.233 243.184C801.941 243.184 800.091 245.038 800.091 247.325C800.091 249.613 801.945 251.467 804.233 251.467C806.52 251.467 808.375 249.613 808.375 247.325C808.375 245.038 806.524 243.184 804.233 243.184Z"
            fill="white"
          />
          <path
            d="M811.694 251.197C809.402 251.197 807.539 253.052 807.539 255.339C807.539 257.627 809.402 259.494 811.694 259.494C813.985 259.494 815.848 257.639 815.848 255.339C815.848 253.039 813.985 251.197 811.694 251.197Z"
            fill="white"
          />
          <path
            d="M819.489 259.229C817.189 259.229 815.334 261.092 815.334 263.383C815.334 265.675 817.184 267.538 819.489 267.538C821.793 267.538 823.643 265.688 823.643 263.383C823.643 261.079 821.78 259.229 819.489 259.229Z"
            fill="white"
          />
          <path
            d="M813.662 264.309C811.371 264.309 809.508 266.159 809.508 268.463C809.508 270.768 811.371 272.618 813.662 272.618C815.954 272.618 817.817 270.755 817.817 268.463C817.817 266.172 815.954 264.309 813.662 264.309Z"
            fill="white"
          />
          <path
            d="M808.062 270.047C805.762 270.047 803.907 271.901 803.907 274.201C803.907 276.502 805.762 278.356 808.062 278.356C810.362 278.356 812.217 276.493 812.217 274.201C812.217 271.91 810.353 270.047 808.062 270.047Z"
            fill="white"
          />
          <path
            d="M802.672 276.246C800.372 276.246 798.518 278.109 798.518 280.401C798.518 282.692 800.372 284.555 802.672 284.555C804.972 284.555 806.827 282.692 806.827 280.401C806.827 278.109 804.964 276.246 802.672 276.246Z"
            fill="white"
          />
          <path
            d="M797.447 282.91C795.147 282.91 793.292 284.773 793.292 287.065C793.292 289.356 795.147 291.219 797.447 291.219C799.747 291.219 801.601 289.365 801.601 287.065C801.601 284.765 799.738 282.91 797.447 282.91Z"
            fill="white"
          />
          <path
            d="M792.304 290.047C790.012 290.047 788.149 291.91 788.149 294.202C788.149 296.493 790.012 298.356 792.304 298.356C794.596 298.356 796.459 296.506 796.459 294.202C796.459 291.897 794.604 290.047 792.304 290.047Z"
            fill="white"
          />
          <path
            d="M787.143 297.707C784.855 297.707 783.001 299.562 783.001 301.849C783.001 304.136 784.855 305.991 787.143 305.991C789.43 305.991 791.285 304.141 791.285 301.849C791.285 299.557 789.43 297.707 787.143 297.707Z"
            fill="white"
          />
          <path
            d="M781.826 305.881C779.547 305.881 777.692 307.735 777.692 310.014C777.692 312.293 779.547 314.156 781.826 314.156C784.105 314.156 785.968 312.302 785.968 310.014C785.968 307.727 784.117 305.881 781.826 305.881Z"
            fill="white"
          />
          <path
            d="M776.237 314.602C773.958 314.602 772.116 316.443 772.116 318.722C772.116 321.001 773.958 322.834 776.237 322.834C778.516 322.834 780.349 320.993 780.349 318.722C780.349 316.452 778.507 314.602 776.237 314.602Z"
            fill="white"
          />
          <path
            d="M770.24 323.811C767.961 323.811 766.128 325.652 766.128 327.923C766.128 330.193 767.961 332.035 770.24 332.035C772.519 332.035 774.352 330.193 774.352 327.923C774.352 325.652 772.511 323.811 770.24 323.811Z"
            fill="white"
          />
          <path
            d="M763.765 333.396C761.508 333.396 759.666 335.23 759.666 337.496C759.666 339.762 761.508 341.587 763.765 341.587C766.023 341.587 767.865 339.754 767.865 337.496C767.865 335.238 766.032 333.396 763.765 333.396Z"
            fill="white"
          />
          <path
            d="M756.834 343.17C754.576 343.17 752.743 345.003 752.743 347.248C752.743 349.493 754.576 351.339 756.834 351.339C759.092 351.339 760.912 349.506 760.912 347.248C760.912 344.99 759.079 343.17 756.834 343.17Z"
            fill="white"
          />
          <path
            d="M749.506 352.924C747.27 352.924 745.449 354.736 745.449 356.972C745.449 359.209 747.27 361.034 749.506 361.034C751.743 361.034 753.555 359.213 753.555 356.972C753.555 354.732 751.743 352.924 749.506 352.924Z"
            fill="white"
          />
          <path
            d="M741.908 362.365C739.672 362.365 737.868 364.177 737.868 366.405C737.868 368.633 739.668 370.445 741.908 370.445C744.149 370.445 745.948 368.633 745.948 366.405C745.948 364.177 744.136 362.365 741.908 362.365Z"
            fill="white"
          />
          <path
            d="M734.164 371.252C731.949 371.252 730.158 373.043 730.158 375.258C730.158 377.473 731.949 379.264 734.164 379.264C736.38 379.264 738.17 377.473 738.17 375.258C738.17 373.043 736.371 371.252 734.164 371.252Z"
            fill="white"
          />
          <path
            d="M732.845 382.666C730.659 382.666 728.89 384.436 728.89 386.621C728.89 388.807 730.659 390.564 732.845 390.564C735.03 390.564 736.787 388.794 736.787 386.621C736.787 384.448 735.018 382.666 732.845 382.666Z"
            fill="white"
          />
          <path
            d="M718.514 387.102C716.328 387.102 714.559 388.871 714.559 391.057C714.559 393.242 716.328 395.003 718.514 395.003C720.699 395.003 722.46 393.234 722.46 391.057C722.46 388.88 720.691 387.102 718.514 387.102Z"
            fill="white"
          />
          <path
            d="M704.089 391.529C701.912 391.529 700.146 393.299 700.146 395.472C700.146 397.645 701.916 399.418 704.089 399.418C706.262 399.418 708.031 397.649 708.031 395.472C708.031 393.295 706.274 391.529 704.089 391.529Z"
            fill="white"
          />
          <path
            d="M689.61 396.029C687.433 396.029 685.676 397.799 685.676 399.972C685.676 402.145 687.437 403.918 689.61 403.918C691.783 403.918 693.552 402.149 693.552 399.972C693.552 397.795 691.783 396.029 689.61 396.029Z"
            fill="white"
          />
          <path
            d="M675.1 400.717C672.923 400.717 671.166 402.478 671.166 404.651C671.166 406.824 672.927 408.593 675.1 408.593C677.273 408.593 679.042 406.836 679.042 404.651C679.042 402.465 677.273 400.717 675.1 400.717Z"
            fill="white"
          />
          <path
            d="M660.595 405.502C658.418 405.502 656.652 407.259 656.652 409.436C656.652 411.613 658.422 413.383 660.595 413.383C662.768 413.383 664.529 411.613 664.529 409.436C664.529 407.259 662.768 405.502 660.595 405.502Z"
            fill="white"
          />
          <path
            d="M646.106 410.354C643.929 410.354 642.172 412.123 642.172 414.287C642.172 416.452 643.929 418.221 646.106 418.221C648.283 418.221 650.031 416.46 650.031 414.287C650.031 412.115 648.27 410.354 646.106 410.354Z"
            fill="white"
          />
          <path
            d="M631.678 423.178C633.851 423.178 635.612 421.417 635.612 419.244C635.612 417.072 633.851 415.311 631.678 415.311C629.505 415.311 627.744 417.072 627.744 419.244C627.744 421.417 629.505 423.178 631.678 423.178Z"
            fill="white"
          />
          <path
            d="M617.346 420.191C615.169 420.191 613.412 421.953 613.412 424.117C613.412 426.281 615.169 428.051 617.346 428.051C619.523 428.051 621.272 426.29 621.272 424.117C621.272 421.944 619.51 420.191 617.346 420.191Z"
            fill="white"
          />
          <path
            d="M603.071 424.914C600.907 424.914 599.146 426.675 599.146 428.84C599.146 431.004 600.907 432.773 603.071 432.773C605.235 432.773 606.996 431.017 606.996 428.84C606.996 426.662 605.235 424.914 603.071 424.914Z"
            fill="white"
          />
          <path
            d="M588.841 429.736C586.676 429.736 584.915 431.497 584.915 433.662C584.915 435.826 586.676 437.596 588.841 437.596C591.005 437.596 592.766 435.839 592.766 433.662C592.766 431.485 591.005 429.736 588.841 429.736Z"
            fill="white"
          />
          <path
            d="M574.655 434.656C572.491 434.656 570.742 436.413 570.742 438.582C570.742 440.75 572.491 442.507 574.655 442.507C576.819 442.507 578.58 440.746 578.58 438.582C578.58 436.417 576.819 434.656 574.655 434.656Z"
            fill="white"
          />
          <path
            d="M560.51 439.621C558.346 439.621 556.585 441.382 556.585 443.547C556.585 445.711 558.346 447.459 560.51 447.459C562.675 447.459 564.436 445.711 564.436 443.547C564.436 441.382 562.679 439.621 560.51 439.621Z"
            fill="white"
          />
          <path
            d="M546.323 444.848C544.159 444.848 542.397 446.596 542.397 448.76C542.397 450.925 544.154 452.686 546.323 452.686C548.491 452.686 550.236 450.925 550.236 448.76C550.236 446.596 548.479 444.848 546.323 444.848Z"
            fill="white"
          />
          <path
            d="M532.064 450.436C529.908 450.436 528.151 452.184 528.151 454.348C528.151 456.513 529.908 458.261 532.064 458.261C534.22 458.261 535.977 456.513 535.977 454.348C535.977 452.184 534.228 450.436 532.064 450.436Z"
            fill="white"
          />
          <path
            d="M517.746 456.441C515.59 456.441 513.833 458.19 513.833 460.354C513.833 462.518 515.59 464.258 517.746 464.258C519.902 464.258 521.658 462.51 521.658 460.354C521.658 458.198 519.91 456.441 517.746 456.441Z"
            fill="white"
          />
          <path
            d="M503.287 463.018C501.122 463.018 499.361 464.766 499.361 466.943C499.361 469.12 501.122 470.856 503.287 470.856C505.451 470.856 507.212 469.107 507.212 466.943C507.212 464.779 505.455 463.018 503.287 463.018Z"
            fill="white"
          />
          <path
            d="M498.967 443.73C496.781 443.73 495.012 445.5 495.012 447.673C495.012 449.846 496.781 451.628 498.967 451.628C501.152 451.628 502.914 449.858 502.914 447.673C502.914 445.487 501.144 443.73 498.967 443.73Z"
            fill="white"
          />
          <path
            d="M494.159 425.27C491.973 425.27 490.195 427.039 490.195 429.233C490.195 431.427 491.973 433.197 494.159 433.197C496.344 433.197 498.123 431.419 498.123 429.233C498.123 427.048 496.344 425.27 494.159 425.27Z"
            fill="white"
          />
          <path
            d="M488.799 408.668C486.605 408.668 484.814 410.459 484.814 412.666C484.814 414.872 486.605 416.65 488.799 416.65C490.993 416.65 492.797 414.86 492.797 412.666C492.797 410.472 491.006 408.668 488.799 408.668Z"
            fill="white"
          />
          <path
            d="M483.117 392.67C480.911 392.67 479.111 394.469 479.111 396.689C479.111 398.908 480.911 400.695 483.117 400.695C485.324 400.695 487.136 398.896 487.136 396.689C487.136 394.482 485.337 392.67 483.117 392.67Z"
            fill="white"
          />
          <path
            d="M477.269 374.447C475.041 374.447 473.241 376.247 473.241 378.475C473.241 380.703 475.041 382.502 477.269 382.502C479.496 382.502 481.296 380.703 481.296 378.475C481.296 376.247 479.496 374.447 477.269 374.447Z"
            fill="white"
          />
          <path
            d="M471.191 355.236C468.955 355.236 467.143 357.048 467.143 359.285C467.143 361.521 468.955 363.325 471.191 363.325C473.428 363.325 475.231 361.513 475.231 359.285C475.231 357.057 473.419 355.236 471.191 355.236Z"
            fill="white"
          />
          <path
            d="M464.808 336.688C462.572 336.688 460.747 338.508 460.747 340.745C460.747 342.981 462.568 344.793 464.808 344.793C467.049 344.793 468.857 342.981 468.857 340.745C468.857 338.508 467.045 336.688 464.808 336.688Z"
            fill="white"
          />
          <path
            d="M458.096 319.889C455.847 319.889 454.026 321.709 454.026 323.95C454.026 326.191 455.847 328.02 458.096 328.02C460.345 328.02 462.153 326.199 462.153 323.95C462.153 321.701 460.341 319.889 458.096 319.889Z"
            fill="white"
          />
          <path
            d="M451.072 305.266C448.815 305.266 446.994 307.086 446.994 309.344C446.994 311.602 448.815 313.422 451.072 313.422C453.33 313.422 455.151 311.589 455.151 309.344C455.151 307.099 453.317 305.266 451.072 305.266Z"
            fill="white"
          />
          <path
            d="M443.755 292.84C441.506 292.84 439.686 294.66 439.686 296.918C439.686 299.176 441.506 300.988 443.755 300.988C446.005 300.988 447.834 299.167 447.834 296.918C447.834 294.669 446.013 292.84 443.755 292.84Z"
            fill="white"
          />
          <path
            d="M436.198 282.377C433.941 282.377 432.107 284.21 432.107 286.468C432.107 288.726 433.941 290.559 436.198 290.559C438.456 290.559 440.289 288.726 440.289 286.468C440.289 284.21 438.456 282.377 436.198 282.377Z"
            fill="white"
          />
          <path
            d="M428.415 273.623C426.158 273.623 424.324 275.444 424.324 277.701C424.324 279.959 426.158 281.792 428.415 281.792C430.673 281.792 432.506 279.959 432.506 277.701C432.506 275.444 430.673 273.623 428.415 273.623Z"
            fill="white"
          />
          <path
            d="M420.42 266.309C418.149 266.309 416.32 268.142 416.32 270.408C416.32 272.674 418.154 274.499 420.42 274.499C422.686 274.499 424.511 272.666 424.511 270.408C424.511 268.15 422.677 266.309 420.42 266.309Z"
            fill="white"
          />
          <path
            d="M412.229 260.158C409.971 260.158 408.138 261.992 408.138 264.249C408.138 266.507 409.971 268.34 412.229 268.34C414.486 268.34 416.32 266.507 416.32 264.249C416.32 261.992 414.486 260.158 412.229 260.158Z"
            fill="white"
          />
          <path
            d="M403.853 263.082C406.112 263.082 407.944 261.251 407.944 258.991C407.944 256.732 406.112 254.9 403.853 254.9C401.593 254.9 399.762 256.732 399.762 258.991C399.762 261.251 401.593 263.082 403.853 263.082Z"
            fill="white"
          />
          <path
            d="M395.276 250.334C393.018 250.334 391.185 252.167 391.185 254.425C391.185 256.683 393.018 258.516 395.276 258.516C397.533 258.516 399.367 256.683 399.367 254.425C399.367 252.167 397.533 250.334 395.276 250.334Z"
            fill="white"
          />
          <path
            d="M401.624 240.57C399.375 240.57 397.546 242.391 397.546 244.649C397.546 246.906 399.379 248.727 401.624 248.727C403.869 248.727 405.702 246.893 405.702 244.649C405.702 242.404 403.882 240.57 401.624 240.57Z"
            fill="white"
          />
          <path
            d="M407.764 231.434C405.515 231.434 403.694 233.254 403.694 235.495C403.694 237.736 405.515 239.565 407.764 239.565C410.013 239.565 411.821 237.744 411.821 235.495C411.821 233.246 410.001 231.434 407.764 231.434Z"
            fill="white"
          />
          <path
            d="M413.677 222.771C411.44 222.771 409.615 224.592 409.615 226.833C409.615 229.073 411.436 230.902 413.677 230.902C415.917 230.902 417.746 229.082 417.746 226.833C417.746 224.584 415.926 222.771 413.677 222.771Z"
            fill="white"
          />
          <path
            d="M419.368 214.674C417.131 214.674 415.319 216.486 415.319 218.722C415.319 220.959 417.131 222.779 419.368 222.779C421.604 222.779 423.425 220.959 423.425 218.722C423.425 216.486 421.604 214.674 419.368 214.674Z"
            fill="white"
          />
          <path
            d="M424.77 207.523C422.533 207.523 420.729 209.336 420.729 211.563C420.729 213.791 422.529 215.604 424.77 215.604C427.01 215.604 428.81 213.791 428.81 211.563C428.81 209.336 426.998 207.523 424.77 207.523Z"
            fill="white"
          />
          <path
            d="M429.747 201.467C427.532 201.467 425.729 203.266 425.729 205.486C425.729 207.705 427.528 209.504 429.747 209.504C431.967 209.504 433.775 207.705 433.775 205.486C433.775 203.266 431.975 201.467 429.747 201.467Z"
            fill="white"
          />
          <path
            d="M434.272 196.252C432.056 196.252 430.266 198.043 430.266 200.258C430.266 202.473 432.056 204.256 434.272 204.256C436.487 204.256 438.278 202.465 438.278 200.258C438.278 198.051 436.478 196.252 434.272 196.252Z"
            fill="white"
          />
          <path
            d="M438.304 191.729C436.105 191.729 434.327 193.507 434.327 195.705C434.327 197.903 436.105 199.681 438.304 199.681C440.502 199.681 442.28 197.903 442.28 195.705C442.28 193.507 440.502 191.729 438.304 191.729Z"
            fill="white"
          />
          <path
            d="M441.808 187.74C439.622 187.74 437.853 189.51 437.853 191.687C437.853 193.864 439.622 195.642 441.808 195.642C443.993 195.642 445.75 193.872 445.75 191.687C445.75 189.501 443.98 187.74 441.808 187.74Z"
            fill="white"
          />
          <path
            d="M444.787 184.156C442.622 184.156 440.861 185.917 440.861 188.09C440.861 190.263 442.622 192.02 444.787 192.02C446.951 192.02 448.721 190.255 448.721 188.09C448.721 185.926 446.964 184.156 444.787 184.156Z"
            fill="white"
          />
          <path
            d="M447.261 180.889C445.097 180.889 443.349 182.646 443.349 184.806C443.349 186.966 445.097 188.723 447.261 188.723C449.426 188.723 451.174 186.961 451.174 184.806C451.174 182.65 449.426 180.889 447.261 180.889Z"
            fill="white"
          />
          <path
            d="M449.251 177.852C447.108 177.852 445.368 179.587 445.368 181.739C445.368 183.89 447.108 185.626 449.251 185.626C451.394 185.626 453.143 183.89 453.143 181.739C453.143 179.587 451.403 177.852 449.251 177.852Z"
            fill="white"
          />
          <path
            d="M450.814 174.938C448.692 174.938 446.965 176.656 446.965 178.778C446.965 180.9 448.692 182.619 450.814 182.619C452.936 182.619 454.655 180.9 454.655 178.778C454.655 176.656 452.927 174.938 450.814 174.938Z"
            fill="white"
          />
          <path
            d="M451.988 172.023C449.875 172.023 448.169 173.742 448.169 175.856C448.169 177.969 449.875 179.675 451.988 179.675C454.102 179.675 455.808 177.969 455.808 175.856C455.808 173.742 454.102 172.023 451.988 172.023Z"
            fill="white"
          />
          <path
            d="M452.893 169.08C450.801 169.08 449.104 170.782 449.104 172.878C449.104 174.975 450.801 176.668 452.893 176.668C454.985 176.668 456.683 174.97 456.683 172.878C456.683 170.786 454.985 169.08 452.893 169.08Z"
            fill="white"
          />
          <path
            d="M453.652 165.986C451.573 165.986 449.884 167.671 449.884 169.755C449.884 171.838 451.569 173.519 453.652 173.519C455.736 173.519 457.408 171.834 457.408 169.755C457.408 167.675 455.732 165.986 453.652 165.986Z"
            fill="white"
          />
          <path
            d="M466.631 162.594C464.56 162.594 462.875 164.279 462.875 166.362C462.875 168.446 464.56 170.118 466.631 170.118C468.702 170.118 470.399 168.437 470.399 166.362C470.399 164.287 468.714 162.594 466.631 162.594Z"
            fill="white"
          />
          <path
            d="M480.121 158.805C478.042 158.805 476.353 160.489 476.353 162.573C476.353 164.657 478.037 166.346 480.121 166.346C482.205 166.346 483.889 164.653 483.889 162.573C483.889 160.494 482.205 158.805 480.121 158.805Z"
            fill="white"
          />
          <path
            d="M494.308 154.85C492.237 154.85 490.552 156.526 490.552 158.605C490.552 160.685 492.237 162.361 494.308 162.361C496.378 162.361 498.063 160.676 498.063 158.605C498.063 156.534 496.378 154.85 494.308 154.85Z"
            fill="white"
          />
          <path
            d="M509.313 150.678C507.234 150.678 505.545 152.363 505.545 154.446C505.545 156.53 507.23 158.215 509.313 158.215C511.397 158.215 513.082 156.53 513.082 154.446C513.082 152.363 511.397 150.678 509.313 150.678Z"
            fill="white"
          />
          <path
            d="M525.477 145.949C523.398 145.949 521.709 147.634 521.709 149.718C521.709 151.801 523.394 153.482 525.477 153.482C527.561 153.482 529.246 151.797 529.246 149.718C529.246 147.638 527.561 145.949 525.477 145.949Z"
            fill="white"
          />
          <path
            d="M542.89 141.066C540.798 141.066 539.113 142.76 539.113 144.839C539.113 146.919 540.798 148.608 542.89 148.608C544.982 148.608 546.659 146.923 546.659 144.839C546.659 142.755 544.974 141.066 542.89 141.066Z"
            fill="white"
          />
          <path
            d="M561.614 136.023C559.522 136.023 557.824 137.721 557.824 139.813C557.824 141.905 559.522 143.59 561.614 143.59C563.706 143.59 565.391 141.893 565.391 139.813C565.391 137.734 563.693 136.023 561.614 136.023Z"
            fill="white"
          />
          <path
            d="M581.419 130.797C579.326 130.797 577.629 132.494 577.629 134.587C577.629 136.679 579.326 138.376 581.419 138.376C583.511 138.376 585.208 136.679 585.208 134.587C585.208 132.494 583.511 130.797 581.419 130.797Z"
            fill="white"
          />
          <path
            d="M601.891 125.875C599.799 125.875 598.102 127.573 598.102 129.665C598.102 131.757 599.799 133.454 601.891 133.454C603.983 133.454 605.668 131.757 605.668 129.665C605.668 127.573 603.983 125.875 601.891 125.875Z"
            fill="white"
          />
          <path
            d="M622.334 121.006C620.241 121.006 618.544 122.703 618.544 124.796C618.544 126.888 620.241 128.594 622.334 128.594C624.426 128.594 626.132 126.896 626.132 124.796C626.132 122.695 624.434 121.006 622.334 121.006Z"
            fill="white"
          />
          <path
            d="M642.089 116.006C639.996 116.006 638.299 117.708 638.299 119.804C638.299 121.9 639.996 123.598 642.089 123.598C644.181 123.598 645.887 121.896 645.887 119.804C645.887 117.712 644.189 116.006 642.089 116.006Z"
            fill="white"
          />
          <path
            d="M660.717 111.287C658.625 111.287 656.919 112.989 656.919 115.085C656.919 117.182 658.625 118.888 660.717 118.888C662.809 118.888 664.515 117.182 664.515 115.085C664.515 112.989 662.818 111.287 660.717 111.287Z"
            fill="white"
          />
          <path
            d="M678.194 106.717C676.093 106.717 674.396 108.419 674.396 110.519C674.396 112.62 676.093 114.317 678.194 114.317C680.294 114.317 681.992 112.611 681.992 110.519C681.992 108.427 680.286 106.717 678.194 106.717Z"
            fill="white"
          />
          <path
            d="M694.553 102.684C692.452 102.684 690.742 104.39 690.742 106.494C690.742 108.599 692.448 110.305 694.553 110.305C696.658 110.305 698.364 108.599 698.364 106.494C698.364 104.39 696.658 102.684 694.553 102.684Z"
            fill="white"
          />
          <path
            d="M709.886 99.9062C707.785 99.9062 706.088 101.608 706.088 103.704C706.088 105.801 707.785 107.515 709.886 107.515C711.987 107.515 713.697 105.809 713.697 103.704C713.697 101.6 711.991 99.9062 709.886 99.9062Z"
            fill="white"
          />
          <path
            d="M724.434 98.0215C722.32 98.0215 720.614 99.7275 720.614 101.832C720.614 103.937 722.32 105.648 724.434 105.648C726.547 105.648 728.245 103.942 728.245 101.832C728.245 99.7232 726.539 98.0215 724.434 98.0215Z"
            fill="white"
          />
          <path
            d="M730.782 111.398C728.647 111.398 726.933 113.126 726.933 115.248C726.933 117.369 728.651 119.092 730.782 119.092C732.912 119.092 734.622 117.369 734.622 115.248C734.622 113.126 732.904 111.398 730.782 111.398Z"
            fill="white"
          />
          <path
            d="M736.999 124.732C734.856 124.732 733.116 126.464 733.116 128.603C733.116 130.742 734.852 132.481 736.999 132.481C739.147 132.481 740.87 130.75 740.87 128.603C740.87 126.455 739.13 124.732 736.999 124.732Z"
            fill="white"
          />
          <path
            d="M743.157 137.799C740.993 137.799 739.244 139.552 739.244 141.707C739.244 143.863 740.993 145.62 743.157 145.62C745.321 145.62 747.061 143.872 747.061 141.707C747.061 139.543 745.313 137.799 743.157 137.799Z"
            fill="white"
          />
          <path
            d="M749.361 150.348C747.176 150.348 745.419 152.113 745.419 154.299C745.419 156.484 747.176 158.245 749.361 158.245C751.547 158.245 753.304 156.476 753.304 154.299C753.304 152.122 751.534 150.348 749.361 150.348Z"
            fill="white"
          />
          <path
            d="M755.659 162.277C753.465 162.277 751.683 164.055 751.683 166.254C751.683 168.452 753.461 170.226 755.659 170.226C757.857 170.226 759.635 168.448 759.635 166.254C759.635 164.06 757.857 162.277 755.659 162.277Z"
            fill="white"
          />
          <path
            d="M762.08 173.584C759.873 173.584 758.095 175.371 758.095 177.569C758.095 179.767 759.873 181.566 762.08 181.566C764.286 181.566 766.077 179.776 766.077 177.569C766.077 175.362 764.286 173.584 762.08 173.584Z"
            fill="white"
          />
          <path
            d="M768.637 184.287C766.422 184.287 764.618 186.086 764.618 188.31C764.618 190.534 766.418 192.329 768.637 192.329C770.856 192.329 772.664 190.53 772.664 188.31C772.664 186.091 770.865 184.287 768.637 184.287Z"
            fill="white"
          />
          <path
            d="M775.328 194.461C773.092 194.461 771.271 196.277 771.271 198.522C771.271 200.767 773.092 202.579 775.328 202.579C777.565 202.579 779.39 200.759 779.39 198.522C779.39 196.286 777.569 194.461 775.328 194.461Z"
            fill="white"
          />
          <path
            d="M782.136 204.154C779.878 204.154 778.058 205.975 778.058 208.224C778.058 210.473 779.878 212.302 782.136 212.302C784.394 212.302 786.206 210.482 786.206 208.224C786.206 205.966 784.385 204.154 782.136 204.154Z"
            fill="white"
          />
          <path
            d="M789.037 213.355C786.767 213.355 784.938 215.189 784.938 217.446C784.938 219.704 786.771 221.546 789.037 221.546C791.303 221.546 793.128 219.713 793.128 217.446C793.128 215.18 791.295 213.355 789.037 213.355Z"
            fill="white"
          />
          <path
            d="M796.03 222.117C793.76 222.117 791.918 223.95 791.918 226.229C791.918 228.508 793.76 230.329 796.03 230.329C798.301 230.329 800.13 228.496 800.13 226.229C800.13 223.963 798.296 222.117 796.03 222.117Z"
            fill="white"
          />
          <path
            d="M803.129 230.523C800.85 230.523 798.995 232.365 798.995 234.644C798.995 236.923 800.845 238.765 803.129 238.765C805.412 238.765 807.249 236.923 807.249 234.644C807.249 232.365 805.395 230.523 803.129 230.523Z"
            fill="white"
          />
          <path
            d="M810.353 238.707C808.061 238.707 806.211 240.57 806.211 242.849C806.211 245.128 808.061 246.991 810.353 246.991C812.644 246.991 814.486 245.136 814.486 242.849C814.486 240.562 812.632 238.707 810.353 238.707Z"
            fill="white"
          />
          <path
            d="M817.762 246.783C815.483 246.783 813.629 248.638 813.629 250.925C813.629 253.212 815.483 255.059 817.762 255.059C820.041 255.059 821.904 253.208 821.904 250.925C821.904 248.642 820.05 246.783 817.762 246.783Z"
            fill="white"
          />
          <path
            d="M825.443 254.691C823.143 254.691 821.28 256.554 821.28 258.846C821.28 261.138 823.143 263.009 825.443 263.009C827.743 263.009 829.598 261.146 829.598 258.846C829.598 256.546 827.735 254.691 825.443 254.691Z"
            fill="white"
          />
          <path
            d="M833.417 262.426C831.13 262.426 829.263 264.28 829.263 266.58C829.263 268.881 831.126 270.735 833.417 270.735C835.709 270.735 837.572 268.872 837.572 266.58C837.572 264.289 835.722 262.426 833.417 262.426Z"
            fill="white"
          />
          <path
            d="M827.693 267.254C825.401 267.254 823.538 269.117 823.538 271.409C823.538 273.7 825.401 275.563 827.693 275.563C829.984 275.563 831.847 273.7 831.847 271.409C831.847 269.117 829.997 267.254 827.693 267.254Z"
            fill="white"
          />
          <path
            d="M822.112 272.521C819.812 272.521 817.957 274.385 817.957 276.676C817.957 278.968 819.812 280.831 822.112 280.831C824.412 280.831 826.266 278.976 826.266 276.676C826.266 274.376 824.403 272.521 822.112 272.521Z"
            fill="white"
          />
          <path
            d="M816.68 278.188C814.388 278.188 812.525 280.05 812.525 282.342C812.525 284.634 814.388 286.497 816.68 286.497C818.972 286.497 820.835 284.642 820.835 282.342C820.835 280.042 818.984 278.188 816.68 278.188Z"
            fill="white"
          />
          <path
            d="M811.413 284.324C809.122 284.324 807.259 286.187 807.259 288.479C807.259 290.77 809.122 292.633 811.413 292.633C813.705 292.633 815.568 290.783 815.568 288.479C815.568 286.175 813.705 284.324 811.413 284.324Z"
            fill="white"
          />
          <path
            d="M806.232 290.955C803.932 290.955 802.077 292.805 802.077 295.11C802.077 297.414 803.927 299.264 806.232 299.264C808.536 299.264 810.386 297.401 810.386 295.11C810.386 292.818 808.523 290.955 806.232 290.955Z"
            fill="white"
          />
          <path
            d="M801.017 298.072C798.725 298.072 796.875 299.927 796.875 302.214C796.875 304.502 798.73 306.356 801.017 306.356C803.304 306.356 805.159 304.493 805.159 302.214C805.159 299.935 803.304 298.072 801.017 298.072Z"
            fill="white"
          />
          <path
            d="M795.665 305.66C793.374 305.66 791.523 307.515 791.523 309.802C791.523 312.089 793.378 313.944 795.665 313.944C797.953 313.944 799.807 312.094 799.807 309.802C799.807 307.51 797.953 305.66 795.665 305.66Z"
            fill="white"
          />
          <path
            d="M790.038 313.77C787.767 313.77 785.917 315.611 785.917 317.89C785.917 320.169 787.767 322.024 790.038 322.024C792.308 322.024 794.171 320.173 794.171 317.89C794.171 315.607 792.317 313.77 790.038 313.77Z"
            fill="white"
          />
          <path
            d="M784.041 322.334C781.771 322.334 779.929 324.176 779.929 326.455C779.929 328.734 781.771 330.567 784.041 330.567C786.311 330.567 788.162 328.725 788.162 326.455C788.162 324.184 786.32 322.334 784.041 322.334Z"
            fill="white"
          />
          <path
            d="M777.607 331.318C775.35 331.318 773.508 333.152 773.508 335.418C773.508 337.684 775.35 339.517 777.607 339.517C779.865 339.517 781.707 337.676 781.707 335.418C781.707 333.16 779.873 331.318 777.607 331.318Z"
            fill="white"
          />
          <path
            d="M770.741 340.547C768.492 340.547 766.663 342.367 766.663 344.625C766.663 346.883 768.496 348.703 770.741 348.703C772.986 348.703 774.82 346.883 774.82 344.625C774.82 342.367 772.999 340.547 770.741 340.547Z"
            fill="white"
          />
          <path
            d="M763.497 349.811C761.261 349.811 759.44 351.631 759.44 353.868C759.44 356.104 761.261 357.925 763.497 357.925C765.734 357.925 767.546 356.104 767.546 353.868C767.546 351.631 765.734 349.811 763.497 349.811Z"
            fill="white"
          />
          <path
            d="M755.969 358.848C753.741 358.848 751.941 360.66 751.941 362.888C751.941 365.116 753.741 366.928 755.969 366.928C758.197 366.928 760.009 365.116 760.009 362.888C760.009 360.66 758.209 358.848 755.969 358.848Z"
            fill="white"
          />
          <path
            d="M748.309 367.402C746.094 367.402 744.29 369.202 744.29 371.421C744.29 373.641 746.089 375.44 748.309 375.44C750.528 375.44 752.315 373.641 752.315 371.421C752.315 369.202 750.524 367.402 748.309 367.402Z"
            fill="white"
          />
          <path
            d="M740.589 375.293C738.383 375.293 736.592 377.084 736.592 379.291C736.592 381.497 738.383 383.275 740.589 383.275C742.796 383.275 744.587 381.485 744.587 379.291C744.587 377.097 742.796 375.293 740.589 375.293Z"
            fill="white"
          />
          <path
            d="M739.265 385.697C737.101 385.697 735.331 387.467 735.331 389.64C735.331 391.813 737.101 393.574 739.265 393.574C741.429 393.574 743.199 391.804 743.199 389.64C743.199 387.475 741.442 385.697 739.265 385.697Z"
            fill="white"
          />
          <path
            d="M724.892 390.797C722.715 390.797 720.958 392.558 720.958 394.731C720.958 396.904 722.719 398.656 724.892 398.656C727.065 398.656 728.817 396.895 728.817 394.731C728.817 392.567 727.061 390.797 724.892 390.797Z"
            fill="white"
          />
          <path
            d="M710.374 395.992C708.197 395.992 706.44 397.749 706.44 399.926C706.44 402.103 708.202 403.852 710.374 403.852C712.547 403.852 714.308 402.095 714.308 399.926C714.308 397.758 712.539 395.992 710.374 395.992Z"
            fill="white"
          />
          <path
            d="M695.75 401.318C693.573 401.318 691.816 403.08 691.816 405.252C691.816 407.425 693.578 409.178 695.75 409.178C697.923 409.178 699.676 407.417 699.676 405.252C699.676 403.088 697.915 401.318 695.75 401.318Z"
            fill="white"
          />
          <path
            d="M681.053 406.951C678.889 406.951 677.128 408.712 677.128 410.877C677.128 413.041 678.885 414.802 681.053 414.802C683.222 414.802 684.979 413.045 684.979 410.877C684.979 408.708 683.218 406.951 681.053 406.951Z"
            fill="white"
          />
          <path
            d="M666.328 412.854C664.163 412.854 662.415 414.61 662.415 416.766C662.415 418.922 664.163 420.679 666.328 420.679C668.492 420.679 670.24 418.931 670.24 416.766C670.24 414.602 668.492 412.854 666.328 412.854Z"
            fill="white"
          />
          <path
            d="M651.59 418.887C649.425 418.887 647.677 420.635 647.677 422.791C647.677 424.947 649.425 426.695 651.59 426.695C653.754 426.695 655.494 424.947 655.494 422.791C655.494 420.635 653.745 418.887 651.59 418.887Z"
            fill="white"
          />
          <path
            d="M636.895 425.049C634.739 425.049 632.99 426.797 632.99 428.953C632.99 431.109 634.739 432.857 636.895 432.857C639.05 432.857 640.807 431.109 640.807 428.953C640.807 426.797 639.059 425.049 636.895 425.049Z"
            fill="white"
          />
          <path
            d="M622.304 431.213C620.148 431.213 618.399 432.961 618.399 435.117C618.399 437.273 620.148 439.021 622.304 439.021C624.46 439.021 626.208 437.273 626.208 435.117C626.208 432.961 624.46 431.213 622.304 431.213Z"
            fill="white"
          />
          <path
            d="M607.803 437.145C605.647 437.145 603.898 438.893 603.898 441.049C603.898 443.205 605.647 444.94 607.803 444.94C609.958 444.94 611.694 443.205 611.694 441.049C611.694 438.893 609.954 437.145 607.803 437.145Z"
            fill="white"
          />
          <path
            d="M593.356 443.025C591.201 443.025 589.452 444.774 589.452 446.93C589.452 449.085 591.201 450.821 593.356 450.821C595.512 450.821 597.248 449.073 597.248 446.93C597.248 444.787 595.508 443.025 593.356 443.025Z"
            fill="white"
          />
          <path
            d="M578.983 449.018C576.84 449.018 575.1 450.753 575.1 452.909C575.1 455.065 576.84 456.792 578.983 456.792C581.126 456.792 582.874 455.052 582.874 452.909C582.874 450.766 581.134 449.018 578.983 449.018Z"
            fill="white"
          />
          <path
            d="M564.707 455.035C562.551 455.035 560.815 456.771 560.815 458.927C560.815 461.083 562.555 462.81 564.707 462.81C566.859 462.81 568.598 461.07 568.598 458.927C568.598 456.784 566.85 455.035 564.707 455.035Z"
            fill="white"
          />
          <path
            d="M550.448 461.176C548.292 461.176 546.557 462.916 546.557 465.067C546.557 467.219 548.297 468.95 550.448 468.95C552.6 468.95 554.331 467.21 554.331 465.067C554.331 462.924 552.591 461.176 550.448 461.176Z"
            fill="white"
          />
          <path
            d="M536.147 467.588C533.992 467.588 532.256 469.336 532.256 471.492C532.256 473.648 533.996 475.384 536.147 475.384C538.299 475.384 540.039 473.635 540.039 471.492C540.039 469.349 538.299 467.588 536.147 467.588Z"
            fill="white"
          />
          <path
            d="M521.815 474.361C519.66 474.361 517.924 476.11 517.924 478.253C517.924 480.396 519.66 482.157 521.815 482.157C523.971 482.157 525.707 480.409 525.707 478.253C525.707 476.097 523.958 474.361 521.815 474.361Z"
            fill="white"
          />
          <path
            d="M507.421 481.447C505.278 481.447 503.529 483.196 503.529 485.339C503.529 487.482 505.278 489.23 507.421 489.23C509.564 489.23 511.312 487.482 511.312 485.339C511.312 483.196 509.564 481.447 507.421 481.447Z"
            fill="white"
          />
          <path
            d="M492.882 489.027C490.739 489.027 488.99 490.767 488.99 492.91C488.99 495.053 490.739 496.802 492.882 496.802C495.025 496.802 496.773 495.062 496.773 492.91C496.773 490.759 495.025 489.027 492.882 489.027Z"
            fill="white"
          />
          <path
            d="M488.642 470.344C486.478 470.344 484.729 472.092 484.729 474.257C484.729 476.421 486.478 478.169 488.642 478.169C490.807 478.169 492.555 476.421 492.555 474.257C492.555 472.092 490.807 470.344 488.642 470.344Z"
            fill="white"
          />
          <path
            d="M484.335 450.445C482.15 450.445 480.38 452.215 480.38 454.392C480.38 456.569 482.15 458.334 484.335 458.334C486.521 458.334 488.282 456.577 488.282 454.392C488.282 452.206 486.512 450.445 484.335 450.445Z"
            fill="white"
          />
          <path
            d="M479.612 431.002C477.418 431.002 475.627 432.78 475.627 434.978C475.627 437.177 477.418 438.955 479.612 438.955C481.806 438.955 483.588 437.177 483.588 434.978C483.588 432.78 481.81 431.002 479.612 431.002Z"
            fill="white"
          />
          <path
            d="M474.324 413.426C472.13 413.426 470.339 415.217 470.339 417.411C470.339 419.605 472.13 421.396 474.324 421.396C476.518 421.396 478.309 419.617 478.309 417.411C478.309 415.204 476.53 413.426 474.324 413.426Z"
            fill="white"
          />
          <path
            d="M468.65 397.219C466.443 397.219 464.644 399.01 464.644 401.216C464.644 403.423 466.443 405.222 468.65 405.222C470.856 405.222 472.656 403.432 472.656 401.216C472.656 399.001 470.856 397.219 468.65 397.219Z"
            fill="white"
          />
          <path
            d="M462.781 379.441C460.553 379.441 458.754 381.241 458.754 383.469C458.754 385.697 460.553 387.496 462.781 387.496C465.009 387.496 466.809 385.684 466.809 383.469C466.809 381.253 464.996 379.441 462.781 379.441Z"
            fill="white"
          />
          <path
            d="M456.683 360.666C454.455 360.666 452.643 362.478 452.643 364.715C452.643 366.951 454.455 368.755 456.683 368.755C458.911 368.755 460.731 366.943 460.731 364.715C460.731 362.487 458.919 360.666 456.683 360.666Z"
            fill="white"
          />
          <path
            d="M450.292 342.475C448.055 342.475 446.23 344.287 446.23 346.523C446.23 348.76 448.051 350.58 450.292 350.58C452.532 350.58 454.349 348.768 454.349 346.523C454.349 344.278 452.528 342.475 450.292 342.475Z"
            fill="white"
          />
          <path
            d="M443.557 325.863C441.308 325.863 439.5 327.684 439.5 329.933C439.5 332.182 441.312 334.003 443.557 334.003C445.802 334.003 447.627 332.182 447.627 329.933C447.627 327.684 445.806 325.863 443.557 325.863Z"
            fill="white"
          />
          <path
            d="M436.499 311.299C434.241 311.299 432.421 313.132 432.421 315.377C432.421 317.622 434.241 319.455 436.499 319.455C438.757 319.455 440.577 317.635 440.577 315.377C440.577 313.119 438.744 311.299 436.499 311.299Z"
            fill="white"
          />
          <path
            d="M429.141 298.832C426.883 298.832 425.062 300.665 425.062 302.923C425.062 305.181 426.883 307.014 429.141 307.014C431.398 307.014 433.232 305.181 433.232 302.923C433.232 300.665 431.398 298.832 429.141 298.832Z"
            fill="white"
          />
          <path
            d="M421.536 288.354C419.279 288.354 417.445 290.187 417.445 292.444C417.445 294.702 419.279 296.523 421.536 296.523C423.794 296.523 425.627 294.702 425.627 292.444C425.627 290.187 423.794 288.354 421.536 288.354Z"
            fill="white"
          />
          <path
            d="M413.697 279.568C411.44 279.568 409.619 281.402 409.619 283.659C409.619 285.917 411.44 287.75 413.697 287.75C415.955 287.75 417.788 285.917 417.788 283.659C417.788 281.402 415.955 279.568 413.697 279.568Z"
            fill="white"
          />
          <path
            d="M405.63 280.436C407.889 280.436 409.721 278.604 409.721 276.345C409.721 274.086 407.889 272.254 405.63 272.254C403.371 272.254 401.539 274.086 401.539 276.345C401.539 278.604 403.371 280.436 405.63 280.436Z"
            fill="white"
          />
          <path
            d="M397.295 266.143C395.037 266.143 393.204 267.976 393.204 270.234C393.204 272.491 395.037 274.325 397.295 274.325C399.553 274.325 401.386 272.491 401.386 270.234C401.386 267.976 399.553 266.143 397.295 266.143Z"
            fill="white"
          />
          <path
            d="M388.762 260.969C386.504 260.969 384.671 262.789 384.671 265.06C384.671 267.33 386.504 269.151 388.762 269.151C391.02 269.151 392.853 267.317 392.853 265.06C392.853 262.802 391.02 260.969 388.762 260.969Z"
            fill="white"
          />
          <path
            d="M380.1 264.616C382.359 264.616 384.191 262.784 384.191 260.525C384.191 258.265 382.359 256.434 380.1 256.434C377.84 256.434 376.009 258.265 376.009 260.525C376.009 262.784 377.84 264.616 380.1 264.616Z"
            fill="white"
          />
          <path
            d="M386.555 246.4C384.306 246.4 382.477 248.234 382.477 250.479C382.477 252.724 384.31 254.548 386.555 254.548C388.8 254.548 390.625 252.728 390.625 250.479C390.625 248.229 388.804 246.4 386.555 246.4Z"
            fill="white"
          />
          <path
            d="M392.81 237.021C390.561 237.021 388.74 238.855 388.74 241.1C388.74 243.345 390.561 245.169 392.81 245.169C395.059 245.169 396.888 243.349 396.888 241.1C396.888 238.851 395.068 237.021 392.81 237.021Z"
            fill="white"
          />
          <path
            d="M398.845 228.258C396.596 228.258 394.775 230.078 394.775 232.328C394.775 234.577 396.596 236.385 398.845 236.385C401.094 236.385 402.902 234.564 402.902 232.328C402.902 230.091 401.082 228.258 398.845 228.258Z"
            fill="white"
          />
          <path
            d="M404.621 220.047C402.393 220.047 400.572 221.859 400.572 224.095C400.572 226.332 402.393 228.144 404.621 228.144C406.849 228.144 408.669 226.332 408.669 224.095C408.669 221.859 406.857 220.047 404.621 220.047Z"
            fill="white"
          />
          <path
            d="M410.149 212.51C407.921 212.51 406.122 214.309 406.122 216.537C406.122 218.765 407.921 220.564 410.149 220.564C412.377 220.564 414.177 218.765 414.177 216.537C414.177 214.309 412.377 212.51 410.149 212.51Z"
            fill="white"
          />
          <path
            d="M415.331 205.934C413.116 205.934 411.312 207.724 411.312 209.952C411.312 212.18 413.112 213.971 415.331 213.971C417.551 213.971 419.35 212.172 419.35 209.952C419.35 207.733 417.559 205.934 415.331 205.934Z"
            fill="white"
          />
          <path
            d="M420.088 200.271C417.882 200.271 416.091 202.062 416.091 204.278C416.091 206.493 417.882 208.275 420.088 208.275C422.295 208.275 424.095 206.484 424.095 204.278C424.095 202.071 422.304 200.271 420.088 200.271Z"
            fill="white"
          />
          <path
            d="M424.345 195.402C422.151 195.402 420.368 197.189 420.368 199.383C420.368 201.577 422.146 203.359 424.345 203.359C426.543 203.359 428.321 201.581 428.321 199.383C428.321 197.185 426.543 195.402 424.345 195.402Z"
            fill="white"
          />
          <path
            d="M428.071 191.154C425.886 191.154 424.116 192.924 424.116 195.109C424.116 197.295 425.886 199.073 428.071 199.073C430.257 199.073 432.027 197.295 432.027 195.109C432.027 192.924 430.257 191.154 428.071 191.154Z"
            fill="white"
          />
          <path
            d="M431.266 187.365C429.102 187.365 427.341 189.126 427.341 191.299C427.341 193.472 429.098 195.225 431.266 195.225C433.435 195.225 435.2 193.463 435.2 191.299C435.2 189.135 433.443 187.365 431.266 187.365Z"
            fill="white"
          />
          <path
            d="M433.949 183.92C431.793 183.92 430.036 185.668 430.036 187.833C430.036 189.997 431.797 191.745 433.949 191.745C436.1 191.745 437.862 189.993 437.862 187.833C437.862 185.673 436.113 183.92 433.949 183.92Z"
            fill="white"
          />
          <path
            d="M436.147 180.746C433.992 180.746 432.256 182.49 432.256 184.638C432.256 186.785 433.996 188.521 436.147 188.521C438.299 188.521 440.03 186.781 440.03 184.638C440.03 182.495 438.29 180.746 436.147 180.746Z"
            fill="white"
          />
          <path
            d="M437.866 177.77C435.744 177.77 434.017 179.492 434.017 181.619C434.017 183.745 435.744 185.468 437.866 185.468C439.988 185.468 441.728 183.74 441.728 181.619C441.728 179.497 440 177.77 437.866 177.77Z"
            fill="white"
          />
          <path
            d="M439.186 174.877C437.072 174.877 435.366 176.587 435.366 178.696C435.366 180.805 437.072 182.516 439.186 182.516C441.299 182.516 443.005 180.81 443.005 178.696C443.005 176.583 441.286 174.877 439.186 174.877Z"
            fill="white"
          />
          <path
            d="M440.166 171.998C438.073 171.998 436.376 173.7 436.376 175.792C436.376 177.884 438.073 179.582 440.166 179.582C442.258 179.582 443.955 177.884 443.955 175.792C443.955 173.7 442.258 171.998 440.166 171.998Z"
            fill="white"
          />
          <path
            d="M440.904 169.045C438.833 169.045 437.148 170.73 437.148 172.801C437.148 174.872 438.833 176.556 440.904 176.556C442.975 176.556 444.66 174.88 444.66 172.801C444.66 170.721 442.984 169.045 440.904 169.045Z"
            fill="white"
          />
          <path
            d="M441.55 165.951C439.508 165.951 437.845 167.61 437.845 169.652C437.845 171.693 439.508 173.357 441.55 173.357C443.591 173.357 445.254 171.693 445.254 169.652C445.254 167.61 443.591 165.951 441.55 165.951Z"
            fill="white"
          />
          <path
            d="M454.433 162.68C452.384 162.68 450.729 164.335 450.729 166.38C450.729 168.426 452.384 170.081 454.433 170.081C456.483 170.081 458.13 168.426 458.13 166.38C458.13 164.335 456.475 162.68 454.433 162.68Z"
            fill="white"
          />
          <path
            d="M467.703 158.953C465.653 158.953 463.989 160.617 463.989 162.662C463.989 164.708 465.653 166.371 467.703 166.371C469.752 166.371 471.407 164.708 471.407 162.662C471.407 160.617 469.744 158.953 467.703 158.953Z"
            fill="white"
          />
          <path
            d="M481.682 154.74C479.633 154.74 477.978 156.4 477.978 158.449C477.978 160.499 479.633 162.154 481.682 162.154C483.732 162.154 485.387 160.495 485.387 158.449C485.387 156.404 483.732 154.74 481.682 154.74Z"
            fill="white"
          />
          <path
            d="M496.566 150.293C494.516 150.293 492.861 151.952 492.861 154.002C492.861 156.052 494.516 157.711 496.566 157.711C498.616 157.711 500.284 156.056 500.284 154.002C500.284 151.948 498.629 150.293 496.566 150.293Z"
            fill="white"
          />
          <path
            d="M512.551 145.434C510.501 145.434 508.838 147.097 508.838 149.147C508.838 151.197 510.501 152.864 512.551 152.864C514.601 152.864 516.269 151.201 516.269 149.147C516.269 147.093 514.605 145.434 512.551 145.434Z"
            fill="white"
          />
          <path
            d="M529.955 139.938C527.905 139.938 526.237 141.601 526.237 143.659C526.237 145.717 527.901 147.381 529.955 147.381C532.009 147.381 533.681 145.717 533.681 143.659C533.681 141.601 532.017 139.938 529.955 139.938Z"
            fill="white"
          />
          <path
            d="M548.75 134.295C546.688 134.295 545.024 135.958 545.024 138.021C545.024 140.083 546.688 141.738 548.75 141.738C550.813 141.738 552.468 140.075 552.468 138.021C552.468 135.967 550.804 134.295 548.75 134.295Z"
            fill="white"
          />
          <path
            d="M568.929 128.23C566.867 128.23 565.203 129.894 565.203 131.956C565.203 134.019 566.867 135.682 568.929 135.682C570.992 135.682 572.655 134.006 572.655 131.956C572.655 129.907 570.992 128.23 568.929 128.23Z"
            fill="white"
          />
          <path
            d="M589.923 129.55C591.981 129.55 593.649 127.881 593.649 125.824C593.649 123.766 591.981 122.098 589.923 122.098C587.865 122.098 586.197 123.766 586.197 125.824C586.197 127.881 587.865 129.55 589.923 129.55Z"
            fill="white"
          />
          <path
            d="M611.206 116.082C609.135 116.082 607.472 117.758 607.472 119.817C607.472 121.875 609.135 123.543 611.206 123.543C613.277 123.543 614.932 121.879 614.932 119.817C614.932 117.754 613.269 116.082 611.206 116.082Z"
            fill="white"
          />
          <path
            d="M631.919 109.838C629.848 109.838 628.172 111.514 628.172 113.585C628.172 115.656 629.848 117.324 631.919 117.324C633.99 117.324 635.654 115.648 635.654 113.585C635.654 111.523 633.977 109.838 631.919 109.838Z"
            fill="white"
          />
          <path
            d="M651.526 103.559C649.455 103.559 647.778 105.235 647.778 107.306C647.778 109.377 649.455 111.053 651.526 111.053C653.596 111.053 655.273 109.373 655.273 107.306C655.273 105.239 653.596 103.559 651.526 103.559Z"
            fill="white"
          />
          <path
            d="M669.833 97.6602C667.762 97.6602 666.077 99.3407 666.077 101.416C666.077 103.491 667.762 105.163 669.833 105.163C671.904 105.163 673.58 103.487 673.58 101.416C673.58 99.3449 671.904 97.6602 669.833 97.6602Z"
            fill="white"
          />
          <path
            d="M686.936 92.0508C684.865 92.0508 683.181 93.7271 683.181 95.798C683.181 97.869 684.865 99.5537 686.936 99.5537C689.007 99.5537 690.684 97.8732 690.684 95.798C690.684 93.7228 689.007 92.0508 686.936 92.0508Z"
            fill="white"
          />
          <path
            d="M702.879 87.7188C700.799 87.7188 699.11 89.395 699.11 91.4745C699.11 93.5539 700.795 95.2302 702.879 95.2302C704.962 95.2302 706.635 93.5454 706.635 91.4745C706.635 89.4035 704.95 87.7188 702.879 87.7188Z"
            fill="white"
          />
          <path
            d="M717.89 84.6582C715.806 84.6582 714.121 86.343 714.121 88.4224C714.121 90.5018 715.806 92.1866 717.89 92.1866C719.973 92.1866 721.645 90.5018 721.645 88.4224C721.645 86.343 719.96 84.6582 717.89 84.6582Z"
            fill="white"
          />
          <path
            d="M732.136 82.7363C730.056 82.7363 728.367 84.4211 728.367 86.5005C728.367 88.58 730.052 90.2647 732.136 90.2647C734.219 90.2647 735.904 88.58 735.904 86.5005C735.904 84.4211 734.219 82.7363 732.136 82.7363Z"
            fill="white"
          />
          <path
            d="M738.289 97.377C736.189 97.377 734.479 99.0829 734.479 101.188C734.479 103.293 736.184 105.007 738.289 105.007C740.394 105.007 742.109 103.297 742.109 101.188C742.109 99.0787 740.39 97.377 738.289 97.377Z"
            fill="white"
          />
          <path
            d="M744.272 112.064C742.15 112.064 740.432 113.792 740.432 115.914C740.432 118.035 742.15 119.754 744.272 119.754C746.394 119.754 748.121 118.035 748.121 115.914C748.121 113.792 746.394 112.064 744.272 112.064Z"
            fill="white"
          />
          <path
            d="M750.214 126.375C748.071 126.375 746.331 128.115 746.331 130.258C746.331 132.401 748.071 134.141 750.214 134.141C752.357 134.141 754.097 132.405 754.097 130.258C754.097 128.111 752.357 126.375 750.214 126.375Z"
            fill="white"
          />
          <path
            d="M756.198 140.078C754.034 140.078 752.285 141.831 752.285 143.987C752.285 146.142 754.034 147.899 756.198 147.899C758.362 147.899 760.102 146.151 760.102 143.987C760.102 141.822 758.354 140.078 756.198 140.078Z"
            fill="white"
          />
          <path
            d="M762.288 153.051C760.103 153.051 758.333 154.82 758.333 157.006C758.333 159.191 760.103 160.961 762.288 160.961C764.474 160.961 766.243 159.191 766.243 157.006C766.243 154.82 764.474 153.051 762.288 153.051Z"
            fill="white"
          />
          <path
            d="M768.535 165.332C766.337 165.332 764.559 167.11 764.559 169.308C764.559 171.507 766.337 173.281 768.535 173.281C770.733 173.281 772.511 171.502 772.511 169.308C772.511 167.114 770.733 165.332 768.535 165.332Z"
            fill="white"
          />
          <path
            d="M774.942 176.926C772.726 176.926 770.923 178.717 770.923 180.932C770.923 183.147 772.722 184.938 774.942 184.938C777.161 184.938 778.948 183.147 778.948 180.932C778.948 178.717 777.148 176.926 774.942 176.926Z"
            fill="white"
          />
          <path
            d="M781.512 187.904C779.284 187.904 777.484 189.704 777.484 191.932C777.484 194.16 779.284 195.959 781.512 195.959C783.74 195.959 785.539 194.151 785.539 191.932C785.539 189.712 783.727 187.904 781.512 187.904Z"
            fill="white"
          />
          <path
            d="M788.234 198.244C785.985 198.244 784.177 200.056 784.177 202.301C784.177 204.546 785.989 206.362 788.234 206.362C790.479 206.362 792.291 204.542 792.291 202.301C792.291 200.06 790.47 198.244 788.234 198.244Z"
            fill="white"
          />
          <path
            d="M795.096 207.938C792.847 207.938 791.026 209.771 791.026 212.016C791.026 214.261 792.847 216.094 795.096 216.094C797.345 216.094 799.174 214.261 799.174 212.016C799.174 209.771 797.341 207.938 795.096 207.938Z"
            fill="white"
          />
          <path
            d="M802.077 217.123C799.82 217.123 797.986 218.956 797.986 221.214C797.986 223.472 799.82 225.313 802.077 225.313C804.335 225.313 806.177 223.472 806.177 221.214C806.177 218.956 804.335 217.123 802.077 217.123Z"
            fill="white"
          />
          <path
            d="M810.12 234.033C812.33 233.511 813.699 231.296 813.178 229.086C812.656 226.875 810.441 225.506 808.231 226.028C806.02 226.55 804.651 228.765 805.173 230.975C805.695 233.185 807.91 234.554 810.12 234.033Z"
            fill="white"
          />
          <path
            d="M816.409 234.355C814.13 234.355 812.275 236.206 812.275 238.489C812.275 240.772 814.13 242.61 816.409 242.61C818.688 242.61 820.529 240.768 820.529 238.489C820.529 236.21 818.688 234.355 816.409 234.355Z"
            fill="white"
          />
          <path
            d="M823.801 242.547C821.522 242.547 819.659 244.397 819.659 246.689C819.659 248.98 821.522 250.831 823.801 250.831C826.08 250.831 827.943 248.968 827.943 246.689C827.943 244.41 826.088 242.547 823.801 242.547Z"
            fill="white"
          />
          <path
            d="M831.397 250.428C829.105 250.428 827.242 252.291 827.242 254.582C827.242 256.874 829.105 258.737 831.397 258.737C833.688 258.737 835.551 256.882 835.551 254.582C835.551 252.282 833.688 250.428 831.397 250.428Z"
            fill="white"
          />
          <path
            d="M839.236 258.025C836.944 258.025 835.081 259.888 835.081 262.18C835.081 264.472 836.944 266.335 839.236 266.335C841.527 266.335 843.39 264.472 843.39 262.18C843.39 259.888 841.527 258.025 839.236 258.025Z"
            fill="white"
          />
          <path
            d="M847.374 265.311C845.074 265.311 843.22 267.174 843.22 269.465C843.22 271.757 845.07 273.628 847.374 273.628C849.679 273.628 851.529 271.765 851.529 269.465C851.529 267.165 849.666 265.311 847.374 265.311Z"
            fill="white"
          />
          <path
            d="M841.765 269.932C839.465 269.932 837.61 271.795 837.61 274.086C837.61 276.378 839.465 278.241 841.765 278.241C844.065 278.241 845.92 276.378 845.92 274.086C845.92 271.795 844.057 269.932 841.765 269.932Z"
            fill="white"
          />
          <path
            d="M836.256 274.875C833.969 274.875 832.102 276.725 832.102 279.03C832.102 281.334 833.965 283.184 836.256 283.184C838.548 283.184 840.411 281.321 840.411 279.03C840.411 276.738 838.561 274.875 836.256 274.875Z"
            fill="white"
          />
          <path
            d="M830.854 280.088C828.554 280.088 826.699 281.951 826.699 284.243C826.699 286.534 828.549 288.397 830.854 288.397C833.158 288.397 835.008 286.543 835.008 284.243C835.008 281.942 833.145 280.088 830.854 280.088Z"
            fill="white"
          />
          <path
            d="M825.515 285.654C823.215 285.654 821.36 287.509 821.36 289.809C821.36 292.109 823.215 293.964 825.515 293.964C827.815 293.964 829.67 292.101 829.67 289.809C829.67 287.517 827.807 285.654 825.515 285.654Z"
            fill="white"
          />
          <path
            d="M820.227 291.652C817.935 291.652 816.072 293.515 816.072 295.807C816.072 298.099 817.935 299.962 820.227 299.962C822.519 299.962 824.382 298.111 824.382 295.807C824.382 293.503 822.519 291.652 820.227 291.652Z"
            fill="white"
          />
          <path
            d="M814.932 298.178C812.64 298.178 810.79 300.032 810.79 302.32C810.79 304.607 812.645 306.462 814.932 306.462C817.219 306.462 819.074 304.611 819.074 302.32C819.074 300.028 817.224 298.178 814.932 298.178Z"
            fill="white"
          />
          <path
            d="M809.507 305.193C807.216 305.193 805.365 307.048 805.365 309.335C805.365 311.623 807.216 313.477 809.507 313.477C811.799 313.477 813.649 311.627 813.649 309.335C813.649 307.044 811.786 305.193 809.507 305.193Z"
            fill="white"
          />
          <path
            d="M803.838 312.709C801.56 312.709 799.705 314.551 799.705 316.83C799.705 319.109 801.555 320.963 803.838 320.963C806.122 320.963 807.959 319.113 807.959 316.83C807.959 314.547 806.117 312.709 803.838 312.709Z"
            fill="white"
          />
          <path
            d="M797.82 320.67C795.55 320.67 793.708 322.512 793.708 324.791C793.708 327.07 795.55 328.903 797.82 328.903C800.091 328.903 801.941 327.061 801.941 324.791C801.941 322.52 800.086 320.67 797.82 320.67Z"
            fill="white"
          />
          <path
            d="M791.408 329.039C789.138 329.039 787.309 330.881 787.309 333.139C787.309 335.396 789.142 337.238 791.408 337.238C793.674 337.238 795.508 335.405 795.508 333.139C795.508 330.872 793.666 329.039 791.408 329.039Z"
            fill="white"
          />
          <path
            d="M784.584 337.697C782.326 337.697 780.506 339.531 780.506 341.788C780.506 344.046 782.326 345.879 784.584 345.879C786.842 345.879 788.675 344.046 788.675 341.788C788.675 339.531 786.842 337.697 784.584 337.697Z"
            fill="white"
          />
          <path
            d="M777.399 346.48C775.162 346.48 773.342 348.301 773.342 350.537C773.342 352.774 775.162 354.595 777.399 354.595C779.635 354.595 781.469 352.782 781.469 350.537C781.469 348.293 779.648 346.48 777.399 346.48Z"
            fill="white"
          />
          <path
            d="M769.96 355.131C767.732 355.131 765.92 356.943 765.92 359.179C765.92 361.416 767.732 363.219 769.96 363.219C772.188 363.219 774.009 361.407 774.009 359.179C774.009 356.951 772.196 355.131 769.96 355.131Z"
            fill="white"
          />
          <path
            d="M762.361 363.428C760.145 363.428 758.354 365.227 758.354 367.447C758.354 369.666 760.145 371.465 762.361 371.465C764.576 371.465 766.379 369.666 766.379 367.447C766.379 365.227 764.589 363.428 762.361 363.428Z"
            fill="white"
          />
          <path
            d="M754.721 371.117C752.506 371.117 750.715 372.908 750.715 375.123C750.715 377.339 752.506 379.121 754.721 379.121C756.936 379.121 758.719 377.33 758.719 375.123C758.719 372.917 756.928 371.117 754.721 371.117Z"
            fill="white"
          />
          <path
            d="M747.061 378.215C744.875 378.215 743.105 379.984 743.105 382.17C743.105 384.356 744.875 386.125 747.061 386.125C749.246 386.125 751.016 384.356 751.016 382.17C751.016 379.984 749.246 378.215 747.061 378.215Z"
            fill="white"
          />
          <path
            d="M745.543 388.715C743.387 388.715 741.639 390.463 741.639 392.628C741.639 394.792 743.387 396.532 745.543 396.532C747.699 396.532 749.447 394.783 749.447 392.628C749.447 390.472 747.699 388.715 745.543 388.715Z"
            fill="white"
          />
          <path
            d="M731.126 394.451C728.97 394.451 727.222 396.2 727.222 398.355C727.222 400.511 728.97 402.26 731.126 402.26C733.282 402.26 735.017 400.511 735.017 398.355C735.017 396.2 733.277 394.451 731.126 394.451Z"
            fill="white"
          />
          <path
            d="M716.522 400.416C714.367 400.416 712.618 402.164 712.618 404.32C712.618 406.476 714.367 408.212 716.522 408.212C718.678 408.212 720.414 406.472 720.414 404.32C720.414 402.169 718.674 400.416 716.522 400.416Z"
            fill="white"
          />
          <path
            d="M701.768 406.629C699.612 406.629 697.863 408.377 697.863 410.52C697.863 412.664 699.612 414.425 701.768 414.425C703.923 414.425 705.659 412.676 705.659 410.52C705.659 408.365 703.911 406.629 701.768 406.629Z"
            fill="white"
          />
          <path
            d="M686.892 413.184C684.737 413.184 683.001 414.932 683.001 417.088C683.001 419.244 684.737 420.979 686.892 420.979C689.048 420.979 690.784 419.231 690.784 417.088C690.784 414.945 689.044 413.184 686.892 413.184Z"
            fill="white"
          />
          <path
            d="M671.947 420.16C669.804 420.16 668.056 421.909 668.056 424.052C668.056 426.195 669.804 427.943 671.947 427.943C674.09 427.943 675.839 426.203 675.839 424.052C675.839 421.9 674.103 420.16 671.947 420.16Z"
            fill="white"
          />
          <path
            d="M656.971 427.379C654.828 427.379 653.088 429.119 653.088 431.262C653.088 433.405 654.828 435.153 656.971 435.153C659.114 435.153 660.862 433.405 660.862 431.262C660.862 429.119 659.114 427.379 656.971 427.379Z"
            fill="white"
          />
          <path
            d="M642.002 434.68C639.859 434.68 638.119 436.415 638.119 438.563C638.119 440.71 639.859 442.454 642.002 442.454C644.145 442.454 645.894 440.719 645.894 438.563C645.894 436.407 644.154 434.68 642.002 434.68Z"
            fill="white"
          />
          <path
            d="M627.141 442.016C624.998 442.016 623.258 443.756 623.258 445.899C623.258 448.042 624.998 449.782 627.141 449.782C629.284 449.782 631.024 448.046 631.024 445.899C631.024 443.751 629.284 442.016 627.141 442.016Z"
            fill="white"
          />
          <path
            d="M612.395 449.104C610.252 449.104 608.512 450.843 608.512 452.987C608.512 455.13 610.247 456.857 612.395 456.857C614.542 456.857 616.278 455.13 616.278 452.987C616.278 450.843 614.538 449.104 612.395 449.104Z"
            fill="white"
          />
          <path
            d="M597.749 455.867C595.606 455.867 593.866 457.607 593.866 459.75C593.866 461.893 595.606 463.633 597.749 463.633C599.892 463.633 601.62 461.893 601.62 459.75C601.62 457.607 599.892 455.867 597.749 455.867Z"
            fill="white"
          />
          <path
            d="M583.21 462.684C581.067 462.684 579.34 464.424 579.34 466.554C579.34 468.684 581.067 470.437 583.21 470.437C585.353 470.437 587.08 468.697 587.08 466.554C587.08 464.411 585.353 462.684 583.21 462.684Z"
            fill="white"
          />
          <path
            d="M568.794 469.545C566.651 469.545 564.924 471.285 564.924 473.415C564.924 475.546 566.651 477.298 568.794 477.298C570.937 477.298 572.664 475.558 572.664 473.415C572.664 471.272 570.925 469.545 568.794 469.545Z"
            fill="white"
          />
          <path
            d="M554.497 476.383C552.363 476.383 550.627 478.11 550.627 480.245C550.627 482.379 552.367 484.115 554.497 484.115C556.628 484.115 558.368 482.375 558.368 480.245C558.368 478.114 556.628 476.383 554.497 476.383Z"
            fill="white"
          />
          <path
            d="M540.216 483.367C538.082 483.367 536.354 485.094 536.354 487.229C536.354 489.364 538.082 491.099 540.216 491.099C542.351 491.099 544.087 489.359 544.087 487.229C544.087 485.099 542.347 483.367 540.216 483.367Z"
            fill="white"
          />
          <path
            d="M525.945 490.59C523.811 490.59 522.075 492.317 522.075 494.46C522.075 496.603 523.811 498.322 525.945 498.322C528.08 498.322 529.807 496.595 529.807 494.46C529.807 492.326 528.08 490.59 525.945 490.59Z"
            fill="white"
          />
          <path
            d="M512.314 505.649C514.416 505.292 515.831 503.298 515.474 501.196C515.117 499.093 513.123 497.678 511.02 498.035C508.917 498.392 507.502 500.386 507.86 502.489C508.217 504.592 510.211 506.007 512.314 505.649Z"
            fill="white"
          />
          <path
            d="M500.065 512.137C501.573 510.629 501.573 508.184 500.065 506.676C498.557 505.167 496.112 505.167 494.604 506.676C493.096 508.184 493.096 510.629 494.604 512.137C496.112 513.645 498.557 513.645 500.065 512.137Z"
            fill="white"
          />
          <path
            d="M482.879 513.32C480.745 513.32 479.018 515.048 479.018 517.182C479.018 519.317 480.745 521.031 482.879 521.031C485.014 521.031 486.741 519.304 486.741 517.182C486.741 515.06 485.014 513.32 482.879 513.32Z"
            fill="white"
          />
          <path
            d="M478.186 497.053C476.031 497.053 474.295 498.793 474.295 500.936C474.295 503.079 476.031 504.827 478.186 504.827C480.342 504.827 482.069 503.079 482.069 500.936C482.069 498.793 480.334 497.053 478.186 497.053Z"
            fill="white"
          />
          <path
            d="M473.814 478.338C471.65 478.338 469.901 480.099 469.901 482.251C469.901 484.402 471.65 486.176 473.814 486.176C475.978 486.176 477.727 484.415 477.727 482.251C477.727 480.086 475.978 478.338 473.814 478.338Z"
            fill="white"
          />
          <path
            d="M469.482 458.031C467.304 458.031 465.539 459.801 465.539 461.974C465.539 464.146 467.309 465.916 469.482 465.916C471.654 465.916 473.428 464.146 473.428 461.974C473.428 459.801 471.659 458.031 469.482 458.031Z"
            fill="white"
          />
          <path
            d="M464.831 437.781C462.637 437.781 460.867 439.559 460.867 441.745C460.867 443.93 462.637 445.709 464.831 445.709C467.025 445.709 468.795 443.939 468.795 441.745C468.795 439.551 467.025 437.781 464.831 437.781Z"
            fill="white"
          />
          <path
            d="M459.636 419.223C457.43 419.223 455.651 421.001 455.651 423.208C455.651 425.414 457.43 427.184 459.636 427.184C461.843 427.184 463.621 425.406 463.621 423.208C463.621 421.009 461.83 419.223 459.636 419.223Z"
            fill="white"
          />
          <path
            d="M453.975 402.549C451.768 402.549 449.978 404.34 449.978 406.555C449.978 408.77 451.768 410.553 453.975 410.553C456.182 410.553 457.981 408.762 457.981 406.555C457.981 404.348 456.182 402.549 453.975 402.549Z"
            fill="white"
          />
          <path
            d="M448.085 385.332C445.857 385.332 444.058 387.131 444.058 389.359C444.058 391.587 445.857 393.387 448.085 393.387C450.313 393.387 452.112 391.587 452.112 389.359C452.112 387.131 450.3 385.332 448.085 385.332Z"
            fill="white"
          />
          <path
            d="M441.986 366.984C439.75 366.984 437.946 368.796 437.946 371.024C437.946 373.252 439.746 375.064 441.986 375.064C444.227 375.064 446.026 373.265 446.026 371.024C446.026 368.784 444.214 366.984 441.986 366.984Z"
            fill="white"
          />
          <path
            d="M435.595 348.98C433.359 348.98 431.547 350.793 431.547 353.029C431.547 355.265 433.359 357.086 435.595 357.086C437.832 357.086 439.644 355.274 439.644 353.029C439.644 350.784 437.832 348.98 435.595 348.98Z"
            fill="white"
          />
          <path
            d="M428.873 332.365C426.624 332.365 424.804 334.177 424.804 336.427C424.804 338.676 426.624 340.484 428.873 340.484C431.123 340.484 432.93 338.671 432.93 336.427C432.93 334.182 431.11 332.365 428.873 332.365Z"
            fill="white"
          />
          <path
            d="M421.804 317.711C419.555 317.711 417.726 319.544 417.726 321.789C417.726 324.034 419.559 325.859 421.804 325.859C424.049 325.859 425.874 324.038 425.874 321.789C425.874 319.54 424.053 317.711 421.804 317.711Z"
            fill="white"
          />
          <path
            d="M414.436 305.143C412.186 305.143 410.357 306.976 410.357 309.221C410.357 311.466 412.191 313.312 414.436 313.312C416.681 313.312 418.514 311.479 418.514 309.221C418.514 306.963 416.693 305.143 414.436 305.143Z"
            fill="white"
          />
          <path
            d="M406.785 294.617C404.528 294.617 402.694 296.438 402.694 298.695C402.694 300.953 404.528 302.774 406.785 302.774C409.043 302.774 410.864 300.94 410.864 298.695C410.864 296.45 409.03 294.617 406.785 294.617Z"
            fill="white"
          />
          <path
            d="M398.815 294.1C401.074 294.1 402.906 292.268 402.906 290.009C402.906 287.75 401.074 285.918 398.815 285.918C396.555 285.918 394.724 287.75 394.724 290.009C394.724 292.268 396.555 294.1 398.815 294.1Z"
            fill="white"
          />
          <path
            d="M390.581 278.695C388.324 278.695 386.49 280.529 386.49 282.786C386.49 285.044 388.324 286.877 390.581 286.877C392.839 286.877 394.672 285.044 394.672 282.786C394.672 280.529 392.839 278.695 390.581 278.695Z"
            fill="white"
          />
          <path
            d="M382.107 272.582C379.849 272.582 378.016 274.415 378.016 276.673C378.016 278.931 379.849 280.764 382.107 280.764C384.364 280.764 386.198 278.943 386.198 276.673C386.198 274.403 384.364 272.582 382.107 272.582Z"
            fill="white"
          />
          <path
            d="M373.48 267.371C371.222 267.371 369.389 269.204 369.389 271.462C369.389 273.72 371.222 275.553 373.48 275.553C375.737 275.553 377.571 273.72 377.571 271.462C377.571 269.204 375.737 267.371 373.48 267.371Z"
            fill="white"
          />
          <path
            d="M364.779 262.789C362.522 262.789 360.688 264.61 360.688 266.867C360.688 269.125 362.522 270.946 364.779 270.946C367.037 270.946 368.858 269.125 368.858 266.867C368.858 264.61 367.024 262.789 364.779 262.789Z"
            fill="white"
          />
          <path
            d="M371.315 252.508C369.066 252.508 367.245 254.341 367.245 256.586C367.245 258.831 369.066 260.656 371.315 260.656C373.564 260.656 375.393 258.835 375.393 256.586C375.393 254.337 373.573 252.508 371.315 252.508Z"
            fill="white"
          />
          <path
            d="M377.706 242.912C375.457 242.912 373.628 244.733 373.628 246.982C373.628 249.231 375.461 251.06 377.706 251.06C379.951 251.06 381.776 249.227 381.776 246.982C381.776 244.737 379.955 242.912 377.706 242.912Z"
            fill="white"
          />
          <path
            d="M383.86 233.939C381.611 233.939 379.799 235.76 379.799 238.001C379.799 240.241 381.611 242.07 383.86 242.07C386.109 242.07 387.93 240.25 387.93 238.001C387.93 235.752 386.109 233.939 383.86 233.939Z"
            fill="white"
          />
          <path
            d="M389.767 225.459C387.531 225.459 385.719 227.271 385.719 229.508C385.719 231.744 387.531 233.556 389.767 233.556C392.004 233.556 393.807 231.744 393.807 229.508C393.807 227.271 391.995 225.459 389.767 225.459Z"
            fill="white"
          />
          <path
            d="M395.411 217.582C393.183 217.582 391.384 219.381 391.384 221.609C391.384 223.837 393.183 225.637 395.411 225.637C397.639 225.637 399.438 223.837 399.438 221.609C399.438 219.381 397.639 217.582 395.411 217.582Z"
            fill="white"
          />
          <path
            d="M400.758 210.617C398.543 210.617 396.739 212.417 396.739 214.636C396.739 216.855 398.539 218.642 400.758 218.642C402.978 218.642 404.764 216.851 404.764 214.636C404.764 212.421 402.973 210.617 400.758 210.617Z"
            fill="white"
          />
          <path
            d="M405.737 204.58C403.521 204.58 401.73 206.371 401.73 208.578C401.73 210.784 403.521 212.584 405.737 212.584C407.952 212.584 409.734 210.793 409.734 208.578C409.734 206.362 407.943 204.58 405.737 204.58Z"
            fill="white"
          />
          <path
            d="M410.252 199.334C408.046 199.334 406.268 201.125 406.268 203.332C406.268 205.538 408.046 207.316 410.252 207.316C412.459 207.316 414.237 205.526 414.237 203.332C414.237 201.138 412.446 199.334 410.252 199.334Z"
            fill="white"
          />
          <path
            d="M414.257 194.775C412.071 194.775 410.302 196.545 410.302 198.731C410.302 200.916 412.071 202.677 414.257 202.677C416.442 202.677 418.212 200.908 418.212 198.731C418.212 196.554 416.442 194.775 414.257 194.775Z"
            fill="white"
          />
          <path
            d="M417.733 190.723C415.556 190.723 413.799 192.484 413.799 194.652C413.799 196.821 415.556 198.578 417.733 198.578C419.91 198.578 421.658 196.821 421.658 194.652C421.658 192.484 419.901 190.723 417.733 190.723Z"
            fill="white"
          />
          <path
            d="M420.671 187.086C418.506 187.086 416.758 188.839 416.758 190.999C416.758 193.159 418.506 194.903 420.671 194.903C422.835 194.903 424.575 193.154 424.575 190.999C424.575 188.843 422.826 187.086 420.671 187.086Z"
            fill="white"
          />
          <path
            d="M423.076 183.787C420.933 183.787 419.193 185.527 419.193 187.67C419.193 189.813 420.933 191.549 423.076 191.549C425.219 191.549 426.959 189.817 426.959 187.67C426.959 185.523 425.224 183.787 423.076 183.787Z"
            fill="white"
          />
          <path
            d="M424.998 180.734C422.877 180.734 421.149 182.462 421.149 184.583C421.149 186.705 422.877 188.428 424.998 188.428C427.12 188.428 428.839 186.705 428.839 184.583C428.839 182.462 427.12 180.734 424.998 180.734Z"
            fill="white"
          />
          <path
            d="M426.481 177.82C424.367 177.82 422.661 179.526 422.661 181.64C422.661 183.753 424.367 185.459 426.481 185.459C428.594 185.459 430.291 183.749 430.291 181.64C430.291 179.531 428.585 177.82 426.481 177.82Z"
            fill="white"
          />
          <path
            d="M427.571 174.969C425.479 174.969 423.781 176.666 423.781 178.758C423.781 180.851 425.479 182.548 427.571 182.548C429.663 182.548 431.348 180.851 431.348 178.758C431.348 176.666 429.663 174.969 427.571 174.969Z"
            fill="white"
          />
          <path
            d="M428.36 172.105C426.289 172.105 424.604 173.782 424.604 175.857C424.604 177.932 426.289 179.613 428.36 179.613C430.431 179.613 432.116 177.932 432.116 175.857C432.116 173.782 430.44 172.105 428.36 172.105Z"
            fill="white"
          />
          <path
            d="M428.967 169.16C426.926 169.16 425.271 170.815 425.271 172.856C425.271 174.898 426.926 176.553 428.967 176.553C431.008 176.553 432.663 174.898 432.663 172.856C432.663 170.815 431.008 169.16 428.967 169.16Z"
            fill="white"
          />
          <path
            d="M429.518 165.979C427.498 165.979 425.855 167.617 425.855 169.641C425.855 171.665 427.502 173.303 429.518 173.303C431.534 173.303 433.18 171.669 433.18 169.641C433.18 167.612 431.546 165.979 429.518 165.979Z"
            fill="white"
          />
          <path
            d="M442.275 162.521C440.255 162.521 438.612 164.168 438.612 166.192C438.612 168.217 440.255 169.863 442.275 169.863C444.295 169.863 445.937 168.217 445.937 166.192C445.937 164.168 444.303 162.521 442.275 162.521Z"
            fill="white"
          />
          <path
            d="M455.465 158.912C453.437 158.912 451.79 160.559 451.79 162.587C451.79 164.616 453.432 166.262 455.465 166.262C457.498 166.262 459.14 164.616 459.14 162.587C459.14 160.559 457.494 158.912 455.465 158.912Z"
            fill="white"
          />
          <path
            d="M469.253 154.727C467.225 154.727 465.578 156.373 465.578 158.402C465.578 160.43 467.225 162.077 469.253 162.077C471.282 162.077 472.928 160.43 472.928 158.402C472.928 156.373 471.286 154.727 469.253 154.727Z"
            fill="white"
          />
          <path
            d="M484.004 149.938C481.963 149.938 480.32 151.584 480.32 153.617C480.32 155.65 481.967 157.296 484.004 157.296C486.041 157.296 487.679 155.65 487.679 153.617C487.679 151.584 486.037 149.938 484.004 149.938Z"
            fill="white"
          />
          <path
            d="M499.875 144.863C497.834 144.863 496.191 146.514 496.191 148.543C496.191 150.571 497.834 152.222 499.875 152.222C501.916 152.222 503.55 150.571 503.55 148.543C503.55 146.514 501.908 144.863 499.875 144.863Z"
            fill="white"
          />
          <path
            d="M517.182 139.082C515.153 139.082 513.498 140.729 513.498 142.766C513.498 144.803 515.153 146.449 517.182 146.449C519.21 146.449 520.865 144.794 520.865 142.766C520.865 140.737 519.219 139.082 517.182 139.082Z"
            fill="white"
          />
          <path
            d="M536.054 132.697C534.012 132.697 532.37 134.348 532.37 136.381C532.37 138.414 534.017 140.064 536.054 140.064C538.091 140.064 539.737 138.414 539.737 136.381C539.737 134.348 538.095 132.697 536.054 132.697Z"
            fill="white"
          />
          <path
            d="M556.432 125.988C554.39 125.988 552.735 127.643 552.735 129.685C552.735 131.726 554.39 133.368 556.432 133.368C558.473 133.368 560.115 131.717 560.115 129.685C560.115 127.652 558.469 125.988 556.432 125.988Z"
            fill="white"
          />
          <path
            d="M577.901 118.791C575.86 118.791 574.218 120.442 574.218 122.479C574.218 124.516 575.864 126.167 577.901 126.167C579.938 126.167 581.598 124.516 581.598 122.479C581.598 120.442 579.943 118.791 577.901 118.791Z"
            fill="white"
          />
          <path
            d="M599.842 111.49C597.792 111.49 596.137 113.145 596.137 115.187C596.137 117.228 597.792 118.883 599.842 118.883C601.891 118.883 603.538 117.228 603.538 115.187C603.538 113.145 601.883 111.49 599.842 111.49Z"
            fill="white"
          />
          <path
            d="M621.416 104.094C619.375 104.094 617.72 105.749 617.72 107.794C617.72 109.84 619.375 111.491 621.416 111.491C623.457 111.491 625.121 109.836 625.121 107.794C625.121 105.753 623.457 104.094 621.416 104.094Z"
            fill="white"
          />
          <path
            d="M641.973 96.3066C639.932 96.3066 638.269 97.9617 638.269 100.003C638.269 102.044 639.932 103.708 641.973 103.708C644.015 103.708 645.678 102.053 645.678 100.003C645.678 97.9532 644.023 96.3066 641.973 96.3066Z"
            fill="white"
          />
          <path
            d="M661.133 88.8984C659.084 88.8984 657.429 90.562 657.429 92.616C657.429 94.6699 659.084 96.3208 661.133 96.3208C663.183 96.3208 664.838 94.6615 664.838 92.616C664.838 90.5705 663.183 88.8984 661.133 88.8984Z"
            fill="white"
          />
          <path
            d="M678.962 81.8828C676.912 81.8828 675.244 83.5464 675.244 85.6003C675.244 87.6543 676.908 89.3221 678.962 89.3221C681.016 89.3221 682.675 87.6628 682.675 85.6003C682.675 83.5379 681.011 81.8828 678.962 81.8828Z"
            fill="white"
          />
          <path
            d="M695.563 75.7598C693.514 75.7598 691.846 77.4233 691.846 79.4858C691.846 81.5482 693.509 83.2075 695.563 83.2075C697.617 83.2075 699.289 81.5355 699.289 79.4858C699.289 77.436 697.626 75.7598 695.563 75.7598Z"
            fill="white"
          />
          <path
            d="M711.07 71.4434C709.02 71.4434 707.344 73.1069 707.344 75.1694C707.344 77.2318 709.02 78.8954 711.07 78.8954C713.119 78.8954 714.796 77.2318 714.796 75.1694C714.796 73.1069 713.132 71.4434 711.07 71.4434Z"
            fill="white"
          />
          <path
            d="M725.745 68.418C723.683 68.418 722.011 70.09 722.011 72.1482C722.011 74.2064 723.687 75.8742 725.745 75.8742C727.803 75.8742 729.471 74.2107 729.471 72.1482C729.471 70.0858 727.808 68.418 725.745 68.418Z"
            fill="white"
          />
          <path
            d="M739.682 67.0078C737.619 67.0078 735.947 68.6799 735.947 70.7423C735.947 72.8048 737.624 74.4768 739.682 74.4768C741.74 74.4768 743.416 72.8005 743.416 70.7423C743.416 68.6841 741.74 67.0078 739.682 67.0078Z"
            fill="white"
          />
          <path
            d="M745.708 82.7109C743.624 82.7109 741.939 84.3957 741.939 86.4751C741.939 88.5546 743.624 90.2436 745.708 90.2436C747.792 90.2436 749.476 88.5588 749.476 86.4751C749.476 84.3915 747.792 82.7109 745.708 82.7109Z"
            fill="white"
          />
          <path
            d="M751.547 98.4883C749.434 98.4883 747.728 100.199 747.728 102.303C747.728 104.408 749.434 106.123 751.547 106.123C753.66 106.123 755.358 104.417 755.358 102.303C755.358 100.19 753.652 98.4883 751.547 98.4883Z"
            fill="white"
          />
          <path
            d="M757.301 113.949C755.179 113.949 753.452 115.672 753.452 117.798C753.452 119.924 755.179 121.647 757.301 121.647C759.423 121.647 761.163 119.92 761.163 117.798C761.163 115.676 759.436 113.949 757.301 113.949Z"
            fill="white"
          />
          <path
            d="M763.089 128.811C760.954 128.811 759.219 130.55 759.219 132.694C759.219 134.837 760.959 136.577 763.089 136.577C765.219 136.577 766.972 134.837 766.972 132.694C766.972 130.55 765.232 128.811 763.089 128.811Z"
            fill="white"
          />
          <path
            d="M768.98 142.926C766.824 142.926 765.067 144.674 765.067 146.839C765.067 149.003 766.824 150.755 768.98 150.755C771.136 150.755 772.906 149.003 772.906 146.839C772.906 144.674 771.144 142.926 768.98 142.926Z"
            fill="white"
          />
          <path
            d="M775.027 156.275C772.842 156.275 771.072 158.045 771.072 160.231C771.072 162.416 772.842 164.194 775.027 164.194C777.213 164.194 778.991 162.42 778.991 160.231C778.991 158.041 777.213 156.275 775.027 156.275Z"
            fill="white"
          />
          <path
            d="M781.253 168.926C779.059 168.926 777.276 170.712 777.276 172.906C777.276 175.1 779.054 176.883 781.253 176.883C783.451 176.883 785.238 175.105 785.238 172.906C785.238 170.708 783.46 168.926 781.253 168.926Z"
            fill="white"
          />
          <path
            d="M787.682 180.797C785.467 180.797 783.663 182.596 783.663 184.807C783.663 187.018 785.462 188.818 787.682 188.818C789.901 188.818 791.688 187.018 791.688 184.807C791.688 182.596 789.897 180.797 787.682 180.797Z"
            fill="white"
          />
          <path
            d="M794.303 191.855C792.087 191.855 790.275 193.659 790.275 195.883C790.275 198.107 792.087 199.914 794.303 199.914C796.518 199.914 798.343 198.102 798.343 195.883C798.343 193.663 796.531 191.855 794.303 191.855Z"
            fill="white"
          />
          <path
            d="M801.11 202.164C798.861 202.164 797.053 203.976 797.053 206.221C797.053 208.466 798.865 210.278 801.11 210.278C803.355 210.278 805.171 208.466 805.171 206.221C805.171 203.976 803.359 202.164 801.11 202.164Z"
            fill="white"
          />
          <path
            d="M808.061 211.887C805.803 211.887 803.982 213.707 803.982 215.965C803.982 218.223 805.803 220.035 808.061 220.035C810.318 220.035 812.13 218.214 812.13 215.965C812.13 213.716 810.31 211.887 808.061 211.887Z"
            fill="white"
          />
          <path
            d="M815.139 221.139C812.881 221.139 811.048 222.972 811.048 225.23C811.048 227.487 812.881 229.329 815.139 229.329C817.397 229.329 819.23 227.487 819.23 225.23C819.23 222.972 817.397 221.139 815.139 221.139Z"
            fill="white"
          />
          <path
            d="M822.376 229.955C820.097 229.955 818.264 231.797 818.264 234.067C818.264 236.338 820.097 238.179 822.376 238.179C824.655 238.179 826.488 236.338 826.488 234.067C826.488 231.797 824.646 229.955 822.376 229.955Z"
            fill="white"
          />
          <path
            d="M829.751 238.332C827.472 238.332 825.617 240.182 825.617 242.465C825.617 244.749 827.472 246.599 829.751 246.599C832.029 246.599 833.884 244.749 833.884 242.465C833.884 240.182 832.034 238.332 829.751 238.332Z"
            fill="white"
          />
          <path
            d="M837.309 246.305C835.017 246.305 833.167 248.155 833.167 250.447C833.167 252.738 835.017 254.58 837.309 254.58C839.601 254.58 841.442 252.725 841.442 250.447C841.442 248.168 839.588 246.305 837.309 246.305Z"
            fill="white"
          />
          <path
            d="M845.062 253.859C842.762 253.859 840.907 255.722 840.907 258.014C840.907 260.306 842.758 262.177 845.062 262.177C847.366 262.177 849.216 260.314 849.216 258.014C849.216 255.714 847.353 253.859 845.062 253.859Z"
            fill="white"
          />
          <path
            d="M853.066 261.076C850.766 261.076 848.911 262.931 848.911 265.231C848.911 267.531 850.766 269.385 853.066 269.385C855.366 269.385 857.22 267.522 857.22 265.231C857.22 262.939 855.357 261.076 853.066 261.076Z"
            fill="white"
          />
          <path
            d="M861.35 267.912C859.058 267.912 857.195 269.775 857.195 272.067C857.195 274.358 859.058 276.23 861.35 276.23C863.642 276.23 865.505 274.367 865.505 272.067C865.505 269.767 863.654 267.912 861.35 267.912Z"
            fill="white"
          />
          <path
            d="M855.845 272.26C853.545 272.26 851.682 274.123 851.682 276.414C851.682 278.706 853.545 280.569 855.845 280.569C858.145 280.569 859.999 278.706 859.999 276.414C859.999 274.123 858.136 272.26 855.845 272.26Z"
            fill="white"
          />
          <path
            d="M850.401 276.861C848.101 276.861 846.246 278.724 846.246 281.016C846.246 283.308 848.101 285.171 850.401 285.171C852.701 285.171 854.555 283.32 854.555 281.016C854.555 278.712 852.692 276.861 850.401 276.861Z"
            fill="white"
          />
          <path
            d="M845.02 281.705C842.72 281.705 840.865 283.56 840.865 285.86C840.865 288.16 842.715 290.014 845.02 290.014C847.324 290.014 849.174 288.151 849.174 285.86C849.174 283.568 847.311 281.705 845.02 281.705Z"
            fill="white"
          />
          <path
            d="M839.672 286.814C837.381 286.814 835.518 288.669 835.518 290.969C835.518 293.269 837.381 295.124 839.672 295.124C841.964 295.124 843.827 293.261 843.827 290.969C843.827 288.677 841.964 286.814 839.672 286.814Z"
            fill="white"
          />
          <path
            d="M834.322 292.275C832.022 292.275 830.167 294.138 830.167 296.43C830.167 298.722 832.017 300.585 834.322 300.585C836.626 300.585 838.476 298.73 838.476 296.43C838.476 294.13 836.613 292.275 834.322 292.275Z"
            fill="white"
          />
          <path
            d="M828.898 298.156C826.606 298.156 824.756 300.019 824.756 302.311C824.756 304.602 826.61 306.453 828.898 306.453C831.185 306.453 833.052 304.598 833.052 302.311C833.052 300.023 831.189 298.156 828.898 298.156Z"
            fill="white"
          />
          <path
            d="M823.364 304.514C821.072 304.514 819.222 306.364 819.222 308.656C819.222 310.947 821.072 312.81 823.364 312.81C825.655 312.81 827.505 310.947 827.505 308.656C827.505 306.364 825.651 304.514 823.364 304.514Z"
            fill="white"
          />
          <path
            d="M817.617 311.398C815.326 311.398 813.476 313.253 813.476 315.54C813.476 317.828 815.326 319.674 817.617 319.674C819.909 319.674 821.751 317.823 821.751 315.54C821.751 313.257 819.896 311.398 817.617 311.398Z"
            fill="white"
          />
          <path
            d="M811.557 318.785C809.278 318.785 807.437 320.627 807.437 322.897C807.437 325.168 809.278 327.018 811.557 327.018C813.836 327.018 815.669 325.176 815.669 322.897C815.669 320.618 813.828 318.785 811.557 318.785Z"
            fill="white"
          />
          <path
            d="M805.137 326.582C802.866 326.582 801.037 328.415 801.037 330.681C801.037 332.948 802.87 334.781 805.137 334.781C807.403 334.781 809.249 332.948 809.249 330.681C809.249 328.415 807.407 326.582 805.137 326.582Z"
            fill="white"
          />
          <path
            d="M798.351 334.68C796.093 334.68 794.26 336.513 794.26 338.771C794.26 341.028 796.093 342.862 798.351 342.862C800.608 342.862 802.442 341.028 802.442 338.771C802.442 336.513 800.608 334.68 798.351 334.68Z"
            fill="white"
          />
          <path
            d="M791.222 342.963C788.986 342.963 787.165 344.783 787.165 347.02C787.165 349.256 788.986 351.09 791.222 351.09C793.458 351.09 795.279 349.269 795.279 347.02C795.279 344.771 793.467 342.963 791.222 342.963Z"
            fill="white"
          />
          <path
            d="M783.854 351.219C781.618 351.219 779.806 353.031 779.806 355.259C779.806 357.487 781.618 359.307 783.854 359.307C786.091 359.307 787.894 357.495 787.894 355.259C787.894 353.022 786.082 351.219 783.854 351.219Z"
            fill="white"
          />
          <path
            d="M776.973 367.171C779.164 366.815 780.652 364.751 780.297 362.56C779.941 360.369 777.877 358.881 775.686 359.237C773.495 359.593 772.007 361.657 772.363 363.848C772.718 366.039 774.783 367.526 776.973 367.171Z"
            fill="white"
          />
          <path
            d="M768.742 366.758C766.535 366.758 764.744 368.549 764.744 370.764C764.744 372.979 766.535 374.762 768.742 374.762C770.948 374.762 772.739 372.971 772.739 370.764C772.739 368.557 770.948 366.758 768.742 366.758Z"
            fill="white"
          />
          <path
            d="M761.163 373.709C758.969 373.709 757.199 375.479 757.199 377.673C757.199 379.867 758.969 381.628 761.163 381.628C763.357 381.628 765.118 379.858 765.118 377.673C765.118 375.487 763.348 373.709 761.163 373.709Z"
            fill="white"
          />
          <path
            d="M753.503 380.711C751.326 380.711 749.569 382.472 749.569 384.645C749.569 386.818 751.326 388.579 753.503 388.579C755.68 388.579 757.437 386.822 757.437 384.645C757.437 382.468 755.668 380.711 753.503 380.711Z"
            fill="white"
          />
          <path
            d="M751.538 391.83C749.395 391.83 747.655 393.557 747.655 395.7C747.655 397.843 749.395 399.583 751.538 399.583C753.681 399.583 755.409 397.848 755.409 395.7C755.409 393.553 753.681 391.83 751.538 391.83Z"
            fill="white"
          />
          <path
            d="M737.102 398.135C734.959 398.135 733.219 399.875 733.219 402.018C733.219 404.161 734.959 405.901 737.102 405.901C739.245 405.901 740.985 404.161 740.985 402.018C740.985 399.875 739.249 398.135 737.102 398.135Z"
            fill="white"
          />
          <path
            d="M722.447 404.816C720.313 404.816 718.577 406.544 718.577 408.687C718.577 410.83 720.313 412.557 722.447 412.557C724.582 412.557 726.318 410.817 726.318 408.687C726.318 406.556 724.591 404.816 722.447 404.816Z"
            fill="white"
          />
          <path
            d="M707.608 411.885C705.473 411.885 703.737 413.625 703.737 415.755C703.737 417.885 705.477 419.617 707.608 419.617C709.738 419.617 711.469 417.89 711.469 415.755C711.469 413.62 709.742 411.885 707.608 411.885Z"
            fill="white"
          />
          <path
            d="M692.597 419.336C690.462 419.336 688.727 421.063 688.727 423.198C688.727 425.332 690.466 427.068 692.597 427.068C694.727 427.068 696.459 425.341 696.459 423.198C696.459 421.055 694.731 419.336 692.597 419.336Z"
            fill="white"
          />
          <path
            d="M677.497 427.266C675.363 427.266 673.627 428.993 673.627 431.127C673.627 433.262 675.367 434.998 677.497 434.998C679.628 434.998 681.359 433.271 681.359 431.127C681.359 428.984 679.632 427.266 677.497 427.266Z"
            fill="white"
          />
          <path
            d="M662.331 435.553C660.196 435.553 658.469 437.28 658.469 439.415C658.469 441.549 660.196 443.276 662.331 443.276C664.465 443.276 666.192 441.549 666.192 439.415C666.192 437.28 664.452 435.553 662.331 435.553Z"
            fill="white"
          />
          <path
            d="M648.009 451.517C650.085 451.027 651.371 448.947 650.881 446.871C650.391 444.795 648.311 443.51 646.235 444C644.159 444.49 642.874 446.569 643.364 448.645C643.854 450.721 645.933 452.007 648.009 451.517Z"
            fill="white"
          />
          <path
            d="M632.035 452.162C629.9 452.162 628.186 453.889 628.186 456.024C628.186 458.159 629.904 459.873 632.035 459.873C634.165 459.873 635.884 458.146 635.884 456.024C635.884 453.902 634.156 452.162 632.035 452.162Z"
            fill="white"
          />
          <path
            d="M617.066 460.215C614.944 460.215 613.217 461.942 613.217 464.064C613.217 466.186 614.944 467.913 617.066 467.913C619.188 467.913 620.915 466.194 620.915 464.064C620.915 461.934 619.196 460.215 617.066 460.215Z"
            fill="white"
          />
          <path
            d="M602.256 467.732C600.134 467.732 598.407 469.451 598.407 471.573C598.407 473.695 600.134 475.422 602.256 475.422C604.378 475.422 606.105 473.703 606.105 471.573C606.105 469.443 604.378 467.732 602.256 467.732Z"
            fill="white"
          />
          <path
            d="M587.602 475.1C585.467 475.1 583.753 476.818 583.753 478.949C583.753 481.079 585.472 482.789 587.602 482.789C589.732 482.789 591.443 481.071 591.443 478.949C591.443 476.827 589.724 475.1 587.602 475.1Z"
            fill="white"
          />
          <path
            d="M573.105 482.492C570.983 482.492 569.265 484.211 569.265 486.333C569.265 488.455 570.983 490.182 573.105 490.182C575.227 490.182 576.954 488.455 576.954 486.333C576.954 484.211 575.227 482.492 573.105 482.492Z"
            fill="white"
          />
          <path
            d="M561.508 496.364C563.007 494.864 563.007 492.433 561.508 490.933C560.008 489.433 557.576 489.433 556.076 490.933C554.576 492.433 554.576 494.864 556.076 496.364C557.576 497.864 560.008 497.864 561.508 496.364Z"
            fill="white"
          />
          <path
            d="M544.596 497.104C542.475 497.104 540.756 498.831 540.756 500.944C540.756 503.058 542.475 504.785 544.596 504.785C546.718 504.785 548.437 503.066 548.437 500.944C548.437 498.822 546.718 497.104 544.596 497.104Z"
            fill="white"
          />
          <path
            d="M530.451 504.506C528.338 504.506 526.623 506.225 526.623 508.346C526.623 510.468 528.342 512.187 530.451 512.187C532.56 512.187 534.292 510.46 534.292 508.346C534.292 506.233 532.573 504.506 530.451 504.506Z"
            fill="white"
          />
          <path
            d="M516.362 511.996C514.241 511.996 512.53 513.715 512.53 515.828C512.53 517.942 514.236 519.656 516.362 519.656C518.489 519.656 520.19 517.95 520.19 515.828C520.19 513.706 518.472 511.996 516.362 511.996Z"
            fill="white"
          />
          <path
            d="M502.278 519.418C500.165 519.418 498.45 521.137 498.45 523.25C498.45 525.363 500.169 527.091 502.278 527.091C504.387 527.091 506.11 525.372 506.11 523.25C506.11 521.128 504.404 519.418 502.278 519.418Z"
            fill="white"
          />
          <path
            d="M488.134 526.842C486.012 526.842 484.306 528.548 484.306 530.661C484.306 532.775 486.012 534.489 488.134 534.489C490.255 534.489 491.953 532.783 491.953 530.661C491.953 528.539 490.247 526.842 488.134 526.842Z"
            fill="white"
          />
          <path
            d="M473.895 534.164C471.782 534.164 470.067 535.883 470.067 537.992C470.067 540.101 471.786 541.811 473.895 541.811C476.004 541.811 477.715 540.105 477.715 537.992C477.715 535.879 476.009 534.164 473.895 534.164Z"
            fill="white"
          />
          <path
            d="M468.319 521.102C466.184 521.102 464.47 522.829 464.47 524.963C464.47 527.098 466.188 528.812 468.319 528.812C470.449 528.812 472.168 527.085 472.168 524.963C472.168 522.841 470.441 521.102 468.319 521.102Z"
            fill="white"
          />
          <path
            d="M467.12 509.844C467.554 507.744 466.203 505.689 464.103 505.255C462.003 504.821 459.949 506.171 459.515 508.272C459.08 510.372 460.431 512.426 462.531 512.86C464.631 513.294 466.686 511.944 467.12 509.844Z"
            fill="white"
          />
          <path
            d="M458.783 486.758C456.627 486.758 454.87 488.519 454.87 490.671C454.87 492.822 456.627 494.583 458.783 494.583C460.939 494.583 462.696 492.835 462.696 490.671C462.696 488.506 460.947 486.758 458.783 486.758Z"
            fill="white"
          />
          <path
            d="M454.383 466.471C452.197 466.471 450.44 468.228 450.44 470.405C450.44 472.582 452.197 474.351 454.383 474.351C456.568 474.351 458.317 472.582 458.317 470.405C458.317 468.228 456.556 466.471 454.383 466.471Z"
            fill="white"
          />
          <path
            d="M449.782 445.699C447.584 445.699 445.806 447.477 445.806 449.663C445.806 451.848 447.584 453.639 449.782 453.639C451.98 453.639 453.746 451.861 453.746 449.663C453.746 447.465 451.968 445.699 449.782 445.699Z"
            fill="white"
          />
          <path
            d="M444.689 426.203C442.495 426.203 440.713 427.981 440.713 430.188C440.713 432.395 442.491 434.164 444.689 434.164C446.888 434.164 448.674 432.386 448.674 430.188C448.674 427.99 446.896 426.203 444.689 426.203Z"
            fill="white"
          />
          <path
            d="M439.101 408.74C436.886 408.74 435.082 410.54 435.082 412.759C435.082 414.979 436.881 416.765 439.101 416.765C441.32 416.765 443.107 414.966 443.107 412.759C443.107 410.552 441.316 408.74 439.101 408.74Z"
            fill="white"
          />
          <path
            d="M433.202 391.857C430.987 391.857 429.184 393.657 429.184 395.876C429.184 398.096 430.983 399.904 433.202 399.904C435.422 399.904 437.23 398.104 437.23 395.876C437.23 393.648 435.43 391.857 433.202 391.857Z"
            fill="white"
          />
          <path
            d="M427.125 373.771C424.897 373.771 423.085 375.571 423.085 377.812C423.085 380.052 424.897 381.839 427.125 381.839C429.353 381.839 431.165 380.04 431.165 377.812C431.165 375.584 429.353 373.771 427.125 373.771Z"
            fill="white"
          />
          <path
            d="M420.764 355.818C418.536 355.818 416.724 357.63 416.724 359.867C416.724 362.103 418.536 363.907 420.764 363.907C422.992 363.907 424.812 362.095 424.812 359.867C424.812 357.639 423 355.818 420.764 355.818Z"
            fill="white"
          />
          <path
            d="M414.083 339.113C411.834 339.113 410.014 340.925 410.014 343.17C410.014 345.415 411.834 347.227 414.083 347.227C416.333 347.227 418.145 345.415 418.145 343.17C418.145 340.925 416.324 339.113 414.083 339.113Z"
            fill="white"
          />
          <path
            d="M407.014 324.406C404.765 324.406 402.944 326.227 402.944 328.476C402.944 330.725 404.765 332.554 407.014 332.554C409.263 332.554 411.084 330.721 411.084 328.476C411.084 326.231 409.263 324.406 407.014 324.406Z"
            fill="white"
          />
          <path
            d="M399.562 311.979C397.312 311.979 395.483 313.812 395.483 316.057C395.483 318.302 397.317 320.135 399.562 320.135C401.807 320.135 403.64 318.314 403.64 316.057C403.64 313.799 401.819 311.979 399.562 311.979Z"
            fill="white"
          />
          <path
            d="M391.767 301.604C389.509 301.604 387.688 303.437 387.688 305.682C387.688 307.927 389.509 309.76 391.767 309.76C394.024 309.76 395.845 307.939 395.845 305.682C395.845 303.424 394.012 301.604 391.767 301.604Z"
            fill="white"
          />
          <path
            d="M383.661 292.898C381.404 292.898 379.57 294.732 379.57 296.989C379.57 299.247 381.404 301.08 383.661 301.08C385.919 301.08 387.752 299.247 387.752 296.989C387.752 294.732 385.919 292.898 383.661 292.898Z"
            fill="white"
          />
          <path
            d="M375.476 293.772C377.733 293.671 379.481 291.76 379.38 289.503C379.279 287.246 377.367 285.498 375.11 285.599C372.853 285.699 371.105 287.611 371.206 289.868C371.307 292.125 373.219 293.873 375.476 293.772Z"
            fill="white"
          />
          <path
            d="M366.758 279.34C364.5 279.34 362.667 281.173 362.667 283.431C362.667 285.688 364.5 287.522 366.758 287.522C369.016 287.522 370.849 285.688 370.849 283.431C370.849 281.173 369.016 279.34 366.758 279.34Z"
            fill="white"
          />
          <path
            d="M358.088 273.959C355.839 273.959 354.01 275.78 354.01 278.037C354.01 280.295 355.843 282.115 358.088 282.115C360.333 282.115 362.179 280.295 362.179 278.037C362.179 275.78 360.346 273.959 358.088 273.959Z"
            fill="white"
          />
          <path
            d="M349.303 269.244C347.054 269.244 345.225 271.077 345.225 273.335C345.225 275.593 347.058 277.413 349.303 277.413C351.548 277.413 353.394 275.58 353.394 273.335C353.394 271.09 351.561 269.244 349.303 269.244Z"
            fill="white"
          />
          <path
            d="M355.996 258.719C353.746 258.719 351.926 260.539 351.926 262.788C351.926 265.038 353.746 266.858 355.996 266.858C358.245 266.858 360.074 265.038 360.074 262.788C360.074 260.539 358.253 258.719 355.996 258.719Z"
            fill="white"
          />
          <path
            d="M362.489 257.12C364.736 257.12 366.558 255.298 366.558 253.05C366.558 250.803 364.736 248.98 362.489 248.98C360.241 248.98 358.419 250.803 358.419 253.05C358.419 255.298 360.241 257.12 362.489 257.12Z"
            fill="white"
          />
          <path
            d="M368.764 239.844C366.528 239.844 364.716 241.656 364.716 243.901C364.716 246.146 366.528 247.949 368.764 247.949C371.001 247.949 372.821 246.137 372.821 243.901C372.821 241.664 371.009 239.844 368.764 239.844Z"
            fill="white"
          />
          <path
            d="M374.826 231.152C372.598 231.152 370.777 232.964 370.777 235.192C370.777 237.42 372.598 239.241 374.826 239.241C377.054 239.241 378.874 237.429 378.874 235.192C378.874 232.956 377.062 231.152 374.826 231.152Z"
            fill="white"
          />
          <path
            d="M380.609 222.961C378.381 222.961 376.582 224.773 376.582 227.001C376.582 229.229 378.381 231.028 380.609 231.028C382.837 231.028 384.637 229.216 384.637 227.001C384.637 224.786 382.837 222.961 380.609 222.961Z"
            fill="white"
          />
          <path
            d="M388.937 222.346C390.507 220.776 390.507 218.232 388.937 216.662C387.368 215.093 384.823 215.093 383.254 216.662C381.684 218.232 381.684 220.776 383.254 222.346C384.823 223.915 387.368 223.915 388.937 222.346Z"
            fill="white"
          />
          <path
            d="M391.248 216.944C393.455 216.944 395.245 215.155 395.245 212.947C395.245 210.739 393.455 208.949 391.248 208.949C389.04 208.949 387.25 210.739 387.25 212.947C387.25 215.155 389.04 216.944 391.248 216.944Z"
            fill="white"
          />
          <path
            d="M395.984 203.344C393.777 203.344 391.999 205.122 391.999 207.32C391.999 209.518 393.777 211.297 395.984 211.297C398.191 211.297 399.96 209.518 399.96 207.32C399.96 205.122 398.182 203.344 395.984 203.344Z"
            fill="white"
          />
          <path
            d="M400.262 198.48C398.076 198.48 396.307 200.25 396.307 202.436C396.307 204.621 398.076 206.391 400.262 206.391C402.447 206.391 404.217 204.613 404.217 202.436C404.217 200.259 402.447 198.48 400.262 198.48Z"
            fill="white"
          />
          <path
            d="M404.026 194.191C401.862 194.191 400.101 195.944 400.101 198.117C400.101 200.29 401.862 202.047 404.026 202.047C406.19 202.047 407.952 200.285 407.952 198.117C407.952 195.948 406.195 194.191 404.026 194.191Z"
            fill="white"
          />
          <path
            d="M407.255 190.34C405.091 190.34 403.343 192.088 403.343 194.244C403.343 196.4 405.091 198.157 407.255 198.157C409.42 198.157 411.16 196.408 411.16 194.244C411.16 192.08 409.411 190.34 407.255 190.34Z"
            fill="white"
          />
          <path
            d="M409.943 194.631C412.087 194.631 413.826 192.893 413.826 190.748C413.826 188.604 412.087 186.865 409.943 186.865C407.798 186.865 406.06 188.604 406.06 190.748C406.06 192.893 407.798 194.631 409.943 194.631Z"
            fill="white"
          />
          <path
            d="M412.106 183.684C409.984 183.684 408.266 185.411 408.266 187.533C408.266 189.655 409.984 191.373 412.106 191.373C414.228 191.373 415.955 189.655 415.955 187.533C415.955 185.411 414.228 183.684 412.106 183.684Z"
            fill="white"
          />
          <path
            d="M413.8 180.693C411.686 180.693 409.98 182.399 409.98 184.513C409.98 186.626 411.686 188.324 413.8 188.324C415.913 188.324 417.611 186.618 417.611 184.513C417.611 182.408 415.905 180.693 413.8 180.693Z"
            fill="white"
          />
          <path
            d="M415.059 177.824C412.98 177.824 411.282 179.517 411.282 181.605C411.282 183.693 412.98 185.395 415.059 185.395C417.139 185.395 418.849 183.698 418.849 181.605C418.849 179.513 417.151 177.824 415.059 177.824Z"
            fill="white"
          />
          <path
            d="M415.977 175C413.898 175 412.222 176.676 412.222 178.756C412.222 180.835 413.898 182.507 415.977 182.507C418.057 182.507 419.733 180.827 419.733 178.756C419.733 176.685 418.048 175 415.977 175Z"
            fill="white"
          />
          <path
            d="M416.612 172.152C414.562 172.152 412.907 173.812 412.907 175.857C412.907 177.903 414.562 179.566 416.612 179.566C418.662 179.566 420.317 177.903 420.317 175.857C420.317 173.812 418.662 172.152 416.612 172.152Z"
            fill="white"
          />
          <path
            d="M417.089 169.172C415.069 169.172 413.436 170.81 413.436 172.834C413.436 174.858 415.069 176.492 417.089 176.492C419.109 176.492 420.752 174.854 420.752 172.834C420.752 170.814 419.118 169.172 417.089 169.172Z"
            fill="white"
          />
          <path
            d="M417.581 165.914C415.582 165.914 413.961 167.539 413.961 169.547C413.961 171.554 415.586 173.167 417.581 173.167C419.575 173.167 421.213 171.546 421.213 169.547C421.213 167.548 419.588 165.914 417.581 165.914Z"
            fill="white"
          />
          <path
            d="M430.235 162.408C428.236 162.408 426.603 164.042 426.603 166.041C426.603 168.04 428.236 169.674 430.235 169.674C432.234 169.674 433.868 168.048 433.868 166.041C433.868 164.034 432.242 162.408 430.235 162.408Z"
            fill="white"
          />
          <path
            d="M443.378 158.588C441.37 158.588 439.745 160.213 439.745 162.221C439.745 164.228 441.37 165.853 443.378 165.853C445.385 165.853 447.01 164.228 447.01 162.221C447.01 160.213 445.385 158.588 443.378 158.588Z"
            fill="white"
          />
          <path
            d="M457.128 154.484C455.108 154.484 453.487 156.114 453.487 158.121C453.487 160.129 455.113 161.758 457.128 161.758C459.144 161.758 460.761 160.133 460.761 158.121C460.761 156.11 459.136 154.484 457.128 154.484Z"
            fill="white"
          />
          <path
            d="M471.765 149.617C469.757 149.617 468.132 151.243 468.132 153.254C468.132 155.266 469.757 156.891 471.765 156.891C473.772 156.891 475.406 155.266 475.406 153.254C475.406 151.243 473.785 149.617 471.765 149.617Z"
            fill="white"
          />
          <path
            d="M487.637 144.061C485.617 144.061 483.996 145.69 483.996 147.71C483.996 149.73 485.621 151.351 487.637 151.351C489.653 151.351 491.278 149.717 491.278 147.71C491.278 145.703 489.645 144.061 487.637 144.061Z"
            fill="white"
          />
          <path
            d="M504.9 138.072C502.893 138.072 501.259 139.706 501.259 141.722C501.259 143.738 502.893 145.372 504.9 145.372C506.907 145.372 508.554 143.738 508.554 141.722C508.554 139.706 506.92 138.072 504.9 138.072Z"
            fill="white"
          />
          <path
            d="M523.895 131.133C521.875 131.133 520.241 132.767 520.241 134.787C520.241 136.807 521.875 138.441 523.895 138.441C525.915 138.441 527.549 136.807 527.549 134.787C527.549 132.767 525.915 131.133 523.895 131.133Z"
            fill="white"
          />
          <path
            d="M544.438 123.658C542.418 123.658 540.784 125.292 540.784 127.312C540.784 129.332 542.418 130.966 544.438 130.966C546.458 130.966 548.092 129.332 548.092 127.312C548.092 125.292 546.458 123.658 544.438 123.658Z"
            fill="white"
          />
          <path
            d="M566.349 115.557C564.329 115.557 562.695 117.195 562.695 119.215C562.695 121.235 564.329 122.869 566.349 122.869C568.369 122.869 570.003 121.235 570.003 119.215C570.003 117.195 568.369 115.557 566.349 115.557Z"
            fill="white"
          />
          <path
            d="M588.769 107.047C586.749 107.047 585.106 108.685 585.106 110.709C585.106 112.734 586.753 114.372 588.769 114.372C590.785 114.372 592.431 112.725 592.431 110.709C592.431 108.693 590.785 107.047 588.769 107.047Z"
            fill="white"
          />
          <path
            d="M611.054 98.3438C609.034 98.3438 607.392 99.9776 607.392 102.006C607.392 104.035 609.038 105.664 611.054 105.664C613.07 105.664 614.716 104.026 614.716 102.006C614.716 99.9861 613.07 98.3438 611.054 98.3438Z"
            fill="white"
          />
          <path
            d="M632.379 89.2793C630.351 89.2793 628.717 90.9174 628.717 92.9416C628.717 94.9659 630.351 96.6167 632.379 96.6167C634.408 96.6167 636.054 94.9702 636.054 92.9416C636.054 90.9131 634.408 89.2793 632.379 89.2793Z"
            fill="white"
          />
          <path
            d="M652.32 80.1699C650.3 80.1699 648.657 81.808 648.657 83.8408C648.657 85.8735 650.304 87.5074 652.32 87.5074C654.335 87.5074 655.995 85.8693 655.995 83.8408C655.995 81.8123 654.348 80.1699 652.32 80.1699Z"
            fill="white"
          />
          <path
            d="M670.801 71.8516C668.773 71.8516 667.126 73.4981 667.126 75.5267C667.126 77.5552 668.773 79.2017 670.801 79.2017C672.83 79.2017 674.476 77.5552 674.476 75.5267C674.476 73.4981 672.83 71.8516 670.801 71.8516Z"
            fill="white"
          />
          <path
            d="M687.997 64.1855C685.969 64.1855 684.322 65.8364 684.322 67.8691C684.322 69.9019 685.969 71.5442 687.997 71.5442C690.026 71.5442 691.681 69.8976 691.681 67.8691C691.681 65.8406 690.034 64.1855 687.997 64.1855Z"
            fill="white"
          />
          <path
            d="M704.013 58.4395C701.971 58.4395 700.329 60.086 700.329 62.1145C700.329 64.143 701.976 65.7981 704.013 65.7981C706.05 65.7981 707.688 64.1473 707.688 62.1145C707.688 60.0818 706.041 58.4395 704.013 58.4395Z"
            fill="white"
          />
          <path
            d="M719.087 54.4355C717.046 54.4355 715.403 56.0864 715.403 58.1191C715.403 60.1519 717.046 61.8027 719.087 61.8027C721.128 61.8027 722.77 60.1561 722.77 58.1191C722.77 56.0821 721.115 54.4355 719.087 54.4355Z"
            fill="white"
          />
          <path
            d="M733.387 51.9277C731.346 51.9277 729.683 53.587 729.683 55.6325C729.683 57.678 731.346 59.3288 733.387 59.3288C735.429 59.3288 737.092 57.6738 737.092 55.6325C737.092 53.5913 735.429 51.9277 733.387 51.9277Z"
            fill="white"
          />
          <path
            d="M746.998 51.7559C744.948 51.7559 743.293 53.4152 743.293 55.4564C743.293 57.4976 744.948 59.1612 746.998 59.1612C749.047 59.1612 750.694 57.5019 750.694 55.4564C750.694 53.4109 749.039 51.7559 746.998 51.7559Z"
            fill="white"
          />
          <path
            d="M752.994 67.75C750.932 67.75 749.26 69.422 749.26 71.4803C749.26 73.5385 750.936 75.2148 752.994 75.2148C755.052 75.2148 756.729 73.5427 756.729 71.4803C756.729 69.4178 755.052 67.75 752.994 67.75Z"
            fill="white"
          />
          <path
            d="M758.762 84.2754C756.678 84.2754 754.993 85.9729 754.993 88.0523C754.993 90.1318 756.678 91.8208 758.762 91.8208C760.845 91.8208 762.53 90.136 762.53 88.0523C762.53 85.9687 760.845 84.2754 758.762 84.2754Z"
            fill="white"
          />
          <path
            d="M764.401 100.695C762.288 100.695 760.582 102.406 760.582 104.51C760.582 106.615 762.288 108.33 764.401 108.33C766.515 108.33 768.221 106.624 768.221 104.51C768.221 102.397 766.515 100.695 764.401 100.695Z"
            fill="white"
          />
          <path
            d="M770.019 116.637C767.897 116.637 766.17 118.364 766.17 120.486C766.17 122.608 767.897 124.335 770.019 124.335C772.141 124.335 773.868 122.616 773.868 120.486C773.868 118.355 772.149 116.637 770.019 116.637Z"
            fill="white"
          />
          <path
            d="M775.724 131.934C773.568 131.934 771.832 133.678 771.832 135.825C771.832 137.972 773.572 139.708 775.724 139.708C777.875 139.708 779.607 137.972 779.607 135.825C779.607 133.678 777.867 131.934 775.724 131.934Z"
            fill="white"
          />
          <path
            d="M781.554 146.545C779.39 146.545 777.642 148.293 777.642 150.458C777.642 152.622 779.39 154.375 781.554 154.375C783.719 154.375 785.48 152.622 785.48 150.458C785.48 148.293 783.723 146.545 781.554 146.545Z"
            fill="white"
          />
          <path
            d="M787.59 160.293C785.404 160.293 783.626 162.067 783.626 164.257C783.626 166.446 785.404 168.212 787.59 168.212C789.775 168.212 791.553 166.442 791.553 164.257C791.553 162.071 789.775 160.293 787.59 160.293Z"
            fill="white"
          />
          <path
            d="M793.857 173.098C791.663 173.098 789.881 174.876 789.881 177.074C789.881 179.272 791.659 181.059 793.857 181.059C796.056 181.059 797.842 179.272 797.842 177.074C797.842 174.876 796.064 173.098 793.857 173.098Z"
            fill="white"
          />
          <path
            d="M800.363 184.938C798.148 184.938 796.357 186.737 796.357 188.956C796.357 191.176 798.148 192.975 800.363 192.975C802.579 192.975 804.382 191.176 804.382 188.956C804.382 186.737 802.591 184.938 800.363 184.938Z"
            fill="white"
          />
          <path
            d="M807.072 195.988C804.844 195.988 803.045 197.792 803.045 200.02C803.045 202.248 804.844 204.06 807.072 204.06C809.3 204.06 811.112 202.248 811.112 200.02C811.112 197.792 809.3 195.988 807.072 195.988Z"
            fill="white"
          />
          <path
            d="M813.963 206.361C811.714 206.361 809.894 208.173 809.894 210.418C809.894 212.663 811.714 214.475 813.963 214.475C816.213 214.475 818.025 212.663 818.025 210.418C818.025 208.173 816.204 206.361 813.963 206.361Z"
            fill="white"
          />
          <path
            d="M821.009 216.154C818.76 216.154 816.931 217.975 816.931 220.233C816.931 222.49 818.764 224.311 821.009 224.311C823.254 224.311 825.087 222.477 825.087 220.233C825.087 217.988 823.267 216.154 821.009 216.154Z"
            fill="white"
          />
          <path
            d="M828.224 225.373C825.966 225.373 824.124 227.206 824.124 229.464C824.124 231.722 825.966 233.563 828.224 233.563C830.481 233.563 832.323 231.73 832.323 229.464C832.323 227.198 830.49 225.373 828.224 225.373Z"
            fill="white"
          />
          <path
            d="M835.591 234.043C833.32 234.043 831.479 235.885 831.479 238.155C831.479 240.426 833.32 242.276 835.591 242.276C837.861 242.276 839.703 240.434 839.703 238.155C839.703 235.876 837.87 234.043 835.591 234.043Z"
            fill="white"
          />
          <path
            d="M843.135 242.172C840.843 242.172 838.993 244.022 838.993 246.305C838.993 248.588 840.848 250.447 843.135 250.447C845.422 250.447 847.268 248.593 847.268 246.305C847.268 244.018 845.418 242.172 843.135 242.172Z"
            fill="white"
          />
          <path
            d="M850.85 249.842C848.558 249.842 846.695 251.696 846.695 253.984C846.695 256.271 848.558 258.126 850.85 258.126C853.142 258.126 854.992 256.271 854.992 253.984C854.992 251.696 853.137 249.842 850.85 249.842Z"
            fill="white"
          />
          <path
            d="M858.769 257.078C856.477 257.078 854.614 258.941 854.614 261.233C854.614 263.524 856.477 265.387 858.769 265.387C861.061 265.387 862.919 263.524 862.919 261.233C862.919 258.941 861.069 257.078 858.769 257.078Z"
            fill="white"
          />
          <path
            d="M866.939 263.926C864.639 263.926 862.784 265.78 862.784 268.08C862.784 270.381 864.634 272.235 866.939 272.235C869.243 272.235 871.093 270.372 871.093 268.08C871.093 265.789 869.23 263.926 866.939 263.926Z"
            fill="white"
          />
          <path
            d="M875.371 270.334C873.08 270.334 871.217 272.188 871.217 274.489C871.217 276.789 873.08 278.643 875.371 278.643C877.663 278.643 879.526 276.78 879.526 274.489C879.526 272.197 877.663 270.334 875.371 270.334Z"
            fill="white"
          />
          <path
            d="M869.939 274.346C867.647 274.346 865.784 276.196 865.784 278.5C865.784 280.805 867.647 282.655 869.939 282.655C872.23 282.655 874.093 280.792 874.093 278.5C874.093 276.209 872.23 274.346 869.939 274.346Z"
            fill="white"
          />
          <path
            d="M864.537 278.547C862.246 278.547 860.383 280.41 860.383 282.701C860.383 284.993 862.246 286.856 864.537 286.856C866.829 286.856 868.701 285.006 868.701 282.701C868.701 280.397 866.838 278.547 864.537 278.547Z"
            fill="white"
          />
          <path
            d="M859.164 282.973C856.873 282.973 855.01 284.827 855.01 287.127C855.01 289.427 856.873 291.282 859.164 291.282C861.456 291.282 863.319 289.419 863.319 287.127C863.319 284.836 861.456 282.973 859.164 282.973Z"
            fill="white"
          />
          <path
            d="M853.796 287.654C851.496 287.654 849.642 289.517 849.642 291.809C849.642 294.101 851.492 295.964 853.796 295.964C856.101 295.964 857.951 294.101 857.951 291.809C857.951 289.517 856.088 287.654 853.796 287.654Z"
            fill="white"
          />
          <path
            d="M848.381 292.654C846.09 292.654 844.227 294.517 844.227 296.809C844.227 299.101 846.09 300.964 848.381 300.964C850.673 300.964 852.536 299.101 852.536 296.809C852.536 294.517 850.686 292.654 848.381 292.654Z"
            fill="white"
          />
          <path
            d="M842.899 297.998C840.599 297.998 838.744 299.861 838.744 302.153C838.744 304.444 840.599 306.307 842.899 306.307C845.199 306.307 847.041 304.444 847.041 302.153C847.041 299.861 845.186 297.998 842.899 297.998Z"
            fill="white"
          />
          <path
            d="M837.258 303.775C834.971 303.775 833.104 305.63 833.104 307.917C833.104 310.205 834.967 312.072 837.258 312.072C839.55 312.072 841.4 310.209 841.4 307.917C841.4 305.626 839.537 303.775 837.258 303.775Z"
            fill="white"
          />
          <path
            d="M831.397 310.01C829.105 310.01 827.264 311.864 827.264 314.143C827.264 316.422 829.105 318.277 831.397 318.277C833.689 318.277 835.53 316.426 835.53 314.143C835.53 311.86 833.68 310.01 831.397 310.01Z"
            fill="white"
          />
          <path
            d="M825.265 316.736C822.986 316.736 821.145 318.578 821.145 320.849C821.145 323.119 822.986 324.969 825.265 324.969C827.544 324.969 829.377 323.127 829.377 320.849C829.377 318.57 827.536 316.736 825.265 316.736Z"
            fill="white"
          />
          <path
            d="M818.814 323.924C816.544 323.924 814.715 325.757 814.715 328.023C814.715 330.289 816.548 332.123 818.814 332.123C821.08 332.123 822.914 330.289 822.914 328.023C822.914 325.757 821.08 323.924 818.814 323.924Z"
            fill="white"
          />
          <path
            d="M812.028 331.492C809.771 331.492 807.938 333.325 807.938 335.583C807.938 337.841 809.771 339.674 812.028 339.674C814.286 339.674 816.119 337.841 816.119 335.583C816.119 333.325 814.286 331.492 812.028 331.492Z"
            fill="white"
          />
          <path
            d="M804.942 339.301C802.705 339.301 800.885 341.121 800.885 343.371C800.885 345.62 802.705 347.428 804.942 347.428C807.178 347.428 809.012 345.607 809.012 343.371C809.012 341.134 807.191 339.301 804.942 339.301Z"
            fill="white"
          />
          <path
            d="M797.622 347.139C795.385 347.139 793.573 348.951 793.573 351.179C793.573 353.407 795.385 355.227 797.622 355.227C799.858 355.227 801.67 353.415 801.67 351.179C801.67 348.942 799.858 347.139 797.622 347.139Z"
            fill="white"
          />
          <path
            d="M790.161 354.816C787.933 354.816 786.121 356.616 786.121 358.844C786.121 361.072 787.933 362.871 790.161 362.871C792.389 362.871 794.188 361.072 794.188 358.844C794.188 356.616 792.389 354.816 790.161 354.816Z"
            fill="white"
          />
          <path
            d="M785.464 369.001C787.025 367.439 787.025 364.908 785.464 363.347C783.902 361.786 781.371 361.786 779.81 363.347C778.249 364.908 778.249 367.439 779.81 369.001C781.371 370.562 783.902 370.562 785.464 369.001Z"
            fill="white"
          />
          <path
            d="M775.112 369.023C772.927 369.023 771.148 370.802 771.148 372.987C771.148 375.173 772.927 376.964 775.112 376.964C777.298 376.964 779.088 375.185 779.088 372.987C779.088 370.789 777.31 369.023 775.112 369.023Z"
            fill="white"
          />
          <path
            d="M767.567 375.695C765.39 375.695 763.625 377.465 763.625 379.638C763.625 381.811 765.395 383.584 767.567 383.584C769.74 383.584 771.501 381.815 771.501 379.638C771.501 377.461 769.74 375.695 767.567 375.695Z"
            fill="white"
          />
          <path
            d="M759.77 383.158C757.606 383.158 755.857 384.907 755.857 387.062C755.857 389.218 757.606 390.975 759.77 390.975C761.934 390.975 763.674 389.227 763.674 387.062C763.674 384.898 761.926 383.158 759.77 383.158Z"
            fill="white"
          />
          <path
            d="M757.241 394.889C755.119 394.889 753.4 396.616 753.4 398.738C753.4 400.86 755.119 402.578 757.241 402.578C759.363 402.578 761.09 400.86 761.09 398.738C761.09 396.616 759.363 394.889 757.241 394.889Z"
            fill="white"
          />
          <path
            d="M742.835 401.789C740.713 401.789 738.994 403.508 738.994 405.617C738.994 407.726 740.713 409.449 742.835 409.449C744.957 409.449 746.663 407.743 746.663 405.617C746.663 403.491 744.944 401.789 742.835 401.789Z"
            fill="white"
          />
          <path
            d="M728.181 409.105C726.067 409.105 724.349 410.811 724.349 412.925C724.349 415.038 726.067 416.757 728.181 416.757C730.294 416.757 732 415.038 732 412.925C732 410.811 730.294 409.105 728.181 409.105Z"
            fill="white"
          />
          <path
            d="M713.298 416.932C711.185 416.932 709.479 418.638 709.479 420.751C709.479 422.864 711.185 424.579 713.298 424.579C715.411 424.579 717.13 422.873 717.13 420.751C717.13 418.629 715.411 416.932 713.298 416.932Z"
            fill="white"
          />
          <path
            d="M698.229 432.856C700.338 432.856 702.048 431.146 702.048 429.036C702.048 426.927 700.338 425.217 698.229 425.217C696.119 425.217 694.409 426.927 694.409 429.036C694.409 431.146 696.119 432.856 698.229 432.856Z"
            fill="white"
          />
          <path
            d="M683.031 433.969C680.918 433.969 679.212 435.675 679.212 437.788C679.212 439.902 680.918 441.607 683.031 441.607C685.145 441.607 686.851 439.902 686.851 437.788C686.851 435.675 685.145 433.969 683.031 433.969Z"
            fill="white"
          />
          <path
            d="M667.755 443.119C665.654 443.119 663.936 444.825 663.936 446.939C663.936 449.052 665.654 450.758 667.755 450.758C669.856 450.758 671.587 449.052 671.587 446.939C671.587 444.825 669.868 443.119 667.755 443.119Z"
            fill="white"
          />
          <path
            d="M652.433 452.299C650.332 452.299 648.613 454.018 648.613 456.118C648.613 458.219 650.332 459.938 652.433 459.938C654.533 459.938 656.252 458.232 656.252 456.118C656.252 454.005 654.546 452.299 652.433 452.299Z"
            fill="white"
          />
          <path
            d="M637.174 461.32C635.06 461.32 633.354 463.026 633.354 465.14C633.354 467.253 635.06 468.951 637.174 468.951C639.287 468.951 640.985 467.245 640.985 465.14C640.985 463.035 639.279 461.32 637.174 461.32Z"
            fill="white"
          />
          <path
            d="M622.075 470.053C619.974 470.053 618.264 471.759 618.264 473.864C618.264 475.969 619.97 477.674 622.075 477.674C624.179 477.674 625.885 475.977 625.885 473.864C625.885 471.75 624.179 470.053 622.075 470.053Z"
            fill="white"
          />
          <path
            d="M607.159 478.193C605.045 478.193 603.348 479.899 603.348 482.004C603.348 484.109 605.045 485.815 607.159 485.815C609.272 485.815 610.969 484.109 610.969 482.004C610.969 479.899 609.263 478.193 607.159 478.193Z"
            fill="white"
          />
          <path
            d="M592.431 485.854C590.339 485.854 588.633 487.559 588.633 489.664C588.633 491.769 590.339 493.463 592.431 493.463C594.523 493.463 596.242 491.765 596.242 489.664C596.242 487.564 594.536 485.854 592.431 485.854Z"
            fill="white"
          />
          <path
            d="M577.943 493.463C575.842 493.463 574.132 495.16 574.132 497.261C574.132 499.362 575.838 501.072 577.943 501.072C580.048 501.072 581.741 499.366 581.741 497.261C581.741 495.156 580.035 493.463 577.943 493.463Z"
            fill="white"
          />
          <path
            d="M563.655 501.025C561.563 501.025 559.865 502.723 559.865 504.824C559.865 506.924 561.563 508.622 563.655 508.622C565.747 508.622 567.453 506.916 567.453 504.824C567.453 502.731 565.756 501.025 563.655 501.025Z"
            fill="white"
          />
          <path
            d="M549.582 508.426C547.482 508.426 545.784 510.132 545.784 512.224C545.784 514.316 547.482 516.022 549.582 516.022C551.683 516.022 553.381 514.316 553.381 512.224C553.381 510.132 551.675 508.426 549.582 508.426Z"
            fill="white"
          />
          <path
            d="M535.616 515.799C533.516 515.799 531.818 517.496 531.818 519.597C531.818 521.698 533.516 523.395 535.616 523.395C537.717 523.395 539.415 521.689 539.415 519.597C539.415 517.505 537.709 515.799 535.616 515.799Z"
            fill="white"
          />
          <path
            d="M521.722 523.209C519.63 523.209 517.933 524.906 517.933 526.999C517.933 529.091 519.63 530.788 521.722 530.788C523.814 530.788 525.512 529.091 525.512 526.999C525.512 524.906 523.814 523.209 521.722 523.209Z"
            fill="white"
          />
          <path
            d="M507.9 538.038C509.993 538.038 511.69 536.342 511.69 534.249C511.69 532.156 509.993 530.459 507.9 530.459C505.807 530.459 504.11 532.156 504.11 534.249C504.11 536.342 505.807 538.038 507.9 538.038Z"
            fill="white"
          />
          <path
            d="M494.056 537.539C491.964 537.539 490.267 539.237 490.267 541.316C490.267 543.395 491.964 545.106 494.056 545.106C496.148 545.106 497.833 543.408 497.833 541.316C497.833 539.224 496.136 537.539 494.056 537.539Z"
            fill="white"
          />
          <path
            d="M480.151 544.408C478.05 544.408 476.353 546.106 476.353 548.198C476.353 550.29 478.05 551.996 480.151 551.996C482.251 551.996 483.94 550.299 483.94 548.198C483.94 546.097 482.243 544.408 480.151 544.408Z"
            fill="white"
          />
          <path
            d="M466.184 550.9C464.092 550.9 462.395 552.598 462.395 554.69C462.395 556.782 464.092 558.488 466.184 558.488C468.276 558.488 469.982 556.782 469.982 554.69C469.982 552.598 468.285 550.9 466.184 550.9Z"
            fill="white"
          />
          <path
            d="M459.594 541.057C457.472 541.057 455.753 542.775 455.753 544.885C455.753 546.994 457.472 548.725 459.594 548.725C461.715 548.725 463.434 547.006 463.434 544.885C463.434 542.763 461.715 541.057 459.594 541.057Z"
            fill="white"
          />
          <path
            d="M453.652 528.566C451.517 528.566 449.79 530.294 449.79 532.415C449.79 534.537 451.517 536.277 453.652 536.277C455.786 536.277 457.501 534.55 457.501 532.415C457.501 530.281 455.774 528.566 453.652 528.566Z"
            fill="white"
          />
          <path
            d="M448.322 513.328C446.178 513.328 444.438 515.055 444.438 517.198C444.438 519.342 446.178 521.081 448.322 521.081C450.465 521.081 452.205 519.342 452.205 517.198C452.205 515.055 450.469 513.328 448.322 513.328Z"
            fill="white"
          />
          <path
            d="M443.527 495.447C441.371 495.447 439.623 497.204 439.623 499.36C439.623 501.516 441.371 503.264 443.527 503.264C445.683 503.264 447.44 501.516 447.44 499.36C447.44 497.204 445.683 495.447 443.527 495.447Z"
            fill="white"
          />
          <path
            d="M439.008 475.496C436.831 475.496 435.074 477.257 435.074 479.43C435.074 481.603 436.831 483.373 439.008 483.373C441.185 483.373 442.951 481.603 442.951 479.43C442.951 477.257 441.181 475.496 439.008 475.496Z"
            fill="white"
          />
          <path
            d="M434.463 454.525C432.264 454.525 430.499 456.304 430.499 458.489C430.499 460.675 432.269 462.453 434.463 462.453C436.657 462.453 438.426 460.683 438.426 458.489C438.426 456.295 436.648 454.525 434.463 454.525Z"
            fill="white"
          />
          <path
            d="M429.527 434.186C427.333 434.186 425.551 435.964 425.551 438.162C425.551 440.36 427.329 442.147 429.527 442.147C431.725 442.147 433.504 440.369 433.504 438.162C433.504 435.955 431.725 434.186 429.527 434.186Z"
            fill="white"
          />
          <path
            d="M424.065 415.691C421.858 415.691 420.067 417.482 420.067 419.689C420.067 421.896 421.858 423.695 424.065 423.695C426.272 423.695 428.071 421.904 428.071 419.689C428.071 417.474 426.28 415.691 424.065 415.691Z"
            fill="white"
          />
          <path
            d="M421.649 404.73C422.805 402.835 422.207 400.362 420.313 399.205C418.419 398.049 415.946 398.647 414.789 400.541C413.632 402.435 414.23 404.908 416.124 406.065C418.019 407.222 420.492 406.624 421.649 404.73Z"
            fill="white"
          />
          <path
            d="M412.178 380.703C409.941 380.703 408.138 382.515 408.138 384.743C408.138 386.971 409.937 388.77 412.178 388.77C414.418 388.77 416.205 386.971 416.205 384.743C416.205 382.515 414.406 380.703 412.178 380.703Z"
            fill="white"
          />
          <path
            d="M405.86 362.854C403.624 362.854 401.812 364.666 401.812 366.902C401.812 369.138 403.624 370.951 405.86 370.951C408.097 370.951 409.9 369.138 409.9 366.902C409.9 364.666 408.088 362.854 405.86 362.854Z"
            fill="white"
          />
          <path
            d="M399.125 346.439C396.888 346.439 395.076 348.26 395.076 350.496C395.076 352.733 396.888 354.554 399.125 354.554C401.361 354.554 403.182 352.733 403.182 350.496C403.182 348.26 401.37 346.439 399.125 346.439Z"
            fill="white"
          />
          <path
            d="M391.974 332.021C389.725 332.021 387.904 333.842 387.904 336.091C387.904 338.34 389.725 340.161 391.974 340.161C394.223 340.161 396.044 338.34 396.044 336.091C396.044 333.842 394.223 332.021 391.974 332.021Z"
            fill="white"
          />
          <path
            d="M384.421 319.648C382.163 319.648 380.343 321.482 380.343 323.727C380.343 325.972 382.163 327.805 384.421 327.805C386.679 327.805 388.499 325.984 388.499 323.727C388.499 321.469 386.666 319.648 384.421 319.648Z"
            fill="white"
          />
          <path
            d="M376.51 309.158C374.252 309.158 372.432 310.991 372.432 313.236C372.432 315.481 374.252 317.315 376.51 317.315C378.768 317.315 380.588 315.494 380.588 313.236C380.588 310.979 378.755 309.158 376.51 309.158Z"
            fill="white"
          />
          <path
            d="M368.307 300.258C366.049 300.258 364.216 302.091 364.216 304.349C364.216 306.606 366.049 308.44 368.307 308.44C370.564 308.44 372.398 306.619 372.398 304.349C372.398 302.078 370.564 300.258 368.307 300.258Z"
            fill="white"
          />
          <path
            d="M359.887 292.711C357.629 292.711 355.796 294.544 355.796 296.802C355.796 299.06 357.629 300.88 359.887 300.88C362.145 300.88 363.978 299.06 363.978 296.802C363.978 294.544 362.145 292.711 359.887 292.711Z"
            fill="white"
          />
          <path
            d="M351.251 286.355C348.993 286.355 347.16 288.176 347.16 290.434C347.16 292.691 348.993 294.512 351.251 294.512C353.509 294.512 355.329 292.691 355.329 290.434C355.329 288.176 353.496 286.355 351.251 286.355Z"
            fill="white"
          />
          <path
            d="M342.453 280.787C340.204 280.787 338.375 282.62 338.375 284.865C338.375 287.11 340.208 288.956 342.453 288.956C344.698 288.956 346.544 287.123 346.544 284.865C346.544 282.608 344.711 280.787 342.453 280.787Z"
            fill="white"
          />
          <path
            d="M333.631 275.664C331.373 275.664 329.54 277.485 329.54 279.742C329.54 282 331.373 283.821 333.631 283.821C335.889 283.821 337.709 282 337.709 279.742C337.709 277.485 335.876 275.664 333.631 275.664Z"
            fill="white"
          />
          <path
            d="M340.468 264.945C338.219 264.945 336.39 266.779 336.39 269.024C336.39 271.268 338.223 273.102 340.468 273.102C342.713 273.102 344.546 271.268 344.546 269.024C344.546 266.779 342.713 264.945 340.468 264.945Z"
            fill="white"
          />
          <path
            d="M347.16 255.027C344.91 255.027 343.09 256.848 343.09 259.097C343.09 261.346 344.91 263.158 347.16 263.158C349.409 263.158 351.221 261.346 351.221 259.097C351.221 256.848 349.4 255.027 347.16 255.027Z"
            fill="white"
          />
          <path
            d="M353.623 245.734C351.387 245.734 349.566 247.555 349.566 249.796C349.566 252.036 351.387 253.853 353.623 253.853C355.86 253.853 357.68 252.032 357.68 249.796C357.68 247.559 355.86 245.734 353.623 245.734Z"
            fill="white"
          />
          <path
            d="M359.815 236.959C357.579 236.959 355.767 238.78 355.767 241.02C355.767 243.261 357.579 245.069 359.815 245.069C362.052 245.069 363.876 243.257 363.876 241.02C363.876 238.784 362.056 236.959 359.815 236.959Z"
            fill="white"
          />
          <path
            d="M365.748 228.631C363.52 228.631 361.721 230.43 361.721 232.65C361.721 234.869 363.52 236.677 365.748 236.677C367.976 236.677 369.767 234.878 369.767 232.65C369.767 230.422 367.967 228.631 365.748 228.631Z"
            fill="white"
          />
          <path
            d="M371.408 220.734C369.193 220.734 367.39 222.534 367.39 224.753C367.39 226.973 369.189 228.759 371.408 228.759C373.628 228.759 375.415 226.968 375.415 224.753C375.415 222.538 373.624 220.734 371.408 220.734Z"
            fill="white"
          />
          <path
            d="M376.748 221.673C378.955 221.673 380.745 219.883 380.745 217.675C380.745 215.468 378.955 213.678 376.748 213.678C374.54 213.678 372.75 215.468 372.75 217.675C372.75 219.883 374.54 221.673 376.748 221.673Z"
            fill="white"
          />
          <path
            d="M381.671 207.6C379.477 207.6 377.694 209.378 377.694 211.584C377.694 213.791 379.472 215.561 381.671 215.561C383.869 215.561 385.656 213.783 385.656 211.584C385.656 209.386 383.865 207.6 381.671 207.6Z"
            fill="white"
          />
          <path
            d="M386.156 202.332C383.971 202.332 382.201 204.102 382.201 206.274C382.201 208.447 383.971 210.23 386.156 210.23C388.342 210.23 390.099 208.46 390.099 206.274C390.099 204.089 388.342 202.332 386.156 202.332Z"
            fill="white"
          />
          <path
            d="M390.166 197.678C388.001 197.678 386.24 199.435 386.24 201.603C386.24 203.772 387.997 205.529 390.166 205.529C392.334 205.529 394.091 203.772 394.091 201.603C394.091 199.435 392.343 197.678 390.166 197.678Z"
            fill="white"
          />
          <path
            d="M393.672 193.549C391.516 193.549 389.768 195.297 389.768 197.453C389.768 199.609 391.516 201.366 393.672 201.366C395.828 201.366 397.585 199.617 397.585 197.453C397.585 195.289 395.836 193.549 393.672 193.549Z"
            fill="white"
          />
          <path
            d="M396.638 189.865C394.503 189.865 392.768 191.601 392.768 193.744C392.768 195.887 394.508 197.623 396.638 197.623C398.768 197.623 400.508 195.887 400.508 193.744C400.508 191.601 398.781 189.865 396.638 189.865Z"
            fill="white"
          />
          <path
            d="M399.073 186.539C396.96 186.539 395.232 188.262 395.232 190.375C395.232 192.489 396.96 194.216 399.073 194.216C401.186 194.216 402.914 192.497 402.914 190.375C402.914 188.254 401.195 186.539 399.073 186.539Z"
            fill="white"
          />
          <path
            d="M401.009 183.457C398.908 183.457 397.198 185.163 397.198 187.272C397.198 189.381 398.904 191.083 401.009 191.083C403.114 191.083 404.82 189.377 404.82 187.272C404.82 185.167 403.114 183.457 401.009 183.457Z"
            fill="white"
          />
          <path
            d="M402.477 180.537C400.385 180.537 398.7 182.235 398.7 184.318C398.7 186.402 400.385 188.104 402.477 188.104C404.569 188.104 406.267 186.406 406.267 184.318C406.267 182.23 404.569 180.537 402.477 180.537Z"
            fill="white"
          />
          <path
            d="M403.551 177.707C401.48 177.707 399.804 179.388 399.804 181.459C399.804 183.529 401.48 185.21 403.551 185.21C405.622 185.21 407.307 183.529 407.307 181.459C407.307 179.388 405.622 177.707 403.551 177.707Z"
            fill="white"
          />
          <path
            d="M404.297 174.906C402.256 174.906 400.601 176.566 400.601 178.611C400.601 180.657 402.256 182.307 404.297 182.307C406.338 182.307 408.002 180.652 408.002 178.611C408.002 176.57 406.338 174.906 404.297 174.906Z"
            fill="white"
          />
          <path
            d="M404.807 172.033C402.787 172.033 401.153 173.667 401.153 175.696C401.153 177.724 402.787 179.349 404.807 179.349C406.827 179.349 408.47 177.716 408.47 175.696C408.47 173.676 406.836 172.033 404.807 172.033Z"
            fill="white"
          />
          <path
            d="M405.215 168.975C403.216 168.975 401.595 170.6 401.595 172.607C401.595 174.615 403.22 176.227 405.215 176.227C407.209 176.227 408.847 174.602 408.847 172.607C408.847 170.613 407.222 168.975 405.215 168.975Z"
            fill="white"
          />
          <path
            d="M405.693 165.611C403.715 165.611 402.111 167.22 402.111 169.197C402.111 171.175 403.715 172.783 405.693 172.783C407.671 172.783 409.275 171.179 409.275 169.197C409.275 167.215 407.671 165.611 405.693 165.611Z"
            fill="white"
          />
          <path
            d="M418.306 162.225C416.329 162.225 414.725 163.829 414.725 165.811C414.725 167.792 416.329 169.392 418.306 169.392C420.284 169.392 421.888 167.788 421.888 165.811C421.888 163.833 420.284 162.225 418.306 162.225Z"
            fill="white"
          />
          <path
            d="M431.412 158.266C429.434 158.266 427.821 159.874 427.821 161.856C427.821 163.838 429.434 165.442 431.412 165.442C433.389 165.442 435.002 163.833 435.002 161.856C435.002 159.878 433.389 158.266 431.412 158.266Z"
            fill="white"
          />
          <path
            d="M445.19 153.906C443.212 153.906 441.6 155.515 441.6 157.492C441.6 159.47 443.212 161.082 445.19 161.082C447.167 161.082 448.78 159.478 448.78 157.492C448.78 155.506 447.176 153.906 445.19 153.906Z"
            fill="white"
          />
          <path
            d="M459.835 149.082C457.849 149.082 456.232 150.69 456.232 152.672C456.232 154.654 457.845 156.275 459.835 156.275C461.826 156.275 463.426 154.663 463.426 152.672C463.426 150.682 461.813 149.082 459.835 149.082Z"
            fill="white"
          />
          <path
            d="M475.737 143.254C473.751 143.254 472.139 144.867 472.139 146.853C472.139 148.839 473.751 150.456 475.737 150.456C477.723 150.456 479.328 148.843 479.328 146.853C479.328 144.862 477.723 143.254 475.737 143.254Z"
            fill="white"
          />
          <path
            d="M493.097 136.738C491.111 136.738 489.494 138.347 489.494 140.333C489.494 142.319 491.107 143.936 493.097 143.936C495.087 143.936 496.696 142.327 496.696 140.333C496.696 138.338 495.083 136.738 493.097 136.738Z"
            fill="white"
          />
          <path
            d="M512.216 129.436C510.217 129.436 508.604 131.048 508.604 133.038C508.604 135.029 510.217 136.646 512.216 136.646C514.215 136.646 515.819 135.033 515.819 133.038C515.819 131.044 514.206 129.436 512.216 129.436Z"
            fill="white"
          />
          <path
            d="M533.015 121.16C531.029 121.16 529.412 122.773 529.412 124.772C529.412 126.77 531.025 128.375 533.015 128.375C535.005 128.375 536.626 126.762 536.626 124.772C536.626 122.781 535.014 121.16 533.015 121.16Z"
            fill="white"
          />
          <path
            d="M555.256 112.209C553.257 112.209 551.645 113.834 551.645 115.82C551.645 117.806 553.257 119.432 555.256 119.432C557.255 119.432 558.867 117.819 558.867 115.82C558.867 113.822 557.242 112.209 555.256 112.209Z"
            fill="white"
          />
          <path
            d="M578.164 102.562C576.178 102.562 574.553 104.175 574.553 106.174C574.553 108.173 576.178 109.785 578.164 109.785C580.15 109.785 581.776 108.168 581.776 106.174C581.776 104.179 580.163 102.562 578.164 102.562Z"
            fill="white"
          />
          <path
            d="M600.957 92.4668C598.958 92.4668 597.337 94.0922 597.337 96.0867C597.337 98.0813 598.962 99.6981 600.957 99.6981C602.951 99.6981 604.568 98.0855 604.568 96.0867C604.568 94.0879 602.956 92.4668 600.957 92.4668Z"
            fill="white"
          />
          <path
            d="M622.876 82.207C620.869 82.207 619.243 83.8409 619.243 85.8397C619.243 87.8385 620.869 89.4723 622.876 89.4723C624.883 89.4723 626.509 87.847 626.509 85.8397C626.509 83.8324 624.883 82.207 622.876 82.207Z"
            fill="white"
          />
          <path
            d="M643.463 71.5645C641.455 71.5645 639.83 73.1898 639.83 75.1971C639.83 77.2044 641.455 78.8298 643.463 78.8298C645.47 78.8298 647.095 77.2044 647.095 75.1971C647.095 73.1898 645.47 71.5645 643.463 71.5645Z"
            fill="white"
          />
          <path
            d="M662.518 61.8574C660.511 61.8574 658.877 63.4828 658.877 65.4901C658.877 67.4974 660.511 69.1312 662.518 69.1312C664.525 69.1312 666.151 67.4974 666.151 65.4901C666.151 63.4828 664.525 61.8574 662.518 61.8574Z"
            fill="white"
          />
          <path
            d="M680.223 53.0469C678.215 53.0469 676.59 54.6765 676.59 56.6838C676.59 58.6911 678.211 60.3249 680.223 60.3249C682.234 60.3249 683.864 58.6911 683.864 56.6838C683.864 54.6765 682.23 53.0469 680.223 53.0469Z"
            fill="white"
          />
          <path
            d="M696.709 45.7773C694.702 45.7773 693.068 47.4112 693.068 49.4185C693.068 51.4258 694.702 53.0596 696.709 53.0596C698.717 53.0596 700.351 51.4258 700.351 49.4185C700.351 47.4112 698.725 45.7773 696.709 45.7773Z"
            fill="white"
          />
          <path
            d="M712.152 40.9668C710.132 40.9668 708.498 42.6006 708.498 44.6207C708.498 46.6407 710.132 48.2618 712.152 48.2618C714.172 48.2618 715.806 46.6322 715.806 44.6207C715.806 42.6091 714.172 40.9668 712.152 40.9668Z"
            fill="white"
          />
          <path
            d="M726.776 38C724.769 38 723.135 39.6338 723.135 41.6539C723.135 43.6739 724.769 45.295 726.776 45.295C728.783 45.295 730.43 43.6612 730.43 41.6539C730.43 39.6466 728.796 38 726.776 38Z"
            fill="white"
          />
          <path
            d="M740.691 36.9492C738.671 36.9492 737.037 38.5831 737.037 40.6031C737.037 42.6231 738.671 44.257 740.691 44.257C742.711 44.257 744.345 42.6231 744.345 40.6031C744.345 38.5831 742.711 36.9492 740.691 36.9492Z"
            fill="white"
          />
          <path
            d="M754.012 38.1055C751.992 38.1055 750.35 39.7436 750.35 41.7678C750.35 43.7921 751.996 45.4217 754.012 45.4217C756.028 45.4217 757.674 43.7878 757.674 41.7678C757.674 39.7478 756.032 38.1055 754.012 38.1055Z"
            fill="white"
          />
          <path
            d="M760.093 53.4043C758.052 53.4043 756.389 55.0594 756.389 57.1091C756.389 59.1588 758.052 60.8139 760.093 60.8139C762.135 60.8139 763.798 59.1546 763.798 57.1091C763.798 55.0636 762.143 53.4043 760.093 53.4043Z"
            fill="white"
          />
          <path
            d="M765.878 69.8477C763.807 69.8477 762.131 71.5239 762.131 73.5949C762.131 75.6658 763.807 77.3294 765.878 77.3294C767.949 77.3294 769.613 75.6531 769.613 73.5949C769.613 71.5367 767.936 69.8477 765.878 69.8477Z"
            fill="white"
          />
          <path
            d="M771.459 86.8906C769.366 86.8906 767.682 88.5839 767.682 90.6633C767.682 92.7428 769.366 94.4318 771.459 94.4318C773.551 94.4318 775.227 92.747 775.227 90.6633C775.227 88.5796 773.542 86.8906 771.459 86.8906Z"
            fill="white"
          />
          <path
            d="M776.941 103.793C774.827 103.793 773.108 105.503 773.108 107.629C773.108 109.755 774.827 111.461 776.941 111.461C779.054 111.461 780.781 109.743 780.781 107.629C780.781 105.516 779.062 103.793 776.941 103.793Z"
            fill="white"
          />
          <path
            d="M782.458 120.338C780.323 120.338 778.596 122.065 778.596 124.2C778.596 126.334 780.323 128.07 782.458 128.07C784.592 128.07 786.328 126.343 786.328 124.2C786.328 122.057 784.588 120.338 782.458 120.338Z"
            fill="white"
          />
          <path
            d="M788.098 136.168C785.942 136.168 784.193 137.916 784.193 140.072C784.193 142.228 785.942 143.964 788.098 143.964C790.253 143.964 791.989 142.22 791.989 140.072C791.989 137.925 790.241 136.168 788.098 136.168Z"
            fill="white"
          />
          <path
            d="M796.727 157.698C798.26 156.165 798.26 153.679 796.727 152.146C795.194 150.613 792.708 150.613 791.175 152.146C789.642 153.679 789.642 156.165 791.175 157.698C792.708 159.231 795.194 159.231 796.727 157.698Z"
            fill="white"
          />
          <path
            d="M800.049 164.75C797.863 164.75 796.085 166.52 796.085 168.714C796.085 170.908 797.863 172.677 800.049 172.677C802.234 172.677 804.025 170.908 804.025 168.714C804.025 166.52 802.247 164.75 800.049 164.75Z"
            fill="white"
          />
          <path
            d="M806.407 177.504C804.2 177.504 802.422 179.291 802.422 181.489C802.422 183.687 804.2 185.482 806.407 185.482C808.614 185.482 810.392 183.691 810.392 181.489C810.392 179.286 808.614 177.504 806.407 177.504Z"
            fill="white"
          />
          <path
            d="M812.996 189.363C810.781 189.363 808.978 191.158 808.978 193.382C808.978 195.606 810.777 197.392 812.996 197.392C815.216 197.392 817.015 195.597 817.015 193.382C817.015 191.167 815.216 189.363 812.996 189.363Z"
            fill="white"
          />
          <path
            d="M819.79 200.459C817.562 200.459 815.763 202.271 815.763 204.499C815.763 206.727 817.562 208.539 819.79 208.539C822.018 208.539 823.83 206.727 823.83 204.499C823.83 202.271 822.018 200.459 819.79 200.459Z"
            fill="white"
          />
          <path
            d="M826.797 210.855C824.548 210.855 822.728 212.668 822.728 214.913C822.728 217.157 824.548 218.97 826.797 218.97C829.046 218.97 830.854 217.157 830.854 214.913C830.854 212.668 829.034 210.855 826.797 210.855Z"
            fill="white"
          />
          <path
            d="M833.978 220.564C831.72 220.564 829.899 222.385 829.899 224.643C829.899 226.9 831.72 228.721 833.978 228.721C836.235 228.721 838.056 226.888 838.056 224.643C838.056 222.398 836.223 220.564 833.978 220.564Z"
            fill="white"
          />
          <path
            d="M841.336 229.576C839.065 229.576 837.236 231.418 837.236 233.676C837.236 235.933 839.07 237.775 841.336 237.775C843.602 237.775 845.435 235.942 845.435 233.676C845.435 231.409 843.593 229.576 841.336 229.576Z"
            fill="white"
          />
          <path
            d="M848.86 237.996C846.59 237.996 844.748 239.838 844.748 242.108C844.748 244.379 846.59 246.22 848.86 246.22C851.131 246.22 852.972 244.379 852.972 242.108C852.972 239.838 851.131 237.996 848.86 237.996Z"
            fill="white"
          />
          <path
            d="M856.554 245.857C854.275 245.857 852.412 247.708 852.412 249.991C852.412 252.274 854.275 254.133 856.554 254.133C858.833 254.133 860.696 252.278 860.696 249.991C860.696 247.703 858.841 245.857 856.554 245.857Z"
            fill="white"
          />
          <path
            d="M864.431 253.246C862.139 253.246 860.289 255.096 860.289 257.401C860.289 259.705 862.144 261.543 864.431 261.543C866.718 261.543 868.581 259.692 868.581 257.401C868.581 255.109 866.718 253.246 864.431 253.246Z"
            fill="white"
          />
          <path
            d="M872.528 260.166C870.228 260.166 868.373 262.029 868.373 264.321C868.373 266.612 870.223 268.475 872.528 268.475C874.832 268.475 876.682 266.612 876.682 264.321C876.682 262.029 874.819 260.166 872.528 260.166Z"
            fill="white"
          />
          <path
            d="M880.853 266.621C878.553 266.621 876.698 268.484 876.698 270.776C876.698 273.067 878.548 274.926 880.853 274.926C883.157 274.926 885.007 273.063 885.007 270.776C885.007 268.488 883.144 266.621 880.853 266.621Z"
            fill="white"
          />
          <path
            d="M889.422 272.562C887.122 272.562 885.268 274.425 885.268 276.717C885.268 279.009 887.122 280.872 889.422 280.872C891.722 280.872 893.577 279.017 893.577 276.717C893.577 274.417 891.714 272.562 889.422 272.562Z"
            fill="white"
          />
          <path
            d="M884.05 276.23C881.759 276.23 879.896 278.093 879.896 280.385C879.896 282.677 881.759 284.54 884.05 284.54C886.342 284.54 888.205 282.677 888.205 280.385C888.205 278.093 886.35 276.23 884.05 276.23Z"
            fill="white"
          />
          <path
            d="M878.682 280.027C876.39 280.027 874.527 281.89 874.527 284.182C874.527 286.474 876.39 288.337 878.682 288.337C880.974 288.337 882.845 286.482 882.845 284.182C882.845 281.882 880.982 280.027 878.682 280.027Z"
            fill="white"
          />
          <path
            d="M873.309 284.012C871.009 284.012 869.154 285.866 869.154 288.166C869.154 290.466 871.005 292.321 873.309 292.321C875.613 292.321 877.463 290.458 877.463 288.166C877.463 285.875 875.601 284.012 873.309 284.012Z"
            fill="white"
          />
          <path
            d="M867.899 288.24C865.611 288.24 863.744 290.103 863.744 292.395C863.744 294.686 865.607 296.549 867.899 296.549C870.19 296.549 872.053 294.686 872.053 292.395C872.053 290.103 870.19 288.24 867.899 288.24Z"
            fill="white"
          />
          <path
            d="M862.432 292.768C860.132 292.768 858.269 294.622 858.269 296.922C858.269 299.222 860.132 301.077 862.432 301.077C864.732 301.077 866.582 299.214 866.582 296.922C866.582 294.631 864.719 292.768 862.432 292.768Z"
            fill="white"
          />
          <path
            d="M856.856 297.627C854.564 297.627 852.701 299.49 852.701 301.782C852.701 304.073 854.564 305.936 856.856 305.936C859.147 305.936 861.01 304.073 861.01 301.782C861.01 299.49 859.147 297.627 856.856 297.627Z"
            fill="white"
          />
          <path
            d="M851.118 302.871C848.827 302.871 846.964 304.734 846.964 307.026C846.964 309.317 848.827 311.18 851.118 311.18C853.41 311.18 855.273 309.317 855.273 307.026C855.273 304.734 853.41 302.871 851.118 302.871Z"
            fill="white"
          />
          <path
            d="M845.176 308.545C842.884 308.545 841.034 310.399 841.034 312.678C841.034 314.957 842.889 316.812 845.176 316.812C847.463 316.812 849.309 314.961 849.309 312.678C849.309 310.395 847.455 308.545 845.176 308.545Z"
            fill="white"
          />
          <path
            d="M838.963 314.652C836.685 314.652 834.83 316.494 834.83 318.773C834.83 321.052 836.68 322.894 838.963 322.894C841.247 322.894 843.084 321.052 843.084 318.773C843.084 316.494 841.23 314.652 838.963 314.652Z"
            fill="white"
          />
          <path
            d="M832.45 321.209C830.18 321.209 828.351 323.051 828.351 325.321C828.351 327.592 830.184 329.421 832.45 329.421C834.716 329.421 836.562 327.587 836.562 325.321C836.562 323.055 834.72 321.209 832.45 321.209Z"
            fill="white"
          />
          <path
            d="M825.644 328.188C823.386 328.188 821.553 330.021 821.553 332.278C821.553 334.536 823.386 336.378 825.644 336.378C827.901 336.378 829.743 334.545 829.743 332.278C829.743 330.012 827.91 328.188 825.644 328.188Z"
            fill="white"
          />
          <path
            d="M818.564 335.48C816.327 335.48 814.507 337.301 814.507 339.55C814.507 341.799 816.327 343.607 818.564 343.607C820.8 343.607 822.634 341.787 822.634 339.55C822.634 337.314 820.813 335.48 818.564 335.48Z"
            fill="white"
          />
          <path
            d="M811.277 342.912C809.041 342.912 807.229 344.733 807.229 346.969C807.229 349.206 809.041 351.018 811.277 351.018C813.513 351.018 815.326 349.197 815.326 346.969C815.326 344.741 813.513 342.912 811.277 342.912Z"
            fill="white"
          />
          <path
            d="M803.86 350.293C801.632 350.293 799.833 352.092 799.833 354.32C799.833 356.548 801.632 358.36 803.86 358.36C806.088 358.36 807.9 356.548 807.9 354.32C807.9 352.092 806.088 350.293 803.86 350.293Z"
            fill="white"
          />
          <path
            d="M796.386 357.42C794.179 357.42 792.38 359.211 792.38 361.426C792.38 363.641 794.179 365.424 796.386 365.424C798.593 365.424 800.392 363.633 800.392 361.426C800.392 359.219 798.601 357.42 796.386 357.42Z"
            fill="white"
          />
          <path
            d="M788.913 364.152C786.727 364.152 784.949 365.93 784.949 368.129C784.949 370.327 786.727 372.092 788.913 372.092C791.098 372.092 792.889 370.314 792.889 368.129C792.889 365.943 791.111 364.152 788.913 364.152Z"
            fill="white"
          />
          <path
            d="M781.44 370.598C779.263 370.598 777.506 372.367 777.506 374.54C777.506 376.713 779.263 378.483 781.44 378.483C783.617 378.483 785.386 376.713 785.386 374.54C785.386 372.367 783.63 370.598 781.44 370.598Z"
            fill="white"
          />
          <path
            d="M773.78 377.613C771.616 377.613 769.867 379.374 769.867 381.526C769.867 383.678 771.616 385.439 773.78 385.439C775.944 385.439 777.693 383.69 777.693 381.526C777.693 379.362 775.931 377.613 773.78 377.613Z"
            fill="white"
          />
          <path
            d="M765.725 393.452C767.869 393.452 769.608 391.713 769.608 389.569C769.608 387.424 767.869 385.686 765.725 385.686C763.58 385.686 761.842 387.424 761.842 389.569C761.842 391.713 763.58 393.452 765.725 393.452Z"
            fill="white"
          />
          <path
            d="M762.683 397.812C760.582 397.812 758.863 399.519 758.863 401.623C758.863 403.728 760.582 405.443 762.683 405.443C764.783 405.443 766.502 403.737 766.502 401.623C766.502 399.51 764.796 397.812 762.683 397.812Z"
            fill="white"
          />
          <path
            d="M748.342 405.252C746.241 405.252 744.531 406.958 744.531 409.063C744.531 411.168 746.237 412.874 748.342 412.874C750.447 412.874 752.14 411.168 752.14 409.063C752.14 406.958 750.443 405.252 748.342 405.252Z"
            fill="white"
          />
          <path
            d="M733.728 413.133C731.627 413.133 729.917 414.839 729.917 416.944C729.917 419.049 731.623 420.742 733.728 420.742C735.833 420.742 737.526 419.036 737.526 416.944C737.526 414.852 735.82 413.133 733.728 413.133Z"
            fill="white"
          />
          <path
            d="M718.887 421.617C716.795 421.617 715.089 423.315 715.089 425.415C715.089 427.516 716.795 429.214 718.887 429.214C720.979 429.214 722.685 427.508 722.685 425.415C722.685 423.323 720.988 421.617 718.887 421.617Z"
            fill="white"
          />
          <path
            d="M703.839 430.65C701.746 430.65 700.049 432.348 700.049 434.44C700.049 436.532 701.746 438.238 703.839 438.238C705.931 438.238 707.637 436.541 707.637 434.44C707.637 432.339 705.931 430.65 703.839 430.65Z"
            fill="white"
          />
          <path
            d="M688.633 440.09C686.532 440.09 684.835 441.787 684.835 443.879C684.835 445.972 686.532 447.678 688.633 447.678C690.734 447.678 692.423 445.972 692.423 443.879C692.423 441.787 690.725 440.09 688.633 440.09Z"
            fill="white"
          />
          <path
            d="M673.342 449.906C671.25 449.906 669.553 451.604 669.553 453.696C669.553 455.788 671.25 457.486 673.342 457.486C675.435 457.486 677.132 455.788 677.132 453.696C677.132 451.604 675.435 449.906 673.342 449.906Z"
            fill="white"
          />
          <path
            d="M658.01 459.781C655.918 459.781 654.221 461.479 654.221 463.571C654.221 465.663 655.918 467.361 658.01 467.361C660.103 467.361 661.8 465.663 661.8 463.571C661.8 461.479 660.103 459.781 658.01 459.781Z"
            fill="white"
          />
          <path
            d="M642.681 469.324C640.589 469.324 638.892 471.009 638.892 473.101C638.892 475.193 640.589 476.878 642.681 476.878C644.773 476.878 646.458 475.193 646.458 473.101C646.458 471.009 644.773 469.324 642.681 469.324Z"
            fill="white"
          />
          <path
            d="M627.536 478.475C625.444 478.475 623.746 480.172 623.746 482.252C623.746 484.331 625.444 486.041 627.536 486.041C629.628 486.041 631.313 484.344 631.313 482.252C631.313 480.159 629.615 478.475 627.536 478.475Z"
            fill="white"
          />
          <path
            d="M612.594 487.039C610.502 487.039 608.817 488.737 608.817 490.829C608.817 492.921 610.502 494.606 612.594 494.606C614.686 494.606 616.371 492.908 616.371 490.829C616.371 488.749 614.686 487.039 612.594 487.039Z"
            fill="white"
          />
          <path
            d="M597.884 494.848C595.805 494.848 594.107 496.545 594.107 498.625C594.107 500.704 595.805 502.401 597.884 502.401C599.964 502.401 601.661 500.704 601.661 498.625C601.661 496.545 599.964 494.848 597.884 494.848Z"
            fill="white"
          />
          <path
            d="M583.439 502.441C581.347 502.441 579.662 504.139 579.662 506.218C579.662 508.298 581.347 509.995 583.439 509.995C585.531 509.995 587.207 508.298 587.207 506.218C587.207 504.139 585.523 502.441 583.439 502.441Z"
            fill="white"
          />
          <path
            d="M569.231 509.988C567.148 509.988 565.463 511.686 565.463 513.765C565.463 515.845 567.148 517.534 569.231 517.534C571.315 517.534 573.008 515.849 573.008 513.765C573.008 511.682 571.311 509.988 569.231 509.988Z"
            fill="white"
          />
          <path
            d="M555.286 517.369C553.206 517.369 551.509 519.067 551.509 521.146C551.509 523.226 553.206 524.915 555.286 524.915C557.365 524.915 559.054 523.23 559.054 521.146C559.054 519.062 557.369 517.369 555.286 517.369Z"
            fill="white"
          />
          <path
            d="M541.494 524.619C539.415 524.619 537.726 526.304 537.726 528.375C537.726 530.446 539.41 532.143 541.494 532.143C543.578 532.143 545.25 530.459 545.25 528.375C545.25 526.291 543.565 524.619 541.494 524.619Z"
            fill="white"
          />
          <path
            d="M527.808 531.793C525.728 531.793 524.039 533.478 524.039 535.561C524.039 537.645 525.724 539.317 527.808 539.317C529.891 539.317 531.563 537.632 531.563 535.561C531.563 533.49 529.887 531.793 527.808 531.793Z"
            fill="white"
          />
          <path
            d="M514.207 538.871C512.127 538.871 510.451 540.556 510.451 542.627C510.451 544.698 512.127 546.383 514.207 546.383C516.286 546.383 517.963 544.698 517.963 542.627C517.963 540.556 516.278 538.871 514.207 538.871Z"
            fill="white"
          />
          <path
            d="M500.636 545.664C498.565 545.664 496.88 547.349 496.88 549.42C496.88 551.491 498.565 553.175 500.636 553.175C502.707 553.175 504.391 551.491 504.391 549.42C504.391 547.349 502.707 545.664 500.636 545.664Z"
            fill="white"
          />
          <path
            d="M487.029 552.162C484.95 552.162 483.261 553.847 483.261 555.931C483.261 558.014 484.946 559.699 487.029 559.699C489.113 559.699 490.785 558.014 490.785 555.931C490.785 553.847 489.1 552.162 487.029 552.162Z"
            fill="white"
          />
          <path
            d="M473.356 558.354C471.285 558.354 469.601 560.03 469.601 562.109C469.601 564.189 471.285 565.865 473.356 565.865C475.427 565.865 477.125 564.18 477.125 562.109C477.125 560.038 475.44 558.354 473.356 558.354Z"
            fill="white"
          />
          <path
            d="M459.637 563.936C457.553 563.936 455.881 565.62 455.881 567.691C455.881 569.762 457.557 571.447 459.637 571.447C461.716 571.447 463.392 569.771 463.392 567.691C463.392 565.612 461.708 563.936 459.637 563.936Z"
            fill="white"
          />
          <path
            d="M452.154 556.762C450.07 556.762 448.377 558.459 448.377 560.539C448.377 562.618 450.074 564.328 452.154 564.328C454.233 564.328 455.944 562.631 455.944 560.539C455.944 558.446 454.246 556.762 452.154 556.762Z"
            fill="white"
          />
          <path
            d="M445.203 547.363C443.09 547.363 441.371 549.082 441.371 551.195C441.371 553.309 443.09 555.023 445.203 555.023C447.317 555.023 449.031 553.317 449.031 551.195C449.031 549.073 447.312 547.363 445.203 547.363Z"
            fill="white"
          />
          <path
            d="M438.863 535.531C436.741 535.531 435.014 537.258 435.014 539.393C435.014 541.528 436.741 543.242 438.863 543.242C440.985 543.242 442.725 541.515 442.725 539.393C442.725 537.271 440.997 535.531 438.863 535.531Z"
            fill="white"
          />
          <path
            d="M433.181 521.086C431.038 521.086 429.311 522.826 429.311 524.969C429.311 527.112 431.038 528.839 433.181 528.839C435.324 528.839 437.064 527.099 437.064 524.969C437.064 522.839 435.328 521.086 433.181 521.086Z"
            fill="white"
          />
          <path
            d="M428.113 503.963C425.957 503.963 424.209 505.711 424.209 507.867C424.209 510.023 425.957 511.78 428.113 511.78C430.269 511.78 432.026 510.031 432.026 507.867C432.026 505.703 430.278 503.963 428.113 503.963Z"
            fill="white"
          />
          <path
            d="M423.479 484.5C421.293 484.5 419.536 486.27 419.536 488.455C419.536 490.641 421.293 492.398 423.479 492.398C425.664 492.398 427.421 490.628 427.421 488.455C427.421 486.282 425.651 484.5 423.479 484.5Z"
            fill="white"
          />
          <path
            d="M418.965 463.592C416.779 463.592 415.001 465.37 415.001 467.555C415.001 469.741 416.779 471.519 418.965 471.519C421.15 471.519 422.92 469.741 422.92 467.555C422.92 465.37 421.15 463.592 418.965 463.592Z"
            fill="white"
          />
          <path
            d="M414.186 442.641C411.992 442.641 410.201 444.431 410.201 446.626C410.201 448.82 411.992 450.623 414.186 450.623C416.38 450.623 418.184 448.832 418.184 446.626C418.184 444.419 416.393 442.641 414.186 442.641Z"
            fill="white"
          />
          <path
            d="M408.932 423.105C406.717 423.105 404.926 424.896 404.926 427.112C404.926 429.327 406.717 431.109 408.932 431.109C411.147 431.109 412.93 429.318 412.93 427.112C412.93 424.905 411.139 423.105 408.932 423.105Z"
            fill="white"
          />
          <path
            d="M403.164 405.4C400.936 405.4 399.137 407.2 399.137 409.428C399.137 411.656 400.936 413.468 403.164 413.468C405.392 413.468 407.191 411.656 407.191 409.428C407.191 407.2 405.392 405.4 403.164 405.4Z"
            fill="white"
          />
          <path
            d="M397.088 388.068C394.851 388.068 393.039 389.868 393.039 392.108C393.039 394.349 394.851 396.148 397.088 396.148C399.324 396.148 401.128 394.336 401.128 392.108C401.128 389.88 399.316 388.068 397.088 388.068Z"
            fill="white"
          />
          <path
            d="M390.696 370.785C388.46 370.785 386.635 372.606 386.635 374.842C386.635 377.079 388.455 378.891 390.696 378.891C392.937 378.891 394.745 377.079 394.745 374.842C394.745 372.606 392.932 370.785 390.696 370.785Z"
            fill="white"
          />
          <path
            d="M383.898 354.684C381.662 354.684 379.85 356.496 379.85 358.732C379.85 360.969 381.662 362.789 383.898 362.789C386.135 362.789 387.955 360.977 387.955 358.732C387.955 356.487 386.143 354.684 383.898 354.684Z"
            fill="white"
          />
          <path
            d="M376.675 340.289C374.439 340.289 372.618 342.11 372.618 344.346C372.618 346.583 374.439 348.416 376.675 348.416C378.912 348.416 380.745 346.595 380.745 344.346C380.745 342.097 378.924 340.289 376.675 340.289Z"
            fill="white"
          />
          <path
            d="M369.057 327.766C366.808 327.766 364.979 329.586 364.979 331.835C364.979 334.085 366.812 335.914 369.057 335.914C371.302 335.914 373.127 334.08 373.127 331.835C373.127 329.59 371.306 327.766 369.057 327.766Z"
            fill="white"
          />
          <path
            d="M361.097 317.002C358.839 317.002 357.006 318.823 357.006 321.08C357.006 323.338 358.839 325.171 361.097 325.171C363.355 325.171 365.175 323.338 365.175 321.08C365.175 318.823 363.342 317.002 361.097 317.002Z"
            fill="white"
          />
          <path
            d="M352.791 307.994C350.534 307.994 348.7 309.827 348.7 312.085C348.7 314.343 350.534 316.163 352.791 316.163C355.049 316.163 356.869 314.33 356.869 312.085C356.869 309.84 355.036 307.994 352.791 307.994Z"
            fill="white"
          />
          <path
            d="M344.223 300.334C341.965 300.334 340.132 302.167 340.132 304.425C340.132 306.683 341.965 308.503 344.223 308.503C346.48 308.503 348.301 306.67 348.301 304.425C348.301 302.18 346.468 300.334 344.223 300.334Z"
            fill="white"
          />
          <path
            d="M335.482 293.586C333.224 293.586 331.403 295.419 331.403 297.677C331.403 299.935 333.224 301.755 335.482 301.755C337.739 301.755 339.56 299.922 339.56 297.677C339.56 295.432 337.739 293.586 335.482 293.586Z"
            fill="white"
          />
          <path
            d="M326.666 287.488C324.417 287.488 322.588 289.309 322.588 291.567C322.588 293.824 324.421 295.645 326.666 295.645C328.911 295.645 330.757 293.811 330.757 291.567C330.757 289.322 328.924 287.488 326.666 287.488Z"
            fill="white"
          />
          <path
            d="M317.891 281.797C315.633 281.797 313.812 283.63 313.812 285.875C313.812 288.12 315.633 289.953 317.891 289.953C320.148 289.953 321.969 288.133 321.969 285.875C321.969 283.617 320.136 281.797 317.891 281.797Z"
            fill="white"
          />
          <path
            d="M324.813 270.857C322.555 270.857 320.734 272.678 320.734 274.936C320.734 277.193 322.555 279.005 324.813 279.005C327.07 279.005 328.882 277.185 328.882 274.936C328.882 272.686 327.062 270.857 324.813 270.857Z"
            fill="white"
          />
          <path
            d="M331.653 260.805C329.404 260.805 327.583 262.625 327.583 264.874C327.583 267.124 329.404 268.931 331.653 268.931C333.902 268.931 335.71 267.111 335.71 264.874C335.71 262.638 333.889 260.805 331.653 260.805Z"
            fill="white"
          />
          <path
            d="M338.312 251.467C336.076 251.467 334.264 253.279 334.264 255.515C334.264 257.752 336.076 259.564 338.312 259.564C340.549 259.564 342.361 257.752 342.361 255.515C342.361 253.279 340.549 251.467 338.312 251.467Z"
            fill="white"
          />
          <path
            d="M344.733 242.631C342.497 242.631 340.685 244.443 340.685 246.679C340.685 248.916 342.497 250.728 344.733 250.728C346.97 250.728 348.782 248.916 348.782 246.679C348.782 244.443 346.97 242.631 344.733 242.631Z"
            fill="white"
          />
          <path
            d="M350.856 234.223C348.641 234.223 346.837 236.022 346.837 238.25C346.837 240.478 348.636 242.269 350.856 242.269C353.075 242.269 354.883 240.469 354.883 238.25C354.883 236.03 353.084 234.223 350.856 234.223Z"
            fill="white"
          />
          <path
            d="M356.67 226.197C354.455 226.197 352.664 227.988 352.664 230.203C352.664 232.419 354.455 234.209 356.67 234.209C358.885 234.209 360.676 232.41 360.676 230.203C360.676 227.997 358.877 226.197 356.67 226.197Z"
            fill="white"
          />
          <path
            d="M362.187 218.736C359.98 218.736 358.189 220.514 358.189 222.721C358.189 224.928 359.98 226.719 362.187 226.719C364.394 226.719 366.172 224.928 366.172 222.721C366.172 220.514 364.394 218.736 362.187 218.736Z"
            fill="white"
          />
          <path
            d="M367.351 212.137C365.144 212.137 363.366 213.928 363.366 216.122C363.366 218.316 365.144 220.098 367.351 220.098C369.558 220.098 371.327 218.32 371.327 216.122C371.327 213.923 369.549 212.137 367.351 212.137Z"
            fill="white"
          />
          <path
            d="M372.075 206.434C369.898 206.434 368.133 208.195 368.133 210.38C368.133 212.566 369.902 214.323 372.075 214.323C374.248 214.323 376.022 212.553 376.022 210.38C376.022 208.207 374.252 206.434 372.075 206.434Z"
            fill="white"
          />
          <path
            d="M376.31 201.438C374.146 201.438 372.385 203.199 372.385 205.363C372.385 207.527 374.142 209.297 376.31 209.297C378.479 209.297 380.244 207.54 380.244 205.363C380.244 203.186 378.487 201.438 376.31 201.438Z"
            fill="white"
          />
          <path
            d="M380.035 197.045C377.879 197.045 376.144 198.793 376.144 200.949C376.144 203.105 377.884 204.853 380.035 204.853C382.187 204.853 383.939 203.105 383.939 200.949C383.939 198.793 382.191 197.045 380.035 197.045Z"
            fill="white"
          />
          <path
            d="M383.266 193.09C381.123 193.09 379.383 194.83 379.383 196.96C379.383 199.091 381.123 200.843 383.266 200.843C385.409 200.843 387.136 199.103 387.136 196.96C387.136 194.817 385.396 193.09 383.266 193.09Z"
            fill="white"
          />
          <path
            d="M385.961 189.498C383.839 189.498 382.12 191.221 382.12 193.339C382.12 195.456 383.839 197.179 385.961 197.179C388.083 197.179 389.789 195.461 389.789 193.339C389.789 191.217 388.07 189.498 385.961 189.498Z"
            fill="white"
          />
          <path
            d="M388.124 186.219C386.024 186.219 384.313 187.925 384.313 190.03C384.313 192.135 386.019 193.841 388.124 193.841C390.229 193.841 391.935 192.135 391.935 190.03C391.935 187.925 390.229 186.219 388.124 186.219Z"
            fill="white"
          />
          <path
            d="M389.809 183.174C387.717 183.174 386.032 184.859 386.032 186.951C386.032 189.043 387.717 190.728 389.809 190.728C391.901 190.728 393.586 189.03 393.586 186.951C393.586 184.871 391.889 183.174 389.809 183.174Z"
            fill="white"
          />
          <path
            d="M391.062 180.262C388.991 180.262 387.314 181.942 387.314 184.013C387.314 186.084 388.991 187.76 391.062 187.76C393.133 187.76 394.809 186.084 394.809 184.013C394.809 181.942 393.133 180.262 391.062 180.262Z"
            fill="white"
          />
          <path
            d="M391.944 177.447C389.903 177.447 388.239 179.107 388.239 181.152C388.239 183.198 389.903 184.848 391.944 184.848C393.985 184.848 395.64 183.193 395.64 181.152C395.64 179.111 393.985 177.447 391.944 177.447Z"
            fill="white"
          />
          <path
            d="M392.539 174.629C390.519 174.629 388.885 176.267 388.885 178.287C388.885 180.307 390.519 181.941 392.539 181.941C394.559 181.941 396.193 180.307 396.193 178.287C396.193 176.267 394.559 174.629 392.539 174.629Z"
            fill="white"
          />
          <path
            d="M392.941 171.711C390.942 171.711 389.321 173.324 389.321 175.327C389.321 177.33 390.947 178.947 392.941 178.947C394.936 178.947 396.561 177.33 396.561 175.327C396.561 173.324 394.936 171.711 392.941 171.711Z"
            fill="white"
          />
          <path
            d="M393.298 168.557C391.312 168.557 389.699 170.169 389.699 172.147C389.699 174.124 391.312 175.741 393.298 175.741C395.284 175.741 396.888 174.133 396.888 172.147C396.888 170.161 395.276 168.557 393.298 168.557Z"
            fill="white"
          />
          <path
            d="M393.798 165.053C391.85 165.053 390.28 166.636 390.28 168.579C390.28 170.523 391.85 172.106 393.798 172.106C395.746 172.106 397.325 170.523 397.325 168.579C397.325 166.636 395.742 165.053 393.798 165.053Z"
            fill="white"
          />
          <path
            d="M406.505 161.73C404.549 161.73 402.966 163.313 402.966 165.257C402.966 167.201 404.549 168.796 406.505 168.796C408.461 168.796 410.032 167.213 410.032 165.257C410.032 163.301 408.449 161.73 406.505 161.73Z"
            fill="white"
          />
          <path
            d="M419.609 157.838C417.661 157.838 416.091 159.417 416.091 161.356C416.091 163.295 417.661 164.887 419.609 164.887C421.557 164.887 423.127 163.304 423.127 161.356C423.127 159.408 421.557 157.838 419.609 157.838Z"
            fill="white"
          />
          <path
            d="M433.452 153.234C431.504 153.234 429.926 154.813 429.926 156.757C429.926 158.7 431.509 160.283 433.452 160.283C435.396 160.283 436.979 158.705 436.979 156.757C436.979 154.809 435.396 153.234 433.452 153.234Z"
            fill="white"
          />
          <path
            d="M448.208 148.137C446.252 148.137 444.682 149.72 444.682 151.663C444.682 153.607 446.252 155.198 448.208 155.198C450.165 155.198 451.735 153.615 451.735 151.663C451.735 149.711 450.152 148.137 448.208 148.137Z"
            fill="white"
          />
          <path
            d="M464.186 142.238C462.238 142.238 460.659 143.821 460.659 145.765C460.659 147.708 462.242 149.3 464.186 149.3C466.129 149.3 467.712 147.721 467.712 145.765C467.712 143.808 466.129 142.238 464.186 142.238Z"
            fill="white"
          />
          <path
            d="M481.755 135.189C479.799 135.189 478.216 136.772 478.216 138.729C478.216 140.685 479.799 142.268 481.755 142.268C483.711 142.268 485.294 140.681 485.294 138.729C485.294 136.777 483.711 135.189 481.755 135.189Z"
            fill="white"
          />
          <path
            d="M501.03 127.385C499.082 127.385 497.49 128.968 497.49 130.92C497.49 132.872 499.082 134.455 501.03 134.455C502.977 134.455 504.569 132.872 504.569 130.92C504.569 128.968 502.986 127.385 501.03 127.385Z"
            fill="white"
          />
          <path
            d="M522.167 118.4C520.211 118.4 518.628 119.983 518.628 121.94C518.628 123.896 520.211 125.487 522.167 125.487C524.124 125.487 525.715 123.896 525.715 121.94C525.715 119.983 524.124 118.4 522.167 118.4Z"
            fill="white"
          />
          <path
            d="M544.69 108.555C542.733 108.555 541.15 110.138 541.15 112.094C541.15 114.05 542.733 115.642 544.69 115.642C546.646 115.642 548.237 114.05 548.237 112.094C548.237 110.138 546.646 108.555 544.69 108.555Z"
            fill="white"
          />
          <path
            d="M568.09 97.7852C566.125 97.7852 564.542 99.3766 564.542 101.333C564.542 103.289 566.125 104.881 568.09 104.881C570.055 104.881 571.629 103.289 571.629 101.333C571.629 99.3766 570.046 97.7852 568.09 97.7852Z"
            fill="white"
          />
          <path
            d="M591.256 86.4297C589.287 86.4297 587.695 88.0211 587.695 89.9944C587.695 91.9678 589.287 93.5592 591.256 93.5592C593.225 93.5592 594.825 91.9678 594.825 89.9944C594.825 88.0211 593.221 86.4297 591.256 86.4297Z"
            fill="white"
          />
          <path
            d="M613.632 74.8359C611.668 74.8359 610.063 76.4401 610.063 78.4049C610.063 80.3698 611.668 81.9654 613.632 81.9654C615.597 81.9654 617.193 80.374 617.193 78.4049C617.193 76.4358 615.602 74.8359 613.632 74.8359Z"
            fill="white"
          />
          <path
            d="M634.687 63.0156C632.718 63.0156 631.118 64.6155 631.118 66.5804C631.118 68.5452 632.722 70.1494 634.687 70.1494C636.652 70.1494 638.256 68.558 638.256 66.5804C638.256 64.6028 636.652 63.0156 634.687 63.0156Z"
            fill="white"
          />
          <path
            d="M654.225 51.7617C652.248 51.7617 650.644 53.3659 650.644 55.335C650.644 57.3041 652.248 58.9082 654.225 58.9082C656.203 58.9082 657.794 57.3041 657.794 55.335C657.794 53.3659 656.19 51.7617 654.225 51.7617Z"
            fill="white"
          />
          <path
            d="M672.324 42.0391C670.346 42.0391 668.742 43.6432 668.742 45.6123C668.742 47.5814 670.346 49.1855 672.324 49.1855C674.302 49.1855 675.893 47.5814 675.893 45.6123C675.893 43.6432 674.302 42.0391 672.324 42.0391Z"
            fill="white"
          />
          <path
            d="M689.206 33.7676C687.229 33.7676 685.616 35.376 685.616 37.3535C685.616 39.3311 687.229 40.9353 689.206 40.9353C691.184 40.9353 692.788 39.3311 692.788 37.3535C692.788 35.376 691.184 33.7676 689.206 33.7676Z"
            fill="white"
          />
          <path
            d="M704.971 28.3516C702.994 28.3516 701.39 29.9599 701.39 31.9375C701.39 33.9151 702.994 35.5193 704.971 35.5193C706.949 35.5193 708.553 33.9151 708.553 31.9375C708.553 29.9599 706.949 28.3516 704.971 28.3516Z"
            fill="white"
          />
          <path
            d="M719.867 25.1562C717.889 25.1562 716.285 26.7604 716.285 28.7465C716.285 30.7325 717.889 32.3282 719.867 32.3282C721.844 32.3282 723.457 30.724 723.457 28.7465C723.457 26.7689 721.853 25.1562 719.867 25.1562Z"
            fill="white"
          />
          <path
            d="M734.041 23.6152C732.064 23.6152 730.451 25.2194 730.451 27.2054C730.451 29.1915 732.064 30.7957 734.041 30.7957C736.019 30.7957 737.644 29.183 737.644 27.2054C737.644 25.2279 736.032 23.6152 734.041 23.6152Z"
            fill="white"
          />
          <path
            d="M747.604 24.1895C745.618 24.1895 744.001 25.8021 744.001 27.7839C744.001 29.7657 745.614 31.3784 747.604 31.3784C749.594 31.3784 751.194 29.7657 751.194 27.7839C751.194 25.8021 749.59 24.1895 747.604 24.1895Z"
            fill="white"
          />
          <path
            d="M760.696 26.3691C758.705 26.3691 757.093 27.9775 757.093 29.9636C757.093 31.9497 758.705 33.5665 760.696 33.5665C762.686 33.5665 764.286 31.9539 764.286 29.9636C764.286 27.9733 762.673 26.3691 760.696 26.3691Z"
            fill="white"
          />
          <path
            d="M766.922 40.6074C764.894 40.6074 763.26 42.2455 763.26 44.2655C763.26 46.2856 764.894 47.9279 766.922 47.9279C768.951 47.9279 770.576 46.2813 770.576 44.2655C770.576 42.2498 768.942 40.6074 766.922 40.6074Z"
            fill="white"
          />
          <path
            d="M772.812 56.2168C770.763 56.2168 769.095 57.8719 769.095 59.9216C769.095 61.9713 770.758 63.6264 772.812 63.6264C774.866 63.6264 776.517 61.9628 776.517 59.9216C776.517 57.8803 774.853 56.2168 772.812 56.2168Z"
            fill="white"
          />
          <path
            d="M778.41 73.0645C776.339 73.0645 774.663 74.7407 774.663 76.799C774.663 78.8572 776.339 80.5462 778.41 80.5462C780.481 80.5462 782.145 78.8699 782.145 76.799C782.145 74.728 780.469 73.0645 778.41 73.0645Z"
            fill="white"
          />
          <path
            d="M783.821 90.7617C781.729 90.7617 780.031 92.4592 780.031 94.5514C780.031 96.6436 781.729 98.3411 783.821 98.3411C785.913 98.3411 787.611 96.6436 787.611 94.5514C787.611 92.4592 785.913 90.7617 783.821 90.7617Z"
            fill="white"
          />
          <path
            d="M789.193 108.338C787.071 108.338 785.353 110.057 785.353 112.17C785.353 114.283 787.071 116.011 789.193 116.011C791.315 116.011 793.025 114.292 793.025 112.17C793.025 110.048 791.307 108.338 789.193 108.338Z"
            fill="white"
          />
          <path
            d="M794.667 125.195C792.533 125.195 790.797 126.927 790.797 129.061C790.797 131.196 792.537 132.932 794.667 132.932C796.798 132.932 798.538 131.2 798.538 129.061C798.538 126.923 796.798 125.195 794.667 125.195Z"
            fill="white"
          />
          <path
            d="M800.342 141.041C798.186 141.041 796.438 142.789 796.438 144.945C796.438 147.101 798.186 148.85 800.342 148.85C802.498 148.85 804.246 147.101 804.246 144.945C804.246 142.789 802.498 141.041 800.342 141.041Z"
            fill="white"
          />
          <path
            d="M806.261 155.809C804.084 155.809 802.336 157.561 802.336 159.734C802.336 161.907 804.084 163.651 806.261 163.651C808.438 163.651 810.174 161.898 810.174 159.734C810.174 157.57 808.426 155.809 806.261 155.809Z"
            fill="white"
          />
          <path
            d="M812.432 169.482C810.247 169.482 808.469 171.261 808.469 173.455C808.469 175.649 810.247 177.427 812.432 177.427C814.618 177.427 816.409 175.649 816.409 173.455C816.409 171.261 814.631 169.482 812.432 169.482Z"
            fill="white"
          />
          <path
            d="M818.878 190.237C821.086 190.237 822.876 188.448 822.876 186.24C822.876 184.032 821.086 182.242 818.878 182.242C816.671 182.242 814.881 184.032 814.881 186.24C814.881 188.448 816.671 190.237 818.878 190.237Z"
            fill="white"
          />
          <path
            d="M825.572 194.152C823.356 194.152 821.553 195.952 821.553 198.171C821.553 200.391 823.352 202.19 825.572 202.19C827.791 202.19 829.59 200.391 829.59 198.171C829.59 195.952 827.791 194.152 825.572 194.152Z"
            fill="white"
          />
          <path
            d="M832.5 205.223C830.272 205.223 828.46 207.022 828.46 209.25C828.46 211.478 830.272 213.29 832.5 213.29C834.728 213.29 836.527 211.478 836.527 209.25C836.527 207.022 834.728 205.223 832.5 205.223Z"
            fill="white"
          />
          <path
            d="M839.63 215.434C837.381 215.434 835.561 217.254 835.561 219.503C835.561 221.753 837.381 223.573 839.63 223.573C841.879 223.573 843.709 221.753 843.709 219.503C843.709 217.254 841.875 215.434 839.63 215.434Z"
            fill="white"
          />
          <path
            d="M846.967 224.896C844.718 224.896 842.889 226.73 842.889 228.987C842.889 231.245 844.722 233.066 846.967 233.066C849.212 233.066 851.045 231.232 851.045 228.987C851.045 226.743 849.225 224.896 846.967 224.896Z"
            fill="white"
          />
          <path
            d="M854.483 233.668C852.213 233.668 850.371 235.51 850.371 237.78C850.371 240.051 852.213 241.892 854.483 241.892C856.754 241.892 858.595 240.051 858.595 237.78C858.595 235.51 856.754 233.668 854.483 233.668Z"
            fill="white"
          />
          <path
            d="M862.165 241.85C859.886 241.85 858.031 243.704 858.031 245.983C858.031 248.262 859.882 250.116 862.165 250.116C864.448 250.116 866.285 248.262 866.285 245.983C866.285 243.704 864.444 241.85 862.165 241.85Z"
            fill="white"
          />
          <path
            d="M870.02 249.469C867.728 249.469 865.865 251.332 865.865 253.623C865.865 255.915 867.728 257.765 870.02 257.765C872.312 257.765 874.162 255.915 874.162 253.623C874.162 251.332 872.312 249.469 870.02 249.469Z"
            fill="white"
          />
          <path
            d="M878.079 256.557C875.788 256.557 873.925 258.42 873.925 260.711C873.925 263.003 875.788 264.866 878.079 264.866C880.371 264.866 882.221 263.003 882.221 260.711C882.221 258.42 880.371 256.557 878.079 256.557Z"
            fill="white"
          />
          <path
            d="M886.328 263.111C884.037 263.111 882.174 264.974 882.174 267.262C882.174 269.549 884.037 271.416 886.328 271.416C888.62 271.416 890.483 269.566 890.483 267.262C890.483 264.957 888.62 263.111 886.328 263.111Z"
            fill="white"
          />
          <path
            d="M894.803 269.117C892.511 269.117 890.648 270.98 890.648 273.272C890.648 275.563 892.511 277.426 894.803 277.426C897.095 277.426 898.958 275.563 898.958 273.272C898.958 270.98 897.103 269.117 894.803 269.117Z"
            fill="white"
          />
          <path
            d="M903.481 274.553C901.189 274.553 899.326 276.416 899.326 278.707C899.326 280.999 901.189 282.862 903.481 282.862C905.772 282.862 907.635 281.012 907.635 278.707C907.635 276.403 905.781 274.553 903.481 274.553Z"
            fill="white"
          />
          <path
            d="M898.173 277.902C895.873 277.902 894.019 279.757 894.019 282.057C894.019 284.357 895.869 286.212 898.173 286.212C900.478 286.212 902.328 284.349 902.328 282.057C902.328 279.765 900.465 277.902 898.173 277.902Z"
            fill="white"
          />
          <path
            d="M892.826 281.326C890.534 281.326 888.671 283.189 888.671 285.481C888.671 287.772 890.534 289.635 892.826 289.635C895.117 289.635 896.98 287.785 896.98 285.481C896.98 283.176 895.117 281.326 892.826 281.326Z"
            fill="white"
          />
          <path
            d="M887.432 284.896C885.14 284.896 883.277 286.751 883.277 289.051C883.277 291.351 885.14 293.206 887.432 293.206C889.724 293.206 891.587 291.343 891.587 289.051C891.587 286.759 889.732 284.896 887.432 284.896Z"
            fill="white"
          />
          <path
            d="M881.992 288.664C879.7 288.664 877.837 290.527 877.837 292.827C877.837 295.127 879.7 296.982 881.992 296.982C884.283 296.982 886.146 295.119 886.146 292.827C886.146 290.536 884.283 288.664 881.992 288.664Z"
            fill="white"
          />
          <path
            d="M876.453 292.711C874.162 292.711 872.299 294.574 872.299 296.866C872.299 299.157 874.162 301.02 876.453 301.02C878.745 301.02 880.608 299.17 880.608 296.866C880.608 294.561 878.758 292.711 876.453 292.711Z"
            fill="white"
          />
          <path
            d="M870.8 297.074C868.5 297.074 866.646 298.937 866.646 301.229C866.646 303.52 868.496 305.383 870.8 305.383C873.104 305.383 874.955 303.529 874.955 301.229C874.955 298.929 873.092 297.074 870.8 297.074Z"
            fill="white"
          />
          <path
            d="M864.973 301.811C862.681 301.811 860.818 303.674 860.818 305.965C860.818 308.257 862.681 310.12 864.973 310.12C867.265 310.12 869.128 308.257 869.128 305.965C869.128 303.674 867.265 301.811 864.973 301.811Z"
            fill="white"
          />
          <path
            d="M858.926 306.963C856.647 306.963 854.793 308.813 854.793 311.096C854.793 313.379 856.643 315.23 858.926 315.23C861.21 315.23 863.068 313.379 863.068 311.096C863.068 308.813 861.214 306.963 858.926 306.963Z"
            fill="white"
          />
          <path
            d="M852.642 312.518C850.363 312.518 848.521 314.372 848.521 316.638C848.521 318.904 850.363 320.772 852.642 320.772C854.921 320.772 856.763 318.917 856.763 316.638C856.763 314.359 854.921 312.518 852.642 312.518Z"
            fill="white"
          />
          <path
            d="M846.071 318.506C843.801 318.506 841.959 320.348 841.959 322.618C841.959 324.888 843.801 326.718 846.071 326.718C848.342 326.718 850.171 324.884 850.171 322.618C850.171 320.352 848.329 318.506 846.071 318.506Z"
            fill="white"
          />
          <path
            d="M839.222 324.896C836.951 324.896 835.122 326.73 835.122 328.987C835.122 331.245 836.955 333.078 839.222 333.078C841.488 333.078 843.312 331.245 843.312 328.987C843.312 326.73 841.479 324.896 839.222 324.896Z"
            fill="white"
          />
          <path
            d="M832.127 331.627C829.878 331.627 828.058 333.448 828.058 335.697C828.058 337.946 829.878 339.766 832.127 339.766C834.377 339.766 836.197 337.946 836.197 335.697C836.197 333.448 834.377 331.627 832.127 331.627Z"
            fill="white"
          />
          <path
            d="M824.842 338.592C822.605 338.592 820.793 340.404 820.793 342.64C820.793 344.877 822.605 346.689 824.842 346.689C827.078 346.689 828.89 344.877 828.89 342.64C828.89 340.404 827.078 338.592 824.842 338.592Z"
            fill="white"
          />
          <path
            d="M817.439 345.621C815.212 345.621 813.399 347.433 813.399 349.661C813.399 351.889 815.212 353.688 817.439 353.688C819.667 353.688 821.467 351.889 821.467 349.661C821.467 347.433 819.667 345.621 817.439 345.621Z"
            fill="white"
          />
          <path
            d="M809.988 352.537C807.781 352.537 805.981 354.328 805.981 356.543C805.981 358.758 807.781 360.549 809.988 360.549C812.194 360.549 813.994 358.75 813.994 356.543C813.994 354.336 812.203 352.537 809.988 352.537Z"
            fill="white"
          />
          <path
            d="M802.556 359.148C800.362 359.148 798.571 360.927 798.571 363.125C798.571 365.323 800.362 367.101 802.556 367.101C804.75 367.101 806.533 365.323 806.533 363.125C806.533 360.927 804.754 359.148 802.556 359.148Z"
            fill="white"
          />
          <path
            d="M795.134 365.424C792.957 365.424 791.191 367.181 791.191 369.358C791.191 371.535 792.961 373.3 795.134 373.3C797.307 373.3 799.081 371.539 799.081 369.358C799.081 367.176 797.311 365.424 795.134 365.424Z"
            fill="white"
          />
          <path
            d="M787.567 372.084C785.403 372.084 783.654 373.832 783.654 375.997C783.654 378.161 785.403 379.909 787.567 379.909C789.731 379.909 791.48 378.148 791.48 375.997C791.48 373.845 789.723 372.084 787.567 372.084Z"
            fill="white"
          />
          <path
            d="M779.657 379.648C777.514 379.648 775.774 381.388 775.774 383.54C775.774 385.692 777.514 387.423 779.657 387.423C781.8 387.423 783.54 385.683 783.54 383.54C783.54 381.397 781.8 379.648 779.657 379.648Z"
            fill="white"
          />
          <path
            d="M771.374 388.225C769.252 388.225 767.524 389.952 767.524 392.074C767.524 394.196 769.252 395.923 771.374 395.923C773.495 395.923 775.223 394.204 775.223 392.074C775.223 389.943 773.495 388.225 771.374 388.225Z"
            fill="white"
          />
          <path
            d="M767.877 400.537C765.784 400.537 764.1 402.222 764.1 404.314C764.1 406.406 765.784 408.091 767.877 408.091C769.969 408.091 771.653 406.393 771.653 404.314C771.653 402.235 769.956 400.537 767.877 400.537Z"
            fill="white"
          />
          <path
            d="M753.64 408.482C751.56 408.482 749.871 410.167 749.871 412.259C749.871 414.352 751.556 416.028 753.64 416.028C755.723 416.028 757.416 414.343 757.416 412.259C757.416 410.176 755.719 408.482 753.64 408.482Z"
            fill="white"
          />
          <path
            d="M739.121 416.869C737.042 416.869 735.353 418.567 735.353 420.646C735.353 422.726 737.037 424.415 739.121 424.415C741.205 424.415 742.898 422.73 742.898 420.646C742.898 418.562 741.2 416.869 739.121 416.869Z"
            fill="white"
          />
          <path
            d="M724.395 425.895C722.312 425.895 720.627 427.579 720.627 429.663C720.627 431.747 722.312 433.419 724.395 433.419C726.479 433.419 728.151 431.734 728.151 429.663C728.151 427.592 726.466 425.895 724.395 425.895Z"
            fill="white"
          />
          <path
            d="M709.449 435.533C707.378 435.533 705.693 437.218 705.693 439.302C705.693 441.385 707.378 443.07 709.449 443.07C711.52 443.07 713.218 441.385 713.218 439.302C713.218 437.218 711.533 435.533 709.449 435.533Z"
            fill="white"
          />
          <path
            d="M694.324 445.562C692.253 445.562 690.568 447.247 690.568 449.318C690.568 451.389 692.253 453.074 694.324 453.074C696.395 453.074 698.093 451.398 698.093 449.318C698.093 447.239 696.408 445.562 694.324 445.562Z"
            fill="white"
          />
          <path
            d="M679.132 455.879C677.052 455.879 675.376 457.564 675.376 459.635C675.376 461.706 677.052 463.39 679.132 463.39C681.211 463.39 682.887 461.706 682.887 459.635C682.887 457.564 681.203 455.879 679.132 455.879Z"
            fill="white"
          />
          <path
            d="M663.883 466.234C661.812 466.234 660.127 467.919 660.127 469.99C660.127 472.061 661.812 473.746 663.883 473.746C665.954 473.746 667.638 472.07 667.638 469.99C667.638 467.911 665.962 466.234 663.883 466.234Z"
            fill="white"
          />
          <path
            d="M648.615 476.16C646.544 476.16 644.868 477.845 644.868 479.916C644.868 481.987 646.544 483.672 648.615 483.672C650.686 483.672 652.371 481.987 652.371 479.916C652.371 477.845 650.686 476.16 648.615 476.16Z"
            fill="white"
          />
          <path
            d="M633.503 485.57C631.432 485.57 629.747 487.247 629.747 489.318C629.747 491.389 631.432 493.073 633.503 493.073C635.574 493.073 637.25 491.389 637.25 489.318C637.25 487.247 635.574 485.57 633.503 485.57Z"
            fill="white"
          />
          <path
            d="M618.62 494.346C616.549 494.346 614.873 496.022 614.873 498.093C614.873 500.164 616.549 501.84 618.62 501.84C620.691 501.84 622.368 500.164 622.368 498.093C622.368 496.022 620.691 494.346 618.62 494.346Z"
            fill="white"
          />
          <path
            d="M603.975 502.275C601.904 502.275 600.228 503.96 600.228 506.031C600.228 508.102 601.904 509.778 603.975 509.778C606.046 509.778 607.722 508.094 607.722 506.031C607.722 503.969 606.046 502.275 603.975 502.275Z"
            fill="white"
          />
          <path
            d="M589.609 509.736C587.539 509.736 585.875 511.413 585.875 513.471C585.875 515.529 587.539 517.218 589.609 517.218C591.68 517.218 593.344 515.542 593.344 513.471C593.344 511.4 591.668 509.736 589.609 509.736Z"
            fill="white"
          />
          <path
            d="M575.52 517.053C573.457 517.053 571.785 518.729 571.785 520.8C571.785 522.871 573.461 524.534 575.52 524.534C577.578 524.534 579.267 522.858 579.267 520.8C579.267 518.742 577.591 517.053 575.52 517.053Z"
            fill="white"
          />
          <path
            d="M561.677 531.772C563.739 531.772 565.411 530.1 565.411 528.037C565.411 525.975 563.739 524.303 561.677 524.303C559.614 524.303 557.942 525.975 557.942 528.037C557.942 530.1 559.614 531.772 561.677 531.772Z"
            fill="white"
          />
          <path
            d="M548.055 531.346C545.992 531.346 544.32 533.009 544.32 535.08C544.32 537.151 545.997 538.806 548.055 538.806C550.113 538.806 551.789 537.143 551.789 535.08C551.789 533.018 550.113 531.346 548.055 531.346Z"
            fill="white"
          />
          <path
            d="M534.555 538.256C532.492 538.256 530.82 539.919 530.82 541.982C530.82 544.044 532.497 545.708 534.555 545.708C536.613 545.708 538.281 544.044 538.281 541.982C538.281 539.919 536.605 538.256 534.555 538.256Z"
            fill="white"
          />
          <path
            d="M521.137 545.084C519.074 545.084 517.402 546.748 517.402 548.81C517.402 550.872 519.079 552.536 521.137 552.536C523.195 552.536 524.863 550.872 524.863 548.81C524.863 546.748 523.187 545.084 521.137 545.084Z"
            fill="white"
          />
          <path
            d="M507.786 551.662C505.724 551.662 504.052 553.326 504.052 555.388C504.052 557.451 505.728 559.114 507.786 559.114C509.844 559.114 511.512 557.451 511.512 555.388C511.512 553.326 509.836 551.662 507.786 551.662Z"
            fill="white"
          />
          <path
            d="M494.41 557.939C492.347 557.939 490.684 559.603 490.684 561.657C490.684 563.711 492.347 565.383 494.41 565.383C496.472 565.383 498.123 563.719 498.123 561.657C498.123 559.595 496.459 557.939 494.41 557.939Z"
            fill="white"
          />
          <path
            d="M480.982 563.852C478.919 563.852 477.256 565.515 477.256 567.578C477.256 569.64 478.919 571.304 480.982 571.304C483.044 571.304 484.708 569.627 484.708 567.578C484.708 565.528 483.044 563.852 480.982 563.852Z"
            fill="white"
          />
          <path
            d="M467.496 569.293C465.433 569.293 463.77 570.969 463.77 573.019C463.77 575.069 465.433 576.753 467.496 576.753C469.558 576.753 471.222 575.077 471.222 573.019C471.222 570.961 469.558 569.293 467.496 569.293Z"
            fill="white"
          />
          <path
            d="M453.924 574.09C451.862 574.09 450.198 575.753 450.198 577.816C450.198 579.878 451.862 581.542 453.924 581.542C455.987 581.542 457.65 579.866 457.65 577.816C457.65 575.766 455.987 574.09 453.924 574.09Z"
            fill="white"
          />
          <path
            d="M445.827 568.803C443.743 568.803 442.059 570.479 442.059 572.558C442.059 574.638 443.743 576.314 445.827 576.314C447.911 576.314 449.583 574.629 449.583 572.558C449.583 570.488 447.898 568.803 445.827 568.803Z"
            fill="white"
          />
          <path
            d="M438.052 561.871C435.973 561.871 434.275 563.556 434.275 565.648C434.275 567.74 435.973 569.438 438.052 569.438C440.132 569.438 441.842 567.74 441.842 565.648C441.842 563.556 440.144 561.871 438.052 561.871Z"
            fill="white"
          />
          <path
            d="M430.754 552.949C428.64 552.949 426.926 554.655 426.926 556.777C426.926 558.899 428.645 560.609 430.754 560.609C432.863 560.609 434.586 558.89 434.586 556.777C434.586 554.664 432.88 552.949 430.754 552.949Z"
            fill="white"
          />
          <path
            d="M424.052 541.742C421.93 541.742 420.203 543.469 420.203 545.604C420.203 547.739 421.93 549.453 424.052 549.453C426.174 549.453 427.914 547.726 427.914 545.604C427.914 543.482 426.187 541.742 424.052 541.742Z"
            fill="white"
          />
          <path
            d="M418.039 527.984C415.896 527.984 414.156 529.733 414.156 531.876C414.156 534.019 415.896 535.759 418.039 535.759C420.182 535.759 421.922 534.019 421.922 531.876C421.922 529.733 420.187 527.984 418.039 527.984Z"
            fill="white"
          />
          <path
            d="M412.709 511.6C410.553 511.6 408.805 513.34 408.805 515.491C408.805 517.643 410.553 519.395 412.709 519.395C414.865 519.395 416.6 517.647 416.6 515.491C416.6 513.335 414.861 511.6 412.709 511.6Z"
            fill="white"
          />
          <path
            d="M407.909 492.797C405.724 492.797 403.954 494.558 403.954 496.739C403.954 498.921 405.724 500.686 407.909 500.686C410.095 500.686 411.856 498.916 411.856 496.739C411.856 494.562 410.086 492.797 407.909 492.797Z"
            fill="white"
          />
          <path
            d="M403.382 472.227C401.196 472.227 399.418 474.005 399.418 476.19C399.418 478.376 401.196 480.145 403.382 480.145C405.567 480.145 407.337 478.376 407.337 476.19C407.337 474.005 405.567 472.227 403.382 472.227Z"
            fill="white"
          />
          <path
            d="M398.751 451.068C396.544 451.068 394.766 452.859 394.766 455.053C394.766 457.247 396.544 459.051 398.751 459.051C400.957 459.051 402.735 457.26 402.735 455.053C402.735 452.846 400.945 451.068 398.751 451.068Z"
            fill="white"
          />
          <path
            d="M393.628 431.033C391.422 431.033 389.631 432.824 389.631 435.031C389.631 437.238 391.422 439.037 393.628 439.037C395.835 439.037 397.635 437.246 397.635 435.031C397.635 432.816 395.844 431.033 393.628 431.033Z"
            fill="white"
          />
          <path
            d="M387.918 412.977C385.69 412.977 383.878 414.776 383.878 417.004C383.878 419.232 385.69 421.031 387.918 421.031C390.146 421.031 391.945 419.232 391.945 417.004C391.945 414.776 390.146 412.977 387.918 412.977Z"
            fill="white"
          />
          <path
            d="M381.755 396.094C379.527 396.094 377.715 397.906 377.715 400.142C377.715 402.379 379.527 404.182 381.755 404.182C383.983 404.182 385.795 402.37 385.795 400.142C385.795 397.914 383.996 396.094 381.755 396.094Z"
            fill="white"
          />
          <path
            d="M375.304 379.254C373.068 379.254 371.256 381.066 371.256 383.302C371.256 385.539 373.068 387.351 375.304 387.351C377.541 387.351 379.353 385.539 379.353 383.302C379.353 381.066 377.541 379.254 375.304 379.254Z"
            fill="white"
          />
          <path
            d="M368.476 363.277C366.227 363.277 364.406 365.098 364.406 367.334C364.406 369.571 366.227 371.404 368.476 371.404C370.725 371.404 372.546 369.584 372.546 367.334C372.546 365.085 370.725 363.277 368.476 363.277Z"
            fill="white"
          />
          <path
            d="M361.232 348.793C358.974 348.793 357.153 350.614 357.153 352.863C357.153 355.112 358.974 356.941 361.232 356.941C363.489 356.941 365.301 355.108 365.301 352.863C365.301 350.618 363.481 348.793 361.232 348.793Z"
            fill="white"
          />
          <path
            d="M353.517 336.248C351.268 336.248 349.447 338.081 349.447 340.326C349.447 342.571 351.268 344.396 353.517 344.396C355.766 344.396 357.595 342.575 357.595 340.326C357.595 338.077 355.762 336.248 353.517 336.248Z"
            fill="white"
          />
          <path
            d="M345.412 325.531C343.155 325.531 341.334 327.365 341.334 329.609C341.334 331.854 343.155 333.7 345.412 333.7C347.67 333.7 349.49 331.867 349.49 329.609C349.49 327.352 347.67 325.531 345.412 325.531Z"
            fill="white"
          />
          <path
            d="M336.992 316.266C334.735 316.266 332.901 318.086 332.901 320.344C332.901 322.602 334.735 324.422 336.992 324.422C339.25 324.422 341.071 322.602 341.071 320.344C341.071 318.086 339.237 316.266 336.992 316.266Z"
            fill="white"
          />
          <path
            d="M328.353 308.086C326.103 308.086 324.274 309.907 324.274 312.164C324.274 314.422 326.108 316.242 328.353 316.242C330.598 316.242 332.444 314.422 332.444 312.164C332.444 309.907 330.61 308.086 328.353 308.086Z"
            fill="white"
          />
          <path
            d="M319.63 300.695C317.372 300.695 315.539 302.529 315.539 304.795C315.539 307.061 317.372 308.886 319.63 308.886C321.888 308.886 323.721 307.052 323.721 304.795C323.721 302.537 321.888 300.695 319.63 300.695Z"
            fill="white"
          />
          <path
            d="M310.888 293.943C308.63 293.943 306.797 295.777 306.797 298.043C306.797 300.309 308.63 302.134 310.888 302.134C313.146 302.134 314.979 300.3 314.979 298.043C314.979 295.785 313.146 293.943 310.888 293.943Z"
            fill="white"
          />
          <path
            d="M302.155 287.77C299.898 287.77 298.064 289.59 298.064 291.848C298.064 294.105 299.898 295.939 302.155 295.939C304.413 295.939 306.234 294.105 306.234 291.848C306.234 289.59 304.413 287.77 302.155 287.77Z"
            fill="white"
          />
          <path
            d="M309.182 276.426C306.933 276.426 305.112 278.246 305.112 280.496C305.112 282.745 306.933 284.574 309.182 284.574C311.431 284.574 313.26 282.753 313.26 280.496C313.26 278.238 311.44 276.426 309.182 276.426Z"
            fill="white"
          />
          <path
            d="M316.113 266.184C313.864 266.184 312.052 268.004 312.052 270.253C312.052 272.503 313.864 274.31 316.113 274.31C318.362 274.31 320.183 272.498 320.183 270.253C320.183 268.008 318.362 266.184 316.113 266.184Z"
            fill="white"
          />
          <path
            d="M322.919 256.732C320.67 256.732 318.862 258.553 318.862 260.789C318.862 263.026 320.674 264.846 322.919 264.846C325.164 264.846 326.976 263.026 326.976 260.789C326.976 258.553 325.156 256.732 322.919 256.732Z"
            fill="white"
          />
          <path
            d="M329.527 247.863C327.291 247.863 325.479 249.675 325.479 251.912C325.479 254.148 327.291 255.96 329.527 255.96C331.763 255.96 333.576 254.148 333.576 251.912C333.576 249.675 331.763 247.863 329.527 247.863Z"
            fill="white"
          />
          <path
            d="M335.867 239.479C333.639 239.479 331.84 241.278 331.84 243.506C331.84 245.734 333.639 247.546 335.867 247.546C338.095 247.546 339.907 245.734 339.907 243.506C339.907 241.278 338.095 239.479 335.867 239.479Z"
            fill="white"
          />
          <path
            d="M341.894 231.42C339.679 231.42 337.888 233.219 337.888 235.439C337.888 237.658 339.679 239.458 341.894 239.458C344.109 239.458 345.913 237.658 345.913 235.439C345.913 233.219 344.122 231.42 341.894 231.42Z"
            fill="white"
          />
          <path
            d="M347.596 223.779C345.402 223.779 343.611 225.57 343.611 227.777C343.611 229.984 345.402 231.762 347.596 231.762C349.79 231.762 351.594 229.984 351.594 227.777C351.594 225.57 349.803 223.779 347.596 223.779Z"
            fill="white"
          />
          <path
            d="M352.957 224.802C355.153 224.802 356.933 223.022 356.933 220.826C356.933 218.63 355.153 216.85 352.957 216.85C350.761 216.85 348.98 218.63 348.98 220.826C348.98 223.022 350.761 224.802 352.957 224.802Z"
            fill="white"
          />
          <path
            d="M357.908 210.752C355.731 210.752 353.966 212.522 353.966 214.694C353.966 216.867 355.735 218.637 357.908 218.637C360.081 218.637 361.863 216.88 361.863 214.694C361.863 212.509 360.094 210.752 357.908 210.752Z"
            fill="white"
          />
          <path
            d="M362.415 205.402C360.238 205.402 358.481 207.159 358.481 209.336C358.481 211.513 360.238 213.262 362.415 213.262C364.592 213.262 366.341 211.505 366.341 209.336C366.341 207.168 364.584 205.402 362.415 205.402Z"
            fill="white"
          />
          <path
            d="M366.405 200.688C364.249 200.688 362.501 202.436 362.501 204.592C362.501 206.748 364.249 208.496 366.405 208.496C368.561 208.496 370.309 206.748 370.309 204.592C370.309 202.436 368.561 200.688 366.405 200.688Z"
            fill="white"
          />
          <path
            d="M369.868 196.473C367.725 196.473 365.985 198.213 365.985 200.356C365.985 202.499 367.725 204.239 369.868 204.239C372.011 204.239 373.751 202.503 373.751 200.356C373.751 198.208 372.011 196.473 369.868 196.473Z"
            fill="white"
          />
          <path
            d="M372.804 200.365C374.926 200.365 376.645 198.645 376.645 196.524C376.645 194.403 374.926 192.684 372.804 192.684C370.683 192.684 368.964 194.403 368.964 196.524C368.964 198.645 370.683 200.365 372.804 200.365Z"
            fill="white"
          />
          <path
            d="M375.219 189.215C373.118 189.215 371.408 190.921 371.408 193.026C371.408 195.131 373.114 196.837 375.219 196.837C377.324 196.837 379.017 195.131 379.017 193.026C379.017 190.921 377.32 189.215 375.219 189.215Z"
            fill="white"
          />
          <path
            d="M377.126 186.012C375.033 186.012 373.349 187.709 373.349 189.789C373.349 191.868 375.033 193.566 377.126 193.566C379.218 193.566 380.903 191.881 380.903 189.789C380.903 187.696 379.205 186.012 377.126 186.012Z"
            fill="white"
          />
          <path
            d="M378.56 183.014C376.489 183.014 374.812 184.69 374.812 186.757C374.812 188.823 376.489 190.5 378.56 190.5C380.631 190.5 382.307 188.823 382.307 186.757C382.307 184.69 380.631 183.014 378.56 183.014Z"
            fill="white"
          />
          <path
            d="M379.59 180.143C377.549 180.143 375.894 181.802 375.894 183.847C375.894 185.893 377.549 187.544 379.59 187.544C381.631 187.544 383.295 185.889 383.295 183.847C383.295 181.806 381.64 180.143 379.59 180.143Z"
            fill="white"
          />
          <path
            d="M380.299 177.332C378.279 177.332 376.646 178.97 376.646 180.99C376.646 183.01 378.279 184.648 380.299 184.648C382.319 184.648 383.953 183.002 383.953 180.99C383.953 178.979 382.319 177.332 380.299 177.332Z"
            fill="white"
          />
          <path
            d="M381.577 181.652C383.523 181.191 384.726 179.24 384.265 177.295C383.804 175.349 381.854 174.146 379.908 174.607C377.963 175.068 376.759 177.018 377.22 178.964C377.681 180.909 379.632 182.113 381.577 181.652Z"
            fill="white"
          />
          <path
            d="M381.058 171.516C379.081 171.516 377.477 173.12 377.477 175.097C377.477 177.075 379.081 178.688 381.058 178.688C383.036 178.688 384.649 177.083 384.649 175.097C384.649 173.111 383.044 171.516 381.058 171.516Z"
            fill="white"
          />
          <path
            d="M381.39 168.277C379.442 168.277 377.863 169.848 377.863 171.8C377.863 173.752 379.446 175.322 381.39 175.322C383.333 175.322 384.908 173.752 384.908 171.8C384.908 169.848 383.338 168.277 381.39 168.277Z"
            fill="white"
          />
          <path
            d="M381.955 164.537C380.028 164.537 378.467 166.099 378.467 168.017C378.467 169.935 380.028 171.497 381.955 171.497C383.882 171.497 385.431 169.935 385.431 168.017C385.431 166.099 383.869 164.537 381.955 164.537Z"
            fill="white"
          />
          <path
            d="M394.754 160.889C392.827 160.889 391.278 162.45 391.278 164.369C391.278 166.287 392.832 167.848 394.754 167.848C396.676 167.848 398.242 166.287 398.242 164.369C398.242 162.45 396.681 160.889 394.754 160.889Z"
            fill="white"
          />
          <path
            d="M408.024 156.992C406.097 156.992 404.535 158.554 404.535 160.481C404.535 162.407 406.097 163.973 408.024 163.973C409.95 163.973 411.512 162.407 411.512 160.481C411.512 158.554 409.95 156.992 408.024 156.992Z"
            fill="white"
          />
          <path
            d="M422.002 159.274C423.929 159.274 425.49 157.712 425.49 155.785C425.49 153.859 423.929 152.297 422.002 152.297C420.075 152.297 418.514 153.859 418.514 155.785C418.514 157.712 420.075 159.274 422.002 159.274Z"
            fill="white"
          />
          <path
            d="M437 146.754C435.073 146.754 433.503 148.316 433.503 150.247C433.503 152.177 435.073 153.739 437 153.739C438.926 153.739 440.497 152.177 440.497 150.247C440.497 148.316 438.926 146.754 437 146.754Z"
            fill="white"
          />
          <path
            d="M453.224 140.568C451.298 140.568 449.728 142.13 449.728 144.061C449.728 145.992 451.298 147.554 453.224 147.554C455.151 147.554 456.721 145.992 456.721 144.061C456.721 142.13 455.151 140.568 453.224 140.568Z"
            fill="white"
          />
          <path
            d="M471.115 133.096C469.18 133.096 467.618 134.666 467.618 136.597C467.618 138.528 469.18 140.094 471.115 140.094C473.05 140.094 474.612 138.528 474.612 136.597C474.612 134.666 473.042 133.096 471.115 133.096Z"
            fill="white"
          />
          <path
            d="M490.747 124.52C488.812 124.52 487.25 126.085 487.25 128.021C487.25 129.956 488.812 131.522 490.747 131.522C492.682 131.522 494.252 129.952 494.252 128.021C494.252 126.09 492.682 124.52 490.747 124.52Z"
            fill="white"
          />
          <path
            d="M512.271 114.852C510.336 114.852 508.766 116.413 508.766 118.348C508.766 120.284 510.336 121.854 512.271 121.854C514.206 121.854 515.776 120.284 515.776 118.348C515.776 116.413 514.206 114.852 512.271 114.852Z"
            fill="white"
          />
          <path
            d="M535.159 104.035C533.224 104.035 531.653 105.605 531.653 107.549C531.653 109.493 533.224 111.054 535.159 111.054C537.094 111.054 538.664 109.484 538.664 107.549C538.664 105.614 537.094 104.035 535.159 104.035Z"
            fill="white"
          />
          <path
            d="M558.869 99.1982C560.805 99.1982 562.374 97.6288 562.374 95.6928C562.374 93.7569 560.805 92.1875 558.869 92.1875C556.933 92.1875 555.363 93.7569 555.363 95.6928C555.363 97.6288 556.933 99.1982 558.869 99.1982Z"
            fill="white"
          />
          <path
            d="M582.348 79.6387C580.413 79.6387 578.843 81.2173 578.843 83.1525C578.843 85.0876 580.413 86.6706 582.348 86.6706C584.283 86.6706 585.866 85.0919 585.866 83.1525C585.866 81.2131 584.296 79.6387 582.348 79.6387Z"
            fill="white"
          />
          <path
            d="M604.92 66.6855C602.972 66.6855 601.402 68.2642 601.402 70.2036C601.402 72.143 602.972 73.7259 604.92 73.7259C606.868 73.7259 608.438 72.1472 608.438 70.2036C608.438 68.26 606.868 66.6855 604.92 66.6855Z"
            fill="white"
          />
          <path
            d="M626.195 53.9766C624.248 53.9766 622.669 55.5467 622.669 57.4946C622.669 59.4425 624.252 61.0127 626.195 61.0127C628.139 61.0127 629.714 59.4425 629.714 57.4946C629.714 55.5467 628.131 53.9766 626.195 53.9766Z"
            fill="white"
          />
          <path
            d="M646.013 41.4883C644.065 41.4883 642.495 43.0712 642.495 45.0148C642.495 46.9585 644.065 48.5414 646.013 48.5414C647.961 48.5414 649.54 46.9585 649.54 45.0148C649.54 43.0712 647.957 41.4883 646.013 41.4883Z"
            fill="white"
          />
          <path
            d="M664.38 31.0195C662.432 31.0195 660.854 32.6025 660.854 34.5461C660.854 36.4897 662.436 38.0811 664.38 38.0811C666.324 38.0811 667.907 36.5025 667.907 34.5461C667.907 32.5897 666.324 31.0195 664.38 31.0195Z"
            fill="white"
          />
          <path
            d="M681.525 22.5684C679.577 22.5684 677.998 24.1513 677.998 26.0949C677.998 28.0386 679.581 29.6342 681.525 29.6342C683.468 29.6342 685.064 28.0513 685.064 26.0949C685.064 24.1385 683.481 22.5684 681.525 22.5684Z"
            fill="white"
          />
          <path
            d="M697.563 16.6016C695.615 16.6016 694.036 18.1845 694.036 20.1408C694.036 22.0972 695.619 23.6801 697.563 23.6801C699.506 23.6801 701.102 22.0972 701.102 20.1408C701.102 18.1845 699.519 16.6016 697.563 16.6016Z"
            fill="white"
          />
          <path
            d="M712.683 13.3066C710.726 13.3066 709.144 14.8938 709.144 16.8502C709.144 18.8065 710.726 20.3895 712.683 20.3895C714.639 20.3895 716.222 18.8065 716.222 16.8502C716.222 14.8938 714.639 13.3066 712.683 13.3066Z"
            fill="white"
          />
          <path
            d="M727.09 11.6777C725.133 11.6777 723.542 13.2691 723.542 15.2213C723.542 17.1734 725.133 18.7648 727.09 18.7648C729.046 18.7648 730.629 17.1776 730.629 15.2213C730.629 13.2649 729.038 11.6777 727.09 11.6777Z"
            fill="white"
          />
          <path
            d="M740.856 11.6582C738.9 11.6582 737.309 13.2496 737.309 15.2187C737.309 17.1878 738.9 18.775 740.856 18.775C742.813 18.775 744.417 17.1836 744.417 15.2187C744.417 13.2539 742.825 11.6582 740.856 11.6582Z"
            fill="white"
          />
          <path
            d="M754.14 13.4707C752.171 13.4707 750.579 15.0621 750.579 17.0312C750.579 19.0003 752.171 20.5917 754.14 20.5917C756.109 20.5917 757.7 19.0003 757.7 17.0312C757.7 15.0621 756.109 13.4707 754.14 13.4707Z"
            fill="white"
          />
          <path
            d="M767.036 16.373C765.071 16.373 763.476 17.9772 763.476 19.942C763.476 21.9069 765.067 23.5068 767.036 23.5068C769.005 23.5068 770.605 21.9111 770.605 19.942C770.605 17.9729 769.014 16.373 767.036 16.373Z"
            fill="white"
          />
          <path
            d="M773.414 29.5352C771.428 29.5352 769.803 31.152 769.803 33.1508C769.803 35.1496 771.428 36.7623 773.414 36.7623C775.4 36.7623 777.026 35.1369 777.026 33.1508C777.026 31.1648 775.413 29.5352 773.414 29.5352Z"
            fill="white"
          />
          <path
            d="M779.462 44.1309C777.442 44.1309 775.8 45.7774 775.8 47.8017C775.8 49.826 777.446 51.4725 779.462 51.4725C781.478 51.4725 783.137 49.826 783.137 47.8017C783.137 45.7774 781.491 44.1309 779.462 44.1309Z"
            fill="white"
          />
          <path
            d="M785.174 60.3574C783.132 60.3574 781.469 62.0125 781.469 64.0622C781.469 66.112 783.132 67.7797 785.174 67.7797C787.215 67.7797 788.891 66.1162 788.891 64.0622C788.891 62.0082 787.228 60.3574 785.174 60.3574Z"
            fill="white"
          />
          <path
            d="M790.619 77.9062C788.548 77.9062 786.872 79.5868 786.872 81.6535C786.872 83.7202 788.548 85.4007 790.619 85.4007C792.69 85.4007 794.367 83.7244 794.367 81.6535C794.367 79.5825 792.682 77.9062 790.619 77.9062Z"
            fill="white"
          />
          <path
            d="M795.916 96.0352C793.823 96.0352 792.126 97.7327 792.126 99.8248C792.126 101.917 793.823 103.619 795.916 103.619C798.008 103.619 799.714 101.917 799.714 99.8248C799.714 97.7327 798.008 96.0352 795.916 96.0352Z"
            fill="white"
          />
          <path
            d="M804.816 119.006C805.628 117.047 804.697 114.8 802.738 113.988C800.778 113.177 798.531 114.107 797.72 116.067C796.908 118.027 797.839 120.273 799.798 121.085C801.758 121.897 804.004 120.966 804.816 119.006Z"
            fill="white"
          />
          <path
            d="M806.762 130.486C804.627 130.486 802.892 132.218 802.892 134.357C802.892 136.495 804.632 138.227 806.762 138.227C808.892 138.227 810.632 136.495 810.632 134.357C810.632 132.218 808.905 130.486 806.762 130.486Z"
            fill="white"
          />
          <path
            d="M816.094 151.61C816.919 149.617 815.973 147.334 813.981 146.508C811.989 145.683 809.705 146.629 808.88 148.621C808.055 150.614 809.001 152.897 810.993 153.723C812.985 154.548 815.269 153.602 816.094 151.61Z"
            fill="white"
          />
          <path
            d="M818.471 160.92C816.294 160.92 814.537 162.69 814.537 164.867C814.537 167.044 816.294 168.801 818.471 168.801C820.648 168.801 822.413 167.044 822.413 164.867C822.413 162.69 820.644 160.92 818.471 160.92Z"
            fill="white"
          />
          <path
            d="M824.746 174.668C822.552 174.668 820.77 176.446 820.77 178.644C820.77 180.843 822.548 182.608 824.746 182.608C826.944 182.608 828.71 180.83 828.71 178.644C828.71 176.459 826.931 174.668 824.746 174.668Z"
            fill="white"
          />
          <path
            d="M831.304 187.43C829.098 187.43 827.307 189.221 827.307 191.427C827.307 193.634 829.098 195.429 831.304 195.429C833.511 195.429 835.302 193.638 835.302 191.427C835.302 189.216 833.511 187.43 831.304 187.43Z"
            fill="white"
          />
          <path
            d="M838.132 199.166C835.917 199.166 834.113 200.965 834.113 203.185C834.113 205.404 835.913 207.212 838.132 207.212C840.352 207.212 842.159 205.413 842.159 203.185C842.159 200.957 840.36 199.166 838.132 199.166Z"
            fill="white"
          />
          <path
            d="M845.207 209.973C842.979 209.973 841.158 211.785 841.158 214.021C841.158 216.258 842.979 218.061 845.207 218.061C847.435 218.061 849.255 216.249 849.255 214.021C849.255 211.793 847.443 209.973 845.207 209.973Z"
            fill="white"
          />
          <path
            d="M853.148 228.001C855.367 227.641 856.874 225.551 856.514 223.332C856.153 221.114 854.063 219.607 851.844 219.967C849.626 220.327 848.119 222.418 848.479 224.636C848.839 226.855 850.93 228.362 853.148 228.001Z"
            fill="white"
          />
          <path
            d="M859.979 229.197C857.722 229.197 855.88 231.031 855.88 233.297C855.88 235.563 857.722 237.396 859.979 237.396C862.237 237.396 864.079 235.554 864.079 233.297C864.079 231.039 862.245 229.197 859.979 229.197Z"
            fill="white"
          />
          <path
            d="M868.593 245.917C870.803 245.396 872.172 243.181 871.65 240.97C871.129 238.76 868.914 237.391 866.703 237.913C864.493 238.434 863.124 240.649 863.646 242.86C864.167 245.07 866.382 246.439 868.593 245.917Z"
            fill="white"
          />
          <path
            d="M875.495 245.693C873.216 245.693 871.374 247.535 871.374 249.814C871.374 252.093 873.216 253.947 875.495 253.947C877.774 253.947 879.628 252.097 879.628 249.814C879.628 247.531 877.778 245.693 875.495 245.693Z"
            fill="white"
          />
          <path
            d="M883.532 252.996C881.24 252.996 879.39 254.851 879.39 257.138C879.39 259.425 881.24 261.293 883.532 261.293C885.823 261.293 887.686 259.43 887.686 257.138C887.686 254.846 885.823 252.996 883.532 252.996Z"
            fill="white"
          />
          <path
            d="M891.765 259.699C889.465 259.699 887.61 261.562 887.61 263.854C887.61 266.145 889.461 268.008 891.765 268.008C894.069 268.008 895.92 266.158 895.92 263.854C895.92 261.549 894.057 259.699 891.765 259.699Z"
            fill="white"
          />
          <path
            d="M900.185 265.828C897.893 265.828 896.03 267.691 896.03 269.983C896.03 272.274 897.893 274.137 900.185 274.137C902.477 274.137 904.34 272.274 904.34 269.983C904.34 267.691 902.477 265.828 900.185 265.828Z"
            fill="white"
          />
          <path
            d="M908.799 271.379C906.499 271.379 904.636 273.242 904.636 275.534C904.636 277.825 906.499 279.688 908.799 279.688C911.099 279.688 912.954 277.825 912.954 275.534C912.954 273.242 911.091 271.379 908.799 271.379Z"
            fill="white"
          />
          <path
            d="M917.576 276.33C915.275 276.33 913.421 278.185 913.421 280.485C913.421 282.785 915.275 284.639 917.576 284.639C919.876 284.639 921.73 282.776 921.73 280.485C921.73 278.193 919.867 276.33 917.576 276.33Z"
            fill="white"
          />
          <path
            d="M912.295 279.34C909.995 279.34 908.141 281.203 908.141 283.494C908.141 285.786 909.991 287.649 912.295 287.649C914.6 287.649 916.45 285.786 916.45 283.494C916.45 281.203 914.587 279.34 912.295 279.34Z"
            fill="white"
          />
          <path
            d="M906.956 282.422C904.665 282.422 902.802 284.276 902.802 286.576C902.802 288.877 904.665 290.731 906.956 290.731C909.248 290.731 911.111 288.868 911.111 286.576C911.111 284.285 909.248 282.422 906.956 282.422Z"
            fill="white"
          />
          <path
            d="M901.545 285.617C899.254 285.617 897.391 287.48 897.391 289.772C897.391 292.063 899.254 293.926 901.545 293.926C903.837 293.926 905.708 292.072 905.708 289.772C905.708 287.472 903.845 285.617 901.545 285.617Z"
            fill="white"
          />
          <path
            d="M896.059 288.986C893.767 288.986 891.904 290.849 891.904 293.141C891.904 295.433 893.767 297.296 896.059 297.296C898.351 297.296 900.214 295.445 900.214 293.141C900.214 290.837 898.359 288.986 896.059 288.986Z"
            fill="white"
          />
          <path
            d="M890.474 292.588C888.174 292.588 886.319 294.451 886.319 296.743C886.319 299.034 888.17 300.897 890.474 300.897C892.778 300.897 894.629 299.034 894.629 296.743C894.629 294.451 892.766 292.588 890.474 292.588Z"
            fill="white"
          />
          <path
            d="M884.729 296.473C882.441 296.473 880.574 298.336 880.574 300.627C880.574 302.919 882.437 304.782 884.729 304.782C887.02 304.782 888.884 302.932 888.884 300.627C888.884 298.323 887.033 296.473 884.729 296.473Z"
            fill="white"
          />
          <path
            d="M878.817 300.695C876.525 300.695 874.662 302.546 874.662 304.85C874.662 307.154 876.525 309.005 878.817 309.005C881.108 309.005 882.971 307.142 882.971 304.85C882.971 302.558 881.108 300.695 878.817 300.695Z"
            fill="white"
          />
          <path
            d="M872.685 305.307C870.393 305.307 868.543 307.161 868.543 309.449C868.543 311.736 870.397 313.59 872.685 313.59C874.972 313.59 876.827 311.74 876.827 309.449C876.827 307.157 874.976 305.307 872.685 305.307Z"
            fill="white"
          />
          <path
            d="M866.306 310.332C864.036 310.332 862.186 312.182 862.186 314.453C862.186 316.723 864.036 318.586 866.306 318.586C868.577 318.586 870.44 316.736 870.44 314.453C870.44 312.17 868.585 310.332 866.306 310.332Z"
            fill="white"
          />
          <path
            d="M859.665 315.791C857.394 315.791 855.553 317.633 855.553 319.903C855.553 322.174 857.394 324.015 859.665 324.015C861.935 324.015 863.786 322.174 863.786 319.903C863.786 317.633 861.944 315.791 859.665 315.791Z"
            fill="white"
          />
          <path
            d="M852.773 321.639C850.503 321.639 848.674 323.472 848.674 325.738C848.674 328.004 850.507 329.829 852.773 329.829C855.039 329.829 856.864 327.996 856.864 325.738C856.864 323.48 855.031 321.639 852.773 321.639Z"
            fill="white"
          />
          <path
            d="M845.644 327.828C843.386 327.828 841.565 329.661 841.565 331.906C841.565 334.151 843.386 335.985 845.644 335.985C847.901 335.985 849.722 334.164 849.722 331.906C849.722 329.649 847.889 327.828 845.644 327.828Z"
            fill="white"
          />
          <path
            d="M838.34 334.312C836.103 334.312 834.291 336.125 834.291 338.361C834.291 340.597 836.103 342.41 838.34 342.41C840.576 342.41 842.388 340.597 842.388 338.361C842.388 336.125 840.576 334.312 838.34 334.312Z"
            fill="white"
          />
          <path
            d="M830.918 340.922C828.703 340.922 826.891 342.721 826.891 344.949C826.891 347.177 828.703 348.989 830.918 348.989C833.133 348.989 834.958 347.177 834.958 344.949C834.958 342.721 833.146 340.922 830.918 340.922Z"
            fill="white"
          />
          <path
            d="M823.466 347.533C821.259 347.533 819.46 349.333 819.46 351.539C819.46 353.746 821.259 355.545 823.466 355.545C825.673 355.545 827.472 353.755 827.472 351.539C827.472 349.324 825.681 347.533 823.466 347.533Z"
            fill="white"
          />
          <path
            d="M818.845 360.773C820.398 359.22 820.398 356.702 818.845 355.149C817.292 353.596 814.775 353.596 813.222 355.149C811.669 356.702 811.669 359.22 813.222 360.773C814.775 362.326 817.292 362.326 818.845 360.773Z"
            fill="white"
          />
          <path
            d="M808.647 360.146C806.461 360.146 804.691 361.916 804.691 364.102C804.691 366.287 806.461 368.048 808.647 368.048C810.832 368.048 812.589 366.279 812.589 364.102C812.589 361.925 810.819 360.146 808.647 360.146Z"
            fill="white"
          />
          <path
            d="M801.139 366.559C798.975 366.559 797.227 368.307 797.227 370.471C797.227 372.636 798.975 374.384 801.139 374.384C803.304 374.384 805.052 372.623 805.052 370.471C805.052 368.32 803.304 366.559 801.139 366.559Z"
            fill="white"
          />
          <path
            d="M793.348 373.709C791.192 373.709 789.443 375.457 789.443 377.601C789.443 379.744 791.192 381.505 793.348 381.505C795.503 381.505 797.239 379.756 797.239 377.601C797.239 375.445 795.491 373.709 793.348 373.709Z"
            fill="white"
          />
          <path
            d="M785.217 381.754C783.083 381.754 781.368 383.481 781.368 385.603C781.368 387.725 783.087 389.452 785.217 389.452C787.348 389.452 789.066 387.733 789.066 385.603C789.066 383.473 787.339 381.754 785.217 381.754Z"
            fill="white"
          />
          <path
            d="M776.725 390.691C774.624 390.691 772.914 392.397 772.914 394.502C772.914 396.607 774.62 398.322 776.725 398.322C778.83 398.322 780.544 396.616 780.544 394.502C780.544 392.389 778.838 390.691 776.725 390.691Z"
            fill="white"
          />
          <path
            d="M775.482 409.433C776.946 407.97 776.946 405.597 775.482 404.134C774.019 402.67 771.646 402.67 770.183 404.134C768.719 405.597 768.72 407.97 770.183 409.433C771.646 410.896 774.019 410.896 775.482 409.433Z"
            fill="white"
          />
          <path
            d="M758.761 411.393C756.69 411.393 755.014 413.069 755.014 415.14C755.014 417.211 756.69 418.887 758.761 418.887C760.832 418.887 762.495 417.211 762.495 415.14C762.495 413.069 760.819 411.393 758.761 411.393Z"
            fill="white"
          />
          <path
            d="M744.396 420.271C742.325 420.271 740.648 421.948 740.648 424.019C740.648 426.09 742.325 427.753 744.396 427.753C746.467 427.753 748.143 426.077 748.143 424.019C748.143 421.96 746.458 420.271 744.396 420.271Z"
            fill="white"
          />
          <path
            d="M729.814 429.742C727.751 429.742 726.079 431.418 726.079 433.477C726.079 435.535 727.755 437.211 729.814 437.211C731.872 437.211 733.548 435.535 733.548 433.477C733.548 431.418 731.872 429.742 729.814 429.742Z"
            fill="white"
          />
          <path
            d="M715.068 439.852C713.005 439.852 711.333 441.528 711.333 443.586C711.333 445.644 713.009 447.321 715.068 447.321C717.126 447.321 718.815 445.644 718.815 443.586C718.815 441.528 717.138 439.852 715.068 439.852Z"
            fill="white"
          />
          <path
            d="M700.155 450.393C698.093 450.393 696.421 452.056 696.421 454.119C696.421 456.181 698.097 457.853 700.155 457.853C702.214 457.853 703.881 456.19 703.881 454.119C703.881 452.048 702.218 450.393 700.155 450.393Z"
            fill="white"
          />
          <path
            d="M685.102 461.084C683.04 461.084 681.376 462.748 681.376 464.81C681.376 466.872 683.04 468.536 685.102 468.536C687.164 468.536 688.837 466.872 688.837 464.81C688.837 462.748 687.16 461.084 685.102 461.084Z"
            fill="white"
          />
          <path
            d="M670.04 471.74C667.991 471.74 666.327 473.404 666.327 475.466C666.327 477.529 667.991 479.192 670.04 479.192C672.09 479.192 673.766 477.529 673.766 475.466C673.766 473.404 672.103 471.74 670.04 471.74Z"
            fill="white"
          />
          <path
            d="M654.963 481.992C652.901 481.992 651.237 483.656 651.237 485.718C651.237 487.781 652.901 489.444 654.963 489.444C657.026 489.444 658.689 487.768 658.689 485.718C658.689 483.668 657.026 481.992 654.963 481.992Z"
            fill="white"
          />
          <path
            d="M639.944 491.514C637.894 491.514 636.227 493.177 636.227 495.227C636.227 497.277 637.89 498.944 639.944 498.944C641.998 498.944 643.67 497.281 643.67 495.227C643.67 493.173 642.007 491.514 639.944 491.514Z"
            fill="white"
          />
          <path
            d="M625.184 500.33C623.135 500.33 621.467 501.994 621.467 504.056C621.467 506.119 623.13 507.774 625.184 507.774C627.238 507.774 628.91 506.11 628.91 504.056C628.91 502.002 627.247 500.33 625.184 500.33Z"
            fill="white"
          />
          <path
            d="M610.676 508.383C608.626 508.383 606.958 510.038 606.958 512.1C606.958 514.163 608.622 515.805 610.676 515.805C612.73 515.805 614.38 514.15 614.38 512.1C614.38 510.051 612.725 508.383 610.676 508.383Z"
            fill="white"
          />
          <path
            d="M596.408 515.619C594.358 515.619 592.69 517.283 592.69 519.337C592.69 521.391 594.354 523.05 596.408 523.05C598.462 523.05 600.121 521.386 600.121 519.337C600.121 517.287 598.458 515.619 596.408 515.619Z"
            fill="white"
          />
          <path
            d="M582.421 522.643C580.371 522.643 578.716 524.306 578.716 526.356C578.716 528.406 580.371 530.061 582.421 530.061C584.47 530.061 586.134 528.397 586.134 526.356C586.134 524.315 584.47 522.643 582.421 522.643Z"
            fill="white"
          />
          <path
            d="M568.692 529.607C566.642 529.607 564.987 531.262 564.987 533.312C564.987 535.362 566.642 537.017 568.692 537.017C570.742 537.017 572.397 535.353 572.397 533.312C572.397 531.271 570.733 529.607 568.692 529.607Z"
            fill="white"
          />
          <path
            d="M555.18 536.412C553.131 536.412 551.476 538.067 551.476 540.117C551.476 542.167 553.131 543.813 555.18 543.813C557.23 543.813 558.877 542.158 558.877 540.117C558.877 538.076 557.222 536.412 555.18 536.412Z"
            fill="white"
          />
          <path
            d="M541.817 543.076C539.776 543.076 538.112 544.731 538.112 546.781C538.112 548.831 539.776 550.477 541.817 550.477C543.858 550.477 545.522 548.822 545.522 546.781C545.522 544.74 543.858 543.076 541.817 543.076Z"
            fill="white"
          />
          <path
            d="M528.559 549.611C526.517 549.611 524.862 551.266 524.862 553.308C524.862 555.349 526.517 557.004 528.559 557.004C530.6 557.004 532.255 555.349 532.255 553.308C532.255 551.266 530.6 549.611 528.559 549.611Z"
            fill="white"
          />
          <path
            d="M515.353 556.002C513.311 556.002 511.656 557.657 511.656 559.698C511.656 561.739 513.311 563.395 515.353 563.395C517.394 563.395 519.049 561.739 519.049 559.698C519.049 557.657 517.394 556.002 515.353 556.002Z"
            fill="white"
          />
          <path
            d="M502.163 562.1C500.122 562.1 498.467 563.755 498.467 565.796C498.467 567.837 500.122 569.492 502.163 569.492C504.204 569.492 505.859 567.837 505.859 565.796C505.859 563.755 504.204 562.1 502.163 562.1Z"
            fill="white"
          />
          <path
            d="M488.927 567.848C486.898 567.848 485.243 569.494 485.243 571.531C485.243 573.568 486.898 575.215 488.927 575.215C490.955 575.215 492.623 573.568 492.623 571.531C492.623 569.494 490.968 567.848 488.927 567.848Z"
            fill="white"
          />
          <path
            d="M475.623 573.193C473.595 573.193 471.939 574.848 471.939 576.877C471.939 578.905 473.595 580.573 475.623 580.573C477.652 580.573 479.319 578.918 479.319 576.877C479.319 574.836 477.664 573.193 475.623 573.193Z"
            fill="white"
          />
          <path
            d="M462.251 577.98C460.21 577.98 458.567 579.627 458.567 581.664C458.567 583.701 460.21 585.348 462.251 585.348C464.292 585.348 465.935 583.693 465.935 581.664C465.935 579.636 464.279 577.98 462.251 577.98Z"
            fill="white"
          />
          <path
            d="M448.75 582.072C446.709 582.072 445.054 583.727 445.054 585.769C445.054 587.81 446.709 589.465 448.75 589.465C450.791 589.465 452.446 587.81 452.446 585.769C452.446 583.727 450.791 582.072 448.75 582.072Z"
            fill="white"
          />
          <path
            d="M440.268 578.096C438.206 578.096 436.542 579.772 436.542 581.822C436.542 583.871 438.206 585.548 440.268 585.548C442.33 585.548 443.994 583.884 443.994 581.822C443.994 579.759 442.318 578.096 440.268 578.096Z"
            fill="white"
          />
          <path
            d="M431.954 572.893C429.883 572.893 428.198 574.569 428.198 576.64C428.198 578.711 429.883 580.396 431.954 580.396C434.025 580.396 435.71 578.719 435.71 576.64C435.71 574.56 434.025 572.893 431.954 572.893Z"
            fill="white"
          />
          <path
            d="M423.938 566.141C421.846 566.141 420.148 567.838 420.148 569.93C420.148 572.022 421.846 573.707 423.938 573.707C426.03 573.707 427.728 572.022 427.728 569.93C427.728 567.838 426.03 566.141 423.938 566.141Z"
            fill="white"
          />
          <path
            d="M416.362 557.508C414.249 557.508 412.53 559.214 412.53 561.327C412.53 563.441 414.249 565.159 416.362 565.159C418.476 565.159 420.19 563.453 420.19 561.327C420.19 559.201 418.472 557.508 416.362 557.508Z"
            fill="white"
          />
          <path
            d="M409.357 546.74C407.222 546.74 405.495 548.467 405.495 550.602C405.495 552.737 407.222 554.464 409.357 554.464C411.492 554.464 413.206 552.737 413.206 550.602C413.206 548.467 411.487 546.74 409.357 546.74Z"
            fill="white"
          />
          <path
            d="M403.02 533.613C400.877 533.613 399.129 535.349 399.129 537.496C399.129 539.644 400.877 541.379 403.02 541.379C405.164 541.379 406.903 539.639 406.903 537.496C406.903 535.353 405.164 533.613 403.02 533.613Z"
            fill="white"
          />
          <path
            d="M397.397 517.949C395.242 517.949 393.506 519.689 393.506 521.841C393.506 523.992 395.246 525.745 397.397 525.745C399.549 525.745 401.302 523.997 401.302 521.841C401.302 519.685 399.553 517.949 397.397 517.949Z"
            fill="white"
          />
          <path
            d="M392.424 499.863C390.247 499.863 388.478 501.633 388.478 503.806C388.478 505.979 390.247 507.752 392.424 507.752C394.601 507.752 396.367 505.983 396.367 503.806C396.367 501.629 394.597 499.863 392.424 499.863Z"
            fill="white"
          />
          <path
            d="M387.81 480.023C385.625 480.023 383.847 481.802 383.847 483.987C383.847 486.173 385.625 487.942 387.81 487.942C389.996 487.942 391.766 486.173 391.766 483.987C391.766 481.802 389.996 480.023 387.81 480.023Z"
            fill="white"
          />
          <path
            d="M383.172 459.428C380.966 459.428 379.188 461.206 379.188 463.413C379.188 465.619 380.966 467.398 383.172 467.398C385.379 467.398 387.157 465.607 387.157 463.413C387.157 461.219 385.366 459.428 383.172 459.428Z"
            fill="white"
          />
          <path
            d="M381.119 446.08C382.581 444.426 382.427 441.899 380.773 440.437C379.119 438.974 376.592 439.129 375.13 440.783C373.667 442.437 373.822 444.963 375.476 446.426C377.13 447.888 379.656 447.733 381.119 446.08Z"
            fill="white"
          />
          <path
            d="M372.481 421.043C370.253 421.043 368.454 422.842 368.454 425.07C368.454 427.298 370.253 429.089 372.481 429.089C374.709 429.089 376.5 427.29 376.5 425.07C376.5 422.851 374.701 421.043 372.481 421.043Z"
            fill="white"
          />
          <path
            d="M366.29 404.254C364.062 404.254 362.25 406.053 362.25 408.294C362.25 410.535 364.062 412.334 366.29 412.334C368.518 412.334 370.33 410.522 370.33 408.294C370.33 406.066 368.518 404.254 366.29 404.254Z"
            fill="white"
          />
          <path
            d="M359.785 387.766C357.548 387.766 355.736 389.578 355.736 391.814C355.736 394.051 357.548 395.863 359.785 395.863C362.021 395.863 363.833 394.051 363.833 391.814C363.833 389.578 362.021 387.766 359.785 387.766Z"
            fill="white"
          />
          <path
            d="M352.885 372.115C350.648 372.115 348.823 373.936 348.823 376.172C348.823 378.409 350.644 380.234 352.885 380.234C355.125 380.234 356.942 378.421 356.942 376.172C356.942 373.923 355.129 372.115 352.885 372.115Z"
            fill="white"
          />
          <path
            d="M345.514 357.982C343.265 357.982 341.436 359.803 341.436 362.052C341.436 364.301 343.269 366.13 345.514 366.13C347.759 366.13 349.584 364.297 349.584 362.052C349.584 359.807 347.763 357.982 345.514 357.982Z"
            fill="white"
          />
          <path
            d="M337.688 345.484C335.439 345.484 333.618 347.305 333.618 349.554C333.618 351.803 335.439 353.632 337.688 353.632C339.937 353.632 341.766 351.812 341.766 349.554C341.766 347.296 339.933 345.484 337.688 345.484Z"
            fill="white"
          />
          <path
            d="M329.506 334.428C327.248 334.428 325.415 336.248 325.415 338.506C325.415 340.764 327.248 342.584 329.506 342.584C331.764 342.584 333.584 340.764 333.584 338.506C333.584 336.248 331.751 334.428 329.506 334.428Z"
            fill="white"
          />
          <path
            d="M321.057 324.594C318.808 324.594 316.979 326.427 316.979 328.672C316.979 330.917 318.812 332.75 321.057 332.75C323.302 332.75 325.135 330.93 325.135 328.672C325.135 326.414 323.314 324.594 321.057 324.594Z"
            fill="white"
          />
          <path
            d="M312.472 323.895C314.731 323.895 316.563 322.063 316.563 319.804C316.563 317.544 314.731 315.713 312.472 315.713C310.212 315.713 308.381 317.544 308.381 319.804C308.381 322.063 310.212 323.895 312.472 323.895Z"
            fill="white"
          />
          <path
            d="M303.767 307.807C301.509 307.807 299.676 309.64 299.676 311.898C299.676 314.155 301.509 315.989 303.767 315.989C306.024 315.989 307.845 314.155 307.845 311.898C307.845 309.64 306.012 307.807 303.767 307.807Z"
            fill="white"
          />
          <path
            d="M295.046 300.543C292.788 300.543 290.955 302.376 290.955 304.634C290.955 306.892 292.788 308.712 295.046 308.712C297.304 308.712 299.124 306.892 299.124 304.634C299.124 302.376 297.291 300.543 295.046 300.543Z"
            fill="white"
          />
          <path
            d="M286.39 293.641C284.132 293.641 282.299 295.474 282.299 297.732C282.299 299.989 284.132 301.81 286.39 301.81C288.647 301.81 290.468 299.989 290.468 297.732C290.468 295.474 288.635 293.641 286.39 293.641Z"
            fill="white"
          />
          <path
            d="M293.506 281.869C291.257 281.869 289.437 283.69 289.437 285.939C289.437 288.188 291.257 290.009 293.506 290.009C295.755 290.009 297.576 288.188 297.576 285.939C297.576 283.69 295.755 281.869 293.506 281.869Z"
            fill="white"
          />
          <path
            d="M300.584 271.244C298.348 271.244 296.527 273.065 296.527 275.314C296.527 277.563 298.348 279.384 300.584 279.384C302.821 279.384 304.654 277.563 304.654 275.314C304.654 273.065 302.834 271.244 300.584 271.244Z"
            fill="white"
          />
          <path
            d="M307.557 261.562C305.321 261.562 303.5 263.383 303.5 265.624C303.5 267.864 305.321 269.681 307.557 269.681C309.793 269.681 311.614 267.869 311.614 265.624C311.614 263.379 309.802 261.562 307.557 261.562Z"
            fill="white"
          />
          <path
            d="M314.312 252.635C312.084 252.635 310.264 254.447 310.264 256.683C310.264 258.92 312.084 260.732 314.312 260.732C316.54 260.732 318.369 258.92 318.369 256.683C318.369 254.447 316.549 252.635 314.312 252.635Z"
            fill="white"
          />
          <path
            d="M320.837 244.213C318.609 244.213 316.797 246.025 316.797 248.253C316.797 250.481 318.609 252.28 320.837 252.28C323.065 252.28 324.864 250.468 324.864 248.253C324.864 246.038 323.065 244.213 320.837 244.213Z"
            fill="white"
          />
          <path
            d="M327.07 236.156C324.854 236.156 323.063 237.947 323.063 240.162C323.063 242.378 324.854 244.181 327.07 244.181C329.285 244.181 331.088 242.382 331.088 240.162C331.088 237.943 329.289 236.156 327.07 236.156Z"
            fill="white"
          />
          <path
            d="M332.986 228.475C330.792 228.475 329.001 230.265 329.001 232.459C329.001 234.654 330.792 236.444 332.986 236.444C335.18 236.444 336.971 234.666 336.971 232.459C336.971 230.253 335.193 228.475 332.986 228.475Z"
            fill="white"
          />
          <path
            d="M338.541 221.336C336.343 221.336 334.577 223.114 334.577 225.312C334.577 227.511 336.347 229.289 338.541 229.289C340.735 229.289 342.517 227.511 342.517 225.312C342.517 223.114 340.739 221.336 338.541 221.336Z"
            fill="white"
          />
          <path
            d="M343.713 214.988C341.536 214.988 339.767 216.758 339.767 218.931C339.767 221.104 341.536 222.877 343.713 222.877C345.89 222.877 347.656 221.108 347.656 218.931C347.656 216.754 345.886 214.988 343.713 214.988Z"
            fill="white"
          />
          <path
            d="M348.429 209.387C346.265 209.387 344.504 211.148 344.504 213.321C344.504 215.493 346.261 217.246 348.429 217.246C350.598 217.246 352.363 215.489 352.363 213.321C352.363 211.152 350.606 209.387 348.429 209.387Z"
            fill="white"
          />
          <path
            d="M352.677 204.434C350.521 204.434 348.785 206.174 348.785 208.325C348.785 210.477 350.525 212.217 352.677 212.217C354.828 212.217 356.568 210.477 356.568 208.325C356.568 206.174 354.828 204.434 352.677 204.434Z"
            fill="white"
          />
          <path
            d="M356.404 199.969C354.26 199.969 352.521 201.709 352.521 203.852C352.521 205.995 354.26 207.722 356.404 207.722C358.547 207.722 360.274 205.995 360.274 203.852C360.274 201.709 358.534 199.969 356.404 199.969Z"
            fill="white"
          />
          <path
            d="M359.585 195.984C357.463 195.984 355.744 197.703 355.744 199.825C355.744 201.947 357.463 203.653 359.585 203.653C361.707 203.653 363.413 201.934 363.413 199.825C363.413 197.716 361.694 195.984 359.585 195.984Z"
            fill="white"
          />
          <path
            d="M362.23 192.34C360.129 192.34 358.432 194.046 358.432 196.151C358.432 198.256 360.129 199.962 362.23 199.962C364.33 199.962 366.041 198.256 366.041 196.151C366.041 194.046 364.335 192.34 362.23 192.34Z"
            fill="white"
          />
          <path
            d="M364.364 188.986C362.28 188.986 360.596 190.671 360.596 192.759C360.596 194.847 362.28 196.532 364.364 196.532C366.448 196.532 368.141 194.847 368.141 192.759C368.141 190.671 366.444 188.986 364.364 188.986Z"
            fill="white"
          />
          <path
            d="M366.02 185.846C363.957 185.846 362.285 187.522 362.285 189.589C362.285 191.655 363.961 193.332 366.02 193.332C368.078 193.332 369.767 191.655 369.767 189.589C369.767 187.522 368.091 185.846 366.02 185.846Z"
            fill="white"
          />
          <path
            d="M367.245 182.881C365.204 182.881 363.549 184.536 363.549 186.577C363.549 188.618 365.204 190.273 367.245 190.273C369.286 190.273 370.941 188.623 370.941 186.577C370.941 184.532 369.286 182.881 367.245 182.881Z"
            fill="white"
          />
          <path
            d="M368.09 180.027C366.062 180.027 364.428 181.661 364.428 183.69C364.428 185.718 366.062 187.344 368.09 187.344C370.119 187.344 371.744 185.71 371.744 183.69C371.744 181.67 370.11 180.027 368.09 180.027Z"
            fill="white"
          />
          <path
            d="M368.629 184.457C370.628 184.457 372.249 182.836 372.249 180.837C372.249 178.837 370.628 177.217 368.629 177.217C366.629 177.217 365.009 178.837 365.009 180.837C365.009 182.836 366.629 184.457 368.629 184.457Z"
            fill="white"
          />
          <path
            d="M368.964 174.354C366.987 174.354 365.374 175.958 365.374 177.939C365.374 179.921 366.987 181.525 368.964 181.525C370.942 181.525 372.554 179.921 372.554 177.939C372.554 175.958 370.942 174.354 368.964 174.354Z"
            fill="white"
          />
          <path
            d="M369.202 171.336C367.254 171.336 365.684 172.915 365.684 174.854C365.684 176.793 367.254 178.381 369.202 178.381C371.15 178.381 372.72 176.798 372.72 174.854C372.72 172.91 371.15 171.336 369.202 171.336Z"
            fill="white"
          />
          <path
            d="M369.516 167.955C367.589 167.955 366.04 169.517 366.04 171.431C366.04 173.345 367.589 174.906 369.516 174.906C371.442 174.906 372.991 173.349 372.991 171.431C372.991 169.513 371.43 167.955 369.516 167.955Z"
            fill="white"
          />
          <path
            d="M370.132 164.01C368.239 164.01 366.707 165.55 366.707 167.443C366.707 169.336 368.239 170.872 370.132 170.872C372.024 170.872 373.565 169.336 373.565 167.443C373.565 165.55 372.024 164.01 370.132 164.01Z"
            fill="white"
          />
          <path
            d="M386.224 164.835C386.953 163.085 386.126 161.075 384.375 160.346C382.625 159.616 380.615 160.444 379.886 162.194C379.157 163.944 379.984 165.954 381.735 166.684C383.485 167.413 385.495 166.585 386.224 164.835Z"
            fill="white"
          />
          <path
            d="M396.536 155.766C394.643 155.766 393.103 157.306 393.103 159.199C393.103 161.092 394.643 162.641 396.536 162.641C398.428 162.641 399.982 161.104 399.982 159.199C399.982 157.293 398.441 155.766 396.536 155.766Z"
            fill="white"
          />
          <path
            d="M410.761 151.008C408.856 151.008 407.315 152.548 407.315 154.441C407.315 156.334 408.856 157.887 410.761 157.887C412.667 157.887 414.207 156.346 414.207 154.441C414.207 152.536 412.658 151.008 410.761 151.008Z"
            fill="white"
          />
          <path
            d="M426.081 145.119C424.188 145.119 422.647 146.66 422.647 148.565C422.647 150.471 424.188 152.011 426.081 152.011C427.973 152.011 429.527 150.471 429.527 148.565C429.527 146.66 427.986 145.119 426.081 145.119Z"
            fill="white"
          />
          <path
            d="M442.746 138.26C440.853 138.26 439.3 139.809 439.3 141.714C439.3 143.62 440.849 145.16 442.746 145.16C444.643 145.16 446.2 143.62 446.2 141.714C446.2 139.809 444.651 138.26 442.746 138.26Z"
            fill="white"
          />
          <path
            d="M461.083 130.359C459.177 130.359 457.637 131.9 457.637 133.805C457.637 135.711 459.177 137.26 461.083 137.26C462.988 137.26 464.529 135.706 464.529 133.805C464.529 131.904 462.988 130.359 461.083 130.359Z"
            fill="white"
          />
          <path
            d="M481.287 120.941C479.382 120.941 477.833 122.482 477.833 124.392C477.833 126.301 479.382 127.842 481.287 127.842C483.193 127.842 484.742 126.301 484.742 124.392C484.742 122.482 483.193 120.941 481.287 120.941Z"
            fill="white"
          />
          <path
            d="M503.266 110.357C501.352 110.357 499.812 111.911 499.812 113.812C499.812 115.713 501.352 117.27 503.266 117.27C505.18 117.27 506.72 115.726 506.72 113.812C506.72 111.898 505.171 110.357 503.266 110.357Z"
            fill="white"
          />
          <path
            d="M526.623 98.4805C524.718 98.4805 523.169 100.029 523.169 101.939C523.169 103.849 524.722 105.398 526.623 105.398C528.525 105.398 530.09 103.849 530.09 101.939C530.09 100.029 528.537 98.4805 526.623 98.4805Z"
            fill="white"
          />
          <path
            d="M550.542 85.5547C548.628 85.5547 547.075 87.1079 547.075 89.0218C547.075 90.9358 548.624 92.4805 550.542 92.4805C552.461 92.4805 554.009 90.9315 554.009 89.0218C554.009 87.1121 552.461 85.5547 550.542 85.5547Z"
            fill="white"
          />
          <path
            d="M574.209 78.7527C576.124 78.7527 577.676 77.2004 577.676 75.2855C577.676 73.3707 576.124 71.8184 574.209 71.8184C572.294 71.8184 570.742 73.3707 570.742 75.2855C570.742 77.2004 572.294 78.7527 574.209 78.7527Z"
            fill="white"
          />
          <path
            d="M596.794 57.7363C594.88 57.7363 593.318 59.2895 593.318 61.2035C593.318 63.1174 594.88 64.6749 596.794 64.6749C598.708 64.6749 600.261 63.1174 600.261 61.2035C600.261 59.2895 598.712 57.7363 596.794 57.7363Z"
            fill="white"
          />
          <path
            d="M618.068 44.1699C616.155 44.1699 614.593 45.7274 614.593 47.6413C614.593 49.5552 616.155 51.1169 618.068 51.1169C619.982 51.1169 621.544 49.568 621.544 47.6413C621.544 45.7146 619.982 44.1699 618.068 44.1699Z"
            fill="white"
          />
          <path
            d="M637.976 31.0488C636.049 31.0488 634.5 32.6105 634.5 34.5372C634.5 36.4638 636.049 38.0128 637.976 38.0128C639.902 38.0128 641.451 36.4511 641.451 34.5372C641.451 32.6233 639.902 31.0488 637.976 31.0488Z"
            fill="white"
          />
          <path
            d="M656.482 20.0898C654.556 20.0898 652.994 21.6515 652.994 23.5697C652.994 25.4879 654.556 27.0496 656.482 27.0496C658.409 27.0496 659.958 25.4879 659.958 23.5697C659.958 21.6515 658.405 20.0898 656.482 20.0898Z"
            fill="white"
          />
          <path
            d="M673.759 11.8867C671.832 11.8867 670.283 13.4484 670.283 15.3666C670.283 17.2848 671.832 18.8465 673.759 18.8465C675.686 18.8465 677.247 17.2848 677.247 15.3666C677.247 13.4484 675.686 11.8867 673.759 11.8867Z"
            fill="white"
          />
          <path
            d="M689.975 5.8125C688.048 5.8125 686.486 7.37844 686.486 9.30511C686.486 11.2318 688.048 12.7935 689.975 12.7935C691.901 12.7935 693.463 11.2318 693.463 9.30511C693.463 7.37844 691.901 5.8125 689.975 5.8125Z"
            fill="white"
          />
          <path
            d="M705.264 2.38477C703.329 2.38477 701.768 3.95495 701.768 5.88586C701.768 7.81677 703.329 9.38695 705.264 9.38695C707.2 9.38695 708.761 7.81677 708.761 5.88586C708.761 3.95495 707.2 2.38477 705.264 2.38477Z"
            fill="white"
          />
          <path
            d="M719.846 7.79583C721.782 7.79583 723.352 6.22644 723.352 4.29049C723.352 2.35455 721.782 0.785156 719.846 0.785156C717.91 0.785156 716.341 2.35455 716.341 4.29049C716.341 6.22644 717.91 7.79583 719.846 7.79583Z"
            fill="white"
          />
          <path
            d="M734.409 7.46799C736.319 7.14814 737.607 5.34102 737.287 3.43168C736.968 1.52234 735.16 0.233813 733.251 0.55367C731.342 0.873526 730.053 2.68064 730.373 4.58997C730.693 6.49931 732.5 7.78785 734.409 7.46799Z"
            fill="white"
          />
          <path
            d="M747.291 1.80664C745.343 1.80664 743.772 3.38532 743.772 5.32047C743.772 7.25562 745.343 8.83853 747.291 8.83853C749.238 8.83853 750.796 7.26835 750.796 5.32047C750.796 3.37258 749.226 1.80664 747.291 1.80664Z"
            fill="white"
          />
          <path
            d="M760.353 4.42578C758.418 4.42578 756.835 5.99597 756.835 7.93961C756.835 9.88324 758.418 11.4534 760.353 11.4534C762.288 11.4534 763.871 9.88324 763.871 7.93961C763.871 5.99597 762.301 4.42578 760.353 4.42578Z"
            fill="white"
          />
          <path
            d="M773.091 7.83789C771.143 7.83789 769.573 9.40808 769.573 11.356C769.573 13.3038 771.143 14.874 773.091 14.874C775.039 14.874 776.609 13.3038 776.609 11.356C776.609 9.40808 775.039 7.83789 773.091 7.83789Z"
            fill="white"
          />
          <path
            d="M779.607 20.1328C777.638 20.1328 776.047 21.7242 776.047 23.6976C776.047 25.6709 777.638 27.2623 779.607 27.2623C781.576 27.2623 783.176 25.6709 783.176 23.6976C783.176 21.7242 781.585 20.1328 779.607 20.1328Z"
            fill="white"
          />
          <path
            d="M785.832 33.8633C783.833 33.8633 782.221 35.4801 782.221 37.4747C782.221 39.4693 783.833 41.0904 785.832 41.0904C787.831 41.0904 789.444 39.465 789.444 37.4747C789.444 35.4844 787.831 33.8633 785.832 33.8633Z"
            fill="white"
          />
          <path
            d="M791.713 49.1602C789.685 49.1602 788.038 50.8067 788.038 52.8352C788.038 54.8638 789.685 56.5146 791.713 56.5146C793.742 56.5146 795.388 54.8638 795.388 52.8352C795.388 50.8067 793.742 49.1602 791.713 49.1602Z"
            fill="white"
          />
          <path
            d="M797.29 65.9141C795.241 65.9141 793.577 67.5776 793.577 69.6316C793.577 71.6856 795.241 73.3534 797.29 73.3534C799.34 73.3534 801.008 71.694 801.008 69.6316C801.008 67.5691 799.344 65.9141 797.29 65.9141Z"
            fill="white"
          />
          <path
            d="M802.628 91.2191C804.698 91.2191 806.375 89.5414 806.375 87.4718C806.375 85.4023 804.698 83.7246 802.628 83.7246C800.559 83.7246 798.881 85.4023 798.881 87.4718C798.881 89.5414 800.559 91.2191 802.628 91.2191Z"
            fill="white"
          />
          <path
            d="M807.886 101.854C805.794 101.854 804.097 103.551 804.097 105.643C804.097 107.735 805.794 109.441 807.886 109.441C809.978 109.441 811.685 107.74 811.685 105.643C811.685 103.547 809.987 101.854 807.886 101.854Z"
            fill="white"
          />
          <path
            d="M813.225 119.398C811.104 119.398 809.385 121.121 809.385 123.235C809.385 125.348 811.104 127.075 813.225 127.075C815.347 127.075 817.066 125.357 817.066 123.235C817.066 121.113 815.347 119.398 813.225 119.398Z"
            fill="white"
          />
          <path
            d="M818.742 136.119C816.608 136.119 814.872 137.846 814.872 139.989C814.872 142.133 816.608 143.86 818.742 143.86C820.877 143.86 822.625 142.128 822.625 139.989C822.625 137.851 820.89 136.119 818.742 136.119Z"
            fill="white"
          />
          <path
            d="M824.518 159.735C826.674 159.735 828.422 157.985 828.422 155.826C828.422 153.668 826.674 151.918 824.518 151.918C822.361 151.918 820.613 153.668 820.613 155.826C820.613 157.985 822.361 159.735 824.518 159.735Z"
            fill="white"
          />
          <path
            d="M830.594 166.664C828.417 166.664 826.66 168.434 826.66 170.611C826.66 172.788 828.417 174.545 830.594 174.545C832.771 174.545 834.541 172.784 834.541 170.611C834.541 168.438 832.771 166.664 830.594 166.664Z"
            fill="white"
          />
          <path
            d="M839.819 187.025C841.372 185.472 841.372 182.954 839.819 181.401C838.266 179.848 835.748 179.848 834.196 181.401C832.643 182.954 832.643 185.472 834.196 187.025C835.748 188.578 838.266 188.578 839.819 187.025Z"
            fill="white"
          />
          <path
            d="M843.72 192.684C841.514 192.684 839.723 194.483 839.723 196.69C839.723 198.896 841.514 200.696 843.72 200.696C845.927 200.696 847.726 198.905 847.726 196.69C847.726 194.474 845.936 192.684 843.72 192.684Z"
            fill="white"
          />
          <path
            d="M850.702 204.154C848.487 204.154 846.684 205.954 846.684 208.173C846.684 210.393 848.483 212.2 850.702 212.2C852.922 212.2 854.73 210.401 854.73 208.173C854.73 205.945 852.93 204.154 850.702 204.154Z"
            fill="white"
          />
          <path
            d="M857.925 214.729C855.688 214.729 853.876 216.549 853.876 218.786C853.876 221.022 855.688 222.834 857.925 222.834C860.161 222.834 861.973 221.022 861.973 218.786C861.973 216.549 860.161 214.729 857.925 214.729Z"
            fill="white"
          />
          <path
            d="M865.368 224.49C863.111 224.49 861.277 226.324 861.277 228.568C861.277 230.813 863.111 232.647 865.368 232.647C867.626 232.647 869.447 230.826 869.447 228.568C869.447 226.311 867.613 224.49 865.368 224.49Z"
            fill="white"
          />
          <path
            d="M873.019 233.502C870.749 233.502 868.92 235.344 868.92 237.601C868.92 239.859 870.753 241.701 873.019 241.701C875.286 241.701 877.11 239.868 877.11 237.601C877.11 235.335 875.277 233.502 873.019 233.502Z"
            fill="white"
          />
          <path
            d="M880.854 241.801C878.584 241.801 876.742 243.643 876.742 245.913C876.742 248.183 878.584 250.034 880.854 250.034C883.125 250.034 884.975 248.192 884.975 245.913C884.975 243.634 883.133 241.801 880.854 241.801Z"
            fill="white"
          />
          <path
            d="M888.891 249.383C886.612 249.383 884.758 251.225 884.758 253.503C884.758 255.782 886.612 257.637 888.891 257.637C891.17 257.637 893.012 255.787 893.012 253.503C893.012 251.22 891.17 249.383 888.891 249.383Z"
            fill="white"
          />
          <path
            d="M897.103 256.297C894.811 256.297 892.948 258.16 892.948 260.451C892.948 262.743 894.811 264.602 897.103 264.602C899.395 264.602 901.258 262.739 901.258 260.451C901.258 258.164 899.395 256.297 897.103 256.297Z"
            fill="white"
          />
          <path
            d="M905.501 262.625C903.201 262.625 901.347 264.475 901.347 266.78C901.347 269.084 903.197 270.93 905.501 270.93C907.806 270.93 909.656 269.067 909.656 266.78C909.656 264.492 907.793 262.625 905.501 262.625Z"
            fill="white"
          />
          <path
            d="M914.078 268.338C911.787 268.338 909.924 270.192 909.924 272.493C909.924 274.793 911.787 276.647 914.078 276.647C916.37 276.647 918.233 274.784 918.233 272.493C918.233 270.201 916.37 268.338 914.078 268.338Z"
            fill="white"
          />
          <path
            d="M922.808 273.428C920.516 273.428 918.653 275.291 918.653 277.582C918.653 279.874 920.516 281.737 922.808 281.737C925.1 281.737 926.963 279.874 926.963 277.582C926.963 275.291 925.112 273.428 922.808 273.428Z"
            fill="white"
          />
          <path
            d="M931.657 277.893C929.365 277.893 927.502 279.756 927.502 282.047C927.502 284.339 929.365 286.202 931.657 286.202C933.948 286.202 935.811 284.347 935.811 282.047C935.811 279.747 933.948 277.893 931.657 277.893Z"
            fill="white"
          />
          <path
            d="M926.411 280.602C924.119 280.602 922.256 282.456 922.256 284.756C922.256 287.056 924.119 288.911 926.411 288.911C928.702 288.911 930.565 287.048 930.565 284.756C930.565 282.465 928.715 280.602 926.411 280.602Z"
            fill="white"
          />
          <path
            d="M921.08 283.34C918.78 283.34 916.926 285.203 916.926 287.494C916.926 289.786 918.78 291.649 921.08 291.649C923.381 291.649 925.235 289.795 925.235 287.494C925.235 285.194 923.372 283.34 921.08 283.34Z"
            fill="white"
          />
          <path
            d="M915.648 286.176C913.356 286.176 911.493 288.039 911.493 290.33C911.493 292.622 913.356 294.485 915.648 294.485C917.939 294.485 919.802 292.631 919.802 290.33C919.802 288.03 917.948 286.176 915.648 286.176Z"
            fill="white"
          />
          <path
            d="M910.123 289.174C907.823 289.174 905.969 291.037 905.969 293.328C905.969 295.62 907.819 297.492 910.123 297.492C912.428 297.492 914.278 295.629 914.278 293.328C914.278 291.028 912.415 289.174 910.123 289.174Z"
            fill="white"
          />
          <path
            d="M904.461 292.381C902.17 292.381 900.307 294.244 900.307 296.544C900.307 298.844 902.17 300.699 904.461 300.699C906.753 300.699 908.616 298.836 908.616 296.544C908.616 294.252 906.753 292.381 904.461 292.381Z"
            fill="white"
          />
          <path
            d="M898.653 295.844C896.361 295.844 894.498 297.698 894.498 299.998C894.498 302.298 896.361 304.153 898.653 304.153C900.944 304.153 902.807 302.29 902.807 299.998C902.807 297.707 900.944 295.844 898.653 295.844Z"
            fill="white"
          />
          <path
            d="M892.656 299.59C890.364 299.59 888.501 301.453 888.501 303.744C888.501 306.036 890.364 307.895 892.656 307.895C894.947 307.895 896.81 306.032 896.81 303.744C896.81 301.457 894.96 299.59 892.656 299.59Z"
            fill="white"
          />
          <path
            d="M886.443 303.703C884.151 303.703 882.301 305.558 882.301 307.845C882.301 310.132 884.151 311.987 886.443 311.987C888.734 311.987 890.585 310.124 890.585 307.845C890.585 305.566 888.73 303.703 886.443 303.703Z"
            fill="white"
          />
          <path
            d="M879.992 308.201C877.713 308.201 875.871 310.051 875.871 312.335C875.871 314.618 877.713 316.455 879.992 316.455C882.271 316.455 884.113 314.605 884.113 312.335C884.113 310.064 882.271 308.201 879.992 308.201Z"
            fill="white"
          />
          <path
            d="M873.278 313.104C871.008 313.104 869.166 314.945 869.166 317.224C869.166 319.503 871.008 321.336 873.278 321.336C875.549 321.336 877.39 319.495 877.39 317.224C877.39 314.954 875.549 313.104 873.278 313.104Z"
            fill="white"
          />
          <path
            d="M866.315 318.422C864.058 318.422 862.216 320.264 862.216 322.521C862.216 324.779 864.058 326.621 866.315 326.621C868.573 326.621 870.415 324.779 870.415 322.521C870.415 320.264 868.573 318.422 866.315 318.422Z"
            fill="white"
          />
          <path
            d="M859.134 324.123C856.885 324.123 855.056 325.944 855.056 328.201C855.056 330.459 856.889 332.28 859.134 332.28C861.379 332.28 863.212 330.446 863.212 328.201C863.212 325.956 861.392 324.123 859.134 324.123Z"
            fill="white"
          />
          <path
            d="M851.797 330.121C849.56 330.121 847.735 331.942 847.735 334.178C847.735 336.415 849.556 338.235 851.797 338.235C854.037 338.235 855.845 336.415 855.845 334.178C855.845 331.942 854.033 330.121 851.797 330.121Z"
            fill="white"
          />
          <path
            d="M844.345 336.299C842.117 336.299 840.305 338.098 840.305 340.339C840.305 342.58 842.117 344.379 844.345 344.379C846.573 344.379 848.385 342.567 848.385 340.339C848.385 338.111 846.585 336.299 844.345 336.299Z"
            fill="white"
          />
          <path
            d="M836.859 342.547C834.643 342.547 832.84 344.346 832.84 346.574C832.84 348.802 834.639 350.593 836.859 350.593C839.078 350.593 840.877 348.794 840.877 346.574C840.877 344.355 839.078 342.547 836.859 342.547Z"
            fill="white"
          />
          <path
            d="M829.398 356.72C831.594 356.72 833.375 354.94 833.375 352.744C833.375 350.548 831.594 348.768 829.398 348.768C827.202 348.768 825.422 350.548 825.422 352.744C825.422 354.94 827.202 356.72 829.398 356.72Z"
            fill="white"
          />
          <path
            d="M821.989 354.777C819.804 354.777 818.034 356.547 818.034 358.733C818.034 360.918 819.804 362.675 821.989 362.675C824.175 362.675 825.932 360.905 825.932 358.733C825.932 356.56 824.162 354.777 821.989 354.777Z"
            fill="white"
          />
          <path
            d="M814.516 360.947C812.339 360.947 810.582 362.708 810.582 364.881C810.582 367.054 812.343 368.807 814.516 368.807C816.689 368.807 818.441 367.05 818.441 364.881C818.441 362.713 816.68 360.947 814.516 360.947Z"
            fill="white"
          />
          <path
            d="M806.792 367.818C804.636 367.818 802.888 369.567 802.888 371.723C802.888 373.878 804.636 375.627 806.792 375.627C808.948 375.627 810.683 373.878 810.683 371.723C810.683 369.567 808.944 367.818 806.792 367.818Z"
            fill="white"
          />
          <path
            d="M798.789 375.445C796.654 375.445 794.927 377.173 794.927 379.294C794.927 381.416 796.654 383.156 798.789 383.156C800.923 383.156 802.638 381.429 802.638 379.294C802.638 377.16 800.91 375.445 798.789 375.445Z"
            fill="white"
          />
          <path
            d="M790.462 383.834C788.349 383.834 786.643 385.54 786.643 387.653C786.643 389.767 788.349 391.473 790.462 391.473C792.575 391.473 794.281 389.767 794.281 387.653C794.281 385.54 792.575 383.834 790.462 383.834Z"
            fill="white"
          />
          <path
            d="M781.805 393.006C779.713 393.006 778.007 394.703 778.007 396.804C778.007 398.905 779.713 400.594 781.805 400.594C783.897 400.594 785.595 398.896 785.595 396.804C785.595 394.712 783.897 393.006 781.805 393.006Z"
            fill="white"
          />
          <path
            d="M777.586 405.328C775.536 405.328 773.881 406.992 773.881 409.033C773.881 411.074 775.536 412.738 777.586 412.738C779.635 412.738 781.282 411.083 781.282 409.033C781.282 406.983 779.627 405.328 777.586 405.328Z"
            fill="white"
          />
          <path
            d="M763.692 414.027C761.651 414.027 759.996 415.682 759.996 417.732C759.996 419.782 761.651 421.428 763.692 421.428C765.734 421.428 767.397 419.773 767.397 417.732C767.397 415.691 765.742 414.027 763.692 414.027Z"
            fill="white"
          />
          <path
            d="M749.561 423.336C747.511 423.336 745.856 424.991 745.856 427.032C745.856 429.073 747.511 430.729 749.561 430.729C751.611 430.729 753.258 429.073 753.258 427.032C753.258 424.991 751.602 423.336 749.561 423.336Z"
            fill="white"
          />
          <path
            d="M735.188 433.182C733.159 433.182 731.504 434.837 731.504 436.878C731.504 438.919 733.159 440.562 735.188 440.562C737.216 440.562 738.884 438.915 738.884 436.878C738.884 434.841 737.229 433.182 735.188 433.182Z"
            fill="white"
          />
          <path
            d="M720.698 443.65C718.657 443.65 717.002 445.297 717.002 447.334C717.002 449.371 718.657 451.03 720.698 451.03C722.739 451.03 724.395 449.375 724.395 447.334C724.395 445.293 722.739 443.65 720.698 443.65Z"
            fill="white"
          />
          <path
            d="M706.067 461.948C708.096 461.948 709.742 460.302 709.742 458.273C709.742 456.243 708.096 454.598 706.067 454.598C704.037 454.598 702.392 456.243 702.392 458.273C702.392 460.302 704.037 461.948 706.067 461.948Z"
            fill="white"
          />
          <path
            d="M691.278 465.578C689.249 465.578 687.603 467.225 687.603 469.253C687.603 471.282 689.249 472.916 691.278 472.916C693.306 472.916 694.94 471.273 694.94 469.253C694.94 467.233 693.293 465.578 691.278 465.578Z"
            fill="white"
          />
          <path
            d="M676.453 476.445C674.433 476.445 672.791 478.088 672.791 480.108C672.791 482.128 674.438 483.783 676.453 483.783C678.469 483.783 680.128 482.136 680.128 480.108C680.128 478.079 678.482 476.445 676.453 476.445Z"
            fill="white"
          />
          <path
            d="M661.635 486.895C659.615 486.895 657.973 488.541 657.973 490.557C657.973 492.573 659.619 494.219 661.635 494.219C663.651 494.219 665.297 492.585 665.297 490.557C665.297 488.528 663.664 486.895 661.635 486.895Z"
            fill="white"
          />
          <path
            d="M646.823 496.488C644.795 496.488 643.161 498.135 643.161 500.163C643.161 502.192 644.795 503.826 646.823 503.826C648.852 503.826 650.486 502.179 650.486 500.163C650.486 498.148 648.839 496.488 646.823 496.488Z"
            fill="white"
          />
          <path
            d="M632.212 505.316C630.192 505.316 628.55 506.95 628.55 508.979C628.55 511.007 630.196 512.633 632.212 512.633C634.228 512.633 635.875 510.999 635.875 508.979C635.875 506.959 634.228 505.316 632.212 505.316Z"
            fill="white"
          />
          <path
            d="M617.86 513.34C615.84 513.34 614.197 514.974 614.197 516.994C614.197 519.014 615.844 520.656 617.86 520.656C619.875 520.656 621.513 519.009 621.513 516.994C621.513 514.978 619.88 513.34 617.86 513.34Z"
            fill="white"
          />
          <path
            d="M603.715 520.49C601.695 520.49 600.062 522.124 600.062 524.144C600.062 526.164 601.695 527.798 603.715 527.798C605.735 527.798 607.369 526.164 607.369 524.144C607.369 522.124 605.735 520.49 603.715 520.49Z"
            fill="white"
          />
          <path
            d="M589.831 527.184C587.811 527.184 586.177 528.817 586.177 530.837C586.177 532.857 587.811 534.491 589.831 534.491C591.851 534.491 593.484 532.857 593.484 530.837C593.484 528.817 591.851 527.184 589.831 527.184Z"
            fill="white"
          />
          <path
            d="M576.186 533.762C574.179 533.762 572.545 535.396 572.545 537.416C572.545 539.436 574.179 541.057 576.186 541.057C578.193 541.057 579.827 539.423 579.827 537.416C579.827 535.408 578.206 533.762 576.186 533.762Z"
            fill="white"
          />
          <path
            d="M562.759 540.285C560.739 540.285 559.118 541.919 559.118 543.939C559.118 545.959 560.744 547.58 562.759 547.58C564.775 547.58 566.4 545.946 566.4 543.939C566.4 541.932 564.767 540.285 562.759 540.285Z"
            fill="white"
          />
          <path
            d="M549.498 546.688C547.49 546.688 545.856 548.321 545.856 550.329C545.856 552.336 547.49 553.97 549.498 553.97C551.505 553.97 553.139 552.336 553.139 550.329C553.139 548.321 551.505 546.688 549.498 546.688Z"
            fill="white"
          />
          <path
            d="M536.342 552.943C534.322 552.943 532.701 554.577 532.701 556.585C532.701 558.592 534.327 560.226 536.342 560.226C538.358 560.226 539.975 558.592 539.975 556.585C539.975 554.577 538.35 552.943 536.342 552.943Z"
            fill="white"
          />
          <path
            d="M523.25 559.115C521.229 559.115 519.608 560.741 519.608 562.748C519.608 564.755 521.234 566.389 523.25 566.389C525.265 566.389 526.882 564.764 526.882 562.748C526.882 560.732 525.257 559.115 523.25 559.115Z"
            fill="white"
          />
          <path
            d="M510.187 565.045C508.167 565.045 506.533 566.679 506.533 568.699C506.533 570.719 508.167 572.34 510.187 572.34C512.207 572.34 513.828 570.706 513.828 568.699C513.828 566.691 512.194 565.045 510.187 565.045Z"
            fill="white"
          />
          <path
            d="M497.083 570.707C495.063 570.707 493.429 572.341 493.429 574.361C493.429 576.381 495.063 578.002 497.083 578.002C499.103 578.002 500.724 576.368 500.724 574.361C500.724 572.354 499.09 570.707 497.083 570.707Z"
            fill="white"
          />
          <path
            d="M483.92 575.973C481.912 575.973 480.287 577.598 480.287 579.605C480.287 581.613 481.908 583.246 483.92 583.246C485.931 583.246 487.561 581.613 487.561 579.605C487.561 577.598 485.927 575.973 483.92 575.973Z"
            fill="white"
          />
          <path
            d="M470.679 580.795C468.672 580.795 467.047 582.42 467.047 584.436C467.047 586.452 468.672 588.069 470.679 588.069C472.687 588.069 474.321 586.443 474.321 584.436C474.321 582.429 472.687 580.795 470.679 580.795Z"
            fill="white"
          />
          <path
            d="M457.336 585.018C455.329 585.018 453.703 586.651 453.703 588.65C453.703 590.649 455.329 592.283 457.336 592.283C459.343 592.283 460.968 590.657 460.968 588.65C460.968 586.643 459.343 585.018 457.336 585.018Z"
            fill="white"
          />
          <path
            d="M443.871 588.508C441.864 588.508 440.238 590.142 440.238 592.14C440.238 594.139 441.864 595.773 443.871 595.773C445.878 595.773 447.504 594.148 447.504 592.14C447.504 590.133 445.878 588.508 443.871 588.508Z"
            fill="white"
          />
          <path
            d="M435.18 585.383C433.138 585.383 431.483 587.038 431.483 589.079C431.483 591.12 433.138 592.775 435.18 592.775C437.221 592.775 438.876 591.12 438.876 589.079C438.876 587.038 437.221 585.383 435.18 585.383Z"
            fill="white"
          />
          <path
            d="M426.552 581.326C424.503 581.326 422.835 582.99 422.835 585.044C422.835 587.098 424.499 588.77 426.552 588.77C428.606 588.77 430.278 587.106 430.278 585.044C430.278 582.981 428.602 581.326 426.552 581.326Z"
            fill="white"
          />
          <path
            d="M418.077 576.037C416.006 576.037 414.33 577.713 414.33 579.784C414.33 581.855 416.006 583.54 418.077 583.54C420.148 583.54 421.833 581.855 421.833 579.784C421.833 577.713 420.157 576.037 418.077 576.037Z"
            fill="white"
          />
          <path
            d="M409.886 569.293C407.794 569.293 406.097 570.978 406.097 573.07C406.097 575.162 407.794 576.847 409.886 576.847C411.979 576.847 413.663 575.162 413.663 573.07C413.663 570.978 411.966 569.293 409.886 569.293Z"
            fill="white"
          />
          <path
            d="M402.083 560.832C399.97 560.832 398.251 562.538 398.251 564.651C398.251 566.765 399.97 568.471 402.083 568.471C404.196 568.471 405.902 566.765 405.902 564.651C405.902 562.538 404.196 560.832 402.083 560.832Z"
            fill="white"
          />
          <path
            d="M394.818 550.4C392.696 550.4 390.969 552.119 390.969 554.241C390.969 556.363 392.696 558.09 394.818 558.09C396.94 558.09 398.667 556.371 398.667 554.241C398.667 552.111 396.94 550.4 394.818 550.4Z"
            fill="white"
          />
          <path
            d="M388.218 537.777C386.075 537.777 384.335 539.517 384.335 541.66C384.335 543.803 386.075 545.543 388.218 545.543C390.361 545.543 392.101 543.803 392.101 541.66C392.101 539.517 390.365 537.777 388.218 537.777Z"
            fill="white"
          />
          <path
            d="M382.349 522.834C380.185 522.834 378.437 524.595 378.437 526.747C378.437 528.898 380.185 530.659 382.349 530.659C384.514 530.659 386.254 528.911 386.254 526.747C386.254 524.582 384.505 522.834 382.349 522.834Z"
            fill="white"
          />
          <path
            d="M377.125 505.689C374.94 505.689 373.183 507.446 373.183 509.636C373.183 511.826 374.94 513.57 377.125 513.57C379.311 513.57 381.059 511.809 381.059 509.636C381.059 507.463 379.302 505.689 377.125 505.689Z"
            fill="white"
          />
          <path
            d="M372.303 486.844C370.118 486.844 368.34 488.613 368.34 490.807C368.34 493.001 370.118 494.771 372.303 494.771C374.489 494.771 376.267 492.993 376.267 490.807C376.267 488.622 374.498 486.844 372.303 486.844Z"
            fill="white"
          />
          <path
            d="M367.547 467.141C365.353 467.141 363.57 468.919 363.57 471.117C363.57 473.315 365.348 475.093 367.547 475.093C369.745 475.093 371.523 473.315 371.523 471.117C371.523 468.919 369.745 467.141 367.547 467.141Z"
            fill="white"
          />
          <path
            d="M362.489 455.597C364.697 455.597 366.486 453.807 366.486 451.599C366.486 449.391 364.697 447.602 362.489 447.602C360.281 447.602 358.491 449.391 358.491 451.599C358.491 453.807 360.281 455.597 362.489 455.597Z"
            fill="white"
          />
          <path
            d="M356.911 429.162C354.696 429.162 352.893 430.961 352.893 433.181C352.893 435.4 354.692 437.208 356.911 437.208C359.131 437.208 360.939 435.409 360.939 433.181C360.939 430.953 359.139 429.162 356.911 429.162Z"
            fill="white"
          />
          <path
            d="M350.721 412.354C348.505 412.354 346.693 414.166 346.693 416.394C346.693 418.622 348.505 420.421 350.721 420.421C352.936 420.421 354.761 418.622 354.761 416.394C354.761 414.166 352.949 412.354 350.721 412.354Z"
            fill="white"
          />
          <path
            d="M344.057 396.637C341.829 396.637 340.009 398.449 340.009 400.685C340.009 402.922 341.829 404.734 344.057 404.734C346.285 404.734 348.106 402.922 348.106 400.685C348.106 398.449 346.294 396.637 344.057 396.637Z"
            fill="white"
          />
          <path
            d="M337.021 381.568C334.784 381.568 332.964 383.38 332.964 385.625C332.964 387.87 334.784 389.682 337.021 389.682C339.257 389.682 341.078 387.862 341.078 385.625C341.078 383.389 339.257 381.568 337.021 381.568Z"
            fill="white"
          />
          <path
            d="M329.562 367.59C327.313 367.59 325.492 369.41 325.492 371.647C325.492 373.883 327.313 375.717 329.562 375.717C331.811 375.717 333.632 373.896 333.632 371.647C333.632 369.398 331.811 367.59 329.562 367.59Z"
            fill="white"
          />
          <path
            d="M321.702 354.852C319.445 354.852 317.611 356.672 317.611 358.93C317.611 361.188 319.445 363.008 321.702 363.008C323.96 363.008 325.781 361.188 325.781 358.93C325.781 356.672 323.947 354.852 321.702 354.852Z"
            fill="white"
          />
          <path
            d="M313.532 343.275C311.275 343.275 309.441 345.109 309.441 347.366C309.441 349.624 311.275 351.445 313.532 351.445C315.79 351.445 317.611 349.611 317.611 347.366C317.611 345.121 315.777 343.275 313.532 343.275Z"
            fill="white"
          />
          <path
            d="M305.092 332.982C302.843 332.982 301.014 334.816 301.014 337.061C301.014 339.306 302.847 341.13 305.092 341.13C307.337 341.13 309.162 339.31 309.162 337.061C309.162 334.811 307.341 332.982 305.092 332.982Z"
            fill="white"
          />
          <path
            d="M296.486 323.695C294.228 323.695 292.395 325.529 292.395 327.774C292.395 330.018 294.228 331.865 296.486 331.865C298.743 331.865 300.576 330.031 300.576 327.774C300.576 325.516 298.743 323.695 296.486 323.695Z"
            fill="white"
          />
          <path
            d="M287.832 315.104C285.575 315.104 283.741 316.937 283.741 319.194C283.741 321.452 285.575 323.285 287.832 323.285C290.09 323.285 291.91 321.452 291.91 319.194C291.91 316.937 290.09 315.104 287.832 315.104Z"
            fill="white"
          />
          <path
            d="M279.226 306.984C276.977 306.984 275.147 308.818 275.147 311.063C275.147 313.308 276.981 315.154 279.226 315.154C281.471 315.154 283.317 313.32 283.317 311.063C283.317 308.805 281.483 306.984 279.226 306.984Z"
            fill="white"
          />
          <path
            d="M270.756 299.209C268.498 299.209 266.665 301.03 266.665 303.287C266.665 305.545 268.498 307.365 270.756 307.365C273.014 307.365 274.834 305.545 274.834 303.287C274.834 301.03 273.001 299.209 270.756 299.209Z"
            fill="white"
          />
          <path
            d="M277.885 286.949C275.636 286.949 273.815 288.77 273.815 291.006C273.815 293.243 275.636 295.076 277.885 295.076C280.134 295.076 281.955 293.255 281.955 291.006C281.955 288.757 280.134 286.949 277.885 286.949Z"
            fill="white"
          />
          <path
            d="M285.044 275.959C282.808 275.959 280.987 277.78 280.987 280.029C280.987 282.278 282.808 284.098 285.044 284.098C287.281 284.098 289.114 282.278 289.114 280.029C289.114 277.78 287.294 275.959 285.044 275.959Z"
            fill="white"
          />
          <path
            d="M292.165 266.049C289.929 266.049 288.108 267.869 288.108 270.11C288.108 272.351 289.929 274.167 292.165 274.167C294.402 274.167 296.222 272.355 296.222 270.11C296.222 267.865 294.402 266.049 292.165 266.049Z"
            fill="white"
          />
          <path
            d="M299.129 256.932C296.901 256.932 295.089 258.744 295.089 260.98C295.089 263.217 296.901 265.02 299.129 265.02C301.357 265.02 303.177 263.208 303.177 260.98C303.177 258.752 301.365 256.932 299.129 256.932Z"
            fill="white"
          />
          <path
            d="M305.852 248.428C303.637 248.428 301.833 250.227 301.833 252.455C301.833 254.683 303.632 256.474 305.852 256.474C308.071 256.474 309.879 254.675 309.879 252.455C309.879 250.236 308.08 248.428 305.852 248.428Z"
            fill="white"
          />
          <path
            d="M312.264 240.383C310.049 240.383 308.245 242.182 308.245 244.402C308.245 246.621 310.044 248.42 312.264 248.42C314.483 248.42 316.27 246.621 316.27 244.402C316.27 242.182 314.479 240.383 312.264 240.383Z"
            fill="white"
          />
          <path
            d="M318.35 232.682C316.135 232.682 314.344 234.473 314.344 236.688C314.344 238.903 316.135 240.685 318.35 240.685C320.565 240.685 322.347 238.894 322.347 236.688C322.347 234.481 320.557 232.682 318.35 232.682Z"
            fill="white"
          />
          <path
            d="M324.117 225.373C321.923 225.373 320.141 227.151 320.141 229.337C320.141 231.522 321.919 233.313 324.117 233.313C326.315 233.313 328.081 231.535 328.081 229.337C328.081 227.138 326.311 225.373 324.117 225.373Z"
            fill="white"
          />
          <path
            d="M329.506 218.785C327.329 218.785 325.563 220.555 325.563 222.728C325.563 224.9 327.333 226.662 329.506 226.662C331.679 226.662 333.44 224.9 333.44 222.728C333.44 220.555 331.67 218.785 329.506 218.785Z"
            fill="white"
          />
          <path
            d="M334.428 213.041C332.264 213.041 330.503 214.789 330.503 216.954C330.503 219.118 332.26 220.879 334.428 220.879C336.597 220.879 338.354 219.131 338.354 216.954C338.354 214.777 336.597 213.041 334.428 213.041Z"
            fill="white"
          />
          <path
            d="M338.884 207.938C336.728 207.938 334.992 209.677 334.992 211.829C334.992 213.981 336.732 215.721 338.884 215.721C341.035 215.721 342.775 213.981 342.775 211.829C342.775 209.677 341.027 207.938 338.884 207.938Z"
            fill="white"
          />
          <path
            d="M342.839 203.344C340.696 203.344 338.969 205.071 338.969 207.214C338.969 209.357 340.696 211.097 342.839 211.097C344.982 211.097 346.722 209.361 346.722 207.214C346.722 205.067 344.982 203.344 342.839 203.344Z"
            fill="white"
          />
          <path
            d="M346.273 199.197C344.151 199.197 342.445 200.916 342.445 203.029C342.445 205.143 344.151 206.87 346.273 206.87C348.395 206.87 350.105 205.151 350.105 203.029C350.105 200.907 348.387 199.197 346.273 199.197Z"
            fill="white"
          />
          <path
            d="M349.159 195.418C347.066 195.418 345.36 197.115 345.36 199.216C345.36 201.317 347.066 203.014 349.159 203.014C351.251 203.014 352.957 201.317 352.957 199.216C352.957 197.115 351.259 195.418 349.159 195.418Z"
            fill="white"
          />
          <path
            d="M351.51 191.945C349.43 191.945 347.741 193.63 347.741 195.714C347.741 197.797 349.426 199.482 351.51 199.482C353.593 199.482 355.287 197.797 355.287 195.714C355.287 193.63 353.602 191.945 351.51 191.945Z"
            fill="white"
          />
          <path
            d="M353.372 188.719C351.301 188.719 349.638 190.382 349.638 192.453C349.638 194.524 351.301 196.188 353.372 196.188C355.443 196.188 357.107 194.511 357.107 192.453C357.107 190.395 355.43 188.719 353.372 188.719Z"
            fill="white"
          />
          <path
            d="M354.769 185.68C352.74 185.68 351.085 187.335 351.085 189.376C351.085 191.417 352.74 193.064 354.769 193.064C356.797 193.064 358.465 191.413 358.465 189.376C358.465 187.339 356.81 185.68 354.769 185.68Z"
            fill="white"
          />
          <path
            d="M355.779 182.752C353.759 182.752 352.125 184.386 352.125 186.41C352.125 188.434 353.759 190.068 355.779 190.068C357.799 190.068 359.441 188.434 359.441 186.41C359.441 184.386 357.807 182.752 355.779 182.752Z"
            fill="white"
          />
          <path
            d="M356.453 179.916C354.454 179.916 352.842 181.533 352.842 183.532C352.842 185.531 354.454 187.143 356.453 187.143C358.452 187.143 360.073 185.531 360.073 183.532C360.073 181.533 358.448 179.916 356.453 179.916Z"
            fill="white"
          />
          <path
            d="M356.869 177.086C354.891 177.086 353.287 178.69 353.287 180.672C353.287 182.654 354.891 184.254 356.869 184.254C358.846 184.254 360.451 182.649 360.451 180.672C360.451 178.694 358.846 177.086 356.869 177.086Z"
            fill="white"
          />
          <path
            d="M357.121 174.188C355.173 174.188 353.603 175.762 353.603 177.706C353.603 179.649 355.173 181.228 357.121 181.228C359.069 181.228 360.639 179.649 360.639 177.706C360.639 175.762 359.069 174.188 357.121 174.188Z"
            fill="white"
          />
          <path
            d="M357.319 171.045C355.405 171.045 353.844 172.594 353.844 174.521C353.844 176.447 355.405 177.996 357.319 177.996C359.233 177.996 360.795 176.434 360.795 174.521C360.795 172.607 359.246 171.045 357.319 171.045Z"
            fill="white"
          />
          <path
            d="M357.65 167.488C355.757 167.488 354.217 169.029 354.217 170.921C354.217 172.814 355.757 174.35 357.65 174.35C359.543 174.35 361.083 172.814 361.083 170.921C361.083 169.029 359.543 167.488 357.65 167.488Z"
            fill="white"
          />
          <path
            d="M358.41 163.248C356.547 163.248 355.027 164.763 355.027 166.63C355.027 168.498 356.547 170.013 358.41 170.013C360.273 170.013 361.792 168.493 361.792 166.63C361.792 164.767 360.281 163.248 358.41 163.248Z"
            fill="white"
          />
          <path
            d="M371.464 159.141C369.593 159.141 368.073 160.66 368.073 162.536C368.073 164.411 369.593 165.918 371.464 165.918C373.335 165.918 374.846 164.403 374.846 162.536C374.846 160.668 373.327 159.141 371.464 159.141Z"
            fill="white"
          />
          <path
            d="M385.188 154.404C383.316 154.404 381.793 155.924 381.793 157.795C381.793 159.667 383.312 161.186 385.188 161.186C387.064 161.186 388.579 159.667 388.579 157.795C388.579 155.924 387.059 154.404 385.188 154.404Z"
            fill="white"
          />
          <path
            d="M399.761 149.182C397.889 149.182 396.37 150.701 396.37 152.572C396.37 154.444 397.889 155.963 399.761 155.963C401.632 155.963 403.156 154.444 403.156 152.572C403.156 150.701 401.637 149.182 399.761 149.182Z"
            fill="white"
          />
          <path
            d="M415.475 143.043C413.604 143.043 412.08 144.562 412.08 146.442C412.08 148.322 413.599 149.833 415.475 149.833C417.351 149.833 418.879 148.314 418.879 146.442C418.879 144.571 417.347 143.043 415.475 143.043Z"
            fill="white"
          />
          <path
            d="M432.701 135.508C430.817 135.508 429.298 137.031 429.298 138.907C429.298 140.783 430.817 142.298 432.701 142.298C434.586 142.298 436.092 140.779 436.092 138.907C436.092 137.036 434.573 135.508 432.701 135.508Z"
            fill="white"
          />
          <path
            d="M451.611 126.832C449.739 126.832 448.207 128.351 448.207 130.236C448.207 132.12 449.739 133.639 451.611 133.639C453.482 133.639 455.014 132.116 455.014 130.236C455.014 128.356 453.495 126.832 451.611 126.832Z"
            fill="white"
          />
          <path
            d="M472.504 116.512C470.633 116.512 469.101 118.035 469.101 119.915C469.101 121.795 470.633 123.319 472.504 123.319C474.376 123.319 475.908 121.795 475.908 119.915C475.908 118.035 474.388 116.512 472.504 116.512Z"
            fill="white"
          />
          <path
            d="M495.068 104.803C493.183 104.803 491.664 106.326 491.664 108.21C491.664 110.095 493.183 111.618 495.068 111.618C496.952 111.618 498.479 110.095 498.479 108.21C498.479 106.326 496.947 104.803 495.068 104.803Z"
            fill="white"
          />
          <path
            d="M518.943 91.7363C517.058 91.7363 515.526 93.2598 515.526 95.1441C515.526 97.0283 517.058 98.5518 518.943 98.5518C520.827 98.5518 522.355 97.0283 522.355 95.1441C522.355 93.2598 520.823 91.7363 518.943 91.7363Z"
            fill="white"
          />
          <path
            d="M543.068 84.4919C544.953 84.4919 546.48 82.9643 546.48 81.0799C546.48 79.1956 544.953 77.668 543.068 77.668C541.184 77.668 539.656 79.1956 539.656 81.0799C539.656 82.9643 541.184 84.4919 543.068 84.4919Z"
            fill="white"
          />
          <path
            d="M566.788 62.7402C564.904 62.7402 563.376 64.2722 563.376 66.1522C563.376 68.0322 564.908 69.5642 566.788 69.5642C568.668 69.5642 570.213 68.0322 570.213 66.1522C570.213 64.2722 568.681 62.7402 566.788 62.7402Z"
            fill="white"
          />
          <path
            d="M589.307 47.6992C587.423 47.6992 585.896 49.2312 585.896 51.1197C585.896 53.0081 587.428 54.5401 589.307 54.5401C591.187 54.5401 592.724 53.0081 592.724 51.1197C592.724 49.2312 591.192 47.6992 589.307 47.6992Z"
            fill="white"
          />
          <path
            d="M610.403 33.3691C608.51 33.3691 606.979 34.9011 606.979 36.7896C606.979 38.6781 608.506 40.2101 610.403 40.2101C612.3 40.2101 613.819 38.6781 613.819 36.7896C613.819 34.9011 612.287 33.3691 610.403 33.3691Z"
            fill="white"
          />
          <path
            d="M630.193 20.2773C628.301 20.2773 626.769 21.8093 626.769 23.702C626.769 25.5948 628.301 27.1352 630.193 27.1352C632.086 27.1352 633.618 25.5948 633.618 23.702C633.618 21.8093 632.086 20.2773 630.193 20.2773Z"
            fill="white"
          />
          <path
            d="M648.678 9.31836C646.786 9.31836 645.245 10.8546 645.245 12.7516C645.245 14.6485 646.786 16.1847 648.678 16.1847C650.571 16.1847 652.112 14.6443 652.112 12.7516C652.112 10.8588 650.58 9.31836 648.678 9.31836Z"
            fill="white"
          />
          <path
            d="M665.964 1.57031C664.058 1.57031 662.53 3.10655 662.53 4.99926C662.53 6.89197 664.062 8.43246 665.964 8.43246C667.865 8.43246 669.397 6.89622 669.397 4.99926C669.397 3.10231 667.856 1.57031 665.964 1.57031Z"
            fill="white"
          />
          <path
            d="M682.251 -4.10938C680.345 -4.10938 678.805 -2.56889 678.805 -0.66345C678.805 1.24199 680.345 2.76974 682.251 2.76974C684.156 2.76974 685.684 1.22926 685.684 -0.66345C685.684 -2.55616 684.143 -4.10938 682.251 -4.10938Z"
            fill="white"
          />
          <path
            d="M753.401 -6.49219C751.487 -6.49219 749.934 -4.94322 749.934 -3.02504C749.934 -1.10687 751.483 0.450587 753.401 0.450587C755.319 0.450587 756.876 -1.11111 756.876 -3.02504C756.876 -4.93898 755.315 -6.49219 753.401 -6.49219Z"
            fill="white"
          />
          <path
            d="M766.294 -3.33984C764.38 -3.33984 762.818 -1.79088 762.818 0.131544C762.818 2.05396 764.38 3.60293 766.294 3.60293C768.208 3.60293 769.77 2.05396 769.77 0.131544C769.77 -1.79088 768.221 -3.33984 766.294 -3.33984Z"
            fill="white"
          />
          <path
            d="M778.89 0.478516C776.976 0.478516 775.414 2.03597 775.414 3.95415C775.414 5.87232 776.976 7.43402 778.89 7.43402C780.804 7.43402 782.378 5.87656 782.378 3.95415C782.378 2.03173 780.816 0.478516 778.89 0.478516Z"
            fill="white"
          />
          <path
            d="M785.54 12.1699C783.592 12.1699 782.021 13.7528 782.021 15.6965C782.021 17.6401 783.592 19.2145 785.54 19.2145C787.487 19.2145 789.066 17.6444 789.066 15.6965C789.066 13.7486 787.483 12.1699 785.54 12.1699Z"
            fill="white"
          />
          <path
            d="M791.918 25.1152C789.953 25.1152 788.349 26.7109 788.349 28.6842C788.349 30.6576 789.953 32.2532 791.918 32.2532C793.882 32.2532 795.487 30.6576 795.487 28.6842C795.487 26.7109 793.895 25.1152 791.918 25.1152Z"
            fill="white"
          />
          <path
            d="M798.007 39.416C796.008 39.416 794.387 41.0414 794.387 43.0359C794.387 45.0305 796.012 46.6474 798.007 46.6474C800.001 46.6474 801.618 45.0347 801.618 43.0359C801.618 41.0371 800.005 39.416 798.007 39.416Z"
            fill="white"
          />
          <path
            d="M803.774 55.0996C801.745 55.0996 800.099 56.7462 800.099 58.7832C800.099 60.8202 801.745 62.4583 803.774 62.4583C805.802 62.4583 807.457 60.8117 807.457 58.7832C807.457 56.7547 805.815 55.0996 803.774 55.0996Z"
            fill="white"
          />
          <path
            d="M809.257 72.0742C807.207 72.0742 805.544 73.7378 805.544 75.7917C805.544 77.8457 807.207 79.5093 809.257 79.5093C811.307 79.5093 812.975 77.8457 812.975 75.7917C812.975 73.7378 811.311 72.0742 809.257 72.0742Z"
            fill="white"
          />
          <path
            d="M814.514 89.8965C812.444 89.8965 810.759 91.5812 810.759 93.6522C810.759 95.7231 812.444 97.4207 814.514 97.4207C816.585 97.4207 818.283 95.7359 818.283 93.6522C818.283 91.5685 816.598 89.8965 814.514 89.8965Z"
            fill="white"
          />
          <path
            d="M819.718 108.037C817.626 108.037 815.92 109.735 815.92 111.835C815.92 113.936 817.626 115.633 819.718 115.633C821.81 115.633 823.516 113.927 823.516 111.835C823.516 109.743 821.819 108.037 819.718 108.037Z"
            fill="white"
          />
          <path
            d="M825.035 125.723C822.913 125.723 821.194 127.45 821.194 129.572C821.194 131.694 822.913 133.412 825.035 133.412C827.157 133.412 828.884 131.694 828.884 129.572C828.884 127.45 827.157 125.723 825.035 125.723Z"
            fill="white"
          />
          <path
            d="M830.596 142.539C828.461 142.539 826.726 144.279 826.726 146.418C826.726 148.557 828.466 150.297 830.596 150.297C832.726 150.297 834.466 148.557 834.466 146.418C834.466 144.279 832.739 142.539 830.596 142.539Z"
            fill="white"
          />
          <path
            d="M836.485 158.174C834.321 158.174 832.572 159.926 832.572 162.087C832.572 164.247 834.321 165.999 836.485 165.999C838.649 165.999 840.389 164.247 840.389 162.087C840.389 159.926 838.641 158.174 836.485 158.174Z"
            fill="white"
          />
          <path
            d="M842.71 172.576C840.533 172.576 838.776 174.337 838.776 176.51C838.776 178.683 840.533 180.453 842.71 180.453C844.887 180.453 846.653 178.683 846.653 176.51C846.653 174.337 844.883 172.576 842.71 172.576Z"
            fill="white"
          />
          <path
            d="M849.276 193.744C851.472 193.744 853.253 191.964 853.253 189.767C853.253 187.571 851.472 185.791 849.276 185.791C847.08 185.791 845.3 187.571 845.3 189.767C845.3 191.964 847.08 193.744 849.276 193.744Z"
            fill="white"
          />
          <path
            d="M856.138 197.949C853.932 197.949 852.141 199.749 852.141 201.955C852.141 204.162 853.932 205.961 856.138 205.961C858.345 205.961 860.144 204.171 860.144 201.955C860.144 199.74 858.353 197.949 856.138 197.949Z"
            fill="white"
          />
          <path
            d="M863.268 209.18C861.053 209.18 859.249 210.979 859.249 213.199C859.249 215.418 861.048 217.217 863.268 217.217C865.487 217.217 867.295 215.418 867.295 213.199C867.295 210.979 865.496 209.18 863.268 209.18Z"
            fill="white"
          />
          <path
            d="M870.643 219.523C868.407 219.523 866.595 221.336 866.595 223.572C866.595 225.808 868.407 227.621 870.643 227.621C872.88 227.621 874.692 225.808 874.692 223.572C874.692 221.336 872.88 219.523 870.643 219.523Z"
            fill="white"
          />
          <path
            d="M878.265 229.018C876.007 229.018 874.187 230.851 874.187 233.096C874.187 235.341 876.007 237.174 878.265 237.174C880.522 237.174 882.343 235.354 882.343 233.096C882.343 230.838 880.51 229.018 878.265 229.018Z"
            fill="white"
          />
          <path
            d="M886.091 237.697C883.833 237.697 881.991 239.531 881.991 241.797C881.991 244.063 883.833 245.896 886.091 245.896C888.348 245.896 890.19 244.054 890.19 241.797C890.19 239.539 888.357 237.697 886.091 237.697Z"
            fill="white"
          />
          <path
            d="M894.115 245.619C891.845 245.619 890.003 247.461 890.003 249.74C890.003 252.019 891.845 253.852 894.115 253.852C896.386 253.852 898.236 252.01 898.236 249.74C898.236 247.469 896.394 245.619 894.115 245.619Z"
            fill="white"
          />
          <path
            d="M902.328 252.842C900.049 252.842 898.194 254.696 898.194 256.984C898.194 259.271 900.045 261.117 902.328 261.117C904.611 261.117 906.47 259.263 906.47 256.984C906.47 254.705 904.619 252.842 902.328 252.842Z"
            fill="white"
          />
          <path
            d="M910.717 259.42C908.425 259.42 906.575 261.283 906.575 263.575C906.575 265.866 908.425 267.716 910.717 267.716C913.009 267.716 914.872 265.866 914.872 263.575C914.872 261.283 913.017 259.42 910.717 259.42Z"
            fill="white"
          />
          <path
            d="M919.293 265.34C916.993 265.34 915.139 267.203 915.139 269.494C915.139 271.786 916.989 273.649 919.293 273.649C921.598 273.649 923.448 271.799 923.448 269.494C923.448 267.19 921.585 265.34 919.293 265.34Z"
            fill="white"
          />
          <path
            d="M928.002 270.629C925.715 270.629 923.848 272.492 923.848 274.784C923.848 277.075 925.711 278.938 928.002 278.938C930.294 278.938 932.157 277.075 932.157 274.784C932.157 272.492 930.307 270.629 928.002 270.629Z"
            fill="white"
          />
          <path
            d="M936.837 275.248C934.537 275.248 932.683 277.111 932.683 279.403C932.683 281.694 934.537 283.557 936.837 283.557C939.137 283.557 940.992 281.703 940.992 279.403C940.992 277.103 939.129 275.248 936.837 275.248Z"
            fill="white"
          />
          <path
            d="M945.719 279.225C943.427 279.225 941.564 281.088 941.564 283.379C941.564 285.671 943.427 287.534 945.719 287.534C948.011 287.534 949.874 285.671 949.874 283.379C949.874 281.088 948.011 279.225 945.719 279.225Z"
            fill="white"
          />
          <path
            d="M940.504 281.662C938.217 281.662 936.35 283.525 936.35 285.817C936.35 288.108 938.213 289.98 940.504 289.98C942.796 289.98 944.659 288.117 944.659 285.817C944.659 283.517 942.809 281.662 940.504 281.662Z"
            fill="white"
          />
          <path
            d="M935.174 284.107C932.887 284.107 931.02 285.97 931.02 288.271C931.02 290.571 932.882 292.425 935.174 292.425C937.466 292.425 939.329 290.562 939.329 288.271C939.329 285.979 937.478 284.107 935.174 284.107Z"
            fill="white"
          />
          <path
            d="M929.729 286.635C927.437 286.635 925.574 288.489 925.574 290.789C925.574 293.089 927.437 294.944 929.729 294.944C932.02 294.944 933.884 293.081 933.884 290.789C933.884 288.498 932.02 286.635 929.729 286.635Z"
            fill="white"
          />
          <path
            d="M924.161 289.281C921.861 289.281 920.007 291.144 920.007 293.436C920.007 295.728 921.861 297.591 924.161 297.591C926.462 297.591 928.316 295.736 928.316 293.436C928.316 291.136 926.453 289.281 924.161 289.281Z"
            fill="white"
          />
          <path
            d="M918.449 292.109C916.149 292.109 914.286 293.972 914.286 296.264C914.286 298.556 916.149 300.427 918.449 300.427C920.749 300.427 922.604 298.564 922.604 296.264C922.604 293.964 920.741 292.109 918.449 292.109Z"
            fill="white"
          />
          <path
            d="M912.568 295.18C910.268 295.18 908.413 297.034 908.413 299.334C908.413 301.634 910.263 303.489 912.568 303.489C914.872 303.489 916.722 301.626 916.722 299.334C916.722 297.043 914.859 295.18 912.568 295.18Z"
            fill="white"
          />
          <path
            d="M906.498 298.508C904.198 298.508 902.344 300.371 902.344 302.662C902.344 304.954 904.194 306.817 906.498 306.817C908.803 306.817 910.653 304.967 910.653 302.662C910.653 300.358 908.79 298.508 906.498 298.508Z"
            fill="white"
          />
          <path
            d="M900.214 302.176C897.923 302.176 896.072 304.03 896.072 306.318C896.072 308.605 897.923 310.451 900.214 310.451C902.506 310.451 904.356 308.597 904.356 306.318C904.356 304.039 902.506 302.176 900.214 302.176Z"
            fill="white"
          />
          <path
            d="M893.687 306.17C891.408 306.17 889.554 308.024 889.554 310.303C889.554 312.582 891.408 314.437 893.687 314.437C895.966 314.437 897.808 312.586 897.808 310.303C897.808 308.02 895.966 306.17 893.687 306.17Z"
            fill="white"
          />
          <path
            d="M886.901 310.553C884.622 310.553 882.78 312.395 882.78 314.673C882.78 316.952 884.622 318.794 886.901 318.794C889.18 318.794 891.022 316.952 891.022 314.673C891.022 312.395 889.18 310.553 886.901 310.553Z"
            fill="white"
          />
          <path
            d="M879.878 315.352C877.607 315.352 875.778 317.185 875.778 319.451C875.778 321.717 877.612 323.55 879.878 323.55C882.144 323.55 883.977 321.709 883.977 319.451C883.977 317.193 882.144 315.352 879.878 315.352Z"
            fill="white"
          />
          <path
            d="M872.634 320.514C870.385 320.514 868.556 322.347 868.556 324.605C868.556 326.862 870.389 328.683 872.634 328.683C874.879 328.683 876.725 326.862 876.725 324.605C876.725 322.347 874.892 320.514 872.634 320.514Z"
            fill="white"
          />
          <path
            d="M865.233 326.039C862.996 326.039 861.176 327.851 861.176 330.1C861.176 332.349 862.996 334.149 865.233 334.149C867.469 334.149 869.294 332.337 869.294 330.1C869.294 327.864 867.473 326.039 865.233 326.039Z"
            fill="white"
          />
          <path
            d="M857.729 331.805C855.501 331.805 853.688 333.617 853.688 335.845C853.688 338.073 855.501 339.885 857.729 339.885C859.957 339.885 861.769 338.073 861.769 335.845C861.769 333.617 859.969 331.805 857.729 331.805Z"
            fill="white"
          />
          <path
            d="M850.193 337.697C847.977 337.697 846.174 339.497 846.174 341.725C846.174 343.953 847.973 345.743 850.193 345.743C852.412 345.743 854.211 343.944 854.211 341.725C854.211 339.505 852.412 337.697 850.193 337.697Z"
            fill="white"
          />
          <path
            d="M842.677 343.621C840.483 343.621 838.692 345.399 838.692 347.606C838.692 349.813 840.483 351.582 842.677 351.582C844.871 351.582 846.654 349.804 846.654 347.606C846.654 345.408 844.875 343.621 842.677 343.621Z"
            fill="white"
          />
          <path
            d="M835.216 349.439C833.039 349.439 831.273 351.196 831.273 353.382C831.273 355.567 833.043 357.324 835.216 357.324C837.389 357.324 839.163 355.555 839.163 353.382C839.163 351.209 837.401 349.439 835.216 349.439Z"
            fill="white"
          />
          <path
            d="M827.723 355.359C825.546 355.359 823.789 357.121 823.789 359.293C823.789 361.466 825.55 363.219 827.723 363.219C829.896 363.219 831.657 361.458 831.657 359.293C831.657 357.129 829.896 355.359 827.723 355.359Z"
            fill="white"
          />
          <path
            d="M820.019 361.914C817.864 361.914 816.128 363.662 816.128 365.818C816.128 367.974 817.868 369.723 820.019 369.723C822.171 369.723 823.924 367.974 823.924 365.818C823.924 363.662 822.175 361.914 820.019 361.914Z"
            fill="white"
          />
          <path
            d="M812.101 369.189C809.966 369.189 808.239 370.917 808.239 373.039C808.239 375.16 809.966 376.9 812.101 376.9C814.236 376.9 815.95 375.173 815.95 373.039C815.95 370.904 814.231 369.189 812.101 369.189Z"
            fill="white"
          />
          <path
            d="M803.911 377.141C801.797 377.141 800.083 378.859 800.083 380.968C800.083 383.078 801.802 384.801 803.911 384.801C806.02 384.801 807.743 383.082 807.743 380.968C807.743 378.855 806.024 377.141 803.911 377.141Z"
            fill="white"
          />
          <path
            d="M795.427 385.812C793.326 385.812 791.629 387.51 791.629 389.602C791.629 391.694 793.326 393.4 795.427 393.4C797.528 393.4 799.217 391.703 799.217 389.602C799.217 387.502 797.519 385.812 795.427 385.812Z"
            fill="white"
          />
          <path
            d="M786.621 395.17C784.55 395.17 782.874 396.846 782.874 398.917C782.874 400.988 784.55 402.664 786.621 402.664C788.692 402.664 790.368 400.988 790.368 398.917C790.368 396.846 788.692 395.17 786.621 395.17Z"
            fill="white"
          />
          <path
            d="M782.156 407.387C780.136 407.387 778.494 409.033 778.494 411.049C778.494 413.065 780.141 414.724 782.156 414.724C784.172 414.724 785.832 413.078 785.832 411.049C785.832 409.021 784.185 407.387 782.156 407.387Z"
            fill="white"
          />
          <path
            d="M768.48 416.381C766.46 416.381 764.826 418.027 764.826 420.043C764.826 422.059 766.46 423.697 768.48 423.697C770.5 423.697 772.142 422.063 772.142 420.043C772.142 418.023 770.496 416.381 768.48 416.381Z"
            fill="white"
          />
          <path
            d="M754.607 426.016C752.587 426.016 750.953 427.649 750.953 429.669C750.953 431.69 752.587 433.311 754.607 433.311C756.627 433.311 758.248 431.677 758.248 429.669C758.248 427.662 756.614 426.016 754.607 426.016Z"
            fill="white"
          />
          <path
            d="M740.526 436.207C738.506 436.207 736.872 437.841 736.872 439.861C736.872 441.881 738.506 443.515 740.526 443.515C742.546 443.515 744.167 441.881 744.167 439.861C744.167 437.841 742.533 436.207 740.526 436.207Z"
            fill="white"
          />
          <path
            d="M726.317 446.969C724.297 446.969 722.663 448.603 722.663 450.61C722.663 452.617 724.297 454.264 726.317 454.264C728.337 454.264 729.958 452.63 729.958 450.61C729.958 448.59 728.324 446.969 726.317 446.969Z"
            fill="white"
          />
          <path
            d="M712.03 458.158C710.01 458.158 708.376 459.792 708.376 461.812C708.376 463.832 710.01 465.453 712.03 465.453C714.05 465.453 715.671 463.819 715.671 461.812C715.671 459.805 714.037 458.158 712.03 458.158Z"
            fill="white"
          />
          <path
            d="M697.583 469.432C695.576 469.432 693.95 471.057 693.95 473.073C693.95 475.089 695.576 476.705 697.583 476.705C699.59 476.705 701.224 475.08 701.224 473.073C701.224 471.065 699.599 469.432 697.583 469.432Z"
            fill="white"
          />
          <path
            d="M683.065 480.432C681.045 480.432 679.424 482.066 679.424 484.073C679.424 486.08 681.049 487.714 683.065 487.714C685.081 487.714 686.698 486.08 686.698 484.073C686.698 482.066 685.072 480.432 683.065 480.432Z"
            fill="white"
          />
          <path
            d="M668.543 490.963C666.535 490.963 664.91 492.588 664.91 494.596C664.91 496.603 666.535 498.237 668.543 498.237C670.55 498.237 672.184 496.603 672.184 494.596C672.184 492.588 670.55 490.963 668.543 490.963Z"
            fill="white"
          />
          <path
            d="M654.026 500.693C652.019 500.693 650.394 502.327 650.394 504.326C650.394 506.325 652.019 507.959 654.026 507.959C656.034 507.959 657.659 506.333 657.659 504.326C657.659 502.319 656.034 500.693 654.026 500.693Z"
            fill="white"
          />
          <path
            d="M639.588 509.457C637.58 509.457 635.955 511.091 635.955 513.09C635.955 515.089 637.576 516.722 639.588 516.722C641.599 516.722 643.22 515.101 643.22 513.09C643.22 511.078 641.595 509.457 639.588 509.457Z"
            fill="white"
          />
          <path
            d="M625.406 517.389C623.407 517.389 621.786 519.014 621.786 521.021C621.786 523.029 623.411 524.641 625.406 524.641C627.401 524.641 629.026 523.016 629.026 521.021C629.026 519.027 627.401 517.389 625.406 517.389Z"
            fill="white"
          />
          <path
            d="M611.427 524.527C609.428 524.527 607.807 526.14 607.807 528.147C607.807 530.155 609.432 531.767 611.427 531.767C613.421 531.767 615.047 530.142 615.047 528.147C615.047 526.153 613.421 524.527 611.427 524.527Z"
            fill="white"
          />
          <path
            d="M597.625 530.91C595.626 530.91 594.014 532.523 594.014 534.53C594.014 536.537 595.626 538.141 597.625 538.141C599.624 538.141 601.245 536.529 601.245 534.53C601.245 532.531 599.62 530.91 597.625 530.91Z"
            fill="white"
          />
          <path
            d="M584.055 537.1C582.057 537.1 580.436 538.725 580.436 540.72C580.436 542.714 582.061 544.339 584.055 544.339C586.05 544.339 587.675 542.718 587.675 540.72C587.675 538.721 586.05 537.1 584.055 537.1Z"
            fill="white"
          />
          <path
            d="M570.679 543.271C568.68 543.271 567.067 544.884 567.067 546.883C567.067 548.882 568.68 550.494 570.679 550.494C572.678 550.494 574.29 548.873 574.29 546.883C574.29 544.893 572.678 543.271 570.679 543.271Z"
            fill="white"
          />
          <path
            d="M557.48 549.375C555.481 549.375 553.868 550.988 553.868 552.986C553.868 554.985 555.481 556.598 557.48 556.598C559.478 556.598 561.091 554.985 561.091 552.986C561.091 550.988 559.466 549.375 557.48 549.375Z"
            fill="white"
          />
          <path
            d="M544.379 555.408C542.38 555.408 540.768 557.034 540.768 559.02C540.768 561.006 542.38 562.623 544.379 562.623C546.378 562.623 547.982 561.01 547.982 559.02C547.982 557.029 546.369 555.408 544.379 555.408Z"
            fill="white"
          />
          <path
            d="M531.347 561.312C529.361 561.312 527.744 562.925 527.744 564.924C527.744 566.923 529.357 568.527 531.347 568.527C533.337 568.527 534.959 566.914 534.959 564.924C534.959 562.934 533.333 561.312 531.347 561.312Z"
            fill="white"
          />
          <path
            d="M518.357 567.117C516.371 567.117 514.754 568.73 514.754 570.72C514.754 572.71 516.367 574.319 518.357 574.319C520.347 574.319 521.96 572.706 521.96 570.72C521.96 568.734 520.347 567.117 518.357 567.117Z"
            fill="white"
          />
          <path
            d="M505.357 572.686C503.371 572.686 501.759 574.29 501.759 576.288C501.759 578.287 503.371 579.879 505.357 579.879C507.344 579.879 508.96 578.275 508.96 576.288C508.96 574.302 507.348 572.686 505.357 572.686Z"
            fill="white"
          />
          <path
            d="M492.288 577.908C490.31 577.908 488.697 579.521 488.697 581.511C488.697 583.501 490.31 585.101 492.288 585.101C494.265 585.101 495.89 583.497 495.89 581.511C495.89 579.525 494.278 577.908 492.288 577.908Z"
            fill="white"
          />
          <path
            d="M479.153 582.752C477.175 582.752 475.562 584.365 475.562 586.342C475.562 588.32 477.175 589.945 479.153 589.945C481.13 589.945 482.756 588.333 482.756 586.342C482.756 584.352 481.143 582.752 479.153 582.752Z"
            fill="white"
          />
          <path
            d="M465.926 587.08C463.94 587.08 462.314 588.693 462.314 590.683C462.314 592.673 463.94 594.282 465.926 594.282C467.912 594.282 469.529 592.669 469.529 590.683C469.529 588.697 467.916 587.08 465.926 587.08Z"
            fill="white"
          />
          <path
            d="M455.096 596.968C456.503 595.561 456.503 593.279 455.096 591.872C453.689 590.465 451.408 590.465 450.001 591.872C448.594 593.279 448.594 595.561 450.001 596.968C451.408 598.375 453.689 598.375 455.096 596.968Z"
            fill="white"
          />
          <path
            d="M439.084 593.773C437.098 593.773 435.485 595.378 435.485 597.364C435.485 599.35 437.098 600.962 439.084 600.962C441.07 600.962 442.674 599.35 442.674 597.364C442.674 595.378 441.07 593.773 439.084 593.773Z"
            fill="white"
          />
          <path
            d="M430.33 591.234C428.322 591.234 426.688 592.86 426.688 594.867C426.688 596.874 428.322 598.5 430.33 598.5C432.337 598.5 433.962 596.866 433.962 594.867C433.962 592.868 432.328 591.234 430.33 591.234Z"
            fill="white"
          />
          <path
            d="M421.557 587.869C419.515 587.869 417.873 589.516 417.873 591.553C417.873 593.59 419.515 595.236 421.557 595.236C423.598 595.236 425.24 593.59 425.24 591.553C425.24 589.516 423.585 587.869 421.557 587.869Z"
            fill="white"
          />
          <path
            d="M412.831 583.553C410.769 583.553 409.105 585.216 409.105 587.279C409.105 589.341 410.769 590.992 412.831 590.992C414.894 590.992 416.545 589.328 416.545 587.279C416.545 585.229 414.881 583.553 412.831 583.553Z"
            fill="white"
          />
          <path
            d="M404.246 578.096C402.175 578.096 400.499 579.772 400.499 581.843C400.499 583.914 402.175 585.59 404.246 585.59C406.317 585.59 407.993 583.914 407.993 581.843C407.993 579.772 406.317 578.096 404.246 578.096Z"
            fill="white"
          />
          <path
            d="M395.921 571.25C393.829 571.25 392.145 572.948 392.145 575.027C392.145 577.106 393.829 578.817 395.921 578.817C398.014 578.817 399.698 577.119 399.698 575.027C399.698 572.935 398.014 571.25 395.921 571.25Z"
            fill="white"
          />
          <path
            d="M387.968 562.861C385.854 562.861 384.148 564.567 384.148 566.681C384.148 568.794 385.854 570.513 387.968 570.513C390.081 570.513 391.787 568.794 391.787 566.681C391.787 564.567 390.081 562.861 387.968 562.861Z"
            fill="white"
          />
          <path
            d="M380.528 552.715C378.406 552.715 376.679 554.442 376.679 556.564C376.679 558.686 378.406 560.413 380.528 560.413C382.65 560.413 384.377 558.686 384.377 556.564C384.377 554.442 382.65 552.715 380.528 552.715Z"
            fill="white"
          />
          <path
            d="M373.722 540.568C371.579 540.568 369.839 542.304 369.839 544.451C369.839 546.599 371.579 548.322 373.722 548.322C375.865 548.322 377.592 546.594 377.592 544.451C377.592 542.308 375.852 540.568 373.722 540.568Z"
            fill="white"
          />
          <path
            d="M367.589 526.318C365.433 526.318 363.685 528.067 363.685 530.223C363.685 532.378 365.433 534.127 367.589 534.127C369.745 534.127 371.493 532.378 371.493 530.223C371.493 528.067 369.745 526.318 367.589 526.318Z"
            fill="white"
          />
          <path
            d="M362.073 510.104C359.896 510.104 358.139 511.873 358.139 514.046C358.139 516.219 359.9 517.98 362.073 517.98C364.245 517.98 366.015 516.219 366.015 514.046C366.015 511.873 364.245 510.104 362.073 510.104Z"
            fill="white"
          />
          <path
            d="M356.975 492.389C354.79 492.389 353.012 494.167 353.012 496.352C353.012 498.538 354.79 500.316 356.975 500.316C359.161 500.316 360.939 498.538 360.939 496.352C360.939 494.167 359.169 492.389 356.975 492.389Z"
            fill="white"
          />
          <path
            d="M352.018 473.758C349.824 473.758 348.033 475.536 348.033 477.734C348.033 479.932 349.824 481.719 352.018 481.719C354.212 481.719 355.994 479.941 355.994 477.734C355.994 475.527 354.216 473.758 352.018 473.758Z"
            fill="white"
          />
          <path
            d="M346.859 455.045C344.643 455.045 342.853 456.844 342.853 459.051C342.853 461.258 344.643 463.057 346.859 463.057C349.074 463.057 350.865 461.266 350.865 459.051C350.865 456.836 349.074 455.045 346.859 455.045Z"
            fill="white"
          />
          <path
            d="M341.206 437.229C338.991 437.229 337.188 439.028 337.188 441.247C337.188 443.467 338.987 445.266 341.206 445.266C343.426 445.266 345.225 443.467 345.225 441.247C345.225 439.028 343.426 437.229 341.206 437.229Z"
            fill="white"
          />
          <path
            d="M334.95 420.801C332.722 420.801 330.91 422.6 330.91 424.828C330.91 427.056 332.722 428.855 334.95 428.855C337.178 428.855 338.978 427.056 338.978 424.828C338.978 422.6 337.178 420.801 334.95 420.801Z"
            fill="white"
          />
          <path
            d="M328.156 405.596C325.928 405.596 324.116 407.408 324.116 409.636C324.116 411.864 325.928 413.684 328.156 413.684C330.384 413.684 332.205 411.872 332.205 409.636C332.205 407.399 330.393 405.596 328.156 405.596Z"
            fill="white"
          />
          <path
            d="M321.006 390.963C318.769 390.963 316.957 392.783 316.957 395.024C316.957 397.265 318.769 399.081 321.006 399.081C323.242 399.081 325.067 397.261 325.067 395.024C325.067 392.788 323.255 390.963 321.006 390.963Z"
            fill="white"
          />
          <path
            d="M313.512 377.006C311.276 377.006 309.455 378.826 309.455 381.076C309.455 383.325 311.276 385.133 313.512 385.133C315.749 385.133 317.582 383.312 317.582 381.076C317.582 378.839 315.761 377.006 313.512 377.006Z"
            fill="white"
          />
          <path
            d="M305.643 364.143C303.394 364.143 301.564 365.976 301.564 368.221C301.564 370.466 303.398 372.291 305.643 372.291C307.888 372.291 309.712 370.47 309.712 368.221C309.712 365.972 307.892 364.143 305.643 364.143Z"
            fill="white"
          />
          <path
            d="M297.432 352.477C295.183 352.477 293.362 354.297 293.362 356.546C293.362 358.795 295.183 360.625 297.432 360.625C299.681 360.625 301.51 358.804 301.51 356.546C301.51 354.289 299.69 352.477 297.432 352.477Z"
            fill="white"
          />
          <path
            d="M289.012 341.744C286.754 341.744 284.921 343.565 284.921 345.822C284.921 348.08 286.754 349.913 289.012 349.913C291.27 349.913 293.09 348.08 293.09 345.822C293.09 343.565 291.27 341.744 289.012 341.744Z"
            fill="white"
          />
          <path
            d="M280.499 331.713C278.241 331.713 276.408 333.546 276.408 335.804C276.408 338.062 278.241 339.882 280.499 339.882C282.757 339.882 284.577 338.062 284.577 335.804C284.577 333.546 282.744 331.713 280.499 331.713Z"
            fill="white"
          />
          <path
            d="M272.002 322.195C269.744 322.195 267.911 324.029 267.911 326.286C267.911 328.544 269.744 330.365 272.002 330.365C274.26 330.365 276.08 328.544 276.08 326.286C276.08 324.029 274.247 322.195 272.002 322.195Z"
            fill="white"
          />
          <path
            d="M263.605 313.146C261.355 313.146 259.526 314.967 259.526 317.225C259.526 319.482 261.36 321.294 263.605 321.294C265.85 321.294 267.683 319.474 267.683 317.225C267.683 314.976 265.85 313.146 263.605 313.146Z"
            fill="white"
          />
          <path
            d="M255.279 304.641C253.03 304.641 251.209 306.461 251.209 308.719C251.209 310.977 253.03 312.797 255.279 312.797C257.528 312.797 259.357 310.964 259.357 308.719C259.357 306.474 257.536 304.641 255.279 304.641Z"
            fill="white"
          />
          <path
            d="M262.472 291.674C260.223 291.674 258.402 293.494 258.402 295.744C258.402 297.993 260.223 299.813 262.472 299.813C264.721 299.813 266.542 297.993 266.542 295.744C266.542 293.494 264.721 291.674 262.472 291.674Z"
            fill="white"
          />
          <path
            d="M270.326 288.297C272.545 287.936 274.05 285.845 273.689 283.626C273.328 281.408 271.236 279.902 269.018 280.264C266.799 280.625 265.294 282.716 265.655 284.935C266.016 287.153 268.108 288.659 270.326 288.297Z"
            fill="white"
          />
          <path
            d="M276.832 270.014C274.596 270.014 272.775 271.826 272.775 274.062C272.775 276.299 274.596 278.123 276.832 278.123C279.069 278.123 280.881 276.303 280.881 274.062C280.881 271.821 279.069 270.014 276.832 270.014Z"
            fill="white"
          />
          <path
            d="M283.941 260.689C281.705 260.689 279.893 262.502 279.893 264.738C279.893 266.974 281.705 268.778 283.941 268.778C286.178 268.778 287.981 266.966 287.981 264.738C287.981 262.51 286.169 260.689 283.941 260.689Z"
            fill="white"
          />
          <path
            d="M290.853 252.113C288.626 252.113 286.826 253.913 286.826 256.141C286.826 258.369 288.626 260.168 290.853 260.168C293.081 260.168 294.881 258.369 294.881 256.141C294.881 253.913 293.081 252.113 290.853 252.113Z"
            fill="white"
          />
          <path
            d="M297.482 244.037C295.266 244.037 293.476 245.836 293.476 248.043C293.476 250.25 295.266 252.062 297.482 252.062C299.697 252.062 301.488 250.263 301.488 248.043C301.488 245.824 299.688 244.037 297.482 244.037Z"
            fill="white"
          />
          <path
            d="M304.805 244.188C306.936 243.612 308.198 241.418 307.623 239.287C307.048 237.155 304.853 235.893 302.722 236.468C300.59 237.044 299.329 239.238 299.904 241.369C300.479 243.501 302.673 244.763 304.805 244.188Z"
            fill="white"
          />
          <path
            d="M309.679 228.996C307.472 228.996 305.694 230.774 305.694 232.981C305.694 235.188 307.472 236.957 309.679 236.957C311.886 236.957 313.656 235.179 313.656 232.981C313.656 230.783 311.877 228.996 309.679 228.996Z"
            fill="white"
          />
          <path
            d="M315.246 222.199C313.069 222.199 311.3 223.969 311.3 226.146C311.3 228.323 313.069 230.101 315.246 230.101C317.424 230.101 319.202 228.331 319.202 226.146C319.202 223.96 317.432 222.199 315.246 222.199Z"
            fill="white"
          />
          <path
            d="M320.411 216.205C318.247 216.205 316.485 217.954 316.485 220.118C316.485 222.282 318.247 224.043 320.411 224.043C322.575 224.043 324.336 222.282 324.336 220.118C324.336 217.954 322.579 216.205 320.411 216.205Z"
            fill="white"
          />
          <path
            d="M325.097 210.92C322.941 210.92 321.192 212.668 321.192 214.824C321.192 216.98 322.941 218.728 325.097 218.728C327.252 218.728 329.001 216.98 329.001 214.824C329.001 212.668 327.252 210.92 325.097 210.92Z"
            fill="white"
          />
          <path
            d="M329.26 206.246C327.117 206.246 325.377 207.982 325.377 210.129C325.377 212.276 327.117 213.999 329.26 213.999C331.403 213.999 333.13 212.272 333.13 210.129C333.13 207.986 331.403 206.246 329.26 206.246Z"
            fill="white"
          />
          <path
            d="M332.887 202.07C330.766 202.07 329.06 203.789 329.06 205.898C329.06 208.007 330.766 209.73 332.887 209.73C335.009 209.73 336.72 208.012 336.72 205.898C336.72 203.785 335.001 202.07 332.887 202.07Z"
            fill="white"
          />
          <path
            d="M336.003 198.209C333.903 198.209 332.205 199.915 332.205 202.02C332.205 204.125 333.903 205.818 336.003 205.818C338.104 205.818 339.801 204.112 339.801 202.02C339.801 199.928 338.095 198.209 336.003 198.209Z"
            fill="white"
          />
          <path
            d="M338.575 194.652C336.496 194.652 334.807 196.337 334.807 198.421C334.807 200.504 336.491 202.198 338.575 202.198C340.659 202.198 342.352 200.513 342.352 198.421C342.352 196.329 340.667 194.652 338.575 194.652Z"
            fill="white"
          />
          <path
            d="M340.633 191.35C338.57 191.35 336.898 193.026 336.898 195.084C336.898 197.142 338.575 198.819 340.633 198.819C342.691 198.819 344.367 197.147 344.367 195.084C344.367 193.022 342.691 191.35 340.633 191.35Z"
            fill="white"
          />
          <path
            d="M342.217 188.275C340.176 188.275 338.533 189.926 338.533 191.963C338.533 194 340.18 195.647 342.217 195.647C344.254 195.647 345.9 193.992 345.9 191.963C345.9 189.935 344.258 188.275 342.217 188.275Z"
            fill="white"
          />
          <path
            d="M343.383 185.324C341.363 185.324 339.721 186.971 339.721 188.987C339.721 191.002 341.363 192.645 343.383 192.645C345.403 192.645 347.045 191.007 347.045 188.987C347.045 186.967 345.403 185.324 343.383 185.324Z"
            fill="white"
          />
          <path
            d="M344.181 182.494C342.182 182.494 340.569 184.107 340.569 186.106C340.569 188.104 342.182 189.725 344.181 189.725C346.18 189.725 347.801 188.1 347.801 186.106C347.801 184.111 346.175 182.494 344.181 182.494Z"
            fill="white"
          />
          <path
            d="M348.023 184.626C348.776 182.797 347.904 180.704 346.075 179.951C344.245 179.198 342.152 180.07 341.399 181.899C340.646 183.728 341.518 185.822 343.347 186.575C345.176 187.328 347.27 186.456 348.023 184.626Z"
            fill="white"
          />
          <path
            d="M345.003 176.842C343.056 176.842 341.485 178.412 341.485 180.36C341.485 182.308 343.056 183.878 345.003 183.878C346.951 183.878 348.521 182.299 348.521 180.36C348.521 178.42 346.939 176.842 345.003 176.842Z"
            fill="white"
          />
          <path
            d="M345.169 173.857C343.255 173.857 341.702 175.415 341.702 177.333C341.702 179.251 343.251 180.8 345.169 180.8C347.087 180.8 348.645 179.251 348.645 177.333C348.645 175.415 347.096 173.857 345.169 173.857Z"
            fill="white"
          />
          <path
            d="M345.361 170.578C343.469 170.578 341.937 172.114 341.937 174.003C341.937 175.891 343.469 177.432 345.361 177.432C347.254 177.432 348.786 175.896 348.786 174.003C348.786 172.11 347.254 170.578 345.361 170.578Z"
            fill="white"
          />
          <path
            d="M345.764 166.801C343.893 166.801 342.382 168.312 342.382 170.179C342.382 172.046 343.893 173.557 345.764 173.557C347.636 173.557 349.138 172.046 349.138 170.179C349.138 168.312 347.627 166.801 345.764 166.801Z"
            fill="white"
          />
          <path
            d="M346.672 162.252C344.839 162.252 343.362 163.733 343.362 165.562C343.362 167.391 344.839 168.881 346.672 168.881C348.506 168.881 349.991 167.391 349.991 165.562C349.991 163.733 348.502 162.252 346.672 162.252Z"
            fill="white"
          />
          <path
            d="M359.981 157.977C358.147 157.977 356.662 159.458 356.662 161.291C356.662 163.124 358.152 164.61 359.981 164.61C361.81 164.61 363.299 163.12 363.299 161.291C363.299 159.462 361.81 157.977 359.981 157.977Z"
            fill="white"
          />
          <path
            d="M374.023 152.887C372.19 152.887 370.713 154.368 370.713 156.201C370.713 158.034 372.19 159.515 374.023 159.515C375.856 159.515 377.342 158.039 377.342 156.201C377.342 154.364 375.865 152.887 374.023 152.887Z"
            fill="white"
          />
          <path
            d="M389.083 146.939C387.25 146.939 385.765 148.429 385.765 150.258C385.765 152.087 387.254 153.589 389.083 153.589C390.912 153.589 392.415 152.1 392.415 150.258C392.415 148.416 390.925 146.939 389.083 146.939Z"
            fill="white"
          />
          <path
            d="M405.372 140.268C403.551 140.268 402.062 141.744 402.062 143.578C402.062 145.411 403.551 146.888 405.372 146.888C407.192 146.888 408.69 145.411 408.69 143.578C408.69 141.744 407.201 140.268 405.372 140.268Z"
            fill="white"
          />
          <path
            d="M423.335 131.99C421.502 131.99 420.017 133.471 420.017 135.305C420.017 137.138 421.506 138.623 423.335 138.623C425.164 138.623 426.645 137.142 426.645 135.305C426.645 133.467 425.169 131.99 423.335 131.99Z"
            fill="white"
          />
          <path
            d="M443.069 122.189C441.227 122.189 439.737 123.679 439.737 125.508C439.737 127.337 441.227 128.839 443.069 128.839C444.91 128.839 446.387 127.35 446.387 125.508C446.387 123.666 444.898 122.189 443.069 122.189Z"
            fill="white"
          />
          <path
            d="M464.788 110.752C462.955 110.752 461.47 112.242 461.47 114.079C461.47 115.917 462.959 117.406 464.788 117.406C466.617 117.406 468.12 115.917 468.12 114.079C468.12 112.242 466.63 110.752 464.788 110.752Z"
            fill="white"
          />
          <path
            d="M488.061 97.7129C486.219 97.7129 484.729 99.2024 484.729 101.044C484.729 102.886 486.219 104.371 488.061 104.371C489.903 104.371 491.392 102.878 491.392 101.044C491.392 99.2109 489.894 97.7129 488.061 97.7129Z"
            fill="white"
          />
          <path
            d="M512.373 83.2891C510.54 83.2891 509.055 84.7786 509.055 86.6204C509.055 88.4622 510.544 89.9518 512.373 89.9518C514.202 89.9518 515.705 88.458 515.705 86.6204C515.705 84.7829 514.215 83.2891 512.373 83.2891Z"
            fill="white"
          />
          <path
            d="M536.643 68.0176C534.801 68.0176 533.303 69.5071 533.303 71.3489C533.303 73.1907 534.801 74.6888 536.643 74.6888C538.484 74.6888 539.974 73.1907 539.974 71.3489C539.974 69.5071 538.484 68.0176 536.643 68.0176Z"
            fill="white"
          />
          <path
            d="M560.934 58.6913C562.736 58.2659 563.852 56.4603 563.427 54.6582C563.001 52.8562 561.196 51.7401 559.394 52.1654C557.592 52.5908 556.476 54.3964 556.901 56.1985C557.326 58.0005 559.132 59.1166 560.934 58.6913Z"
            fill="white"
          />
          <path
            d="M582.429 36.375C580.579 36.375 579.068 37.873 579.068 39.7276C579.068 41.5821 580.579 43.0844 582.429 43.0844C584.28 43.0844 585.782 41.5821 585.782 39.7276C585.782 37.873 584.284 36.375 582.429 36.375Z"
            fill="white"
          />
          <path
            d="M603.193 21.5586C601.343 21.5586 599.841 23.0566 599.841 24.9112C599.841 26.7657 601.339 28.2637 603.193 28.2637C605.048 28.2637 606.554 26.7657 606.554 24.9112C606.554 23.0566 605.044 21.5586 603.193 21.5586Z"
            fill="white"
          />
          <path
            d="M622.684 9.09766C620.834 9.09766 619.323 10.6084 619.323 12.4587C619.323 14.309 620.834 15.8198 622.684 15.8198C624.535 15.8198 626.045 14.3175 626.045 12.4587C626.045 10.5999 624.535 9.09766 622.684 9.09766Z"
            fill="white"
          />
          <path
            d="M640.997 -1.1543C639.134 -1.1543 637.636 0.343747 637.636 2.20675C637.636 4.06976 639.134 5.5678 640.997 5.5678C642.86 5.5678 644.358 4.06551 644.358 2.20675C644.358 0.34799 642.86 -1.1543 640.997 -1.1543Z"
            fill="white"
          />
          <path
            d="M784.471 0.958714C786.355 0.958714 787.883 -0.568879 787.883 -2.45326C787.883 -4.33764 786.355 -5.86523 784.471 -5.86523C782.586 -5.86523 781.059 -4.33764 781.059 -2.45326C781.059 -0.568879 782.586 0.958714 784.471 0.958714Z"
            fill="white"
          />
          <path
            d="M791.243 5.28711C789.329 5.28711 787.768 6.84457 787.768 8.76274C787.768 10.6809 789.329 12.2426 791.243 12.2426C793.157 12.2426 794.732 10.6852 794.732 8.76274C794.732 6.84032 793.17 5.28711 791.243 5.28711Z"
            fill="white"
          />
          <path
            d="M797.79 17.5C795.834 17.5 794.264 19.0787 794.264 21.035C794.264 22.9914 795.834 24.5616 797.79 24.5616C799.747 24.5616 801.317 22.9787 801.317 21.035C801.317 19.0914 799.734 17.5 797.79 17.5Z"
            fill="white"
          />
          <path
            d="M804.067 30.8809C802.089 30.8809 800.485 32.485 800.485 34.4626C800.485 36.4402 802.089 38.0316 804.067 38.0316C806.045 38.0316 807.649 36.4359 807.649 34.4626C807.649 32.4892 806.045 30.8809 804.067 30.8809Z"
            fill="white"
          />
          <path
            d="M810.051 45.5137C808.052 45.5137 806.431 47.1305 806.431 49.1336C806.431 51.1366 808.056 52.7535 810.051 52.7535C812.045 52.7535 813.67 51.1324 813.67 49.1336C813.67 47.1348 812.058 45.5137 810.051 45.5137Z"
            fill="white"
          />
          <path
            d="M815.712 61.4238C813.671 61.4238 812.028 63.0746 812.028 65.1116C812.028 67.1486 813.675 68.7952 815.712 68.7952C817.749 68.7952 819.395 67.1402 819.395 65.1116C819.395 63.0831 817.749 61.4238 815.712 61.4238Z"
            fill="white"
          />
          <path
            d="M821.064 78.6445C819.001 78.6445 817.338 80.3081 817.338 82.3705C817.338 84.433 819.001 86.0923 821.064 86.0923C823.126 86.0923 824.777 84.4288 824.777 82.3705C824.777 80.3123 823.114 78.6445 821.064 78.6445Z"
            fill="white"
          />
          <path
            d="M826.216 96.8184C824.136 96.8184 822.46 98.5031 822.46 100.587C822.46 102.67 824.136 104.343 826.216 104.343C828.295 104.343 829.971 102.658 829.971 100.587C829.971 98.5159 828.295 96.8184 826.216 96.8184Z"
            fill="white"
          />
          <path
            d="M831.368 115.188C829.275 115.188 827.569 116.889 827.569 118.986C827.569 121.082 829.275 122.784 831.368 122.784C833.46 122.784 835.166 121.082 835.166 118.986C835.166 116.889 833.468 115.188 831.368 115.188Z"
            fill="white"
          />
          <path
            d="M836.735 132.766C834.613 132.766 832.895 134.493 832.895 136.615C832.895 138.737 834.613 140.455 836.735 140.455C838.857 140.455 840.576 138.737 840.576 136.615C840.576 134.493 838.857 132.766 836.735 132.766Z"
            fill="white"
          />
          <path
            d="M842.418 149.219C840.275 149.219 838.535 150.959 838.535 153.102C838.535 155.245 840.271 156.972 842.418 156.972C844.565 156.972 846.288 155.241 846.288 153.102C846.288 150.963 844.561 149.219 842.418 149.219Z"
            fill="white"
          />
          <path
            d="M848.444 164.441C846.288 164.441 844.531 166.194 844.531 168.35C844.531 170.506 846.288 172.263 848.444 172.263C850.6 172.263 852.357 170.514 852.357 168.35C852.357 166.186 850.596 164.441 848.444 164.441Z"
            fill="white"
          />
          <path
            d="M854.826 178.453C852.641 178.453 850.884 180.223 850.884 182.4C850.884 184.577 852.645 186.342 854.826 186.342C857.007 186.342 858.773 184.573 858.773 182.4C858.773 180.227 857.003 178.453 854.826 178.453Z"
            fill="white"
          />
          <path
            d="M861.537 191.346C859.33 191.346 857.552 193.132 857.552 195.326C857.552 197.52 859.33 199.311 861.537 199.311C863.743 199.311 865.513 197.533 865.513 195.326C865.513 193.12 863.735 191.346 861.537 191.346Z"
            fill="white"
          />
          <path
            d="M868.551 203.246C866.336 203.246 864.545 205.037 864.545 207.244C864.545 209.45 866.336 211.25 868.551 211.25C870.766 211.25 872.549 209.459 872.549 207.244C872.549 205.028 870.758 203.246 868.551 203.246Z"
            fill="white"
          />
          <path
            d="M875.838 214.186C873.61 214.186 871.811 215.998 871.811 218.226C871.811 220.454 873.61 222.266 875.838 222.266C878.066 222.266 879.878 220.454 879.878 218.226C879.878 215.998 878.079 214.186 875.838 214.186Z"
            fill="white"
          />
          <path
            d="M883.404 224.188C881.167 224.188 879.347 226.008 879.347 228.245C879.347 230.481 881.167 232.302 883.404 232.302C885.64 232.302 887.461 230.481 887.461 228.245C887.461 226.008 885.64 224.188 883.404 224.188Z"
            fill="white"
          />
          <path
            d="M891.2 233.316C888.943 233.316 887.122 235.15 887.122 237.407C887.122 239.665 888.943 241.498 891.2 241.498C893.458 241.498 895.291 239.665 895.291 237.407C895.291 235.15 893.458 233.316 891.2 233.316Z"
            fill="white"
          />
          <path
            d="M899.217 241.652C896.959 241.652 895.117 243.494 895.117 245.765C895.117 248.035 896.959 249.864 899.217 249.864C901.474 249.864 903.329 248.031 903.329 245.765C903.329 243.498 901.487 241.652 899.217 241.652Z"
            fill="white"
          />
          <path
            d="M907.429 249.27C905.158 249.27 903.316 251.111 903.316 253.382C903.316 255.652 905.158 257.502 907.429 257.502C909.699 257.502 911.549 255.661 911.549 253.382C911.549 251.103 909.707 249.27 907.429 249.27Z"
            fill="white"
          />
          <path
            d="M915.828 256.152C913.536 256.152 911.694 258.007 911.694 260.286C911.694 262.565 913.536 264.428 915.828 264.428C918.119 264.428 919.961 262.577 919.961 260.286C919.961 257.994 918.107 256.152 915.828 256.152Z"
            fill="white"
          />
          <path
            d="M924.391 262.346C922.099 262.346 920.236 264.2 920.236 266.5C920.236 268.8 922.099 270.655 924.391 270.655C926.683 270.655 928.546 268.792 928.546 266.5C928.546 264.209 926.691 262.346 924.391 262.346Z"
            fill="white"
          />
          <path
            d="M933.112 267.84C930.812 267.84 928.957 269.703 928.957 271.994C928.957 274.286 930.812 276.158 933.112 276.158C935.412 276.158 937.266 274.295 937.266 271.994C937.266 269.694 935.403 267.84 933.112 267.84Z"
            fill="white"
          />
          <path
            d="M941.939 272.646C939.647 272.646 937.784 274.51 937.784 276.81C937.784 279.11 939.647 280.964 941.939 280.964C944.23 280.964 946.093 279.101 946.093 276.81C946.093 274.518 944.239 272.646 941.939 272.646Z"
            fill="white"
          />
          <path
            d="M950.837 276.799C948.546 276.799 946.683 278.653 946.683 280.953C946.683 283.254 948.546 285.108 950.837 285.108C953.129 285.108 954.992 283.245 954.992 280.953C954.992 278.662 953.137 276.799 950.837 276.799Z"
            fill="white"
          />
          <path
            d="M959.745 280.307C957.445 280.307 955.582 282.17 955.582 284.461C955.582 286.753 957.445 288.616 959.745 288.616C962.045 288.616 963.9 286.753 963.9 284.461C963.9 282.17 962.037 280.307 959.745 280.307Z"
            fill="white"
          />
          <path
            d="M954.555 282.516C952.263 282.516 950.4 284.379 950.4 286.67C950.4 288.962 952.263 290.825 954.555 290.825C956.847 290.825 958.71 288.97 958.71 286.67C958.71 284.37 956.847 282.516 954.555 282.516Z"
            fill="white"
          />
          <path
            d="M949.234 284.723C946.934 284.723 945.079 286.586 945.079 288.877C945.079 291.169 946.934 293.032 949.234 293.032C951.534 293.032 953.388 291.182 953.388 288.877C953.388 286.573 951.525 284.723 949.234 284.723Z"
            fill="white"
          />
          <path
            d="M943.771 286.979C941.479 286.979 939.616 288.829 939.616 291.133C939.616 293.438 941.479 295.288 943.771 295.288C946.062 295.288 947.934 293.425 947.934 291.133C947.934 288.842 946.071 286.979 943.771 286.979Z"
            fill="white"
          />
          <path
            d="M938.17 289.33C935.883 289.33 934.016 291.18 934.016 293.485C934.016 295.789 935.879 297.639 938.17 297.639C940.462 297.639 942.325 295.776 942.325 293.485C942.325 291.193 940.475 289.33 938.17 289.33Z"
            fill="white"
          />
          <path
            d="M932.415 291.83C930.115 291.83 928.261 293.685 928.261 295.985C928.261 298.285 930.111 300.139 932.415 300.139C934.72 300.139 936.57 298.276 936.57 295.985C936.57 293.693 934.707 291.83 932.415 291.83Z"
            fill="white"
          />
          <path
            d="M926.474 294.523C924.182 294.523 922.319 296.374 922.319 298.678C922.319 300.982 924.182 302.833 926.474 302.833C928.766 302.833 930.629 300.97 930.629 298.678C930.629 296.386 928.766 294.523 926.474 294.523Z"
            fill="white"
          />
          <path
            d="M920.342 297.459C918.042 297.459 916.188 299.322 916.188 301.614C916.188 303.905 918.042 305.768 920.342 305.768C922.642 305.768 924.497 303.914 924.497 301.614C924.497 299.313 922.634 297.459 920.342 297.459Z"
            fill="white"
          />
          <path
            d="M913.985 300.695C911.693 300.695 909.843 302.546 909.843 304.837C909.843 307.129 911.697 308.979 913.985 308.979C916.272 308.979 918.127 307.125 918.127 304.837C918.127 302.55 916.276 300.695 913.985 300.695Z"
            fill="white"
          />
          <path
            d="M907.395 304.254C905.103 304.254 903.253 306.104 903.253 308.396C903.253 310.687 905.107 312.538 907.395 312.538C909.682 312.538 911.537 310.675 911.537 308.396C911.537 306.117 909.682 304.254 907.395 304.254Z"
            fill="white"
          />
          <path
            d="M900.557 308.168C898.278 308.168 896.424 310.022 896.424 312.301C896.424 314.58 898.274 316.422 900.557 316.422C902.84 316.422 904.678 314.568 904.678 312.301C904.678 310.035 902.823 308.168 900.557 308.168Z"
            fill="white"
          />
          <path
            d="M893.47 312.461C891.199 312.461 889.357 314.294 889.357 316.573C889.357 318.852 891.199 320.685 893.47 320.685C895.74 320.685 897.582 318.844 897.582 316.573C897.582 314.303 895.74 312.461 893.47 312.461Z"
            fill="white"
          />
          <path
            d="M886.163 317.119C883.914 317.119 882.085 318.952 882.085 321.21C882.085 323.468 883.918 325.288 886.163 325.288C888.408 325.288 890.254 323.468 890.254 321.21C890.254 318.952 888.421 317.119 886.163 317.119Z"
            fill="white"
          />
          <path
            d="M878.69 322.139C876.453 322.139 874.633 323.959 874.633 326.208C874.633 328.458 876.453 330.278 878.69 330.278C880.926 330.278 882.76 328.458 882.76 326.208C882.76 323.959 880.939 322.139 878.69 322.139Z"
            fill="white"
          />
          <path
            d="M871.114 327.457C868.886 327.457 867.074 329.269 867.074 331.497C867.074 333.725 868.886 335.537 871.114 335.537C873.342 335.537 875.154 333.725 875.154 331.497C875.154 329.269 873.355 327.457 871.114 327.457Z"
            fill="white"
          />
          <path
            d="M863.497 332.971C861.282 332.971 859.479 334.77 859.479 336.99C859.479 339.209 861.278 341.008 863.497 341.008C865.717 341.008 867.525 339.209 867.525 336.99C867.525 334.77 865.725 332.971 863.497 332.971Z"
            fill="white"
          />
          <path
            d="M855.909 338.604C853.702 338.604 851.924 340.382 851.924 342.58C851.924 344.778 853.702 346.565 855.909 346.565C858.115 346.565 859.885 344.787 859.885 342.58C859.885 340.373 858.107 338.604 855.909 338.604Z"
            fill="white"
          />
          <path
            d="M848.363 344.18C846.178 344.18 844.408 345.949 844.408 348.143C844.408 350.337 846.178 352.099 848.363 352.099C850.549 352.099 852.327 350.329 852.327 348.143C852.327 345.958 850.557 344.18 848.363 344.18Z"
            fill="white"
          />
          <path
            d="M840.814 349.861C838.65 349.861 836.88 351.622 836.88 353.795C836.88 355.968 838.65 357.729 840.814 357.729C842.978 357.729 844.756 355.968 844.756 353.795C844.756 351.622 842.987 349.861 840.814 349.861Z"
            fill="white"
          />
          <path
            d="M833.103 356.117C830.948 356.117 829.199 357.866 829.199 360.021C829.199 362.177 830.948 363.913 833.103 363.913C835.259 363.913 837.008 362.173 837.008 360.021C837.008 357.87 835.259 356.117 833.103 356.117Z"
            fill="white"
          />
          <path
            d="M825.206 363.02C823.071 363.02 821.344 364.747 821.344 366.869C821.344 368.99 823.071 370.73 825.206 370.73C827.34 370.73 829.055 369.003 829.055 366.869C829.055 364.734 827.336 363.02 825.206 363.02Z"
            fill="white"
          />
          <path
            d="M817.095 370.555C814.982 370.555 813.268 372.273 813.268 374.383C813.268 376.492 814.986 378.215 817.095 378.215C819.205 378.215 820.915 376.496 820.915 374.383C820.915 372.269 819.209 370.555 817.095 370.555Z"
            fill="white"
          />
          <path
            d="M808.74 378.768C806.647 378.768 804.941 380.465 804.941 382.557C804.941 384.649 806.647 386.355 808.74 386.355C810.832 386.355 812.529 384.649 812.529 382.557C812.529 380.465 810.832 378.768 808.74 378.768Z"
            fill="white"
          />
          <path
            d="M800.113 387.625C798.042 387.625 796.357 389.31 796.357 391.393C796.357 393.477 798.042 395.149 800.113 395.149C802.184 395.149 803.882 393.464 803.882 391.393C803.882 389.323 802.197 387.625 800.113 387.625Z"
            fill="white"
          />
          <path
            d="M791.213 397.154C789.172 397.154 787.517 398.809 787.517 400.851C787.517 402.892 789.172 404.555 791.213 404.555C793.254 404.555 794.918 402.9 794.918 400.851C794.918 398.801 793.263 397.154 791.213 397.154Z"
            fill="white"
          />
          <path
            d="M786.579 409.262C784.58 409.262 782.959 410.887 782.959 412.882C782.959 414.876 784.584 416.514 786.579 416.514C788.573 416.514 790.212 414.889 790.212 412.882C790.212 410.874 788.586 409.262 786.579 409.262Z"
            fill="white"
          />
          <path
            d="M773.135 418.494C771.136 418.494 769.515 420.115 769.515 422.114C769.515 424.113 771.136 425.747 773.135 425.747C775.133 425.747 776.754 424.121 776.754 422.114C776.754 420.107 775.129 418.494 773.135 418.494Z"
            fill="white"
          />
          <path
            d="M759.543 428.359C757.544 428.359 755.923 429.985 755.923 431.979C755.923 433.974 757.548 435.599 759.543 435.599C761.537 435.599 763.163 433.987 763.163 431.979C763.163 429.972 761.542 428.359 759.543 428.359Z"
            fill="white"
          />
          <path
            d="M745.793 438.879C743.794 438.879 742.182 440.491 742.182 442.49C742.182 444.489 743.794 446.11 745.793 446.11C747.792 446.11 749.413 444.489 749.413 442.49C749.413 440.491 747.788 438.879 745.793 438.879Z"
            fill="white"
          />
          <path
            d="M731.92 449.85C729.921 449.85 728.309 451.462 728.309 453.461C728.309 455.46 729.921 457.081 731.92 457.081C733.919 457.081 735.54 455.46 735.54 453.461C735.54 451.462 733.915 449.85 731.92 449.85Z"
            fill="white"
          />
          <path
            d="M718.004 461.229C716.005 461.229 714.393 462.841 714.393 464.84C714.393 466.839 716.005 468.451 718.004 468.451C720.003 468.451 721.615 466.839 721.615 464.84C721.615 462.841 720.003 461.229 718.004 461.229Z"
            fill="white"
          />
          <path
            d="M703.975 472.721C701.989 472.721 700.363 474.333 700.363 476.332C700.363 478.331 701.989 479.944 703.975 479.944C705.961 479.944 707.599 478.331 707.599 476.332C707.599 474.333 705.974 472.721 703.975 472.721Z"
            fill="white"
          />
          <path
            d="M689.808 483.842C687.822 483.842 686.205 485.446 686.205 487.432C686.205 489.418 687.818 491.031 689.808 491.031C691.798 491.031 693.398 489.418 693.398 487.432C693.398 485.446 691.786 483.842 689.808 483.842Z"
            fill="white"
          />
          <path
            d="M675.622 494.432C673.636 494.432 672.032 496.044 672.032 498.022C672.032 499.999 673.636 501.612 675.622 501.612C677.609 501.612 679.213 500.008 679.213 498.022C679.213 496.036 677.6 494.432 675.622 494.432Z"
            fill="white"
          />
          <path
            d="M661.427 504.242C659.45 504.242 657.837 505.855 657.837 507.832C657.837 509.81 659.45 511.423 661.427 511.423C663.405 511.423 665.017 509.819 665.017 507.832C665.017 505.846 663.413 504.242 661.427 504.242Z"
            fill="white"
          />
          <path
            d="M647.23 512.996C645.253 512.996 643.648 514.6 643.648 516.586C643.648 518.572 645.253 520.168 647.23 520.168C649.208 520.168 650.82 518.564 650.82 516.586C650.82 514.609 649.216 512.996 647.23 512.996Z"
            fill="white"
          />
          <path
            d="M633.209 520.844C631.232 520.844 629.619 522.456 629.619 524.434C629.619 526.412 631.232 528.016 633.209 528.016C635.187 528.016 636.791 526.412 636.791 524.434C636.791 522.456 635.187 520.844 633.209 520.844Z"
            fill="white"
          />
          <path
            d="M619.387 527.881C617.41 527.881 615.806 529.485 615.806 531.463C615.806 533.44 617.41 535.044 619.387 535.044C621.365 535.044 622.969 533.44 622.969 531.463C622.969 529.485 621.365 527.881 619.387 527.881Z"
            fill="white"
          />
          <path
            d="M605.71 534.133C603.732 534.133 602.128 535.737 602.128 537.715C602.128 539.692 603.732 541.296 605.71 541.296C607.687 541.296 609.291 539.692 609.291 537.715C609.291 535.737 607.687 534.133 605.71 534.133Z"
            fill="white"
          />
          <path
            d="M592.181 539.961C590.204 539.961 588.612 541.565 588.612 543.543C588.612 545.52 590.204 547.112 592.181 547.112C594.159 547.112 595.75 545.508 595.75 543.543C595.75 541.578 594.159 539.961 592.181 539.961Z"
            fill="white"
          />
          <path
            d="M578.84 545.721C576.862 545.721 575.258 547.312 575.258 549.29C575.258 551.267 576.862 552.859 578.84 552.859C580.817 552.859 582.409 551.267 582.409 549.29C582.409 547.312 580.817 545.721 578.84 545.721Z"
            fill="white"
          />
          <path
            d="M565.654 551.496C563.689 551.496 562.085 553.1 562.085 555.065C562.085 557.03 563.689 558.634 565.654 558.634C567.619 558.634 569.223 557.043 569.223 555.065C569.223 553.087 567.619 551.496 565.654 551.496Z"
            fill="white"
          />
          <path
            d="M552.579 557.252C550.61 557.252 549.01 558.856 549.01 560.821C549.01 562.786 550.614 564.39 552.579 564.39C554.544 564.39 556.148 562.799 556.148 560.821C556.148 558.843 554.556 557.252 552.579 557.252Z"
            fill="white"
          />
          <path
            d="M539.58 562.945C537.602 562.945 536.011 564.549 536.011 566.514C536.011 568.479 537.602 570.075 539.58 570.075C541.557 570.075 543.14 568.483 543.14 566.514C543.14 564.545 541.549 562.945 539.58 562.945Z"
            fill="white"
          />
          <path
            d="M526.625 568.543C524.656 568.543 523.056 570.134 523.056 572.103C523.056 574.073 524.66 575.672 526.625 575.672C528.589 575.672 530.185 574.068 530.185 572.103C530.185 570.139 528.594 568.543 526.625 568.543Z"
            fill="white"
          />
          <path
            d="M513.675 573.988C511.706 573.988 510.106 575.592 510.106 577.557C510.106 579.522 511.711 581.126 513.675 581.126C515.64 581.126 517.244 579.522 517.244 577.557C517.244 575.592 515.64 573.988 513.675 573.988Z"
            fill="white"
          />
          <path
            d="M500.678 579.234C498.701 579.234 497.109 580.826 497.109 582.795C497.109 584.764 498.701 586.364 500.678 586.364C502.656 586.364 504.239 584.772 504.239 582.795C504.239 580.817 502.647 579.234 500.678 579.234Z"
            fill="white"
          />
          <path
            d="M487.603 591.191C489.569 591.191 491.163 589.597 491.163 587.631C491.163 585.664 489.569 584.07 487.603 584.07C485.636 584.07 484.042 585.664 484.042 587.631C484.042 589.597 485.636 591.191 487.603 591.191Z"
            fill="white"
          />
          <path
            d="M474.446 588.508C472.477 588.508 470.886 590.112 470.886 592.077C470.886 594.042 472.477 595.637 474.446 595.637C476.415 595.637 478.007 594.046 478.007 592.077C478.007 590.108 476.415 588.508 474.446 588.508Z"
            fill="white"
          />
          <path
            d="M461.169 592.432C459.212 592.432 457.621 594.023 457.621 595.992C457.621 597.961 459.212 599.553 461.169 599.553C463.125 599.553 464.729 597.961 464.729 595.992C464.729 594.023 463.138 592.432 461.169 592.432Z"
            fill="white"
          />
          <path
            d="M447.754 595.686C445.789 595.686 444.193 597.277 444.193 599.246C444.193 601.215 445.785 602.794 447.754 602.794C449.723 602.794 451.314 601.202 451.314 599.246C451.314 597.29 449.723 595.686 447.754 595.686Z"
            fill="white"
          />
          <path
            d="M434.221 598.174C432.256 598.174 430.673 599.765 430.673 601.722C430.673 603.678 432.256 605.269 434.221 605.269C436.185 605.269 437.768 603.678 437.768 601.722C437.768 599.765 436.177 598.174 434.221 598.174Z"
            fill="white"
          />
          <path
            d="M425.499 595.949C423.522 595.949 421.909 597.562 421.909 599.552C421.909 601.542 423.522 603.142 425.499 603.142C427.477 603.142 429.102 601.53 429.102 599.552C429.102 597.575 427.49 595.949 425.499 595.949Z"
            fill="white"
          />
          <path
            d="M416.707 593.076C414.708 593.076 413.087 594.702 413.087 596.696C413.087 598.691 414.712 600.329 416.707 600.329C418.701 600.329 420.339 598.703 420.339 596.696C420.339 594.689 418.714 593.076 416.707 593.076Z"
            fill="white"
          />
          <path
            d="M407.879 589.379C405.85 589.379 404.195 591.026 404.195 593.063C404.195 595.1 405.85 596.746 407.879 596.746C409.907 596.746 411.575 595.091 411.575 593.063C411.575 591.034 409.92 589.379 407.879 589.379Z"
            fill="white"
          />
          <path
            d="M399.117 584.736C397.054 584.736 395.391 586.4 395.391 588.454C395.391 590.508 397.054 592.171 399.117 592.171C401.179 592.171 402.834 590.508 402.834 588.454C402.834 586.4 401.171 584.736 399.117 584.736Z"
            fill="white"
          />
          <path
            d="M390.488 579.006C388.417 579.006 386.732 580.682 386.732 582.762C386.732 584.841 388.417 586.517 390.488 586.517C392.559 586.517 394.244 584.833 394.244 582.762C394.244 580.691 392.568 579.006 390.488 579.006Z"
            fill="white"
          />
          <path
            d="M382.107 572.068C380.015 572.068 378.317 573.753 378.317 575.845C378.317 577.937 380.015 579.635 382.107 579.635C384.199 579.635 385.884 577.937 385.884 575.845C385.884 573.753 384.199 572.068 382.107 572.068Z"
            fill="white"
          />
          <path
            d="M374.074 563.715C371.961 563.715 370.255 565.421 370.255 567.534C370.255 569.648 371.961 571.366 374.074 571.366C376.188 571.366 377.906 569.648 377.906 567.534C377.906 565.421 376.188 563.715 374.074 563.715Z"
            fill="white"
          />
          <path
            d="M366.52 553.752C364.398 553.752 362.671 555.471 362.671 557.601C362.671 559.731 364.398 561.45 366.52 561.45C368.642 561.45 370.369 559.723 370.369 557.601C370.369 555.479 368.642 553.752 366.52 553.752Z"
            fill="white"
          />
          <path
            d="M359.526 542.023C357.383 542.023 355.643 543.751 355.643 545.894C355.643 548.037 357.383 549.777 359.526 549.777C361.669 549.777 363.396 548.037 363.396 545.894C363.396 543.751 361.656 542.023 359.526 542.023Z"
            fill="white"
          />
          <path
            d="M353.135 528.461C350.97 528.461 349.23 530.209 349.23 532.365C349.23 534.521 350.97 536.278 353.135 536.278C355.299 536.278 357.039 534.529 357.039 532.365C357.039 530.201 355.291 528.461 353.135 528.461Z"
            fill="white"
          />
          <path
            d="M347.318 513.184C345.141 513.184 343.384 514.945 343.384 517.118C343.384 519.29 345.141 521.052 347.318 521.052C349.495 521.052 351.252 519.295 351.252 517.118C351.252 514.941 349.495 513.184 347.318 513.184Z"
            fill="white"
          />
          <path
            d="M341.924 496.541C339.738 496.541 337.96 498.319 337.96 500.505C337.96 502.69 339.738 504.468 341.924 504.468C344.109 504.468 345.887 502.69 345.887 500.505C345.887 498.319 344.109 496.541 341.924 496.541Z"
            fill="white"
          />
          <path
            d="M336.669 479.182C334.475 479.182 332.685 480.96 332.685 483.167C332.685 485.373 334.475 487.143 336.669 487.143C338.863 487.143 340.646 485.365 340.646 483.167C340.646 480.968 338.868 479.182 336.669 479.182Z"
            fill="white"
          />
          <path
            d="M331.245 461.736C329.038 461.736 327.247 463.527 327.247 465.742C327.247 467.958 329.038 469.74 331.245 469.74C333.451 469.74 335.251 467.949 335.251 465.742C335.251 463.536 333.46 461.736 331.245 461.736Z"
            fill="white"
          />
          <path
            d="M325.441 444.848C323.225 444.848 321.422 446.639 321.422 448.854C321.422 451.069 323.221 452.873 325.441 452.873C327.66 452.873 329.447 451.073 329.447 448.854C329.447 446.634 327.656 444.848 325.441 444.848Z"
            fill="white"
          />
          <path
            d="M319.079 428.953C316.851 428.953 315.052 430.752 315.052 432.98C315.052 435.208 316.851 437.008 319.079 437.008C321.307 437.008 323.119 435.208 323.119 432.98C323.119 430.752 321.307 428.953 319.079 428.953Z"
            fill="white"
          />
          <path
            d="M312.23 414.059C309.993 414.059 308.189 415.871 308.189 418.099C308.189 420.327 309.989 422.139 312.23 422.139C314.47 422.139 316.27 420.339 316.27 418.099C316.27 415.858 314.457 414.059 312.23 414.059Z"
            fill="white"
          />
          <path
            d="M304.965 399.906C302.728 399.906 300.916 401.718 300.916 403.955C300.916 406.191 302.728 408.003 304.965 408.003C307.201 408.003 309.022 406.191 309.022 403.955C309.022 401.718 307.201 399.906 304.965 399.906Z"
            fill="white"
          />
          <path
            d="M297.376 386.385C295.127 386.385 293.307 388.205 293.307 390.455C293.307 392.704 295.127 394.524 297.376 394.524C299.626 394.524 301.438 392.704 301.438 390.455C301.438 388.205 299.617 386.385 297.376 386.385Z"
            fill="white"
          />
          <path
            d="M289.449 373.674C287.199 373.674 285.379 375.494 285.379 377.744C285.379 379.993 287.199 381.822 289.449 381.822C291.698 381.822 293.527 380.001 293.527 377.744C293.527 375.486 291.706 373.674 289.449 373.674Z"
            fill="white"
          />
          <path
            d="M281.275 361.699C279.026 361.699 277.205 363.52 277.205 365.769C277.205 368.018 279.026 369.847 281.275 369.847C283.524 369.847 285.353 368.027 285.353 365.769C285.353 363.511 283.532 361.699 281.275 361.699Z"
            fill="white"
          />
          <path
            d="M272.971 350.312C270.722 350.312 268.893 352.146 268.893 354.403C268.893 356.661 270.726 358.482 272.971 358.482C275.216 358.482 277.062 356.648 277.062 354.403C277.062 352.159 275.228 350.312 272.971 350.312Z"
            fill="white"
          />
          <path
            d="M264.645 339.414C262.387 339.414 260.566 341.247 260.566 343.492C260.566 345.737 262.387 347.583 264.645 347.583C266.902 347.583 268.723 345.75 268.723 343.492C268.723 341.235 266.902 339.414 264.645 339.414Z"
            fill="white"
          />
          <path
            d="M256.318 329.162C254.069 329.162 252.24 330.983 252.24 333.24C252.24 335.498 254.074 337.319 256.318 337.319C258.563 337.319 260.409 335.498 260.409 333.24C260.409 330.983 258.576 329.162 256.318 329.162Z"
            fill="white"
          />
          <path
            d="M248.064 319.439C245.806 319.439 243.985 321.26 243.985 323.518C243.985 325.775 245.806 327.587 248.064 327.587C250.321 327.587 252.133 325.767 252.133 323.518C252.133 321.269 250.313 319.439 248.064 319.439Z"
            fill="white"
          />
          <path
            d="M239.894 310.137C237.645 310.137 235.824 311.957 235.824 314.215C235.824 316.473 237.645 318.285 239.894 318.285C242.143 318.285 243.972 316.464 243.972 314.215C243.972 311.966 242.152 310.137 239.894 310.137Z"
            fill="white"
          />
          <path
            d="M247.13 296.43C244.881 296.43 243.061 298.263 243.061 300.508C243.061 302.753 244.881 304.586 247.13 304.586C249.38 304.586 251.209 302.753 251.209 300.508C251.209 298.263 249.388 296.43 247.13 296.43Z"
            fill="white"
          />
          <path
            d="M254.413 284.307C252.164 284.307 250.356 286.127 250.356 288.364C250.356 290.6 252.169 292.425 254.413 292.425C256.658 292.425 258.475 290.613 258.475 288.364C258.475 286.114 256.654 284.307 254.413 284.307Z"
            fill="white"
          />
          <path
            d="M261.678 273.553C259.442 273.553 257.63 275.365 257.63 277.601C257.63 279.838 259.442 281.65 261.678 281.65C263.915 281.65 265.735 279.838 265.735 277.601C265.735 275.365 263.915 273.553 261.678 273.553Z"
            fill="white"
          />
          <path
            d="M268.871 263.926C266.634 263.926 264.822 265.738 264.822 267.974C264.822 270.211 266.634 272.031 268.871 272.031C271.107 272.031 272.919 270.211 272.919 267.974C272.919 265.738 271.107 263.926 268.871 263.926Z"
            fill="white"
          />
          <path
            d="M275.908 255.172C273.692 255.172 271.889 256.971 271.889 259.191C271.889 261.41 273.688 263.218 275.908 263.218C278.127 263.218 279.935 261.419 279.935 259.191C279.935 256.963 278.135 255.172 275.908 255.172Z"
            fill="white"
          />
          <path
            d="M282.714 247.012C280.507 247.012 278.708 248.811 278.708 251.018C278.708 253.225 280.507 255.024 282.714 255.024C284.921 255.024 286.72 253.233 286.72 251.018C286.72 248.803 284.929 247.012 282.714 247.012Z"
            fill="white"
          />
          <path
            d="M289.178 239.365C286.984 239.365 285.193 241.156 285.193 243.363C285.193 245.57 286.984 247.348 289.178 247.348C291.372 247.348 293.176 245.57 293.176 243.363C293.176 241.156 291.385 239.365 289.178 239.365Z"
            fill="white"
          />
          <path
            d="M295.913 239.955C298.08 239.603 299.552 237.56 299.199 235.392C298.846 233.224 296.803 231.753 294.636 232.106C292.468 232.458 290.997 234.501 291.349 236.669C291.702 238.837 293.745 240.308 295.913 239.955Z"
            fill="white"
          />
          <path
            d="M301.022 225.137C298.836 225.137 297.079 226.906 297.079 229.079C297.079 231.252 298.84 233.026 301.022 233.026C303.203 233.026 304.968 231.265 304.968 229.079C304.968 226.894 303.199 225.137 301.022 225.137Z"
            fill="white"
          />
          <path
            d="M306.347 218.965C304.183 218.965 302.422 220.726 302.422 222.89C302.422 225.055 304.179 226.803 306.347 226.803C308.516 226.803 310.273 225.055 310.273 222.89C310.273 220.726 308.512 218.965 306.347 218.965Z"
            fill="white"
          />
          <path
            d="M311.241 213.52C309.085 213.52 307.337 215.268 307.337 217.424C307.337 219.58 309.085 221.315 311.241 221.315C313.397 221.315 315.133 219.575 315.133 217.424C315.133 215.272 313.384 213.52 311.241 213.52Z"
            fill="white"
          />
          <path
            d="M315.625 208.721C313.482 208.721 311.755 210.448 311.755 212.591C311.755 214.734 313.482 216.461 315.625 216.461C317.768 216.461 319.495 214.726 319.495 212.591C319.495 210.456 317.76 208.721 315.625 208.721Z"
            fill="white"
          />
          <path
            d="M319.473 204.434C317.36 204.434 315.646 206.152 315.646 208.266C315.646 210.379 317.364 212.085 319.473 212.085C321.583 212.085 323.305 210.379 323.305 208.266C323.305 206.152 321.587 204.434 319.473 204.434Z"
            fill="white"
          />
          <path
            d="M322.784 200.508C320.683 200.508 318.973 202.214 318.973 204.319C318.973 206.424 320.679 208.13 322.784 208.13C324.888 208.13 326.594 206.424 326.594 204.319C326.594 202.214 324.897 200.508 322.784 200.508Z"
            fill="white"
          />
          <path
            d="M325.563 196.918C323.484 196.918 321.795 198.603 321.795 200.695C321.795 202.787 323.48 204.472 325.563 204.472C327.647 204.472 329.34 202.774 329.34 200.695C329.34 198.615 327.656 196.918 325.563 196.918Z"
            fill="white"
          />
          <path
            d="M331.285 198.727C332.073 196.813 331.16 194.623 329.246 193.836C327.332 193.048 325.142 193.961 324.355 195.875C323.567 197.788 324.48 199.978 326.394 200.766C328.308 201.554 330.498 200.641 331.285 198.727Z"
            fill="white"
          />
          <path
            d="M329.6 197.842C331.634 197.842 333.283 196.191 333.283 194.155C333.283 192.118 331.634 190.467 329.6 190.467C327.565 190.467 325.916 192.118 325.916 194.155C325.916 196.191 327.565 197.842 329.6 197.842Z"
            fill="white"
          />
          <path
            d="M330.923 187.51C328.903 187.51 327.27 189.144 327.27 191.164C327.27 193.184 328.903 194.822 330.923 194.822C332.943 194.822 334.577 193.184 334.577 191.164C334.577 189.144 332.943 187.51 330.923 187.51Z"
            fill="white"
          />
          <path
            d="M331.87 184.684C329.871 184.684 328.259 186.3 328.259 188.295C328.259 190.29 329.871 191.902 331.87 191.902C333.869 191.902 335.482 190.29 335.482 188.295C335.482 186.3 333.856 184.684 331.87 184.684Z"
            fill="white"
          />
          <path
            d="M332.494 181.912C330.516 181.912 328.912 183.516 328.912 185.494C328.912 187.471 330.516 189.063 332.494 189.063C334.471 189.063 336.063 187.467 336.063 185.494C336.063 183.52 334.459 181.912 332.494 181.912Z"
            fill="white"
          />
          <path
            d="M332.859 179.16C330.924 179.16 329.341 180.739 329.341 182.674C329.341 184.609 330.924 186.192 332.859 186.192C334.794 186.192 336.377 184.622 336.377 182.674C336.377 180.726 334.807 179.16 332.859 179.16Z"
            fill="white"
          />
          <path
            d="M333.058 176.279C331.131 176.279 329.582 177.841 329.582 179.755C329.582 181.669 331.131 183.222 333.058 183.222C334.984 183.222 336.525 181.669 336.525 179.755C336.525 177.841 334.976 176.279 333.058 176.279Z"
            fill="white"
          />
          <path
            d="M333.172 173.205C331.28 173.205 329.739 174.741 329.739 176.634C329.739 178.527 331.28 180.059 333.172 180.059C335.065 180.059 336.597 178.522 336.597 176.634C336.597 174.746 335.057 173.205 333.172 173.205Z"
            fill="white"
          />
          <path
            d="M333.346 169.775C331.483 169.775 329.973 171.286 329.973 173.149C329.973 175.012 331.483 176.527 333.346 176.527C335.209 176.527 336.72 175.012 336.72 173.149C336.72 171.286 335.209 169.775 333.346 169.775Z"
            fill="white"
          />
          <path
            d="M333.805 165.777C331.972 165.777 330.495 167.267 330.495 169.096C330.495 170.925 331.972 172.406 333.805 172.406C335.639 172.406 337.124 170.921 337.124 169.096C337.124 167.271 335.634 165.777 333.805 165.777Z"
            fill="white"
          />
          <path
            d="M334.878 160.889C333.066 160.889 331.61 162.357 331.61 164.156C331.61 165.956 333.066 167.424 334.878 167.424C336.69 167.424 338.137 165.956 338.137 164.156C338.137 162.357 336.682 160.889 334.878 160.889Z"
            fill="white"
          />
          <path
            d="M348.514 156.496C346.702 156.496 345.246 157.964 345.246 159.768C345.246 161.572 346.702 163.04 348.514 163.04C350.326 163.04 351.781 161.572 351.781 159.768C351.781 157.964 350.313 156.496 348.514 156.496Z"
            fill="white"
          />
          <path
            d="M362.925 151.104C361.134 151.104 359.666 152.559 359.666 154.363C359.666 156.166 361.134 157.622 362.925 157.622C364.716 157.622 366.184 156.166 366.184 154.363C366.184 152.559 364.729 151.104 362.925 151.104Z"
            fill="white"
          />
          <path
            d="M378.559 144.496C376.747 144.496 375.291 145.964 375.291 147.764C375.291 149.563 376.747 151.023 378.559 151.023C380.371 151.023 381.818 149.567 381.818 147.764C381.818 145.96 380.362 144.496 378.559 144.496Z"
            fill="white"
          />
          <path
            d="M395.599 136.801C393.799 136.801 392.331 138.269 392.331 140.068C392.331 141.868 393.799 143.328 395.599 143.328C397.398 143.328 398.858 141.872 398.858 140.068C398.858 138.265 397.402 136.801 395.599 136.801Z"
            fill="white"
          />
          <path
            d="M414.436 127.67C412.636 127.67 411.168 129.134 411.168 130.942C411.168 132.75 412.636 134.21 414.436 134.21C416.235 134.21 417.703 132.741 417.703 130.942C417.703 129.142 416.248 127.67 414.436 127.67Z"
            fill="white"
          />
          <path
            d="M435.209 116.533C433.397 116.533 431.929 117.997 431.929 119.805C431.929 121.613 433.397 123.081 435.209 123.081C437.021 123.081 438.485 121.613 438.485 119.805C438.485 117.997 437.017 116.533 435.209 116.533Z"
            fill="white"
          />
          <path
            d="M457.909 103.609C456.097 103.609 454.629 105.078 454.629 106.881C454.629 108.685 456.097 110.153 457.909 110.153C459.721 110.153 461.177 108.685 461.177 106.881C461.177 105.078 459.709 103.609 457.909 103.609Z"
            fill="white"
          />
          <path
            d="M481.992 88.9648C480.18 88.9648 478.712 90.4374 478.712 92.2495C478.712 94.0616 480.18 95.5299 481.992 95.5299C483.804 95.5299 485.268 94.0616 485.268 92.2495C485.268 90.4374 483.8 88.9648 481.992 88.9648Z"
            fill="white"
          />
          <path
            d="M506.661 73.0547C504.849 73.0547 503.381 74.523 503.381 76.3394C503.381 78.1557 504.849 79.624 506.661 79.624C508.473 79.624 509.942 78.1557 509.942 76.3394C509.942 74.523 508.473 73.0547 506.661 73.0547Z"
            fill="white"
          />
          <path
            d="M530.974 56.5391C529.162 56.5391 527.693 58.0074 527.693 59.8195C527.693 61.6316 529.162 63.1041 530.974 63.1041C532.786 63.1041 534.263 61.6316 534.263 59.8195C534.263 58.0074 532.786 56.5391 530.974 56.5391Z"
            fill="white"
          />
          <path
            d="M554.139 39.7363C552.327 39.7363 550.851 41.2089 550.851 43.0252C550.851 44.8416 552.327 46.3141 554.139 46.3141C555.952 46.3141 557.428 44.8416 557.428 43.0252C557.428 41.2089 555.96 39.7363 554.139 39.7363Z"
            fill="white"
          />
          <path
            d="M575.987 23.709C574.175 23.709 572.698 25.1858 572.698 27.0064C572.698 28.8269 574.175 30.2953 575.987 30.2953C577.799 30.2953 579.289 28.8227 579.289 27.0064C579.289 25.1901 577.812 23.709 575.987 23.709Z"
            fill="white"
          />
          <path
            d="M596.379 9.04688C594.558 9.04688 593.09 10.5237 593.09 12.3485C593.09 14.1733 594.558 15.6374 596.379 15.6374C598.199 15.6374 599.668 14.1648 599.668 12.3485C599.668 10.5322 598.199 9.04688 596.379 9.04688Z"
            fill="white"
          />
          <path
            d="M615.441 -2.35156C613.62 -2.35156 612.144 -0.874738 612.144 0.950074C612.144 2.77489 613.62 4.24747 615.441 4.24747C617.262 4.24747 618.743 2.77064 618.743 0.950074C618.743 -0.870494 617.266 -2.35156 615.441 -2.35156Z"
            fill="white"
          />
          <path
            d="M796.751 -0.820312C794.867 -0.820312 793.326 0.711681 793.326 2.60439C793.326 4.49711 794.867 6.02486 796.751 6.02486C798.635 6.02486 800.176 4.48862 800.176 2.60439C800.176 0.720168 798.644 -0.820312 796.751 -0.820312Z"
            fill="white"
          />
          <path
            d="M803.453 10.7539C801.527 10.7539 799.965 12.3156 799.965 14.2423C799.965 16.1689 801.527 17.7179 803.453 17.7179C805.38 17.7179 806.929 16.1604 806.929 14.2423C806.929 12.3241 805.367 10.7539 803.453 10.7539Z"
            fill="white"
          />
          <path
            d="M809.915 23.3203C807.959 23.3203 806.376 24.899 806.376 26.8554C806.376 28.8117 807.959 30.3819 809.915 30.3819C811.872 30.3819 813.442 28.799 813.442 26.8554C813.442 24.9117 811.859 23.3203 809.915 23.3203Z"
            fill="white"
          />
          <path
            d="M816.086 37.0137C814.108 37.0137 812.504 38.6178 812.504 40.5954C812.504 42.573 814.108 44.1686 816.086 44.1686C818.063 44.1686 819.655 42.5645 819.655 40.5954C819.655 38.6263 818.063 37.0137 816.086 37.0137Z"
            fill="white"
          />
          <path
            d="M821.925 52.041C819.917 52.041 818.292 53.6664 818.292 55.6694C818.292 57.6725 819.917 59.2978 821.925 59.2978C823.932 59.2978 825.545 57.6725 825.545 55.6694C825.545 53.6664 823.919 52.041 821.925 52.041Z"
            fill="white"
          />
          <path
            d="M827.421 68.5176C825.392 68.5176 823.737 70.1726 823.737 72.2054C823.737 74.2381 825.392 75.8932 827.421 75.8932C829.449 75.8932 831.104 74.2381 831.104 72.2054C831.104 70.1726 829.462 68.5176 827.421 68.5176Z"
            fill="white"
          />
          <path
            d="M832.645 86.2617C830.583 86.2617 828.919 87.9253 828.919 89.975C828.919 92.0247 830.583 93.701 832.645 93.701C834.707 93.701 836.362 92.0375 836.362 89.975C836.362 87.9125 834.699 86.2617 832.645 86.2617Z"
            fill="white"
          />
          <path
            d="M837.754 104.57C835.674 104.57 833.985 106.255 833.985 108.339C833.985 110.422 835.67 112.107 837.754 112.107C839.837 112.107 841.522 110.422 841.522 108.339C841.522 106.255 839.825 104.57 837.754 104.57Z"
            fill="white"
          />
          <path
            d="M842.961 122.678C840.861 122.678 839.15 124.384 839.15 126.489C839.15 128.594 840.856 130.287 842.961 130.287C845.066 130.287 846.759 128.585 846.759 126.489C846.759 124.392 845.062 122.678 842.961 122.678Z"
            fill="white"
          />
          <path
            d="M848.423 139.844C846.301 139.844 844.574 141.571 844.574 143.693C844.574 145.815 846.301 147.542 848.423 147.542C850.545 147.542 852.272 145.815 852.272 143.693C852.272 141.571 850.554 139.844 848.423 139.844Z"
            fill="white"
          />
          <path
            d="M854.233 155.852C852.09 155.852 850.35 157.591 850.35 159.735C850.35 161.878 852.085 163.618 854.233 163.618C856.38 163.618 858.103 161.878 858.103 159.735C858.103 157.591 856.376 155.852 854.233 155.852Z"
            fill="white"
          />
          <path
            d="M860.395 170.662C858.231 170.662 856.482 172.411 856.482 174.575C856.482 176.739 858.231 178.488 860.395 178.488C862.559 178.488 864.308 176.739 864.308 174.575C864.308 172.411 862.559 170.662 860.395 170.662Z"
            fill="white"
          />
          <path
            d="M866.917 184.326C864.74 184.326 862.975 186.092 862.975 188.269C862.975 190.446 864.744 192.215 866.917 192.215C869.09 192.215 870.864 190.446 870.864 188.269C870.864 186.092 869.094 184.326 866.917 184.326Z"
            fill="white"
          />
          <path
            d="M873.788 196.891C871.581 196.891 869.803 198.681 869.803 200.875C869.803 203.07 871.581 204.873 873.788 204.873C875.994 204.873 877.785 203.082 877.785 200.875C877.785 198.669 875.994 196.891 873.788 196.891Z"
            fill="white"
          />
          <path
            d="M880.982 208.41C878.766 208.41 876.976 210.21 876.976 212.416C876.976 214.623 878.766 216.435 880.982 216.435C883.197 216.435 884.988 214.636 884.988 212.416C884.988 210.197 883.197 208.41 880.982 208.41Z"
            fill="white"
          />
          <path
            d="M888.454 218.965C886.226 218.965 884.427 220.777 884.427 223.005C884.427 225.233 886.226 227.045 888.454 227.045C890.682 227.045 892.494 225.233 892.494 223.005C892.494 220.777 890.695 218.965 888.454 218.965Z"
            fill="white"
          />
          <path
            d="M896.207 228.609C893.958 228.609 892.15 230.43 892.15 232.671C892.15 234.911 893.962 236.728 896.207 236.728C898.452 236.728 900.269 234.916 900.269 232.671C900.269 230.426 898.448 228.609 896.207 228.609Z"
            fill="white"
          />
          <path
            d="M904.191 237.438C901.933 237.438 900.1 239.271 900.1 241.528C900.1 243.786 901.933 245.607 904.191 245.607C906.448 245.607 908.269 243.786 908.269 241.528C908.269 239.271 906.448 237.438 904.191 237.438Z"
            fill="white"
          />
          <path
            d="M912.394 245.471C910.124 245.471 908.295 247.312 908.295 249.583C908.295 251.853 910.128 253.682 912.394 253.682C914.661 253.682 916.494 251.841 916.494 249.583C916.494 247.325 914.661 245.471 912.394 245.471Z"
            fill="white"
          />
          <path
            d="M920.792 252.748C918.521 252.748 916.68 254.59 916.68 256.86C916.68 259.131 918.521 260.981 920.792 260.981C923.062 260.981 924.913 259.139 924.913 256.86C924.913 254.581 923.071 252.748 920.792 252.748Z"
            fill="white"
          />
          <path
            d="M929.376 259.25C927.085 259.25 925.234 261.092 925.234 263.383C925.234 265.675 927.089 267.517 929.376 267.517C931.664 267.517 933.51 265.667 933.51 263.383C933.51 261.1 931.659 259.25 929.376 259.25Z"
            fill="white"
          />
          <path
            d="M938.098 264.988C935.806 264.988 933.943 266.851 933.943 269.143C933.943 271.435 935.806 273.298 938.098 273.298C940.39 273.298 942.261 271.447 942.261 269.143C942.261 266.839 940.398 264.988 938.098 264.988Z"
            fill="white"
          />
          <path
            d="M946.946 270.031C944.654 270.031 942.791 271.882 942.791 274.186C942.791 276.49 944.654 278.341 946.946 278.341C949.237 278.341 951.109 276.477 951.109 274.186C951.109 271.894 949.246 270.031 946.946 270.031Z"
            fill="white"
          />
          <path
            d="M955.874 274.383C953.583 274.383 951.72 276.246 951.72 278.537C951.72 280.829 953.583 282.692 955.874 282.692C958.166 282.692 960.029 280.838 960.029 278.537C960.029 276.237 958.166 274.383 955.874 274.383Z"
            fill="white"
          />
          <path
            d="M964.816 278.092C962.528 278.092 960.661 279.955 960.661 282.246C960.661 284.538 962.524 286.401 964.816 286.401C967.107 286.401 968.97 284.538 968.97 282.246C968.97 279.955 967.12 278.092 964.816 278.092Z"
            fill="white"
          />
          <path
            d="M973.716 281.182C971.425 281.182 969.562 283.045 969.562 285.336C969.562 287.628 971.425 289.491 973.716 289.491C976.008 289.491 977.871 287.628 977.871 285.336C977.871 283.045 976.016 281.182 973.716 281.182Z"
            fill="white"
          />
          <path
            d="M968.551 283.182C966.26 283.182 964.396 285.045 964.396 287.336C964.396 289.628 966.26 291.491 968.551 291.491C970.843 291.491 972.706 289.628 972.706 287.336C972.706 285.045 970.855 283.182 968.551 283.182Z"
            fill="white"
          />
          <path
            d="M963.243 285.166C960.951 285.166 959.088 287.029 959.088 289.321C959.088 291.612 960.951 293.475 963.243 293.475C965.534 293.475 967.397 291.612 967.397 289.321C967.397 287.029 965.534 285.166 963.243 285.166Z"
            fill="white"
          />
          <path
            d="M957.78 287.186C955.488 287.186 953.625 289.049 953.625 291.34C953.625 293.632 955.488 295.503 957.78 295.503C960.071 295.503 961.934 293.64 961.934 291.34C961.934 289.04 960.071 287.186 957.78 287.186Z"
            fill="white"
          />
          <path
            d="M952.15 289.301C949.858 289.301 947.995 291.155 947.995 293.455C947.995 295.756 949.858 297.61 952.15 297.61C954.441 297.61 956.304 295.747 956.304 293.455C956.304 291.164 954.45 289.301 952.15 289.301Z"
            fill="white"
          />
          <path
            d="M946.353 291.514C944.061 291.514 942.198 293.377 942.198 295.668C942.198 297.96 944.061 299.823 946.353 299.823C948.645 299.823 950.508 297.973 950.508 295.668C950.508 293.364 948.653 291.514 946.353 291.514Z"
            fill="white"
          />
          <path
            d="M940.368 293.9C938.077 293.9 936.214 295.763 936.214 298.055C936.214 300.347 938.077 302.21 940.368 302.21C942.66 302.21 944.532 300.347 944.532 298.055C944.532 295.763 942.669 293.9 940.368 293.9Z"
            fill="white"
          />
          <path
            d="M934.185 296.48C931.893 296.48 930.03 298.343 930.03 300.644C930.03 302.944 931.893 304.798 934.185 304.798C936.477 304.798 938.34 302.935 938.34 300.644C938.34 298.352 936.477 296.48 934.185 296.48Z"
            fill="white"
          />
          <path
            d="M927.773 299.324C925.481 299.324 923.618 301.187 923.618 303.479C923.618 305.77 925.481 307.633 927.773 307.633C930.064 307.633 931.927 305.779 931.927 303.479C931.927 301.179 930.064 299.324 927.773 299.324Z"
            fill="white"
          />
          <path
            d="M921.122 302.465C918.831 302.465 916.98 304.319 916.98 306.607C916.98 308.894 918.831 310.749 921.122 310.749C923.414 310.749 925.264 308.894 925.264 306.607C925.264 304.319 923.41 302.465 921.122 302.465Z"
            fill="white"
          />
          <path
            d="M914.235 305.945C911.943 305.945 910.102 307.787 910.102 310.066C910.102 312.345 911.943 314.199 914.235 314.199C916.527 314.199 918.356 312.358 918.356 310.066C918.356 307.774 916.514 305.945 914.235 305.945Z"
            fill="white"
          />
          <path
            d="M907.093 309.771C904.814 309.771 902.98 311.613 902.98 313.884C902.98 316.154 904.814 317.996 907.093 317.996C909.372 317.996 911.205 316.154 911.205 313.884C911.205 311.613 909.363 309.771 907.093 309.771Z"
            fill="white"
          />
          <path
            d="M899.734 313.965C897.477 313.965 895.644 315.798 895.644 318.056C895.644 320.313 897.477 322.134 899.734 322.134C901.992 322.134 903.813 320.301 903.813 318.056C903.813 315.811 901.979 313.965 899.734 313.965Z"
            fill="white"
          />
          <path
            d="M892.202 318.494C889.952 318.494 888.132 320.315 888.132 322.564C888.132 324.813 889.952 326.634 892.202 326.634C894.451 326.634 896.259 324.813 896.259 322.564C896.259 320.315 894.438 318.494 892.202 318.494Z"
            fill="white"
          />
          <path
            d="M884.542 323.344C882.305 323.344 880.493 325.156 880.493 327.392C880.493 329.629 882.305 331.432 884.542 331.432C886.778 331.432 888.582 329.62 888.582 327.392C888.582 325.164 886.77 323.344 884.542 323.344Z"
            fill="white"
          />
          <path
            d="M876.826 328.432C874.598 328.432 872.799 330.231 872.799 332.459C872.799 334.687 874.598 336.486 876.826 336.486C879.054 336.486 880.853 334.687 880.853 332.459C880.853 330.231 879.041 328.432 876.826 328.432Z"
            fill="white"
          />
          <path
            d="M869.125 333.721C866.918 333.721 865.14 335.499 865.14 337.706C865.14 339.912 866.918 341.682 869.125 341.682C871.331 341.682 873.101 339.904 873.101 337.706C873.101 335.507 871.323 333.721 869.125 333.721Z"
            fill="white"
          />
          <path
            d="M861.476 339.037C859.291 339.037 857.513 340.815 857.513 343.001C857.513 345.186 859.291 346.964 861.476 346.964C863.662 346.964 865.44 345.186 865.44 343.001C865.44 340.815 863.67 339.037 861.476 339.037Z"
            fill="white"
          />
          <path
            d="M857.482 349.943C858.313 347.936 857.36 345.634 855.352 344.803C853.345 343.971 851.044 344.925 850.212 346.932C849.381 348.939 850.334 351.24 852.342 352.072C854.349 352.903 856.65 351.95 857.482 349.943Z"
            fill="white"
          />
          <path
            d="M846.081 350.465C843.916 350.465 842.168 352.213 842.168 354.369C842.168 356.525 843.916 358.273 846.081 358.273C848.245 358.273 849.985 356.525 849.985 354.369C849.985 352.213 848.237 350.465 846.081 350.465Z"
            fill="white"
          />
          <path
            d="M840.883 363.592C842.391 362.084 842.391 359.639 840.883 358.131C839.374 356.623 836.929 356.622 835.421 358.131C833.913 359.639 833.913 362.084 835.421 363.592C836.929 365.1 839.374 365.1 840.883 363.592Z"
            fill="white"
          />
          <path
            d="M830.064 364.143C827.951 364.143 826.236 365.849 826.236 367.962C826.236 370.075 827.955 371.794 830.064 371.794C832.173 371.794 833.896 370.075 833.896 367.962C833.896 365.849 832.178 364.143 830.064 364.143Z"
            fill="white"
          />
          <path
            d="M821.782 371.889C819.689 371.889 817.983 373.586 817.983 375.687C817.983 377.787 819.689 379.485 821.782 379.485C823.874 379.485 825.58 377.779 825.58 375.687C825.58 373.595 823.882 371.889 821.782 371.889Z"
            fill="white"
          />
          <path
            d="M813.289 380.264C811.209 380.264 809.521 381.948 809.521 384.032C809.521 386.116 811.205 387.788 813.289 387.788C815.373 387.788 817.057 386.103 817.057 384.032C817.057 381.961 815.373 380.264 813.289 380.264Z"
            fill="white"
          />
          <path
            d="M804.555 389.287C802.506 389.287 800.851 390.951 800.851 392.992C800.851 395.033 802.506 396.697 804.555 396.697C806.605 396.697 808.26 395.042 808.26 392.992C808.26 390.942 806.597 389.287 804.555 389.287Z"
            fill="white"
          />
          <path
            d="M795.605 398.916C793.576 398.916 791.942 400.563 791.942 402.591C791.942 404.62 793.576 406.253 795.605 406.253C797.633 406.253 799.28 404.607 799.28 402.591C799.28 400.575 797.633 398.916 795.605 398.916Z"
            fill="white"
          />
          <path
            d="M790.857 410.938C788.871 410.938 787.254 412.55 787.254 414.54C787.254 416.531 788.867 418.131 790.857 418.131C792.847 418.131 794.447 416.527 794.447 414.54C794.447 412.554 792.843 410.938 790.857 410.938Z"
            fill="white"
          />
          <path
            d="M777.663 420.398C775.685 420.398 774.081 422.003 774.081 423.989C774.081 425.975 775.685 427.57 777.663 427.57C779.64 427.57 781.253 425.966 781.253 423.989C781.253 422.011 779.649 420.398 777.663 420.398Z"
            fill="white"
          />
          <path
            d="M764.372 437.638C766.35 437.638 767.953 436.034 767.953 434.056C767.953 432.078 766.35 430.475 764.372 430.475C762.394 430.475 760.79 432.078 760.79 434.056C760.79 436.034 762.394 437.638 764.372 437.638Z"
            fill="white"
          />
          <path
            d="M750.987 441.199C749.018 441.199 747.418 442.803 747.418 444.781C747.418 446.759 749.022 448.35 750.987 448.35C752.952 448.35 754.569 446.746 754.569 444.781C754.569 442.816 752.965 441.199 750.987 441.199Z"
            fill="white"
          />
          <path
            d="M737.508 452.393C735.531 452.393 733.927 453.997 733.927 455.962C733.927 457.926 735.531 459.531 737.508 459.531C739.486 459.531 741.077 457.939 741.077 455.962C741.077 453.984 739.473 452.393 737.508 452.393Z"
            fill="white"
          />
          <path
            d="M723.966 463.914C721.989 463.914 720.397 465.518 720.397 467.483C720.397 469.448 721.989 471.065 723.966 471.065C725.944 471.065 727.535 469.461 727.535 467.483C727.535 465.505 725.944 463.914 723.966 463.914Z"
            fill="white"
          />
          <path
            d="M710.374 475.529C708.409 475.529 706.805 477.121 706.805 479.098C706.805 481.076 708.409 482.659 710.374 482.659C712.339 482.659 713.943 481.067 713.943 479.098C713.943 477.129 712.339 475.529 710.374 475.529Z"
            fill="white"
          />
          <path
            d="M696.624 486.799C694.659 486.799 693.063 488.39 693.063 490.359C693.063 492.328 694.655 493.92 696.624 493.92C698.593 493.92 700.193 492.328 700.193 490.359C700.193 488.39 698.589 486.799 696.624 486.799Z"
            fill="white"
          />
          <path
            d="M682.781 497.426C680.812 497.426 679.212 499.03 679.212 500.995C679.212 502.96 680.816 504.555 682.781 504.555C684.746 504.555 686.341 502.964 686.341 500.995C686.341 499.026 684.75 497.426 682.781 497.426Z"
            fill="white"
          />
          <path
            d="M668.93 507.264C666.961 507.264 665.369 508.855 665.369 510.811C665.369 512.768 666.961 514.372 668.93 514.372C670.899 514.372 672.477 512.781 672.477 510.811C672.477 508.842 670.886 507.264 668.93 507.264Z"
            fill="white"
          />
          <path
            d="M655.044 516.1C653.075 516.1 651.483 517.691 651.483 519.66C651.483 521.629 653.075 523.221 655.044 523.221C657.013 523.221 658.592 521.629 658.592 519.66C658.592 517.691 657 516.1 655.044 516.1Z"
            fill="white"
          />
          <path
            d="M641.184 523.861C639.227 523.861 637.636 525.453 637.636 527.409C637.636 529.365 639.227 530.97 641.184 530.97C643.14 530.97 644.744 529.378 644.744 527.409C644.744 525.44 643.153 523.861 641.184 523.861Z"
            fill="white"
          />
          <path
            d="M627.506 530.781C625.549 530.781 623.958 532.373 623.958 534.329C623.958 536.285 625.549 537.868 627.506 537.868C629.462 537.868 631.054 536.285 631.054 534.329C631.054 532.373 629.462 530.781 627.506 530.781Z"
            fill="white"
          />
          <path
            d="M613.964 536.965C612.007 536.965 610.416 538.556 610.416 540.513C610.416 542.469 612.007 544.06 613.964 544.06C615.92 544.06 617.503 542.469 617.503 540.513C617.503 538.556 615.92 536.965 613.964 536.965Z"
            fill="white"
          />
          <path
            d="M600.486 542.504C598.529 542.504 596.946 544.087 596.946 546.043C596.946 548 598.529 549.583 600.486 549.583C602.442 549.583 604.033 548 604.033 546.043C604.033 544.087 602.442 542.504 600.486 542.504Z"
            fill="white"
          />
          <path
            d="M587.145 547.895C585.188 547.895 583.605 549.477 583.605 551.434C583.605 553.39 585.188 554.973 587.145 554.973C589.101 554.973 590.684 553.39 590.684 551.434C590.684 549.477 589.101 547.895 587.145 547.895Z"
            fill="white"
          />
          <path
            d="M573.945 553.273C571.998 553.273 570.419 554.856 570.419 556.813C570.419 558.769 572.002 560.352 573.945 560.352C575.889 560.352 577.485 558.769 577.485 556.813C577.485 554.856 575.902 553.273 573.945 553.273Z"
            fill="white"
          />
          <path
            d="M560.875 558.719C558.927 558.719 557.336 560.302 557.336 562.258C557.336 564.214 558.927 565.785 560.875 565.785C562.823 565.785 564.414 564.202 564.414 562.258C564.414 560.314 562.832 558.719 560.875 558.719Z"
            fill="white"
          />
          <path
            d="M548.776 571.179C550.653 570.66 551.755 568.718 551.236 566.841C550.717 564.963 548.774 563.862 546.897 564.381C545.02 564.9 543.919 566.842 544.438 568.719C544.956 570.597 546.899 571.698 548.776 571.179Z"
            fill="white"
          />
          <path
            d="M535.463 576.614C537.385 576.301 538.69 574.489 538.377 572.567C538.065 570.645 536.253 569.34 534.33 569.652C532.408 569.965 531.103 571.777 531.416 573.7C531.729 575.622 533.541 576.927 535.463 576.614Z"
            fill="white"
          />
          <path
            d="M521.969 574.904C520.021 574.904 518.442 576.487 518.442 578.431C518.442 580.375 520.025 581.949 521.969 581.949C523.913 581.949 525.495 580.379 525.495 578.431C525.495 576.483 523.913 574.904 521.969 574.904Z"
            fill="white"
          />
          <path
            d="M509.012 580.064C507.064 580.064 505.485 581.647 505.485 583.591C505.485 585.535 507.068 587.109 509.012 587.109C510.956 587.109 512.53 585.539 512.53 583.591C512.53 581.643 510.96 580.064 509.012 580.064Z"
            fill="white"
          />
          <path
            d="M495.984 584.979C494.036 584.979 492.466 586.549 492.466 588.497C492.466 590.444 494.036 592.015 495.984 592.015C497.932 592.015 499.502 590.444 499.502 588.497C499.502 586.549 497.919 584.979 495.984 584.979Z"
            fill="white"
          />
          <path
            d="M482.879 589.463C480.932 589.463 479.361 591.033 479.361 592.981C479.361 594.929 480.932 596.499 482.879 596.499C484.827 596.499 486.397 594.929 486.397 592.981C486.397 591.033 484.815 589.463 482.879 589.463Z"
            fill="white"
          />
          <path
            d="M469.66 593.535C467.724 593.535 466.154 595.105 466.154 597.045C466.154 598.984 467.724 600.563 469.66 600.563C471.595 600.563 473.178 598.993 473.178 597.045C473.178 595.097 471.608 593.535 469.66 593.535Z"
            fill="white"
          />
          <path
            d="M456.309 597.061C454.361 597.061 452.791 598.643 452.791 600.579C452.791 602.514 454.361 604.097 456.309 604.097C458.257 604.097 459.814 602.514 459.814 600.579C459.814 598.643 458.244 597.061 456.309 597.061Z"
            fill="white"
          />
          <path
            d="M442.809 599.85C440.861 599.85 439.291 601.42 439.291 603.368C439.291 605.316 440.861 606.886 442.809 606.886C444.757 606.886 446.327 605.316 446.327 603.368C446.327 601.42 444.744 599.85 442.809 599.85Z"
            fill="white"
          />
          <path
            d="M429.174 601.891C427.226 601.891 425.656 603.474 425.656 605.409C425.656 607.344 427.226 608.927 429.174 608.927C431.122 608.927 432.692 607.357 432.692 605.409C432.692 603.461 431.109 601.891 429.174 601.891Z"
            fill="white"
          />
          <path
            d="M420.555 599.85C418.598 599.85 417.007 601.441 417.007 603.397C417.007 605.354 418.598 606.945 420.555 606.945C422.511 606.945 424.115 605.362 424.115 603.397C424.115 601.433 422.524 599.85 420.555 599.85Z"
            fill="white"
          />
          <path
            d="M411.822 597.248C409.836 597.248 408.231 598.852 408.231 600.838C408.231 602.824 409.836 604.428 411.822 604.428C413.808 604.428 415.412 602.824 415.412 600.838C415.412 598.852 413.799 597.248 411.822 597.248Z"
            fill="white"
          />
          <path
            d="M403.008 593.938C401 593.938 399.375 595.571 399.375 597.579C399.375 599.586 401 601.22 403.008 601.22C405.015 601.22 406.649 599.586 406.649 597.579C406.649 595.571 405.015 593.938 403.008 593.938Z"
            fill="white"
          />
          <path
            d="M394.201 589.818C392.16 589.818 390.518 591.465 390.518 593.502C390.518 595.539 392.164 597.177 394.201 597.177C396.238 597.177 397.876 595.53 397.876 593.502C397.876 591.473 396.234 589.818 394.201 589.818Z"
            fill="white"
          />
          <path
            d="M385.451 584.852C383.401 584.852 381.733 586.507 381.733 588.556C381.733 590.606 383.397 592.274 385.451 592.274C387.505 592.274 389.168 590.619 389.168 588.556C389.168 586.494 387.505 584.852 385.451 584.852Z"
            fill="white"
          />
          <path
            d="M376.845 578.891C374.761 578.891 373.089 580.567 373.089 582.646C373.089 584.726 374.765 586.402 376.845 586.402C378.924 586.402 380.6 584.717 380.6 582.646C380.6 580.575 378.916 578.891 376.845 578.891Z"
            fill="white"
          />
          <path
            d="M368.456 571.812C366.363 571.812 364.679 573.497 364.679 575.589C364.679 577.682 366.363 579.379 368.456 579.379C370.548 579.379 372.245 577.682 372.245 575.589C372.245 573.497 370.548 571.812 368.456 571.812Z"
            fill="white"
          />
          <path
            d="M360.387 563.453C358.265 563.453 356.555 565.172 356.555 567.281C356.555 569.39 358.261 571.113 360.387 571.113C362.513 571.113 364.206 569.394 364.206 567.281C364.206 565.168 362.5 563.453 360.387 563.453Z"
            fill="white"
          />
          <path
            d="M352.72 553.703C350.598 553.703 348.871 555.43 348.871 557.552C348.871 559.674 350.598 561.401 352.72 561.401C354.842 561.401 356.569 559.683 356.569 557.552C356.569 555.422 354.851 553.703 352.72 553.703Z"
            fill="white"
          />
          <path
            d="M345.569 542.346C343.425 542.346 341.698 544.086 341.698 546.229C341.698 548.372 343.425 550.099 345.569 550.099C347.712 550.099 349.452 548.359 349.452 546.229C349.452 544.098 347.716 542.346 345.569 542.346Z"
            fill="white"
          />
          <path
            d="M338.978 529.355C336.823 529.355 335.074 531.104 335.074 533.26C335.074 535.416 336.823 537.164 338.978 537.164C341.134 537.164 342.883 535.416 342.883 533.26C342.883 531.104 341.134 529.355 338.978 529.355Z"
            fill="white"
          />
          <path
            d="M332.9 514.924C330.723 514.924 328.966 516.681 328.966 518.858C328.966 521.035 330.727 522.804 332.9 522.804C335.073 522.804 336.842 521.035 336.842 518.858C336.842 516.681 335.073 514.924 332.9 514.924Z"
            fill="white"
          />
          <path
            d="M327.184 499.412C324.999 499.412 323.221 501.182 323.221 503.367C323.221 505.553 324.999 507.322 327.184 507.322C329.37 507.322 331.14 505.553 331.14 503.367C331.14 501.182 329.37 499.412 327.184 499.412Z"
            fill="white"
          />
          <path
            d="M321.579 483.334C319.38 483.334 317.594 485.112 317.594 487.319C317.594 489.526 319.385 491.295 321.579 491.295C323.773 491.295 325.563 489.517 325.563 487.319C325.563 485.121 323.785 483.334 321.579 483.334Z"
            fill="white"
          />
          <path
            d="M315.832 467.244C313.617 467.244 311.826 469.035 311.826 471.242C311.826 473.448 313.617 475.239 315.832 475.239C318.048 475.239 319.83 473.448 319.83 471.242C319.83 469.035 318.039 467.244 315.832 467.244Z"
            fill="white"
          />
          <path
            d="M309.764 451.453C307.536 451.453 305.736 453.252 305.736 455.48C305.736 457.708 307.536 459.499 309.764 459.499C311.992 459.499 313.791 457.7 313.791 455.48C313.791 453.261 311.992 451.453 309.764 451.453Z"
            fill="white"
          />
          <path
            d="M303.271 436.291C301.043 436.291 299.244 438.103 299.244 440.331C299.244 442.559 301.043 444.371 303.271 444.371C305.499 444.371 307.312 442.559 307.312 440.331C307.312 438.103 305.512 436.291 303.271 436.291Z"
            fill="white"
          />
          <path
            d="M296.286 422.02C294.049 422.02 292.237 423.832 292.237 426.068C292.237 428.305 294.049 430.117 296.286 430.117C298.522 430.117 300.343 428.305 300.343 426.068C300.343 423.832 298.522 422.02 296.286 422.02Z"
            fill="white"
          />
          <path
            d="M288.884 408.533C286.635 408.533 284.814 410.354 284.814 412.603C284.814 414.852 286.635 416.66 288.884 416.66C291.133 416.66 292.941 414.839 292.941 412.603C292.941 410.367 291.121 408.533 288.884 408.533Z"
            fill="white"
          />
          <path
            d="M281.195 395.439C278.946 395.439 277.125 397.273 277.125 399.518C277.125 401.763 278.946 403.587 281.195 403.587C283.444 403.587 285.273 401.767 285.273 399.518C285.273 397.269 283.452 395.439 281.195 395.439Z"
            fill="white"
          />
          <path
            d="M273.293 382.73C271.044 382.73 269.215 384.551 269.215 386.809C269.215 389.066 271.048 390.878 273.293 390.878C275.538 390.878 277.363 389.058 277.363 386.809C277.363 384.56 275.542 382.73 273.293 382.73Z"
            fill="white"
          />
          <path
            d="M265.247 370.334C262.99 370.334 261.156 372.167 261.156 374.412C261.156 376.657 262.99 378.503 265.247 378.503C267.505 378.503 269.325 376.67 269.325 374.412C269.325 372.155 267.492 370.334 265.247 370.334Z"
            fill="white"
          />
          <path
            d="M257.077 358.482C254.828 358.482 252.999 360.316 252.999 362.573C252.999 364.831 254.832 366.652 257.077 366.652C259.322 366.652 261.168 364.818 261.168 362.573C261.168 360.328 259.335 358.482 257.077 358.482Z"
            fill="white"
          />
          <path
            d="M248.879 347.146C246.621 347.146 244.801 348.98 244.801 351.237C244.801 353.495 246.621 355.316 248.879 355.316C251.137 355.316 252.957 353.482 252.957 351.237C252.957 348.992 251.137 347.146 248.879 347.146Z"
            fill="white"
          />
          <path
            d="M240.719 336.219C238.47 336.219 236.641 338.052 236.641 340.297C236.641 342.542 238.474 344.375 240.719 344.375C242.964 344.375 244.797 342.542 244.797 340.297C244.797 338.052 242.964 336.219 240.719 336.219Z"
            fill="white"
          />
          <path
            d="M232.651 325.613C230.393 325.613 228.572 327.447 228.572 329.692C228.572 331.936 230.393 333.77 232.651 333.77C234.908 333.77 236.729 331.936 236.729 329.692C236.729 327.447 234.895 325.613 232.651 325.613Z"
            fill="white"
          />
          <path
            d="M224.689 315.391C222.44 315.391 220.619 317.211 220.619 319.46C220.619 321.71 222.44 323.539 224.689 323.539C226.938 323.539 228.767 321.718 228.767 319.46C228.767 317.203 226.947 315.391 224.689 315.391Z"
            fill="white"
          />
          <path
            d="M231.934 301.039C229.676 301.039 227.855 302.86 227.855 305.109C227.855 307.358 229.676 309.187 231.934 309.187C234.191 309.187 236.003 307.367 236.003 305.109C236.003 302.851 234.183 301.039 231.934 301.039Z"
            fill="white"
          />
          <path
            d="M239.241 288.268C237.004 288.268 235.184 290.088 235.184 292.325C235.184 294.561 237.004 296.382 239.241 296.382C241.477 296.382 243.298 294.57 243.298 292.325C243.298 290.08 241.486 288.268 239.241 288.268Z"
            fill="white"
          />
          <path
            d="M246.6 276.934C244.364 276.934 242.543 278.754 242.543 280.991C242.543 283.227 244.364 285.048 246.6 285.048C248.836 285.048 250.661 283.236 250.661 280.991C250.661 278.746 248.849 276.934 246.6 276.934Z"
            fill="white"
          />
          <path
            d="M253.946 266.809C251.71 266.809 249.897 268.621 249.897 270.857C249.897 273.094 251.71 274.906 253.946 274.906C256.182 274.906 257.986 273.094 257.986 270.857C257.986 268.621 256.174 266.809 253.946 266.809Z"
            fill="white"
          />
          <path
            d="M261.126 257.723C258.911 257.723 257.107 259.522 257.107 261.742C257.107 263.961 258.907 265.76 261.126 265.76C263.346 265.76 265.145 263.969 265.145 261.742C265.145 259.514 263.346 257.723 261.126 257.723Z"
            fill="white"
          />
          <path
            d="M268.048 249.426C265.833 249.426 264.042 251.217 264.042 253.432C264.042 255.647 265.833 257.438 268.048 257.438C270.263 257.438 272.054 255.639 272.054 253.432C272.054 251.225 270.263 249.426 268.048 249.426Z"
            fill="white"
          />
          <path
            d="M274.668 241.674C272.461 241.674 270.67 243.465 270.67 245.671C270.67 247.878 272.461 249.656 274.668 249.656C276.874 249.656 278.652 247.878 278.652 245.671C278.652 243.465 276.862 241.674 274.668 241.674Z"
            fill="white"
          />
          <path
            d="M280.945 234.314C278.747 234.314 276.969 236.093 276.969 238.291C276.969 240.489 278.747 242.267 280.945 242.267C283.143 242.267 284.922 240.489 284.922 238.291C284.922 236.093 283.143 234.314 280.945 234.314Z"
            fill="white"
          />
          <path
            d="M286.827 227.412C284.649 227.412 282.893 229.182 282.893 231.359C282.893 233.536 284.649 235.293 286.827 235.293C289.004 235.293 290.769 233.536 290.769 231.359C290.769 229.182 288.999 227.412 286.827 227.412Z"
            fill="white"
          />
          <path
            d="M292.309 221.129C290.145 221.129 288.384 222.886 288.384 225.054C288.384 227.223 290.145 228.98 292.309 228.98C294.474 228.98 296.243 227.219 296.243 225.054C296.243 222.89 294.486 221.129 292.309 221.129Z"
            fill="white"
          />
          <path
            d="M297.359 215.604C295.203 215.604 293.468 217.343 293.468 219.495C293.468 221.647 295.203 223.399 297.359 223.399C299.515 223.399 301.264 221.651 301.264 219.495C301.264 217.339 299.515 215.604 297.359 215.604Z"
            fill="white"
          />
          <path
            d="M301.917 210.73C299.783 210.73 298.047 212.458 298.047 214.592C298.047 216.727 299.787 218.463 301.917 218.463C304.048 218.463 305.787 216.735 305.787 214.592C305.787 212.449 304.06 210.73 301.917 210.73Z"
            fill="white"
          />
          <path
            d="M305.974 206.348C303.853 206.348 302.134 208.066 302.134 210.188C302.134 212.31 303.853 214.029 305.974 214.029C308.096 214.029 309.806 212.31 309.806 210.188C309.806 208.066 308.088 206.348 305.974 206.348Z"
            fill="white"
          />
          <path
            d="M309.492 202.385C307.392 202.385 305.694 204.091 305.694 206.196C305.694 208.301 307.392 209.994 309.492 209.994C311.593 209.994 313.291 208.288 313.291 206.196C313.291 204.103 311.593 202.385 309.492 202.385Z"
            fill="white"
          />
          <path
            d="M312.471 198.744C310.388 198.744 308.694 200.442 308.694 202.521C308.694 204.601 310.392 206.298 312.471 206.298C314.551 206.298 316.248 204.613 316.248 202.521C316.248 200.429 314.563 198.744 312.471 198.744Z"
            fill="white"
          />
          <path
            d="M314.924 195.369C312.862 195.369 311.189 197.045 311.189 199.116C311.189 201.187 312.866 202.864 314.924 202.864C316.982 202.864 318.671 201.187 318.671 199.116C318.671 197.045 316.995 195.369 314.924 195.369Z"
            fill="white"
          />
          <path
            d="M316.893 192.225C314.851 192.225 313.196 193.88 313.196 195.921C313.196 197.962 314.851 199.604 316.893 199.604C318.934 199.604 320.576 197.949 320.576 195.921C320.576 193.892 318.921 192.225 316.893 192.225Z"
            fill="white"
          />
          <path
            d="M318.405 189.229C316.385 189.229 314.751 190.862 314.751 192.882C314.751 194.902 316.385 196.536 318.405 196.536C320.425 196.536 322.059 194.902 322.059 192.882C322.059 190.862 320.425 189.229 318.405 189.229Z"
            fill="white"
          />
          <path
            d="M319.516 186.359C317.518 186.359 315.896 187.976 315.896 189.975C315.896 191.974 317.518 193.595 319.516 193.595C321.515 193.595 323.136 191.978 323.136 189.975C323.136 187.972 321.511 186.359 319.516 186.359Z"
            fill="white"
          />
          <path
            d="M320.275 183.605C318.297 183.605 316.693 185.21 316.693 187.179C316.693 189.148 318.297 190.752 320.275 190.752C322.253 190.752 323.844 189.148 323.844 187.179C323.844 185.21 322.24 183.605 320.275 183.605Z"
            fill="white"
          />
          <path
            d="M320.743 180.91C318.795 180.91 317.225 182.48 317.225 184.424C317.225 186.368 318.795 187.938 320.743 187.938C322.691 187.938 324.248 186.368 324.248 184.424C324.248 182.48 322.678 180.91 320.743 180.91Z"
            fill="white"
          />
          <path
            d="M320.984 178.152C319.07 178.152 317.509 179.701 317.509 181.624C317.509 183.546 319.07 185.095 320.984 185.095C322.898 185.095 324.452 183.546 324.452 181.624C324.452 179.701 322.903 178.152 320.984 178.152Z"
            fill="white"
          />
          <path
            d="M321.078 175.262C319.185 175.262 317.653 176.794 317.653 178.686C317.653 180.579 319.185 182.098 321.078 182.098C322.971 182.098 324.503 180.566 324.503 178.686C324.503 176.806 322.962 175.262 321.078 175.262Z"
            fill="white"
          />
          <path
            d="M321.129 172.092C319.266 172.092 317.755 173.607 317.755 175.47C317.755 177.333 319.266 178.844 321.129 178.844C322.992 178.844 324.511 177.333 324.511 175.47C324.511 173.607 323 172.092 321.129 172.092Z"
            fill="white"
          />
          <path
            d="M321.307 168.516C319.474 168.516 317.997 170.005 317.997 171.826C317.997 173.646 319.474 175.136 321.307 175.136C323.14 175.136 324.617 173.659 324.617 171.826C324.617 169.992 323.14 168.516 321.307 168.516Z"
            fill="white"
          />
          <path
            d="M321.837 164.27C320.038 164.27 318.569 165.738 318.569 167.537C318.569 169.337 320.038 170.805 321.837 170.805C323.636 170.805 325.105 169.337 325.105 167.537C325.105 165.738 323.636 164.27 321.837 164.27Z"
            fill="white"
          />
          <path
            d="M323.148 158.992C321.379 158.992 319.944 160.422 319.944 162.192C319.944 163.962 321.379 165.392 323.148 165.392C324.918 165.392 326.344 163.962 326.344 162.192C326.344 160.422 324.918 158.992 323.148 158.992Z"
            fill="white"
          />
          <path
            d="M337.127 154.568C335.349 154.568 333.91 156.003 333.91 157.772C333.91 159.542 335.345 160.989 337.127 160.989C338.909 160.989 340.331 159.546 340.331 157.772C340.331 155.998 338.897 154.568 337.127 154.568Z"
            fill="white"
          />
          <path
            d="M352.04 148.844C350.27 148.844 348.836 150.278 348.836 152.048C348.836 153.817 350.27 155.252 352.04 155.252C353.81 155.252 355.244 153.817 355.244 152.048C355.244 150.278 353.81 148.844 352.04 148.844Z"
            fill="white"
          />
          <path
            d="M368.277 141.621C366.508 141.621 365.061 143.06 365.061 144.838C365.061 146.616 366.508 148.05 368.277 148.05C370.047 148.05 371.494 146.607 371.494 144.838C371.494 143.068 370.06 141.621 368.277 141.621Z"
            fill="white"
          />
          <path
            d="M386.211 132.814C384.433 132.814 382.994 134.257 382.994 136.031C382.994 137.805 384.433 139.248 386.211 139.248C387.989 139.248 389.415 137.805 389.415 136.031C389.415 134.257 387.981 132.814 386.211 132.814Z"
            fill="white"
          />
          <path
            d="M406.059 122.453C404.28 122.453 402.842 123.888 402.842 125.67C402.842 127.452 404.276 128.887 406.059 128.887C407.841 128.887 409.275 127.452 409.275 125.67C409.275 123.888 407.841 122.453 406.059 122.453Z"
            fill="white"
          />
          <path
            d="M428.037 109.742C426.259 109.742 424.812 111.189 424.812 112.967C424.812 114.746 426.259 116.188 428.037 116.188C429.815 116.188 431.262 114.746 431.262 112.967C431.262 111.189 429.815 109.742 428.037 109.742Z"
            fill="white"
          />
          <path
            d="M451.801 94.9824C450.023 94.9824 448.576 96.4295 448.576 98.2077C448.576 99.9858 450.023 101.429 451.801 101.429C453.58 101.429 455.018 99.9858 455.018 98.2077C455.018 96.4295 453.58 94.9824 451.801 94.9824Z"
            fill="white"
          />
          <path
            d="M476.748 78.4238C474.957 78.4238 473.522 79.8709 473.522 81.6491C473.522 83.4272 474.961 84.8743 476.748 84.8743C478.534 84.8743 479.973 83.4314 479.973 81.6491C479.973 79.8667 478.526 78.4238 476.748 78.4238Z"
            fill="white"
          />
          <path
            d="M501.705 60.8887C499.914 60.8887 498.467 62.3358 498.467 64.1139C498.467 65.8921 499.914 67.3519 501.705 67.3519C503.496 67.3519 504.93 65.9048 504.93 64.1139C504.93 62.3231 503.483 60.8887 501.705 60.8887Z"
            fill="white"
          />
          <path
            d="M525.893 43.1582C524.115 43.1582 522.668 44.6053 522.668 46.3877C522.668 48.1701 524.115 49.6257 525.893 49.6257C527.671 49.6257 529.131 48.1786 529.131 46.3877C529.131 44.5968 527.684 43.1582 525.893 43.1582Z"
            fill="white"
          />
          <path
            d="M548.615 25.8027C546.824 25.8027 545.377 27.2499 545.377 29.0407C545.377 30.8316 546.824 32.2787 548.615 32.2787C550.406 32.2787 551.853 30.8273 551.853 29.0407C551.853 27.2541 550.406 25.8027 548.615 25.8027Z"
            fill="white"
          />
          <path
            d="M569.888 9.9082C568.098 9.9082 566.65 11.3553 566.65 13.1462C566.65 14.937 568.098 16.3927 569.888 16.3927C571.679 16.3927 573.135 14.937 573.135 13.1462C573.135 11.3553 571.679 9.9082 569.888 9.9082Z"
            fill="white"
          />
          <path
            d="M589.788 -3.57812C587.989 -3.57812 586.542 -2.12252 586.542 -0.331656C586.542 1.45921 587.989 2.91481 589.788 2.91481C591.588 2.91481 593.035 1.46769 593.035 -0.331656C593.035 -2.13101 591.579 -3.57812 589.788 -3.57812Z"
            fill="white"
          />
          <path
            d="M802.055 -6.37891C800.192 -6.37891 798.682 -4.86389 798.682 -3.00088C798.682 -1.13788 800.192 0.372899 802.055 0.372899C803.918 0.372899 805.429 -1.13788 805.429 -3.00088C805.429 -4.86389 803.918 -6.37891 802.055 -6.37891Z"
            fill="white"
          />
          <path
            d="M808.905 4.67578C807.021 4.67578 805.493 6.20777 805.493 8.08776C805.493 9.96774 807.025 11.5125 808.905 11.5125C810.785 11.5125 812.33 9.98047 812.33 8.08776C812.33 6.19504 810.798 4.67578 808.905 4.67578Z"
            fill="white"
          />
          <path
            d="M815.534 16.5332C813.599 16.5332 812.028 18.0991 812.028 20.0343C812.028 21.9694 813.599 23.5311 815.534 23.5311C817.469 23.5311 819.031 21.9652 819.031 20.0343C819.031 18.1034 817.46 16.5332 815.534 16.5332Z"
            fill="white"
          />
          <path
            d="M821.861 29.5391C819.905 29.5391 818.313 31.122 818.313 33.0826C818.313 35.0432 819.905 36.6261 821.861 36.6261C823.818 36.6261 825.409 35.0432 825.409 33.0826C825.409 31.122 823.818 29.5391 821.861 29.5391Z"
            fill="white"
          />
          <path
            d="M827.88 43.8711C825.902 43.8711 824.298 45.4752 824.298 47.4571C824.298 49.4389 825.902 51.043 827.88 51.043C829.857 51.043 831.461 49.4347 831.461 47.4571C831.461 45.4795 829.857 43.8711 827.88 43.8711Z"
            fill="white"
          />
          <path
            d="M833.57 59.5781C831.563 59.5781 829.938 61.2035 829.938 63.198C829.938 65.1926 831.563 66.8307 833.57 66.8307C835.577 66.8307 837.19 65.2053 837.19 63.198C837.19 61.1907 835.565 59.5781 833.57 59.5781Z"
            fill="white"
          />
          <path
            d="M838.951 76.4805C836.91 76.4805 835.255 78.1355 835.255 80.1768C835.255 82.218 836.91 83.8646 838.951 83.8646C840.992 83.8646 842.648 82.2138 842.648 80.1768C842.648 78.1398 840.992 76.4805 838.951 76.4805Z"
            fill="white"
          />
          <path
            d="M847.572 99.453C848.361 97.5475 847.456 95.3629 845.551 94.5736C843.645 93.7843 841.461 94.6892 840.671 96.5947C839.882 98.5002 840.787 100.685 842.692 101.474C844.598 102.263 846.782 101.358 847.572 99.453Z"
            fill="white"
          />
          <path
            d="M849.255 112.404C847.175 112.404 845.486 114.089 845.486 116.173C845.486 118.256 847.171 119.941 849.255 119.941C851.338 119.941 853.023 118.248 853.023 116.173C853.023 114.098 851.338 112.404 849.255 112.404Z"
            fill="white"
          />
          <path
            d="M854.534 130.113C852.433 130.113 850.723 131.819 850.723 133.924C850.723 136.029 852.429 137.722 854.534 137.722C856.638 137.722 858.332 136.021 858.332 133.924C858.332 131.828 856.626 130.113 854.534 130.113Z"
            fill="white"
          />
          <path
            d="M860.094 146.824C857.972 146.824 856.245 148.551 856.245 150.673C856.245 152.795 857.972 154.522 860.094 154.522C862.216 154.522 863.943 152.795 863.943 150.673C863.943 148.551 862.216 146.824 860.094 146.824Z"
            fill="white"
          />
          <path
            d="M866.013 162.408C863.87 162.408 862.13 164.148 862.13 166.291C862.13 168.434 863.87 170.174 866.013 170.174C868.156 170.174 869.904 168.439 869.904 166.291C869.904 164.144 868.165 162.408 866.013 162.408Z"
            fill="white"
          />
          <path
            d="M872.333 176.82C870.168 176.82 868.42 178.569 868.42 180.733C868.42 182.897 870.168 184.646 872.333 184.646C874.497 184.646 876.245 182.897 876.245 180.733C876.245 178.569 874.497 176.82 872.333 176.82Z"
            fill="white"
          />
          <path
            d="M879.025 190.031C876.848 190.031 875.083 191.801 875.083 193.982C875.083 196.163 876.853 197.933 879.025 197.933C881.198 197.933 882.981 196.163 882.981 193.982C882.981 191.801 881.211 190.031 879.025 190.031Z"
            fill="white"
          />
          <path
            d="M886.082 202.133C883.876 202.133 882.098 203.924 882.098 206.118C882.098 208.312 883.876 210.115 886.082 210.115C888.289 210.115 890.08 208.324 890.08 206.118C890.08 203.911 888.289 202.133 886.082 202.133Z"
            fill="white"
          />
          <path
            d="M893.45 213.283C891.234 213.283 889.443 215.083 889.443 217.302C889.443 219.522 891.234 221.308 893.45 221.308C895.665 221.308 897.456 219.509 897.456 217.302C897.456 215.095 895.665 213.283 893.45 213.283Z"
            fill="white"
          />
          <path
            d="M901.109 223.51C898.873 223.51 897.061 225.322 897.061 227.55C897.061 229.778 898.873 231.59 901.109 231.59C903.345 231.59 905.149 229.791 905.149 227.55C905.149 225.309 903.337 223.51 901.109 223.51Z"
            fill="white"
          />
          <path
            d="M909.04 232.889C906.791 232.889 904.983 234.701 904.983 236.946C904.983 239.191 906.796 240.994 909.04 240.994C911.285 240.994 913.102 239.182 913.102 236.946C913.102 234.709 911.281 232.889 909.04 232.889Z"
            fill="white"
          />
          <path
            d="M917.218 241.402C914.96 241.402 913.127 243.236 913.127 245.493C913.127 247.751 914.96 249.572 917.218 249.572C919.476 249.572 921.309 247.751 921.309 245.493C921.309 243.236 919.476 241.402 917.218 241.402Z"
            fill="white"
          />
          <path
            d="M925.621 249.096C923.363 249.096 921.521 250.937 921.521 253.208C921.521 255.478 923.363 257.307 925.621 257.307C927.879 257.307 929.733 255.474 929.733 253.208C929.733 250.942 927.891 249.096 925.621 249.096Z"
            fill="white"
          />
          <path
            d="M934.214 255.953C931.936 255.953 930.094 257.795 930.094 260.074C930.094 262.353 931.936 264.194 934.214 264.194C936.493 264.194 938.335 262.353 938.335 260.074C938.335 257.795 936.493 255.953 934.214 255.953Z"
            fill="white"
          />
          <path
            d="M942.962 262.021C940.683 262.021 938.828 263.872 938.828 266.155C938.828 268.438 940.678 270.297 942.962 270.297C945.245 270.297 947.103 268.447 947.103 266.155C947.103 263.863 945.253 262.021 942.962 262.021Z"
            fill="white"
          />
          <path
            d="M951.838 267.332C949.538 267.332 947.684 269.195 947.684 271.487C947.684 273.778 949.538 275.641 951.838 275.641C954.138 275.641 955.993 273.787 955.993 271.487C955.993 269.187 954.13 267.332 951.838 267.332Z"
            fill="white"
          />
          <path
            d="M960.788 271.939C958.497 271.939 956.634 273.802 956.634 276.094C956.634 278.386 958.497 280.249 960.788 280.249C963.08 280.249 964.943 278.394 964.943 276.094C964.943 273.794 963.089 271.939 960.788 271.939Z"
            fill="white"
          />
          <path
            d="M969.782 275.863C967.49 275.863 965.627 277.726 965.627 280.018C965.627 282.31 967.49 284.173 969.782 284.173C972.073 284.173 973.936 282.322 973.936 280.018C973.936 277.714 972.073 275.863 969.782 275.863Z"
            fill="white"
          />
          <path
            d="M978.741 279.154C976.449 279.154 974.586 281.017 974.586 283.309C974.586 285.601 976.449 287.464 978.741 287.464C981.032 287.464 982.895 285.601 982.895 283.309C982.895 281.017 981.045 279.154 978.741 279.154Z"
            fill="white"
          />
          <path
            d="M987.618 281.848C985.33 281.848 983.463 283.711 983.463 286.011C983.463 288.311 985.326 290.165 987.618 290.165C989.909 290.165 991.772 288.302 991.772 286.011C991.772 283.719 989.922 281.848 987.618 281.848Z"
            fill="white"
          />
          <path
            d="M982.5 283.678C980.2 283.678 978.346 285.541 978.346 287.832C978.346 290.124 980.2 291.987 982.5 291.987C984.8 291.987 986.655 290.124 986.655 287.832C986.655 285.541 984.792 283.678 982.5 283.678Z"
            fill="white"
          />
          <path
            d="M977.2 285.48C974.908 285.48 973.045 287.335 973.045 289.635C973.045 291.935 974.908 293.79 977.2 293.79C979.491 293.79 981.354 291.927 981.354 289.635C981.354 287.343 979.5 285.48 977.2 285.48Z"
            fill="white"
          />
          <path
            d="M971.737 287.301C969.445 287.301 967.582 289.155 967.582 291.455C967.582 293.756 969.445 295.61 971.737 295.61C974.028 295.61 975.891 293.747 975.891 291.455C975.891 289.164 974.037 287.301 971.737 287.301Z"
            fill="white"
          />
          <path
            d="M966.099 289.186C963.807 289.186 961.944 291.04 961.944 293.34C961.944 295.64 963.807 297.495 966.099 297.495C968.391 297.495 970.254 295.632 970.254 293.34C970.254 291.049 968.399 289.186 966.099 289.186Z"
            fill="white"
          />
          <path
            d="M960.28 291.162C957.98 291.162 956.125 293.025 956.125 295.317C956.125 297.608 957.975 299.471 960.28 299.471C962.584 299.471 964.434 297.621 964.434 295.317C964.434 293.012 962.571 291.162 960.28 291.162Z"
            fill="white"
          />
          <path
            d="M954.249 293.285C951.958 293.285 950.095 295.148 950.095 297.44C950.095 299.731 951.958 301.594 954.249 301.594C956.541 301.594 958.404 299.74 958.404 297.44C958.404 295.14 956.554 293.285 954.249 293.285Z"
            fill="white"
          />
          <path
            d="M948.029 295.578C945.729 295.578 943.874 297.441 943.874 299.741C943.874 302.041 945.724 303.896 948.029 303.896C950.333 303.896 952.179 302.033 952.179 299.741C952.179 297.45 950.316 295.578 948.029 295.578Z"
            fill="white"
          />
          <path
            d="M941.574 298.084C939.273 298.084 937.419 299.947 937.419 302.234C937.419 304.522 939.273 306.389 941.574 306.389C943.874 306.389 945.728 304.526 945.728 302.234C945.728 299.943 943.865 298.084 941.574 298.084Z"
            fill="white"
          />
          <path
            d="M934.872 300.852C932.593 300.852 930.73 302.702 930.73 304.993C930.73 307.285 932.593 309.135 934.872 309.135C937.151 309.135 939.014 307.272 939.014 304.993C939.014 302.715 937.164 300.852 934.872 300.852Z"
            fill="white"
          />
          <path
            d="M927.93 303.902C925.651 303.902 923.797 305.757 923.797 308.036C923.797 310.315 925.647 312.169 927.93 312.169C930.213 312.169 932.064 310.327 932.064 308.036C932.064 305.744 930.222 303.902 927.93 303.902Z"
            fill="white"
          />
          <path
            d="M920.748 307.295C918.478 307.295 916.636 309.137 916.636 311.407C916.636 313.678 918.478 315.519 920.748 315.519C923.018 315.519 924.86 313.678 924.86 311.407C924.86 309.137 923.018 307.295 920.748 307.295Z"
            fill="white"
          />
          <path
            d="M913.34 311.041C911.082 311.041 909.249 312.862 909.249 315.119C909.249 317.377 911.082 319.197 913.34 319.197C915.598 319.197 917.418 317.377 917.418 315.119C917.418 312.862 915.598 311.041 913.34 311.041Z"
            fill="white"
          />
          <path
            d="M905.739 315.111C903.49 315.111 901.661 316.932 901.661 319.181C901.661 321.43 903.494 323.259 905.739 323.259C907.984 323.259 909.809 321.439 909.809 319.181C909.809 316.923 907.989 315.111 905.739 315.111Z"
            fill="white"
          />
          <path
            d="M898.008 319.523C895.771 319.523 893.959 321.336 893.959 323.563C893.959 325.791 895.771 327.612 898.008 327.612C900.244 327.612 902.048 325.8 902.048 323.563C902.048 321.327 900.236 319.523 898.008 319.523Z"
            fill="white"
          />
          <path
            d="M890.19 324.189C887.975 324.189 886.163 325.989 886.163 328.217C886.163 330.445 887.975 332.244 890.19 332.244C892.406 332.244 894.218 330.432 894.218 328.217C894.218 326.002 892.418 324.189 890.19 324.189Z"
            fill="white"
          />
          <path
            d="M882.373 329.068C880.166 329.068 878.375 330.859 878.375 333.074C878.375 335.29 880.166 337.072 882.373 337.072C884.579 337.072 886.379 335.281 886.379 333.074C886.379 330.868 884.588 329.068 882.373 329.068Z"
            fill="white"
          />
          <path
            d="M874.611 334.096C872.417 334.096 870.647 335.874 870.647 338.059C870.647 340.245 872.417 342.023 874.611 342.023C876.805 342.023 878.566 340.245 878.566 338.059C878.566 335.874 876.797 334.096 874.611 334.096Z"
            fill="white"
          />
          <path
            d="M866.858 347.147C869.03 347.147 870.792 345.386 870.792 343.213C870.792 341.041 869.03 339.279 866.858 339.279C864.685 339.279 862.924 341.041 862.924 343.213C862.924 345.386 864.685 347.147 866.858 347.147Z"
            fill="white"
          />
          <path
            d="M858.99 344.939C856.834 344.939 855.086 346.688 855.086 348.852C855.086 351.016 856.834 352.756 858.99 352.756C861.146 352.756 862.903 351.008 862.903 348.852C862.903 346.696 861.154 344.939 858.99 344.939Z"
            fill="white"
          />
          <path
            d="M851.002 351.166C848.881 351.166 847.141 352.893 847.141 355.028C847.141 357.162 848.881 358.89 851.002 358.89C853.124 358.89 854.864 357.162 854.864 355.028C854.864 352.893 853.137 351.166 851.002 351.166Z"
            fill="white"
          />
          <path
            d="M842.898 357.918C840.785 357.918 839.07 359.637 839.07 361.759C839.07 363.88 840.789 365.586 842.898 365.586C845.007 365.586 846.73 363.868 846.73 361.759C846.73 359.649 845.012 357.918 842.898 357.918Z"
            fill="white"
          />
          <path
            d="M834.636 365.248C832.535 365.248 830.838 366.946 830.838 369.046C830.838 371.147 832.535 372.844 834.636 372.844C836.737 372.844 838.434 371.138 838.434 369.046C838.434 366.954 836.737 365.248 834.636 365.248Z"
            fill="white"
          />
          <path
            d="M826.194 373.135C824.111 373.135 822.426 374.82 822.426 376.903C822.426 378.987 824.111 380.672 826.194 380.672C828.278 380.672 829.963 378.987 829.963 376.903C829.963 374.82 828.278 373.135 826.194 373.135Z"
            fill="white"
          />
          <path
            d="M817.575 381.682C815.534 381.682 813.87 383.337 813.87 385.386C813.87 387.436 815.534 389.091 817.575 389.091C819.616 389.091 821.28 387.436 821.28 385.386C821.28 383.337 819.625 381.682 817.575 381.682Z"
            fill="white"
          />
          <path
            d="M808.77 390.764C806.741 390.764 805.086 392.41 805.086 394.439C805.086 396.467 806.741 398.122 808.77 398.122C810.798 398.122 812.445 396.476 812.445 394.439C812.445 392.402 810.798 390.764 808.77 390.764Z"
            fill="white"
          />
          <path
            d="M799.81 400.498C797.812 400.498 796.178 402.132 796.178 404.131C796.178 406.13 797.812 407.763 799.81 407.763C801.809 407.763 803.443 406.138 803.443 404.131C803.443 402.123 801.822 400.498 799.81 400.498Z"
            fill="white"
          />
          <path
            d="M794.982 412.531C793.034 412.531 791.455 414.101 791.455 416.049C791.455 417.997 793.038 419.576 794.982 419.576C796.925 419.576 798.512 417.993 798.512 416.049C798.512 414.106 796.93 412.531 794.982 412.531Z"
            fill="white"
          />
          <path
            d="M782.085 422.189C780.137 422.189 778.559 423.76 778.559 425.708C778.559 427.655 780.142 429.234 782.085 429.234C784.029 429.234 785.612 427.651 785.612 425.708C785.612 423.764 784.029 422.189 782.085 422.189Z"
            fill="white"
          />
          <path
            d="M769.095 432.428C767.147 432.428 765.577 433.998 765.577 435.946C765.577 437.894 767.147 439.464 769.095 439.464C771.043 439.464 772.613 437.894 772.613 435.946C772.613 433.998 771.03 432.428 769.095 432.428Z"
            fill="white"
          />
          <path
            d="M756.084 443.295C754.149 443.295 752.574 444.865 752.574 446.813C752.574 448.761 754.144 450.318 756.084 450.318C758.023 450.318 759.602 448.748 759.602 446.813C759.602 444.878 758.032 443.295 756.084 443.295Z"
            fill="white"
          />
          <path
            d="M743.025 454.684C741.09 454.684 739.52 456.266 739.52 458.202C739.52 460.137 741.09 461.72 743.025 461.72C744.96 461.72 746.543 460.15 746.543 458.202C746.543 456.254 744.973 454.684 743.025 454.684Z"
            fill="white"
          />
          <path
            d="M729.899 466.307C727.951 466.307 726.381 467.877 726.381 469.825C726.381 471.773 727.951 473.33 729.899 473.33C731.847 473.33 733.404 471.76 733.404 469.825C733.404 467.89 731.834 466.307 729.899 466.307Z"
            fill="white"
          />
          <path
            d="M716.735 478.008C714.8 478.008 713.238 479.578 713.238 481.513C713.238 483.448 714.8 485.01 716.735 485.01C718.67 485.01 720.24 483.448 720.24 481.513C720.24 479.578 718.67 478.008 716.735 478.008Z"
            fill="white"
          />
          <path
            d="M703.452 489.422C701.517 489.422 699.942 490.992 699.942 492.927C699.942 494.862 701.513 496.424 703.452 496.424C705.391 496.424 706.957 494.862 706.957 492.927C706.957 490.992 705.387 489.422 703.452 489.422Z"
            fill="white"
          />
          <path
            d="M689.973 500.1C688.047 500.1 686.477 501.661 686.477 503.597C686.477 505.532 688.047 507.093 689.973 507.093C691.9 507.093 693.479 505.532 693.479 503.597C693.479 501.661 691.909 500.1 689.973 500.1Z"
            fill="white"
          />
          <path
            d="M676.445 509.967C674.519 509.967 672.957 511.529 672.957 513.455C672.957 515.382 674.519 516.952 676.445 516.952C678.372 516.952 679.942 515.39 679.942 513.455C679.942 511.52 678.381 509.967 676.445 509.967Z"
            fill="white"
          />
          <path
            d="M662.882 518.857C660.946 518.857 659.385 520.428 659.385 522.354C659.385 524.281 660.946 525.851 662.882 525.851C664.817 525.851 666.37 524.281 666.37 522.354C666.37 520.428 664.808 518.857 662.882 518.857Z"
            fill="white"
          />
          <path
            d="M649.247 526.631C647.32 526.631 645.759 528.193 645.759 530.119C645.759 532.046 647.32 533.616 649.247 533.616C651.174 533.616 652.744 532.046 652.744 530.119C652.744 528.193 651.174 526.631 649.247 526.631Z"
            fill="white"
          />
          <path
            d="M635.697 533.469C633.762 533.469 632.2 535.039 632.2 536.966C632.2 538.892 633.762 540.454 635.697 540.454C637.632 540.454 639.185 538.892 639.185 536.966C639.185 535.039 637.624 533.469 635.697 533.469Z"
            fill="white"
          />
          <path
            d="M622.262 539.547C620.335 539.547 618.786 541.096 618.786 543.022C618.786 544.949 620.335 546.49 622.262 546.49C624.188 546.49 625.737 544.941 625.737 543.022C625.737 541.104 624.176 539.547 622.262 539.547Z"
            fill="white"
          />
          <path
            d="M608.875 544.971C606.961 544.971 605.408 546.52 605.408 548.438C605.408 550.356 606.957 551.905 608.875 551.905C610.794 551.905 612.351 550.356 612.351 548.438C612.351 546.52 610.798 544.971 608.875 544.971Z"
            fill="white"
          />
          <path
            d="M595.534 549.977C593.608 549.977 592.059 551.538 592.059 553.452C592.059 555.366 593.608 556.919 595.534 556.919C597.461 556.919 599.001 555.37 599.001 553.452C599.001 551.534 597.452 549.977 595.534 549.977Z"
            fill="white"
          />
          <path
            d="M582.293 554.98C580.388 554.98 578.839 556.534 578.839 558.448C578.839 560.362 580.388 561.915 582.293 561.915C584.199 561.915 585.76 560.366 585.76 558.448C585.76 556.529 584.211 554.98 582.293 554.98Z"
            fill="white"
          />
          <path
            d="M569.193 560.072C567.267 560.072 565.718 561.621 565.718 563.539C565.718 565.458 567.267 567.015 569.193 567.015C571.12 567.015 572.661 565.466 572.661 563.539C572.661 561.613 571.112 560.072 569.193 560.072Z"
            fill="white"
          />
          <path
            d="M556.152 565.246C554.238 565.246 552.685 566.808 552.685 568.722C552.685 570.636 554.234 572.189 556.152 572.189C558.07 572.189 559.627 570.636 559.627 568.722C559.627 566.808 558.066 565.246 556.152 565.246Z"
            fill="white"
          />
          <path
            d="M543.162 577.401C545.077 577.401 546.63 575.849 546.63 573.934C546.63 572.019 545.077 570.467 543.162 570.467C541.248 570.467 539.695 572.019 539.695 573.934C539.695 575.849 541.248 577.401 543.162 577.401Z"
            fill="white"
          />
          <path
            d="M530.201 575.586C528.296 575.586 526.747 577.135 526.747 579.053C526.747 580.971 528.296 582.508 530.201 582.508C532.107 582.508 533.669 580.954 533.669 579.053C533.669 577.152 532.12 575.586 530.201 575.586Z"
            fill="white"
          />
          <path
            d="M517.257 587.571C519.172 587.571 520.724 586.019 520.724 584.104C520.724 582.189 519.172 580.637 517.257 580.637C515.342 580.637 513.79 582.189 513.79 584.104C513.79 586.019 515.342 587.571 517.257 587.571Z"
            fill="white"
          />
          <path
            d="M504.246 585.559C502.332 585.559 500.792 587.108 500.792 589.013C500.792 590.918 502.332 592.467 504.246 592.467C506.16 592.467 507.701 590.927 507.701 589.013C507.701 587.099 506.152 585.559 504.246 585.559Z"
            fill="white"
          />
          <path
            d="M491.163 590.117C489.258 590.117 487.709 591.658 487.709 593.572C487.709 595.485 489.262 597.026 491.163 597.026C493.065 597.026 494.618 595.473 494.618 593.572C494.618 591.67 493.077 590.117 491.163 590.117Z"
            fill="white"
          />
          <path
            d="M477.999 594.293C476.085 594.293 474.545 595.842 474.545 597.747C474.545 599.653 476.085 601.202 477.999 601.202C479.913 601.202 481.445 599.649 481.445 597.747C481.445 595.846 479.905 594.293 477.999 594.293Z"
            fill="white"
          />
          <path
            d="M464.695 598.021C462.781 598.021 461.24 599.562 461.24 601.467C461.24 603.373 462.781 604.922 464.695 604.922C466.609 604.922 468.141 603.373 468.141 601.467C468.141 599.562 466.6 598.021 464.695 598.021Z"
            fill="white"
          />
          <path
            d="M451.229 601.152C449.324 601.152 447.783 602.693 447.783 604.598C447.783 606.504 449.324 608.053 451.229 608.053C453.135 608.053 454.675 606.504 454.675 604.598C454.675 602.693 453.135 601.152 451.229 601.152Z"
            fill="white"
          />
          <path
            d="M437.616 603.504C435.71 603.504 434.161 605.053 434.161 606.958C434.161 608.864 435.71 610.413 437.616 610.413C439.521 610.413 441.083 608.864 441.083 606.958C441.083 605.053 439.534 603.504 437.616 603.504Z"
            fill="white"
          />
          <path
            d="M423.823 605.107C421.917 605.107 420.368 606.656 420.368 608.562C420.368 610.467 421.917 612.016 423.823 612.016C425.728 612.016 427.277 610.463 427.277 608.562C427.277 606.661 425.728 605.107 423.823 605.107Z"
            fill="white"
          />
          <path
            d="M415.361 603.109C413.413 603.109 411.843 604.68 411.843 606.627C411.843 608.575 413.413 610.145 415.361 610.145C417.309 610.145 418.879 608.575 418.879 606.627C418.879 604.68 417.309 603.109 415.361 603.109Z"
            fill="white"
          />
          <path
            d="M406.747 600.629C404.778 600.629 403.187 602.22 403.187 604.189C403.187 606.159 404.778 607.75 406.747 607.75C408.716 607.75 410.308 606.159 410.308 604.189C410.308 602.22 408.716 600.629 406.747 600.629Z"
            fill="white"
          />
          <path
            d="M398.035 597.527C396.057 597.527 394.444 599.131 394.444 601.118C394.444 603.104 396.057 604.708 398.035 604.708C400.012 604.708 401.625 603.104 401.625 601.118C401.625 599.131 400.021 597.527 398.035 597.527Z"
            fill="white"
          />
          <path
            d="M389.279 593.764C387.272 593.764 385.646 595.389 385.646 597.396C385.646 599.404 387.272 601.029 389.279 601.029C391.286 601.029 392.912 599.404 392.912 597.396C392.912 595.389 391.278 593.764 389.279 593.764Z"
            fill="white"
          />
          <path
            d="M380.515 589.287C378.486 589.287 376.84 590.934 376.84 592.962C376.84 594.991 378.482 596.646 380.515 596.646C382.548 596.646 384.199 594.999 384.199 592.962C384.199 590.925 382.552 589.287 380.515 589.287Z"
            fill="white"
          />
          <path
            d="M371.837 583.99C369.775 583.99 368.111 585.654 368.111 587.716C368.111 589.779 369.775 591.434 371.837 591.434C373.9 591.434 375.563 589.77 375.563 587.716C375.563 585.662 373.887 583.99 371.837 583.99Z"
            fill="white"
          />
          <path
            d="M363.269 577.809C361.198 577.809 359.521 579.493 359.521 581.564C359.521 583.635 361.198 585.312 363.269 585.312C365.34 585.312 367.024 583.635 367.024 581.564C367.024 579.493 365.34 577.809 363.269 577.809Z"
            fill="white"
          />
          <path
            d="M354.904 570.627C352.82 570.627 351.127 572.324 351.127 574.417C351.127 576.509 352.824 578.206 354.904 578.206C356.983 578.206 358.694 576.509 358.694 574.417C358.694 572.324 356.996 570.627 354.904 570.627Z"
            fill="white"
          />
          <path
            d="M346.825 562.287C344.712 562.287 342.997 563.993 342.997 566.119C342.997 568.245 344.716 569.939 346.825 569.939C348.934 569.939 350.644 568.233 350.644 566.119C350.644 564.006 348.938 562.287 346.825 562.287Z"
            fill="white"
          />
          <path
            d="M339.122 552.641C336.987 552.641 335.26 554.368 335.26 556.49C335.26 558.612 336.987 560.339 339.122 560.339C341.256 560.339 342.971 558.62 342.971 556.49C342.971 554.359 341.243 552.641 339.122 552.641Z"
            fill="white"
          />
          <path
            d="M332.822 549.17C334.909 548.676 336.199 546.583 335.704 544.496C335.21 542.41 333.117 541.119 331.03 541.614C328.944 542.109 327.653 544.201 328.148 546.288C328.643 548.375 330.735 549.665 332.822 549.17Z"
            fill="white"
          />
          <path
            d="M325.156 529.09C323 529.09 321.252 530.826 321.252 532.981C321.252 535.137 323 536.886 325.156 536.886C327.312 536.886 329.048 535.137 329.048 532.981C329.048 530.826 327.299 529.09 325.156 529.09Z"
            fill="white"
          />
          <path
            d="M318.842 515.441C316.665 515.441 314.899 517.203 314.899 519.375C314.899 521.548 316.669 523.318 318.842 523.318C321.015 523.318 322.784 521.561 322.784 519.375C322.784 517.19 321.015 515.441 318.842 515.441Z"
            fill="white"
          />
          <path
            d="M316.428 506.505C317.268 504.488 316.314 502.173 314.298 501.333C312.282 500.492 309.966 501.446 309.126 503.462C308.286 505.479 309.239 507.794 311.255 508.635C313.272 509.475 315.587 508.521 316.428 506.505Z"
            fill="white"
          />
          <path
            d="M306.798 486.256C304.604 486.256 302.821 488.034 302.821 490.232C302.821 492.431 304.599 494.217 306.798 494.217C308.996 494.217 310.783 492.426 310.783 490.232C310.783 488.038 309.004 486.256 306.798 486.256Z"
            fill="white"
          />
          <path
            d="M300.708 479.4C302.915 479.4 304.705 477.61 304.705 475.402C304.705 473.194 302.915 471.404 300.708 471.404C298.5 471.404 296.71 473.194 296.71 475.402C296.71 477.61 298.5 479.4 300.708 479.4Z"
            fill="white"
          />
          <path
            d="M294.338 456.834C292.11 456.834 290.311 458.633 290.311 460.853C290.311 463.072 292.11 464.88 294.338 464.88C296.566 464.88 298.357 463.081 298.357 460.853C298.357 458.625 296.557 456.834 294.338 456.834Z"
            fill="white"
          />
          <path
            d="M287.585 442.764C285.357 442.764 283.545 444.576 283.545 446.804C283.545 449.032 285.357 450.844 287.585 450.844C289.813 450.844 291.612 449.032 291.612 446.804C291.612 444.576 289.813 442.764 287.585 442.764Z"
            fill="white"
          />
          <path
            d="M281.369 437.237C283.545 436.722 284.89 434.54 284.374 432.364C283.858 430.188 281.676 428.843 279.501 429.359C277.325 429.875 275.98 432.057 276.496 434.232C277.012 436.408 279.193 437.753 281.369 437.237Z"
            fill="white"
          />
          <path
            d="M272.919 416.277C270.67 416.277 268.862 418.098 268.862 420.339C268.862 422.579 270.674 424.396 272.919 424.396C275.164 424.396 276.976 422.575 276.976 420.339C276.976 418.102 275.156 416.277 272.919 416.277Z"
            fill="white"
          />
          <path
            d="M265.188 403.516C262.939 403.516 261.118 405.336 261.118 407.585C261.118 409.835 262.939 411.655 265.188 411.655C267.437 411.655 269.258 409.835 269.258 407.585C269.258 405.336 267.437 403.516 265.188 403.516Z"
            fill="white"
          />
          <path
            d="M257.32 390.877C255.071 390.877 253.25 392.698 253.25 394.947C253.25 397.196 255.071 399.016 257.32 399.016C259.569 399.016 261.39 397.196 261.39 394.947C261.39 392.698 259.569 390.877 257.32 390.877Z"
            fill="white"
          />
          <path
            d="M249.317 378.559C247.067 378.559 245.238 380.379 245.238 382.628C245.238 384.878 247.072 386.707 249.317 386.707C251.561 386.707 253.395 384.886 253.395 382.628C253.395 380.371 251.574 378.559 249.317 378.559Z"
            fill="white"
          />
          <path
            d="M241.27 366.494C239.012 366.494 237.191 368.315 237.191 370.564C237.191 372.813 239.012 374.642 241.27 374.642C243.527 374.642 245.348 372.822 245.348 370.564C245.348 368.306 243.515 366.494 241.27 366.494Z"
            fill="white"
          />
          <path
            d="M233.237 354.6C230.98 354.6 229.146 356.42 229.146 358.678C229.146 360.936 230.98 362.769 233.237 362.769C235.495 362.769 237.328 360.936 237.328 358.678C237.328 356.42 235.495 354.6 233.237 354.6Z"
            fill="white"
          />
          <path
            d="M225.292 342.871C223.034 342.871 221.201 344.704 221.201 346.962C221.201 349.22 223.034 351.053 225.292 351.053C227.55 351.053 229.37 349.22 229.37 346.962C229.37 344.704 227.537 342.871 225.292 342.871Z"
            fill="white"
          />
          <path
            d="M217.458 331.389C215.2 331.389 213.367 333.209 213.367 335.467C213.367 337.725 215.2 339.558 217.458 339.558C219.716 339.558 221.536 337.725 221.536 335.467C221.536 333.209 219.716 331.389 217.458 331.389Z"
            fill="white"
          />
          <path
            d="M209.671 320.484C207.413 320.484 205.58 322.305 205.58 324.563C205.58 326.82 207.413 328.654 209.671 328.654C211.929 328.654 213.762 326.82 213.762 324.563C213.762 322.305 211.929 320.484 209.671 320.484Z"
            fill="white"
          />
          <path
            d="M216.936 305.41C214.687 305.41 212.866 307.231 212.866 309.48C212.866 311.729 214.687 313.55 216.936 313.55C219.185 313.55 221.006 311.729 221.006 309.48C221.006 307.231 219.185 305.41 216.936 305.41Z"
            fill="white"
          />
          <path
            d="M224.232 292.016C221.995 292.016 220.175 293.828 220.175 296.073C220.175 298.318 221.995 300.13 224.232 300.13C226.468 300.13 228.289 298.309 228.289 296.073C228.289 293.836 226.477 292.016 224.232 292.016Z"
            fill="white"
          />
          <path
            d="M231.62 280.057C229.383 280.057 227.562 281.869 227.562 284.118C227.562 286.367 229.383 288.175 231.62 288.175C233.856 288.175 235.689 286.354 235.689 284.118C235.689 281.881 233.869 280.057 231.62 280.057Z"
            fill="white"
          />
          <path
            d="M239.062 269.432C236.826 269.432 235.014 271.244 235.014 273.472C235.014 275.7 236.826 277.52 239.062 277.52C241.299 277.52 243.111 275.708 243.111 273.472C243.111 271.235 241.299 269.432 239.062 269.432Z"
            fill="white"
          />
          <path
            d="M246.4 259.951C244.172 259.951 242.36 261.751 242.36 263.978C242.36 266.206 244.172 268.006 246.4 268.006C248.628 268.006 250.428 266.206 250.428 263.978C250.428 261.751 248.616 259.951 246.4 259.951Z"
            fill="white"
          />
          <path
            d="M253.508 251.33C251.293 251.33 249.502 253.121 249.502 255.336C249.502 257.551 251.293 259.355 253.508 259.355C255.723 259.355 257.527 257.556 257.527 255.336C257.527 253.117 255.728 251.33 253.508 251.33Z"
            fill="white"
          />
          <path
            d="M260.274 243.434C258.076 243.434 256.289 245.224 256.289 247.418C256.289 249.612 258.08 251.403 260.274 251.403C262.468 251.403 264.259 249.625 264.259 247.418C264.259 245.212 262.481 243.434 260.274 243.434Z"
            fill="white"
          />
          <path
            d="M266.665 236.035C264.471 236.035 262.688 237.813 262.688 240.012C262.688 242.21 264.467 243.975 266.665 243.975C268.863 243.975 270.641 242.197 270.641 240.012C270.641 237.826 268.863 236.035 266.665 236.035Z"
            fill="white"
          />
          <path
            d="M272.691 229.018C270.514 229.018 268.749 230.787 268.749 232.96C268.749 235.133 270.519 236.907 272.691 236.907C274.864 236.907 276.625 235.137 276.625 232.96C276.625 230.783 274.864 229.018 272.691 229.018Z"
            fill="white"
          />
          <path
            d="M278.33 222.562C276.153 222.562 274.404 224.324 274.404 226.496C274.404 228.669 276.153 230.422 278.33 230.422C280.507 230.422 282.255 228.661 282.255 226.496C282.255 224.332 280.498 222.562 278.33 222.562Z"
            fill="white"
          />
          <path
            d="M283.524 216.945C281.369 216.945 279.62 218.694 279.62 220.85C279.62 223.005 281.369 224.754 283.524 224.754C285.68 224.754 287.416 223.005 287.416 220.85C287.416 218.694 285.676 216.945 283.524 216.945Z"
            fill="white"
          />
          <path
            d="M288.218 212.07C286.084 212.07 284.356 213.81 284.356 215.941C284.356 218.071 286.084 219.802 288.218 219.802C290.353 219.802 292.08 218.075 292.08 215.941C292.08 213.806 290.353 212.07 288.218 212.07Z"
            fill="white"
          />
          <path
            d="M292.424 207.701C290.311 207.701 288.592 209.42 288.592 211.533C288.592 213.647 290.311 215.374 292.424 215.374C294.537 215.374 296.265 213.655 296.265 211.533C296.265 209.411 294.546 207.701 292.424 207.701Z"
            fill="white"
          />
          <path
            d="M296.129 203.717C294.029 203.717 292.318 205.423 292.318 207.528C292.318 209.633 294.024 211.326 296.129 211.326C298.234 211.326 299.927 209.628 299.927 207.528C299.927 205.427 298.23 203.717 296.129 203.717Z"
            fill="white"
          />
          <path
            d="M299.295 200.064C297.215 200.064 295.518 201.762 295.518 203.841C295.518 205.921 297.215 207.618 299.295 207.618C301.374 207.618 303.071 205.921 303.071 203.841C303.071 201.762 301.374 200.064 299.295 200.064Z"
            fill="white"
          />
          <path
            d="M301.94 196.68C299.869 196.68 298.192 198.356 298.192 200.414C298.192 202.472 299.869 204.161 301.94 204.161C304.011 204.161 305.674 202.485 305.674 200.414C305.674 198.343 303.998 196.68 301.94 196.68Z"
            fill="white"
          />
          <path
            d="M304.069 193.525C302.028 193.525 300.386 195.176 300.386 197.213C300.386 199.25 302.032 200.901 304.069 200.901C306.106 200.901 307.766 199.254 307.766 197.213C307.766 195.172 306.111 193.525 304.069 193.525Z"
            fill="white"
          />
          <path
            d="M305.758 190.539C303.738 190.539 302.104 192.173 302.104 194.18C302.104 196.188 303.738 197.834 305.758 197.834C307.778 197.834 309.399 196.2 309.399 194.18C309.399 192.16 307.766 190.539 305.758 190.539Z"
            fill="white"
          />
          <path
            d="M307.026 194.898C309.025 194.898 310.646 193.277 310.646 191.278C310.646 189.279 309.025 187.658 307.026 187.658C305.027 187.658 303.406 189.279 303.406 191.278C303.406 193.277 305.027 194.898 307.026 194.898Z"
            fill="white"
          />
          <path
            d="M307.942 184.879C305.964 184.879 304.373 186.483 304.373 188.461C304.373 190.438 305.964 192.03 307.942 192.03C309.92 192.03 311.524 190.425 311.524 188.461C311.524 186.496 309.92 184.879 307.942 184.879Z"
            fill="white"
          />
          <path
            d="M308.555 182.184C306.607 182.184 305.037 183.754 305.037 185.697C305.037 187.641 306.607 189.211 308.555 189.211C310.503 189.211 312.061 187.641 312.061 185.697C312.061 183.754 310.49 182.184 308.555 182.184Z"
            fill="white"
          />
          <path
            d="M308.898 179.477C306.984 179.477 305.431 181.03 305.431 182.944C305.431 184.858 306.98 186.411 308.898 186.411C310.816 186.411 312.365 184.853 312.365 182.944C312.365 181.034 310.816 179.477 308.898 179.477Z"
            fill="white"
          />
          <path
            d="M309.047 176.674C307.155 176.674 305.614 178.206 305.614 180.103C305.614 182 307.155 183.532 309.047 183.532C310.94 183.532 312.472 181.995 312.472 180.103C312.472 178.21 310.94 176.674 309.047 176.674Z"
            fill="white"
          />
          <path
            d="M309.068 173.711C307.205 173.711 305.686 175.222 305.686 177.093C305.686 178.965 307.205 180.475 309.068 180.475C310.931 180.475 312.45 178.956 312.45 177.093C312.45 175.23 310.931 173.711 309.068 173.711Z"
            fill="white"
          />
          <path
            d="M309.089 170.453C307.256 170.453 305.779 171.93 305.779 173.763C305.779 175.597 307.256 177.073 309.089 177.073C310.923 177.073 312.4 175.597 312.4 173.763C312.4 171.93 310.91 170.453 309.089 170.453Z"
            fill="white"
          />
          <path
            d="M309.285 166.674C307.485 166.674 306.025 168.129 306.025 169.933C306.025 171.737 307.481 173.192 309.285 173.192C311.088 173.192 312.544 171.737 312.544 169.933C312.544 168.129 311.088 166.674 309.285 166.674Z"
            fill="white"
          />
          <path
            d="M309.951 162.135C308.181 162.135 306.747 163.565 306.747 165.339C306.747 167.113 308.181 168.539 309.951 168.539C311.721 168.539 313.155 167.108 313.155 165.339C313.155 163.569 311.716 162.135 309.951 162.135Z"
            fill="white"
          />
          <path
            d="M311.47 156.457C309.722 156.457 308.317 157.866 308.317 159.614C308.317 161.363 309.722 162.767 311.47 162.767C313.219 162.767 314.624 161.35 314.624 159.614C314.624 157.879 313.206 156.457 311.47 156.457Z"
            fill="white"
          />
          <path
            d="M325.793 152.086C324.044 152.086 322.627 153.495 322.627 155.243C322.627 156.992 324.044 158.409 325.793 158.409C327.541 158.409 328.946 156.992 328.946 155.243C328.946 153.495 327.528 152.086 325.793 152.086Z"
            fill="white"
          />
          <path
            d="M341.311 146.035C339.571 146.035 338.158 147.453 338.158 149.188C338.158 150.924 339.576 152.354 341.311 152.354C343.047 152.354 344.473 150.937 344.473 149.188C344.473 147.44 343.055 146.035 341.311 146.035Z"
            fill="white"
          />
          <path
            d="M358.317 138.146C356.569 138.146 355.151 139.564 355.151 141.308C355.151 143.052 356.569 144.474 358.317 144.474C360.066 144.474 361.479 143.057 361.479 141.308C361.479 139.56 360.061 138.146 358.317 138.146Z"
            fill="white"
          />
          <path
            d="M377.311 128.135C375.563 128.135 374.146 129.552 374.146 131.292C374.146 133.032 375.563 134.449 377.311 134.449C379.06 134.449 380.477 133.032 380.477 131.292C380.477 129.552 379.06 128.135 377.311 128.135Z"
            fill="white"
          />
          <path
            d="M398.407 116.09C396.65 116.09 395.232 117.507 395.232 119.256C395.232 121.004 396.65 122.43 398.407 122.43C400.164 122.43 401.573 121.004 401.573 119.256C401.573 117.507 400.155 116.09 398.407 116.09Z"
            fill="white"
          />
          <path
            d="M421.731 101.502C419.974 101.502 418.557 102.924 418.557 104.676C418.557 106.429 419.974 107.851 421.731 107.851C423.488 107.851 424.905 106.425 424.905 104.676C424.905 102.928 423.479 101.502 421.731 101.502Z"
            fill="white"
          />
          <path
            d="M446.596 84.5859C444.835 84.5859 443.422 86.0118 443.422 87.7603C443.422 89.5087 444.839 90.9346 446.596 90.9346C448.353 90.9346 449.771 89.5172 449.771 87.7603C449.771 86.0033 448.345 84.5859 446.596 84.5859Z"
            fill="white"
          />
          <path
            d="M472.252 65.9336C470.495 65.9336 469.069 67.3595 469.069 69.1122C469.069 70.8648 470.495 72.2907 472.252 72.2907C474.009 72.2907 475.427 70.8648 475.427 69.1122C475.427 67.3595 474.001 65.9336 472.252 65.9336Z"
            fill="white"
          />
          <path
            d="M497.312 46.834C495.551 46.834 494.125 48.2556 494.125 50.0126C494.125 51.7695 495.551 53.1996 497.312 53.1996C499.073 53.1996 500.495 51.7737 500.495 50.0126C500.495 48.2514 499.069 46.834 497.312 46.834Z"
            fill="white"
          />
          <path
            d="M521.15 28.1699C519.393 28.1699 517.967 29.5958 517.967 31.3485C517.967 33.1012 519.393 34.5313 521.15 34.5313C522.907 34.5313 524.324 33.1054 524.324 31.3485C524.324 29.5916 522.907 28.1699 521.15 28.1699Z"
            fill="white"
          />
          <path
            d="M543.335 10.6895C541.579 10.6895 540.148 12.1196 540.148 13.885C540.148 15.6504 541.574 17.0721 543.335 17.0721C545.097 17.0721 546.518 15.6462 546.518 13.885C546.518 12.1238 545.092 10.6895 543.335 10.6895Z"
            fill="white"
          />
          <path
            d="M563.955 -4.27148C562.198 -4.27148 560.76 -2.84134 560.76 -1.08018C560.76 0.680972 562.198 2.11536 563.955 2.11536C565.712 2.11536 567.151 0.680972 567.151 -1.08018C567.151 -2.84134 565.716 -4.27148 563.955 -4.27148Z"
            fill="white"
          />
          <path
            d="M814.164 -0.914062C812.301 -0.914062 810.79 0.600956 810.79 2.46821C810.79 4.33546 812.301 5.84199 814.164 5.84199C816.027 5.84199 817.546 4.33121 817.546 2.46821C817.546 0.6052 816.035 -0.914062 814.164 -0.914062Z"
            fill="white"
          />
          <path
            d="M820.916 10.5273C819.032 10.5273 817.491 12.0636 817.491 13.9478C817.491 15.832 819.032 17.3725 820.916 17.3725C822.8 17.3725 824.341 15.8405 824.341 13.9478C824.341 12.0551 822.809 10.5273 820.916 10.5273Z"
            fill="white"
          />
          <path
            d="M827.412 22.9961C825.477 22.9961 823.915 24.562 823.915 26.4972C823.915 28.4323 825.477 29.994 827.412 29.994C829.347 29.994 830.909 28.4238 830.909 26.4972C830.909 24.5705 829.347 22.9961 827.412 22.9961Z"
            fill="white"
          />
          <path
            d="M833.603 36.6777C831.647 36.6777 830.056 38.2649 830.056 40.2255C830.056 42.1861 831.647 43.7733 833.603 43.7733C835.56 43.7733 837.151 42.1861 837.151 40.2255C837.151 38.2649 835.568 36.6777 833.603 36.6777Z"
            fill="white"
          />
          <path
            d="M839.494 51.5605C837.504 51.5605 835.904 53.1732 835.904 55.155C835.904 57.1368 837.508 58.7495 839.494 58.7495C841.481 58.7495 843.093 57.1368 843.093 55.155C843.093 53.1732 841.481 51.5605 839.494 51.5605Z"
            fill="white"
          />
          <path
            d="M845.092 67.6035C843.084 67.6035 841.459 69.2331 841.459 71.2362C841.459 73.2392 843.084 74.8688 845.092 74.8688C847.099 74.8688 848.724 73.2435 848.724 71.2362C848.724 69.2289 847.09 67.6035 845.092 67.6035Z"
            fill="white"
          />
          <path
            d="M850.422 84.6074C848.381 84.6074 846.726 86.2625 846.726 88.3037C846.726 90.345 848.381 91.9915 850.422 91.9915C852.463 91.9915 854.105 90.3407 854.105 88.3037C854.105 86.2667 852.459 84.6074 850.422 84.6074Z"
            fill="white"
          />
          <path
            d="M855.574 102.301C853.503 102.301 851.84 103.977 851.84 106.04C851.84 108.102 853.503 109.774 855.574 109.774C857.645 109.774 859.309 108.102 859.309 106.04C859.309 103.977 857.633 102.301 855.574 102.301Z"
            fill="white"
          />
          <path
            d="M860.718 120.131C858.639 120.131 856.941 121.816 856.941 123.899C856.941 125.983 858.639 127.676 860.718 127.676C862.798 127.676 864.487 125.979 864.487 123.899C864.487 121.82 862.802 120.131 860.718 120.131Z"
            fill="white"
          />
          <path
            d="M866.056 137.416C863.955 137.416 862.245 139.122 862.245 141.227C862.245 143.332 863.951 145.038 866.056 145.038C868.161 145.038 869.867 143.336 869.867 141.227C869.867 139.118 868.161 137.416 866.056 137.416Z"
            fill="white"
          />
          <path
            d="M871.726 153.674C869.591 153.674 867.864 155.401 867.864 157.536C867.864 159.67 869.591 161.406 871.726 161.406C873.861 161.406 875.596 159.674 875.596 157.536C875.596 155.397 873.856 153.674 871.726 153.674Z"
            fill="white"
          />
          <path
            d="M877.815 168.723C875.66 168.723 873.911 170.471 873.911 172.627C873.911 174.783 875.66 176.518 877.815 176.518C879.971 176.518 881.707 174.77 881.707 172.627C881.707 170.484 879.958 168.723 877.815 168.723Z"
            fill="white"
          />
          <path
            d="M884.313 182.578C882.136 182.578 880.379 184.335 880.379 186.508C880.379 188.681 882.14 190.438 884.313 190.438C886.486 190.438 888.238 188.676 888.238 186.508C888.238 184.339 886.481 182.578 884.313 182.578Z"
            fill="white"
          />
          <path
            d="M891.179 195.338C889.002 195.338 887.232 197.108 887.232 199.293C887.232 201.479 889.002 203.236 891.179 203.236C893.356 203.236 895.134 201.466 895.134 199.293C895.134 197.12 893.365 195.338 891.179 195.338Z"
            fill="white"
          />
          <path
            d="M902.095 212.614C902.94 210.575 901.971 208.236 899.932 207.391C897.892 206.546 895.553 207.515 894.709 209.555C893.864 211.595 894.832 213.933 896.872 214.778C898.912 215.623 901.25 214.654 902.095 212.614Z"
            fill="white"
          />
          <path
            d="M905.939 217.941C903.724 217.941 901.92 219.741 901.92 221.969C901.92 224.197 903.719 225.988 905.939 225.988C908.158 225.988 909.966 224.188 909.966 221.969C909.966 219.749 908.167 217.941 905.939 217.941Z"
            fill="white"
          />
          <path
            d="M913.798 227.902C911.561 227.902 909.749 229.714 909.749 231.951C909.749 234.187 911.561 235.991 913.798 235.991C916.034 235.991 917.846 234.179 917.846 231.951C917.846 229.723 916.034 227.902 913.798 227.902Z"
            fill="white"
          />
          <path
            d="M921.933 236.971C919.684 236.971 917.863 238.791 917.863 241.04C917.863 243.29 919.684 245.097 921.933 245.097C924.182 245.097 925.99 243.277 925.99 241.04C925.99 238.804 924.169 236.971 921.933 236.971Z"
            fill="white"
          />
          <path
            d="M930.316 245.119C928.058 245.119 926.225 246.952 926.225 249.21C926.225 251.468 928.058 253.301 930.316 253.301C932.573 253.301 934.407 251.468 934.407 249.21C934.407 246.952 932.573 245.119 930.316 245.119Z"
            fill="white"
          />
          <path
            d="M938.908 252.393C936.638 252.393 934.809 254.234 934.809 256.505C934.809 258.775 936.642 260.604 938.908 260.604C941.174 260.604 943.008 258.771 943.008 256.505C943.008 254.239 941.174 252.393 938.908 252.393Z"
            fill="white"
          />
          <path
            d="M947.673 258.848C945.402 258.848 943.552 260.689 943.552 262.968C943.552 265.247 945.406 267.089 947.673 267.089C949.939 267.089 951.793 265.247 951.793 262.968C951.793 260.689 949.951 258.848 947.673 258.848Z"
            fill="white"
          />
          <path
            d="M956.584 264.51C954.293 264.51 952.442 266.36 952.442 268.643C952.442 270.926 954.293 272.785 956.584 272.785C958.876 272.785 960.718 270.931 960.718 268.643C960.718 266.356 958.867 264.51 956.584 264.51Z"
            fill="white"
          />
          <path
            d="M965.577 269.4C963.276 269.4 961.422 271.263 961.422 273.555C961.422 275.847 963.276 277.71 965.577 277.71C967.877 277.71 969.731 275.859 969.731 273.555C969.731 271.251 967.868 269.4 965.577 269.4Z"
            fill="white"
          />
          <path
            d="M974.611 273.584C972.319 273.584 970.456 275.447 970.456 277.739C970.456 280.03 972.319 281.893 974.611 281.893C976.902 281.893 978.774 280.03 978.774 277.739C978.774 275.447 976.911 273.584 974.611 273.584Z"
            fill="white"
          />
          <path
            d="M983.642 277.09C981.342 277.09 979.487 278.944 979.487 281.244C979.487 283.545 981.342 285.399 983.642 285.399C985.942 285.399 987.796 283.536 987.796 281.244C987.796 278.953 985.934 277.09 983.642 277.09Z"
            fill="white"
          />
          <path
            d="M992.605 279.973C990.305 279.973 988.45 281.836 988.45 284.127C988.45 286.419 990.3 288.282 992.605 288.282C994.909 288.282 996.759 286.419 996.759 284.127C996.759 281.836 994.896 279.973 992.605 279.973Z"
            fill="white"
          />
          <path
            d="M1001.45 282.314C999.164 282.314 997.297 284.165 997.297 286.469C997.297 288.773 999.16 290.624 1001.45 290.624C1003.74 290.624 1005.61 288.761 1005.61 286.469C1005.61 284.177 1003.74 282.314 1001.45 282.314Z"
            fill="white"
          />
          <path
            d="M996.36 284.004C994.06 284.004 992.205 285.867 992.205 288.159C992.205 290.45 994.055 292.322 996.36 292.322C998.664 292.322 1000.51 290.459 1000.51 288.159C1000.51 285.858 998.651 284.004 996.36 284.004Z"
            fill="white"
          />
          <path
            d="M991.093 285.654C988.801 285.654 986.938 287.517 986.938 289.809C986.938 292.101 988.801 293.972 991.093 293.972C993.385 293.972 995.248 292.109 995.248 289.809C995.248 287.509 993.385 285.654 991.093 285.654Z"
            fill="white"
          />
          <path
            d="M985.654 287.311C983.354 287.311 981.499 289.174 981.499 291.465C981.499 293.757 983.354 295.62 985.654 295.62C987.954 295.62 989.808 293.765 989.808 291.465C989.808 289.165 987.945 287.311 985.654 287.311Z"
            fill="white"
          />
          <path
            d="M980.013 289.008C977.713 289.008 975.858 290.871 975.858 293.162C975.858 295.454 977.713 297.317 980.013 297.317C982.313 297.317 984.168 295.467 984.168 293.162C984.168 290.858 982.305 289.008 980.013 289.008Z"
            fill="white"
          />
          <path
            d="M974.174 290.791C971.874 290.791 970.02 292.646 970.02 294.946C970.02 297.246 971.874 299.1 974.174 299.1C976.474 299.1 978.329 297.237 978.329 294.946C978.329 292.654 976.466 290.791 974.174 290.791Z"
            fill="white"
          />
          <path
            d="M968.127 292.668C965.827 292.668 963.973 294.531 963.973 296.823C963.973 299.114 965.827 300.977 968.127 300.977C970.427 300.977 972.282 299.127 972.282 296.823C972.282 294.518 970.419 292.668 968.127 292.668Z"
            fill="white"
          />
          <path
            d="M961.859 294.711C959.567 294.711 957.704 296.574 957.704 298.866C957.704 301.157 959.567 303.02 961.859 303.02C964.15 303.02 966.013 301.157 966.013 298.866C966.013 296.574 964.15 294.711 961.859 294.711Z"
            fill="white"
          />
          <path
            d="M955.366 296.939C953.074 296.939 951.211 298.794 951.211 301.094C951.211 303.394 953.074 305.249 955.366 305.249C957.657 305.249 959.52 303.386 959.52 301.094C959.52 298.802 957.666 296.939 955.366 296.939Z"
            fill="white"
          />
          <path
            d="M948.643 299.375C946.351 299.375 944.488 301.238 944.488 303.53C944.488 305.821 946.351 307.672 948.643 307.672C950.934 307.672 952.785 305.817 952.785 303.53C952.785 301.242 950.934 299.375 948.643 299.375Z"
            fill="white"
          />
          <path
            d="M941.667 302.084C939.388 302.084 937.533 303.926 937.533 306.217C937.533 308.509 939.388 310.351 941.667 310.351C943.946 310.351 945.8 308.501 945.8 306.217C945.8 303.934 943.946 302.084 941.667 302.084Z"
            fill="white"
          />
          <path
            d="M934.444 305.057C932.165 305.057 930.323 306.911 930.323 309.177C930.323 311.443 932.165 313.298 934.444 313.298C936.723 313.298 938.556 311.456 938.556 309.177C938.556 306.898 936.714 305.057 934.444 305.057Z"
            fill="white"
          />
          <path
            d="M926.992 308.377C924.722 308.377 922.901 310.21 922.901 312.468C922.901 314.726 924.722 316.559 926.992 316.559C929.263 316.559 931.071 314.726 931.071 312.468C931.071 310.21 929.25 308.377 926.992 308.377Z"
            fill="white"
          />
          <path
            d="M919.992 320.052C922.211 319.692 923.717 317.602 923.357 315.383C922.997 313.164 920.907 311.658 918.688 312.018C916.469 312.378 914.963 314.468 915.323 316.687C915.683 318.906 917.774 320.412 919.992 320.052Z"
            fill="white"
          />
          <path
            d="M911.527 315.963C909.277 315.963 907.47 317.775 907.47 320.02C907.47 322.265 909.282 324.068 911.527 324.068C913.772 324.068 915.575 322.256 915.575 320.02C915.575 317.783 913.763 315.963 911.527 315.963Z"
            fill="white"
          />
          <path
            d="M903.617 320.234C901.402 320.234 899.59 322.034 899.59 324.262C899.59 326.49 901.402 328.289 903.617 328.289C905.832 328.289 907.644 326.477 907.644 324.262C907.644 322.046 905.845 320.234 903.617 320.234Z"
            fill="white"
          />
          <path
            d="M896.334 332.636C898.513 332.282 899.993 330.229 899.639 328.05C899.285 325.87 897.232 324.39 895.052 324.744C892.873 325.098 891.393 327.151 891.747 329.331C892.101 331.51 894.154 332.99 896.334 332.636Z"
            fill="white"
          />
          <path
            d="M887.774 329.412C885.589 329.412 883.811 331.19 883.811 333.389C883.811 335.587 885.589 337.352 887.774 337.352C889.96 337.352 891.751 335.574 891.751 333.389C891.751 331.203 889.972 329.412 887.774 329.412Z"
            fill="white"
          />
          <path
            d="M879.886 334.283C877.709 334.283 875.952 336.053 875.952 338.23C875.952 340.407 877.709 342.164 879.886 342.164C882.063 342.164 883.833 340.407 883.833 338.23C883.833 336.053 882.063 334.283 879.886 334.283Z"
            fill="white"
          />
          <path
            d="M871.904 339.609C869.748 339.609 868 341.358 868 343.522C868 345.686 869.748 347.426 871.904 347.426C874.06 347.426 875.809 345.678 875.809 343.522C875.809 341.366 874.06 339.609 871.904 339.609Z"
            fill="white"
          />
          <path
            d="M863.82 345.484C861.685 345.484 859.958 347.212 859.958 349.346C859.958 351.481 861.685 353.216 863.82 353.216C865.954 353.216 867.69 351.477 867.69 349.346C867.69 347.216 865.963 345.484 863.82 345.484Z"
            fill="white"
          />
          <path
            d="M855.646 351.869C853.524 351.869 851.806 353.588 851.806 355.71C851.806 357.832 853.524 359.542 855.646 359.542C857.768 359.542 859.478 357.823 859.478 355.71C859.478 353.596 857.76 351.869 855.646 351.869Z"
            fill="white"
          />
          <path
            d="M847.354 358.805C845.253 358.805 843.556 360.511 843.556 362.616C843.556 364.72 845.253 366.414 847.354 366.414C849.454 366.414 851.152 364.708 851.152 362.616C851.152 360.523 849.454 358.805 847.354 358.805Z"
            fill="white"
          />
          <path
            d="M839.794 373.763C841.819 373.285 843.074 371.255 842.596 369.229C842.117 367.204 840.088 365.949 838.062 366.427C836.037 366.905 834.782 368.935 835.26 370.961C835.738 372.986 837.768 374.241 839.794 373.763Z"
            fill="white"
          />
          <path
            d="M830.358 374.332C828.308 374.332 826.645 375.987 826.645 378.037C826.645 380.087 828.308 381.75 830.358 381.75C832.408 381.75 834.063 380.087 834.063 378.037C834.063 375.987 832.408 374.332 830.358 374.332Z"
            fill="white"
          />
          <path
            d="M821.632 382.951C819.604 382.951 817.957 384.598 817.957 386.626C817.957 388.655 819.604 390.31 821.632 390.31C823.661 390.31 825.307 388.655 825.307 386.626C825.307 384.598 823.661 382.951 821.632 382.951Z"
            fill="white"
          />
          <path
            d="M812.766 392.139C810.768 392.139 809.134 393.764 809.134 395.771C809.134 397.779 810.768 399.404 812.766 399.404C814.765 399.404 816.399 397.779 816.399 395.771C816.399 393.764 814.774 392.139 812.766 392.139Z"
            fill="white"
          />
          <path
            d="M803.838 401.957C801.861 401.957 800.248 403.561 800.248 405.547C800.248 407.533 801.861 409.146 803.838 409.146C805.816 409.146 807.437 407.533 807.437 405.547C807.437 403.561 805.824 401.957 803.838 401.957Z"
            fill="white"
          />
          <path
            d="M798.954 414.027C797.019 414.027 795.457 415.589 795.457 417.516C795.457 419.442 797.019 421.013 798.954 421.013C800.889 421.013 802.442 419.451 802.442 417.516C802.442 415.581 800.881 414.027 798.954 414.027Z"
            fill="white"
          />
          <path
            d="M786.942 430.755C788.844 430.447 790.135 428.655 789.826 426.753C789.518 424.852 787.726 423.56 785.824 423.869C783.922 424.177 782.631 425.969 782.94 427.871C783.248 429.773 785.04 431.064 786.942 430.755Z"
            fill="white"
          />
          <path
            d="M773.717 434.229C771.79 434.229 770.241 435.79 770.241 437.717C770.241 439.644 771.79 441.193 773.717 441.193C775.643 441.193 777.192 439.631 777.192 437.717C777.192 435.803 775.639 434.229 773.717 434.229Z"
            fill="white"
          />
          <path
            d="M761.083 445.219C759.156 445.219 757.607 446.768 757.607 448.694C757.607 450.621 759.156 452.162 761.083 452.162C763.01 452.162 764.55 450.613 764.55 448.694C764.55 446.776 763.001 445.219 761.083 445.219Z"
            fill="white"
          />
          <path
            d="M748.456 456.742C746.542 456.742 744.98 458.291 744.98 460.209C744.98 462.127 746.542 463.676 748.456 463.676C750.37 463.676 751.923 462.127 751.923 460.209C751.923 458.291 750.374 456.742 748.456 456.742Z"
            fill="white"
          />
          <path
            d="M735.768 468.48C733.854 468.48 732.301 470.029 732.301 471.948C732.301 473.866 733.85 475.402 735.768 475.402C737.686 475.402 739.222 473.862 739.222 471.948C739.222 470.034 737.669 468.48 735.768 468.48Z"
            fill="white"
          />
          <path
            d="M723.03 480.252C721.116 480.252 719.562 481.801 719.562 483.719C719.562 485.637 721.111 487.186 723.03 487.186C724.948 487.186 726.497 485.637 726.497 483.719C726.497 481.801 724.935 480.252 723.03 480.252Z"
            fill="white"
          />
          <path
            d="M710.196 491.73C708.282 491.73 706.729 493.279 706.729 495.198C706.729 497.116 708.278 498.652 710.196 498.652C712.114 498.652 713.65 497.103 713.65 495.198C713.65 493.292 712.101 491.73 710.196 491.73Z"
            fill="white"
          />
          <path
            d="M697.155 502.557C695.249 502.557 693.7 504.097 693.7 506.011C693.7 507.925 695.249 509.465 697.155 509.465C699.06 509.465 700.609 507.917 700.609 506.011C700.609 504.106 699.056 502.557 697.155 502.557Z"
            fill="white"
          />
          <path
            d="M683.949 512.453C682.043 512.453 680.494 513.994 680.494 515.907C680.494 517.821 682.043 519.362 683.949 519.362C685.854 519.362 687.403 517.813 687.403 515.907C687.403 514.002 685.854 512.453 683.949 512.453Z"
            fill="white"
          />
          <path
            d="M670.671 521.373C668.765 521.373 667.225 522.914 667.225 524.819C667.225 526.724 668.765 528.265 670.671 528.265C672.576 528.265 674.125 526.724 674.125 524.819C674.125 522.914 672.572 521.373 670.671 521.373Z"
            fill="white"
          />
          <path
            d="M657.313 529.242C655.408 529.242 653.867 530.783 653.867 532.688C653.867 534.594 655.408 536.143 657.313 536.143C659.219 536.143 660.759 534.594 660.759 532.688C660.759 530.783 659.219 529.242 657.313 529.242Z"
            fill="white"
          />
          <path
            d="M644.663 542.852C646.516 542.414 647.663 540.558 647.226 538.706C646.789 536.854 644.933 535.707 643.08 536.144C641.228 536.581 640.081 538.437 640.518 540.289C640.955 542.142 642.811 543.289 644.663 542.852Z"
            fill="white"
          />
          <path
            d="M630.537 541.982C628.644 541.982 627.104 543.523 627.104 545.428C627.104 547.334 628.644 548.862 630.537 548.862C632.429 548.862 633.983 547.321 633.983 545.428C633.983 543.536 632.442 541.982 630.537 541.982Z"
            fill="white"
          />
          <path
            d="M617.232 547.291C615.339 547.291 613.799 548.831 613.799 550.737C613.799 552.642 615.339 554.183 617.232 554.183C619.125 554.183 620.678 552.642 620.678 550.737C620.678 548.831 619.137 547.291 617.232 547.291Z"
            fill="white"
          />
          <path
            d="M603.924 552.07C602.032 552.07 600.491 553.602 600.491 555.503C600.491 557.405 602.032 558.937 603.924 558.937C605.817 558.937 607.358 557.396 607.358 555.503C607.358 553.611 605.817 552.07 603.924 552.07Z"
            fill="white"
          />
          <path
            d="M590.64 556.721C588.748 556.721 587.207 558.261 587.207 560.154C587.207 562.047 588.748 563.579 590.64 563.579C592.533 563.579 594.065 562.047 594.065 560.154C594.065 558.261 592.537 556.721 590.64 556.721Z"
            fill="white"
          />
          <path
            d="M577.463 561.412C575.57 561.412 574.038 562.944 574.038 564.837C574.038 566.73 575.57 568.27 577.463 568.27C579.355 568.27 580.896 566.73 580.896 564.837C580.896 562.944 579.355 561.412 577.463 561.412Z"
            fill="white"
          />
          <path
            d="M564.38 566.256C562.487 566.256 560.955 567.788 560.955 569.681C560.955 571.573 562.487 573.105 564.38 573.105C566.273 573.105 567.804 571.573 567.804 569.681C567.804 567.788 566.273 566.256 564.38 566.256Z"
            fill="white"
          />
          <path
            d="M551.339 571.23C549.455 571.23 547.914 572.762 547.914 574.655C547.914 576.548 549.455 578.08 551.339 578.08C553.223 578.08 554.763 576.539 554.763 574.655C554.763 572.771 553.232 571.23 551.339 571.23Z"
            fill="white"
          />
          <path
            d="M538.341 576.182C536.456 576.182 534.929 577.714 534.929 579.594C534.929 581.474 536.461 583.018 538.341 583.018C540.221 583.018 541.765 581.486 541.765 579.594C541.765 577.701 540.233 576.182 538.341 576.182Z"
            fill="white"
          />
          <path
            d="M525.363 581.086C523.479 581.086 521.951 582.618 521.951 584.511C521.951 586.403 523.483 587.923 525.363 587.923C527.243 587.923 528.788 586.391 528.788 584.511C528.788 582.631 527.256 581.086 525.363 581.086Z"
            fill="white"
          />
          <path
            d="M512.365 585.914C510.481 585.914 508.953 587.446 508.953 589.326C508.953 591.206 510.485 592.742 512.365 592.742C514.245 592.742 515.777 591.21 515.777 589.326C515.777 587.442 514.245 585.914 512.365 585.914Z"
            fill="white"
          />
          <path
            d="M499.281 590.568C497.397 590.568 495.878 592.088 495.878 593.972C495.878 595.856 497.397 597.388 499.281 597.388C501.166 597.388 502.693 595.856 502.693 593.972C502.693 592.088 501.161 590.568 499.281 590.568Z"
            fill="white"
          />
          <path
            d="M486.134 594.805C484.25 594.805 482.73 596.324 482.73 598.208C482.73 600.092 484.25 601.62 486.134 601.62C488.018 601.62 489.537 600.088 489.537 598.208C489.537 596.328 488.018 594.805 486.134 594.805Z"
            fill="white"
          />
          <path
            d="M472.877 598.652C470.993 598.652 469.465 600.184 469.465 602.069C469.465 603.953 470.997 605.472 472.877 605.472C474.757 605.472 476.28 603.953 476.28 602.069C476.28 600.184 474.761 598.652 472.877 598.652Z"
            fill="white"
          />
          <path
            d="M459.449 602.049C457.578 602.049 456.046 603.581 456.046 605.452C456.046 607.324 457.578 608.856 459.449 608.856C461.321 608.856 462.853 607.336 462.853 605.452C462.853 603.568 461.334 602.049 459.449 602.049Z"
            fill="white"
          />
          <path
            d="M445.869 604.744C443.985 604.744 442.457 606.276 442.457 608.16C442.457 610.045 443.989 611.572 445.869 611.572C447.749 611.572 449.281 610.045 449.281 608.16C449.281 606.276 447.749 604.744 445.869 604.744Z"
            fill="white"
          />
          <path
            d="M432.098 606.713C430.214 606.713 428.694 608.232 428.694 610.116C428.694 612.001 430.214 613.533 432.098 613.533C433.982 613.533 435.501 612.001 435.501 610.116C435.501 608.232 433.982 606.713 432.098 606.713Z"
            fill="white"
          />
          <path
            d="M418.077 607.875C416.206 607.875 414.674 609.407 414.674 611.287C414.674 613.167 416.202 614.69 418.077 614.69C419.953 614.69 421.494 613.171 421.494 611.287C421.494 609.403 419.962 607.875 418.077 607.875Z"
            fill="white"
          />
          <path
            d="M409.793 605.867C407.888 605.867 406.339 607.416 406.339 609.322C406.339 611.227 407.888 612.776 409.793 612.776C411.699 612.776 413.248 611.227 413.248 609.322C413.248 607.416 411.699 605.867 409.793 605.867Z"
            fill="white"
          />
          <path
            d="M401.353 603.381C399.405 603.381 397.835 604.951 397.835 606.886C397.835 608.821 399.405 610.404 401.353 610.404C403.301 610.404 404.858 608.834 404.858 606.886C404.858 604.938 403.288 603.381 401.353 603.381Z"
            fill="white"
          />
          <path
            d="M392.789 600.357C390.824 600.357 389.229 601.949 389.229 603.918C389.229 605.887 390.82 607.466 392.789 607.466C394.758 607.466 396.35 605.874 396.35 603.918C396.35 601.962 394.758 600.357 392.789 600.357Z"
            fill="white"
          />
          <path
            d="M384.149 596.824C382.171 596.824 380.559 598.437 380.559 600.414C380.559 602.392 382.171 604.005 384.149 604.005C386.126 604.005 387.739 602.4 387.739 600.414C387.739 598.428 386.135 596.824 384.149 596.824Z"
            fill="white"
          />
          <path
            d="M375.479 592.668C373.48 592.668 371.859 594.293 371.859 596.301C371.859 598.308 373.485 599.933 375.479 599.933C377.474 599.933 379.112 598.308 379.112 596.301C379.112 594.293 377.487 592.668 375.479 592.668Z"
            fill="white"
          />
          <path
            d="M366.829 587.818C364.788 587.818 363.133 589.473 363.133 591.515C363.133 593.556 364.788 595.211 366.829 595.211C368.87 595.211 370.513 593.556 370.513 591.515C370.513 589.473 368.87 587.818 366.829 587.818Z"
            fill="white"
          />
          <path
            d="M358.222 582.293C356.173 582.293 354.505 583.948 354.505 586.01C354.505 588.073 356.168 589.728 358.222 589.728C360.276 589.728 361.94 588.064 361.94 586.01C361.94 583.957 360.285 582.293 358.222 582.293Z"
            fill="white"
          />
          <path
            d="M349.74 575.91C347.669 575.91 345.993 577.595 345.993 579.666C345.993 581.737 347.669 583.413 349.74 583.413C351.811 583.413 353.488 581.737 353.488 579.666C353.488 577.595 351.811 575.91 349.74 575.91Z"
            fill="white"
          />
          <path
            d="M341.444 568.594C339.352 568.594 337.667 570.279 337.667 572.371C337.667 574.463 339.352 576.148 341.444 576.148C343.536 576.148 345.221 574.45 345.221 572.371C345.221 570.291 343.523 568.594 341.444 568.594Z"
            fill="white"
          />
          <path
            d="M333.423 560.174C331.309 560.174 329.595 561.88 329.595 564.006C329.595 566.132 331.313 567.825 333.423 567.825C335.532 567.825 337.242 566.119 337.242 564.006C337.242 561.893 335.536 560.174 333.423 560.174Z"
            fill="white"
          />
          <path
            d="M325.742 550.588C323.607 550.588 321.893 552.315 321.893 554.437C321.893 556.559 323.611 558.286 325.742 558.286C327.872 558.286 329.591 556.567 329.591 554.437C329.591 552.307 327.864 550.588 325.742 550.588Z"
            fill="white"
          />
          <path
            d="M318.476 547.499C320.62 547.499 322.359 545.76 322.359 543.615C322.359 541.471 320.62 539.732 318.476 539.732C316.331 539.732 314.593 541.471 314.593 543.615C314.593 545.76 316.331 547.499 318.476 547.499Z"
            fill="white"
          />
          <path
            d="M311.606 527.795C309.451 527.795 307.702 529.543 307.702 531.699C307.702 533.855 309.451 535.612 311.606 535.612C313.762 535.612 315.511 533.864 315.511 531.699C315.511 529.535 313.762 527.795 311.606 527.795Z"
            fill="white"
          />
          <path
            d="M305.049 515.004C302.872 515.004 301.115 516.765 301.115 518.938C301.115 521.111 302.872 522.88 305.049 522.88C307.226 522.88 308.992 521.111 308.992 518.938C308.992 516.765 307.222 515.004 305.049 515.004Z"
            fill="white"
          />
          <path
            d="M298.701 501.619C296.515 501.619 294.737 503.397 294.737 505.583C294.737 507.768 296.515 509.546 298.701 509.546C300.886 509.546 302.665 507.768 302.665 505.583C302.665 503.397 300.886 501.619 298.701 501.619Z"
            fill="white"
          />
          <path
            d="M292.382 487.967C290.188 487.967 288.397 489.745 288.397 491.952C288.397 494.158 290.188 495.928 292.382 495.928C294.576 495.928 296.367 494.15 296.367 491.952C296.367 489.753 294.576 487.967 292.382 487.967Z"
            fill="white"
          />
          <path
            d="M285.931 474.361C283.724 474.361 281.934 476.152 281.934 478.359C281.934 480.566 283.724 482.344 285.931 482.344C288.138 482.344 289.916 480.553 289.916 478.359C289.916 476.165 288.138 474.361 285.931 474.361Z"
            fill="white"
          />
          <path
            d="M279.217 460.977C276.989 460.977 275.198 462.776 275.198 464.995C275.198 467.215 276.989 469.014 279.217 469.014C281.445 469.014 283.236 467.215 283.236 464.995C283.236 462.776 281.437 460.977 279.217 460.977Z"
            fill="white"
          />
          <path
            d="M272.168 447.957C269.94 447.957 268.141 449.756 268.141 451.984C268.141 454.212 269.94 456.024 272.168 456.024C274.396 456.024 276.208 454.212 276.208 451.984C276.208 449.756 274.396 447.957 272.168 447.957Z"
            fill="white"
          />
          <path
            d="M264.822 435.252C262.594 435.252 260.782 437.064 260.782 439.292C260.782 441.52 262.594 443.341 264.822 443.341C267.05 443.341 268.871 441.528 268.871 439.292C268.871 437.056 267.059 435.252 264.822 435.252Z"
            fill="white"
          />
          <path
            d="M257.226 422.75C254.977 422.75 253.169 424.562 253.169 426.807C253.169 429.052 254.981 430.864 257.226 430.864C259.471 430.864 261.283 429.043 261.283 426.807C261.283 424.571 259.462 422.75 257.226 422.75Z"
            fill="white"
          />
          <path
            d="M249.41 410.502C247.16 410.502 245.34 412.323 245.34 414.572C245.34 416.821 247.16 418.641 249.41 418.641C251.659 418.641 253.479 416.821 253.479 414.572C253.479 412.323 251.659 410.502 249.41 410.502Z"
            fill="white"
          />
          <path
            d="M241.507 398.281C239.249 398.281 237.429 400.115 237.429 402.359C237.429 404.604 239.249 406.438 241.507 406.438C243.765 406.438 245.577 404.617 245.577 402.359C245.577 400.102 243.756 398.281 241.507 398.281Z"
            fill="white"
          />
          <path
            d="M233.567 386.033C231.318 386.033 229.489 387.866 229.489 390.111C229.489 392.356 231.323 394.19 233.567 394.19C235.812 394.19 237.646 392.369 237.646 390.111C237.646 387.854 235.825 386.033 233.567 386.033Z"
            fill="white"
          />
          <path
            d="M225.657 373.717C223.408 373.717 221.579 375.55 221.579 377.795C221.579 380.04 223.412 381.873 225.657 381.873C227.902 381.873 229.736 380.04 229.736 377.795C229.736 375.55 227.902 373.717 225.657 373.717Z"
            fill="white"
          />
          <path
            d="M217.831 361.291C215.574 361.291 213.74 363.124 213.74 365.369C213.74 367.614 215.574 369.46 217.831 369.46C220.089 369.46 221.922 367.627 221.922 365.369C221.922 363.112 220.089 361.291 217.831 361.291Z"
            fill="white"
          />
          <path
            d="M210.065 349.053C207.807 349.053 205.974 350.886 205.974 353.144C205.974 355.401 207.807 357.222 210.065 357.222C212.322 357.222 214.156 355.401 214.156 353.144C214.156 350.886 212.322 349.053 210.065 349.053Z"
            fill="white"
          />
          <path
            d="M202.363 337.166C200.106 337.166 198.272 338.999 198.272 341.244C198.272 343.489 200.106 345.335 202.363 345.335C204.621 345.335 206.442 343.502 206.442 341.244C206.442 338.987 204.608 337.166 202.363 337.166Z"
            fill="white"
          />
          <path
            d="M194.683 325.771C192.434 325.771 190.604 327.605 190.604 329.85C190.604 332.095 192.438 333.928 194.683 333.928C196.928 333.928 198.761 332.107 198.761 329.85C198.761 327.592 196.94 325.771 194.683 325.771Z"
            fill="white"
          />
          <path
            d="M202.011 310.002C199.762 310.002 197.941 311.823 197.941 314.072C197.941 316.321 199.762 318.141 202.011 318.141C204.26 318.141 206.081 316.321 206.081 314.072C206.081 311.823 204.26 310.002 202.011 310.002Z"
            fill="white"
          />
          <path
            d="M209.378 295.713C207.142 295.713 205.309 297.533 205.309 299.783C205.309 302.032 207.142 303.852 209.378 303.852C211.615 303.852 213.448 302.032 213.448 299.783C213.448 297.533 211.628 295.713 209.378 295.713Z"
            fill="white"
          />
          <path
            d="M216.831 282.982C214.594 282.982 212.782 284.803 212.782 287.039C212.782 289.276 214.594 291.088 216.831 291.088C219.067 291.088 220.888 289.276 220.888 287.039C220.888 284.803 219.076 282.982 216.831 282.982Z"
            fill="white"
          />
          <path
            d="M224.304 271.76C222.068 271.76 220.256 273.572 220.256 275.808C220.256 278.045 222.068 279.848 224.304 279.848C226.541 279.848 228.353 278.036 228.353 275.808C228.353 273.58 226.541 271.76 224.304 271.76Z"
            fill="white"
          />
          <path
            d="M231.734 261.779C229.506 261.779 227.707 263.579 227.707 265.807C227.707 268.035 229.506 269.834 231.734 269.834C233.962 269.834 235.762 268.035 235.762 265.807C235.762 263.579 233.962 261.779 231.734 261.779Z"
            fill="white"
          />
          <path
            d="M239.012 252.828C236.797 252.828 234.993 254.619 234.993 256.834C234.993 259.049 236.793 260.853 239.012 260.853C241.231 260.853 243.018 259.054 243.018 256.834C243.018 254.615 241.219 252.828 239.012 252.828Z"
            fill="white"
          />
          <path
            d="M245.942 244.723C243.735 244.723 241.944 246.514 241.944 248.708C241.944 250.902 243.735 252.705 245.942 252.705C248.149 252.705 249.94 250.914 249.94 248.708C249.94 246.501 248.149 244.723 245.942 244.723Z"
            fill="white"
          />
          <path
            d="M252.498 237.178C250.312 237.178 248.534 238.947 248.534 241.141C248.534 243.335 250.312 245.105 252.498 245.105C254.683 245.105 256.474 243.327 256.474 241.141C256.474 238.956 254.696 237.178 252.498 237.178Z"
            fill="white"
          />
          <path
            d="M258.64 230.092C256.463 230.092 254.697 231.849 254.697 234.026C254.697 236.203 256.467 237.968 258.64 237.968C260.813 237.968 262.582 236.199 262.582 234.026C262.582 231.853 260.813 230.092 258.64 230.092Z"
            fill="white"
          />
          <path
            d="M264.377 223.5C262.212 223.5 260.451 225.257 260.451 227.425C260.451 229.594 262.208 231.359 264.377 231.359C266.545 231.359 268.302 229.598 268.302 227.425C268.302 225.253 266.541 223.5 264.377 223.5Z"
            fill="white"
          />
          <path
            d="M269.716 217.695C267.56 217.695 265.824 219.444 265.824 221.587C265.824 223.73 267.56 225.491 269.716 225.491C271.872 225.491 273.607 223.743 273.607 221.587C273.607 219.431 271.867 217.695 269.716 217.695Z"
            fill="white"
          />
          <path
            d="M274.574 212.666C272.431 212.666 270.704 214.402 270.704 216.536C270.704 218.671 272.431 220.419 274.574 220.419C276.717 220.419 278.445 218.684 278.445 216.536C278.445 214.389 276.717 212.666 274.574 212.666Z"
            fill="white"
          />
          <path
            d="M278.924 208.283C276.811 208.283 275.092 210.002 275.092 212.111C275.092 214.22 276.811 215.943 278.924 215.943C281.037 215.943 282.752 214.224 282.752 212.111C282.752 209.998 281.033 208.283 278.924 208.283Z"
            fill="white"
          />
          <path
            d="M282.757 204.35C280.656 204.35 278.959 206.056 278.959 208.161C278.959 210.265 280.656 211.959 282.757 211.959C284.858 211.959 286.568 210.253 286.568 208.161C286.568 206.068 284.862 204.35 282.757 204.35Z"
            fill="white"
          />
          <path
            d="M286.075 200.75C283.996 200.75 282.307 202.448 282.307 204.527C282.307 206.606 283.991 208.295 286.075 208.295C288.159 208.295 289.844 206.611 289.844 204.527C289.844 202.443 288.159 200.75 286.075 200.75Z"
            fill="white"
          />
          <path
            d="M288.884 197.375C286.821 197.375 285.149 199.051 285.149 201.109C285.149 203.168 286.826 204.857 288.884 204.857C290.942 204.857 292.631 203.18 292.631 201.109C292.631 199.039 290.955 197.375 288.884 197.375Z"
            fill="white"
          />
          <path
            d="M291.206 194.236C289.165 194.236 287.51 195.891 287.51 197.933C287.51 199.974 289.165 201.629 291.206 201.629C293.247 201.629 294.89 199.974 294.89 197.933C294.89 195.891 293.247 194.236 291.206 194.236Z"
            fill="white"
          />
          <path
            d="M293.047 191.258C291.027 191.258 289.394 192.892 289.394 194.912C289.394 196.932 291.027 198.553 293.047 198.553C295.067 198.553 296.689 196.919 296.689 194.912C296.689 192.904 295.063 191.258 293.047 191.258Z"
            fill="white"
          />
          <path
            d="M294.474 188.396C292.475 188.396 290.862 190.022 290.862 192.016C290.862 194.011 292.475 195.628 294.474 195.628C296.473 195.628 298.085 194.011 298.085 192.016C298.085 190.022 296.473 188.396 294.474 188.396Z"
            fill="white"
          />
          <path
            d="M295.535 185.646C293.557 185.646 291.966 187.242 291.966 189.215C291.966 191.189 293.557 192.784 295.535 192.784C297.512 192.784 299.104 191.18 299.104 189.215C299.104 187.251 297.5 185.646 295.535 185.646Z"
            fill="white"
          />
          <path
            d="M296.273 182.969C294.338 182.969 292.768 184.539 292.768 186.483C292.768 188.426 294.338 189.988 296.273 189.988C298.208 189.988 299.778 188.418 299.778 186.483C299.778 184.547 298.208 182.969 296.273 182.969Z"
            fill="white"
          />
          <path
            d="M296.744 180.264C294.818 180.264 293.269 181.825 293.269 183.739C293.269 185.653 294.818 187.215 296.744 187.215C298.671 187.215 300.22 185.657 300.22 183.739C300.22 181.821 298.658 180.264 296.744 180.264Z"
            fill="white"
          />
          <path
            d="M296.982 177.541C295.09 177.541 293.558 179.082 293.558 180.97C293.558 182.858 295.09 184.399 296.982 184.399C298.875 184.399 300.407 182.858 300.407 180.97C300.407 179.082 298.875 177.541 296.982 177.541Z"
            fill="white"
          />
          <path
            d="M297.045 174.697C295.174 174.697 293.663 176.208 293.663 178.08C293.663 179.951 295.174 181.462 297.045 181.462C298.917 181.462 300.428 179.943 300.428 178.08C300.428 176.217 298.908 174.697 297.045 174.697Z"
            fill="white"
          />
          <path
            d="M297.015 171.66C295.182 171.66 293.705 173.137 293.705 174.97C293.705 176.804 295.182 178.272 297.015 178.272C298.848 178.272 300.313 176.795 300.313 174.97C300.313 173.145 298.836 171.66 297.015 171.66Z"
            fill="white"
          />
          <path
            d="M297.024 168.219C295.224 168.219 293.765 169.683 293.765 171.482C293.765 173.282 295.22 174.741 297.024 174.741C298.827 174.741 300.283 173.286 300.283 171.482C300.283 169.679 298.827 168.219 297.024 168.219Z"
            fill="white"
          />
          <path
            d="M297.283 164.219C295.514 164.219 294.066 165.653 294.066 167.423C294.066 169.192 295.514 170.635 297.283 170.635C299.053 170.635 300.487 169.197 300.487 167.423C300.487 165.649 299.053 164.219 297.283 164.219Z"
            fill="white"
          />
          <path
            d="M298.077 159.379C296.337 159.379 294.924 160.796 294.924 162.532C294.924 164.268 296.341 165.677 298.077 165.677C299.813 165.677 301.222 164.272 301.222 162.532C301.222 160.792 299.817 159.379 298.077 159.379Z"
            fill="white"
          />
          <path
            d="M299.856 153.301C298.158 153.301 296.783 154.676 296.783 156.373C296.783 158.071 298.158 159.446 299.856 159.446C301.553 159.446 302.928 158.071 302.928 156.373C302.928 154.676 301.553 153.301 299.856 153.301Z"
            fill="white"
          />
          <path
            d="M314.478 149.051C312.781 149.051 311.397 150.426 311.397 152.127C311.397 153.829 312.781 155.204 314.478 155.204C316.176 155.204 317.551 153.829 317.551 152.127C317.551 150.426 316.176 149.051 314.478 149.051Z"
            fill="white"
          />
          <path
            d="M330.593 142.766C328.895 142.766 327.521 144.145 327.521 145.842C327.521 147.54 328.895 148.915 330.593 148.915C332.29 148.915 333.674 147.54 333.674 145.842C333.674 144.145 332.299 142.766 330.593 142.766Z"
            fill="white"
          />
          <path
            d="M348.48 134.18C346.782 134.18 345.407 135.559 345.407 137.252C345.407 138.945 346.782 140.325 348.48 140.325C350.177 140.325 351.552 138.95 351.552 137.252C351.552 135.555 350.169 134.18 348.48 134.18Z"
            fill="white"
          />
          <path
            d="M368.62 122.908C366.923 122.908 365.548 124.287 365.548 125.989C365.548 127.691 366.923 129.062 368.62 129.062C370.318 129.062 371.701 127.687 371.701 125.989C371.701 124.292 370.326 122.908 368.62 122.908Z"
            fill="white"
          />
          <path
            d="M391.1 108.992C389.403 108.992 388.032 110.367 388.032 112.06C388.032 113.754 389.407 115.137 391.1 115.137C392.794 115.137 394.173 113.758 394.173 112.06C394.173 110.363 392.798 108.992 391.1 108.992Z"
            fill="white"
          />
          <path
            d="M415.841 92.1641C414.135 92.1641 412.76 93.5475 412.76 95.245C412.76 96.9425 414.135 98.326 415.841 98.326C417.547 98.326 418.913 96.9468 418.913 95.245C418.913 93.5433 417.538 92.1641 415.841 92.1641Z"
            fill="white"
          />
          <path
            d="M441.83 72.8262C440.132 72.8262 438.749 74.2096 438.749 75.9114C438.749 77.6131 440.132 78.9966 441.83 78.9966C443.527 78.9966 444.919 77.6131 444.919 75.9114C444.919 74.2096 443.536 72.8262 441.83 72.8262Z"
            fill="white"
          />
          <path
            d="M468.056 51.9473C466.35 51.9473 464.975 53.3222 464.975 55.0282C464.975 56.7342 466.35 58.1092 468.056 58.1092C469.762 58.1092 471.136 56.7257 471.136 55.0282C471.136 53.3307 469.753 51.9473 468.056 51.9473Z"
            fill="white"
          />
          <path
            d="M493.128 31.3516C491.422 31.3516 490.047 32.735 490.047 34.4368C490.047 36.1385 491.422 37.522 493.128 37.522C494.834 37.522 496.217 36.1385 496.217 34.4368C496.217 32.735 494.834 31.3516 493.128 31.3516Z"
            fill="white"
          />
          <path
            d="M516.456 12.0859C514.75 12.0859 513.366 13.4694 513.366 15.1754C513.366 16.8814 514.75 18.2648 516.456 18.2648C518.162 18.2648 519.545 16.8814 519.545 15.1754C519.545 13.4694 518.162 12.0859 516.456 12.0859Z"
            fill="white"
          />
          <path
            d="M538.031 -4.6543C536.325 -4.6543 534.941 -3.27083 534.941 -1.56485C534.941 0.14114 536.325 1.53309 538.031 1.53309C539.737 1.53309 541.12 0.149627 541.12 -1.56485C541.12 -3.27932 539.737 -4.6543 538.031 -4.6543Z"
            fill="white"
          />
          <path
            d="M819.201 -5.99219C817.368 -5.99219 815.87 -4.50263 815.87 -2.66084C815.87 -0.819057 817.368 0.670499 819.201 0.670499C821.035 0.670499 822.533 -0.823301 822.533 -2.66084C822.533 -4.49839 821.043 -5.99219 819.201 -5.99219Z"
            fill="white"
          />
          <path
            d="M826.089 5.12305C824.218 5.12305 822.707 6.64231 822.707 8.50532C822.707 10.3683 824.218 11.8876 826.089 11.8876C827.961 11.8876 829.472 10.3768 829.472 8.50532C829.472 6.63382 827.952 5.12305 826.089 5.12305Z"
            fill="white"
          />
          <path
            d="M832.73 17.1875C830.837 17.1875 829.297 18.7195 829.297 20.6122C829.297 22.5049 830.837 24.0454 832.73 24.0454C834.623 24.0454 836.155 22.5049 836.155 20.6122C836.155 18.7195 834.623 17.1875 832.73 17.1875Z"
            fill="white"
          />
          <path
            d="M839.108 30.2285C837.173 30.2285 835.611 31.7987 835.611 33.7296C835.611 35.6605 837.173 37.2307 839.108 37.2307C841.043 37.2307 842.614 35.6648 842.614 33.7296C842.614 31.7945 841.043 30.2285 839.108 30.2285Z"
            fill="white"
          />
          <path
            d="M845.207 44.3594C843.251 44.3594 841.659 45.9465 841.659 47.9071C841.659 49.8678 843.251 51.4549 845.207 51.4549C847.163 51.4549 848.767 49.8635 848.767 47.9071C848.767 45.9508 847.176 44.3594 845.207 44.3594Z"
            fill="white"
          />
          <path
            d="M851.025 59.5312C849.039 59.5312 847.422 61.1396 847.422 63.1257C847.422 65.1118 849.034 66.7244 851.025 66.7244C853.015 66.7244 854.628 65.1118 854.628 63.1257C854.628 61.1396 853.015 59.5312 851.025 59.5312Z"
            fill="white"
          />
          <path
            d="M856.542 75.7227C854.535 75.7227 852.909 77.348 852.909 79.3553C852.909 81.3626 854.535 82.988 856.542 82.988C858.549 82.988 860.174 81.3541 860.174 79.3553C860.174 77.3565 858.541 75.7227 856.542 75.7227Z"
            fill="white"
          />
          <path
            d="M861.786 92.7227C859.745 92.7227 858.09 94.3777 858.09 96.4232C858.09 98.4687 859.745 100.12 861.786 100.12C863.827 100.12 865.482 98.4645 865.482 96.4232C865.482 94.382 863.836 92.7227 861.786 92.7227Z"
            fill="white"
          />
          <path
            d="M866.917 110.232C864.846 110.232 863.17 111.909 863.17 113.98C863.17 116.051 864.846 117.714 866.917 117.714C868.988 117.714 870.652 116.038 870.652 113.98C870.652 111.921 868.975 110.232 866.917 110.232Z"
            fill="white"
          />
          <path
            d="M872.103 127.699C870.024 127.699 868.335 129.397 868.335 131.476C868.335 133.556 870.02 135.245 872.103 135.245C874.187 135.245 875.88 133.56 875.88 131.476C875.88 129.392 874.196 127.699 872.103 127.699Z"
            fill="white"
          />
          <path
            d="M877.564 152.07C879.674 152.07 881.384 150.36 881.384 148.251C881.384 146.142 879.674 144.432 877.564 144.432C875.455 144.432 873.745 146.142 873.745 148.251C873.745 150.36 875.455 152.07 877.564 152.07Z"
            fill="white"
          />
          <path
            d="M883.417 160.053C881.283 160.053 879.547 161.78 879.547 163.915C879.547 166.049 881.287 167.785 883.417 167.785C885.547 167.785 887.279 166.045 887.279 163.915C887.279 161.784 885.552 160.053 883.417 160.053Z"
            fill="white"
          />
          <path
            d="M892.432 181.196C893.956 179.672 893.956 177.2 892.432 175.675C890.907 174.15 888.435 174.15 886.91 175.675C885.385 177.2 885.385 179.672 886.91 181.196C888.435 182.721 890.907 182.721 892.432 181.196Z"
            fill="white"
          />
          <path
            d="M896.331 195.807C898.504 195.807 900.265 194.046 900.265 191.873C900.265 189.701 898.504 187.939 896.331 187.939C894.159 187.939 892.397 189.701 892.397 191.873C892.397 194.046 894.159 195.807 896.331 195.807Z"
            fill="white"
          />
          <path
            d="M903.366 200.363C901.181 200.363 899.411 202.133 899.411 204.318C899.411 206.504 901.181 208.282 903.366 208.282C905.552 208.282 907.33 206.504 907.33 204.318C907.33 202.133 905.552 200.363 903.366 200.363Z"
            fill="white"
          />
          <path
            d="M914.45 217.382C915.295 215.342 914.326 213.004 912.286 212.159C910.246 211.314 907.908 212.282 907.063 214.322C906.218 216.362 907.187 218.701 909.227 219.545C911.266 220.39 913.605 219.422 914.45 217.382Z"
            fill="white"
          />
          <path
            d="M918.491 222.441C916.276 222.441 914.473 224.241 914.473 226.469C914.473 228.697 916.272 230.488 918.491 230.488C920.711 230.488 922.519 228.688 922.519 226.469C922.519 224.249 920.719 222.441 918.491 222.441Z"
            fill="white"
          />
          <path
            d="M926.547 232.057C924.319 232.057 922.507 233.869 922.507 236.097C922.507 238.325 924.319 240.145 926.547 240.145C928.775 240.145 930.595 238.333 930.595 236.097C930.595 233.86 928.783 232.057 926.547 232.057Z"
            fill="white"
          />
          <path
            d="M934.893 240.715C932.635 240.715 930.814 242.535 930.814 244.793C930.814 247.051 932.635 248.863 934.893 248.863C937.15 248.863 938.963 247.042 938.963 244.793C938.963 242.544 937.142 240.715 934.893 240.715Z"
            fill="white"
          />
          <path
            d="M943.471 248.5C941.213 248.5 939.38 250.333 939.38 252.591C939.38 254.849 941.213 256.682 943.471 256.682C945.728 256.682 947.562 254.849 947.562 252.591C947.562 250.333 945.728 248.5 943.471 248.5Z"
            fill="white"
          />
          <path
            d="M952.243 255.402C949.964 255.402 948.122 257.244 948.122 259.515C948.122 261.785 949.964 263.635 952.243 263.635C954.522 263.635 956.364 261.793 956.364 259.515C956.364 257.236 954.509 255.402 952.243 255.402Z"
            fill="white"
          />
          <path
            d="M961.171 261.469C958.893 261.469 957.038 263.319 957.038 265.602C957.038 267.885 958.888 269.736 961.171 269.736C963.455 269.736 965.305 267.885 965.305 265.602C965.305 263.319 963.455 261.469 961.171 261.469Z"
            fill="white"
          />
          <path
            d="M970.206 266.715C967.915 266.715 966.064 268.569 966.064 270.857C966.064 273.144 967.919 275.011 970.206 275.011C972.494 275.011 974.361 273.157 974.361 270.857C974.361 268.557 972.506 266.715 970.206 266.715Z"
            fill="white"
          />
          <path
            d="M979.305 271.191C977.013 271.191 975.15 273.042 975.15 275.346C975.15 277.65 977.013 279.501 979.305 279.501C981.597 279.501 983.46 277.638 983.46 275.346C983.46 273.054 981.605 271.191 979.305 271.191Z"
            fill="white"
          />
          <path
            d="M988.398 274.936C986.098 274.936 984.235 276.799 984.235 279.09C984.235 281.382 986.098 283.245 988.398 283.245C990.699 283.245 992.553 281.39 992.553 279.09C992.553 276.79 990.69 274.936 988.398 274.936Z"
            fill="white"
          />
          <path
            d="M997.435 278.039C995.143 278.039 993.28 279.894 993.28 282.194C993.28 284.494 995.143 286.348 997.435 286.348C999.727 286.348 1001.59 284.485 1001.59 282.194C1001.59 279.902 999.739 278.039 997.435 278.039Z"
            fill="white"
          />
          <path
            d="M1006.38 280.566C1004.09 280.566 1002.23 282.421 1002.23 284.721C1002.23 287.021 1004.09 288.876 1006.38 288.876C1008.68 288.876 1010.54 287.013 1010.54 284.721C1010.54 282.429 1008.69 280.566 1006.38 280.566Z"
            fill="white"
          />
          <path
            d="M1015.21 282.596C1012.92 282.596 1011.06 284.459 1011.06 286.75C1011.06 289.042 1012.92 290.913 1015.21 290.913C1017.5 290.913 1019.37 289.05 1019.37 286.75C1019.37 284.45 1017.51 282.596 1015.21 282.596Z"
            fill="white"
          />
          <path
            d="M1010.16 284.17C1007.86 284.17 1006.01 286.033 1006.01 288.325C1006.01 290.616 1007.86 292.479 1010.16 292.479C1012.46 292.479 1014.32 290.629 1014.32 288.325C1014.32 286.02 1012.45 284.17 1010.16 284.17Z"
            fill="white"
          />
          <path
            d="M1004.93 285.697C1002.63 285.697 1000.77 287.56 1000.77 289.852C1000.77 292.144 1002.62 294.015 1004.93 294.015C1007.23 294.015 1009.08 292.152 1009.08 289.852C1009.08 287.552 1007.22 285.697 1004.93 285.697Z"
            fill="white"
          />
          <path
            d="M999.504 287.23C997.204 287.23 995.35 289.093 995.35 291.385C995.35 293.677 997.204 295.54 999.504 295.54C1001.8 295.54 1003.66 293.689 1003.66 291.385C1003.66 289.081 1001.8 287.23 999.504 287.23Z"
            fill="white"
          />
          <path
            d="M993.873 288.779C991.582 288.779 989.719 290.642 989.719 292.934C989.719 295.226 991.582 297.089 993.873 297.089C996.165 297.089 998.028 295.234 998.028 292.934C998.028 290.634 996.165 288.779 993.873 288.779Z"
            fill="white"
          />
          <path
            d="M988.035 290.383C985.743 290.383 983.88 292.246 983.88 294.537C983.88 296.829 985.743 298.692 988.035 298.692C990.326 298.692 992.189 296.842 992.189 294.537C992.189 292.233 990.326 290.383 988.035 290.383Z"
            fill="white"
          />
          <path
            d="M981.979 292.08C979.691 292.08 977.824 293.943 977.824 296.235C977.824 298.526 979.687 300.389 981.979 300.389C984.27 300.389 986.134 298.526 986.134 296.235C986.134 293.943 984.27 292.08 981.979 292.08Z"
            fill="white"
          />
          <path
            d="M975.694 293.889C973.402 293.889 971.539 295.752 971.539 298.043C971.539 300.335 973.402 302.206 975.694 302.206C977.985 302.206 979.848 300.343 979.848 298.043C979.848 295.743 977.994 293.889 975.694 293.889Z"
            fill="white"
          />
          <path
            d="M969.175 295.865C966.884 295.865 965.021 297.72 965.021 300.02C965.021 302.32 966.884 304.175 969.175 304.175C971.467 304.175 973.33 302.311 973.33 300.02C973.33 297.728 971.467 295.865 969.175 295.865Z"
            fill="white"
          />
          <path
            d="M962.422 298.033C960.131 298.033 958.268 299.883 958.268 302.175C958.268 304.467 960.131 306.33 962.422 306.33C964.714 306.33 966.564 304.467 966.564 302.175C966.564 299.883 964.71 298.033 962.422 298.033Z"
            fill="white"
          />
          <path
            d="M955.417 308.691C957.699 308.691 959.55 306.84 959.55 304.557C959.55 302.274 957.699 300.424 955.417 300.424C953.134 300.424 951.283 302.274 951.283 304.557C951.283 306.84 953.134 308.691 955.417 308.691Z"
            fill="white"
          />
          <path
            d="M948.164 303.072C945.893 303.072 944.043 304.914 944.043 307.184C944.043 309.455 945.897 311.305 948.164 311.305C950.43 311.305 952.284 309.463 952.284 307.184C952.284 304.906 950.443 303.072 948.164 303.072Z"
            fill="white"
          />
          <path
            d="M940.678 305.994C938.42 305.994 936.587 307.827 936.587 310.085C936.587 312.343 938.42 314.176 940.678 314.176C942.936 314.176 944.769 312.343 944.769 310.085C944.769 307.827 942.936 305.994 940.678 305.994Z"
            fill="white"
          />
          <path
            d="M932.981 309.207C930.732 309.207 928.911 311.028 928.911 313.285C928.911 315.543 930.732 317.355 932.981 317.355C935.23 317.355 937.051 315.534 937.051 313.285C937.051 311.036 935.23 309.207 932.981 309.207Z"
            fill="white"
          />
          <path
            d="M925.107 312.74C922.858 312.74 921.05 314.561 921.05 316.797C921.05 319.034 922.862 320.854 925.107 320.854C927.352 320.854 929.155 319.034 929.155 316.797C929.155 314.561 927.343 312.74 925.107 312.74Z"
            fill="white"
          />
          <path
            d="M917.116 316.578C914.888 316.578 913.076 318.377 913.076 320.605C913.076 322.833 914.888 324.645 917.116 324.645C919.344 324.645 921.144 322.833 921.144 320.605C921.144 318.377 919.344 316.578 917.116 316.578Z"
            fill="white"
          />
          <path
            d="M909.071 320.701C906.855 320.701 905.064 322.492 905.064 324.699C905.064 326.906 906.855 328.696 909.071 328.696C911.286 328.696 913.068 326.906 913.068 324.699C913.068 322.492 911.277 320.701 909.071 320.701Z"
            fill="white"
          />
          <path
            d="M901.025 325.027C898.831 325.027 897.049 326.805 897.049 329.004C897.049 331.202 898.827 332.967 901.025 332.967C903.223 332.967 904.989 331.189 904.989 329.004C904.989 326.818 903.211 325.027 901.025 325.027Z"
            fill="white"
          />
          <path
            d="M892.983 329.59C890.806 329.59 889.049 331.347 889.049 333.524C889.049 335.701 890.81 337.47 892.983 337.47C895.156 337.47 896.925 335.701 896.925 333.524C896.925 331.347 895.156 329.59 892.983 329.59Z"
            fill="white"
          />
          <path
            d="M884.864 334.551C882.7 334.551 880.951 336.312 880.951 338.464C880.951 340.615 882.7 342.376 884.864 342.376C887.028 342.376 888.768 340.628 888.768 338.464C888.768 336.299 887.02 334.551 884.864 334.551Z"
            fill="white"
          />
          <path
            d="M876.649 340.039C874.506 340.039 872.766 341.779 872.766 343.909C872.766 346.04 874.506 347.792 876.649 347.792C878.792 347.792 880.519 346.052 880.519 343.909C880.519 341.766 878.779 340.039 876.649 340.039Z"
            fill="white"
          />
          <path
            d="M868.356 346.033C866.242 346.033 864.523 347.752 864.523 349.874C864.523 351.996 866.242 353.706 868.356 353.706C870.469 353.706 872.196 351.987 872.196 349.874C872.196 347.76 870.477 346.033 868.356 346.033Z"
            fill="white"
          />
          <path
            d="M859.996 352.559C857.896 352.559 856.186 354.265 856.186 356.357C856.186 358.449 857.892 360.168 859.996 360.168C862.101 360.168 863.795 358.462 863.795 356.357C863.795 354.252 862.089 352.559 859.996 352.559Z"
            fill="white"
          />
          <path
            d="M851.538 359.627C849.459 359.627 847.77 361.312 847.77 363.404C847.77 365.496 849.454 367.172 851.538 367.172C853.622 367.172 855.315 365.488 855.315 363.404C855.315 361.32 853.617 359.627 851.538 359.627Z"
            fill="white"
          />
          <path
            d="M842.97 367.254C840.908 367.254 839.244 368.917 839.244 370.971C839.244 373.025 840.908 374.697 842.97 374.697C845.033 374.697 846.688 373.034 846.688 370.971C846.688 368.909 845.024 367.254 842.97 367.254Z"
            fill="white"
          />
          <path
            d="M834.279 375.414C832.25 375.414 830.604 377.061 830.604 379.089C830.604 381.118 832.25 382.773 834.279 382.773C836.307 382.773 837.954 381.118 837.954 379.089C837.954 377.061 836.307 375.414 834.279 375.414Z"
            fill="white"
          />
          <path
            d="M825.486 384.135C823.479 384.135 821.845 385.76 821.845 387.767C821.845 389.775 823.479 391.409 825.486 391.409C827.493 391.409 829.119 389.775 829.119 387.767C829.119 385.76 827.493 384.135 825.486 384.135Z"
            fill="white"
          />
          <path
            d="M816.587 393.422C814.601 393.422 812.988 395.026 812.988 397.025C812.988 399.024 814.601 400.624 816.587 400.624C818.573 400.624 820.19 399.011 820.19 397.025C820.19 395.039 818.577 393.422 816.587 393.422Z"
            fill="white"
          />
          <path
            d="M807.7 403.359C805.744 403.359 804.161 404.951 804.161 406.899C804.161 408.847 805.744 410.438 807.7 410.438C809.657 410.438 811.24 408.855 811.24 406.899C811.24 404.942 809.657 403.359 807.7 403.359Z"
            fill="white"
          />
          <path
            d="M803.547 422.439C805.399 422.002 806.547 420.146 806.109 418.294C805.672 416.442 803.816 415.295 801.964 415.732C800.112 416.169 798.965 418.025 799.402 419.877C799.839 421.729 801.695 422.877 803.547 422.439Z"
            fill="white"
          />
          <path
            d="M790.526 425.516C788.62 425.516 787.071 427.065 787.071 428.97C787.071 430.875 788.62 432.416 790.526 432.416C792.431 432.416 793.972 430.875 793.972 428.97C793.972 427.065 792.431 425.516 790.526 425.516Z"
            fill="white"
          />
          <path
            d="M778.232 436.041C776.327 436.041 774.799 437.573 774.799 439.474C774.799 441.375 776.331 442.899 778.232 442.899C780.133 442.899 781.657 441.371 781.657 439.474C781.657 437.577 780.125 436.041 778.232 436.041Z"
            fill="white"
          />
          <path
            d="M765.955 447.113C764.071 447.113 762.53 448.645 762.53 450.538C762.53 452.431 764.071 453.963 765.955 453.963C767.839 453.963 769.388 452.431 769.388 450.538C769.388 448.645 767.848 447.113 765.955 447.113Z"
            fill="white"
          />
          <path
            d="M753.767 458.678C751.875 458.678 750.334 460.218 750.334 462.111C750.334 464.004 751.875 465.536 753.767 465.536C755.66 465.536 757.192 464.004 757.192 462.111C757.192 460.218 755.66 458.678 753.767 458.678Z"
            fill="white"
          />
          <path
            d="M741.544 477.412C743.435 477.412 744.969 475.879 744.969 473.987C744.969 472.096 743.435 470.562 741.544 470.562C739.652 470.562 738.119 472.096 738.119 473.987C738.119 475.879 739.652 477.412 741.544 477.412Z"
            fill="white"
          />
          <path
            d="M729.234 482.379C727.349 482.379 725.817 483.911 725.817 485.804C725.817 487.696 727.345 489.216 729.234 489.216C731.122 489.216 732.658 487.684 732.658 485.804C732.658 483.924 731.118 482.379 729.234 482.379Z"
            fill="white"
          />
          <path
            d="M717.609 500.688C719.443 500.255 720.579 498.417 720.146 496.583C719.713 494.749 717.875 493.613 716.041 494.046C714.207 494.479 713.072 496.317 713.504 498.151C713.937 499.985 715.775 501.121 717.609 500.688Z"
            fill="white"
          />
          <path
            d="M704.241 504.865C702.357 504.865 700.829 506.393 700.829 508.281C700.829 510.17 702.357 511.693 704.241 511.693C706.125 511.693 707.653 510.174 707.653 508.281C707.653 506.389 706.121 504.865 704.241 504.865Z"
            fill="white"
          />
          <path
            d="M691.379 514.838C689.508 514.838 687.976 516.37 687.976 518.254C687.976 520.138 689.508 521.658 691.379 521.658C693.251 521.658 694.795 520.138 694.795 518.254C694.795 516.37 693.263 514.838 691.379 514.838Z"
            fill="white"
          />
          <path
            d="M678.38 523.824C676.509 523.824 674.977 525.356 674.977 527.228C674.977 529.099 676.509 530.631 678.38 530.631C680.252 530.631 681.784 529.112 681.784 527.228C681.784 525.343 680.264 523.824 678.38 523.824Z"
            fill="white"
          />
          <path
            d="M665.276 531.75C663.391 531.75 661.872 533.269 661.872 535.153C661.872 537.038 663.391 538.557 665.276 538.557C667.16 538.557 668.679 537.029 668.679 535.153C668.679 533.278 667.16 531.75 665.276 531.75Z"
            fill="white"
          />
          <path
            d="M652.039 538.576C650.168 538.576 648.648 540.108 648.648 541.98C648.648 543.851 650.168 545.37 652.039 545.37C653.911 545.37 655.443 543.851 655.443 541.98C655.443 540.108 653.923 538.576 652.039 538.576Z"
            fill="white"
          />
          <path
            d="M638.756 544.48C636.885 544.48 635.361 546 635.361 547.875C635.361 549.751 636.881 551.266 638.756 551.266C640.632 551.266 642.151 549.747 642.151 547.875C642.151 546.004 640.632 544.48 638.756 544.48Z"
            fill="white"
          />
          <path
            d="M625.507 549.654C623.635 549.654 622.116 551.174 622.116 553.049C622.116 554.925 623.635 556.44 625.507 556.44C627.378 556.44 628.898 554.921 628.898 553.049C628.898 551.178 627.378 549.654 625.507 549.654Z"
            fill="white"
          />
          <path
            d="M612.238 554.307C610.375 554.307 608.855 555.826 608.855 557.702C608.855 559.577 610.375 561.092 612.238 561.092C614.101 561.092 615.629 559.573 615.629 557.702C615.629 555.83 614.109 554.307 612.238 554.307Z"
            fill="white"
          />
          <path
            d="M598.925 558.605C597.054 558.605 595.543 560.125 595.543 561.988C595.543 563.851 597.054 565.37 598.925 565.37C600.797 565.37 602.308 563.859 602.308 561.988C602.308 560.116 600.797 558.605 598.925 558.605Z"
            fill="white"
          />
          <path
            d="M585.675 562.934C583.799 562.934 582.284 564.453 582.284 566.316C582.284 568.179 583.803 569.698 585.675 569.698C587.546 569.698 589.057 568.187 589.057 566.316C589.057 564.444 587.538 562.934 585.675 562.934Z"
            fill="white"
          />
          <path
            d="M572.512 567.396C570.649 567.396 569.139 568.907 569.139 570.77C569.139 572.633 570.649 574.153 572.512 574.153C574.375 574.153 575.895 572.642 575.895 570.77C575.895 568.899 574.384 567.396 572.512 567.396Z"
            fill="white"
          />
          <path
            d="M559.419 572.031C557.548 572.031 556.037 573.551 556.037 575.414C556.037 577.277 557.548 578.796 559.419 578.796C561.291 578.796 562.793 577.277 562.793 575.414C562.793 573.551 561.282 572.031 559.419 572.031Z"
            fill="white"
          />
          <path
            d="M546.345 576.818C544.482 576.818 542.971 578.329 542.971 580.192C542.971 582.055 544.482 583.566 546.345 583.566C548.208 583.566 549.718 582.055 549.718 580.192C549.718 578.329 548.208 576.818 546.345 576.818Z"
            fill="white"
          />
          <path
            d="M533.324 581.541C531.461 581.541 529.95 583.052 529.95 584.902C529.95 586.752 531.461 588.276 533.324 588.276C535.187 588.276 536.685 586.765 536.685 584.902C536.685 583.039 535.174 581.541 533.324 581.541Z"
            fill="white"
          />
          <path
            d="M520.297 586.236C518.434 586.236 516.923 587.747 516.923 589.61C516.923 591.473 518.434 592.971 520.297 592.971C522.16 592.971 523.67 591.46 523.67 589.61C523.67 587.76 522.16 586.236 520.297 586.236Z"
            fill="white"
          />
          <path
            d="M507.214 590.855C505.359 590.855 503.853 592.366 503.853 594.216C503.853 596.067 505.363 597.578 507.214 597.578C509.064 597.578 510.587 596.079 510.587 594.216C510.587 592.353 509.077 590.855 507.214 590.855Z"
            fill="white"
          />
          <path
            d="M494.066 595.191C492.212 595.191 490.705 596.702 490.705 598.565C490.705 600.428 492.216 601.926 494.066 601.926C495.916 601.926 497.427 600.415 497.427 598.565C497.427 596.715 495.929 595.191 494.066 595.191Z"
            fill="white"
          />
          <path
            d="M480.829 599.141C478.979 599.141 477.477 600.651 477.477 602.502C477.477 604.352 478.975 605.863 480.829 605.863C482.684 605.863 484.19 604.352 484.19 602.502C484.19 600.651 482.679 599.141 480.829 599.141Z"
            fill="white"
          />
          <path
            d="M467.454 602.693C465.599 602.693 464.093 604.191 464.093 606.054C464.093 607.917 465.604 609.407 467.454 609.407C469.304 609.407 470.806 607.909 470.806 606.054C470.806 604.2 469.308 602.693 467.454 602.693Z"
            fill="white"
          />
          <path
            d="M453.89 605.711C452.04 605.711 450.529 607.222 450.529 609.085C450.529 610.948 452.04 612.446 453.89 612.446C455.741 612.446 457.264 610.935 457.264 609.085C457.264 607.234 455.753 605.711 453.89 605.711Z"
            fill="white"
          />
          <path
            d="M440.154 607.99C438.304 607.99 436.793 609.501 436.793 611.351C436.793 613.202 438.304 614.725 440.154 614.725C442.004 614.725 443.515 613.214 443.515 611.351C443.515 609.488 442.017 607.99 440.154 607.99Z"
            fill="white"
          />
          <path
            d="M426.175 609.543C424.312 609.543 422.813 611.041 422.813 612.896C422.813 614.75 424.312 616.257 426.175 616.257C428.038 616.257 429.527 614.759 429.527 612.896C429.527 611.033 428.029 609.543 426.175 609.543Z"
            fill="white"
          />
          <path
            d="M411.856 610.268C410.001 610.268 408.503 611.778 408.503 613.629C408.503 615.479 410.001 616.99 411.856 616.99C413.71 616.99 415.217 615.479 415.217 613.629C415.217 611.778 413.719 610.268 411.856 610.268Z"
            fill="white"
          />
          <path
            d="M403.759 608.146C401.887 608.146 400.355 609.678 400.355 611.55C400.355 613.421 401.887 614.953 403.759 614.953C405.63 614.953 407.162 613.434 407.162 611.55C407.162 609.666 405.643 608.146 403.759 608.146Z"
            fill="white"
          />
          <path
            d="M395.505 605.588C393.6 605.588 392.051 607.137 392.051 609.042C392.051 610.948 393.6 612.497 395.505 612.497C397.411 612.497 398.96 610.948 398.96 609.042C398.96 607.137 397.411 605.588 395.505 605.588Z"
            fill="white"
          />
          <path
            d="M387.135 602.6C385.187 602.6 383.617 604.183 383.617 606.118C383.617 608.053 385.187 609.623 387.135 609.623C389.083 609.623 390.641 608.053 390.641 606.118C390.641 604.183 389.07 602.6 387.135 602.6Z"
            fill="white"
          />
          <path
            d="M378.674 599.162C376.709 599.162 375.113 600.754 375.113 602.723C375.113 604.692 376.705 606.283 378.674 606.283C380.643 606.283 382.222 604.692 382.222 602.723C382.222 600.754 380.63 599.162 378.674 599.162Z"
            fill="white"
          />
          <path
            d="M370.153 595.219C368.167 595.219 366.55 596.823 366.55 598.809C366.55 600.795 368.162 602.412 370.153 602.412C372.143 602.412 373.756 600.799 373.756 598.809C373.756 596.819 372.143 595.219 370.153 595.219Z"
            fill="white"
          />
          <path
            d="M361.606 590.734C359.599 590.734 357.974 592.36 357.974 594.354C357.974 596.349 359.599 597.987 361.606 597.987C363.614 597.987 365.239 596.366 365.239 594.354C365.239 592.343 363.614 590.734 361.606 590.734Z"
            fill="white"
          />
          <path
            d="M353.071 585.605C351.043 585.605 349.388 587.252 349.388 589.289C349.388 591.326 351.043 592.973 353.071 592.973C355.1 592.973 356.755 591.326 356.755 589.289C356.755 587.252 355.113 585.605 353.071 585.605Z"
            fill="white"
          />
          <path
            d="M344.6 579.785C342.551 579.785 340.883 581.449 340.883 583.503C340.883 585.557 342.546 587.229 344.6 587.229C346.654 587.229 348.326 585.565 348.326 583.503C348.326 581.44 346.663 579.785 344.6 579.785Z"
            fill="white"
          />
          <path
            d="M336.254 573.174C334.183 573.174 332.507 574.85 332.507 576.921C332.507 578.992 334.183 580.668 336.254 580.668C338.325 580.668 340.001 578.992 340.001 576.921C340.001 574.85 338.325 573.174 336.254 573.174Z"
            fill="white"
          />
          <path
            d="M328.08 565.67C325.996 565.67 324.303 567.367 324.303 569.447C324.303 571.526 326 573.224 328.08 573.224C330.159 573.224 331.857 571.539 331.857 569.447C331.857 567.355 330.172 565.67 328.08 565.67Z"
            fill="white"
          />
          <path
            d="M320.161 557.188C318.061 557.188 316.342 558.893 316.342 561.007C316.342 563.12 318.061 564.826 320.161 564.826C322.262 564.826 323.981 563.108 323.981 561.007C323.981 558.906 322.275 557.188 320.161 557.188Z"
            fill="white"
          />
          <path
            d="M312.53 547.699C310.395 547.699 308.681 549.426 308.681 551.548C308.681 553.67 310.399 555.41 312.53 555.41C314.66 555.41 316.379 553.683 316.379 551.548C316.379 549.414 314.652 547.699 312.53 547.699Z"
            fill="white"
          />
          <path
            d="M305.228 537.174C303.093 537.174 301.357 538.914 301.357 541.057C301.357 543.2 303.097 544.94 305.228 544.94C307.358 544.94 309.111 543.2 309.111 541.057C309.111 538.914 307.371 537.174 305.228 537.174Z"
            fill="white"
          />
          <path
            d="M298.264 525.758C296.108 525.758 294.359 527.506 294.359 529.671C294.359 531.835 296.108 533.575 298.264 533.575C300.419 533.575 302.168 531.826 302.168 529.671C302.168 527.515 300.419 525.758 298.264 525.758Z"
            fill="white"
          />
          <path
            d="M291.541 513.691C289.377 513.691 287.607 515.453 287.607 517.625C287.607 519.798 289.377 521.551 291.541 521.551C293.706 521.551 295.475 519.79 295.475 517.625C295.475 515.461 293.718 513.691 291.541 513.691Z"
            fill="white"
          />
          <path
            d="M284.942 501.225C282.757 501.225 280.979 503.003 280.979 505.188C280.979 507.374 282.757 509.143 284.942 509.143C287.128 509.143 288.897 507.374 288.897 505.188C288.897 503.003 287.128 501.225 284.942 501.225Z"
            fill="white"
          />
          <path
            d="M281.399 495.091C282.786 493.388 282.53 490.884 280.827 489.497C279.124 488.11 276.62 488.366 275.233 490.069C273.846 491.772 274.102 494.277 275.805 495.663C277.508 497.05 280.012 496.794 281.399 495.091Z"
            fill="white"
          />
          <path
            d="M271.515 476.111C269.308 476.111 267.518 477.902 267.518 480.109C267.518 482.316 269.308 484.115 271.515 484.115C273.722 484.115 275.521 482.324 275.521 480.109C275.521 477.894 273.73 476.111 271.515 476.111Z"
            fill="white"
          />
          <path
            d="M264.47 471.854C266.69 471.854 268.489 470.055 268.489 467.835C268.489 465.616 266.69 463.816 264.47 463.816C262.25 463.816 260.451 465.616 260.451 467.835C260.451 470.055 262.25 471.854 264.47 471.854Z"
            fill="white"
          />
          <path
            d="M257.163 451.705C254.935 451.705 253.123 453.504 253.123 455.732C253.123 457.96 254.935 459.772 257.163 459.772C259.391 459.772 261.19 457.96 261.19 455.732C261.19 453.504 259.391 451.705 257.163 451.705Z"
            fill="white"
          />
          <path
            d="M249.604 439.797C247.368 439.797 245.556 441.609 245.556 443.837C245.556 446.065 247.368 447.885 249.604 447.885C251.841 447.885 253.644 446.073 253.644 443.837C253.644 441.6 251.832 439.797 249.604 439.797Z"
            fill="white"
          />
          <path
            d="M241.831 428.045C239.594 428.045 237.782 429.857 237.782 432.093C237.782 434.33 239.594 436.15 241.831 436.15C244.067 436.15 245.879 434.33 245.879 432.093C245.879 429.857 244.067 428.045 241.831 428.045Z"
            fill="white"
          />
          <path
            d="M233.932 416.318C231.696 416.318 229.875 418.139 229.875 420.388C229.875 422.637 231.696 424.458 233.932 424.458C236.168 424.458 238.002 422.637 238.002 420.388C238.002 418.139 236.181 416.318 233.932 416.318Z"
            fill="white"
          />
          <path
            d="M226.001 404.484C223.752 404.484 221.923 406.305 221.923 408.554C221.923 410.803 223.756 412.632 226.001 412.632C228.246 412.632 230.079 410.812 230.079 408.554C230.079 406.296 228.259 404.484 226.001 404.484Z"
            fill="white"
          />
          <path
            d="M218.133 392.316C215.884 392.316 214.063 394.137 214.063 396.386C214.063 398.635 215.884 400.464 218.133 400.464C220.382 400.464 222.211 398.644 222.211 396.386C222.211 394.128 220.391 392.316 218.133 392.316Z"
            fill="white"
          />
          <path
            d="M210.337 379.922C208.079 379.922 206.246 381.755 206.246 384.013C206.246 386.271 208.079 388.104 210.337 388.104C212.595 388.104 214.428 386.271 214.428 384.013C214.428 381.755 212.595 379.922 210.337 379.922Z"
            fill="white"
          />
          <path
            d="M202.606 367.484C200.348 367.484 198.515 369.318 198.515 371.575C198.515 373.833 200.348 375.666 202.606 375.666C204.863 375.666 206.684 373.833 206.684 371.575C206.684 369.318 204.863 367.484 202.606 367.484Z"
            fill="white"
          />
          <path
            d="M194.945 355.066C192.688 355.066 190.854 356.9 190.854 359.157C190.854 361.415 192.688 363.236 194.945 363.236C197.203 363.236 199.024 361.415 199.024 359.157C199.024 356.9 197.203 355.066 194.945 355.066Z"
            fill="white"
          />
          <path
            d="M187.344 342.818C185.095 342.818 183.266 344.639 183.266 346.897C183.266 349.154 185.099 350.975 187.344 350.975C189.589 350.975 191.422 349.142 191.422 346.897C191.422 344.652 189.602 342.818 187.344 342.818Z"
            fill="white"
          />
          <path
            d="M179.79 330.961C177.532 330.961 175.712 332.794 175.712 335.039C175.712 337.284 177.532 339.117 179.79 339.117C182.048 339.117 183.868 337.297 183.868 335.039C183.868 332.781 182.035 330.961 179.79 330.961Z"
            fill="white"
          />
          <path
            d="M187.127 322.856C189.375 322.856 191.197 321.034 191.197 318.787C191.197 316.539 189.375 314.717 187.127 314.717C184.88 314.717 183.058 316.539 183.058 318.787C183.058 321.034 184.88 322.856 187.127 322.856Z"
            fill="white"
          />
          <path
            d="M194.537 299.727C192.301 299.727 190.48 301.547 190.48 303.788C190.48 306.029 192.301 307.858 194.537 307.858C196.774 307.858 198.607 306.037 198.607 303.788C198.607 301.539 196.787 299.727 194.537 299.727Z"
            fill="white"
          />
          <path
            d="M202.083 286.135C199.847 286.135 198.026 287.947 198.026 290.183C198.026 292.42 199.847 294.232 202.083 294.232C204.32 294.232 206.132 292.42 206.132 290.183C206.132 287.947 204.32 286.135 202.083 286.135Z"
            fill="white"
          />
          <path
            d="M209.68 274.039C207.443 274.039 205.64 275.851 205.64 278.079C205.64 280.307 207.439 282.119 209.68 282.119C211.92 282.119 213.72 280.307 213.72 278.079C213.72 275.851 211.908 274.039 209.68 274.039Z"
            fill="white"
          />
          <path
            d="M217.216 263.398C215.001 263.398 213.197 265.198 213.197 267.426C213.197 269.654 214.997 271.445 217.216 271.445C219.436 271.445 221.235 269.645 221.235 267.426C221.235 265.206 219.436 263.398 217.216 263.398Z"
            fill="white"
          />
          <path
            d="M224.588 253.977C222.373 253.977 220.569 255.767 220.569 257.983C220.569 260.198 222.369 262.002 224.588 262.002C226.808 262.002 228.594 260.202 228.594 257.983C228.594 255.763 226.795 253.977 224.588 253.977Z"
            fill="white"
          />
          <path
            d="M231.663 245.506C229.456 245.506 227.678 247.297 227.678 249.503C227.678 251.71 229.456 253.488 231.663 253.488C233.869 253.488 235.66 251.71 235.66 249.503C235.66 247.297 233.869 245.506 231.663 245.506Z"
            fill="white"
          />
          <path
            d="M238.376 237.768C236.182 237.768 234.399 239.546 234.399 241.744C234.399 243.942 236.178 245.72 238.376 245.72C240.574 245.72 242.361 243.942 242.361 241.744C242.361 239.546 240.57 237.768 238.376 237.768Z"
            fill="white"
          />
          <path
            d="M244.661 230.588C242.475 230.588 240.714 232.358 240.714 234.535C240.714 236.712 242.471 238.49 244.661 238.49C246.85 238.49 248.603 236.72 248.603 234.535C248.603 232.349 246.833 230.588 244.661 230.588Z"
            fill="white"
          />
          <path
            d="M250.512 223.895C248.357 223.895 246.6 225.643 246.6 227.807C246.6 229.972 248.361 231.72 250.512 231.72C252.664 231.72 254.438 229.972 254.438 227.807C254.438 225.643 252.681 223.895 250.512 223.895Z"
            fill="white"
          />
          <path
            d="M255.944 217.926C253.788 217.926 252.053 219.666 252.053 221.817C252.053 223.969 253.793 225.722 255.944 225.722C258.096 225.722 259.849 223.973 259.849 221.817C259.849 219.661 258.1 217.926 255.944 217.926Z"
            fill="white"
          />
          <path
            d="M260.932 212.76C258.797 212.76 257.062 214.5 257.062 216.643C257.062 218.786 258.801 220.513 260.932 220.513C263.062 220.513 264.815 218.773 264.815 216.643C264.815 214.512 263.075 212.76 260.932 212.76Z"
            fill="white"
          />
          <path
            d="M265.425 208.297C263.311 208.297 261.597 210.016 261.597 212.129C261.597 214.242 263.315 215.957 265.425 215.957C267.534 215.957 269.257 214.251 269.257 212.129C269.257 210.007 267.551 208.297 265.425 208.297Z"
            fill="white"
          />
          <path
            d="M269.414 204.326C267.322 204.326 265.616 206.024 265.616 208.116C265.616 210.208 267.322 211.914 269.414 211.914C271.507 211.914 273.213 210.216 273.213 208.116C273.213 206.015 271.515 204.326 269.414 204.326Z"
            fill="white"
          />
          <path
            d="M272.889 200.707C270.797 200.707 269.112 202.392 269.112 204.475C269.112 206.559 270.797 208.252 272.889 208.252C274.981 208.252 276.658 206.555 276.658 204.475C276.658 202.396 274.973 200.707 272.889 200.707Z"
            fill="white"
          />
          <path
            d="M275.845 197.375C273.782 197.375 272.11 199.039 272.11 201.109C272.11 203.18 273.787 204.844 275.845 204.844C277.903 204.844 279.579 203.168 279.579 201.109C279.579 199.051 277.903 197.375 275.845 197.375Z"
            fill="white"
          />
          <path
            d="M278.322 194.262C276.281 194.262 274.626 195.913 274.626 197.95C274.626 199.987 276.281 201.646 278.322 201.646C280.364 201.646 282.019 199.991 282.019 197.95C282.019 195.908 280.364 194.262 278.322 194.262Z"
            fill="white"
          />
          <path
            d="M280.33 191.295C278.31 191.295 276.676 192.933 276.676 194.953C276.676 196.973 278.31 198.615 280.33 198.615C282.35 198.615 283.992 196.969 283.992 194.953C283.992 192.937 282.358 191.295 280.33 191.295Z"
            fill="white"
          />
          <path
            d="M281.912 188.469C279.913 188.469 278.301 190.081 278.301 192.08C278.301 194.079 279.913 195.692 281.912 195.692C283.911 195.692 285.532 194.079 285.532 192.08C285.532 190.081 283.907 188.469 281.912 188.469Z"
            fill="white"
          />
          <path
            d="M283.122 185.732C281.144 185.732 279.553 187.337 279.553 189.301C279.553 191.266 281.144 192.875 283.122 192.875C285.099 192.875 286.691 191.279 286.691 189.301C286.691 187.324 285.087 185.732 283.122 185.732Z"
            fill="white"
          />
          <path
            d="M283.992 183.082C282.044 183.082 280.474 184.661 280.474 186.596C280.474 188.531 282.044 190.114 283.992 190.114C285.94 190.114 287.497 188.544 287.497 186.596C287.497 184.648 285.927 183.082 283.992 183.082Z"
            fill="white"
          />
          <path
            d="M284.577 180.449C282.663 180.449 281.102 182.007 281.102 183.921C281.102 185.835 282.663 187.388 284.577 187.388C286.491 187.388 288.044 185.839 288.044 183.921C288.044 182.002 286.495 180.449 284.577 180.449Z"
            fill="white"
          />
          <path
            d="M284.921 177.791C283.029 177.791 281.488 179.323 281.488 181.216C281.488 183.108 283.029 184.64 284.921 184.64C286.814 184.64 288.346 183.108 288.346 181.216C288.346 179.323 286.806 177.791 284.921 177.791Z"
            fill="white"
          />
          <path
            d="M285.057 175.033C283.186 175.033 281.675 176.552 281.675 178.415C281.675 180.278 283.186 181.798 285.057 181.798C286.929 181.798 288.439 180.287 288.439 178.415C288.439 176.544 286.92 175.033 285.057 175.033Z"
            fill="white"
          />
          <path
            d="M285.044 172.139C283.223 172.139 281.742 173.616 281.742 175.445C281.742 177.274 283.219 178.75 285.044 178.75C286.869 178.75 288.354 177.274 288.354 175.445C288.354 173.616 286.877 172.139 285.044 172.139Z"
            fill="white"
          />
          <path
            d="M284.994 168.943C283.194 168.943 281.734 170.399 281.734 172.194C281.734 173.989 283.19 175.445 284.994 175.445C286.797 175.445 288.24 173.989 288.24 172.194C288.24 170.399 286.784 168.943 284.994 168.943Z"
            fill="white"
          />
          <path
            d="M285.015 165.318C283.245 165.318 281.811 166.753 281.811 168.522C281.811 170.292 283.245 171.739 285.015 171.739C286.784 171.739 288.219 170.296 288.219 168.522C288.219 166.748 286.784 165.318 285.015 165.318Z"
            fill="white"
          />
          <path
            d="M285.324 161.098C283.589 161.098 282.18 162.507 282.18 164.251C282.18 165.995 283.584 167.395 285.324 167.395C287.064 167.395 288.477 165.991 288.477 164.251C288.477 162.511 287.06 161.098 285.324 161.098Z"
            fill="white"
          />
          <path
            d="M286.282 155.949C284.585 155.949 283.21 157.328 283.21 159.026C283.21 160.723 284.585 162.098 286.282 162.098C287.98 162.098 289.355 160.723 289.355 159.026C289.355 157.328 287.98 155.949 286.282 155.949Z"
            fill="white"
          />
          <path
            d="M288.482 149.303C286.819 149.303 285.465 150.656 285.465 152.316C285.465 153.975 286.819 155.329 288.482 155.329C290.146 155.329 291.491 153.975 291.491 152.316C291.491 150.656 290.15 149.303 288.482 149.303Z"
            fill="white"
          />
          <path
            d="M303.457 145.148C301.802 145.148 300.448 146.498 300.448 148.157C300.448 149.817 301.802 151.166 303.457 151.166C305.112 151.166 306.466 149.825 306.466 148.157C306.466 146.489 305.125 145.148 303.457 145.148Z"
            fill="white"
          />
          <path
            d="M320.162 138.664C318.498 138.664 317.145 140.018 317.145 141.681C317.145 143.345 318.498 144.699 320.162 144.699C321.825 144.699 323.171 143.345 323.171 141.681C323.171 140.018 321.83 138.664 320.162 138.664Z"
            fill="white"
          />
          <path
            d="M339.029 129.332C337.365 129.332 336.012 130.686 336.012 132.354C336.012 134.021 337.365 135.375 339.029 135.375C340.693 135.375 342.046 134.021 342.046 132.354C342.046 130.686 340.693 129.332 339.029 129.332Z"
            fill="white"
          />
          <path
            d="M360.418 122.783C362.084 122.783 363.435 121.432 363.435 119.765C363.435 118.099 362.084 116.748 360.418 116.748C358.751 116.748 357.4 118.099 357.4 119.765C357.4 121.432 358.751 122.783 360.418 122.783Z"
            fill="white"
          />
          <path
            d="M384.421 100.738C382.757 100.738 381.403 102.092 381.403 103.756C381.403 105.419 382.757 106.786 384.421 106.786C386.084 106.786 387.451 105.432 387.451 103.756C387.451 102.079 386.097 100.738 384.421 100.738Z"
            fill="white"
          />
          <path
            d="M410.532 81.3887C408.868 81.3887 407.502 82.7424 407.502 84.4187C407.502 86.095 408.864 87.4488 410.532 87.4488C412.2 87.4488 413.562 86.095 413.562 84.4187C413.562 82.7424 412.208 81.3887 410.532 81.3887Z"
            fill="white"
          />
          <path
            d="M437.564 59.4414C435.888 59.4414 434.534 60.7952 434.534 62.4714C434.534 64.1477 435.888 65.5015 437.564 65.5015C439.24 65.5015 440.594 64.1435 440.594 62.4714C440.594 60.7994 439.232 59.4414 437.564 59.4414Z"
            fill="white"
          />
          <path
            d="M464.028 36.5098C462.352 36.5098 460.998 37.8678 460.998 39.544C460.998 41.2203 462.352 42.5741 464.028 42.5741C465.704 42.5741 467.067 41.2203 467.067 39.544C467.067 37.8678 465.704 36.5098 464.028 36.5098Z"
            fill="white"
          />
          <path
            d="M488.863 20.9716C490.541 20.9716 491.901 19.6112 491.901 17.9331C491.901 16.2549 490.541 14.8945 488.863 14.8945C487.185 14.8945 485.824 16.2549 485.824 17.9331C485.824 19.6112 487.185 20.9716 488.863 20.9716Z"
            fill="white"
          />
          <path
            d="M511.572 -4.33789C509.895 -4.33789 508.533 -2.97565 508.533 -1.29937C508.533 0.376915 509.895 1.7434 511.572 1.7434C513.248 1.7434 514.619 0.385403 514.619 -1.29937C514.619 -2.98413 513.256 -4.33789 511.572 -4.33789Z"
            fill="white"
          />
          <path
            d="M831.045 0.197266C829.203 0.197266 827.705 1.69107 827.705 3.53285C827.705 5.37464 829.203 6.86844 831.045 6.86844C832.887 6.86844 834.376 5.37464 834.376 3.53285C834.376 1.69107 832.887 0.197266 831.045 0.197266Z"
            fill="white"
          />
          <path
            d="M837.839 11.8574C835.968 11.8574 834.457 13.3682 834.457 15.2397C834.457 17.1112 835.968 18.622 837.839 18.622C839.711 18.622 841.222 17.1069 841.222 15.2397C841.222 13.3724 839.711 11.8574 837.839 11.8574Z"
            fill="white"
          />
          <path
            d="M844.408 24.377C842.515 24.377 840.975 25.9174 840.975 27.8101C840.975 29.7029 842.515 31.2433 844.408 31.2433C846.301 31.2433 847.841 29.7029 847.841 27.8101C847.841 25.9174 846.301 24.377 844.408 24.377Z"
            fill="white"
          />
          <path
            d="M851.527 44.7602C853.411 44.3155 854.578 42.4275 854.133 40.5434C853.689 38.6592 851.801 37.4923 849.916 37.937C848.032 38.3817 846.865 40.2696 847.31 42.1538C847.755 44.038 849.643 45.2049 851.527 44.7602Z"
            fill="white"
          />
          <path
            d="M856.74 52.2188C854.775 52.2188 853.18 53.8059 853.18 55.7665C853.18 57.7271 854.771 59.327 856.74 59.327C858.709 59.327 860.288 57.7356 860.288 55.7665C860.288 53.7974 858.697 52.2188 856.74 52.2188Z"
            fill="white"
          />
          <path
            d="M862.431 67.6035C860.445 67.6035 858.828 69.2161 858.828 71.2107C858.828 73.2053 860.441 74.8094 862.431 74.8094C864.421 74.8094 866.03 73.1968 866.03 71.2107C866.03 69.2246 864.417 67.6035 862.431 67.6035Z"
            fill="white"
          />
          <path
            d="M867.847 83.8516C865.827 83.8516 864.193 85.4854 864.193 87.5012C864.193 89.517 865.827 91.1551 867.847 91.1551C869.867 91.1551 871.488 89.5212 871.488 87.5012C871.488 85.4812 869.855 83.8516 867.847 83.8516Z"
            fill="white"
          />
          <path
            d="M873.05 100.75C871.009 100.75 869.354 102.405 869.354 104.446C869.354 106.488 871.009 108.143 873.05 108.143C875.091 108.143 876.746 106.488 876.746 104.446C876.746 102.405 875.091 100.75 873.05 100.75Z"
            fill="white"
          />
          <path
            d="M878.223 117.869C876.16 117.869 874.488 119.545 874.488 121.616C874.488 123.687 876.165 125.351 878.223 125.351C880.281 125.351 881.97 123.675 881.97 121.616C881.97 119.558 880.294 117.869 878.223 117.869Z"
            fill="white"
          />
          <path
            d="M883.54 134.723C881.46 134.723 879.763 136.407 879.763 138.5C879.763 140.592 881.46 142.277 883.54 142.277C885.619 142.277 887.316 140.579 887.316 138.5C887.316 136.42 885.632 134.723 883.54 134.723Z"
            fill="white"
          />
          <path
            d="M889.159 158.462C891.269 158.462 892.979 156.75 892.979 154.638C892.979 152.526 891.269 150.814 889.159 150.814C887.05 150.814 885.34 152.526 885.34 154.638C885.34 156.75 887.05 158.462 889.159 158.462Z"
            fill="white"
          />
          <path
            d="M895.168 165.883C893.033 165.883 891.298 167.619 891.298 169.753C891.298 171.888 893.033 173.623 895.168 173.623C897.303 173.623 899.038 171.896 899.038 169.753C899.038 167.61 897.311 165.883 895.168 165.883Z"
            fill="white"
          />
          <path
            d="M901.576 179.955C899.42 179.955 897.672 181.699 897.672 183.851C897.672 186.002 899.42 187.751 901.576 187.751C903.732 187.751 905.48 186.007 905.48 183.851C905.48 181.695 903.732 179.955 901.576 179.955Z"
            fill="white"
          />
          <path
            d="M908.396 193.047C906.219 193.047 904.462 194.808 904.462 196.977C904.462 199.145 906.219 200.906 908.396 200.906C910.573 200.906 912.33 199.145 912.33 196.977C912.33 194.808 910.56 193.047 908.396 193.047Z"
            fill="white"
          />
          <path
            d="M915.598 205.193C913.413 205.193 911.635 206.971 911.635 209.157C911.635 211.343 913.413 213.121 915.598 213.121C917.784 213.121 919.562 211.351 919.562 209.157C919.562 206.963 917.792 205.193 915.598 205.193Z"
            fill="white"
          />
          <path
            d="M923.172 224.368C925.38 224.368 927.17 222.578 927.17 220.371C927.17 218.163 925.38 216.373 923.172 216.373C920.965 216.373 919.175 218.163 919.175 220.371C919.175 222.578 920.965 224.368 923.172 224.368Z"
            fill="white"
          />
          <path
            d="M931.117 226.57C928.889 226.57 927.09 228.382 927.09 230.598C927.09 232.813 928.889 234.625 931.117 234.625C933.345 234.625 935.144 232.826 935.144 230.598C935.144 228.37 933.332 226.57 931.117 226.57Z"
            fill="white"
          />
          <path
            d="M939.367 235.848C937.13 235.848 935.318 237.66 935.318 239.896C935.318 242.133 937.13 243.945 939.367 243.945C941.603 243.945 943.407 242.133 943.407 239.896C943.407 237.66 941.595 235.848 939.367 235.848Z"
            fill="white"
          />
          <path
            d="M947.901 244.195C945.644 244.195 943.823 246.016 943.823 248.265C943.823 250.514 945.644 252.343 947.901 252.343C950.159 252.343 951.971 250.51 951.971 248.265C951.971 246.02 950.151 244.195 947.901 244.195Z"
            fill="white"
          />
          <path
            d="M956.664 251.625C954.394 251.625 952.564 253.458 952.564 255.724C952.564 257.991 954.398 259.824 956.664 259.824C958.93 259.824 960.763 257.991 960.763 255.724C960.763 253.458 958.93 251.625 956.664 251.625Z"
            fill="white"
          />
          <path
            d="M965.619 258.16C963.34 258.16 961.498 260.002 961.498 262.281C961.498 264.56 963.34 266.402 965.619 266.402C967.898 266.402 969.739 264.551 969.739 262.281C969.739 260.01 967.898 258.16 965.619 258.16Z"
            fill="white"
          />
          <path
            d="M974.692 263.811C972.413 263.811 970.559 265.665 970.559 267.944C970.559 270.223 972.409 272.086 974.692 272.086C976.975 272.086 978.834 270.236 978.834 267.944C978.834 265.652 976.979 263.811 974.692 263.811Z"
            fill="white"
          />
          <path
            d="M983.841 268.607C981.55 268.607 979.687 270.47 979.687 272.762C979.687 275.054 981.55 276.917 983.841 276.917C986.133 276.917 987.996 275.062 987.996 272.762C987.996 270.462 986.133 268.607 983.841 268.607Z"
            fill="white"
          />
          <path
            d="M992.999 272.656C990.708 272.656 988.845 274.507 988.845 276.811C988.845 279.115 990.708 280.966 992.999 280.966C995.291 280.966 997.154 279.103 997.154 276.811C997.154 274.519 995.291 272.656 992.999 272.656Z"
            fill="white"
          />
          <path
            d="M1002.13 276.008C999.827 276.008 997.964 277.858 997.964 280.162C997.964 282.467 999.827 284.317 1002.13 284.317C1004.43 284.317 1006.28 282.454 1006.28 280.162C1006.28 277.871 1004.42 276.008 1002.13 276.008Z"
            fill="white"
          />
          <path
            d="M1011.17 278.754C1008.87 278.754 1007.02 280.608 1007.02 282.909C1007.02 285.209 1008.87 287.063 1011.17 287.063C1013.48 287.063 1015.33 285.2 1015.33 282.909C1015.33 280.617 1013.46 278.754 1011.17 278.754Z"
            fill="white"
          />
          <path
            d="M1020.11 280.975C1017.81 280.975 1015.96 282.838 1015.96 285.129C1015.96 287.421 1017.81 289.284 1020.11 289.284C1022.41 289.284 1024.27 287.421 1024.27 285.129C1024.27 282.838 1022.4 280.975 1020.11 280.975Z"
            fill="white"
          />
          <path
            d="M1028.92 282.766C1026.63 282.766 1024.76 284.629 1024.76 286.916C1024.76 289.203 1026.63 291.071 1028.92 291.071C1031.21 291.071 1033.07 289.22 1033.07 286.916C1033.07 284.612 1031.21 282.766 1028.92 282.766Z"
            fill="white"
          />
          <path
            d="M1023.9 284.211C1021.61 284.211 1019.75 286.065 1019.75 288.366C1019.75 290.666 1021.61 292.52 1023.9 292.52C1026.19 292.52 1028.06 290.657 1028.06 288.366C1028.06 286.074 1026.19 284.211 1023.9 284.211Z"
            fill="white"
          />
          <path
            d="M1018.7 285.625C1016.41 285.625 1014.54 287.488 1014.54 289.78C1014.54 292.071 1016.41 293.943 1018.7 293.943C1020.99 293.943 1022.86 292.08 1022.86 289.78C1022.86 287.48 1021 285.625 1018.7 285.625Z"
            fill="white"
          />
          <path
            d="M1013.31 287.043C1011.01 287.043 1009.15 288.906 1009.15 291.198C1009.15 293.489 1011.01 295.352 1013.31 295.352C1015.6 295.352 1017.46 293.498 1017.46 291.198C1017.46 288.897 1015.59 287.043 1013.31 287.043Z"
            fill="white"
          />
          <path
            d="M1007.7 288.479C1005.4 288.479 1003.54 290.333 1003.54 292.633C1003.54 294.933 1005.4 296.788 1007.7 296.788C1009.99 296.788 1011.85 294.925 1011.85 292.633C1011.85 290.342 1010 288.479 1007.7 288.479Z"
            fill="white"
          />
          <path
            d="M1001.87 289.945C999.577 289.945 997.714 291.808 997.714 294.1C997.714 296.392 999.577 298.255 1001.87 298.255C1004.16 298.255 1006.02 296.392 1006.02 294.1C1006.02 291.808 1004.17 289.945 1001.87 289.945Z"
            fill="white"
          />
          <path
            d="M995.809 291.486C993.521 291.486 991.658 293.349 991.658 295.641C991.658 297.933 993.521 299.796 995.809 299.796C998.096 299.796 999.963 297.933 999.963 295.641C999.963 293.349 998.113 291.486 995.809 291.486Z"
            fill="white"
          />
          <path
            d="M989.524 293.119C987.224 293.119 985.369 294.982 985.369 297.274C985.369 299.565 987.219 301.428 989.524 301.428C991.828 301.428 993.678 299.565 993.678 297.274C993.678 294.982 991.815 293.119 989.524 293.119Z"
            fill="white"
          />
          <path
            d="M982.989 294.877C980.697 294.877 978.834 296.74 978.834 299.032C978.834 301.323 980.697 303.186 982.989 303.186C985.28 303.186 987.143 301.323 987.143 299.032C987.143 296.74 985.289 294.877 982.989 294.877Z"
            fill="white"
          />
          <path
            d="M976.211 296.803C973.92 296.803 972.057 298.657 972.057 300.945C972.057 303.232 973.92 305.099 976.211 305.099C978.503 305.099 980.353 303.236 980.353 300.945C980.353 298.653 978.499 296.803 976.211 296.803Z"
            fill="white"
          />
          <path
            d="M969.187 298.916C966.895 298.916 965.045 300.771 965.045 303.049C965.045 305.328 966.899 307.191 969.187 307.191C971.474 307.191 973.32 305.341 973.32 303.049C973.32 300.758 971.47 298.916 969.187 298.916Z"
            fill="white"
          />
          <path
            d="M961.914 301.26C959.635 301.26 957.793 303.102 957.793 305.38C957.793 307.659 959.635 309.493 961.914 309.493C964.193 309.493 966.034 307.651 966.034 305.38C966.034 303.11 964.18 301.26 961.914 301.26Z"
            fill="white"
          />
          <path
            d="M954.398 303.854C952.128 303.854 950.299 305.687 950.299 307.953C950.299 310.219 952.132 312.052 954.398 312.052C956.664 312.052 958.498 310.211 958.498 307.953C958.498 305.695 956.664 303.854 954.398 303.854Z"
            fill="white"
          />
          <path
            d="M946.666 306.713C944.408 306.713 942.588 308.533 942.588 310.791C942.588 313.049 944.408 314.869 946.666 314.869C948.924 314.869 950.744 313.036 950.744 310.791C950.744 308.546 948.911 306.713 946.666 306.713Z"
            fill="white"
          />
          <path
            d="M938.734 309.846C936.497 309.846 934.677 311.666 934.677 313.903C934.677 316.139 936.497 317.972 938.734 317.972C940.97 317.972 942.803 316.152 942.803 313.903C942.803 311.654 940.983 309.846 938.734 309.846Z"
            fill="white"
          />
          <path
            d="M930.666 313.289C928.438 313.289 926.639 315.088 926.639 317.316C926.639 319.544 928.438 321.344 930.666 321.344C932.894 321.344 934.706 319.544 934.706 317.316C934.706 315.088 932.894 313.289 930.666 313.289Z"
            fill="white"
          />
          <path
            d="M922.519 324.997C924.727 324.997 926.517 323.207 926.517 321C926.517 318.792 924.727 317.002 922.519 317.002C920.311 317.002 918.521 318.792 918.521 321C918.521 323.207 920.311 324.997 922.519 324.997Z"
            fill="white"
          />
          <path
            d="M914.337 320.971C912.143 320.971 910.373 322.749 910.373 324.934C910.373 327.12 912.143 328.911 914.337 328.911C916.531 328.911 918.3 327.133 918.3 324.934C918.3 322.736 916.531 320.971 914.337 320.971Z"
            fill="white"
          />
          <path
            d="M906.146 325.186C903.969 325.186 902.199 326.947 902.199 329.119C902.199 331.292 903.969 333.062 906.146 333.062C908.323 333.062 910.088 331.292 910.088 329.119C910.088 326.947 908.319 325.186 906.146 325.186Z"
            fill="white"
          />
          <path
            d="M897.872 329.799C895.707 329.799 893.946 331.56 893.946 333.724C893.946 335.889 895.707 337.65 897.872 337.65C900.036 337.65 901.797 335.889 901.797 333.724C901.797 331.56 900.036 329.799 897.872 329.799Z"
            fill="white"
          />
          <path
            d="M889.515 334.91C887.38 334.91 885.645 336.65 885.645 338.793C885.645 340.936 887.385 342.663 889.515 342.663C891.645 342.663 893.398 340.924 893.398 338.793C893.398 336.663 891.658 334.91 889.515 334.91Z"
            fill="white"
          />
          <path
            d="M881.095 340.484C878.974 340.484 877.255 342.212 877.255 344.333C877.255 346.455 878.974 348.174 881.095 348.174C883.217 348.174 884.945 346.455 884.945 344.333C884.945 342.212 883.226 340.484 881.095 340.484Z"
            fill="white"
          />
          <path
            d="M872.621 346.588C870.521 346.588 868.811 348.294 868.811 350.399C868.811 352.504 870.517 354.21 872.621 354.21C874.726 354.21 876.432 352.504 876.432 350.399C876.432 348.294 874.726 346.588 872.621 346.588Z"
            fill="white"
          />
          <path
            d="M864.079 353.203C861.999 353.203 860.302 354.888 860.302 356.98C860.302 359.072 861.999 360.749 864.079 360.749C866.158 360.749 867.856 359.064 867.856 356.98C867.856 354.896 866.158 353.203 864.079 353.203Z"
            fill="white"
          />
          <path
            d="M855.472 360.396C853.41 360.396 851.746 362.073 851.746 364.123C851.746 366.172 853.41 367.849 855.472 367.849C857.535 367.849 859.198 366.185 859.198 364.123C859.198 362.06 857.535 360.396 855.472 360.396Z"
            fill="white"
          />
          <path
            d="M846.768 368.127C844.739 368.127 843.084 369.774 843.084 371.802C843.084 373.831 844.739 375.486 846.768 375.486C848.796 375.486 850.451 373.839 850.451 371.802C850.451 369.765 848.796 368.127 846.768 368.127Z"
            fill="white"
          />
          <path
            d="M837.997 376.416C835.977 376.416 834.343 378.05 834.343 380.057C834.343 382.064 835.977 383.711 837.997 383.711C840.017 383.711 841.638 382.077 841.638 380.057C841.638 378.037 840.004 376.416 837.997 376.416Z"
            fill="white"
          />
          <path
            d="M829.139 385.262C827.14 385.262 825.536 386.874 825.536 388.865C825.536 390.855 827.14 392.468 829.139 392.468C831.138 392.468 832.742 390.855 832.742 388.865C832.742 386.874 831.129 385.262 829.139 385.262Z"
            fill="white"
          />
          <path
            d="M820.228 394.67C818.271 394.67 816.688 396.261 816.688 398.218C816.688 400.174 818.271 401.757 820.228 401.757C822.184 401.757 823.776 400.174 823.776 398.218C823.776 396.261 822.184 394.67 820.228 394.67Z"
            fill="white"
          />
          <path
            d="M811.391 404.756C809.456 404.756 807.895 406.318 807.895 408.253C807.895 410.188 809.456 411.75 811.391 411.75C813.327 411.75 814.888 410.188 814.888 408.253C814.888 406.318 813.327 404.756 811.391 404.756Z"
            fill="white"
          />
          <path
            d="M806.418 417.324C804.534 417.324 803.015 418.843 803.015 420.728C803.015 422.612 804.534 424.131 806.418 424.131C808.302 424.131 809.822 422.599 809.822 420.728C809.822 418.856 808.29 417.324 806.418 417.324Z"
            fill="white"
          />
          <path
            d="M794.523 427.309C792.638 427.309 791.119 428.828 791.119 430.704C791.119 432.579 792.638 434.107 794.523 434.107C796.407 434.107 797.918 432.588 797.918 430.704C797.918 428.819 796.398 427.309 794.523 427.309Z"
            fill="white"
          />
          <path
            d="M782.615 437.926C780.744 437.926 779.225 439.445 779.225 441.321C779.225 443.197 780.744 444.712 782.615 444.712C784.487 444.712 785.998 443.192 785.998 441.321C785.998 439.449 784.487 437.926 782.615 437.926Z"
            fill="white"
          />
          <path
            d="M770.728 449.039C768.856 449.039 767.346 450.558 767.346 452.434C767.346 454.31 768.856 455.816 770.728 455.816C772.599 455.816 774.123 454.306 774.123 452.434C774.123 450.563 772.604 449.039 770.728 449.039Z"
            fill="white"
          />
          <path
            d="M758.948 460.674C757.076 460.674 755.565 462.185 755.565 464.056C755.565 465.928 757.076 467.438 758.948 467.438C760.819 467.438 762.33 465.919 762.33 464.056C762.33 462.193 760.811 460.674 758.948 460.674Z"
            fill="white"
          />
          <path
            d="M747.197 472.627C745.325 472.627 743.814 474.138 743.814 476.001C743.814 477.864 745.325 479.383 747.197 479.383C749.068 479.383 750.571 477.872 750.571 476.001C750.571 474.129 749.06 472.627 747.197 472.627Z"
            fill="white"
          />
          <path
            d="M735.344 484.508C733.481 484.508 731.97 486.019 731.97 487.89C731.97 489.762 733.481 491.264 735.344 491.264C737.207 491.264 738.717 489.753 738.717 487.89C738.717 486.027 737.207 484.508 735.344 484.508Z"
            fill="white"
          />
          <path
            d="M723.351 496.125C721.488 496.125 719.978 497.636 719.978 499.499C719.978 501.362 721.488 502.873 723.351 502.873C725.214 502.873 726.725 501.362 726.725 499.499C726.725 497.636 725.214 496.125 723.351 496.125Z"
            fill="white"
          />
          <path
            d="M711.184 507.148C709.321 507.148 707.811 508.646 707.811 510.509C707.811 512.372 709.321 513.883 711.184 513.883C713.047 513.883 714.545 512.372 714.545 510.509C714.545 508.646 713.047 507.148 711.184 507.148Z"
            fill="white"
          />
          <path
            d="M698.729 517.283C696.866 517.283 695.355 518.794 695.355 520.644C695.355 522.494 696.866 524.018 698.729 524.018C700.592 524.018 702.09 522.507 702.09 520.644C702.09 518.781 700.58 517.283 698.729 517.283Z"
            fill="white"
          />
          <path
            d="M685.989 526.318C684.139 526.318 682.628 527.829 682.628 529.692C682.628 531.555 684.139 533.053 685.989 533.053C687.839 533.053 689.35 531.542 689.35 529.692C689.35 527.842 687.852 526.318 685.989 526.318Z"
            fill="white"
          />
          <path
            d="M673.105 534.301C671.251 534.301 669.744 535.799 669.744 537.653C669.744 539.508 671.255 541.014 673.105 541.014C674.955 541.014 676.466 539.516 676.466 537.653C676.466 535.79 674.955 534.301 673.105 534.301Z"
            fill="white"
          />
          <path
            d="M662.442 546.966C663.751 545.657 663.751 543.534 662.442 542.225C661.133 540.916 659.01 540.916 657.701 542.225C656.391 543.534 656.391 545.657 657.701 546.966C659.01 548.276 661.133 548.276 662.442 546.966Z"
            fill="white"
          />
          <path
            d="M649.985 551.736C650.693 550.026 649.881 548.064 648.17 547.356C646.46 546.647 644.498 547.46 643.79 549.17C643.081 550.881 643.894 552.842 645.604 553.551C647.315 554.259 649.276 553.447 649.985 551.736Z"
            fill="white"
          />
          <path
            d="M633.655 552.205C631.814 552.205 630.303 553.703 630.303 555.558C630.303 557.412 631.814 558.897 633.655 558.897C635.497 558.897 637.008 557.399 637.008 555.558C637.008 553.716 635.51 552.205 633.655 552.205Z"
            fill="white"
          />
          <path
            d="M620.419 556.697C618.577 556.697 617.079 558.195 617.079 560.037C617.079 561.879 618.577 563.39 620.419 563.39C622.261 563.39 623.759 561.892 623.759 560.037C623.759 558.183 622.269 556.697 620.419 556.697Z"
            fill="white"
          />
          <path
            d="M607.106 560.777C605.265 560.777 603.767 562.275 603.767 564.117C603.767 565.959 605.265 567.457 607.106 567.457C608.948 567.457 610.446 565.959 610.446 564.117C610.446 562.275 608.957 560.777 607.106 560.777Z"
            fill="white"
          />
          <path
            d="M593.772 564.746C591.931 564.746 590.433 566.236 590.433 568.086C590.433 569.936 591.931 571.417 593.772 571.417C595.614 571.417 597.112 569.928 597.112 568.086C597.112 566.244 595.614 564.746 593.772 564.746Z"
            fill="white"
          />
          <path
            d="M580.515 568.803C578.673 568.803 577.184 570.292 577.184 572.134C577.184 573.976 578.673 575.465 580.515 575.465C582.357 575.465 583.855 573.976 583.855 572.134C583.855 570.292 582.357 568.803 580.515 568.803Z"
            fill="white"
          />
          <path
            d="M567.338 573.07C565.496 573.07 564.007 574.56 564.007 576.402C564.007 578.243 565.496 579.733 567.338 579.733C569.18 579.733 570.657 578.243 570.657 576.402C570.657 574.56 569.167 573.07 567.338 573.07Z"
            fill="white"
          />
          <path
            d="M554.192 577.564C552.358 577.564 550.86 579.054 550.86 580.896C550.86 582.738 552.358 584.227 554.192 584.227C556.025 584.227 557.523 582.729 557.523 580.896C557.523 579.062 556.033 577.564 554.192 577.564Z"
            fill="white"
          />
          <path
            d="M541.099 582.125C539.266 582.125 537.78 583.615 537.78 585.456C537.78 587.298 539.27 588.775 541.099 588.775C542.928 588.775 544.418 587.285 544.418 585.456C544.418 583.627 542.928 582.125 541.099 582.125Z"
            fill="white"
          />
          <path
            d="M528.029 586.643C526.195 586.643 524.71 588.132 524.71 589.974C524.71 591.816 526.199 593.293 528.029 593.293C529.858 593.293 531.347 591.803 531.347 589.974C531.347 588.145 529.858 586.643 528.029 586.643Z"
            fill="white"
          />
          <path
            d="M514.937 591.15C513.104 591.15 511.618 592.64 511.618 594.469C511.618 596.298 513.108 597.788 514.937 597.788C516.766 597.788 518.255 596.298 518.255 594.469C518.255 592.64 516.766 591.15 514.937 591.15Z"
            fill="white"
          />
          <path
            d="M501.782 595.543C499.94 595.543 498.463 597.033 498.463 598.862C498.463 600.691 499.94 602.18 501.782 602.18C503.623 602.18 505.1 600.691 505.1 598.862C505.1 597.033 503.611 595.543 501.782 595.543Z"
            fill="white"
          />
          <path
            d="M488.541 599.561C486.72 599.561 485.23 601.037 485.23 602.871C485.23 604.704 486.72 606.189 488.541 606.189C490.361 606.189 491.859 604.7 491.859 602.871C491.859 601.042 490.37 599.561 488.541 599.561Z"
            fill="white"
          />
          <path
            d="M475.198 603.211C473.365 603.211 471.888 604.688 471.888 606.521C471.888 608.354 473.365 609.84 475.198 609.84C477.031 609.84 478.516 608.35 478.516 606.521C478.516 604.692 477.027 603.211 475.198 603.211Z"
            fill="white"
          />
          <path
            d="M461.676 606.461C459.856 606.461 458.366 607.938 458.366 609.771C458.366 611.604 459.856 613.081 461.676 613.081C463.497 613.081 464.986 611.604 464.986 609.771C464.986 607.938 463.51 606.461 461.676 606.461Z"
            fill="white"
          />
          <path
            d="M447.97 609.064C446.137 609.064 444.651 610.554 444.651 612.383C444.651 614.212 446.141 615.702 447.97 615.702C449.799 615.702 451.289 614.212 451.289 612.383C451.289 610.554 449.799 609.064 447.97 609.064Z"
            fill="white"
          />
          <path
            d="M434.033 610.934C432.2 610.934 430.715 612.423 430.715 614.252C430.715 616.081 432.204 617.562 434.033 617.562C435.863 617.562 437.344 616.086 437.344 614.252C437.344 612.419 435.854 610.934 434.033 610.934Z"
            fill="white"
          />
          <path
            d="M419.766 612.059C417.933 612.059 416.447 613.535 416.447 615.369C416.447 617.202 417.937 618.687 419.766 618.687C421.595 618.687 423.076 617.198 423.076 615.369C423.076 613.54 421.599 612.059 419.766 612.059Z"
            fill="white"
          />
          <path
            d="M405.079 612.295C403.245 612.295 401.769 613.772 401.769 615.592C401.769 617.413 403.245 618.902 405.079 618.902C406.912 618.902 408.389 617.426 408.389 615.592C408.389 613.759 406.912 612.295 405.079 612.295Z"
            fill="white"
          />
          <path
            d="M397.169 609.975C395.314 609.975 393.808 611.473 393.808 613.327C393.808 615.182 395.318 616.688 397.169 616.688C399.019 616.688 400.53 615.19 400.53 613.327C400.53 611.464 399.019 609.975 397.169 609.975Z"
            fill="white"
          />
          <path
            d="M389.114 607.336C387.239 607.336 385.711 608.864 385.711 610.739C385.711 612.615 387.243 614.143 389.114 614.143C390.986 614.143 392.518 612.624 392.518 610.739C392.518 608.855 390.999 607.336 389.114 607.336Z"
            fill="white"
          />
          <path
            d="M380.952 604.348C379.047 604.348 377.498 605.888 377.498 607.794C377.498 609.699 379.047 611.24 380.952 611.24C382.858 611.24 384.398 609.699 384.398 607.794C384.398 605.888 382.858 604.348 380.952 604.348Z"
            fill="white"
          />
          <path
            d="M372.699 600.932C370.764 600.932 369.193 602.502 369.193 604.441C369.193 606.381 370.764 607.947 372.699 607.947C374.634 607.947 376.196 606.376 376.196 604.441C376.196 602.506 374.634 600.932 372.699 600.932Z"
            fill="white"
          />
          <path
            d="M364.372 597.111C362.407 597.111 360.812 598.703 360.812 600.672C360.812 602.641 362.403 604.22 364.372 604.22C366.341 604.22 367.92 602.628 367.92 600.672C367.92 598.715 366.328 597.111 364.372 597.111Z"
            fill="white"
          />
          <path
            d="M356.007 592.826C354.021 592.826 352.417 594.439 352.417 596.429C352.417 598.419 354.021 600.019 356.007 600.019C357.993 600.019 359.597 598.407 359.597 596.429C359.597 594.452 357.993 592.826 356.007 592.826Z"
            fill="white"
          />
          <path
            d="M347.627 588.006C345.628 588.006 344.007 589.631 344.007 591.639C344.007 593.646 345.632 595.258 347.627 595.258C349.621 595.258 351.259 593.633 351.259 591.639C351.259 589.644 349.634 588.006 347.627 588.006Z"
            fill="white"
          />
          <path
            d="M339.279 582.553C337.238 582.553 335.596 584.199 335.596 586.236C335.596 588.273 337.238 589.92 339.279 589.92C341.321 589.92 342.963 588.265 342.963 586.236C342.963 584.208 341.308 582.553 339.279 582.553Z"
            fill="white"
          />
          <path
            d="M330.996 576.443C328.946 576.443 327.282 578.107 327.282 580.157C327.282 582.206 328.946 583.883 330.996 583.883C333.045 583.883 334.713 582.219 334.713 580.157C334.713 578.094 333.049 576.443 330.996 576.443Z"
            fill="white"
          />
          <path
            d="M322.826 569.604C320.755 569.604 319.079 571.28 319.079 573.338C319.079 575.396 320.755 577.085 322.826 577.085C324.897 577.085 326.574 575.409 326.574 573.338C326.574 571.267 324.897 569.604 322.826 569.604Z"
            fill="white"
          />
          <path
            d="M314.81 561.965C312.718 561.965 311.021 563.662 311.021 565.755C311.021 567.847 312.718 569.544 314.81 569.544C316.902 569.544 318.6 567.847 318.6 565.755C318.6 563.662 316.902 561.965 314.81 561.965Z"
            fill="white"
          />
          <path
            d="M306.997 553.516C304.883 553.516 303.169 555.234 303.169 557.348C303.169 559.461 304.888 561.176 306.997 561.176C309.106 561.176 310.829 559.457 310.829 557.348C310.829 555.239 309.11 553.516 306.997 553.516Z"
            fill="white"
          />
          <path
            d="M299.43 544.201C297.308 544.201 295.581 545.92 295.581 548.042C295.581 550.164 297.308 551.891 299.43 551.891C301.552 551.891 303.271 550.164 303.271 548.042C303.271 545.92 301.552 544.201 299.43 544.201Z"
            fill="white"
          />
          <path
            d="M292.153 533.949C290.009 533.949 288.282 535.685 288.282 537.82C288.282 539.954 290.009 541.69 292.153 541.69C294.296 541.69 296.023 539.963 296.023 537.82C296.023 535.676 294.287 533.949 292.153 533.949Z"
            fill="white"
          />
          <path
            d="M285.138 522.986C282.982 522.986 281.233 524.735 281.233 526.891C281.233 529.046 282.982 530.795 285.138 530.795C287.293 530.795 289.042 529.046 289.042 526.891C289.042 524.735 287.293 522.986 285.138 522.986Z"
            fill="white"
          />
          <path
            d="M278.301 511.58C276.116 511.58 274.354 513.337 274.354 515.523C274.354 517.708 276.111 519.469 278.301 519.469C280.491 519.469 282.235 517.7 282.235 515.523C282.235 513.345 280.478 511.58 278.301 511.58Z"
            fill="white"
          />
          <path
            d="M271.485 499.977C269.3 499.977 267.521 501.746 267.521 503.932C267.521 506.117 269.3 507.895 271.485 507.895C273.671 507.895 275.44 506.117 275.44 503.932C275.44 501.746 273.671 499.977 271.485 499.977Z"
            fill="white"
          />
          <path
            d="M264.563 488.361C262.369 488.361 260.587 490.139 260.587 492.338C260.587 494.536 262.365 496.314 264.563 496.314C266.762 496.314 268.527 494.536 268.527 492.338C268.527 490.139 266.757 488.361 264.563 488.361Z"
            fill="white"
          />
          <path
            d="M257.456 476.826C255.241 476.826 253.45 478.617 253.45 480.824C253.45 483.031 255.241 484.83 257.456 484.83C259.672 484.83 261.454 483.039 261.454 480.824C261.454 478.609 259.663 476.826 257.456 476.826Z"
            fill="white"
          />
          <path
            d="M250.118 465.412C247.903 465.412 246.091 467.211 246.091 469.439C246.091 471.667 247.903 473.467 250.118 473.467C252.333 473.467 254.145 471.655 254.145 469.439C254.145 467.224 252.346 465.412 250.118 465.412Z"
            fill="white"
          />
          <path
            d="M242.552 454.162C240.324 454.162 238.512 455.974 238.512 458.202C238.512 460.43 240.324 462.242 242.552 462.242C244.78 462.242 246.592 460.443 246.592 458.202C246.592 455.961 244.78 454.162 242.552 454.162Z"
            fill="white"
          />
          <path
            d="M234.777 443.035C232.541 443.035 230.729 444.847 230.729 447.084C230.729 449.32 232.541 451.141 234.777 451.141C237.014 451.141 238.826 449.32 238.826 447.084C238.826 444.847 237.014 443.035 234.777 443.035Z"
            fill="white"
          />
          <path
            d="M226.845 431.963C224.609 431.963 222.797 433.775 222.797 436.011C222.797 438.248 224.609 440.068 226.845 440.068C229.082 440.068 230.902 438.248 230.902 436.011C230.902 433.775 229.082 431.963 226.845 431.963Z"
            fill="white"
          />
          <path
            d="M218.863 420.762C216.614 420.762 214.793 422.582 214.793 424.823C214.793 427.064 216.614 428.893 218.863 428.893C221.112 428.893 222.92 427.072 222.92 424.823C222.92 422.574 221.099 420.762 218.863 420.762Z"
            fill="white"
          />
          <path
            d="M210.897 409.283C208.647 409.283 206.818 411.104 206.818 413.353C206.818 415.602 208.652 417.431 210.897 417.431C213.142 417.431 214.975 415.611 214.975 413.353C214.975 411.095 213.142 409.283 210.897 409.283Z"
            fill="white"
          />
          <path
            d="M203.009 397.52C200.76 397.52 198.931 399.34 198.931 401.598C198.931 403.855 200.764 405.668 203.009 405.668C205.254 405.668 207.087 403.847 207.087 401.598C207.087 399.349 205.254 397.52 203.009 397.52Z"
            fill="white"
          />
          <path
            d="M195.216 385.445C192.967 385.445 191.138 387.279 191.138 389.536C191.138 391.794 192.971 393.615 195.216 393.615C197.461 393.615 199.307 391.781 199.307 389.536C199.307 387.291 197.474 385.445 195.216 385.445Z"
            fill="white"
          />
          <path
            d="M187.536 373.105C185.279 373.105 183.458 374.939 183.458 377.184C183.458 379.429 185.279 381.275 187.536 381.275C189.794 381.275 191.627 379.441 191.627 377.184C191.627 374.926 189.794 373.105 187.536 373.105Z"
            fill="white"
          />
          <path
            d="M179.948 360.596C177.699 360.596 175.87 362.429 175.87 364.674C175.87 366.919 177.703 368.752 179.948 368.752C182.193 368.752 184.027 366.932 184.027 364.674C184.027 362.416 182.206 360.596 179.948 360.596Z"
            fill="white"
          />
          <path
            d="M172.495 347.998C170.238 347.998 168.417 349.831 168.417 352.076C168.417 354.321 170.238 356.155 172.495 356.155C174.753 356.155 176.573 354.334 176.573 352.076C176.573 349.819 174.74 347.998 172.495 347.998Z"
            fill="white"
          />
          <path
            d="M165.103 335.689C162.845 335.689 161.024 337.51 161.024 339.768C161.024 342.025 162.845 343.846 165.103 343.846C167.36 343.846 169.181 342.013 169.181 339.768C169.181 337.523 167.348 335.689 165.103 335.689Z"
            fill="white"
          />
          <path
            d="M172.36 319.359C170.111 319.359 168.29 321.18 168.29 323.429C168.29 325.678 170.111 327.507 172.36 327.507C174.609 327.507 176.438 325.687 176.438 323.429C176.438 321.171 174.617 319.359 172.36 319.359Z"
            fill="white"
          />
          <path
            d="M179.74 303.891C177.49 303.891 175.683 305.711 175.683 307.96C175.683 310.21 177.495 312.017 179.74 312.017C181.985 312.017 183.809 310.197 183.809 307.96C183.809 305.724 181.989 303.891 179.74 303.891Z"
            fill="white"
          />
          <path
            d="M187.323 289.51C185.086 289.51 183.266 291.322 183.266 293.558C183.266 295.795 185.086 297.607 187.323 297.607C189.559 297.607 191.371 295.795 191.371 293.558C191.371 291.322 189.559 289.51 187.323 289.51Z"
            fill="white"
          />
          <path
            d="M195.005 276.58C192.768 276.58 190.956 278.392 190.956 280.629C190.956 282.865 192.768 284.677 195.005 284.677C197.241 284.677 199.053 282.865 199.053 280.629C199.053 278.392 197.241 276.58 195.005 276.58Z"
            fill="white"
          />
          <path
            d="M202.706 265.111C200.491 265.111 198.688 266.911 198.688 269.139C198.688 271.367 200.487 273.157 202.706 273.157C204.926 273.157 206.734 271.358 206.734 269.139C206.734 266.919 204.934 265.111 202.706 265.111Z"
            fill="white"
          />
          <path
            d="M210.265 254.973C208.05 254.973 206.259 256.772 206.259 258.979C206.259 261.186 208.05 262.985 210.265 262.985C212.48 262.985 214.263 261.194 214.263 258.979C214.263 256.764 212.472 254.973 210.265 254.973Z"
            fill="white"
          />
          <path
            d="M217.488 246.021C215.281 246.021 213.49 247.812 213.49 250.006C213.49 252.2 215.281 254.004 217.488 254.004C219.695 254.004 221.473 252.213 221.473 250.006C221.473 247.8 219.682 246.021 217.488 246.021Z"
            fill="white"
          />
          <path
            d="M224.439 245.908C226.634 245.839 228.358 244.004 228.289 241.809C228.22 239.614 226.384 237.89 224.189 237.959C221.994 238.028 220.271 239.863 220.34 242.058C220.409 244.253 222.244 245.977 224.439 245.908Z"
            fill="white"
          />
          <path
            d="M230.738 230.523C228.561 230.523 226.791 232.293 226.791 234.47C226.791 236.647 228.561 238.413 230.738 238.413C232.915 238.413 234.68 236.643 234.68 234.47C234.68 232.297 232.923 230.523 230.738 230.523Z"
            fill="white"
          />
          <path
            d="M236.72 223.68C234.556 223.68 232.808 225.437 232.808 227.605C232.808 229.774 234.556 231.518 236.72 231.518C238.885 231.518 240.646 229.757 240.646 227.605C240.646 225.454 238.889 223.68 236.72 223.68Z"
            fill="white"
          />
          <path
            d="M242.259 217.568C240.103 217.568 238.367 219.304 238.367 221.46C238.367 223.616 240.107 225.364 242.259 225.364C244.41 225.364 246.163 223.616 246.163 221.46C246.163 219.304 244.415 217.568 242.259 217.568Z"
            fill="white"
          />
          <path
            d="M247.346 212.301C245.203 212.301 243.476 214.041 243.476 216.171C243.476 218.301 245.203 220.041 247.346 220.041C249.489 220.041 251.216 218.314 251.216 216.171C251.216 214.028 249.489 212.301 247.346 212.301Z"
            fill="white"
          />
          <path
            d="M251.947 207.787C249.834 207.787 248.128 209.506 248.128 211.619C248.128 213.733 249.834 215.439 251.947 215.439C254.061 215.439 255.775 213.733 255.775 211.619C255.775 209.506 254.056 207.787 251.947 207.787Z"
            fill="white"
          />
          <path
            d="M256.069 203.77C253.977 203.77 252.271 205.467 252.271 207.568C252.271 209.668 253.977 211.366 256.069 211.366C258.161 211.366 259.867 209.66 259.867 207.568C259.867 205.476 258.169 203.77 256.069 203.77Z"
            fill="white"
          />
          <path
            d="M259.692 200.125C257.613 200.125 255.924 201.823 255.924 203.902C255.924 205.981 257.609 207.67 259.692 207.67C261.776 207.67 263.461 205.986 263.461 203.902C263.461 201.818 261.776 200.125 259.692 200.125Z"
            fill="white"
          />
          <path
            d="M262.802 196.795C260.739 196.795 259.067 198.471 259.067 200.529C259.067 202.588 260.744 204.264 262.802 204.264C264.86 204.264 266.536 202.588 266.536 200.529C266.536 198.471 264.86 196.795 262.802 196.795Z"
            fill="white"
          />
          <path
            d="M265.426 193.705C263.397 193.705 261.742 195.352 261.742 197.389C261.742 199.426 263.397 201.072 265.426 201.072C267.454 201.072 269.122 199.426 269.122 197.389C269.122 195.352 267.467 193.705 265.426 193.705Z"
            fill="white"
          />
          <path
            d="M267.602 190.752C265.582 190.752 263.948 192.386 263.948 194.406C263.948 196.426 265.582 198.055 267.602 198.055C269.622 198.055 271.256 196.422 271.256 194.406C271.256 192.39 269.622 190.752 267.602 190.752Z"
            fill="white"
          />
          <path
            d="M269.351 187.912C267.352 187.912 265.739 189.529 265.739 191.519C265.739 193.51 267.352 195.131 269.351 195.131C271.349 195.131 272.962 193.518 272.962 191.519C272.962 189.52 271.349 187.912 269.351 187.912Z"
            fill="white"
          />
          <path
            d="M270.713 185.146C268.748 185.146 267.144 186.742 267.144 188.715C267.144 190.689 268.748 192.297 270.713 192.297C272.677 192.297 274.294 190.693 274.294 188.715C274.294 186.738 272.69 185.146 270.713 185.146Z"
            fill="white"
          />
          <path
            d="M271.745 182.494C269.797 182.494 268.227 184.064 268.227 186.012C268.227 187.96 269.797 189.526 271.745 189.526C273.693 189.526 275.25 187.947 275.25 186.012C275.25 184.077 273.68 182.494 271.745 182.494Z"
            fill="white"
          />
          <path
            d="M272.461 179.883C270.547 179.883 268.994 181.432 268.994 183.354C268.994 185.277 270.543 186.826 272.461 186.826C274.379 186.826 275.928 185.277 275.928 183.354C275.928 181.432 274.375 179.883 272.461 179.883Z"
            fill="white"
          />
          <path
            d="M272.92 177.277C271.036 177.277 269.508 178.809 269.508 180.702C269.508 182.595 271.036 184.123 272.92 184.123C274.804 184.123 276.344 182.586 276.344 180.702C276.344 178.818 274.812 177.277 272.92 177.277Z"
            fill="white"
          />
          <path
            d="M273.158 174.617C271.295 174.617 269.775 176.136 269.775 177.999C269.775 179.862 271.295 181.377 273.158 181.377C275.021 181.377 276.531 179.862 276.531 177.999C276.531 176.136 275.021 174.617 273.158 174.617Z"
            fill="white"
          />
          <path
            d="M273.213 171.859C271.392 171.859 269.911 173.336 269.911 175.157C269.911 176.977 271.388 178.463 273.213 178.463C275.038 178.463 276.51 176.986 276.51 175.157C276.51 173.328 275.033 171.859 273.213 171.859Z"
            fill="white"
          />
          <path
            d="M273.15 168.846C271.35 168.846 269.891 170.301 269.891 172.096C269.891 173.892 271.346 175.356 273.15 175.356C274.953 175.356 276.409 173.9 276.409 172.096C276.409 170.293 274.953 168.846 273.15 168.846Z"
            fill="white"
          />
          <path
            d="M273.063 165.498C271.294 165.498 269.859 166.932 269.859 168.702C269.859 170.472 271.294 171.906 273.063 171.906C274.833 171.906 276.28 170.476 276.28 168.702C276.28 166.928 274.842 165.498 273.063 165.498Z"
            fill="white"
          />
          <path
            d="M273.118 161.699C271.378 161.699 269.965 163.117 269.965 164.852C269.965 166.588 271.382 167.997 273.118 167.997C274.854 167.997 276.263 166.588 276.263 164.852C276.263 163.117 274.845 161.699 273.118 161.699Z"
            fill="white"
          />
          <path
            d="M273.544 157.215C271.847 157.215 270.472 158.59 270.472 160.287C270.472 161.985 271.847 163.347 273.544 163.347C275.242 163.347 276.617 161.972 276.617 160.287C276.617 158.603 275.242 157.215 273.544 157.215Z"
            fill="white"
          />
          <path
            d="M274.761 151.643C273.106 151.643 271.752 152.992 271.752 154.647C271.752 156.302 273.106 157.656 274.761 157.656C276.416 157.656 277.77 156.315 277.77 154.647C277.77 152.979 276.429 151.643 274.761 151.643Z"
            fill="white"
          />
          <path
            d="M277.363 144.451C275.738 144.451 274.418 145.771 274.418 147.396C274.418 149.022 275.742 150.341 277.363 150.341C278.984 150.341 280.308 149.022 280.308 147.396C280.308 145.771 278.988 144.451 277.363 144.451Z"
            fill="white"
          />
          <path
            d="M292.724 140.375C291.099 140.375 289.779 141.699 289.779 143.333C289.779 144.967 291.099 146.278 292.724 146.278C294.35 146.278 295.682 144.954 295.682 143.333C295.682 141.712 294.358 140.375 292.724 140.375Z"
            fill="white"
          />
          <path
            d="M310.057 133.703C308.423 133.703 307.104 135.023 307.104 136.661C307.104 138.299 308.423 139.61 310.057 139.61C311.691 139.61 313.015 138.286 313.015 136.661C313.015 135.036 311.695 133.703 310.057 133.703Z"
            fill="white"
          />
          <path
            d="M329.977 129.51C331.611 129.51 332.935 128.185 332.935 126.552C332.935 124.918 331.611 123.594 329.977 123.594C328.344 123.594 327.02 124.918 327.02 126.552C327.02 128.185 328.344 129.51 329.977 129.51Z"
            fill="white"
          />
          <path
            d="M352.706 109.598C351.072 109.598 349.748 110.917 349.748 112.551C349.748 114.185 351.068 115.509 352.706 115.509C354.344 115.509 355.66 114.189 355.66 112.551C355.66 110.913 354.34 109.598 352.706 109.598Z"
            fill="white"
          />
          <path
            d="M378.258 91.4062C376.624 91.4062 375.3 92.7261 375.3 94.3641C375.3 96.0022 376.62 97.3305 378.258 97.3305C379.896 97.3305 381.224 96.0022 381.224 94.3641C381.224 92.7261 379.892 91.4062 378.258 91.4062Z"
            fill="white"
          />
          <path
            d="M405.588 69.4961C403.955 69.4961 402.622 70.8244 402.622 72.4625C402.622 74.1006 403.955 75.4204 405.588 75.4204C407.222 75.4204 408.555 74.0963 408.555 72.4625C408.555 70.8286 407.222 69.4961 405.588 69.4961Z"
            fill="white"
          />
          <path
            d="M433.346 45.043C431.704 45.043 430.38 46.3713 430.38 48.0136C430.38 49.6559 431.704 50.98 433.346 50.98C434.989 50.98 436.313 49.6474 436.313 48.0136C436.313 46.3797 434.98 45.043 433.346 45.043Z"
            fill="white"
          />
          <path
            d="M459.815 20.4199C458.168 20.4199 456.84 21.7525 456.84 23.3905C456.84 25.0286 458.172 26.3612 459.815 26.3612C461.457 26.3612 462.781 25.0286 462.781 23.3905C462.781 21.7525 461.461 20.4199 459.815 20.4199Z"
            fill="white"
          />
          <path
            d="M484.2 -1.62109C482.566 -1.62109 481.233 -0.2928 481.233 1.34529C481.233 2.98337 482.566 4.31591 484.2 4.31591C485.834 4.31591 487.175 2.98762 487.175 1.34529C487.175 -0.297044 485.842 -1.62109 484.2 -1.62109Z"
            fill="white"
          />
          <path
            d="M839.13 -1.09095C839.132 -2.90971 837.661 -4.38564 835.845 -4.38755C834.028 -4.38945 832.554 -2.91659 832.552 -1.09784C832.55 0.720916 834.021 2.19685 835.838 2.19876C837.654 2.20066 839.128 0.727804 839.13 -1.09095Z"
            fill="white"
          />
          <path
            d="M842.741 6.92383C840.899 6.92383 839.409 8.41763 839.409 10.2637C839.409 12.1097 840.899 13.5992 842.741 13.5992C844.582 13.5992 846.08 12.1054 846.08 10.2637C846.08 8.42187 844.591 6.92383 842.741 6.92383Z"
            fill="white"
          />
          <path
            d="M849.485 18.9766C847.622 18.9766 846.103 20.4958 846.103 22.3588C846.103 24.2218 847.622 25.7496 849.485 25.7496C851.348 25.7496 852.876 24.2303 852.876 22.3588C852.876 20.4873 851.356 18.9766 849.485 18.9766Z"
            fill="white"
          />
          <path
            d="M855.99 31.8184C854.084 31.8184 852.544 33.3673 852.544 35.2728C852.544 37.1782 854.084 38.7187 855.99 38.7187C857.895 38.7187 859.444 37.1782 859.444 35.2728C859.444 33.3673 857.895 31.8184 855.99 31.8184Z"
            fill="white"
          />
          <path
            d="M862.194 45.5781C860.259 45.5781 858.688 47.1568 858.688 49.0962C858.688 51.0356 860.259 52.61 862.194 52.61C864.129 52.61 865.712 51.0313 865.712 49.0962C865.712 47.161 864.142 45.5781 862.194 45.5781Z"
            fill="white"
          />
          <path
            d="M868.084 60.2441C866.119 60.2441 864.523 61.8398 864.523 63.8046C864.523 65.7695 866.115 67.3694 868.084 67.3694C870.053 67.3694 871.644 65.7695 871.644 63.8046C871.644 61.8398 870.053 60.2441 868.084 60.2441Z"
            fill="white"
          />
          <path
            d="M873.686 75.7227C871.687 75.7227 870.074 77.3353 870.074 79.3341C870.074 81.3329 871.687 82.937 873.686 82.937C875.684 82.937 877.289 81.3244 877.289 79.3341C877.289 77.3438 875.676 75.7227 873.686 75.7227Z"
            fill="white"
          />
          <path
            d="M879.062 91.8105C877.042 91.8105 875.408 93.4444 875.408 95.4644C875.408 97.4844 877.042 99.1183 879.062 99.1183C881.082 99.1183 882.703 97.4844 882.703 95.4644C882.703 93.4444 881.069 91.8105 879.062 91.8105Z"
            fill="white"
          />
          <path
            d="M884.321 108.273C882.28 108.273 880.616 109.928 880.616 111.978C880.616 114.028 882.28 115.696 884.321 115.696C886.362 115.696 888.034 114.032 888.034 111.978C888.034 109.924 886.371 108.273 884.321 108.273Z"
            fill="white"
          />
          <path
            d="M889.618 124.836C887.547 124.836 885.862 126.512 885.862 128.583C885.862 130.654 887.547 132.33 889.618 132.33C891.689 132.33 893.365 130.654 893.365 128.583C893.365 126.512 891.681 124.836 889.618 124.836Z"
            fill="white"
          />
          <path
            d="M895.062 141.09C892.97 141.09 891.272 142.787 891.272 144.884C891.272 146.98 892.97 148.678 895.062 148.678C897.154 148.678 898.86 146.98 898.86 144.884C898.86 142.787 897.163 141.09 895.062 141.09Z"
            fill="white"
          />
          <path
            d="M900.816 156.695C898.703 156.695 896.997 158.406 896.997 160.519C896.997 162.632 898.703 164.338 900.816 164.338C902.93 164.338 904.644 162.632 904.644 160.519C904.644 158.406 902.926 156.695 900.816 156.695Z"
            fill="white"
          />
          <path
            d="M906.97 171.367C904.827 171.367 903.1 173.103 903.1 175.237C903.1 177.372 904.827 179.108 906.97 179.108C909.113 179.108 910.84 177.381 910.84 175.237C910.84 173.094 909.104 171.367 906.97 171.367Z"
            fill="white"
          />
          <path
            d="M913.525 185.117C911.369 185.117 909.621 186.866 909.621 189.021C909.621 191.177 911.369 192.926 913.525 192.926C915.681 192.926 917.438 191.177 917.438 189.021C917.438 186.866 915.69 185.117 913.525 185.117Z"
            fill="white"
          />
          <path
            d="M920.521 197.857C918.344 197.857 916.578 199.614 916.578 201.791C916.578 203.968 918.348 205.725 920.521 205.725C922.693 205.725 924.454 203.964 924.454 201.791C924.454 199.619 922.693 197.857 920.521 197.857Z"
            fill="white"
          />
          <path
            d="M927.899 209.637C925.714 209.637 923.936 211.415 923.936 213.6C923.936 215.786 925.714 217.564 927.899 217.564C930.085 217.564 931.863 215.794 931.863 213.6C931.863 211.406 930.093 209.637 927.899 209.637Z"
            fill="white"
          />
          <path
            d="M935.662 228.487C937.87 228.487 939.659 226.698 939.659 224.49C939.659 222.282 937.87 220.492 935.662 220.492C933.454 220.492 931.664 222.282 931.664 224.49C931.664 226.698 933.454 228.487 935.662 228.487Z"
            fill="white"
          />
          <path
            d="M943.793 230.41C941.565 230.41 939.766 232.21 939.766 234.437C939.766 236.665 941.565 238.465 943.793 238.465C946.021 238.465 947.82 236.665 947.82 234.437C947.82 232.21 946.021 230.41 943.793 230.41Z"
            fill="white"
          />
          <path
            d="M952.243 239.402C950.006 239.402 948.194 241.214 948.194 243.451C948.194 245.687 950.006 247.491 952.243 247.491C954.479 247.491 956.283 245.679 956.283 243.451C956.283 241.223 954.471 239.402 952.243 239.402Z"
            fill="white"
          />
          <path
            d="M960.963 247.439C958.714 247.439 956.894 249.26 956.894 251.509C956.894 253.758 958.714 255.587 960.963 255.587C963.212 255.587 965.042 253.754 965.042 251.509C965.042 249.264 963.221 247.439 960.963 247.439Z"
            fill="white"
          />
          <path
            d="M969.917 254.496C967.659 254.496 965.817 256.338 965.817 258.596C965.817 260.853 967.659 262.695 969.917 262.695C972.174 262.695 974.029 260.862 974.029 258.596C974.029 256.329 972.187 254.496 969.917 254.496Z"
            fill="white"
          />
          <path
            d="M979.024 260.604C976.754 260.604 974.903 262.445 974.903 264.724C974.903 267.003 976.758 268.845 979.024 268.845C981.29 268.845 983.145 266.995 983.145 264.724C983.145 262.454 981.303 260.604 979.024 260.604Z"
            fill="white"
          />
          <path
            d="M988.226 265.811C985.934 265.811 984.084 267.665 984.084 269.944C984.084 272.223 985.934 274.086 988.226 274.086C990.518 274.086 992.368 272.236 992.368 269.944C992.368 267.652 990.513 265.811 988.226 265.811Z"
            fill="white"
          />
          <path
            d="M997.447 270.191C995.155 270.191 993.292 272.054 993.292 274.346C993.292 276.638 995.155 278.501 997.447 278.501C999.738 278.501 1001.6 276.638 1001.6 274.346C1001.6 272.054 999.747 270.191 997.447 270.191Z"
            fill="white"
          />
          <path
            d="M1006.66 273.844C1004.36 273.844 1002.5 275.707 1002.5 277.998C1002.5 280.29 1004.36 282.153 1006.66 282.153C1008.96 282.153 1010.81 280.303 1010.81 277.998C1010.81 275.694 1008.95 273.844 1006.66 273.844Z"
            fill="white"
          />
          <path
            d="M1015.79 276.842C1013.5 276.842 1011.64 278.705 1011.64 280.996C1011.64 283.288 1013.5 285.151 1015.79 285.151C1018.08 285.151 1019.95 283.301 1019.95 280.996C1019.95 278.692 1018.1 276.842 1015.79 276.842Z"
            fill="white"
          />
          <path
            d="M1024.84 279.277C1022.55 279.277 1020.69 281.128 1020.69 283.432C1020.69 285.736 1022.55 287.582 1024.84 287.582C1027.13 287.582 1028.99 285.719 1028.99 283.432C1028.99 281.145 1027.14 279.277 1024.84 279.277Z"
            fill="white"
          />
          <path
            d="M1033.77 281.297C1031.47 281.297 1029.61 283.147 1029.61 285.452C1029.61 287.756 1031.47 289.606 1033.77 289.606C1036.07 289.606 1037.92 287.743 1037.92 285.452C1037.92 283.16 1036.06 281.297 1033.77 281.297Z"
            fill="white"
          />
          <path
            d="M1042.56 283.014C1040.27 283.014 1038.41 284.877 1038.41 287.168C1038.41 289.46 1040.27 291.323 1042.56 291.323C1044.85 291.323 1046.72 289.46 1046.72 287.168C1046.72 284.877 1044.86 283.014 1042.56 283.014Z"
            fill="white"
          />
          <path
            d="M1037.59 284.271C1035.3 284.271 1033.43 286.135 1033.43 288.426C1033.43 290.718 1035.3 292.589 1037.59 292.589C1039.88 292.589 1041.74 290.726 1041.74 288.426C1041.74 286.126 1039.89 284.271 1037.59 284.271Z"
            fill="white"
          />
          <path
            d="M1032.44 285.521C1030.14 285.521 1028.28 287.384 1028.28 289.676C1028.28 291.968 1030.14 293.831 1032.44 293.831C1034.74 293.831 1036.59 291.98 1036.59 289.676C1036.59 287.372 1034.73 285.521 1032.44 285.521Z"
            fill="white"
          />
          <path
            d="M1027.08 286.791C1024.78 286.791 1022.92 288.646 1022.92 290.946C1022.92 293.246 1024.78 295.1 1027.08 295.1C1029.38 295.1 1031.23 293.237 1031.23 290.946C1031.23 288.654 1029.37 286.791 1027.08 286.791Z"
            fill="white"
          />
          <path
            d="M1021.49 288.104C1019.2 288.104 1017.33 289.967 1017.33 292.258C1017.33 294.55 1019.2 296.413 1021.49 296.413C1023.78 296.413 1025.64 294.55 1025.64 292.258C1025.64 289.967 1023.79 288.104 1021.49 288.104Z"
            fill="white"
          />
          <path
            d="M1015.68 289.457C1013.39 289.457 1011.52 291.32 1011.52 293.612C1011.52 295.903 1013.39 297.766 1015.68 297.766C1017.97 297.766 1019.83 295.912 1019.83 293.612C1019.83 291.312 1017.97 289.457 1015.68 289.457Z"
            fill="white"
          />
          <path
            d="M1009.63 290.871C1007.33 290.871 1005.48 292.726 1005.48 295.026C1005.48 297.326 1007.33 299.18 1009.63 299.18C1011.93 299.18 1013.79 297.317 1013.79 295.026C1013.79 292.734 1011.92 290.871 1009.63 290.871Z"
            fill="white"
          />
          <path
            d="M1003.34 292.359C1001.05 292.359 999.183 294.222 999.183 296.514C999.183 298.806 1001.05 300.669 1003.34 300.669C1005.63 300.669 1007.49 298.818 1007.49 296.514C1007.49 294.21 1005.64 292.359 1003.34 292.359Z"
            fill="white"
          />
          <path
            d="M996.798 293.953C994.507 293.953 992.644 295.816 992.644 298.108C992.644 300.399 994.507 302.262 996.798 302.262C999.09 302.262 1000.95 300.399 1000.95 298.108C1000.95 295.816 999.09 293.953 996.798 293.953Z"
            fill="white"
          />
          <path
            d="M990.011 295.678C987.719 295.678 985.869 297.528 985.869 299.82C985.869 302.111 987.724 303.962 990.011 303.962C992.298 303.962 994.153 302.107 994.153 299.82C994.153 297.532 992.298 295.678 990.011 295.678Z"
            fill="white"
          />
          <path
            d="M982.975 297.555C980.675 297.555 978.82 299.409 978.82 301.697C978.82 303.984 980.675 305.838 982.975 305.838C985.275 305.838 987.117 303.988 987.117 301.697C987.117 299.405 985.262 297.555 982.975 297.555Z"
            fill="white"
          />
          <path
            d="M975.68 307.888C977.963 307.888 979.814 306.037 979.814 303.755C979.814 301.472 977.963 299.621 975.68 299.621C973.397 299.621 971.547 301.472 971.547 303.755C971.547 306.037 973.397 307.888 975.68 307.888Z"
            fill="white"
          />
          <path
            d="M968.148 301.926C965.878 301.926 964.049 303.768 964.049 306.025C964.049 308.283 965.882 310.137 968.148 310.137C970.415 310.137 972.248 308.296 972.248 306.025C972.248 303.755 970.406 301.926 968.148 301.926Z"
            fill="white"
          />
          <path
            d="M960.382 304.465C958.124 304.465 956.304 306.298 956.304 308.543C956.304 310.788 958.124 312.621 960.382 312.621C962.64 312.621 964.46 310.801 964.46 308.543C964.46 306.285 962.627 304.465 960.382 304.465Z"
            fill="white"
          />
          <path
            d="M952.408 307.264C950.171 307.264 948.351 309.084 948.351 311.321C948.351 313.557 950.171 315.378 952.408 315.378C954.644 315.378 956.465 313.566 956.465 311.321C956.465 309.076 954.653 307.264 952.408 307.264Z"
            fill="white"
          />
          <path
            d="M944.281 310.332C942.045 310.332 940.232 312.131 940.232 314.372C940.232 316.613 942.045 318.412 944.281 318.412C946.517 318.412 948.321 316.6 948.321 314.372C948.321 312.144 946.509 310.332 944.281 310.332Z"
            fill="white"
          />
          <path
            d="M936.039 313.676C933.82 313.676 932.033 315.467 932.033 317.682C932.033 319.897 933.824 321.688 936.039 321.688C938.255 321.688 940.045 319.889 940.045 317.682C940.045 315.475 938.246 313.676 936.039 313.676Z"
            fill="white"
          />
          <path
            d="M927.734 317.268C925.536 317.268 923.758 319.046 923.758 321.244C923.758 323.442 925.536 325.22 927.734 325.22C929.933 325.22 931.711 323.442 931.711 321.244C931.711 319.046 929.933 317.268 927.734 317.268Z"
            fill="white"
          />
          <path
            d="M919.396 321.107C917.21 321.107 915.44 322.886 915.44 325.071C915.44 327.257 917.21 329.026 919.396 329.026C921.581 329.026 923.351 327.248 923.351 325.071C923.351 322.894 921.581 321.107 919.396 321.107Z"
            fill="white"
          />
          <path
            d="M910.967 325.373C908.803 325.373 907.042 327.121 907.042 329.286C907.042 331.45 908.803 333.211 910.967 333.211C913.132 333.211 914.893 331.463 914.893 329.286C914.893 327.109 913.132 325.373 910.967 325.373Z"
            fill="white"
          />
          <path
            d="M902.463 330.086C900.32 330.086 898.58 331.826 898.58 333.969C898.58 336.112 900.316 337.852 902.463 337.852C904.611 337.852 906.333 336.116 906.333 333.969C906.333 331.822 904.606 330.086 902.463 330.086Z"
            fill="white"
          />
          <path
            d="M893.887 335.281C891.765 335.281 890.046 337.008 890.046 339.13C890.046 341.252 891.765 342.971 893.887 342.971C896.008 342.971 897.736 341.252 897.736 339.13C897.736 337.008 896.008 335.281 893.887 335.281Z"
            fill="white"
          />
          <path
            d="M885.267 340.955C883.153 340.955 881.447 342.661 881.447 344.766C881.447 346.871 883.153 348.585 885.267 348.585C887.38 348.585 889.086 346.879 889.086 344.766C889.086 342.653 887.38 340.955 885.267 340.955Z"
            fill="white"
          />
          <path
            d="M876.61 347.139C874.53 347.139 872.833 348.823 872.833 350.907C872.833 352.991 874.53 354.684 876.61 354.684C878.689 354.684 880.378 352.987 880.378 350.907C880.378 348.828 878.694 347.139 876.61 347.139Z"
            fill="white"
          />
          <path
            d="M867.898 353.85C865.848 353.85 864.172 355.513 864.172 357.576C864.172 359.638 865.848 361.302 867.898 361.302C869.948 361.302 871.624 359.625 871.624 357.576C871.624 355.526 869.96 353.85 867.898 353.85Z"
            fill="white"
          />
          <path
            d="M859.155 361.125C857.114 361.125 855.459 362.772 855.459 364.809C855.459 366.846 857.114 368.492 859.155 368.492C861.197 368.492 862.839 366.837 862.839 364.809C862.839 362.78 861.184 361.125 859.155 361.125Z"
            fill="white"
          />
          <path
            d="M850.341 368.943C848.321 368.943 846.688 370.577 846.688 372.597C846.688 374.617 848.321 376.251 850.341 376.251C852.361 376.251 853.995 374.617 853.995 372.597C853.995 370.577 852.361 368.943 850.341 368.943Z"
            fill="white"
          />
          <path
            d="M841.493 377.369C839.494 377.369 837.882 378.982 837.882 380.981C837.882 382.979 839.494 384.584 841.493 384.584C843.492 384.584 845.092 382.971 845.092 380.981C845.092 378.99 843.479 377.369 841.493 377.369Z"
            fill="white"
          />
          <path
            d="M832.585 386.375C830.629 386.375 829.046 387.958 829.046 389.914C829.046 391.871 830.629 393.462 832.585 393.462C834.542 393.462 836.133 391.871 836.133 389.914C836.133 387.958 834.542 386.375 832.585 386.375Z"
            fill="white"
          />
          <path
            d="M823.695 395.949C821.76 395.949 820.198 397.511 820.198 399.446C820.198 401.381 821.76 402.943 823.695 402.943C825.63 402.943 827.192 401.373 827.192 399.446C827.192 397.519 825.622 395.949 823.695 395.949Z"
            fill="white"
          />
          <path
            d="M814.923 406.213C813.018 406.213 811.469 407.762 811.469 409.667C811.469 411.573 813.018 413.122 814.923 413.122C816.829 413.122 818.378 411.573 818.378 409.667C818.378 407.762 816.829 406.213 814.923 406.213Z"
            fill="white"
          />
          <path
            d="M809.902 426.016C811.741 426.016 813.233 424.525 813.233 422.685C813.233 420.845 811.741 419.354 809.902 419.354C808.062 419.354 806.57 420.845 806.57 422.685C806.57 424.525 808.062 426.016 809.902 426.016Z"
            fill="white"
          />
          <path
            d="M798.364 429.391C796.522 429.391 795.024 430.88 795.024 432.722C795.024 434.564 796.522 436.053 798.364 436.053C800.206 436.053 801.696 434.555 801.696 432.722C801.696 430.889 800.198 429.391 798.364 429.391Z"
            fill="white"
          />
          <path
            d="M786.851 440.025C785.009 440.025 783.52 441.515 783.52 443.357C783.52 445.199 785.009 446.675 786.851 446.675C788.693 446.675 790.182 445.186 790.182 443.357C790.182 441.528 788.693 440.025 786.851 440.025Z"
            fill="white"
          />
          <path
            d="M775.393 451.217C773.56 451.217 772.074 452.706 772.074 454.535C772.074 456.364 773.564 457.867 775.393 457.867C777.222 457.867 778.711 456.377 778.711 454.535C778.711 452.694 777.222 451.217 775.393 451.217Z"
            fill="white"
          />
          <path
            d="M764.015 462.873C762.173 462.873 760.696 464.363 760.696 466.192C760.696 468.021 762.173 469.51 764.015 469.51C765.857 469.51 767.325 468.021 767.325 466.192C767.325 464.363 765.848 462.873 764.015 462.873Z"
            fill="white"
          />
          <path
            d="M752.701 474.842C750.88 474.842 749.399 476.319 749.399 478.139C749.399 479.96 750.876 481.441 752.701 481.441C754.526 481.441 756.011 479.964 756.011 478.139C756.011 476.314 754.534 474.842 752.701 474.842Z"
            fill="white"
          />
          <path
            d="M741.336 486.844C739.516 486.844 738.039 488.321 738.039 490.145C738.039 491.97 739.516 493.443 741.336 493.443C743.157 493.443 744.638 491.966 744.638 490.145C744.638 488.325 743.161 486.844 741.336 486.844Z"
            fill="white"
          />
          <path
            d="M729.764 498.479C727.943 498.479 726.462 499.955 726.462 501.78C726.462 503.605 727.939 505.09 729.764 505.09C731.588 505.09 733.061 503.613 733.061 501.78C733.061 499.947 731.584 498.479 729.764 498.479Z"
            fill="white"
          />
          <path
            d="M717.982 509.572C716.161 509.572 714.685 511.049 714.685 512.87C714.685 514.69 716.161 516.167 717.982 516.167C719.803 516.167 721.284 514.69 721.284 512.87C721.284 511.049 719.807 509.572 717.982 509.572Z"
            fill="white"
          />
          <path
            d="M705.91 519.867C704.089 519.867 702.621 521.336 702.621 523.156C702.621 524.977 704.089 526.445 705.91 526.445C707.731 526.445 709.199 524.977 709.199 523.156C709.199 521.336 707.722 519.867 705.91 519.867Z"
            fill="white"
          />
          <path
            d="M693.484 529.025C691.664 529.025 690.195 530.494 690.195 532.314C690.195 534.135 691.664 535.595 693.484 535.595C695.305 535.595 696.76 534.126 696.76 532.314C696.76 530.502 695.292 529.025 693.484 529.025Z"
            fill="white"
          />
          <path
            d="M680.794 537.1C678.982 537.1 677.514 538.568 677.514 540.389C677.514 542.209 678.982 543.669 680.794 543.669C682.606 543.669 684.083 542.201 684.083 540.389C684.083 538.576 682.615 537.1 680.794 537.1Z"
            fill="white"
          />
          <path
            d="M667.941 544.088C666.128 544.088 664.66 545.556 664.66 547.364C664.66 549.172 666.128 550.653 667.941 550.653C669.753 550.653 671.217 549.176 671.217 547.364C671.217 545.552 669.748 544.088 667.941 544.088Z"
            fill="white"
          />
          <path
            d="M654.891 556.601C656.701 556.601 658.168 555.134 658.168 553.325C658.168 551.516 656.701 550.049 654.891 550.049C653.082 550.049 651.615 551.516 651.615 553.325C651.615 555.134 653.082 556.601 654.891 556.601Z"
            fill="white"
          />
          <path
            d="M641.694 555.064C639.882 555.064 638.418 556.533 638.418 558.345C638.418 560.157 639.886 561.625 641.694 561.625C643.502 561.625 644.975 560.157 644.975 558.345C644.975 556.533 643.506 555.064 641.694 555.064Z"
            fill="white"
          />
          <path
            d="M628.443 559.428C626.631 559.428 625.176 560.883 625.176 562.695C625.176 564.507 626.631 565.963 628.443 565.963C630.256 565.963 631.711 564.507 631.711 562.695C631.711 560.883 630.256 559.428 628.443 559.428Z"
            fill="white"
          />
          <path
            d="M615.14 563.328C613.328 563.328 611.872 564.796 611.872 566.596C611.872 568.395 613.328 569.863 615.14 569.863C616.952 569.863 618.399 568.395 618.399 566.596C618.399 564.796 616.943 563.328 615.14 563.328Z"
            fill="white"
          />
          <path
            d="M601.746 566.959C599.947 566.959 598.479 568.415 598.479 570.218C598.479 572.022 599.947 573.486 601.746 573.486C603.546 573.486 605.005 572.018 605.005 570.218C605.005 568.419 603.55 566.959 601.746 566.959Z"
            fill="white"
          />
          <path
            d="M588.374 570.645C586.575 570.645 585.115 572.113 585.115 573.912C585.115 575.712 586.571 577.171 588.374 577.171C590.178 577.171 591.642 575.716 591.642 573.912C591.642 572.109 590.186 570.645 588.374 570.645Z"
            fill="white"
          />
          <path
            d="M575.091 574.498C573.292 574.498 571.832 575.954 571.832 577.757C571.832 579.561 573.288 581.016 575.091 581.016C576.895 581.016 578.35 579.561 578.35 577.757C578.35 575.954 576.895 574.498 575.091 574.498Z"
            fill="white"
          />
          <path
            d="M561.864 578.619C560.073 578.619 558.617 580.075 558.617 581.866C558.617 583.656 560.073 585.125 561.864 585.125C563.655 585.125 565.123 583.669 565.123 581.866C565.123 580.062 563.667 578.619 561.864 578.619Z"
            fill="white"
          />
          <path
            d="M548.687 582.959C546.896 582.959 545.44 584.415 545.44 586.205C545.44 587.996 546.896 589.465 548.687 589.465C550.478 589.465 551.946 588.009 551.946 586.205C551.946 584.402 550.491 582.959 548.687 582.959Z"
            fill="white"
          />
          <path
            d="M535.552 587.279C533.761 587.279 532.306 588.735 532.306 590.526C532.306 592.317 533.761 593.772 535.552 593.772C537.343 593.772 538.799 592.325 538.799 590.526C538.799 588.726 537.343 587.279 535.552 587.279Z"
            fill="white"
          />
          <path
            d="M522.418 591.617C520.627 591.617 519.172 593.073 519.172 594.864C519.172 596.655 520.627 598.11 522.418 598.11C524.209 598.11 525.665 596.655 525.665 594.864C525.665 593.073 524.218 591.617 522.418 591.617Z"
            fill="white"
          />
          <path
            d="M509.25 595.949C507.46 595.949 506.004 597.396 506.004 599.187C506.004 600.978 507.46 602.434 509.25 602.434C511.041 602.434 512.488 600.978 512.488 599.187C512.488 597.396 511.041 595.949 509.25 595.949Z"
            fill="white"
          />
          <path
            d="M496.014 600.037C494.223 600.037 492.768 601.484 492.768 603.275C492.768 605.066 494.223 606.522 496.014 606.522C497.805 606.522 499.252 605.074 499.252 603.275C499.252 601.476 497.805 600.037 496.014 600.037Z"
            fill="white"
          />
          <path
            d="M483.432 610.129C485.173 609.719 486.252 607.976 485.842 606.235C485.433 604.494 483.69 603.415 481.949 603.825C480.208 604.234 479.129 605.978 479.538 607.718C479.948 609.459 481.691 610.538 483.432 610.129Z"
            fill="white"
          />
          <path
            d="M469.201 607.115C467.41 607.115 465.963 608.562 465.963 610.353C465.963 612.144 467.41 613.591 469.201 613.591C470.992 613.591 472.439 612.144 472.439 610.353C472.439 608.562 470.983 607.115 469.201 607.115Z"
            fill="white"
          />
          <path
            d="M455.528 610.008C453.737 610.008 452.29 611.455 452.29 613.254C452.29 615.054 453.737 616.492 455.528 616.492C457.319 616.492 458.775 615.045 458.775 613.254C458.775 611.463 457.327 610.008 455.528 610.008Z"
            fill="white"
          />
          <path
            d="M441.643 612.182C439.852 612.182 438.396 613.629 438.396 615.42C438.396 617.21 439.852 618.658 441.643 618.658C443.434 618.658 444.881 617.21 444.881 615.42C444.881 613.629 443.425 612.182 441.643 612.182Z"
            fill="white"
          />
          <path
            d="M427.435 613.641C425.657 613.641 424.197 615.088 424.197 616.879C424.197 618.669 425.653 620.117 427.435 620.117C429.218 620.117 430.673 618.669 430.673 616.879C430.673 615.088 429.226 613.641 427.435 613.641Z"
            fill="white"
          />
          <path
            d="M412.823 614.307C411.032 614.307 409.585 615.762 409.585 617.553C409.585 619.344 411.032 620.791 412.823 620.791C414.614 620.791 416.061 619.335 416.061 617.553C416.061 615.771 414.605 614.307 412.823 614.307Z"
            fill="white"
          />
          <path
            d="M397.712 613.951C395.921 613.951 394.474 615.398 394.474 617.189C394.474 618.98 395.921 620.414 397.712 620.414C399.502 620.414 400.937 618.967 400.937 617.189C400.937 615.411 399.49 613.951 397.712 613.951Z"
            fill="white"
          />
          <path
            d="M389.959 611.424C388.138 611.424 386.648 612.913 386.648 614.734C386.648 616.555 388.138 618.044 389.959 618.044C391.779 618.044 393.269 616.567 393.269 614.734C393.269 612.901 391.792 611.424 389.959 611.424Z"
            fill="white"
          />
          <path
            d="M382.099 608.666C380.244 608.666 378.746 610.164 378.746 612.019C378.746 613.873 380.244 615.38 382.099 615.38C383.953 615.38 385.451 613.869 385.451 612.019C385.451 610.168 383.953 608.666 382.099 608.666Z"
            fill="white"
          />
          <path
            d="M374.145 605.596C372.273 605.596 370.754 607.115 370.754 608.999C370.754 610.883 372.273 612.394 374.145 612.394C376.016 612.394 377.535 610.875 377.535 608.999C377.535 607.123 376.016 605.596 374.145 605.596Z"
            fill="white"
          />
          <path
            d="M366.113 602.205C364.22 602.205 362.667 603.746 362.667 605.651C362.667 607.556 364.216 609.097 366.113 609.097C368.01 609.097 369.567 607.556 369.567 605.651C369.567 603.746 368.018 602.205 366.113 602.205Z"
            fill="white"
          />
          <path
            d="M358.023 598.424C356.088 598.424 354.505 599.994 354.505 601.942C354.505 603.89 356.088 605.447 358.023 605.447C359.958 605.447 361.541 603.877 361.541 601.942C361.541 600.007 359.971 598.424 358.023 598.424Z"
            fill="white"
          />
          <path
            d="M349.897 594.262C347.933 594.262 346.35 595.845 346.35 597.801C346.35 599.757 347.933 601.349 349.897 601.349C351.862 601.349 353.445 599.766 353.445 597.801C353.445 595.836 351.854 594.262 349.897 594.262Z"
            fill="white"
          />
          <path
            d="M341.737 589.609C339.759 589.609 338.146 591.213 338.146 593.2C338.146 595.186 339.759 596.79 341.737 596.79C343.714 596.79 345.327 595.186 345.327 593.2C345.327 591.213 343.723 589.609 341.737 589.609Z"
            fill="white"
          />
          <path
            d="M333.589 584.436C331.581 584.436 329.956 586.061 329.956 588.068C329.956 590.075 331.581 591.701 333.589 591.701C335.596 591.701 337.221 590.075 337.221 588.068C337.221 586.061 335.596 584.436 333.589 584.436Z"
            fill="white"
          />
          <path
            d="M325.47 578.682C323.428 578.682 321.786 580.328 321.786 582.365C321.786 584.402 323.428 586.049 325.47 586.049C327.511 586.049 329.153 584.394 329.153 582.365C329.153 580.337 327.498 578.682 325.47 578.682Z"
            fill="white"
          />
          <path
            d="M317.402 572.354C315.352 572.354 313.685 574.009 313.685 576.058C313.685 578.108 315.348 579.776 317.402 579.776C319.456 579.776 321.107 578.112 321.107 576.058C321.107 574.004 319.452 572.354 317.402 572.354Z"
            fill="white"
          />
          <path
            d="M309.42 565.369C307.349 565.369 305.664 567.054 305.664 569.125C305.664 571.196 307.349 572.881 309.42 572.881C311.491 572.881 313.175 571.196 313.175 569.125C313.175 567.054 311.491 565.369 309.42 565.369Z"
            fill="white"
          />
          <path
            d="M301.573 557.711C299.481 557.711 297.783 559.408 297.783 561.501C297.783 563.593 299.481 565.278 301.573 565.278C303.665 565.278 305.35 563.58 305.35 561.501C305.35 559.421 303.652 557.711 301.573 557.711Z"
            fill="white"
          />
          <path
            d="M293.9 549.268C291.787 549.268 290.068 550.986 290.068 553.095C290.068 555.205 291.787 556.915 293.9 556.915C296.014 556.915 297.72 555.209 297.72 553.095C297.72 550.982 296.014 549.268 293.9 549.268Z"
            fill="white"
          />
          <path
            d="M286.448 540.045C284.326 540.045 282.599 541.772 282.599 543.907C282.599 546.041 284.326 547.756 286.448 547.756C288.57 547.756 290.31 546.029 290.31 543.907C290.31 541.785 288.582 540.045 286.448 540.045Z"
            fill="white"
          />
          <path
            d="M279.248 530.064C277.092 530.064 275.356 531.8 275.356 533.947C275.356 536.095 277.096 537.839 279.248 537.839C281.4 537.839 283.131 536.103 283.131 533.947C283.131 531.792 281.391 530.064 279.248 530.064Z"
            fill="white"
          />
          <path
            d="M272.224 519.584C270.068 519.584 268.319 521.332 268.319 523.488C268.319 525.644 270.068 527.38 272.224 527.38C274.379 527.38 276.128 525.644 276.128 523.488C276.128 521.332 274.379 519.584 272.224 519.584Z"
            fill="white"
          />
          <path
            d="M265.247 508.861C263.07 508.861 261.313 510.622 261.313 512.795C261.313 514.968 263.07 516.742 265.247 516.742C267.424 516.742 269.194 514.972 269.194 512.795C269.194 510.618 267.437 508.861 265.247 508.861Z"
            fill="white"
          />
          <path
            d="M258.232 498.094C256.047 498.094 254.269 499.863 254.269 502.049C254.269 504.234 256.047 506.004 258.232 506.004C260.418 506.004 262.187 504.234 262.187 502.049C262.187 499.863 260.418 498.094 258.232 498.094Z"
            fill="white"
          />
          <path
            d="M251.073 487.289C248.879 487.289 247.088 489.08 247.088 491.274C247.088 493.468 248.879 495.259 251.073 495.259C253.267 495.259 255.058 493.481 255.058 491.274C255.058 489.067 253.267 487.289 251.073 487.289Z"
            fill="white"
          />
          <path
            d="M243.714 476.588C241.508 476.588 239.717 478.379 239.717 480.585C239.717 482.792 241.508 484.583 243.714 484.583C245.921 484.583 247.721 482.792 247.721 480.585C247.721 478.379 245.921 476.588 243.714 476.588Z"
            fill="white"
          />
          <path
            d="M236.14 465.963C233.912 465.963 232.112 467.775 232.112 469.99C232.112 472.205 233.912 474.018 236.14 474.018C238.368 474.018 240.167 472.218 240.167 469.99C240.167 467.762 238.355 465.963 236.14 465.963Z"
            fill="white"
          />
          <path
            d="M228.343 455.461C226.115 455.461 224.303 457.26 224.303 459.501C224.303 461.742 226.115 463.528 228.343 463.528C230.571 463.528 232.37 461.729 232.37 459.501C232.37 457.273 230.571 455.461 228.343 455.461Z"
            fill="white"
          />
          <path
            d="M220.36 445.041C218.124 445.041 216.312 446.853 216.312 449.081C216.312 451.309 218.124 453.13 220.36 453.13C222.597 453.13 224.409 451.318 224.409 449.081C224.409 446.845 222.597 445.041 220.36 445.041Z"
            fill="white"
          />
          <path
            d="M212.285 434.523C210.048 434.523 208.228 436.344 208.228 438.593C208.228 440.842 210.048 442.654 212.285 442.654C214.521 442.654 216.354 440.834 216.354 438.593C216.354 436.353 214.534 434.523 212.285 434.523Z"
            fill="white"
          />
          <path
            d="M204.196 423.883C201.947 423.883 200.118 425.703 200.118 427.953C200.118 430.202 201.951 432.022 204.196 432.022C206.441 432.022 208.266 430.202 208.266 427.953C208.266 425.703 206.446 423.883 204.196 423.883Z"
            fill="white"
          />
          <path
            d="M196.129 413.01C193.88 413.01 192.06 414.83 192.06 417.08C192.06 419.329 193.88 421.149 196.129 421.149C198.379 421.149 200.199 419.329 200.199 417.08C200.199 414.83 198.379 413.01 196.129 413.01Z"
            fill="white"
          />
          <path
            d="M188.168 401.746C185.919 401.746 184.09 403.579 184.09 405.824C184.09 408.069 185.923 409.903 188.168 409.903C190.413 409.903 192.259 408.082 192.259 405.824C192.259 403.567 190.426 401.746 188.168 401.746Z"
            fill="white"
          />
          <path
            d="M180.342 390.059C178.093 390.059 176.264 391.892 176.264 394.137C176.264 396.382 178.097 398.215 180.342 398.215C182.587 398.215 184.42 396.395 184.42 394.137C184.42 391.879 182.6 390.059 180.342 390.059Z"
            fill="white"
          />
          <path
            d="M172.703 377.852C170.446 377.852 168.625 379.685 168.625 381.93C168.625 384.175 170.446 386.008 172.703 386.008C174.961 386.008 176.781 384.187 176.781 381.93C176.781 379.672 174.948 377.852 172.703 377.852Z"
            fill="white"
          />
          <path
            d="M165.239 365.205C162.982 365.205 161.161 367.038 161.161 369.283C161.161 371.528 162.982 373.362 165.239 373.362C167.497 373.362 169.318 371.541 169.318 369.283C169.318 367.026 167.484 365.205 165.239 365.205Z"
            fill="white"
          />
          <path
            d="M157.894 352.484C155.644 352.484 153.815 354.305 153.815 356.563C153.815 358.82 155.649 360.641 157.894 360.641C160.139 360.641 161.972 358.808 161.972 356.563C161.972 354.318 160.151 352.484 157.894 352.484Z"
            fill="white"
          />
          <path
            d="M150.585 340.08C148.327 340.08 146.507 341.901 146.507 344.158C146.507 346.416 148.327 348.228 150.585 348.228C152.843 348.228 154.663 346.408 154.663 344.158C154.663 341.909 152.83 340.08 150.585 340.08Z"
            fill="white"
          />
          <path
            d="M157.787 323.779C155.537 323.779 153.717 325.6 153.717 327.849C153.717 330.098 155.537 331.927 157.787 331.927C160.036 331.927 161.865 330.094 161.865 327.849C161.865 325.604 160.031 323.779 157.787 323.779Z"
            fill="white"
          />
          <path
            d="M165.117 308.002C162.867 308.002 161.047 309.823 161.047 312.072C161.047 314.321 162.867 316.129 165.117 316.129C167.366 316.129 169.174 314.317 169.174 312.072C169.174 309.827 167.353 308.002 165.117 308.002Z"
            fill="white"
          />
          <path
            d="M172.631 293.09C170.395 293.09 168.574 294.902 168.574 297.147C168.574 299.392 170.395 301.204 172.631 301.204C174.868 301.204 176.688 299.383 176.688 297.147C176.688 294.91 174.868 293.09 172.631 293.09Z"
            fill="white"
          />
          <path
            d="M180.321 279.381C178.085 279.381 176.272 281.193 176.272 283.429C176.272 285.666 178.085 287.478 180.321 287.478C182.557 287.478 184.37 285.666 184.37 283.429C184.37 281.193 182.557 279.381 180.321 279.381Z"
            fill="white"
          />
          <path
            d="M188.146 267.025C185.918 267.025 184.119 268.825 184.119 271.044C184.119 273.264 185.918 275.063 188.146 275.063C190.374 275.063 192.165 273.264 192.165 271.044C192.165 268.825 190.366 267.025 188.146 267.025Z"
            fill="white"
          />
          <path
            d="M195.87 256.131C193.655 256.131 191.864 257.93 191.864 260.137C191.864 262.344 193.655 264.143 195.87 264.143C198.086 264.143 199.876 262.352 199.876 260.137C199.876 257.922 198.077 256.131 195.87 256.131Z"
            fill="white"
          />
          <path
            d="M203.322 246.504C201.115 246.504 199.337 248.282 199.337 250.489C199.337 252.696 201.115 254.474 203.322 254.474C205.529 254.474 207.307 252.683 207.307 250.489C207.307 248.295 205.516 246.504 203.322 246.504Z"
            fill="white"
          />
          <path
            d="M210.338 237.926C208.152 237.926 206.374 239.704 206.374 241.902C206.374 244.1 208.152 245.866 210.338 245.866C212.523 245.866 214.314 244.096 214.314 241.902C214.314 239.708 212.536 237.926 210.338 237.926Z"
            fill="white"
          />
          <path
            d="M216.885 230.184C214.708 230.184 212.938 231.953 212.938 234.126C212.938 236.299 214.708 238.068 216.885 238.068C219.062 238.068 220.828 236.299 220.828 234.126C220.828 231.953 219.058 230.184 216.885 230.184Z"
            fill="white"
          />
          <path
            d="M222.982 223.043C220.805 223.043 219.057 224.804 219.057 226.977C219.057 229.15 220.805 230.902 222.982 230.902C225.159 230.902 226.908 229.145 226.908 226.977C226.908 224.808 225.151 223.043 222.982 223.043Z"
            fill="white"
          />
          <path
            d="M228.657 216.645C226.501 216.645 224.753 218.393 224.753 220.549C224.753 222.705 226.501 224.453 228.657 224.453C230.813 224.453 232.561 222.705 232.561 220.549C232.561 218.393 230.813 216.645 228.657 216.645Z"
            fill="white"
          />
          <path
            d="M233.861 211.211C231.726 211.211 229.99 212.938 229.99 215.073C229.99 217.207 231.726 218.943 233.861 218.943C235.995 218.943 237.731 217.216 237.731 215.073C237.731 212.93 235.991 211.211 233.861 211.211Z"
            fill="white"
          />
          <path
            d="M238.562 206.629C236.44 206.629 234.722 208.348 234.722 210.47C234.722 212.591 236.44 214.302 238.562 214.302C240.684 214.302 242.394 212.583 242.394 210.47C242.394 208.356 240.676 206.629 238.562 206.629Z"
            fill="white"
          />
          <path
            d="M242.776 202.613C240.675 202.613 238.965 204.319 238.965 206.424C238.965 208.529 240.671 210.222 242.776 210.222C244.881 210.222 246.587 208.525 246.587 206.424C246.587 204.324 244.881 202.613 242.776 202.613Z"
            fill="white"
          />
          <path
            d="M246.516 198.988C244.436 198.988 242.747 200.673 242.747 202.757C242.747 204.84 244.432 206.534 246.516 206.534C248.599 206.534 250.292 204.849 250.292 202.757C250.292 200.665 248.608 198.988 246.516 198.988Z"
            fill="white"
          />
          <path
            d="M249.774 195.658C247.711 195.658 246.039 197.334 246.039 199.405C246.039 201.476 247.715 203.153 249.774 203.153C251.832 203.153 253.521 201.476 253.521 199.405C253.521 197.334 251.845 195.658 249.774 195.658Z"
            fill="white"
          />
          <path
            d="M252.55 192.588C250.521 192.588 248.866 194.234 248.866 196.271C248.866 198.308 250.521 199.955 252.55 199.955C254.578 199.955 256.246 198.304 256.246 196.271C256.246 194.239 254.591 192.588 252.55 192.588Z"
            fill="white"
          />
          <path
            d="M254.871 189.652C252.851 189.652 251.217 191.286 251.217 193.306C251.217 195.326 252.851 196.96 254.871 196.96C256.891 196.96 258.525 195.326 258.525 193.306C258.525 191.286 256.891 189.652 254.871 189.652Z"
            fill="white"
          />
          <path
            d="M256.768 186.822C254.782 186.822 253.156 188.439 253.156 190.434C253.156 192.428 254.782 194.045 256.768 194.045C258.754 194.045 260.379 192.432 260.379 190.434C260.379 188.435 258.766 186.822 256.768 186.822Z"
            fill="white"
          />
          <path
            d="M258.275 184.064C256.306 184.064 254.706 185.669 254.706 187.646C254.706 189.624 256.31 191.215 258.275 191.215C260.24 191.215 261.857 189.62 261.857 187.646C261.857 185.673 260.253 184.064 258.275 184.064Z"
            fill="white"
          />
          <path
            d="M259.454 181.393C257.518 181.393 255.936 182.971 255.936 184.906C255.936 186.842 257.518 188.424 259.454 188.424C261.389 188.424 262.972 186.854 262.972 184.906C262.972 182.959 261.401 181.393 259.454 181.393Z"
            fill="white"
          />
          <path
            d="M260.325 178.762C258.411 178.762 256.857 180.315 256.857 182.225C256.857 184.134 258.406 185.692 260.325 185.692C262.243 185.692 263.792 184.139 263.792 182.225C263.792 180.311 262.243 178.762 260.325 178.762Z"
            fill="white"
          />
          <path
            d="M260.932 176.158C259.047 176.158 257.507 177.69 257.507 179.583C257.507 181.476 259.047 183.003 260.932 183.003C262.816 183.003 264.356 181.467 264.356 179.583C264.356 177.699 262.824 176.158 260.932 176.158Z"
            fill="white"
          />
          <path
            d="M261.304 173.523C259.433 173.523 257.922 175.043 257.922 176.906C257.922 178.769 259.433 180.279 261.304 180.279C263.176 180.279 264.678 178.769 264.678 176.906C264.678 175.043 263.167 173.523 261.304 173.523Z"
            fill="white"
          />
          <path
            d="M261.461 170.85C259.641 170.85 258.164 172.326 258.164 174.147C258.164 175.968 259.641 177.449 261.461 177.449C263.282 177.449 264.772 175.972 264.772 174.147C264.772 172.322 263.295 170.85 261.461 170.85Z"
            fill="white"
          />
          <path
            d="M261.47 167.971C259.671 167.971 258.211 169.422 258.211 171.221C258.211 173.021 259.667 174.468 261.47 174.468C263.274 174.468 264.717 173.012 264.717 171.221C264.717 169.431 263.261 167.971 261.47 167.971Z"
            fill="white"
          />
          <path
            d="M261.377 164.832C259.607 164.832 258.173 166.266 258.173 168.036C258.173 169.806 259.611 171.24 261.377 171.24C263.142 171.24 264.581 169.806 264.581 168.036C264.581 166.266 263.147 164.832 261.377 164.832Z"
            fill="white"
          />
          <path
            d="M261.305 161.33C259.578 161.33 258.16 162.739 258.16 164.479C258.16 166.219 259.578 167.624 261.305 167.624C263.032 167.624 264.458 166.219 264.458 164.479C264.458 162.739 263.04 161.33 261.305 161.33Z"
            fill="white"
          />
          <path
            d="M261.449 157.287C259.752 157.287 258.377 158.662 258.377 160.351C258.377 162.04 259.752 163.415 261.449 163.415C263.147 163.415 264.518 162.04 264.518 160.351C264.518 158.662 263.143 157.287 261.449 157.287Z"
            fill="white"
          />
          <path
            d="M262.064 152.436C260.401 152.436 259.056 153.785 259.056 155.444C259.056 157.104 260.397 158.453 262.064 158.453C263.732 158.453 265.061 157.099 265.061 155.444C265.061 153.789 263.72 152.436 262.064 152.436Z"
            fill="white"
          />
          <path
            d="M263.541 146.443C261.916 146.443 260.604 147.767 260.604 149.389C260.604 151.01 261.916 152.334 263.541 152.334C265.167 152.334 266.486 151.01 266.486 149.389C266.486 147.767 265.175 146.443 263.541 146.443Z"
            fill="white"
          />
          <path
            d="M266.634 138.635C265.03 138.635 263.74 139.925 263.74 141.529C263.74 143.133 265.03 144.423 266.634 144.423C268.239 144.423 269.529 143.12 269.529 141.529C269.529 139.938 268.226 138.635 266.634 138.635Z"
            fill="white"
          />
          <path
            d="M282.306 134.713C280.702 134.713 279.412 136.003 279.412 137.607C279.412 139.211 280.702 140.489 282.306 140.489C283.91 140.489 285.188 139.199 285.188 137.607C285.188 136.016 283.898 134.713 282.306 134.713Z"
            fill="white"
          />
          <path
            d="M300.27 127.83C298.679 127.83 297.389 129.12 297.389 130.72C297.389 132.32 298.679 133.61 300.27 133.61C301.862 133.61 303.164 132.32 303.164 130.72C303.164 129.12 301.874 127.83 300.27 127.83Z"
            fill="white"
          />
          <path
            d="M321.235 116.988C319.644 116.988 318.354 118.291 318.354 119.883C318.354 121.474 319.644 122.777 321.235 122.777C322.826 122.777 324.129 121.487 324.129 119.883C324.129 118.278 322.839 116.988 321.235 116.988Z"
            fill="white"
          />
          <path
            d="M345.348 101.541C343.744 101.541 342.454 102.831 342.454 104.435C342.454 106.039 343.744 107.325 345.348 107.325C346.952 107.325 348.243 106.031 348.243 104.435C348.243 102.84 346.94 101.541 345.348 101.541Z"
            fill="white"
          />
          <path
            d="M372.388 81.1406C370.784 81.1406 369.494 82.4435 369.494 84.0433C369.494 85.6432 370.784 86.9376 372.388 86.9376C373.993 86.9376 375.283 85.6348 375.283 84.0433C375.283 82.4519 373.993 81.1406 372.388 81.1406Z"
            fill="white"
          />
          <path
            d="M400.822 56.6836C399.218 56.6836 397.919 57.9779 397.919 59.5821C397.919 61.1862 399.222 62.4806 400.822 62.4806C402.422 62.4806 403.716 61.1862 403.716 59.5821C403.716 57.9779 402.426 56.6836 400.822 56.6836Z"
            fill="white"
          />
          <path
            d="M429.018 29.9434C427.414 29.9434 426.115 31.2462 426.115 32.8461C426.115 34.446 427.418 35.7446 429.018 35.7446C430.618 35.7446 431.912 34.4502 431.912 32.8461C431.912 31.2419 430.622 29.9434 429.018 29.9434Z"
            fill="white"
          />
          <path
            d="M455.222 4.25977C453.618 4.25977 452.319 5.5626 452.319 7.16249C452.319 8.76238 453.622 10.0652 455.222 10.0652C456.822 10.0652 458.125 8.76238 458.125 7.16249C458.125 5.5626 456.835 4.25977 455.222 4.25977Z"
            fill="white"
          />
          <path
            d="M847.455 2.30859C845.634 2.30859 844.166 3.78117 844.166 5.60174C844.166 7.42231 845.634 8.89065 847.455 8.89065C849.275 8.89065 850.744 7.41807 850.744 5.60174C850.744 3.78542 849.275 2.30859 847.455 2.30859Z"
            fill="white"
          />
          <path
            d="M854.369 13.9492C852.515 13.9492 851.029 15.4473 851.029 17.2975C851.029 19.1478 852.519 20.6416 854.369 20.6416C856.219 20.6416 857.709 19.1436 857.709 17.2975C857.709 15.4515 856.211 13.9492 854.369 13.9492Z"
            fill="white"
          />
          <path
            d="M861.028 26.3457C859.156 26.3457 857.637 27.865 857.637 29.7449C857.637 31.6249 859.156 33.1442 861.028 33.1442C862.899 33.1442 864.431 31.6249 864.431 29.7449C864.431 27.865 862.912 26.3457 861.028 26.3457Z"
            fill="white"
          />
          <path
            d="M867.41 39.5527C865.504 39.5527 863.964 41.0932 863.964 42.9987C863.964 44.9041 865.504 46.4488 867.41 46.4488C869.315 46.4488 870.864 44.9041 870.864 42.9987C870.864 41.0932 869.315 39.5527 867.41 39.5527Z"
            fill="white"
          />
          <path
            d="M873.495 53.5293C871.56 53.5293 869.985 55.0995 869.985 57.0474C869.985 58.9952 871.556 60.5569 873.495 60.5569C875.434 60.5569 877.013 58.9868 877.013 57.0474C877.013 55.108 875.443 53.5293 873.495 53.5293Z"
            fill="white"
          />
          <path
            d="M879.306 68.2344C877.349 68.2344 875.758 69.8258 875.758 71.7949C875.758 73.764 877.349 75.3554 879.306 75.3554C881.262 75.3554 882.866 73.7597 882.866 71.7949C882.866 69.83 881.275 68.2344 879.306 68.2344Z"
            fill="white"
          />
          <path
            d="M884.894 83.5039C882.904 83.5039 881.291 85.1165 881.291 87.1111C881.291 89.1057 882.904 90.7183 884.894 90.7183C886.884 90.7183 888.497 89.1057 888.497 87.1111C888.497 85.1165 886.884 83.5039 884.894 83.5039Z"
            fill="white"
          />
          <path
            d="M890.326 99.2051C888.306 99.2051 886.672 100.843 886.672 102.859C886.672 104.875 888.306 106.509 890.326 106.509C892.346 106.509 893.98 104.875 893.98 102.859C893.98 100.843 892.333 99.2051 890.326 99.2051Z"
            fill="white"
          />
          <path
            d="M895.677 115.188C893.627 115.188 891.964 116.847 891.964 118.905C891.964 120.963 893.627 122.618 895.677 122.618C897.727 122.618 899.395 120.955 899.395 118.905C899.395 116.855 897.731 115.188 895.677 115.188Z"
            fill="white"
          />
          <path
            d="M901.058 138.762C903.127 138.762 904.805 137.084 904.805 135.015C904.805 132.945 903.127 131.268 901.058 131.268C898.988 131.268 897.311 132.945 897.311 135.015C897.311 137.084 898.988 138.762 901.058 138.762Z"
            fill="white"
          />
          <path
            d="M906.634 147.066C904.533 147.066 902.836 148.764 902.836 150.856C902.836 152.948 904.533 154.65 906.634 154.65C908.735 154.65 910.424 152.952 910.424 150.856C910.424 148.76 908.726 147.066 906.634 147.066Z"
            fill="white"
          />
          <path
            d="M912.525 162.252C910.412 162.252 908.697 163.971 908.697 166.084C908.697 168.197 910.416 169.912 912.525 169.912C914.634 169.912 916.357 168.193 916.357 166.084C916.357 163.975 914.639 162.252 912.525 162.252Z"
            fill="white"
          />
          <path
            d="M918.835 176.496C916.692 176.496 914.965 178.236 914.965 180.379C914.965 182.522 916.692 184.249 918.835 184.249C920.978 184.249 922.718 182.518 922.718 180.379C922.718 178.24 920.978 176.496 918.835 176.496Z"
            fill="white"
          />
          <path
            d="M925.579 189.809C923.414 189.809 921.666 191.557 921.666 193.717C921.666 195.877 923.414 197.626 925.579 197.626C927.743 197.626 929.483 195.877 929.483 193.717C929.483 191.557 927.735 189.809 925.579 189.809Z"
            fill="white"
          />
          <path
            d="M932.729 202.217C930.552 202.217 928.795 203.974 928.795 206.151C928.795 208.328 930.556 210.085 932.729 210.085C934.902 210.085 936.663 208.328 936.663 206.151C936.663 203.974 934.906 202.217 932.729 202.217Z"
            fill="white"
          />
          <path
            d="M940.284 213.742C938.09 213.742 936.308 215.52 936.308 217.706C936.308 219.891 938.086 221.67 940.284 221.67C942.482 221.67 944.248 219.9 944.248 217.706C944.248 215.512 942.469 213.742 940.284 213.742Z"
            fill="white"
          />
          <path
            d="M948.228 224.346C946.013 224.346 944.209 226.145 944.209 228.365C944.209 230.584 946.008 232.371 948.228 232.371C950.447 232.371 952.234 230.58 952.234 228.365C952.234 226.149 950.443 224.346 948.228 224.346Z"
            fill="white"
          />
          <path
            d="M956.542 234.043C954.314 234.043 952.502 235.855 952.502 238.07C952.502 240.286 954.314 242.11 956.542 242.11C958.77 242.11 960.569 240.298 960.569 238.07C960.569 235.842 958.757 234.043 956.542 234.043Z"
            fill="white"
          />
          <path
            d="M965.19 242.725C962.941 242.725 961.12 244.545 961.12 246.782C961.12 249.018 962.941 250.851 965.19 250.851C967.439 250.851 969.247 249.031 969.247 246.782C969.247 244.532 967.426 242.725 965.19 242.725Z"
            fill="white"
          />
          <path
            d="M974.098 250.385C971.84 250.385 970.02 252.205 970.02 254.463C970.02 256.721 971.84 258.541 974.098 258.541C976.355 258.541 978.176 256.708 978.176 254.463C978.176 252.218 976.343 250.385 974.098 250.385Z"
            fill="white"
          />
          <path
            d="M983.205 257.014C980.935 257.014 979.105 258.847 979.105 261.113C979.105 263.379 980.939 265.225 983.205 265.225C985.471 265.225 987.317 263.384 987.317 261.113C987.317 258.843 985.475 257.014 983.205 257.014Z"
            fill="white"
          />
          <path
            d="M992.448 262.709C990.169 262.709 988.327 264.551 988.327 266.83C988.327 269.109 990.169 270.95 992.448 270.95C994.727 270.95 996.569 269.096 996.569 266.83C996.569 264.564 994.727 262.709 992.448 262.709Z"
            fill="white"
          />
          <path
            d="M1001.73 267.504C999.442 267.504 997.592 269.354 997.592 271.646C997.592 273.937 999.446 275.788 1001.73 275.788C1004.02 275.788 1005.88 273.933 1005.88 271.646C1005.88 269.358 1004.03 267.504 1001.73 267.504Z"
            fill="white"
          />
          <path
            d="M1011.03 271.512C1008.73 271.512 1006.87 273.366 1006.87 275.654C1006.87 277.941 1008.73 279.808 1011.03 279.808C1013.33 279.808 1015.18 277.954 1015.18 275.654C1015.18 273.354 1013.32 271.512 1011.03 271.512Z"
            fill="white"
          />
          <path
            d="M1020.26 274.805C1017.97 274.805 1016.1 276.668 1016.1 278.959C1016.1 281.251 1017.96 283.114 1020.26 283.114C1022.55 283.114 1024.41 281.259 1024.41 278.959C1024.41 276.659 1022.56 274.805 1020.26 274.805Z"
            fill="white"
          />
          <path
            d="M1029.41 277.498C1027.11 277.498 1025.25 279.361 1025.25 281.653C1025.25 283.944 1027.11 285.807 1029.41 285.807C1031.7 285.807 1033.56 283.953 1033.56 281.653C1033.56 279.353 1031.7 277.498 1029.41 277.498Z"
            fill="white"
          />
          <path
            d="M1038.44 279.764C1036.15 279.764 1034.29 281.627 1034.29 283.914C1034.29 286.201 1036.15 288.069 1038.44 288.069C1040.73 288.069 1042.6 286.218 1042.6 283.914C1042.6 281.61 1040.74 279.764 1038.44 279.764Z"
            fill="white"
          />
          <path
            d="M1047.37 281.705C1045.07 281.705 1043.22 283.568 1043.22 285.86C1043.22 288.151 1045.07 290.014 1047.37 290.014C1049.67 290.014 1051.53 288.164 1051.53 285.86C1051.53 283.555 1049.66 281.705 1047.37 281.705Z"
            fill="white"
          />
          <path
            d="M1056.2 283.389C1053.9 283.389 1052.04 285.252 1052.04 287.543C1052.04 289.835 1053.89 291.698 1056.2 291.698C1058.5 291.698 1060.35 289.848 1060.35 287.543C1060.35 285.239 1058.49 283.389 1056.2 283.389Z"
            fill="white"
          />
          <path
            d="M1051.25 284.5C1048.97 284.5 1047.1 286.355 1047.1 288.655C1047.1 290.955 1048.96 292.809 1051.25 292.809C1053.54 292.809 1055.41 290.946 1055.41 288.655C1055.41 286.363 1053.56 284.5 1051.25 284.5Z"
            fill="white"
          />
          <path
            d="M1046.13 285.582C1043.84 285.582 1041.98 287.437 1041.98 289.737C1041.98 292.037 1043.84 293.891 1046.13 293.891C1048.42 293.891 1050.29 292.028 1050.29 289.737C1050.29 287.445 1048.43 285.582 1046.13 285.582Z"
            fill="white"
          />
          <path
            d="M1040.81 286.666C1038.51 286.666 1036.65 288.529 1036.65 290.821C1036.65 293.112 1038.51 294.975 1040.81 294.975C1043.11 294.975 1044.97 293.121 1044.97 290.821C1044.97 288.521 1043.1 286.666 1040.81 286.666Z"
            fill="white"
          />
          <path
            d="M1035.26 287.789C1032.97 287.789 1031.1 289.644 1031.1 291.944C1031.1 294.244 1032.97 296.098 1035.26 296.098C1037.55 296.098 1039.41 294.235 1039.41 291.944C1039.41 289.652 1037.56 287.789 1035.26 287.789Z"
            fill="white"
          />
          <path
            d="M1029.47 288.965C1027.18 288.965 1025.32 290.828 1025.32 293.119C1025.32 295.411 1027.18 297.274 1029.47 297.274C1031.76 297.274 1033.62 295.411 1033.62 293.119C1033.62 290.828 1031.77 288.965 1029.47 288.965Z"
            fill="white"
          />
          <path
            d="M1023.43 290.238C1021.14 290.238 1019.28 292.101 1019.28 294.393C1019.28 296.685 1021.14 298.548 1023.43 298.548C1025.72 298.548 1027.59 296.693 1027.59 294.393C1027.59 292.093 1025.74 290.238 1023.43 290.238Z"
            fill="white"
          />
          <path
            d="M1017.15 291.602C1014.85 291.602 1012.99 293.465 1012.99 295.756C1012.99 298.048 1014.85 299.907 1017.15 299.907C1019.44 299.907 1021.31 298.056 1021.31 295.756C1021.31 293.456 1019.45 291.602 1017.15 291.602Z"
            fill="white"
          />
          <path
            d="M1010.61 293.055C1008.32 293.055 1006.46 294.905 1006.46 297.209C1006.46 299.514 1008.32 301.364 1010.61 301.364C1012.9 301.364 1014.77 299.501 1014.77 297.209C1014.77 294.918 1012.91 293.055 1010.61 293.055Z"
            fill="white"
          />
          <path
            d="M1003.81 294.617C1001.52 294.617 999.657 296.467 999.657 298.772C999.657 301.076 1001.52 302.926 1003.81 302.926C1006.1 302.926 1007.97 301.063 1007.97 298.772C1007.97 296.48 1006.11 294.617 1003.81 294.617Z"
            fill="white"
          />
          <path
            d="M996.768 296.316C994.476 296.316 992.626 298.171 992.626 300.458C992.626 302.746 994.476 304.6 996.768 304.6C999.06 304.6 1000.91 302.75 1000.91 300.458C1000.91 298.167 999.055 296.316 996.768 296.316Z"
            fill="white"
          />
          <path
            d="M989.461 298.156C987.182 298.156 985.327 300.011 985.327 302.298C985.327 304.586 987.177 306.432 989.461 306.432C991.744 306.432 993.602 304.577 993.602 302.298C993.602 300.019 991.748 298.156 989.461 298.156Z"
            fill="white"
          />
          <path
            d="M981.914 300.221C979.644 300.221 977.802 302.054 977.802 304.32C977.802 306.586 979.644 308.432 981.914 308.432C984.184 308.432 986.013 306.591 986.013 304.32C986.013 302.05 984.18 300.221 981.914 300.221Z"
            fill="white"
          />
          <path
            d="M974.118 302.465C971.861 302.465 970.027 304.298 970.027 306.556C970.027 308.813 971.861 310.647 974.118 310.647C976.376 310.647 978.209 308.813 978.209 306.556C978.209 304.298 976.376 302.465 974.118 302.465Z"
            fill="white"
          />
          <path
            d="M966.116 304.951C963.879 304.951 962.059 306.772 962.059 309.008C962.059 311.245 963.879 313.078 966.116 313.078C968.352 313.078 970.173 311.257 970.173 309.008C970.173 306.759 968.361 304.951 966.116 304.951Z"
            fill="white"
          />
          <path
            d="M957.937 307.691C955.701 307.691 953.889 309.503 953.889 311.731C953.889 313.959 955.701 315.78 957.937 315.78C960.174 315.78 961.977 313.968 961.977 311.731C961.977 309.495 960.165 307.691 957.937 307.691Z"
            fill="white"
          />
          <path
            d="M949.612 310.697C947.396 310.697 945.605 312.488 945.605 314.703C945.605 316.919 947.396 318.701 949.612 318.701C951.827 318.701 953.609 316.91 953.609 314.703C953.609 312.497 951.818 310.697 949.612 310.697Z"
            fill="white"
          />
          <path
            d="M941.191 313.938C938.997 313.938 937.206 315.716 937.206 317.922C937.206 320.129 938.997 321.907 941.191 321.907C943.385 321.907 945.176 320.116 945.176 317.922C945.176 315.728 943.398 313.938 941.191 313.938Z"
            fill="white"
          />
          <path
            d="M932.716 317.432C930.53 317.432 928.761 319.21 928.761 321.387C928.761 323.564 930.53 325.35 932.716 325.35C934.901 325.35 936.671 323.572 936.671 321.387C936.671 319.201 934.901 317.432 932.716 317.432Z"
            fill="white"
          />
          <path
            d="M924.141 321.316C921.977 321.316 920.216 323.078 920.216 325.242C920.216 327.406 921.977 329.167 924.141 329.167C926.306 329.167 928.075 327.41 928.075 325.242C928.075 323.073 926.314 321.316 924.141 321.316Z"
            fill="white"
          />
          <path
            d="M915.484 333.395C917.628 333.395 919.367 331.656 919.367 329.512C919.367 327.367 917.628 325.629 915.484 325.629C913.339 325.629 911.601 327.367 911.601 329.512C911.601 331.656 913.339 333.395 915.484 333.395Z"
            fill="white"
          />
          <path
            d="M906.748 330.41C904.614 330.41 902.899 332.129 902.899 334.259C902.899 336.39 904.618 338.108 906.748 338.108C908.879 338.108 910.598 336.381 910.598 334.259C910.598 332.137 908.87 330.41 906.748 330.41Z"
            fill="white"
          />
          <path
            d="M897.965 335.666C895.865 335.666 894.154 337.372 894.154 339.477C894.154 341.582 895.86 343.296 897.965 343.296C900.07 343.296 901.785 341.59 901.785 339.477C901.785 337.364 900.079 335.666 897.965 335.666Z"
            fill="white"
          />
          <path
            d="M889.16 341.422C887.068 341.422 885.383 343.107 885.383 345.199C885.383 347.291 887.068 348.976 889.16 348.976C891.252 348.976 892.937 347.278 892.937 345.199C892.937 343.119 891.239 341.422 889.16 341.422Z"
            fill="white"
          />
          <path
            d="M880.323 347.686C878.261 347.686 876.589 349.349 876.589 351.412C876.589 353.474 878.265 355.146 880.323 355.146C882.382 355.146 884.049 353.47 884.049 351.412C884.049 349.353 882.386 347.686 880.323 347.686Z"
            fill="white"
          />
          <path
            d="M871.467 354.482C869.426 354.482 867.783 356.137 867.783 358.166C867.783 360.195 869.43 361.85 871.467 361.85C873.504 361.85 875.15 360.207 875.15 358.166C875.15 356.125 873.495 354.482 871.467 354.482Z"
            fill="white"
          />
          <path
            d="M862.581 361.844C860.573 361.844 858.939 363.478 858.939 365.485C858.939 367.492 860.573 369.139 862.581 369.139C864.588 369.139 866.234 367.505 866.234 365.485C866.234 363.465 864.601 361.844 862.581 361.844Z"
            fill="white"
          />
          <path
            d="M853.682 369.783C851.683 369.783 850.07 371.396 850.07 373.395C850.07 375.393 851.683 377.006 853.682 377.006C855.681 377.006 857.293 375.381 857.293 373.395C857.293 371.409 855.668 369.783 853.682 369.783Z"
            fill="white"
          />
          <path
            d="M844.761 378.371C842.805 378.371 841.222 379.963 841.222 381.919C841.222 383.875 842.805 385.467 844.761 385.467C846.717 385.467 848.309 383.875 848.309 381.919C848.309 379.963 846.726 378.371 844.761 378.371Z"
            fill="white"
          />
          <path
            d="M835.832 387.51C833.897 387.51 832.335 389.08 832.335 391.015C832.335 392.95 833.897 394.512 835.832 394.512C837.767 394.512 839.329 392.942 839.329 391.015C839.329 389.088 837.767 387.51 835.832 387.51Z"
            fill="white"
          />
          <path
            d="M826.954 397.303C825.049 397.303 823.5 398.852 823.5 400.757C823.5 402.663 825.049 404.212 826.954 404.212C828.86 404.212 830.409 402.671 830.409 400.757C830.409 398.843 828.86 397.303 826.954 397.303Z"
            fill="white"
          />
          <path
            d="M818.262 407.867C816.378 407.867 814.858 409.399 814.858 411.271C814.858 413.142 816.378 414.683 818.262 414.683C820.146 414.683 821.665 413.151 821.665 411.271C821.665 409.391 820.146 407.867 818.262 407.867Z"
            fill="white"
          />
          <path
            d="M813.213 421.832C811.392 421.832 809.924 423.309 809.924 425.121C809.924 426.933 811.392 428.41 813.213 428.41C815.033 428.41 816.502 426.942 816.502 425.121C816.502 423.3 815.025 421.832 813.213 421.832Z"
            fill="white"
          />
          <path
            d="M802.056 431.885C800.244 431.885 798.768 433.353 798.768 435.174C798.768 436.994 800.244 438.454 802.056 438.454C803.869 438.454 805.345 436.986 805.345 435.174C805.345 433.362 803.869 431.885 802.056 431.885Z"
            fill="white"
          />
          <path
            d="M790.949 442.504C789.137 442.504 787.669 443.981 787.669 445.793C787.669 447.605 789.137 449.073 790.949 449.073C792.761 449.073 794.23 447.605 794.23 445.793C794.23 443.981 792.761 442.504 790.949 442.504Z"
            fill="white"
          />
          <path
            d="M779.929 453.754C778.129 453.754 776.661 455.21 776.661 457.022C776.661 458.834 778.129 460.289 779.929 460.289C781.728 460.289 783.209 458.821 783.209 457.022C783.209 455.222 781.741 453.754 779.929 453.754Z"
            fill="white"
          />
          <path
            d="M768.981 465.389C767.181 465.389 765.713 466.844 765.713 468.648C765.713 470.451 767.181 471.916 768.981 471.916C770.78 471.916 772.248 470.46 772.248 468.648C772.248 466.836 770.793 465.389 768.981 465.389Z"
            fill="white"
          />
          <path
            d="M758.103 477.35C756.304 477.35 754.844 478.818 754.844 480.617C754.844 482.417 756.299 483.876 758.103 483.876C759.907 483.876 761.362 482.421 761.362 480.617C761.362 478.814 759.907 477.35 758.103 477.35Z"
            fill="white"
          />
          <path
            d="M747.189 489.393C745.39 489.393 743.93 490.848 743.93 492.652C743.93 494.455 745.385 495.911 747.189 495.911C748.993 495.911 750.448 494.455 750.448 492.652C750.448 490.848 748.993 489.393 747.189 489.393Z"
            fill="white"
          />
          <path
            d="M736.797 507.578C738.549 507.164 739.634 505.409 739.221 503.657C738.807 501.905 737.052 500.82 735.3 501.234C733.548 501.647 732.463 503.403 732.877 505.154C733.29 506.906 735.045 507.991 736.797 507.578Z"
            fill="white"
          />
          <path
            d="M724.654 512.299C722.863 512.299 721.407 513.746 721.407 515.545C721.407 517.345 722.863 518.792 724.654 518.792C726.445 518.792 727.9 517.336 727.9 515.545C727.9 513.754 726.445 512.299 724.654 512.299Z"
            fill="white"
          />
          <path
            d="M712.933 522.664C711.142 522.664 709.687 524.111 709.687 525.902C709.687 527.693 711.142 529.149 712.933 529.149C714.724 529.149 716.179 527.701 716.179 525.902C716.179 524.103 714.724 522.664 712.933 522.664Z"
            fill="white"
          />
          <path
            d="M700.83 532.035C699.039 532.035 697.592 533.491 697.592 535.282C697.592 537.072 699.039 538.52 700.83 538.52C702.621 538.52 704.076 537.072 704.076 535.282C704.076 533.491 702.621 532.035 700.83 532.035Z"
            fill="white"
          />
          <path
            d="M688.361 540.205C686.57 540.205 685.123 541.652 685.123 543.443C685.123 545.234 686.57 546.69 688.361 546.69C690.152 546.69 691.599 545.234 691.599 543.443C691.599 541.652 690.152 540.205 688.361 540.205Z"
            fill="white"
          />
          <path
            d="M675.643 547.268C673.865 547.268 672.405 548.715 672.405 550.506C672.405 552.296 673.861 553.731 675.643 553.731C677.426 553.731 678.881 552.284 678.881 550.506C678.881 548.727 677.434 547.268 675.643 547.268Z"
            fill="white"
          />
          <path
            d="M662.724 553.318C660.933 553.318 659.486 554.765 659.486 556.544C659.486 558.322 660.933 559.782 662.724 559.782C664.515 559.782 665.95 558.334 665.95 556.544C665.95 554.753 664.502 553.318 662.724 553.318Z"
            fill="white"
          />
          <path
            d="M649.582 558.334C647.804 558.334 646.365 559.781 646.365 561.559C646.365 563.337 647.8 564.784 649.582 564.784C651.364 564.784 652.807 563.337 652.807 561.559C652.807 559.781 651.369 558.334 649.582 558.334Z"
            fill="white"
          />
          <path
            d="M636.321 562.602C634.552 562.602 633.104 564.049 633.104 565.827C633.104 567.605 634.552 569.044 636.321 569.044C638.091 569.044 639.538 567.596 639.538 565.827C639.538 564.057 638.104 562.602 636.321 562.602Z"
            fill="white"
          />
          <path
            d="M622.99 566.307C621.221 566.307 619.786 567.754 619.786 569.523C619.786 571.293 621.221 572.727 622.99 572.727C624.76 572.727 626.207 571.293 626.207 569.523C626.207 567.754 624.768 566.307 622.99 566.307Z"
            fill="white"
          />
          <path
            d="M609.572 569.697C607.803 569.697 606.368 571.123 606.368 572.901C606.368 574.679 607.803 576.105 609.572 576.105C611.342 576.105 612.776 574.667 612.776 572.901C612.776 571.136 611.342 569.697 609.572 569.697Z"
            fill="white"
          />
          <path
            d="M596.094 572.965C594.324 572.965 592.89 574.403 592.89 576.169C592.89 577.934 594.328 579.373 596.094 579.373C597.859 579.373 599.298 577.934 599.298 576.169C599.298 574.403 597.863 572.965 596.094 572.965Z"
            fill="white"
          />
          <path
            d="M582.692 576.391C580.922 576.391 579.496 577.825 579.496 579.595C579.496 581.364 580.922 582.799 582.692 582.799C584.461 582.799 585.896 581.364 585.896 579.595C585.896 577.825 584.461 576.391 582.692 576.391Z"
            fill="white"
          />
          <path
            d="M569.366 580.072C567.597 580.072 566.162 581.511 566.162 583.289C566.162 585.067 567.597 586.493 569.366 586.493C571.136 586.493 572.57 585.059 572.57 583.289C572.57 581.519 571.136 580.072 569.366 580.072Z"
            fill="white"
          />
          <path
            d="M556.087 584.07C554.317 584.07 552.883 585.509 552.883 587.274C552.883 589.04 554.317 590.478 556.087 590.478C557.857 590.478 559.304 589.044 559.304 587.274C559.304 585.505 557.869 584.07 556.087 584.07Z"
            fill="white"
          />
          <path
            d="M542.869 588.205C541.1 588.205 539.674 589.639 539.674 591.409C539.674 593.179 541.1 594.613 542.869 594.613C544.639 594.613 546.073 593.179 546.073 591.409C546.073 589.639 544.635 588.205 542.869 588.205Z"
            fill="white"
          />
          <path
            d="M529.684 592.324C527.927 592.324 526.488 593.763 526.488 595.528C526.488 597.294 527.923 598.724 529.684 598.724C531.445 598.724 532.879 597.289 532.879 595.528C532.879 593.767 531.453 592.324 529.684 592.324Z"
            fill="white"
          />
          <path
            d="M516.485 596.488C514.716 596.488 513.281 597.914 513.281 599.684C513.281 601.453 514.716 602.879 516.485 602.879C518.255 602.879 519.681 601.453 519.681 599.684C519.681 597.914 518.246 596.488 516.485 596.488Z"
            fill="white"
          />
          <path
            d="M503.224 600.578C501.467 600.578 500.028 602.013 500.028 603.774C500.028 605.535 501.467 606.969 503.224 606.969C504.981 606.969 506.419 605.535 506.419 603.774C506.419 602.013 504.994 600.578 503.224 600.578Z"
            fill="white"
          />
          <path
            d="M489.903 604.334C488.133 604.334 486.707 605.76 486.707 607.529C486.707 609.299 488.133 610.725 489.903 610.725C491.672 610.725 493.098 609.286 493.098 607.529C493.098 605.773 491.659 604.334 489.903 604.334Z"
            fill="white"
          />
          <path
            d="M476.458 607.773C474.697 607.773 473.263 609.199 473.263 610.956C473.263 612.713 474.697 614.152 476.458 614.152C478.219 614.152 479.645 612.713 479.645 610.956C479.645 609.199 478.219 607.773 476.458 607.773Z"
            fill="white"
          />
          <path
            d="M462.831 610.832C461.062 610.832 459.636 612.258 459.636 614.028C459.636 615.797 461.062 617.215 462.831 617.215C464.601 617.215 466.014 615.789 466.014 614.028C466.014 612.266 464.588 610.832 462.831 610.832Z"
            fill="white"
          />
          <path
            d="M448.988 613.32C447.227 613.32 445.806 614.746 445.806 616.507C445.806 618.269 447.232 619.69 448.988 619.69C450.745 619.69 452.163 618.264 452.163 616.507C452.163 614.75 450.737 613.32 448.988 613.32Z"
            fill="white"
          />
          <path
            d="M434.864 615.055C433.108 615.055 431.669 616.481 431.669 618.237C431.669 619.994 433.103 621.433 434.864 621.433C436.626 621.433 438.052 620.007 438.052 618.237C438.052 616.468 436.626 615.055 434.864 615.055Z"
            fill="white"
          />
          <path
            d="M420.348 616.076C418.591 616.076 417.152 617.502 417.152 619.259C417.152 621.016 418.587 622.455 420.348 622.455C422.109 622.455 423.535 621.02 423.535 619.259C423.535 617.498 422.109 616.076 420.348 616.076Z"
            fill="white"
          />
          <path
            d="M405.308 616.223C403.551 616.223 402.125 617.649 402.125 619.41C402.125 621.171 403.551 622.593 405.308 622.593C407.065 622.593 408.495 621.167 408.495 619.41C408.495 617.653 407.069 616.223 405.308 616.223Z"
            fill="white"
          />
          <path
            d="M389.716 615.242C387.968 615.242 386.542 616.668 386.542 618.429C386.542 620.19 387.968 621.612 389.716 621.612C391.465 621.612 392.899 620.186 392.899 618.429C392.899 616.672 391.473 615.242 389.716 615.242Z"
            fill="white"
          />
          <path
            d="M382.099 612.539C380.308 612.539 378.874 613.986 378.874 615.777C378.874 617.568 380.308 619.002 382.099 619.002C383.89 619.002 385.325 617.555 385.325 615.777C385.325 613.999 383.877 612.539 382.099 612.539Z"
            fill="white"
          />
          <path
            d="M374.396 609.58C372.576 609.58 371.095 611.07 371.095 612.89C371.095 614.711 372.572 616.192 374.396 616.192C376.221 616.192 377.706 614.715 377.706 612.89C377.706 611.065 376.217 609.58 374.396 609.58Z"
            fill="white"
          />
          <path
            d="M366.643 606.406C364.78 606.406 363.282 607.917 363.282 609.767C363.282 611.618 364.78 613.141 366.643 613.141C368.506 613.141 370.004 611.63 370.004 609.767C370.004 607.904 368.506 606.406 366.643 606.406Z"
            fill="white"
          />
          <path
            d="M358.848 602.973C356.964 602.973 355.444 604.492 355.444 606.376C355.444 608.26 356.964 609.78 358.848 609.78C360.732 609.78 362.251 608.26 362.251 606.376C362.251 604.492 360.732 602.973 358.848 602.973Z"
            fill="white"
          />
          <path
            d="M351.022 599.203C349.108 599.203 347.567 600.744 347.567 602.649C347.567 604.554 349.108 606.103 351.022 606.103C352.936 606.103 354.468 604.554 354.468 602.649C354.468 600.744 352.927 599.203 351.022 599.203Z"
            fill="white"
          />
          <path
            d="M343.163 595.055C341.215 595.055 339.645 596.625 339.645 598.56C339.645 600.495 341.215 602.078 343.163 602.078C345.11 602.078 346.668 600.508 346.668 598.56C346.668 596.612 345.098 595.055 343.163 595.055Z"
            fill="white"
          />
          <path
            d="M335.285 590.514C333.32 590.514 331.725 592.105 331.725 594.074C331.725 596.043 333.316 597.635 335.285 597.635C337.254 597.635 338.846 596.043 338.846 594.074C338.846 592.105 337.241 590.514 335.285 590.514Z"
            fill="white"
          />
          <path
            d="M327.396 585.541C325.41 585.541 323.806 587.145 323.806 589.131C323.806 591.117 325.41 592.721 327.396 592.721C329.382 592.721 330.986 591.117 330.986 589.131C330.986 587.145 329.373 585.541 327.396 585.541Z"
            fill="white"
          />
          <path
            d="M319.507 580.088C317.5 580.088 315.866 581.713 315.866 583.721C315.866 585.728 317.5 587.362 319.507 587.362C321.515 587.362 323.14 585.728 323.14 583.721C323.14 581.713 321.515 580.088 319.507 580.088Z"
            fill="white"
          />
          <path
            d="M311.626 574.152C309.597 574.152 307.942 575.799 307.942 577.827C307.942 579.856 309.597 581.511 311.626 581.511C313.654 581.511 315.301 579.856 315.301 577.827C315.301 575.799 313.659 574.152 311.626 574.152Z"
            fill="white"
          />
          <path
            d="M303.789 567.668C301.739 567.668 300.071 569.331 300.071 571.394C300.071 573.456 301.735 575.111 303.789 575.111C305.843 575.111 307.515 573.448 307.515 571.394C307.515 569.34 305.839 567.668 303.789 567.668Z"
            fill="white"
          />
          <path
            d="M296.036 560.59C293.965 560.59 292.28 562.275 292.28 564.346C292.28 566.417 293.965 568.093 296.036 568.093C298.107 568.093 299.783 566.417 299.783 564.346C299.783 562.275 298.107 560.59 296.036 560.59Z"
            fill="white"
          />
          <path
            d="M288.396 552.859C286.304 552.859 284.619 554.557 284.619 556.649C284.619 558.741 286.304 560.426 288.396 560.426C290.488 560.426 292.186 558.728 292.186 556.649C292.186 554.57 290.488 552.859 288.396 552.859Z"
            fill="white"
          />
          <path
            d="M280.916 544.438C278.815 544.438 277.097 546.143 277.097 548.257C277.097 550.37 278.815 552.089 280.916 552.089C283.017 552.089 284.744 550.37 284.744 548.257C284.744 546.143 283.025 544.438 280.916 544.438Z"
            fill="white"
          />
          <path
            d="M273.616 535.354C271.481 535.354 269.754 537.081 269.754 539.215C269.754 541.35 271.481 543.064 273.616 543.064C275.75 543.064 277.465 541.337 277.465 539.215C277.465 537.093 275.738 535.354 273.616 535.354Z"
            fill="white"
          />
          <path
            d="M266.47 525.717C264.327 525.717 262.587 527.457 262.587 529.6C262.587 531.743 264.327 533.483 266.47 533.483C268.613 533.483 270.353 531.743 270.353 529.6C270.353 527.457 268.613 525.717 266.47 525.717Z"
            fill="white"
          />
          <path
            d="M259.412 515.775C257.256 515.775 255.508 517.524 255.508 519.68C255.508 521.835 257.256 523.592 259.412 523.592C261.568 523.592 263.325 521.844 263.325 519.68C263.325 517.515 261.576 515.775 259.412 515.775Z"
            fill="white"
          />
          <path
            d="M252.355 505.689C250.178 505.689 248.412 507.459 248.412 509.636C248.412 511.813 250.182 513.579 252.355 513.579C254.527 513.579 256.301 511.809 256.301 509.636C256.301 507.463 254.532 505.689 252.355 505.689Z"
            fill="white"
          />
          <path
            d="M245.183 495.592C242.997 495.592 241.228 497.361 241.228 499.547C241.228 501.733 242.997 503.511 245.183 503.511C247.368 503.511 249.146 501.733 249.146 499.547C249.146 497.361 247.368 495.592 245.183 495.592Z"
            fill="white"
          />
          <path
            d="M237.845 485.52C235.638 485.52 233.86 487.298 233.86 489.504C233.86 491.711 235.638 493.481 237.845 493.481C240.052 493.481 241.83 491.703 241.83 489.504C241.83 487.306 240.039 485.52 237.845 485.52Z"
            fill="white"
          />
          <path
            d="M230.279 483.511C232.487 483.511 234.276 481.721 234.276 479.513C234.276 477.305 232.487 475.516 230.279 475.516C228.071 475.516 226.281 477.305 226.281 479.513C226.281 481.721 228.071 483.511 230.279 483.511Z"
            fill="white"
          />
          <path
            d="M222.474 465.619C220.246 465.619 218.455 467.419 218.455 469.638C218.455 471.857 220.246 473.657 222.474 473.657C224.702 473.657 226.493 471.857 226.493 469.638C226.493 467.419 224.693 465.619 222.474 465.619Z"
            fill="white"
          />
          <path
            d="M214.458 455.795C212.23 455.795 210.418 457.594 210.418 459.822C210.418 462.05 212.23 463.862 214.458 463.862C216.686 463.862 218.498 462.063 218.498 459.822C218.498 457.582 216.686 455.795 214.458 455.795Z"
            fill="white"
          />
          <path
            d="M206.319 445.949C204.083 445.949 202.271 447.761 202.271 449.989C202.271 452.217 204.083 454.038 206.319 454.038C208.556 454.038 210.368 452.226 210.368 449.989C210.368 447.753 208.556 445.949 206.319 445.949Z"
            fill="white"
          />
          <path
            d="M198.098 436.041C195.862 436.041 194.041 437.853 194.041 440.098C194.041 442.343 195.862 444.159 198.098 444.159C200.334 444.159 202.155 442.339 202.155 440.098C202.155 437.857 200.343 436.041 198.098 436.041Z"
            fill="white"
          />
          <path
            d="M189.874 425.988C187.625 425.988 185.796 427.809 185.796 430.058C185.796 432.307 187.629 434.128 189.874 434.128C192.119 434.128 193.944 432.307 193.944 430.058C193.944 427.809 192.123 425.988 189.874 425.988Z"
            fill="white"
          />
          <path
            d="M181.696 415.691C179.447 415.691 177.618 417.512 177.618 419.761C177.618 422.01 179.451 423.831 181.696 423.831C183.941 423.831 185.766 422.01 185.766 419.761C185.766 417.512 183.946 415.691 181.696 415.691Z"
            fill="white"
          />
          <path
            d="M173.637 404.951C171.388 404.951 169.559 406.784 169.559 409.029C169.559 411.274 171.392 413.108 173.637 413.108C175.882 413.108 177.715 411.287 177.715 409.029C177.715 406.772 175.895 404.951 173.637 404.951Z"
            fill="white"
          />
          <path
            d="M165.812 393.545C163.562 393.545 161.733 395.378 161.733 397.623C161.733 399.868 163.567 401.701 165.812 401.701C168.057 401.701 169.89 399.881 169.89 397.623C169.89 395.366 168.069 393.545 165.812 393.545Z"
            fill="white"
          />
          <path
            d="M158.202 381.549C155.932 381.549 154.111 383.382 154.111 385.64C154.111 387.897 155.932 389.731 158.202 389.731C160.473 389.731 162.293 387.897 162.293 385.64C162.293 383.382 160.46 381.549 158.202 381.549Z"
            fill="white"
          />
          <path
            d="M150.764 369.094C148.506 369.094 146.673 370.927 146.673 373.172C146.673 375.417 148.506 377.263 150.764 377.263C153.022 377.263 154.855 375.43 154.855 373.172C154.855 370.914 153.022 369.094 150.764 369.094Z"
            fill="white"
          />
          <path
            d="M143.447 356.453C141.198 356.453 139.369 358.286 139.369 360.544C139.369 362.802 141.202 364.635 143.447 364.635C145.692 364.635 147.538 362.802 147.538 360.544C147.538 358.286 145.705 356.453 143.447 356.453Z"
            fill="white"
          />
          <path
            d="M136.169 344.076C133.911 344.076 132.091 345.897 132.091 348.154C132.091 350.412 133.911 352.233 136.169 352.233C138.427 352.233 140.247 350.412 140.247 348.154C140.247 345.897 138.427 344.076 136.169 344.076Z"
            fill="white"
          />
          <path
            d="M143.311 328.088C141.062 328.088 139.241 329.921 139.241 332.166C139.241 334.411 141.062 336.236 143.311 336.236C145.56 336.236 147.381 334.415 147.381 332.166C147.381 329.917 145.56 328.088 143.311 328.088Z"
            fill="white"
          />
          <path
            d="M150.585 312.23C148.336 312.23 146.507 314.064 146.507 316.309C146.507 318.554 148.34 320.378 150.585 320.378C152.83 320.378 154.655 318.558 154.655 316.309C154.655 314.06 152.834 312.23 150.585 312.23Z"
            fill="white"
          />
          <path
            d="M158.066 296.855C155.83 296.855 154.005 298.668 154.005 300.912C154.005 303.157 155.825 304.961 158.066 304.961C160.307 304.961 162.123 303.149 162.123 300.912C162.123 298.676 160.303 296.855 158.066 296.855Z"
            fill="white"
          />
          <path
            d="M165.749 282.43C163.512 282.43 161.7 284.242 161.7 286.478C161.7 288.715 163.512 290.527 165.749 290.527C167.985 290.527 169.797 288.715 169.797 286.478C169.797 284.242 167.985 282.43 165.749 282.43Z"
            fill="white"
          />
          <path
            d="M173.578 269.293C171.35 269.293 169.551 271.092 169.551 273.32C169.551 275.548 171.35 277.348 173.578 277.348C175.806 277.348 177.605 275.548 177.605 273.32C177.605 271.092 175.806 269.293 173.578 269.293Z"
            fill="white"
          />
          <path
            d="M181.412 257.502C179.197 257.502 177.394 259.301 177.394 261.521C177.394 263.74 179.193 265.54 181.412 265.54C183.632 265.54 185.418 263.74 185.418 261.521C185.418 259.301 183.619 257.502 181.412 257.502Z"
            fill="white"
          />
          <path
            d="M189.063 247.074C186.869 247.074 185.078 248.865 185.078 251.059C185.078 253.253 186.869 255.057 189.063 255.057C191.257 255.057 193.048 253.266 193.048 251.059C193.048 248.852 191.27 247.074 189.063 247.074Z"
            fill="white"
          />
          <path
            d="M196.307 237.926C194.113 237.926 192.331 239.704 192.331 241.889C192.331 244.075 194.109 245.866 196.307 245.866C198.506 245.866 200.271 244.088 200.271 241.889C200.271 239.691 198.493 237.926 196.307 237.926Z"
            fill="white"
          />
          <path
            d="M203.064 229.691C200.886 229.691 199.121 231.461 199.121 233.634C199.121 235.807 200.891 237.576 203.064 237.576C205.236 237.576 207.01 235.819 207.01 233.634C207.01 231.448 205.241 229.691 203.064 229.691Z"
            fill="white"
          />
          <path
            d="M209.306 222.211C207.142 222.211 205.381 223.968 205.381 226.136C205.381 228.305 207.138 230.07 209.306 230.07C211.475 230.07 213.24 228.309 213.24 226.136C213.24 223.964 211.483 222.211 209.306 222.211Z"
            fill="white"
          />
          <path
            d="M215.081 215.496C212.925 215.496 211.189 217.245 211.189 219.4C211.189 221.556 212.929 223.292 215.081 223.292C217.233 223.292 218.972 221.543 218.972 219.4C218.972 217.257 217.233 215.496 215.081 215.496Z"
            fill="white"
          />
          <path
            d="M220.412 209.75C218.277 209.75 216.55 211.477 216.55 213.62C216.55 215.763 218.277 217.482 220.412 217.482C222.546 217.482 224.282 215.755 224.282 213.62C224.282 211.486 222.555 209.75 220.412 209.75Z"
            fill="white"
          />
          <path
            d="M225.262 204.943C223.141 204.943 221.422 206.662 221.422 208.775C221.422 210.889 223.141 212.616 225.262 212.616C227.384 212.616 229.095 210.897 229.095 208.775C229.095 206.654 227.376 204.943 225.262 204.943Z"
            fill="white"
          />
          <path
            d="M229.604 200.822C227.503 200.822 225.793 202.528 225.793 204.633C225.793 206.738 227.499 208.444 229.604 208.444C231.709 208.444 233.415 206.738 233.415 204.633C233.415 202.528 231.709 200.822 229.604 200.822Z"
            fill="white"
          />
          <path
            d="M233.444 197.219C231.365 197.219 229.676 198.904 229.676 200.987C229.676 203.071 231.361 204.764 233.444 204.764C235.528 204.764 237.221 203.079 237.221 200.987C237.221 198.895 235.536 197.219 233.444 197.219Z"
            fill="white"
          />
          <path
            d="M236.814 193.947C234.743 193.947 233.079 195.619 233.079 197.69C233.079 199.761 234.743 201.425 236.814 201.425C238.885 201.425 240.548 199.748 240.548 197.69C240.548 195.632 238.872 193.947 236.814 193.947Z"
            fill="white"
          />
          <path
            d="M239.729 190.906C237.701 190.906 236.046 192.557 236.046 194.59C236.046 196.623 237.701 198.269 239.729 198.269C241.758 198.269 243.413 196.618 243.413 194.59C243.413 192.561 241.771 190.906 239.729 190.906Z"
            fill="white"
          />
          <path
            d="M242.195 187.98C240.188 187.98 238.541 189.614 238.541 191.634C238.541 193.654 240.188 195.288 242.195 195.288C244.202 195.288 245.849 193.654 245.849 191.634C245.849 189.614 244.215 187.98 242.195 187.98Z"
            fill="white"
          />
          <path
            d="M244.812 192.354C246.785 192.033 248.124 190.173 247.803 188.2C247.482 186.226 245.622 184.887 243.649 185.208C241.676 185.529 240.336 187.389 240.657 189.362C240.978 191.335 242.838 192.675 244.812 192.354Z"
            fill="white"
          />
          <path
            d="M245.891 182.4C243.914 182.4 242.31 184.005 242.31 185.969C242.31 187.934 243.914 189.551 245.891 189.551C247.869 189.551 249.46 187.947 249.46 185.969C249.46 183.992 247.856 182.4 245.891 182.4Z"
            fill="white"
          />
          <path
            d="M250.437 184.578C251.175 182.785 250.32 180.734 248.528 179.996C246.736 179.258 244.685 180.113 243.947 181.905C243.209 183.697 244.063 185.749 245.856 186.487C247.648 187.225 249.699 186.37 250.437 184.578Z"
            fill="white"
          />
          <path
            d="M248.192 177.104C246.286 177.104 244.737 178.652 244.737 180.571C244.737 182.489 246.291 184.038 248.192 184.038C250.093 184.038 251.659 182.489 251.659 180.571C251.659 178.652 250.106 177.104 248.192 177.104Z"
            fill="white"
          />
          <path
            d="M248.938 174.49C247.046 174.49 245.514 176.031 245.514 177.915C245.514 179.799 247.046 181.34 248.938 181.34C250.831 181.34 252.363 179.808 252.363 177.915C252.363 176.022 250.823 174.49 248.938 174.49Z"
            fill="white"
          />
          <path
            d="M249.438 171.879C247.588 171.879 246.064 173.39 246.064 175.253C246.064 177.116 247.584 178.626 249.438 178.626C251.293 178.626 252.812 177.116 252.812 175.253C252.812 173.39 251.301 171.879 249.438 171.879Z"
            fill="white"
          />
          <path
            d="M249.74 169.219C247.907 169.219 246.43 170.704 246.43 172.525C246.43 174.345 247.907 175.835 249.74 175.835C251.573 175.835 253.037 174.358 253.037 172.525C253.037 170.691 251.56 169.219 249.74 169.219Z"
            fill="white"
          />
          <path
            d="M249.846 166.436C248.055 166.436 246.6 167.891 246.6 169.682C246.6 171.473 248.055 172.941 249.846 172.941C251.637 172.941 253.105 171.486 253.105 169.682C253.105 167.878 251.65 166.436 249.846 166.436Z"
            fill="white"
          />
          <path
            d="M249.825 163.443C248.055 163.443 246.621 164.873 246.621 166.643C246.621 168.413 248.055 169.847 249.825 169.847C251.595 169.847 253.021 168.413 253.021 166.643C253.021 164.873 251.595 163.443 249.825 163.443Z"
            fill="white"
          />
          <path
            d="M249.74 160.141C248 160.141 246.596 161.55 246.596 163.289C246.596 165.029 248 166.443 249.74 166.443C251.48 166.443 252.893 165.034 252.893 163.289C252.893 161.545 251.476 160.141 249.74 160.141Z"
            fill="white"
          />
          <path
            d="M249.74 156.441C248.043 156.441 246.681 157.808 246.681 159.501C246.681 161.194 248.043 162.561 249.74 162.561C251.438 162.561 252.8 161.194 252.8 159.501C252.8 157.808 251.438 156.441 249.74 156.441Z"
            fill="white"
          />
          <path
            d="M250.004 152.092C248.349 152.092 247.008 153.433 247.008 155.088C247.008 156.743 248.349 158.088 250.004 158.088C251.659 158.088 253.013 156.739 253.013 155.088C253.013 153.437 251.672 152.092 250.004 152.092Z"
            fill="white"
          />
          <path
            d="M250.835 146.846C249.201 146.846 247.877 148.166 247.877 149.795C247.877 151.425 249.197 152.745 250.835 152.745C252.473 152.745 253.78 151.425 253.78 149.795C253.78 148.166 252.46 146.846 250.835 146.846Z"
            fill="white"
          />
          <path
            d="M252.75 140.285C251.146 140.285 249.855 141.579 249.855 143.175C249.855 144.771 251.146 146.069 252.75 146.069C254.354 146.069 255.631 144.779 255.631 143.175C255.631 141.571 254.341 140.285 252.75 140.285Z"
            fill="white"
          />
          <path
            d="M256.632 131.633C255.091 131.633 253.831 132.893 253.831 134.434C253.831 135.974 255.091 137.239 256.632 137.239C258.172 137.239 259.433 135.983 259.433 134.434C259.433 132.885 258.185 131.633 256.632 131.633Z"
            fill="white"
          />
          <path
            d="M272.648 127.799C271.099 127.799 269.847 129.059 269.847 130.6C269.847 132.14 271.094 133.401 272.648 133.401C274.201 133.401 275.448 132.153 275.448 130.6C275.448 129.046 274.201 127.799 272.648 127.799Z"
            fill="white"
          />
          <path
            d="M291.35 120.619C289.801 120.619 288.541 121.875 288.541 123.42C288.541 124.965 289.801 126.229 291.35 126.229C292.899 126.229 294.151 124.969 294.151 123.42C294.151 121.871 292.891 120.619 291.35 120.619Z"
            fill="white"
          />
          <path
            d="M313.375 108.988C311.835 108.988 310.574 110.244 310.574 111.789C310.574 113.334 311.835 114.59 313.375 114.59C314.916 114.59 316.176 113.334 316.176 111.789C316.176 110.244 314.928 108.988 313.375 108.988Z"
            fill="white"
          />
          <path
            d="M338.897 91.9883C337.356 91.9883 336.096 93.2359 336.096 94.7807C336.096 96.3254 337.356 97.5731 338.897 97.5731C340.437 97.5731 341.697 96.3254 341.697 94.7807C341.697 93.2359 340.45 91.9883 338.897 91.9883Z"
            fill="white"
          />
          <path
            d="M367.187 69.5156C365.633 69.5156 364.386 70.776 364.386 72.3207C364.386 73.8655 365.633 75.1259 367.187 75.1259C368.74 75.1259 369.987 73.8655 369.987 72.3207C369.987 70.776 368.74 69.5156 367.187 69.5156Z"
            fill="white"
          />
          <path
            d="M396.328 42.8906C394.788 42.8906 393.527 44.1383 393.527 45.6915C393.527 47.2447 394.788 48.5009 396.328 48.5009C397.869 48.5009 399.138 47.2405 399.138 45.6915C399.138 44.1425 397.877 42.8906 396.328 42.8906Z"
            fill="white"
          />
          <path
            d="M424.439 14.6367C422.89 14.6367 421.63 15.8971 421.63 17.4461C421.63 18.995 422.89 20.2554 424.439 20.2554C425.988 20.2554 427.249 18.995 427.249 17.4461C427.249 15.8971 425.988 14.6367 424.439 14.6367Z"
            fill="white"
          />
          <path
            d="M851.975 -2.03711C850.196 -2.03711 848.758 -0.589991 848.758 1.18814C848.758 2.96627 850.196 4.4049 851.975 4.4049C853.753 4.4049 855.191 2.96203 855.191 1.18814C855.191 -0.585747 853.753 -2.03711 851.975 -2.03711Z"
            fill="white"
          />
          <path
            d="M859.019 9.27734C857.207 9.27734 855.73 10.7542 855.73 12.5747C855.73 14.3953 857.207 15.8679 859.019 15.8679C860.831 15.8679 862.321 14.3953 862.321 12.5747C862.321 10.7542 860.844 9.27734 859.019 9.27734Z"
            fill="white"
          />
          <path
            d="M865.835 21.291C863.993 21.291 862.495 22.7848 862.495 24.6308C862.495 26.4769 863.993 27.9792 865.835 27.9792C867.677 27.9792 869.175 26.4811 869.175 24.6308C869.175 22.7806 867.677 21.291 865.835 21.291Z"
            fill="white"
          />
          <path
            d="M872.391 33.9824C870.507 33.9824 868.987 35.5017 868.987 37.3859C868.987 39.2701 870.507 40.7894 872.391 40.7894C874.275 40.7894 875.794 39.2659 875.794 37.3859C875.794 35.5059 874.275 33.9824 872.391 33.9824Z"
            fill="white"
          />
          <path
            d="M878.68 47.3613C876.775 47.3613 875.234 48.9103 875.234 50.8157C875.234 52.7212 876.775 54.2659 878.68 54.2659C880.586 54.2659 882.135 52.7212 882.135 50.8157C882.135 48.9103 880.586 47.3613 878.68 47.3613Z"
            fill="white"
          />
          <path
            d="M884.715 61.3262C882.767 61.3262 881.197 62.8964 881.197 64.8442C881.197 66.7921 882.767 68.3623 884.715 68.3623C886.663 68.3623 888.233 66.7836 888.233 64.8442C888.233 62.9049 886.651 61.3262 884.715 61.3262Z"
            fill="white"
          />
          <path
            d="M890.526 75.8223C888.561 75.8223 886.966 77.4179 886.966 79.387C886.966 81.3561 888.557 82.9518 890.526 82.9518C892.495 82.9518 894.087 81.3604 894.087 79.387C894.087 77.4137 892.495 75.8223 890.526 75.8223Z"
            fill="white"
          />
          <path
            d="M896.144 90.791C894.145 90.791 892.532 92.4036 892.532 94.4024C892.532 96.4012 894.145 98.0096 896.144 98.0096C898.142 98.0096 899.747 96.3928 899.747 94.4024C899.747 92.4121 898.134 90.791 896.144 90.791Z"
            fill="white"
          />
          <path
            d="M901.61 106.133C899.59 106.133 897.956 107.771 897.956 109.791C897.956 111.811 899.59 113.449 901.61 113.449C903.63 113.449 905.272 111.815 905.272 109.791C905.272 107.767 903.626 106.133 901.61 106.133Z"
            fill="white"
          />
          <path
            d="M907.042 121.707C904.98 121.707 903.329 123.366 903.329 125.429C903.329 127.491 904.984 129.142 907.042 129.142C909.101 129.142 910.76 127.479 910.76 125.429C910.76 123.379 909.096 121.707 907.042 121.707Z"
            fill="white"
          />
          <path
            d="M912.537 137.334C910.466 137.334 908.79 139.015 908.79 141.09C908.79 143.165 910.466 144.837 912.537 144.837C914.608 144.837 916.293 143.161 916.293 141.09C916.293 139.019 914.617 137.334 912.537 137.334Z"
            fill="white"
          />
          <path
            d="M918.271 152.621C916.179 152.621 914.481 154.319 914.481 156.415C914.481 158.511 916.179 160.209 918.271 160.209C920.363 160.209 922.069 158.511 922.069 156.415C922.069 154.319 920.363 152.621 918.271 152.621Z"
            fill="white"
          />
          <path
            d="M924.348 167.279C922.234 167.279 920.516 168.998 920.516 171.107C920.516 173.216 922.234 174.939 924.348 174.939C926.461 174.939 928.176 173.221 928.176 171.107C928.176 168.994 926.457 167.279 924.348 167.279Z"
            fill="white"
          />
          <path
            d="M930.832 181.09C928.689 181.09 926.949 182.826 926.949 184.973C926.949 187.12 928.685 188.843 930.832 188.843C932.98 188.843 934.703 187.116 934.703 184.973C934.703 182.83 932.963 181.09 930.832 181.09Z"
            fill="white"
          />
          <path
            d="M937.711 194.1C935.555 194.1 933.807 195.848 933.807 198.008C933.807 200.168 935.555 201.917 937.711 201.917C939.867 201.917 941.624 200.168 941.624 198.008C941.624 195.848 939.875 194.1 937.711 194.1Z"
            fill="white"
          />
          <path
            d="M945.019 206.297C942.842 206.297 941.076 208.058 941.076 210.231C941.076 212.404 942.846 214.178 945.019 214.178C947.191 214.178 948.953 212.408 948.953 210.231C948.953 208.054 947.191 206.297 945.019 206.297Z"
            fill="white"
          />
          <path
            d="M952.722 217.652C950.536 217.652 948.758 219.43 948.758 221.629C948.758 223.827 950.536 225.592 952.722 225.592C954.907 225.592 956.698 223.814 956.698 221.629C956.698 219.443 954.92 217.652 952.722 217.652Z"
            fill="white"
          />
          <path
            d="M960.848 228.051C958.633 228.051 956.842 229.842 956.842 232.057C956.842 234.272 958.633 236.076 960.848 236.076C963.063 236.076 964.867 234.276 964.867 232.057C964.867 229.837 963.067 228.051 960.848 228.051Z"
            fill="white"
          />
          <path
            d="M969.366 237.426C967.138 237.426 965.326 239.225 965.326 241.453C965.326 243.681 967.138 245.48 969.366 245.48C971.594 245.48 973.394 243.681 973.394 241.453C973.394 239.225 971.581 237.426 969.366 237.426Z"
            fill="white"
          />
          <path
            d="M978.188 245.721C975.951 245.721 974.131 247.533 974.131 249.778C974.131 252.023 975.951 253.835 978.188 253.835C980.424 253.835 982.245 252.014 982.245 249.778C982.245 247.541 980.433 245.721 978.188 245.721Z"
            fill="white"
          />
          <path
            d="M987.266 252.986C985.016 252.986 983.188 254.807 983.188 257.065C983.188 259.322 985.021 261.143 987.266 261.143C989.511 261.143 991.344 259.31 991.344 257.065C991.344 254.82 989.523 252.986 987.266 252.986Z"
            fill="white"
          />
          <path
            d="M996.516 259.229C994.246 259.229 992.404 261.07 992.404 263.341C992.404 265.611 994.246 267.453 996.516 267.453C998.787 267.453 1000.63 265.611 1000.63 263.341C1000.63 261.07 998.787 259.229 996.516 259.229Z"
            fill="white"
          />
          <path
            d="M1005.87 272.796C1008.15 272.796 1010 270.946 1010 268.663C1010 266.38 1008.15 264.529 1005.87 264.529C1003.58 264.529 1001.73 266.38 1001.73 268.663C1001.73 270.946 1003.58 272.796 1005.87 272.796Z"
            fill="white"
          />
          <path
            d="M1015.23 268.953C1012.94 268.953 1011.09 270.803 1011.09 273.095C1011.09 275.387 1012.94 277.237 1015.23 277.237C1017.52 277.237 1019.37 275.387 1019.37 273.095C1019.37 270.803 1017.52 268.953 1015.23 268.953Z"
            fill="white"
          />
          <path
            d="M1024.57 272.582C1022.27 272.582 1020.41 274.437 1020.41 276.737C1020.41 279.037 1022.27 280.891 1024.57 280.891C1026.87 280.891 1028.72 279.028 1028.72 276.737C1028.72 274.445 1026.86 272.582 1024.57 272.582Z"
            fill="white"
          />
          <path
            d="M1033.81 275.602C1031.52 275.602 1029.66 277.465 1029.66 279.756C1029.66 282.048 1031.52 283.911 1033.81 283.911C1036.1 283.911 1037.97 282.048 1037.97 279.756C1037.97 277.465 1036.1 275.602 1033.81 275.602Z"
            fill="white"
          />
          <path
            d="M1042.96 278.152C1040.66 278.152 1038.79 280.015 1038.79 282.307C1038.79 284.599 1040.66 286.462 1042.96 286.462C1045.26 286.462 1047.11 284.611 1047.11 282.307C1047.11 280.003 1045.25 278.152 1042.96 278.152Z"
            fill="white"
          />
          <path
            d="M1052 280.338C1049.71 280.338 1047.85 282.201 1047.85 284.493C1047.85 286.784 1049.71 288.647 1052 288.647C1054.3 288.647 1056.16 286.784 1056.16 284.493C1056.16 282.201 1054.3 280.338 1052 280.338Z"
            fill="white"
          />
          <path
            d="M1060.95 282.234C1058.66 282.234 1056.8 284.097 1056.8 286.389C1056.8 288.681 1058.66 290.544 1060.95 290.544C1063.25 290.544 1065.11 288.693 1065.11 286.389C1065.11 284.085 1063.25 282.234 1060.95 282.234Z"
            fill="white"
          />
          <path
            d="M1069.83 283.906C1067.54 283.906 1065.68 285.769 1065.68 288.061C1065.68 290.352 1067.54 292.216 1069.83 292.216C1072.12 292.216 1073.99 290.361 1073.99 288.061C1073.99 285.761 1072.13 283.906 1069.83 283.906Z"
            fill="white"
          />
          <path
            d="M1064.93 284.879C1062.63 284.879 1060.78 286.742 1060.78 289.034C1060.78 291.325 1062.63 293.188 1064.93 293.188C1067.23 293.188 1069.08 291.325 1069.08 289.034C1069.08 286.742 1067.22 284.879 1064.93 284.879Z"
            fill="white"
          />
          <path
            d="M1059.84 285.812C1057.54 285.812 1055.68 287.676 1055.68 289.967C1055.68 292.259 1057.53 294.122 1059.84 294.122C1062.14 294.122 1063.99 292.259 1063.99 289.967C1063.99 287.676 1062.13 285.812 1059.84 285.812Z"
            fill="white"
          />
          <path
            d="M1054.54 286.742C1052.24 286.742 1050.39 288.605 1050.39 290.897C1050.39 293.188 1052.24 295.051 1054.54 295.051C1056.84 295.051 1058.7 293.201 1058.7 290.897C1058.7 288.592 1056.83 286.742 1054.54 286.742Z"
            fill="white"
          />
          <path
            d="M1049.02 287.688C1046.72 287.688 1044.86 289.551 1044.86 291.842C1044.86 294.134 1046.72 295.997 1049.02 295.997C1051.31 295.997 1053.18 294.142 1053.18 291.842C1053.18 289.542 1051.32 287.688 1049.02 287.688Z"
            fill="white"
          />
          <path
            d="M1043.26 288.684C1040.97 288.684 1039.1 290.534 1039.1 292.838C1039.1 295.143 1040.97 296.993 1043.26 296.993C1045.55 296.993 1047.41 295.13 1047.41 292.838C1047.41 290.547 1045.55 288.684 1043.26 288.684Z"
            fill="white"
          />
          <path
            d="M1037.24 289.736C1034.96 289.736 1033.09 291.599 1033.09 293.891C1033.09 296.183 1034.95 298.054 1037.24 298.054C1039.54 298.054 1041.4 296.191 1041.4 293.891C1041.4 291.591 1039.54 289.736 1037.24 289.736Z"
            fill="white"
          />
          <path
            d="M1030.97 290.904C1028.68 290.904 1026.81 292.759 1026.81 295.059C1026.81 297.359 1028.68 299.214 1030.97 299.214C1033.26 299.214 1035.12 297.351 1035.12 295.059C1035.12 292.767 1033.26 290.904 1030.97 290.904Z"
            fill="white"
          />
          <path
            d="M1024.43 292.195C1022.13 292.195 1020.28 294.046 1020.28 296.35C1020.28 298.654 1022.13 300.505 1024.43 300.505C1026.73 300.505 1028.59 298.642 1028.59 296.35C1028.59 294.058 1026.72 292.195 1024.43 292.195Z"
            fill="white"
          />
          <path
            d="M1017.63 293.607C1015.33 293.607 1013.48 295.47 1013.48 297.762C1013.48 300.054 1015.33 301.917 1017.63 301.917C1019.94 301.917 1021.78 300.054 1021.78 297.762C1021.78 295.47 1019.92 293.607 1017.63 293.607Z"
            fill="white"
          />
          <path
            d="M1010.57 295.146C1008.28 295.146 1006.43 296.997 1006.43 299.288C1006.43 301.58 1008.28 303.443 1010.57 303.443C1012.86 303.443 1014.72 301.58 1014.72 299.288C1014.72 296.997 1012.87 295.146 1010.57 295.146Z"
            fill="white"
          />
          <path
            d="M1003.26 296.826C1000.97 296.826 999.119 298.681 999.119 300.968C999.119 303.255 1000.97 305.101 1003.26 305.101C1005.55 305.101 1007.39 303.247 1007.39 300.968C1007.39 298.689 1005.54 296.826 1003.26 296.826Z"
            fill="white"
          />
          <path
            d="M995.685 298.68C993.428 298.68 991.586 300.513 991.586 302.779C991.586 305.045 993.428 306.891 995.685 306.891C997.943 306.891 999.798 305.05 999.798 302.779C999.798 300.509 997.956 298.68 995.685 298.68Z"
            fill="white"
          />
          <path
            d="M987.88 300.688C985.622 300.688 983.789 302.521 983.789 304.778C983.789 307.036 985.622 308.869 987.88 308.869C990.138 308.869 991.971 307.036 991.971 304.778C991.971 302.521 990.138 300.688 987.88 300.688Z"
            fill="white"
          />
          <path
            d="M979.843 302.902C977.607 302.902 975.782 304.723 975.782 306.972C975.782 309.221 977.603 311.029 979.843 311.029C982.084 311.029 983.913 309.209 983.913 306.972C983.913 304.736 982.093 302.902 979.843 302.902Z"
            fill="white"
          />
          <path
            d="M971.61 305.336C969.374 305.336 967.562 307.148 967.562 309.384C967.562 311.621 969.374 313.433 971.61 313.433C973.847 313.433 975.659 311.621 975.659 309.384C975.659 307.148 973.847 305.336 971.61 305.336Z"
            fill="white"
          />
          <path
            d="M963.225 308.023C961.01 308.023 959.206 309.823 959.206 312.042C959.206 314.262 961.005 316.048 963.225 316.048C965.444 316.048 967.231 314.257 967.231 312.042C967.231 309.827 965.44 308.023 963.225 308.023Z"
            fill="white"
          />
          <path
            d="M954.707 310.947C952.501 310.947 950.723 312.725 950.723 314.932C950.723 317.139 952.501 318.917 954.707 318.917C956.914 318.917 958.692 317.126 958.692 314.932C958.692 312.738 956.902 310.947 954.707 310.947Z"
            fill="white"
          />
          <path
            d="M946.113 314.123C943.928 314.123 942.158 315.901 942.158 318.087C942.158 320.272 943.928 322.042 946.113 322.042C948.299 322.042 950.069 320.272 950.069 318.087C950.069 315.901 948.299 314.123 946.113 314.123Z"
            fill="white"
          />
          <path
            d="M937.402 317.654C935.225 317.654 933.468 319.415 933.468 321.58C933.468 323.744 935.225 325.514 937.402 325.514C939.579 325.514 941.327 323.757 941.327 321.58C941.327 319.403 939.57 317.654 937.402 317.654Z"
            fill="white"
          />
          <path
            d="M928.587 321.588C926.444 321.588 924.704 323.328 924.704 325.471C924.704 327.614 926.444 329.354 928.587 329.354C930.73 329.354 932.457 327.618 932.457 325.471C932.457 323.324 930.717 321.588 928.587 321.588Z"
            fill="white"
          />
          <path
            d="M919.689 325.936C917.567 325.936 915.84 327.663 915.84 329.785C915.84 331.907 917.567 333.634 919.689 333.634C921.811 333.634 923.538 331.915 923.538 329.785C923.538 327.654 921.819 325.936 919.689 325.936Z"
            fill="white"
          />
          <path
            d="M910.747 330.744C908.634 330.744 906.915 332.463 906.915 334.572C906.915 336.681 908.634 338.391 910.747 338.391C912.861 338.391 914.567 336.685 914.567 334.572C914.567 332.459 912.861 330.744 910.747 330.744Z"
            fill="white"
          />
          <path
            d="M902.377 343.536C904.443 343.201 905.846 341.254 905.511 339.188C905.175 337.122 903.228 335.72 901.163 336.055C899.097 336.39 897.694 338.337 898.029 340.403C898.364 342.469 900.311 343.872 902.377 343.536Z"
            fill="white"
          />
          <path
            d="M892.762 341.904C890.7 341.904 889.036 343.581 889.036 345.639C889.036 347.697 890.7 349.365 892.762 349.365C894.825 349.365 896.497 347.701 896.497 345.639C896.497 343.576 894.82 341.904 892.762 341.904Z"
            fill="white"
          />
          <path
            d="M883.76 348.242C881.711 348.242 880.056 349.906 880.056 351.947C880.056 353.988 881.711 355.652 883.76 355.652C885.81 355.652 887.457 353.988 887.457 351.947C887.457 349.906 885.802 348.242 883.76 348.242Z"
            fill="white"
          />
          <path
            d="M874.755 355.16C872.735 355.16 871.102 356.794 871.102 358.814C871.102 360.834 872.735 362.468 874.755 362.468C876.776 362.468 878.409 360.834 878.409 358.814C878.409 356.794 876.776 355.16 874.755 355.16Z"
            fill="white"
          />
          <path
            d="M865.755 362.625C863.756 362.625 862.144 364.238 862.144 366.236C862.144 368.235 863.756 369.839 865.755 369.839C867.754 369.839 869.366 368.227 869.366 366.236C869.366 364.246 867.754 362.625 865.755 362.625Z"
            fill="white"
          />
          <path
            d="M856.763 370.719C854.806 370.719 853.215 372.302 853.215 374.267C853.215 376.231 854.806 377.806 856.763 377.806C858.719 377.806 860.31 376.223 860.31 374.267C860.31 372.31 858.719 370.719 856.763 370.719Z"
            fill="white"
          />
          <path
            d="M848.598 386.403C850.482 385.958 851.649 384.07 851.205 382.186C850.76 380.302 848.872 379.135 846.988 379.58C845.104 380.024 843.937 381.912 844.381 383.796C844.826 385.681 846.714 386.847 848.598 386.403Z"
            fill="white"
          />
          <path
            d="M838.849 388.791C836.935 388.791 835.395 390.344 835.395 392.245C835.395 394.147 836.935 395.7 838.849 395.7C840.763 395.7 842.303 394.159 842.303 392.245C842.303 390.331 840.754 388.791 838.849 388.791Z"
            fill="white"
          />
          <path
            d="M829.992 398.865C828.108 398.865 826.589 400.397 826.589 402.277C826.589 404.157 828.108 405.681 829.992 405.681C831.877 405.681 833.404 404.149 833.404 402.277C833.404 400.406 831.872 398.865 829.992 398.865Z"
            fill="white"
          />
          <path
            d="M821.395 409.846C819.553 409.846 818.055 411.344 818.055 413.186C818.055 415.027 819.553 416.517 821.395 416.517C823.236 416.517 824.726 415.027 824.726 413.186C824.726 411.344 823.236 409.846 821.395 409.846Z"
            fill="white"
          />
          <path
            d="M816.337 425.029C814.558 425.029 813.111 426.476 813.111 428.255C813.111 430.033 814.558 431.48 816.337 431.48C818.115 431.48 819.575 430.033 819.575 428.255C819.575 426.476 818.127 425.029 816.337 425.029Z"
            fill="white"
          />
          <path
            d="M805.647 435.074C803.856 435.074 802.422 436.521 802.422 438.3C802.422 440.078 803.861 441.525 805.647 441.525C807.434 441.525 808.872 440.078 808.872 438.3C808.872 436.521 807.425 435.074 805.647 435.074Z"
            fill="white"
          />
          <path
            d="M794.948 445.656C793.17 445.656 791.723 447.103 791.723 448.881C791.723 450.66 793.17 452.119 794.948 452.119C796.726 452.119 798.173 450.672 798.173 448.881C798.173 447.091 796.726 445.656 794.948 445.656Z"
            fill="white"
          />
          <path
            d="M784.372 456.848C782.594 456.848 781.146 458.286 781.146 460.064C781.146 461.843 782.594 463.29 784.372 463.29C786.15 463.29 787.597 461.843 787.597 460.064C787.597 458.286 786.15 456.848 784.372 456.848Z"
            fill="white"
          />
          <path
            d="M773.881 468.48C772.103 468.48 770.656 469.915 770.656 471.697C770.656 473.48 772.103 474.922 773.881 474.922C775.66 474.922 777.098 473.475 777.098 471.697C777.098 469.919 775.66 468.48 773.881 468.48Z"
            fill="white"
          />
          <path
            d="M763.425 480.41C761.655 480.41 760.208 481.857 760.208 483.627C760.208 485.397 761.655 486.844 763.425 486.844C765.194 486.844 766.642 485.409 766.642 483.627C766.642 481.845 765.207 480.41 763.425 480.41Z"
            fill="white"
          />
          <path
            d="M752.943 492.42C751.165 492.42 749.727 493.854 749.727 495.624C749.727 497.394 751.161 498.841 752.943 498.841C754.726 498.841 756.16 497.402 756.16 495.624C756.16 493.846 754.713 492.42 752.943 492.42Z"
            fill="white"
          />
          <path
            d="M742.266 504.242C740.487 504.242 739.062 505.677 739.062 507.446C739.062 509.216 740.487 510.663 742.266 510.663C744.044 510.663 745.47 509.229 745.47 507.446C745.47 505.664 744.035 504.242 742.266 504.242Z"
            fill="white"
          />
          <path
            d="M731.231 515.477C729.462 515.477 728.027 516.911 728.027 518.681C728.027 520.45 729.462 521.885 731.231 521.885C733.001 521.885 734.427 520.45 734.427 518.681C734.427 516.911 733.001 515.477 731.231 515.477Z"
            fill="white"
          />
          <path
            d="M719.834 525.953C718.065 525.953 716.639 527.388 716.639 529.149C716.639 530.91 718.065 532.344 719.834 532.344C721.604 532.344 723.03 530.91 723.03 529.149C723.03 527.388 721.595 525.953 719.834 525.953Z"
            fill="white"
          />
          <path
            d="M708.031 535.49C706.275 535.49 704.849 536.929 704.849 538.686C704.849 540.443 706.275 541.873 708.031 541.873C709.788 541.873 711.227 540.447 711.227 538.686C711.227 536.925 709.801 535.49 708.031 535.49Z"
            fill="white"
          />
          <path
            d="M695.801 543.836C694.04 543.836 692.618 545.262 692.618 547.023C692.618 548.784 694.044 550.21 695.801 550.21C697.558 550.21 698.988 548.784 698.988 547.023C698.988 545.262 697.562 543.836 695.801 543.836Z"
            fill="white"
          />
          <path
            d="M683.217 551.016C681.469 551.016 680.043 552.442 680.043 554.203C680.043 555.964 681.469 557.377 683.217 557.377C684.966 557.377 686.4 555.951 686.4 554.203C686.4 552.454 684.974 551.016 683.217 551.016Z"
            fill="white"
          />
          <path
            d="M670.407 557.105C668.646 557.105 667.22 558.523 667.22 560.28C667.22 562.037 668.646 563.454 670.407 563.454C672.168 563.454 673.581 562.028 673.581 560.28C673.581 558.531 672.155 557.105 670.407 557.105Z"
            fill="white"
          />
          <path
            d="M657.344 562.203C655.596 562.203 654.183 563.629 654.183 565.377C654.183 567.126 655.6 568.543 657.344 568.543C659.088 568.543 660.519 567.126 660.519 565.377C660.519 563.629 659.093 562.203 657.344 562.203Z"
            fill="white"
          />
          <path
            d="M644.086 566.371C642.33 566.371 640.912 567.788 640.912 569.545C640.912 571.302 642.33 572.711 644.086 572.711C645.843 572.711 647.252 571.294 647.252 569.545C647.252 567.797 645.835 566.371 644.086 566.371Z"
            fill="white"
          />
          <path
            d="M630.71 569.906C628.961 569.906 627.544 571.324 627.544 573.072C627.544 574.82 628.961 576.234 630.71 576.234C632.458 576.234 633.884 574.816 633.884 573.072C633.884 571.328 632.458 569.906 630.71 569.906Z"
            fill="white"
          />
          <path
            d="M617.254 573.021C615.505 573.021 614.088 574.439 614.088 576.187C614.088 577.936 615.505 579.349 617.254 579.349C619.002 579.349 620.42 577.931 620.42 576.187C620.42 574.443 619.002 573.021 617.254 573.021Z"
            fill="white"
          />
          <path
            d="M603.703 575.932C601.955 575.932 600.537 577.349 600.537 579.085C600.537 580.82 601.955 582.238 603.703 582.238C605.451 582.238 606.856 580.833 606.856 579.085C606.856 577.336 605.439 575.932 603.703 575.932Z"
            fill="white"
          />
          <path
            d="M590.161 578.939C588.421 578.939 587.008 580.357 587.008 582.093C587.008 583.828 588.425 585.258 590.161 585.258C591.897 585.258 593.327 583.841 593.327 582.093C593.327 580.344 591.909 578.939 590.161 578.939Z"
            fill="white"
          />
          <path
            d="M576.717 582.148C574.977 582.148 573.563 583.566 573.563 585.302C573.563 587.037 574.981 588.455 576.717 588.455C578.452 588.455 579.87 587.037 579.87 585.302C579.87 583.566 578.452 582.148 576.717 582.148Z"
            fill="white"
          />
          <path
            d="M563.332 585.695C561.596 585.695 560.179 587.1 560.179 588.84C560.179 590.58 561.596 591.993 563.332 591.993C565.067 591.993 566.476 590.576 566.476 588.84C566.476 587.104 565.072 585.695 563.332 585.695Z"
            fill="white"
          />
          <path
            d="M550.007 589.537C548.271 589.537 546.862 590.942 546.862 592.682C546.862 594.422 548.267 595.835 550.007 595.835C551.747 595.835 553.152 594.417 553.152 592.682C553.152 590.946 551.747 589.537 550.007 589.537Z"
            fill="white"
          />
          <path
            d="M536.75 593.42C535.01 593.42 533.605 594.825 533.605 596.565C533.605 598.304 535.01 599.709 536.75 599.709C538.49 599.709 539.895 598.304 539.895 596.565C539.895 594.825 538.49 593.42 536.75 593.42Z"
            fill="white"
          />
          <path
            d="M523.501 597.363C521.765 597.363 520.356 598.768 520.356 600.495C520.356 602.222 521.761 603.64 523.501 603.64C525.241 603.64 526.633 602.235 526.633 600.495C526.633 598.755 525.228 597.363 523.501 597.363Z"
            fill="white"
          />
          <path
            d="M510.21 601.328C508.483 601.328 507.078 602.733 507.078 604.46C507.078 606.187 508.483 607.605 510.21 607.605C511.937 607.605 513.355 606.2 513.355 604.46C513.355 602.72 511.95 601.328 510.21 601.328Z"
            fill="white"
          />
          <path
            d="M496.875 605.107C495.139 605.107 493.73 606.512 493.73 608.252C493.73 609.992 495.135 611.397 496.875 611.397C498.615 611.397 500.02 609.992 500.02 608.252C500.02 606.512 498.615 605.107 496.875 605.107Z"
            fill="white"
          />
          <path
            d="M483.452 608.553C481.712 608.553 480.308 609.957 480.308 611.697C480.308 613.437 481.712 614.842 483.452 614.842C485.192 614.842 486.597 613.437 486.597 611.697C486.597 609.957 485.192 608.553 483.452 608.553Z"
            fill="white"
          />
          <path
            d="M469.868 611.684C468.128 611.684 466.724 613.088 466.724 614.828C466.724 616.568 468.128 617.96 469.868 617.96C471.608 617.96 473 616.555 473 614.828C473 613.101 471.595 611.684 469.868 611.684Z"
            fill="white"
          />
          <path
            d="M456.593 620.611C458.301 620.337 459.463 618.73 459.189 617.023C458.916 615.315 457.309 614.152 455.601 614.426C453.893 614.7 452.731 616.306 453.005 618.014C453.279 619.722 454.885 620.885 456.593 620.611Z"
            fill="white"
          />
          <path
            d="M442.038 616.408C440.311 616.408 438.906 617.813 438.906 619.54C438.906 621.267 440.311 622.672 442.038 622.672C443.765 622.672 445.17 621.267 445.17 619.54C445.17 617.813 443.765 616.408 442.038 616.408Z"
            fill="white"
          />
          <path
            d="M427.634 617.721C425.907 617.721 424.511 619.125 424.511 620.853C424.511 622.58 425.907 623.976 427.634 623.976C429.361 623.976 430.766 622.58 430.766 620.853C430.766 619.125 429.361 617.721 427.634 617.721Z"
            fill="white"
          />
          <path
            d="M412.738 618.271C411.011 618.271 409.606 619.676 409.606 621.403C409.606 623.131 411.011 624.527 412.738 624.527C414.466 624.527 415.87 623.131 415.87 621.403C415.87 619.676 414.466 618.271 412.738 618.271Z"
            fill="white"
          />
          <path
            d="M397.253 617.77C395.517 617.77 394.108 619.166 394.108 620.901C394.108 622.637 395.513 624.033 397.253 624.033C398.993 624.033 400.385 622.629 400.385 620.901C400.385 619.174 398.98 617.77 397.253 617.77Z"
            fill="white"
          />
          <path
            d="M381.131 616.191C379.404 616.191 377.999 617.596 377.999 619.323C377.999 621.051 379.404 622.455 381.131 622.455C382.858 622.455 384.276 621.051 384.276 619.323C384.276 617.596 382.871 616.191 381.131 616.191Z"
            fill="white"
          />
          <path
            d="M373.556 613.246C371.799 613.246 370.369 614.672 370.369 616.433C370.369 618.194 371.795 619.616 373.556 619.616C375.317 619.616 376.739 618.19 376.739 616.433C376.739 614.676 375.313 613.246 373.556 613.246Z"
            fill="white"
          />
          <path
            d="M365.968 610.131C364.19 610.131 362.73 611.578 362.73 613.369C362.73 615.16 364.186 616.607 365.968 616.607C367.751 616.607 369.215 615.16 369.215 613.369C369.215 611.578 367.759 610.131 365.968 610.131Z"
            fill="white"
          />
          <path
            d="M358.389 606.793C356.556 606.793 355.079 608.283 355.079 610.103C355.079 611.924 356.556 613.422 358.389 613.422C360.223 613.422 361.708 611.932 361.708 610.103C361.708 608.274 360.218 606.793 358.389 606.793Z"
            fill="white"
          />
          <path
            d="M350.823 603.244C348.973 603.244 347.462 604.742 347.462 606.605C347.462 608.468 348.973 609.958 350.823 609.958C352.673 609.958 354.184 608.46 354.184 606.605C354.184 604.751 352.673 603.244 350.823 603.244Z"
            fill="white"
          />
          <path
            d="M343.269 599.412C341.385 599.412 339.865 600.931 339.865 602.816C339.865 604.7 341.385 606.228 343.269 606.228C345.153 606.228 346.672 604.696 346.672 602.816C346.672 600.936 345.153 599.412 343.269 599.412Z"
            fill="white"
          />
          <path
            d="M335.711 595.283C333.805 595.283 332.265 596.824 332.265 598.729C332.265 600.635 333.805 602.184 335.711 602.184C337.616 602.184 339.165 600.643 339.165 598.729C339.165 596.815 337.625 595.283 335.711 595.283Z"
            fill="white"
          />
          <path
            d="M328.156 590.785C326.221 590.785 324.65 592.355 324.65 594.303C324.65 596.251 326.221 597.809 328.156 597.809C330.091 597.809 331.674 596.238 331.674 594.303C331.674 592.368 330.104 590.785 328.156 590.785Z"
            fill="white"
          />
          <path
            d="M320.59 585.969C318.625 585.969 317.029 587.56 317.029 589.517C317.029 591.473 318.621 593.077 320.59 593.077C322.559 593.077 324.138 591.486 324.138 589.517C324.138 587.547 322.546 585.969 320.59 585.969Z"
            fill="white"
          />
          <path
            d="M312.99 580.775C311.004 580.775 309.399 582.388 309.399 584.366C309.399 586.343 311.004 587.947 312.99 587.947C314.976 587.947 316.571 586.343 316.571 584.366C316.571 582.388 314.967 580.775 312.99 580.775Z"
            fill="white"
          />
          <path
            d="M305.372 575.15C303.373 575.15 301.752 576.776 301.752 578.783C301.752 580.79 303.373 582.416 305.372 582.416C307.371 582.416 309.005 580.79 309.005 578.783C309.005 576.776 307.379 575.15 305.372 575.15Z"
            fill="white"
          />
          <path
            d="M297.775 569.043C295.734 569.043 294.092 570.69 294.092 572.727C294.092 574.764 295.734 576.423 297.775 576.423C299.817 576.423 301.472 574.768 301.472 572.727C301.472 570.685 299.817 569.043 297.775 569.043Z"
            fill="white"
          />
          <path
            d="M290.208 562.424C288.159 562.424 286.495 564.087 286.495 566.141C286.495 568.195 288.159 569.867 290.208 569.867C292.258 569.867 293.934 568.204 293.934 566.141C293.934 564.079 292.271 562.424 290.208 562.424Z"
            fill="white"
          />
          <path
            d="M283.546 562.663C285.56 562.186 286.806 560.166 286.328 558.153C285.851 556.139 283.832 554.893 281.818 555.37C279.804 555.848 278.559 557.867 279.036 559.881C279.513 561.894 281.532 563.14 283.546 562.663Z"
            fill="white"
          />
          <path
            d="M275.326 547.471C273.234 547.471 271.536 549.168 271.536 551.248C271.536 553.327 273.234 555.037 275.326 555.037C277.418 555.037 279.103 553.34 279.103 551.248C279.103 549.155 277.405 547.471 275.326 547.471Z"
            fill="white"
          />
          <path
            d="M268.026 539.143C265.913 539.143 264.207 540.861 264.207 542.97C264.207 545.08 265.913 546.79 268.026 546.79C270.14 546.79 271.846 545.071 271.846 542.97C271.846 540.87 270.14 539.143 268.026 539.143Z"
            fill="white"
          />
          <path
            d="M260.846 530.324C258.712 530.324 256.997 532.051 256.997 534.186C256.997 536.321 258.716 538.035 260.846 538.035C262.976 538.035 264.695 536.308 264.695 534.186C264.695 532.064 262.968 530.324 260.846 530.324Z"
            fill="white"
          />
          <path
            d="M253.759 521.086C251.624 521.086 249.889 522.813 249.889 524.956C249.889 527.099 251.629 528.839 253.759 528.839C255.889 528.839 257.642 527.099 257.642 524.956C257.642 522.813 255.902 521.086 253.759 521.086Z"
            fill="white"
          />
          <path
            d="M246.723 511.592C244.559 511.592 242.811 513.34 242.811 515.505C242.811 517.669 244.559 519.417 246.723 519.417C248.888 519.417 250.628 517.656 250.628 515.505C250.628 513.353 248.879 511.592 246.723 511.592Z"
            fill="white"
          />
          <path
            d="M239.602 502.07C237.425 502.07 235.668 503.84 235.668 506.004C235.668 508.169 237.425 509.951 239.602 509.951C241.779 509.951 243.536 508.181 243.536 506.004C243.536 503.827 241.779 502.07 239.602 502.07Z"
            fill="white"
          />
          <path
            d="M232.328 492.568C230.134 492.568 228.364 494.338 228.364 496.524C228.364 498.709 230.134 500.487 232.328 500.487C234.522 500.487 236.283 498.718 236.283 496.524C236.283 494.33 234.513 492.568 232.328 492.568Z"
            fill="white"
          />
          <path
            d="M224.817 483.146C222.619 483.146 220.841 484.925 220.841 487.123C220.841 489.321 222.619 491.099 224.817 491.099C227.015 491.099 228.794 489.321 228.794 487.123C228.794 484.925 227.015 483.146 224.817 483.146Z"
            fill="white"
          />
          <path
            d="M217.038 473.824C214.831 473.824 213.04 475.615 213.04 477.822C213.04 480.029 214.831 481.828 217.038 481.828C219.244 481.828 221.044 480.037 221.044 477.822C221.044 475.607 219.253 473.824 217.038 473.824Z"
            fill="white"
          />
          <path
            d="M209.992 472.462C212.152 471.95 213.488 469.784 212.976 467.624C212.463 465.465 210.298 464.129 208.138 464.641C205.978 465.153 204.643 467.319 205.155 469.479C205.667 471.638 207.833 472.974 209.992 472.462Z"
            fill="white"
          />
          <path
            d="M200.878 455.287C198.65 455.287 196.838 457.099 196.838 459.327C196.838 461.555 198.65 463.367 200.878 463.367C203.106 463.367 204.918 461.555 204.918 459.327C204.918 457.099 203.106 455.287 200.878 455.287Z"
            fill="white"
          />
          <path
            d="M192.582 446.021C190.345 446.021 188.533 447.834 188.533 450.07C188.533 452.306 190.345 454.119 192.582 454.119C194.818 454.119 196.63 452.306 196.63 450.07C196.63 447.834 194.818 446.021 192.582 446.021Z"
            fill="white"
          />
          <path
            d="M184.225 436.688C181.976 436.688 180.164 438.5 180.164 440.736C180.164 442.973 181.976 444.793 184.225 444.793C186.475 444.793 188.274 442.973 188.274 440.736C188.274 438.5 186.462 436.688 184.225 436.688Z"
            fill="white"
          />
          <path
            d="M175.843 427.213C173.594 427.213 171.773 429.033 171.773 431.283C171.773 433.532 173.594 435.352 175.843 435.352C178.092 435.352 179.913 433.532 179.913 431.283C179.913 429.033 178.092 427.213 175.843 427.213Z"
            fill="white"
          />
          <path
            d="M167.573 417.4C165.324 417.4 163.495 419.221 163.495 421.479C163.495 423.736 165.328 425.557 167.573 425.557C169.818 425.557 171.652 423.724 171.652 421.479C171.652 419.234 169.831 417.4 167.573 417.4Z"
            fill="white"
          />
          <path
            d="M159.463 407.107C157.214 407.107 155.385 408.941 155.385 411.186C155.385 413.431 157.218 415.264 159.463 415.264C161.708 415.264 163.541 413.443 163.541 411.186C163.541 408.928 161.721 407.107 159.463 407.107Z"
            fill="white"
          />
          <path
            d="M151.574 404.348C153.834 404.348 155.665 402.516 155.665 400.257C155.665 397.998 153.834 396.166 151.574 396.166C149.315 396.166 147.483 397.998 147.483 400.257C147.483 402.516 149.315 404.348 151.574 404.348Z"
            fill="white"
          />
          <path
            d="M143.905 384.551C141.648 384.551 139.814 386.384 139.814 388.642C139.814 390.899 141.648 392.72 143.905 392.72C146.163 392.72 147.996 390.887 147.996 388.642C147.996 386.397 146.163 384.551 143.905 384.551Z"
            fill="white"
          />
          <path
            d="M136.441 372.344C134.183 372.344 132.35 374.177 132.35 376.435C132.35 378.692 134.183 380.513 136.441 380.513C138.698 380.513 140.532 378.692 140.532 376.435C140.532 374.177 138.698 372.344 136.441 372.344Z"
            fill="white"
          />
          <path
            d="M129.124 359.822C126.875 359.822 125.046 361.656 125.046 363.913C125.046 366.171 126.879 367.991 129.124 367.991C131.369 367.991 133.215 366.158 133.215 363.913C133.215 361.668 131.382 359.822 129.124 359.822Z"
            fill="white"
          />
          <path
            d="M121.909 347.396C119.652 347.396 117.818 349.23 117.818 351.475C117.818 353.72 119.652 355.566 121.909 355.566C124.167 355.566 125.988 353.732 125.988 351.475C125.988 349.217 124.154 347.396 121.909 347.396Z"
            fill="white"
          />
          <path
            d="M128.916 332.098C126.667 332.098 124.847 333.918 124.847 336.167C124.847 338.417 126.667 340.237 128.916 340.237C131.166 340.237 132.986 338.417 132.986 336.167C132.986 333.918 131.166 332.098 128.916 332.098Z"
            fill="white"
          />
          <path
            d="M136.119 316.463C133.869 316.463 132.049 318.283 132.049 320.533C132.049 322.782 133.869 324.602 136.119 324.602C138.368 324.602 140.188 322.782 140.188 320.533C140.188 318.283 138.368 316.463 136.119 316.463Z"
            fill="white"
          />
          <path
            d="M143.54 300.936C141.304 300.936 139.483 302.756 139.483 304.993C139.483 307.229 141.304 309.05 143.54 309.05C145.777 309.05 147.597 307.229 147.597 304.993C147.597 302.756 145.777 300.936 143.54 300.936Z"
            fill="white"
          />
          <path
            d="M151.2 285.961C148.972 285.961 147.16 287.773 147.16 290.009C147.16 292.246 148.972 294.05 151.2 294.05C153.428 294.05 155.24 292.237 155.24 290.009C155.24 287.781 153.441 285.961 151.2 285.961Z"
            fill="white"
          />
          <path
            d="M159.068 271.969C156.84 271.969 155.028 273.768 155.028 275.996C155.028 278.224 156.84 280.023 159.068 280.023C161.296 280.023 163.096 278.224 163.096 275.996C163.096 273.768 161.284 271.969 159.068 271.969Z"
            fill="white"
          />
          <path
            d="M166.979 259.293C164.764 259.293 162.96 261.092 162.96 263.312C162.96 265.531 164.759 267.318 166.979 267.318C169.198 267.318 170.985 265.527 170.985 263.312C170.985 261.097 169.194 259.293 166.979 259.293Z"
            fill="white"
          />
          <path
            d="M174.86 256.022C177.067 255.963 178.808 254.126 178.75 251.919C178.691 249.712 176.854 247.971 174.647 248.03C172.44 248.089 170.698 249.926 170.757 252.133C170.816 254.34 172.653 256.081 174.86 256.022Z"
            fill="white"
          />
          <path
            d="M182.183 238.074C179.985 238.074 178.207 239.844 178.207 242.038C178.207 244.232 179.985 246.014 182.183 246.014C184.382 246.014 186.147 244.236 186.147 242.038C186.147 239.84 184.369 238.074 182.183 238.074Z"
            fill="white"
          />
          <path
            d="M189.169 229.225C186.992 229.225 185.227 230.994 185.227 233.167C185.227 235.34 186.996 237.101 189.169 237.101C191.342 237.101 193.103 235.34 193.103 233.167C193.103 230.994 191.342 229.225 189.169 229.225Z"
            fill="white"
          />
          <path
            d="M195.611 221.316C193.447 221.316 191.698 223.065 191.698 225.242C191.698 227.419 193.447 229.155 195.611 229.155C197.775 229.155 199.536 227.406 199.536 225.242C199.536 223.078 197.775 221.316 195.611 221.316Z"
            fill="white"
          />
          <path
            d="M201.553 214.207C199.41 214.207 197.661 215.947 197.661 218.099C197.661 220.25 199.41 221.99 201.553 221.99C203.696 221.99 205.444 220.25 205.444 218.099C205.444 215.947 203.704 214.207 201.553 214.207Z"
            fill="white"
          />
          <path
            d="M207.018 208.098C204.875 208.098 203.135 209.838 203.135 211.981C203.135 214.124 204.875 215.864 207.018 215.864C209.161 215.864 210.888 214.124 210.888 211.981C210.888 209.838 209.148 208.098 207.018 208.098Z"
            fill="white"
          />
          <path
            d="M211.983 203.037C209.87 203.037 208.151 204.756 208.151 206.878C208.151 209 209.87 210.71 211.983 210.71C214.097 210.71 215.824 208.991 215.824 206.878C215.824 204.764 214.105 203.037 211.983 203.037Z"
            fill="white"
          />
          <path
            d="M216.465 198.76C214.365 198.76 212.654 200.466 212.654 202.571C212.654 204.676 214.36 206.369 216.465 206.369C218.57 206.369 220.263 204.663 220.263 202.571C220.263 200.478 218.557 198.76 216.465 198.76Z"
            fill="white"
          />
          <path
            d="M220.454 195.035C218.362 195.035 216.677 196.733 216.677 198.812C216.677 200.892 218.362 202.589 220.454 202.589C222.546 202.589 224.222 200.892 224.222 198.812C224.222 196.733 222.537 195.035 220.454 195.035Z"
            fill="white"
          />
          <path
            d="M223.959 191.705C221.888 191.705 220.212 193.381 220.212 195.44C220.212 197.498 221.888 199.187 223.959 199.187C226.03 199.187 227.694 197.506 227.694 195.44C227.694 193.373 226.017 191.705 223.959 191.705Z"
            fill="white"
          />
          <path
            d="M226.998 188.643C224.97 188.643 223.314 190.289 223.314 192.326C223.314 194.363 224.97 196.022 226.998 196.022C229.027 196.022 230.694 194.367 230.694 192.326C230.694 190.285 229.039 188.643 226.998 188.643Z"
            fill="white"
          />
          <path
            d="M229.612 185.736C227.592 185.736 225.971 187.37 225.971 189.386C225.971 191.402 227.592 193.036 229.612 193.036C231.632 193.036 233.253 191.406 233.253 189.386C233.253 187.366 231.632 185.736 229.612 185.736Z"
            fill="white"
          />
          <path
            d="M231.798 182.893C229.799 182.893 228.187 184.509 228.187 186.508C228.187 188.507 229.799 190.12 231.798 190.12C233.797 190.12 235.418 188.507 235.418 186.508C235.418 184.509 233.793 182.893 231.798 182.893Z"
            fill="white"
          />
          <path
            d="M233.589 180.131C231.624 180.131 230.02 181.722 230.02 183.7C230.02 185.677 231.624 187.269 233.589 187.269C235.553 187.269 237.158 185.665 237.158 183.7C237.158 181.735 235.566 180.131 233.589 180.131Z"
            fill="white"
          />
          <path
            d="M235.023 177.447C233.075 177.447 231.505 179.017 231.505 180.953C231.505 182.888 233.075 184.462 235.023 184.462C236.971 184.462 238.528 182.896 238.528 180.953C238.528 179.009 236.958 177.447 235.023 177.447Z"
            fill="white"
          />
          <path
            d="M236.148 181.735C238.063 181.735 239.615 180.183 239.615 178.268C239.615 176.353 238.063 174.801 236.148 174.801C234.233 174.801 232.681 176.353 232.681 178.268C232.681 180.183 234.233 181.735 236.148 181.735Z"
            fill="white"
          />
          <path
            d="M237.014 172.207C235.129 172.207 233.602 173.739 233.602 175.627C233.602 177.516 235.134 179.039 237.014 179.039C238.894 179.039 240.438 177.512 240.438 175.627C240.438 173.743 238.906 172.207 237.014 172.207Z"
            fill="white"
          />
          <path
            d="M237.646 169.607C235.783 169.607 234.272 171.118 234.272 172.981C234.272 174.844 235.783 176.355 237.646 176.355C239.509 176.355 241.02 174.844 241.02 172.981C241.02 171.118 239.509 169.607 237.646 169.607Z"
            fill="white"
          />
          <path
            d="M238.066 166.996C236.245 166.996 234.756 168.473 234.756 170.302C234.756 172.131 236.245 173.608 238.066 173.608C239.887 173.608 241.376 172.131 241.376 170.302C241.376 168.473 239.887 166.996 238.066 166.996Z"
            fill="white"
          />
          <path
            d="M238.303 164.258C236.504 164.258 235.044 165.713 235.044 167.517C235.044 169.321 236.5 170.776 238.303 170.776C240.107 170.776 241.55 169.312 241.55 167.517C241.55 165.722 240.094 164.258 238.303 164.258Z"
            fill="white"
          />
          <path
            d="M238.375 161.359C236.606 161.359 235.18 162.79 235.18 164.559C235.18 166.329 236.606 167.759 238.375 167.759C240.145 167.759 241.579 166.329 241.579 164.559C241.579 162.79 240.145 161.359 238.375 161.359Z"
            fill="white"
          />
          <path
            d="M238.355 158.211C236.615 158.211 235.21 159.62 235.21 161.364C235.21 163.108 236.615 164.509 238.355 164.509C240.095 164.509 241.508 163.104 241.508 161.364C241.508 159.624 240.103 158.211 238.355 158.211Z"
            fill="white"
          />
          <path
            d="M238.324 154.748C236.64 154.748 235.265 156.123 235.265 157.808C235.265 159.493 236.64 160.872 238.324 160.872C240.009 160.872 241.384 159.505 241.384 157.808C241.384 156.11 240.022 154.748 238.324 154.748Z"
            fill="white"
          />
          <path
            d="M238.404 150.75C236.749 150.75 235.396 152.091 235.396 153.759C235.396 155.427 236.749 156.776 238.404 156.776C240.059 156.776 241.422 155.422 241.422 153.759C241.422 152.095 240.068 150.75 238.404 150.75Z"
            fill="white"
          />
          <path
            d="M238.834 146.064C237.208 146.064 235.889 147.389 235.889 149.022C235.889 150.656 237.208 151.968 238.834 151.968C240.459 151.968 241.792 150.648 241.792 149.022C241.792 147.397 240.472 146.064 238.834 146.064Z"
            fill="white"
          />
          <path
            d="M240.009 140.348C238.418 140.348 237.115 141.642 237.115 143.238C237.115 144.833 238.418 146.132 240.009 146.132C241.601 146.132 242.904 144.842 242.904 143.238C242.904 141.634 241.614 140.348 240.009 140.348Z"
            fill="white"
          />
          <path
            d="M242.551 133.088C241.01 133.088 239.763 134.336 239.763 135.889C239.763 137.442 241.01 138.677 242.551 138.677C244.091 138.677 245.352 137.429 245.352 135.889C245.352 134.348 244.104 133.088 242.551 133.088Z"
            fill="white"
          />
          <path
            d="M247.419 123.344C245.908 123.344 244.682 124.57 244.682 126.081C244.682 127.592 245.908 128.818 247.419 128.818C248.93 128.818 250.156 127.592 250.156 126.081C250.156 124.57 248.93 123.344 247.419 123.344Z"
            fill="white"
          />
          <path
            d="M263.897 119.473C262.378 119.473 261.16 120.699 261.16 122.21C261.16 123.721 262.378 124.951 263.897 124.951C265.417 124.951 266.635 123.725 266.635 122.21C266.635 120.695 265.408 119.473 263.897 119.473Z"
            fill="white"
          />
          <path
            d="M283.388 111.9C281.878 111.9 280.643 113.127 280.643 114.646C280.643 116.165 281.882 117.388 283.388 117.388C284.895 117.388 286.138 116.161 286.138 114.646C286.138 113.131 284.912 111.9 283.388 111.9Z"
            fill="white"
          />
          <path
            d="M306.527 99.377C305.008 99.377 303.781 100.603 303.781 102.123C303.781 103.642 305.008 104.86 306.527 104.86C308.046 104.86 309.264 103.633 309.264 102.123C309.264 100.612 308.038 99.377 306.527 99.377Z"
            fill="white"
          />
          <path
            d="M333.346 80.8184C331.835 80.8184 330.608 82.0448 330.608 83.5556C330.608 85.0664 331.835 86.2928 333.346 86.2928C334.856 86.2928 336.083 85.0706 336.083 83.5556C336.083 82.0406 334.865 80.8184 333.346 80.8184Z"
            fill="white"
          />
          <path
            d="M362.51 56.6113C360.999 56.6113 359.772 57.8378 359.772 59.3486C359.772 60.8593 360.999 62.0858 362.51 62.0858C364.02 62.0858 365.247 60.8593 365.247 59.3486C365.247 57.8378 364.02 56.6113 362.51 56.6113Z"
            fill="white"
          />
          <path
            d="M391.974 28.3105C390.455 28.3105 389.229 29.537 389.229 31.0563C389.229 32.5755 390.455 33.7935 391.974 33.7935C393.493 33.7935 394.711 32.567 394.711 31.0563C394.711 29.5455 393.485 28.3105 391.974 28.3105Z"
            fill="white"
          />
          <path
            d="M419.579 -0.626953C418.068 -0.626953 416.833 0.607978 416.833 2.11451C416.833 3.62104 418.072 4.86446 419.579 4.86446C421.085 4.86446 422.324 3.63802 422.324 2.11451C422.324 0.591003 421.098 -0.626953 419.579 -0.626953Z"
            fill="white"
          />
          <path
            d="M856.304 -6.17188C854.555 -6.17188 853.138 -4.75446 853.138 -3.00604C853.138 -1.25761 854.555 0.151311 856.304 0.151311C858.052 0.151311 859.465 -1.25761 859.465 -3.00604C859.465 -4.75446 858.048 -6.17188 856.304 -6.17188Z"
            fill="white"
          />
          <path
            d="M863.475 4.91406C861.697 4.91406 860.25 6.36118 860.25 8.13507C860.25 9.90896 861.697 11.3561 863.475 11.3561C865.253 11.3561 866.692 9.90896 866.692 8.13507C866.692 6.36118 865.253 4.91406 863.475 4.91406Z"
            fill="white"
          />
          <path
            d="M870.428 16.5527C868.607 16.5527 867.126 18.0253 867.126 19.8501C867.126 21.6749 868.603 23.156 870.428 23.156C872.252 23.156 873.725 21.6792 873.725 19.8501C873.725 18.0211 872.248 16.5527 870.428 16.5527Z"
            fill="white"
          />
          <path
            d="M877.149 28.8047C875.295 28.8047 873.797 30.307 873.797 32.1615C873.797 34.016 875.295 35.5225 877.149 35.5225C879.004 35.5225 880.511 34.0118 880.511 32.1615C880.511 30.3112 879.012 28.8047 877.149 28.8047Z"
            fill="white"
          />
          <path
            d="M883.634 41.6367C881.762 41.6367 880.23 43.1602 880.23 45.0444C880.23 46.9287 881.762 48.4522 883.634 48.4522C885.505 48.4522 887.046 46.9287 887.046 45.0444C887.046 43.1602 885.514 41.6367 883.634 41.6367Z"
            fill="white"
          />
          <path
            d="M889.902 54.9629C887.988 54.9629 886.435 56.5119 886.435 58.4215C886.435 60.3312 887.984 61.8802 889.902 61.8802C891.82 61.8802 893.356 60.3312 893.356 58.4215C893.356 56.5119 891.807 54.9629 889.902 54.9629Z"
            fill="white"
          />
          <path
            d="M895.928 68.7656C893.972 68.7656 892.389 70.3485 892.389 72.2964C892.389 74.2443 893.972 75.8357 895.928 75.8357C897.884 75.8357 899.454 74.2528 899.454 72.2964C899.454 70.3401 897.872 68.7656 895.928 68.7656Z"
            fill="white"
          />
          <path
            d="M901.725 83.0586C899.748 83.0586 898.144 84.6627 898.144 86.6403C898.144 88.6179 899.748 90.222 901.725 90.222C903.703 90.222 905.307 88.6179 905.307 86.6403C905.307 84.6627 903.703 83.0586 901.725 83.0586Z"
            fill="white"
          />
          <path
            d="M907.364 97.7617C905.366 97.7617 903.753 99.3786 903.753 101.373C903.753 103.368 905.366 104.985 907.364 104.985C909.363 104.985 910.976 103.372 910.976 101.373C910.976 99.3743 909.35 97.7617 907.364 97.7617Z"
            fill="white"
          />
          <path
            d="M912.903 112.752C910.883 112.752 909.249 114.386 909.249 116.406C909.249 118.426 910.883 120.06 912.903 120.06C914.923 120.06 916.565 118.426 916.565 116.406C916.565 114.386 914.919 112.752 912.903 112.752Z"
            fill="white"
          />
          <path
            d="M918.471 127.814C916.409 127.814 914.745 129.478 914.745 131.54C914.745 133.603 916.409 135.262 918.471 135.262C920.534 135.262 922.184 133.59 922.184 131.54C922.184 129.491 920.521 127.814 918.471 127.814Z"
            fill="white"
          />
          <path
            d="M924.153 142.83C922.082 142.83 920.397 144.515 920.397 146.599C920.397 148.682 922.082 150.354 924.153 150.354C926.224 150.354 927.922 148.669 927.922 146.599C927.922 144.528 926.237 142.83 924.153 142.83Z"
            fill="white"
          />
          <path
            d="M930.073 157.566C927.98 157.566 926.274 159.272 926.274 161.365C926.274 163.457 927.98 165.163 930.073 165.163C932.165 165.163 933.871 163.465 933.871 161.365C933.871 159.264 932.173 157.566 930.073 157.566Z"
            fill="white"
          />
          <path
            d="M936.308 171.816C934.195 171.816 932.48 173.527 932.48 175.649C932.48 177.77 934.199 179.472 936.308 179.472C938.417 179.472 940.14 177.762 940.14 175.649C940.14 173.535 938.422 171.816 936.308 171.816Z"
            fill="white"
          />
          <path
            d="M942.919 185.365C940.776 185.365 939.036 187.097 939.036 189.236C939.036 191.374 940.772 193.114 942.919 193.114C945.066 193.114 946.789 191.383 946.789 189.236C946.789 187.088 945.054 185.365 942.919 185.365Z"
            fill="white"
          />
          <path
            d="M949.933 198.191C947.769 198.191 946.021 199.948 946.021 202.117C946.021 204.285 947.769 206.03 949.933 206.03C952.098 206.03 953.846 204.281 953.846 202.117C953.846 199.953 952.098 198.191 949.933 198.191Z"
            fill="white"
          />
          <path
            d="M957.373 210.244C955.196 210.244 953.427 212.014 953.427 214.187C953.427 216.359 955.196 218.121 957.373 218.121C959.551 218.121 961.316 216.359 961.316 214.187C961.316 212.014 959.546 210.244 957.373 210.244Z"
            fill="white"
          />
          <path
            d="M965.254 221.344C963.068 221.344 961.29 223.113 961.29 225.307C961.29 227.501 963.068 229.284 965.254 229.284C967.439 229.284 969.23 227.506 969.23 225.307C969.23 223.109 967.452 221.344 965.254 221.344Z"
            fill="white"
          />
          <path
            d="M973.559 231.41C971.344 231.41 969.553 233.21 969.553 235.429C969.553 237.648 971.344 239.435 973.559 239.435C975.774 239.435 977.578 237.644 977.578 235.429C977.578 233.214 975.778 231.41 973.559 231.41Z"
            fill="white"
          />
          <path
            d="M982.249 240.467C980.021 240.467 978.209 242.266 978.209 244.494C978.209 246.722 980.021 248.521 982.249 248.521C984.477 248.521 986.276 246.722 986.276 244.494C986.276 242.266 984.477 240.467 982.249 240.467Z"
            fill="white"
          />
          <path
            d="M991.242 248.428C988.992 248.428 987.185 250.248 987.185 252.485C987.185 254.721 988.997 256.554 991.242 256.554C993.487 256.554 995.299 254.734 995.299 252.485C995.299 250.236 993.478 248.428 991.242 248.428Z"
            fill="white"
          />
          <path
            d="M1000.47 255.338C998.215 255.338 996.395 257.158 996.395 259.416C996.395 261.674 998.215 263.494 1000.47 263.494C1002.73 263.494 1004.55 261.661 1004.55 259.416C1004.55 257.171 1002.72 255.338 1000.47 255.338Z"
            fill="white"
          />
          <path
            d="M1009.85 261.207C1007.57 261.207 1005.74 263.049 1005.74 265.319C1005.74 267.59 1007.57 269.431 1009.85 269.431C1012.13 269.431 1013.95 267.59 1013.95 265.319C1013.95 263.049 1012.12 261.207 1009.85 261.207Z"
            fill="white"
          />
          <path
            d="M1019.28 266.111C1017 266.111 1015.15 267.953 1015.15 270.232C1015.15 272.511 1017 274.365 1019.28 274.365C1021.56 274.365 1023.41 272.511 1023.41 270.232C1023.41 267.953 1021.56 266.111 1019.28 266.111Z"
            fill="white"
          />
          <path
            d="M1028.7 270.15C1026.41 270.15 1024.56 272.001 1024.56 274.292C1024.56 276.584 1026.41 278.434 1028.7 278.434C1030.99 278.434 1032.84 276.58 1032.84 274.292C1032.84 272.005 1030.98 270.15 1028.7 270.15Z"
            fill="white"
          />
          <path
            d="M1038.03 273.543C1035.74 273.543 1033.88 275.406 1033.88 277.698C1033.88 279.989 1035.74 281.852 1038.03 281.852C1040.33 281.852 1042.19 279.989 1042.19 277.698C1042.19 275.406 1040.33 273.543 1038.03 273.543Z"
            fill="white"
          />
          <path
            d="M1047.3 276.416C1045 276.416 1043.14 278.279 1043.14 280.571C1043.14 282.862 1044.99 284.725 1047.3 284.725C1049.6 284.725 1051.45 282.875 1051.45 280.571C1051.45 278.266 1049.59 276.416 1047.3 276.416Z"
            fill="white"
          />
          <path
            d="M1056.46 278.883C1054.16 278.883 1052.3 280.746 1052.3 283.037C1052.3 285.329 1054.16 287.192 1056.46 287.192C1058.75 287.192 1060.61 285.329 1060.61 283.037C1060.61 280.746 1058.76 278.883 1056.46 278.883Z"
            fill="white"
          />
          <path
            d="M1065.54 281.018C1063.25 281.018 1061.39 282.872 1061.39 285.172C1061.39 287.472 1063.25 289.327 1065.54 289.327C1067.83 289.327 1069.7 287.464 1069.7 285.172C1069.7 282.881 1067.84 281.018 1065.54 281.018Z"
            fill="white"
          />
          <path
            d="M1074.57 282.887C1072.27 282.887 1070.41 284.75 1070.41 287.041C1070.41 289.333 1072.27 291.196 1074.57 291.196C1076.87 291.196 1078.72 289.341 1078.72 287.041C1078.72 284.741 1076.86 282.887 1074.57 282.887Z"
            fill="white"
          />
          <path
            d="M1083.52 284.635C1081.22 284.635 1079.36 286.498 1079.36 288.789C1079.36 291.081 1081.22 292.944 1083.52 292.944C1085.82 292.944 1087.67 291.094 1087.67 288.789C1087.67 286.485 1085.81 284.635 1083.52 284.635Z"
            fill="white"
          />
          <path
            d="M1078.64 285.438C1076.35 285.438 1074.48 287.301 1074.48 289.592C1074.48 291.884 1076.35 293.747 1078.64 293.747C1080.93 293.747 1082.79 291.892 1082.79 289.592C1082.79 287.292 1080.94 285.438 1078.64 285.438Z"
            fill="white"
          />
          <path
            d="M1073.57 286.219C1071.28 286.219 1069.41 288.082 1069.41 290.373C1069.41 292.665 1071.28 294.528 1073.57 294.528C1075.86 294.528 1077.72 292.673 1077.72 290.373C1077.72 288.073 1075.87 286.219 1073.57 286.219Z"
            fill="white"
          />
          <path
            d="M1068.29 287.008C1066 287.008 1064.14 288.871 1064.14 291.162C1064.14 293.454 1066 295.317 1068.29 295.317C1070.58 295.317 1072.45 293.454 1072.45 291.162C1072.45 288.871 1070.6 287.008 1068.29 287.008Z"
            fill="white"
          />
          <path
            d="M1062.8 287.801C1060.5 287.801 1058.64 289.664 1058.64 291.955C1058.64 294.247 1060.5 296.11 1062.8 296.11C1065.09 296.11 1066.95 294.256 1066.95 291.955C1066.95 289.655 1065.1 287.801 1062.8 287.801Z"
            fill="white"
          />
          <path
            d="M1057.06 288.627C1054.76 288.627 1052.91 290.49 1052.91 292.79C1052.91 295.09 1054.76 296.945 1057.06 296.945C1059.37 296.945 1061.22 295.082 1061.22 292.79C1061.22 290.498 1059.35 288.627 1057.06 288.627Z"
            fill="white"
          />
          <path
            d="M1051.07 289.51C1048.77 289.51 1046.9 291.36 1046.9 293.664C1046.9 295.969 1048.77 297.819 1051.07 297.819C1053.37 297.819 1055.22 295.956 1055.22 293.664C1055.22 291.373 1053.36 289.51 1051.07 289.51Z"
            fill="white"
          />
          <path
            d="M1044.8 290.455C1042.5 290.455 1040.64 292.318 1040.64 294.61C1040.64 296.901 1042.5 298.764 1044.8 298.764C1047.1 298.764 1048.95 296.91 1048.95 294.61C1048.95 292.31 1047.09 290.455 1044.8 290.455Z"
            fill="white"
          />
          <path
            d="M1038.26 291.514C1035.98 291.514 1034.11 293.368 1034.11 295.668C1034.11 297.968 1035.97 299.823 1038.26 299.823C1040.55 299.823 1042.42 297.96 1042.42 295.668C1042.42 293.377 1040.57 291.514 1038.26 291.514Z"
            fill="white"
          />
          <path
            d="M1031.46 292.703C1029.16 292.703 1027.3 294.553 1027.3 296.858C1027.3 299.162 1029.16 301.012 1031.46 301.012C1033.75 301.012 1035.62 299.149 1035.62 296.858C1035.62 294.566 1033.76 292.703 1031.46 292.703Z"
            fill="white"
          />
          <path
            d="M1024.39 294.059C1022.1 294.059 1020.24 295.909 1020.24 298.213C1020.24 300.518 1022.1 302.368 1024.39 302.368C1026.68 302.368 1028.54 300.505 1028.54 298.213C1028.54 295.922 1026.69 294.059 1024.39 294.059Z"
            fill="white"
          />
          <path
            d="M1017.06 295.586C1014.78 295.586 1012.93 297.44 1012.93 299.719C1012.93 301.998 1014.78 303.861 1017.06 303.861C1019.34 303.861 1021.2 302.011 1021.2 299.719C1021.2 297.428 1019.35 295.586 1017.06 295.586Z"
            fill="white"
          />
          <path
            d="M1009.48 297.26C1007.22 297.26 1005.38 299.093 1005.38 301.359C1005.38 303.625 1007.22 305.471 1009.48 305.471C1011.74 305.471 1013.59 303.63 1013.59 301.359C1013.59 299.089 1011.75 297.26 1009.48 297.26Z"
            fill="white"
          />
          <path
            d="M1001.65 299.072C999.391 299.072 997.558 300.906 997.558 303.163C997.558 305.421 999.391 307.263 1001.65 307.263C1003.91 307.263 1005.75 305.429 1005.75 303.163C1005.75 300.897 1003.91 299.072 1001.65 299.072Z"
            fill="white"
          />
          <path
            d="M993.594 301.059C991.336 301.059 989.516 302.892 989.516 305.137C989.516 307.382 991.336 309.215 993.594 309.215C995.852 309.215 997.664 307.382 997.664 305.137C997.664 302.892 995.843 301.059 993.594 301.059Z"
            fill="white"
          />
          <path
            d="M985.318 303.258C983.082 303.258 981.27 305.07 981.27 307.306C981.27 309.543 983.082 311.355 985.318 311.355C987.555 311.355 989.367 309.543 989.367 307.306C989.367 305.07 987.555 303.258 985.318 303.258Z"
            fill="white"
          />
          <path
            d="M976.869 305.65C974.641 305.65 972.842 307.45 972.842 309.678C972.842 311.906 974.641 313.697 976.869 313.697C979.097 313.697 980.888 311.897 980.888 309.678C980.888 307.458 979.089 305.65 976.869 305.65Z"
            fill="white"
          />
          <path
            d="M968.27 308.281C966.063 308.281 964.272 310.059 964.272 312.266C964.272 314.473 966.063 316.264 968.27 316.264C970.477 316.264 972.255 314.473 972.255 312.266C972.255 310.059 970.464 308.281 968.27 308.281Z"
            fill="white"
          />
          <path
            d="M959.558 311.148C957.364 311.148 955.595 312.927 955.595 315.112C955.595 317.298 957.364 319.076 959.558 319.076C961.752 319.076 963.514 317.298 963.514 315.112C963.514 312.927 961.744 311.148 959.558 311.148Z"
            fill="white"
          />
          <path
            d="M950.715 314.342C948.538 314.342 946.781 316.103 946.781 318.276C946.781 320.449 948.542 322.21 950.715 322.21C952.888 322.21 954.649 320.453 954.649 318.276C954.649 316.099 952.892 314.342 950.715 314.342Z"
            fill="white"
          />
          <path
            d="M941.751 317.92C939.608 317.92 937.868 319.66 937.868 321.803C937.868 323.946 939.608 325.694 941.751 325.694C943.894 325.694 945.643 323.955 945.643 321.803C945.643 319.651 943.894 317.92 941.751 317.92Z"
            fill="white"
          />
          <path
            d="M932.708 321.875C930.573 321.875 928.846 323.602 928.846 325.737C928.846 327.871 930.573 329.599 932.708 329.599C934.842 329.599 936.557 327.871 936.557 325.737C936.557 323.602 934.829 321.875 932.708 321.875Z"
            fill="white"
          />
          <path
            d="M923.589 326.268C921.476 326.268 919.77 327.986 919.77 330.1C919.77 332.213 921.476 333.919 923.589 333.919C925.702 333.919 927.421 332.213 927.421 330.1C927.421 327.986 925.702 326.268 923.589 326.268Z"
            fill="white"
          />
          <path
            d="M914.43 331.131C912.338 331.131 910.641 332.828 910.641 334.921C910.641 337.013 912.338 338.71 914.43 338.71C916.522 338.71 918.228 337.013 918.228 334.921C918.228 332.828 916.531 331.131 914.43 331.131Z"
            fill="white"
          />
          <path
            d="M905.264 336.512C903.201 336.512 901.529 338.188 901.529 340.246C901.529 342.304 903.205 343.981 905.264 343.981C907.322 343.981 908.998 342.304 908.998 340.246C908.998 338.188 907.322 336.512 905.264 336.512Z"
            fill="white"
          />
          <path
            d="M896.072 342.412C894.031 342.412 892.376 344.067 892.376 346.117C892.376 348.167 894.031 349.813 896.072 349.813C898.114 349.813 899.777 348.158 899.777 346.117C899.777 344.076 898.122 342.412 896.072 342.412Z"
            fill="white"
          />
          <path
            d="M886.901 348.875C884.881 348.875 883.247 350.509 883.247 352.529C883.247 354.549 884.881 356.183 886.901 356.183C888.921 356.183 890.555 354.549 890.555 352.529C890.555 350.509 888.921 348.875 886.901 348.875Z"
            fill="white"
          />
          <path
            d="M877.764 355.91C875.766 355.91 874.145 357.536 874.145 359.53C874.145 361.525 875.77 363.142 877.764 363.142C879.759 363.142 881.376 361.516 881.376 359.53C881.376 357.544 879.755 355.91 877.764 355.91Z"
            fill="white"
          />
          <path
            d="M868.648 363.551C866.679 363.551 865.088 365.134 865.088 367.099C865.088 369.063 866.679 370.646 868.648 370.646C870.618 370.646 872.196 369.055 872.196 367.099C872.196 365.142 870.605 363.551 868.648 363.551Z"
            fill="white"
          />
          <path
            d="M860.155 378.72C862.066 378.41 863.363 376.609 863.053 374.698C862.743 372.787 860.942 371.489 859.031 371.8C857.12 372.11 855.823 373.91 856.133 375.821C856.443 377.732 858.244 379.03 860.155 378.72Z"
            fill="white"
          />
          <path
            d="M850.579 380.73C848.665 380.73 847.125 382.271 847.125 384.185C847.125 386.099 848.665 387.639 850.579 387.639C852.493 387.639 854.034 386.099 854.034 384.185C854.034 382.271 852.485 380.73 850.579 380.73Z"
            fill="white"
          />
          <path
            d="M841.607 390.332C839.723 390.332 838.195 391.864 838.195 393.744C838.195 395.624 839.727 397.156 841.607 397.156C843.487 397.156 845.023 395.624 845.023 393.744C845.023 391.864 843.492 390.332 841.607 390.332Z"
            fill="white"
          />
          <path
            d="M832.793 400.787C830.951 400.787 829.453 402.285 829.453 404.127C829.453 405.969 830.951 407.467 832.793 407.467C834.635 407.467 836.133 405.969 836.133 404.127C836.133 402.285 834.635 400.787 832.793 400.787Z"
            fill="white"
          />
          <path
            d="M824.31 412.268C822.49 412.268 821.009 413.744 821.009 415.556C821.009 417.369 822.486 418.854 824.31 418.854C826.135 418.854 827.599 417.377 827.599 415.556C827.599 413.736 826.123 412.268 824.31 412.268Z"
            fill="white"
          />
          <path
            d="M819.345 429.234C817.575 429.234 816.149 430.669 816.149 432.43C816.149 434.191 817.575 435.613 819.345 435.613C821.115 435.613 822.532 434.187 822.532 432.43C822.532 430.673 821.106 429.234 819.345 429.234Z"
            fill="white"
          />
          <path
            d="M809.147 439.279C807.386 439.279 805.96 440.705 805.96 442.466C805.96 444.228 807.386 445.653 809.147 445.653C810.908 445.653 812.33 444.228 812.33 442.466C812.33 440.705 810.904 439.279 809.147 439.279Z"
            fill="white"
          />
          <path
            d="M798.916 449.791C797.167 449.791 795.741 451.217 795.741 452.978C795.741 454.739 797.167 456.161 798.916 456.161C800.664 456.161 802.103 454.735 802.103 452.978C802.103 451.221 800.677 449.791 798.916 449.791Z"
            fill="white"
          />
          <path
            d="M788.786 460.854C787.037 460.854 785.611 462.279 785.611 464.028C785.611 465.776 787.037 467.202 788.786 467.202C790.534 467.202 791.96 465.785 791.96 464.028C791.96 462.271 790.543 460.854 788.786 460.854Z"
            fill="white"
          />
          <path
            d="M778.753 472.447C777.005 472.447 775.579 473.873 775.579 475.622C775.579 477.37 777.005 478.796 778.753 478.796C780.502 478.796 781.928 477.37 781.928 475.622C781.928 473.873 780.51 472.447 778.753 472.447Z"
            fill="white"
          />
          <path
            d="M768.73 484.301C766.99 484.301 765.577 485.718 765.577 487.462C765.577 489.207 766.995 490.615 768.73 490.615C770.466 490.615 771.892 489.198 771.892 487.462C771.892 485.727 770.474 484.301 768.73 484.301Z"
            fill="white"
          />
          <path
            d="M758.655 496.273C756.907 496.273 755.502 497.691 755.502 499.427C755.502 501.162 756.907 502.58 758.655 502.58C760.403 502.58 761.808 501.162 761.808 499.427C761.808 497.691 760.391 496.273 758.655 496.273Z"
            fill="white"
          />
          <path
            d="M748.386 508.096C746.646 508.096 745.232 509.513 745.232 511.249C745.232 512.984 746.65 514.415 748.386 514.415C750.121 514.415 751.539 512.997 751.539 511.249C751.539 509.5 750.134 508.096 748.386 508.096Z"
            fill="white"
          />
          <path
            d="M737.737 519.418C735.997 519.418 734.593 520.835 734.593 522.571C734.593 524.307 735.997 525.716 737.737 525.716C739.477 525.716 740.89 524.311 740.89 522.571C740.89 520.831 739.486 519.418 737.737 519.418Z"
            fill="white"
          />
          <path
            d="M726.653 529.992C724.913 529.992 723.509 531.397 723.509 533.137C723.509 534.877 724.913 536.281 726.653 536.281C728.393 536.281 729.806 534.877 729.806 533.137C729.806 531.397 728.389 529.992 726.653 529.992Z"
            fill="white"
          />
          <path
            d="M715.119 539.602C713.392 539.602 711.987 541.006 711.987 542.746C711.987 544.486 713.392 545.891 715.119 545.891C716.846 545.891 718.264 544.486 718.264 542.746C718.264 541.006 716.859 539.602 715.119 539.602Z"
            fill="white"
          />
          <path
            d="M703.13 548.143C701.403 548.143 699.998 549.547 699.998 551.287C699.998 553.027 701.403 554.432 703.13 554.432C704.857 554.432 706.275 553.027 706.275 551.287C706.275 549.547 704.87 548.143 703.13 548.143Z"
            fill="white"
          />
          <path
            d="M690.704 555.439C688.977 555.439 687.572 556.844 687.572 558.571C687.572 560.299 688.977 561.703 690.704 561.703C692.431 561.703 693.836 560.307 693.836 558.571C693.836 556.836 692.431 555.439 690.704 555.439Z"
            fill="white"
          />
          <path
            d="M677.965 561.592C676.238 561.592 674.833 562.996 674.833 564.724C674.833 566.451 676.238 567.847 677.965 567.847C679.692 567.847 681.088 566.451 681.088 564.724C681.088 562.996 679.692 561.592 677.965 561.592Z"
            fill="white"
          />
          <path
            d="M664.974 566.723C663.246 566.723 661.842 568.127 661.842 569.855C661.842 571.582 663.246 572.986 664.974 572.986C666.701 572.986 668.106 571.582 668.106 569.855C668.106 568.127 666.701 566.723 664.974 566.723Z"
            fill="white"
          />
          <path
            d="M651.746 570.895C650.019 570.895 648.623 572.291 648.623 574.018C648.623 575.745 650.019 577.141 651.746 577.141C653.474 577.141 654.87 575.745 654.87 574.018C654.87 572.291 653.474 570.895 651.746 570.895Z"
            fill="white"
          />
          <path
            d="M638.341 574.291C636.622 574.291 635.218 575.696 635.218 577.414C635.218 579.133 636.622 580.538 638.341 580.538C640.06 580.538 641.465 579.142 641.465 577.414C641.465 575.687 640.068 574.291 638.341 574.291Z"
            fill="white"
          />
          <path
            d="M624.832 577.141C623.114 577.141 621.722 578.537 621.722 580.251C621.722 581.966 623.118 583.362 624.832 583.362C626.547 583.362 627.943 581.966 627.943 580.251C627.943 578.537 626.547 577.141 624.832 577.141Z"
            fill="white"
          />
          <path
            d="M611.915 585.893C613.587 585.498 614.622 583.823 614.228 582.151C613.833 580.479 612.158 579.444 610.486 579.838C608.813 580.233 607.778 581.908 608.173 583.58C608.567 585.252 610.243 586.288 611.915 585.893Z"
            fill="white"
          />
          <path
            d="M597.562 582.264C595.843 582.264 594.451 583.66 594.451 585.374C594.451 587.089 595.847 588.485 597.562 588.485C599.276 588.485 600.673 587.089 600.673 585.374C600.673 583.66 599.276 582.264 597.562 582.264Z"
            fill="white"
          />
          <path
            d="M583.97 584.979C582.252 584.979 580.868 586.375 580.868 588.081C580.868 589.787 582.252 591.191 583.97 591.191C585.689 591.191 587.081 589.795 587.081 588.081C587.081 586.366 585.685 584.979 583.97 584.979Z"
            fill="white"
          />
          <path
            d="M570.463 587.996C568.744 587.996 567.36 589.392 567.36 591.098C567.36 592.804 568.744 594.2 570.463 594.2C572.181 594.2 573.565 592.817 573.565 591.098C573.565 589.38 572.168 587.996 570.463 587.996Z"
            fill="white"
          />
          <path
            d="M557.025 591.408C555.306 591.408 553.923 592.804 553.923 594.51C553.923 596.216 555.306 597.6 557.025 597.6C558.744 597.6 560.114 596.216 560.114 594.51C560.114 592.804 558.731 591.408 557.025 591.408Z"
            fill="white"
          />
          <path
            d="M543.658 595.033C541.939 595.033 540.556 596.429 540.556 598.135C540.556 599.841 541.939 601.238 543.658 601.238C545.377 601.238 546.747 599.854 546.747 598.135C546.747 596.417 545.364 595.033 543.658 595.033Z"
            fill="white"
          />
          <path
            d="M530.337 598.688C528.631 598.688 527.248 600.071 527.248 601.777C527.248 603.483 528.631 604.866 530.337 604.866C532.043 604.866 533.427 603.483 533.427 601.777C533.427 600.071 532.043 598.688 530.337 598.688Z"
            fill="white"
          />
          <path
            d="M517.007 602.414C515.301 602.414 513.918 603.798 513.918 605.504C513.918 607.21 515.301 608.593 517.007 608.593C518.713 608.593 520.097 607.21 520.097 605.504C520.097 603.798 518.713 602.414 517.007 602.414Z"
            fill="white"
          />
          <path
            d="M503.644 606.139C501.938 606.139 500.555 607.522 500.555 609.228C500.555 610.934 501.938 612.309 503.644 612.309C505.35 612.309 506.734 610.926 506.734 609.228C506.734 607.531 505.35 606.139 503.644 606.139Z"
            fill="white"
          />
          <path
            d="M490.217 609.572C488.511 609.572 487.136 610.947 487.136 612.653C487.136 614.359 488.511 615.743 490.217 615.743C491.923 615.743 493.298 614.359 493.298 612.653C493.298 610.947 491.923 609.572 490.217 609.572Z"
            fill="white"
          />
          <path
            d="M476.666 612.717C474.96 612.717 473.585 614.092 473.585 615.798C473.585 617.504 474.96 618.87 476.666 618.87C478.372 618.87 479.747 617.495 479.747 615.798C479.747 614.1 478.363 612.717 476.666 612.717Z"
            fill="white"
          />
          <path
            d="M462.926 615.535C461.228 615.535 459.845 616.91 459.845 618.616C459.845 620.322 461.228 621.697 462.926 621.697C464.623 621.697 466.007 620.314 466.007 618.616C466.007 616.919 464.632 615.535 462.926 615.535Z"
            fill="white"
          />
          <path
            d="M448.967 617.805C447.261 617.805 445.886 619.18 445.886 620.877C445.886 622.575 447.261 623.945 448.967 623.945C450.673 623.945 452.039 622.57 452.039 620.877C452.039 619.184 450.664 617.805 448.967 617.805Z"
            fill="white"
          />
          <path
            d="M434.691 619.346C432.985 619.346 431.602 620.721 431.602 622.427C431.602 624.133 432.985 625.508 434.691 625.508C436.397 625.508 437.772 624.133 437.772 622.427C437.772 620.721 436.389 619.346 434.691 619.346Z"
            fill="white"
          />
          <path
            d="M419.962 620.199C418.256 620.199 416.881 621.574 416.881 623.28C416.881 624.986 418.256 626.361 419.962 626.361C421.668 626.361 423.043 624.978 423.043 623.28C423.043 621.583 421.659 620.199 419.962 620.199Z"
            fill="white"
          />
          <path
            d="M404.642 620.168C402.936 620.168 401.561 621.551 401.561 623.249C401.561 624.946 402.936 626.33 404.642 626.33C406.348 626.33 407.722 624.955 407.722 623.249C407.722 621.543 406.339 620.168 404.642 620.168Z"
            fill="white"
          />
          <path
            d="M388.668 619.023C386.97 619.023 385.587 620.398 385.587 622.096C385.587 623.793 386.97 625.177 388.668 625.177C390.365 625.177 391.74 623.793 391.74 622.096C391.74 620.398 390.365 619.023 388.668 619.023Z"
            fill="white"
          />
          <path
            d="M371.96 616.814C370.262 616.814 368.892 618.198 368.892 619.895C368.892 621.593 370.267 622.964 371.96 622.964C373.653 622.964 375.041 621.589 375.041 619.895C375.041 618.202 373.657 616.814 371.96 616.814Z"
            fill="white"
          />
          <path
            d="M364.343 613.592C362.616 613.592 361.211 614.996 361.211 616.736C361.211 618.476 362.616 619.868 364.343 619.868C366.07 619.868 367.487 618.464 367.487 616.736C367.487 615.009 366.083 613.592 364.343 613.592Z"
            fill="white"
          />
          <path
            d="M356.805 610.246C355.044 610.246 353.618 611.672 353.618 613.42C353.618 615.169 355.044 616.607 356.805 616.607C358.566 616.607 359.98 615.182 359.98 613.42C359.98 611.659 358.554 610.246 356.805 610.246Z"
            fill="white"
          />
          <path
            d="M349.353 606.721C347.562 606.721 346.115 608.168 346.115 609.959C346.115 611.75 347.562 613.205 349.353 613.205C351.144 613.205 352.6 611.75 352.6 609.959C352.6 608.168 351.144 606.721 349.353 606.721Z"
            fill="white"
          />
          <path
            d="M342.007 602.98C340.174 602.98 338.697 604.47 338.697 606.299C338.697 608.128 340.174 609.609 342.007 609.609C343.841 609.609 345.326 608.132 345.326 606.299C345.326 604.466 343.836 602.98 342.007 602.98Z"
            fill="white"
          />
          <path
            d="M334.734 599.068C332.884 599.068 331.373 600.566 331.373 602.429C331.373 604.292 332.884 605.782 334.734 605.782C336.584 605.782 338.095 604.284 338.095 602.429C338.095 600.575 336.584 599.068 334.734 599.068Z"
            fill="white"
          />
          <path
            d="M327.507 594.906C325.623 594.906 324.104 596.426 324.104 598.31C324.104 600.194 325.623 601.7 327.507 601.7C329.391 601.7 330.911 600.181 330.911 598.31C330.911 596.438 329.391 594.906 327.507 594.906Z"
            fill="white"
          />
          <path
            d="M320.297 590.492C318.391 590.492 316.851 592.033 316.851 593.938C316.851 595.844 318.391 597.393 320.297 597.393C322.202 597.393 323.751 595.844 323.751 593.938C323.751 592.033 322.198 590.492 320.297 590.492Z"
            fill="white"
          />
          <path
            d="M313.074 585.789C311.139 585.789 309.568 587.359 309.568 589.294C309.568 591.23 311.139 592.812 313.074 592.812C315.009 592.812 316.592 591.242 316.592 589.294C316.592 587.347 315.022 585.789 313.074 585.789Z"
            fill="white"
          />
          <path
            d="M305.83 580.795C303.874 580.795 302.282 582.378 302.282 584.343C302.282 586.308 303.874 587.891 305.83 587.891C307.786 587.891 309.391 586.299 309.391 584.343C309.391 582.386 307.799 580.795 305.83 580.795Z"
            fill="white"
          />
          <path
            d="M298.556 575.414C296.578 575.414 294.966 577.027 294.966 579.004C294.966 580.982 296.578 582.607 298.556 582.607C300.534 582.607 302.159 580.995 302.159 579.004C302.159 577.014 300.546 575.414 298.556 575.414Z"
            fill="white"
          />
          <path
            d="M291.269 569.625C289.262 569.625 287.637 571.25 287.637 573.258C287.637 575.265 289.262 576.89 291.269 576.89C293.277 576.89 294.902 575.256 294.902 573.258C294.902 571.259 293.268 569.625 291.269 569.625Z"
            fill="white"
          />
          <path
            d="M283.975 563.361C281.933 563.361 280.291 565.008 280.291 567.045C280.291 569.082 281.938 570.741 283.975 570.741C286.012 570.741 287.671 569.086 287.671 567.045C287.671 565.004 286.016 563.361 283.975 563.361Z"
            fill="white"
          />
          <path
            d="M276.709 556.627C274.66 556.627 272.996 558.291 272.996 560.344C272.996 562.398 274.66 564.062 276.709 564.062C278.759 564.062 280.427 562.398 280.427 560.344C280.427 558.291 278.763 556.627 276.709 556.627Z"
            fill="white"
          />
          <path
            d="M272.941 554.569C273.728 552.655 272.815 550.465 270.901 549.677C268.988 548.89 266.798 549.803 266.01 551.716C265.222 553.63 266.135 555.82 268.049 556.608C269.963 557.395 272.153 556.482 272.941 554.569Z"
            fill="white"
          />
          <path
            d="M262.294 541.73C260.201 541.73 258.504 543.428 258.504 545.52C258.504 547.612 260.201 549.318 262.294 549.318C264.386 549.318 266.083 547.621 266.083 545.52C266.083 543.419 264.386 541.73 262.294 541.73Z"
            fill="white"
          />
          <path
            d="M255.185 533.582C253.063 533.582 251.345 535.301 251.345 537.414C251.345 539.528 253.063 541.255 255.185 541.255C257.307 541.255 259.013 539.536 259.013 537.414C259.013 535.292 257.294 533.582 255.185 533.582Z"
            fill="white"
          />
          <path
            d="M248.149 525.02C246.014 525.02 244.3 526.747 244.3 528.869C244.3 530.99 246.019 532.718 248.149 532.718C250.279 532.718 251.989 530.999 251.989 528.869C251.989 526.738 250.271 525.02 248.149 525.02Z"
            fill="white"
          />
          <path
            d="M241.155 516.107C239.012 516.107 237.285 517.847 237.285 519.99C237.285 522.134 239.012 523.861 241.155 523.861C243.299 523.861 245.026 522.121 245.026 519.99C245.026 517.86 243.299 516.107 241.155 516.107Z"
            fill="white"
          />
          <path
            d="M234.141 507.072C231.976 507.072 230.236 508.821 230.236 510.976C230.236 513.132 231.976 514.881 234.141 514.881C236.305 514.881 238.045 513.132 238.045 510.976C238.045 508.821 236.296 507.072 234.141 507.072Z"
            fill="white"
          />
          <path
            d="M226.968 498.051C224.791 498.051 223.021 499.82 223.021 501.997C223.021 504.175 224.791 505.94 226.968 505.94C229.145 505.94 230.911 504.179 230.911 501.997C230.911 499.816 229.149 498.051 226.968 498.051Z"
            fill="white"
          />
          <path
            d="M219.567 489.164C217.373 489.164 215.604 490.942 215.604 493.128C215.604 495.313 217.373 497.091 219.567 497.091C221.761 497.091 223.522 495.313 223.522 493.128C223.522 490.942 221.753 489.164 219.567 489.164Z"
            fill="white"
          />
          <path
            d="M211.899 480.367C209.692 480.367 207.914 482.145 207.914 484.344C207.914 486.542 209.692 488.32 211.899 488.32C214.106 488.32 215.875 486.542 215.875 484.344C215.875 482.145 214.097 480.367 211.899 480.367Z"
            fill="white"
          />
          <path
            d="M203.98 471.596C201.764 471.596 199.974 473.387 199.974 475.593C199.974 477.8 201.764 479.599 203.98 479.599C206.195 479.599 207.977 477.809 207.977 475.593C207.977 473.378 206.186 471.596 203.98 471.596Z"
            fill="white"
          />
          <path
            d="M195.84 462.861C193.612 462.861 191.812 464.661 191.812 466.889C191.812 469.117 193.612 470.908 195.84 470.908C198.068 470.908 199.859 469.108 199.859 466.889C199.859 464.669 198.059 462.861 195.84 462.861Z"
            fill="white"
          />
          <path
            d="M187.522 454.148C185.294 454.148 183.495 455.948 183.495 458.176C183.495 460.404 185.294 462.203 187.522 462.203C189.75 462.203 191.55 460.391 191.55 458.176C191.55 455.961 189.75 454.148 187.522 454.148Z"
            fill="white"
          />
          <path
            d="M179.073 445.449C176.845 445.449 175.033 447.261 175.033 449.498C175.033 451.734 176.845 453.538 179.073 453.538C181.301 453.538 183.122 451.726 183.122 449.498C183.122 447.27 181.31 445.449 179.073 445.449Z"
            fill="white"
          />
          <path
            d="M170.555 436.688C168.319 436.688 166.507 438.508 166.507 440.744C166.507 442.981 168.319 444.806 170.555 444.806C172.792 444.806 174.612 442.985 174.612 440.744C174.612 438.504 172.8 436.688 170.555 436.688Z"
            fill="white"
          />
          <path
            d="M162.085 427.707C159.836 427.707 158.016 429.528 158.016 431.777C158.016 434.026 159.836 435.847 162.085 435.847C164.335 435.847 166.155 434.026 166.155 431.777C166.155 429.528 164.335 427.707 162.085 427.707Z"
            fill="white"
          />
          <path
            d="M153.717 418.398C151.459 418.398 149.639 420.232 149.639 422.477C149.639 424.722 151.459 426.555 153.717 426.555C155.975 426.555 157.795 424.734 157.795 422.477C157.795 420.219 155.962 418.398 153.717 418.398Z"
            fill="white"
          />
          <path
            d="M145.505 408.637C143.247 408.637 141.427 410.457 141.427 412.715C141.427 414.973 143.247 416.793 145.505 416.793C147.763 416.793 149.583 414.96 149.583 412.715C149.583 410.47 147.75 408.637 145.505 408.637Z"
            fill="white"
          />
          <path
            d="M137.515 398.156C135.257 398.156 133.424 399.99 133.424 402.247C133.424 404.505 135.257 406.338 137.515 406.338C139.772 406.338 141.606 404.505 141.606 402.247C141.606 399.99 139.772 398.156 137.515 398.156Z"
            fill="white"
          />
          <path
            d="M129.77 386.873C127.512 386.873 125.679 388.694 125.679 390.951C125.679 393.209 127.512 395.042 129.77 395.042C132.027 395.042 133.861 393.209 133.861 390.951C133.861 388.694 132.027 386.873 129.77 386.873Z"
            fill="white"
          />
          <path
            d="M122.31 374.777C120.052 374.777 118.219 376.611 118.219 378.868C118.219 381.126 120.052 382.947 122.31 382.947C124.567 382.947 126.388 381.113 126.388 378.868C126.388 376.623 124.555 374.777 122.31 374.777Z"
            fill="white"
          />
          <path
            d="M115.024 362.311C112.766 362.311 110.945 364.144 110.945 366.389C110.945 368.634 112.766 370.467 115.024 370.467C117.281 370.467 119.102 368.646 119.102 366.389C119.102 364.131 117.281 362.311 115.024 362.311Z"
            fill="white"
          />
          <path
            d="M107.808 350.072C105.55 350.072 103.729 351.906 103.729 354.163C103.729 356.421 105.55 358.241 107.808 358.241C110.065 358.241 111.886 356.408 111.886 354.163C111.886 351.918 110.053 350.072 107.808 350.072Z"
            fill="white"
          />
          <path
            d="M114.721 335.418C112.463 335.418 110.63 337.251 110.63 339.496C110.63 341.741 112.463 343.587 114.721 343.587C116.979 343.587 118.799 341.754 118.799 339.496C118.799 337.239 116.966 335.418 114.721 335.418Z"
            fill="white"
          />
          <path
            d="M121.787 320.348C119.537 320.348 117.717 322.168 117.717 324.405C117.717 326.641 119.537 328.474 121.787 328.474C124.036 328.474 125.856 326.654 125.856 324.405C125.856 322.155 124.036 320.348 121.787 320.348Z"
            fill="white"
          />
          <path
            d="M129.061 305.1C126.825 305.1 125.013 306.912 125.013 309.157C125.013 311.402 126.825 313.205 129.061 313.205C131.298 313.205 133.118 311.393 133.118 309.157C133.118 306.92 131.306 305.1 129.061 305.1Z"
            fill="white"
          />
          <path
            d="M136.662 289.893C134.434 289.893 132.622 291.705 132.622 293.933C132.622 296.161 134.434 297.973 136.662 297.973C138.89 297.973 140.702 296.173 140.702 293.933C140.702 291.692 138.89 289.893 136.662 289.893Z"
            fill="white"
          />
          <path
            d="M144.496 275.312C142.268 275.312 140.469 277.112 140.469 279.34C140.469 281.568 142.268 283.367 144.496 283.367C146.724 283.367 148.515 281.568 148.515 279.34C148.515 277.112 146.716 275.312 144.496 275.312Z"
            fill="white"
          />
          <path
            d="M152.47 261.758C150.255 261.758 148.464 263.549 148.464 265.764C148.464 267.979 150.255 269.77 152.47 269.77C154.685 269.77 156.476 267.979 156.476 265.764C156.476 263.549 154.685 261.758 152.47 261.758Z"
            fill="white"
          />
          <path
            d="M160.388 257.493C162.596 257.493 164.386 255.703 164.386 253.496C164.386 251.288 162.596 249.498 160.388 249.498C158.18 249.498 156.391 251.288 156.391 253.496C156.391 255.703 158.18 257.493 160.388 257.493Z"
            fill="white"
          />
          <path
            d="M168.01 238.664C165.804 238.664 164.025 240.442 164.025 242.649C164.025 244.856 165.804 246.625 168.01 246.625C170.217 246.625 171.987 244.847 171.987 242.649C171.987 240.451 170.209 238.664 168.01 238.664Z"
            fill="white"
          />
          <path
            d="M175.169 229.111C172.984 229.111 171.214 230.868 171.214 233.054C171.214 235.239 172.984 237 175.169 237C177.355 237 179.116 235.231 179.116 233.054C179.116 230.877 177.346 229.111 175.169 229.111Z"
            fill="white"
          />
          <path
            d="M181.853 220.514C179.689 220.514 177.928 222.262 177.928 224.426C177.928 226.591 179.689 228.352 181.853 228.352C184.018 228.352 185.766 226.591 185.766 224.426C185.766 222.262 184.018 220.514 181.853 220.514Z"
            fill="white"
          />
          <path
            d="M188.002 212.867C185.846 212.867 184.098 214.616 184.098 216.771C184.098 218.927 185.846 220.676 188.002 220.676C190.158 220.676 191.906 218.927 191.906 216.771C191.906 214.616 190.158 212.867 188.002 212.867Z"
            fill="white"
          />
          <path
            d="M193.634 206.348C191.491 206.348 189.751 208.088 189.751 210.231C189.751 212.374 191.487 214.114 193.634 214.114C195.781 214.114 197.504 212.378 197.504 210.231C197.504 208.083 195.764 206.348 193.634 206.348Z"
            fill="white"
          />
          <path
            d="M198.744 201C196.631 201 194.912 202.719 194.912 204.832C194.912 206.945 196.631 208.651 198.744 208.651C200.858 208.651 202.572 206.945 202.572 204.832C202.572 202.719 200.853 201 198.744 201Z"
            fill="white"
          />
          <path
            d="M203.344 196.523C201.252 196.523 199.546 198.225 199.546 200.322C199.546 202.418 201.252 204.12 203.344 204.12C205.436 204.12 207.155 202.422 207.155 200.322C207.155 198.221 205.449 196.523 203.344 196.523Z"
            fill="white"
          />
          <path
            d="M207.476 192.662C205.397 192.662 203.708 194.347 203.708 196.431C203.708 198.514 205.393 200.199 207.476 200.199C209.56 200.199 211.245 198.514 211.245 196.431C211.245 194.347 209.56 192.662 207.476 192.662Z"
            fill="white"
          />
          <path
            d="M211.139 189.215C209.068 189.215 207.404 190.891 207.404 192.949C207.404 195.008 209.068 196.684 211.139 196.684C213.21 196.684 214.873 195.008 214.873 192.949C214.873 190.891 213.197 189.215 211.139 189.215Z"
            fill="white"
          />
          <path
            d="M214.335 186.076C212.294 186.076 210.639 187.731 210.639 189.772C210.639 191.814 212.294 193.46 214.335 193.46C216.376 193.46 218.031 191.809 218.031 189.772C218.031 187.735 216.376 186.076 214.335 186.076Z"
            fill="white"
          />
          <path
            d="M217.093 183.117C215.073 183.117 213.439 184.751 213.439 186.771C213.439 188.791 215.073 190.412 217.093 190.412C219.113 190.412 220.734 188.778 220.734 186.771C220.734 184.764 219.101 183.117 217.093 183.117Z"
            fill="white"
          />
          <path
            d="M219.424 180.236C217.425 180.236 215.812 181.853 215.812 183.848C215.812 185.842 217.425 187.463 219.424 187.463C221.423 187.463 223.035 185.847 223.035 183.848C223.035 181.849 221.423 180.236 219.424 180.236Z"
            fill="white"
          />
          <path
            d="M221.37 177.404C219.392 177.404 217.801 179.008 217.801 180.973C217.801 182.938 219.392 184.542 221.37 184.542C223.347 184.542 224.939 182.947 224.939 180.973C224.939 179 223.335 177.404 221.37 177.404Z"
            fill="white"
          />
          <path
            d="M222.951 174.643C221.016 174.643 219.445 176.209 219.445 178.144C219.445 180.079 221.016 181.649 222.951 181.649C224.886 181.649 226.456 180.079 226.456 178.144C226.456 176.209 224.886 174.643 222.951 174.643Z"
            fill="white"
          />
          <path
            d="M224.222 171.914C222.308 171.914 220.755 173.472 220.755 175.385C220.755 177.299 222.308 178.853 224.222 178.853C226.136 178.853 227.698 177.299 227.698 175.385C227.698 173.472 226.136 171.914 224.222 171.914Z"
            fill="white"
          />
          <path
            d="M225.22 169.268C223.328 169.268 221.787 170.8 221.787 172.692C221.787 174.585 223.328 176.125 225.22 176.125C227.113 176.125 228.645 174.585 228.645 172.692C228.645 170.8 227.113 169.268 225.22 169.268Z"
            fill="white"
          />
          <path
            d="M225.971 166.664C224.108 166.664 222.598 168.175 222.598 170.042C222.598 171.909 224.108 173.42 225.971 173.42C227.834 173.42 229.354 171.909 229.354 170.042C229.354 168.175 227.843 166.664 225.971 166.664Z"
            fill="white"
          />
          <path
            d="M226.523 164.082C224.703 164.082 223.222 165.559 223.222 167.379C223.222 169.2 224.699 170.677 226.523 170.677C228.348 170.677 229.821 169.2 229.821 167.379C229.821 165.559 228.344 164.082 226.523 164.082Z"
            fill="white"
          />
          <path
            d="M226.874 161.396C225.075 161.396 223.615 162.852 223.615 164.656C223.615 166.459 225.071 167.906 226.874 167.906C228.678 167.906 230.134 166.451 230.134 164.656C230.134 162.861 228.678 161.396 226.874 161.396Z"
            fill="white"
          />
          <path
            d="M227.074 158.592C225.305 158.592 223.879 160.022 223.879 161.792C223.879 163.561 225.305 164.987 227.074 164.987C228.844 164.987 230.27 163.553 230.27 161.792C230.27 160.03 228.836 158.592 227.074 158.592Z"
            fill="white"
          />
          <path
            d="M227.134 155.559C225.394 155.559 223.989 156.976 223.989 158.712C223.989 160.447 225.394 161.865 227.134 161.865C228.874 161.865 230.287 160.447 230.287 158.712C230.287 156.976 228.882 155.559 227.134 155.559Z"
            fill="white"
          />
          <path
            d="M227.147 152.256C225.449 152.256 224.074 153.631 224.074 155.328C224.074 157.026 225.449 158.401 227.147 158.401C228.844 158.401 230.215 157.026 230.215 155.328C230.215 153.631 228.84 152.256 227.147 152.256Z"
            fill="white"
          />
          <path
            d="M227.177 148.535C225.522 148.535 224.168 149.889 224.168 151.544C224.168 153.199 225.522 154.553 227.177 154.553C228.832 154.553 230.186 153.212 230.186 151.544C230.186 149.876 228.845 148.535 227.177 148.535Z"
            fill="white"
          />
          <path
            d="M227.405 144.244C225.78 144.244 224.46 145.56 224.46 147.189C224.46 148.819 225.784 150.134 227.405 150.134C229.026 150.134 230.363 148.81 230.363 147.189C230.363 145.568 229.039 144.244 227.405 144.244Z"
            fill="white"
          />
          <path
            d="M228.136 139.121C226.545 139.121 225.242 140.411 225.242 142.003C225.242 143.594 226.545 144.884 228.136 144.884C229.728 144.884 231.018 143.594 231.018 142.003C231.018 140.411 229.728 139.121 228.136 139.121Z"
            fill="white"
          />
          <path
            d="M229.77 132.83C228.229 132.83 226.969 134.09 226.969 135.631C226.969 137.171 228.229 138.432 229.77 138.432C231.31 138.432 232.571 137.184 232.571 135.631C232.571 134.078 231.323 132.83 229.77 132.83Z"
            fill="white"
          />
          <path
            d="M233.028 124.697C231.517 124.697 230.291 125.924 230.291 127.439C230.291 128.954 231.517 130.176 233.028 130.176C234.539 130.176 235.765 128.954 235.765 127.439C235.765 125.924 234.539 124.697 233.028 124.697Z"
            fill="white"
          />
          <path
            d="M239.199 113.613C237.722 113.613 236.525 114.81 236.525 116.287C236.525 117.764 237.722 118.96 239.199 118.96C240.676 118.96 241.873 117.764 241.873 116.287C241.873 114.81 240.676 113.613 239.199 113.613Z"
            fill="white"
          />
          <path
            d="M256.267 109.555C254.79 109.555 253.594 110.751 253.594 112.228C253.594 113.705 254.79 114.902 256.267 114.902C257.744 114.902 258.941 113.705 258.941 112.228C258.941 110.751 257.744 109.555 256.267 109.555Z"
            fill="white"
          />
          <path
            d="M276.645 101.461C275.168 101.461 273.972 102.662 273.972 104.147C273.972 105.633 275.168 106.821 276.645 106.821C278.122 106.821 279.319 105.624 279.319 104.147C279.319 102.67 278.122 101.461 276.645 101.461Z"
            fill="white"
          />
          <path
            d="M300.917 87.918C299.427 87.918 298.23 89.1274 298.23 90.6043C298.23 92.0811 299.427 93.2906 300.917 93.2906C302.406 93.2906 303.603 92.0811 303.603 90.6043C303.603 89.1274 302.394 87.918 300.917 87.918Z"
            fill="white"
          />
          <path
            d="M328.903 67.8066C327.435 67.8066 326.238 68.9991 326.238 70.476C326.238 71.9528 327.435 73.1495 328.903 73.1495C330.372 73.1495 331.577 71.9528 331.577 70.476C331.577 68.9991 330.38 67.8066 328.903 67.8066Z"
            fill="white"
          />
          <path
            d="M358.597 42.0859C357.121 42.0859 355.924 43.2869 355.924 44.7637C355.924 46.2406 357.121 47.4373 358.597 47.4373C360.074 47.4373 361.271 46.2406 361.271 44.7637C361.271 43.2869 360.074 42.0859 358.597 42.0859Z"
            fill="white"
          />
          <path
            d="M387.76 13.0312C386.284 13.0312 385.074 14.228 385.074 15.7091C385.074 17.1901 386.279 18.3869 387.76 18.3869C389.242 18.3869 390.434 17.1901 390.434 15.7091C390.434 14.228 389.237 13.0312 387.76 13.0312Z"
            fill="white"
          />
          <path
            d="M867.731 0.75C865.983 0.75 864.565 2.17166 864.565 3.92008C864.565 5.66851 865.983 7.09016 867.731 7.09016C869.48 7.09016 870.897 5.66851 870.897 3.92008C870.897 2.17166 869.48 0.75 867.731 0.75Z"
            fill="white"
          />
          <path
            d="M874.819 12.1152C873.041 12.1152 871.594 13.5624 871.594 15.3447C871.594 17.1271 873.041 18.5785 874.819 18.5785C876.597 18.5785 878.044 17.1313 878.044 15.3447C878.044 13.5581 876.597 12.1152 874.819 12.1152Z"
            fill="white"
          />
          <path
            d="M881.707 23.9727C879.873 23.9727 878.396 25.4495 878.396 27.2785C878.396 29.1076 879.873 30.5844 881.707 30.5844C883.54 30.5844 885.008 29.1076 885.008 27.2785C885.008 25.4495 883.531 23.9727 881.707 23.9727Z"
            fill="white"
          />
          <path
            d="M888.382 36.3105C886.527 36.3105 885.021 37.8128 885.021 39.6716C885.021 41.5304 886.531 43.0284 888.382 43.0284C890.232 43.0284 891.743 41.5304 891.743 39.6716C891.743 37.8128 890.245 36.3105 888.382 36.3105Z"
            fill="white"
          />
          <path
            d="M894.845 49.0977C892.961 49.0977 891.441 50.6296 891.441 52.5139C891.441 54.3981 892.961 55.9174 894.845 55.9174C896.729 55.9174 898.257 54.3939 898.257 52.5139C898.257 50.6339 896.725 49.0977 894.845 49.0977Z"
            fill="white"
          />
          <path
            d="M901.068 62.3574C899.162 62.3574 897.613 63.9021 897.613 65.8118C897.613 67.7215 899.162 69.2662 901.068 69.2662C902.973 69.2662 904.522 67.7173 904.522 65.8118C904.522 63.9064 902.973 62.3574 901.068 62.3574Z"
            fill="white"
          />
          <path
            d="M907.071 76.0098C905.115 76.0098 903.532 77.5927 903.532 79.5448C903.532 81.4969 905.115 83.0799 907.071 83.0799C909.028 83.0799 910.598 81.4969 910.598 79.5448C910.598 77.5927 909.015 76.0098 907.071 76.0098Z"
            fill="white"
          />
          <path
            d="M913.461 97.1376C915.413 96.8207 916.739 94.9809 916.422 93.0283C916.105 91.0757 914.265 89.7498 912.313 90.0667C910.36 90.3837 909.034 92.2235 909.351 94.1761C909.668 96.1287 911.508 97.4546 913.461 97.1376Z"
            fill="white"
          />
          <path
            d="M918.614 104.361C916.615 104.361 914.994 105.987 914.994 107.994C914.994 110.001 916.619 111.614 918.614 111.614C920.609 111.614 922.247 109.989 922.247 107.994C922.247 105.999 920.621 104.361 918.614 104.361Z"
            fill="white"
          />
          <path
            d="M924.31 118.828C922.29 118.828 920.656 120.462 920.656 122.482C920.656 124.502 922.29 126.144 924.31 126.144C926.33 126.144 927.972 124.51 927.972 122.482C927.972 120.453 926.339 118.828 924.31 118.828Z"
            fill="white"
          />
          <path
            d="M930.065 133.316C928.002 133.316 926.339 134.98 926.339 137.034C926.339 139.088 928.002 140.756 930.065 140.756C932.127 140.756 933.778 139.092 933.778 137.034C933.778 134.976 932.115 133.316 930.065 133.316Z"
            fill="white"
          />
          <path
            d="M935.925 147.805C933.841 147.805 932.156 149.498 932.156 151.573C932.156 153.648 933.841 155.342 935.925 155.342C938.008 155.342 939.693 153.657 939.693 151.573C939.693 149.489 938.008 147.805 935.925 147.805Z"
            fill="white"
          />
          <path
            d="M941.982 162.166C939.89 162.166 938.184 163.864 938.184 165.964C938.184 168.065 939.89 169.762 941.982 169.762C944.074 169.762 945.78 168.056 945.78 165.964C945.78 163.872 944.082 162.166 941.982 162.166Z"
            fill="white"
          />
          <path
            d="M948.337 176.145C946.215 176.145 944.496 177.863 944.496 179.977C944.496 182.09 946.215 183.817 948.337 183.817C950.458 183.817 952.169 182.099 952.169 179.977C952.169 177.855 950.45 176.145 948.337 176.145Z"
            fill="white"
          />
          <path
            d="M955.065 189.492C952.922 189.492 951.182 191.236 951.182 193.384C951.182 195.531 952.922 197.271 955.065 197.271C957.208 197.271 958.956 195.531 958.956 193.384C958.956 191.236 957.22 189.492 955.065 189.492Z"
            fill="white"
          />
          <path
            d="M964.999 208.795C966.532 207.262 966.532 204.777 964.999 203.244C963.466 201.711 960.981 201.711 959.448 203.244C957.915 204.777 957.915 207.262 959.448 208.795C960.981 210.328 963.466 210.328 964.999 208.795Z"
            fill="white"
          />
          <path
            d="M969.823 213.865C967.646 213.865 965.881 215.635 965.881 217.808C965.881 219.98 967.651 221.763 969.823 221.763C971.996 221.763 973.779 219.993 973.779 217.808C973.779 215.622 972.009 213.865 969.823 213.865Z"
            fill="white"
          />
          <path
            d="M977.866 224.711C975.681 224.711 973.902 226.481 973.902 228.675C973.902 230.869 975.681 232.651 977.866 232.651C980.052 232.651 981.842 230.873 981.842 228.675C981.842 226.476 980.064 224.711 977.866 224.711Z"
            fill="white"
          />
          <path
            d="M986.341 234.521C984.126 234.521 982.322 236.312 982.322 238.54C982.322 240.768 984.122 242.559 986.341 242.559C988.561 242.559 990.36 240.76 990.36 238.54C990.36 236.321 988.561 234.521 986.341 234.521Z"
            fill="white"
          />
          <path
            d="M995.185 243.264C992.949 243.264 991.137 245.076 991.137 247.312C991.137 249.549 992.949 251.361 995.185 251.361C997.422 251.361 999.234 249.549 999.234 247.312C999.234 245.076 997.422 243.264 995.185 243.264Z"
            fill="white"
          />
          <path
            d="M1004.33 250.924C1002.1 250.924 1000.27 252.744 1000.27 254.985C1000.27 257.226 1002.09 259.042 1004.33 259.042C1006.58 259.042 1008.4 257.23 1008.4 254.985C1008.4 252.74 1006.58 250.924 1004.33 250.924Z"
            fill="white"
          />
          <path
            d="M1013.7 257.443C1011.44 257.443 1009.61 259.277 1009.61 261.534C1009.61 263.792 1011.44 265.625 1013.7 265.625C1015.96 265.625 1017.79 263.792 1017.79 261.534C1017.79 259.277 1015.96 257.443 1013.7 257.443Z"
            fill="white"
          />
          <path
            d="M1026.98 268.585C1027.84 266.486 1026.85 264.081 1024.75 263.212C1022.65 262.343 1020.25 263.339 1019.38 265.437C1018.51 267.535 1019.5 269.941 1021.6 270.81C1023.7 271.679 1026.11 270.683 1026.98 268.585Z"
            fill="white"
          />
          <path
            d="M1032.65 267.432C1030.37 267.432 1028.52 269.286 1028.52 271.574C1028.52 273.861 1030.37 275.707 1032.65 275.707C1034.93 275.707 1036.79 273.857 1036.79 271.574C1036.79 269.29 1034.94 267.432 1032.65 267.432Z"
            fill="white"
          />
          <path
            d="M1042.1 271.264C1039.8 271.264 1037.94 273.127 1037.94 275.418C1037.94 277.71 1039.8 279.573 1042.1 279.573C1044.39 279.573 1046.25 277.723 1046.25 275.418C1046.25 273.114 1044.39 271.264 1042.1 271.264Z"
            fill="white"
          />
          <path
            d="M1051.46 274.52C1049.16 274.52 1047.3 276.37 1047.3 278.674C1047.3 280.979 1049.16 282.829 1051.46 282.829C1053.76 282.829 1055.61 280.966 1055.61 278.674C1055.61 276.383 1053.75 274.52 1051.46 274.52Z"
            fill="white"
          />
          <path
            d="M1060.75 277.289C1058.45 277.289 1056.59 279.152 1056.59 281.444C1056.59 283.735 1058.45 285.598 1060.75 285.598C1063.05 285.598 1064.9 283.744 1064.9 281.444C1064.9 279.144 1063.04 277.289 1060.75 277.289Z"
            fill="white"
          />
          <path
            d="M1069.95 279.684C1067.66 279.684 1065.8 281.547 1065.8 283.847C1065.8 286.147 1067.66 288.001 1069.95 288.001C1072.25 288.001 1074.11 286.138 1074.11 283.847C1074.11 281.555 1072.26 279.684 1069.95 279.684Z"
            fill="white"
          />
          <path
            d="M1079.11 281.812C1076.81 281.812 1074.96 283.675 1074.96 285.967C1074.96 288.259 1076.81 290.122 1079.11 290.122C1081.42 290.122 1083.27 288.271 1083.27 285.967C1083.27 283.663 1081.4 281.812 1079.11 281.812Z"
            fill="white"
          />
          <path
            d="M1088.2 283.793C1085.91 283.793 1084.04 285.656 1084.04 287.948C1084.04 290.239 1085.91 292.111 1088.2 292.111C1090.49 292.111 1092.35 290.248 1092.35 287.948C1092.35 285.648 1090.5 283.793 1088.2 283.793Z"
            fill="white"
          />
          <path
            d="M1097.25 285.689C1094.95 285.689 1093.09 287.54 1093.09 289.844C1093.09 292.148 1094.95 293.999 1097.25 293.999C1099.55 293.999 1101.4 292.136 1101.4 289.844C1101.4 287.552 1099.54 285.689 1097.25 285.689Z"
            fill="white"
          />
          <path
            d="M1092.4 286.312C1090.1 286.312 1088.25 288.176 1088.25 290.467C1088.25 292.759 1090.1 294.622 1092.4 294.622C1094.7 294.622 1096.56 292.767 1096.56 290.467C1096.56 288.167 1094.7 286.312 1092.4 286.312Z"
            fill="white"
          />
          <path
            d="M1087.36 286.914C1085.06 286.914 1083.2 288.777 1083.2 291.069C1083.2 293.36 1085.06 295.223 1087.36 295.223C1089.66 295.223 1091.51 293.373 1091.51 291.069C1091.51 288.764 1089.65 286.914 1087.36 286.914Z"
            fill="white"
          />
          <path
            d="M1082.1 287.518C1079.8 287.518 1077.95 289.372 1077.95 291.672C1077.95 293.972 1079.8 295.827 1082.1 295.827C1084.4 295.827 1086.26 293.964 1086.26 291.672C1086.26 289.381 1084.39 287.518 1082.1 287.518Z"
            fill="white"
          />
          <path
            d="M1076.62 288.133C1074.32 288.133 1072.46 289.996 1072.46 292.287C1072.46 294.579 1074.32 296.442 1076.62 296.442C1078.92 296.442 1080.77 294.588 1080.77 292.287C1080.77 289.987 1078.91 288.133 1076.62 288.133Z"
            fill="white"
          />
          <path
            d="M1070.88 288.799C1068.59 288.799 1066.73 290.649 1066.73 292.953C1066.73 295.258 1068.59 297.108 1070.88 297.108C1073.17 297.108 1075.04 295.245 1075.04 292.953C1075.04 290.662 1073.19 288.799 1070.88 288.799Z"
            fill="white"
          />
          <path
            d="M1064.9 289.51C1062.6 289.51 1060.74 291.373 1060.74 293.664C1060.74 295.956 1062.6 297.819 1064.9 297.819C1067.19 297.819 1069.06 295.964 1069.06 293.664C1069.06 291.364 1067.2 289.51 1064.9 289.51Z"
            fill="white"
          />
          <path
            d="M1058.65 290.275C1056.35 290.275 1054.5 292.138 1054.5 294.43C1054.5 296.722 1056.35 298.585 1058.65 298.585C1060.95 298.585 1062.81 296.722 1062.81 294.43C1062.81 292.138 1060.95 290.275 1058.65 290.275Z"
            fill="white"
          />
          <path
            d="M1052.12 291.135C1049.83 291.135 1047.96 292.998 1047.96 295.289C1047.96 297.581 1049.83 299.444 1052.12 299.444C1054.41 299.444 1056.28 297.589 1056.28 295.289C1056.28 292.989 1054.42 291.135 1052.12 291.135Z"
            fill="white"
          />
          <path
            d="M1045.32 292.088C1043.02 292.088 1041.16 293.951 1041.16 296.238C1041.16 298.526 1043.02 300.401 1045.32 300.401C1047.62 300.401 1049.48 298.538 1049.48 296.238C1049.48 293.938 1047.61 292.088 1045.32 292.088Z"
            fill="white"
          />
          <path
            d="M1038.23 293.191C1035.94 293.191 1034.08 295.042 1034.08 297.346C1034.08 299.65 1035.94 301.501 1038.23 301.501C1040.52 301.501 1042.39 299.638 1042.39 297.346C1042.39 295.054 1040.53 293.191 1038.23 293.191Z"
            fill="white"
          />
          <path
            d="M1030.88 294.461C1028.6 294.461 1026.75 296.311 1026.75 298.603C1026.75 300.894 1028.6 302.736 1030.88 302.736C1033.17 302.736 1035.03 300.882 1035.03 298.603C1035.03 296.324 1033.18 294.461 1030.88 294.461Z"
            fill="white"
          />
          <path
            d="M1023.29 295.949C1021.01 295.949 1019.17 297.791 1019.17 300.061C1019.17 302.332 1021.01 304.174 1023.29 304.174C1025.57 304.174 1027.4 302.332 1027.4 300.061C1027.4 297.791 1025.56 295.949 1023.29 295.949Z"
            fill="white"
          />
          <path
            d="M1015.43 297.598C1013.17 297.598 1011.34 299.439 1011.34 301.697C1011.34 303.955 1013.17 305.788 1015.43 305.788C1017.68 305.788 1019.53 303.955 1019.53 301.697C1019.53 299.439 1017.68 297.598 1015.43 297.598Z"
            fill="white"
          />
          <path
            d="M1007.34 299.406C1005.09 299.406 1003.26 301.227 1003.26 303.484C1003.26 305.742 1005.09 307.554 1007.34 307.554C1009.6 307.554 1011.41 305.734 1011.41 303.484C1011.41 301.235 1009.59 299.406 1007.34 299.406Z"
            fill="white"
          />
          <path
            d="M999.025 301.395C996.789 301.395 994.977 303.207 994.977 305.435C994.977 307.663 996.789 309.483 999.025 309.483C1001.26 309.483 1003.07 307.671 1003.07 305.435C1003.07 303.198 1001.26 301.395 999.025 301.395Z"
            fill="white"
          />
          <path
            d="M990.525 303.559C988.297 303.559 986.498 305.358 986.498 307.577C986.498 309.797 988.297 311.596 990.525 311.596C992.753 311.596 994.544 309.797 994.544 307.577C994.544 305.358 992.745 303.559 990.525 303.559Z"
            fill="white"
          />
          <path
            d="M981.842 305.922C979.644 305.922 977.857 307.713 977.857 309.907C977.857 312.101 979.648 313.904 981.842 313.904C984.036 313.904 985.84 312.114 985.84 309.907C985.84 307.7 984.049 305.922 981.842 305.922Z"
            fill="white"
          />
          <path
            d="M973.037 308.512C970.851 308.512 969.073 310.281 969.073 312.467C969.073 314.652 970.851 316.431 973.037 316.431C975.222 316.431 977.001 314.652 977.001 312.467C977.001 310.281 975.222 308.512 973.037 308.512Z"
            fill="white"
          />
          <path
            d="M964.078 311.375C961.901 311.375 960.131 313.145 960.131 315.317C960.131 317.49 961.901 319.264 964.078 319.264C966.255 319.264 968.02 317.495 968.02 315.317C968.02 313.14 966.259 311.375 964.078 311.375Z"
            fill="white"
          />
          <path
            d="M954.993 314.609C952.837 314.609 951.089 316.358 951.089 318.501C951.089 320.644 952.837 322.405 954.993 322.405C957.149 322.405 958.885 320.657 958.885 318.501C958.885 316.345 957.136 314.609 954.993 314.609Z"
            fill="white"
          />
          <path
            d="M948.523 324.803C950.031 323.295 950.031 320.85 948.523 319.342C947.015 317.833 944.57 317.833 943.062 319.342C941.554 320.85 941.554 323.295 943.062 324.803C944.57 326.311 947.015 326.311 948.523 324.803Z"
            fill="white"
          />
          <path
            d="M936.506 322.211C934.393 322.211 932.687 323.93 932.687 326.039C932.687 328.148 934.393 329.871 936.506 329.871C938.619 329.871 940.338 328.152 940.338 326.039C940.338 323.925 938.619 322.211 936.506 322.211Z"
            fill="white"
          />
          <path
            d="M927.17 326.654C925.078 326.654 923.381 328.352 923.381 330.452C923.381 332.553 925.078 334.242 927.17 334.242C929.263 334.242 930.969 332.545 930.969 330.452C930.969 328.36 929.271 326.654 927.17 326.654Z"
            fill="white"
          />
          <path
            d="M917.813 331.59C915.742 331.59 914.078 333.253 914.078 335.324C914.078 337.395 915.742 339.059 917.813 339.059C919.884 339.059 921.547 337.383 921.547 335.324C921.547 333.266 919.871 331.59 917.813 331.59Z"
            fill="white"
          />
          <path
            d="M908.438 337.021C906.397 337.021 904.733 338.677 904.733 340.726C904.733 342.776 906.397 344.431 908.438 344.431C910.479 344.431 912.151 342.768 912.151 340.726C912.151 338.685 910.488 337.021 908.438 337.021Z"
            fill="white"
          />
          <path
            d="M899.08 343.014C897.052 343.014 895.418 344.648 895.418 346.668C895.418 348.688 897.052 350.33 899.08 350.33C901.109 350.33 902.734 348.696 902.734 346.668C902.734 344.639 901.1 343.014 899.08 343.014Z"
            fill="white"
          />
          <path
            d="M889.745 349.594C887.746 349.594 886.125 351.219 886.125 353.218C886.125 355.217 887.75 356.838 889.745 356.838C891.739 356.838 893.365 355.217 893.365 353.218C893.365 351.219 891.752 349.594 889.745 349.594Z"
            fill="white"
          />
          <path
            d="M880.459 356.812C878.502 356.812 876.911 358.404 876.911 360.36C876.911 362.317 878.502 363.921 880.459 363.921C882.415 363.921 884.019 362.329 884.019 360.36C884.019 358.391 882.428 356.812 880.459 356.812Z"
            fill="white"
          />
          <path
            d="M871.228 364.625C869.293 364.625 867.719 366.195 867.719 368.143C867.719 370.091 869.289 371.648 871.228 371.648C873.168 371.648 874.746 370.078 874.746 368.143C874.746 366.208 873.176 364.625 871.228 364.625Z"
            fill="white"
          />
          <path
            d="M862.101 373.127C860.195 373.127 858.646 374.676 858.646 376.594C858.646 378.512 860.195 380.061 862.101 380.061C864.006 380.061 865.568 378.508 865.568 376.594C865.568 374.68 864.019 373.127 862.101 373.127Z"
            fill="white"
          />
          <path
            d="M853.066 382.324C851.174 382.324 849.642 383.856 849.642 385.74C849.642 387.625 851.174 389.152 853.066 389.152C854.959 389.152 856.483 387.62 856.483 385.74C856.483 383.86 854.951 382.324 853.066 382.324Z"
            fill="white"
          />
          <path
            d="M844.095 392.305C842.253 392.305 840.755 393.803 840.755 395.645C840.755 397.486 842.253 398.984 844.095 398.984C845.936 398.984 847.435 397.495 847.435 395.645C847.435 393.794 845.936 392.305 844.095 392.305Z"
            fill="white"
          />
          <path
            d="M835.341 403.246C833.52 403.246 832.039 404.714 832.039 406.535C832.039 408.356 833.516 409.837 835.341 409.837C837.166 409.837 838.638 408.36 838.638 406.535C838.638 404.71 837.161 403.246 835.341 403.246Z"
            fill="white"
          />
          <path
            d="M827.004 415.443C825.205 415.443 823.758 416.89 823.758 418.69C823.758 420.489 825.205 421.936 827.004 421.936C828.804 421.936 830.251 420.481 830.251 418.69C830.251 416.899 828.795 415.443 827.004 415.443Z"
            fill="white"
          />
          <path
            d="M822.341 435.115C820.622 435.115 819.23 436.499 819.23 438.226C819.23 439.953 820.627 441.337 822.341 441.337C824.056 441.337 825.465 439.94 825.465 438.226C825.465 436.511 824.068 435.115 822.341 435.115Z"
            fill="white"
          />
          <path
            d="M812.682 445.084C810.964 445.084 809.58 446.48 809.58 448.195C809.58 449.909 810.964 451.297 812.682 451.297C814.401 451.297 815.793 449.913 815.793 448.195C815.793 446.476 814.397 445.084 812.682 445.084Z"
            fill="white"
          />
          <path
            d="M803.003 455.494C801.285 455.494 799.893 456.878 799.893 458.596C799.893 460.315 801.289 461.707 803.003 461.707C804.718 461.707 806.105 460.311 806.105 458.596C806.105 456.882 804.709 455.494 803.003 455.494Z"
            fill="white"
          />
          <path
            d="M793.305 472.569C795.012 472.569 796.395 471.186 796.395 469.48C796.395 467.774 795.012 466.391 793.305 466.391C791.599 466.391 790.216 467.774 790.216 469.48C790.216 471.186 791.599 472.569 793.305 472.569Z"
            fill="white"
          />
          <path
            d="M783.719 477.797C782.013 477.797 780.63 479.18 780.63 480.886C780.63 482.592 782.013 483.976 783.719 483.976C785.425 483.976 786.809 482.592 786.809 480.886C786.809 479.18 785.425 477.797 783.719 477.797Z"
            fill="white"
          />
          <path
            d="M774.132 489.537C772.426 489.537 771.051 490.912 771.051 492.618C771.051 494.324 772.426 495.699 774.132 495.699C775.838 495.699 777.213 494.316 777.213 492.618C777.213 490.921 775.829 489.537 774.132 489.537Z"
            fill="white"
          />
          <path
            d="M764.443 501.371C762.737 501.371 761.354 502.755 761.354 504.452C761.354 506.15 762.737 507.541 764.443 507.541C766.149 507.541 767.524 506.158 767.524 504.452C767.524 502.746 766.14 501.371 764.443 501.371Z"
            fill="white"
          />
          <path
            d="M754.535 513.068C752.829 513.068 751.454 514.443 751.454 516.149C751.454 517.855 752.829 519.23 754.535 519.23C756.241 519.23 757.616 517.847 757.616 516.149C757.616 514.452 756.233 513.068 754.535 513.068Z"
            fill="white"
          />
          <path
            d="M744.252 524.426C742.555 524.426 741.18 525.801 741.18 527.494C741.18 529.187 742.555 530.566 744.252 530.566C745.95 530.566 747.325 529.192 747.325 527.494C747.325 525.797 745.95 524.426 744.252 524.426Z"
            fill="white"
          />
          <path
            d="M733.468 535.002C731.77 535.002 730.387 536.377 730.387 538.074C730.387 539.772 731.77 541.147 733.468 541.147C735.165 541.147 736.54 539.772 736.54 538.074C736.54 536.377 735.165 535.002 733.468 535.002Z"
            fill="white"
          />
          <path
            d="M722.167 550.801C723.864 550.801 725.24 549.426 725.24 547.729C725.24 546.032 723.864 544.656 722.167 544.656C720.47 544.656 719.095 546.032 719.095 547.729C719.095 549.426 720.47 550.801 722.167 550.801Z"
            fill="white"
          />
          <path
            d="M710.383 553.309C708.698 553.309 707.336 554.671 707.336 556.356C707.336 558.04 708.698 559.407 710.383 559.407C712.068 559.407 713.434 558.045 713.434 556.356C713.434 554.667 712.072 553.309 710.383 553.309Z"
            fill="white"
          />
          <path
            d="M698.114 560.727C696.438 560.727 695.062 562.102 695.062 563.778C695.062 565.454 696.438 566.829 698.114 566.829C699.79 566.829 701.165 565.467 701.165 563.778C701.165 562.089 699.803 560.727 698.114 560.727Z"
            fill="white"
          />
          <path
            d="M685.458 566.953C683.774 566.953 682.407 568.315 682.407 570.004C682.407 571.693 683.769 573.043 685.458 573.043C687.147 573.043 688.497 571.681 688.497 570.004C688.497 568.328 687.135 566.953 685.458 566.953Z"
            fill="white"
          />
          <path
            d="M672.511 572.068C670.835 572.068 669.473 573.431 669.473 575.12C669.473 576.809 670.835 578.158 672.511 578.158C674.187 578.158 675.55 576.796 675.55 575.12C675.55 573.443 674.196 572.068 672.511 572.068Z"
            fill="white"
          />
          <path
            d="M659.322 576.275C657.646 576.275 656.292 577.629 656.292 579.305C656.292 580.982 657.646 582.344 659.322 582.344C660.998 582.344 662.361 580.982 662.361 579.305C662.361 577.629 660.998 576.275 659.322 576.275Z"
            fill="white"
          />
          <path
            d="M645.907 579.545C644.231 579.545 642.877 580.899 642.877 582.575C642.877 584.251 644.231 585.605 645.907 585.605C647.583 585.605 648.937 584.251 648.937 582.575C648.937 580.899 647.583 579.545 645.907 579.545Z"
            fill="white"
          />
          <path
            d="M632.356 582.178C630.68 582.178 629.326 583.531 629.326 585.208C629.326 586.884 630.68 588.238 632.356 588.238C634.032 588.238 635.386 586.884 635.386 585.208C635.386 583.531 634.024 582.178 632.356 582.178Z"
            fill="white"
          />
          <path
            d="M618.692 584.428C617.029 584.428 615.662 585.781 615.662 587.458C615.662 589.134 617.024 590.488 618.692 590.488C620.36 590.488 621.722 589.134 621.722 587.458C621.722 585.781 620.368 584.428 618.692 584.428Z"
            fill="white"
          />
          <path
            d="M604.942 586.537C603.279 586.537 601.925 587.891 601.925 589.554C601.925 591.218 603.279 592.584 604.942 592.584C606.606 592.584 607.972 591.231 607.972 589.554C607.972 587.878 606.618 586.537 604.942 586.537Z"
            fill="white"
          />
          <path
            d="M591.214 588.764C589.55 588.764 588.196 590.117 588.196 591.781C588.196 593.445 589.55 594.798 591.214 594.798C592.877 594.798 594.231 593.445 594.231 591.781C594.231 590.117 592.877 588.764 591.214 588.764Z"
            fill="white"
          />
          <path
            d="M577.558 591.242C575.894 591.242 574.549 592.583 574.549 594.251C574.549 595.919 575.89 597.26 577.558 597.26C579.225 597.26 580.575 595.919 580.575 594.251C580.575 592.583 579.221 591.242 577.558 591.242Z"
            fill="white"
          />
          <path
            d="M563.986 594.105C562.322 594.105 560.969 595.459 560.969 597.123C560.969 598.786 562.322 600.132 563.986 600.132C565.65 600.132 567.003 598.791 567.003 597.123C567.003 595.455 565.65 594.105 563.986 594.105Z"
            fill="white"
          />
          <path
            d="M550.508 597.355C548.844 597.355 547.49 598.696 547.49 600.364C547.49 602.032 548.844 603.373 550.508 603.373C552.171 603.373 553.516 602.032 553.516 600.364C553.516 598.696 552.163 597.355 550.508 597.355Z"
            fill="white"
          />
          <path
            d="M537.085 600.682C535.43 600.682 534.089 602.023 534.089 603.678C534.089 605.333 535.43 606.687 537.085 606.687C538.74 606.687 540.094 605.346 540.094 603.678C540.094 602.01 538.753 600.682 537.085 600.682Z"
            fill="white"
          />
          <path
            d="M523.688 604.098C522.032 604.098 520.691 605.439 520.691 607.106C520.691 608.774 522.032 610.103 523.688 610.103C525.343 610.103 526.684 608.762 526.684 607.106C526.684 605.451 525.343 604.098 523.688 604.098Z"
            fill="white"
          />
          <path
            d="M510.272 607.615C508.617 607.615 507.276 608.956 507.276 610.624C507.276 612.292 508.617 613.62 510.272 613.62C511.928 613.62 513.281 612.279 513.281 610.624C513.281 608.969 511.94 607.615 510.272 607.615Z"
            fill="white"
          />
          <path
            d="M496.824 610.998C495.169 610.998 493.815 612.352 493.815 614.007C493.815 615.662 495.169 617.016 496.824 617.016C498.479 617.016 499.833 615.662 499.833 614.007C499.833 612.352 498.492 610.998 496.824 610.998Z"
            fill="white"
          />
          <path
            d="M483.282 614.078C481.627 614.078 480.273 615.419 480.273 617.087C480.273 618.755 481.627 620.096 483.282 620.096C484.937 620.096 486.291 618.742 486.291 617.087C486.291 615.432 484.95 614.078 483.282 614.078Z"
            fill="white"
          />
          <path
            d="M469.587 616.889C467.923 616.889 466.578 618.242 466.578 619.897C466.578 621.553 467.919 622.894 469.587 622.894C471.255 622.894 472.583 621.553 472.583 619.897C472.583 618.242 471.242 616.889 469.587 616.889Z"
            fill="white"
          />
          <path
            d="M455.681 619.322C454.026 619.322 452.685 620.663 452.685 622.318C452.685 623.973 454.026 625.314 455.681 625.314C457.336 625.314 458.677 623.973 458.677 622.318C458.677 620.663 457.336 619.322 455.681 619.322Z"
            fill="white"
          />
          <path
            d="M441.516 621.059C439.852 621.059 438.52 622.4 438.52 624.055C438.52 625.71 439.852 627.051 441.516 627.051C443.179 627.051 444.503 625.71 444.503 624.055C444.503 622.4 443.171 621.059 441.516 621.059Z"
            fill="white"
          />
          <path
            d="M426.946 622.146C425.291 622.146 423.95 623.487 423.95 625.143C423.95 626.798 425.291 628.13 426.946 628.13C428.601 628.13 429.942 626.789 429.942 625.143C429.942 623.496 428.601 622.146 426.946 622.146Z"
            fill="white"
          />
          <path
            d="M411.843 622.486C410.188 622.486 408.847 623.827 408.847 625.474C408.847 627.121 410.188 628.47 411.843 628.47C413.498 628.47 414.839 627.129 414.839 625.474C414.839 623.819 413.498 622.486 411.843 622.486Z"
            fill="white"
          />
          <path
            d="M396.077 621.768C394.422 621.768 393.081 623.109 393.081 624.764C393.081 626.419 394.422 627.76 396.077 627.76C397.732 627.76 399.073 626.419 399.073 624.764C399.073 623.109 397.732 621.768 396.077 621.768Z"
            fill="white"
          />
          <path
            d="M379.561 619.969C377.905 619.969 376.564 621.31 376.564 622.965C376.564 624.62 377.905 625.961 379.561 625.961C381.216 625.961 382.569 624.62 382.569 622.965C382.569 621.31 381.228 619.969 379.561 619.969Z"
            fill="white"
          />
          <path
            d="M362.207 617.125C360.552 617.125 359.22 618.466 359.22 620.121C359.22 621.776 360.552 623.117 362.207 623.117C363.862 623.117 365.203 621.776 365.203 620.121C365.203 618.466 363.862 617.125 362.207 617.125Z"
            fill="white"
          />
          <path
            d="M354.484 613.535C352.787 613.535 351.403 614.919 351.403 616.616C351.403 618.314 352.787 619.706 354.484 619.706C356.182 619.706 357.574 618.322 357.574 616.616C357.574 614.91 356.19 613.535 354.484 613.535Z"
            fill="white"
          />
          <path
            d="M346.911 609.887C345.183 609.887 343.787 611.283 343.787 613.019C343.787 614.754 345.183 616.142 346.911 616.142C348.638 616.142 350.042 614.746 350.042 613.019C350.042 611.291 348.646 609.887 346.911 609.887Z"
            fill="white"
          />
          <path
            d="M339.551 606.104C337.794 606.104 336.355 607.529 336.355 609.286C336.355 611.043 337.79 612.482 339.551 612.482C341.312 612.482 342.747 611.056 342.747 609.286C342.747 607.517 341.321 606.104 339.551 606.104Z"
            fill="white"
          />
          <path
            d="M332.391 602.211C330.6 602.211 329.153 603.658 329.153 605.436C329.153 607.214 330.6 608.674 332.391 608.674C334.182 608.674 335.629 607.227 335.629 605.436C335.629 603.645 334.182 602.211 332.391 602.211Z"
            fill="white"
          />
          <path
            d="M325.385 598.143C323.565 598.143 322.075 599.632 322.075 601.453C322.075 603.273 323.565 604.763 325.385 604.763C327.206 604.763 328.695 603.286 328.695 601.453C328.695 599.619 327.219 598.143 325.385 598.143Z"
            fill="white"
          />
          <path
            d="M318.484 593.971C316.63 593.971 315.132 595.481 315.132 597.332C315.132 599.182 316.63 600.693 318.484 600.693C320.339 600.693 321.845 599.182 321.845 597.332C321.845 595.481 320.347 593.971 318.484 593.971Z"
            fill="white"
          />
          <path
            d="M311.649 589.617C309.773 589.617 308.245 591.149 308.245 593.021C308.245 594.892 309.777 596.424 311.649 596.424C313.52 596.424 315.052 594.905 315.052 593.021C315.052 591.136 313.533 589.617 311.649 589.617Z"
            fill="white"
          />
          <path
            d="M304.82 585.039C302.927 585.039 301.374 586.58 301.374 588.485C301.374 590.39 302.927 591.931 304.82 591.931C306.713 591.931 308.266 590.39 308.266 588.485C308.266 586.58 306.725 585.039 304.82 585.039Z"
            fill="white"
          />
          <path
            d="M297.983 580.16C296.035 580.16 294.456 581.73 294.456 583.678C294.456 585.626 296.039 587.196 297.983 587.196C299.926 587.196 301.501 585.626 301.501 583.678C301.501 581.73 299.93 580.16 297.983 580.16Z"
            fill="white"
          />
          <path
            d="M291.103 574.998C289.139 574.998 287.543 576.589 287.543 578.546C287.543 580.502 289.134 582.106 291.103 582.106C293.073 582.106 294.651 580.515 294.651 578.546C294.651 576.577 293.06 574.998 291.103 574.998Z"
            fill="white"
          />
          <path
            d="M284.183 569.461C282.197 569.461 280.593 571.074 280.593 573.064C280.593 575.054 282.197 576.654 284.183 576.654C286.169 576.654 287.786 575.05 287.786 573.064C287.786 571.078 286.173 569.461 284.183 569.461Z"
            fill="white"
          />
          <path
            d="M277.226 563.535C275.219 563.535 273.594 565.16 273.594 567.168C273.594 569.175 275.215 570.809 277.226 570.809C279.238 570.809 280.868 569.175 280.868 567.168C280.868 565.16 279.234 563.535 277.226 563.535Z"
            fill="white"
          />
          <path
            d="M270.245 557.209C268.217 557.209 266.57 558.864 266.57 560.893C266.57 562.921 268.217 564.576 270.245 564.576C272.274 564.576 273.929 562.93 273.929 560.893C273.929 558.856 272.287 557.209 270.245 557.209Z"
            fill="white"
          />
          <path
            d="M263.252 550.494C261.203 550.494 259.539 552.158 259.539 554.212C259.539 556.266 261.203 557.929 263.252 557.929C265.302 557.929 266.97 556.266 266.97 554.212C266.97 552.158 265.315 550.494 263.252 550.494Z"
            fill="white"
          />
          <path
            d="M256.267 543.336C254.196 543.336 252.512 545.021 252.512 547.092C252.512 549.163 254.196 550.86 256.267 550.86C258.338 550.86 260.036 549.175 260.036 547.092C260.036 545.008 258.351 543.336 256.267 543.336Z"
            fill="white"
          />
          <path
            d="M249.325 535.76C247.233 535.76 245.535 537.457 245.535 539.537C245.535 541.616 247.233 543.326 249.325 543.326C251.417 543.326 253.114 541.629 253.114 539.537C253.114 537.445 251.417 535.76 249.325 535.76Z"
            fill="white"
          />
          <path
            d="M242.415 527.756C240.302 527.756 238.583 529.462 238.583 531.575C238.583 533.689 240.302 535.403 242.415 535.403C244.528 535.403 246.243 533.684 246.243 531.575C246.243 529.466 244.524 527.756 242.415 527.756Z"
            fill="white"
          />
          <path
            d="M238.269 526.01C239.777 524.502 239.777 522.057 238.269 520.549C236.761 519.04 234.316 519.04 232.808 520.549C231.3 522.057 231.3 524.502 232.808 526.01C234.316 527.518 236.761 527.518 238.269 526.01Z"
            fill="white"
          />
          <path
            d="M228.636 510.861C226.493 510.861 224.753 512.601 224.753 514.744C224.753 516.887 226.493 518.636 228.636 518.636C230.779 518.636 232.527 516.9 232.527 514.744C232.527 512.588 230.779 510.861 228.636 510.861Z"
            fill="white"
          />
          <path
            d="M221.608 510.135C223.765 510.135 225.513 508.387 225.513 506.23C225.513 504.074 223.765 502.326 221.608 502.326C219.452 502.326 217.704 504.074 217.704 506.23C217.704 508.387 219.452 510.135 221.608 510.135Z"
            fill="white"
          />
          <path
            d="M214.364 493.879C212.187 493.879 210.422 495.649 210.422 497.826C210.422 500.003 212.192 501.768 214.364 501.768C216.537 501.768 218.311 499.998 218.311 497.826C218.311 495.653 216.541 493.879 214.364 493.879Z"
            fill="white"
          />
          <path
            d="M206.861 485.51C204.676 485.51 202.897 487.288 202.897 489.473C202.897 491.659 204.676 493.437 206.861 493.437C209.047 493.437 210.816 491.659 210.816 489.473C210.816 487.288 209.047 485.51 206.861 485.51Z"
            fill="white"
          />
          <path
            d="M199.074 477.191C196.88 477.191 195.089 478.982 195.089 481.176C195.089 483.37 196.88 485.174 199.074 485.174C201.268 485.174 203.059 483.383 203.059 481.176C203.059 478.97 201.281 477.191 199.074 477.191Z"
            fill="white"
          />
          <path
            d="M195.038 472.963C195.052 470.756 193.273 468.955 191.065 468.941C188.857 468.928 187.056 470.707 187.043 472.915C187.029 475.122 188.808 476.923 191.016 476.937C193.224 476.95 195.025 475.171 195.038 472.963Z"
            fill="white"
          />
          <path
            d="M182.766 460.717C180.538 460.717 178.738 462.529 178.738 464.744C178.738 466.959 180.538 468.771 182.766 468.771C184.994 468.771 186.793 466.972 186.793 464.744C186.793 462.516 184.994 460.717 182.766 460.717Z"
            fill="white"
          />
          <path
            d="M174.282 452.609C172.054 452.609 170.242 454.421 170.242 456.649C170.242 458.877 172.054 460.689 174.282 460.689C176.51 460.689 178.322 458.877 178.322 456.649C178.322 454.421 176.523 452.609 174.282 452.609Z"
            fill="white"
          />
          <path
            d="M165.698 444.473C163.461 444.473 161.641 446.285 161.641 448.521C161.641 450.758 163.461 452.578 165.698 452.578C167.934 452.578 169.755 450.758 169.755 448.521C169.755 446.285 167.934 444.473 165.698 444.473Z"
            fill="white"
          />
          <path
            d="M157.079 436.207C154.829 436.207 153.009 438.028 153.009 440.277C153.009 442.526 154.829 444.338 157.079 444.338C159.328 444.338 161.136 442.526 161.136 440.277C161.136 438.028 159.323 436.207 157.079 436.207Z"
            fill="white"
          />
          <path
            d="M148.493 427.756C146.243 427.756 144.423 429.589 144.423 431.834C144.423 434.079 146.243 435.904 148.493 435.904C150.742 435.904 152.571 434.083 152.571 431.834C152.571 429.585 150.738 427.756 148.493 427.756Z"
            fill="white"
          />
          <path
            d="M140.01 418.961C137.761 418.961 135.932 420.794 135.932 423.039C135.932 425.284 137.765 427.117 140.01 427.117C142.255 427.117 144.088 425.297 144.088 423.039C144.088 420.781 142.268 418.961 140.01 418.961Z"
            fill="white"
          />
          <path
            d="M131.696 409.627C129.439 409.627 127.605 411.448 127.605 413.705C127.605 415.963 129.439 417.796 131.696 417.796C133.954 417.796 135.787 415.963 135.787 413.705C135.787 411.448 133.954 409.627 131.696 409.627Z"
            fill="white"
          />
          <path
            d="M123.628 407.629C125.887 407.629 127.719 405.798 127.719 403.538C127.719 401.279 125.887 399.447 123.628 399.447C121.369 399.447 119.537 401.279 119.537 403.538C119.537 405.798 121.369 407.629 123.628 407.629Z"
            fill="white"
          />
          <path
            d="M115.862 388.332C113.605 388.332 111.771 390.165 111.771 392.41C111.771 394.655 113.605 396.501 115.862 396.501C118.12 396.501 119.941 394.668 119.941 392.41C119.941 390.153 118.12 388.332 115.862 388.332Z"
            fill="white"
          />
          <path
            d="M108.352 376.467C106.094 376.467 104.261 378.3 104.261 380.558C104.261 382.815 106.094 384.636 108.352 384.636C110.609 384.636 112.43 382.803 112.43 380.558C112.43 378.313 110.597 376.467 108.352 376.467Z"
            fill="white"
          />
          <path
            d="M101.023 364.266C98.7649 364.266 96.9443 366.086 96.9443 368.344C96.9443 370.602 98.7649 372.422 101.023 372.422C103.28 372.422 105.101 370.589 105.101 368.344C105.101 366.099 103.268 364.266 101.023 364.266Z"
            fill="white"
          />
          <path
            d="M93.757 352.328C91.4993 352.328 89.666 354.161 89.666 356.419C89.666 358.677 91.4993 360.497 93.757 360.497C96.0147 360.497 97.8352 358.664 97.8352 356.419C97.8352 354.174 96.0019 352.328 93.757 352.328Z"
            fill="white"
          />
          <path
            d="M100.585 338.414C98.3274 338.414 96.5068 340.235 96.5068 342.484C96.5068 344.733 98.3274 346.562 100.585 346.562C102.843 346.562 104.655 344.742 104.655 342.484C104.655 340.226 102.834 338.414 100.585 338.414Z"
            fill="white"
          />
          <path
            d="M107.571 323.887C105.334 323.887 103.514 325.699 103.514 327.948C103.514 330.197 105.334 332.018 107.571 332.018C109.807 332.018 111.64 330.197 111.64 327.948C111.64 325.699 109.82 323.887 107.571 323.887Z"
            fill="white"
          />
          <path
            d="M114.751 308.961C112.514 308.961 110.702 310.782 110.702 313.018C110.702 315.254 112.514 317.067 114.751 317.067C116.987 317.067 118.808 315.254 118.808 313.018C118.808 310.782 116.996 308.961 114.751 308.961Z"
            fill="white"
          />
          <path
            d="M122.212 293.889C119.975 293.889 118.163 295.701 118.163 297.937C118.163 300.174 119.975 301.986 122.212 301.986C124.448 301.986 126.26 300.174 126.26 297.937C126.26 295.701 124.448 293.889 122.212 293.889Z"
            fill="white"
          />
          <path
            d="M129.914 279.162C127.686 279.162 125.887 280.961 125.887 283.189C125.887 285.417 127.686 287.208 129.914 287.208C132.142 287.208 133.933 285.409 133.933 283.189C133.933 280.97 132.134 279.162 129.914 279.162Z"
            fill="white"
          />
          <path
            d="M137.879 264.967C135.664 264.967 133.873 266.766 133.873 268.973C133.873 271.18 135.664 272.992 137.879 272.992C140.094 272.992 141.885 271.192 141.885 268.973C141.885 266.753 140.086 264.967 137.879 264.967Z"
            fill="white"
          />
          <path
            d="M145.871 251.842C143.677 251.842 141.886 253.633 141.886 255.839C141.886 258.046 143.677 259.824 145.871 259.824C148.065 259.824 149.868 258.033 149.868 255.839C149.868 253.645 148.077 251.842 145.871 251.842Z"
            fill="white"
          />
          <path
            d="M153.687 247.961C155.883 247.961 157.664 246.18 157.664 243.984C157.664 241.788 155.883 240.008 153.687 240.008C151.491 240.008 149.711 241.788 149.711 243.984C149.711 246.18 151.491 247.961 153.687 247.961Z"
            fill="white"
          />
          <path
            d="M161.089 229.527C158.904 229.527 157.143 231.297 157.143 233.474C157.143 235.651 158.904 237.429 161.089 237.429C163.275 237.429 165.032 235.66 165.032 233.474C165.032 231.288 163.262 229.527 161.089 229.527Z"
            fill="white"
          />
          <path
            d="M167.967 220.221C165.803 220.221 164.042 221.978 164.042 224.146C164.042 226.315 165.799 228.072 167.967 228.072C170.136 228.072 171.893 226.315 171.893 224.146C171.893 221.978 170.132 220.221 167.967 220.221Z"
            fill="white"
          />
          <path
            d="M174.325 211.916C172.169 211.916 170.421 213.664 170.421 215.82C170.421 217.976 172.169 219.725 174.325 219.725C176.481 219.725 178.229 217.976 178.229 215.82C178.229 213.664 176.481 211.916 174.325 211.916Z"
            fill="white"
          />
          <path
            d="M180.185 204.727C178.05 204.727 176.314 206.454 176.314 208.597C176.314 210.74 178.054 212.459 180.185 212.459C182.315 212.459 184.055 210.731 184.055 208.597C184.055 206.462 182.328 204.727 180.185 204.727Z"
            fill="white"
          />
          <path
            d="M185.504 198.865C183.39 198.865 181.676 200.584 181.676 202.697C181.676 204.811 183.394 206.525 185.504 206.525C187.613 206.525 189.336 204.806 189.336 202.697C189.336 200.588 187.617 198.865 185.504 198.865Z"
            fill="white"
          />
          <path
            d="M190.272 194.109C188.159 194.109 186.453 195.815 186.453 197.925C186.453 200.034 188.159 201.74 190.272 201.74C192.386 201.74 194.083 200.034 194.083 197.925C194.083 195.815 192.377 194.109 190.272 194.109Z"
            fill="white"
          />
          <path
            d="M194.529 190.102C192.445 190.102 190.752 191.786 190.752 193.878C190.752 195.971 192.449 197.655 194.529 197.655C196.608 197.655 198.306 195.958 198.306 193.878C198.306 191.799 196.621 190.102 194.529 190.102Z"
            fill="white"
          />
          <path
            d="M198.336 194.016C200.399 194.016 202.071 192.344 202.071 190.281C202.071 188.219 200.399 186.547 198.336 186.547C196.274 186.547 194.602 188.219 194.602 190.281C194.602 192.344 196.274 194.016 198.336 194.016Z"
            fill="white"
          />
          <path
            d="M201.696 183.301C199.655 183.301 198.013 184.952 198.013 186.984C198.013 189.017 199.655 190.668 201.696 190.668C203.738 190.668 205.38 189.017 205.38 186.984C205.38 184.952 203.725 183.301 201.696 183.301Z"
            fill="white"
          />
          <path
            d="M204.613 180.24C202.593 180.24 200.959 181.878 200.959 183.894C200.959 185.91 202.593 187.548 204.613 187.548C206.633 187.548 208.267 185.91 208.267 183.894C208.267 181.878 206.633 180.24 204.613 180.24Z"
            fill="white"
          />
          <path
            d="M207.112 177.277C205.114 177.277 203.501 178.903 203.501 180.889C203.501 182.875 205.114 184.504 207.112 184.504C209.111 184.504 210.724 182.888 210.724 180.889C210.724 178.89 209.111 177.277 207.112 177.277Z"
            fill="white"
          />
          <path
            d="M209.204 174.357C207.226 174.357 205.622 175.966 205.622 177.943C205.622 179.921 207.226 181.525 209.204 181.525C211.181 181.525 212.786 179.921 212.786 177.943C212.786 175.966 211.181 174.357 209.204 174.357Z"
            fill="white"
          />
          <path
            d="M210.919 171.523C208.984 171.523 207.414 173.094 207.414 175.042C207.414 176.989 208.984 178.547 210.919 178.547C212.855 178.547 214.437 176.977 214.437 175.042C214.437 173.106 212.867 171.523 210.919 171.523Z"
            fill="white"
          />
          <path
            d="M212.323 168.713C210.409 168.713 208.855 170.262 208.855 172.189C208.855 174.115 210.404 175.656 212.323 175.656C214.241 175.656 215.798 174.107 215.798 172.189C215.798 170.27 214.249 168.713 212.323 168.713Z"
            fill="white"
          />
          <path
            d="M213.461 165.969C211.577 165.969 210.049 167.501 210.049 169.393C210.049 171.286 211.581 172.818 213.461 172.818C215.341 172.818 216.886 171.286 216.886 169.393C216.886 167.501 215.354 165.969 213.461 165.969Z"
            fill="white"
          />
          <path
            d="M214.366 163.268C212.494 163.268 210.983 164.783 210.983 166.65C210.983 168.517 212.494 170.024 214.366 170.024C216.237 170.024 217.739 168.513 217.739 166.65C217.739 164.787 216.229 163.268 214.366 163.268Z"
            fill="white"
          />
          <path
            d="M215.052 160.639C213.219 160.639 211.742 162.115 211.742 163.936C211.742 165.757 213.219 167.242 215.052 167.242C216.886 167.242 218.354 165.765 218.354 163.936C218.354 162.107 216.877 160.639 215.052 160.639Z"
            fill="white"
          />
          <path
            d="M215.539 157.945C213.749 157.945 212.28 159.409 212.28 161.205C212.28 163 213.749 164.464 215.539 164.464C217.33 164.464 218.799 163.008 218.799 161.205C218.799 159.401 217.343 157.945 215.539 157.945Z"
            fill="white"
          />
          <path
            d="M215.875 155.168C214.105 155.168 212.671 156.602 212.671 158.38C212.671 160.159 214.105 161.585 215.875 161.585C217.645 161.585 219.079 160.15 219.079 158.38C219.079 156.611 217.645 155.168 215.875 155.168Z"
            fill="white"
          />
          <path
            d="M216.062 152.23C214.322 152.23 212.917 153.639 212.917 155.379C212.917 157.119 214.322 158.524 216.062 158.524C217.802 158.524 219.215 157.119 219.215 155.379C219.215 153.639 217.797 152.23 216.062 152.23Z"
            fill="white"
          />
          <path
            d="M216.155 149.066C214.458 149.066 213.083 150.441 213.083 152.139C213.083 153.836 214.458 155.211 216.155 155.211C217.853 155.211 219.224 153.836 219.224 152.139C219.224 150.441 217.849 149.066 216.155 149.066Z"
            fill="white"
          />
          <path
            d="M216.228 145.533C214.564 145.533 213.219 146.874 213.219 148.542C213.219 150.21 214.56 151.551 216.228 151.551C217.895 151.551 219.236 150.201 219.236 148.542C219.236 146.883 217.883 145.533 216.228 145.533Z"
            fill="white"
          />
          <path
            d="M216.406 141.504C214.781 141.504 213.461 142.819 213.461 144.453C213.461 146.087 214.781 147.398 216.406 147.398C218.031 147.398 219.351 146.079 219.351 144.453C219.351 142.828 218.027 141.504 216.406 141.504Z"
            fill="white"
          />
          <path
            d="M216.885 136.801C215.294 136.801 214.004 138.091 214.004 139.682C214.004 141.274 215.294 142.577 216.885 142.577C218.477 142.577 219.78 141.282 219.78 139.682C219.78 138.082 218.477 136.801 216.885 136.801Z"
            fill="white"
          />
          <path
            d="M217.968 131.193C216.427 131.193 215.18 132.445 215.18 133.994C215.18 135.543 216.427 136.782 217.968 136.782C219.508 136.782 220.756 135.535 220.756 133.994C220.756 132.454 219.508 131.193 217.968 131.193Z"
            fill="white"
          />
          <path
            d="M220.154 124.184C218.643 124.184 217.425 125.406 217.425 126.917C217.425 128.427 218.643 129.65 220.154 129.65C221.664 129.65 222.891 128.427 222.891 126.917C222.891 125.406 221.664 124.184 220.154 124.184Z"
            fill="white"
          />
          <path
            d="M224.472 114.924C222.996 114.924 221.799 116.121 221.799 117.597C221.799 119.074 222.996 120.271 224.472 120.271C225.949 120.271 227.137 119.074 227.137 117.597C227.137 116.121 225.949 114.924 224.472 114.924Z"
            fill="white"
          />
          <path
            d="M232.342 102.217C230.903 102.217 229.728 103.384 229.728 104.831C229.728 106.278 230.903 107.437 232.342 107.437C233.78 107.437 234.956 106.265 234.956 104.831C234.956 103.397 233.789 102.217 232.342 102.217Z"
            fill="white"
          />
          <path
            d="M250.105 97.8477C248.671 97.8477 247.504 99.0147 247.504 100.453C247.504 101.892 248.671 103.059 250.105 103.059C251.54 103.059 252.719 101.892 252.719 100.453C252.719 99.0147 251.552 97.8477 250.105 97.8477Z"
            fill="white"
          />
          <path
            d="M271.392 89.1348C269.944 89.1348 268.777 90.3018 268.777 91.7489C268.777 93.196 269.944 94.3631 271.392 94.3631C272.839 94.3631 274.006 93.196 274.006 91.7489C274.006 90.3018 272.839 89.1348 271.392 89.1348Z"
            fill="white"
          />
          <path
            d="M296.566 74.6855C295.119 74.6855 293.952 75.8568 293.952 77.2912C293.952 78.7256 295.119 79.8926 296.566 79.8926C298.013 79.8926 299.168 78.7256 299.168 77.2912C299.168 75.8568 298.001 74.6855 296.566 74.6855Z"
            fill="white"
          />
          <path
            d="M325.147 53.4805C323.7 53.4805 322.533 54.6475 322.533 56.0819C322.533 57.5163 323.7 58.696 325.147 58.696C326.594 58.696 327.749 57.5248 327.749 56.0819C327.749 54.639 326.582 53.4805 325.147 53.4805Z"
            fill="white"
          />
          <path
            d="M354.641 27.168C353.207 27.168 352.04 28.3435 352.04 29.7821C352.04 31.2208 353.207 32.3963 354.641 32.3963C356.076 32.3963 357.256 31.2292 357.256 29.7821C357.256 28.335 356.089 27.168 354.641 27.168Z"
            fill="white"
          />
          <path
            d="M382.93 -1.46484C381.495 -1.46484 380.315 -0.289325 380.315 1.15355C380.315 2.59642 381.491 3.77194 382.93 3.77194C384.368 3.77194 385.552 2.59642 385.552 1.15355C385.552 -0.289325 384.377 -1.46484 382.93 -1.46484Z"
            fill="white"
          />
          <path
            d="M871.811 -3.22461C870.084 -3.22461 868.688 -1.82842 868.688 -0.113941C868.688 1.60053 870.084 3.00946 871.811 3.00946C873.538 3.00946 874.922 1.60902 874.922 -0.113941C874.922 -1.8369 873.525 -3.22461 871.811 -3.22461Z"
            fill="white"
          />
          <path
            d="M879.024 7.89258C877.267 7.89258 875.85 9.31423 875.85 11.0669C875.85 12.8196 877.267 14.254 879.024 14.254C880.781 14.254 882.211 12.8281 882.211 11.0669C882.211 9.30575 880.785 7.89258 879.024 7.89258Z"
            fill="white"
          />
          <path
            d="M886.061 19.4434C884.283 19.4434 882.836 20.8777 882.836 22.6686C882.836 24.4595 884.283 25.8939 886.061 25.8939C887.839 25.8939 889.286 24.4467 889.286 22.6686C889.286 20.8905 887.839 19.4434 886.061 19.4434Z"
            fill="white"
          />
          <path
            d="M892.918 31.3164C891.085 31.3164 889.6 32.806 889.6 34.635C889.6 36.4641 891.089 37.9536 892.918 37.9536C894.747 37.9536 896.237 36.4726 896.237 34.635C896.237 32.7975 894.747 31.3164 892.918 31.3164Z"
            fill="white"
          />
          <path
            d="M899.548 43.6719C897.693 43.6719 896.187 45.1826 896.187 47.0457C896.187 48.9087 897.697 50.4067 899.548 50.4067C901.398 50.4067 902.921 48.9044 902.921 47.0457C902.921 45.1869 901.411 43.6719 899.548 43.6719Z"
            fill="white"
          />
          <path
            d="M905.967 56.4375C904.074 56.4375 902.551 57.961 902.551 59.8495C902.551 61.7379 904.07 63.2615 905.967 63.2615C907.864 63.2615 909.379 61.7295 909.379 59.8495C909.379 57.9695 907.847 56.4375 905.967 56.4375Z"
            fill="white"
          />
          <path
            d="M912.172 69.5723C910.258 69.5723 908.705 71.117 908.705 73.0309C908.705 74.9449 910.258 76.4896 912.172 76.4896C914.086 76.4896 915.627 74.9449 915.627 73.0309C915.627 71.117 914.078 69.5723 912.172 69.5723Z"
            fill="white"
          />
          <path
            d="M918.207 82.9727C916.251 82.9727 914.668 84.5556 914.668 86.5077C914.668 88.4598 916.251 90.0427 918.207 90.0427C920.164 90.0427 921.747 88.4598 921.747 86.5077C921.747 84.5556 920.164 82.9727 918.207 82.9727Z"
            fill="white"
          />
          <path
            d="M924.132 96.6172C922.154 96.6172 920.55 98.2256 920.55 100.203C920.55 102.181 922.154 103.789 924.132 103.789C926.109 103.789 927.722 102.185 927.722 100.203C927.722 98.2213 926.109 96.6172 924.132 96.6172Z"
            fill="white"
          />
          <path
            d="M930.013 110.426C928.014 110.426 926.393 112.043 926.393 114.054C926.393 116.066 928.018 117.674 930.013 117.674C932.007 117.674 933.632 116.049 933.632 114.054C933.632 112.06 932.007 110.426 930.013 110.426Z"
            fill="white"
          />
          <path
            d="M935.869 124.389C933.849 124.389 932.207 126.023 932.207 128.047C932.207 130.071 933.854 131.705 935.869 131.705C937.885 131.705 939.532 130.071 939.532 128.047C939.532 126.023 937.885 124.389 935.869 124.389Z"
            fill="white"
          />
          <path
            d="M941.764 138.447C939.715 138.447 938.047 140.111 938.047 142.173C938.047 144.236 939.71 145.891 941.764 145.891C943.818 145.891 945.49 144.227 945.49 142.173C945.49 140.119 943.827 138.447 941.764 138.447Z"
            fill="white"
          />
          <path
            d="M947.757 152.584C945.673 152.584 943.988 154.269 943.988 156.352C943.988 158.436 945.673 160.121 947.757 160.121C949.84 160.121 951.525 158.436 951.525 156.352C951.525 154.269 949.84 152.584 947.757 152.584Z"
            fill="white"
          />
          <path
            d="M953.948 166.621C951.847 166.621 950.149 168.327 950.149 170.432C950.149 172.537 951.847 174.23 953.948 174.23C956.048 174.23 957.759 172.528 957.759 170.432C957.759 168.336 956.052 166.621 953.948 166.621Z"
            fill="white"
          />
          <path
            d="M960.454 180.279C958.332 180.279 956.604 181.998 956.604 184.12C956.604 186.242 958.332 187.969 960.454 187.969C962.575 187.969 964.294 186.242 964.294 184.12C964.294 181.998 962.575 180.279 960.454 180.279Z"
            fill="white"
          />
          <path
            d="M967.333 193.32C965.177 193.32 963.441 195.06 963.441 197.212C963.441 199.363 965.181 201.103 967.333 201.103C969.484 201.103 971.224 199.355 971.224 197.212C971.224 195.069 969.476 193.32 967.333 193.32Z"
            fill="white"
          />
          <path
            d="M974.632 205.672C972.467 205.672 970.706 207.429 970.706 209.597C970.706 211.766 972.467 213.523 974.632 213.523C976.796 213.523 978.557 211.762 978.557 209.597C978.557 207.433 976.796 205.672 974.632 205.672Z"
            fill="white"
          />
          <path
            d="M982.364 217.246C980.179 217.246 978.409 219.016 978.409 221.201C978.409 223.387 980.179 225.148 982.364 225.148C984.55 225.148 986.307 223.378 986.307 221.201C986.307 219.024 984.537 217.246 982.364 217.246Z"
            fill="white"
          />
          <path
            d="M990.554 227.885C988.36 227.885 986.569 229.663 986.569 231.87C986.569 234.076 988.36 235.846 990.554 235.846C992.748 235.846 994.531 234.068 994.531 231.87C994.531 229.671 992.752 227.885 990.554 227.885Z"
            fill="white"
          />
          <path
            d="M999.182 237.48C996.954 237.48 995.163 239.271 995.163 241.499C995.163 243.727 996.954 245.518 999.182 245.518C1001.41 245.518 1003.2 243.719 1003.2 241.499C1003.2 239.28 1001.4 237.48 999.182 237.48Z"
            fill="white"
          />
          <path
            d="M1008.18 245.908C1005.95 245.908 1004.13 247.72 1004.13 249.957C1004.13 252.193 1005.95 253.997 1008.18 253.997C1010.42 253.997 1012.23 252.185 1012.23 249.957C1012.23 247.729 1010.42 245.908 1008.18 245.908Z"
            fill="white"
          />
          <path
            d="M1017.47 253.143C1015.23 253.143 1013.41 254.963 1013.41 257.212C1013.41 259.462 1015.23 261.282 1017.47 261.282C1019.71 261.282 1021.54 259.462 1021.54 257.212C1021.54 254.963 1019.72 253.143 1017.47 253.143Z"
            fill="white"
          />
          <path
            d="M1026.93 259.24C1024.67 259.24 1022.84 261.074 1022.84 263.331C1022.84 265.589 1024.67 267.422 1026.93 267.422C1029.18 267.422 1031.02 265.589 1031.02 263.331C1031.02 261.074 1029.18 259.24 1026.93 259.24Z"
            fill="white"
          />
          <path
            d="M1036.45 264.381C1034.18 264.381 1032.33 266.223 1032.33 268.502C1032.33 270.78 1034.18 272.622 1036.45 272.622C1038.73 272.622 1040.58 270.772 1040.58 268.502C1040.58 266.231 1038.73 264.381 1036.45 264.381Z"
            fill="white"
          />
          <path
            d="M1045.97 268.723C1043.67 268.723 1041.82 270.573 1041.82 272.865C1041.82 275.156 1043.68 277.006 1045.97 277.006C1048.25 277.006 1050.11 275.152 1050.11 272.865C1050.11 270.577 1048.25 268.723 1045.97 268.723Z"
            fill="white"
          />
          <path
            d="M1055.44 272.398C1053.14 272.398 1051.28 274.261 1051.28 276.553C1051.28 278.845 1053.14 280.708 1055.44 280.708C1057.74 280.708 1059.59 278.845 1059.59 276.553C1059.59 274.261 1057.73 272.398 1055.44 272.398Z"
            fill="white"
          />
          <path
            d="M1064.85 275.529C1062.55 275.529 1060.69 277.392 1060.69 279.684C1060.69 281.976 1062.55 283.839 1064.85 283.839C1067.15 283.839 1069 281.988 1069 279.684C1069 277.38 1067.14 275.529 1064.85 275.529Z"
            fill="white"
          />
          <path
            d="M1074.19 278.236C1071.89 278.236 1070.04 280.091 1070.04 282.391C1070.04 284.691 1071.89 286.546 1074.19 286.546C1076.49 286.546 1078.34 284.683 1078.34 282.391C1078.34 280.099 1076.48 278.236 1074.19 278.236Z"
            fill="white"
          />
          <path
            d="M1083.47 280.652C1081.18 280.652 1079.31 282.515 1079.31 284.815C1079.31 287.116 1081.18 288.97 1083.47 288.97C1085.76 288.97 1087.62 287.107 1087.62 284.815C1087.62 282.524 1085.77 280.652 1083.47 280.652Z"
            fill="white"
          />
          <path
            d="M1092.7 282.887C1090.4 282.887 1088.54 284.75 1088.54 287.041C1088.54 289.333 1090.39 291.196 1092.7 291.196C1095 291.196 1096.85 289.341 1096.85 287.041C1096.85 284.741 1094.99 282.887 1092.7 282.887Z"
            fill="white"
          />
          <path
            d="M1101.88 285.002C1099.58 285.002 1097.72 286.865 1097.72 289.157C1097.72 291.448 1099.58 293.311 1101.88 293.311C1104.18 293.311 1106.03 291.448 1106.03 289.157C1106.03 286.865 1104.17 285.002 1101.88 285.002Z"
            fill="white"
          />
          <path
            d="M1111.01 287.029C1108.71 287.029 1106.85 288.884 1106.85 291.184C1106.85 293.484 1108.71 295.339 1111.01 295.339C1113.3 295.339 1115.16 293.476 1115.16 291.184C1115.16 288.892 1113.3 287.029 1111.01 287.029Z"
            fill="white"
          />
          <path
            d="M1106.22 287.51C1103.93 287.51 1102.06 289.373 1102.06 291.664C1102.06 293.956 1103.93 295.819 1106.22 295.819C1108.51 295.819 1110.37 293.956 1110.37 291.664C1110.37 289.373 1108.51 287.51 1106.22 287.51Z"
            fill="white"
          />
          <path
            d="M1101.2 287.959C1098.91 287.959 1097.05 289.809 1097.05 292.114C1097.05 294.418 1098.91 296.268 1101.2 296.268C1103.49 296.268 1105.36 294.405 1105.36 292.114C1105.36 289.822 1103.5 287.959 1101.2 287.959Z"
            fill="white"
          />
          <path
            d="M1095.97 288.383C1093.67 288.383 1091.81 290.237 1091.81 292.537C1091.81 294.838 1093.66 296.692 1095.97 296.692C1098.27 296.692 1100.12 294.829 1100.12 292.537C1100.12 290.246 1098.26 288.383 1095.97 288.383Z"
            fill="white"
          />
          <path
            d="M1090.49 288.811C1088.19 288.811 1086.33 290.665 1086.33 292.965C1086.33 295.265 1088.19 297.12 1090.49 297.12C1092.79 297.12 1094.65 295.257 1094.65 292.965C1094.65 290.674 1092.78 288.811 1090.49 288.811Z"
            fill="white"
          />
          <path
            d="M1084.77 289.27C1082.47 289.27 1080.61 291.12 1080.61 293.424C1080.61 295.729 1082.47 297.575 1084.77 297.575C1087.07 297.575 1088.92 295.712 1088.92 293.424C1088.92 291.137 1087.06 289.27 1084.77 289.27Z"
            fill="white"
          />
          <path
            d="M1078.78 289.768C1076.49 289.768 1074.63 291.631 1074.63 293.922C1074.63 296.214 1076.49 298.077 1078.78 298.077C1081.07 298.077 1082.94 296.222 1082.94 293.922C1082.94 291.622 1081.08 289.768 1078.78 289.768Z"
            fill="white"
          />
          <path
            d="M1072.54 290.352C1070.24 290.352 1068.38 292.215 1068.38 294.506C1068.38 296.798 1070.23 298.661 1072.54 298.661C1074.84 298.661 1076.69 296.798 1076.69 294.506C1076.69 292.215 1074.83 290.352 1072.54 290.352Z"
            fill="white"
          />
          <path
            d="M1066.01 291.02C1063.71 291.02 1061.86 292.883 1061.86 295.174C1061.86 297.466 1063.71 299.337 1066.01 299.337C1068.32 299.337 1070.17 297.474 1070.17 295.174C1070.17 292.874 1068.3 291.02 1066.01 291.02Z"
            fill="white"
          />
          <path
            d="M1059.19 291.777C1056.9 291.777 1055.04 293.64 1055.04 295.932C1055.04 298.224 1056.9 300.087 1059.19 300.087C1061.48 300.087 1063.35 298.232 1063.35 295.932C1063.35 293.632 1061.49 291.777 1059.19 291.777Z"
            fill="white"
          />
          <path
            d="M1052.11 292.654C1049.81 292.654 1047.95 294.517 1047.95 296.809C1047.95 299.101 1049.81 300.964 1052.11 300.964C1054.4 300.964 1056.26 299.101 1056.26 296.809C1056.26 294.517 1054.4 292.654 1052.11 292.654Z"
            fill="white"
          />
          <path
            d="M1044.74 293.672C1042.45 293.672 1040.6 295.526 1040.6 297.814C1040.6 300.101 1042.45 301.956 1044.74 301.956C1047.03 301.956 1048.88 300.105 1048.88 297.814C1048.88 295.522 1047.03 293.672 1044.74 293.672Z"
            fill="white"
          />
          <path
            d="M1037.11 294.867C1034.83 294.867 1032.99 296.722 1032.99 298.988C1032.99 301.254 1034.83 303.121 1037.11 303.121C1039.39 303.121 1041.23 301.267 1041.23 298.988C1041.23 296.709 1039.39 294.867 1037.11 294.867Z"
            fill="white"
          />
          <path
            d="M1029.22 296.273C1026.96 296.273 1025.13 298.107 1025.13 300.364C1025.13 302.622 1026.96 304.464 1029.22 304.464C1031.48 304.464 1033.31 302.631 1033.31 300.364C1033.31 298.098 1031.48 296.273 1029.22 296.273Z"
            fill="white"
          />
          <path
            d="M1021.09 297.885C1018.84 297.885 1017.01 299.718 1017.01 301.963C1017.01 304.208 1018.85 306.041 1021.09 306.041C1023.34 306.041 1025.17 304.208 1025.17 301.963C1025.17 299.718 1023.35 297.885 1021.09 297.885Z"
            fill="white"
          />
          <path
            d="M1012.74 299.678C1010.5 299.678 1008.67 301.498 1008.67 303.748C1008.67 305.997 1010.5 307.805 1012.74 307.805C1014.99 307.805 1016.8 305.984 1016.8 303.748C1016.8 301.511 1014.98 299.678 1012.74 299.678Z"
            fill="white"
          />
          <path
            d="M1004.18 309.7C1006.4 309.7 1008.2 307.9 1008.2 305.681C1008.2 303.461 1006.4 301.662 1004.18 301.662C1001.96 301.662 1000.16 303.461 1000.16 305.681C1000.16 307.9 1001.96 309.7 1004.18 309.7Z"
            fill="white"
          />
          <path
            d="M995.435 303.811C993.241 303.811 991.45 305.601 991.45 307.808C991.45 310.015 993.241 311.793 995.435 311.793C997.629 311.793 999.433 310.015 999.433 307.808C999.433 305.601 997.642 303.811 995.435 303.811Z"
            fill="white"
          />
          <path
            d="M986.536 306.148C984.35 306.148 982.572 307.927 982.572 310.125C982.572 312.323 984.35 314.089 986.536 314.089C988.721 314.089 990.512 312.31 990.512 310.125C990.512 307.939 988.734 306.148 986.536 306.148Z"
            fill="white"
          />
          <path
            d="M977.484 308.754C975.299 308.754 973.542 310.524 973.542 312.696C973.542 314.869 975.299 316.643 977.484 316.643C979.67 316.643 981.427 314.873 981.427 312.696C981.427 310.519 979.657 308.754 977.484 308.754Z"
            fill="white"
          />
          <path
            d="M968.263 319.475C970.419 319.475 972.167 317.727 972.167 315.57C972.167 313.414 970.419 311.666 968.263 311.666C966.106 311.666 964.358 313.414 964.358 315.57C964.358 317.727 966.106 319.475 968.263 319.475Z"
            fill="white"
          />
          <path
            d="M958.926 314.916C956.792 314.916 955.064 316.652 955.064 318.786C955.064 320.921 956.792 322.657 958.926 322.657C961.061 322.657 962.797 320.917 962.797 318.786C962.797 316.656 961.069 314.916 958.926 314.916Z"
            fill="white"
          />
          <path
            d="M949.496 318.543C947.382 318.543 945.668 320.262 945.668 322.371C945.668 324.48 947.387 326.203 949.496 326.203C951.605 326.203 953.315 324.484 953.315 322.371C953.315 320.257 951.609 318.543 949.496 318.543Z"
            fill="white"
          />
          <path
            d="M939.982 322.598C937.89 322.598 936.184 324.295 936.184 326.396C936.184 328.496 937.89 330.194 939.982 330.194C942.074 330.194 943.78 328.488 943.78 326.396C943.78 324.304 942.082 322.598 939.982 322.598Z"
            fill="white"
          />
          <path
            d="M930.429 327.1C928.358 327.1 926.673 328.776 926.673 330.847C926.673 332.918 928.358 334.603 930.429 334.603C932.499 334.603 934.176 332.926 934.176 330.847C934.176 328.767 932.499 327.1 930.429 327.1Z"
            fill="white"
          />
          <path
            d="M920.851 332.107C918.802 332.107 917.146 333.762 917.146 335.812C917.146 337.862 918.802 339.517 920.851 339.517C922.901 339.517 924.556 337.853 924.556 335.812C924.556 333.771 922.893 332.107 920.851 332.107Z"
            fill="white"
          />
          <path
            d="M911.286 337.645C909.266 337.645 907.624 339.278 907.624 341.298C907.624 343.318 909.271 344.961 911.286 344.961C913.302 344.961 914.94 343.327 914.94 341.298C914.94 339.27 913.306 337.645 911.286 337.645Z"
            fill="white"
          />
          <path
            d="M901.746 343.734C899.747 343.734 898.113 345.355 898.113 347.367C898.113 349.379 899.747 351 901.746 351C903.745 351 905.379 349.379 905.379 347.367C905.379 345.355 903.757 343.734 901.746 343.734Z"
            fill="white"
          />
          <path
            d="M892.262 350.508C890.297 350.508 888.701 352.099 888.701 354.068C888.701 356.037 890.293 357.637 892.262 357.637C894.231 357.637 895.831 356.033 895.831 354.068C895.831 352.103 894.239 350.508 892.262 350.508Z"
            fill="white"
          />
          <path
            d="M882.844 357.896C880.909 357.896 879.326 359.467 879.326 361.415C879.326 363.362 880.909 364.933 882.844 364.933C884.779 364.933 886.362 363.35 886.362 361.415C886.362 359.479 884.792 357.896 882.844 357.896Z"
            fill="white"
          />
          <path
            d="M873.508 365.955C871.594 365.955 870.032 367.517 870.032 369.431C870.032 371.345 871.594 372.906 873.508 372.906C875.422 372.906 876.984 371.345 876.984 369.431C876.984 367.517 875.435 365.955 873.508 365.955Z"
            fill="white"
          />
          <path
            d="M864.317 374.799C862.432 374.799 860.9 376.327 860.9 378.224C860.9 380.12 862.432 381.636 864.317 381.636C866.201 381.636 867.729 380.104 867.729 378.224C867.729 376.344 866.197 374.799 864.317 374.799Z"
            fill="white"
          />
          <path
            d="M855.23 384.398C853.375 384.398 851.877 385.909 851.877 387.759C851.877 389.61 853.375 391.112 855.23 391.112C857.084 391.112 858.582 389.601 858.582 387.759C858.582 385.918 857.084 384.398 855.23 384.398Z"
            fill="white"
          />
          <path
            d="M846.294 394.867C844.473 394.867 842.992 396.344 842.992 398.165C842.992 399.985 844.469 401.462 846.294 401.462C848.119 401.462 849.591 399.985 849.591 398.165C849.591 396.344 848.114 394.867 846.294 394.867Z"
            fill="white"
          />
          <path
            d="M837.64 406.514C835.841 406.514 834.381 407.969 834.381 409.76C834.381 411.551 835.836 413.007 837.64 413.007C839.444 413.007 840.887 411.56 840.887 409.76C840.887 407.961 839.431 406.514 837.64 406.514Z"
            fill="white"
          />
          <path
            d="M829.534 419.752C827.773 419.752 826.352 421.186 826.352 422.948C826.352 424.709 827.777 426.143 829.534 426.143C831.291 426.143 832.73 424.709 832.73 422.948C832.73 421.186 831.304 419.752 829.534 419.752Z"
            fill="white"
          />
          <path
            d="M825.663 443.357C823.978 443.357 822.604 444.732 822.604 446.417C822.604 448.102 823.978 449.477 825.663 449.477C827.348 449.477 828.723 448.102 828.723 446.417C828.723 444.732 827.361 443.357 825.663 443.357Z"
            fill="white"
          />
          <path
            d="M816.543 453.139C814.846 453.139 813.483 454.501 813.483 456.19C813.483 457.879 814.846 459.25 816.543 459.25C818.241 459.25 819.594 457.875 819.594 456.19C819.594 454.505 818.232 453.139 816.543 453.139Z"
            fill="white"
          />
          <path
            d="M807.428 463.441C805.743 463.441 804.377 464.816 804.377 466.501C804.377 468.186 805.739 469.552 807.428 469.552C809.117 469.552 810.488 468.19 810.488 466.501C810.488 464.812 809.113 463.441 807.428 463.441Z"
            fill="white"
          />
          <path
            d="M798.215 474.104C796.531 474.104 795.164 475.466 795.164 477.155C795.164 478.844 796.526 480.202 798.215 480.202C799.904 480.202 801.267 478.84 801.267 477.155C801.267 475.47 799.904 474.104 798.215 474.104Z"
            fill="white"
          />
          <path
            d="M789.015 485.174C787.33 485.174 785.964 486.536 785.964 488.212C785.964 489.889 787.326 491.264 789.015 491.264C790.704 491.264 792.054 489.901 792.054 488.212C792.054 486.523 790.691 485.174 789.015 485.174Z"
            fill="white"
          />
          <path
            d="M779.814 496.676C778.138 496.676 776.775 498.038 776.775 499.714C776.775 501.391 778.138 502.753 779.814 502.753C781.49 502.753 782.865 501.391 782.865 499.714C782.865 498.038 781.503 496.676 779.814 496.676Z"
            fill="white"
          />
          <path
            d="M770.469 508.252C768.793 508.252 767.439 509.606 767.439 511.269C767.439 512.933 768.793 514.299 770.469 514.299C772.146 514.299 773.5 512.946 773.5 511.269C773.5 509.593 772.146 508.252 770.469 508.252Z"
            fill="white"
          />
          <path
            d="M760.861 519.732C759.197 519.732 757.844 521.086 757.844 522.75C757.844 524.413 759.197 525.78 760.861 525.78C762.525 525.78 763.891 524.426 763.891 522.75C763.891 521.073 762.537 519.732 760.861 519.732Z"
            fill="white"
          />
          <path
            d="M750.872 530.887C749.208 530.887 747.854 532.24 747.854 533.904C747.854 535.568 749.208 536.921 750.872 536.921C752.535 536.921 753.889 535.568 753.889 533.904C753.889 532.24 752.548 530.887 750.872 530.887Z"
            fill="white"
          />
          <path
            d="M740.36 541.402C738.697 541.402 737.343 542.756 737.343 544.42C737.343 546.083 738.697 547.428 740.36 547.428C742.024 547.428 743.369 546.087 743.369 544.42C743.369 542.752 742.028 541.402 740.36 541.402Z"
            fill="white"
          />
          <path
            d="M729.255 551.016C727.6 551.016 726.246 552.357 726.246 554.024C726.246 555.692 727.6 557.042 729.255 557.042C730.91 557.042 732.272 555.688 732.272 554.024C732.272 552.361 730.918 551.016 729.255 551.016Z"
            fill="white"
          />
          <path
            d="M717.627 559.572C715.963 559.572 714.618 560.913 714.618 562.568C714.618 564.223 715.959 565.577 717.627 565.577C719.295 565.577 720.636 564.236 720.636 562.568C720.636 560.901 719.282 559.572 717.627 559.572Z"
            fill="white"
          />
          <path
            d="M705.502 567.053C703.838 567.053 702.493 568.394 702.493 570.049C702.493 571.704 703.834 573.058 705.502 573.058C707.17 573.058 708.498 571.704 708.498 570.049C708.498 568.394 707.157 567.053 705.502 567.053Z"
            fill="white"
          />
          <path
            d="M692.92 573.289C691.265 573.289 689.924 574.63 689.924 576.285C689.924 577.94 691.265 579.281 692.92 579.281C694.575 579.281 695.916 577.94 695.916 576.285C695.916 574.63 694.575 573.289 692.92 573.289Z"
            fill="white"
          />
          <path
            d="M680.005 578.389C678.35 578.389 677.009 579.73 677.009 581.385C677.009 583.04 678.35 584.372 680.005 584.372C681.66 584.372 683.001 583.031 683.001 581.385C683.001 579.738 681.66 578.389 680.005 578.389Z"
            fill="white"
          />
          <path
            d="M666.837 582.5C665.182 582.5 663.85 583.841 663.85 585.488C663.85 587.134 665.182 588.475 666.837 588.475C668.492 588.475 669.825 587.143 669.825 585.488C669.825 583.833 668.484 582.5 666.837 582.5Z"
            fill="white"
          />
          <path
            d="M653.431 585.717C651.789 585.717 650.443 587.049 650.443 588.704C650.443 590.359 651.784 591.692 653.431 591.692C655.078 591.692 656.419 590.351 656.419 588.704C656.419 587.058 655.086 585.717 653.431 585.717Z"
            fill="white"
          />
          <path
            d="M639.851 588.184C638.204 588.184 636.876 589.516 636.876 591.15C636.876 592.784 638.209 594.125 639.851 594.125C641.493 594.125 642.817 592.792 642.817 591.15C642.817 589.508 641.493 588.184 639.851 588.184Z"
            fill="white"
          />
          <path
            d="M626.144 590.098C624.498 590.098 623.178 591.417 623.178 593.064C623.178 594.711 624.502 596.022 626.144 596.022C627.786 596.022 629.11 594.702 629.11 593.064C629.11 591.426 627.778 590.098 626.144 590.098Z"
            fill="white"
          />
          <path
            d="M612.322 591.773C610.688 591.773 609.355 593.097 609.355 594.74C609.355 596.382 610.688 597.706 612.322 597.706C613.956 597.706 615.288 596.374 615.288 594.74C615.288 593.106 613.968 591.773 612.322 591.773Z"
            fill="white"
          />
          <path
            d="M598.467 593.479C596.833 593.479 595.509 594.803 595.509 596.436C595.509 598.07 596.833 599.403 598.467 599.403C600.101 599.403 601.433 598.079 601.433 596.436C601.433 594.794 600.113 593.479 598.467 593.479Z"
            fill="white"
          />
          <path
            d="M584.686 595.406C583.053 595.406 581.729 596.739 581.729 598.364C581.729 599.989 583.048 601.331 584.686 601.331C586.324 601.331 587.64 599.998 587.64 598.364C587.64 596.73 586.32 595.406 584.686 595.406Z"
            fill="white"
          />
          <path
            d="M570.971 597.686C569.349 597.686 568.025 599.01 568.025 600.643C568.025 602.277 569.349 603.589 570.971 603.589C572.592 603.589 573.928 602.269 573.928 600.643C573.928 599.018 572.609 597.686 570.971 597.686Z"
            fill="white"
          />
          <path
            d="M557.356 600.414C555.722 600.414 554.398 601.725 554.398 603.359C554.398 604.993 555.718 606.304 557.356 606.304C558.994 606.304 560.302 604.98 560.302 603.359C560.302 601.738 558.977 600.414 557.356 600.414Z"
            fill="white"
          />
          <path
            d="M543.815 603.381C542.181 603.381 540.857 604.701 540.857 606.339C540.857 607.977 542.181 609.305 543.815 609.305C545.449 609.305 546.773 607.973 546.773 606.339C546.773 604.705 545.453 603.381 543.815 603.381Z"
            fill="white"
          />
          <path
            d="M530.337 606.439C528.704 606.439 527.384 607.759 527.384 609.397C527.384 611.035 528.704 612.355 530.337 612.355C531.971 612.355 533.295 611.031 533.295 609.397C533.295 607.763 531.963 606.439 530.337 606.439Z"
            fill="white"
          />
          <path
            d="M516.85 609.645C515.225 609.645 513.905 610.969 513.905 612.59C513.905 614.211 515.225 615.548 516.85 615.548C518.476 615.548 519.808 614.224 519.808 612.59C519.808 610.956 518.484 609.645 516.85 609.645Z"
            fill="white"
          />
          <path
            d="M503.36 612.891C501.739 612.891 500.415 614.215 500.415 615.836C500.415 617.457 501.739 618.781 503.36 618.781C504.981 618.781 506.305 617.457 506.305 615.836C506.305 614.215 504.981 612.891 503.36 612.891Z"
            fill="white"
          />
          <path
            d="M489.809 615.879C488.176 615.879 486.852 617.199 486.852 618.837C486.852 620.475 488.171 621.782 489.809 621.782C491.448 621.782 492.755 620.458 492.755 618.837C492.755 617.216 491.435 615.879 489.809 615.879Z"
            fill="white"
          />
          <path
            d="M476.124 618.627C474.498 618.627 473.179 619.938 473.179 621.564C473.179 623.189 474.498 624.509 476.124 624.509C477.749 624.509 479.069 623.189 479.069 621.564C479.069 619.938 477.749 618.627 476.124 618.627Z"
            fill="white"
          />
          <path
            d="M462.259 621.072C460.638 621.072 459.313 622.392 459.313 624.017C459.313 625.643 460.638 626.954 462.259 626.954C463.88 626.954 465.204 625.643 465.204 624.017C465.204 622.392 463.88 621.072 462.259 621.072Z"
            fill="white"
          />
          <path
            d="M448.157 622.986C446.545 622.986 445.221 624.298 445.221 625.923C445.221 627.548 446.541 628.86 448.157 628.86C449.774 628.86 451.103 627.548 451.103 625.923C451.103 624.298 449.783 622.986 448.157 622.986Z"
            fill="white"
          />
          <path
            d="M433.732 624.203C432.106 624.203 430.795 625.523 430.795 627.14C430.795 628.757 432.106 630.076 433.732 630.076C435.357 630.076 436.668 628.765 436.668 627.14C436.668 625.514 435.348 624.203 433.732 624.203Z"
            fill="white"
          />
          <path
            d="M418.816 624.768C417.19 624.768 415.879 626.079 415.879 627.704C415.879 629.33 417.19 630.649 418.816 630.649C420.441 630.649 421.761 629.338 421.761 627.704C421.761 626.07 420.449 624.768 418.816 624.768Z"
            fill="white"
          />
          <path
            d="M403.301 624.463C401.675 624.463 400.355 625.783 400.355 627.408C400.355 629.033 401.675 630.345 403.301 630.345C404.926 630.345 406.237 629.025 406.237 627.408C406.237 625.791 404.926 624.463 403.301 624.463Z"
            fill="white"
          />
          <path
            d="M387.043 623.051C385.417 623.051 384.098 624.362 384.098 625.987C384.098 627.613 385.417 628.933 387.043 628.933C388.668 628.933 389.979 627.609 389.979 625.987C389.979 624.366 388.668 623.051 387.043 623.051Z"
            fill="white"
          />
          <path
            d="M369.94 620.605C368.314 620.605 367.003 621.917 367.003 623.542C367.003 625.167 368.314 626.479 369.94 626.479C371.565 626.479 372.876 625.167 372.876 623.542C372.876 621.917 371.556 620.605 369.94 620.605Z"
            fill="white"
          />
          <path
            d="M351.896 617.031C350.27 617.031 348.959 618.343 348.959 619.968C348.959 621.593 350.27 622.905 351.896 622.905C353.521 622.905 354.832 621.585 354.832 619.968C354.832 618.351 353.508 617.031 351.896 617.031Z"
            fill="white"
          />
          <path
            d="M344.027 613.068C342.372 613.068 341.031 614.409 341.031 616.064C341.031 617.719 342.372 619.061 344.027 619.061C345.682 619.061 347.023 617.719 347.023 616.064C347.023 614.409 345.682 613.068 344.027 613.068Z"
            fill="white"
          />
          <path
            d="M336.347 609.006C334.649 609.006 333.266 610.381 333.266 612.087C333.266 613.793 334.649 615.168 336.347 615.168C338.044 615.168 339.428 613.793 339.428 612.087C339.428 610.381 338.053 609.006 336.347 609.006Z"
            fill="white"
          />
          <path
            d="M328.989 604.93C327.261 604.93 325.865 606.334 325.865 608.062C325.865 609.789 327.261 611.193 328.989 611.193C330.716 611.193 332.121 609.789 332.121 608.062C332.121 606.334 330.724 604.93 328.989 604.93Z"
            fill="white"
          />
          <path
            d="M321.961 600.838C320.2 600.838 318.778 602.264 318.778 604.025C318.778 605.786 320.204 607.221 321.961 607.221C323.718 607.221 325.148 605.795 325.148 604.025C325.148 602.255 323.722 600.838 321.961 600.838Z"
            fill="white"
          />
          <path
            d="M315.209 596.717C313.418 596.717 311.971 598.164 311.971 599.955C311.971 601.746 313.418 603.193 315.209 603.193C317 603.193 318.447 601.746 318.447 599.955C318.447 598.164 316.991 596.717 315.209 596.717Z"
            fill="white"
          />
          <path
            d="M308.639 592.49C306.806 592.49 305.329 593.967 305.329 595.8C305.329 597.634 306.806 599.11 308.639 599.11C310.473 599.11 311.949 597.621 311.949 595.8C311.949 593.98 310.46 592.49 308.639 592.49Z"
            fill="white"
          />
          <path
            d="M302.189 588.152C300.335 588.152 298.828 589.663 298.828 591.513C298.828 593.364 300.339 594.874 302.189 594.874C304.039 594.874 305.563 593.376 305.563 591.513C305.563 589.65 304.052 588.152 302.189 588.152Z"
            fill="white"
          />
          <path
            d="M295.798 583.646C293.914 583.646 292.382 585.178 292.382 587.063C292.382 588.947 293.914 590.475 295.798 590.475C297.682 590.475 299.21 588.943 299.21 587.063C299.21 585.183 297.678 583.646 295.798 583.646Z"
            fill="white"
          />
          <path
            d="M289.394 578.932C287.488 578.932 285.939 580.472 285.939 582.386C285.939 584.3 287.488 585.84 289.394 585.84C291.299 585.84 292.848 584.287 292.848 582.386C292.848 580.485 291.299 578.932 289.394 578.932Z"
            fill="white"
          />
          <path
            d="M282.964 573.924C281.016 573.924 279.446 575.494 279.446 577.442C279.446 579.39 281.016 580.96 282.964 580.96C284.912 580.96 286.482 579.39 286.482 577.442C286.482 575.494 284.9 573.924 282.964 573.924Z"
            fill="white"
          />
          <path
            d="M276.468 575.756C278.434 575.756 280.028 574.162 280.028 572.195C280.028 570.229 278.434 568.635 276.468 568.635C274.501 568.635 272.907 570.229 272.907 572.195C272.907 574.162 274.501 575.756 276.468 575.756Z"
            fill="white"
          />
          <path
            d="M269.903 563.061C267.925 563.061 266.312 564.673 266.312 566.651C266.312 568.628 267.925 570.241 269.903 570.241C271.88 570.241 273.493 568.637 273.493 566.651C273.493 564.665 271.889 563.061 269.903 563.061Z"
            fill="white"
          />
          <path
            d="M263.274 557.129C261.267 557.129 259.642 558.754 259.642 560.762C259.642 562.769 261.267 564.394 263.274 564.394C265.282 564.394 266.907 562.769 266.907 560.762C266.907 558.754 265.282 557.129 263.274 557.129Z"
            fill="white"
          />
          <path
            d="M256.591 550.809C254.55 550.809 252.907 552.455 252.907 554.492C252.907 556.529 254.554 558.167 256.591 558.167C258.628 558.167 260.266 556.521 260.266 554.492C260.266 552.464 258.624 550.809 256.591 550.809Z"
            fill="white"
          />
          <path
            d="M249.876 544.088C247.814 544.088 246.15 545.764 246.15 547.814C246.15 549.864 247.814 551.54 249.876 551.54C251.939 551.54 253.602 549.876 253.602 547.814C253.602 545.751 251.939 544.088 249.876 544.088Z"
            fill="white"
          />
          <path
            d="M243.162 536.986C241.091 536.986 239.415 538.663 239.415 540.734C239.415 542.804 241.091 544.489 243.162 544.489C245.233 544.489 246.918 542.804 246.918 540.734C246.918 538.663 245.233 536.986 243.162 536.986Z"
            fill="white"
          />
          <path
            d="M236.462 529.492C234.369 529.492 232.672 531.19 232.672 533.282C232.672 535.374 234.369 537.059 236.462 537.059C238.554 537.059 240.238 535.374 240.238 533.282C240.238 531.19 238.541 529.492 236.462 529.492Z"
            fill="white"
          />
          <path
            d="M229.749 521.666C227.635 521.666 225.921 523.385 225.921 525.494C225.921 527.603 227.64 529.326 229.749 529.326C231.858 529.326 233.581 527.607 233.581 525.494C233.581 523.38 231.862 521.666 229.749 521.666Z"
            fill="white"
          />
          <path
            d="M222.985 513.664C220.863 513.664 219.136 515.391 219.136 517.526C219.136 519.66 220.863 521.375 222.985 521.375C225.107 521.375 226.847 519.648 226.847 517.526C226.847 515.404 225.119 513.664 222.985 513.664Z"
            fill="white"
          />
          <path
            d="M216.125 505.564C213.982 505.564 212.233 507.313 212.233 509.456C212.233 511.599 213.982 513.339 216.125 513.339C218.268 513.339 220.008 511.599 220.008 509.456C220.008 507.313 218.268 505.564 216.125 505.564Z"
            fill="white"
          />
          <path
            d="M209.077 497.512C206.921 497.512 205.164 499.26 205.164 501.424C205.164 503.589 206.921 505.337 209.077 505.337C211.233 505.337 212.99 503.58 212.99 501.424C212.99 499.269 211.241 497.512 209.077 497.512Z"
            fill="white"
          />
          <path
            d="M201.781 489.518C199.604 489.518 197.839 491.279 197.839 493.46C197.839 495.641 199.609 497.402 201.781 497.402C203.954 497.402 205.736 495.633 205.736 493.46C205.736 491.287 203.967 489.518 201.781 489.518Z"
            fill="white"
          />
          <path
            d="M194.206 481.598C192.012 481.598 190.229 483.376 190.229 485.561C190.229 487.747 192.008 489.538 194.206 489.538C196.404 489.538 198.182 487.76 198.182 485.561C198.182 483.363 196.404 481.598 194.206 481.598Z"
            fill="white"
          />
          <path
            d="M186.326 473.768C184.132 473.768 182.341 475.546 182.341 477.744C182.341 479.942 184.132 481.729 186.326 481.729C188.52 481.729 190.302 479.938 190.302 477.744C190.302 475.55 188.524 473.768 186.326 473.768Z"
            fill="white"
          />
          <path
            d="M178.135 474.062C180.343 474.062 182.133 472.272 182.133 470.064C182.133 467.856 180.343 466.066 178.135 466.066C175.927 466.066 174.138 467.856 174.138 470.064C174.138 472.272 175.927 474.062 178.135 474.062Z"
            fill="white"
          />
          <path
            d="M169.703 458.459C167.475 458.459 165.676 460.258 165.676 462.478C165.676 464.697 167.475 466.505 169.703 466.505C171.931 466.505 173.722 464.706 173.722 462.478C173.722 460.25 171.923 458.459 169.703 458.459Z"
            fill="white"
          />
          <path
            d="M161.097 450.859C158.869 450.859 157.057 452.671 157.057 454.899C157.057 457.127 158.869 458.939 161.097 458.939C163.325 458.939 165.137 457.127 165.137 454.899C165.137 452.671 163.337 450.859 161.097 450.859Z"
            fill="white"
          />
          <path
            d="M152.406 443.242C150.17 443.242 148.357 445.054 148.357 447.291C148.357 449.527 150.17 451.339 152.406 451.339C154.642 451.339 156.455 449.519 156.455 447.291C156.455 445.063 154.642 443.242 152.406 443.242Z"
            fill="white"
          />
          <path
            d="M143.698 435.49C141.448 435.49 139.628 437.311 139.628 439.56C139.628 441.809 141.448 443.617 143.698 443.617C145.947 443.617 147.755 441.796 147.755 439.56C147.755 437.324 145.934 435.49 143.698 435.49Z"
            fill="white"
          />
          <path
            d="M135.006 427.514C132.757 427.514 130.937 429.347 130.937 431.592C130.937 433.837 132.757 435.662 135.006 435.662C137.255 435.662 139.085 433.841 139.085 431.592C139.085 429.343 137.264 427.514 135.006 427.514Z"
            fill="white"
          />
          <path
            d="M126.803 427.25C129.04 427.029 130.674 425.036 130.453 422.799C130.232 420.563 128.239 418.929 126.002 419.15C123.765 419.371 122.132 421.364 122.353 423.601C122.574 425.838 124.567 427.471 126.803 427.25Z"
            fill="white"
          />
          <path
            d="M118.061 410.021C115.803 410.021 113.97 411.842 113.97 414.1C113.97 416.357 115.803 418.178 118.061 418.178C120.318 418.178 122.139 416.345 122.139 414.1C122.139 411.855 120.306 410.021 118.061 410.021Z"
            fill="white"
          />
          <path
            d="M109.921 400.102C107.663 400.102 105.843 401.922 105.843 404.18C105.843 406.437 107.663 408.258 109.921 408.258C112.179 408.258 113.999 406.437 113.999 404.18C113.999 401.922 112.179 400.102 109.921 400.102Z"
            fill="white"
          />
          <path
            d="M102.062 389.258C99.804 389.258 97.9707 391.091 97.9707 393.336C97.9707 395.581 99.804 397.427 102.062 397.427C104.319 397.427 106.14 395.594 106.14 393.336C106.14 391.078 104.307 389.258 102.062 389.258Z"
            fill="white"
          />
          <path
            d="M94.4572 377.664C92.1995 377.664 90.3662 379.497 90.3662 381.755C90.3662 384.013 92.1995 385.846 94.4572 385.846C96.7149 385.846 98.5482 384.013 98.5482 381.755C98.5482 379.497 96.7149 377.664 94.4572 377.664Z"
            fill="white"
          />
          <path
            d="M87.0565 365.748C84.7861 365.748 82.957 367.581 82.957 369.839C82.957 372.097 84.7903 373.93 87.0565 373.93C89.3227 373.93 91.1475 372.097 91.1475 369.839C91.1475 367.581 89.3142 365.748 87.0565 365.748Z"
            fill="white"
          />
          <path
            d="M79.7277 362.291C81.9871 362.291 83.8187 360.46 83.8187 358.2C83.8187 355.941 81.9871 354.109 79.7277 354.109C77.4683 354.109 75.6367 355.941 75.6367 358.2C75.6367 360.46 77.4683 362.291 79.7277 362.291Z"
            fill="white"
          />
          <path
            d="M86.462 341.035C84.2128 341.035 82.3838 342.856 82.3838 345.105C82.3838 347.354 84.2171 349.183 86.462 349.183C88.707 349.183 90.5403 347.363 90.5403 345.105C90.5403 342.847 88.707 341.035 86.462 341.035Z"
            fill="white"
          />
          <path
            d="M93.3754 327.205C91.1389 327.205 89.3184 329.026 89.3184 331.275C89.3184 333.524 91.1389 335.332 93.3754 335.332C95.6118 335.332 97.4451 333.511 97.4451 331.275C97.4451 329.038 95.6246 327.205 93.3754 327.205Z"
            fill="white"
          />
          <path
            d="M100.47 312.789C98.2337 312.789 96.4131 314.601 96.4131 316.846C96.4131 319.091 98.2337 320.907 100.47 320.907C102.707 320.907 104.527 319.087 104.527 316.846C104.527 314.605 102.715 312.789 100.47 312.789Z"
            fill="white"
          />
          <path
            d="M107.842 297.949C105.605 297.949 103.793 299.761 103.793 301.998C103.793 304.234 105.605 306.046 107.842 306.046C110.078 306.046 111.89 304.234 111.89 301.998C111.89 299.761 110.078 297.949 107.842 297.949Z"
            fill="white"
          />
          <path
            d="M115.447 283.117C113.219 283.117 111.42 284.929 111.42 287.157C111.42 289.385 113.219 291.185 115.447 291.185C117.675 291.185 119.487 289.385 119.487 287.157C119.487 284.929 117.675 283.117 115.447 283.117Z"
            fill="white"
          />
          <path
            d="M127.011 274.236C127.86 272.185 126.886 269.835 124.836 268.985C122.785 268.136 120.434 269.11 119.585 271.16C118.735 273.211 119.709 275.562 121.76 276.411C123.81 277.26 126.161 276.287 127.011 274.236Z"
            fill="white"
          />
          <path
            d="M131.238 255.027C129.031 255.027 127.253 256.818 127.253 259.012C127.253 261.206 129.031 263.01 131.238 263.01C133.445 263.01 135.235 261.219 135.235 259.012C135.235 256.805 133.445 255.027 131.238 255.027Z"
            fill="white"
          />
          <path
            d="M139.157 242.316C136.963 242.316 135.181 244.095 135.181 246.28C135.181 248.466 136.959 250.256 139.157 250.256C141.355 250.256 143.133 248.478 143.133 246.28C143.133 244.082 141.355 242.316 139.157 242.316Z"
            fill="white"
          />
          <path
            d="M146.758 230.889C144.581 230.889 142.815 232.658 142.815 234.831C142.815 237.004 144.585 238.774 146.758 238.774C148.931 238.774 150.713 237.004 150.713 234.831C150.713 232.658 148.943 230.889 146.758 230.889Z"
            fill="white"
          />
          <path
            d="M153.904 220.67C151.74 220.67 149.979 222.431 149.979 224.604C149.979 226.777 151.735 228.529 153.904 228.529C156.073 228.529 157.829 226.768 157.829 224.604C157.829 222.44 156.073 220.67 153.904 220.67Z"
            fill="white"
          />
          <path
            d="M160.516 211.594C158.36 211.594 156.611 213.342 156.611 215.498C156.611 217.654 158.36 219.402 160.516 219.402C162.671 219.402 164.42 217.654 164.42 215.498C164.42 213.342 162.671 211.594 160.516 211.594Z"
            fill="white"
          />
          <path
            d="M166.584 203.682C164.45 203.682 162.714 205.422 162.714 207.552C162.714 209.682 164.45 211.422 166.584 211.422C168.719 211.422 170.454 209.695 170.454 207.552C170.454 205.409 168.727 203.682 166.584 203.682Z"
            fill="white"
          />
          <path
            d="M172.131 197.143C170.017 197.143 168.29 198.866 168.29 200.979C168.29 203.092 170.017 204.82 172.131 204.82C174.244 204.82 175.971 203.101 175.971 200.979C175.971 198.857 174.253 197.143 172.131 197.143Z"
            fill="white"
          />
          <path
            d="M177.126 191.859C175.026 191.859 173.328 193.557 173.328 195.658C173.328 197.758 175.026 199.468 177.126 199.468C179.227 199.468 180.937 197.762 180.937 195.658C180.937 193.553 179.231 191.859 177.126 191.859Z"
            fill="white"
          />
          <path
            d="M181.602 187.457C179.523 187.457 177.825 189.155 177.825 191.234C177.825 193.313 179.523 195.011 181.602 195.011C183.682 195.011 185.379 193.326 185.379 191.234C185.379 189.142 183.694 187.457 181.602 187.457Z"
            fill="white"
          />
          <path
            d="M185.574 183.672C183.503 183.672 181.827 185.352 181.827 187.415C181.827 189.477 183.503 191.162 185.574 191.162C187.645 191.162 189.322 189.486 189.322 187.415C189.322 185.344 187.645 183.672 185.574 183.672Z"
            fill="white"
          />
          <path
            d="M189.093 180.318C187.052 180.318 185.409 181.969 185.409 184.002C185.409 186.035 187.056 187.686 189.093 187.686C191.13 187.686 192.776 186.035 192.776 184.002C192.776 181.969 191.121 180.318 189.093 180.318Z"
            fill="white"
          />
          <path
            d="M192.173 177.154C190.166 177.154 188.52 178.788 188.52 180.808C188.52 182.828 190.166 184.462 192.173 184.462C194.181 184.462 195.827 182.828 195.827 180.808C195.827 178.788 194.193 177.154 192.173 177.154Z"
            fill="white"
          />
          <path
            d="M194.852 174.082C192.866 174.082 191.249 175.699 191.249 177.693C191.249 179.688 192.862 181.301 194.852 181.301C196.842 181.301 198.463 179.684 198.463 177.693C198.463 175.703 196.851 174.082 194.852 174.082Z"
            fill="white"
          />
          <path
            d="M197.11 171.053C195.132 171.053 193.528 172.648 193.528 174.626C193.528 176.604 195.132 178.208 197.11 178.208C199.088 178.208 200.692 176.604 200.692 174.626C200.692 172.648 199.088 171.053 197.11 171.053Z"
            fill="white"
          />
          <path
            d="M198.981 168.09C197.046 168.09 195.463 169.66 195.463 171.608C195.463 173.556 197.046 175.122 198.981 175.122C200.916 175.122 202.499 173.543 202.499 171.608C202.499 169.673 200.929 168.09 198.981 168.09Z"
            fill="white"
          />
          <path
            d="M200.522 165.168C198.608 165.168 197.055 166.73 197.055 168.644C197.055 170.558 198.604 172.119 200.522 172.119C202.44 172.119 203.997 170.558 203.997 168.644C203.997 166.73 202.448 165.168 200.522 165.168Z"
            fill="white"
          />
          <path
            d="M201.781 162.322C199.888 162.322 198.356 163.863 198.356 165.747C198.356 167.631 199.888 169.172 201.781 169.172C203.674 169.172 205.206 167.64 205.206 165.747C205.206 163.854 203.674 162.322 201.781 162.322Z"
            fill="white"
          />
          <path
            d="M202.8 159.543C200.937 159.543 199.426 161.054 199.426 162.921C199.426 164.788 200.937 166.299 202.8 166.299C204.663 166.299 206.182 164.788 206.182 162.921C206.182 161.054 204.663 159.543 202.8 159.543Z"
            fill="white"
          />
          <path
            d="M203.624 156.824C201.803 156.824 200.326 158.301 200.326 160.13C200.326 161.959 201.803 163.427 203.624 163.427C205.444 163.427 206.921 161.951 206.921 160.13C206.921 158.31 205.444 156.824 203.624 156.824Z"
            fill="white"
          />
          <path
            d="M204.26 154.068C202.461 154.068 201.001 155.524 201.001 157.328C201.001 159.131 202.457 160.574 204.26 160.574C206.064 160.574 207.507 159.118 207.507 157.328C207.507 155.537 206.06 154.068 204.26 154.068Z"
            fill="white"
          />
          <path
            d="M204.726 151.273C202.957 151.273 201.522 152.708 201.522 154.477C201.522 156.247 202.957 157.69 204.726 157.69C206.496 157.69 207.943 156.251 207.943 154.477C207.943 152.704 206.509 151.273 204.726 151.273Z"
            fill="white"
          />
          <path
            d="M205.062 148.365C203.327 148.365 201.909 149.77 201.909 151.51C201.909 153.25 203.327 154.663 205.062 154.663C206.798 154.663 208.207 153.246 208.207 151.51C208.207 149.774 206.802 148.365 205.062 148.365Z"
            fill="white"
          />
          <path
            d="M205.271 145.285C203.586 145.285 202.211 146.66 202.211 148.345C202.211 150.03 203.586 151.417 205.271 151.417C206.955 151.417 208.343 150.042 208.343 148.345C208.343 146.647 206.968 145.285 205.271 145.285Z"
            fill="white"
          />
          <path
            d="M205.437 141.881C203.773 141.881 202.428 143.222 202.428 144.877C202.428 146.532 203.769 147.886 205.437 147.886C207.104 147.886 208.445 146.545 208.445 144.877C208.445 143.209 207.092 141.881 205.437 141.881Z"
            fill="white"
          />
          <path
            d="M205.631 138.053C204.01 138.053 202.686 139.373 202.686 140.998C202.686 142.623 204.01 143.947 205.631 143.947C207.252 143.947 208.576 142.632 208.576 140.998C208.576 139.364 207.265 138.053 205.631 138.053Z"
            fill="white"
          />
          <path
            d="M206.016 133.66C204.425 133.66 203.135 134.95 203.135 136.542C203.135 138.133 204.425 139.423 206.016 139.423C207.608 139.423 208.889 138.133 208.889 136.542C208.889 134.95 207.599 133.66 206.016 133.66Z"
            fill="white"
          />
          <path
            d="M206.798 128.494C205.249 128.494 203.997 129.755 203.997 131.304C203.997 132.852 205.245 134.109 206.798 134.109C208.351 134.109 209.607 132.857 209.607 131.304C209.607 129.75 208.347 128.494 206.798 128.494Z"
            fill="white"
          />
          <path
            d="M208.381 122.211C206.87 122.211 205.644 123.437 205.644 124.948C205.644 126.459 206.87 127.685 208.381 127.685C209.892 127.685 211.118 126.459 211.118 124.948C211.118 123.437 209.892 122.211 208.381 122.211Z"
            fill="white"
          />
          <path
            d="M211.491 114.186C210.014 114.186 208.826 115.382 208.826 116.851C208.826 118.319 210.014 119.52 211.491 119.52C212.968 119.52 214.156 118.327 214.156 116.851C214.156 115.374 212.96 114.186 211.491 114.186Z"
            fill="white"
          />
          <path
            d="M217.165 103.582C215.731 103.582 214.563 104.753 214.563 106.196C214.563 107.639 215.731 108.798 217.165 108.798C218.599 108.798 219.766 107.631 219.766 106.196C219.766 104.762 218.599 103.582 217.165 103.582Z"
            fill="white"
          />
          <path
            d="M227.011 88.9922C225.628 88.9922 224.503 90.1168 224.503 91.5087C224.503 92.9007 225.628 94.0295 227.011 94.0295C228.394 94.0295 229.528 92.8964 229.528 91.5087C229.528 90.121 228.403 88.9922 227.011 88.9922Z"
            fill="white"
          />
          <path
            d="M245.527 84.2422C244.143 84.2422 243.006 85.3668 243.006 86.7502C243.006 88.1337 244.139 89.271 245.527 89.271C246.914 89.271 248.043 88.1464 248.043 86.7502C248.043 85.3541 246.919 84.2422 245.527 84.2422Z"
            fill="white"
          />
          <path
            d="M267.611 74.9277C266.214 74.9277 265.09 76.0523 265.09 77.44C265.09 78.8277 266.214 79.9481 267.611 79.9481C269.007 79.9481 270.119 78.8235 270.119 77.44C270.119 76.0566 268.994 74.9277 267.611 74.9277Z"
            fill="white"
          />
          <path
            d="M293.363 59.7598C291.966 59.7598 290.854 60.8801 290.854 62.2678C290.854 63.6555 291.966 64.7759 293.363 64.7759C294.759 64.7759 295.871 63.6513 295.871 62.2678C295.871 60.8844 294.746 59.7598 293.363 59.7598Z"
            fill="white"
          />
          <path
            d="M321.888 38.0742C320.504 38.0742 319.38 39.1988 319.38 40.5823C319.38 41.9657 320.504 43.0903 321.888 43.0903C323.271 43.0903 324.404 41.9657 324.404 40.5823C324.404 39.1988 323.28 38.0742 321.888 38.0742Z"
            fill="white"
          />
          <path
            d="M350.685 11.9336C349.302 11.9336 348.169 13.0624 348.169 14.4459C348.169 15.8294 349.302 16.9624 350.685 16.9624C352.069 16.9624 353.206 15.8378 353.206 14.4459C353.206 13.0539 352.082 11.9336 350.685 11.9336Z"
            fill="white"
          />
          <path
            d="M883.061 3.85352C881.334 3.85352 879.938 5.24971 879.938 6.97692C879.938 8.70412 881.334 10.0961 883.061 10.0961C884.788 10.0961 886.172 8.69563 886.172 6.97692C886.172 5.2582 884.775 3.85352 883.061 3.85352Z"
            fill="white"
          />
          <path
            d="M890.233 15.0938C888.476 15.0938 887.05 16.5196 887.05 18.2766C887.05 20.0335 888.476 21.4636 890.233 21.4636C891.99 21.4636 893.42 20.0377 893.42 18.2766C893.42 16.5154 891.994 15.0938 890.233 15.0938Z"
            fill="white"
          />
          <path
            d="M897.24 26.6934C895.462 26.6934 894.015 28.1405 894.015 29.9271C894.015 31.7137 895.462 33.1651 897.24 33.1651C899.018 33.1651 900.478 31.7137 900.478 29.9271C900.478 28.1405 899.031 26.6934 897.24 26.6934Z"
            fill="white"
          />
          <path
            d="M904.033 38.6348C902.199 38.6348 900.714 40.1243 900.714 41.9534C900.714 43.7824 902.203 45.272 904.033 45.272C905.862 45.272 907.351 43.7824 907.351 41.9534C907.351 40.1243 905.862 38.6348 904.033 38.6348Z"
            fill="white"
          />
          <path
            d="M910.633 50.959C908.77 50.959 907.259 52.4698 907.259 54.3328C907.259 56.1958 908.77 57.7065 910.633 57.7065C912.496 57.7065 913.994 56.1958 913.994 54.3328C913.994 52.4698 912.483 50.959 910.633 50.959Z"
            fill="white"
          />
          <path
            d="M917.031 63.5898C915.147 63.5898 913.619 65.1218 913.619 67.0103C913.619 68.8988 915.151 70.4223 917.031 70.4223C918.911 70.4223 920.456 68.8903 920.456 67.0103C920.456 65.1303 918.924 63.5898 917.031 63.5898Z"
            fill="white"
          />
          <path
            d="M923.286 76.4609C921.373 76.4609 919.819 78.0099 919.819 79.9281C919.819 81.8463 921.368 83.3952 923.286 83.3952C925.205 83.3952 926.754 81.8378 926.754 79.9281C926.754 78.0184 925.2 76.4609 923.286 76.4609Z"
            fill="white"
          />
          <path
            d="M929.441 89.4648C927.493 89.4648 925.901 91.0478 925.901 93.0041C925.901 94.9605 927.493 96.5434 929.441 96.5434C931.388 96.5434 932.98 94.9563 932.98 93.0041C932.98 91.052 931.397 89.4648 929.441 89.4648Z"
            fill="white"
          />
          <path
            d="M935.506 102.684C933.528 102.684 931.924 104.292 931.924 106.27C931.924 108.247 933.528 109.856 935.506 109.856C937.483 109.856 939.087 108.251 939.087 106.27C939.087 104.288 937.483 102.684 935.506 102.684Z"
            fill="white"
          />
          <path
            d="M941.514 116.113C939.506 116.113 937.881 117.739 937.881 119.742C937.881 121.745 939.502 123.37 941.514 123.37C943.525 123.37 945.133 121.749 945.133 119.742C945.133 117.734 943.508 116.113 941.514 116.113Z"
            fill="white"
          />
          <path
            d="M947.498 129.705C945.47 129.705 943.823 131.352 943.823 133.38C943.823 135.409 945.47 137.055 947.498 137.055C949.527 137.055 951.173 135.409 951.173 133.38C951.173 131.352 949.527 129.705 947.498 129.705Z"
            fill="white"
          />
          <path
            d="M953.524 143.422C951.474 143.422 949.798 145.085 949.798 147.148C949.798 149.21 951.474 150.874 953.524 150.874C955.574 150.874 957.25 149.202 957.25 147.148C957.25 145.094 955.586 143.422 953.524 143.422Z"
            fill="white"
          />
          <path
            d="M959.685 157.15C957.602 157.15 955.917 158.835 955.917 160.919C955.917 163.003 957.602 164.683 959.685 164.683C961.769 164.683 963.454 162.998 963.454 160.919C963.454 158.839 961.769 157.15 959.685 157.15Z"
            fill="white"
          />
          <path
            d="M966.055 170.76C963.954 170.76 962.244 172.462 962.244 174.562C962.244 176.663 963.95 178.36 966.055 178.36C968.16 178.36 969.853 176.663 969.853 174.562C969.853 172.462 968.156 170.76 966.055 170.76Z"
            fill="white"
          />
          <path
            d="M972.706 184.076C970.584 184.076 968.856 185.795 968.856 187.917C968.856 190.039 970.584 191.762 972.706 191.762C974.827 191.762 976.546 190.039 976.546 187.917C976.546 185.795 974.819 184.076 972.706 184.076Z"
            fill="white"
          />
          <path
            d="M979.699 196.904C977.543 196.904 975.808 198.648 975.808 200.804C975.808 202.96 977.548 204.687 979.699 204.687C981.851 204.687 983.591 202.947 983.591 200.804C983.591 198.661 981.842 196.904 979.699 196.904Z"
            fill="white"
          />
          <path
            d="M987.101 209.127C984.937 209.127 983.176 210.875 983.176 213.052C983.176 215.229 984.933 216.965 987.101 216.965C989.27 216.965 991.027 215.217 991.027 213.052C991.027 210.888 989.266 209.127 987.101 209.127Z"
            fill="white"
          />
          <path
            d="M994.968 220.555C992.782 220.555 991.013 222.324 991.013 224.51C991.013 226.695 992.782 228.452 994.968 228.452C997.153 228.452 998.915 226.695 998.915 224.51C998.915 222.324 997.145 220.555 994.968 220.555Z"
            fill="white"
          />
          <path
            d="M1003.3 230.975C1001.1 230.975 999.318 232.753 999.318 234.959C999.318 237.166 1001.1 238.944 1003.3 238.944C1005.51 238.944 1007.29 237.153 1007.29 234.959C1007.29 232.765 1005.5 230.975 1003.3 230.975Z"
            fill="white"
          />
          <path
            d="M1012.08 240.205C1009.87 240.205 1008.06 242.004 1008.06 244.224C1008.06 246.443 1009.86 248.251 1012.08 248.251C1014.3 248.251 1016.11 246.452 1016.11 244.224C1016.11 241.996 1014.31 240.205 1012.08 240.205Z"
            fill="white"
          />
          <path
            d="M1021.22 248.229C1018.99 248.229 1017.17 250.041 1017.17 252.277C1017.17 254.513 1018.99 256.326 1021.22 256.326C1023.44 256.326 1025.26 254.505 1025.26 252.277C1025.26 250.049 1023.45 248.229 1021.22 248.229Z"
            fill="white"
          />
          <path
            d="M1030.6 255.088C1028.35 255.088 1026.53 256.908 1026.53 259.158C1026.53 261.407 1028.35 263.227 1030.6 263.227C1032.85 263.227 1034.67 261.407 1034.67 259.158C1034.67 256.908 1032.84 255.088 1030.6 255.088Z"
            fill="white"
          />
          <path
            d="M1040.1 260.918C1037.85 260.918 1036.01 262.751 1036.01 265.017C1036.01 267.284 1037.85 269.108 1040.1 269.108C1042.36 269.108 1044.2 267.275 1044.2 265.017C1044.2 262.76 1042.37 260.918 1040.1 260.918Z"
            fill="white"
          />
          <path
            d="M1049.67 265.842C1047.39 265.842 1045.55 267.684 1045.55 269.962C1045.55 272.241 1047.39 274.096 1049.67 274.096C1051.95 274.096 1053.8 272.241 1053.8 269.962C1053.8 267.684 1051.95 265.842 1049.67 265.842Z"
            fill="white"
          />
          <path
            d="M1059.24 270.004C1056.94 270.004 1055.09 271.858 1055.09 274.146C1055.09 276.433 1056.95 278.288 1059.24 278.288C1061.52 278.288 1063.37 276.437 1063.37 274.146C1063.37 271.854 1061.51 270.004 1059.24 270.004Z"
            fill="white"
          />
          <path
            d="M1068.75 273.543C1066.46 273.543 1064.6 275.406 1064.6 277.706C1064.6 280.006 1066.46 281.861 1068.75 281.861C1071.04 281.861 1072.91 279.998 1072.91 277.706C1072.91 275.414 1071.05 273.543 1068.75 273.543Z"
            fill="white"
          />
          <path
            d="M1078.22 276.625C1075.92 276.625 1074.07 278.48 1074.07 280.78C1074.07 283.08 1075.92 284.934 1078.22 284.934C1080.52 284.934 1082.38 283.071 1082.38 280.78C1082.38 278.488 1080.51 276.625 1078.22 276.625Z"
            fill="white"
          />
          <path
            d="M1087.62 279.369C1085.33 279.369 1083.46 281.232 1083.46 283.524C1083.46 285.815 1085.33 287.678 1087.62 287.678C1089.91 287.678 1091.77 285.815 1091.77 283.524C1091.77 281.232 1089.92 279.369 1087.62 279.369Z"
            fill="white"
          />
          <path
            d="M1096.97 281.891C1094.68 281.891 1092.82 283.754 1092.82 286.045C1092.82 288.337 1094.68 290.2 1096.97 290.2C1099.27 290.2 1101.13 288.337 1101.13 286.045C1101.13 283.754 1099.27 281.891 1096.97 281.891Z"
            fill="white"
          />
          <path
            d="M1106.29 284.24C1103.99 284.24 1102.14 286.103 1102.14 288.395C1102.14 290.687 1103.99 292.55 1106.29 292.55C1108.59 292.55 1110.44 290.695 1110.44 288.395C1110.44 286.095 1108.58 284.24 1106.29 284.24Z"
            fill="white"
          />
          <path
            d="M1115.56 286.479C1113.27 286.479 1111.41 288.333 1111.41 290.633C1111.41 292.933 1113.27 294.788 1115.56 294.788C1117.86 294.788 1119.72 292.925 1119.72 290.633C1119.72 288.342 1117.86 286.479 1115.56 286.479Z"
            fill="white"
          />
          <path
            d="M1124.8 288.633C1122.5 288.633 1120.63 290.496 1120.63 292.787C1120.63 295.079 1122.5 296.942 1124.8 296.942C1127.1 296.942 1128.95 295.092 1128.95 292.787C1128.95 290.483 1127.09 288.633 1124.8 288.633Z"
            fill="white"
          />
          <path
            d="M1120.07 288.986C1117.77 288.986 1115.92 290.849 1115.92 293.141C1115.92 295.433 1117.77 297.304 1120.07 297.304C1122.37 297.304 1124.23 295.441 1124.23 293.141C1124.23 290.841 1122.36 288.986 1120.07 288.986Z"
            fill="white"
          />
          <path
            d="M1115.1 289.301C1112.8 289.301 1110.94 291.164 1110.94 293.455C1110.94 295.747 1112.8 297.61 1115.1 297.61C1117.39 297.61 1119.25 295.76 1119.25 293.455C1119.25 291.151 1117.4 289.301 1115.1 289.301Z"
            fill="white"
          />
          <path
            d="M1109.88 289.572C1107.59 289.572 1105.73 291.435 1105.73 293.735C1105.73 296.035 1107.59 297.89 1109.88 297.89C1112.17 297.89 1114.03 296.027 1114.03 293.735C1114.03 291.444 1112.17 289.572 1109.88 289.572Z"
            fill="white"
          />
          <path
            d="M1104.42 289.838C1102.13 289.838 1100.26 291.688 1100.26 293.993C1100.26 296.297 1102.13 298.147 1104.42 298.147C1106.71 298.147 1108.57 296.284 1108.57 293.993C1108.57 291.701 1106.72 289.838 1104.42 289.838Z"
            fill="white"
          />
          <path
            d="M1098.7 290.111C1096.4 290.111 1094.55 291.962 1094.55 294.266C1094.55 296.57 1096.4 298.421 1098.7 298.421C1101 298.421 1102.86 296.558 1102.86 294.266C1102.86 291.974 1100.99 290.111 1098.7 290.111Z"
            fill="white"
          />
          <path
            d="M1092.72 290.412C1090.43 290.412 1088.56 292.267 1088.56 294.567C1088.56 296.867 1090.43 298.721 1092.72 298.721C1095.01 298.721 1096.87 296.858 1096.87 294.567C1096.87 292.275 1095.01 290.412 1092.72 290.412Z"
            fill="white"
          />
          <path
            d="M1086.46 290.77C1084.17 290.77 1082.31 292.624 1082.31 294.924C1082.31 297.224 1084.17 299.079 1086.46 299.079C1088.76 299.079 1090.62 297.216 1090.62 294.924C1090.62 292.633 1088.76 290.77 1086.46 290.77Z"
            fill="white"
          />
          <path
            d="M1079.93 291.205C1077.64 291.205 1075.77 293.06 1075.77 295.36C1075.77 297.66 1077.64 299.514 1079.93 299.514C1082.22 299.514 1084.08 297.651 1084.08 295.36C1084.08 293.068 1082.23 291.205 1079.93 291.205Z"
            fill="white"
          />
          <path
            d="M1073.11 291.744C1070.82 291.744 1068.96 293.607 1068.96 295.899C1068.96 298.19 1070.82 300.053 1073.11 300.053C1075.4 300.053 1077.26 298.19 1077.26 295.899C1077.26 293.607 1075.4 291.744 1073.11 291.744Z"
            fill="white"
          />
          <path
            d="M1066.01 292.412C1063.71 292.412 1061.86 294.275 1061.86 296.567C1061.86 298.858 1063.71 300.721 1066.01 300.721C1068.32 300.721 1070.17 298.867 1070.17 296.567C1070.17 294.267 1068.3 292.412 1066.01 292.412Z"
            fill="white"
          />
          <path
            d="M1058.62 293.205C1056.33 293.205 1054.47 295.06 1054.47 297.36C1054.47 299.66 1056.33 301.514 1058.62 301.514C1060.91 301.514 1062.78 299.651 1062.78 297.36C1062.78 295.068 1060.91 293.205 1058.62 293.205Z"
            fill="white"
          />
          <path
            d="M1050.96 294.16C1048.68 294.16 1046.84 296.002 1046.84 298.281C1046.84 300.56 1048.68 302.402 1050.96 302.402C1053.24 302.402 1055.08 300.56 1055.08 298.281C1055.08 296.002 1053.24 294.16 1050.96 294.16Z"
            fill="white"
          />
          <path
            d="M1043.03 295.275C1040.78 295.275 1038.93 297.117 1038.93 299.388C1038.93 301.658 1040.78 303.487 1043.03 303.487C1045.29 303.487 1047.15 301.645 1047.15 299.388C1047.15 297.13 1045.3 295.275 1043.03 295.275Z"
            fill="white"
          />
          <path
            d="M1034.86 296.596C1032.6 296.596 1030.78 298.429 1030.78 300.674C1030.78 302.919 1032.6 304.765 1034.86 304.765C1037.12 304.765 1038.94 302.932 1038.94 300.674C1038.94 298.416 1037.12 296.596 1034.86 296.596Z"
            fill="white"
          />
          <path
            d="M1026.46 298.137C1024.21 298.137 1022.39 299.957 1022.39 302.206C1022.39 304.456 1024.21 306.263 1026.46 306.263C1028.71 306.263 1030.52 304.451 1030.52 302.206C1030.52 299.962 1028.7 298.137 1026.46 298.137Z"
            fill="white"
          />
          <path
            d="M1017.84 299.947C1015.61 299.947 1013.81 301.747 1013.81 303.966C1013.81 306.186 1015.61 307.993 1017.84 307.993C1020.07 307.993 1021.87 306.194 1021.87 303.966C1021.87 301.738 1020.07 299.947 1017.84 299.947Z"
            fill="white"
          />
          <path
            d="M1009.04 301.891C1006.83 301.891 1005.03 303.681 1005.03 305.897C1005.03 308.112 1006.83 309.903 1009.04 309.903C1011.26 309.903 1013.05 308.103 1013.05 305.897C1013.05 303.69 1011.25 301.891 1009.04 301.891Z"
            fill="white"
          />
          <path
            d="M1000.06 304.039C997.862 304.039 996.071 305.817 996.071 308.015C996.071 310.214 997.862 311.992 1000.06 311.992C1002.25 311.992 1004.03 310.214 1004.03 308.015C1004.03 305.817 1002.25 304.039 1000.06 304.039Z"
            fill="white"
          />
          <path
            d="M990.887 306.398C988.71 306.398 986.944 308.168 986.944 310.354C986.944 312.539 988.714 314.296 990.887 314.296C993.06 314.296 994.842 312.526 994.842 310.354C994.842 308.181 993.072 306.398 990.887 306.398Z"
            fill="white"
          />
          <path
            d="M981.562 309.055C979.407 309.055 977.658 310.803 977.658 312.959C977.658 315.115 979.407 316.863 981.562 316.863C983.718 316.863 985.467 315.115 985.467 312.959C985.467 310.803 983.718 309.055 981.562 309.055Z"
            fill="white"
          />
          <path
            d="M972.103 311.988C969.968 311.988 968.232 313.728 968.232 315.859C968.232 317.989 969.968 319.729 972.103 319.729C974.237 319.729 975.973 317.989 975.973 315.859C975.973 313.728 974.246 311.988 972.103 311.988Z"
            fill="white"
          />
          <path
            d="M962.525 315.268C960.403 315.268 958.685 316.986 958.685 319.108C958.685 321.23 960.403 322.936 962.525 322.936C964.647 322.936 966.366 321.217 966.366 319.108C966.366 316.999 964.647 315.268 962.525 315.268Z"
            fill="white"
          />
          <path
            d="M952.844 318.93C950.752 318.93 949.055 320.636 949.055 322.728C949.055 324.82 950.752 326.526 952.844 326.526C954.936 326.526 956.642 324.828 956.642 322.728C956.642 320.627 954.945 318.93 952.844 318.93Z"
            fill="white"
          />
          <path
            d="M943.114 323.041C941.035 323.041 939.358 324.726 939.358 326.797C939.358 328.868 941.035 330.544 943.114 330.544C945.194 330.544 946.861 328.868 946.861 326.797C946.861 324.726 945.185 323.041 943.114 323.041Z"
            fill="white"
          />
          <path
            d="M933.323 327.633C931.282 327.633 929.618 329.296 929.618 331.338C929.618 333.379 931.282 335.042 933.323 335.042C935.364 335.042 937.028 333.387 937.028 331.338C937.028 329.288 935.373 327.633 933.323 327.633Z"
            fill="white"
          />
          <path
            d="M923.537 332.73C921.509 332.73 919.862 334.377 919.862 336.406C919.862 338.434 921.509 340.081 923.537 340.081C925.566 340.081 927.212 338.434 927.212 336.406C927.212 334.377 925.566 332.73 923.537 332.73Z"
            fill="white"
          />
          <path
            d="M913.776 338.404C911.769 338.404 910.144 340.025 910.144 342.024C910.144 344.023 911.769 345.657 913.776 345.657C915.784 345.657 917.396 344.032 917.396 342.024C917.396 340.017 915.771 338.404 913.776 338.404Z"
            fill="white"
          />
          <path
            d="M904.067 344.682C902.09 344.682 900.498 346.286 900.498 348.251C900.498 350.215 902.09 351.82 904.067 351.82C906.045 351.82 907.636 350.228 907.636 348.251C907.636 346.273 906.032 344.682 904.067 344.682Z"
            fill="white"
          />
          <path
            d="M894.438 351.633C892.49 351.633 890.92 353.216 890.92 355.159C890.92 357.103 892.49 358.686 894.438 358.686C896.386 358.686 897.964 357.103 897.964 355.159C897.964 353.216 896.382 351.633 894.438 351.633Z"
            fill="white"
          />
          <path
            d="M884.881 359.271C882.967 359.271 881.405 360.82 881.405 362.747C881.405 364.674 882.967 366.223 884.881 366.223C886.795 366.223 888.369 364.661 888.369 362.747C888.369 360.833 886.808 359.271 884.881 359.271Z"
            fill="white"
          />
          <path
            d="M875.452 367.66C873.559 367.66 872.019 369.201 872.019 371.093C872.019 372.986 873.559 374.518 875.452 374.518C877.344 374.518 878.885 372.986 878.885 371.093C878.885 369.201 877.344 367.66 875.452 367.66Z"
            fill="white"
          />
          <path
            d="M866.2 376.957C864.345 376.957 862.839 378.455 862.839 380.31C862.839 382.164 864.35 383.671 866.2 383.671C868.05 383.671 869.553 382.16 869.553 380.31C869.553 378.459 868.054 376.957 866.2 376.957Z"
            fill="white"
          />
          <path
            d="M857.073 387.08C855.252 387.08 853.775 388.557 853.775 390.382C853.775 392.207 855.252 393.692 857.073 393.692C858.893 393.692 860.37 392.215 860.37 390.382C860.37 388.548 858.893 387.08 857.073 387.08Z"
            fill="white"
          />
          <path
            d="M848.194 398.301C846.394 398.301 844.935 399.756 844.935 401.547C844.935 403.338 846.39 404.806 848.194 404.806C849.997 404.806 851.44 403.351 851.44 401.547C851.44 399.744 849.985 398.301 848.194 398.301Z"
            fill="white"
          />
          <path
            d="M839.744 411.02C837.975 411.02 836.549 412.445 836.549 414.215C836.549 415.985 837.975 417.402 839.744 417.402C841.514 417.402 842.94 415.976 842.94 414.215C842.94 412.454 841.506 411.02 839.744 411.02Z"
            fill="white"
          />
          <path
            d="M832.051 425.809C830.332 425.809 828.928 427.213 828.928 428.932C828.928 430.651 830.332 432.043 832.051 432.043C833.77 432.043 835.162 430.646 835.162 428.932C835.162 427.218 833.766 425.809 832.051 425.809Z"
            fill="white"
          />
          <path
            d="M829.908 455.035C828.245 455.035 826.899 456.389 826.899 458.052C826.899 459.716 828.24 461.061 829.908 461.061C831.576 461.061 832.917 459.708 832.917 458.052C832.917 456.397 831.576 455.035 829.908 455.035Z"
            fill="white"
          />
          <path
            d="M821.272 464.453C819.616 464.453 818.275 465.794 818.275 467.449C818.275 469.104 819.616 470.445 821.272 470.445C822.927 470.445 824.268 469.104 824.268 467.449C824.268 465.794 822.927 464.453 821.272 464.453Z"
            fill="white"
          />
          <path
            d="M812.694 474.539C811.039 474.539 809.698 475.88 809.698 477.535C809.698 479.19 811.039 480.523 812.694 480.523C814.349 480.523 815.682 479.182 815.682 477.535C815.682 475.889 814.349 474.539 812.694 474.539Z"
            fill="white"
          />
          <path
            d="M804.003 484.945C802.357 484.945 801.016 486.286 801.016 487.933C801.016 489.58 802.357 490.929 804.003 490.929C805.65 490.929 806.999 489.588 806.999 487.933C806.999 486.278 805.658 484.945 804.003 484.945Z"
            fill="white"
          />
          <path
            d="M795.105 495.586C793.458 495.586 792.117 496.927 792.117 498.574C792.117 500.22 793.458 501.561 795.105 501.561C796.751 501.561 798.092 500.229 798.092 498.574C798.092 496.918 796.76 495.586 795.105 495.586Z"
            fill="white"
          />
          <path
            d="M786.162 506.564C784.507 506.564 783.175 507.897 783.175 509.552C783.175 511.207 784.507 512.527 786.162 512.527C787.817 512.527 789.137 511.194 789.137 509.552C789.137 507.91 787.805 506.564 786.162 506.564Z"
            fill="white"
          />
          <path
            d="M777.056 517.742C775.409 517.742 774.081 519.075 774.081 520.717C774.081 522.359 775.414 523.692 777.056 523.692C778.698 523.692 780.031 522.359 780.031 520.717C780.031 519.075 778.698 517.742 777.056 517.742Z"
            fill="white"
          />
          <path
            d="M767.648 528.783C766.001 528.783 764.673 530.116 764.673 531.758C764.673 533.4 766.005 534.733 767.648 534.733C769.29 534.733 770.614 533.4 770.614 531.758C770.614 530.116 769.282 528.783 767.648 528.783Z"
            fill="white"
          />
          <path
            d="M757.814 539.516C756.18 539.516 754.848 540.835 754.848 542.474C754.848 544.112 756.18 545.44 757.814 545.44C759.448 545.44 760.772 544.12 760.772 542.474C760.772 540.827 759.452 539.516 757.814 539.516Z"
            fill="white"
          />
          <path
            d="M747.469 549.756C745.835 549.756 744.503 551.076 744.503 552.714C744.503 554.352 745.835 555.667 747.469 555.667C749.103 555.667 750.427 554.348 750.427 552.714C750.427 551.08 749.095 549.756 747.469 549.756Z"
            fill="white"
          />
          <path
            d="M736.499 559.115C734.865 559.115 733.545 560.448 733.545 562.073C733.545 563.698 734.865 565.031 736.499 565.031C738.132 565.031 739.456 563.711 739.456 562.073C739.456 560.435 738.137 559.115 736.499 559.115Z"
            fill="white"
          />
          <path
            d="M724.956 567.48C723.331 567.48 722.011 568.805 722.011 570.438C722.011 572.072 723.331 573.384 724.956 573.384C726.581 573.384 727.914 572.059 727.914 570.438C727.914 568.817 726.594 567.48 724.956 567.48Z"
            fill="white"
          />
          <path
            d="M712.903 574.791C711.278 574.791 709.958 576.115 709.958 577.736C709.958 579.357 711.278 580.681 712.903 580.681C714.529 580.681 715.848 579.37 715.848 577.736C715.848 576.102 714.537 574.791 712.903 574.791Z"
            fill="white"
          />
          <path
            d="M700.392 580.969C698.771 580.969 697.447 582.28 697.447 583.914C697.447 585.548 698.771 586.851 700.392 586.851C702.014 586.851 703.338 585.539 703.338 583.914C703.338 582.289 702.014 580.969 700.392 580.969Z"
            fill="white"
          />
          <path
            d="M687.496 585.977C685.871 585.977 684.551 587.288 684.551 588.913C684.551 590.539 685.871 591.85 687.496 591.85C689.121 591.85 690.433 590.539 690.433 588.913C690.433 587.288 689.113 585.977 687.496 585.977Z"
            fill="white"
          />
          <path
            d="M674.322 589.91C672.697 589.91 671.386 591.234 671.386 592.847C671.386 594.459 672.697 595.784 674.322 595.784C675.948 595.784 677.246 594.472 677.246 592.847C677.246 591.221 675.935 589.91 674.322 589.91Z"
            fill="white"
          />
          <path
            d="M660.926 593.012C659.301 593.012 657.989 594.323 657.989 595.936C657.989 597.548 659.301 598.872 660.926 598.872C662.551 598.872 663.85 597.561 663.85 595.936C663.85 594.31 662.539 593.012 660.926 593.012Z"
            fill="white"
          />
          <path
            d="M647.324 595.248C645.699 595.248 644.4 596.559 644.4 598.172C644.4 599.785 645.703 601.096 647.324 601.096C648.945 601.096 650.24 599.785 650.24 598.172C650.24 596.559 648.937 595.248 647.324 595.248Z"
            fill="white"
          />
          <path
            d="M633.575 596.873C631.963 596.873 630.651 598.176 630.651 599.789C630.651 601.401 631.963 602.712 633.575 602.712C635.188 602.712 636.491 601.401 636.491 599.789C636.491 598.176 635.179 596.873 633.575 596.873Z"
            fill="white"
          />
          <path
            d="M619.702 598.113C618.097 598.113 616.786 599.416 616.786 601.029C616.786 602.641 618.097 603.944 619.702 603.944C621.306 603.944 622.617 602.641 622.617 601.029C622.617 599.416 621.314 598.113 619.702 598.113Z"
            fill="white"
          />
          <path
            d="M605.765 599.289C604.161 599.289 602.862 600.6 602.862 602.205C602.862 603.809 604.165 605.12 605.765 605.12C607.365 605.12 608.681 603.809 608.681 602.205C608.681 600.6 607.378 599.289 605.765 599.289Z"
            fill="white"
          />
          <path
            d="M591.859 600.652C590.246 600.652 588.943 601.964 588.943 603.568C588.943 605.172 590.246 606.471 591.859 606.471C593.471 606.471 594.762 605.168 594.762 603.568C594.762 601.968 593.459 600.652 591.859 600.652Z"
            fill="white"
          />
          <path
            d="M578.007 602.285C576.403 602.285 575.104 603.588 575.104 605.188C575.104 606.788 576.407 608.091 578.007 608.091C579.607 608.091 580.923 606.788 580.923 605.188C580.923 603.588 579.62 602.285 578.007 602.285Z"
            fill="white"
          />
          <path
            d="M564.237 604.357C562.633 604.357 561.334 605.66 561.334 607.26C561.334 608.86 562.637 610.163 564.237 610.163C565.837 610.163 567.139 608.86 567.139 607.26C567.139 605.66 565.837 604.357 564.237 604.357Z"
            fill="white"
          />
          <path
            d="M550.579 606.885C548.975 606.885 547.677 608.175 547.677 609.779C547.677 611.383 548.98 612.682 550.579 612.682C552.179 612.682 553.474 611.379 553.474 609.779C553.474 608.179 552.171 606.885 550.579 606.885Z"
            fill="white"
          />
          <path
            d="M536.987 609.551C535.396 609.551 534.093 610.854 534.093 612.445C534.093 614.036 535.396 615.339 536.987 615.339C538.578 615.339 539.881 614.049 539.881 612.445C539.881 610.841 538.591 609.551 536.987 609.551Z"
            fill="white"
          />
          <path
            d="M523.428 612.359C521.824 612.359 520.534 613.662 520.534 615.254C520.534 616.845 521.824 618.156 523.428 618.156C525.033 618.156 526.323 616.854 526.323 615.254C526.323 613.654 525.02 612.359 523.428 612.359Z"
            fill="white"
          />
          <path
            d="M509.866 615.348C508.274 615.348 506.984 616.638 506.984 618.229C506.984 619.821 508.274 621.123 509.866 621.123C511.457 621.123 512.76 619.833 512.76 618.229C512.76 616.625 511.457 615.348 509.866 615.348Z"
            fill="white"
          />
          <path
            d="M496.285 618.229C494.681 618.229 493.391 619.519 493.391 621.11C493.391 622.701 494.681 623.992 496.285 623.992C497.889 623.992 499.166 622.701 499.166 621.11C499.166 619.519 497.876 618.229 496.285 618.229Z"
            fill="white"
          />
          <path
            d="M482.598 620.834C481.007 620.834 479.717 622.124 479.717 623.716C479.717 625.307 481.007 626.61 482.598 626.61C484.19 626.61 485.48 625.307 485.48 623.716C485.48 622.124 484.19 620.834 482.598 620.834Z"
            fill="white"
          />
          <path
            d="M468.756 623.215C467.165 623.215 465.875 624.496 465.875 626.088C465.875 627.679 467.165 628.969 468.756 628.969C470.348 628.969 471.629 627.679 471.629 626.088C471.629 624.496 470.339 623.215 468.756 623.215Z"
            fill="white"
          />
          <path
            d="M454.706 625.215C453.114 625.215 451.824 626.505 451.824 628.088C451.824 629.671 453.114 630.969 454.706 630.969C456.297 630.969 457.579 629.679 457.579 628.088C457.579 626.496 456.289 625.215 454.706 625.215Z"
            fill="white"
          />
          <path
            d="M440.361 626.547C438.778 626.547 437.488 627.828 437.488 629.42C437.488 631.011 438.778 632.301 440.361 632.301C441.944 632.301 443.243 631.011 443.243 629.42C443.243 627.828 441.953 626.547 440.361 626.547Z"
            fill="white"
          />
          <path
            d="M425.614 632.99C427.205 632.99 428.495 631.699 428.495 630.108C428.495 628.517 427.205 627.227 425.614 627.227C424.023 627.227 422.732 628.517 422.732 630.108C422.732 631.699 424.023 632.99 425.614 632.99Z"
            fill="white"
          />
          <path
            d="M410.315 632.956C411.907 632.956 413.197 631.666 413.197 630.075C413.197 628.483 411.907 627.193 410.315 627.193C408.724 627.193 407.434 628.483 407.434 630.075C407.434 631.666 408.724 632.956 410.315 632.956Z"
            fill="white"
          />
          <path
            d="M394.329 626.131C392.738 626.131 391.456 627.421 391.456 629.012C391.456 630.604 392.738 631.885 394.329 631.885C395.92 631.885 397.211 630.595 397.211 629.012C397.211 627.429 395.92 626.131 394.329 626.131Z"
            fill="white"
          />
          <path
            d="M377.541 624.037C375.95 624.037 374.668 625.319 374.668 626.91C374.668 628.502 375.95 629.783 377.541 629.783C379.132 629.783 380.414 628.493 380.414 626.91C380.414 625.327 379.124 624.037 377.541 624.037Z"
            fill="white"
          />
          <path
            d="M359.793 620.906C358.21 620.906 356.92 622.196 356.92 623.788C356.92 625.379 358.21 626.661 359.793 626.661C361.376 626.661 362.674 625.371 362.674 623.788C362.674 622.205 361.384 620.906 359.793 620.906Z"
            fill="white"
          />
          <path
            d="M341.04 616.482C339.448 616.482 338.158 617.764 338.158 619.355C338.158 620.947 339.448 622.237 341.04 622.237C342.631 622.237 343.921 620.947 343.921 619.355C343.921 617.764 342.631 616.482 341.04 616.482Z"
            fill="white"
          />
          <path
            d="M332.965 612.059C331.331 612.059 330.02 613.378 330.02 615.004C330.02 616.629 331.331 617.94 332.965 617.94C334.599 617.94 335.901 616.629 335.901 615.004C335.901 613.378 334.59 612.059 332.965 612.059Z"
            fill="white"
          />
          <path
            d="M325.135 607.658C323.48 607.658 322.139 608.991 322.139 610.646C322.139 612.301 323.48 613.633 325.135 613.633C326.79 613.633 328.122 612.292 328.122 610.646C328.122 608.999 326.781 607.658 325.135 607.658Z"
            fill="white"
          />
          <path
            d="M317.695 603.254C315.998 603.254 314.627 604.629 314.627 606.326C314.627 608.024 316.002 609.407 317.695 609.407C319.388 609.407 320.776 608.032 320.776 606.326C320.776 604.62 319.401 603.254 317.695 603.254Z"
            fill="white"
          />
          <path
            d="M310.731 598.947C309.004 598.947 307.6 600.352 307.6 602.079C307.6 603.806 309.004 605.211 310.731 605.211C312.459 605.211 313.876 603.806 313.876 602.079C313.876 600.352 312.471 598.947 310.731 598.947Z"
            fill="white"
          />
          <path
            d="M304.184 594.689C302.427 594.689 300.997 596.115 300.997 597.877C300.997 599.638 302.423 601.059 304.184 601.059C305.945 601.059 307.38 599.633 307.38 597.877C307.38 596.12 305.945 594.689 304.184 594.689Z"
            fill="white"
          />
          <path
            d="M297.949 590.42C296.158 590.42 294.711 591.867 294.711 593.658C294.711 595.449 296.158 596.904 297.949 596.904C299.74 596.904 301.187 595.449 301.187 593.658C301.187 591.867 299.74 590.42 297.949 590.42Z"
            fill="white"
          />
          <path
            d="M291.915 586.082C290.082 586.082 288.597 587.559 288.597 589.392C288.597 591.225 290.086 592.711 291.915 592.711C293.744 592.711 295.234 591.221 295.234 589.392C295.234 587.563 293.744 586.082 291.915 586.082Z"
            fill="white"
          />
          <path
            d="M285.969 581.648C284.119 581.648 282.608 583.159 282.608 585.022C282.608 586.885 284.119 588.383 285.969 588.383C287.82 588.383 289.343 586.873 289.343 585.022C289.343 583.172 287.832 581.648 285.969 581.648Z"
            fill="white"
          />
          <path
            d="M280.058 577.07C278.186 577.07 276.654 578.59 276.654 580.474C276.654 582.358 278.186 583.877 280.058 583.877C281.929 583.877 283.474 582.358 283.474 580.474C283.474 578.59 281.942 577.07 280.058 577.07Z"
            fill="white"
          />
          <path
            d="M274.108 572.291C272.203 572.291 270.662 573.831 270.662 575.737C270.662 577.642 272.203 579.191 274.108 579.191C276.013 579.191 277.562 577.651 277.562 575.737C277.562 573.823 276.013 572.291 274.108 572.291Z"
            fill="white"
          />
          <path
            d="M268.082 567.262C266.134 567.262 264.563 568.832 264.563 570.78C264.563 572.728 266.134 574.298 268.082 574.298C270.029 574.298 271.6 572.715 271.6 570.78C271.6 568.845 270.017 567.262 268.082 567.262Z"
            fill="white"
          />
          <path
            d="M261.949 561.986C259.984 561.986 258.389 563.578 258.389 565.547C258.389 567.516 259.98 569.107 261.949 569.107C263.918 569.107 265.51 567.516 265.51 565.547C265.51 563.578 263.918 561.986 261.949 561.986Z"
            fill="white"
          />
          <path
            d="M255.724 556.389C253.738 556.389 252.125 558.001 252.125 559.992C252.125 561.982 253.738 563.595 255.724 563.595C257.71 563.595 259.327 561.982 259.327 559.992C259.327 558.001 257.714 556.389 255.724 556.389Z"
            fill="white"
          />
          <path
            d="M249.418 550.443C247.411 550.443 245.785 552.069 245.785 554.076C245.785 556.083 247.411 557.709 249.418 557.709C251.425 557.709 253.05 556.083 253.05 554.076C253.05 552.069 251.425 550.443 249.418 550.443Z"
            fill="white"
          />
          <path
            d="M243.048 544.094C241.007 544.094 239.352 545.749 239.352 547.79C239.352 549.831 241.007 551.486 243.048 551.486C245.089 551.486 246.731 549.831 246.731 547.79C246.731 545.749 245.076 544.094 243.048 544.094Z"
            fill="white"
          />
          <path
            d="M236.628 537.424C234.565 537.424 232.91 539.079 232.91 541.141C232.91 543.204 234.565 544.855 236.628 544.855C238.69 544.855 240.341 543.191 240.341 541.141C240.341 539.092 238.677 537.424 236.628 537.424Z"
            fill="white"
          />
          <path
            d="M230.178 530.379C228.107 530.379 226.422 532.064 226.422 534.135C226.422 536.206 228.107 537.882 230.178 537.882C232.249 537.882 233.925 536.206 233.925 534.135C233.925 532.064 232.249 530.379 230.178 530.379Z"
            fill="white"
          />
          <path
            d="M223.671 523.08C221.579 523.08 219.895 524.765 219.895 526.857C219.895 528.949 221.579 530.647 223.671 530.647C225.764 530.647 227.461 528.949 227.461 526.857C227.461 524.765 225.764 523.08 223.671 523.08Z"
            fill="white"
          />
          <path
            d="M217.102 515.568C214.988 515.568 213.27 517.274 213.27 519.388C213.27 521.501 214.988 523.22 217.102 523.22C219.215 523.22 220.921 521.501 220.921 519.388C220.921 517.274 219.215 515.568 217.102 515.568Z"
            fill="white"
          />
          <path
            d="M210.43 507.93C208.296 507.93 206.568 509.657 206.568 511.779C206.568 513.901 208.296 515.641 210.43 515.641C212.565 515.641 214.279 513.913 214.279 511.779C214.279 509.644 212.552 507.93 210.43 507.93Z"
            fill="white"
          />
          <path
            d="M203.603 500.234C201.46 500.234 199.72 501.974 199.72 504.117C199.72 506.261 201.455 507.988 203.603 507.988C205.75 507.988 207.486 506.248 207.486 504.117C207.486 501.987 205.746 500.234 203.603 500.234Z"
            fill="white"
          />
          <path
            d="M196.557 492.576C194.393 492.576 192.645 494.325 192.645 496.489C192.645 498.653 194.393 500.402 196.557 500.402C198.722 500.402 200.47 498.645 200.47 496.489C200.47 494.333 198.709 492.576 196.557 492.576Z"
            fill="white"
          />
          <path
            d="M189.207 485.021C187.043 485.021 185.273 486.791 185.273 488.968C185.273 491.145 187.043 492.902 189.207 492.902C191.372 492.902 193.15 491.145 193.15 488.968C193.15 486.791 191.38 485.021 189.207 485.021Z"
            fill="white"
          />
          <path
            d="M181.526 477.609C179.341 477.609 177.562 479.388 177.562 481.573C177.562 483.759 179.341 485.537 181.526 485.537C183.712 485.537 185.49 483.767 185.49 481.573C185.49 479.379 183.72 477.609 181.526 477.609Z"
            fill="white"
          />
          <path
            d="M173.493 470.363C171.299 470.363 169.517 472.141 169.517 474.34C169.517 476.538 171.295 478.325 173.493 478.325C175.691 478.325 177.478 476.546 177.478 474.34C177.478 472.133 175.7 470.363 173.493 470.363Z"
            fill="white"
          />
          <path
            d="M165.175 463.205C162.96 463.205 161.169 464.996 161.169 467.211C161.169 469.426 162.96 471.217 165.175 471.217C167.39 471.217 169.181 469.418 169.181 467.211C169.181 465.004 167.382 463.205 165.175 463.205Z"
            fill="white"
          />
          <path
            d="M156.633 456.088C154.418 456.088 152.605 457.887 152.605 460.115C152.605 462.343 154.418 464.143 156.633 464.143C158.848 464.143 160.66 462.33 160.66 460.115C160.66 457.9 158.861 456.088 156.633 456.088Z"
            fill="white"
          />
          <path
            d="M151.676 454.582C152.53 452.521 151.551 450.158 149.49 449.304C147.428 448.45 145.065 449.429 144.211 451.49C143.357 453.552 144.336 455.915 146.398 456.769C148.459 457.623 150.822 456.644 151.676 454.582Z"
            fill="white"
          />
          <path
            d="M140.081 449.876C142.257 449.363 143.604 447.182 143.091 445.006C142.577 442.83 140.397 441.482 138.221 441.996C136.044 442.509 134.697 444.69 135.21 446.866C135.724 449.042 137.904 450.39 140.081 449.876Z"
            fill="white"
          />
          <path
            d="M130.364 434.594C128.127 434.594 126.307 436.414 126.307 438.655C126.307 440.896 128.127 442.712 130.364 442.712C132.6 442.712 134.425 440.9 134.425 438.655C134.425 436.41 132.604 434.594 130.364 434.594Z"
            fill="white"
          />
          <path
            d="M121.609 426.963C119.36 426.963 117.539 428.783 117.539 431.033C117.539 433.282 119.36 435.111 121.609 435.111C123.858 435.111 125.687 433.278 125.687 431.033C125.687 428.788 123.866 426.963 121.609 426.963Z"
            fill="white"
          />
          <path
            d="M112.982 418.807C110.732 418.807 108.903 420.627 108.903 422.885C108.903 425.143 110.737 426.963 112.982 426.963C115.227 426.963 117.073 425.143 117.073 422.885C117.073 420.627 115.239 418.807 112.982 418.807Z"
            fill="white"
          />
          <path
            d="M104.52 409.988C102.262 409.988 100.441 411.822 100.441 414.079C100.441 416.337 102.262 418.157 104.52 418.157C106.777 418.157 108.598 416.324 108.598 414.079C108.598 411.834 106.777 409.988 104.52 409.988Z"
            fill="white"
          />
          <path
            d="M96.2775 400.342C94.0198 400.342 92.1992 402.175 92.1992 404.42C92.1992 406.665 94.0198 408.511 96.2775 408.511C98.5351 408.511 100.356 406.678 100.356 404.42C100.356 402.162 98.5351 400.342 96.2775 400.342Z"
            fill="white"
          />
          <path
            d="M88.3039 389.746C86.0462 389.746 84.2129 391.579 84.2129 393.837C84.2129 396.095 86.0462 397.928 88.3039 397.928C90.5615 397.928 92.3948 396.095 92.3948 393.837C92.3948 391.579 90.5615 389.746 88.3039 389.746Z"
            fill="white"
          />
          <path
            d="M80.6141 378.371C78.3437 378.371 76.5146 380.213 76.5146 382.471C76.5146 384.728 78.3479 386.562 80.6141 386.562C82.8803 386.562 84.7051 384.728 84.7051 382.471C84.7051 380.213 82.8718 378.371 80.6141 378.371Z"
            fill="white"
          />
          <path
            d="M73.1708 366.609C70.9131 366.609 69.0713 368.443 69.0713 370.7C69.0713 372.958 70.9131 374.8 73.1708 374.8C75.4284 374.8 77.2617 372.967 77.2617 370.7C77.2617 368.434 75.4284 366.609 73.1708 366.609Z"
            fill="white"
          />
          <path
            d="M65.8332 355.223C63.5755 355.223 61.7422 357.056 61.7422 359.314C61.7422 361.571 63.5755 363.392 65.8332 363.392C68.0908 363.392 69.9114 361.559 69.9114 359.314C69.9114 357.069 68.0908 355.223 65.8332 355.223Z"
            fill="white"
          />
          <path
            d="M72.4233 343.07C70.1741 343.07 68.3535 344.891 68.3535 347.14C68.3535 349.389 70.1741 351.218 72.4233 351.218C74.6725 351.218 76.5015 349.398 76.5015 347.14C76.5015 344.882 74.6809 343.07 72.4233 343.07Z"
            fill="white"
          />
          <path
            d="M79.1886 330.172C76.9394 330.172 75.1104 331.992 75.1104 334.242C75.1104 336.491 76.9437 338.32 79.1886 338.32C81.4335 338.32 83.2668 336.499 83.2668 334.242C83.2668 331.984 81.4335 330.172 79.1886 330.172Z"
            fill="white"
          />
          <path
            d="M86.182 316.473C83.9456 316.473 82.125 318.285 82.125 320.53C82.125 322.775 83.9456 324.591 86.182 324.591C88.4185 324.591 90.239 322.77 90.239 320.53C90.239 318.289 88.427 316.473 86.182 316.473Z"
            fill="white"
          />
          <path
            d="M93.4353 302.121C91.1988 302.121 89.3867 303.942 89.3867 306.17C89.3867 308.398 91.1988 310.218 93.4353 310.218C95.6717 310.218 97.4838 308.406 97.4838 306.17C97.4838 303.933 95.6717 302.121 93.4353 302.121Z"
            fill="white"
          />
          <path
            d="M100.959 287.445C98.731 287.445 96.9189 289.245 96.9189 291.473C96.9189 293.701 98.731 295.513 100.959 295.513C103.187 295.513 104.986 293.701 104.986 291.473C104.986 289.245 103.187 287.445 100.959 287.445Z"
            fill="white"
          />
          <path
            d="M108.725 272.812C106.51 272.812 104.706 274.612 104.706 276.831C104.706 279.051 106.505 280.85 108.725 280.85C110.944 280.85 112.744 279.059 112.744 276.831C112.744 274.603 110.944 272.812 108.725 272.812Z"
            fill="white"
          />
          <path
            d="M116.634 258.699C114.428 258.699 112.637 260.49 112.637 262.697C112.637 264.904 114.428 266.703 116.634 266.703C118.841 266.703 120.632 264.912 120.632 262.697C120.632 260.482 118.841 258.699 116.634 258.699Z"
            fill="white"
          />
          <path
            d="M124.515 245.471C122.321 245.471 120.539 247.249 120.539 249.447C120.539 251.645 122.317 253.411 124.515 253.411C126.714 253.411 128.492 251.641 128.492 249.447C128.492 247.253 126.714 245.471 124.515 245.471Z"
            fill="white"
          />
          <path
            d="M132.206 233.283C130.029 233.283 128.264 235.053 128.264 237.226C128.264 239.398 130.033 241.172 132.206 241.172C134.379 241.172 136.14 239.403 136.14 237.226C136.14 235.049 134.383 233.283 132.206 233.283Z"
            fill="white"
          />
          <path
            d="M139.551 222.17C137.387 222.17 135.626 223.927 135.626 226.095C135.626 228.264 137.387 230.021 139.551 230.021C141.716 230.021 143.477 228.264 143.477 226.095C143.477 223.927 141.716 222.17 139.551 222.17Z"
            fill="white"
          />
          <path
            d="M146.422 212.221C144.266 212.221 142.518 213.956 142.518 216.112C142.518 218.268 144.266 220.016 146.422 220.016C148.578 220.016 150.313 218.268 150.313 216.112C150.313 213.956 148.565 212.221 146.422 212.221Z"
            fill="white"
          />
          <path
            d="M152.762 203.438C150.619 203.438 148.879 205.177 148.879 207.321C148.879 209.464 150.615 211.204 152.762 211.204C154.909 211.204 156.645 209.464 156.645 207.321C156.645 205.177 154.905 203.438 152.762 203.438Z"
            fill="white"
          />
          <path
            d="M158.559 196.107C156.437 196.107 154.719 197.826 154.719 199.948C154.719 202.07 156.437 203.789 158.559 203.789C160.681 203.789 162.4 202.061 162.4 199.948C162.4 197.835 160.681 196.107 158.559 196.107Z"
            fill="white"
          />
          <path
            d="M163.791 190.18C161.691 190.18 159.993 191.881 159.993 193.982C159.993 196.083 161.691 197.784 163.791 197.784C165.892 197.784 167.602 196.083 167.602 193.982C167.602 191.881 165.896 190.18 163.791 190.18Z"
            fill="white"
          />
          <path
            d="M168.519 185.252C166.44 185.252 164.742 186.949 164.742 189.029C164.742 191.108 166.44 192.797 168.519 192.797C170.599 192.797 172.288 191.113 172.288 189.029C172.288 186.945 170.603 185.252 168.519 185.252Z"
            fill="white"
          />
          <path
            d="M172.734 181.039C170.663 181.039 168.986 182.715 168.986 184.786C168.986 186.857 170.663 188.534 172.734 188.534C174.805 188.534 176.481 186.857 176.481 184.786C176.481 182.715 174.805 181.039 172.734 181.039Z"
            fill="white"
          />
          <path
            d="M176.48 177.355C174.439 177.355 172.797 179.006 172.797 181.039C172.797 183.072 174.439 184.723 176.48 184.723C178.522 184.723 180.164 183.076 180.164 181.039C180.164 179.002 178.509 177.355 176.48 177.355Z"
            fill="white"
          />
          <path
            d="M179.77 173.951C177.75 173.951 176.116 175.585 176.116 177.605C176.116 179.625 177.75 181.259 179.77 181.259C181.79 181.259 183.424 179.625 183.424 177.605C183.424 175.585 181.79 173.951 179.77 173.951Z"
            fill="white"
          />
          <path
            d="M182.63 170.699C180.631 170.699 179.019 172.316 179.019 174.319C179.019 176.322 180.631 177.931 182.63 177.931C184.629 177.931 186.25 176.318 186.25 174.319C186.25 172.32 184.625 170.699 182.63 170.699Z"
            fill="white"
          />
          <path
            d="M185.087 167.504C183.117 167.504 181.518 169.108 181.518 171.086C181.518 173.063 183.122 174.659 185.087 174.659C187.051 174.659 188.668 173.063 188.668 171.086C188.668 169.108 187.064 167.504 185.087 167.504Z"
            fill="white"
          />
          <path
            d="M190.391 169.222C191.129 167.43 190.275 165.379 188.482 164.641C186.69 163.903 184.639 164.757 183.901 166.55C183.163 168.342 184.017 170.393 185.81 171.131C187.602 171.869 189.653 171.015 190.391 169.222Z"
            fill="white"
          />
          <path
            d="M188.846 161.305C186.932 161.305 185.379 162.854 185.379 164.772C185.379 166.69 186.928 168.239 188.846 168.239C190.764 168.239 192.313 166.686 192.313 164.772C192.313 162.858 190.764 161.305 188.846 161.305Z"
            fill="white"
          />
          <path
            d="M190.23 158.305C188.346 158.305 186.818 159.841 186.818 161.729C186.818 163.618 188.35 165.154 190.23 165.154C192.11 165.154 193.655 163.622 193.655 161.729C193.655 159.837 192.123 158.305 190.23 158.305Z"
            fill="white"
          />
          <path
            d="M191.376 155.402C189.513 155.402 188.002 156.913 188.002 158.776C188.002 160.639 189.513 162.154 191.376 162.154C193.239 162.154 194.75 160.639 194.75 158.776C194.75 156.913 193.239 155.402 191.376 155.402Z"
            fill="white"
          />
          <path
            d="M192.31 152.584C190.477 152.584 189 154.061 189 155.894C189 157.727 190.477 159.204 192.31 159.204C194.143 159.204 195.62 157.715 195.62 155.894C195.62 154.074 194.131 152.584 192.31 152.584Z"
            fill="white"
          />
          <path
            d="M193.07 149.777C191.27 149.777 189.811 151.229 189.811 153.028C189.811 154.827 191.266 156.279 193.07 156.279C194.873 156.279 196.316 154.823 196.316 153.028C196.316 151.233 194.861 149.777 193.07 149.777Z"
            fill="white"
          />
          <path
            d="M193.676 146.932C191.906 146.932 190.472 148.366 190.472 150.136C190.472 151.905 191.91 153.34 193.676 153.34C195.441 153.34 196.871 151.905 196.871 150.136C196.871 148.366 195.445 146.932 193.676 146.932Z"
            fill="white"
          />
          <path
            d="M194.144 144.008C192.404 144.008 190.999 145.417 190.999 147.152C190.999 148.888 192.404 150.297 194.144 150.297C195.884 150.297 197.288 148.892 197.288 147.152C197.288 145.412 195.871 144.008 194.144 144.008Z"
            fill="white"
          />
          <path
            d="M194.495 140.947C192.798 140.947 191.423 142.314 191.423 144.007C191.423 145.7 192.798 147.079 194.495 147.079C196.193 147.079 197.555 145.705 197.555 144.007C197.555 142.31 196.193 140.947 194.495 140.947Z"
            fill="white"
          />
          <path
            d="M194.776 137.617C193.121 137.617 191.78 138.958 191.78 140.626C191.78 142.294 193.121 143.622 194.776 143.622C196.431 143.622 197.785 142.281 197.785 140.626C197.785 138.971 196.444 137.617 194.776 137.617Z"
            fill="white"
          />
          <path
            d="M195.06 133.936C193.427 133.936 192.115 135.251 192.115 136.876C192.115 138.502 193.427 139.822 195.06 139.822C196.694 139.822 197.997 138.506 197.997 136.876C197.997 135.247 196.686 133.936 195.06 133.936Z"
            fill="white"
          />
          <path
            d="M195.425 129.756C193.82 129.756 192.53 131.059 192.53 132.654C192.53 134.25 193.82 135.553 195.425 135.553C197.029 135.553 198.319 134.25 198.319 132.654C198.319 131.059 197.029 129.756 195.425 129.756Z"
            fill="white"
          />
          <path
            d="M196.057 124.969C194.516 124.969 193.256 126.225 193.256 127.77C193.256 129.314 194.516 130.57 196.057 130.57C197.597 130.57 198.858 129.323 198.858 127.77C198.858 126.216 197.61 124.969 196.057 124.969Z"
            fill="white"
          />
          <path
            d="M197.296 119.18C195.785 119.18 194.559 120.406 194.559 121.921C194.559 123.436 195.785 124.663 197.296 124.663C198.807 124.663 200.033 123.436 200.033 121.921C200.033 120.406 198.807 119.18 197.296 119.18Z"
            fill="white"
          />
          <path
            d="M199.66 111.982C198.17 111.982 196.974 113.183 196.974 114.66C196.974 116.137 198.17 117.334 199.66 117.334C201.149 117.334 202.333 116.137 202.333 114.66C202.333 113.183 201.137 111.982 199.66 111.982Z"
            fill="white"
          />
          <path
            d="M203.916 102.758C202.469 102.758 201.302 103.925 201.302 105.363C201.302 106.802 202.469 107.969 203.916 107.969C205.363 107.969 206.517 106.802 206.517 105.363C206.517 103.925 205.35 102.758 203.916 102.758Z"
            fill="white"
          />
          <path
            d="M211.296 90.498C209.913 90.498 208.788 91.6226 208.788 93.0103C208.788 94.3981 209.913 95.5226 211.296 95.5226C212.68 95.5226 213.804 94.3981 213.804 93.0103C213.804 91.6226 212.68 90.498 211.296 90.498Z"
            fill="white"
          />
          <path
            d="M223.837 73.3789C222.483 73.3789 221.38 74.478 221.38 75.8275C221.38 77.1771 222.483 78.2804 223.837 78.2804C225.191 78.2804 226.281 77.1855 226.281 75.8275C226.281 74.4695 225.191 73.3789 223.837 73.3789Z"
            fill="white"
          />
          <path
            d="M243.081 68.1621C241.727 68.1621 240.637 69.2528 240.637 70.6065C240.637 71.9603 241.732 73.0552 243.081 73.0552C244.431 73.0552 245.538 71.956 245.538 70.6065C245.538 69.257 244.435 68.1621 243.081 68.1621Z"
            fill="white"
          />
          <path
            d="M265.769 58.2402C264.428 58.2402 263.333 59.3394 263.333 60.6804C263.333 62.0214 264.424 63.1248 265.769 63.1248C267.114 63.1248 268.213 62.0299 268.213 60.6804C268.213 59.3309 267.118 58.2402 265.769 58.2402Z"
            fill="white"
          />
          <path
            d="M291.635 42.6035C290.281 42.6035 289.19 43.6984 289.19 45.0479C289.19 46.3974 290.285 47.4923 291.635 47.4923C292.984 47.4923 294.079 46.3974 294.079 45.0479C294.079 43.6984 292.984 42.6035 291.635 42.6035Z"
            fill="white"
          />
          <path
            d="M319.295 21.3301C317.941 21.3301 316.851 22.4335 316.851 23.7872C316.851 25.141 317.945 26.2316 319.295 26.2316C320.645 26.2316 321.752 25.1367 321.752 23.7872C321.752 22.4377 320.649 21.3301 319.295 21.3301Z"
            fill="white"
          />
          <path
            d="M346.711 -3.48438C345.357 -3.48438 344.254 -2.381 344.254 -1.02724C344.254 0.326512 345.357 1.41716 346.711 1.41716C348.065 1.41716 349.155 0.322268 349.155 -1.02724C349.155 -2.37676 348.065 -3.48438 346.711 -3.48438Z"
            fill="white"
          />
          <path
            d="M886.922 -0.0644531C885.225 -0.0644531 883.85 1.31477 883.85 3.01227C883.85 4.70976 885.225 6.09323 886.922 6.09323C888.62 6.09323 890.003 4.70976 890.003 3.01227C890.003 1.31477 888.628 -0.0644531 886.922 -0.0644531Z"
            fill="white"
          />
          <path
            d="M894.239 10.9395C892.512 10.9395 891.107 12.3356 891.107 14.0629C891.107 15.7901 892.512 17.1863 894.239 17.1863C895.966 17.1863 897.363 15.7901 897.363 14.0629C897.363 12.3356 895.958 10.9395 894.239 10.9395Z"
            fill="white"
          />
          <path
            d="M901.368 22.2656C899.607 22.2656 898.181 23.6915 898.181 25.4484C898.181 27.2053 899.607 28.6355 901.368 28.6355C903.129 28.6355 904.542 27.2096 904.542 25.4484C904.542 23.6873 903.125 22.2656 901.368 22.2656Z"
            fill="white"
          />
          <path
            d="M908.311 33.9121C906.52 33.9121 905.064 35.3592 905.064 37.1543C905.064 38.9494 906.52 40.4008 908.311 40.4008C910.102 40.4008 911.557 38.9494 911.557 37.1543C911.557 35.3592 910.102 33.9121 908.311 33.9121Z"
            fill="white"
          />
          <path
            d="M915.075 45.832C913.233 45.832 911.743 47.3216 911.743 49.1591C911.743 50.9967 913.233 52.4777 915.075 52.4777C916.916 52.4777 918.393 50.9882 918.393 49.1591C918.393 47.3301 916.904 45.832 915.075 45.832Z"
            fill="white"
          />
          <path
            d="M921.676 58.0215C919.813 58.0215 918.302 59.5323 918.302 61.3868C918.302 63.2413 919.813 64.7606 921.676 64.7606C923.539 64.7606 925.049 63.2498 925.049 61.3868C925.049 59.5238 923.539 58.0215 921.676 58.0215Z"
            fill="white"
          />
          <path
            d="M928.15 70.3906C926.258 70.3906 924.726 71.9226 924.726 73.8068C924.726 75.6911 926.258 77.2273 928.15 77.2273C930.043 77.2273 931.562 75.6953 931.562 73.8068C931.562 71.9184 930.03 70.3906 928.15 70.3906Z"
            fill="white"
          />
          <path
            d="M934.508 82.8965C932.594 82.8965 931.032 84.4539 931.032 86.3679C931.032 88.2818 932.594 89.8435 934.508 89.8435C936.422 89.8435 937.984 88.2945 937.984 86.3679C937.984 84.4412 936.435 82.8965 934.508 82.8965Z"
            fill="white"
          />
          <path
            d="M940.763 95.5977C938.807 95.5977 937.224 97.1806 937.224 99.1369C937.224 101.093 938.807 102.676 940.763 102.676C942.719 102.676 944.302 101.093 944.302 99.1369C944.302 97.1806 942.719 95.5977 940.763 95.5977Z"
            fill="white"
          />
          <path
            d="M946.934 108.508C944.948 108.508 943.344 110.116 943.344 112.094C943.344 114.071 944.948 115.684 946.934 115.684C948.92 115.684 950.516 114.08 950.516 112.094C950.516 110.108 948.912 108.508 946.934 108.508Z"
            fill="white"
          />
          <path
            d="M953.065 121.604C951.058 121.604 949.433 123.233 949.433 125.232C949.433 127.231 951.058 128.865 953.065 128.865C955.073 128.865 956.685 127.239 956.685 125.232C956.685 123.225 955.06 121.604 953.065 121.604Z"
            fill="white"
          />
          <path
            d="M959.206 134.793C957.178 134.793 955.531 136.44 955.531 138.468C955.531 140.497 957.174 142.152 959.206 142.152C961.239 142.152 962.89 140.501 962.89 138.468C962.89 136.435 961.235 134.793 959.206 134.793Z"
            fill="white"
          />
          <path
            d="M965.432 148.041C963.369 148.041 961.697 149.713 961.697 151.776C961.697 153.838 963.374 155.51 965.432 155.51C967.49 155.51 969.166 153.834 969.166 151.776C969.166 149.717 967.49 148.041 965.432 148.041Z"
            fill="white"
          />
          <path
            d="M971.768 161.348C969.689 161.348 967.991 163.032 967.991 165.116C967.991 167.2 969.689 168.893 971.768 168.893C973.848 168.893 975.537 167.196 975.537 165.116C975.537 163.037 973.852 161.348 971.768 161.348Z"
            fill="white"
          />
          <path
            d="M978.272 174.635C976.159 174.635 974.453 176.341 974.453 178.454C974.453 180.568 976.159 182.265 978.272 182.265C980.386 182.265 982.083 180.559 982.083 178.454C982.083 176.349 980.377 174.635 978.272 174.635Z"
            fill="white"
          />
          <path
            d="M985.017 187.781C982.895 187.781 981.168 189.5 981.168 191.622C981.168 193.744 982.895 195.471 985.017 195.471C987.139 195.471 988.858 193.748 988.858 191.622C988.858 189.496 987.139 187.781 985.017 187.781Z"
            fill="white"
          />
          <path
            d="M992.105 200.5C989.962 200.5 988.222 202.236 988.222 204.392C988.222 206.547 989.962 208.275 992.105 208.275C994.248 208.275 995.996 206.539 995.996 204.392C995.996 202.244 994.256 200.5 992.105 200.5Z"
            fill="white"
          />
          <path
            d="M999.628 212.561C997.463 212.561 995.702 214.322 995.702 216.494C995.702 218.667 997.459 220.42 999.628 220.42C1001.8 220.42 1003.55 218.663 1003.55 216.494C1003.55 214.326 1001.79 212.561 999.628 212.561Z"
            fill="white"
          />
          <path
            d="M1007.64 223.723C1005.45 223.723 1003.68 225.492 1003.68 227.678C1003.68 229.863 1005.45 231.633 1007.64 231.633C1009.82 231.633 1011.59 229.863 1011.59 227.678C1011.59 225.492 1009.82 223.723 1007.64 223.723Z"
            fill="white"
          />
          <path
            d="M1016.11 233.783C1013.91 233.783 1012.13 235.561 1012.13 237.768C1012.13 239.975 1013.91 241.753 1016.11 241.753C1018.32 241.753 1020.1 239.962 1020.1 237.768C1020.1 235.574 1018.32 233.783 1016.11 233.783Z"
            fill="white"
          />
          <path
            d="M1025.03 242.652C1022.81 242.652 1021.01 244.443 1021.01 246.671C1021.01 248.899 1022.81 250.69 1025.03 250.69C1027.25 250.69 1029.05 248.891 1029.05 246.671C1029.05 244.452 1027.25 242.652 1025.03 242.652Z"
            fill="white"
          />
          <path
            d="M1034.25 250.355C1032.01 250.355 1030.2 252.168 1030.2 254.404C1030.2 256.64 1032.01 258.453 1034.25 258.453C1036.48 258.453 1038.29 256.64 1038.29 254.404C1038.29 252.168 1036.48 250.355 1034.25 250.355Z"
            fill="white"
          />
          <path
            d="M1043.69 256.943C1041.43 256.943 1039.61 258.764 1039.61 261.022C1039.61 263.279 1041.43 265.091 1043.69 265.091C1045.94 265.091 1047.76 263.271 1047.76 261.022C1047.76 258.772 1045.93 256.943 1043.69 256.943Z"
            fill="white"
          />
          <path
            d="M1053.24 262.541C1050.98 262.541 1049.15 264.383 1049.15 266.64C1049.15 268.898 1050.98 270.731 1053.24 270.731C1055.5 270.731 1057.34 268.898 1057.34 266.64C1057.34 264.383 1055.5 262.541 1053.24 262.541Z"
            fill="white"
          />
          <path
            d="M1062.86 267.275C1060.58 267.275 1058.74 269.117 1058.74 271.396C1058.74 273.675 1060.58 275.517 1062.86 275.517C1065.14 275.517 1066.99 273.675 1066.99 271.396C1066.99 269.117 1065.14 267.275 1062.86 267.275Z"
            fill="white"
          />
          <path
            d="M1072.48 271.293C1070.19 271.293 1068.32 273.147 1068.32 275.435C1068.32 277.722 1070.19 279.577 1072.48 279.577C1074.77 279.577 1076.62 277.722 1076.62 275.435C1076.62 273.147 1074.77 271.293 1072.48 271.293Z"
            fill="white"
          />
          <path
            d="M1082.04 274.805C1079.75 274.805 1077.89 276.659 1077.89 278.959C1077.89 281.259 1079.75 283.114 1082.04 283.114C1084.33 283.114 1086.2 281.251 1086.2 278.959C1086.2 276.668 1084.33 274.805 1082.04 274.805Z"
            fill="white"
          />
          <path
            d="M1091.56 277.922C1089.26 277.922 1087.4 279.776 1087.4 282.076C1087.4 284.377 1089.26 286.231 1091.56 286.231C1093.86 286.231 1095.72 284.368 1095.72 282.076C1095.72 279.785 1093.86 277.922 1091.56 277.922Z"
            fill="white"
          />
          <path
            d="M1101.03 280.754C1098.73 280.754 1096.88 282.617 1096.88 284.909C1096.88 287.2 1098.73 289.063 1101.03 289.063C1103.33 289.063 1105.19 287.2 1105.19 284.909C1105.19 282.617 1103.32 280.754 1101.03 280.754Z"
            fill="white"
          />
          <path
            d="M1110.47 283.377C1108.18 283.377 1106.32 285.227 1106.32 287.532C1106.32 289.836 1108.18 291.686 1110.47 291.686C1112.77 291.686 1114.63 289.823 1114.63 287.532C1114.63 285.24 1112.78 283.377 1110.47 283.377Z"
            fill="white"
          />
          <path
            d="M1119.89 285.832C1117.59 285.832 1115.74 287.695 1115.74 289.987C1115.74 292.278 1117.59 294.141 1119.89 294.141C1122.19 294.141 1124.05 292.278 1124.05 289.987C1124.05 287.695 1122.18 285.832 1119.89 285.832Z"
            fill="white"
          />
          <path
            d="M1129.26 288.205C1126.97 288.205 1125.11 290.068 1125.11 292.368C1125.11 294.668 1126.97 296.523 1129.26 296.523C1131.55 296.523 1133.42 294.66 1133.42 292.368C1133.42 290.077 1131.57 288.205 1129.26 288.205Z"
            fill="white"
          />
          <path
            d="M1138.56 290.561C1136.27 290.561 1134.41 292.415 1134.41 294.715C1134.41 297.015 1136.27 298.87 1138.56 298.87C1140.86 298.87 1142.72 297.007 1142.72 294.715C1142.72 292.424 1140.87 290.561 1138.56 290.561Z"
            fill="white"
          />
          <path
            d="M1133.93 290.775C1131.63 290.775 1129.78 292.638 1129.78 294.93C1129.78 297.222 1131.63 299.085 1133.93 299.085C1136.24 299.085 1138.09 297.23 1138.09 294.93C1138.09 292.63 1136.23 290.775 1133.93 290.775Z"
            fill="white"
          />
          <path
            d="M1129.02 290.943C1126.72 290.943 1124.87 292.806 1124.87 295.098C1124.87 297.39 1126.72 299.253 1129.02 299.253C1131.32 299.253 1133.17 297.39 1133.17 295.098C1133.17 292.806 1131.31 290.943 1129.02 290.943Z"
            fill="white"
          />
          <path
            d="M1123.84 291.07C1121.55 291.07 1119.68 292.933 1119.68 295.225C1119.68 297.517 1121.55 299.38 1123.84 299.38C1126.13 299.38 1127.99 297.529 1127.99 295.225C1127.99 292.921 1126.13 291.07 1123.84 291.07Z"
            fill="white"
          />
          <path
            d="M1118.39 291.184C1116.1 291.184 1114.24 293.047 1114.24 295.338C1114.24 297.63 1116.1 299.501 1118.39 299.501C1120.68 299.501 1122.55 297.638 1122.55 295.338C1122.55 293.038 1120.68 291.184 1118.39 291.184Z"
            fill="white"
          />
          <path
            d="M1112.68 291.299C1110.39 291.299 1108.53 293.162 1108.53 295.453C1108.53 297.745 1110.39 299.608 1112.68 299.608C1114.97 299.608 1116.84 297.745 1116.84 295.453C1116.84 293.162 1114.98 291.299 1112.68 291.299Z"
            fill="white"
          />
          <path
            d="M1106.71 291.422C1104.41 291.422 1102.54 293.272 1102.54 295.572C1102.54 297.872 1104.41 299.727 1106.71 299.727C1109.01 299.727 1110.86 297.864 1110.86 295.572C1110.86 293.281 1109 291.422 1106.71 291.422Z"
            fill="white"
          />
          <path
            d="M1100.44 291.57C1098.15 291.57 1096.29 293.433 1096.29 295.725C1096.29 298.017 1098.15 299.888 1100.44 299.888C1102.73 299.888 1104.6 298.025 1104.6 295.725C1104.6 293.425 1102.73 291.57 1100.44 291.57Z"
            fill="white"
          />
          <path
            d="M1093.89 291.785C1091.6 291.785 1089.74 293.64 1089.74 295.94C1089.74 298.24 1091.6 300.094 1093.89 300.094C1096.19 300.094 1098.05 298.231 1098.05 295.94C1098.05 293.648 1096.19 291.785 1093.89 291.785Z"
            fill="white"
          />
          <path
            d="M1087.06 292.08C1084.77 292.08 1082.9 293.943 1082.9 296.235C1082.9 298.526 1084.77 300.389 1087.06 300.389C1089.35 300.389 1091.21 298.526 1091.21 296.235C1091.21 293.943 1089.36 292.08 1087.06 292.08Z"
            fill="white"
          />
          <path
            d="M1079.94 292.484C1077.64 292.484 1075.78 294.347 1075.78 296.639C1075.78 298.931 1077.63 300.794 1079.94 300.794C1082.24 300.794 1084.09 298.931 1084.09 296.639C1084.09 294.347 1082.23 292.484 1079.94 292.484Z"
            fill="white"
          />
          <path
            d="M1072.53 293.035C1070.24 293.035 1068.37 294.898 1068.37 297.19C1068.37 299.481 1070.24 301.344 1072.53 301.344C1074.82 301.344 1076.68 299.481 1076.68 297.19C1076.68 294.898 1074.82 293.035 1072.53 293.035Z"
            fill="white"
          />
          <path
            d="M1064.84 293.766C1062.56 293.766 1060.72 295.62 1060.72 297.899C1060.72 300.178 1062.56 302.02 1064.84 302.02C1067.12 302.02 1068.97 300.169 1068.97 297.899C1068.97 295.629 1067.12 293.766 1064.84 293.766Z"
            fill="white"
          />
          <path
            d="M1056.87 294.631C1054.6 294.631 1052.76 296.473 1052.76 298.743C1052.76 301.013 1054.6 302.855 1056.87 302.855C1059.14 302.855 1060.98 301.022 1060.98 298.743C1060.98 296.464 1059.14 294.631 1056.87 294.631Z"
            fill="white"
          />
          <path
            d="M1048.65 295.691C1046.4 295.691 1044.57 297.512 1044.57 299.77C1044.57 302.027 1046.41 303.848 1048.65 303.848C1050.9 303.848 1052.74 302.027 1052.74 299.77C1052.74 297.512 1050.91 295.691 1048.65 295.691Z"
            fill="white"
          />
          <path
            d="M1040.19 296.932C1037.95 296.932 1036.13 298.752 1036.13 301.001C1036.13 303.251 1037.95 305.058 1040.19 305.058C1042.43 305.058 1044.26 303.246 1044.26 301.001C1044.26 298.756 1042.44 296.932 1040.19 296.932Z"
            fill="white"
          />
          <path
            d="M1031.51 298.428C1029.28 298.428 1027.48 300.227 1027.48 302.455C1027.48 304.683 1029.28 306.482 1031.51 306.482C1033.74 306.482 1035.54 304.683 1035.54 302.455C1035.54 300.227 1033.74 298.428 1031.51 298.428Z"
            fill="white"
          />
          <path
            d="M1022.63 300.164C1020.42 300.164 1018.63 301.955 1018.63 304.17C1018.63 306.385 1020.42 308.176 1022.63 308.176C1024.85 308.176 1026.64 306.377 1026.64 304.17C1026.64 301.963 1024.84 300.164 1022.63 300.164Z"
            fill="white"
          />
          <path
            d="M1013.56 302.121C1011.37 302.121 1009.59 303.899 1009.59 306.097C1009.59 308.296 1011.37 310.082 1013.56 310.082C1015.76 310.082 1017.54 308.304 1017.54 306.097C1017.54 303.891 1015.76 302.121 1013.56 302.121Z"
            fill="white"
          />
          <path
            d="M1004.31 304.297C1002.14 304.297 1000.37 306.054 1000.37 308.239C1000.37 310.425 1002.14 312.182 1004.31 312.182C1006.49 312.182 1008.26 310.412 1008.26 308.239C1008.26 306.067 1006.49 304.297 1004.31 304.297Z"
            fill="white"
          />
          <path
            d="M994.883 314.521C997.039 314.521 998.787 312.773 998.787 310.617C998.787 308.461 997.039 306.713 994.883 306.713C992.727 306.713 990.979 308.461 990.979 310.617C990.979 312.773 992.727 314.521 994.883 314.521Z"
            fill="white"
          />
          <path
            d="M985.297 309.377C983.163 309.377 981.427 311.117 981.427 313.247C981.427 315.378 983.167 317.118 985.297 317.118C987.427 317.118 989.167 315.39 989.167 313.247C989.167 311.104 987.44 309.377 985.297 309.377Z"
            fill="white"
          />
          <path
            d="M975.588 312.354C973.466 312.354 971.739 314.072 971.739 316.194C971.739 318.316 973.466 320.035 975.588 320.035C977.71 320.035 979.429 318.316 979.429 316.194C979.429 314.072 977.702 312.354 975.588 312.354Z"
            fill="white"
          />
          <path
            d="M965.755 315.662C963.655 315.662 961.944 317.368 961.944 319.473C961.944 321.578 963.65 323.292 965.755 323.292C967.86 323.292 969.575 321.586 969.575 319.473C969.575 317.36 967.869 315.662 965.755 315.662Z"
            fill="white"
          />
          <path
            d="M955.846 319.4C953.775 319.4 952.09 321.085 952.09 323.156C952.09 325.227 953.775 326.912 955.846 326.912C957.917 326.912 959.601 325.227 959.601 323.156C959.601 321.085 957.917 319.4 955.846 319.4Z"
            fill="white"
          />
          <path
            d="M945.864 323.572C943.814 323.572 942.146 325.236 942.146 327.298C942.146 329.361 943.81 331.012 945.864 331.012C947.918 331.012 949.59 329.348 949.59 327.298C949.59 325.249 947.926 323.572 945.864 323.572Z"
            fill="white"
          />
          <path
            d="M935.861 328.268C933.832 328.268 932.186 329.914 932.186 331.943C932.186 333.971 933.832 335.618 935.861 335.618C937.889 335.618 939.536 333.971 939.536 331.943C939.536 329.914 937.881 328.268 935.861 328.268Z"
            fill="white"
          />
          <path
            d="M925.858 333.512C923.851 333.512 922.217 335.137 922.217 337.144C922.217 339.152 923.851 340.786 925.858 340.786C927.865 340.786 929.491 339.152 929.491 337.144C929.491 335.137 927.865 333.512 925.858 333.512Z"
            fill="white"
          />
          <path
            d="M915.89 339.371C913.913 339.371 912.321 340.975 912.321 342.94C912.321 344.905 913.913 346.509 915.89 346.509C917.868 346.509 919.459 344.918 919.459 342.94C919.459 340.962 917.855 339.371 915.89 339.371Z"
            fill="white"
          />
          <path
            d="M906.003 345.865C904.055 345.865 902.477 347.448 902.477 349.396C902.477 351.344 904.059 352.923 906.003 352.923C907.947 352.923 909.53 351.34 909.53 349.396C909.53 347.452 907.947 345.865 906.003 345.865Z"
            fill="white"
          />
          <path
            d="M896.237 353.08C894.323 353.08 892.762 354.642 892.762 356.568C892.762 358.495 894.323 360.057 896.237 360.057C898.151 360.057 899.726 358.495 899.726 356.568C899.726 354.642 898.164 353.08 896.237 353.08Z"
            fill="white"
          />
          <path
            d="M886.571 361.041C884.678 361.041 883.138 362.581 883.138 364.474C883.138 366.367 884.678 367.907 886.571 367.907C888.464 367.907 890.004 366.367 890.004 364.474C890.004 362.581 888.476 361.041 886.571 361.041Z"
            fill="white"
          />
          <path
            d="M877.055 369.898C875.201 369.898 873.694 371.409 873.694 373.259C873.694 375.11 875.205 376.621 877.055 376.621C878.906 376.621 880.416 375.122 880.416 373.259C880.416 371.396 878.906 369.898 877.055 369.898Z"
            fill="white"
          />
          <path
            d="M867.74 379.721C865.907 379.721 864.422 381.198 864.422 383.031C864.422 384.864 865.911 386.349 867.74 386.349C869.57 386.349 871.051 384.86 871.051 383.031C871.051 381.202 869.574 379.721 867.74 379.721Z"
            fill="white"
          />
          <path
            d="M858.604 390.619C856.805 390.619 855.345 392.075 855.345 393.878C855.345 395.682 856.8 397.138 858.604 397.138C860.407 397.138 861.872 395.682 861.872 393.878C861.872 392.075 860.403 390.619 858.604 390.619Z"
            fill="white"
          />
          <path
            d="M849.849 402.965C848.07 402.965 846.632 404.399 846.632 406.169C846.632 407.939 848.066 409.373 849.849 409.373C851.631 409.373 853.053 407.947 853.053 406.169C853.053 404.391 851.618 402.965 849.849 402.965Z"
            fill="white"
          />
          <path
            d="M841.764 417.324C840.045 417.324 838.641 418.729 838.641 420.448C838.641 422.166 840.045 423.571 841.764 423.571C843.483 423.571 844.887 422.175 844.887 420.448C844.887 418.72 843.491 417.324 841.764 417.324Z"
            fill="white"
          />
          <path
            d="M834.873 434.385C833.188 434.385 831.813 435.747 831.813 437.445C831.813 439.142 833.188 440.496 834.873 440.496C836.558 440.496 837.933 439.134 837.933 437.445C837.933 435.756 836.558 434.385 834.873 434.385Z"
            fill="white"
          />
          <path
            d="M835.884 471.064C834.25 471.064 832.926 472.384 832.926 474.022C832.926 475.66 834.25 476.98 835.884 476.98C837.518 476.98 838.842 475.656 838.842 474.022C838.842 472.388 837.522 471.064 835.884 471.064Z"
            fill="white"
          />
          <path
            d="M827.722 485.99C829.355 485.99 830.679 484.666 830.679 483.032C830.679 481.399 829.355 480.074 827.722 480.074C826.088 480.074 824.764 481.399 824.764 483.032C824.764 484.666 826.088 485.99 827.722 485.99Z"
            fill="white"
          />
          <path
            d="M819.522 489.725C817.897 489.725 816.577 491.049 816.577 492.67C816.577 494.291 817.897 495.615 819.522 495.615C821.148 495.615 822.467 494.304 822.467 492.67C822.467 491.036 821.156 489.725 819.522 489.725Z"
            fill="white"
          />
          <path
            d="M811.247 499.818C809.622 499.818 808.311 501.13 808.311 502.755C808.311 504.38 809.622 505.692 811.247 505.692C812.873 505.692 814.184 504.38 814.184 502.755C814.184 501.13 812.873 499.818 811.247 499.818Z"
            fill="white"
          />
          <path
            d="M802.671 510.018C801.046 510.018 799.734 511.329 799.734 512.954C799.734 514.58 801.046 515.878 802.671 515.878C804.296 515.878 805.595 514.567 805.595 512.954C805.595 511.342 804.284 510.018 802.671 510.018Z"
            fill="white"
          />
          <path
            d="M793.721 520.219C792.095 520.219 790.797 521.53 790.797 523.155C790.797 524.781 792.1 526.079 793.721 526.079C795.342 526.079 796.645 524.768 796.645 523.155C796.645 521.543 795.333 520.219 793.721 520.219Z"
            fill="white"
          />
          <path
            d="M784.622 530.689C783.01 530.689 781.698 531.992 781.698 533.605C781.698 535.218 783.01 536.529 784.622 536.529C786.235 536.529 787.538 535.218 787.538 533.605C787.538 531.992 786.235 530.689 784.622 530.689Z"
            fill="white"
          />
          <path
            d="M775.206 541.043C773.593 541.043 772.282 542.354 772.282 543.958C772.282 545.563 773.593 546.882 775.206 546.882C776.819 546.882 778.122 545.571 778.122 543.958C778.122 542.346 776.81 541.043 775.206 541.043Z"
            fill="white"
          />
          <path
            d="M765.348 551.102C763.744 551.102 762.433 552.413 762.433 554.017C762.433 555.621 763.744 556.932 765.348 556.932C766.952 556.932 768.264 555.63 768.264 554.017C768.264 552.404 766.961 551.102 765.348 551.102Z"
            fill="white"
          />
          <path
            d="M754.984 560.686C753.38 560.686 752.081 561.988 752.081 563.601C752.081 565.214 753.384 566.516 754.984 566.516C756.584 566.516 757.899 565.205 757.899 563.601C757.899 561.997 756.596 560.686 754.984 560.686Z"
            fill="white"
          />
          <path
            d="M744.044 569.604C742.452 569.604 741.149 570.894 741.149 572.498C741.149 574.102 742.452 575.392 744.044 575.392C745.635 575.392 746.946 574.102 746.946 572.498C746.946 570.894 745.644 569.604 744.044 569.604Z"
            fill="white"
          />
          <path
            d="M732.513 577.545C730.909 577.545 729.619 578.835 729.619 580.439C729.619 582.043 730.909 583.321 732.513 583.321C734.117 583.321 735.395 582.031 735.395 580.439C735.395 578.848 734.105 577.545 732.513 577.545Z"
            fill="white"
          />
          <path
            d="M720.449 584.428C718.845 584.428 717.555 585.718 717.555 587.322C717.555 588.926 718.845 590.203 720.449 590.203C722.053 590.203 723.33 588.913 723.33 587.322C723.33 585.731 722.04 584.428 720.449 584.428Z"
            fill="white"
          />
          <path
            d="M707.938 590.34C706.347 590.34 705.057 591.63 705.057 593.221C705.057 594.813 706.347 596.103 707.938 596.103C709.53 596.103 710.82 594.813 710.82 593.221C710.82 591.63 709.53 590.34 707.938 590.34Z"
            fill="white"
          />
          <path
            d="M695.033 595.104C693.441 595.104 692.151 596.385 692.151 597.976C692.151 599.568 693.441 600.858 695.033 600.858C696.624 600.858 697.906 599.568 697.906 597.976C697.906 596.385 696.616 595.104 695.033 595.104Z"
            fill="white"
          />
          <path
            d="M681.826 598.809C680.235 598.809 678.953 600.099 678.953 601.682C678.953 603.265 680.235 604.555 681.826 604.555C683.418 604.555 684.699 603.273 684.699 601.682C684.699 600.09 683.409 598.809 681.826 598.809Z"
            fill="white"
          />
          <path
            d="M668.399 601.619C666.816 601.619 665.526 602.909 665.526 604.492C665.526 606.075 666.816 607.365 668.399 607.365C669.982 607.365 671.272 606.084 671.272 604.492C671.272 602.901 669.991 601.619 668.399 601.619Z"
            fill="white"
          />
          <path
            d="M654.785 603.648C653.203 603.648 651.921 604.939 651.921 606.521C651.921 608.104 653.203 609.382 654.785 609.382C656.368 609.382 657.646 608.1 657.646 606.521C657.646 604.943 656.364 603.648 654.785 603.648Z"
            fill="white"
          />
          <path
            d="M641.006 604.959C639.423 604.959 638.146 606.241 638.146 607.824C638.146 609.406 639.427 610.684 641.006 610.684C642.584 610.684 643.866 609.402 643.866 607.824C643.866 606.245 642.584 604.959 641.006 604.959Z"
            fill="white"
          />
          <path
            d="M627.1 605.752C625.517 605.752 624.239 607.034 624.239 608.612C624.239 610.191 625.521 611.464 627.1 611.464C628.678 611.464 629.951 610.182 629.951 608.612C629.951 607.042 628.682 605.752 627.1 605.752Z"
            fill="white"
          />
          <path
            d="M613.09 606.355C611.52 606.355 610.238 607.637 610.238 609.207C610.238 610.777 611.52 612.059 613.09 612.059C614.66 612.059 615.942 610.79 615.942 609.207C615.942 607.624 614.673 606.355 613.09 606.355Z"
            fill="white"
          />
          <path
            d="M599.074 607.084C597.503 607.084 596.222 608.353 596.222 609.927C596.222 611.502 597.503 612.779 599.074 612.779C600.644 612.779 601.925 611.51 601.925 609.927C601.925 608.344 600.644 607.084 599.074 607.084Z"
            fill="white"
          />
          <path
            d="M585.103 608.062C583.533 608.062 582.26 609.344 582.26 610.914C582.26 612.485 583.529 613.758 585.103 613.758C586.677 613.758 587.955 612.489 587.955 610.914C587.955 609.34 586.673 608.062 585.103 608.062Z"
            fill="white"
          />
          <path
            d="M571.199 609.436C569.637 609.436 568.355 610.704 568.355 612.279C568.355 613.853 569.637 615.122 571.199 615.122C572.76 615.122 574.042 613.841 574.042 612.279C574.042 610.717 572.773 609.436 571.199 609.436Z"
            fill="white"
          />
          <path
            d="M557.399 611.32C555.829 611.32 554.556 612.602 554.556 614.172C554.556 615.742 555.825 617.015 557.399 617.015C558.973 617.015 560.242 615.734 560.242 614.172C560.242 612.61 558.973 611.32 557.399 611.32Z"
            fill="white"
          />
          <path
            d="M543.693 613.557C542.123 613.557 540.85 614.826 540.85 616.4C540.85 617.974 542.119 619.243 543.693 619.243C545.267 619.243 546.524 617.974 546.524 616.4C546.524 614.826 545.255 613.557 543.693 613.557Z"
            fill="white"
          />
          <path
            d="M530.035 615.928C528.473 615.928 527.204 617.188 527.204 618.758C527.204 620.329 528.473 621.589 530.035 621.589C531.596 621.589 532.865 620.32 532.865 618.758C532.865 617.197 531.596 615.928 530.035 615.928Z"
            fill="white"
          />
          <path
            d="M516.392 618.492C514.83 618.492 513.562 619.761 513.562 621.323C513.562 622.884 514.83 624.153 516.392 624.153C517.954 624.153 519.223 622.884 519.223 621.323C519.223 619.761 517.954 618.492 516.392 618.492Z"
            fill="white"
          />
          <path
            d="M502.749 621.158C501.187 621.158 499.918 622.427 499.918 623.989C499.918 625.551 501.187 626.811 502.749 626.811C504.31 626.811 505.571 625.551 505.571 623.989C505.571 622.427 504.31 621.158 502.749 621.158Z"
            fill="white"
          />
          <path
            d="M489.041 623.602C487.479 623.602 486.21 624.87 486.21 626.424C486.21 627.977 487.479 629.254 489.041 629.254C490.602 629.254 491.863 627.985 491.863 626.424C491.863 624.862 490.602 623.602 489.041 623.602Z"
            fill="white"
          />
          <path
            d="M475.198 625.83C473.636 625.83 472.376 627.09 472.376 628.652C472.376 630.214 473.636 631.474 475.198 631.474C476.76 631.474 478.02 630.205 478.02 628.652C478.02 627.099 476.751 625.83 475.198 625.83Z"
            fill="white"
          />
          <path
            d="M461.176 627.795C459.615 627.795 458.346 629.055 458.346 630.617C458.346 632.179 459.615 633.439 461.176 633.439C462.738 633.439 463.998 632.179 463.998 630.617C463.998 629.055 462.729 627.795 461.176 627.795Z"
            fill="white"
          />
          <path
            d="M446.909 629.234C445.347 629.234 444.087 630.495 444.087 632.044C444.087 633.593 445.347 634.866 446.909 634.866C448.471 634.866 449.718 633.605 449.718 632.044C449.718 630.482 448.458 629.234 446.909 629.234Z"
            fill="white"
          />
          <path
            d="M432.277 629.992C430.715 629.992 429.455 631.253 429.455 632.814C429.455 634.376 430.715 635.636 432.277 635.636C433.839 635.636 435.108 634.376 435.108 632.814C435.108 631.253 433.839 629.992 432.277 629.992Z"
            fill="white"
          />
          <path
            d="M417.165 630.117C415.603 630.117 414.343 631.378 414.343 632.939C414.343 634.501 415.603 635.77 417.165 635.77C418.727 635.77 419.995 634.501 419.995 632.939C419.995 631.378 418.727 630.117 417.165 630.117Z"
            fill="white"
          />
          <path
            d="M401.425 629.369C399.876 629.369 398.603 630.63 398.603 632.179C398.603 633.727 399.871 635.001 401.425 635.001C402.978 635.001 404.247 633.74 404.247 632.179C404.247 630.617 402.986 629.369 401.425 629.369Z"
            fill="white"
          />
          <path
            d="M384.942 627.521C383.381 627.521 382.12 628.79 382.12 630.344C382.12 631.897 383.381 633.166 384.942 633.166C386.504 633.166 387.764 631.905 387.764 630.344C387.764 628.782 386.504 627.521 384.942 627.521Z"
            fill="white"
          />
          <path
            d="M367.568 624.748C366.006 624.748 364.746 626.017 364.746 627.57C364.746 629.123 366.006 630.38 367.568 630.38C369.13 630.38 370.378 629.119 370.378 627.57C370.378 626.021 369.117 624.748 367.568 624.748Z"
            fill="white"
          />
          <path
            d="M349.159 620.822C347.597 620.822 346.328 622.083 346.328 623.644C346.328 625.206 347.597 626.466 349.159 626.466C350.72 626.466 351.981 625.206 351.981 623.644C351.981 622.083 350.712 620.822 349.159 620.822Z"
            fill="white"
          />
          <path
            d="M329.654 615.441C328.105 615.441 326.832 616.702 326.832 618.264C326.832 619.825 328.101 621.086 329.654 621.086C331.207 621.086 332.485 619.825 332.485 618.264C332.485 616.702 331.216 615.441 329.654 615.441Z"
            fill="white"
          />
          <path
            d="M321.315 610.59C319.724 610.59 318.434 611.88 318.434 613.463C318.434 615.046 319.724 616.344 321.315 616.344C322.907 616.344 324.197 615.054 324.197 613.463C324.197 611.871 322.907 610.59 321.315 610.59Z"
            fill="white"
          />
          <path
            d="M313.26 605.775C311.635 605.775 310.323 607.095 310.323 608.721C310.323 610.346 311.635 611.666 313.26 611.666C314.885 611.666 316.205 610.342 316.205 608.721C316.205 607.099 314.885 605.775 313.26 605.775Z"
            fill="white"
          />
          <path
            d="M305.703 601.068C304.048 601.068 302.707 602.409 302.707 604.064C302.707 605.72 304.048 607.061 305.703 607.061C307.358 607.061 308.712 605.72 308.712 604.064C308.712 602.409 307.358 601.068 305.703 601.068Z"
            fill="white"
          />
          <path
            d="M298.744 596.467C297.038 596.467 295.663 597.85 295.663 599.548C295.663 601.245 297.038 602.629 298.744 602.629C300.45 602.629 301.817 601.245 301.817 599.548C301.817 597.85 300.442 596.467 298.744 596.467Z"
            fill="white"
          />
          <path
            d="M292.373 592.045C290.633 592.045 289.229 593.45 289.229 595.177C289.229 596.904 290.633 598.321 292.373 598.321C294.113 598.321 295.505 596.917 295.505 595.177C295.505 593.437 294.1 592.045 292.373 592.045Z"
            fill="white"
          />
          <path
            d="M286.449 587.725C284.688 587.725 283.262 589.142 283.262 590.899C283.262 592.656 284.688 594.082 286.449 594.082C288.21 594.082 289.623 592.656 289.623 590.899C289.623 589.142 288.206 587.725 286.449 587.725Z"
            fill="white"
          />
          <path
            d="M280.83 583.406C279.039 583.406 277.592 584.862 277.592 586.653C277.592 588.444 279.039 589.891 280.83 589.891C282.621 589.891 284.068 588.435 284.068 586.653C284.068 584.87 282.621 583.406 280.83 583.406Z"
            fill="white"
          />
          <path
            d="M275.365 579.066C273.532 579.066 272.055 580.543 272.055 582.376C272.055 584.21 273.532 585.695 275.365 585.695C277.198 585.695 278.683 584.206 278.683 582.376C278.683 580.547 277.194 579.066 275.365 579.066Z"
            fill="white"
          />
          <path
            d="M269.953 574.662C268.099 574.662 266.601 576.173 266.601 578.023C266.601 579.873 268.099 581.384 269.953 581.384C271.808 581.384 273.314 579.873 273.314 578.023C273.314 576.173 271.816 574.662 269.953 574.662Z"
            fill="white"
          />
          <path
            d="M264.521 570.125C262.637 570.125 261.109 571.644 261.109 573.528C261.109 575.413 262.641 576.932 264.521 576.932C266.401 576.932 267.925 575.413 267.925 573.528C267.925 571.644 266.406 570.125 264.521 570.125Z"
            fill="white"
          />
          <path
            d="M258.996 565.377C257.09 565.377 255.55 566.917 255.55 568.823C255.55 570.728 257.09 572.277 258.996 572.277C260.901 572.277 262.442 570.728 262.442 568.823C262.442 566.917 260.901 565.377 258.996 565.377Z"
            fill="white"
          />
          <path
            d="M253.351 560.354C251.416 560.354 249.833 561.924 249.833 563.872C249.833 565.819 251.416 567.377 253.351 567.377C255.286 567.377 256.869 565.807 256.869 563.872C256.869 561.936 255.299 560.354 253.351 560.354Z"
            fill="white"
          />
          <path
            d="M247.597 555.057C245.632 555.057 244.036 556.648 244.036 558.617C244.036 560.586 245.628 562.178 247.597 562.178C249.566 562.178 251.157 560.574 251.157 558.617C251.157 556.661 249.553 555.057 247.597 555.057Z"
            fill="white"
          />
          <path
            d="M241.706 549.426C239.72 549.426 238.104 551.038 238.104 553.037C238.104 555.036 239.716 556.64 241.706 556.64C243.697 556.64 245.318 555.028 245.318 553.037C245.318 551.047 243.705 549.426 241.706 549.426Z"
            fill="white"
          />
          <path
            d="M235.722 543.471C233.724 543.471 232.09 545.105 232.09 547.112C232.09 549.119 233.724 550.744 235.722 550.744C237.721 550.744 239.355 549.111 239.355 547.112C239.355 545.113 237.73 543.471 235.722 543.471Z"
            fill="white"
          />
          <path
            d="M229.655 537.164C227.614 537.164 225.959 538.819 225.959 540.848C225.959 542.876 227.614 544.531 229.655 544.531C231.697 544.531 233.339 542.885 233.339 540.848C233.339 538.811 231.684 537.164 229.655 537.164Z"
            fill="white"
          />
          <path
            d="M223.484 530.588C221.434 530.588 219.767 532.251 219.767 534.305C219.767 536.359 221.43 538.031 223.484 538.031C225.538 538.031 227.21 536.368 227.21 534.305C227.21 532.243 225.547 530.588 223.484 530.588Z"
            fill="white"
          />
          <path
            d="M217.237 523.746C215.158 523.746 213.469 525.431 213.469 527.502C213.469 529.573 215.154 531.27 217.237 531.27C219.321 531.27 220.993 529.585 220.993 527.502C220.993 525.418 219.308 523.746 217.237 523.746Z"
            fill="white"
          />
          <path
            d="M210.897 516.701C208.805 516.701 207.107 518.399 207.107 520.491C207.107 522.583 208.805 524.281 210.897 524.281C212.989 524.281 214.687 522.583 214.687 520.491C214.687 518.399 212.989 516.701 210.897 516.701Z"
            fill="white"
          />
          <path
            d="M204.456 509.457C202.342 509.457 200.628 511.176 200.628 513.298C200.628 515.42 202.347 517.138 204.456 517.138C206.565 517.138 208.296 515.42 208.296 513.298C208.296 511.176 206.578 509.457 204.456 509.457Z"
            fill="white"
          />
          <path
            d="M197.878 502.15C195.744 502.15 194.008 503.878 194.008 506.012C194.008 508.147 195.748 509.874 197.878 509.874C200.008 509.874 201.74 508.147 201.74 506.012C201.74 503.878 200.013 502.15 197.878 502.15Z"
            fill="white"
          />
          <path
            d="M191.084 494.867C188.941 494.867 187.201 496.594 187.201 498.737C187.201 500.881 188.937 502.621 191.084 502.621C193.232 502.621 194.967 500.881 194.967 498.737C194.967 496.594 193.227 494.867 191.084 494.867Z"
            fill="white"
          />
          <path
            d="M184.005 487.662C181.84 487.662 180.092 489.411 180.092 491.575C180.092 493.739 181.84 495.479 184.005 495.479C186.169 495.479 187.909 493.731 187.909 491.575C187.909 489.419 186.16 487.662 184.005 487.662Z"
            fill="white"
          />
          <path
            d="M176.553 480.639C174.367 480.639 172.598 482.408 172.598 484.594C172.598 486.779 174.367 488.536 176.553 488.536C178.738 488.536 180.495 486.767 180.495 484.594C180.495 482.421 178.726 480.639 176.553 480.639Z"
            fill="white"
          />
          <path
            d="M168.727 473.789C166.542 473.789 164.764 475.567 164.764 477.753C164.764 479.938 166.542 481.716 168.727 481.716C170.913 481.716 172.691 479.947 172.691 477.753C172.691 475.559 170.921 473.789 168.727 473.789Z"
            fill="white"
          />
          <path
            d="M160.587 467.025C158.381 467.025 156.59 468.804 156.59 471.01C156.59 473.217 158.381 475.008 160.587 475.008C162.794 475.008 164.572 473.217 164.572 471.01C164.572 468.804 162.781 467.025 160.587 467.025Z"
            fill="white"
          />
          <path
            d="M152.168 460.346C149.953 460.346 148.162 462.137 148.162 464.352C148.162 466.567 149.953 468.358 152.168 468.358C154.383 468.358 156.174 466.567 156.174 464.352C156.174 462.137 154.383 460.346 152.168 460.346Z"
            fill="white"
          />
          <path
            d="M143.55 453.711C141.322 453.711 139.522 455.523 139.522 457.751C139.522 459.979 141.322 461.778 143.55 461.778C145.778 461.778 147.577 459.979 147.577 457.751C147.577 455.523 145.778 453.711 143.55 453.711Z"
            fill="white"
          />
          <path
            d="M134.777 447.133C132.549 447.133 130.737 448.932 130.737 451.173C130.737 453.414 132.549 455.213 134.777 455.213C137.005 455.213 138.826 453.401 138.826 451.173C138.826 448.945 137.014 447.133 134.777 447.133Z"
            fill="white"
          />
          <path
            d="M125.941 440.441C123.705 440.441 121.893 442.254 121.893 444.49C121.893 446.726 123.705 448.538 125.941 448.538C128.178 448.538 129.981 446.726 129.981 444.49C129.981 442.254 128.169 440.441 125.941 440.441Z"
            fill="white"
          />
          <path
            d="M117.093 433.482C114.844 433.482 113.036 435.303 113.036 437.539C113.036 439.776 114.848 441.596 117.093 441.596C119.338 441.596 121.15 439.776 121.15 437.539C121.15 435.303 119.33 433.482 117.093 433.482Z"
            fill="white"
          />
          <path
            d="M108.288 426.123C106.038 426.123 104.218 427.944 104.218 430.193C104.218 432.442 106.038 434.263 108.288 434.263C110.537 434.263 112.357 432.442 112.357 430.193C112.357 427.944 110.537 426.123 108.288 426.123Z"
            fill="white"
          />
          <path
            d="M99.5753 418.234C97.3261 418.234 95.4971 420.055 95.4971 422.313C95.4971 424.57 97.3304 426.391 99.5753 426.391C101.82 426.391 103.654 424.57 103.654 422.313C103.654 420.055 101.833 418.234 99.5753 418.234Z"
            fill="white"
          />
          <path
            d="M91.0118 409.656C88.7542 409.656 86.9336 411.477 86.9336 413.734C86.9336 415.992 88.7542 417.813 91.0118 417.813C93.2695 417.813 95.0901 415.992 95.0901 413.734C95.0901 411.477 93.2695 409.656 91.0118 409.656Z"
            fill="white"
          />
          <path
            d="M82.6632 408.368C84.9226 408.368 86.7542 406.536 86.7542 404.277C86.7542 402.017 84.9226 400.186 82.6632 400.186C80.4039 400.186 78.5723 402.017 78.5723 404.277C78.5723 406.536 80.4039 408.368 82.6632 408.368Z"
            fill="white"
          />
          <path
            d="M74.6183 397.864C76.8777 397.864 78.7093 396.032 78.7093 393.773C78.7093 391.513 76.8777 389.682 74.6183 389.682C72.3589 389.682 70.5273 391.513 70.5273 393.773C70.5273 396.032 72.3589 397.864 74.6183 397.864Z"
            fill="white"
          />
          <path
            d="M66.8732 378.432C64.6155 378.432 62.7822 380.265 62.7822 382.523C62.7822 384.78 64.6155 386.614 66.8732 386.614C69.1309 386.614 70.9727 384.78 70.9727 382.523C70.9727 380.265 69.1394 378.432 66.8732 378.432Z"
            fill="white"
          />
          <path
            d="M59.383 366.965C57.1253 366.965 55.292 368.798 55.292 371.056C55.292 373.313 57.1253 375.147 59.383 375.147C61.6406 375.147 63.4739 373.313 63.4739 371.056C63.4739 368.798 61.6406 366.965 59.383 366.965Z"
            fill="white"
          />
          <path
            d="M51.9689 355.975C49.7112 355.975 47.8779 357.808 47.8779 360.066C47.8779 362.323 49.7112 364.144 51.9689 364.144C54.2266 364.144 56.0472 362.323 56.0472 360.066C56.0472 357.808 54.2266 355.975 51.9689 355.975Z"
            fill="white"
          />
          <path
            d="M58.4662 344.617C56.2171 344.617 54.3965 346.438 54.3965 348.687C54.3965 350.936 56.2171 352.765 58.4662 352.765C60.7154 352.765 62.5445 350.945 62.5445 348.687C62.5445 346.429 60.7239 344.617 58.4662 344.617Z"
            fill="white"
          />
          <path
            d="M65.1069 332.557C62.8577 332.557 61.0371 334.377 61.0371 336.626C61.0371 338.876 62.8577 340.696 65.1069 340.696C67.3561 340.696 69.1766 338.876 69.1766 336.626C69.1766 334.377 67.3561 332.557 65.1069 332.557Z"
            fill="white"
          />
          <path
            d="M71.9525 319.703C69.7161 319.703 67.8955 321.524 67.8955 323.76C67.8955 325.997 69.7161 327.817 71.9525 327.817C74.189 327.817 76.0096 326.005 76.0096 323.76C76.0096 321.515 74.189 319.703 71.9525 319.703Z"
            fill="white"
          />
          <path
            d="M79.0232 306.182C76.7867 306.182 74.9746 307.994 74.9746 310.23C74.9746 312.467 76.7867 314.27 79.0232 314.27C81.2596 314.27 83.0632 312.458 83.0632 310.23C83.0632 308.002 81.2511 306.182 79.0232 306.182Z"
            fill="white"
          />
          <path
            d="M86.3987 291.973C84.1835 291.973 82.3799 293.772 82.3799 296C82.3799 298.228 84.1792 300.027 86.3987 300.027C88.6182 300.027 90.426 298.215 90.426 296C90.426 293.785 88.6267 291.973 86.3987 291.973Z"
            fill="white"
          />
          <path
            d="M94.0501 277.477C91.8348 277.477 90.0312 279.276 90.0312 281.495C90.0312 283.715 91.8306 285.514 94.0501 285.514C96.2696 285.514 98.0689 283.715 98.0689 281.495C98.0689 279.276 96.278 277.477 94.0501 277.477Z"
            fill="white"
          />
          <path
            d="M101.908 263.104C99.7017 263.104 97.9023 264.894 97.9023 267.11C97.9023 269.325 99.7017 271.107 101.908 271.107C104.115 271.107 105.906 269.316 105.906 267.11C105.906 264.903 104.115 263.104 101.908 263.104Z"
            fill="white"
          />
          <path
            d="M109.82 249.291C107.613 249.291 105.835 251.069 105.835 253.276C105.835 255.483 107.613 257.261 109.82 257.261C112.027 257.261 113.796 255.47 113.796 253.276C113.796 251.082 112.018 249.291 109.82 249.291Z"
            fill="white"
          />
          <path
            d="M117.56 236.449C115.374 236.449 113.604 238.219 113.604 240.396C113.604 242.573 115.374 244.351 117.56 244.351C119.745 244.351 121.502 242.581 121.502 240.396C121.502 238.21 119.732 236.449 117.56 236.449Z"
            fill="white"
          />
          <path
            d="M124.983 224.678C122.819 224.678 121.058 226.435 121.058 228.603C121.058 230.772 122.815 232.529 124.983 232.529C127.152 232.529 128.909 230.78 128.909 228.603C128.909 226.426 127.147 224.678 124.983 224.678Z"
            fill="white"
          />
          <path
            d="M132.027 213.914C129.863 213.914 128.114 215.662 128.114 217.827C128.114 219.991 129.863 221.731 132.027 221.731C134.191 221.731 135.931 219.983 135.931 217.827C135.931 215.671 134.183 213.914 132.027 213.914Z"
            fill="white"
          />
          <path
            d="M138.617 204.256C136.474 204.256 134.747 205.996 134.747 208.139C134.747 210.282 136.474 212.009 138.617 212.009C140.76 212.009 142.488 210.282 142.488 208.139C142.488 205.996 140.76 204.256 138.617 204.256Z"
            fill="white"
          />
          <path
            d="M144.682 195.992C142.569 195.992 140.854 197.711 140.854 199.824C140.854 201.938 142.573 203.652 144.682 203.652C146.791 203.652 148.514 201.946 148.514 199.824C148.514 197.702 146.808 195.992 144.682 195.992Z"
            fill="white"
          />
          <path
            d="M150.199 189.254C148.098 189.254 146.388 190.956 146.388 193.056C146.388 195.157 148.094 196.859 150.199 196.859C152.303 196.859 154.009 195.157 154.009 193.056C154.009 190.956 152.303 189.254 150.199 189.254Z"
            fill="white"
          />
          <path
            d="M155.185 183.686C153.106 183.686 151.408 185.379 151.408 187.458C151.408 189.538 153.106 191.227 155.185 191.227C157.265 191.227 158.954 189.542 158.954 187.458C158.954 185.375 157.269 183.686 155.185 183.686Z"
            fill="white"
          />
          <path
            d="M159.671 178.934C157.609 178.934 155.937 180.61 155.937 182.677C155.937 184.743 157.613 186.42 159.671 186.42C161.729 186.42 163.406 184.743 163.406 182.677C163.406 180.61 161.729 178.934 159.671 178.934Z"
            fill="white"
          />
          <path
            d="M163.678 174.783C161.637 174.783 159.981 176.438 159.981 178.48C159.981 180.521 161.637 182.18 163.678 182.18C165.719 182.18 167.374 180.525 167.374 178.48C167.374 176.434 165.727 174.783 163.678 174.783Z"
            fill="white"
          />
          <path
            d="M167.238 171.023C165.218 171.023 163.584 172.657 163.584 174.677C163.584 176.697 165.218 178.331 167.238 178.331C169.258 178.331 170.892 176.697 170.892 174.677C170.892 172.657 169.258 171.023 167.238 171.023Z"
            fill="white"
          />
          <path
            d="M170.348 167.475C168.35 167.475 166.729 169.1 166.729 171.095C166.729 173.089 168.354 174.71 170.348 174.71C172.343 174.71 173.968 173.093 173.968 171.095C173.968 169.096 172.347 167.475 170.348 167.475Z"
            fill="white"
          />
          <path
            d="M173.048 164.029C171.07 164.029 169.466 165.633 169.466 167.611C169.466 169.589 171.07 171.18 173.048 171.18C175.025 171.18 176.617 169.584 176.617 167.611C176.617 165.638 175.012 164.029 173.048 164.029Z"
            fill="white"
          />
          <path
            d="M175.327 160.66C173.379 160.66 171.809 162.23 171.809 164.165C171.809 166.101 173.379 167.679 175.327 167.679C177.275 167.679 178.832 166.109 178.832 164.165C178.832 162.222 177.262 160.66 175.327 160.66Z"
            fill="white"
          />
          <path
            d="M177.232 164.249C179.147 164.249 180.699 162.696 180.699 160.782C180.699 158.867 179.147 157.314 177.232 157.314C175.317 157.314 173.765 158.867 173.765 160.782C173.765 162.696 175.317 164.249 177.232 164.249Z"
            fill="white"
          />
          <path
            d="M178.802 160.898C180.686 160.898 182.214 159.366 182.214 157.477C182.214 155.588 180.686 154.057 178.802 154.057C176.917 154.057 175.39 155.588 175.39 157.477C175.39 159.366 176.917 160.898 178.802 160.898Z"
            fill="white"
          />
          <path
            d="M180.099 150.928C178.236 150.928 176.726 152.439 176.726 154.302C176.726 156.165 178.236 157.68 180.099 157.68C181.962 157.68 183.473 156.165 183.473 154.302C183.473 152.439 181.962 150.928 180.099 150.928Z"
            fill="white"
          />
          <path
            d="M181.167 147.938C179.346 147.938 177.869 149.419 177.869 151.243C177.869 153.068 179.346 154.554 181.167 154.554C182.987 154.554 184.477 153.077 184.477 151.243C184.477 149.41 183 147.938 181.167 147.938Z"
            fill="white"
          />
          <path
            d="M182.048 145.006C180.257 145.006 178.802 146.461 178.802 148.257C178.802 150.052 180.257 151.507 182.048 151.507C183.839 151.507 185.307 150.052 185.307 148.257C185.307 146.461 183.852 145.006 182.048 145.006Z"
            fill="white"
          />
          <path
            d="M182.778 142.084C181.021 142.084 179.582 143.514 179.582 145.284C179.582 147.053 181.016 148.488 182.778 148.488C184.539 148.488 185.982 147.053 185.982 145.284C185.982 143.514 184.547 142.084 182.778 142.084Z"
            fill="white"
          />
          <path
            d="M183.381 139.117C181.632 139.117 180.228 140.526 180.228 142.27C180.228 144.014 181.632 145.428 183.381 145.428C185.129 145.428 186.534 144.01 186.534 142.27C186.534 140.53 185.116 139.117 183.381 139.117Z"
            fill="white"
          />
          <path
            d="M183.868 136.076C182.171 136.076 180.796 137.443 180.796 139.136C180.796 140.829 182.171 142.196 183.868 142.196C185.566 142.196 186.928 140.821 186.928 139.136C186.928 137.451 185.553 136.076 183.868 136.076Z"
            fill="white"
          />
          <path
            d="M184.275 132.773C182.612 132.773 181.267 134.114 181.267 135.782C181.267 137.45 182.608 138.795 184.275 138.795C185.943 138.795 187.284 137.446 187.284 135.782C187.284 134.119 185.943 132.773 184.275 132.773Z"
            fill="white"
          />
          <path
            d="M184.662 129.174C183.028 129.174 181.704 130.502 181.704 132.132C181.704 133.761 183.028 135.09 184.662 135.09C186.296 135.09 187.62 133.766 187.62 132.132C187.62 130.498 186.296 129.174 184.662 129.174Z"
            fill="white"
          />
          <path
            d="M185.087 125.182C183.482 125.182 182.192 126.476 182.192 128.072C182.192 129.667 183.482 130.966 185.087 130.966C186.691 130.966 187.968 129.672 187.968 128.072C187.968 126.472 186.678 125.182 185.087 125.182Z"
            fill="white"
          />
          <path
            d="M185.703 120.629C184.154 120.629 182.894 121.881 182.894 123.43C182.894 124.979 184.154 126.235 185.703 126.235C187.252 126.235 188.504 124.983 188.504 123.43C188.504 121.877 187.243 120.629 185.703 120.629Z"
            fill="white"
          />
          <path
            d="M186.755 115.232C185.244 115.232 184.018 116.455 184.018 117.965C184.018 119.476 185.244 120.703 186.755 120.703C188.266 120.703 189.492 119.48 189.492 117.965C189.492 116.45 188.266 115.232 186.755 115.232Z"
            fill="white"
          />
          <path
            d="M188.618 108.66C187.141 108.66 185.944 109.857 185.944 111.334C185.944 112.811 187.141 114.016 188.618 114.016C190.095 114.016 191.291 112.815 191.291 111.334C191.291 109.853 190.095 108.66 188.618 108.66Z"
            fill="white"
          />
          <path
            d="M191.906 100.416C190.459 100.416 189.292 101.583 189.292 103.03C189.292 104.477 190.459 105.644 191.906 105.644C193.353 105.644 194.52 104.469 194.52 103.03C194.52 101.592 193.353 100.416 191.906 100.416Z"
            fill="white"
          />
          <path
            d="M197.67 89.6875C196.287 89.6875 195.162 90.8121 195.162 92.1956C195.162 93.579 196.287 94.7036 197.67 94.7036C199.054 94.7036 200.178 93.579 200.178 92.1956C200.178 90.8121 199.054 89.6875 197.67 89.6875Z"
            fill="white"
          />
          <path
            d="M207.478 75.1602C206.124 75.1602 205.033 76.2593 205.033 77.613C205.033 78.9668 206.124 80.0574 207.478 80.0574C208.831 80.0574 209.922 78.9626 209.922 77.613C209.922 76.2635 208.831 75.1602 207.478 75.1602Z"
            fill="white"
          />
          <path
            d="M222.878 55.2871C221.554 55.2871 220.484 56.348 220.484 57.6721C220.484 58.9961 221.558 60.0571 222.878 60.0571C224.198 60.0571 225.263 58.9919 225.263 57.6721C225.263 56.3523 224.189 55.2871 222.878 55.2871Z"
            fill="white"
          />
          <path
            d="M242.632 49.7051C241.312 49.7051 240.247 50.7703 240.247 52.0816C240.247 53.3929 241.308 54.4666 242.632 54.4666C243.956 54.4666 245.004 53.4014 245.004 52.0816C245.004 50.7618 243.943 49.7051 242.632 49.7051Z"
            fill="white"
          />
          <path
            d="M265.362 39.5645C264.05 39.5645 262.977 40.6254 262.977 41.9367C262.977 43.248 264.05 44.3217 265.362 44.3217C266.673 44.3217 267.734 43.248 267.734 41.9367C267.734 40.6254 266.673 39.5645 265.362 39.5645Z"
            fill="white"
          />
          <path
            d="M290.561 24.1836C289.241 24.1836 288.176 25.2488 288.176 26.5601C288.176 27.8714 289.237 28.9451 290.561 28.9451C291.885 28.9451 292.933 27.8841 292.933 26.5601C292.933 25.236 291.872 24.1836 290.561 24.1836Z"
            fill="white"
          />
          <path
            d="M316.651 4.33594C315.331 4.33594 314.258 5.40112 314.258 6.72517C314.258 8.04922 315.331 9.11015 316.651 9.11015C317.971 9.11015 319.036 8.04497 319.036 6.72517C319.036 5.40536 317.963 4.33594 316.651 4.33594Z"
            fill="white"
          />
          <path
            d="M890.649 -3.84961C888.994 -3.84961 887.661 -2.51283 887.661 -0.86201C887.661 0.788809 888.994 2.12559 890.649 2.12559C892.304 2.12559 893.636 0.793052 893.636 -0.86201C893.636 -2.51707 892.304 -3.84961 890.649 -3.84961Z"
            fill="white"
          />
          <path
            d="M898.07 6.91211C896.364 6.91211 894.989 8.28708 894.989 9.99307C894.989 11.6991 896.364 13.074 898.07 13.074C899.776 13.074 901.151 11.6906 901.151 9.99307C901.151 8.29557 899.768 6.91211 898.07 6.91211Z"
            fill="white"
          />
          <path
            d="M905.315 18.002C903.587 18.002 902.17 19.4066 902.17 21.1381C902.17 22.8695 903.587 24.2827 905.315 24.2827C907.042 24.2827 908.459 22.878 908.459 21.1381C908.459 19.3981 907.055 18.002 905.315 18.002Z"
            fill="white"
          />
          <path
            d="M912.402 29.3887C910.641 29.3887 909.215 30.8146 909.215 32.58C909.215 34.3454 910.641 35.767 912.402 35.767C914.163 35.767 915.589 34.3411 915.589 32.58C915.589 30.8188 914.163 29.3887 912.402 29.3887Z"
            fill="white"
          />
          <path
            d="M919.324 40.998C917.524 40.998 916.064 42.4537 916.064 44.2572C916.064 46.0608 917.52 47.5037 919.324 47.5037C921.127 47.5037 922.57 46.0481 922.57 44.2572C922.57 42.4664 921.114 40.998 919.324 40.998Z"
            fill="white"
          />
          <path
            d="M926.109 52.7793C924.267 52.7793 922.777 54.2689 922.777 56.1106C922.777 57.9524 924.267 59.4292 926.109 59.4292C927.951 59.4292 929.427 57.9397 929.427 56.1106C929.427 54.2816 927.938 52.7793 926.109 52.7793Z"
            fill="white"
          />
          <path
            d="M932.78 71.4644C934.643 71.4644 936.154 69.9539 936.154 68.0906C936.154 66.2273 934.643 64.7168 932.78 64.7168C930.917 64.7168 929.406 66.2273 929.406 68.0906C929.406 69.9539 930.917 71.4644 932.78 71.4644Z"
            fill="white"
          />
          <path
            d="M939.329 76.8125C937.436 76.8125 935.896 78.3445 935.896 80.2415C935.896 82.1384 937.436 83.6704 939.329 83.6704C941.221 83.6704 942.762 82.1384 942.762 80.2415C942.762 78.3445 941.221 76.8125 939.329 76.8125Z"
            fill="white"
          />
          <path
            d="M945.771 89.0859C943.844 89.0859 942.295 90.6392 942.295 92.5616C942.295 94.484 943.844 96.0414 945.771 96.0414C947.697 96.0414 949.246 94.484 949.246 92.5616C949.246 90.6392 947.697 89.0859 945.771 89.0859Z"
            fill="white"
          />
          <path
            d="M952.127 101.506C950.171 101.506 948.588 103.093 948.588 105.045C948.588 106.997 950.171 108.584 952.127 108.584C954.084 108.584 955.666 106.997 955.666 105.045C955.666 103.093 954.075 101.506 952.127 101.506Z"
            fill="white"
          />
          <path
            d="M958.433 114.062C956.456 114.062 954.852 115.667 954.852 117.653C954.852 119.639 956.456 121.234 958.433 121.234C960.411 121.234 962.023 119.63 962.023 117.653C962.023 115.675 960.419 114.062 958.433 114.062Z"
            fill="white"
          />
          <path
            d="M964.745 126.727C962.746 126.727 961.112 128.352 961.112 130.359C961.112 132.367 962.746 133.992 964.745 133.992C966.744 133.992 968.386 132.367 968.386 130.359C968.386 128.352 966.752 126.727 964.745 126.727Z"
            fill="white"
          />
          <path
            d="M971.092 139.488C969.064 139.488 967.417 141.139 967.417 143.168C967.417 145.196 969.064 146.843 971.092 146.843C973.121 146.843 974.767 145.192 974.767 143.168C974.767 141.143 973.121 139.488 971.092 139.488Z"
            fill="white"
          />
          <path
            d="M977.463 152.385C975.401 152.385 973.729 154.061 973.729 156.119C973.729 158.177 975.405 159.862 977.463 159.862C979.521 159.862 981.198 158.19 981.198 156.119C981.198 154.048 979.534 152.385 977.463 152.385Z"
            fill="white"
          />
          <path
            d="M983.913 165.447C981.833 165.447 980.145 167.141 980.145 169.22C980.145 171.299 981.829 172.993 983.913 172.993C985.997 172.993 987.681 171.308 987.681 169.22C987.681 167.132 985.997 165.447 983.913 165.447Z"
            fill="white"
          />
          <path
            d="M990.513 178.562C988.412 178.562 986.702 180.268 986.702 182.378C986.702 184.487 988.408 186.189 990.513 186.189C992.618 186.189 994.324 184.483 994.324 182.378C994.324 180.273 992.618 178.562 990.513 178.562Z"
            fill="white"
          />
          <path
            d="M997.362 191.529C995.24 191.529 993.521 193.257 993.521 195.378C993.521 197.5 995.24 199.227 997.362 199.227C999.484 199.227 1001.21 197.5 1001.21 195.378C1001.21 193.257 999.492 191.529 997.362 191.529Z"
            fill="white"
          />
          <path
            d="M1004.58 203.996C1002.43 203.996 1000.69 205.745 1000.69 207.888C1000.69 210.031 1002.43 211.792 1004.58 211.792C1006.74 211.792 1008.49 210.043 1008.49 207.888C1008.49 205.732 1006.74 203.996 1004.58 203.996Z"
            fill="white"
          />
          <path
            d="M1012.24 215.77C1010.08 215.77 1008.32 217.531 1008.32 219.695C1008.32 221.859 1010.08 223.629 1012.24 223.629C1014.41 223.629 1016.17 221.868 1016.17 219.695C1016.17 217.522 1014.41 215.77 1012.24 215.77Z"
            fill="white"
          />
          <path
            d="M1020.38 226.604C1018.2 226.604 1016.43 228.382 1016.43 230.559C1016.43 232.736 1018.2 234.522 1020.38 234.522C1022.57 234.522 1024.34 232.744 1024.34 230.559C1024.34 228.373 1022.57 226.604 1020.38 226.604Z"
            fill="white"
          />
          <path
            d="M1028.97 236.363C1026.76 236.363 1024.98 238.154 1024.98 240.348C1024.98 242.542 1026.76 244.333 1028.97 244.333C1031.18 244.333 1032.95 242.555 1032.95 240.348C1032.95 238.141 1031.16 236.363 1028.97 236.363Z"
            fill="white"
          />
          <path
            d="M1037.95 244.951C1035.72 244.951 1033.92 246.751 1033.92 248.978C1033.92 251.206 1035.72 253.006 1037.95 253.006C1040.18 253.006 1041.98 251.206 1041.98 248.978C1041.98 246.751 1040.18 244.951 1037.95 244.951Z"
            fill="white"
          />
          <path
            d="M1047.23 252.393C1045.01 252.393 1043.19 254.205 1043.19 256.441C1043.19 258.678 1045.01 260.49 1047.23 260.49C1049.46 260.49 1051.28 258.678 1051.28 256.441C1051.28 254.205 1049.47 252.393 1047.23 252.393Z"
            fill="white"
          />
          <path
            d="M1056.74 258.74C1054.49 258.74 1052.66 260.574 1052.66 262.818C1052.66 265.063 1054.49 266.888 1056.74 266.888C1058.98 266.888 1060.81 265.068 1060.81 262.818C1060.81 260.569 1058.99 258.74 1056.74 258.74Z"
            fill="white"
          />
          <path
            d="M1066.36 264.143C1064.1 264.143 1062.26 265.976 1062.26 268.234C1062.26 270.491 1064.1 272.333 1066.36 272.333C1068.61 272.333 1070.45 270.491 1070.45 268.234C1070.45 265.976 1068.61 264.143 1066.36 264.143Z"
            fill="white"
          />
          <path
            d="M1076.02 268.736C1073.74 268.736 1071.89 270.578 1071.89 272.857C1071.89 275.136 1073.74 276.978 1076.02 276.978C1078.29 276.978 1080.14 275.136 1080.14 272.857C1080.14 270.578 1078.29 268.736 1076.02 268.736Z"
            fill="white"
          />
          <path
            d="M1085.66 272.719C1083.37 272.719 1081.51 274.582 1081.51 276.861C1081.51 279.14 1083.37 281.015 1085.66 281.015C1087.95 281.015 1089.8 279.152 1089.8 276.861C1089.8 274.569 1087.95 272.719 1085.66 272.719Z"
            fill="white"
          />
          <path
            d="M1095.27 276.26C1092.98 276.26 1091.11 278.123 1091.11 280.414C1091.11 282.706 1092.98 284.569 1095.27 284.569C1097.56 284.569 1099.43 282.719 1099.43 280.414C1099.43 278.11 1097.57 276.26 1095.27 276.26Z"
            fill="white"
          />
          <path
            d="M1104.86 279.441C1102.56 279.441 1100.71 281.304 1100.71 283.596C1100.71 285.888 1102.56 287.751 1104.86 287.751C1107.16 287.751 1109.02 285.896 1109.02 283.596C1109.02 281.296 1107.16 279.441 1104.86 279.441Z"
            fill="white"
          />
          <path
            d="M1114.43 282.357C1112.13 282.357 1110.28 284.22 1110.28 286.512C1110.28 288.804 1112.13 290.667 1114.43 290.667C1116.73 290.667 1118.58 288.804 1118.58 286.512C1118.58 284.22 1116.72 282.357 1114.43 282.357Z"
            fill="white"
          />
          <path
            d="M1123.97 285.074C1121.67 285.074 1119.81 286.937 1119.81 289.229C1119.81 291.52 1121.67 293.383 1123.97 293.383C1126.27 293.383 1128.13 291.533 1128.13 289.229C1128.13 286.924 1126.27 285.074 1123.97 285.074Z"
            fill="white"
          />
          <path
            d="M1133.48 287.697C1131.18 287.697 1129.32 289.552 1129.32 291.852C1129.32 294.152 1131.18 296.007 1133.48 296.007C1135.78 296.007 1137.63 294.144 1137.63 291.852C1137.63 289.56 1135.77 287.697 1133.48 287.697Z"
            fill="white"
          />
          <path
            d="M1142.93 290.248C1140.63 290.248 1138.77 292.103 1138.77 294.403C1138.77 296.703 1140.63 298.557 1142.93 298.557C1145.22 298.557 1147.08 296.694 1147.08 294.403C1147.08 292.111 1145.22 290.248 1142.93 290.248Z"
            fill="white"
          />
          <path
            d="M1152.31 292.746C1150.01 292.746 1148.15 294.601 1148.15 296.901C1148.15 299.201 1150.01 301.055 1152.31 301.055C1154.61 301.055 1156.46 299.192 1156.46 296.901C1156.46 294.609 1154.6 292.746 1152.31 292.746Z"
            fill="white"
          />
          <path
            d="M1147.78 292.871C1145.48 292.871 1143.61 294.734 1143.61 297.026C1143.61 299.317 1145.48 301.18 1147.78 301.18C1150.08 301.18 1151.93 299.317 1151.93 297.026C1151.93 294.734 1150.07 292.871 1147.78 292.871Z"
            fill="white"
          />
          <path
            d="M1142.93 292.92C1140.64 292.92 1138.78 294.774 1138.78 297.075C1138.78 299.375 1140.64 301.229 1142.93 301.229C1145.23 301.229 1147.09 299.366 1147.09 297.075C1147.09 294.783 1145.24 292.92 1142.93 292.92Z"
            fill="white"
          />
          <path
            d="M1137.8 292.912C1135.51 292.912 1133.65 294.767 1133.65 297.067C1133.65 299.367 1135.51 301.221 1137.8 301.221C1140.1 301.221 1141.96 299.358 1141.96 297.067C1141.96 294.775 1140.11 292.912 1137.8 292.912Z"
            fill="white"
          />
          <path
            d="M1132.39 292.859C1130.1 292.859 1128.24 294.722 1128.24 297.014C1128.24 299.306 1130.1 301.169 1132.39 301.169C1134.68 301.169 1136.55 299.314 1136.55 297.014C1136.55 294.714 1134.69 292.859 1132.39 292.859Z"
            fill="white"
          />
          <path
            d="M1126.7 292.805C1124.4 292.805 1122.55 294.659 1122.55 296.959C1122.55 299.259 1124.4 301.114 1126.7 301.114C1129 301.114 1130.85 299.251 1130.85 296.959C1130.85 294.668 1128.99 292.805 1126.7 292.805Z"
            fill="white"
          />
          <path
            d="M1120.72 292.756C1118.42 292.756 1116.56 294.619 1116.56 296.906C1116.56 299.194 1118.42 301.061 1120.72 301.061C1123.01 301.061 1124.87 299.211 1124.87 296.906C1124.87 294.602 1123.01 292.756 1120.72 292.756Z"
            fill="white"
          />
          <path
            d="M1114.45 292.734C1112.16 292.734 1110.3 294.597 1110.3 296.889C1110.3 299.181 1112.16 301.044 1114.45 301.044C1116.74 301.044 1118.61 299.193 1118.61 296.889C1118.61 294.585 1116.75 292.734 1114.45 292.734Z"
            fill="white"
          />
          <path
            d="M1107.89 292.756C1105.6 292.756 1103.74 294.606 1103.74 296.906C1103.74 299.206 1105.6 301.061 1107.89 301.061C1110.19 301.061 1112.05 299.198 1112.05 296.906C1112.05 294.615 1110.19 292.756 1107.89 292.756Z"
            fill="white"
          />
          <path
            d="M1101.05 292.826C1098.75 292.826 1096.89 294.681 1096.89 296.981C1096.89 299.281 1098.75 301.135 1101.05 301.135C1103.34 301.135 1105.2 299.272 1105.2 296.981C1105.2 294.689 1103.35 292.826 1101.05 292.826Z"
            fill="white"
          />
          <path
            d="M1093.91 292.982C1091.61 292.982 1089.75 294.837 1089.75 297.137C1089.75 299.437 1091.6 301.292 1093.91 301.292C1096.21 301.292 1098.06 299.429 1098.06 297.137C1098.06 294.845 1096.19 292.982 1093.91 292.982Z"
            fill="white"
          />
          <path
            d="M1086.46 293.258C1084.17 293.258 1082.31 295.121 1082.31 297.412C1082.31 299.704 1084.17 301.567 1086.46 301.567C1088.76 301.567 1090.62 299.704 1090.62 297.412C1090.62 295.121 1088.76 293.258 1086.46 293.258Z"
            fill="white"
          />
          <path
            d="M1078.74 293.701C1076.46 293.701 1074.62 295.551 1074.62 297.835C1074.62 300.118 1076.46 301.955 1078.74 301.955C1081.02 301.955 1082.86 300.105 1082.86 297.835C1082.86 295.564 1081.02 293.701 1078.74 293.701Z"
            fill="white"
          />
          <path
            d="M1070.74 294.316C1068.47 294.316 1066.62 296.158 1066.62 298.429C1066.62 300.699 1068.47 302.541 1070.74 302.541C1073.01 302.541 1074.85 300.707 1074.85 298.429C1074.85 296.15 1073.01 294.316 1070.74 294.316Z"
            fill="white"
          />
          <path
            d="M1062.47 303.301C1064.73 303.301 1066.56 301.47 1066.56 299.21C1066.56 296.951 1064.73 295.119 1062.47 295.119C1060.21 295.119 1058.38 296.951 1058.38 299.21C1058.38 301.47 1060.21 303.301 1062.47 303.301Z"
            fill="white"
          />
          <path
            d="M1053.95 296.094C1051.71 296.094 1049.89 297.914 1049.89 300.164C1049.89 302.413 1051.71 304.221 1053.95 304.221C1056.18 304.221 1058.02 302.408 1058.02 300.164C1058.02 297.919 1056.2 296.094 1053.95 296.094Z"
            fill="white"
          />
          <path
            d="M1045.2 297.291C1042.97 297.291 1041.16 299.09 1041.16 301.331C1041.16 303.572 1042.97 305.358 1045.2 305.358C1047.43 305.358 1049.24 303.559 1049.24 301.331C1049.24 299.103 1047.43 297.291 1045.2 297.291Z"
            fill="white"
          />
          <path
            d="M1036.23 298.717C1034.02 298.717 1032.23 300.508 1032.23 302.723C1032.23 304.938 1034.02 306.729 1036.23 306.729C1038.45 306.729 1040.24 304.93 1040.24 302.723C1040.24 300.516 1038.44 298.717 1036.23 298.717Z"
            fill="white"
          />
          <path
            d="M1027.72 308.258C1029.89 307.906 1031.36 305.863 1031.01 303.696C1030.65 301.528 1028.61 300.056 1026.44 300.408C1024.28 300.76 1022.8 302.802 1023.16 304.97C1023.51 307.138 1025.55 308.61 1027.72 308.258Z"
            fill="white"
          />
          <path
            d="M1017.74 302.385C1015.55 302.385 1013.79 304.154 1013.79 306.327C1013.79 308.5 1015.55 310.274 1017.74 310.274C1019.93 310.274 1021.68 308.517 1021.68 306.327C1021.68 304.137 1019.91 302.385 1017.74 302.385Z"
            fill="white"
          />
          <path
            d="M1008.2 304.59C1006.05 304.59 1004.3 306.338 1004.3 308.503C1004.3 310.667 1006.05 312.407 1008.2 312.407C1010.36 312.407 1012.11 310.658 1012.11 308.503C1012.11 306.347 1010.36 304.59 1008.2 304.59Z"
            fill="white"
          />
          <path
            d="M998.508 307.027C996.373 307.027 994.638 308.767 994.638 310.91C994.638 313.053 996.378 314.781 998.508 314.781C1000.64 314.781 1002.39 313.041 1002.39 310.91C1002.39 308.78 1000.66 307.027 998.508 307.027Z"
            fill="white"
          />
          <path
            d="M988.663 309.742C986.549 309.742 984.822 311.461 984.822 313.583C984.822 315.705 986.549 317.423 988.663 317.423C990.776 317.423 992.512 315.705 992.512 313.583C992.512 311.461 990.785 309.742 988.663 309.742Z"
            fill="white"
          />
          <path
            d="M978.689 312.758C976.576 312.758 974.87 314.464 974.87 316.569C974.87 318.674 976.576 320.38 978.689 320.38C980.803 320.38 982.5 318.674 982.5 316.569C982.5 314.464 980.794 312.758 978.689 312.758Z"
            fill="white"
          />
          <path
            d="M968.606 316.164C966.535 316.164 964.851 317.84 964.851 319.92C964.851 321.999 966.535 323.667 968.606 323.667C970.677 323.667 972.362 321.991 972.362 319.92C972.362 317.849 970.677 316.164 968.606 316.164Z"
            fill="white"
          />
          <path
            d="M958.446 319.963C956.396 319.963 954.732 321.626 954.732 323.68C954.732 325.734 956.396 327.398 958.446 327.398C960.495 327.398 962.163 325.734 962.163 323.68C962.163 321.626 960.5 319.963 958.446 319.963Z"
            fill="white"
          />
          <path
            d="M948.236 324.23C946.195 324.23 944.553 325.877 944.553 327.914C944.553 329.951 946.199 331.589 948.236 331.589C950.273 331.589 951.911 329.943 951.911 327.914C951.911 325.886 950.265 324.23 948.236 324.23Z"
            fill="white"
          />
          <path
            d="M938.004 329.061C935.996 329.061 934.371 330.682 934.371 332.693C934.371 334.705 935.992 336.326 938.004 336.326C940.015 336.326 941.636 334.7 941.636 332.693C941.636 330.686 940.003 329.061 938.004 329.061Z"
            fill="white"
          />
          <path
            d="M927.786 334.5C925.808 334.5 924.217 336.104 924.217 338.069C924.217 340.034 925.808 341.651 927.786 341.651C929.763 341.651 931.367 340.047 931.367 338.069C931.367 336.091 929.763 334.5 927.786 334.5Z"
            fill="white"
          />
          <path
            d="M918.421 347.57C920.316 347.123 921.49 345.223 921.043 343.328C920.595 341.432 918.696 340.258 916.8 340.706C914.905 341.153 913.731 343.052 914.178 344.948C914.626 346.843 916.525 348.017 918.421 347.57Z"
            fill="white"
          />
          <path
            d="M907.561 347.375C905.634 347.375 904.085 348.937 904.085 350.859C904.085 352.782 905.634 354.335 907.561 354.335C909.487 354.335 911.049 352.773 911.049 350.859C911.049 348.945 909.487 347.375 907.561 347.375Z"
            fill="white"
          />
          <path
            d="M897.655 354.951C895.749 354.951 894.222 356.492 894.222 358.384C894.222 360.277 895.754 361.818 897.655 361.818C899.556 361.818 901.088 360.277 901.088 358.384C901.088 356.492 899.548 354.951 897.655 354.951Z"
            fill="white"
          />
          <path
            d="M887.882 363.383C886.019 363.383 884.521 364.894 884.521 366.744C884.521 368.594 886.019 370.105 887.882 370.105C889.745 370.105 891.243 368.594 891.243 366.744C891.243 364.894 889.732 363.383 887.882 363.383Z"
            fill="white"
          />
          <path
            d="M878.316 372.834C876.482 372.834 874.997 374.311 874.997 376.144C874.997 377.977 876.487 379.454 878.316 379.454C880.145 379.454 881.626 377.977 881.626 376.144C881.626 374.311 880.149 372.834 878.316 372.834Z"
            fill="white"
          />
          <path
            d="M868.951 383.418C867.151 383.418 865.691 384.874 865.691 386.677C865.691 388.481 867.147 389.936 868.951 389.936C870.754 389.936 872.197 388.481 872.197 386.677C872.197 384.874 870.741 383.418 868.951 383.418Z"
            fill="white"
          />
          <path
            d="M859.864 395.422C858.095 395.422 856.66 396.856 856.66 398.639C856.66 400.421 858.095 401.843 859.864 401.843C861.634 401.843 863.081 400.404 863.081 398.639C863.081 396.873 861.647 395.422 859.864 395.422Z"
            fill="white"
          />
          <path
            d="M851.39 409.449C849.662 409.449 848.258 410.845 848.258 412.573C848.258 414.3 849.662 415.696 851.39 415.696C853.117 415.696 854.513 414.291 854.513 412.573C854.513 410.854 853.108 409.449 851.39 409.449Z"
            fill="white"
          />
          <path
            d="M844.021 426.123C842.315 426.123 840.94 427.507 840.94 429.204C840.94 430.902 842.315 432.285 844.021 432.285C845.727 432.285 847.09 430.902 847.09 429.204C847.09 427.507 845.715 426.123 844.021 426.123Z"
            fill="white"
          />
          <path
            d="M838.535 446.395C836.871 446.395 835.518 447.748 835.518 449.412C835.518 451.075 836.871 452.429 838.535 452.429C840.198 452.429 841.552 451.075 841.552 449.412C841.552 447.748 840.198 446.395 838.535 446.395Z"
            fill="white"
          />
          <path
            d="M844.303 491.93C842.72 491.93 841.43 493.211 841.43 494.803C841.43 496.394 842.72 497.676 844.303 497.676C845.886 497.676 847.176 496.386 847.176 494.803C847.176 493.22 845.886 491.93 844.303 491.93Z"
            fill="white"
          />
          <path
            d="M836.664 500.705C835.081 500.705 833.791 501.987 833.791 503.565C833.791 505.144 835.081 506.438 836.664 506.438C838.247 506.438 839.524 505.148 839.524 503.565C839.524 501.982 838.243 500.705 836.664 500.705Z"
            fill="white"
          />
          <path
            d="M828.702 509.873C827.119 509.873 825.842 511.163 825.842 512.746C825.842 514.329 827.123 515.606 828.702 515.606C830.281 515.606 831.575 514.325 831.575 512.746C831.575 511.167 830.285 509.873 828.702 509.873Z"
            fill="white"
          />
          <path
            d="M820.563 519.461C818.98 519.461 817.703 520.743 817.703 522.321C817.703 523.9 818.985 525.182 820.563 525.182C822.142 525.182 823.415 523.9 823.415 522.321C823.415 520.743 822.134 519.461 820.563 519.461Z"
            fill="white"
          />
          <path
            d="M812.101 529.162C810.519 529.162 809.241 530.444 809.241 532.014C809.241 533.584 810.523 534.874 812.101 534.874C813.68 534.874 814.953 533.593 814.953 532.014C814.953 530.435 813.672 529.162 812.101 529.162Z"
            fill="white"
          />
          <path
            d="M803.1 538.684C801.53 538.684 800.257 539.952 800.257 541.514C800.257 543.076 801.526 544.357 803.1 544.357C804.675 544.357 805.943 543.089 805.943 541.514C805.943 539.94 804.675 538.684 803.1 538.684Z"
            fill="white"
          />
          <path
            d="M793.615 548.008C792.053 548.008 790.784 549.277 790.784 550.838C790.784 552.4 792.053 553.682 793.615 553.682C795.176 553.682 796.445 552.413 796.445 550.838C796.445 549.264 795.176 548.008 793.615 548.008Z"
            fill="white"
          />
          <path
            d="M783.897 557.387C782.335 557.387 781.066 558.656 781.066 560.217C781.066 561.779 782.335 563.048 783.897 563.048C785.459 563.048 786.728 561.779 786.728 560.217C786.728 558.656 785.459 557.387 783.897 557.387Z"
            fill="white"
          />
          <path
            d="M773.767 566.451C772.205 566.451 770.937 567.72 770.937 569.282C770.937 570.843 772.205 572.112 773.767 572.112C775.329 572.112 776.598 570.843 776.598 569.282C776.598 567.72 775.329 566.451 773.767 566.451Z"
            fill="white"
          />
          <path
            d="M763.161 575.029C761.599 575.029 760.339 576.29 760.339 577.851C760.339 579.413 761.599 580.682 763.161 580.682C764.723 580.682 765.983 579.413 765.983 577.851C765.983 576.29 764.723 575.029 763.161 575.029Z"
            fill="white"
          />
          <path
            d="M752.056 583.096C750.495 583.096 749.234 584.356 749.234 585.918C749.234 587.48 750.495 588.727 752.056 588.727C753.618 588.727 754.866 587.467 754.866 585.918C754.866 584.369 753.605 583.096 752.056 583.096Z"
            fill="white"
          />
          <path
            d="M740.39 590.326C738.841 590.326 737.589 591.574 737.589 593.127C737.589 594.68 738.837 595.936 740.39 595.936C741.943 595.936 743.199 594.676 743.199 593.127C743.199 591.578 741.939 590.326 740.39 590.326Z"
            fill="white"
          />
          <path
            d="M728.223 596.572C726.682 596.572 725.422 597.833 725.422 599.373C725.422 600.914 726.682 602.174 728.223 602.174C729.763 602.174 731.024 600.926 731.024 599.373C731.024 597.82 729.763 596.572 728.223 596.572Z"
            fill="white"
          />
          <path
            d="M715.632 601.879C714.091 601.879 712.831 603.127 712.831 604.667C712.831 606.208 714.091 607.455 715.632 607.455C717.172 607.455 718.42 606.208 718.42 604.667C718.42 603.127 717.172 601.879 715.632 601.879Z"
            fill="white"
          />
          <path
            d="M702.671 606.232C701.131 606.232 699.883 607.48 699.883 609.021C699.883 610.561 701.131 611.809 702.671 611.809C704.211 611.809 705.459 610.561 705.459 609.021C705.459 607.48 704.211 606.232 702.671 606.232Z"
            fill="white"
          />
          <path
            d="M689.402 609.551C687.87 609.551 686.622 610.798 686.622 612.339C686.622 613.879 687.87 615.119 689.402 615.119C690.934 615.119 692.19 613.871 692.19 612.339C692.19 610.807 690.942 609.551 689.402 609.551Z"
            fill="white"
          />
          <path
            d="M675.924 611.924C674.383 611.924 673.136 613.172 673.136 614.712C673.136 616.252 674.383 617.492 675.924 617.492C677.464 617.492 678.704 616.244 678.704 614.712C678.704 613.18 677.456 611.924 675.924 611.924Z"
            fill="white"
          />
          <path
            d="M662.27 613.607C660.738 613.607 659.49 614.847 659.49 616.387C659.49 617.928 660.738 619.167 662.27 619.167C663.802 619.167 665.05 617.919 665.05 616.387C665.05 614.855 663.81 613.607 662.27 613.607Z"
            fill="white"
          />
          <path
            d="M648.457 614.543C646.925 614.543 645.69 615.791 645.69 617.323C645.69 618.855 646.93 620.102 648.457 620.102C649.985 620.102 651.237 618.855 651.237 617.323C651.237 615.791 649.989 614.543 648.457 614.543Z"
            fill="white"
          />
          <path
            d="M634.522 614.91C632.99 614.91 631.755 616.149 631.755 617.677C631.755 619.205 632.994 620.444 634.522 620.444C636.05 620.444 637.289 619.205 637.289 617.677C637.289 616.149 636.05 614.91 634.522 614.91Z"
            fill="white"
          />
          <path
            d="M620.462 614.91C618.942 614.91 617.703 616.149 617.703 617.677C617.703 619.205 618.942 620.444 620.462 620.444C621.981 620.444 623.228 619.205 623.228 617.677C623.228 616.149 621.989 614.91 620.462 614.91Z"
            fill="white"
          />
          <path
            d="M606.36 614.953C604.828 614.953 603.602 616.18 603.602 617.712C603.602 619.244 604.828 620.47 606.36 620.47C607.892 620.47 609.118 619.231 609.118 617.712C609.118 616.192 607.879 614.953 606.36 614.953Z"
            fill="white"
          />
          <path
            d="M592.275 615.254C590.756 615.254 589.529 616.48 589.529 618.012C589.529 619.544 590.756 620.771 592.275 620.771C593.794 620.771 595.033 619.532 595.033 618.012C595.033 616.493 593.807 615.254 592.275 615.254Z"
            fill="white"
          />
          <path
            d="M578.257 615.869C576.738 615.869 575.499 617.096 575.499 618.615C575.499 620.134 576.738 621.373 578.257 621.373C579.777 621.373 581.016 620.147 581.016 618.615C581.016 617.083 579.789 615.869 578.257 615.869Z"
            fill="white"
          />
          <path
            d="M564.308 616.973C562.776 616.973 561.55 618.212 561.55 619.731C561.55 621.25 562.776 622.481 564.308 622.481C565.84 622.481 567.058 621.255 567.058 619.731C567.058 618.208 565.832 616.973 564.308 616.973Z"
            fill="white"
          />
          <path
            d="M550.464 618.627C548.945 618.627 547.719 619.853 547.719 621.373C547.719 622.892 548.945 624.118 550.464 624.118C551.984 624.118 553.21 622.892 553.21 621.373C553.21 619.853 551.984 618.627 550.464 618.627Z"
            fill="white"
          />
          <path
            d="M536.707 620.49C535.188 620.49 533.957 621.717 533.957 623.236C533.957 624.755 535.183 625.973 536.707 625.973C538.23 625.973 539.444 624.747 539.444 623.236C539.444 621.725 538.218 620.49 536.707 620.49Z"
            fill="white"
          />
          <path
            d="M522.97 622.549C521.451 622.549 520.225 623.775 520.225 625.286C520.225 626.797 521.451 628.032 522.97 628.032C524.49 628.032 525.708 626.805 525.708 625.286C525.708 623.767 524.481 622.549 522.97 622.549Z"
            fill="white"
          />
          <path
            d="M509.241 624.84C507.73 624.84 506.504 626.066 506.504 627.577C506.504 629.088 507.73 630.314 509.241 630.314C510.752 630.314 511.978 629.088 511.978 627.577C511.978 626.066 510.752 624.84 509.241 624.84Z"
            fill="white"
          />
          <path
            d="M495.491 627.068C493.972 627.068 492.754 628.295 492.754 629.806C492.754 631.316 493.972 632.543 495.491 632.543C497.01 632.543 498.22 631.316 498.22 629.806C498.22 628.295 497.002 627.068 495.491 627.068Z"
            fill="white"
          />
          <path
            d="M481.627 629.076C480.116 629.076 478.898 630.294 478.898 631.805C478.898 633.316 480.116 634.542 481.627 634.542C483.138 634.542 484.364 633.316 484.364 631.805C484.364 630.294 483.138 629.076 481.627 629.076Z"
            fill="white"
          />
          <path
            d="M467.61 630.887C466.099 630.887 464.881 632.105 464.881 633.615C464.881 635.126 466.099 636.344 467.61 636.344C469.12 636.344 470.338 635.118 470.338 633.615C470.338 632.113 469.12 630.887 467.61 630.887Z"
            fill="white"
          />
          <path
            d="M453.381 632.344C451.87 632.344 450.652 633.562 450.652 635.072C450.652 636.583 451.87 637.801 453.381 637.801C454.892 637.801 456.11 636.583 456.11 635.072C456.11 633.562 454.892 632.344 453.381 632.344Z"
            fill="white"
          />
          <path
            d="M438.854 633.145C437.344 633.145 436.117 634.371 436.117 635.882C436.117 637.393 437.344 638.61 438.854 638.61C440.365 638.61 441.583 637.393 441.583 635.882C441.583 634.371 440.365 633.145 438.854 633.145Z"
            fill="white"
          />
          <path
            d="M423.887 633.342C422.376 633.342 421.149 634.568 421.149 636.079C421.149 637.59 422.376 638.808 423.887 638.808C425.397 638.808 426.615 637.581 426.615 636.079C426.615 634.577 425.389 633.342 423.887 633.342Z"
            fill="white"
          />
          <path
            d="M408.367 632.832C406.857 632.832 405.639 634.05 405.639 635.561C405.639 637.072 406.857 638.298 408.367 638.298C409.878 638.298 411.096 637.072 411.096 635.561C411.096 634.05 409.878 632.832 408.367 632.832Z"
            fill="white"
          />
          <path
            d="M392.165 631.262C390.654 631.262 389.428 632.48 389.428 633.99C389.428 635.501 390.654 636.719 392.165 636.719C393.676 636.719 394.894 635.501 394.894 633.99C394.894 632.48 393.667 631.262 392.165 631.262Z"
            fill="white"
          />
          <path
            d="M375.126 628.703C373.628 628.703 372.397 629.921 372.397 631.432C372.397 632.943 373.624 634.161 375.126 634.161C376.628 634.161 377.855 632.943 377.855 631.432C377.855 629.921 376.637 628.703 375.126 628.703Z"
            fill="white"
          />
          <path
            d="M357.128 625.162C355.617 625.162 354.399 626.389 354.399 627.899C354.399 629.41 355.617 630.628 357.128 630.628C358.639 630.628 359.865 629.41 359.865 627.899C359.865 626.389 358.639 625.162 357.128 625.162Z"
            fill="white"
          />
          <path
            d="M338.031 620.334C336.533 620.334 335.303 621.56 335.303 623.071C335.303 624.582 336.529 625.8 338.031 625.8C339.534 625.8 340.769 624.573 340.769 623.071C340.769 621.569 339.542 620.334 338.031 620.334Z"
            fill="white"
          />
          <path
            d="M317.768 614.027C316.257 614.027 315.039 615.245 315.039 616.756C315.039 618.267 316.257 619.485 317.768 619.485C319.279 619.485 320.497 618.267 320.497 616.756C320.497 615.245 319.279 614.027 317.768 614.027Z"
            fill="white"
          />
          <path
            d="M309.106 608.654C307.545 608.654 306.284 609.915 306.284 611.476C306.284 613.038 307.545 614.299 309.106 614.299C310.668 614.299 311.928 613.038 311.928 611.476C311.928 609.915 310.668 608.654 309.106 608.654Z"
            fill="white"
          />
          <path
            d="M301.132 609.171C302.708 608.952 303.808 607.497 303.589 605.92C303.37 604.344 301.915 603.244 300.338 603.463C298.762 603.682 297.662 605.137 297.881 606.713C298.1 608.29 299.555 609.39 301.132 609.171Z"
            fill="white"
          />
          <path
            d="M293.059 598.309C291.434 598.309 290.114 599.628 290.114 601.254C290.114 602.879 291.434 604.19 293.059 604.19C294.685 604.19 296.005 602.879 296.005 601.254C296.005 599.628 294.685 598.309 293.059 598.309Z"
            fill="white"
          />
          <path
            d="M286.054 599.434C287.708 599.434 289.05 598.092 289.05 596.437C289.05 594.783 287.708 593.441 286.054 593.441C284.399 593.441 283.058 594.783 283.058 596.437C283.058 598.092 284.399 599.434 286.054 599.434Z"
            fill="white"
          />
          <path
            d="M279.777 588.787C278.08 588.787 276.696 590.162 276.696 591.868C276.696 593.574 278.08 594.957 279.777 594.957C281.475 594.957 282.867 593.574 282.867 591.868C282.867 590.162 281.483 588.787 279.777 588.787Z"
            fill="white"
          />
          <path
            d="M274.147 584.428C272.419 584.428 271.015 585.824 271.015 587.56C271.015 589.295 272.419 590.692 274.147 590.692C275.874 590.692 277.278 589.287 277.278 587.56C277.278 585.832 275.874 584.428 274.147 584.428Z"
            fill="white"
          />
          <path
            d="M268.935 580.188C267.178 580.188 265.748 581.613 265.748 583.375C265.748 585.136 267.174 586.57 268.935 586.57C270.696 586.57 272.131 585.144 272.131 583.375C272.131 581.605 270.705 580.188 268.935 580.188Z"
            fill="white"
          />
          <path
            d="M263.97 576.004C262.179 576.004 260.724 577.451 260.724 579.242C260.724 581.033 262.179 582.488 263.97 582.488C265.761 582.488 267.208 581.033 267.208 579.242C267.208 577.451 265.752 576.004 263.97 576.004Z"
            fill="white"
          />
          <path
            d="M259.09 571.76C257.257 571.76 255.771 573.237 255.771 575.07C255.771 576.903 257.261 578.389 259.09 578.389C260.919 578.389 262.409 576.899 262.409 575.07C262.409 573.241 260.919 571.76 259.09 571.76Z"
            fill="white"
          />
          <path
            d="M254.196 567.432C252.346 567.432 250.844 568.93 250.844 570.793C250.844 572.656 252.342 574.145 254.196 574.145C256.051 574.145 257.557 572.647 257.557 570.793C257.557 568.938 256.047 567.432 254.196 567.432Z"
            fill="white"
          />
          <path
            d="M249.223 562.926C247.351 562.926 245.819 564.445 245.819 566.329C245.819 568.214 247.351 569.733 249.223 569.733C251.094 569.733 252.626 568.201 252.626 566.329C252.626 564.458 251.107 562.926 249.223 562.926Z"
            fill="white"
          />
          <path
            d="M244.121 558.176C242.216 558.176 240.667 559.729 240.667 561.63C240.667 563.531 242.216 565.076 244.121 565.076C246.027 565.076 247.567 563.536 247.567 561.63C247.567 559.725 246.027 558.176 244.121 558.176Z"
            fill="white"
          />
          <path
            d="M238.863 553.152C236.916 553.152 235.337 554.723 235.337 556.67C235.337 558.618 236.92 560.201 238.863 560.201C240.807 560.201 242.382 558.618 242.382 556.67C242.382 554.723 240.799 553.152 238.863 553.152Z"
            fill="white"
          />
          <path
            d="M233.452 547.85C231.487 547.85 229.892 549.441 229.892 551.41C229.892 553.379 231.483 554.958 233.452 554.958C235.421 554.958 237 553.366 237 551.41C237 549.454 235.408 547.85 233.452 547.85Z"
            fill="white"
          />
          <path
            d="M227.886 542.254C225.9 542.254 224.296 543.867 224.296 545.853C224.296 547.839 225.9 549.443 227.886 549.443C229.872 549.443 231.489 547.839 231.489 545.853C231.489 543.867 229.876 542.254 227.886 542.254Z"
            fill="white"
          />
          <path
            d="M222.181 536.371C220.174 536.371 218.54 538.005 218.54 540.012C218.54 542.02 220.174 543.645 222.181 543.645C224.188 543.645 225.814 542.02 225.814 540.012C225.814 538.005 224.188 536.371 222.181 536.371Z"
            fill="white"
          />
          <path
            d="M216.342 530.209C214.313 530.209 212.658 531.856 212.658 533.893C212.658 535.93 214.313 537.576 216.342 537.576C218.37 537.576 220.025 535.93 220.025 533.893C220.025 531.856 218.379 530.209 216.342 530.209Z"
            fill="white"
          />
          <path
            d="M210.402 523.789C208.339 523.789 206.676 525.453 206.676 527.515C206.676 529.578 208.339 531.254 210.402 531.254C212.464 531.254 214.128 529.578 214.128 527.515C214.128 525.453 212.464 523.789 210.402 523.789Z"
            fill="white"
          />
          <path
            d="M204.341 517.141C202.27 517.141 200.585 518.825 200.585 520.909C200.585 522.993 202.27 524.665 204.341 524.665C206.412 524.665 208.109 522.98 208.109 520.909C208.109 518.838 206.424 517.141 204.341 517.141Z"
            fill="white"
          />
          <path
            d="M198.171 510.322C196.078 510.322 194.381 512.02 194.381 514.112C194.381 516.204 196.078 517.902 198.171 517.902C200.263 517.902 201.96 516.204 201.96 514.112C201.96 512.02 200.263 510.322 198.171 510.322Z"
            fill="white"
          />
          <path
            d="M191.844 503.389C189.73 503.389 188.012 505.095 188.012 507.217C188.012 509.338 189.73 511.049 191.844 511.049C193.957 511.049 195.672 509.33 195.672 507.217C195.672 505.103 193.953 503.389 191.844 503.389Z"
            fill="white"
          />
          <path
            d="M185.316 496.447C183.181 496.447 181.454 498.183 181.454 500.318C181.454 502.452 183.181 504.179 185.316 504.179C187.451 504.179 189.178 502.452 189.178 500.318C189.178 498.183 187.451 496.447 185.316 496.447Z"
            fill="white"
          />
          <path
            d="M178.487 489.65C176.344 489.65 174.596 491.386 174.596 493.533C174.596 495.681 176.344 497.425 178.487 497.425C180.63 497.425 182.379 495.685 182.379 493.533C182.379 491.382 180.639 489.65 178.487 489.65Z"
            fill="white"
          />
          <path
            d="M171.307 483.002C169.143 483.002 167.395 484.763 167.395 486.915C167.395 489.066 169.143 490.84 171.307 490.84C173.472 490.84 175.22 489.079 175.22 486.915C175.22 484.75 173.472 483.002 171.307 483.002Z"
            fill="white"
          />
          <path
            d="M163.753 476.488C161.567 476.488 159.798 478.245 159.798 480.431C159.798 482.616 161.567 484.373 163.753 484.373C165.939 484.373 167.695 482.603 167.695 480.431C167.695 478.258 165.926 476.488 163.753 476.488Z"
            fill="white"
          />
          <path
            d="M155.831 470.084C153.645 470.084 151.867 471.854 151.867 474.048C151.867 476.242 153.645 478.003 155.831 478.003C158.016 478.003 159.795 476.233 159.795 474.048C159.795 471.862 158.016 470.084 155.831 470.084Z"
            fill="white"
          />
          <path
            d="M147.597 463.779C145.39 463.779 143.612 465.57 143.612 467.764C143.612 469.958 145.39 471.762 147.597 471.762C149.804 471.762 151.582 469.971 151.582 467.764C151.582 465.557 149.804 463.779 147.597 463.779Z"
            fill="white"
          />
          <path
            d="M139.106 457.596C136.89 457.596 135.1 459.395 135.1 461.602C135.1 463.809 136.89 465.608 139.106 465.608C141.321 465.608 143.112 463.817 143.112 461.602C143.112 459.387 141.321 457.596 139.106 457.596Z"
            fill="white"
          />
          <path
            d="M130.415 451.453C128.187 451.453 126.388 453.265 126.388 455.493C126.388 457.721 128.187 459.52 130.415 459.52C132.643 459.52 134.442 457.721 134.442 455.493C134.442 453.265 132.643 451.453 130.415 451.453Z"
            fill="white"
          />
          <path
            d="M121.601 445.262C119.373 445.262 117.561 447.074 117.561 449.302C117.561 451.53 119.373 453.35 121.601 453.35C123.829 453.35 125.649 451.538 125.649 449.302C125.649 447.065 123.837 445.262 121.601 445.262Z"
            fill="white"
          />
          <path
            d="M112.73 438.863C110.494 438.863 108.682 440.675 108.682 442.912C108.682 445.148 110.494 446.969 112.73 446.969C114.967 446.969 116.787 445.157 116.787 442.912C116.787 440.667 114.975 438.863 112.73 438.863Z"
            fill="white"
          />
          <path
            d="M103.853 432.17C101.604 432.17 99.7832 433.99 99.7832 436.24C99.7832 438.489 101.604 440.309 103.853 440.309C106.102 440.309 107.914 438.489 107.914 436.24C107.914 433.99 106.094 432.17 103.853 432.17Z"
            fill="white"
          />
          <path
            d="M94.9877 425.07C92.7385 425.07 90.918 426.891 90.918 429.14C90.918 431.389 92.7385 433.218 94.9877 433.218C97.2369 433.218 99.0575 431.385 99.0575 429.14C99.0575 426.895 97.2369 425.07 94.9877 425.07Z"
            fill="white"
          />
          <path
            d="M86.1827 417.4C83.9335 417.4 82.1045 419.221 82.1045 421.479C82.1045 423.736 83.9378 425.557 86.1827 425.557C88.4277 425.557 90.2737 423.736 90.2737 421.479C90.2737 419.221 88.4404 417.4 86.1827 417.4Z"
            fill="white"
          />
          <path
            d="M81.3141 414.584C82.1788 412.497 81.1875 410.103 79.1001 409.239C77.0127 408.374 74.6196 409.365 73.755 411.453C72.8904 413.54 73.8816 415.933 75.969 416.798C78.0564 417.663 80.4495 416.671 81.3141 414.584Z"
            fill="white"
          />
          <path
            d="M69.1222 399.49C66.8645 399.49 65.0312 401.324 65.0312 403.581C65.0312 405.839 66.8645 407.681 69.1222 407.681C71.3799 407.681 73.2132 405.847 73.2132 403.581C73.2132 401.315 71.3799 399.49 69.1222 399.49Z"
            fill="white"
          />
          <path
            d="M61.0031 389.113C58.7454 389.113 56.9121 390.947 56.9121 393.204C56.9121 395.462 58.7454 397.295 61.0031 397.295C63.2608 397.295 65.0941 395.462 65.0941 393.204C65.0941 390.947 63.2608 389.113 61.0031 389.113Z"
            fill="white"
          />
          <path
            d="M53.1867 378.088C50.929 378.088 49.0957 379.921 49.0957 382.179C49.0957 384.437 50.929 386.278 53.1867 386.278C55.4444 386.278 57.2777 384.445 57.2777 382.179C57.2777 379.913 55.4444 378.088 53.1867 378.088Z"
            fill="white"
          />
          <path
            d="M45.5988 366.973C43.3411 366.973 41.5205 368.806 41.5205 371.051C41.5205 373.296 43.3411 375.142 45.5988 375.142C47.8564 375.142 49.6897 373.309 49.6897 371.051C49.6897 368.793 47.8564 366.973 45.5988 366.973Z"
            fill="white"
          />
          <path
            d="M38.1086 356.389C35.8509 356.389 34.0176 358.222 34.0176 360.467C34.0176 362.712 35.8509 364.558 38.1086 364.558C40.3662 364.558 42.1868 362.725 42.1868 360.467C42.1868 358.209 40.3662 356.389 38.1086 356.389Z"
            fill="white"
          />
          <path
            d="M44.5089 345.822C42.2512 345.822 40.4307 347.656 40.4307 349.901C40.4307 352.145 42.2512 353.991 44.5089 353.991C46.7666 353.991 48.5872 352.158 48.5872 349.901C48.5872 347.643 46.7666 345.822 44.5089 345.822Z"
            fill="white"
          />
          <path
            d="M51.0356 334.635C48.7864 334.635 46.9658 336.455 46.9658 338.705C46.9658 340.954 48.7864 342.774 51.0356 342.774C53.2848 342.774 55.1053 340.954 55.1053 338.705C55.1053 336.455 53.2848 334.635 51.0356 334.635Z"
            fill="white"
          />
          <path
            d="M57.7582 322.605C55.509 322.605 53.7012 324.418 53.7012 326.662C53.7012 328.907 55.5133 330.711 57.7582 330.711C60.0031 330.711 61.8195 328.899 61.8195 326.662C61.8195 324.426 59.9989 322.605 57.7582 322.605Z"
            fill="white"
          />
          <path
            d="M64.6791 309.803C62.4299 309.803 60.6221 311.623 60.6221 313.86C60.6221 316.096 62.4342 317.908 64.6791 317.908C66.924 317.908 68.7276 316.096 68.7276 313.86C68.7276 311.623 66.9156 309.803 64.6791 309.803Z"
            fill="white"
          />
          <path
            d="M71.873 296.303C69.6578 296.303 67.8457 298.102 67.8457 300.33C67.8457 302.558 69.6578 304.357 71.873 304.357C74.0883 304.357 75.9003 302.558 75.9003 300.33C75.9003 298.102 74.101 296.303 71.873 296.303Z"
            fill="white"
          />
          <path
            d="M79.3108 282.367C77.0956 282.367 75.292 284.167 75.292 286.386C75.292 288.606 77.0913 290.392 79.3108 290.392C81.5303 290.392 83.3169 288.593 83.3169 286.386C83.3169 284.179 81.5261 282.367 79.3108 282.367Z"
            fill="white"
          />
          <path
            d="M87.022 268.111C84.8153 268.111 83.0244 269.902 83.0244 272.117C83.0244 274.333 84.8153 276.115 87.022 276.115C89.2288 276.115 91.0281 274.324 91.0281 272.117C91.0281 269.911 89.2373 268.111 87.022 268.111Z"
            fill="white"
          />
          <path
            d="M94.8814 254.025C92.6873 254.025 90.8965 255.804 90.8965 258.01C90.8965 260.217 92.6873 261.987 94.8814 261.987C97.0754 261.987 98.8662 260.209 98.8662 258.01C98.8662 255.812 97.0754 254.025 94.8814 254.025Z"
            fill="white"
          />
          <path
            d="M102.678 240.582C100.501 240.582 98.7354 242.352 98.7354 244.537C98.7354 246.723 100.505 248.484 102.678 248.484C104.851 248.484 106.633 246.714 106.633 244.537C106.633 242.36 104.863 240.582 102.678 240.582Z"
            fill="white"
          />
          <path
            d="M110.244 228.039C108.08 228.039 106.318 229.796 106.318 231.965C106.318 234.133 108.08 235.89 110.244 235.89C112.408 235.89 114.169 234.142 114.169 231.965C114.169 229.787 112.408 228.039 110.244 228.039Z"
            fill="white"
          />
          <path
            d="M117.425 216.559C115.269 216.559 113.521 218.307 113.521 220.471C113.521 222.636 115.269 224.376 117.425 224.376C119.581 224.376 121.338 222.627 121.338 220.471C121.338 218.316 119.589 216.559 117.425 216.559Z"
            fill="white"
          />
          <path
            d="M124.172 206.189C122.029 206.189 120.289 207.917 120.289 210.06C120.289 212.203 122.029 213.93 124.172 213.93C126.315 213.93 128.042 212.203 128.042 210.06C128.042 207.917 126.302 206.189 124.172 206.189Z"
            fill="white"
          />
          <path
            d="M130.477 196.982C128.355 196.982 126.649 198.701 126.649 200.81C126.649 202.919 128.355 204.642 130.477 204.642C132.599 204.642 134.309 202.924 134.309 200.81C134.309 198.697 132.591 196.982 130.477 196.982Z"
            fill="white"
          />
          <path
            d="M136.262 189.293C134.17 189.293 132.464 190.99 132.464 193.091C132.464 195.192 134.17 196.889 136.262 196.889C138.354 196.889 140.06 195.192 140.06 193.091C140.06 190.99 138.363 189.293 136.262 189.293Z"
            fill="white"
          />
          <path
            d="M141.542 182.922C139.449 182.922 137.765 184.607 137.765 186.695C137.765 188.782 139.449 190.467 141.542 190.467C143.634 190.467 145.31 188.782 145.31 186.695C145.31 184.607 143.625 182.922 141.542 182.922Z"
            fill="white"
          />
          <path
            d="M146.308 177.527C144.237 177.527 142.573 179.191 142.573 181.262C142.573 183.333 144.237 184.996 146.308 184.996C148.379 184.996 150.042 183.32 150.042 181.262C150.042 179.204 148.366 177.527 146.308 177.527Z"
            fill="white"
          />
          <path
            d="M150.606 172.83C148.565 172.83 146.91 174.481 146.91 176.518C146.91 178.555 148.565 180.206 150.606 180.206C152.648 180.206 154.29 178.555 154.29 176.518C154.29 174.481 152.643 172.83 150.606 172.83Z"
            fill="white"
          />
          <path
            d="M154.456 168.578C152.436 168.578 150.802 170.212 150.802 172.232C150.802 174.252 152.436 175.894 154.456 175.894C156.476 175.894 158.118 174.256 158.118 172.232C158.118 170.208 156.471 168.578 154.456 168.578Z"
            fill="white"
          />
          <path
            d="M157.88 164.623C155.894 164.623 154.269 166.248 154.269 168.234C154.269 170.221 155.894 171.85 157.88 171.85C159.866 171.85 161.491 170.233 161.491 168.234C161.491 166.236 159.879 164.623 157.88 164.623Z"
            fill="white"
          />
          <path
            d="M160.868 160.824C158.899 160.824 157.299 162.428 157.299 164.393C157.299 166.358 158.903 167.962 160.868 167.962C162.833 167.962 164.437 166.371 164.437 164.393C164.437 162.416 162.833 160.824 160.868 160.824Z"
            fill="white"
          />
          <path
            d="M164.216 164.059C166.101 163.614 167.267 161.726 166.823 159.842C166.378 157.958 164.49 156.791 162.606 157.236C160.722 157.681 159.555 159.568 160 161.453C160.444 163.337 162.332 164.504 164.216 164.059Z"
            fill="white"
          />
          <path
            d="M165.562 153.471C163.635 153.471 162.086 155.028 162.086 156.951C162.086 158.873 163.635 160.426 165.562 160.426C167.488 160.426 169.037 158.865 169.037 156.951C169.037 155.037 167.484 153.471 165.562 153.471Z"
            fill="white"
          />
          <path
            d="M167.353 149.926C165.46 149.926 163.92 151.458 163.92 153.35C163.92 155.243 165.46 156.779 167.353 156.779C169.246 156.779 170.778 155.243 170.778 153.35C170.778 151.458 169.246 149.926 167.353 149.926Z"
            fill="white"
          />
          <path
            d="M168.842 146.488C166.97 146.488 165.451 148.003 165.451 149.875C165.451 151.746 166.97 153.257 168.842 153.257C170.713 153.257 172.224 151.738 172.224 149.875C172.224 148.012 170.705 146.488 168.842 146.488Z"
            fill="white"
          />
          <path
            d="M170.081 143.213C168.26 143.213 166.771 144.69 166.771 146.519C166.771 148.348 168.26 149.829 170.081 149.829C171.901 149.829 173.391 148.344 173.391 146.519C173.391 144.694 171.914 143.213 170.081 143.213Z"
            fill="white"
          />
          <path
            d="M171.121 140.039C169.33 140.039 167.861 141.495 167.861 143.298C167.861 145.102 169.33 146.557 171.121 146.557C172.911 146.557 174.38 145.102 174.38 143.298C174.38 141.495 172.924 140.039 171.121 140.039Z"
            fill="white"
          />
          <path
            d="M172.003 136.938C170.233 136.938 168.799 138.372 168.799 140.142C168.799 141.911 170.237 143.346 172.003 143.346C173.768 143.346 175.207 141.911 175.207 140.142C175.207 138.372 173.768 136.938 172.003 136.938Z"
            fill="white"
          />
          <path
            d="M172.754 133.855C171.006 133.855 169.593 135.26 169.593 137.009C169.593 138.757 171.01 140.162 172.754 140.162C174.499 140.162 175.907 138.744 175.907 137.009C175.907 135.273 174.49 133.855 172.754 133.855Z"
            fill="white"
          />
          <path
            d="M173.379 130.742C171.694 130.742 170.319 132.113 170.319 133.806C170.319 135.499 171.694 136.866 173.379 136.866C175.064 136.866 176.452 135.491 176.452 133.806C176.452 132.121 175.077 130.742 173.379 130.742Z"
            fill="white"
          />
          <path
            d="M173.942 127.436C172.279 127.436 170.925 128.777 170.925 130.444C170.925 132.112 172.279 133.453 173.942 133.453C175.606 133.453 176.951 132.112 176.951 130.444C176.951 128.777 175.597 127.436 173.942 127.436Z"
            fill="white"
          />
          <path
            d="M174.439 123.887C172.814 123.887 171.494 125.207 171.494 126.845C171.494 128.483 172.814 129.79 174.439 129.79C176.065 129.79 177.397 128.47 177.397 126.845C177.397 125.219 176.077 123.887 174.439 123.887Z"
            fill="white"
          />
          <path
            d="M174.982 119.982C173.378 119.982 172.088 121.273 172.088 122.872C172.088 124.472 173.378 125.762 174.982 125.762C176.586 125.762 177.864 124.472 177.864 122.872C177.864 121.273 176.574 119.982 174.982 119.982Z"
            fill="white"
          />
          <path
            d="M175.657 115.592C174.108 115.592 172.856 116.839 172.856 118.384C172.856 119.929 174.104 121.177 175.657 121.177C177.211 121.177 178.445 119.929 178.445 118.384C178.445 116.839 177.198 115.592 175.657 115.592Z"
            fill="white"
          />
          <path
            d="M176.638 110.465C175.127 110.465 173.9 111.687 173.9 113.198C173.9 114.709 175.127 115.935 176.638 115.935C178.148 115.935 179.375 114.713 179.375 113.198C179.375 111.683 178.157 110.465 176.638 110.465Z"
            fill="white"
          />
          <path
            d="M178.221 104.361C176.745 104.361 175.535 105.558 175.535 107.035C175.535 108.512 176.745 109.708 178.221 109.708C179.698 109.708 180.895 108.512 180.895 107.035C180.895 105.558 179.686 104.361 178.221 104.361Z"
            fill="white"
          />
          <path
            d="M180.852 96.8418C179.405 96.8418 178.238 98.0131 178.238 99.4602C178.238 100.907 179.405 102.074 180.852 102.074C182.3 102.074 183.467 100.903 183.467 99.4602C183.467 98.0173 182.3 96.8418 180.852 96.8418Z"
            fill="white"
          />
          <path
            d="M185.482 87.2207C184.098 87.2207 182.974 88.3453 182.974 89.7288C182.974 91.1122 184.098 92.2368 185.482 92.2368C186.865 92.2368 187.99 91.1122 187.99 89.7288C187.99 88.3453 186.865 87.2207 185.482 87.2207Z"
            fill="white"
          />
          <path
            d="M193.354 74.4688C192 74.4688 190.909 75.5594 190.909 76.9132C190.909 78.2669 192.004 79.3576 193.354 79.3576C194.703 79.3576 195.798 78.2669 195.798 76.9132C195.798 75.5594 194.707 74.4688 193.354 74.4688Z"
            fill="white"
          />
          <path
            d="M205.894 57.3711C204.57 57.3711 203.509 58.432 203.509 59.7561C203.509 61.0801 204.57 62.1411 205.894 62.1411C207.218 62.1411 208.279 61.0674 208.279 59.7561C208.279 58.4448 207.205 57.3711 205.894 57.3711Z"
            fill="white"
          />
          <path
            d="M224.575 34.0781C223.294 34.0781 222.254 35.1178 222.254 36.3995C222.254 37.6811 223.294 38.7208 224.575 38.7208C225.857 38.7208 226.897 37.6811 226.897 36.3995C226.897 35.1178 225.857 34.0781 224.575 34.0781Z"
            fill="white"
          />
          <path
            d="M244.423 28.3066C243.141 28.3066 242.102 29.3421 242.102 30.6237C242.102 31.9053 243.141 32.9323 244.423 32.9323C245.705 32.9323 246.732 31.9011 246.732 30.6237C246.732 29.3464 245.692 28.3066 244.423 28.3066Z"
            fill="white"
          />
          <path
            d="M266.528 18.4141C265.247 18.4141 264.207 19.4538 264.207 20.7354C264.207 22.017 265.247 23.0567 266.528 23.0567C267.81 23.0567 268.85 22.017 268.85 20.7354C268.85 19.4538 267.81 18.4141 266.528 18.4141Z"
            fill="white"
          />
          <path
            d="M290.311 4.11133C289.029 4.11133 288.002 5.14256 288.002 6.41993C288.002 7.6973 289.033 8.74126 290.311 8.74126C291.588 8.74126 292.632 7.70154 292.632 6.41993C292.632 5.13832 291.592 4.11133 290.311 4.11133Z"
            fill="white"
          />
          <path
            d="M901.746 3C900.091 3 898.75 4.34102 898.75 5.99609C898.75 7.65115 900.091 8.98369 901.746 8.98369C903.401 8.98369 904.734 7.64691 904.734 5.99609C904.734 4.34527 903.393 3 901.746 3Z"
            fill="white"
          />
          <path
            d="M909.105 13.8652C907.399 13.8652 906.016 15.2487 906.016 16.9462C906.016 18.6437 907.399 20.0356 909.105 20.0356C910.811 20.0356 912.186 18.6522 912.186 16.9462C912.186 15.2402 910.803 13.8652 909.105 13.8652Z"
            fill="white"
          />
          <path
            d="M916.306 25.0078C914.57 25.0078 913.161 26.4167 913.161 28.1524C913.161 29.8881 914.566 31.297 916.306 31.297C918.046 31.297 919.45 29.8881 919.45 28.1524C919.45 26.4167 918.046 25.0078 916.306 25.0078Z"
            fill="white"
          />
          <path
            d="M923.38 36.3477C921.61 36.3477 920.185 37.782 920.185 39.5432C920.185 41.3044 921.61 42.7387 923.38 42.7387C925.15 42.7387 926.563 41.3044 926.563 39.5432C926.563 37.782 925.137 36.3477 923.38 36.3477Z"
            fill="white"
          />
          <path
            d="M930.336 47.8125C928.545 47.8125 927.09 49.2681 927.09 51.059C927.09 52.8498 928.545 54.3097 930.336 54.3097C932.127 54.3097 933.583 52.8583 933.583 51.059C933.583 49.2596 932.127 47.8125 930.336 47.8125Z"
            fill="white"
          />
          <path
            d="M937.181 59.3906C935.339 59.3906 933.85 60.8802 933.85 62.7092C933.85 64.5383 935.339 66.0406 937.181 66.0406C939.023 66.0406 940.512 64.551 940.512 62.7092C940.512 60.8675 939.014 59.3906 937.181 59.3906Z"
            fill="white"
          />
          <path
            d="M946.294 76.8934C947.611 75.5759 947.611 73.4398 946.294 72.1222C944.976 70.8047 942.84 70.8047 941.522 72.1222C940.205 73.4397 940.205 75.5759 941.522 76.8934C942.84 78.211 944.976 78.211 946.294 76.8934Z"
            fill="white"
          />
          <path
            d="M950.536 82.998C948.643 82.998 947.103 84.5343 947.103 86.427C947.103 88.3197 948.643 89.8602 950.536 89.8602C952.428 89.8602 953.969 88.3197 953.969 86.427C953.969 84.5343 952.428 82.998 950.536 82.998Z"
            fill="white"
          />
          <path
            d="M957.093 94.9824C955.166 94.9824 953.617 96.5441 953.617 98.458C953.617 100.372 955.166 101.938 957.093 101.938C959.019 101.938 960.568 100.38 960.568 98.458C960.568 96.5356 959.007 94.9824 957.093 94.9824Z"
            fill="white"
          />
          <path
            d="M963.607 107.043C961.651 107.043 960.06 108.63 960.06 110.586C960.06 112.543 961.651 114.134 963.607 114.134C965.564 114.134 967.147 112.543 967.147 110.586C967.147 108.63 965.564 107.043 963.607 107.043Z"
            fill="white"
          />
          <path
            d="M970.104 119.199C968.126 119.199 966.514 120.808 966.514 122.794C966.514 124.78 968.126 126.384 970.104 126.384C972.081 126.384 973.694 124.771 973.694 122.794C973.694 120.816 972.09 119.199 970.104 119.199Z"
            fill="white"
          />
          <path
            d="M976.589 131.52C974.581 131.52 972.956 133.145 972.956 135.152C972.956 137.159 974.581 138.785 976.589 138.785C978.596 138.785 980.221 137.159 980.221 135.152C980.221 133.145 978.596 131.52 976.589 131.52Z"
            fill="white"
          />
          <path
            d="M983.051 144.027C981.009 144.027 979.367 145.674 979.367 147.711C979.367 149.748 981.014 151.386 983.051 151.386C985.088 151.386 986.726 149.739 986.726 147.711C986.726 145.682 985.079 144.027 983.051 144.027Z"
            fill="white"
          />
          <path
            d="M989.524 156.725C987.461 156.725 985.789 158.401 985.789 160.468C985.789 162.534 987.465 164.211 989.524 164.211C991.582 164.211 993.258 162.534 993.258 160.468C993.258 158.401 991.595 156.725 989.524 156.725Z"
            fill="white"
          />
          <path
            d="M996.093 169.588C994.014 169.588 992.316 171.273 992.316 173.356C992.316 175.44 994.014 177.129 996.093 177.129C998.173 177.129 999.862 175.436 999.862 173.356C999.862 171.277 998.177 169.588 996.093 169.588Z"
            fill="white"
          />
          <path
            d="M1002.81 182.422C1000.71 182.422 998.995 184.132 998.995 186.241C998.995 188.35 1000.71 190.061 1002.81 190.061C1004.92 190.061 1006.63 188.355 1006.63 186.241C1006.63 184.128 1004.93 182.422 1002.81 182.422Z"
            fill="white"
          />
          <path
            d="M1009.81 195.078C1007.69 195.078 1005.96 196.805 1005.96 198.927C1005.96 201.049 1007.69 202.776 1009.81 202.776C1011.93 202.776 1013.66 201.049 1013.66 198.927C1013.66 196.805 1011.93 195.078 1009.81 195.078Z"
            fill="white"
          />
          <path
            d="M1017.16 207.264C1015 207.264 1013.27 209.012 1013.27 211.155C1013.27 213.298 1015.01 215.059 1017.16 215.059C1019.31 215.059 1021.05 213.311 1021.05 211.155C1021.05 208.999 1019.31 207.264 1017.16 207.264Z"
            fill="white"
          />
          <path
            d="M1024.92 218.785C1022.76 218.785 1020.99 220.542 1020.99 222.711C1020.99 224.879 1022.76 226.636 1024.92 226.636C1027.08 226.636 1028.85 224.879 1028.85 222.711C1028.85 220.542 1027.08 218.785 1024.92 218.785Z"
            fill="white"
          />
          <path
            d="M1033.14 229.381C1030.96 229.381 1029.19 231.151 1029.19 233.336C1029.19 235.522 1030.96 237.291 1033.14 237.291C1035.33 237.291 1037.1 235.522 1037.1 233.336C1037.1 231.151 1035.33 229.381 1033.14 229.381Z"
            fill="white"
          />
          <path
            d="M1041.81 238.871C1039.62 238.871 1037.83 240.662 1037.83 242.856C1037.83 245.05 1039.62 246.841 1041.81 246.841C1044.01 246.841 1045.8 245.063 1045.8 242.856C1045.8 240.649 1044.02 238.871 1041.81 238.871Z"
            fill="white"
          />
          <path
            d="M1050.87 247.189C1048.64 247.189 1046.83 248.989 1046.83 251.217C1046.83 253.445 1048.64 255.257 1050.87 255.257C1053.09 255.257 1054.91 253.457 1054.91 251.217C1054.91 248.976 1053.09 247.189 1050.87 247.189Z"
            fill="white"
          />
          <path
            d="M1060.23 254.381C1057.99 254.381 1056.17 256.193 1056.17 258.429C1056.17 260.666 1057.99 262.491 1060.23 262.491C1062.46 262.491 1064.27 260.67 1064.27 258.429C1064.27 256.189 1062.46 254.381 1060.23 254.381Z"
            fill="white"
          />
          <path
            d="M1069.77 260.523C1067.51 260.523 1065.69 262.344 1065.69 264.602C1065.69 266.859 1067.51 268.671 1069.77 268.671C1072.03 268.671 1073.84 266.851 1073.84 264.602C1073.84 262.352 1072.02 260.523 1069.77 260.523Z"
            fill="white"
          />
          <path
            d="M1079.42 265.791C1077.15 265.791 1075.32 267.624 1075.32 269.882C1075.32 272.14 1077.15 273.981 1079.42 273.981C1081.69 273.981 1083.51 272.148 1083.51 269.882C1083.51 267.616 1081.68 265.791 1079.42 265.791Z"
            fill="white"
          />
          <path
            d="M1089.09 270.334C1086.82 270.334 1084.96 272.188 1084.96 274.467C1084.96 276.746 1086.82 278.588 1089.09 278.588C1091.37 278.588 1093.22 276.746 1093.22 274.467C1093.22 272.188 1091.37 270.334 1089.09 270.334Z"
            fill="white"
          />
          <path
            d="M1098.79 274.346C1096.5 274.346 1094.65 276.196 1094.65 278.488C1094.65 280.779 1096.5 282.63 1098.79 282.63C1101.07 282.63 1102.93 280.775 1102.93 278.488C1102.93 276.2 1101.08 274.346 1098.79 274.346Z"
            fill="white"
          />
          <path
            d="M1108.47 277.914C1106.18 277.914 1104.31 279.769 1104.31 282.069C1104.31 284.369 1106.18 286.223 1108.47 286.223C1110.76 286.223 1112.62 284.36 1112.62 282.069C1112.62 279.777 1110.77 277.914 1108.47 277.914Z"
            fill="white"
          />
          <path
            d="M1118.14 281.152C1115.84 281.152 1113.98 283.015 1113.98 285.307C1113.98 287.599 1115.84 289.47 1118.14 289.47C1120.44 289.47 1122.3 287.607 1122.3 285.307C1122.3 283.007 1120.43 281.152 1118.14 281.152Z"
            fill="white"
          />
          <path
            d="M1127.79 284.17C1125.49 284.17 1123.64 286.033 1123.64 288.325C1123.64 290.616 1125.49 292.479 1127.79 292.479C1130.09 292.479 1131.95 290.629 1131.95 288.325C1131.95 286.02 1130.08 284.17 1127.79 284.17Z"
            fill="white"
          />
          <path
            d="M1137.42 287.053C1135.12 287.053 1133.26 288.907 1133.26 291.207C1133.26 293.507 1135.12 295.362 1137.42 295.362C1139.72 295.362 1141.58 293.499 1141.58 291.207C1141.58 288.916 1139.71 287.053 1137.42 287.053Z"
            fill="white"
          />
          <path
            d="M1147 289.822C1144.7 289.822 1142.85 291.685 1142.85 293.977C1142.85 296.269 1144.7 298.132 1147 298.132C1149.3 298.132 1151.16 296.269 1151.16 293.977C1151.16 291.685 1149.3 289.822 1147 289.822Z"
            fill="white"
          />
          <path
            d="M1156.53 292.504C1154.24 292.504 1152.37 294.354 1152.37 296.659C1152.37 298.963 1154.24 300.813 1156.53 300.813C1158.82 300.813 1160.68 298.95 1160.68 296.659C1160.68 294.367 1158.83 292.504 1156.53 292.504Z"
            fill="white"
          />
          <path
            d="M1165.97 295.098C1163.68 295.098 1161.82 296.961 1161.82 299.252C1161.82 301.544 1163.68 303.415 1165.97 303.415C1168.26 303.415 1170.13 301.552 1170.13 299.252C1170.13 296.952 1168.27 295.098 1165.97 295.098Z"
            fill="white"
          />
          <path
            d="M1161.56 295.18C1159.27 295.18 1157.4 297.043 1157.4 299.334C1157.4 301.626 1159.27 303.489 1161.56 303.489C1163.85 303.489 1165.71 301.626 1165.71 299.334C1165.71 297.043 1163.86 295.18 1161.56 295.18Z"
            fill="white"
          />
          <path
            d="M1156.82 295.146C1154.53 295.146 1152.67 297.01 1152.67 299.301C1152.67 301.593 1154.53 303.456 1156.82 303.456C1159.11 303.456 1160.98 301.601 1160.98 299.301C1160.98 297.001 1159.11 295.146 1156.82 295.146Z"
            fill="white"
          />
          <path
            d="M1151.76 295.047C1149.47 295.047 1147.61 296.91 1147.61 299.201C1147.61 301.493 1149.47 303.356 1151.76 303.356C1154.05 303.356 1155.92 301.493 1155.92 299.201C1155.92 296.91 1154.06 295.047 1151.76 295.047Z"
            fill="white"
          />
          <path
            d="M1146.39 294.877C1144.1 294.877 1142.24 296.727 1142.24 299.032C1142.24 301.336 1144.1 303.186 1146.39 303.186C1148.69 303.186 1150.55 301.323 1150.55 299.032C1150.55 296.74 1148.69 294.877 1146.39 294.877Z"
            fill="white"
          />
          <path
            d="M1140.72 294.668C1138.43 294.668 1136.57 296.523 1136.57 298.823C1136.57 301.123 1138.43 302.977 1140.72 302.977C1143.01 302.977 1144.87 301.114 1144.87 298.823C1144.87 296.531 1143.02 294.668 1140.72 294.668Z"
            fill="white"
          />
          <path
            d="M1134.74 294.439C1132.45 294.439 1130.59 296.302 1130.59 298.603C1130.59 300.903 1132.45 302.757 1134.74 302.757C1137.04 302.757 1138.9 300.894 1138.9 298.603C1138.9 296.311 1137.05 294.439 1134.74 294.439Z"
            fill="white"
          />
          <path
            d="M1128.48 294.232C1126.19 294.232 1124.33 296.095 1124.33 298.387C1124.33 300.679 1126.19 302.542 1128.48 302.542C1130.77 302.542 1132.64 300.679 1132.64 298.387C1132.64 296.095 1130.77 294.232 1128.48 294.232Z"
            fill="white"
          />
          <path
            d="M1121.91 294.059C1119.62 294.059 1117.76 295.922 1117.76 298.213C1117.76 300.505 1119.62 302.368 1121.91 302.368C1124.2 302.368 1126.07 300.513 1126.07 298.213C1126.07 295.913 1124.2 294.059 1121.91 294.059Z"
            fill="white"
          />
          <path
            d="M1115.05 293.93C1112.75 293.93 1110.9 295.793 1110.9 298.093C1110.9 300.393 1112.75 302.247 1115.05 302.247C1117.35 302.247 1119.21 300.384 1119.21 298.093C1119.21 295.801 1117.35 293.93 1115.05 293.93Z"
            fill="white"
          />
          <path
            d="M1107.88 293.881C1105.59 293.881 1103.73 295.731 1103.73 298.035C1103.73 300.34 1105.59 302.19 1107.88 302.19C1110.17 302.19 1112.04 300.327 1112.04 298.035C1112.04 295.744 1110.18 293.881 1107.88 293.881Z"
            fill="white"
          />
          <path
            d="M1100.42 293.9C1098.13 293.9 1096.27 295.763 1096.27 298.055C1096.27 300.347 1098.13 302.21 1100.42 302.21C1102.71 302.21 1104.58 300.355 1104.58 298.055C1104.58 295.755 1102.72 293.9 1100.42 293.9Z"
            fill="white"
          />
          <path
            d="M1092.67 294.078C1090.39 294.078 1088.53 295.92 1088.53 298.199C1088.53 300.478 1090.39 302.332 1092.67 302.332C1094.95 302.332 1096.79 300.482 1096.79 298.199C1096.79 295.916 1094.95 294.078 1092.67 294.078Z"
            fill="white"
          />
          <path
            d="M1084.62 294.389C1082.35 294.389 1080.51 296.23 1080.51 298.501C1080.51 300.771 1082.35 302.613 1084.62 302.613C1086.89 302.613 1088.73 300.771 1088.73 298.501C1088.73 296.23 1086.89 294.389 1084.62 294.389Z"
            fill="white"
          />
          <path
            d="M1076.3 294.889C1074.04 294.889 1072.21 296.722 1072.21 298.98C1072.21 301.237 1074.04 303.071 1076.3 303.071C1078.55 303.071 1080.4 301.237 1080.4 298.98C1080.4 296.722 1078.56 294.889 1076.3 294.889Z"
            fill="white"
          />
          <path
            d="M1067.73 295.605C1065.48 295.605 1063.66 297.426 1063.66 299.675C1063.66 301.924 1065.48 303.745 1067.73 303.745C1069.98 303.745 1071.8 301.924 1071.8 299.675C1071.8 297.426 1069.98 295.605 1067.73 295.605Z"
            fill="white"
          />
          <path
            d="M1058.9 296.531C1056.68 296.531 1054.86 298.343 1054.86 300.571C1054.86 302.799 1056.68 304.599 1058.9 304.599C1061.13 304.599 1062.94 302.799 1062.94 300.571C1062.94 298.343 1061.13 296.531 1058.9 296.531Z"
            fill="white"
          />
          <path
            d="M1049.86 297.656C1047.64 297.656 1045.85 299.456 1045.85 301.662C1045.85 303.869 1047.64 305.668 1049.86 305.668C1052.07 305.668 1053.86 303.878 1053.86 301.662C1053.86 299.447 1052.07 297.656 1049.86 297.656Z"
            fill="white"
          />
          <path
            d="M1040.61 299.031C1038.41 299.031 1036.62 300.809 1036.62 303.008C1036.62 305.206 1038.41 306.993 1040.61 306.993C1042.8 306.993 1044.59 305.214 1044.59 303.008C1044.59 300.801 1042.8 299.031 1040.61 299.031Z"
            fill="white"
          />
          <path
            d="M1031.16 300.68C1028.96 300.68 1027.19 302.458 1027.19 304.643C1027.19 306.829 1028.96 308.607 1031.16 308.607C1033.35 308.607 1035.11 306.829 1035.11 304.643C1035.11 302.458 1033.34 300.68 1031.16 300.68Z"
            fill="white"
          />
          <path
            d="M1021.52 302.664C1019.35 302.664 1017.6 304.425 1017.6 306.577C1017.6 308.728 1019.35 310.502 1021.52 310.502C1023.68 310.502 1025.44 308.745 1025.44 306.577C1025.44 304.408 1023.68 302.664 1021.52 302.664Z"
            fill="white"
          />
          <path
            d="M1011.72 304.914C1009.58 304.914 1007.84 306.641 1007.84 308.784C1007.84 310.927 1009.57 312.667 1011.72 312.667C1013.87 312.667 1015.59 310.927 1015.59 308.784C1015.59 306.641 1013.87 304.914 1011.72 304.914Z"
            fill="white"
          />
          <path
            d="M1001.75 307.379C999.632 307.379 997.904 309.098 997.904 311.228C997.904 313.358 999.632 315.069 1001.75 315.069C1003.88 315.069 1005.6 313.35 1005.6 311.228C1005.6 309.106 1003.88 307.379 1001.75 307.379Z"
            fill="white"
          />
          <path
            d="M991.646 310.137C989.532 310.137 987.826 311.843 987.826 313.956C987.826 316.069 989.532 317.767 991.646 317.767C993.759 317.767 995.456 316.061 995.456 313.956C995.456 311.851 993.75 310.137 991.646 310.137Z"
            fill="white"
          />
          <path
            d="M981.396 313.248C979.325 313.248 977.641 314.933 977.641 317.004C977.641 319.075 979.325 320.759 981.396 320.759C983.467 320.759 985.152 319.075 985.152 317.004C985.152 314.933 983.467 313.248 981.396 313.248Z"
            fill="white"
          />
          <path
            d="M971.05 316.717C968.988 316.717 967.324 318.38 967.324 320.443C967.324 322.505 968.988 324.169 971.05 324.169C973.113 324.169 974.776 322.505 974.776 320.443C974.776 318.38 973.113 316.717 971.05 316.717Z"
            fill="white"
          />
          <path
            d="M960.632 320.635C958.604 320.635 956.957 322.281 956.957 324.31C956.957 326.338 958.604 327.985 960.632 327.985C962.661 327.985 964.316 326.338 964.316 324.31C964.316 322.281 962.661 320.635 960.632 320.635Z"
            fill="white"
          />
          <path
            d="M950.183 325.041C948.176 325.041 946.551 326.675 946.551 328.682C946.551 330.689 948.176 332.315 950.183 332.315C952.191 332.315 953.825 330.689 953.825 328.682C953.825 326.675 952.191 325.041 950.183 325.041Z"
            fill="white"
          />
          <path
            d="M939.732 330.066C937.767 330.066 936.163 331.671 936.163 333.648C936.163 335.626 937.767 337.217 939.732 337.217C941.697 337.217 943.314 335.613 943.314 333.648C943.314 331.683 941.71 330.066 939.732 330.066Z"
            fill="white"
          />
          <path
            d="M929.305 335.709C927.357 335.709 925.778 337.292 925.778 339.248C925.778 341.205 927.361 342.775 929.305 342.775C931.249 342.775 932.831 341.192 932.831 339.248C932.831 337.305 931.249 335.709 929.305 335.709Z"
            fill="white"
          />
          <path
            d="M918.938 349.053C920.864 349.053 922.426 347.491 922.426 345.565C922.426 343.638 920.864 342.076 918.938 342.076C917.011 342.076 915.449 343.638 915.449 345.565C915.449 347.491 917.011 349.053 918.938 349.053Z"
            fill="white"
          />
          <path
            d="M908.727 349.281C906.822 349.281 905.281 350.822 905.281 352.727C905.281 354.633 906.822 356.16 908.727 356.16C910.633 356.16 912.16 354.62 912.16 352.727C912.16 350.834 910.62 349.281 908.727 349.281Z"
            fill="white"
          />
          <path
            d="M898.652 357.365C896.789 357.365 895.291 358.876 895.291 360.739C895.291 362.602 896.789 364.1 898.652 364.1C900.515 364.1 902.013 362.589 902.013 360.739C902.013 358.889 900.515 357.365 898.652 357.365Z"
            fill="white"
          />
          <path
            d="M888.798 366.43C886.956 366.43 885.479 367.919 885.479 369.748C885.479 371.577 886.956 373.067 888.798 373.067C890.64 373.067 892.108 371.577 892.108 369.748C892.108 367.919 890.631 366.43 888.798 366.43Z"
            fill="white"
          />
          <path
            d="M879.211 376.738C877.412 376.738 875.943 378.194 875.943 379.997C875.943 381.801 877.412 383.257 879.211 383.257C881.01 383.257 882.47 381.801 882.47 379.997C882.47 378.194 881.015 376.738 879.211 376.738Z"
            fill="white"
          />
          <path
            d="M869.846 388.426C868.068 388.426 866.629 389.86 866.629 391.643C866.629 393.425 868.063 394.859 869.846 394.859C871.628 394.859 873.05 393.425 873.05 391.643C873.05 389.86 871.615 388.426 869.846 388.426Z"
            fill="white"
          />
          <path
            d="M860.977 402.09C859.237 402.09 857.832 403.495 857.832 405.234C857.832 406.974 859.237 408.366 860.977 408.366C862.717 408.366 864.109 406.962 864.109 405.234C864.109 403.507 862.704 402.09 860.977 402.09Z"
            fill="white"
          />
          <path
            d="M853.13 418.422C851.432 418.422 850.049 419.805 850.049 421.503C850.049 423.2 851.432 424.584 853.13 424.584C854.827 424.584 856.198 423.2 856.198 421.503C856.198 419.805 854.823 418.422 853.13 418.422Z"
            fill="white"
          />
          <path
            d="M847.091 438.34C845.427 438.34 844.073 439.681 844.073 441.357C844.073 443.033 845.427 444.374 847.091 444.374C848.754 444.374 850.121 443.021 850.121 441.357C850.121 439.694 848.767 438.34 847.091 438.34Z"
            fill="white"
          />
          <path
            d="M843.907 462.645C842.26 462.645 840.94 463.977 840.94 465.611C840.94 467.245 842.264 468.565 843.907 468.565C845.549 468.565 846.865 467.245 846.865 465.611C846.865 463.977 845.541 462.645 843.907 462.645Z"
            fill="white"
          />
          <path
            d="M855.472 517.812C853.924 517.812 852.65 519.081 852.65 520.635C852.65 522.188 853.919 523.457 855.472 523.457C857.026 523.457 858.295 522.196 858.295 520.635C858.295 519.073 857.034 517.812 855.472 517.812Z"
            fill="white"
          />
          <path
            d="M848.163 526.525C846.614 526.525 845.362 527.786 845.362 529.335C845.362 530.884 846.61 532.136 848.163 532.136C849.716 532.136 850.973 530.888 850.973 529.335C850.973 527.782 849.712 526.525 848.163 526.525Z"
            fill="white"
          />
          <path
            d="M840.483 535.553C838.935 535.553 837.683 536.813 837.683 538.362C837.683 539.911 838.93 541.163 840.483 541.163C842.037 541.163 843.293 539.903 843.293 538.362C843.293 536.822 842.032 535.553 840.483 535.553Z"
            fill="white"
          />
          <path
            d="M832.207 544.584C830.658 544.584 829.406 545.844 829.406 547.385C829.406 548.925 830.654 550.186 832.207 550.186C833.76 550.186 835.008 548.938 835.008 547.385C835.008 545.832 833.748 544.584 832.207 544.584Z"
            fill="white"
          />
          <path
            d="M823.538 553.703C821.989 553.703 820.737 554.951 820.737 556.504C820.737 558.057 821.985 559.305 823.538 559.305C825.091 559.305 826.339 558.044 826.339 556.504C826.339 554.964 825.079 553.703 823.538 553.703Z"
            fill="white"
          />
          <path
            d="M814.316 562.539C812.762 562.539 811.515 563.787 811.515 565.34C811.515 566.893 812.762 568.128 814.316 568.128C815.869 568.128 817.104 566.88 817.104 565.34C817.104 563.799 815.856 562.539 814.316 562.539Z"
            fill="white"
          />
          <path
            d="M804.368 570.758C802.828 570.758 801.58 572.006 801.58 573.546C801.58 575.086 802.828 576.326 804.368 576.326C805.909 576.326 807.148 575.078 807.148 573.546C807.148 572.014 805.9 570.758 804.368 570.758Z"
            fill="white"
          />
          <path
            d="M793.959 578.723C792.419 578.723 791.18 579.962 791.18 581.502C791.18 583.043 792.419 584.282 793.959 584.282C795.5 584.282 796.739 583.034 796.739 581.502C796.739 579.97 795.491 578.723 793.959 578.723Z"
            fill="white"
          />
          <path
            d="M783.269 586.465C781.737 586.465 780.502 587.704 780.502 589.232C780.502 590.76 781.741 591.999 783.269 591.999C784.797 591.999 786.036 590.76 786.036 589.232C786.036 587.704 784.797 586.465 783.269 586.465Z"
            fill="white"
          />
          <path
            d="M772.197 593.73C770.665 593.73 769.43 594.97 769.43 596.497C769.43 598.025 770.669 599.264 772.197 599.264C773.724 599.264 774.964 598.025 774.964 596.497C774.964 594.97 773.724 593.73 772.197 593.73Z"
            fill="white"
          />
          <path
            d="M760.696 600.486C759.164 600.486 757.938 601.726 757.938 603.245C757.938 604.764 759.164 606.012 760.696 606.012C762.228 606.012 763.454 604.773 763.454 603.245C763.454 601.717 762.228 600.486 760.696 600.486Z"
            fill="white"
          />
          <path
            d="M748.758 606.635C747.239 606.635 746 607.874 746 609.393C746 610.912 747.239 612.152 748.758 612.152C750.278 612.152 751.517 610.925 751.517 609.393C751.517 607.861 750.278 606.635 748.758 606.635Z"
            fill="white"
          />
          <path
            d="M736.363 611.936C734.852 611.936 733.626 613.162 733.626 614.685C733.626 616.209 734.852 617.423 736.363 617.423C737.874 617.423 739.113 616.196 739.113 614.685C739.113 613.175 737.887 611.936 736.363 611.936Z"
            fill="white"
          />
          <path
            d="M723.581 616.293C722.07 616.293 720.844 617.511 720.844 619.022C720.844 620.532 722.07 621.759 723.581 621.759C725.092 621.759 726.318 620.532 726.318 619.022C726.318 617.511 725.092 616.293 723.581 616.293Z"
            fill="white"
          />
          <path
            d="M710.488 619.885C708.978 619.885 707.76 621.103 707.76 622.614C707.76 624.124 708.978 625.351 710.488 625.351C711.999 625.351 713.226 624.124 713.226 622.614C713.226 621.103 711.999 619.885 710.488 619.885Z"
            fill="white"
          />
          <path
            d="M697.133 622.57C695.622 622.57 694.396 623.797 694.396 625.308C694.396 626.818 695.622 628.036 697.133 628.036C698.643 628.036 699.861 626.81 699.861 625.308C699.861 623.805 698.635 622.57 697.133 622.57Z"
            fill="white"
          />
          <path
            d="M683.554 624.381C682.056 624.381 680.825 625.599 680.825 627.11C680.825 628.62 682.052 629.838 683.554 629.838C685.056 629.838 686.283 628.612 686.283 627.11C686.283 625.607 685.065 624.381 683.554 624.381Z"
            fill="white"
          />
          <path
            d="M669.834 625.473C668.323 625.473 667.105 626.691 667.105 628.201C667.105 629.712 668.323 630.917 669.834 630.917C671.345 630.917 672.55 629.699 672.55 628.201C672.55 626.703 671.332 625.473 669.834 625.473Z"
            fill="white"
          />
          <path
            d="M655.982 625.965C654.484 625.965 653.266 627.183 653.266 628.694C653.266 630.204 654.484 631.41 655.982 631.41C657.48 631.41 658.698 630.192 658.698 628.694C658.698 627.196 657.48 625.965 655.982 625.965Z"
            fill="white"
          />
          <path
            d="M642.003 625.838C640.505 625.838 639.287 627.056 639.287 628.554C639.287 630.052 640.505 631.27 642.003 631.27C643.501 631.27 644.711 630.052 644.711 628.554C644.711 627.056 643.505 625.838 642.003 625.838Z"
            fill="white"
          />
          <path
            d="M627.914 625.234C626.416 625.234 625.206 626.444 625.206 627.942C625.206 629.44 626.411 630.649 627.914 630.649C629.416 630.649 630.621 629.44 630.621 627.942C630.621 626.444 629.412 625.234 627.914 625.234Z"
            fill="white"
          />
          <path
            d="M613.727 624.484C612.237 624.484 611.02 625.694 611.02 627.192C611.02 628.69 612.237 629.899 613.727 629.899C615.217 629.899 616.435 628.681 616.435 627.192C616.435 625.702 615.225 624.484 613.727 624.484Z"
            fill="white"
          />
          <path
            d="M599.553 623.996C598.064 623.996 596.858 625.206 596.858 626.704C596.858 628.202 598.064 629.398 599.553 629.398C601.043 629.398 602.248 628.189 602.248 626.704C602.248 625.218 601.039 623.996 599.553 623.996Z"
            fill="white"
          />
          <path
            d="M585.424 623.83C583.926 623.83 582.729 625.035 582.729 626.525C582.729 628.014 583.926 629.22 585.424 629.22C586.922 629.22 588.119 628.01 588.119 626.525C588.119 625.04 586.91 623.83 585.424 623.83Z"
            fill="white"
          />
          <path
            d="M571.337 624.068C569.86 624.068 568.65 625.274 568.65 626.763C568.65 628.253 569.86 629.458 571.337 629.458C572.814 629.458 574.031 628.248 574.031 626.763C574.031 625.278 572.822 624.068 571.337 624.068Z"
            fill="white"
          />
          <path
            d="M557.357 624.934C555.868 624.934 554.671 626.143 554.671 627.62C554.671 629.097 555.868 630.315 557.357 630.315C558.847 630.315 560.043 629.105 560.043 627.62C560.043 626.135 558.834 624.934 557.357 624.934Z"
            fill="white"
          />
          <path
            d="M543.47 626.211C541.981 626.211 540.784 627.42 540.784 628.897C540.784 630.374 541.981 631.584 543.47 631.584C544.96 631.584 546.157 630.387 546.157 628.897C546.157 627.408 544.947 626.211 543.47 626.211Z"
            fill="white"
          />
          <path
            d="M529.629 627.68C528.152 627.68 526.942 628.889 526.942 630.366C526.942 631.843 528.152 633.052 529.629 633.052C531.106 633.052 532.315 631.847 532.315 630.366C532.315 628.885 531.11 627.68 529.629 627.68Z"
            fill="white"
          />
          <path
            d="M515.799 629.406C514.322 629.406 513.125 630.603 513.125 632.093C513.125 633.582 514.322 634.766 515.799 634.766C517.275 634.766 518.485 633.569 518.485 632.093C518.485 630.616 517.28 629.406 515.799 629.406Z"
            fill="white"
          />
          <path
            d="M501.976 631.305C500.499 631.305 499.303 632.501 499.303 633.978C499.303 635.455 500.499 636.652 501.976 636.652C503.453 636.652 504.65 635.455 504.65 633.978C504.65 632.501 503.453 631.305 501.976 631.305Z"
            fill="white"
          />
          <path
            d="M488.091 633.02C486.614 633.02 485.417 634.216 485.417 635.693C485.417 637.17 486.614 638.358 488.091 638.358C489.567 638.358 490.756 637.161 490.756 635.693C490.756 634.225 489.559 633.02 488.091 633.02Z"
            fill="white"
          />
          <path
            d="M474.052 634.559C472.575 634.559 471.387 635.747 471.387 637.224C471.387 638.701 472.575 639.889 474.052 639.889C475.529 639.889 476.717 638.692 476.717 637.224C476.717 635.755 475.52 634.559 474.052 634.559Z"
            fill="white"
          />
          <path
            d="M459.836 635.893C458.359 635.893 457.162 637.081 457.162 638.558C457.162 640.034 458.359 641.223 459.836 641.223C461.313 641.223 462.501 640.034 462.501 638.558C462.501 637.081 461.304 635.893 459.836 635.893Z"
            fill="white"
          />
          <path
            d="M445.356 636.715C443.888 636.715 442.691 637.903 442.691 639.367C442.691 640.831 443.888 642.032 445.356 642.032C446.825 642.032 448.022 640.844 448.022 639.367C448.022 637.89 446.825 636.715 445.356 636.715Z"
            fill="white"
          />
          <path
            d="M430.508 636.9C429.031 636.9 427.834 638.097 427.834 639.574C427.834 641.051 429.031 642.239 430.508 642.239C431.984 642.239 433.173 641.042 433.173 639.574C433.173 638.106 431.984 636.9 430.508 636.9Z"
            fill="white"
          />
          <path
            d="M415.166 636.508C413.689 636.508 412.501 637.705 412.501 639.181C412.501 640.658 413.689 641.846 415.166 641.846C416.643 641.846 417.84 640.65 417.84 639.181C417.84 637.713 416.643 636.508 415.166 636.508Z"
            fill="white"
          />
          <path
            d="M399.209 635.219C397.732 635.219 396.544 636.407 396.544 637.884C396.544 639.361 397.732 640.549 399.209 640.549C400.686 640.549 401.874 639.352 401.874 637.884C401.874 636.415 400.677 635.219 399.209 635.219Z"
            fill="white"
          />
          <path
            d="M382.493 632.865C381.025 632.865 379.828 634.062 379.828 635.53C379.828 636.999 381.025 638.195 382.493 638.195C383.962 638.195 385.158 637.007 385.158 635.53C385.158 634.053 383.97 632.865 382.493 632.865Z"
            fill="white"
          />
          <path
            d="M364.903 629.598C363.427 629.598 362.238 630.794 362.238 632.263C362.238 633.731 363.427 634.928 364.903 634.928C366.38 634.928 367.568 633.731 367.568 632.263C367.568 630.794 366.372 629.598 364.903 629.598Z"
            fill="white"
          />
          <path
            d="M346.265 625.193C344.796 625.193 343.6 626.39 343.6 627.858C343.6 629.327 344.796 630.532 346.265 630.532C347.733 630.532 348.938 629.335 348.938 627.858C348.938 626.382 347.742 625.193 346.265 625.193Z"
            fill="white"
          />
          <path
            d="M326.468 619.389C324.991 619.389 323.794 620.585 323.794 622.054C323.794 623.522 324.991 624.727 326.468 624.727C327.944 624.727 329.133 623.531 329.133 622.054C329.133 620.577 327.944 619.389 326.468 619.389Z"
            fill="white"
          />
          <path
            d="M305.401 612.152C303.933 612.152 302.736 613.349 302.736 614.817C302.736 616.286 303.933 617.491 305.401 617.491C306.87 617.491 308.066 616.294 308.066 614.817C308.066 613.341 306.87 612.152 305.401 612.152Z"
            fill="white"
          />
          <path
            d="M296.37 606.27C294.86 606.27 293.642 607.496 293.642 609.007C293.642 610.518 294.86 611.735 296.37 611.735C297.881 611.735 299.108 610.518 299.108 609.007C299.108 607.496 297.881 606.27 296.37 606.27Z"
            fill="white"
          />
          <path
            d="M287.738 600.506C286.189 600.506 284.916 601.766 284.916 603.315C284.916 604.864 286.185 606.137 287.738 606.137C289.291 606.137 290.56 604.877 290.56 603.315C290.56 601.754 289.291 600.506 287.738 600.506Z"
            fill="white"
          />
          <path
            d="M279.799 595.012C278.207 595.012 276.926 596.293 276.926 597.885C276.926 599.476 278.207 600.766 279.799 600.766C281.39 600.766 282.68 599.476 282.68 597.885C282.68 596.293 281.39 595.012 279.799 595.012Z"
            fill="white"
          />
          <path
            d="M272.72 589.881C271.095 589.881 269.783 591.192 269.783 592.818C269.783 594.443 271.095 595.763 272.72 595.763C274.345 595.763 275.657 594.439 275.657 592.818C275.657 591.196 274.345 589.881 272.72 589.881Z"
            fill="white"
          />
          <path
            d="M266.629 591.084C268.284 591.04 269.589 589.664 269.546 588.01C269.503 586.356 268.127 585.05 266.473 585.093C264.818 585.137 263.513 586.513 263.556 588.167C263.599 589.821 264.975 591.127 266.629 591.084Z"
            fill="white"
          />
          <path
            d="M261.075 580.637C259.369 580.637 257.985 582.02 257.985 583.726C257.985 585.432 259.369 586.807 261.075 586.807C262.781 586.807 264.156 585.424 264.156 583.726C264.156 582.029 262.772 580.637 261.075 580.637Z"
            fill="white"
          />
          <path
            d="M256.255 576.461C254.528 576.461 253.123 577.866 253.123 579.593C253.123 581.32 254.528 582.725 256.255 582.725C257.982 582.725 259.387 581.32 259.387 579.593C259.387 577.866 257.991 576.461 256.255 576.461Z"
            fill="white"
          />
          <path
            d="M251.789 572.393C250.028 572.393 248.594 573.818 248.594 575.588C248.594 577.358 250.032 578.775 251.789 578.775C253.546 578.775 254.985 577.349 254.985 575.588C254.985 573.827 253.546 572.393 251.789 572.393Z"
            fill="white"
          />
          <path
            d="M247.474 568.355C245.696 568.355 244.236 569.803 244.236 571.581C244.236 573.359 245.692 574.819 247.474 574.819C249.257 574.819 250.712 573.372 250.712 571.581C250.712 569.79 249.265 568.355 247.474 568.355Z"
            fill="white"
          />
          <path
            d="M243.175 564.203C241.342 564.203 239.856 565.68 239.856 567.513C239.856 569.347 241.346 570.823 243.175 570.823C245.004 570.823 246.485 569.347 246.485 567.513C246.485 565.68 244.996 564.203 243.175 564.203Z"
            fill="white"
          />
          <path
            d="M238.783 559.938C236.933 559.938 235.422 561.436 235.422 563.29C235.422 565.145 236.933 566.651 238.783 566.651C240.633 566.651 242.144 565.153 242.144 563.29C242.144 561.427 240.633 559.938 238.783 559.938Z"
            fill="white"
          />
          <path
            d="M234.242 555.459C232.358 555.459 230.83 556.978 230.83 558.862C230.83 560.747 232.362 562.274 234.242 562.274C236.122 562.274 237.654 560.742 237.654 558.862C237.654 556.982 236.122 555.459 234.242 555.459Z"
            fill="white"
          />
          <path
            d="M229.519 550.758C227.613 550.758 226.064 552.307 226.064 554.212C226.064 556.118 227.613 557.667 229.519 557.667C231.424 557.667 232.973 556.126 232.973 554.212C232.973 552.298 231.433 550.758 229.519 550.758Z"
            fill="white"
          />
          <path
            d="M224.596 545.793C222.648 545.793 221.078 547.363 221.078 549.311C221.078 551.259 222.648 552.838 224.596 552.838C226.544 552.838 228.123 551.255 228.123 549.311C228.123 547.367 226.54 545.793 224.596 545.793Z"
            fill="white"
          />
          <path
            d="M219.487 540.576C217.518 540.576 215.918 542.168 215.918 544.137C215.918 546.106 217.522 547.697 219.487 547.697C221.452 547.697 223.047 546.106 223.047 544.137C223.047 542.168 221.456 540.576 219.487 540.576Z"
            fill="white"
          />
          <path
            d="M214.186 535.094C212.2 535.094 210.583 536.698 210.583 538.684C210.583 540.67 212.196 542.287 214.186 542.287C216.176 542.287 217.776 540.674 217.776 538.684C217.776 536.694 216.172 535.094 214.186 535.094Z"
            fill="white"
          />
          <path
            d="M208.734 529.305C206.727 529.305 205.093 530.939 205.093 532.946C205.093 534.953 206.727 536.587 208.734 536.587C210.741 536.587 212.367 534.953 212.367 532.946C212.367 530.939 210.741 529.305 208.734 529.305Z"
            fill="white"
          />
          <path
            d="M203.135 523.25C201.094 523.25 199.431 524.905 199.431 526.946C199.431 528.988 201.094 530.643 203.135 530.643C205.177 530.643 206.832 528.988 206.832 526.946C206.832 524.905 205.177 523.25 203.135 523.25Z"
            fill="white"
          />
          <path
            d="M197.389 516.982C195.339 516.982 193.663 518.659 193.663 520.708C193.663 522.758 195.339 524.443 197.389 524.443C199.439 524.443 201.124 522.767 201.124 520.708C201.124 518.65 199.447 516.982 197.389 516.982Z"
            fill="white"
          />
          <path
            d="M191.521 510.553C189.442 510.553 187.766 512.238 187.766 514.308C187.766 516.379 189.442 518.064 191.521 518.064C193.601 518.064 195.277 516.388 195.277 514.308C195.277 512.229 193.592 510.553 191.521 510.553Z"
            fill="white"
          />
          <path
            d="M185.473 504.025C183.381 504.025 181.684 505.723 181.684 507.815C181.684 509.907 183.381 511.605 185.473 511.605C187.565 511.605 189.263 509.907 189.263 507.815C189.263 505.723 187.565 504.025 185.473 504.025Z"
            fill="white"
          />
          <path
            d="M179.196 497.49C177.083 497.49 175.368 499.209 175.368 501.331C175.368 503.453 177.087 505.159 179.196 505.159C181.305 505.159 183.028 503.44 183.028 501.331C183.028 499.222 181.322 497.49 179.196 497.49Z"
            fill="white"
          />
          <path
            d="M172.64 491.057C170.518 491.057 168.791 492.784 168.791 494.918C168.791 497.053 170.518 498.78 172.64 498.78C174.762 498.78 176.502 497.053 176.502 494.918C176.502 492.784 174.775 491.057 172.64 491.057Z"
            fill="white"
          />
          <path
            d="M165.748 484.75C163.605 484.75 161.856 486.49 161.856 488.633C161.856 490.776 163.605 492.525 165.748 492.525C167.891 492.525 169.639 490.789 169.639 488.633C169.639 486.477 167.891 484.75 165.748 484.75Z"
            fill="white"
          />
          <path
            d="M158.487 478.547C156.323 478.547 154.562 480.308 154.562 482.472C154.562 484.637 156.318 486.385 158.487 486.385C160.656 486.385 162.4 484.624 162.4 482.472C162.4 480.321 160.651 478.547 158.487 478.547Z"
            fill="white"
          />
          <path
            d="M150.835 472.469C148.658 472.469 146.893 474.238 146.893 476.411C146.893 478.584 148.662 480.366 150.835 480.366C153.008 480.366 154.782 478.597 154.782 476.411C154.782 474.226 153.012 472.469 150.835 472.469Z"
            fill="white"
          />
          <path
            d="M142.832 466.545C140.638 466.545 138.855 468.323 138.855 470.509C138.855 472.694 140.634 474.485 142.832 474.485C145.03 474.485 146.808 472.707 146.808 470.509C146.808 468.31 145.03 466.545 142.832 466.545Z"
            fill="white"
          />
          <path
            d="M134.527 460.762C132.32 460.762 130.529 462.54 130.529 464.747C130.529 466.953 132.32 468.731 134.527 468.731C136.734 468.731 138.512 466.953 138.512 464.747C138.512 462.54 136.721 460.762 134.527 460.762Z"
            fill="white"
          />
          <path
            d="M128.294 462.278C130.085 460.987 130.49 458.489 129.2 456.697C127.909 454.906 125.41 454.501 123.619 455.792C121.828 457.082 121.422 459.581 122.713 461.372C124.004 463.163 126.503 463.569 128.294 462.278Z"
            fill="white"
          />
          <path
            d="M117.26 449.219C115.032 449.219 113.232 451.018 113.232 453.246C113.232 455.474 115.032 457.273 117.26 457.273C119.488 457.273 121.287 455.474 121.287 453.246C121.287 451.018 119.488 449.219 117.26 449.219Z"
            fill="white"
          />
          <path
            d="M108.432 443.295C106.204 443.295 104.392 445.107 104.392 447.335C104.392 449.563 106.204 451.384 108.432 451.384C110.66 451.384 112.48 449.571 112.48 447.335C112.48 445.099 110.668 443.295 108.432 443.295Z"
            fill="white"
          />
          <path
            d="M99.5456 437.164C97.3092 437.164 95.4971 438.976 95.4971 441.213C95.4971 443.449 97.3092 445.27 99.5456 445.27C101.782 445.27 103.607 443.458 103.607 441.213C103.607 438.968 101.795 437.164 99.5456 437.164Z"
            fill="white"
          />
          <path
            d="M90.6166 430.723C88.3674 430.723 86.5469 432.543 86.5469 434.792C86.5469 437.042 88.3674 438.862 90.6166 438.862C92.8658 438.862 94.6737 437.042 94.6737 434.792C94.6737 432.543 92.8531 430.723 90.6166 430.723Z"
            fill="white"
          />
          <path
            d="M81.6749 423.801C79.4257 423.801 77.5967 425.634 77.5967 427.879C77.5967 430.124 79.43 431.957 81.6749 431.957C83.9199 431.957 85.7532 430.137 85.7532 427.879C85.7532 425.621 83.9199 423.801 81.6749 423.801Z"
            fill="white"
          />
          <path
            d="M72.8048 416.215C70.5556 416.215 68.7266 418.048 68.7266 420.293C68.7266 422.538 70.5599 424.371 72.8048 424.371C75.0497 424.371 76.883 422.551 76.883 420.293C76.883 418.035 75.0625 416.215 72.8048 416.215Z"
            fill="white"
          />
          <path
            d="M64.0975 407.771C61.8271 407.771 59.998 409.605 59.998 411.862C59.998 414.12 61.8313 415.953 64.0975 415.953C66.3637 415.953 68.1885 414.12 68.1885 411.862C68.1885 409.605 66.3552 407.771 64.0975 407.771Z"
            fill="white"
          />
          <path
            d="M55.6007 398.416C53.3431 398.416 51.5098 400.249 51.5098 402.507C51.5098 404.765 53.3431 406.598 55.6007 406.598C57.8584 406.598 59.6917 404.765 59.6917 402.507C59.6917 400.249 57.8584 398.416 55.6007 398.416Z"
            fill="white"
          />
          <path
            d="M47.4025 388.184C45.1448 388.184 43.3115 390.017 43.3115 392.275C43.3115 394.532 45.1448 396.366 47.4025 396.366C49.6602 396.366 51.4935 394.532 51.4935 392.275C51.4935 390.017 49.6602 388.184 47.4025 388.184Z"
            fill="white"
          />
          <path
            d="M39.5001 377.422C37.2509 377.422 35.4219 379.255 35.4219 381.5C35.4219 383.745 37.2552 385.591 39.5001 385.591C41.7451 385.591 43.5911 383.758 43.5911 381.5C43.5911 379.242 41.7578 377.422 39.5001 377.422Z"
            fill="white"
          />
          <path
            d="M31.8543 366.586C29.5967 366.586 27.7549 368.419 27.7549 370.677C27.7549 372.935 29.5967 374.768 31.8543 374.768C34.112 374.768 35.9453 372.935 35.9453 370.677C35.9453 368.419 34.112 366.586 31.8543 366.586Z"
            fill="white"
          />
          <path
            d="M24.3292 356.254C22.08 356.254 20.251 358.087 20.251 360.345C20.251 362.603 22.0843 364.423 24.3292 364.423C26.5742 364.423 28.4202 362.603 28.4202 360.345C28.4202 358.087 26.5869 356.254 24.3292 356.254Z"
            fill="white"
          />
          <path
            d="M30.5629 346.615C28.3137 346.615 26.4932 348.449 26.4932 350.693C26.4932 352.938 28.3137 354.772 30.5629 354.772C32.8121 354.772 34.6412 352.951 34.6412 350.693C34.6412 348.436 32.8206 346.615 30.5629 346.615Z"
            fill="white"
          />
          <path
            d="M36.9506 336.342C34.7014 336.342 32.8809 338.162 32.8809 340.412C32.8809 342.661 34.7014 344.481 36.9506 344.481C39.1998 344.481 41.0204 342.661 41.0204 340.412C41.0204 338.162 39.1998 336.342 36.9506 336.342Z"
            fill="white"
          />
          <path
            d="M43.52 325.197C41.2708 325.197 39.4502 327.018 39.4502 329.267C39.4502 331.516 41.2708 333.337 43.52 333.337C45.7691 333.337 47.5897 331.516 47.5897 329.267C47.5897 327.018 45.7691 325.197 43.52 325.197Z"
            fill="white"
          />
          <path
            d="M50.2846 313.268C48.0481 313.268 46.2275 315.08 46.2275 317.316C46.2275 319.553 48.0481 321.365 50.2846 321.365C52.521 321.365 54.3331 319.553 54.3331 317.316C54.3331 315.08 52.521 313.268 50.2846 313.268Z"
            fill="white"
          />
          <path
            d="M57.3115 300.486C55.0836 300.486 53.2715 302.298 53.2715 304.526C53.2715 306.754 55.0836 308.566 57.3115 308.566C59.5395 308.566 61.3516 306.754 61.3516 304.526C61.3516 302.298 59.5395 300.486 57.3115 300.486Z"
            fill="white"
          />
          <path
            d="M64.5859 287.094C62.3579 287.094 60.5586 288.893 60.5586 291.113C60.5586 293.332 62.3579 295.131 64.5859 295.131C66.8139 295.131 68.6047 293.332 68.6047 291.113C68.6047 288.893 66.8054 287.094 64.5859 287.094Z"
            fill="white"
          />
          <path
            d="M72.1089 273.285C69.9022 273.285 68.1113 275.063 68.1113 277.27C68.1113 279.477 69.9022 281.268 72.1089 281.268C74.3157 281.268 76.0938 279.477 76.0938 277.27C76.0938 275.063 74.303 273.285 72.1089 273.285Z"
            fill="white"
          />
          <path
            d="M79.7694 259.398C77.5753 259.398 75.793 261.189 75.793 263.383C75.793 265.577 77.5711 267.36 79.7694 267.36C81.9676 267.36 83.7458 265.582 83.7458 263.383C83.7458 261.185 81.9676 259.398 79.7694 259.398Z"
            fill="white"
          />
          <path
            d="M87.5235 245.68C85.338 245.68 83.5684 247.449 83.5684 249.622C83.5684 251.795 85.338 253.577 87.5235 253.577C89.7091 253.577 91.466 251.808 91.466 249.622C91.466 247.437 89.7048 245.68 87.5235 245.68Z"
            fill="white"
          />
          <path
            d="M95.1615 232.535C92.9845 232.535 91.2275 234.292 91.2275 236.469C91.2275 238.646 92.9887 240.403 95.1615 240.403C97.3343 240.403 99.0954 238.646 99.0954 236.469C99.0954 234.292 97.3258 232.535 95.1615 232.535Z"
            fill="white"
          />
          <path
            d="M102.499 220.295C100.343 220.295 98.5947 222.043 98.5947 224.199C98.5947 226.355 100.343 228.103 102.499 228.103C104.655 228.103 106.403 226.355 106.403 224.199C106.403 222.043 104.655 220.295 102.499 220.295Z"
            fill="white"
          />
          <path
            d="M109.442 209.105C107.307 209.105 105.571 210.833 105.571 212.976C105.571 215.119 107.311 216.859 109.442 216.859C111.572 216.859 113.325 215.119 113.325 212.976C113.325 210.833 111.585 209.105 109.442 209.105Z"
            fill="white"
          />
          <path
            d="M118.663 205.6C120.163 204.101 120.163 201.669 118.663 200.169C117.163 198.669 114.731 198.669 113.231 200.169C111.731 201.669 111.731 204.101 113.231 205.6C114.731 207.1 117.163 207.1 118.663 205.6Z"
            fill="white"
          />
          <path
            d="M121.965 190.395C119.865 190.395 118.154 192.101 118.154 194.205C118.154 196.31 119.86 198.016 121.965 198.016C124.07 198.016 125.776 196.31 125.776 194.205C125.776 192.101 124.07 190.395 121.965 190.395Z"
            fill="white"
          />
          <path
            d="M127.512 183.117C125.433 183.117 123.735 184.815 123.735 186.907C123.735 188.999 125.433 190.684 127.512 190.684C129.592 190.684 131.302 188.991 131.302 186.907C131.302 184.823 129.604 183.117 127.512 183.117Z"
            fill="white"
          />
          <path
            d="M132.592 176.934C130.529 176.934 128.857 178.61 128.857 180.668C128.857 182.726 130.534 184.411 132.592 184.411C134.65 184.411 136.326 182.739 136.326 180.668C136.326 178.597 134.65 176.934 132.592 176.934Z"
            fill="white"
          />
          <path
            d="M137.191 171.574C135.163 171.574 133.508 173.225 133.508 175.258C133.508 177.291 135.163 178.954 137.191 178.954C139.22 178.954 140.888 177.299 140.888 175.258C140.888 173.217 139.233 171.574 137.191 171.574Z"
            fill="white"
          />
          <path
            d="M141.363 166.766C139.343 166.766 137.7 168.399 137.7 170.419C137.7 172.44 139.347 174.073 141.363 174.073C143.378 174.073 145.016 172.44 145.016 170.419C145.016 168.399 143.383 166.766 141.363 166.766Z"
            fill="white"
          />
          <path
            d="M145.11 162.314C143.124 162.314 141.499 163.94 141.499 165.93C141.499 167.92 143.124 169.546 145.11 169.546C147.097 169.546 148.722 167.92 148.722 165.93C148.722 163.94 147.109 162.314 145.11 162.314Z"
            fill="white"
          />
          <path
            d="M148.452 158.049C146.474 158.049 144.87 159.657 144.87 161.635C144.87 163.612 146.474 165.217 148.452 165.217C150.429 165.217 152.034 163.612 152.034 161.635C152.034 159.657 150.429 158.049 148.452 158.049Z"
            fill="white"
          />
          <path
            d="M151.345 153.934C149.41 153.934 147.827 155.504 147.827 157.452C147.827 159.4 149.41 160.974 151.345 160.974C153.28 160.974 154.876 159.395 154.876 157.452C154.876 155.508 153.293 153.934 151.345 153.934Z"
            fill="white"
          />
          <path
            d="M153.801 149.896C151.887 149.896 150.334 151.445 150.334 153.368C150.334 155.29 151.883 156.839 153.801 156.839C155.719 156.839 157.277 155.29 157.277 153.368C157.277 151.445 155.715 149.896 153.801 149.896Z"
            fill="white"
          />
          <path
            d="M155.865 145.965C153.972 145.965 152.432 147.497 152.432 149.39C152.432 151.282 153.972 152.818 155.865 152.818C157.758 152.818 159.29 151.282 159.29 149.39C159.29 147.497 157.749 145.965 155.865 145.965Z"
            fill="white"
          />
          <path
            d="M157.571 142.18C155.708 142.18 154.188 143.695 154.188 145.558C154.188 147.421 155.708 148.94 157.571 148.94C159.434 148.94 160.953 147.425 160.953 145.558C160.953 143.69 159.434 142.18 157.571 142.18Z"
            fill="white"
          />
          <path
            d="M159.004 138.584C157.184 138.584 155.707 140.061 155.707 141.894C155.707 143.727 157.184 145.192 159.004 145.192C160.825 145.192 162.306 143.715 162.306 141.894C162.306 140.074 160.829 138.584 159.004 138.584Z"
            fill="white"
          />
          <path
            d="M160.222 135.107C158.423 135.107 156.963 136.563 156.963 138.367C156.963 140.17 158.418 141.626 160.222 141.626C162.026 141.626 163.481 140.17 163.481 138.367C163.481 136.563 162.026 135.107 160.222 135.107Z"
            fill="white"
          />
          <path
            d="M161.275 131.734C159.506 131.734 158.071 133.169 158.071 134.938C158.071 136.708 159.506 138.151 161.275 138.151C163.045 138.151 164.479 136.712 164.479 134.938C164.479 133.165 163.045 131.734 161.275 131.734Z"
            fill="white"
          />
          <path
            d="M162.18 128.441C160.444 128.441 159.035 129.85 159.035 131.59C159.035 133.33 160.44 134.743 162.18 134.743C163.92 134.743 165.333 133.326 165.333 131.59C165.333 129.855 163.915 128.441 162.18 128.441Z"
            fill="white"
          />
          <path
            d="M162.974 125.16C161.276 125.16 159.901 126.539 159.901 128.237C159.901 129.934 161.276 131.309 162.974 131.309C164.671 131.309 166.055 129.934 166.055 128.237C166.055 126.539 164.671 125.16 162.974 125.16Z"
            fill="white"
          />
          <path
            d="M163.689 121.779C162.026 121.779 160.672 123.129 160.672 124.792C160.672 126.456 162.026 127.801 163.689 127.801C165.353 127.801 166.698 126.452 166.698 124.792C166.698 123.133 165.344 121.779 163.689 121.779Z"
            fill="white"
          />
          <path
            d="M164.343 118.205C162.709 118.205 161.385 119.525 161.385 121.163C161.385 122.801 162.709 124.108 164.343 124.108C165.977 124.108 167.301 122.788 167.301 121.163C167.301 119.538 165.977 118.205 164.343 118.205Z"
            fill="white"
          />
          <path
            d="M165.023 114.326C163.419 114.326 162.129 115.621 162.129 117.212C162.129 118.803 163.419 120.106 165.023 120.106C166.627 120.106 167.917 118.816 167.917 117.212C167.917 115.608 166.615 114.326 165.023 114.326Z"
            fill="white"
          />
          <path
            d="M165.79 110.045C164.241 110.045 162.989 111.293 162.989 112.846C162.989 114.399 164.237 115.638 165.79 115.638C167.343 115.638 168.578 114.386 168.578 112.846C168.578 111.305 167.331 110.045 165.79 110.045Z"
            fill="white"
          />
          <path
            d="M166.793 105.111C165.274 105.111 164.056 106.338 164.056 107.849C164.056 109.359 165.274 110.586 166.793 110.586C168.312 110.586 169.53 109.364 169.53 107.849C169.53 106.334 168.304 105.111 166.793 105.111Z"
            fill="white"
          />
          <path
            d="M168.239 99.3301C166.762 99.3301 165.565 100.527 165.565 101.999C165.565 103.472 166.762 104.673 168.239 104.673C169.716 104.673 170.913 103.476 170.913 101.999C170.913 100.523 169.716 99.3301 168.239 99.3301Z"
            fill="white"
          />
          <path
            d="M170.54 92.2832C169.105 92.2832 167.938 93.4545 167.938 94.8889C167.938 96.3233 169.105 97.503 170.54 97.503C171.974 97.503 173.154 96.336 173.154 94.8889C173.154 93.4417 171.987 92.2832 170.54 92.2832Z"
            fill="white"
          />
          <path
            d="M174.418 83.418C173.035 83.418 171.91 84.5468 171.91 85.9388C171.91 87.3307 173.035 88.4595 174.418 88.4595C175.802 88.4595 176.939 87.3307 176.939 85.9388C176.939 84.5468 175.814 83.418 174.418 83.418Z"
            fill="white"
          />
          <path
            d="M180.844 71.9863C179.503 71.9863 178.399 73.0855 178.399 74.4265C178.399 75.7675 179.503 76.8709 180.844 76.8709C182.185 76.8709 183.288 75.7802 183.288 74.4265C183.288 73.0727 182.193 71.9863 180.844 71.9863Z"
            fill="white"
          />
          <path
            d="M191.239 56.8184C189.915 56.8184 188.854 57.8835 188.854 59.2033C188.854 60.5232 189.915 61.5883 191.239 61.5883C192.564 61.5883 193.624 60.5274 193.624 59.2033C193.624 57.8793 192.551 56.8184 191.239 56.8184Z"
            fill="white"
          />
          <path
            d="M207.142 36.4492C205.86 36.4492 204.82 37.4889 204.82 38.7748C204.82 40.0607 205.86 41.1004 207.142 41.1004C208.423 41.1004 209.463 40.0607 209.463 38.7748C209.463 37.4889 208.423 36.4492 207.142 36.4492Z"
            fill="white"
          />
          <path
            d="M228.177 10.1484C226.951 10.1484 225.949 11.1415 225.949 12.3806C225.949 13.6198 226.946 14.6086 228.177 14.6086C229.408 14.6086 230.405 13.6113 230.405 12.3806C230.405 11.15 229.416 10.1484 228.177 10.1484Z"
            fill="white"
          />
          <path
            d="M247.389 4.76367C246.163 4.76367 245.174 5.75671 245.174 6.97467C245.174 8.19262 246.163 9.1899 247.389 9.1899C248.616 9.1899 249.604 8.20111 249.604 6.97467C249.604 5.74822 248.616 4.76367 247.389 4.76367Z"
            fill="white"
          />
          <path
            d="M268.112 -4.02734C266.885 -4.02734 265.884 -3.03006 265.884 -1.79938C265.884 -0.568687 266.881 0.415862 268.112 0.415862C269.342 0.415862 270.327 -0.577175 270.327 -1.79938C270.327 -3.02158 269.338 -4.02734 268.112 -4.02734Z"
            fill="white"
          />
          <path
            d="M905.263 -0.914062C903.638 -0.914062 902.318 0.4015 902.318 2.0311C902.318 3.6607 903.642 4.97626 905.263 4.97626C906.885 4.97626 908.217 3.6607 908.217 2.0311C908.217 0.4015 906.897 -0.914062 905.263 -0.914062Z"
            fill="white"
          />
          <path
            d="M912.725 9.81641C911.07 9.81641 909.729 11.1574 909.729 12.8125C909.729 14.4676 911.07 15.8086 912.725 15.8086C914.38 15.8086 915.721 14.4676 915.721 12.8125C915.721 11.1574 914.38 9.81641 912.725 9.81641Z"
            fill="white"
          />
          <path
            d="M920.054 20.7266C918.348 20.7266 916.973 22.11 916.973 23.8075C916.973 25.505 918.348 26.897 920.054 26.897C921.76 26.897 923.135 25.5135 923.135 23.8075C923.135 22.1015 921.751 20.7266 920.054 20.7266Z"
            fill="white"
          />
          <path
            d="M927.263 31.7988C925.523 31.7988 924.11 33.2162 924.11 34.9519C924.11 36.6876 925.528 38.0966 927.263 38.0966C928.999 38.0966 930.408 36.6919 930.408 34.9519C930.408 33.212 929.003 31.7988 927.263 31.7988Z"
            fill="white"
          />
          <path
            d="M934.372 43.0059C932.611 43.0059 931.177 44.4318 931.177 46.2014C931.177 47.971 932.615 49.3969 934.372 49.3969C936.129 49.3969 937.568 47.9626 937.568 46.2014C937.568 44.4402 936.142 43.0059 934.372 43.0059Z"
            fill="white"
          />
          <path
            d="M941.377 54.3203C939.578 54.3203 938.118 55.7759 938.118 57.5795C938.118 59.3831 939.574 60.826 941.377 60.826C943.181 60.826 944.624 59.3746 944.624 57.5795C944.624 55.7844 943.168 54.3203 941.377 54.3203Z"
            fill="white"
          />
          <path
            d="M948.266 65.7266C946.433 65.7266 944.935 67.2161 944.935 69.0579C944.935 70.8997 946.433 72.3892 948.266 72.3892C950.099 72.3892 951.597 70.8997 951.597 69.0579C951.597 67.2161 950.108 65.7266 948.266 65.7266Z"
            fill="white"
          />
          <path
            d="M955.086 77.248C953.211 77.248 951.691 78.7673 951.691 80.6346C951.691 82.5018 953.211 84.0211 955.086 84.0211C956.962 84.0211 958.469 82.5018 958.469 80.6346C958.469 78.7673 956.949 77.248 955.086 77.248Z"
            fill="white"
          />
          <path
            d="M961.838 88.8379C959.932 88.8379 958.404 90.3741 958.404 92.2796C958.404 94.185 959.932 95.7128 961.838 95.7128C963.743 95.7128 965.271 94.1723 965.271 92.2796C965.271 90.3869 963.73 88.8379 961.838 88.8379Z"
            fill="white"
          />
          <path
            d="M968.551 100.479C966.624 100.479 965.075 102.04 965.075 103.967C965.075 105.894 966.624 107.447 968.551 107.447C970.477 107.447 972.039 105.889 972.039 103.967C972.039 102.044 970.477 100.479 968.551 100.479Z"
            fill="white"
          />
          <path
            d="M975.243 112.186C973.274 112.186 971.683 113.777 971.683 115.733C971.683 117.69 973.274 119.294 975.243 119.294C977.212 119.294 978.791 117.702 978.791 115.733C978.791 113.764 977.2 112.186 975.243 112.186Z"
            fill="white"
          />
          <path
            d="M981.872 124.098C979.886 124.098 978.27 125.71 978.27 127.696C978.27 129.682 979.882 131.299 981.872 131.299C983.863 131.299 985.475 129.687 985.475 127.696C985.475 125.706 983.863 124.098 981.872 124.098Z"
            fill="white"
          />
          <path
            d="M988.463 136.215C986.456 136.215 984.822 137.844 984.822 139.852C984.822 141.859 986.456 143.493 988.463 143.493C990.471 143.493 992.105 141.859 992.105 139.852C992.105 137.844 990.471 136.215 988.463 136.215Z"
            fill="white"
          />
          <path
            d="M995.04 148.535C992.999 148.535 991.356 150.182 991.356 152.214C991.356 154.247 993.003 155.894 995.04 155.894C997.077 155.894 998.715 154.247 998.715 152.214C998.715 150.182 997.069 148.535 995.04 148.535Z"
            fill="white"
          />
          <path
            d="M1001.65 160.969C999.585 160.969 997.913 162.645 997.913 164.712C997.913 166.778 999.589 168.455 1001.65 168.455C1003.71 168.455 1005.38 166.778 1005.38 164.712C1005.38 162.645 1003.71 160.969 1001.65 160.969Z"
            fill="white"
          />
          <path
            d="M1008.35 173.514C1006.26 173.514 1004.58 175.211 1004.58 177.303C1004.58 179.396 1006.26 181.089 1008.35 181.089C1010.44 181.089 1012.14 179.396 1012.14 177.303C1012.14 175.211 1010.44 173.514 1008.35 173.514Z"
            fill="white"
          />
          <path
            d="M1015.22 186.061C1013.12 186.061 1011.41 187.771 1011.41 189.88C1011.41 191.989 1013.11 193.699 1015.22 193.699C1017.32 193.699 1019.04 191.989 1019.04 189.88C1019.04 187.771 1017.33 186.061 1015.22 186.061Z"
            fill="white"
          />
          <path
            d="M1022.32 198.48C1020.2 198.48 1018.48 200.208 1018.48 202.33C1018.48 204.451 1020.2 206.179 1022.32 206.179C1024.44 206.179 1026.17 204.451 1026.17 202.33C1026.17 200.208 1024.45 198.48 1022.32 198.48Z"
            fill="white"
          />
          <path
            d="M1029.75 218.269C1031.91 218.269 1033.65 216.521 1033.65 214.365C1033.65 212.209 1031.91 210.461 1029.75 210.461C1027.59 210.461 1025.85 212.209 1025.85 214.365C1025.85 216.521 1027.59 218.269 1029.75 218.269Z"
            fill="white"
          />
          <path
            d="M1037.6 221.752C1035.42 221.752 1033.66 223.509 1033.66 225.686C1033.66 227.863 1035.42 229.62 1037.6 229.62C1039.77 229.62 1041.53 227.859 1041.53 225.686C1041.53 223.513 1039.77 221.752 1037.6 221.752Z"
            fill="white"
          />
          <path
            d="M1045.91 232.1C1043.72 232.1 1041.94 233.869 1041.94 236.063C1041.94 238.257 1043.72 240.027 1045.91 240.027C1048.11 240.027 1049.88 238.249 1049.88 236.063C1049.88 233.878 1048.1 232.1 1045.91 232.1Z"
            fill="white"
          />
          <path
            d="M1054.66 241.342C1052.46 241.342 1050.67 243.12 1050.67 245.327C1050.67 247.533 1052.46 249.303 1054.66 249.303C1056.85 249.303 1058.64 247.525 1058.64 245.327C1058.64 243.128 1056.86 241.342 1054.66 241.342Z"
            fill="white"
          />
          <path
            d="M1063.77 249.396C1061.54 249.396 1059.75 251.196 1059.75 253.424C1059.75 255.652 1061.54 257.464 1063.77 257.464C1066 257.464 1067.81 255.652 1067.81 253.424C1067.81 251.196 1066 249.396 1063.77 249.396Z"
            fill="white"
          />
          <path
            d="M1073.17 256.361C1070.92 256.361 1069.12 258.182 1069.12 260.418C1069.12 262.655 1070.93 264.488 1073.17 264.488C1075.42 264.488 1077.23 262.668 1077.23 260.418C1077.23 258.169 1075.41 256.361 1073.17 256.361Z"
            fill="white"
          />
          <path
            d="M1082.74 262.373C1080.48 262.373 1078.66 264.206 1078.66 266.451C1078.66 268.696 1080.48 270.53 1082.74 270.53C1085 270.53 1086.82 268.709 1086.82 266.451C1086.82 264.194 1084.98 262.373 1082.74 262.373Z"
            fill="white"
          />
          <path
            d="M1092.41 267.576C1090.13 267.576 1088.31 269.409 1088.31 271.667C1088.31 273.925 1090.14 275.767 1092.41 275.767C1094.67 275.767 1096.5 273.933 1096.5 271.667C1096.5 269.401 1094.66 267.576 1092.41 267.576Z"
            fill="white"
          />
          <path
            d="M1102.13 272.105C1099.85 272.105 1097.99 273.947 1097.99 276.226C1097.99 278.505 1099.85 280.347 1102.13 280.347C1104.41 280.347 1106.25 278.505 1106.25 276.226C1106.25 273.947 1104.39 272.105 1102.13 272.105Z"
            fill="white"
          />
          <path
            d="M1111.87 276.115C1109.58 276.115 1107.72 277.97 1107.72 280.257C1107.72 282.545 1109.58 284.399 1111.87 284.399C1114.15 284.399 1116.01 282.545 1116.01 280.257C1116.01 277.97 1114.15 276.115 1111.87 276.115Z"
            fill="white"
          />
          <path
            d="M1121.62 279.725C1119.33 279.725 1117.47 281.588 1117.47 283.879C1117.47 286.171 1119.33 288.034 1121.62 288.034C1123.92 288.034 1125.78 286.184 1125.78 283.879C1125.78 281.575 1123.93 279.725 1121.62 279.725Z"
            fill="white"
          />
          <path
            d="M1131.36 283.086C1129.07 283.086 1127.21 284.94 1127.21 287.241C1127.21 289.541 1129.07 291.395 1131.36 291.395C1133.65 291.395 1135.52 289.532 1135.52 287.241C1135.52 284.949 1133.67 283.086 1131.36 283.086Z"
            fill="white"
          />
          <path
            d="M1141.09 286.24C1138.79 286.24 1136.94 288.103 1136.94 290.395C1136.94 292.686 1138.79 294.55 1141.09 294.55C1143.39 294.55 1145.25 292.695 1145.25 290.395C1145.25 288.095 1143.38 286.24 1141.09 286.24Z"
            fill="white"
          />
          <path
            d="M1150.79 289.25C1148.5 289.25 1146.64 291.113 1146.64 293.405C1146.64 295.696 1148.5 297.559 1150.79 297.559C1153.08 297.559 1154.95 295.709 1154.95 293.405C1154.95 291.1 1153.1 289.25 1150.79 289.25Z"
            fill="white"
          />
          <path
            d="M1160.47 292.131C1158.17 292.131 1156.32 293.994 1156.32 296.285C1156.32 298.577 1158.17 300.44 1160.47 300.44C1162.78 300.44 1164.63 298.586 1164.63 296.285C1164.63 293.985 1162.77 292.131 1160.47 292.131Z"
            fill="white"
          />
          <path
            d="M1170.07 294.896C1167.78 294.896 1165.91 296.759 1165.91 299.051C1165.91 301.343 1167.78 303.206 1170.07 303.206C1172.36 303.206 1174.23 301.343 1174.23 299.051C1174.23 296.759 1172.37 294.896 1170.07 294.896Z"
            fill="white"
          />
          <path
            d="M1179.57 297.576C1177.28 297.576 1175.42 299.439 1175.42 301.731C1175.42 304.022 1177.28 305.885 1179.57 305.885C1181.86 305.885 1183.73 304.035 1183.73 301.731C1183.73 299.426 1181.86 297.576 1179.57 297.576Z"
            fill="white"
          />
          <path
            d="M1175.27 297.613C1172.98 297.613 1171.12 299.476 1171.12 301.768C1171.12 304.06 1172.98 305.931 1175.27 305.931C1177.56 305.931 1179.43 304.068 1179.43 301.768C1179.43 299.468 1177.57 297.613 1175.27 297.613Z"
            fill="white"
          />
          <path
            d="M1170.64 297.555C1168.35 297.555 1166.49 299.409 1166.49 301.709C1166.49 304.009 1168.35 305.864 1170.64 305.864C1172.93 305.864 1174.8 304.001 1174.8 301.709C1174.8 299.418 1172.93 297.555 1170.64 297.555Z"
            fill="white"
          />
          <path
            d="M1165.67 297.389C1163.38 297.389 1161.52 299.239 1161.52 301.543C1161.52 303.848 1163.38 305.698 1165.67 305.698C1167.96 305.698 1169.82 303.835 1169.82 301.543C1169.82 299.252 1167.97 297.389 1165.67 297.389Z"
            fill="white"
          />
          <path
            d="M1160.36 297.139C1158.07 297.139 1156.21 299.002 1156.21 301.293C1156.21 303.585 1158.07 305.448 1160.36 305.448C1162.65 305.448 1164.52 303.585 1164.52 301.293C1164.52 299.002 1162.66 297.139 1160.36 297.139Z"
            fill="white"
          />
          <path
            d="M1154.73 296.826C1152.44 296.826 1150.57 298.689 1150.57 300.981C1150.57 303.272 1152.44 305.135 1154.73 305.135C1157.02 305.135 1158.88 303.272 1158.88 300.981C1158.88 298.689 1157.03 296.826 1154.73 296.826Z"
            fill="white"
          />
          <path
            d="M1148.77 296.473C1146.48 296.473 1144.62 298.336 1144.62 300.627C1144.62 302.919 1146.48 304.782 1148.77 304.782C1151.07 304.782 1152.93 302.919 1152.93 300.627C1152.93 298.336 1151.08 296.473 1148.77 296.473Z"
            fill="white"
          />
          <path
            d="M1142.51 296.094C1140.22 296.094 1138.36 297.957 1138.36 300.248C1138.36 302.54 1140.22 304.403 1142.51 304.403C1144.8 304.403 1146.67 302.54 1146.67 300.248C1146.67 297.957 1144.82 296.094 1142.51 296.094Z"
            fill="white"
          />
          <path
            d="M1135.94 295.73C1133.64 295.73 1131.78 297.585 1131.78 299.885C1131.78 302.185 1133.64 304.04 1135.94 304.04C1138.24 304.04 1140.1 302.177 1140.1 299.885C1140.1 297.593 1138.23 295.73 1135.94 295.73Z"
            fill="white"
          />
          <path
            d="M1129.05 295.391C1126.76 295.391 1124.9 297.254 1124.9 299.545C1124.9 301.837 1126.76 303.7 1129.05 303.7C1131.34 303.7 1133.21 301.845 1133.21 299.545C1133.21 297.245 1131.35 295.391 1129.05 295.391Z"
            fill="white"
          />
          <path
            d="M1121.87 295.119C1119.58 295.119 1117.71 296.982 1117.71 299.274C1117.71 301.565 1119.58 303.428 1121.87 303.428C1124.16 303.428 1126.02 301.574 1126.02 299.274C1126.02 296.974 1124.16 295.119 1121.87 295.119Z"
            fill="white"
          />
          <path
            d="M1114.39 294.932C1112.09 294.932 1110.23 296.795 1110.23 299.086C1110.23 301.378 1112.09 303.237 1114.39 303.237C1116.69 303.237 1118.54 301.386 1118.54 299.086C1118.54 296.786 1116.68 294.932 1114.39 294.932Z"
            fill="white"
          />
          <path
            d="M1106.59 294.848C1104.31 294.848 1102.46 296.702 1102.46 298.99C1102.46 301.277 1104.31 303.123 1106.59 303.123C1108.87 303.123 1110.73 301.268 1110.73 298.99C1110.73 296.711 1108.88 294.848 1106.59 294.848Z"
            fill="white"
          />
          <path
            d="M1101.42 301.916C1103.03 300.31 1103.03 297.706 1101.42 296.1C1099.82 294.494 1097.21 294.494 1095.61 296.1C1094 297.706 1094 300.31 1095.61 301.916C1097.21 303.521 1099.82 303.522 1101.42 301.916Z"
            fill="white"
          />
          <path
            d="M1090.15 295.09C1087.88 295.09 1086.05 296.923 1086.05 299.189C1086.05 301.455 1087.88 303.289 1090.15 303.289C1092.41 303.289 1094.24 301.447 1094.24 299.189C1094.24 296.932 1092.4 295.09 1090.15 295.09Z"
            fill="white"
          />
          <path
            d="M1081.51 295.471C1079.25 295.471 1077.43 297.304 1077.43 299.549C1077.43 301.794 1079.25 303.627 1081.51 303.627C1083.77 303.627 1085.59 301.807 1085.59 299.549C1085.59 297.291 1083.75 295.471 1081.51 295.471Z"
            fill="white"
          />
          <path
            d="M1072.62 296.107C1070.38 296.107 1068.58 297.92 1068.58 300.147C1068.58 302.375 1070.38 304.196 1072.62 304.196C1074.86 304.196 1076.66 302.384 1076.66 300.147C1076.66 297.911 1074.85 296.107 1072.62 296.107Z"
            fill="white"
          />
          <path
            d="M1063.51 296.969C1061.29 296.969 1059.49 298.76 1059.49 300.975C1059.49 303.19 1061.29 304.994 1063.51 304.994C1065.72 304.994 1067.51 303.194 1067.51 300.975C1067.51 298.755 1065.71 296.969 1063.51 296.969Z"
            fill="white"
          />
          <path
            d="M1054.16 298.033C1051.95 298.033 1050.16 299.824 1050.16 302.031C1050.16 304.238 1051.95 306.028 1054.16 306.028C1056.36 306.028 1058.14 304.238 1058.14 302.031C1058.14 299.824 1056.36 298.033 1054.16 298.033Z"
            fill="white"
          />
          <path
            d="M1044.59 299.375C1042.41 299.375 1040.64 301.145 1040.64 303.339C1040.64 305.533 1042.41 307.294 1044.59 307.294C1046.78 307.294 1048.55 305.524 1048.55 303.339C1048.55 301.153 1046.78 299.375 1044.59 299.375Z"
            fill="white"
          />
          <path
            d="M1034.84 301.016C1032.67 301.016 1030.92 302.764 1030.92 304.928C1030.92 307.093 1032.67 308.854 1034.84 308.854C1037 308.854 1038.76 307.097 1038.76 304.928C1038.76 302.76 1037.01 301.016 1034.84 301.016Z"
            fill="white"
          />
          <path
            d="M1024.92 302.975C1022.76 302.975 1021.03 304.715 1021.03 306.858C1021.03 309.001 1022.76 310.749 1024.92 310.749C1027.08 310.749 1028.8 309.009 1028.8 306.858C1028.8 304.706 1027.06 302.975 1024.92 302.975Z"
            fill="white"
          />
          <path
            d="M1014.84 305.256C1012.72 305.256 1011 306.975 1011 309.105C1011 311.235 1012.72 312.946 1014.84 312.946C1016.96 312.946 1018.69 311.227 1018.69 309.105C1018.69 306.983 1016.96 305.256 1014.84 305.256Z"
            fill="white"
          />
          <path
            d="M1004.59 307.773C1002.49 307.773 1000.78 309.479 1000.78 311.593C1000.78 313.706 1002.49 315.412 1004.59 315.412C1006.7 315.412 1008.41 313.693 1008.41 311.593C1008.41 309.492 1006.71 307.773 1004.59 307.773Z"
            fill="white"
          />
          <path
            d="M994.209 310.617C992.125 310.617 990.44 312.302 990.44 314.386C990.44 316.469 992.125 318.154 994.209 318.154C996.293 318.154 997.977 316.469 997.977 314.386C997.977 312.302 996.293 310.617 994.209 310.617Z"
            fill="white"
          />
          <path
            d="M983.697 313.791C981.634 313.791 979.971 315.455 979.971 317.517C979.971 319.58 981.634 321.243 983.697 321.243C985.759 321.243 987.414 319.58 987.414 317.517C987.414 315.455 985.751 313.791 983.697 313.791Z"
            fill="white"
          />
          <path
            d="M973.078 317.389C971.05 317.389 969.395 319.035 969.395 321.064C969.395 323.092 971.05 324.747 973.078 324.747C975.107 324.747 976.762 323.101 976.762 321.064C976.762 319.027 975.107 317.389 973.078 317.389Z"
            fill="white"
          />
          <path
            d="M962.401 321.439C960.381 321.439 958.747 323.073 958.747 325.081C958.747 327.088 960.381 328.734 962.401 328.734C964.421 328.734 966.042 327.101 966.042 325.081C966.042 323.061 964.408 321.439 962.401 321.439Z"
            fill="white"
          />
          <path
            d="M951.691 326.059C949.714 326.059 948.109 327.663 948.109 329.649C948.109 331.635 949.714 333.239 951.691 333.239C953.669 333.239 955.281 331.626 955.281 329.649C955.281 327.671 953.677 326.059 951.691 326.059Z"
            fill="white"
          />
          <path
            d="M941.034 331.318C939.078 331.318 937.495 332.901 937.495 334.845C937.495 336.789 939.078 338.371 941.034 338.371C942.991 338.371 944.561 336.789 944.561 334.845C944.561 332.901 942.978 331.318 941.034 331.318Z"
            fill="white"
          />
          <path
            d="M930.387 337.25C928.473 337.25 926.911 338.812 926.911 340.738C926.911 342.665 928.473 344.227 930.387 344.227C932.301 344.227 933.875 342.665 933.875 340.738C933.875 338.812 932.314 337.25 930.387 337.25Z"
            fill="white"
          />
          <path
            d="M922.277 349.884C923.622 348.538 923.622 346.356 922.277 345.011C920.931 343.665 918.749 343.665 917.403 345.011C916.058 346.356 916.058 348.538 917.403 349.884C918.749 351.23 920.931 351.23 922.277 349.884Z"
            fill="white"
          />
          <path
            d="M909.466 351.74C907.603 351.74 906.092 353.251 906.092 355.114C906.092 356.977 907.603 358.475 909.466 358.475C911.329 358.475 912.827 356.964 912.827 355.114C912.827 353.264 911.316 351.74 909.466 351.74Z"
            fill="white"
          />
          <path
            d="M899.246 360.469C897.413 360.469 895.928 361.946 895.928 363.787C895.928 365.629 897.417 367.106 899.246 367.106C901.075 367.106 902.565 365.616 902.565 363.787C902.565 361.958 901.075 360.469 899.246 360.469Z"
            fill="white"
          />
          <path
            d="M889.329 370.482C887.53 370.482 886.062 371.951 886.062 373.763C886.062 375.575 887.53 377.043 889.329 377.043C891.129 377.043 892.61 375.575 892.61 373.763C892.61 371.951 891.141 370.482 889.329 370.482Z"
            fill="white"
          />
          <path
            d="M879.729 382.004C877.951 382.004 876.513 383.438 876.513 385.221C876.513 387.003 877.951 388.437 879.729 388.437C881.508 388.437 882.946 387.003 882.946 385.221C882.946 383.438 881.508 382.004 879.729 382.004Z"
            fill="white"
          />
          <path
            d="M870.55 395.387C868.823 395.387 867.418 396.791 867.418 398.519C867.418 400.246 868.823 401.663 870.55 401.663C872.277 401.663 873.694 400.259 873.694 398.519C873.694 396.779 872.29 395.387 870.55 395.387Z"
            fill="white"
          />
          <path
            d="M862.267 411.363C860.569 411.363 859.186 412.747 859.186 414.444C859.186 416.142 860.569 417.525 862.267 417.525C863.964 417.525 865.347 416.15 865.347 414.444C865.347 412.738 863.973 411.363 862.267 411.363Z"
            fill="white"
          />
          <path
            d="M855.701 430.879C854.037 430.879 852.684 432.241 852.684 433.909C852.684 435.577 854.037 436.926 855.701 436.926C857.364 436.926 858.718 435.572 858.718 433.909C858.718 432.245 857.364 430.879 855.701 430.879Z"
            fill="white"
          />
          <path
            d="M851.911 454.764C850.277 454.764 848.957 456.083 848.957 457.73C848.957 459.377 850.277 460.688 851.911 460.688C853.545 460.688 854.869 459.368 854.869 457.73C854.869 456.092 853.549 454.764 851.911 454.764Z"
            fill="white"
          />
          <path
            d="M851.797 483.625C850.205 483.625 848.915 484.915 848.915 486.507C848.915 488.098 850.205 489.388 851.797 489.388C853.388 489.388 854.678 488.098 854.678 486.507C854.678 484.915 853.388 483.625 851.797 483.625Z"
            fill="white"
          />
          <path
            d="M868.835 548.438C867.303 548.438 866.068 549.677 866.068 551.204C866.068 552.732 867.307 553.971 868.835 553.971C870.363 553.971 871.602 552.732 871.602 551.204C871.602 549.677 870.363 548.438 868.835 548.438Z"
            fill="white"
          />
          <path
            d="M861.621 557.355C860.101 557.355 858.875 558.582 858.875 560.105C858.875 561.629 860.101 562.851 861.621 562.851C863.14 562.851 864.366 561.625 864.366 560.105C864.366 558.586 863.14 557.355 861.621 557.355Z"
            fill="white"
          />
          <path
            d="M853.953 566.451C852.434 566.451 851.203 567.678 851.203 569.197C851.203 570.716 852.43 571.943 853.953 571.943C855.477 571.943 856.699 570.716 856.699 569.197C856.699 567.678 855.472 566.451 853.953 566.451Z"
            fill="white"
          />
          <path
            d="M845.605 575.488C844.086 575.488 842.859 576.715 842.859 578.234C842.859 579.753 844.086 580.98 845.605 580.98C847.124 580.98 848.355 579.753 848.355 578.234C848.355 576.715 847.129 575.488 845.605 575.488Z"
            fill="white"
          />
          <path
            d="M836.498 584.084C834.979 584.084 833.748 585.31 833.748 586.821C833.748 588.332 834.974 589.558 836.498 589.558C838.021 589.558 839.235 588.332 839.235 586.821C839.235 585.31 838.009 584.084 836.498 584.084Z"
            fill="white"
          />
          <path
            d="M826.826 592.305C825.307 592.305 824.089 593.531 824.089 595.042C824.089 596.553 825.307 597.779 826.826 597.779C828.345 597.779 829.563 596.561 829.563 595.042C829.563 593.523 828.337 592.305 826.826 592.305Z"
            fill="white"
          />
          <path
            d="M816.464 599.768C814.953 599.768 813.735 600.994 813.735 602.505C813.735 604.016 814.953 605.234 816.464 605.234C817.975 605.234 819.201 604.016 819.201 602.505C819.201 600.994 817.975 599.768 816.464 599.768Z"
            fill="white"
          />
          <path
            d="M805.366 606.312C803.868 606.312 802.65 607.53 802.65 609.029C802.65 610.527 803.868 611.745 805.366 611.745C806.864 611.745 808.082 610.527 808.082 609.029C808.082 607.53 806.877 606.312 805.366 606.312Z"
            fill="white"
          />
          <path
            d="M793.916 612.432C792.418 612.432 791.2 613.65 791.2 615.148C791.2 616.646 792.418 617.855 793.916 617.855C795.414 617.855 796.624 616.637 796.624 615.148C796.624 613.658 795.418 612.432 793.916 612.432Z"
            fill="white"
          />
          <path
            d="M782.178 618.084C780.68 618.084 779.471 619.302 779.471 620.8C779.471 622.298 780.68 623.508 782.178 623.508C783.676 623.508 784.886 622.29 784.886 620.8C784.886 619.31 783.681 618.084 782.178 618.084Z"
            fill="white"
          />
          <path
            d="M770.105 623.113C768.607 623.113 767.397 624.323 767.397 625.821C767.397 627.319 768.603 628.516 770.105 628.516C771.607 628.516 772.8 627.306 772.8 625.821C772.8 624.335 771.595 623.113 770.105 623.113Z"
            fill="white"
          />
          <path
            d="M757.7 627.68C756.21 627.68 755.005 628.889 755.005 630.375C755.005 631.86 756.214 633.069 757.7 633.069C759.185 633.069 760.394 631.864 760.394 630.375C760.394 628.885 759.189 627.68 757.7 627.68Z"
            fill="white"
          />
          <path
            d="M744.961 631.574C743.471 631.574 742.274 632.771 742.274 634.26C742.274 635.75 743.471 636.947 744.961 636.947C746.45 636.947 747.647 635.737 747.647 634.26C747.647 632.784 746.442 631.574 744.961 631.574Z"
            fill="white"
          />
          <path
            d="M731.898 634.635C730.421 634.635 729.225 635.844 729.225 637.321C729.225 638.798 730.421 639.995 731.898 639.995C733.375 639.995 734.572 638.798 734.572 637.321C734.572 635.844 733.375 634.635 731.898 634.635Z"
            fill="white"
          />
          <path
            d="M718.586 636.996C717.109 636.996 715.912 638.193 715.912 639.67C715.912 641.146 717.109 642.343 718.586 642.343C720.063 642.343 721.259 641.146 721.259 639.67C721.259 638.193 720.063 636.996 718.586 636.996Z"
            fill="white"
          />
          <path
            d="M705.065 638.723C703.588 638.723 702.392 639.919 702.392 641.396C702.392 642.873 703.588 644.07 705.065 644.07C706.542 644.07 707.739 642.873 707.739 641.396C707.739 639.919 706.542 638.723 705.065 638.723Z"
            fill="white"
          />
          <path
            d="M691.37 639.703C689.902 639.703 688.705 640.9 688.705 642.368C688.705 643.837 689.902 645.042 691.37 645.042C692.839 645.042 694.044 643.845 694.044 642.368C694.044 640.891 692.847 639.703 691.37 639.703Z"
            fill="white"
          />
          <path
            d="M677.535 639.961C676.067 639.961 674.883 641.149 674.883 642.626C674.883 644.103 676.071 645.291 677.535 645.291C678.999 645.291 680.2 644.094 680.2 642.626C680.2 641.158 679.012 639.961 677.535 639.961Z"
            fill="white"
          />
          <path
            d="M663.62 639.754C662.152 639.754 660.955 640.942 660.955 642.406C660.955 643.87 662.152 645.071 663.62 645.071C665.089 645.071 666.273 643.883 666.273 642.406C666.273 640.929 665.084 639.754 663.62 639.754Z"
            fill="white"
          />
          <path
            d="M649.591 639.008C648.122 639.008 646.938 640.196 646.938 641.66C646.938 643.124 648.127 644.312 649.591 644.312C651.055 644.312 652.243 643.124 652.243 641.66C652.243 640.196 651.055 639.008 649.591 639.008Z"
            fill="white"
          />
          <path
            d="M635.459 637.746C634.004 637.746 632.815 638.922 632.815 640.39C632.815 641.858 634.004 643.034 635.459 643.034C636.915 643.034 638.112 641.846 638.112 640.39C638.112 638.934 636.923 637.746 635.459 637.746Z"
            fill="white"
          />
          <path
            d="M621.23 641.452C622.69 641.452 623.874 640.268 623.874 638.808C623.874 637.348 622.69 636.164 621.23 636.164C619.77 636.164 618.586 637.348 618.586 638.808C618.586 640.268 619.77 641.452 621.23 641.452Z"
            fill="white"
          />
          <path
            d="M606.962 634.738C605.494 634.738 604.318 635.914 604.318 637.382C604.318 638.851 605.494 640.026 606.962 640.026C608.431 640.026 609.606 638.838 609.606 637.382C609.606 635.927 608.418 634.738 606.962 634.738Z"
            fill="white"
          />
          <path
            d="M592.724 633.705C591.269 633.705 590.089 634.881 590.089 636.336C590.089 637.792 591.264 638.972 592.724 638.972C594.184 638.972 595.355 637.796 595.355 636.336C595.355 634.876 594.18 633.705 592.724 633.705Z"
            fill="white"
          />
          <path
            d="M578.526 633.01C577.079 633.01 575.895 634.198 575.895 635.645C575.895 637.092 577.083 638.289 578.526 638.289C579.969 638.289 581.169 637.101 581.169 635.645C581.169 634.19 579.981 633.01 578.526 633.01Z"
            fill="white"
          />
          <path
            d="M564.393 632.865C562.938 632.865 561.758 634.041 561.758 635.496C561.758 636.952 562.933 638.132 564.393 638.132C565.853 638.132 567.016 636.956 567.016 635.496C567.016 634.036 565.84 632.865 564.393 632.865Z"
            fill="white"
          />
          <path
            d="M550.363 633.375C548.916 633.375 547.74 634.551 547.74 635.998C547.74 637.445 548.916 638.62 550.363 638.62C551.81 638.62 552.994 637.445 552.994 635.998C552.994 634.551 551.819 633.375 550.363 633.375Z"
            fill="white"
          />
          <path
            d="M536.406 634.156C534.959 634.156 533.783 635.332 533.783 636.779C533.783 638.226 534.959 639.402 536.406 639.402C537.853 639.402 539.028 638.226 539.028 636.779C539.028 635.332 537.853 634.156 536.406 634.156Z"
            fill="white"
          />
          <path
            d="M522.47 635.188C521.023 635.188 519.848 636.363 519.848 637.81C519.848 639.257 521.023 640.424 522.47 640.424C523.917 640.424 525.084 639.257 525.084 637.81C525.084 636.363 523.917 635.188 522.47 635.188Z"
            fill="white"
          />
          <path
            d="M508.546 636.527C507.099 636.527 505.932 637.703 505.932 639.141C505.932 640.58 507.099 641.756 508.546 641.756C509.993 641.756 511.16 640.589 511.16 639.141C511.16 637.694 509.993 636.527 508.546 636.527Z"
            fill="white"
          />
          <path
            d="M494.596 637.869C493.148 637.869 491.981 639.045 491.981 640.483C491.981 641.922 493.148 643.097 494.596 643.097C496.043 643.097 497.197 641.93 497.197 640.483C497.197 639.036 496.03 637.869 494.596 637.869Z"
            fill="white"
          />
          <path
            d="M480.528 639.035C479.094 639.035 477.914 640.202 477.914 641.649C477.914 643.096 479.09 644.263 480.528 644.263C481.967 644.263 483.142 643.088 483.142 641.649C483.142 640.211 481.975 639.035 480.528 639.035Z"
            fill="white"
          />
          <path
            d="M466.287 640.068C464.853 640.068 463.686 641.244 463.686 642.683C463.686 644.121 464.853 645.284 466.287 645.284C467.721 645.284 468.901 644.117 468.901 642.683C468.901 641.248 467.726 640.068 466.287 640.068Z"
            fill="white"
          />
          <path
            d="M451.841 640.805C450.402 640.805 449.239 641.972 449.239 643.406C449.239 644.84 450.406 646.008 451.841 646.008C453.275 646.008 454.442 644.84 454.442 643.406C454.442 641.972 453.275 640.805 451.841 640.805Z"
            fill="white"
          />
          <path
            d="M437.072 640.941C435.625 640.941 434.458 642.108 434.458 643.543C434.458 644.977 435.625 646.144 437.072 646.144C438.519 646.144 439.674 644.977 439.674 643.543C439.674 642.108 438.507 640.941 437.072 640.941Z"
            fill="white"
          />
          <path
            d="M421.858 640.514C420.411 640.514 419.244 641.689 419.244 643.128C419.244 644.566 420.411 645.742 421.858 645.742C423.305 645.742 424.472 644.575 424.472 643.128C424.472 641.681 423.297 640.514 421.858 640.514Z"
            fill="white"
          />
          <path
            d="M406.11 639.432C404.676 639.432 403.509 640.599 403.509 642.033C403.509 643.467 404.676 644.634 406.11 644.634C407.545 644.634 408.724 643.467 408.724 642.033C408.724 640.599 407.549 639.432 406.11 639.432Z"
            fill="white"
          />
          <path
            d="M389.686 637.295C388.252 637.295 387.072 638.462 387.072 639.909C387.072 641.356 388.248 642.511 389.686 642.511C391.125 642.511 392.288 641.343 392.288 639.909C392.288 638.475 391.121 637.295 389.686 637.295Z"
            fill="white"
          />
          <path
            d="M372.448 634.236C371.014 634.236 369.847 635.403 369.847 636.838C369.847 638.272 371.014 639.439 372.448 639.439C373.882 639.439 375.05 638.272 375.05 636.838C375.05 635.403 373.882 634.236 372.448 634.236Z"
            fill="white"
          />
          <path
            d="M354.267 630.188C352.833 630.188 351.666 631.342 351.666 632.789C351.666 634.236 352.833 635.39 354.267 635.39C355.702 635.39 356.869 634.223 356.869 632.789C356.869 631.355 355.702 630.188 354.267 630.188Z"
            fill="white"
          />
          <path
            d="M334.993 624.799C333.546 624.799 332.379 625.974 332.379 627.413C332.379 628.852 333.546 630.027 334.993 630.027C336.44 630.027 337.594 628.86 337.594 627.413C337.594 625.966 336.427 624.799 334.993 624.799Z"
            fill="white"
          />
          <path
            d="M314.478 618.076C313.031 618.076 311.864 619.243 311.864 620.69C311.864 622.137 313.031 623.292 314.478 623.292C315.926 623.292 317.093 622.125 317.093 620.69C317.093 619.256 315.917 618.076 314.478 618.076Z"
            fill="white"
          />
          <path
            d="M292.624 609.852C291.185 609.852 290.022 611.019 290.022 612.453C290.022 613.887 291.189 615.067 292.624 615.067C294.058 615.067 295.238 613.892 295.238 612.453C295.238 611.014 294.071 609.852 292.624 609.852Z"
            fill="white"
          />
          <path
            d="M283.173 603.391C281.696 603.391 280.508 604.587 280.508 606.056C280.508 607.524 281.696 608.721 283.173 608.721C284.65 608.721 285.838 607.533 285.838 606.056C285.838 604.579 284.641 603.391 283.173 603.391Z"
            fill="white"
          />
          <path
            d="M274.159 597.176C272.648 597.176 271.422 598.394 271.422 599.913C271.422 601.432 272.648 602.65 274.159 602.65C275.67 602.65 276.896 601.424 276.896 599.913C276.896 598.402 275.67 597.176 274.159 597.176Z"
            fill="white"
          />
          <path
            d="M265.947 591.307C264.385 591.307 263.116 592.567 263.116 594.129C263.116 595.69 264.385 596.959 265.947 596.959C267.508 596.959 268.777 595.699 268.777 594.129C268.777 592.559 267.508 591.307 265.947 591.307Z"
            fill="white"
          />
          <path
            d="M258.746 585.904C257.154 585.904 255.864 587.194 255.864 588.786C255.864 590.377 257.154 591.68 258.746 591.68C260.337 591.68 261.64 590.39 261.64 588.786C261.64 587.182 260.35 585.904 258.746 585.904Z"
            fill="white"
          />
          <path
            d="M252.592 580.959C250.958 580.959 249.639 582.283 249.639 583.904C249.639 585.525 250.958 586.862 252.592 586.862C254.226 586.862 255.537 585.538 255.537 583.904C255.537 582.27 254.213 580.959 252.592 580.959Z"
            fill="white"
          />
          <path
            d="M247.348 576.443C245.693 576.443 244.352 577.776 244.352 579.431C244.352 581.086 245.693 582.427 247.348 582.427C249.003 582.427 250.335 581.086 250.335 579.431C250.335 577.776 248.994 576.443 247.348 576.443Z"
            fill="white"
          />
          <path
            d="M242.852 572.205C241.146 572.205 239.763 573.589 239.763 575.286C239.763 576.984 241.146 578.376 242.852 578.376C244.558 578.376 245.933 576.992 245.933 575.286C245.933 573.58 244.55 572.205 242.852 572.205Z"
            fill="white"
          />
          <path
            d="M238.885 568.25C237.158 568.25 235.74 569.655 235.74 571.395C235.74 573.135 237.158 574.539 238.885 574.539C240.612 574.539 242.029 573.135 242.029 571.395C242.029 569.655 240.625 568.25 238.885 568.25Z"
            fill="white"
          />
          <path
            d="M235.159 564.379C233.398 564.379 231.964 565.813 231.964 567.574C231.964 569.336 233.398 570.761 235.159 570.761C236.921 570.761 238.342 569.336 238.342 567.574C238.342 565.813 236.916 564.379 235.159 564.379Z"
            fill="white"
          />
          <path
            d="M231.454 560.49C229.664 560.49 228.208 561.937 228.208 563.728C228.208 565.519 229.664 566.975 231.454 566.975C233.245 566.975 234.701 565.528 234.701 563.728C234.701 561.929 233.254 560.49 231.454 560.49Z"
            fill="white"
          />
          <path
            d="M227.663 556.471C225.83 556.471 224.345 557.96 224.345 559.789C224.345 561.618 225.834 563.108 227.663 563.108C229.492 563.108 230.995 561.618 230.995 559.789C230.995 557.96 229.505 556.471 227.663 556.471Z"
            fill="white"
          />
          <path
            d="M223.709 552.328C221.858 552.328 220.348 553.826 220.348 555.689C220.348 557.552 221.858 559.05 223.709 559.05C225.559 559.05 227.082 557.539 227.082 555.689C227.082 553.839 225.572 552.328 223.709 552.328Z"
            fill="white"
          />
          <path
            d="M219.55 547.965C217.666 547.965 216.134 549.497 216.134 551.381C216.134 553.265 217.666 554.785 219.55 554.785C221.434 554.785 222.962 553.265 222.962 551.381C222.962 549.497 221.43 547.965 219.55 547.965Z"
            fill="white"
          />
          <path
            d="M215.145 543.363C213.239 543.363 211.69 544.904 211.69 546.818C211.69 548.732 213.239 550.272 215.145 550.272C217.05 550.272 218.599 548.723 218.599 546.818C218.599 544.912 217.05 543.363 215.145 543.363Z"
            fill="white"
          />
          <path
            d="M210.515 538.465C208.567 538.465 206.997 540.048 206.997 541.983C206.997 543.918 208.567 545.509 210.515 545.509C212.463 545.509 214.033 543.927 214.033 541.983C214.033 540.039 212.463 538.465 210.515 538.465Z"
            fill="white"
          />
          <path
            d="M205.665 533.312C203.7 533.312 202.104 534.904 202.104 536.873C202.104 538.842 203.696 540.434 205.665 540.434C207.634 540.434 209.234 538.842 209.234 536.873C209.234 534.904 207.63 533.312 205.665 533.312Z"
            fill="white"
          />
          <path
            d="M200.628 527.881C198.629 527.881 197.017 529.493 197.017 531.492C197.017 533.491 198.629 535.095 200.628 535.095C202.627 535.095 204.231 533.483 204.231 531.492C204.231 529.502 202.618 527.881 200.628 527.881Z"
            fill="white"
          />
          <path
            d="M195.404 522.205C193.397 522.205 191.763 523.83 191.763 525.838C191.763 527.845 193.397 529.479 195.404 529.479C197.411 529.479 199.045 527.853 199.045 525.838C199.045 523.822 197.411 522.205 195.404 522.205Z"
            fill="white"
          />
          <path
            d="M190.022 516.287C187.972 516.287 186.317 517.942 186.317 519.992C186.317 522.042 187.972 523.688 190.022 523.688C192.072 523.688 193.718 522.033 193.718 519.992C193.718 517.951 192.063 516.287 190.022 516.287Z"
            fill="white"
          />
          <path
            d="M184.462 510.26C182.4 510.26 180.736 511.923 180.736 513.986C180.736 516.048 182.4 517.712 184.462 517.712C186.525 517.712 188.188 516.036 188.188 513.986C188.188 511.936 186.512 510.26 184.462 510.26Z"
            fill="white"
          />
          <path
            d="M178.695 504.162C176.624 504.162 174.939 505.838 174.939 507.918C174.939 509.997 176.624 511.665 178.695 511.665C180.766 511.665 182.451 509.989 182.451 507.918C182.451 505.847 180.775 504.162 178.695 504.162Z"
            fill="white"
          />
          <path
            d="M172.704 498.029C170.604 498.029 168.906 499.735 168.906 501.827C168.906 503.92 170.604 505.626 172.704 505.626C174.805 505.626 176.503 503.92 176.503 501.827C176.503 499.735 174.797 498.029 172.704 498.029Z"
            fill="white"
          />
          <path
            d="M166.428 491.93C164.306 491.93 162.587 493.657 162.587 495.77C162.587 497.884 164.306 499.611 166.428 499.611C168.549 499.611 170.268 497.892 170.268 495.77C170.268 493.648 168.549 491.93 166.428 491.93Z"
            fill="white"
          />
          <path
            d="M159.836 485.934C157.702 485.934 155.975 487.661 155.975 489.783C155.975 491.905 157.702 493.644 159.836 493.644C161.971 493.644 163.685 491.917 163.685 489.783C163.685 487.648 161.958 485.934 159.836 485.934Z"
            fill="white"
          />
          <path
            d="M152.885 487.819C155.03 487.819 156.768 486.08 156.768 483.936C156.768 481.791 155.03 480.053 152.885 480.053C150.74 480.053 149.002 481.791 149.002 483.936C149.002 486.08 150.74 487.819 152.885 487.819Z"
            fill="white"
          />
          <path
            d="M145.54 474.318C143.375 474.318 141.627 476.08 141.627 478.244C141.627 480.408 143.375 482.157 145.54 482.157C147.704 482.157 149.452 480.395 149.452 478.244C149.452 476.092 147.696 474.318 145.54 474.318Z"
            fill="white"
          />
          <path
            d="M137.803 468.75C135.626 468.75 133.86 470.511 133.86 472.692C133.86 474.874 135.63 476.626 137.803 476.626C139.976 476.626 141.737 474.865 141.737 472.692C141.737 470.52 139.98 468.75 137.803 468.75Z"
            fill="white"
          />
          <path
            d="M129.727 463.289C127.533 463.289 125.764 465.067 125.764 467.265C125.764 469.464 127.533 471.229 129.727 471.229C131.921 471.229 133.691 469.451 133.691 467.265C133.691 465.08 131.921 463.289 129.727 463.289Z"
            fill="white"
          />
          <path
            d="M121.379 457.887C119.173 457.887 117.395 459.678 117.395 461.872C117.395 464.066 119.173 465.856 121.379 465.856C123.586 465.856 125.356 464.078 125.356 461.872C125.356 459.665 123.578 457.887 121.379 457.887Z"
            fill="white"
          />
          <path
            d="M112.816 452.443C110.609 452.443 108.81 454.234 108.81 456.449C108.81 458.665 110.609 460.456 112.816 460.456C115.022 460.456 116.835 458.665 116.835 456.449C116.835 454.234 115.035 452.443 112.816 452.443Z"
            fill="white"
          />
          <path
            d="M104.103 446.928C101.888 446.928 100.076 448.727 100.076 450.947C100.076 453.166 101.888 454.974 104.103 454.974C106.319 454.974 108.131 453.175 108.131 450.947C108.131 448.719 106.331 446.928 104.103 446.928Z"
            fill="white"
          />
          <path
            d="M95.2676 441.266C93.0396 441.266 91.2275 443.078 91.2275 445.306C91.2275 447.534 93.0396 449.354 95.2676 449.354C97.4956 449.354 99.3076 447.542 99.3076 445.306C99.3076 443.069 97.5083 441.266 95.2676 441.266Z"
            fill="white"
          />
          <path
            d="M86.3269 435.387C84.0904 435.387 82.2783 437.207 82.2783 439.444C82.2783 441.68 84.0904 443.492 86.3269 443.492C88.5633 443.492 90.3839 441.68 90.3839 439.444C90.3839 437.207 88.5633 435.387 86.3269 435.387Z"
            fill="white"
          />
          <path
            d="M77.3461 429.098C75.0969 429.098 73.2764 430.918 73.2764 433.167C73.2764 435.417 75.0969 437.237 77.3461 437.237C79.5953 437.237 81.4032 435.417 81.4032 433.167C81.4032 430.918 79.5826 429.098 77.3461 429.098Z"
            fill="white"
          />
          <path
            d="M68.3539 422.24C66.1048 422.24 64.2842 424.061 64.2842 426.31C64.2842 428.559 66.1048 430.388 68.3539 430.388C70.6031 430.388 72.4322 428.555 72.4322 426.31C72.4322 424.065 70.6116 422.24 68.3539 422.24Z"
            fill="white"
          />
          <path
            d="M59.4337 414.666C57.1761 414.666 55.3428 416.499 55.3428 418.757C55.3428 421.015 57.1761 422.835 59.4337 422.835C61.6914 422.835 63.5247 421.002 63.5247 418.757C63.5247 416.512 61.6914 414.666 59.4337 414.666Z"
            fill="white"
          />
          <path
            d="M50.6407 406.283C48.3831 406.283 46.5625 408.116 46.5625 410.361C46.5625 412.606 48.3831 414.452 50.6407 414.452C52.8984 414.452 54.7317 412.619 54.7317 410.361C54.7317 408.104 52.8984 406.283 50.6407 406.283Z"
            fill="white"
          />
          <path
            d="M42.0809 396.98C39.8105 396.98 37.9814 398.814 37.9814 401.071C37.9814 403.329 39.8147 405.171 42.0809 405.171C44.3471 405.171 46.1719 403.338 46.1719 401.071C46.1719 398.805 44.3386 396.98 42.0809 396.98Z"
            fill="white"
          />
          <path
            d="M33.8182 386.873C31.5605 386.873 29.7188 388.706 29.7188 390.964C29.7188 393.222 31.5605 395.063 33.8182 395.063C36.0759 395.063 37.9092 393.23 37.9092 390.964C37.9092 388.698 36.0759 386.873 33.8182 386.873Z"
            fill="white"
          />
          <path
            d="M25.8993 376.236C23.6416 376.236 21.7998 378.07 21.7998 380.327C21.7998 382.585 23.6416 384.427 25.8993 384.427C28.1569 384.427 29.9902 382.593 29.9902 380.327C29.9902 378.061 28.1569 376.236 25.8993 376.236Z"
            fill="white"
          />
          <path
            d="M18.2267 365.643C15.969 365.643 14.1357 367.476 14.1357 369.734C14.1357 371.991 15.969 373.833 18.2267 373.833C20.4844 373.833 22.3262 371.991 22.3262 369.734C22.3262 367.476 20.4929 365.643 18.2267 365.643Z"
            fill="white"
          />
          <path
            d="M10.66 355.674C8.40233 355.674 6.56055 357.507 6.56055 359.773C6.56055 362.039 8.40233 363.864 10.66 363.864C12.9177 363.864 14.751 362.031 14.751 359.773C14.751 357.516 12.9177 355.674 10.66 355.674Z"
            fill="white"
          />
          <path
            d="M16.7638 346.795C14.5061 346.795 12.6855 348.615 12.6855 350.873C12.6855 353.131 14.5061 354.951 16.7638 354.951C19.0215 354.951 20.842 353.118 20.842 350.873C20.842 348.628 19.0087 346.795 16.7638 346.795Z"
            fill="white"
          />
          <path
            d="M22.9542 337.426C20.6965 337.426 18.876 339.246 18.876 341.504C18.876 343.762 20.6965 345.582 22.9542 345.582C25.2119 345.582 27.024 343.749 27.024 341.504C27.024 339.259 25.2034 337.426 22.9542 337.426Z"
            fill="white"
          />
          <path
            d="M29.2826 327.342C27.0462 327.342 25.2256 329.154 25.2256 331.399C25.2256 333.644 27.0462 335.456 29.2826 335.456C31.5191 335.456 33.3524 333.644 33.3524 331.399C33.3524 329.154 31.5318 327.342 29.2826 327.342Z"
            fill="white"
          />
          <path
            d="M35.8376 316.381C33.6011 316.381 31.7891 318.193 31.7891 320.429C31.7891 322.666 33.6011 324.486 35.8376 324.486C38.0741 324.486 39.8861 322.666 39.8861 320.429C39.8861 318.193 38.0741 316.381 35.8376 316.381Z"
            fill="white"
          />
          <path
            d="M42.6543 304.496C40.4263 304.496 38.6143 306.308 38.6143 308.536C38.6143 310.764 40.4263 312.576 42.6543 312.576C44.8823 312.576 46.6944 310.764 46.6944 308.536C46.6944 306.308 44.8823 304.496 42.6543 304.496Z"
            fill="white"
          />
          <path
            d="M50.6327 299.782C52.7929 299.273 54.1307 297.108 53.6209 294.948C53.111 292.788 50.9466 291.45 48.7864 291.96C46.6262 292.469 45.2883 294.634 45.7982 296.794C46.308 298.954 48.4725 300.292 50.6327 299.782Z"
            fill="white"
          />
          <path
            d="M57.0621 278.539C54.8553 278.539 53.0645 280.33 53.0645 282.545C53.0645 284.76 54.8553 286.543 57.0621 286.543C59.2688 286.543 61.0682 284.752 61.0682 282.545C61.0682 280.338 59.2773 278.539 57.0621 278.539Z"
            fill="white"
          />
          <path
            d="M64.5946 264.902C62.4005 264.902 60.6182 266.68 60.6182 268.879C60.6182 271.077 62.3963 272.855 64.5946 272.855C66.7928 272.855 68.571 271.077 68.571 268.879C68.571 266.68 66.7928 264.902 64.5946 264.902Z"
            fill="white"
          />
          <path
            d="M72.2035 251.281C70.0265 251.281 68.2568 253.042 68.2568 255.228C68.2568 257.413 70.0265 259.183 72.2035 259.183C74.3806 259.183 76.1587 257.413 76.1587 255.228C76.1587 253.042 74.3891 251.281 72.2035 251.281Z"
            fill="white"
          />
          <path
            d="M79.7614 237.98C77.5971 237.98 75.8359 239.737 75.8359 241.914C75.8359 244.091 77.5971 245.84 79.7614 245.84C81.9257 245.84 83.6954 244.079 83.6954 241.914C83.6954 239.75 81.9385 237.98 79.7614 237.98Z"
            fill="white"
          />
          <path
            d="M87.1708 225.199C85.015 225.199 83.2666 226.948 83.2666 229.103C83.2666 231.259 85.015 233.008 87.1708 233.008C89.3267 233.008 91.0751 231.259 91.0751 229.103C91.0751 226.948 89.3267 225.199 87.1708 225.199Z"
            fill="white"
          />
          <path
            d="M94.2795 213.24C92.1364 213.24 90.3965 214.976 90.3965 217.123C90.3965 219.271 92.1364 221.006 94.2795 221.006C96.4226 221.006 98.1625 219.266 98.1625 217.123C98.1625 214.98 96.4226 213.24 94.2795 213.24Z"
            fill="white"
          />
          <path
            d="M101.002 202.301C98.8799 202.301 97.1611 204.019 97.1611 206.133C97.1611 208.246 98.8799 209.973 101.002 209.973C103.124 209.973 104.842 208.255 104.842 206.133C104.842 204.011 103.115 202.301 101.002 202.301Z"
            fill="white"
          />
          <path
            d="M107.277 192.615C105.176 192.615 103.466 194.317 103.466 196.426C103.466 198.535 105.172 200.241 107.277 200.241C109.382 200.241 111.088 198.535 111.088 196.426C111.088 194.317 109.382 192.615 107.277 192.615Z"
            fill="white"
          />
          <path
            d="M113.087 184.398C110.995 184.398 109.311 186.083 109.311 188.171C109.311 190.259 110.995 191.944 113.087 191.944C115.18 191.944 116.856 190.259 116.856 188.171C116.856 186.083 115.171 184.398 113.087 184.398Z"
            fill="white"
          />
          <path
            d="M118.447 177.32C116.376 177.32 114.7 178.997 114.7 181.068C114.7 183.139 116.376 184.815 118.447 184.815C120.518 184.815 122.195 183.139 122.195 181.068C122.195 178.997 120.518 177.32 118.447 177.32Z"
            fill="white"
          />
          <path
            d="M123.379 171.172C121.338 171.172 119.683 172.818 119.683 174.855C119.683 176.892 121.338 178.552 123.379 178.552C125.42 178.552 127.075 176.897 127.075 174.855C127.075 172.814 125.42 171.172 123.379 171.172Z"
            fill="white"
          />
          <path
            d="M127.899 165.654C125.879 165.654 124.236 167.288 124.236 169.308C124.236 171.328 125.879 172.971 127.899 172.971C129.919 172.971 131.553 171.324 131.553 169.308C131.553 167.292 129.919 165.654 127.899 165.654Z"
            fill="white"
          />
          <path
            d="M132.006 160.613C130.007 160.613 128.395 162.23 128.395 164.229C128.395 166.228 130.007 167.84 132.006 167.84C134.005 167.84 135.617 166.224 135.617 164.229C135.617 162.234 134.005 160.613 132.006 160.613Z"
            fill="white"
          />
          <path
            d="M135.715 155.852C133.738 155.852 132.125 157.456 132.125 159.433C132.125 161.411 133.738 163.015 135.715 163.015C137.693 163.015 139.297 161.411 139.297 159.433C139.297 157.456 137.693 155.852 135.715 155.852Z"
            fill="white"
          />
          <path
            d="M138.978 151.273C137.043 151.273 135.469 152.844 135.469 154.779C135.469 156.714 137.039 158.297 138.978 158.297C140.918 158.297 142.496 156.727 142.496 154.779C142.496 152.831 140.926 151.273 138.978 151.273Z"
            fill="white"
          />
          <path
            d="M141.835 146.73C139.921 146.73 138.359 148.292 138.359 150.206C138.359 152.12 139.921 153.677 141.835 153.677C143.749 153.677 145.302 152.12 145.302 150.206C145.302 148.292 143.753 146.73 141.835 146.73Z"
            fill="white"
          />
          <path
            d="M144.236 142.318C142.344 142.318 140.812 143.85 140.812 145.743C140.812 147.636 142.344 149.172 144.236 149.172C146.129 149.172 147.669 147.636 147.669 145.743C147.669 143.85 146.129 142.318 144.236 142.318Z"
            fill="white"
          />
          <path
            d="M146.256 138.072C144.393 138.072 142.874 139.592 142.874 141.455C142.874 143.318 144.393 144.837 146.256 144.837C148.119 144.837 149.639 143.318 149.639 141.455C149.639 139.592 148.119 138.072 146.256 138.072Z"
            fill="white"
          />
          <path
            d="M147.942 134.07C146.122 134.07 144.641 135.547 144.641 137.368C144.641 139.188 146.117 140.665 147.942 140.665C149.767 140.665 151.24 139.188 151.24 137.368C151.24 135.547 149.763 134.07 147.942 134.07Z"
            fill="white"
          />
          <path
            d="M149.379 130.215C147.58 130.215 146.12 131.67 146.12 133.474C146.12 135.278 147.576 136.733 149.379 136.733C151.183 136.733 152.626 135.278 152.626 133.474C152.626 131.67 151.17 130.215 149.379 130.215Z"
            fill="white"
          />
          <path
            d="M150.606 126.541C148.828 126.541 147.39 127.98 147.39 129.745C147.39 131.51 148.824 132.962 150.606 132.962C152.389 132.962 153.81 131.519 153.81 129.745C153.81 127.971 152.376 126.541 150.606 126.541Z"
            fill="white"
          />
          <path
            d="M151.68 122.984C149.944 122.984 148.535 124.402 148.535 126.137C148.535 127.873 149.94 129.282 151.68 129.282C153.42 129.282 154.833 127.877 154.833 126.137C154.833 124.398 153.415 122.984 151.68 122.984Z"
            fill="white"
          />
          <path
            d="M152.648 125.614C154.345 125.614 155.72 124.243 155.72 122.55C155.72 120.858 154.345 119.486 152.648 119.486C150.951 119.486 149.575 120.858 149.575 122.55C149.575 124.243 150.951 125.614 152.648 125.614Z"
            fill="white"
          />
          <path
            d="M153.53 115.926C151.867 115.926 150.521 117.267 150.521 118.935C150.521 120.602 151.863 121.943 153.53 121.943C155.198 121.943 156.539 120.59 156.539 118.935C156.539 117.28 155.185 115.926 153.53 115.926Z"
            fill="white"
          />
          <path
            d="M154.362 112.242C152.728 112.242 151.404 113.562 151.404 115.187C151.404 116.813 152.724 118.133 154.362 118.133C156 118.133 157.307 116.821 157.307 115.187C157.307 113.554 155.983 112.242 154.362 112.242Z"
            fill="white"
          />
          <path
            d="M155.185 108.324C153.594 108.324 152.304 109.614 152.304 111.206C152.304 112.797 153.594 114.096 155.185 114.096C156.777 114.096 158.067 112.806 158.067 111.206C158.067 109.606 156.777 108.324 155.185 108.324Z"
            fill="white"
          />
          <path
            d="M156.081 104.068C154.532 104.068 153.271 105.329 153.271 106.873C153.271 108.418 154.532 109.679 156.081 109.679C157.63 109.679 158.882 108.418 158.882 106.873C158.882 105.329 157.634 104.068 156.081 104.068Z"
            fill="white"
          />
          <path
            d="M157.142 99.2812C155.631 99.2812 154.404 100.503 154.404 102.014C154.404 103.525 155.631 104.747 157.142 104.747C158.652 104.747 159.87 103.525 159.87 102.014C159.87 100.503 158.652 99.2812 157.142 99.2812Z"
            fill="white"
          />
          <path
            d="M158.559 93.7344C157.082 93.7344 155.886 94.9311 155.886 96.4079C155.886 97.8848 157.082 99.073 158.559 99.073C160.036 99.073 161.233 97.8805 161.233 96.4079C161.233 94.9354 160.036 93.7344 158.559 93.7344Z"
            fill="white"
          />
          <path
            d="M160.694 87.0215C159.256 87.0215 158.093 88.197 158.093 89.6356C158.093 91.0743 159.26 92.2498 160.694 92.2498C162.129 92.2498 163.308 91.0828 163.308 89.6356C163.308 88.1885 162.141 87.0215 160.694 87.0215Z"
            fill="white"
          />
          <path
            d="M164.114 78.709C162.718 78.709 161.598 79.8336 161.598 81.2255C161.598 82.6175 162.722 83.7463 164.114 83.7463C165.506 83.7463 166.622 82.6217 166.622 81.2255C166.622 79.8293 165.498 78.709 164.114 78.709Z"
            fill="white"
          />
          <path
            d="M169.58 68.1328C168.218 68.1328 167.114 69.2362 167.114 70.5899C167.114 71.9437 168.218 73.0513 169.58 73.0513C170.942 73.0513 172.037 71.9522 172.037 70.5899C172.037 69.2277 170.934 68.1328 169.58 68.1328Z"
            fill="white"
          />
          <path
            d="M178.322 54.3926C177.003 54.3926 175.938 55.4578 175.938 56.7776C175.938 58.0974 176.998 59.1541 178.322 59.1541C179.647 59.1541 180.695 58.0889 180.695 56.7776C180.695 55.4662 179.634 54.3926 178.322 54.3926Z"
            fill="white"
          />
          <path
            d="M191.967 36.1309C190.685 36.1309 189.658 37.1663 189.658 38.4522C189.658 39.738 190.689 40.7693 191.967 40.7693C193.244 40.7693 194.288 39.738 194.288 38.4522C194.288 37.1663 193.257 36.1309 191.967 36.1309Z"
            fill="white"
          />
          <path
            d="M210.846 12.459C209.62 12.459 208.618 13.4563 208.618 14.687C208.618 15.9176 209.615 16.9149 210.846 16.9149C212.077 16.9149 213.074 15.9176 213.074 14.687C213.074 13.4563 212.077 12.459 210.846 12.459Z"
            fill="white"
          />
          <path
            d="M908.654 -4.85547C907.05 -4.85547 905.76 -3.56113 905.76 -1.96548C905.76 -0.369826 907.05 0.928761 908.654 0.928761C910.258 0.928761 911.535 -0.365582 911.535 -1.96548C911.535 -3.56537 910.245 -4.85547 908.654 -4.85547Z"
            fill="white"
          />
          <path
            d="M916.209 5.72461C914.575 5.72461 913.264 7.04017 913.264 8.66977C913.264 10.2994 914.575 11.6149 916.209 11.6149C917.843 11.6149 919.154 10.2951 919.154 8.66977C919.154 7.04442 917.83 5.72461 916.209 5.72461Z"
            fill="white"
          />
          <path
            d="M923.644 16.4648C921.98 16.4648 920.635 17.8059 920.635 19.4737C920.635 21.1415 921.976 22.4825 923.644 22.4825C925.311 22.4825 926.661 21.1415 926.661 19.4737C926.661 17.8059 925.307 16.4648 923.644 16.4648Z"
            fill="white"
          />
          <path
            d="M930.99 33.4836C932.696 33.4836 934.079 32.1004 934.079 30.3941C934.079 28.6879 932.696 27.3047 930.99 27.3047C929.284 27.3047 927.9 28.6879 927.9 30.3941C927.9 32.1004 929.284 33.4836 930.99 33.4836Z"
            fill="white"
          />
          <path
            d="M938.234 38.2832C936.494 38.2832 935.089 39.6879 935.089 41.4278C935.089 43.1678 936.494 44.5809 938.234 44.5809C939.973 44.5809 941.387 43.1635 941.387 41.4278C941.387 39.6921 939.969 38.2832 938.234 38.2832Z"
            fill="white"
          />
          <path
            d="M945.376 49.3672C943.606 49.3672 942.172 50.8058 942.172 52.5712C942.172 54.3366 943.611 55.7752 945.376 55.7752C947.141 55.7752 948.593 54.3409 948.593 52.5712C948.593 50.8016 947.158 49.3672 945.376 49.3672Z"
            fill="white"
          />
          <path
            d="M952.428 60.543C950.629 60.543 949.169 62.0071 949.169 63.8022C949.169 65.5973 950.625 67.0614 952.428 67.0614C954.232 67.0614 955.687 65.5973 955.687 63.8022C955.687 62.0071 954.232 60.543 952.428 60.543Z"
            fill="white"
          />
          <path
            d="M959.413 71.7539C957.58 71.7539 956.082 73.2435 956.082 75.081C956.082 76.9185 957.58 78.4124 959.413 78.4124C961.247 78.4124 962.745 76.9185 962.745 75.081C962.745 73.2435 961.255 71.7539 959.413 71.7539Z"
            fill="white"
          />
          <path
            d="M966.366 82.9863C964.494 82.9863 962.971 84.5056 962.971 86.3771C962.971 88.2486 964.49 89.7721 966.366 89.7721C968.241 89.7721 969.761 88.2528 969.761 86.3771C969.761 84.5013 968.241 82.9863 966.366 82.9863Z"
            fill="white"
          />
          <path
            d="M973.279 94.2676C971.386 94.2676 969.846 95.8081 969.846 97.7008C969.846 99.5935 971.386 101.134 973.279 101.134C975.172 101.134 976.712 99.602 976.712 97.7008C976.712 95.7996 975.18 94.2676 973.279 94.2676Z"
            fill="white"
          />
          <path
            d="M980.136 105.664C978.209 105.664 976.66 107.222 976.66 109.14C976.66 111.058 978.209 112.628 980.136 112.628C982.063 112.628 983.624 111.066 983.624 109.14C983.624 107.213 982.063 105.664 980.136 105.664Z"
            fill="white"
          />
          <path
            d="M986.943 117.164C984.974 117.164 983.383 118.76 983.383 120.725C983.383 122.689 984.974 124.285 986.943 124.285C988.912 124.285 990.504 122.694 990.504 120.725C990.504 118.755 988.9 117.164 986.943 117.164Z"
            fill="white"
          />
          <path
            d="M996.237 135.034C997.644 133.627 997.644 131.346 996.237 129.939C994.83 128.532 992.548 128.532 991.141 129.939C989.734 131.346 989.734 133.627 991.141 135.034C992.548 136.441 994.83 136.441 996.237 135.034Z"
            fill="white"
          />
          <path
            d="M1000.4 140.766C998.393 140.766 996.759 142.395 996.759 144.415C996.759 146.435 998.393 148.056 1000.4 148.056C1002.41 148.056 1004.05 146.423 1004.05 144.415C1004.05 142.408 1002.42 140.766 1000.4 140.766Z"
            fill="white"
          />
          <path
            d="M1007.12 152.809C1005.09 152.809 1003.44 154.459 1003.44 156.492C1003.44 158.525 1005.09 160.167 1007.12 160.167C1009.15 160.167 1010.81 158.521 1010.81 156.492C1010.81 154.464 1009.15 152.809 1007.12 152.809Z"
            fill="white"
          />
          <path
            d="M1013.88 164.977C1011.82 164.977 1010.13 166.653 1010.13 168.72C1010.13 170.786 1011.82 172.463 1013.88 172.463C1015.94 172.463 1017.63 170.786 1017.63 168.72C1017.63 166.653 1015.95 164.977 1013.88 164.977Z"
            fill="white"
          />
          <path
            d="M1020.69 177.305C1018.6 177.305 1016.92 178.998 1016.92 181.09C1016.92 183.182 1018.6 184.88 1020.69 184.88C1022.79 184.88 1024.48 183.182 1024.48 181.09C1024.48 178.998 1022.79 177.305 1020.69 177.305Z"
            fill="white"
          />
          <path
            d="M1027.65 189.674C1025.55 189.674 1023.84 191.38 1023.84 193.493C1023.84 195.607 1025.54 197.313 1027.65 197.313C1029.75 197.313 1031.47 195.602 1031.47 193.493C1031.47 191.384 1029.76 189.674 1027.65 189.674Z"
            fill="white"
          />
          <path
            d="M1034.83 201.896C1032.71 201.896 1030.98 203.624 1030.98 205.746C1030.98 207.867 1032.71 209.595 1034.83 209.595C1036.95 209.595 1038.68 207.867 1038.68 205.746C1038.68 203.624 1036.96 201.896 1034.83 201.896Z"
            fill="white"
          />
          <path
            d="M1042.35 213.654C1040.19 213.654 1038.44 215.403 1038.44 217.559C1038.44 219.714 1040.19 221.471 1042.35 221.471C1044.52 221.471 1046.26 219.723 1046.26 217.559C1046.26 215.394 1044.51 213.654 1042.35 213.654Z"
            fill="white"
          />
          <path
            d="M1050.29 224.697C1048.12 224.697 1046.35 226.467 1046.35 228.64C1046.35 230.813 1048.12 232.574 1050.29 232.574C1052.47 232.574 1054.23 230.813 1054.23 228.64C1054.23 226.467 1052.47 224.697 1050.29 224.697Z"
            fill="white"
          />
          <path
            d="M1058.68 234.785C1056.49 234.785 1054.71 236.555 1054.71 238.749C1054.71 240.943 1056.49 242.725 1058.68 242.725C1060.88 242.725 1062.66 240.947 1062.66 238.749C1062.66 236.551 1060.88 234.785 1058.68 234.785Z"
            fill="white"
          />
          <path
            d="M1067.5 243.754C1065.29 243.754 1063.5 245.545 1063.5 247.752C1063.5 249.958 1065.29 251.758 1067.5 251.758C1069.7 251.758 1071.5 249.967 1071.5 247.752C1071.5 245.536 1069.7 243.754 1067.5 243.754Z"
            fill="white"
          />
          <path
            d="M1076.65 251.625C1074.42 251.625 1072.62 253.424 1072.62 255.652C1072.62 257.88 1074.42 259.68 1076.65 259.68C1078.88 259.68 1080.69 257.88 1080.69 255.652C1080.69 253.424 1078.88 251.625 1076.65 251.625Z"
            fill="white"
          />
          <path
            d="M1086.06 258.438C1083.82 258.438 1082 260.25 1082 262.495C1082 264.739 1083.82 266.552 1086.06 266.552C1088.29 266.552 1090.13 264.739 1090.13 262.495C1090.13 260.25 1088.31 258.438 1086.06 258.438Z"
            fill="white"
          />
          <path
            d="M1095.64 264.35C1093.39 264.35 1091.56 266.17 1091.56 268.428C1091.56 270.686 1093.4 272.506 1095.64 272.506C1097.89 272.506 1099.72 270.673 1099.72 268.428C1099.72 266.183 1097.9 264.35 1095.64 264.35Z"
            fill="white"
          />
          <path
            d="M1105.34 269.473C1103.07 269.473 1101.23 271.314 1101.23 273.585C1101.23 275.855 1103.07 277.697 1105.34 277.697C1107.61 277.697 1109.46 275.864 1109.46 273.585C1109.46 271.306 1107.61 269.473 1105.34 269.473Z"
            fill="white"
          />
          <path
            d="M1115.1 274.002C1112.83 274.002 1110.97 275.844 1110.97 278.123C1110.97 280.402 1112.82 282.256 1115.1 282.256C1117.39 282.256 1119.24 280.414 1119.24 278.123C1119.24 275.831 1117.38 274.002 1115.1 274.002Z"
            fill="white"
          />
          <path
            d="M1124.9 278.039C1122.61 278.039 1120.74 279.902 1120.74 282.194C1120.74 284.485 1122.61 286.348 1124.9 286.348C1127.19 286.348 1129.05 284.485 1129.05 282.194C1129.05 279.902 1127.2 278.039 1124.9 278.039Z"
            fill="white"
          />
          <path
            d="M1134.7 281.764C1132.41 281.764 1130.55 283.627 1130.55 285.914C1130.55 288.201 1132.41 290.069 1134.7 290.069C1136.99 290.069 1138.86 288.206 1138.86 285.914C1138.86 283.622 1137 281.764 1134.7 281.764Z"
            fill="white"
          />
          <path
            d="M1144.52 285.23C1142.23 285.23 1140.36 287.093 1140.36 289.385C1140.36 291.677 1142.23 293.54 1144.52 293.54C1146.81 293.54 1148.67 291.689 1148.67 289.385C1148.67 287.081 1146.81 285.23 1144.52 285.23Z"
            fill="white"
          />
          <path
            d="M1154.33 288.496C1152.03 288.496 1150.18 290.359 1150.18 292.651C1150.18 294.942 1152.03 296.805 1154.33 296.805C1156.63 296.805 1158.49 294.955 1158.49 292.651C1158.49 290.346 1156.63 288.496 1154.33 288.496Z"
            fill="white"
          />
          <path
            d="M1164.13 291.602C1161.83 291.602 1159.97 293.452 1159.97 295.756C1159.97 298.061 1161.82 299.907 1164.13 299.907C1166.43 299.907 1168.28 298.044 1168.28 295.756C1168.28 293.469 1166.42 291.602 1164.13 291.602Z"
            fill="white"
          />
          <path
            d="M1173.87 294.555C1171.58 294.555 1169.71 296.409 1169.71 298.709C1169.71 301.009 1171.58 302.864 1173.87 302.864C1176.16 302.864 1178.02 301.001 1178.02 298.709C1178.02 296.418 1176.17 294.555 1173.87 294.555Z"
            fill="white"
          />
          <path
            d="M1183.54 297.398C1181.25 297.398 1179.38 299.253 1179.38 301.553C1179.38 303.853 1181.25 305.708 1183.54 305.708C1185.83 305.708 1187.69 303.845 1187.69 301.553C1187.69 299.261 1185.83 297.398 1183.54 297.398Z"
            fill="white"
          />
          <path
            d="M1193.09 300.105C1190.79 300.105 1188.93 301.956 1188.93 304.26C1188.93 306.564 1190.79 308.415 1193.09 308.415C1195.39 308.415 1197.25 306.552 1197.25 304.26C1197.25 301.968 1195.38 300.105 1193.09 300.105Z"
            fill="white"
          />
          <path
            d="M1188.92 300.143C1186.62 300.143 1184.77 302.006 1184.77 304.306C1184.77 306.606 1186.62 308.46 1188.92 308.46C1191.22 308.46 1193.07 306.597 1193.07 304.306C1193.07 302.014 1191.21 300.143 1188.92 300.143Z"
            fill="white"
          />
          <path
            d="M1184.39 300.062C1182.1 300.062 1180.24 301.925 1180.24 304.217C1180.24 306.509 1182.1 308.372 1184.39 308.372C1186.68 308.372 1188.55 306.521 1188.55 304.217C1188.55 301.913 1186.7 300.062 1184.39 300.062Z"
            fill="white"
          />
          <path
            d="M1179.51 299.861C1177.22 299.861 1175.35 301.716 1175.35 304.016C1175.35 306.316 1177.22 308.171 1179.51 308.171C1181.8 308.171 1183.66 306.308 1183.66 304.016C1183.66 301.724 1181.8 299.861 1179.51 299.861Z"
            fill="white"
          />
          <path
            d="M1174.28 299.555C1171.98 299.555 1170.12 301.418 1170.12 303.718C1170.12 306.018 1171.98 307.872 1174.28 307.872C1176.57 307.872 1178.43 306.009 1178.43 303.718C1178.43 301.426 1176.58 299.555 1174.28 299.555Z"
            fill="white"
          />
          <path
            d="M1168.69 299.176C1166.39 299.176 1164.54 301.039 1164.54 303.33C1164.54 305.622 1166.39 307.485 1168.69 307.485C1170.99 307.485 1172.85 305.622 1172.85 303.33C1172.85 301.039 1170.99 299.176 1168.69 299.176Z"
            fill="white"
          />
          <path
            d="M1162.77 298.738C1160.48 298.738 1158.62 300.593 1158.62 302.893C1158.62 305.193 1160.48 307.048 1162.77 307.048C1165.07 307.048 1166.93 305.185 1166.93 302.893C1166.93 300.601 1165.07 298.738 1162.77 298.738Z"
            fill="white"
          />
          <path
            d="M1156.53 298.25C1154.23 298.25 1152.37 300.105 1152.37 302.405C1152.37 304.705 1154.23 306.559 1156.53 306.559C1158.83 306.559 1160.68 304.696 1160.68 302.405C1160.68 300.113 1158.82 298.25 1156.53 298.25Z"
            fill="white"
          />
          <path
            d="M1149.95 297.729C1147.66 297.729 1145.79 299.592 1145.79 301.883C1145.79 304.175 1147.66 306.038 1149.95 306.038C1152.24 306.038 1154.1 304.187 1154.1 301.883C1154.1 299.579 1152.24 297.729 1149.95 297.729Z"
            fill="white"
          />
          <path
            d="M1143.06 297.219C1140.76 297.219 1138.91 299.082 1138.91 301.373C1138.91 303.665 1140.76 305.528 1143.06 305.528C1145.37 305.528 1147.22 303.665 1147.22 301.373C1147.22 299.082 1145.35 297.219 1143.06 297.219Z"
            fill="white"
          />
          <path
            d="M1135.85 296.73C1133.56 296.73 1131.69 298.593 1131.69 300.885C1131.69 303.177 1133.56 305.04 1135.85 305.04C1138.14 305.04 1140 303.189 1140 300.885C1140 298.581 1138.14 296.73 1135.85 296.73Z"
            fill="white"
          />
          <path
            d="M1128.33 296.303C1126.03 296.303 1124.18 298.166 1124.18 300.466C1124.18 302.766 1126.03 304.62 1128.33 304.62C1130.64 304.62 1132.49 302.757 1132.49 300.466C1132.49 298.174 1130.62 296.303 1128.33 296.303Z"
            fill="white"
          />
          <path
            d="M1120.52 295.992C1118.23 295.992 1116.38 297.842 1116.38 300.134C1116.38 302.426 1118.23 304.276 1120.52 304.276C1122.81 304.276 1124.65 302.421 1124.65 300.134C1124.65 297.847 1122.8 295.992 1120.52 295.992Z"
            fill="white"
          />
          <path
            d="M1112.4 295.793C1110.12 295.793 1108.28 297.635 1108.28 299.914C1108.28 302.193 1110.12 304.034 1112.4 304.034C1114.68 304.034 1116.52 302.193 1116.52 299.914C1116.52 297.635 1114.68 295.793 1112.4 295.793Z"
            fill="white"
          />
          <path
            d="M1103.99 295.721C1101.72 295.721 1099.89 297.554 1099.89 299.82C1099.89 302.086 1101.72 303.92 1103.99 303.92C1106.26 303.92 1108.09 302.078 1108.09 299.82C1108.09 297.562 1106.25 295.721 1103.99 295.721Z"
            fill="white"
          />
          <path
            d="M1095.3 295.805C1093.04 295.805 1091.22 297.625 1091.22 299.883C1091.22 302.141 1093.04 303.961 1095.3 303.961C1097.56 303.961 1099.38 302.141 1099.38 299.883C1099.38 297.625 1097.54 295.805 1095.3 295.805Z"
            fill="white"
          />
          <path
            d="M1086.34 296.107C1084.11 296.107 1082.3 297.907 1082.3 300.147C1082.3 302.388 1084.11 304.188 1086.34 304.188C1088.56 304.188 1090.38 302.375 1090.38 300.147C1090.38 297.92 1088.56 296.107 1086.34 296.107Z"
            fill="white"
          />
          <path
            d="M1077.14 296.615C1074.91 296.615 1073.12 298.415 1073.12 300.634C1073.12 302.854 1074.91 304.661 1077.14 304.661C1079.36 304.661 1081.15 302.862 1081.15 300.634C1081.15 298.406 1079.35 296.615 1077.14 296.615Z"
            fill="white"
          />
          <path
            d="M1067.71 297.406C1065.5 297.406 1063.72 299.197 1063.72 301.404C1063.72 303.611 1065.5 305.389 1067.71 305.389C1069.91 305.389 1071.7 303.598 1071.7 301.404C1071.7 299.21 1069.91 297.406 1067.71 297.406Z"
            fill="white"
          />
          <path
            d="M1058.06 298.451C1055.87 298.451 1054.1 300.221 1054.1 302.415C1054.1 304.609 1055.87 306.37 1058.06 306.37C1060.25 306.37 1062.02 304.6 1062.02 302.415C1062.02 300.229 1060.24 298.451 1058.06 298.451Z"
            fill="white"
          />
          <path
            d="M1048.19 299.762C1046.03 299.762 1044.27 301.519 1044.27 303.687C1044.27 305.856 1046.02 307.613 1048.19 307.613C1050.36 307.613 1052.12 305.851 1052.12 303.687C1052.12 301.523 1050.36 299.762 1048.19 299.762Z"
            fill="white"
          />
          <path
            d="M1038.14 301.375C1036 301.375 1034.26 303.115 1034.26 305.258C1034.26 307.401 1036 309.15 1038.14 309.15C1040.28 309.15 1042.03 307.414 1042.03 305.258C1042.03 303.102 1040.29 301.375 1038.14 301.375Z"
            fill="white"
          />
          <path
            d="M1027.92 303.316C1025.78 303.316 1024.05 305.044 1024.05 307.178C1024.05 309.313 1025.78 311.027 1027.92 311.027C1030.05 311.027 1031.77 309.3 1031.77 307.178C1031.77 305.056 1030.04 303.316 1027.92 303.316Z"
            fill="white"
          />
          <path
            d="M1017.54 305.639C1015.43 305.639 1013.72 307.345 1013.72 309.458C1013.72 311.571 1015.43 313.269 1017.54 313.269C1019.65 313.269 1021.35 311.563 1021.35 309.458C1021.35 307.353 1019.65 305.639 1017.54 305.639Z"
            fill="white"
          />
          <path
            d="M1007.87 315.737C1009.89 315.259 1011.15 313.23 1010.67 311.204C1010.19 309.178 1008.16 307.924 1006.14 308.402C1004.11 308.88 1002.86 310.91 1003.34 312.935C1003.81 314.961 1005.84 316.215 1007.87 315.737Z"
            fill="white"
          />
          <path
            d="M996.343 311.156C994.281 311.156 992.617 312.82 992.617 314.882C992.617 316.945 994.281 318.621 996.343 318.621C998.406 318.621 1000.07 316.945 1000.07 314.882C1000.07 312.82 998.406 311.156 996.343 311.156Z"
            fill="white"
          />
          <path
            d="M985.548 314.436C983.507 314.436 981.864 316.091 981.864 318.132C981.864 320.173 983.511 321.828 985.548 321.828C987.585 321.828 989.244 320.173 989.244 318.132C989.244 316.091 987.589 314.436 985.548 314.436Z"
            fill="white"
          />
          <path
            d="M974.67 318.17C972.65 318.17 971.017 319.804 971.017 321.824C971.017 323.844 972.65 325.478 974.67 325.478C976.69 325.478 978.324 323.844 978.324 321.824C978.324 319.804 976.69 318.17 974.67 318.17Z"
            fill="white"
          />
          <path
            d="M963.713 322.439C961.735 322.439 960.131 324.052 960.131 326.03C960.131 328.007 961.735 329.62 963.713 329.62C965.69 329.62 967.303 328.007 967.303 326.03C967.303 324.052 965.699 322.439 963.713 322.439Z"
            fill="white"
          />
          <path
            d="M952.764 327.301C950.808 327.301 949.225 328.892 949.225 330.849C949.225 332.805 950.808 334.396 952.764 334.396C954.72 334.396 956.312 332.805 956.312 330.849C956.312 328.892 954.72 327.301 952.764 327.301Z"
            fill="white"
          />
          <path
            d="M941.859 332.857C939.924 332.857 938.354 334.428 938.354 336.367C938.354 338.306 939.924 339.864 941.859 339.864C943.794 339.864 945.356 338.302 945.356 336.367C945.356 334.432 943.794 332.857 941.859 332.857Z"
            fill="white"
          />
          <path
            d="M931.01 339.193C929.105 339.193 927.564 340.742 927.564 342.639C927.564 344.536 929.105 346.085 931.01 346.085C932.916 346.085 934.456 344.545 934.456 342.639C934.456 340.734 932.916 339.193 931.01 339.193Z"
            fill="white"
          />
          <path
            d="M920.312 346.51C918.44 346.51 916.93 348.021 916.93 349.892C916.93 351.764 918.44 353.266 920.312 353.266C922.183 353.266 923.686 351.755 923.686 349.892C923.686 348.029 922.175 346.51 920.312 346.51Z"
            fill="white"
          />
          <path
            d="M909.758 354.879C907.916 354.879 906.427 356.368 906.427 358.21C906.427 360.052 907.916 361.529 909.758 361.529C911.6 361.529 913.077 360.039 913.077 358.21C913.077 356.381 911.587 354.879 909.758 354.879Z"
            fill="white"
          />
          <path
            d="M899.434 364.559C897.634 364.559 896.166 366.027 896.166 367.839C896.166 369.651 897.634 371.107 899.434 371.107C901.233 371.107 902.71 369.638 902.71 367.839C902.71 366.04 901.242 364.559 899.434 364.559Z"
            fill="white"
          />
          <path
            d="M889.516 375.924C887.746 375.924 886.299 377.358 886.299 379.141C886.299 380.923 887.746 382.357 889.516 382.357C891.285 382.357 892.732 380.923 892.732 379.141C892.732 377.358 891.298 375.924 889.516 375.924Z"
            fill="white"
          />
          <path
            d="M880.022 389.166C878.286 389.166 876.877 390.571 876.877 392.311C876.877 394.051 878.282 395.455 880.022 395.455C881.761 395.455 883.153 394.051 883.153 392.311C883.153 390.571 881.749 389.166 880.022 389.166Z"
            fill="white"
          />
          <path
            d="M871.365 404.908C869.659 404.908 868.284 406.292 868.284 407.998C868.284 409.704 869.659 411.079 871.365 411.079C873.071 411.079 874.446 409.695 874.446 407.998C874.446 406.3 873.071 404.908 871.365 404.908Z"
            fill="white"
          />
          <path
            d="M864.329 424.061C862.665 424.061 861.312 425.414 861.312 427.091C861.312 428.767 862.665 430.108 864.329 430.108C865.992 430.108 867.359 428.754 867.359 427.091C867.359 425.427 866.005 424.061 864.329 424.061Z"
            fill="white"
          />
          <path
            d="M859.979 447.479C858.332 447.479 857.004 448.811 857.004 450.453C857.004 452.096 858.336 453.42 859.979 453.42C861.621 453.42 862.954 452.087 862.954 450.453C862.954 448.82 861.621 447.479 859.979 447.479Z"
            fill="white"
          />
          <path
            d="M859.299 475.881C857.695 475.881 856.405 477.171 856.405 478.762C856.405 480.354 857.695 481.657 859.299 481.657C860.904 481.657 862.181 480.354 862.181 478.762C862.181 477.171 860.891 475.881 859.299 475.881Z"
            fill="white"
          />
          <path
            d="M862.602 509.564C861.041 509.564 859.78 510.825 859.78 512.387C859.78 513.948 861.041 515.217 862.602 515.217C864.164 515.217 865.433 513.948 865.433 512.387C865.433 510.825 864.164 509.564 862.602 509.564Z"
            fill="white"
          />
          <path
            d="M883.081 582.553C881.582 582.553 880.373 583.771 880.373 585.26C880.373 586.75 881.582 587.976 883.081 587.976C884.579 587.976 885.788 586.758 885.788 585.26C885.788 583.762 884.57 582.553 883.081 582.553Z"
            fill="white"
          />
          <path
            d="M875.872 592.24C874.373 592.24 873.164 593.45 873.164 594.948C873.164 596.446 874.373 597.655 875.872 597.655C877.37 597.655 878.579 596.437 878.579 594.948C878.579 593.458 877.361 592.24 875.872 592.24Z"
            fill="white"
          />
          <path
            d="M868.042 601.879C866.553 601.879 865.348 603.088 865.348 604.574C865.348 606.059 866.557 607.26 868.042 607.26C869.528 607.26 870.729 606.051 870.729 604.574C870.729 603.097 869.532 601.879 868.042 601.879Z"
            fill="white"
          />
          <path
            d="M859.508 611.35C858.018 611.35 856.821 612.555 856.821 614.036C856.821 615.517 858.018 616.722 859.508 616.722C860.997 616.722 862.194 615.525 862.194 614.036C862.194 612.546 860.989 611.35 859.508 611.35Z"
            fill="white"
          />
          <path
            d="M850.1 620.176C848.611 620.176 847.405 621.385 847.405 622.862C847.405 624.339 848.615 625.557 850.1 625.557C851.585 625.557 852.786 624.347 852.786 622.862C852.786 621.377 851.577 620.176 850.1 620.176Z"
            fill="white"
          />
          <path
            d="M839.859 628.088C838.382 628.088 837.173 629.285 837.173 630.761C837.173 632.238 838.382 633.448 839.859 633.448C841.336 633.448 842.533 632.242 842.533 630.761C842.533 629.28 841.336 628.088 839.859 628.088Z"
            fill="white"
          />
          <path
            d="M828.953 635.039C827.476 635.039 826.279 636.236 826.279 637.713C826.279 639.189 827.476 640.378 828.953 640.378C830.43 640.378 831.626 639.181 831.626 637.713C831.626 636.244 830.43 635.039 828.953 635.039Z"
            fill="white"
          />
          <path
            d="M817.359 640.672C815.883 640.672 814.694 641.86 814.694 643.324C814.694 644.788 815.883 645.989 817.359 645.989C818.836 645.989 820.012 644.793 820.012 643.324C820.012 641.856 818.824 640.672 817.359 640.672Z"
            fill="white"
          />
          <path
            d="M805.171 645.184C803.703 645.184 802.519 646.372 802.519 647.836C802.519 649.3 803.707 650.501 805.171 650.501C806.635 650.501 807.823 649.304 807.823 647.836C807.823 646.368 806.635 645.184 805.171 645.184Z"
            fill="white"
          />
          <path
            d="M792.72 649.061C791.264 649.061 790.076 650.249 790.076 651.704C790.076 653.16 791.264 654.357 792.72 654.357C794.176 654.357 795.372 653.169 795.372 651.704C795.372 650.24 794.184 649.061 792.72 649.061Z"
            fill="white"
          />
          <path
            d="M780.022 652.193C778.566 652.193 777.378 653.382 777.378 654.837C777.378 656.293 778.566 657.481 780.022 657.481C781.477 657.481 782.674 656.306 782.674 654.837C782.674 653.369 781.486 652.193 780.022 652.193Z"
            fill="white"
          />
          <path
            d="M767.088 654.713C765.633 654.713 764.444 655.888 764.444 657.344C764.444 658.8 765.633 659.988 767.088 659.988C768.544 659.988 769.732 658.812 769.732 657.344C769.732 655.876 768.544 654.713 767.088 654.713Z"
            fill="white"
          />
          <path
            d="M753.919 656.75C752.471 656.75 751.296 657.926 751.296 659.373C751.296 660.82 752.471 661.995 753.919 661.995C755.366 661.995 756.541 660.82 756.541 659.373C756.541 657.926 755.366 656.75 753.919 656.75Z"
            fill="white"
          />
          <path
            d="M740.535 658.115C739.079 658.115 737.899 659.291 737.899 660.738C737.899 662.185 739.075 663.361 740.535 663.361C741.995 663.361 743.157 662.185 743.157 660.738C743.157 659.291 741.982 658.115 740.535 658.115Z"
            fill="white"
          />
          <path
            d="M726.942 658.777C725.495 658.777 724.328 659.953 724.328 661.4C724.328 662.847 725.495 664.014 726.942 664.014C728.389 664.014 729.565 662.847 729.565 661.4C729.565 659.953 728.389 658.777 726.942 658.777Z"
            fill="white"
          />
          <path
            d="M713.226 659.041C711.779 659.041 710.612 660.217 710.612 661.655C710.612 663.094 711.779 664.269 713.226 664.269C714.674 664.269 715.841 663.102 715.841 661.655C715.841 660.208 714.665 659.041 713.226 659.041Z"
            fill="white"
          />
          <path
            d="M699.383 658.791C697.936 658.791 696.769 659.958 696.769 661.392C696.769 662.827 697.936 664.007 699.383 664.007C700.83 664.007 701.984 662.84 701.984 661.392C701.984 659.945 700.817 658.791 699.383 658.791Z"
            fill="white"
          />
          <path
            d="M685.438 657.945C684.004 657.945 682.837 659.112 682.837 660.547C682.837 661.981 684.004 663.148 685.438 663.148C686.873 663.148 688.04 661.981 688.04 660.547C688.04 659.112 686.873 657.945 685.438 657.945Z"
            fill="white"
          />
          <path
            d="M671.416 656.678C669.981 656.678 668.814 657.845 668.814 659.279C668.814 660.714 669.981 661.881 671.416 661.881C672.85 661.881 674.017 660.714 674.017 659.279C674.017 657.845 672.85 656.678 671.416 656.678Z"
            fill="white"
          />
          <path
            d="M657.322 655.072C655.897 655.072 654.729 656.227 654.729 657.665C654.729 659.104 655.897 660.258 657.322 660.258C658.748 660.258 659.915 659.091 659.915 657.665C659.915 656.239 658.761 655.072 657.322 655.072Z"
            fill="white"
          />
          <path
            d="M643.161 653.016C641.727 653.016 640.568 654.17 640.568 655.609C640.568 657.047 641.723 658.189 643.161 658.189C644.6 658.189 645.754 657.034 645.754 655.609C645.754 654.183 644.587 653.016 643.161 653.016Z"
            fill="white"
          />
          <path
            d="M628.889 650.537C627.463 650.537 626.296 651.691 626.296 653.13C626.296 654.569 627.463 655.71 628.889 655.71C630.315 655.71 631.469 654.556 631.469 653.13C631.469 651.704 630.315 650.537 628.889 650.537Z"
            fill="white"
          />
          <path
            d="M614.529 647.998C613.111 647.998 611.957 649.152 611.957 650.57C611.957 651.987 613.111 653.141 614.529 653.141C615.946 653.141 617.1 651.987 617.1 650.57C617.1 649.152 615.955 647.998 614.529 647.998Z"
            fill="white"
          />
          <path
            d="M600.198 645.895C598.78 645.895 597.639 647.049 597.639 648.466C597.639 649.884 598.784 651.038 600.198 651.038C601.611 651.038 602.769 649.884 602.769 648.466C602.769 647.049 601.615 645.895 600.198 645.895Z"
            fill="white"
          />
          <path
            d="M585.897 644.189C584.479 644.189 583.338 645.335 583.338 646.748C583.338 648.162 584.484 649.32 585.897 649.32C587.31 649.32 588.469 648.166 588.469 646.748C588.469 645.331 587.314 644.189 585.897 644.189Z"
            fill="white"
          />
          <path
            d="M571.624 642.92C570.207 642.92 569.065 644.066 569.065 645.479C569.065 646.892 570.211 648.038 571.624 648.038C573.038 648.038 574.183 646.884 574.183 645.479C574.183 644.074 573.029 642.92 571.624 642.92Z"
            fill="white"
          />
          <path
            d="M557.442 642.354C556.024 642.354 554.883 643.499 554.883 644.913C554.883 646.326 556.029 647.463 557.442 647.463C558.855 647.463 559.992 646.317 559.992 644.913C559.992 643.508 558.846 642.354 557.442 642.354Z"
            fill="white"
          />
          <path
            d="M543.348 642.324C541.931 642.324 540.789 643.47 540.789 644.875C540.789 646.279 541.935 647.425 543.348 647.425C544.761 647.425 545.899 646.279 545.899 644.875C545.899 643.47 544.753 642.324 543.348 642.324Z"
            fill="white"
          />
          <path
            d="M529.289 642.525C527.872 642.525 526.73 643.671 526.73 645.084C526.73 646.498 527.876 647.643 529.289 647.643C530.703 647.643 531.848 646.498 531.848 645.084C531.848 643.671 530.703 642.525 529.289 642.525Z"
            fill="white"
          />
          <path
            d="M515.225 643.055C513.82 643.055 512.666 644.2 512.666 645.614C512.666 647.027 513.82 648.173 515.225 648.173C516.63 648.173 517.784 647.027 517.784 645.614C517.784 644.2 516.638 643.055 515.225 643.055Z"
            fill="white"
          />
          <path
            d="M501.187 643.857C499.77 643.857 498.628 645.003 498.628 646.408C498.628 647.813 499.774 648.967 501.187 648.967C502.6 648.967 503.746 647.821 503.746 646.408C503.746 644.995 502.6 643.857 501.187 643.857Z"
            fill="white"
          />
          <path
            d="M487.064 644.539C485.659 644.539 484.514 645.672 484.514 647.09C484.514 648.507 485.659 649.64 487.064 649.64C488.469 649.64 489.615 648.494 489.615 647.09C489.615 645.685 488.482 644.539 487.064 644.539Z"
            fill="white"
          />
          <path
            d="M472.783 645.104C471.378 645.104 470.245 646.237 470.245 647.641C470.245 649.046 471.378 650.192 472.783 650.192C474.188 650.192 475.333 649.059 475.333 647.641C475.333 646.224 474.2 645.104 472.783 645.104Z"
            fill="white"
          />
          <path
            d="M458.325 645.551C456.92 645.551 455.787 646.697 455.787 648.101C455.787 649.506 456.92 650.652 458.325 650.652C459.73 650.652 460.875 649.506 460.875 648.101C460.875 646.697 459.73 645.551 458.325 645.551Z"
            fill="white"
          />
          <path
            d="M443.598 645.551C442.194 645.551 441.061 646.697 441.061 648.101C441.061 649.506 442.194 650.639 443.598 650.639C445.003 650.639 446.149 649.493 446.149 648.101C446.149 646.709 445.003 645.551 443.598 645.551Z"
            fill="white"
          />
          <path
            d="M428.487 645.012C427.082 645.012 425.949 646.145 425.949 647.549C425.949 648.954 427.082 650.087 428.487 650.087C429.892 650.087 431.016 648.954 431.016 647.549C431.016 646.145 429.883 645.012 428.487 645.012Z"
            fill="white"
          />
          <path
            d="M412.895 643.951C411.491 643.951 410.345 645.084 410.345 646.502C410.345 647.919 411.491 649.039 412.895 649.039C414.3 649.039 415.433 647.906 415.433 646.502C415.433 645.097 414.3 643.951 412.895 643.951Z"
            fill="white"
          />
          <path
            d="M396.71 642.025C395.305 642.025 394.159 643.158 394.159 644.563C394.159 645.968 395.305 647.114 396.71 647.114C398.114 647.114 399.247 645.981 399.247 644.563C399.247 643.146 398.114 642.025 396.71 642.025Z"
            fill="white"
          />
          <path
            d="M379.791 639.129C378.386 639.129 377.253 640.275 377.253 641.667C377.253 643.059 378.386 644.217 379.791 644.217C381.195 644.217 382.328 643.071 382.328 641.667C382.328 640.262 381.195 639.129 379.791 639.129Z"
            fill="white"
          />
          <path
            d="M362.034 635.361C360.629 635.361 359.483 636.507 359.483 637.912C359.483 639.317 360.629 640.45 362.034 640.45C363.439 640.45 364.572 639.317 364.572 637.912C364.572 636.507 363.439 635.361 362.034 635.361Z"
            fill="white"
          />
          <path
            d="M343.268 630.432C341.864 630.432 340.73 631.565 340.73 632.969C340.73 634.374 341.864 635.499 343.268 635.499C344.673 635.499 345.798 634.366 345.798 632.969C345.798 631.573 344.664 630.432 343.268 630.432Z"
            fill="white"
          />
          <path
            d="M323.336 624.068C321.931 624.068 320.798 625.201 320.798 626.606C320.798 628.011 321.931 629.157 323.336 629.157C324.74 629.157 325.886 628.011 325.886 626.606C325.886 625.201 324.753 624.068 323.336 624.068Z"
            fill="white"
          />
          <path
            d="M302.125 616.387C300.707 616.387 299.574 617.52 299.574 618.924C299.574 620.329 300.707 621.475 302.125 621.475C303.542 621.475 304.662 620.329 304.662 618.924C304.662 617.52 303.529 616.387 302.125 616.387Z"
            fill="white"
          />
          <path
            d="M279.489 607.166C278.084 607.166 276.938 608.299 276.938 609.704C276.938 611.108 278.084 612.242 279.489 612.242C280.894 612.242 282.027 611.108 282.027 609.704C282.027 608.299 280.894 607.166 279.489 607.166Z"
            fill="white"
          />
          <path
            d="M269.529 600.193C268.091 600.193 266.915 601.36 266.915 602.807C266.915 604.255 268.091 605.422 269.529 605.422C270.968 605.422 272.143 604.246 272.143 602.807C272.143 601.369 270.976 600.193 269.529 600.193Z"
            fill="white"
          />
          <path
            d="M260.065 593.514C258.588 593.514 257.392 594.71 257.392 596.187C257.392 597.664 258.588 598.861 260.065 598.861C261.542 598.861 262.739 597.664 262.739 596.187C262.739 594.71 261.542 593.514 260.065 593.514Z"
            fill="white"
          />
          <path
            d="M251.553 587.279C250.042 587.279 248.815 588.497 248.815 590.016C248.815 591.536 250.042 592.754 251.553 592.754C253.063 592.754 254.29 591.527 254.29 590.016C254.29 588.506 253.063 587.279 251.553 587.279Z"
            fill="white"
          />
          <path
            d="M244.202 581.533C242.64 581.533 241.38 582.802 241.38 584.364C241.38 585.926 242.64 587.186 244.202 587.186C245.764 587.186 247.024 585.926 247.024 584.364C247.024 582.802 245.764 581.533 244.202 581.533Z"
            fill="white"
          />
          <path
            d="M238.083 576.381C236.491 576.381 235.188 577.671 235.188 579.275C235.188 580.879 236.491 582.157 238.083 582.157C239.674 582.157 240.964 580.867 240.964 579.275C240.964 577.684 239.674 576.381 238.083 576.381Z"
            fill="white"
          />
          <path
            d="M233.037 571.76C231.412 571.76 230.092 573.08 230.092 574.705C230.092 576.33 231.412 577.65 233.037 577.65C234.662 577.65 235.982 576.33 235.982 574.705C235.982 573.08 234.671 571.76 233.037 571.76Z"
            fill="white"
          />
          <path
            d="M228.844 567.576C227.189 567.576 225.848 568.917 225.848 570.572C225.848 572.227 227.189 573.581 228.844 573.581C230.499 573.581 231.853 572.227 231.853 570.572C231.853 568.917 230.512 567.576 228.844 567.576Z"
            fill="white"
          />
          <path
            d="M225.292 563.691C223.594 563.691 222.211 565.075 222.211 566.772C222.211 568.47 223.594 569.853 225.292 569.853C226.989 569.853 228.373 568.47 228.373 566.772C228.373 565.075 226.989 563.691 225.292 563.691Z"
            fill="white"
          />
          <path
            d="M222.13 560.039C220.403 560.039 218.998 561.444 218.998 563.184C218.998 564.924 220.403 566.316 222.13 566.316C223.857 566.316 225.275 564.911 225.275 563.184C225.275 561.456 223.87 560.039 222.13 560.039Z"
            fill="white"
          />
          <path
            d="M219.049 556.428C217.292 556.428 215.866 557.854 215.866 559.615C215.866 561.376 217.292 562.798 219.049 562.798C220.806 562.798 222.236 561.372 222.236 559.615C222.236 557.858 220.81 556.428 219.049 556.428Z"
            fill="white"
          />
          <path
            d="M215.883 552.715C214.092 552.715 212.637 554.17 212.637 555.961C212.637 557.752 214.092 559.208 215.883 559.208C217.674 559.208 219.13 557.752 219.13 555.961C219.13 554.17 217.674 552.715 215.883 552.715Z"
            fill="white"
          />
          <path
            d="M212.535 548.84C210.702 548.84 209.217 550.329 209.217 552.158C209.217 553.987 210.706 555.477 212.535 555.477C214.364 555.477 215.854 553.987 215.854 552.158C215.854 550.329 214.377 548.84 212.535 548.84Z"
            fill="white"
          />
          <path
            d="M208.954 544.791C207.091 544.791 205.58 546.302 205.58 548.152C205.58 550.002 207.091 551.513 208.954 551.513C210.817 551.513 212.315 550.015 212.315 548.152C212.315 546.289 210.804 544.791 208.954 544.791Z"
            fill="white"
          />
          <path
            d="M205.101 540.496C203.217 540.496 201.689 542.028 201.689 543.908C201.689 545.788 203.221 547.32 205.101 547.32C206.981 547.32 208.518 545.788 208.518 543.908C208.518 542.028 206.986 540.496 205.101 540.496Z"
            fill="white"
          />
          <path
            d="M200.98 535.934C199.074 535.934 197.525 537.483 197.525 539.388C197.525 541.293 199.074 542.842 200.98 542.842C202.885 542.842 204.434 541.302 204.434 539.388C204.434 537.474 202.885 535.934 200.98 535.934Z"
            fill="white"
          />
          <path
            d="M196.609 531.082C194.661 531.082 193.082 532.652 193.082 534.6C193.082 536.548 194.665 538.127 196.609 538.127C198.552 538.127 200.135 536.544 200.135 534.6C200.135 532.656 198.552 531.082 196.609 531.082Z"
            fill="white"
          />
          <path
            d="M192.008 525.996C190.031 525.996 188.439 527.588 188.439 529.557C188.439 531.526 190.031 533.117 192.008 533.117C193.986 533.117 195.569 531.526 195.569 529.557C195.569 527.588 193.978 525.996 192.008 525.996Z"
            fill="white"
          />
          <path
            d="M187.192 520.666C185.206 520.666 183.589 522.279 183.589 524.269C183.589 526.259 185.202 527.868 187.192 527.868C189.182 527.868 190.795 526.255 190.795 524.269C190.795 522.283 189.182 520.666 187.192 520.666Z"
            fill="white"
          />
          <path
            d="M182.171 515.16C180.151 515.16 178.518 516.794 178.518 518.814C178.518 520.834 180.151 522.455 182.171 522.455C184.191 522.455 185.813 520.821 185.813 518.814C185.813 516.807 184.179 515.16 182.171 515.16Z"
            fill="white"
          />
          <path
            d="M176.938 509.551C174.91 509.551 173.255 511.197 173.255 513.234C173.255 515.271 174.91 516.931 176.938 516.931C178.967 516.931 180.635 515.276 180.635 513.234C180.635 511.193 178.98 509.551 176.938 509.551Z"
            fill="white"
          />
          <path
            d="M171.485 503.848C169.422 503.848 167.759 505.511 167.759 507.574C167.759 509.636 169.422 511.308 171.485 511.308C173.547 511.308 175.219 509.632 175.219 507.574C175.219 505.515 173.543 503.848 171.485 503.848Z"
            fill="white"
          />
          <path
            d="M165.79 498.102C163.71 498.102 162.021 499.786 162.021 501.87C162.021 503.954 163.706 505.638 165.79 505.638C167.874 505.638 169.546 503.954 169.546 501.87C169.546 499.786 167.861 498.102 165.79 498.102Z"
            fill="white"
          />
          <path
            d="M159.815 492.359C157.723 492.359 156.025 494.057 156.025 496.149C156.025 498.241 157.723 499.947 159.815 499.947C161.907 499.947 163.605 498.25 163.605 496.149C163.605 494.048 161.907 492.359 159.815 492.359Z"
            fill="white"
          />
          <path
            d="M153.53 486.635C151.408 486.635 149.689 488.362 149.689 490.475C149.689 492.589 151.408 494.316 153.53 494.316C155.652 494.316 157.371 492.597 157.371 490.475C157.371 488.354 155.652 486.635 153.53 486.635Z"
            fill="white"
          />
          <path
            d="M146.902 481.066C144.767 481.066 143.031 482.794 143.031 484.928C143.031 487.063 144.771 488.799 146.902 488.799C149.032 488.799 150.763 487.059 150.763 484.928C150.763 482.798 149.036 481.066 146.902 481.066Z"
            fill="white"
          />
          <path
            d="M139.873 475.672C137.73 475.672 135.981 477.412 135.981 479.563C135.981 481.715 137.73 483.455 139.873 483.455C142.016 483.455 143.764 481.707 143.764 479.563C143.764 477.42 142.025 475.672 139.873 475.672Z"
            fill="white"
          />
          <path
            d="M132.456 470.439C130.3 470.439 128.543 472.188 128.543 474.352C128.543 476.516 130.304 478.265 132.456 478.265C134.607 478.265 136.368 476.504 136.368 474.352C136.368 472.201 134.62 470.439 132.456 470.439Z"
            fill="white"
          />
          <path
            d="M128.623 469.542C128.778 467.363 127.138 465.471 124.959 465.316C122.78 465.161 120.888 466.802 120.733 468.981C120.578 471.159 122.219 473.051 124.397 473.207C126.576 473.362 128.468 471.721 128.623 469.542Z"
            fill="white"
          />
          <path
            d="M116.563 460.154C114.378 460.154 112.6 461.932 112.6 464.131C112.6 466.329 114.378 468.094 116.563 468.094C118.749 468.094 120.54 466.316 120.54 464.131C120.54 461.945 118.762 460.154 116.563 460.154Z"
            fill="white"
          />
          <path
            d="M108.215 463.019C110.423 463.019 112.213 461.229 112.213 459.021C112.213 456.813 110.423 455.023 108.215 455.023C106.008 455.023 104.218 456.813 104.218 459.021C104.218 461.229 106.008 463.019 108.215 463.019Z"
            fill="white"
          />
          <path
            d="M99.6467 449.863C97.44 449.863 95.6406 451.663 95.6406 453.882C95.6406 456.102 97.44 457.888 99.6467 457.888C101.853 457.888 103.666 456.089 103.666 453.882C103.666 451.675 101.866 449.863 99.6467 449.863Z"
            fill="white"
          />
          <path
            d="M90.918 444.625C88.69 444.625 86.8779 446.424 86.8779 448.652C86.8779 450.88 88.69 452.692 90.918 452.692C93.146 452.692 94.958 450.88 94.958 448.652C94.958 446.424 93.146 444.625 90.918 444.625Z"
            fill="white"
          />
          <path
            d="M82.0492 439.193C79.8128 439.193 77.9922 441.014 77.9922 443.25C77.9922 445.487 79.8128 447.299 82.0492 447.299C84.2857 447.299 86.0978 445.487 86.0978 443.25C86.0978 441.014 84.2772 439.193 82.0492 439.193Z"
            fill="white"
          />
          <path
            d="M73.0775 433.441C70.8283 433.441 69.0205 435.254 69.0205 437.503C69.0205 439.752 70.8326 441.56 73.0775 441.56C75.3225 441.56 77.1388 439.739 77.1388 437.503C77.1388 435.266 75.3182 433.441 73.0775 433.441Z"
            fill="white"
          />
          <path
            d="M64.0551 427.191C61.8059 427.191 59.9854 429.003 59.9854 431.248C59.9854 433.493 61.8059 435.318 64.0551 435.318C66.3043 435.318 68.1249 433.498 68.1249 431.248C68.1249 428.999 66.3043 427.191 64.0551 427.191Z"
            fill="white"
          />
          <path
            d="M55.0206 420.357C52.7629 420.357 50.9424 422.178 50.9424 424.427C50.9424 426.676 52.7629 428.505 55.0206 428.505C57.2783 428.505 59.0904 426.672 59.0904 424.427C59.0904 422.182 57.2698 420.357 55.0206 420.357Z"
            fill="white"
          />
          <path
            d="M46.0275 412.789C43.7698 412.789 41.9492 414.622 41.9492 416.88C41.9492 419.138 43.7698 420.971 46.0275 420.971C48.2851 420.971 50.1184 419.138 50.1184 416.88C50.1184 414.622 48.2851 412.789 46.0275 412.789Z"
            fill="white"
          />
          <path
            d="M37.171 404.418C34.9218 404.418 33.0928 406.251 33.0928 408.496C33.0928 410.741 34.9261 412.587 37.171 412.587C39.416 412.587 41.262 410.754 41.262 408.496C41.262 406.239 39.4287 404.418 37.171 404.418Z"
            fill="white"
          />
          <path
            d="M28.5861 395.104C26.3284 395.104 24.5078 396.937 24.5078 399.194C24.5078 401.452 26.3284 403.273 28.5861 403.273C30.8437 403.273 32.6643 401.439 32.6643 399.194C32.6643 396.95 30.8437 395.104 28.5861 395.104Z"
            fill="white"
          />
          <path
            d="M20.3195 385.021C18.0618 385.021 16.2285 386.863 16.2285 389.121C16.2285 391.379 18.0618 393.212 20.3195 393.212C22.5772 393.212 24.419 391.379 24.419 389.121C24.419 386.863 22.5857 385.021 20.3195 385.021Z"
            fill="white"
          />
          <path
            d="M12.3915 374.611C10.121 374.611 8.29199 376.445 8.29199 378.702C8.29199 380.96 10.1253 382.802 12.3915 382.802C14.6576 382.802 16.4824 380.968 16.4824 378.702C16.4824 376.436 14.6491 374.611 12.3915 374.611Z"
            fill="white"
          />
          <path
            d="M4.67691 364.365C2.41924 364.365 0.585938 366.207 0.585938 368.465C0.585938 370.722 2.41924 372.556 4.67691 372.556C6.93459 372.556 8.76789 370.722 8.76789 368.465C8.76789 366.207 6.93459 364.365 4.67691 364.365Z"
            fill="white"
          />
          <path
            d="M-2.96274 354.764C-5.22041 354.764 -7.05371 356.597 -7.05371 358.863C-7.05371 361.129 -5.22041 362.954 -2.96274 362.954C-0.705061 362.954 1.12824 361.121 1.12824 358.863C1.12824 356.605 -0.705061 354.764 -2.96274 354.764Z"
            fill="white"
          />
          <path
            d="M3.00012 346.596C0.750931 346.596 -1.07812 348.429 -1.07812 350.674C-1.07812 352.919 0.755175 354.752 3.00012 354.752C5.24506 354.752 7.07836 352.932 7.07836 350.674C7.07836 348.416 5.25779 346.596 3.00012 346.596Z"
            fill="white"
          />
          <path
            d="M9.03918 338.02C6.78151 338.02 4.96094 339.853 4.96094 342.098C4.96094 344.343 6.78151 346.176 9.03918 346.176C11.2969 346.176 13.1174 344.355 13.1174 342.098C13.1174 339.84 11.2841 338.02 9.03918 338.02Z"
            fill="white"
          />
          <path
            d="M15.1677 328.818C12.9313 328.818 11.1064 330.63 11.1064 332.875C11.1064 335.12 12.927 336.937 15.1677 336.937C17.4084 336.937 19.2375 335.116 19.2375 332.875C19.2375 330.635 17.4169 328.818 15.1677 328.818Z"
            fill="white"
          />
          <path
            d="M21.4773 318.816C19.2408 318.816 17.416 320.628 17.416 322.865C17.416 325.101 19.2366 326.926 21.4773 326.926C23.718 326.926 25.5258 325.106 25.5258 322.865C25.5258 320.624 23.7137 318.816 21.4773 318.816Z"
            fill="white"
          />
          <path
            d="M27.9785 308.01C25.7506 308.01 23.9385 309.809 23.9385 312.037C23.9385 314.265 25.7506 316.077 27.9785 316.077C30.2065 316.077 32.0186 314.278 32.0186 312.037C32.0186 309.796 30.2065 308.01 27.9785 308.01Z"
            fill="white"
          />
          <path
            d="M34.7561 296.344C32.5409 296.344 30.7373 298.143 30.7373 300.363C30.7373 302.582 32.5367 304.381 34.7561 304.381C36.9756 304.381 38.775 302.591 38.775 300.363C38.775 298.135 36.9841 296.344 34.7561 296.344Z"
            fill="white"
          />
          <path
            d="M41.843 283.812C39.6363 283.812 37.8369 285.603 37.8369 287.819C37.8369 290.034 39.6363 291.816 41.843 291.816C44.0498 291.816 45.8491 290.025 45.8491 287.819C45.8491 285.612 44.0582 283.812 41.843 283.812Z"
            fill="white"
          />
          <path
            d="M49.1724 270.691C46.9657 270.691 45.1748 272.482 45.1748 274.676C45.1748 276.87 46.9657 278.661 49.1724 278.661C51.3792 278.661 53.1573 276.883 53.1573 274.676C53.1573 272.47 51.3664 270.691 49.1724 270.691Z"
            fill="white"
          />
          <path
            d="M56.6544 257.256C54.4773 257.256 52.6992 259.026 52.6992 261.211C52.6992 263.397 54.4773 265.166 56.6544 265.166C58.8314 265.166 60.6096 263.397 60.6096 261.211C60.6096 259.026 58.8399 257.256 56.6544 257.256Z"
            fill="white"
          />
          <path
            d="M64.1781 243.85C62.001 243.85 60.2441 245.611 60.2441 247.784C60.2441 249.956 62.0053 251.709 64.1781 251.709C66.3509 251.709 68.1036 249.948 68.1036 247.784C68.1036 245.619 66.3466 243.85 64.1781 243.85Z"
            fill="white"
          />
          <path
            d="M71.5573 230.838C69.393 230.838 67.6445 232.586 67.6445 234.742C67.6445 236.898 69.393 238.655 71.5573 238.655C73.7216 238.655 75.47 236.906 75.47 234.742C75.47 232.578 73.7216 230.838 71.5573 230.838Z"
            fill="white"
          />
          <path
            d="M78.6962 218.471C76.5404 218.471 74.8047 220.211 74.8047 222.354C74.8047 224.497 76.5404 226.237 78.6962 226.237C80.852 226.237 82.5792 224.501 82.5792 222.354C82.5792 220.206 80.8435 218.471 78.6962 218.471Z"
            fill="white"
          />
          <path
            d="M85.5662 206.807C83.4443 206.807 81.7256 208.525 81.7256 210.647C81.7256 212.769 83.4443 214.479 85.5662 214.479C87.6881 214.479 89.394 212.761 89.394 210.647C89.394 208.534 87.6753 206.807 85.5662 206.807Z"
            fill="white"
          />
          <path
            d="M92.0716 196.129C89.971 196.129 88.2607 197.835 88.2607 199.94C88.2607 202.045 89.9667 203.751 92.0716 203.751C94.1765 203.751 95.8825 202.053 95.8825 199.94C95.8825 197.826 94.1765 196.129 92.0716 196.129Z"
            fill="white"
          />
          <path
            d="M98.15 194.389C100.236 194.389 101.927 192.7 101.927 190.616C101.927 188.533 100.236 186.844 98.15 186.844C96.064 186.844 94.373 188.533 94.373 190.616C94.373 192.7 96.064 194.389 98.15 194.389Z"
            fill="white"
          />
          <path
            d="M103.803 178.797C101.74 178.797 100.068 180.473 100.068 182.54C100.068 184.607 101.745 186.283 103.803 186.283C105.861 186.283 107.55 184.607 107.55 182.54C107.55 180.473 105.874 178.797 103.803 178.797Z"
            fill="white"
          />
          <path
            d="M109.061 171.744C107.019 171.744 105.364 173.399 105.364 175.449C105.364 177.499 107.019 179.145 109.061 179.145C111.102 179.145 112.765 177.49 112.765 175.449C112.765 173.408 111.11 171.744 109.061 171.744Z"
            fill="white"
          />
          <path
            d="M113.94 165.424C111.92 165.424 110.286 167.062 110.286 169.082C110.286 171.102 111.92 172.74 113.94 172.74C115.96 172.74 117.602 171.102 117.602 169.082C117.602 167.062 115.956 165.424 113.94 165.424Z"
            fill="white"
          />
          <path
            d="M118.469 159.627C116.461 159.627 114.849 161.252 114.849 163.26C114.849 165.267 116.461 166.88 118.469 166.88C120.476 166.88 122.088 165.254 122.088 163.26C122.088 161.265 120.463 159.627 118.469 159.627Z"
            fill="white"
          />
          <path
            d="M122.59 154.246C120.612 154.246 119.008 155.85 119.008 157.828C119.008 159.805 120.612 161.397 122.59 161.397C124.567 161.397 126.171 159.801 126.171 157.828C126.171 155.854 124.567 154.246 122.59 154.246Z"
            fill="white"
          />
          <path
            d="M126.293 149.115C124.346 149.115 122.775 150.685 122.775 152.629C122.775 154.573 124.346 156.143 126.293 156.143C128.241 156.143 129.812 154.573 129.812 152.629C129.812 150.685 128.229 149.115 126.293 149.115Z"
            fill="white"
          />
          <path
            d="M129.552 144.08C127.638 144.08 126.085 145.642 126.085 147.556C126.085 149.47 127.634 151.031 129.552 151.031C131.47 151.031 133.028 149.47 133.028 147.556C133.028 145.642 131.479 144.08 129.552 144.08Z"
            fill="white"
          />
          <path
            d="M132.371 139.156C130.487 139.156 128.959 140.688 128.959 142.581C128.959 144.474 130.491 146.001 132.371 146.001C134.251 146.001 135.796 144.465 135.796 142.581C135.796 140.697 134.268 139.156 132.371 139.156Z"
            fill="white"
          />
          <path
            d="M134.787 134.355C132.915 134.355 131.404 135.87 131.404 137.738C131.404 139.605 132.915 141.116 134.787 141.116C136.658 141.116 138.16 139.601 138.16 137.738C138.16 135.875 136.65 134.355 134.787 134.355Z"
            fill="white"
          />
          <path
            d="M136.814 129.807C134.981 129.807 133.504 131.283 133.504 133.117C133.504 134.95 134.981 136.427 136.814 136.427C138.647 136.427 140.124 134.95 140.124 133.117C140.124 131.283 138.647 129.807 136.814 129.807Z"
            fill="white"
          />
          <path
            d="M138.534 125.492C136.734 125.492 135.274 126.948 135.274 128.751C135.274 130.555 136.73 132.011 138.534 132.011C140.337 132.011 141.793 130.555 141.793 128.751C141.793 126.948 140.337 125.492 138.534 125.492Z"
            fill="white"
          />
          <path
            d="M140.002 121.4C138.232 121.4 136.798 122.835 136.798 124.604C136.798 126.374 138.232 127.808 140.002 127.808C141.772 127.808 143.206 126.374 143.206 124.604C143.206 122.835 141.772 121.4 140.002 121.4Z"
            fill="white"
          />
          <path
            d="M141.283 117.498C139.543 117.498 138.13 118.903 138.13 120.651C138.13 122.4 139.547 123.804 141.283 123.804C143.019 123.804 144.436 122.387 144.436 120.651C144.436 118.915 143.031 117.498 141.283 117.498Z"
            fill="white"
          />
          <path
            d="M142.437 113.727C140.739 113.727 139.364 115.102 139.364 116.791C139.364 118.48 140.739 119.855 142.437 119.855C144.134 119.855 145.496 118.48 145.496 116.791C145.496 115.102 144.122 113.727 142.437 113.727Z"
            fill="white"
          />
          <path
            d="M143.485 109.953C141.822 109.953 140.477 111.307 140.477 112.962C140.477 114.617 141.818 115.971 143.485 115.971C145.153 115.971 146.494 114.63 146.494 112.962C146.494 111.294 145.14 109.953 143.485 109.953Z"
            fill="white"
          />
          <path
            d="M144.487 106.104C142.853 106.104 141.529 107.428 141.529 109.061C141.529 110.695 142.853 112.019 144.487 112.019C146.121 112.019 147.445 110.695 147.445 109.061C147.445 107.428 146.125 106.104 144.487 106.104Z"
            fill="white"
          />
          <path
            d="M145.484 102.07C143.88 102.07 142.581 103.373 142.581 104.965C142.581 106.556 143.884 107.867 145.484 107.867C147.084 107.867 148.378 106.564 148.378 104.965C148.378 103.365 147.075 102.07 145.484 102.07Z"
            fill="white"
          />
          <path
            d="M146.516 97.793C144.967 97.793 143.715 99.0534 143.715 100.598C143.715 102.143 144.963 103.403 146.516 103.403C148.069 103.403 149.317 102.143 149.317 100.598C149.317 99.0534 148.069 97.793 146.516 97.793Z"
            fill="white"
          />
          <path
            d="M147.682 93.0469C146.171 93.0469 144.944 94.2733 144.944 95.7926C144.944 97.3118 146.171 98.534 147.682 98.534C149.192 98.534 150.432 97.3076 150.432 95.7926C150.432 94.2776 149.205 93.0469 147.682 93.0469Z"
            fill="white"
          />
          <path
            d="M149.16 87.6367C147.683 87.6367 146.474 88.8419 146.474 90.323C146.474 91.8041 147.679 93.0093 149.16 93.0093C150.641 93.0093 151.846 91.8126 151.846 90.323C151.846 88.8335 150.649 87.6367 149.16 87.6367Z"
            fill="white"
          />
          <path
            d="M151.222 81.2051C149.774 81.2051 148.607 82.3721 148.607 83.8107C148.607 85.2494 149.774 86.4164 151.222 86.4164C152.669 86.4164 153.823 85.2494 153.823 83.8107C153.823 82.3721 152.656 81.2051 151.222 81.2051Z"
            fill="white"
          />
          <path
            d="M154.303 73.3145C152.92 73.3145 151.795 74.4433 151.795 75.831C151.795 77.2187 152.92 78.3391 154.303 78.3391C155.686 78.3391 156.824 77.2145 156.824 75.831C156.824 74.4475 155.699 73.3145 154.303 73.3145Z"
            fill="white"
          />
          <path
            d="M159.09 63.3965C157.736 63.3965 156.646 64.4914 156.646 65.8409C156.646 67.1904 157.74 68.298 159.09 68.298C160.439 68.298 161.547 67.1989 161.547 65.8409C161.547 64.4829 160.444 63.3965 159.09 63.3965Z"
            fill="white"
          />
          <path
            d="M166.758 50.5645C165.438 50.5645 164.364 51.6381 164.364 52.9579C164.364 54.2777 165.438 55.3472 166.758 55.3472C168.078 55.3472 169.143 54.282 169.143 52.9579C169.143 51.6339 168.082 50.5645 166.758 50.5645Z"
            fill="white"
          />
          <path
            d="M178.543 33.8945C177.253 33.8945 176.222 34.93 176.222 36.2159C176.222 37.5017 177.253 38.5329 178.543 38.5329C179.833 38.5329 180.852 37.4975 180.852 36.2159C180.852 34.9342 179.82 33.8945 178.543 33.8945Z"
            fill="white"
          />
          <path
            d="M195.518 16.5848C196.748 16.5848 197.746 15.5873 197.746 14.3569C197.746 13.1264 196.748 12.1289 195.518 12.1289C194.288 12.1289 193.29 13.1264 193.29 14.3569C193.29 15.5873 194.288 16.5848 195.518 16.5848Z"
            fill="white"
          />
          <path
            d="M919.561 1.54492C917.957 1.54492 916.667 2.83927 916.667 4.43916C916.667 6.03905 917.957 7.3334 919.561 7.3334C921.165 7.3334 922.443 6.03905 922.443 4.43916C922.443 2.83927 921.153 1.54492 919.561 1.54492Z"
            fill="white"
          />
          <path
            d="M927.106 12.1289C925.481 12.1289 924.161 13.4445 924.161 15.0741C924.161 16.7037 925.485 18.0235 927.106 18.0235C928.727 18.0235 930.064 16.7079 930.064 15.0741C930.064 13.4402 928.74 12.1289 927.106 12.1289Z"
            fill="white"
          />
          <path
            d="M934.571 22.7969C932.908 22.7969 931.562 24.1506 931.562 25.8142C931.562 27.4777 932.904 28.8272 934.571 28.8272C936.239 28.8272 937.589 27.4777 937.589 25.8142C937.589 24.1506 936.235 22.7969 934.571 22.7969Z"
            fill="white"
          />
          <path
            d="M941.938 33.5684C940.232 33.5684 938.849 34.9518 938.849 36.6578C938.849 38.3638 940.232 39.7557 941.938 39.7557C943.644 39.7557 945.028 38.3723 945.028 36.6578C945.028 34.9433 943.644 33.5684 941.938 33.5684Z"
            fill="white"
          />
          <path
            d="M949.213 44.4688C947.473 44.4688 946.06 45.8777 946.06 47.6176C946.06 49.3575 947.477 50.7707 949.213 50.7707C950.948 50.7707 952.357 49.3533 952.357 47.6176C952.357 45.8819 950.953 44.4688 949.213 44.4688Z"
            fill="white"
          />
          <path
            d="M956.418 55.4219C954.64 55.4219 953.201 56.8605 953.201 58.6259C953.201 60.3913 954.636 61.8384 956.418 61.8384C958.2 61.8384 959.622 60.404 959.622 58.6259C959.622 56.8478 958.188 55.4219 956.418 55.4219Z"
            fill="white"
          />
          <path
            d="M963.569 66.4062C961.769 66.4062 960.31 67.8619 960.31 69.6655C960.31 71.469 961.765 72.9246 963.569 72.9246C965.372 72.9246 966.828 71.469 966.828 69.6655C966.828 67.8619 965.372 66.4062 963.569 66.4062Z"
            fill="white"
          />
          <path
            d="M970.699 77.332C968.845 77.332 967.359 78.8301 967.359 80.6719C967.359 82.5137 968.849 84.0244 970.699 84.0244C972.55 84.0244 974.039 82.5264 974.039 80.6719C974.039 78.8173 972.541 77.332 970.699 77.332Z"
            fill="white"
          />
          <path
            d="M977.786 88.3379C975.914 88.3379 974.391 89.8529 974.391 91.7244C974.391 93.5959 975.91 95.1194 977.786 95.1194C979.661 95.1194 981.181 93.6001 981.181 91.7244C981.181 89.8487 979.661 88.3379 977.786 88.3379Z"
            fill="white"
          />
          <path
            d="M984.809 99.4336C982.904 99.4336 981.363 100.974 981.363 102.875C981.363 104.776 982.904 106.317 984.809 106.317C986.715 106.317 988.242 104.776 988.242 102.875C988.242 100.974 986.702 99.4336 984.809 99.4336Z"
            fill="white"
          />
          <path
            d="M991.781 117.615C993.708 117.615 995.27 116.054 995.27 114.127C995.27 112.2 993.708 110.639 991.781 110.639C989.855 110.639 988.293 112.2 988.293 114.127C988.293 116.054 989.855 117.615 991.781 117.615Z"
            fill="white"
          />
          <path
            d="M998.702 129.074C1000.67 129.074 1002.26 127.48 1002.26 125.514C1002.26 123.547 1000.67 121.953 998.702 121.953C996.736 121.953 995.142 123.547 995.142 125.514C995.142 127.48 996.736 129.074 998.702 129.074Z"
            fill="white"
          />
          <path
            d="M1005.6 133.424C1003.61 133.424 1001.99 135.041 1001.99 137.035C1001.99 139.03 1003.6 140.638 1005.6 140.638C1007.59 140.638 1009.2 139.026 1009.2 137.035C1009.2 135.045 1007.59 133.424 1005.6 133.424Z"
            fill="white"
          />
          <path
            d="M1012.46 145.055C1010.44 145.055 1008.81 146.689 1008.81 148.696C1008.81 150.703 1010.44 152.35 1012.46 152.35C1014.48 152.35 1016.1 150.716 1016.1 148.696C1016.1 146.676 1014.47 145.055 1012.46 145.055Z"
            fill="white"
          />
          <path
            d="M1019.29 156.912C1017.26 156.912 1015.61 158.563 1015.61 160.596C1015.61 162.628 1017.26 164.279 1019.29 164.279C1021.32 164.279 1022.97 162.628 1022.97 160.596C1022.97 158.563 1021.33 156.912 1019.29 156.912Z"
            fill="white"
          />
          <path
            d="M1026.14 168.93C1024.07 168.93 1022.39 170.606 1022.39 172.677C1022.39 174.748 1024.07 176.42 1026.14 176.42C1028.21 176.42 1029.89 174.744 1029.89 172.677C1029.89 170.61 1028.21 168.93 1026.14 168.93Z"
            fill="white"
          />
          <path
            d="M1033.04 181.107C1030.96 181.107 1029.26 182.801 1029.26 184.893C1029.26 186.985 1030.96 188.683 1033.04 188.683C1035.12 188.683 1036.83 186.985 1036.83 184.893C1036.83 182.801 1035.13 181.107 1033.04 181.107Z"
            fill="white"
          />
          <path
            d="M1040.08 193.285C1037.97 193.285 1036.26 195.004 1036.26 197.105C1036.26 199.205 1037.97 200.924 1040.08 200.924C1042.2 200.924 1043.9 199.218 1043.9 197.105C1043.9 194.991 1042.18 193.285 1040.08 193.285Z"
            fill="white"
          />
          <path
            d="M1047.35 205.287C1045.21 205.287 1043.49 207.027 1043.49 209.149C1043.49 211.271 1045.21 213.011 1047.35 213.011C1049.48 213.011 1051.21 211.284 1051.21 209.149C1051.21 207.014 1049.48 205.287 1047.35 205.287Z"
            fill="white"
          />
          <path
            d="M1054.97 216.82C1052.81 216.82 1051.06 218.569 1051.06 220.733C1051.06 222.897 1052.82 224.646 1054.97 224.646C1057.12 224.646 1058.88 222.885 1058.88 220.733C1058.88 218.581 1057.13 216.82 1054.97 216.82Z"
            fill="white"
          />
          <path
            d="M1063 227.621C1060.83 227.621 1059.06 229.378 1059.06 231.555C1059.06 233.732 1060.83 235.497 1063 235.497C1065.18 235.497 1066.94 233.728 1066.94 231.555C1066.94 229.382 1065.18 227.621 1063 227.621Z"
            fill="white"
          />
          <path
            d="M1071.45 237.467C1069.26 237.467 1067.48 239.245 1067.48 241.443C1067.48 243.641 1069.26 245.407 1071.45 245.407C1073.65 245.407 1075.42 243.629 1075.42 241.443C1075.42 239.258 1073.64 237.467 1071.45 237.467Z"
            fill="white"
          />
          <path
            d="M1080.3 246.244C1078.09 246.244 1076.29 248.035 1076.29 250.242C1076.29 252.448 1078.09 254.248 1080.3 254.248C1082.52 254.248 1084.3 252.457 1084.3 250.242C1084.3 248.027 1082.51 246.244 1080.3 246.244Z"
            fill="white"
          />
          <path
            d="M1089.47 253.926C1087.24 253.926 1085.45 255.725 1085.45 257.953C1085.45 260.181 1087.24 261.993 1089.47 261.993C1091.7 261.993 1093.51 260.181 1093.51 257.953C1093.51 255.725 1091.7 253.926 1089.47 253.926Z"
            fill="white"
          />
          <path
            d="M1098.9 260.604C1096.67 260.604 1094.84 262.416 1094.84 264.665C1094.84 266.914 1096.66 268.722 1098.9 268.722C1101.14 268.722 1102.96 266.91 1102.96 264.665C1102.96 262.42 1101.15 260.604 1098.9 260.604Z"
            fill="white"
          />
          <path
            d="M1108.51 266.422C1106.26 266.422 1104.43 268.242 1104.43 270.5C1104.43 272.758 1106.26 274.578 1108.51 274.578C1110.75 274.578 1112.58 272.745 1112.58 270.5C1112.58 268.255 1110.76 266.422 1108.51 266.422Z"
            fill="white"
          />
          <path
            d="M1118.24 271.512C1115.97 271.512 1114.13 273.345 1114.13 275.624C1114.13 277.903 1115.97 279.723 1118.24 279.723C1120.51 279.723 1122.34 277.89 1122.34 275.624C1122.34 273.358 1120.51 271.512 1118.24 271.512Z"
            fill="white"
          />
          <path
            d="M1128.03 276.039C1125.74 276.039 1123.89 277.894 1123.89 280.181C1123.89 282.468 1125.74 284.323 1128.03 284.323C1130.32 284.323 1132.16 282.473 1132.16 280.181C1132.16 277.889 1130.31 276.039 1128.03 276.039Z"
            fill="white"
          />
          <path
            d="M1137.85 280.172C1135.56 280.172 1133.7 282.035 1133.7 284.326C1133.7 286.618 1135.56 288.481 1137.85 288.481C1140.15 288.481 1142.01 286.631 1142.01 284.326C1142.01 282.022 1140.15 280.172 1137.85 280.172Z"
            fill="white"
          />
          <path
            d="M1147.73 283.984C1145.43 283.984 1143.58 285.847 1143.58 288.139C1143.58 290.431 1145.43 292.294 1147.73 292.294C1150.03 292.294 1151.89 290.439 1151.89 288.139C1151.89 285.839 1150.03 283.984 1147.73 283.984Z"
            fill="white"
          />
          <path
            d="M1157.62 287.541C1155.32 287.541 1153.47 289.396 1153.47 291.696C1153.47 293.996 1155.32 295.85 1157.62 295.85C1159.93 295.85 1161.78 293.987 1161.78 291.696C1161.78 289.404 1159.91 287.541 1157.62 287.541Z"
            fill="white"
          />
          <path
            d="M1167.51 290.871C1165.22 290.871 1163.36 292.726 1163.36 295.026C1163.36 297.326 1165.22 299.18 1167.51 299.18C1169.8 299.18 1171.66 297.317 1171.66 295.026C1171.66 292.734 1169.81 290.871 1167.51 290.871Z"
            fill="white"
          />
          <path
            d="M1177.38 294.037C1175.09 294.037 1173.22 295.9 1173.22 298.192C1173.22 300.483 1175.09 302.346 1177.38 302.346C1179.67 302.346 1181.54 300.492 1181.54 298.192C1181.54 295.892 1179.68 294.037 1177.38 294.037Z"
            fill="white"
          />
          <path
            d="M1187.19 297.055C1184.9 297.055 1183.03 298.905 1183.03 301.209C1183.03 303.514 1184.9 305.364 1187.19 305.364C1189.48 305.364 1191.34 303.501 1191.34 301.209C1191.34 298.918 1189.49 297.055 1187.19 297.055Z"
            fill="white"
          />
          <path
            d="M1196.92 299.896C1194.63 299.896 1192.77 301.759 1192.77 304.051C1192.77 306.343 1194.63 308.206 1196.92 308.206C1199.22 308.206 1201.08 306.351 1201.08 304.051C1201.08 301.751 1199.22 299.896 1196.92 299.896Z"
            fill="white"
          />
          <path
            d="M1206.54 302.549C1204.25 302.549 1202.39 304.412 1202.39 306.703C1202.39 308.995 1204.25 310.858 1206.54 310.858C1208.83 310.858 1210.7 308.995 1210.7 306.703C1210.7 304.412 1208.84 302.549 1206.54 302.549Z"
            fill="white"
          />
          <path
            d="M1202.48 302.656C1200.19 302.656 1198.33 304.507 1198.33 306.811C1198.33 309.115 1200.19 310.966 1202.48 310.966C1204.77 310.966 1206.63 309.102 1206.63 306.811C1206.63 304.519 1204.78 302.656 1202.48 302.656Z"
            fill="white"
          />
          <path
            d="M1198.07 302.6C1195.77 302.6 1193.91 304.454 1193.91 306.754C1193.91 309.054 1195.77 310.909 1198.07 310.909C1200.36 310.909 1202.22 309.046 1202.22 306.754C1202.22 304.463 1200.36 302.6 1198.07 302.6Z"
            fill="white"
          />
          <path
            d="M1193.28 302.404C1190.99 302.404 1189.12 304.267 1189.12 306.559C1189.12 308.851 1190.99 310.714 1193.28 310.714C1195.57 310.714 1197.43 308.851 1197.43 306.559C1197.43 304.267 1195.58 302.404 1193.28 302.404Z"
            fill="white"
          />
          <path
            d="M1188.13 302.09C1185.83 302.09 1183.97 303.944 1183.97 306.244C1183.97 308.545 1185.83 310.399 1188.13 310.399C1190.43 310.399 1192.28 308.536 1192.28 306.244C1192.28 303.953 1190.42 302.09 1188.13 302.09Z"
            fill="white"
          />
          <path
            d="M1182.6 301.662C1180.31 301.662 1178.45 303.525 1178.45 305.817C1178.45 308.108 1180.31 309.971 1182.6 309.971C1184.89 309.971 1186.76 308.121 1186.76 305.817C1186.76 303.512 1184.9 301.662 1182.6 301.662Z"
            fill="white"
          />
          <path
            d="M1176.72 301.166C1174.43 301.166 1172.56 303.016 1172.56 305.321C1172.56 307.625 1174.43 309.475 1176.72 309.475C1179.01 309.475 1180.87 307.612 1180.87 305.321C1180.87 303.029 1179.02 301.166 1176.72 301.166Z"
            fill="white"
          />
          <path
            d="M1170.5 300.592C1168.2 300.592 1166.34 302.455 1166.34 304.746C1166.34 307.038 1168.2 308.897 1170.5 308.897C1172.8 308.897 1174.65 307.034 1174.65 304.746C1174.65 302.459 1172.79 300.592 1170.5 300.592Z"
            fill="white"
          />
          <path
            d="M1163.93 299.977C1161.64 299.977 1159.77 301.84 1159.77 304.131C1159.77 306.423 1161.64 308.286 1163.93 308.286C1166.22 308.286 1168.08 306.436 1168.08 304.131C1168.08 301.827 1166.22 299.977 1163.93 299.977Z"
            fill="white"
          />
          <path
            d="M1157.03 299.346C1154.74 299.346 1152.87 301.196 1152.87 303.5C1152.87 305.805 1154.74 307.655 1157.03 307.655C1159.32 307.655 1161.18 305.792 1161.18 303.5C1161.18 301.209 1159.33 299.346 1157.03 299.346Z"
            fill="white"
          />
          <path
            d="M1149.8 298.688C1147.51 298.688 1145.65 300.55 1145.65 302.842C1145.65 305.134 1147.51 306.997 1149.8 306.997C1152.1 306.997 1153.96 305.146 1153.96 302.842C1153.96 300.538 1152.11 298.688 1149.8 298.688Z"
            fill="white"
          />
          <path
            d="M1142.27 298.064C1139.97 298.064 1138.11 299.927 1138.11 302.219C1138.11 304.511 1139.97 306.374 1142.27 306.374C1144.57 306.374 1146.42 304.523 1146.42 302.219C1146.42 299.915 1144.56 298.064 1142.27 298.064Z"
            fill="white"
          />
          <path
            d="M1134.41 297.514C1132.12 297.514 1130.27 299.368 1130.27 301.656C1130.27 303.943 1132.12 305.789 1134.41 305.789C1136.71 305.789 1138.56 303.934 1138.56 301.656C1138.56 299.377 1136.7 297.514 1134.41 297.514Z"
            fill="white"
          />
          <path
            d="M1126.25 297.055C1123.97 297.055 1122.13 298.896 1122.13 301.175C1122.13 303.454 1123.97 305.309 1126.25 305.309C1128.53 305.309 1130.39 303.459 1130.39 301.175C1130.39 298.892 1128.53 297.055 1126.25 297.055Z"
            fill="white"
          />
          <path
            d="M1117.8 296.73C1115.54 296.73 1113.7 298.572 1113.7 300.83C1113.7 303.088 1115.54 304.929 1117.8 304.929C1120.06 304.929 1121.9 303.096 1121.9 300.83C1121.9 298.564 1120.06 296.73 1117.8 296.73Z"
            fill="white"
          />
          <path
            d="M1109.07 296.553C1106.81 296.553 1104.99 298.373 1104.99 300.631C1104.99 302.889 1106.81 304.709 1109.07 304.709C1111.33 304.709 1113.15 302.876 1113.15 300.631C1113.15 298.386 1111.32 296.553 1109.07 296.553Z"
            fill="white"
          />
          <path
            d="M1100.04 296.531C1097.82 296.531 1096 298.343 1096 300.58C1096 302.816 1097.82 304.628 1100.04 304.628C1102.27 304.628 1104.1 302.816 1104.1 300.58C1104.1 298.343 1102.28 296.531 1100.04 296.531Z"
            fill="white"
          />
          <path
            d="M1090.77 296.723C1088.55 296.723 1086.75 298.522 1086.75 300.741C1086.75 302.961 1088.55 304.769 1090.77 304.769C1092.99 304.769 1094.8 302.969 1094.8 300.741C1094.8 298.514 1093 296.723 1090.77 296.723Z"
            fill="white"
          />
          <path
            d="M1081.26 297.146C1079.05 297.146 1077.26 298.937 1077.26 301.144C1077.26 303.351 1079.05 305.142 1081.26 305.142C1083.47 305.142 1085.25 303.351 1085.25 301.144C1085.25 298.937 1083.47 297.146 1081.26 297.146Z"
            fill="white"
          />
          <path
            d="M1071.52 297.863C1069.33 297.863 1067.55 299.641 1067.55 301.827C1067.55 304.012 1069.33 305.791 1071.52 305.791C1073.7 305.791 1075.48 304.012 1075.48 301.827C1075.48 299.641 1073.7 297.863 1071.52 297.863Z"
            fill="white"
          />
          <path
            d="M1061.56 298.887C1059.39 298.887 1057.63 300.635 1057.63 302.812C1057.63 304.989 1059.39 306.725 1061.56 306.725C1063.72 306.725 1065.48 304.976 1065.48 302.812C1065.48 300.648 1063.72 298.887 1061.56 298.887Z"
            fill="white"
          />
          <path
            d="M1051.39 300.156C1049.25 300.156 1047.5 301.905 1047.5 304.048C1047.5 306.191 1049.25 307.939 1051.39 307.939C1053.53 307.939 1055.28 306.199 1055.28 304.048C1055.28 301.896 1053.54 300.156 1051.39 300.156Z"
            fill="white"
          />
          <path
            d="M1044.6 307.085C1045.42 305.115 1044.48 302.856 1042.51 302.039C1040.54 301.223 1038.28 302.159 1037.46 304.129C1036.65 306.1 1037.58 308.359 1039.55 309.175C1041.52 309.991 1043.78 309.056 1044.6 307.085Z"
            fill="white"
          />
          <path
            d="M1030.49 303.703C1028.37 303.703 1026.67 305.422 1026.67 307.535C1026.67 309.649 1028.37 311.363 1030.49 311.363C1032.6 311.363 1034.32 309.644 1034.32 307.535C1034.32 305.426 1032.6 303.703 1030.49 303.703Z"
            fill="white"
          />
          <path
            d="M1019.81 306.09C1017.73 306.09 1016.03 307.775 1016.03 309.858C1016.03 311.942 1017.73 313.627 1019.81 313.627C1021.89 313.627 1023.58 311.942 1023.58 309.858C1023.58 307.775 1021.89 306.09 1019.81 306.09Z"
            fill="white"
          />
          <path
            d="M1008.98 308.773C1006.91 308.773 1005.24 310.45 1005.24 312.512C1005.24 314.575 1006.91 316.247 1008.98 316.247C1011.04 316.247 1012.71 314.583 1012.71 312.512C1012.71 310.441 1011.04 308.773 1008.98 308.773Z"
            fill="white"
          />
          <path
            d="M998.015 311.791C995.973 311.791 994.318 313.446 994.318 315.487C994.318 317.529 995.973 319.192 998.015 319.192C1000.06 319.192 1001.71 317.537 1001.71 315.487C1001.71 313.438 1000.06 311.791 998.015 311.791Z"
            fill="white"
          />
          <path
            d="M986.964 315.225C984.944 315.225 983.311 316.871 983.311 318.878C983.311 320.886 984.944 322.532 986.964 322.532C988.984 322.532 990.606 320.898 990.606 318.878C990.606 316.858 988.972 315.225 986.964 315.225Z"
            fill="white"
          />
          <path
            d="M975.795 319.16C973.805 319.16 972.205 320.764 972.205 322.75C972.205 324.736 973.809 326.341 975.795 326.341C977.781 326.341 979.386 324.736 979.386 322.75C979.386 320.764 977.781 319.16 975.795 319.16Z"
            fill="white"
          />
          <path
            d="M964.574 323.645C962.618 323.645 961.026 325.236 961.026 327.192C961.026 329.149 962.618 330.732 964.574 330.732C966.53 330.732 968.122 329.149 968.122 327.192C968.122 325.236 966.53 323.645 964.574 323.645Z"
            fill="white"
          />
          <path
            d="M953.379 328.83C951.444 328.83 949.874 330.4 949.874 332.335C949.874 334.271 951.444 335.841 953.379 335.841C955.315 335.841 956.876 334.271 956.876 332.335C956.876 330.4 955.306 328.83 953.379 328.83Z"
            fill="white"
          />
          <path
            d="M942.198 334.803C940.292 334.803 938.743 336.343 938.743 338.257C938.743 340.171 940.292 341.712 942.198 341.712C944.103 341.712 945.652 340.158 945.652 338.257C945.652 336.356 944.111 334.803 942.198 334.803Z"
            fill="white"
          />
          <path
            d="M931.146 341.723C929.283 341.723 927.764 343.233 927.764 345.105C927.764 346.976 929.283 348.487 931.146 348.487C933.009 348.487 934.528 346.968 934.528 345.105C934.528 343.242 933.017 341.723 931.146 341.723Z"
            fill="white"
          />
          <path
            d="M920.291 349.748C918.458 349.748 916.973 351.238 916.973 353.067C916.973 354.896 918.462 356.385 920.291 356.385C922.12 356.385 923.61 354.896 923.61 353.067C923.61 351.238 922.12 349.748 920.291 349.748Z"
            fill="white"
          />
          <path
            d="M909.601 359.055C907.789 359.055 906.32 360.523 906.32 362.335C906.32 364.147 907.789 365.603 909.601 365.603C911.413 365.603 912.881 364.134 912.881 362.335C912.881 360.536 911.413 359.055 909.601 359.055Z"
            fill="white"
          />
          <path
            d="M899.266 370.104C897.488 370.104 896.041 371.551 896.041 373.341C896.041 375.132 897.488 376.567 899.266 376.567C901.044 376.567 902.504 375.12 902.504 373.341C902.504 371.563 901.057 370.104 899.266 370.104Z"
            fill="white"
          />
          <path
            d="M889.443 383.23C887.703 383.23 886.299 384.635 886.299 386.375C886.299 388.115 887.703 389.52 889.443 389.52C891.183 389.52 892.588 388.115 892.588 386.375C892.588 384.635 891.183 383.23 889.443 383.23Z"
            fill="white"
          />
          <path
            d="M880.374 398.789C878.668 398.789 877.293 400.173 877.293 401.87C877.293 403.568 878.668 404.959 880.374 404.959C882.08 404.959 883.463 403.576 883.463 401.87C883.463 400.164 882.08 398.789 880.374 398.789Z"
            fill="white"
          />
          <path
            d="M872.863 417.641C871.187 417.641 869.824 418.994 869.824 420.679C869.824 422.364 871.187 423.718 872.863 423.718C874.539 423.718 875.901 422.355 875.901 420.679C875.901 419.003 874.539 417.641 872.863 417.641Z"
            fill="white"
          />
          <path
            d="M867.919 440.598C866.277 440.598 864.944 441.93 864.944 443.573C864.944 445.215 866.277 446.547 867.919 446.547C869.562 446.547 870.894 445.215 870.894 443.573C870.894 441.93 869.562 440.598 867.919 440.598Z"
            fill="white"
          />
          <path
            d="M866.587 468.42C864.995 468.42 863.692 469.71 863.692 471.314C863.692 472.918 864.995 474.196 866.587 474.196C868.178 474.196 869.481 472.906 869.481 471.314C869.481 469.723 868.191 468.42 866.587 468.42Z"
            fill="white"
          />
          <path
            d="M869.387 501.443C867.826 501.443 866.565 502.712 866.565 504.274C866.565 505.836 867.826 507.105 869.387 507.105C870.949 507.105 872.218 505.836 872.218 504.274C872.218 502.712 870.949 501.443 869.387 501.443Z"
            fill="white"
          />
          <path
            d="M875.55 539.588C874.018 539.588 872.783 540.827 872.783 542.355C872.783 543.883 874.022 545.122 875.55 545.122C877.078 545.122 878.33 543.883 878.33 542.355C878.33 540.827 877.082 539.588 875.55 539.588Z"
            fill="white"
          />
          <path
            d="M897.599 618.951C896.152 618.951 894.977 620.127 894.977 621.574C894.977 623.021 896.152 624.209 897.599 624.209C899.046 624.209 900.222 623.034 900.222 621.574C900.222 620.114 899.046 618.951 897.599 618.951Z"
            fill="white"
          />
          <path
            d="M890.203 635.331C891.651 635.331 892.825 634.157 892.825 632.709C892.825 631.26 891.651 630.086 890.203 630.086C888.754 630.086 887.58 631.26 887.58 632.709C887.58 634.157 888.754 635.331 890.203 635.331Z"
            fill="white"
          />
          <path
            d="M881.885 640.684C880.45 640.684 879.271 641.851 879.271 643.298C879.271 644.745 880.446 645.912 881.885 645.912C883.323 645.912 884.499 644.745 884.499 643.298C884.499 641.851 883.332 640.684 881.885 640.684Z"
            fill="white"
          />
          <path
            d="M872.769 650.857C871.335 650.857 870.168 652.024 870.168 653.459C870.168 654.893 871.335 656.06 872.769 656.06C874.204 656.06 875.371 654.893 875.371 653.459C875.371 652.024 874.204 650.857 872.769 650.857Z"
            fill="white"
          />
          <path
            d="M862.797 660.311C861.362 660.311 860.195 661.478 860.195 662.912C860.195 664.346 861.362 665.513 862.797 665.513C864.231 665.513 865.39 664.346 865.39 662.912C865.39 661.478 864.223 660.311 862.797 660.311Z"
            fill="white"
          />
          <path
            d="M851.953 668.514C850.515 668.514 849.36 669.681 849.36 671.115C849.36 672.549 850.515 673.708 851.953 673.708C853.392 673.708 854.546 672.541 854.546 671.115C854.546 669.689 853.392 668.514 851.953 668.514Z"
            fill="white"
          />
          <path
            d="M840.453 675.393C839.027 675.393 837.86 676.547 837.86 677.986C837.86 679.424 839.027 680.566 840.453 680.566C841.879 680.566 843.034 679.411 843.034 677.986C843.034 676.56 841.879 675.393 840.453 675.393Z"
            fill="white"
          />
          <path
            d="M679.326 677.828C677.943 677.828 676.818 678.961 676.818 680.345C676.818 681.728 677.943 682.853 679.326 682.853C680.71 682.853 681.835 681.728 681.835 680.345C681.835 678.961 680.71 677.828 679.326 677.828Z"
            fill="white"
          />
          <path
            d="M665.182 674.963C663.799 674.963 662.683 676.087 662.683 677.471C662.683 678.854 663.794 679.971 665.182 679.971C666.57 679.971 667.69 678.859 667.69 677.471C667.69 676.083 666.566 674.963 665.182 674.963Z"
            fill="white"
          />
          <path
            d="M650.987 671.832C649.603 671.832 648.487 672.957 648.487 674.332C648.487 675.707 649.599 676.818 650.987 676.818C652.375 676.818 653.474 675.707 653.474 674.332C653.474 672.957 652.362 671.832 650.987 671.832Z"
            fill="white"
          />
          <path
            d="M636.699 668.322C635.324 668.322 634.212 669.426 634.212 670.801C634.212 672.176 635.324 673.287 636.699 673.287C638.074 673.287 639.186 672.176 639.186 670.801C639.186 669.426 638.074 668.322 636.699 668.322Z"
            fill="white"
          />
          <path
            d="M622.304 664.559C620.929 664.559 619.825 665.662 619.825 667.037C619.825 668.412 620.929 669.515 622.304 669.515C623.679 669.515 624.782 668.412 624.782 667.037C624.782 665.662 623.679 664.559 622.304 664.559Z"
            fill="white"
          />
          <path
            d="M607.879 661.09C606.504 661.09 605.4 662.193 605.4 663.568C605.4 664.943 606.504 666.047 607.879 666.047C609.254 666.047 610.357 664.935 610.357 663.568C610.357 662.202 609.245 661.09 607.879 661.09Z"
            fill="white"
          />
          <path
            d="M593.484 658.188C592.109 658.188 591.006 659.291 591.006 660.666C591.006 662.041 592.109 663.131 593.484 663.131C594.859 663.131 595.95 662.028 595.95 660.666C595.95 659.304 594.846 658.188 593.484 658.188Z"
            fill="white"
          />
          <path
            d="M579.097 655.68C577.735 655.68 576.632 656.783 576.632 658.145C576.632 659.508 577.735 660.624 579.097 660.624C580.46 660.624 581.563 659.512 581.563 658.145C581.563 656.779 580.46 655.68 579.097 655.68Z"
            fill="white"
          />
          <path
            d="M564.736 653.74C563.374 653.74 562.271 654.852 562.271 656.206C562.271 657.56 563.374 658.671 564.736 658.671C566.098 658.671 567.202 657.568 567.202 656.206C567.202 654.844 566.098 653.74 564.736 653.74Z"
            fill="white"
          />
          <path
            d="M550.486 652.607C549.124 652.607 548.021 653.711 548.021 655.073C548.021 656.435 549.124 657.53 550.486 657.53C551.848 657.53 552.952 656.427 552.952 655.073C552.952 653.719 551.848 652.607 550.486 652.607Z"
            fill="white"
          />
          <path
            d="M536.29 651.84C534.936 651.84 533.833 652.943 533.833 654.297C533.833 655.651 534.936 656.754 536.29 656.754C537.644 656.754 538.747 655.659 538.747 654.297C538.747 652.935 537.644 651.84 536.29 651.84Z"
            fill="white"
          />
          <path
            d="M522.096 651.359C520.734 651.359 519.639 652.463 519.639 653.817C519.639 655.17 520.734 656.274 522.096 656.274C523.458 656.274 524.54 655.17 524.54 653.817C524.54 652.463 523.45 651.359 522.096 651.359Z"
            fill="white"
          />
          <path
            d="M507.922 651.316C506.56 651.316 505.465 652.407 505.465 653.761C505.465 655.115 506.556 656.218 507.922 656.218C509.288 656.218 510.366 655.123 510.366 653.761C510.366 652.399 509.272 651.316 507.922 651.316Z"
            fill="white"
          />
          <path
            d="M493.701 651.359C492.348 651.359 491.244 652.463 491.244 653.817C491.244 655.17 492.348 656.282 493.701 656.282C495.055 656.282 496.167 655.179 496.167 653.817C496.167 652.454 495.064 651.359 493.701 651.359Z"
            fill="white"
          />
          <path
            d="M479.369 651.311C478.015 651.311 476.912 652.414 476.912 653.768C476.912 655.121 478.015 656.225 479.369 656.225C480.723 656.225 481.826 655.121 481.826 653.768C481.826 652.414 480.723 651.311 479.369 651.311Z"
            fill="white"
          />
          <path
            d="M464.86 651.232C463.507 651.232 462.403 652.336 462.403 653.69C462.403 655.043 463.507 656.147 464.86 656.147C466.214 656.147 467.318 655.043 467.318 653.69C467.318 652.336 466.214 651.232 464.86 651.232Z"
            fill="white"
          />
          <path
            d="M450.148 650.965C448.794 650.965 447.69 652.055 447.69 653.409C447.69 654.763 448.794 655.854 450.148 655.854C451.501 655.854 452.592 654.759 452.592 653.409C452.592 652.06 451.497 650.965 450.148 650.965Z"
            fill="white"
          />
          <path
            d="M435.086 650.186C433.732 650.186 432.642 651.276 432.642 652.63C432.642 653.984 433.732 655.087 435.086 655.087C436.44 655.087 437.543 653.984 437.543 652.63C437.543 651.276 436.44 650.186 435.086 650.186Z"
            fill="white"
          />
          <path
            d="M419.597 648.953C418.243 648.953 417.152 650.057 417.152 651.41C417.152 652.764 418.247 653.855 419.597 653.855C420.946 653.855 422.041 652.751 422.041 651.41C422.041 650.069 420.946 648.953 419.597 648.953Z"
            fill="white"
          />
          <path
            d="M403.602 647.146C402.248 647.146 401.157 648.237 401.157 649.591C401.157 650.945 402.248 652.035 403.602 652.035C404.955 652.035 406.046 650.94 406.046 649.591C406.046 648.241 404.951 647.146 403.602 647.146Z"
            fill="white"
          />
          <path
            d="M386.958 644.377C385.596 644.377 384.501 645.472 384.501 646.834C384.501 648.196 385.592 649.278 386.958 649.278C388.325 649.278 389.403 648.188 389.403 646.834C389.403 645.48 388.308 644.377 386.958 644.377Z"
            fill="white"
          />
          <path
            d="M369.546 640.785C368.192 640.785 367.102 641.889 367.102 643.242C367.102 644.596 368.196 645.687 369.546 645.687C370.895 645.687 372.003 644.592 372.003 643.242C372.003 641.893 370.9 640.785 369.546 640.785Z"
            fill="white"
          />
          <path
            d="M351.26 636.234C349.906 636.234 348.815 637.338 348.815 638.679C348.815 640.02 349.91 641.123 351.26 641.123C352.609 641.123 353.704 640.028 353.704 638.679C353.704 637.329 352.609 636.234 351.26 636.234Z"
            fill="white"
          />
          <path
            d="M331.912 630.324C330.558 630.324 329.468 631.419 329.468 632.769C329.468 634.118 330.563 635.213 331.912 635.213C333.262 635.213 334.357 634.118 334.357 632.769C334.357 631.419 333.262 630.324 331.912 630.324Z"
            fill="white"
          />
          <path
            d="M311.368 623.059C310.014 623.059 308.924 624.162 308.924 625.516C308.924 626.869 310.014 627.96 311.368 627.96C312.722 627.96 313.825 626.869 313.825 625.516C313.825 624.162 312.73 623.059 311.368 623.059Z"
            fill="white"
          />
          <path
            d="M289.457 614.359C288.103 614.359 287 615.463 287 616.816C287 618.17 288.103 619.274 289.457 619.274C290.811 619.274 291.914 618.17 291.914 616.816C291.914 615.463 290.811 614.359 289.457 614.359Z"
            fill="white"
          />
          <path
            d="M266.02 604.326C264.666 604.326 263.562 605.43 263.562 606.783C263.562 608.137 264.666 609.228 266.02 609.228C267.373 609.228 268.477 608.133 268.477 606.783C268.477 605.434 267.373 604.326 266.02 604.326Z"
            fill="white"
          />
          <path
            d="M255.499 596.748C254.082 596.748 252.94 597.894 252.94 599.307C252.94 600.72 254.086 601.857 255.499 601.857C256.913 601.857 258.05 600.712 258.05 599.307C258.05 597.902 256.904 596.748 255.499 596.748Z"
            fill="white"
          />
          <path
            d="M245.548 589.559C244.101 589.559 242.934 590.734 242.934 592.181C242.934 593.628 244.101 594.795 245.548 594.795C246.995 594.795 248.162 593.62 248.162 592.181C248.162 590.743 246.995 589.559 245.548 589.559Z"
            fill="white"
          />
          <path
            d="M236.691 582.875C235.214 582.875 234.018 584.072 234.018 585.549C234.018 587.025 235.214 588.222 236.691 588.222C238.168 588.222 239.365 587.025 239.365 585.549C239.365 584.072 238.168 582.875 236.691 582.875Z"
            fill="white"
          />
          <path
            d="M229.175 576.883C227.664 576.883 226.446 578.101 226.446 579.612C226.446 581.122 227.664 582.349 229.175 582.349C230.686 582.349 231.912 581.131 231.912 579.612C231.912 578.092 230.686 576.883 229.175 576.883Z"
            fill="white"
          />
          <path
            d="M223.034 571.541C221.472 571.541 220.212 572.801 220.212 574.363C220.212 575.925 221.472 577.194 223.034 577.194C224.596 577.194 225.865 575.925 225.865 574.363C225.865 572.801 224.596 571.541 223.034 571.541Z"
            fill="white"
          />
          <path
            d="M218.163 566.879C216.571 566.879 215.281 568.169 215.281 569.76C215.281 571.352 216.571 572.642 218.163 572.642C219.754 572.642 221.057 571.352 221.057 569.76C221.057 568.169 219.754 566.879 218.163 566.879Z"
            fill="white"
          />
          <path
            d="M214.292 562.725C212.671 562.725 211.347 564.036 211.347 565.661C211.347 567.287 212.671 568.606 214.292 568.606C215.913 568.606 217.237 567.295 217.237 565.661C217.237 564.027 215.913 562.725 214.292 562.725Z"
            fill="white"
          />
          <path
            d="M211.126 558.936C209.462 558.936 208.117 560.277 208.117 561.944C208.117 563.612 209.458 564.94 211.126 564.94C212.794 564.94 214.122 563.599 214.122 561.944C214.122 560.289 212.781 558.936 211.126 558.936Z"
            fill="white"
          />
          <path
            d="M208.432 555.389C206.726 555.389 205.351 556.772 205.351 558.478C205.351 560.184 206.726 561.568 208.432 561.568C210.138 561.568 211.521 560.184 211.521 558.478C211.521 556.772 210.138 555.389 208.432 555.389Z"
            fill="white"
          />
          <path
            d="M205.975 552.006C204.247 552.006 202.843 553.411 202.843 555.15C202.843 556.89 204.247 558.282 205.975 558.282C207.702 558.282 209.119 556.878 209.119 555.15C209.119 553.423 207.715 552.006 205.975 552.006Z"
            fill="white"
          />
          <path
            d="M203.458 548.572C201.689 548.572 200.263 549.998 200.263 551.768C200.263 553.537 201.689 554.963 203.458 554.963C205.228 554.963 206.654 553.529 206.654 551.768C206.654 550.007 205.215 548.572 203.458 548.572Z"
            fill="white"
          />
          <path
            d="M200.729 545.012C198.938 545.012 197.491 546.459 197.491 548.25C197.491 550.041 198.938 551.488 200.729 551.488C202.52 551.488 203.976 550.041 203.976 548.25C203.976 546.459 202.52 545.012 200.729 545.012Z"
            fill="white"
          />
          <path
            d="M197.742 541.223C195.908 541.223 194.432 542.7 194.432 544.533C194.432 546.366 195.908 547.851 197.742 547.851C199.575 547.851 201.06 546.362 201.06 544.533C201.06 542.704 199.571 541.223 197.742 541.223Z"
            fill="white"
          />
          <path
            d="M194.466 537.225C192.603 537.225 191.104 538.735 191.104 540.586C191.104 542.436 192.603 543.947 194.466 543.947C196.329 543.947 197.827 542.449 197.827 540.586C197.827 538.723 196.316 537.225 194.466 537.225Z"
            fill="white"
          />
          <path
            d="M194.03 537.64C194.747 535.898 193.917 533.904 192.174 533.186C190.432 532.469 188.437 533.3 187.72 535.042C187.003 536.785 187.833 538.779 189.576 539.496C191.318 540.214 193.312 539.383 194.03 537.64Z"
            fill="white"
          />
          <path
            d="M187.571 535.332C189.462 535.025 190.745 533.244 190.438 531.354C190.132 529.464 188.351 528.181 186.46 528.487C184.57 528.794 183.287 530.575 183.594 532.465C183.9 534.355 185.681 535.639 187.571 535.332Z"
            fill="white"
          />
          <path
            d="M182.838 523.693C180.89 523.693 179.312 525.276 179.312 527.224C179.312 529.172 180.894 530.751 182.838 530.751C184.782 530.751 186.356 529.168 186.356 527.224C186.356 525.28 184.786 523.693 182.838 523.693Z"
            fill="white"
          />
          <path
            d="M178.436 518.773C176.471 518.773 174.867 520.378 174.867 522.342C174.867 524.307 176.471 525.911 178.436 525.911C180.401 525.911 182.005 524.307 182.005 522.342C182.005 520.378 180.401 518.773 178.436 518.773Z"
            fill="white"
          />
          <path
            d="M173.794 513.707C171.808 513.707 170.204 515.311 170.204 517.297C170.204 519.283 171.808 520.9 173.794 520.9C175.78 520.9 177.397 519.288 177.397 517.297C177.397 515.307 175.785 513.707 173.794 513.707Z"
            fill="white"
          />
          <path
            d="M168.922 508.482C166.915 508.482 165.281 510.116 165.281 512.124C165.281 514.131 166.915 515.765 168.922 515.765C170.93 515.765 172.564 514.131 172.564 512.124C172.564 510.116 170.93 508.482 168.922 508.482Z"
            fill="white"
          />
          <path
            d="M163.805 503.131C161.763 503.131 160.108 504.786 160.108 506.836C160.108 508.885 161.763 510.532 163.805 510.532C165.846 510.532 167.509 508.877 167.509 506.836C167.509 504.794 165.854 503.131 163.805 503.131Z"
            fill="white"
          />
          <path
            d="M158.432 497.738C156.369 497.738 154.697 499.415 154.697 501.473C154.697 503.531 156.374 505.207 158.432 505.207C160.49 505.207 162.166 503.531 162.166 501.473C162.166 499.415 160.49 497.738 158.432 497.738Z"
            fill="white"
          />
          <path
            d="M152.77 492.338C150.699 492.338 149.015 494.014 149.015 496.094C149.015 498.173 150.699 499.862 152.77 499.862C154.841 499.862 156.539 498.177 156.539 496.094C156.539 494.01 154.854 492.338 152.77 492.338Z"
            fill="white"
          />
          <path
            d="M146.808 486.965C144.716 486.965 143.019 488.662 143.019 490.763C143.019 492.864 144.716 494.553 146.808 494.553C148.9 494.553 150.598 492.855 150.598 490.763C150.598 488.671 148.9 486.965 146.808 486.965Z"
            fill="white"
          />
          <path
            d="M140.502 481.689C138.389 481.689 136.67 483.408 136.67 485.53C136.67 487.652 138.389 489.362 140.502 489.362C142.615 489.362 144.343 487.643 144.343 485.53C144.343 483.417 142.624 481.689 140.502 481.689Z"
            fill="white"
          />
          <path
            d="M133.826 476.568C131.692 476.568 129.956 478.296 129.956 480.43C129.956 482.565 131.692 484.3 133.826 484.3C135.961 484.3 137.688 482.561 137.688 480.43C137.688 478.3 135.961 476.568 133.826 476.568Z"
            fill="white"
          />
          <path
            d="M126.752 471.617C124.609 471.617 122.86 473.357 122.86 475.509C122.86 477.66 124.609 479.4 126.752 479.4C128.895 479.4 130.643 477.665 130.643 475.509C130.643 473.353 128.903 471.617 126.752 471.617Z"
            fill="white"
          />
          <path
            d="M119.288 466.744C117.123 466.744 115.375 468.505 115.375 470.67C115.375 472.834 117.123 474.582 119.288 474.582C121.452 474.582 123.213 472.834 123.213 470.67C123.213 468.505 121.456 466.744 119.288 466.744Z"
            fill="white"
          />
          <path
            d="M111.483 461.895C109.298 461.895 107.528 463.664 107.528 465.85C107.528 468.035 109.298 469.792 111.483 469.792C113.669 469.792 115.426 468.022 115.426 465.85C115.426 463.677 113.656 461.895 111.483 461.895Z"
            fill="white"
          />
          <path
            d="M103.374 457.057C101.18 457.057 99.3887 458.835 99.3887 461.033C99.3887 463.231 101.18 465.009 103.374 465.009C105.568 465.009 107.35 463.231 107.35 461.033C107.35 458.835 105.572 457.057 103.374 457.057Z"
            fill="white"
          />
          <path
            d="M95.0093 452.234C92.8026 452.234 91.0117 454.025 91.0117 456.219C91.0117 458.413 92.8026 460.217 95.0093 460.217C97.2161 460.217 99.0069 458.426 99.0069 456.219C99.0069 454.013 97.2161 452.234 95.0093 452.234Z"
            fill="white"
          />
          <path
            d="M86.4202 447.355C84.2134 447.355 82.4141 449.155 82.4141 451.374C82.4141 453.594 84.2134 455.38 86.4202 455.38C88.6269 455.38 90.439 453.581 90.439 451.374C90.439 449.168 88.6396 447.355 86.4202 447.355Z"
            fill="white"
          />
          <path
            d="M77.6699 442.297C75.4419 442.297 73.6426 444.109 73.6426 446.337C73.6426 448.565 75.4419 450.377 77.6699 450.377C79.8979 450.377 81.7099 448.565 81.7099 446.337C81.7099 444.109 79.8979 442.297 77.6699 442.297Z"
            fill="white"
          />
          <path
            d="M68.7783 436.959C66.5504 436.959 64.7383 438.771 64.7383 441.007C64.7383 443.244 66.5504 445.056 68.7783 445.056C71.0063 445.056 72.8269 443.244 72.8269 441.007C72.8269 438.771 71.0148 436.959 68.7783 436.959Z"
            fill="white"
          />
          <path
            d="M59.7865 431.213C57.5501 431.213 55.7295 433.033 55.7295 435.27C55.7295 437.506 57.5501 439.327 59.7865 439.327C62.023 439.327 63.8435 437.515 63.8435 435.27C63.8435 433.025 62.0315 431.213 59.7865 431.213Z"
            fill="white"
          />
          <path
            d="M50.7211 424.977C48.4719 424.977 46.6514 426.797 46.6514 429.046C46.6514 431.296 48.4719 433.116 50.7211 433.116C52.9703 433.116 54.7909 431.296 54.7909 429.046C54.7909 426.797 52.9703 424.977 50.7211 424.977Z"
            fill="white"
          />
          <path
            d="M41.6274 418.15C39.3782 418.15 37.5576 419.971 37.5576 422.229C37.5576 424.486 39.3782 426.298 41.6274 426.298C43.8766 426.298 45.7056 424.478 45.7056 422.229C45.7056 419.979 43.885 418.15 41.6274 418.15Z"
            fill="white"
          />
          <path
            d="M32.592 410.561C30.3343 410.561 28.501 412.381 28.501 414.639C28.501 416.896 30.3343 418.73 32.592 418.73C34.8496 418.73 36.6702 416.896 36.6702 414.639C36.6702 412.381 34.8369 410.561 32.592 410.561Z"
            fill="white"
          />
          <path
            d="M23.7355 402.078C21.4778 402.078 19.6445 403.899 19.6445 406.156C19.6445 408.414 21.4778 410.235 23.7355 410.235C25.9932 410.235 27.8137 408.414 27.8137 406.156C27.8137 403.899 25.9804 402.078 23.7355 402.078Z"
            fill="white"
          />
          <path
            d="M15.1463 392.732C12.8887 392.732 11.0469 394.566 11.0469 396.823C11.0469 399.081 12.8887 400.923 15.1463 400.923C17.404 400.923 19.2373 399.09 19.2373 396.823C19.2373 394.557 17.404 392.732 15.1463 392.732Z"
            fill="white"
          />
          <path
            d="M6.88394 382.814C4.62627 382.814 2.79297 384.648 2.79297 386.905C2.79297 389.163 4.62627 390.996 6.88394 390.996C9.14162 390.996 10.9749 389.163 10.9749 386.905C10.9749 384.648 9.14162 382.814 6.88394 382.814Z"
            fill="white"
          />
          <path
            d="M-1.07895 372.678C-3.33662 372.678 -5.16992 374.511 -5.16992 376.769C-5.16992 379.026 -3.33662 380.868 -1.07895 380.868C1.17873 380.868 3.02052 379.035 3.02052 376.769C3.02052 374.503 1.17873 372.678 -1.07895 372.678Z"
            fill="white"
          />
          <path
            d="M1.09511 329.852C-1.15408 329.852 -2.96191 331.664 -2.96191 333.909C-2.96191 336.154 -1.14983 337.966 1.09511 337.966C3.34005 337.966 5.15638 336.154 5.15638 333.909C5.15638 331.664 3.33581 329.852 1.09511 329.852Z"
            fill="white"
          />
          <path
            d="M7.15502 320.742C4.91856 320.742 3.09375 322.554 3.09375 324.799C3.09375 327.044 4.91432 328.848 7.15502 328.848C9.39572 328.848 11.212 327.036 11.212 324.799C11.212 322.563 9.39996 320.742 7.15502 320.742Z"
            fill="white"
          />
          <path
            d="M13.3897 310.865C11.1617 310.865 9.34961 312.677 9.34961 314.905C9.34961 317.133 11.1617 318.945 13.3897 318.945C15.6176 318.945 17.417 317.133 17.417 314.905C17.417 312.677 15.6176 310.865 13.3897 310.865Z"
            fill="white"
          />
          <path
            d="M19.8528 300.143C17.6376 300.143 15.834 301.942 15.834 304.17C15.834 306.398 17.6333 308.189 19.8528 308.189C22.0723 308.189 23.8716 306.389 23.8716 304.17C23.8716 301.95 22.0723 300.143 19.8528 300.143Z"
            fill="white"
          />
          <path
            d="M26.5745 288.633C24.3592 288.633 22.5684 290.424 22.5684 292.639C22.5684 294.854 24.3592 296.645 26.5745 296.645C28.7897 296.645 30.5806 294.846 30.5806 292.639C30.5806 290.432 28.7812 288.633 26.5745 288.633Z"
            fill="white"
          />
          <path
            d="M33.5601 276.402C31.3533 276.402 29.5752 278.193 29.5752 280.387C29.5752 282.581 31.3533 284.385 33.5601 284.385C35.7668 284.385 37.545 282.594 37.545 280.387C37.545 278.18 35.7541 276.402 33.5601 276.402Z"
            fill="white"
          />
          <path
            d="M40.8116 263.498C38.6261 263.498 36.8564 265.276 36.8564 267.453C36.8564 269.63 38.6261 271.417 40.8116 271.417C42.9972 271.417 44.7668 269.639 44.7668 267.453C44.7668 265.268 42.9972 263.498 40.8116 263.498Z"
            fill="white"
          />
          <path
            d="M48.1921 250.293C46.0278 250.293 44.2666 252.054 44.2666 254.227C44.2666 256.4 46.0278 258.152 48.1921 258.152C50.3564 258.152 52.1175 256.391 52.1175 254.227C52.1175 252.063 50.3691 250.293 48.1921 250.293Z"
            fill="white"
          />
          <path
            d="M55.5634 237.115C53.4076 237.115 51.6592 238.876 51.6592 241.028C51.6592 243.18 53.4076 244.941 55.5634 244.941C57.7193 244.941 59.4762 243.192 59.4762 241.028C59.4762 238.864 57.7277 237.115 55.5634 237.115Z"
            fill="white"
          />
          <path
            d="M62.7863 224.346C60.6433 224.346 58.9033 226.081 58.9033 228.216C58.9033 230.351 60.6433 232.099 62.7863 232.099C64.9294 232.099 66.6567 230.363 66.6567 228.216C66.6567 226.069 64.9167 224.346 62.7863 224.346Z"
            fill="white"
          />
          <path
            d="M69.7244 212.207C67.6025 212.207 65.8838 213.926 65.8838 216.048C65.8838 218.17 67.6025 219.88 69.7244 219.88C71.8463 219.88 73.565 218.161 73.565 216.048C73.565 213.934 71.8378 212.207 69.7244 212.207Z"
            fill="white"
          />
          <path
            d="M76.3451 200.887C74.2444 200.887 72.5342 202.593 72.5342 204.698C72.5342 206.803 74.2402 208.508 76.3451 208.508C78.45 208.508 80.156 206.803 80.156 204.698C80.156 202.593 78.45 200.887 76.3451 200.887Z"
            fill="white"
          />
          <path
            d="M82.651 198.127C84.7369 198.127 86.4279 196.438 86.4279 194.355C86.4279 192.271 84.7369 190.582 82.651 190.582C80.565 190.582 78.874 192.271 78.874 194.355C78.874 196.438 80.565 198.127 82.651 198.127Z"
            fill="white"
          />
          <path
            d="M88.5968 181.475C86.5259 181.475 84.8496 183.151 84.8496 185.222C84.8496 187.293 86.5259 188.969 88.5968 188.969C90.6678 188.969 92.3313 187.293 92.3313 185.222C92.3313 183.151 90.6551 181.475 88.5968 181.475Z"
            fill="white"
          />
          <path
            d="M94.1641 173.438C92.1228 173.438 90.4678 175.093 90.4678 177.134C90.4678 179.175 92.1228 180.83 94.1641 180.83C96.2053 180.83 97.8604 179.175 97.8604 177.134C97.8604 175.093 96.2053 173.438 94.1641 173.438Z"
            fill="white"
          />
          <path
            d="M99.4019 166.227C97.3946 166.227 95.7607 167.86 95.7607 169.876C95.7607 171.892 97.3946 173.526 99.4019 173.526C101.409 173.526 103.056 171.892 103.056 169.876C103.056 167.86 101.422 166.227 99.4019 166.227Z"
            fill="white"
          />
          <path
            d="M104.341 159.598C102.342 159.598 100.721 161.223 100.721 163.218C100.721 165.212 102.346 166.829 104.341 166.829C106.335 166.829 107.952 165.216 107.952 163.218C107.952 161.219 106.339 159.598 104.341 159.598Z"
            fill="white"
          />
          <path
            d="M108.933 153.438C106.956 153.438 105.364 155.042 105.364 157.011C105.364 158.98 106.956 160.584 108.933 160.584C110.911 160.584 112.515 158.98 112.515 157.011C112.515 155.042 110.911 153.438 108.933 153.438Z"
            fill="white"
          />
          <path
            d="M113.147 147.605C111.199 147.605 109.629 149.176 109.629 151.124C109.629 153.071 111.199 154.637 113.147 154.637C115.095 154.637 116.652 153.059 116.652 151.124C116.652 149.188 115.082 147.605 113.147 147.605Z"
            fill="white"
          />
          <path
            d="M116.915 141.961C115.001 141.961 113.448 143.518 113.448 145.432C113.448 147.346 114.997 148.899 116.915 148.899C118.834 148.899 120.383 147.346 120.383 145.432C120.383 143.518 118.834 141.961 116.915 141.961Z"
            fill="white"
          />
          <path
            d="M120.225 136.428C118.32 136.428 116.792 137.968 116.792 139.861C116.792 141.754 118.324 143.294 120.225 143.294C122.126 143.294 123.65 141.754 123.65 139.861C123.65 137.968 122.118 136.428 120.225 136.428Z"
            fill="white"
          />
          <path
            d="M123.078 131.08C121.202 131.08 119.683 132.591 119.683 134.462C119.683 136.334 121.202 137.845 123.078 137.845C124.953 137.845 126.46 136.334 126.46 134.462C126.46 132.591 124.941 131.08 123.078 131.08Z"
            fill="white"
          />
          <path
            d="M125.513 125.959C123.68 125.959 122.194 127.449 122.194 129.278C122.194 131.107 123.684 132.588 125.513 132.588C127.342 132.588 128.823 131.107 128.823 129.278C128.823 127.449 127.346 125.959 125.513 125.959Z"
            fill="white"
          />
          <path
            d="M127.591 121.076C125.792 121.076 124.332 122.545 124.332 124.344C124.332 126.143 125.788 127.612 127.591 127.612C129.395 127.612 130.859 126.143 130.859 124.344C130.859 122.545 129.403 121.076 127.591 121.076Z"
            fill="white"
          />
          <path
            d="M130.13 122.819C131.853 122.413 132.919 120.687 132.513 118.965C132.106 117.242 130.381 116.176 128.658 116.582C126.936 116.989 125.87 118.714 126.276 120.437C126.683 122.159 128.408 123.226 130.13 122.819Z"
            fill="white"
          />
          <path
            d="M130.959 112.129C129.21 112.129 127.793 113.546 127.793 115.286C127.793 117.026 129.21 118.444 130.959 118.444C132.707 118.444 134.112 117.026 134.112 115.286C134.112 113.546 132.694 112.129 130.959 112.129Z"
            fill="white"
          />
          <path
            d="M132.825 114.081C134.5 113.809 135.637 112.231 135.365 110.556C135.094 108.881 133.515 107.744 131.84 108.016C130.165 108.287 129.028 109.866 129.3 111.541C129.572 113.216 131.15 114.353 132.825 114.081Z"
            fill="white"
          />
          <path
            d="M136.472 107.828C136.969 106.237 136.083 104.545 134.492 104.048C132.901 103.551 131.209 104.438 130.712 106.028C130.215 107.619 131.102 109.311 132.693 109.808C134.283 110.305 135.975 109.418 136.472 107.828Z"
            fill="white"
          />
          <path
            d="M134.765 99.8379C133.139 99.8379 131.807 101.166 131.807 102.8C131.807 104.434 133.139 105.758 134.765 105.758C136.39 105.758 137.731 104.434 137.731 102.8C137.731 101.166 136.398 99.8379 134.765 99.8379Z"
            fill="white"
          />
          <path
            d="M135.919 95.6816C134.327 95.6816 133.024 96.9717 133.024 98.5759C133.024 100.18 134.327 101.47 135.919 101.47C137.51 101.47 138.813 100.167 138.813 98.5759C138.813 96.9845 137.523 95.6816 135.919 95.6816Z"
            fill="white"
          />
          <path
            d="M137.108 91.3203C135.567 91.3203 134.307 92.5807 134.307 94.1212C134.307 95.6617 135.567 96.9263 137.108 96.9263C138.648 96.9263 139.908 95.6744 139.908 94.1212C139.908 92.568 138.661 91.3203 137.108 91.3203Z"
            fill="white"
          />
          <path
            d="M138.418 86.5547C136.907 86.5547 135.681 87.7811 135.681 89.2961C135.681 90.8112 136.907 92.0376 138.418 92.0376C139.929 92.0376 141.164 90.8112 141.164 89.2961C141.164 87.7811 139.937 86.5547 138.418 86.5547Z"
            fill="white"
          />
          <path
            d="M139.988 81.2168C138.511 81.2168 137.314 82.422 137.314 83.9031C137.314 85.3842 138.511 86.5766 139.988 86.5766C141.465 86.5766 142.662 85.3799 142.662 83.9031C142.662 82.4263 141.465 81.2168 139.988 81.2168Z"
            fill="white"
          />
          <path
            d="M142.021 74.9492C140.574 74.9492 139.407 76.1247 139.407 77.5719C139.407 79.019 140.574 80.1903 142.021 80.1903C143.468 80.1903 144.644 79.019 144.644 77.5719C144.644 76.1247 143.468 74.9492 142.021 74.9492Z"
            fill="white"
          />
          <path
            d="M144.894 67.3945C143.498 67.3945 142.378 68.5276 142.378 69.9238C142.378 71.32 143.503 72.4446 144.894 72.4446C146.286 72.4446 147.424 71.32 147.424 69.9238C147.424 68.5276 146.291 67.3945 144.894 67.3945Z"
            fill="white"
          />
          <path
            d="M149.223 57.9531C147.869 57.9531 146.778 59.0438 146.778 60.4018C146.778 61.7598 147.873 62.8547 149.223 62.8547C150.572 62.8547 151.68 61.7598 151.68 60.4018C151.68 59.0438 150.589 57.9531 149.223 57.9531Z"
            fill="white"
          />
          <path
            d="M156.081 45.8262C154.761 45.8262 153.688 46.8998 153.688 48.2196C153.688 49.5395 154.761 50.6046 156.081 50.6046C157.401 50.6046 158.466 49.5395 158.466 48.2196C158.466 46.8998 157.392 45.8262 156.081 45.8262Z"
            fill="white"
          />
          <path
            d="M166.508 30.2285C165.226 30.2285 164.178 31.2682 164.178 32.5583C164.178 33.8484 165.23 34.8797 166.508 34.8797C167.785 34.8797 168.837 33.8399 168.837 32.5583C168.837 31.2767 167.798 30.2285 166.508 30.2285Z"
            fill="white"
          />
          <path
            d="M181.704 10.002C180.478 10.002 179.489 10.9907 179.489 12.2172C179.489 13.4436 180.478 14.4409 181.704 14.4409C182.931 14.4409 183.932 13.4479 183.932 12.2172C183.932 10.9865 182.935 10.002 181.704 10.002Z"
            fill="white"
          />
          <path
            d="M922.829 -2.94531C921.267 -2.94531 919.998 -1.68068 919.998 -0.114732C919.998 1.45121 921.267 2.71585 922.829 2.71585C924.39 2.71585 925.659 1.44697 925.659 -0.114732C925.659 -1.67643 924.39 -2.94531 922.829 -2.94531Z"
            fill="white"
          />
          <path
            d="M930.467 7.62109C928.863 7.62109 927.564 8.91544 927.564 10.5153C927.564 12.1152 928.867 13.4096 930.467 13.4096C932.067 13.4096 933.361 12.1195 933.361 10.5153C933.361 8.91119 932.059 7.62109 930.467 7.62109Z"
            fill="white"
          />
          <path
            d="M938.038 18.1641C936.404 18.1641 935.08 19.4839 935.08 21.1177C935.08 22.7516 936.4 24.0671 938.038 24.0671C939.676 24.0671 940.992 22.7431 940.992 21.1177C940.992 19.4924 939.672 18.1641 938.038 18.1641Z"
            fill="white"
          />
          <path
            d="M945.508 28.8242C943.844 28.8242 942.499 30.1737 942.499 31.833C942.499 33.4923 943.84 34.8503 945.508 34.8503C947.176 34.8503 948.517 33.4966 948.517 31.833C948.517 30.1695 947.176 28.8242 945.508 28.8242Z"
            fill="white"
          />
          <path
            d="M952.9 39.5293C951.194 39.5293 949.798 40.917 949.798 42.6315C949.798 44.346 951.194 45.7337 952.9 45.7337C954.606 45.7337 956.002 44.3502 956.002 42.6315C956.002 40.9128 954.619 39.5293 952.9 39.5293Z"
            fill="white"
          />
          <path
            d="M960.237 50.3125C958.497 50.3125 957.084 51.7299 957.084 53.4656C957.084 55.2013 958.501 56.6187 960.237 56.6187C961.973 56.6187 963.39 55.2098 963.39 53.4656C963.39 51.7214 961.973 50.3125 960.237 50.3125Z"
            fill="white"
          />
          <path
            d="M967.553 61.0762C965.774 61.0762 964.336 62.5106 964.336 64.2802C964.336 66.0498 965.77 67.497 967.553 67.497C969.335 67.497 970.757 66.0583 970.757 64.2802C970.757 62.5021 969.318 61.0762 967.553 61.0762Z"
            fill="white"
          />
          <path
            d="M974.841 71.8262C973.042 71.8262 971.573 73.2818 971.573 75.0854C971.573 76.889 973.042 78.3488 974.841 78.3488C976.64 78.3488 978.1 76.8847 978.1 75.0854C978.1 73.286 976.645 71.8262 974.841 71.8262Z"
            fill="white"
          />
          <path
            d="M982.083 82.5664C980.228 82.5664 978.73 84.0687 978.73 85.919C978.73 87.7692 980.228 89.2715 982.083 89.2715C983.938 89.2715 985.423 87.7735 985.423 85.919C985.423 84.0645 983.925 82.5664 982.083 82.5664Z"
            fill="white"
          />
          <path
            d="M989.274 93.4219C987.402 93.4219 985.883 94.9411 985.883 96.8084C985.883 98.6756 987.402 100.195 989.274 100.195C991.145 100.195 992.669 98.6799 992.669 96.8084C992.669 94.9369 991.149 93.4219 989.274 93.4219Z"
            fill="white"
          />
          <path
            d="M996.415 104.354C994.522 104.354 992.981 105.89 992.981 107.787C992.981 109.684 994.522 111.22 996.415 111.22C998.307 111.22 999.861 109.679 999.861 107.787C999.861 105.894 998.32 104.354 996.415 104.354Z"
            fill="white"
          />
          <path
            d="M1004.08 122.236C1005.98 121.927 1007.27 120.135 1006.97 118.234C1006.66 116.332 1004.87 115.041 1002.96 115.349C1001.06 115.658 999.771 117.45 1000.08 119.351C1000.39 121.253 1002.18 122.545 1004.08 122.236Z"
            fill="white"
          />
          <path
            d="M1010.59 126.445C1008.62 126.445 1007.03 128.037 1007.03 130.006C1007.03 131.975 1008.62 133.566 1010.59 133.566C1012.56 133.566 1014.15 131.975 1014.15 130.006C1014.15 128.037 1012.56 126.445 1010.59 126.445Z"
            fill="white"
          />
          <path
            d="M1017.6 137.738C1015.61 137.738 1014 139.351 1014 141.35C1014 143.349 1015.61 144.953 1017.6 144.953C1019.58 144.953 1021.21 143.34 1021.21 141.35C1021.21 139.359 1019.6 137.738 1017.6 137.738Z"
            fill="white"
          />
          <path
            d="M1024.56 149.252C1022.54 149.252 1020.9 150.886 1020.9 152.906C1020.9 154.926 1022.54 156.56 1024.56 156.56C1026.58 156.56 1028.21 154.922 1028.21 152.906C1028.21 150.89 1026.58 149.252 1024.56 149.252Z"
            fill="white"
          />
          <path
            d="M1031.49 160.961C1029.45 160.961 1027.79 162.616 1027.79 164.657C1027.79 166.698 1029.45 168.354 1031.49 168.354C1033.53 168.354 1035.19 166.698 1035.19 164.657C1035.19 162.616 1033.53 160.961 1031.49 160.961Z"
            fill="white"
          />
          <path
            d="M1038.42 172.846C1036.34 172.846 1034.67 174.522 1034.67 176.593C1034.67 178.664 1036.34 180.349 1038.42 180.349C1040.5 180.349 1042.17 178.668 1042.17 176.593C1042.17 174.518 1040.49 172.846 1038.42 172.846Z"
            fill="white"
          />
          <path
            d="M1045.4 184.865C1043.31 184.865 1041.63 186.554 1041.63 188.642C1041.63 190.73 1043.31 192.432 1045.4 192.432C1047.5 192.432 1049.19 190.734 1049.19 188.642C1049.19 186.55 1047.5 184.865 1045.4 184.865Z"
            fill="white"
          />
          <path
            d="M1052.54 196.867C1050.43 196.867 1048.71 198.573 1048.71 200.687C1048.71 202.8 1050.43 204.506 1052.54 204.506C1054.65 204.506 1056.36 202.8 1056.36 200.687C1056.36 198.573 1054.64 196.867 1052.54 196.867Z"
            fill="white"
          />
          <path
            d="M1060.79 216.337C1062.87 215.847 1064.15 213.767 1063.66 211.691C1063.17 209.616 1061.09 208.33 1059.02 208.82C1056.94 209.31 1055.66 211.39 1056.15 213.466C1056.64 215.541 1058.72 216.827 1060.79 216.337Z"
            fill="white"
          />
          <path
            d="M1067.6 219.996C1065.44 219.996 1063.68 221.745 1063.68 223.909C1063.68 226.073 1065.44 227.813 1067.6 227.813C1069.75 227.813 1071.51 226.065 1071.51 223.909C1071.51 221.753 1069.76 219.996 1067.6 219.996Z"
            fill="white"
          />
          <path
            d="M1075.68 230.588C1073.5 230.588 1071.74 232.358 1071.74 234.535C1071.74 236.712 1073.51 238.469 1075.68 238.469C1077.85 238.469 1079.61 236.707 1079.61 234.535C1079.61 232.362 1077.85 230.588 1075.68 230.588Z"
            fill="white"
          />
          <path
            d="M1084.17 240.217C1081.98 240.217 1080.21 241.995 1080.21 244.193C1080.21 246.391 1081.98 248.157 1084.17 248.157C1086.37 248.157 1088.14 246.379 1088.14 244.193C1088.14 242.008 1086.37 240.217 1084.17 240.217Z"
            fill="white"
          />
          <path
            d="M1093.05 248.779C1090.84 248.779 1089.05 250.57 1089.05 252.777C1089.05 254.984 1090.84 256.783 1093.05 256.783C1095.26 256.783 1097.06 254.992 1097.06 252.777C1097.06 250.562 1095.26 248.779 1093.05 248.779Z"
            fill="white"
          />
          <path
            d="M1102.25 256.285C1100.02 256.285 1098.22 258.085 1098.22 260.312C1098.22 262.54 1100.02 264.353 1102.25 264.353C1104.48 264.353 1106.29 262.54 1106.29 260.312C1106.29 258.085 1104.48 256.285 1102.25 256.285Z"
            fill="white"
          />
          <path
            d="M1111.7 262.844C1109.45 262.844 1107.64 264.656 1107.64 266.901C1107.64 269.146 1109.46 270.958 1111.7 270.958C1113.95 270.958 1115.76 269.137 1115.76 266.901C1115.76 264.664 1113.95 262.844 1111.7 262.844Z"
            fill="white"
          />
          <path
            d="M1121.32 268.578C1119.06 268.578 1117.23 270.411 1117.23 272.669C1117.23 274.927 1119.06 276.769 1121.32 276.769C1123.58 276.769 1125.42 274.935 1125.42 272.669C1125.42 270.403 1123.58 268.578 1121.32 268.578Z"
            fill="white"
          />
          <path
            d="M1133.97 280.709C1135.57 279.103 1135.57 276.499 1133.97 274.893C1132.36 273.287 1129.76 273.287 1128.15 274.893C1126.55 276.499 1126.55 279.103 1128.15 280.709C1129.76 282.314 1132.36 282.314 1133.97 280.709Z"
            fill="white"
          />
          <path
            d="M1140.88 278.268C1138.59 278.268 1136.74 280.122 1136.74 282.409C1136.74 284.697 1138.6 286.543 1140.88 286.543C1143.17 286.543 1145.03 284.693 1145.03 282.409C1145.03 280.126 1143.16 278.268 1140.88 278.268Z"
            fill="white"
          />
          <path
            d="M1150.77 282.451C1148.47 282.451 1146.62 284.314 1146.62 286.606C1146.62 288.897 1148.47 290.76 1150.77 290.76C1153.07 290.76 1154.93 288.897 1154.93 286.606C1154.93 284.314 1153.07 282.451 1150.77 282.451Z"
            fill="white"
          />
          <path
            d="M1160.71 286.32C1158.41 286.32 1156.56 288.175 1156.56 290.475C1156.56 292.775 1158.41 294.63 1160.71 294.63C1163.02 294.63 1164.87 292.767 1164.87 290.475C1164.87 288.183 1163 286.32 1160.71 286.32Z"
            fill="white"
          />
          <path
            d="M1170.67 289.924C1168.37 289.924 1166.52 291.787 1166.52 294.078C1166.52 296.37 1168.37 298.233 1170.67 298.233C1172.97 298.233 1174.83 296.37 1174.83 294.078C1174.83 291.787 1172.96 289.924 1170.67 289.924Z"
            fill="white"
          />
          <path
            d="M1180.63 293.318C1178.33 293.318 1176.48 295.181 1176.48 297.473C1176.48 299.765 1178.33 301.636 1180.63 301.636C1182.93 301.636 1184.79 299.773 1184.79 297.473C1184.79 295.173 1182.92 293.318 1180.63 293.318Z"
            fill="white"
          />
          <path
            d="M1190.58 296.521C1188.28 296.521 1186.41 298.385 1186.41 300.676C1186.41 302.968 1188.28 304.831 1190.58 304.831C1192.88 304.831 1194.73 302.968 1194.73 300.676C1194.73 298.385 1192.87 296.521 1190.58 296.521Z"
            fill="white"
          />
          <path
            d="M1200.46 299.51C1198.16 299.51 1196.3 301.373 1196.3 303.664C1196.3 305.956 1198.16 307.819 1200.46 307.819C1202.76 307.819 1204.61 305.969 1204.61 303.664C1204.61 301.36 1202.75 299.51 1200.46 299.51Z"
            fill="white"
          />
          <path
            d="M1210.28 302.277C1207.98 302.277 1206.11 304.128 1206.11 306.432C1206.11 308.736 1207.98 310.587 1210.28 310.587C1212.58 310.587 1214.43 308.724 1214.43 306.432C1214.43 304.14 1212.57 302.277 1210.28 302.277Z"
            fill="white"
          />
          <path
            d="M1219.96 304.777C1217.67 304.777 1215.81 306.64 1215.81 308.932C1215.81 311.224 1217.67 313.087 1219.96 313.087C1222.26 313.087 1224.12 311.232 1224.12 308.932C1224.12 306.632 1222.26 304.777 1219.96 304.777Z"
            fill="white"
          />
          <path
            d="M1216 304.973C1213.71 304.973 1211.85 306.836 1211.85 309.127C1211.85 311.419 1213.71 313.282 1216 313.282C1218.29 313.282 1220.15 311.419 1220.15 309.127C1220.15 306.836 1218.3 304.973 1216 304.973Z"
            fill="white"
          />
          <path
            d="M1211.68 305.006C1209.39 305.006 1207.53 306.869 1207.53 309.161C1207.53 311.452 1209.39 313.315 1211.68 313.315C1213.97 313.315 1215.83 311.461 1215.83 309.161C1215.83 306.86 1213.98 305.006 1211.68 305.006Z"
            fill="white"
          />
          <path
            d="M1206.99 304.879C1204.69 304.879 1202.83 306.742 1202.83 309.034C1202.83 311.325 1204.69 313.188 1206.99 313.188C1209.28 313.188 1211.14 311.338 1211.14 309.034C1211.14 306.729 1209.29 304.879 1206.99 304.879Z"
            fill="white"
          />
          <path
            d="M1201.92 304.611C1199.62 304.611 1197.76 306.474 1197.76 308.766C1197.76 311.058 1199.61 312.921 1201.92 312.921C1204.22 312.921 1206.07 311.066 1206.07 308.766C1206.07 306.466 1204.21 304.611 1201.92 304.611Z"
            fill="white"
          />
          <path
            d="M1196.45 304.213C1194.16 304.213 1192.3 306.067 1192.3 308.368C1192.3 310.668 1194.16 312.522 1196.45 312.522C1198.75 312.522 1200.61 310.659 1200.61 308.368C1200.61 306.076 1198.75 304.213 1196.45 304.213Z"
            fill="white"
          />
          <path
            d="M1190.61 303.695C1188.32 303.695 1186.46 305.546 1186.46 307.85C1186.46 310.154 1188.32 312.005 1190.61 312.005C1192.91 312.005 1194.78 310.142 1194.78 307.85C1194.78 305.558 1192.91 303.695 1190.61 303.695Z"
            fill="white"
          />
          <path
            d="M1184.42 303.08C1182.12 303.08 1180.26 304.93 1180.26 307.23C1180.26 309.531 1182.12 311.385 1184.42 311.385C1186.72 311.385 1188.58 309.522 1188.58 307.23C1188.58 304.939 1186.71 303.08 1184.42 303.08Z"
            fill="white"
          />
          <path
            d="M1177.86 302.393C1175.56 302.393 1173.7 304.247 1173.7 306.547C1173.7 308.847 1175.56 310.702 1177.86 310.702C1180.15 310.702 1182.02 308.839 1182.02 306.547C1182.02 304.256 1180.16 302.393 1177.86 302.393Z"
            fill="white"
          />
          <path
            d="M1170.95 301.654C1168.66 301.654 1166.8 303.505 1166.8 305.809C1166.8 308.113 1168.66 309.964 1170.95 309.964C1173.24 309.964 1175.11 308.101 1175.11 305.809C1175.11 303.517 1173.26 301.654 1170.95 301.654Z"
            fill="white"
          />
          <path
            d="M1163.72 300.895C1161.43 300.895 1159.57 302.758 1159.57 305.049C1159.57 307.341 1161.43 309.204 1163.72 309.204C1166.01 309.204 1167.88 307.341 1167.88 305.049C1167.88 302.758 1166.03 300.895 1163.72 300.895Z"
            fill="white"
          />
          <path
            d="M1156.16 300.125C1153.86 300.125 1152.01 301.975 1152.01 304.28C1152.01 306.584 1153.86 308.434 1156.16 308.434C1158.46 308.434 1160.32 306.571 1160.32 304.28C1160.32 301.988 1158.45 300.125 1156.16 300.125Z"
            fill="white"
          />
          <path
            d="M1148.27 299.383C1146 299.383 1144.14 301.233 1144.14 303.516C1144.14 305.799 1145.99 307.658 1148.27 307.658C1150.56 307.658 1152.42 305.808 1152.42 303.516C1152.42 301.225 1150.57 299.383 1148.27 299.383Z"
            fill="white"
          />
          <path
            d="M1140.08 298.688C1137.8 298.688 1135.95 300.542 1135.95 302.821C1135.95 305.1 1137.8 306.954 1140.08 306.954C1142.37 306.954 1144.2 305.104 1144.2 302.821C1144.2 300.538 1142.36 298.688 1140.08 298.688Z"
            fill="white"
          />
          <path
            d="M1131.58 298.105C1129.31 298.105 1127.47 299.939 1127.47 302.205C1127.47 304.471 1129.31 306.317 1131.58 306.317C1133.85 306.317 1135.7 304.475 1135.7 302.205C1135.7 299.935 1133.85 298.105 1131.58 298.105Z"
            fill="white"
          />
          <path
            d="M1122.8 297.656C1120.54 297.656 1118.72 299.477 1118.72 301.734C1118.72 303.992 1120.54 305.813 1122.8 305.813C1125.06 305.813 1126.88 303.979 1126.88 301.734C1126.88 299.49 1125.04 297.656 1122.8 297.656Z"
            fill="white"
          />
          <path
            d="M1113.73 297.375C1111.5 297.375 1109.69 299.187 1109.69 301.424C1109.69 303.66 1111.5 305.472 1113.73 305.472C1115.97 305.472 1117.78 303.66 1117.78 301.424C1117.78 299.187 1115.97 297.375 1113.73 297.375Z"
            fill="white"
          />
          <path
            d="M1104.4 297.26C1102.17 297.26 1100.37 299.059 1100.37 301.279C1100.37 303.498 1102.17 305.297 1104.4 305.297C1106.63 305.297 1108.42 303.498 1108.42 301.279C1108.42 299.059 1106.62 297.26 1104.4 297.26Z"
            fill="white"
          />
          <path
            d="M1094.8 297.355C1092.59 297.355 1090.8 299.134 1090.8 301.34C1090.8 303.547 1092.59 305.338 1094.8 305.338C1097 305.338 1098.78 303.547 1098.78 301.34C1098.78 299.134 1097 297.355 1094.8 297.355Z"
            fill="white"
          />
          <path
            d="M1084.96 297.689C1082.78 297.689 1081 299.468 1081 301.666C1081 303.864 1082.78 305.63 1084.96 305.63C1087.15 305.63 1088.93 303.851 1088.93 301.666C1088.93 299.48 1087.16 297.689 1084.96 297.689Z"
            fill="white"
          />
          <path
            d="M1077.69 305.043C1079.22 303.51 1079.22 301.025 1077.69 299.492C1076.16 297.959 1073.67 297.959 1072.14 299.492C1070.61 301.025 1070.61 303.51 1072.14 305.043C1073.67 306.576 1076.16 306.576 1077.69 305.043Z"
            fill="white"
          />
          <path
            d="M1064.65 299.311C1062.49 299.311 1060.75 301.05 1060.75 303.202C1060.75 305.354 1062.49 307.094 1064.65 307.094C1066.8 307.094 1068.54 305.345 1068.54 303.202C1068.54 301.059 1066.79 299.311 1064.65 299.311Z"
            fill="white"
          />
          <path
            d="M1054.17 300.572C1052.03 300.572 1050.31 302.299 1050.31 304.434C1050.31 306.569 1052.03 308.296 1054.17 308.296C1056.3 308.296 1058.03 306.569 1058.03 304.434C1058.03 302.299 1056.3 300.572 1054.17 300.572Z"
            fill="white"
          />
          <path
            d="M1043.49 302.164C1041.37 302.164 1039.66 303.87 1039.66 305.992C1039.66 308.114 1041.38 309.824 1043.49 309.824C1045.6 309.824 1047.32 308.105 1047.32 305.992C1047.32 303.879 1045.6 302.164 1043.49 302.164Z"
            fill="white"
          />
          <path
            d="M1032.63 304.162C1030.55 304.162 1028.86 305.847 1028.86 307.939C1028.86 310.031 1030.55 311.708 1032.63 311.708C1034.71 311.708 1036.4 310.023 1036.4 307.939C1036.4 305.855 1034.72 304.162 1032.63 304.162Z"
            fill="white"
          />
          <path
            d="M1021.63 306.59C1019.57 306.59 1017.9 308.253 1017.9 310.324C1017.9 312.395 1019.57 314.059 1021.63 314.059C1023.69 314.059 1025.37 312.383 1025.37 310.324C1025.37 308.266 1023.69 306.59 1021.63 306.59Z"
            fill="white"
          />
          <path
            d="M1010.49 309.387C1008.45 309.387 1006.79 311.042 1006.79 313.083C1006.79 315.124 1008.45 316.788 1010.49 316.788C1012.53 316.788 1014.18 315.133 1014.18 313.083C1014.18 311.033 1012.53 309.387 1010.49 309.387Z"
            fill="white"
          />
          <path
            d="M999.224 312.561C997.204 312.561 995.57 314.194 995.57 316.214C995.57 318.234 997.204 319.868 999.224 319.868C1001.24 319.868 1002.88 318.234 1002.88 316.214C1002.88 314.194 1001.24 312.561 999.224 312.561Z"
            fill="white"
          />
          <path
            d="M987.881 316.205C985.891 316.205 984.291 317.809 984.291 319.795C984.291 321.781 985.895 323.386 987.881 323.386C989.867 323.386 991.472 321.773 991.472 319.795C991.472 317.818 989.859 316.205 987.881 316.205Z"
            fill="white"
          />
          <path
            d="M976.439 320.334C974.483 320.334 972.892 321.925 972.892 323.882C972.892 325.838 974.483 327.43 976.439 327.43C978.396 327.43 979.987 325.838 979.987 323.882C979.987 321.925 978.396 320.334 976.439 320.334Z"
            fill="white"
          />
          <path
            d="M964.96 325.135C963.025 325.135 961.455 326.705 961.455 328.644C961.455 330.584 963.025 332.141 964.96 332.141C966.896 332.141 968.457 330.579 968.457 328.644C968.457 326.709 966.896 325.135 964.96 325.135Z"
            fill="white"
          />
          <path
            d="M953.49 330.732C951.576 330.732 950.035 332.273 950.035 334.187C950.035 336.101 951.576 337.641 953.49 337.641C955.404 337.641 956.944 336.092 956.944 334.187C956.944 332.281 955.395 330.732 953.49 330.732Z"
            fill="white"
          />
          <path
            d="M942.066 337.258C940.19 337.258 938.684 338.777 938.684 340.64C938.684 342.503 940.194 344.035 942.066 344.035C943.937 344.035 945.448 342.516 945.448 340.64C945.448 338.764 943.937 337.258 942.066 337.258Z"
            fill="white"
          />
          <path
            d="M930.811 344.932C928.969 344.932 927.471 346.43 927.471 348.271C927.471 350.113 928.969 351.611 930.811 351.611C932.652 351.611 934.15 350.113 934.15 348.271C934.15 346.43 932.652 344.932 930.811 344.932Z"
            fill="white"
          />
          <path
            d="M919.769 353.953C917.957 353.953 916.488 355.43 916.488 357.242C916.488 359.054 917.957 360.518 919.769 360.518C921.581 360.518 923.049 359.05 923.049 357.242C923.049 355.434 921.581 353.953 919.769 353.953Z"
            fill="white"
          />
          <path
            d="M909.042 364.674C907.251 364.674 905.804 366.121 905.804 367.912C905.804 369.703 907.251 371.137 909.042 371.137C910.833 371.137 912.28 369.69 912.28 367.912C912.28 366.134 910.833 364.674 909.042 364.674Z"
            fill="white"
          />
          <path
            d="M898.881 377.613C897.141 377.613 895.728 379.018 895.728 380.766C895.728 382.515 897.145 383.911 898.881 383.911C900.616 383.911 902.025 382.506 902.025 380.766C902.025 379.026 900.621 377.613 898.881 377.613Z"
            fill="white"
          />
          <path
            d="M889.431 392.939C887.713 392.939 886.329 394.323 886.329 396.042C886.329 397.76 887.713 399.144 889.431 399.144C891.15 399.144 892.533 397.748 892.533 396.042C892.533 394.336 891.137 392.939 889.431 392.939Z"
            fill="white"
          />
          <path
            d="M881.406 411.457C879.729 411.457 878.367 412.819 878.367 414.496C878.367 416.172 879.729 417.534 881.406 417.534C883.082 417.534 884.444 416.18 884.444 414.496C884.444 412.811 883.082 411.457 881.406 411.457Z"
            fill="white"
          />
          <path
            d="M875.817 433.979C874.17 433.979 872.842 435.311 872.842 436.953C872.842 438.596 874.174 439.928 875.817 439.928C877.459 439.928 878.804 438.596 878.804 436.953C878.804 435.311 877.463 433.979 875.817 433.979Z"
            fill="white"
          />
          <path
            d="M873.767 461.248C872.163 461.248 870.873 462.538 870.873 464.142C870.873 465.746 872.163 467.037 873.767 467.037C875.371 467.037 876.662 465.734 876.662 464.142C876.662 462.551 875.359 461.248 873.767 461.248Z"
            fill="white"
          />
          <path
            d="M875.901 493.521C874.339 493.521 873.07 494.79 873.07 496.352C873.07 497.914 874.339 499.183 875.901 499.183C877.463 499.183 878.744 497.914 878.744 496.352C878.744 494.79 877.475 493.521 875.901 493.521Z"
            fill="white"
          />
          <path
            d="M881.749 530.701C880.217 530.701 878.982 531.94 878.982 533.481C878.982 535.021 880.222 536.248 881.749 536.248C883.277 536.248 884.529 535.009 884.529 533.481C884.529 531.953 883.281 530.701 881.749 530.701Z"
            fill="white"
          />
          <path
            d="M889.579 572.57C888.081 572.57 886.863 573.78 886.863 575.278C886.863 576.776 888.081 577.994 889.579 577.994C891.077 577.994 892.287 576.776 892.287 575.278C892.287 573.78 891.082 572.57 889.579 572.57Z"
            fill="white"
          />
          <path
            d="M911.205 656.199C909.788 656.199 908.646 657.353 908.646 658.771C908.646 660.188 909.792 661.33 911.205 661.33C912.619 661.33 913.777 660.184 913.777 658.771C913.777 657.358 912.623 656.199 911.205 656.199Z"
            fill="white"
          />
          <path
            d="M903.171 668.865C901.754 668.865 900.612 670.011 900.612 671.424C900.612 672.837 901.758 673.983 903.171 673.983C904.584 673.983 905.743 672.837 905.743 671.424C905.743 670.011 904.589 668.865 903.171 668.865Z"
            fill="white"
          />
          <path
            d="M601.258 675.658C599.926 675.658 598.844 676.74 598.844 678.073C598.844 679.405 599.926 680.488 601.258 680.488C602.591 680.488 603.673 679.405 603.673 678.073C603.673 676.74 602.591 675.658 601.258 675.658Z"
            fill="white"
          />
          <path
            d="M586.791 671.725C585.458 671.725 584.385 672.798 584.385 674.139C584.385 675.48 585.458 676.541 586.791 676.541C588.123 676.541 589.206 675.468 589.206 674.139C589.206 672.811 588.132 671.725 586.791 671.725Z"
            fill="white"
          />
          <path
            d="M572.312 668.24C570.98 668.24 569.906 669.322 569.906 670.646C569.906 671.97 570.98 673.053 572.312 673.053C573.645 673.053 574.719 671.979 574.719 670.646C574.719 669.314 573.645 668.24 572.312 668.24Z"
            fill="white"
          />
          <path
            d="M557.888 665.584C556.555 665.584 555.481 666.666 555.481 667.99C555.481 669.314 556.555 670.392 557.888 670.392C559.22 670.392 560.29 669.319 560.29 667.99C560.29 666.662 559.216 665.584 557.888 665.584Z"
            fill="white"
          />
          <path
            d="M543.535 663.6C542.215 663.6 541.129 664.673 541.129 666.006C541.129 667.338 542.211 668.399 543.535 668.399C544.859 668.399 545.941 667.326 545.941 666.006C545.941 664.686 544.868 663.6 543.535 663.6Z"
            fill="white"
          />
          <path
            d="M529.194 661.924C527.87 661.924 526.801 662.998 526.801 664.317C526.801 665.637 527.874 666.723 529.194 666.723C530.514 666.723 531.6 665.65 531.6 664.317C531.6 662.985 530.518 661.924 529.194 661.924Z"
            fill="white"
          />
          <path
            d="M514.839 660.662C513.519 660.662 512.445 661.736 512.445 663.056C512.445 664.375 513.519 665.449 514.839 665.449C516.159 665.449 517.232 664.375 517.232 663.056C517.232 661.736 516.159 660.662 514.839 660.662Z"
            fill="white"
          />
          <path
            d="M500.509 659.822C499.185 659.822 498.115 660.896 498.115 662.207C498.115 663.519 499.189 664.601 500.509 664.601C501.829 664.601 502.894 663.527 502.894 662.207C502.894 660.887 501.82 659.822 500.509 659.822Z"
            fill="white"
          />
          <path
            d="M486.083 658.977C484.759 658.977 483.698 660.037 483.698 661.362C483.698 662.686 484.759 663.747 486.083 663.747C487.407 663.747 488.468 662.673 488.468 661.362C488.468 660.05 487.407 658.977 486.083 658.977Z"
            fill="white"
          />
          <path
            d="M471.493 658.115C470.182 658.115 469.108 659.189 469.108 660.5C469.108 661.812 470.182 662.885 471.493 662.885C472.805 662.885 473.878 661.812 473.878 660.5C473.878 659.189 472.817 658.115 471.493 658.115Z"
            fill="white"
          />
          <path
            d="M456.733 657.293C455.414 657.293 454.34 658.367 454.34 659.686C454.34 661.006 455.414 662.08 456.733 662.08C458.053 662.08 459.127 661.006 459.127 659.686C459.127 658.367 458.053 657.293 456.733 657.293Z"
            fill="white"
          />
          <path
            d="M441.706 656.146C440.386 656.146 439.312 657.22 439.312 658.531C439.312 659.843 440.386 660.925 441.706 660.925C443.026 660.925 444.091 659.851 444.091 658.531C444.091 657.212 443.03 656.146 441.706 656.146Z"
            fill="white"
          />
          <path
            d="M426.268 654.6C424.956 654.6 423.883 655.661 423.883 656.985C423.883 658.309 424.956 659.37 426.268 659.37C427.579 659.37 428.661 658.296 428.661 656.985C428.661 655.673 427.588 654.6 426.268 654.6Z"
            fill="white"
          />
          <path
            d="M410.408 652.67C409.084 652.67 408.023 653.744 408.023 655.055C408.023 656.366 409.084 657.44 410.408 657.44C411.732 657.44 412.781 656.366 412.781 655.055C412.781 653.744 411.72 652.67 410.408 652.67Z"
            fill="white"
          />
          <path
            d="M393.973 649.986C392.662 649.986 391.601 651.047 391.601 652.359C391.601 653.67 392.662 654.744 393.973 654.744C395.284 654.744 396.358 653.683 396.358 652.359C396.358 651.035 395.284 649.986 393.973 649.986Z"
            fill="white"
          />
          <path
            d="M376.862 646.457C375.538 646.457 374.469 647.531 374.469 648.851C374.469 650.17 375.542 651.244 376.862 651.244C378.182 651.244 379.247 650.17 379.247 648.851C379.247 647.531 378.186 646.457 376.862 646.457Z"
            fill="white"
          />
          <path
            d="M358.984 642.189C357.672 642.189 356.599 643.263 356.599 644.583C356.599 645.903 357.672 646.968 358.984 646.968C360.295 646.968 361.377 645.894 361.377 644.583C361.377 643.272 360.303 642.189 358.984 642.189Z"
            fill="white"
          />
          <path
            d="M340.175 636.756C338.851 636.756 337.781 637.83 337.781 639.141C337.781 640.452 338.855 641.534 340.175 641.534C341.495 641.534 342.56 640.461 342.56 639.141C342.56 637.821 341.486 636.756 340.175 636.756Z"
            fill="white"
          />
          <path
            d="M320.276 629.938C318.964 629.938 317.891 630.998 317.891 632.322C317.891 633.647 318.964 634.707 320.276 634.707C321.587 634.707 322.661 633.634 322.661 632.322C322.661 631.011 321.587 629.938 320.276 629.938Z"
            fill="white"
          />
          <path
            d="M299.138 621.709C297.818 621.709 296.744 622.783 296.744 624.102C296.744 625.422 297.818 626.496 299.138 626.496C300.457 626.496 301.531 625.422 301.531 624.102C301.531 622.783 300.457 621.709 299.138 621.709Z"
            fill="white"
          />
          <path
            d="M276.553 612.059C275.233 612.059 274.159 613.132 274.159 614.452C274.159 615.772 275.233 616.837 276.553 616.837C277.872 616.837 278.938 615.763 278.938 614.452C278.938 613.141 277.864 612.059 276.553 612.059Z"
            fill="white"
          />
          <path
            d="M252.304 601.328C250.993 601.328 249.919 602.389 249.919 603.713C249.919 605.037 250.993 606.098 252.304 606.098C253.615 606.098 254.689 605.037 254.689 603.713C254.689 602.389 253.628 601.328 252.304 601.328Z"
            fill="white"
          />
          <path
            d="M241.155 593.156C239.793 593.156 238.689 594.251 238.689 595.613C238.689 596.976 239.793 598.079 241.155 598.079C242.517 598.079 243.612 596.976 243.612 595.613C243.612 594.251 242.509 593.156 241.155 593.156Z"
            fill="white"
          />
          <path
            d="M230.665 585.402C229.26 585.402 228.114 586.548 228.114 587.953C228.114 589.358 229.26 590.503 230.665 590.503C232.069 590.503 233.215 589.358 233.215 587.953C233.215 586.548 232.082 585.402 230.665 585.402Z"
            fill="white"
          />
          <path
            d="M221.401 578.367C219.967 578.367 218.8 579.543 218.8 580.981C218.8 582.42 219.967 583.595 221.401 583.595C222.836 583.595 224.015 582.428 224.015 580.981C224.015 579.534 222.848 578.367 221.401 578.367Z"
            fill="white"
          />
          <path
            d="M213.698 572.111C212.221 572.111 211.024 573.308 211.024 574.785C211.024 576.262 212.221 577.458 213.698 577.458C215.175 577.458 216.372 576.262 216.372 574.785C216.372 573.308 215.175 572.111 213.698 572.111Z"
            fill="white"
          />
          <path
            d="M207.549 566.617C206.038 566.617 204.812 567.844 204.812 569.354C204.812 570.865 206.038 572.092 207.549 572.092C209.06 572.092 210.277 570.865 210.277 569.354C210.277 567.844 209.06 566.617 207.549 566.617Z"
            fill="white"
          />
          <path
            d="M202.801 561.799C201.231 561.799 199.971 563.068 199.971 564.629C199.971 566.191 201.231 567.46 202.801 567.46C204.371 567.46 205.632 566.191 205.632 564.629C205.632 563.068 204.363 561.799 202.801 561.799Z"
            fill="white"
          />
          <path
            d="M199.23 557.637C197.626 557.637 196.336 558.927 196.336 560.518C196.336 562.11 197.626 563.412 199.23 563.412C200.834 563.412 202.112 562.122 202.112 560.518C202.112 558.914 200.822 557.637 199.23 557.637Z"
            fill="white"
          />
          <path
            d="M196.474 553.932C194.848 553.932 193.537 555.243 193.537 556.868C193.537 558.494 194.848 559.805 196.474 559.805C198.099 559.805 199.41 558.494 199.41 556.868C199.41 555.243 198.099 553.932 196.474 553.932Z"
            fill="white"
          />
          <path
            d="M194.236 550.506C192.581 550.506 191.24 551.847 191.24 553.502C191.24 555.157 192.581 556.498 194.236 556.498C195.891 556.498 197.232 555.157 197.232 553.502C197.232 551.847 195.891 550.506 194.236 550.506Z"
            fill="white"
          />
          <path
            d="M192.301 547.24C190.595 547.24 189.212 548.624 189.212 550.33C189.212 552.036 190.595 553.419 192.301 553.419C194.007 553.419 195.382 552.036 195.382 550.33C195.382 548.624 194.007 547.24 192.301 547.24Z"
            fill="white"
          />
          <path
            d="M190.417 544.053C188.677 544.053 187.264 545.47 187.264 547.206C187.264 548.942 188.681 550.359 190.417 550.359C192.152 550.359 193.561 548.942 193.561 547.206C193.561 545.47 192.157 544.053 190.417 544.053Z"
            fill="white"
          />
          <path
            d="M188.324 540.775C186.563 540.775 185.129 542.214 185.129 543.971C185.129 545.728 186.563 547.166 188.324 547.166C190.086 547.166 191.52 545.741 191.52 543.971C191.52 542.201 190.094 540.775 188.324 540.775Z"
            fill="white"
          />
          <path
            d="M185.94 537.311C184.149 537.311 182.693 538.758 182.693 540.557C182.693 542.356 184.149 543.804 185.94 543.804C187.731 543.804 189.199 542.356 189.199 540.557C189.199 538.758 187.743 537.311 185.94 537.311Z"
            fill="white"
          />
          <path
            d="M183.224 533.605C181.391 533.605 179.905 535.095 179.905 536.924C179.905 538.753 181.395 540.243 183.224 540.243C185.053 540.243 186.543 538.753 186.543 536.924C186.543 535.095 185.053 533.605 183.224 533.605Z"
            fill="white"
          />
          <path
            d="M180.156 529.678C178.293 529.678 176.782 531.188 176.782 533.051C176.782 534.915 178.293 536.434 180.156 536.434C182.019 536.434 183.538 534.915 183.538 533.051C183.538 531.188 182.019 529.678 180.156 529.678Z"
            fill="white"
          />
          <path
            d="M176.761 525.537C174.876 525.537 173.349 527.069 173.349 528.953C173.349 530.838 174.881 532.365 176.761 532.365C178.641 532.365 180.185 530.838 180.185 528.953C180.185 527.069 178.653 525.537 176.761 525.537Z"
            fill="white"
          />
          <path
            d="M173.077 521.18C171.164 521.18 169.61 522.729 169.61 524.647C169.61 526.565 171.159 528.101 173.077 528.101C174.996 528.101 176.532 526.552 176.532 524.647C176.532 522.741 174.983 521.18 173.077 521.18Z"
            fill="white"
          />
          <path
            d="M169.113 516.607C167.166 516.607 165.587 518.19 165.587 520.134C165.587 522.078 167.17 523.661 169.113 523.661C171.057 523.661 172.632 522.078 172.632 520.134C172.632 518.19 171.061 516.607 169.113 516.607Z"
            fill="white"
          />
          <path
            d="M164.874 511.895C162.909 511.895 161.305 513.486 161.305 515.464C161.305 517.441 162.909 519.024 164.874 519.024C166.839 519.024 168.443 517.433 168.443 515.464C168.443 513.494 166.839 511.895 164.874 511.895Z"
            fill="white"
          />
          <path
            d="M160.388 507.021C158.389 507.021 156.776 508.647 156.776 510.633C156.776 512.619 158.389 514.244 160.388 514.244C162.387 514.244 163.991 512.632 163.991 510.633C163.991 508.634 162.378 507.021 160.388 507.021Z"
            fill="white"
          />
          <path
            d="M155.635 502.057C153.615 502.057 151.994 503.69 151.994 505.698C151.994 507.705 153.619 509.339 155.635 509.339C157.651 509.339 159.276 507.705 159.276 505.698C159.276 503.69 157.643 502.057 155.635 502.057Z"
            fill="white"
          />
          <path
            d="M150.599 496.998C148.557 496.998 146.902 498.653 146.902 500.694C146.902 502.736 148.557 504.399 150.599 504.399C152.64 504.399 154.303 502.744 154.303 500.694C154.303 498.645 152.648 496.998 150.599 496.998Z"
            fill="white"
          />
          <path
            d="M145.276 491.943C143.214 491.943 141.542 493.62 141.542 495.678C141.542 497.736 143.218 499.412 145.276 499.412C147.335 499.412 149.002 497.736 149.002 495.678C149.002 493.62 147.339 491.943 145.276 491.943Z"
            fill="white"
          />
          <path
            d="M139.644 486.924C137.565 486.924 135.876 488.609 135.876 490.68C135.876 492.75 137.561 494.435 139.644 494.435C141.728 494.435 143.4 492.759 143.4 490.68C143.4 488.6 141.715 486.924 139.644 486.924Z"
            fill="white"
          />
          <path
            d="M133.673 481.951C131.572 481.951 129.875 483.657 129.875 485.762C129.875 487.867 131.572 489.56 133.673 489.56C135.774 489.56 137.471 487.854 137.471 485.762C137.471 483.67 135.774 481.951 133.673 481.951Z"
            fill="white"
          />
          <path
            d="M127.346 477.078C125.224 477.078 123.497 478.797 123.497 480.919C123.497 483.041 125.224 484.768 127.346 484.768C129.468 484.768 131.187 483.041 131.187 480.919C131.187 478.797 129.468 477.078 127.346 477.078Z"
            fill="white"
          />
          <path
            d="M120.632 472.332C118.498 472.332 116.771 474.068 116.771 476.202C116.771 478.337 118.498 480.064 120.632 480.064C122.767 480.064 124.503 478.337 124.503 476.202C124.503 474.068 122.767 472.332 120.632 472.332Z"
            fill="white"
          />
          <path
            d="M113.533 467.711C111.39 467.711 109.642 469.459 109.642 471.602C109.642 473.746 111.39 475.494 113.533 475.494C115.676 475.494 117.425 473.754 117.425 471.602C117.425 469.451 115.685 467.711 113.533 467.711Z"
            fill="white"
          />
          <path
            d="M106.06 463.152C103.896 463.152 102.135 464.901 102.135 467.065C102.135 469.229 103.892 470.978 106.06 470.978C108.229 470.978 109.973 469.229 109.973 467.065C109.973 464.901 108.212 463.152 106.06 463.152Z"
            fill="white"
          />
          <path
            d="M98.2345 458.605C96.0489 458.605 94.2793 460.375 94.2793 462.561C94.2793 464.746 96.0489 466.503 98.2345 466.503C100.42 466.503 102.181 464.733 102.181 462.561C102.181 460.388 100.412 458.605 98.2345 458.605Z"
            fill="white"
          />
          <path
            d="M92.9176 460.872C94.4705 459.319 94.4705 456.802 92.9176 455.249C91.3647 453.696 88.847 453.696 87.2942 455.249C85.7413 456.802 85.7413 459.319 87.2942 460.872C88.847 462.425 91.3647 462.425 92.9176 460.872Z"
            fill="white"
          />
          <path
            d="M81.7261 449.508C79.5194 449.508 77.7285 451.299 77.7285 453.505C77.7285 455.712 79.5194 457.49 81.7261 457.49C83.9329 457.49 85.7237 455.712 85.7237 453.505C85.7237 451.299 83.9329 449.508 81.7261 449.508Z"
            fill="white"
          />
          <path
            d="M73.1409 444.76C70.9129 444.76 69.1221 446.559 69.1221 448.779C69.1221 450.998 70.9129 452.806 73.1409 452.806C75.3689 452.806 77.1597 451.007 77.1597 448.779C77.1597 446.551 75.3604 444.76 73.1409 444.76Z"
            fill="white"
          />
          <path
            d="M64.3779 439.766C62.15 439.766 60.3379 441.578 60.3379 443.806C60.3379 446.034 62.15 447.846 64.3779 447.846C66.6059 447.846 68.418 446.034 68.418 443.806C68.418 441.578 66.6059 439.766 64.3779 439.766Z"
            fill="white"
          />
          <path
            d="M55.4704 434.459C53.234 434.459 51.4219 436.271 51.4219 438.499C51.4219 440.727 53.234 442.548 55.4704 442.548C57.7069 442.548 59.519 440.735 59.519 438.499C59.519 436.263 57.7069 434.459 55.4704 434.459Z"
            fill="white"
          />
          <path
            d="M46.434 428.732C44.1975 428.732 42.377 430.545 42.377 432.789C42.377 435.034 44.1975 436.851 46.434 436.851C48.6704 436.851 50.4952 435.03 50.4952 432.789C50.4952 430.549 48.6747 428.732 46.434 428.732Z"
            fill="white"
          />
          <path
            d="M37.3061 422.498C35.0569 422.498 33.2363 424.319 33.2363 426.568C33.2363 428.817 35.0569 430.638 37.3061 430.638C39.5553 430.638 41.3758 428.817 41.3758 426.568C41.3758 424.319 39.5553 422.498 37.3061 422.498Z"
            fill="white"
          />
          <path
            d="M28.1779 415.568C25.9202 415.568 24.0996 417.389 24.0996 419.647C24.0996 421.904 25.9202 423.725 28.1779 423.725C30.4355 423.725 32.2561 421.904 32.2561 419.647C32.2561 417.389 30.4355 415.568 28.1779 415.568Z"
            fill="white"
          />
          <path
            d="M19.1437 407.846C16.886 407.846 15.0527 409.666 15.0527 411.924C15.0527 414.182 16.886 416.002 19.1437 416.002C21.4014 416.002 23.222 414.182 23.222 411.924C23.222 409.666 21.3887 407.846 19.1437 407.846Z"
            fill="white"
          />
          <path
            d="M10.299 399.27C8.04131 399.27 6.20801 401.103 6.20801 403.369C6.20801 405.635 8.04131 407.46 10.299 407.46C12.5567 407.46 14.3984 405.627 14.3984 403.369C14.3984 401.111 12.5651 399.27 10.299 399.27Z"
            fill="white"
          />
          <path
            d="M1.7316 390.008C-0.526075 390.008 -2.35938 391.841 -2.35938 394.099C-2.35938 396.356 -0.526075 398.19 1.7316 398.19C3.98927 398.19 5.83106 396.356 5.83106 394.099C5.83106 391.841 3.98927 390.008 1.7316 390.008Z"
            fill="white"
          />
          <path
            d="M-1.19241 313.217C-3.42038 313.217 -5.21973 315.016 -5.21973 317.244C-5.21973 319.472 -3.42038 321.284 -1.19241 321.284C1.03556 321.284 2.83491 319.472 2.83491 317.244C2.83491 315.016 1.03556 313.217 -1.19241 313.217Z"
            fill="white"
          />
          <path
            d="M4.94848 303.443C2.73325 303.443 0.942383 305.243 0.942383 307.462C0.942383 309.682 2.73325 311.468 4.94848 311.468C7.16372 311.468 8.96731 309.677 8.96731 307.462C8.96731 305.247 7.16796 303.443 4.94848 303.443Z"
            fill="white"
          />
          <path
            d="M11.3264 292.848C9.11118 292.848 7.32031 294.639 7.32031 296.845C7.32031 299.052 9.11118 300.851 11.3264 300.851C13.5416 300.851 15.324 299.06 15.324 296.845C15.324 294.63 13.5332 292.848 11.3264 292.848Z"
            fill="white"
          />
          <path
            d="M17.9585 281.477C15.7645 281.477 13.9736 283.255 13.9736 285.461C13.9736 287.668 15.7645 289.446 17.9585 289.446C20.1525 289.446 21.9434 287.655 21.9434 285.461C21.9434 283.267 20.1653 281.477 17.9585 281.477Z"
            fill="white"
          />
          <path
            d="M24.8468 269.432C22.6612 269.432 20.8916 271.201 20.8916 273.374C20.8916 275.547 22.6612 277.329 24.8468 277.329C27.0323 277.329 28.802 275.56 28.802 273.374C28.802 271.189 27.0323 269.432 24.8468 269.432Z"
            fill="white"
          />
          <path
            d="M31.9125 256.877C29.7354 256.877 27.9785 258.638 27.9785 260.811C27.9785 262.984 29.7354 264.753 31.9125 264.753C34.0895 264.753 35.8592 262.984 35.8592 260.811C35.8592 258.638 34.0895 256.877 31.9125 256.877Z"
            fill="white"
          />
          <path
            d="M39.1269 243.953C36.9711 243.953 35.2227 245.702 35.2227 247.857C35.2227 250.013 36.9711 251.77 39.1269 251.77C41.2827 251.77 43.0312 250.022 43.0312 247.857C43.0312 245.693 41.2827 243.953 39.1269 243.953Z"
            fill="white"
          />
          <path
            d="M46.3283 231.018C44.1853 231.018 42.4453 232.758 42.4453 234.901C42.4453 237.044 44.1853 238.771 46.3283 238.771C48.4714 238.771 50.2114 237.031 50.2114 234.901C50.2114 232.77 48.4757 231.018 46.3283 231.018Z"
            fill="white"
          />
          <path
            d="M53.365 218.457C51.2431 218.457 49.5244 220.176 49.5244 222.298C49.5244 224.419 51.2431 226.138 53.365 226.138C55.4869 226.138 57.2141 224.419 57.2141 222.298C57.2141 220.176 55.4869 218.457 53.365 218.457Z"
            fill="white"
          />
          <path
            d="M60.1507 206.496C58.0501 206.496 56.3398 208.202 56.3398 210.307C56.3398 212.412 58.0458 214.126 60.1507 214.126C62.2556 214.126 63.9616 212.42 63.9616 210.307C63.9616 208.194 62.2556 206.496 60.1507 206.496Z"
            fill="white"
          />
          <path
            d="M66.6256 202.948C68.7186 202.948 70.4153 201.252 70.4153 199.159C70.4153 197.066 68.7186 195.369 66.6256 195.369C64.5326 195.369 62.8359 197.066 62.8359 199.159C62.8359 201.252 64.5326 202.948 66.6256 202.948Z"
            fill="white"
          />
          <path
            d="M72.7677 185.357C70.6968 185.357 69.0205 187.042 69.0205 189.113C69.0205 191.184 70.6968 192.869 72.7677 192.869C74.8387 192.869 76.5235 191.184 76.5235 189.113C76.5235 187.042 74.8387 185.357 72.7677 185.357Z"
            fill="white"
          />
          <path
            d="M78.6231 176.336C76.5818 176.336 74.9268 177.987 74.9268 180.024C74.9268 182.061 76.5818 183.72 78.6231 183.72C80.6643 183.72 82.3194 182.065 82.3194 180.024C82.3194 177.983 80.6643 176.336 78.6231 176.336Z"
            fill="white"
          />
          <path
            d="M84.2258 168.104C82.2058 168.104 80.5635 169.742 80.5635 171.762C80.5635 173.782 82.2101 175.424 84.2258 175.424C86.2416 175.424 87.8882 173.79 87.8882 171.762C87.8882 169.733 86.2416 168.104 84.2258 168.104Z"
            fill="white"
          />
          <path
            d="M89.573 160.553C87.5742 160.553 85.9531 162.174 85.9531 164.173C85.9531 166.171 87.5742 167.784 89.573 167.784C91.5719 167.784 93.1845 166.171 93.1845 164.173C93.1845 162.174 91.5719 160.553 89.573 160.553Z"
            fill="white"
          />
          <path
            d="M94.6227 153.553C92.6452 153.553 91.041 155.157 91.041 157.143C91.041 159.129 92.6452 160.725 94.6227 160.725C96.6003 160.725 98.2129 159.121 98.2129 157.143C98.2129 155.165 96.6003 153.553 94.6227 153.553Z"
            fill="white"
          />
          <path
            d="M99.3586 153.996C101.306 153.996 102.885 152.418 102.885 150.47C102.885 148.522 101.306 146.943 99.3586 146.943C97.4109 146.943 95.832 148.522 95.832 150.47C95.832 152.418 97.4109 153.996 99.3586 153.996Z"
            fill="white"
          />
          <path
            d="M103.718 140.557C101.791 140.557 100.242 142.114 100.242 144.037C100.242 145.959 101.791 147.512 103.718 147.512C105.644 147.512 107.193 145.95 107.193 144.037C107.193 142.123 105.632 140.557 103.718 140.557Z"
            fill="white"
          />
          <path
            d="M107.622 134.326C105.729 134.326 104.188 135.867 104.188 137.759C104.188 139.652 105.729 141.193 107.622 141.193C109.514 141.193 111.055 139.652 111.055 137.759C111.055 135.867 109.514 134.326 107.622 134.326Z"
            fill="white"
          />
          <path
            d="M111.038 128.279C109.166 128.279 107.655 129.799 107.655 131.662C107.655 133.525 109.166 135.052 111.038 135.052C112.909 135.052 114.42 133.533 114.42 131.662C114.42 129.79 112.909 128.279 111.038 128.279Z"
            fill="white"
          />
          <path
            d="M113.982 122.504C112.149 122.504 110.672 123.981 110.672 125.814C110.672 127.647 112.149 129.124 113.982 129.124C115.815 129.124 117.292 127.643 117.292 125.814C117.292 123.985 115.815 122.504 113.982 122.504Z"
            fill="white"
          />
          <path
            d="M116.499 117.016C114.709 117.016 113.24 118.471 113.24 120.275C113.24 122.078 114.709 123.538 116.499 123.538C118.29 123.538 119.767 122.074 119.767 120.275C119.767 118.475 118.299 117.016 116.499 117.016Z"
            fill="white"
          />
          <path
            d="M118.676 111.877C116.906 111.877 115.48 113.311 115.48 115.081C115.48 116.851 116.906 118.285 118.676 118.285C120.446 118.285 121.88 116.851 121.88 115.081C121.88 113.311 120.446 111.877 118.676 111.877Z"
            fill="white"
          />
          <path
            d="M120.578 107.016C118.838 107.016 117.425 108.433 117.425 110.177C117.425 111.921 118.842 113.33 120.578 113.33C122.314 113.33 123.731 111.913 123.731 110.177C123.731 108.442 122.326 107.016 120.578 107.016Z"
            fill="white"
          />
          <path
            d="M122.267 102.43C120.569 102.43 119.194 103.809 119.194 105.506C119.194 107.204 120.569 108.579 122.267 108.579C123.964 108.579 125.348 107.204 125.348 105.506C125.348 103.809 123.964 102.43 122.267 102.43Z"
            fill="white"
          />
          <path
            d="M123.785 97.9844C122.122 97.9844 120.776 99.3254 120.776 100.993C120.776 102.661 122.117 104.01 123.785 104.01C125.453 104.01 126.802 102.657 126.802 100.993C126.802 99.3296 125.449 97.9844 123.785 97.9844Z"
            fill="white"
          />
          <path
            d="M125.191 93.5977C123.557 93.5977 122.237 94.9217 122.237 96.5556C122.237 98.1894 123.557 99.505 125.191 99.505C126.825 99.505 128.149 98.1851 128.149 96.5556C128.149 94.926 126.829 93.5977 125.191 93.5977Z"
            fill="white"
          />
          <path
            d="M126.545 89.209C124.94 89.209 123.65 90.4991 123.65 92.1032C123.65 93.7074 124.94 94.9975 126.545 94.9975C128.149 94.9975 129.439 93.6946 129.439 92.1032C129.439 90.5118 128.136 89.209 126.545 89.209Z"
            fill="white"
          />
          <path
            d="M127.906 84.7012C126.357 84.7012 125.097 85.9488 125.097 87.502C125.097 89.0553 126.357 90.3029 127.906 90.3029C129.455 90.3029 130.707 89.0468 130.707 87.502C130.707 85.9573 129.447 84.7012 127.906 84.7012Z"
            fill="white"
          />
          <path
            d="M129.353 79.8711C127.843 79.8711 126.616 81.0975 126.616 82.6083C126.616 84.1191 127.843 85.3498 129.353 85.3498C130.864 85.3498 132.091 84.1276 132.091 82.6083C132.091 81.089 130.873 79.8711 129.353 79.8711Z"
            fill="white"
          />
          <path
            d="M131.009 74.5742C129.533 74.5742 128.336 75.771 128.336 77.252C128.336 78.7331 129.533 79.9341 131.009 79.9341C132.486 79.9341 133.683 78.7373 133.683 77.252C133.683 75.7667 132.486 74.5742 131.009 74.5742Z"
            fill="white"
          />
          <path
            d="M133.05 68.4551C131.603 68.4551 130.428 69.6221 130.428 71.0692C130.428 72.5163 131.603 73.6834 133.05 73.6834C134.497 73.6834 135.665 72.5163 135.665 71.0692C135.665 69.6221 134.489 68.4551 133.05 68.4551Z"
            fill="white"
          />
          <path
            d="M135.786 61.1387C134.39 61.1387 133.257 62.2633 133.257 63.6595C133.257 65.0556 134.39 66.1887 135.786 66.1887C137.182 66.1887 138.307 65.0599 138.307 63.6595C138.307 62.259 137.182 61.1387 135.786 61.1387Z"
            fill="white"
          />
          <path
            d="M139.836 52.0098C138.482 52.0098 137.379 53.1131 137.379 54.4711C137.379 55.8291 138.482 56.9325 139.836 56.9325C141.19 56.9325 142.302 55.8291 142.302 54.4711C142.302 53.1131 141.198 52.0098 139.836 52.0098Z"
            fill="white"
          />
          <path
            d="M146.049 40.4512C144.729 40.4512 143.655 41.5164 143.655 42.8404C143.655 44.1645 144.729 45.2339 146.049 45.2339C147.369 45.2339 148.442 44.1602 148.442 42.8404C148.442 41.5206 147.369 40.4512 146.049 40.4512Z"
            fill="white"
          />
          <path
            d="M155.414 25.6523C154.132 25.6523 153.093 26.6963 153.093 27.9779C153.093 29.2595 154.132 30.3077 155.414 30.3077C156.696 30.3077 157.744 29.268 157.744 27.9779C157.744 26.6878 156.704 25.6523 155.414 25.6523Z"
            fill="white"
          />
          <path
            d="M169.228 6.50391C168.002 6.50391 167 7.50119 167 8.73187C167 9.96256 167.997 10.9598 169.228 10.9598C170.459 10.9598 171.456 9.96256 171.456 8.73187C171.456 7.50119 170.467 6.50391 169.228 6.50391Z"
            fill="white"
          />
          <path
            d="M933.777 2.74805C932.207 2.74805 930.934 4.01693 930.934 5.57863C930.934 7.14033 932.203 8.42194 933.777 8.42194C935.351 8.42194 936.608 7.15306 936.608 5.57863C936.608 4.0042 935.339 2.74805 933.777 2.74805Z"
            fill="white"
          />
          <path
            d="M941.4 13.3379C939.796 13.3379 938.497 14.6322 938.497 16.2364C938.497 17.8405 939.8 19.1349 941.4 19.1349C943 19.1349 944.294 17.8405 944.294 16.2364C944.294 14.6322 943.004 13.3379 941.4 13.3379Z"
            fill="white"
          />
          <path
            d="M948.967 23.9004C947.333 23.9004 946.009 25.2244 946.009 26.8583C946.009 28.4921 947.333 29.8204 948.967 29.8204C950.601 29.8204 951.925 28.4921 951.925 26.8583C951.925 25.2244 950.605 23.9004 948.967 23.9004Z"
            fill="white"
          />
          <path
            d="M956.47 34.5137C954.806 34.5137 953.461 35.8632 953.461 37.5267C953.461 39.1903 954.802 40.5398 956.47 40.5398C958.138 40.5398 959.487 39.1903 959.487 37.5267C959.487 35.8632 958.133 34.5137 956.47 34.5137Z"
            fill="white"
          />
          <path
            d="M963.942 45.1094C962.223 45.1094 960.831 46.4971 960.831 48.2116C960.831 49.926 962.227 51.318 963.942 51.318C965.656 51.318 967.044 49.9303 967.044 48.2116C967.044 46.4928 965.648 45.1094 963.942 45.1094Z"
            fill="white"
          />
          <path
            d="M971.393 55.7031C969.653 55.7031 968.24 57.1205 968.24 58.8562C968.24 60.5919 969.658 62.0093 971.393 62.0093C973.129 62.0093 974.546 60.6004 974.546 58.8562C974.546 57.1121 973.129 55.7031 971.393 55.7031Z"
            fill="white"
          />
          <path
            d="M978.812 66.291C977.043 66.291 975.608 67.7254 975.608 69.5078C975.608 71.2901 977.047 72.7118 978.812 72.7118C980.578 72.7118 982.029 71.2774 982.029 69.5078C982.029 67.7381 980.595 66.291 978.812 66.291Z"
            fill="white"
          />
          <path
            d="M986.204 76.8965C984.392 76.8965 982.937 78.3648 982.937 80.1642C982.937 81.9635 984.392 83.4361 986.204 83.4361C988.016 83.4361 989.472 81.972 989.472 80.1642C989.472 78.3563 988.004 76.8965 986.204 76.8965Z"
            fill="white"
          />
          <path
            d="M993.552 87.5176C991.701 87.5176 990.199 89.0156 990.199 90.8617C990.199 92.7077 991.697 94.2142 993.552 94.2142C995.406 94.2142 996.904 92.7162 996.904 90.8617C996.904 89.0071 995.406 87.5176 993.552 87.5176Z"
            fill="white"
          />
          <path
            d="M1000.86 98.2129C998.986 98.2129 997.463 99.7322 997.463 101.612C997.463 103.492 998.982 105.011 1000.86 105.011C1002.73 105.011 1004.26 103.492 1004.26 101.612C1004.26 99.7322 1002.73 98.2129 1000.86 98.2129Z"
            fill="white"
          />
          <path
            d="M1008.15 108.953C1006.24 108.953 1004.7 110.498 1004.7 112.399C1004.7 114.3 1006.24 115.845 1008.15 115.845C1010.05 115.845 1011.58 114.304 1011.58 112.399C1011.58 110.494 1010.04 108.953 1008.15 108.953Z"
            fill="white"
          />
          <path
            d="M1015.37 119.795C1013.44 119.795 1011.87 121.357 1011.87 123.288C1011.87 125.218 1013.44 126.78 1015.37 126.78C1017.29 126.78 1018.86 125.218 1018.86 123.288C1018.86 121.357 1017.3 119.795 1015.37 119.795Z"
            fill="white"
          />
          <path
            d="M1022.53 130.785C1020.56 130.785 1018.97 132.381 1018.97 134.35C1018.97 136.319 1020.56 137.91 1022.53 137.91C1024.5 137.91 1026.1 136.319 1026.1 134.35C1026.1 132.381 1024.49 130.785 1022.53 130.785Z"
            fill="white"
          />
          <path
            d="M1029.65 141.961C1027.65 141.961 1026.04 143.574 1026.04 145.568C1026.04 147.563 1027.65 149.167 1029.65 149.167C1031.65 149.167 1033.25 147.554 1033.25 145.568C1033.25 143.582 1031.63 141.961 1029.65 141.961Z"
            fill="white"
          />
          <path
            d="M1036.69 153.344C1034.69 153.344 1033.05 154.978 1033.05 156.993C1033.05 159.009 1034.69 160.643 1036.69 160.643C1038.7 160.643 1040.35 159.009 1040.35 156.993C1040.35 154.978 1038.71 153.344 1036.69 153.344Z"
            fill="white"
          />
          <path
            d="M1043.72 164.924C1041.67 164.924 1040.02 166.579 1040.02 168.62C1040.02 170.661 1041.67 172.308 1043.72 172.308C1045.76 172.308 1047.41 170.657 1047.41 168.62C1047.41 166.583 1045.76 164.924 1043.72 164.924Z"
            fill="white"
          />
          <path
            d="M1050.73 176.666C1048.66 176.666 1046.98 178.347 1046.98 180.422C1046.98 182.497 1048.66 184.169 1050.73 184.169C1052.8 184.169 1054.49 182.493 1054.49 180.422C1054.49 178.351 1052.8 176.666 1050.73 176.666Z"
            fill="white"
          />
          <path
            d="M1057.81 188.555C1055.72 188.555 1054.02 190.252 1054.02 192.344C1054.02 194.437 1055.72 196.134 1057.81 196.134C1059.9 196.134 1061.6 194.437 1061.6 192.344C1061.6 190.252 1059.9 188.555 1057.81 188.555Z"
            fill="white"
          />
          <path
            d="M1064.99 200.436C1062.88 200.436 1061.16 202.154 1061.16 204.268C1061.16 206.381 1062.88 208.108 1064.99 208.108C1067.1 208.108 1068.83 206.39 1068.83 204.268C1068.83 202.146 1067.11 200.436 1064.99 200.436Z"
            fill="white"
          />
          <path
            d="M1072.42 219.825C1074.55 219.825 1076.28 218.096 1076.28 215.963C1076.28 213.831 1074.55 212.102 1072.42 212.102C1070.29 212.102 1068.56 213.831 1068.56 215.963C1068.56 218.096 1070.29 219.825 1072.42 219.825Z"
            fill="white"
          />
          <path
            d="M1080.18 223.221C1078.01 223.221 1076.27 224.982 1076.27 227.133C1076.27 229.285 1078.01 231.046 1080.18 231.046C1082.34 231.046 1084.09 229.298 1084.09 227.133C1084.09 224.969 1082.33 223.221 1080.18 223.221Z"
            fill="white"
          />
          <path
            d="M1088.31 233.598C1086.14 233.598 1084.38 235.359 1084.38 237.532C1084.38 239.704 1086.14 241.474 1088.31 241.474C1090.49 241.474 1092.26 239.704 1092.26 237.532C1092.26 235.359 1090.49 233.598 1088.31 233.598Z"
            fill="white"
          />
          <path
            d="M1096.86 242.982C1094.68 242.982 1092.9 244.761 1092.9 246.946C1092.9 249.132 1094.68 250.922 1096.86 250.922C1099.05 250.922 1100.84 249.144 1100.84 246.946C1100.84 244.748 1099.06 242.982 1096.86 242.982Z"
            fill="white"
          />
          <path
            d="M1105.78 259.335C1107.99 259.335 1109.78 257.545 1109.78 255.337C1109.78 253.13 1107.99 251.34 1105.78 251.34C1103.57 251.34 1101.78 253.13 1101.78 255.337C1101.78 257.545 1103.57 259.335 1105.78 259.335Z"
            fill="white"
          />
          <path
            d="M1115 258.682C1112.77 258.682 1110.96 260.494 1110.96 262.722C1110.96 264.95 1112.77 266.77 1115 266.77C1117.24 266.77 1119.04 264.958 1119.04 262.722C1119.04 260.485 1117.23 258.682 1115 258.682Z"
            fill="white"
          />
          <path
            d="M1124.45 265.162C1122.21 265.162 1120.38 266.974 1120.38 269.219C1120.38 271.464 1122.21 273.28 1124.45 273.28C1126.7 273.28 1128.51 271.468 1128.51 269.219C1128.51 266.97 1126.69 265.162 1124.45 265.162Z"
            fill="white"
          />
          <path
            d="M1134.07 270.877C1131.81 270.877 1129.98 272.71 1129.98 274.968C1129.98 277.226 1131.81 279.059 1134.07 279.059C1136.33 279.059 1138.17 277.226 1138.17 274.968C1138.17 272.71 1136.34 270.877 1134.07 270.877Z"
            fill="white"
          />
          <path
            d="M1143.83 276C1141.56 276 1139.72 277.833 1139.72 280.099C1139.72 282.366 1141.56 284.212 1143.83 284.212C1146.1 284.212 1147.94 282.37 1147.94 280.099C1147.94 277.829 1146.1 276 1143.83 276Z"
            fill="white"
          />
          <path
            d="M1153.7 280.602C1151.42 280.602 1149.56 282.456 1149.56 284.735C1149.56 287.014 1151.41 288.877 1153.7 288.877C1155.98 288.877 1157.84 287.027 1157.84 284.735C1157.84 282.443 1155.98 280.602 1153.7 280.602Z"
            fill="white"
          />
          <path
            d="M1163.65 284.814C1161.36 284.814 1159.49 286.669 1159.49 288.969C1159.49 291.269 1161.36 293.124 1163.65 293.124C1165.94 293.124 1167.8 291.261 1167.8 288.969C1167.8 286.677 1165.94 284.814 1163.65 284.814Z"
            fill="white"
          />
          <path
            d="M1173.64 288.727C1171.35 288.727 1169.48 290.577 1169.48 292.881C1169.48 295.186 1171.35 297.036 1173.64 297.036C1175.93 297.036 1177.8 295.173 1177.8 292.881C1177.8 290.59 1175.94 288.727 1173.64 288.727Z"
            fill="white"
          />
          <path
            d="M1183.67 292.369C1181.37 292.369 1179.51 294.232 1179.51 296.532C1179.51 298.832 1181.37 300.687 1183.67 300.687C1185.97 300.687 1187.83 298.824 1187.83 296.532C1187.83 294.241 1185.97 292.369 1183.67 292.369Z"
            fill="white"
          />
          <path
            d="M1193.71 295.771C1191.41 295.771 1189.55 297.634 1189.55 299.926C1189.55 302.218 1191.4 304.081 1193.71 304.081C1196.01 304.081 1197.86 302.226 1197.86 299.926C1197.86 297.626 1196 295.771 1193.71 295.771Z"
            fill="white"
          />
          <path
            d="M1203.73 298.928C1201.43 298.928 1199.57 300.791 1199.57 303.082C1199.57 305.374 1201.43 307.233 1203.73 307.233C1206.03 307.233 1207.88 305.382 1207.88 303.082C1207.88 300.782 1206.02 298.928 1203.73 298.928Z"
            fill="white"
          />
          <path
            d="M1213.71 301.811C1211.41 301.811 1209.55 303.661 1209.55 305.965C1209.55 308.27 1211.4 310.12 1213.71 310.12C1216.01 310.12 1217.86 308.257 1217.86 305.965C1217.86 303.674 1216 301.811 1213.71 301.811Z"
            fill="white"
          />
          <path
            d="M1223.6 304.398C1221.31 304.398 1219.44 306.261 1219.44 308.553C1219.44 310.845 1221.3 312.708 1223.6 312.708C1225.89 312.708 1227.75 310.853 1227.75 308.553C1227.75 306.253 1225.9 304.398 1223.6 304.398Z"
            fill="white"
          />
          <path
            d="M1233.38 306.684C1231.09 306.684 1229.23 308.538 1229.23 310.838C1229.23 313.138 1231.09 314.993 1233.38 314.993C1235.67 314.993 1237.54 313.13 1237.54 310.838C1237.54 308.547 1235.67 306.684 1233.38 306.684Z"
            fill="white"
          />
          <path
            d="M1229.5 307.014C1227.21 307.014 1225.34 308.868 1225.34 311.168C1225.34 313.468 1227.21 315.323 1229.5 315.323C1231.79 315.323 1233.65 313.46 1233.65 311.168C1233.65 308.877 1231.8 307.014 1229.5 307.014Z"
            fill="white"
          />
          <path
            d="M1225.26 307.158C1222.98 307.158 1221.11 309.021 1221.11 311.313C1221.11 313.604 1222.97 315.467 1225.26 315.467C1227.56 315.467 1229.43 313.613 1229.43 311.313C1229.43 309.013 1227.56 307.158 1225.26 307.158Z"
            fill="white"
          />
          <path
            d="M1220.65 307.148C1218.36 307.148 1216.5 309.003 1216.5 311.303C1216.5 313.603 1218.36 315.458 1220.65 315.458C1222.94 315.458 1224.81 313.595 1224.81 311.303C1224.81 309.011 1222.95 307.148 1220.65 307.148Z"
            fill="white"
          />
          <path
            d="M1215.66 306.971C1213.36 306.971 1211.49 308.834 1211.49 311.125C1211.49 313.417 1213.36 315.28 1215.66 315.28C1217.96 315.28 1219.81 313.43 1219.81 311.125C1219.81 308.821 1217.95 306.971 1215.66 306.971Z"
            fill="white"
          />
          <path
            d="M1210.25 306.66C1207.96 306.66 1206.1 308.515 1206.1 310.815C1206.1 313.115 1207.96 314.969 1210.25 314.969C1212.55 314.969 1214.41 313.106 1214.41 310.815C1214.41 308.523 1212.55 306.66 1210.25 306.66Z"
            fill="white"
          />
          <path
            d="M1204.47 306.191C1202.18 306.191 1200.32 308.054 1200.32 310.346C1200.32 312.638 1202.18 314.501 1204.47 314.501C1206.76 314.501 1208.62 312.65 1208.62 310.346C1208.62 308.042 1206.76 306.191 1204.47 306.191Z"
            fill="white"
          />
          <path
            d="M1198.29 305.607C1196 305.607 1194.14 307.458 1194.14 309.762C1194.14 312.066 1196 313.917 1198.29 313.917C1200.59 313.917 1202.45 312.054 1202.45 309.762C1202.45 307.47 1200.59 305.607 1198.29 305.607Z"
            fill="white"
          />
          <path
            d="M1191.75 304.9C1189.46 304.9 1187.6 306.763 1187.6 309.055C1187.6 311.347 1189.46 313.21 1191.75 313.21C1194.04 313.21 1195.9 311.359 1195.9 309.055C1195.9 306.751 1194.04 304.9 1191.75 304.9Z"
            fill="white"
          />
          <path
            d="M1184.85 304.111C1182.55 304.111 1180.69 305.974 1180.69 308.266C1180.69 310.558 1182.55 312.421 1184.85 312.421C1187.15 312.421 1189.01 310.566 1189.01 308.266C1189.01 305.966 1187.14 304.111 1184.85 304.111Z"
            fill="white"
          />
          <path
            d="M1177.59 303.268C1175.29 303.268 1173.44 305.122 1173.44 307.422C1173.44 309.722 1175.29 311.577 1177.59 311.577C1179.89 311.577 1181.75 309.714 1181.75 307.422C1181.75 305.131 1179.89 303.268 1177.59 303.268Z"
            fill="white"
          />
          <path
            d="M1170.01 302.385C1167.71 302.385 1165.85 304.248 1165.85 306.539C1165.85 308.831 1167.71 310.694 1170.01 310.694C1172.31 310.694 1174.16 308.831 1174.16 306.539C1174.16 304.248 1172.3 302.385 1170.01 302.385Z"
            fill="white"
          />
          <path
            d="M1162.1 301.518C1159.8 301.518 1157.95 303.368 1157.95 305.651C1157.95 307.934 1159.8 309.793 1162.1 309.793C1164.39 309.793 1166.23 307.943 1166.23 305.651C1166.23 303.359 1164.38 301.518 1162.1 301.518Z"
            fill="white"
          />
          <path
            d="M1153.86 300.656C1151.58 300.656 1149.74 302.498 1149.74 304.777C1149.74 307.056 1151.58 308.91 1153.86 308.91C1156.14 308.91 1158 307.056 1158 304.777C1158 302.498 1156.14 300.656 1153.86 300.656Z"
            fill="white"
          />
          <path
            d="M1145.32 299.842C1143.05 299.842 1141.22 301.684 1141.22 303.954C1141.22 306.224 1143.05 308.066 1145.32 308.066C1147.59 308.066 1149.43 306.224 1149.43 303.954C1149.43 301.684 1147.6 299.842 1145.32 299.842Z"
            fill="white"
          />
          <path
            d="M1136.48 299.135C1134.23 299.135 1132.39 300.955 1132.39 303.213C1132.39 305.471 1134.23 307.304 1136.48 307.304C1138.74 307.304 1140.57 305.471 1140.57 303.213C1140.57 300.955 1138.74 299.135 1136.48 299.135Z"
            fill="white"
          />
          <path
            d="M1127.36 298.564C1125.12 298.564 1123.31 300.385 1123.31 302.613C1123.31 304.841 1125.12 306.662 1127.36 306.662C1129.59 306.662 1131.4 304.849 1131.4 302.613C1131.4 300.377 1129.59 298.564 1127.36 298.564Z"
            fill="white"
          />
          <path
            d="M1117.96 298.166C1115.73 298.166 1113.93 299.965 1113.93 302.193C1113.93 304.421 1115.73 306.221 1117.96 306.221C1120.18 306.221 1121.98 304.421 1121.98 302.193C1121.98 299.965 1120.18 298.166 1117.96 298.166Z"
            fill="white"
          />
          <path
            d="M1108.3 297.957C1106.09 297.957 1104.3 299.748 1104.3 301.955C1104.3 304.161 1106.09 305.961 1108.3 305.961C1110.5 305.961 1112.3 304.17 1112.3 301.955C1112.3 299.739 1110.5 297.957 1108.3 297.957Z"
            fill="white"
          />
          <path
            d="M1098.39 297.957C1096.19 297.957 1094.41 299.735 1094.41 301.933C1094.41 304.132 1096.19 305.91 1098.39 305.91C1100.59 305.91 1102.36 304.132 1102.36 301.933C1102.36 299.735 1100.59 297.957 1098.39 297.957Z"
            fill="white"
          />
          <path
            d="M1088.25 298.242C1086.08 298.242 1084.32 300.003 1084.32 302.176C1084.32 304.349 1086.08 306.102 1088.25 306.102C1090.43 306.102 1092.18 304.345 1092.18 302.176C1092.18 300.008 1090.42 298.242 1088.25 298.242Z"
            fill="white"
          />
          <path
            d="M1077.88 298.814C1075.72 298.814 1073.97 300.563 1073.97 302.719C1073.97 304.875 1075.72 306.623 1077.88 306.623C1080.03 306.623 1081.78 304.875 1081.78 302.719C1081.78 300.563 1080.03 298.814 1077.88 298.814Z"
            fill="white"
          />
          <path
            d="M1067.29 299.75C1065.17 299.75 1063.43 301.477 1063.43 303.612C1063.43 305.746 1065.17 307.474 1067.29 307.474C1069.41 307.474 1071.15 305.746 1071.15 303.612C1071.15 301.477 1069.42 299.75 1067.29 299.75Z"
            fill="white"
          />
          <path
            d="M1056.5 300.996C1054.39 300.996 1052.67 302.715 1052.67 304.828C1052.67 306.942 1054.39 308.656 1056.5 308.656C1058.61 308.656 1060.33 306.95 1060.33 304.828C1060.33 302.706 1058.62 300.996 1056.5 300.996Z"
            fill="white"
          />
          <path
            d="M1045.5 302.635C1043.42 302.635 1041.73 304.32 1041.73 306.412C1041.73 308.504 1043.42 310.18 1045.5 310.18C1047.58 310.18 1049.28 308.495 1049.28 306.412C1049.28 304.328 1047.58 302.635 1045.5 302.635Z"
            fill="white"
          />
          <path
            d="M1034.32 304.65C1032.26 304.65 1030.59 306.327 1030.59 308.398C1030.59 310.469 1032.26 312.132 1034.32 312.132C1036.38 312.132 1038.07 310.456 1038.07 308.398C1038.07 306.339 1036.39 304.65 1034.32 304.65Z"
            fill="white"
          />
          <path
            d="M1023.01 307.158C1020.97 307.158 1019.31 308.813 1019.31 310.863C1019.31 312.913 1020.97 314.559 1023.01 314.559C1025.05 314.559 1026.7 312.904 1026.7 310.863C1026.7 308.822 1025.05 307.158 1023.01 307.158Z"
            fill="white"
          />
          <path
            d="M1011.54 310.102C1009.52 310.102 1007.88 311.735 1007.88 313.755C1007.88 315.775 1009.52 317.409 1011.54 317.409C1013.56 317.409 1015.2 315.775 1015.2 313.755C1015.2 311.735 1013.55 310.102 1011.54 310.102Z"
            fill="white"
          />
          <path
            d="M999.971 313.49C997.985 313.49 996.368 315.094 996.368 317.08C996.368 319.067 997.981 320.683 999.971 320.683C1001.96 320.683 1003.56 319.071 1003.56 317.08C1003.56 315.09 1001.95 313.49 999.971 313.49Z"
            fill="white"
          />
          <path
            d="M988.306 317.34C986.349 317.34 984.758 318.931 984.758 320.888C984.758 322.844 986.349 324.435 988.306 324.435C990.262 324.435 991.853 322.844 991.853 320.888C991.853 318.931 990.262 317.34 988.306 317.34Z"
            fill="white"
          />
          <path
            d="M976.576 321.783C974.649 321.783 973.079 323.353 973.079 325.293C973.079 327.232 974.649 328.79 976.576 328.79C978.503 328.79 980.081 327.228 980.081 325.293C980.081 323.358 978.511 321.783 976.576 321.783Z"
            fill="white"
          />
          <path
            d="M964.846 326.984C962.941 326.984 961.392 328.533 961.392 330.452C961.392 332.37 962.941 333.906 964.846 333.906C966.752 333.906 968.313 332.357 968.313 330.452C968.313 328.546 966.764 326.984 964.846 326.984Z"
            fill="white"
          />
          <path
            d="M953.109 333.125C951.233 333.125 949.718 334.636 949.718 336.507C949.718 338.379 951.237 339.89 953.109 339.89C954.98 339.89 956.491 338.379 956.491 336.507C956.491 334.636 954.972 333.125 953.109 333.125Z"
            fill="white"
          />
          <path
            d="M941.437 340.369C939.596 340.369 938.098 341.859 938.098 343.709C938.098 345.559 939.596 347.049 941.437 347.049C943.279 347.049 944.777 345.551 944.777 343.709C944.777 341.867 943.288 340.369 941.437 340.369Z"
            fill="white"
          />
          <path
            d="M930 349.096C928.188 349.096 926.72 350.564 926.72 352.376C926.72 354.188 928.188 355.657 930 355.657C931.812 355.657 933.289 354.188 933.289 352.376C933.289 350.564 931.812 349.096 930 349.096Z"
            fill="white"
          />
          <path
            d="M918.823 359.512C917.032 359.512 915.585 360.967 915.585 362.758C915.585 364.549 917.032 365.996 918.823 365.996C920.614 365.996 922.061 364.549 922.061 362.758C922.061 360.967 920.614 359.512 918.823 359.512Z"
            fill="white"
          />
          <path
            d="M908.267 372.23C906.519 372.23 905.102 373.648 905.102 375.396C905.102 377.145 906.519 378.558 908.267 378.558C910.016 378.558 911.42 377.14 911.42 375.396C911.42 373.652 910.003 372.23 908.267 372.23Z"
            fill="white"
          />
          <path
            d="M898.486 387.365C896.78 387.365 895.384 388.749 895.384 390.455C895.384 392.161 896.78 393.557 898.486 393.557C900.192 393.557 901.588 392.173 901.588 390.455C901.588 388.736 900.205 387.365 898.486 387.365Z"
            fill="white"
          />
          <path
            d="M890.004 405.516C888.328 405.516 886.966 406.878 886.966 408.567C886.966 410.256 888.328 411.605 890.004 411.605C891.681 411.605 893.043 410.243 893.043 408.567C893.043 406.891 891.689 405.516 890.004 405.516Z"
            fill="white"
          />
          <path
            d="M883.778 427.578C882.131 427.578 880.803 428.919 880.803 430.566C880.803 432.212 882.135 433.553 883.778 433.553C885.42 433.553 886.765 432.212 886.765 430.566C886.765 428.919 885.433 427.578 883.778 427.578Z"
            fill="white"
          />
          <path
            d="M880.947 454.285C879.343 454.285 878.053 455.588 878.053 457.188C878.053 458.788 879.343 460.082 880.947 460.082C882.551 460.082 883.841 458.792 883.841 457.188C883.841 455.584 882.551 454.285 880.947 454.285Z"
            fill="white"
          />
          <path
            d="M882.3 485.799C880.73 485.799 879.457 487.068 879.457 488.642C879.457 490.217 880.726 491.485 882.3 491.485C883.875 491.485 885.152 490.217 885.152 488.642C885.152 487.068 883.871 485.799 882.3 485.799Z"
            fill="white"
          />
          <path
            d="M887.66 521.982C886.12 521.982 884.872 523.23 884.872 524.771C884.872 526.311 886.12 527.559 887.66 527.559C889.201 527.559 890.44 526.311 890.44 524.771C890.44 523.23 889.192 521.982 887.66 521.982Z"
            fill="white"
          />
          <path
            d="M895.562 562.602C894.051 562.602 892.833 563.828 892.833 565.33C892.833 566.833 894.051 568.068 895.562 568.068C897.073 568.068 898.291 566.841 898.291 565.33C898.291 563.82 897.073 562.602 895.562 562.602Z"
            fill="white"
          />
          <path
            d="M904.169 607.531C902.713 607.531 901.533 608.707 901.533 610.154C901.533 611.601 902.709 612.785 904.169 612.785C905.629 612.785 906.791 611.61 906.791 610.154C906.791 608.698 905.616 607.531 904.169 607.531Z"
            fill="white"
          />
          <path
            d="M551.051 678.545C549.76 678.545 548.708 679.585 548.708 680.875C548.708 682.165 549.76 683.217 551.051 683.217C552.341 683.217 553.393 682.165 553.393 680.875C553.393 679.585 552.341 678.545 551.051 678.545Z"
            fill="white"
          />
          <path
            d="M536.563 675.393C535.273 675.393 534.233 676.432 534.233 677.722C534.233 679.012 535.273 680.052 536.563 680.052C537.853 680.052 538.893 679.012 538.893 677.722C538.893 676.432 537.853 675.393 536.563 675.393Z"
            fill="white"
          />
          <path
            d="M522.032 672.592C520.75 672.592 519.702 673.644 519.702 674.922C519.702 676.199 520.755 677.251 522.032 677.251C523.309 677.251 524.362 676.212 524.362 674.922C524.362 673.632 523.322 672.592 522.032 672.592Z"
            fill="white"
          />
          <path
            d="M507.523 670.428C506.233 670.428 505.193 671.467 505.193 672.758C505.193 674.048 506.233 675.079 507.523 675.079C508.813 675.079 509.853 674.039 509.853 672.758C509.853 671.476 508.813 670.428 507.523 670.428Z"
            fill="white"
          />
          <path
            d="M492.975 668.52C491.693 668.52 490.653 669.559 490.653 670.841C490.653 672.122 491.693 673.171 492.975 673.171C494.256 673.171 495.296 672.131 495.296 670.841C495.296 669.551 494.256 668.52 492.975 668.52Z"
            fill="white"
          />
          <path
            d="M478.288 666.65C476.998 666.65 475.958 667.69 475.958 668.972C475.958 670.253 476.998 671.293 478.288 671.293C479.578 671.293 480.609 670.253 480.609 668.972C480.609 667.69 479.569 666.65 478.288 666.65Z"
            fill="white"
          />
          <path
            d="M463.439 664.951C462.157 664.951 461.117 665.982 461.117 667.272C461.117 668.563 462.157 669.594 463.439 669.594C464.72 669.594 465.76 668.554 465.76 667.272C465.76 665.991 464.72 664.951 463.439 664.951Z"
            fill="white"
          />
          <path
            d="M448.378 663.213C447.088 663.213 446.048 664.253 446.048 665.534C446.048 666.816 447.088 667.864 448.378 667.864C449.668 667.864 450.708 666.824 450.708 665.534C450.708 664.244 449.655 663.213 448.378 663.213Z"
            fill="white"
          />
          <path
            d="M432.982 661.154C431.692 661.154 430.652 662.194 430.652 663.476C430.652 664.757 431.692 665.805 432.982 665.805C434.272 665.805 435.304 664.766 435.304 663.476C435.304 662.186 434.264 661.154 432.982 661.154Z"
            fill="white"
          />
          <path
            d="M417.173 658.854C415.891 658.854 414.852 659.893 414.852 661.175C414.852 662.456 415.891 663.496 417.173 663.496C418.455 663.496 419.494 662.456 419.494 661.175C419.494 659.893 418.455 658.854 417.173 658.854Z"
            fill="white"
          />
          <path
            d="M400.894 656.096C399.612 656.096 398.572 657.135 398.572 658.417C398.572 659.699 399.612 660.738 400.894 660.738C402.175 660.738 403.223 659.699 403.223 658.417C403.223 657.135 402.184 656.096 400.894 656.096Z"
            fill="white"
          />
          <path
            d="M384.025 652.566C382.744 652.566 381.704 653.598 381.704 654.875C381.704 656.152 382.744 657.196 384.025 657.196C385.307 657.196 386.347 656.165 386.347 654.875C386.347 653.585 385.307 652.566 384.025 652.566Z"
            fill="white"
          />
          <path
            d="M366.478 648.395C365.196 648.395 364.156 649.434 364.156 650.716C364.156 651.997 365.196 653.037 366.478 653.037C367.759 653.037 368.799 651.997 368.799 650.716C368.799 649.434 367.759 648.395 366.478 648.395Z"
            fill="white"
          />
          <path
            d="M348.135 643.336C346.845 643.336 345.806 644.376 345.806 645.666C345.806 646.956 346.845 647.987 348.135 647.987C349.426 647.987 350.457 646.947 350.457 645.666C350.457 644.384 349.417 643.336 348.135 643.336Z"
            fill="white"
          />
          <path
            d="M328.81 636.986C327.528 636.986 326.488 638.018 326.488 639.308C326.488 640.598 327.528 641.629 328.81 641.629C330.091 641.629 331.139 640.589 331.139 639.308C331.139 638.026 330.1 636.986 328.81 636.986Z"
            fill="white"
          />
          <path
            d="M308.41 629.314C307.129 629.314 306.089 630.354 306.089 631.636C306.089 632.917 307.129 633.957 308.41 633.957C309.692 633.957 310.732 632.917 310.732 631.636C310.732 630.354 309.692 629.314 308.41 629.314Z"
            fill="white"
          />
          <path
            d="M286.699 620.074C285.409 620.074 284.369 621.114 284.369 622.404C284.369 623.694 285.409 624.734 286.699 624.734C287.989 624.734 289.029 623.694 289.029 622.404C289.029 621.114 287.989 620.074 286.699 620.074Z"
            fill="white"
          />
          <path
            d="M263.448 609.688C262.158 609.688 261.118 610.727 261.118 612.017C261.118 613.307 262.158 614.347 263.448 614.347C264.738 614.347 265.769 613.295 265.769 612.017C265.769 610.74 264.73 609.688 263.448 609.688Z"
            fill="white"
          />
          <path
            d="M238.418 598.236C237.136 598.236 236.097 599.276 236.097 600.558C236.097 601.839 237.136 602.888 238.418 602.888C239.7 602.888 240.748 601.848 240.748 600.558C240.748 599.268 239.708 598.236 238.418 598.236Z"
            fill="white"
          />
          <path
            d="M226.574 589.502C225.254 589.502 224.172 590.576 224.172 591.904C224.172 593.232 225.254 594.297 226.574 594.297C227.894 594.297 228.967 593.224 228.967 591.904C228.967 590.584 227.894 589.502 226.574 589.502Z"
            fill="white"
          />
          <path
            d="M215.46 581.334C214.098 581.334 212.994 582.429 212.994 583.791C212.994 585.153 214.098 586.248 215.46 586.248C216.822 586.248 217.917 585.145 217.917 583.791C217.917 582.437 216.814 581.334 215.46 581.334Z"
            fill="white"
          />
          <path
            d="M205.758 573.861C204.353 573.861 203.207 574.994 203.207 576.412C203.207 577.829 204.353 578.962 205.758 578.962C207.162 578.962 208.308 577.817 208.308 576.412C208.308 575.007 207.175 573.861 205.758 573.861Z"
            fill="white"
          />
          <path
            d="M197.827 567.262C196.393 567.262 195.226 568.429 195.226 569.876C195.226 571.323 196.393 572.49 197.827 572.49C199.261 572.49 200.441 571.315 200.441 569.876C200.441 568.437 199.274 567.262 197.827 567.262Z"
            fill="white"
          />
          <path
            d="M191.686 561.541C190.209 561.541 189 562.738 189 564.215C189 565.691 190.205 566.901 191.686 566.901C193.167 566.901 194.36 565.704 194.36 564.215C194.36 562.725 193.163 561.541 191.686 561.541Z"
            fill="white"
          />
          <path
            d="M187.076 556.627C185.565 556.627 184.339 557.853 184.339 559.364C184.339 560.875 185.565 562.101 187.076 562.101C188.587 562.101 189.822 560.883 189.822 559.364C189.822 557.845 188.595 556.627 187.076 556.627Z"
            fill="white"
          />
          <path
            d="M183.734 552.393C182.172 552.393 180.903 553.653 180.903 555.223C180.903 556.793 182.172 558.054 183.734 558.054C185.296 558.054 186.564 556.785 186.564 555.223C186.564 553.661 185.304 552.393 183.734 552.393Z"
            fill="white"
          />
          <path
            d="M181.374 548.746C179.782 548.746 178.479 550.036 178.479 551.628C178.479 553.219 179.782 554.522 181.374 554.522C182.965 554.522 184.268 553.232 184.268 551.628C184.268 550.023 182.965 548.746 181.374 548.746Z"
            fill="white"
          />
          <path
            d="M179.592 545.459C177.958 545.459 176.634 546.783 176.634 548.417C176.634 550.051 177.958 551.362 179.592 551.362C181.226 551.362 182.537 550.042 182.537 548.417C182.537 546.792 181.213 545.459 179.592 545.459Z"
            fill="white"
          />
          <path
            d="M178.115 542.389C176.46 542.389 175.106 543.73 175.106 545.398C175.106 547.065 176.46 548.406 178.115 548.406C179.77 548.406 181.133 547.065 181.133 545.398C181.133 543.73 179.779 542.389 178.115 542.389Z"
            fill="white"
          />
          <path
            d="M176.753 539.395C175.047 539.395 173.663 540.778 173.663 542.484C173.663 544.19 175.047 545.565 176.753 545.565C178.459 545.565 179.834 544.181 179.834 542.484C179.834 540.786 178.459 539.395 176.753 539.395Z"
            fill="white"
          />
          <path
            d="M175.284 536.393C173.549 536.393 172.14 537.797 172.14 539.537C172.14 541.277 173.544 542.682 175.284 542.682C177.024 542.682 178.429 541.277 178.429 539.537C178.429 537.797 177.011 536.393 175.284 536.393Z"
            fill="white"
          />
          <path
            d="M173.493 533.238C171.724 533.238 170.298 534.664 170.298 536.434C170.298 538.203 171.724 539.629 173.493 539.629C175.263 539.629 176.68 538.191 176.68 536.434C176.68 534.677 175.255 533.238 173.493 533.238Z"
            fill="white"
          />
          <path
            d="M171.329 529.857C169.529 529.857 168.069 531.313 168.069 533.117C168.069 534.92 169.525 536.363 171.329 536.363C173.132 536.363 174.575 534.907 174.575 533.117C174.575 531.326 173.119 529.857 171.329 529.857Z"
            fill="white"
          />
          <path
            d="M168.79 526.238C166.957 526.238 165.472 527.728 165.472 529.57C165.472 531.411 166.961 532.888 168.79 532.888C170.619 532.888 172.122 531.399 172.122 529.57C172.122 527.741 170.632 526.238 168.79 526.238Z"
            fill="white"
          />
          <path
            d="M165.905 522.414C164.05 522.414 162.544 523.925 162.544 525.788C162.544 527.651 164.055 529.162 165.905 529.162C167.755 529.162 169.279 527.651 169.279 525.788C169.279 523.925 167.768 522.414 165.905 522.414Z"
            fill="white"
          />
          <path
            d="M162.701 518.387C160.817 518.387 159.289 519.919 159.289 521.811C159.289 523.704 160.821 525.228 162.701 525.228C164.581 525.228 166.126 523.696 166.126 521.811C166.126 519.927 164.594 518.387 162.701 518.387Z"
            fill="white"
          />
          <path
            d="M159.192 514.174C157.278 514.174 155.725 515.723 155.725 517.641C155.725 519.559 157.274 521.095 159.192 521.095C161.11 521.095 162.646 519.542 162.646 517.641C162.646 515.74 161.097 514.174 159.192 514.174Z"
            fill="white"
          />
          <path
            d="M155.385 509.771C153.437 509.771 151.854 511.354 151.854 513.298C151.854 515.242 153.437 516.825 155.385 516.825C157.333 516.825 158.912 515.242 158.912 513.298C158.912 511.354 157.329 509.771 155.385 509.771Z"
            fill="white"
          />
          <path
            d="M151.294 505.252C149.325 505.252 147.725 506.843 147.725 508.821C147.725 510.799 149.329 512.39 151.294 512.39C153.258 512.39 154.863 510.786 154.863 508.821C154.863 506.856 153.258 505.252 151.294 505.252Z"
            fill="white"
          />
          <path
            d="M146.911 500.631C144.924 500.631 143.308 502.243 143.308 504.242C143.308 506.241 144.92 507.841 146.911 507.841C148.901 507.841 150.522 506.228 150.522 504.242C150.522 502.256 148.909 500.631 146.911 500.631Z"
            fill="white"
          />
          <path
            d="M142.251 495.949C140.243 495.949 138.597 497.583 138.597 499.603C138.597 501.623 140.243 503.257 142.251 503.257C144.258 503.257 145.904 501.623 145.904 499.603C145.904 497.583 144.271 495.949 142.251 495.949Z"
            fill="white"
          />
          <path
            d="M137.286 491.234C135.245 491.234 133.59 492.889 133.59 494.931C133.59 496.972 135.245 498.635 137.286 498.635C139.327 498.635 140.991 496.972 140.991 494.931C140.991 492.889 139.336 491.234 137.286 491.234Z"
            fill="white"
          />
          <path
            d="M135.687 490.868C136.002 488.834 134.609 486.931 132.575 486.616C130.542 486.301 128.638 487.694 128.323 489.728C128.008 491.762 129.401 493.665 131.435 493.98C133.469 494.295 135.372 492.902 135.687 490.868Z"
            fill="white"
          />
          <path
            d="M126.379 481.857C124.299 481.857 122.61 483.542 122.61 485.626C122.61 487.71 124.295 489.403 126.379 489.403C128.462 489.403 130.147 487.705 130.147 485.626C130.147 483.546 128.462 481.857 126.379 481.857Z"
            fill="white"
          />
          <path
            d="M120.391 477.234C118.299 477.234 116.593 478.94 116.593 481.045C116.593 483.15 118.299 484.843 120.391 484.843C122.483 484.843 124.202 483.137 124.202 481.045C124.202 478.953 122.496 477.234 120.391 477.234Z"
            fill="white"
          />
          <path
            d="M114.055 472.678C111.933 472.678 110.206 474.396 110.206 476.518C110.206 478.64 111.933 480.367 114.055 480.367C116.177 480.367 117.896 478.64 117.896 476.518C117.896 474.396 116.177 472.678 114.055 472.678Z"
            fill="white"
          />
          <path
            d="M107.328 468.234C105.194 468.234 103.458 469.974 103.458 472.105C103.458 474.235 105.198 475.975 107.328 475.975C109.459 475.975 111.199 474.235 111.199 472.105C111.199 469.974 109.463 468.234 107.328 468.234Z"
            fill="white"
          />
          <path
            d="M100.221 471.74C102.377 471.74 104.125 469.992 104.125 467.836C104.125 465.68 102.377 463.932 100.221 463.932C98.0644 463.932 96.3164 465.68 96.3164 467.836C96.3164 469.992 98.0644 471.74 100.221 471.74Z"
            fill="white"
          />
          <path
            d="M92.7262 459.707C90.5619 459.707 88.8135 461.468 88.8135 463.632C88.8135 465.797 90.5619 467.545 92.7262 467.545C94.8905 467.545 96.6517 465.797 96.6517 463.632C96.6517 461.468 94.8948 459.707 92.7262 459.707Z"
            fill="white"
          />
          <path
            d="M84.8917 455.451C82.7062 455.451 80.9365 457.221 80.9365 459.415C80.9365 461.609 82.7062 463.37 84.8917 463.37C87.0772 463.37 88.8554 461.6 88.8554 459.415C88.8554 457.229 87.0772 455.451 84.8917 455.451Z"
            fill="white"
          />
          <path
            d="M76.7606 451.145C74.5623 451.145 72.7842 452.923 72.7842 455.121C72.7842 457.319 74.5623 459.097 76.7606 459.097C78.9588 459.097 80.737 457.319 80.737 455.121C80.737 452.923 78.9588 451.145 76.7606 451.145Z"
            fill="white"
          />
          <path
            d="M68.3755 446.66C66.1688 446.66 64.3779 448.459 64.3779 450.666C64.3779 452.873 66.1688 454.672 68.3755 454.672C70.5823 454.672 72.3816 452.873 72.3816 450.666C72.3816 448.459 70.5908 446.66 68.3755 446.66Z"
            fill="white"
          />
          <path
            d="M59.7864 441.973C57.5712 441.973 55.7676 443.772 55.7676 445.991C55.7676 448.211 57.5669 449.998 59.7864 449.998C62.0059 449.998 63.7925 448.207 63.7925 445.991C63.7925 443.776 62.0016 441.973 59.7864 441.973Z"
            fill="white"
          />
          <path
            d="M51.002 437.01C48.774 437.01 46.9619 438.822 46.9619 441.05C46.9619 443.278 48.774 445.077 51.002 445.077C53.2299 445.077 55.0293 443.278 55.0293 441.05C55.0293 438.822 53.2299 437.01 51.002 437.01Z"
            fill="white"
          />
          <path
            d="M42.043 431.732C39.8065 431.732 38.0029 433.544 38.0029 435.772C38.0029 438 39.8023 439.821 42.043 439.821C44.2837 439.821 46.0915 438.009 46.0915 435.772C46.0915 433.536 44.2794 431.732 42.043 431.732Z"
            fill="white"
          />
          <path
            d="M32.9564 425.975C30.72 425.975 28.8994 427.795 28.8994 430.032C28.8994 432.268 30.72 434.089 32.9564 434.089C35.1929 434.089 37.0177 432.268 37.0177 430.032C37.0177 427.795 35.1971 425.975 32.9564 425.975Z"
            fill="white"
          />
          <path
            d="M23.808 419.604C21.5716 419.604 19.7383 421.424 19.7383 423.673C19.7383 425.922 21.5716 427.743 23.808 427.743C26.0445 427.743 27.8863 425.922 27.8863 423.673C27.8863 421.424 26.053 419.604 23.808 419.604Z"
            fill="white"
          />
          <path
            d="M14.6876 412.518C12.4299 412.518 10.6094 414.338 10.6094 416.596C10.6094 418.853 12.4299 420.674 14.6876 420.674C16.9453 420.674 18.7786 418.853 18.7786 416.596C18.7786 414.338 16.9453 412.518 14.6876 412.518Z"
            fill="white"
          />
          <path
            d="M5.67883 404.684C3.42964 404.684 1.60059 406.517 1.60059 408.775C1.60059 411.032 3.43389 412.853 5.67883 412.853C7.92377 412.853 9.7698 411.02 9.7698 408.775C9.7698 406.53 7.9365 404.684 5.67883 404.684Z"
            fill="white"
          />
          <path
            d="M-3.12777 396.094C-5.38545 396.094 -7.21875 397.927 -7.21875 400.193C-7.21875 402.459 -5.38545 404.284 -3.12777 404.284C-0.8701 404.284 0.971687 402.451 0.971687 400.193C0.971687 397.936 -0.861612 396.094 -3.12777 396.094Z"
            fill="white"
          />
          <path
            d="M-3.92945 296.48C-6.14468 296.48 -7.93555 298.28 -7.93555 300.487C-7.93555 302.693 -6.14468 304.493 -3.92945 304.493C-1.71421 304.493 0.0766535 302.702 0.0766535 300.487C0.0766535 298.271 -1.71421 296.48 -3.92945 296.48Z"
            fill="white"
          />
          <path
            d="M2.30422 286.062C0.110198 286.062 -1.68066 287.841 -1.68066 290.047C-1.68066 292.254 0.110198 294.024 2.30422 294.024C4.49824 294.024 6.28061 292.246 6.28061 290.047C6.28061 287.849 4.50248 286.062 2.30422 286.062Z"
            fill="white"
          />
          <path
            d="M8.81846 274.842C6.63293 274.842 4.86328 276.611 4.86328 278.797C4.86328 280.983 6.63293 282.752 8.81846 282.752C11.004 282.752 12.7736 280.974 12.7736 278.797C12.7736 276.62 11.004 274.842 8.81846 274.842Z"
            fill="white"
          />
          <path
            d="M15.5658 262.957C13.3887 262.957 11.6318 264.714 11.6318 266.891C11.6318 269.068 13.3887 270.838 15.5658 270.838C17.7428 270.838 19.4997 269.068 19.4997 266.891C19.4997 264.714 17.7428 262.957 15.5658 262.957Z"
            fill="white"
          />
          <path
            d="M22.4831 250.623C20.3187 250.623 18.5703 252.371 18.5703 254.527C18.5703 256.683 20.3187 258.432 22.4831 258.432C24.6474 258.432 26.3873 256.683 26.3873 254.527C26.3873 252.371 24.6389 250.623 22.4831 250.623Z"
            fill="white"
          />
          <path
            d="M29.4687 238.041C27.3128 238.041 25.5771 239.777 25.5771 241.933C25.5771 244.088 27.3171 245.816 29.4687 245.816C31.6202 245.816 33.3517 244.076 33.3517 241.933C33.3517 239.789 31.6118 238.041 29.4687 238.041Z"
            fill="white"
          />
          <path
            d="M36.4324 225.449C34.3105 225.449 32.5918 227.176 32.5918 229.298C32.5918 231.42 34.3105 233.139 36.4324 233.139C38.5543 233.139 40.2815 231.42 40.2815 229.298C40.2815 227.176 38.5543 225.449 36.4324 225.449Z"
            fill="white"
          />
          <path
            d="M43.3031 213.061C41.2024 213.061 39.4922 214.767 39.4922 216.871C39.4922 218.976 41.1982 220.691 43.3031 220.691C45.408 220.691 47.114 218.985 47.114 216.871C47.114 214.758 45.408 213.061 43.3031 213.061Z"
            fill="white"
          />
          <path
            d="M49.9527 201.238C47.8606 201.238 46.1758 202.936 46.1758 205.028C46.1758 207.12 47.8606 208.805 49.9527 208.805C52.0449 208.805 53.7297 207.107 53.7297 205.028C53.7297 202.949 52.0449 201.238 49.9527 201.238Z"
            fill="white"
          />
          <path
            d="M56.3224 190.307C54.2515 190.307 52.5752 191.987 52.5752 194.058C52.5752 196.129 54.2515 197.814 56.3224 197.814C58.3934 197.814 60.0781 196.129 60.0781 194.058C60.0781 191.987 58.4019 190.307 56.3224 190.307Z"
            fill="white"
          />
          <path
            d="M62.4297 180.352C60.3885 180.352 58.7334 182.007 58.7334 184.048C58.7334 186.089 60.3885 187.744 62.4297 187.744C64.471 187.744 66.126 186.089 66.126 184.048C66.126 182.007 64.471 180.352 62.4297 180.352Z"
            fill="white"
          />
          <path
            d="M68.3206 171.172C66.3005 171.172 64.6582 172.818 64.6582 174.834C64.6582 176.85 66.3048 178.497 68.3206 178.497C70.3363 178.497 71.9829 176.854 71.9829 174.834C71.9829 172.814 70.3363 171.172 68.3206 171.172Z"
            fill="white"
          />
          <path
            d="M74.0789 162.625C72.0801 162.625 70.459 164.25 70.459 166.245C70.459 168.239 72.0801 169.865 74.0789 169.865C76.0777 169.865 77.6903 168.239 77.6903 166.245C77.6903 164.25 76.0777 162.625 74.0789 162.625Z"
            fill="white"
          />
          <path
            d="M79.6042 154.664C77.6266 154.664 76.0225 156.268 76.0225 158.246C76.0225 160.223 77.6266 161.836 79.6042 161.836C81.5818 161.836 83.1944 160.228 83.1944 158.246C83.1944 156.264 81.5818 154.664 79.6042 154.664Z"
            fill="white"
          />
          <path
            d="M84.8801 147.182C82.9322 147.182 81.3535 148.752 81.3535 150.7C81.3535 152.648 82.9364 154.218 84.8801 154.218C86.8237 154.218 88.3981 152.648 88.3981 150.7C88.3981 148.752 86.8152 147.182 84.8801 147.182Z"
            fill="white"
          />
          <path
            d="M89.8145 140.018C87.8878 140.018 86.3389 141.579 86.3389 143.497C86.3389 145.416 87.8878 146.977 89.8145 146.977C91.7412 146.977 93.2901 145.416 93.2901 143.497C93.2901 141.579 91.7284 140.018 89.8145 140.018Z"
            fill="white"
          />
          <path
            d="M94.3639 133.066C92.4711 133.066 90.9307 134.598 90.9307 136.491C90.9307 138.384 92.4711 139.916 94.3639 139.916C96.2566 139.916 97.7886 138.384 97.7886 136.491C97.7886 134.598 96.2481 133.066 94.3639 133.066Z"
            fill="white"
          />
          <path
            d="M98.4506 126.219C96.5876 126.219 95.0684 127.73 95.0684 129.601C95.0684 131.473 96.5876 132.983 98.4506 132.983C100.314 132.983 101.841 131.473 101.841 129.601C101.841 127.73 100.322 126.219 98.4506 126.219Z"
            fill="white"
          />
          <path
            d="M102.053 119.631C100.22 119.631 98.7432 121.112 98.7432 122.941C98.7432 124.77 100.22 126.251 102.053 126.251C103.887 126.251 105.363 124.766 105.363 122.941C105.363 121.116 103.874 119.631 102.053 119.631Z"
            fill="white"
          />
          <path
            d="M105.155 113.377C103.356 113.377 101.888 114.841 101.888 116.64C101.888 118.44 103.356 119.904 105.155 119.904C106.955 119.904 108.415 118.44 108.415 116.64C108.415 114.841 106.959 113.377 105.155 113.377Z"
            fill="white"
          />
          <path
            d="M107.82 107.545C106.042 107.545 104.604 108.979 104.604 110.749C104.604 112.519 106.038 113.966 107.82 113.966C109.603 113.966 111.024 112.527 111.024 110.749C111.024 108.971 109.59 107.545 107.82 107.545Z"
            fill="white"
          />
          <path
            d="M110.13 102.133C108.381 102.133 106.977 103.537 106.977 105.286C106.977 107.034 108.381 108.431 110.13 108.431C111.878 108.431 113.274 107.026 113.274 105.286C113.274 103.546 111.87 102.133 110.13 102.133Z"
            fill="white"
          />
          <path
            d="M112.158 97.0781C110.461 97.0781 109.077 98.4573 109.077 100.155C109.077 101.852 110.461 103.223 112.158 103.223C113.856 103.223 115.231 101.848 115.231 100.155C115.231 98.4616 113.856 97.0781 112.158 97.0781Z"
            fill="white"
          />
          <path
            d="M113.982 92.2441C112.319 92.2441 110.974 93.5979 110.974 95.2614C110.974 96.925 112.315 98.2703 113.982 98.2703C115.65 98.2703 117 96.9292 117 95.2614C117 93.5937 115.646 92.2441 113.982 92.2441Z"
            fill="white"
          />
          <path
            d="M115.668 87.5312C114.034 87.5312 112.71 88.8553 112.71 90.4891C112.71 92.123 114.034 93.447 115.668 93.447C117.302 93.447 118.626 92.1272 118.626 90.4891C118.626 88.8511 117.306 87.5312 115.668 87.5312Z"
            fill="white"
          />
          <path
            d="M117.272 82.8301C115.659 82.8301 114.369 84.1329 114.369 85.7328C114.369 87.3327 115.659 88.6355 117.272 88.6355C118.884 88.6355 120.175 87.3327 120.175 85.7328C120.175 84.1329 118.872 82.8301 117.272 82.8301Z"
            fill="white"
          />
          <path
            d="M118.829 78.0938C117.28 78.0938 116.02 79.3499 116.02 80.9031C116.02 82.4563 117.28 83.7125 118.829 83.7125C120.378 83.7125 121.638 82.4521 121.638 80.9031C121.638 79.3541 120.378 78.0938 118.829 78.0938Z"
            fill="white"
          />
          <path
            d="M120.446 73.1289C118.927 73.1289 117.7 74.3553 117.7 75.8746C117.7 77.3939 118.927 78.633 120.446 78.633C121.965 78.633 123.204 77.3939 123.204 75.8746C123.204 74.3553 121.965 73.1289 120.446 73.1289Z"
            fill="white"
          />
          <path
            d="M122.203 67.8105C120.726 67.8105 119.517 69.0115 119.517 70.4968C119.517 71.9822 120.726 73.1831 122.203 73.1831C123.68 73.1831 124.898 71.9822 124.898 70.4968C124.898 69.0115 123.688 67.8105 122.203 67.8105Z"
            fill="white"
          />
          <path
            d="M124.274 61.7852C122.827 61.7852 121.651 62.9607 121.651 64.3993C121.651 65.8379 122.827 67.0219 124.274 67.0219C125.721 67.0219 126.888 65.8464 126.888 64.3993C126.888 62.9522 125.713 61.7852 124.274 61.7852Z"
            fill="white"
          />
          <path
            d="M126.948 54.6543C125.552 54.6543 124.432 55.7789 124.432 57.1751C124.432 58.5713 125.556 59.7001 126.948 59.7001C128.34 59.7001 129.469 58.5713 129.469 57.1751C129.469 55.7789 128.344 54.6543 126.948 54.6543Z"
            fill="white"
          />
          <path
            d="M130.78 45.8086C129.418 45.8086 128.314 46.912 128.314 48.2657C128.314 49.6195 129.418 50.7313 130.78 50.7313C132.142 50.7313 133.237 49.628 133.237 48.2657C133.237 46.9035 132.134 45.8086 130.78 45.8086Z"
            fill="white"
          />
          <path
            d="M136.462 34.6875C135.129 34.6875 134.056 35.7654 134.056 37.0852C134.056 38.405 135.129 39.4914 136.462 39.4914C137.794 39.4914 138.855 38.4135 138.855 37.0852C138.855 35.7569 137.782 34.6875 136.462 34.6875Z"
            fill="white"
          />
          <path
            d="M144.987 20.4961C143.706 20.4961 142.666 21.5358 142.666 22.8259C142.666 24.116 143.706 25.1472 144.987 25.1472C146.269 25.1472 147.317 24.1075 147.317 22.8259C147.317 21.5443 146.277 20.4961 144.987 20.4961Z"
            fill="white"
          />
          <path
            d="M157.686 2.15625C156.46 2.15625 155.458 3.15353 155.458 4.38422C155.458 5.61491 156.455 6.61643 157.686 6.61643C158.917 6.61643 159.922 5.61915 159.922 4.38422C159.922 3.14929 158.925 2.15625 157.686 2.15625Z"
            fill="white"
          />
          <path
            d="M937.13 -2.60156C935.61 -2.60156 934.371 -1.36663 934.371 0.156875C934.371 1.68038 935.61 2.91531 937.13 2.91531C938.649 2.91531 939.896 1.68887 939.896 0.156875C939.896 -1.37512 938.657 -2.60156 937.13 -2.60156Z"
            fill="white"
          />
          <path
            d="M944.748 8.08789C943.177 8.08789 941.904 9.3695 941.904 10.9397C941.904 12.5099 943.173 13.7915 944.748 13.7915C946.322 13.7915 947.599 12.5184 947.599 10.9397C947.599 9.36102 946.331 8.08789 944.748 8.08789Z"
            fill="white"
          />
          <path
            d="M952.356 18.7148C950.752 18.7148 949.44 20.0219 949.44 21.6303C949.44 23.2387 950.752 24.5458 952.356 24.5458C953.96 24.5458 955.271 23.2429 955.271 21.6303C955.271 20.0177 953.968 18.7148 952.356 18.7148Z"
            fill="white"
          />
          <path
            d="M959.966 29.248C958.332 29.248 957.008 30.5721 957.008 32.2102C957.008 33.8483 958.328 35.1723 959.966 35.1723C961.604 35.1723 962.932 33.8483 962.932 32.2102C962.932 30.5721 961.6 29.248 959.966 29.248Z"
            fill="white"
          />
          <path
            d="M967.553 39.752C965.89 39.752 964.536 41.1057 964.536 42.7693C964.536 44.4328 965.89 45.7866 967.553 45.7866C969.217 45.7866 970.583 44.4328 970.583 42.7693C970.583 41.1057 969.23 39.752 967.553 39.752Z"
            fill="white"
          />
          <path
            d="M975.85 56.3736C977.522 55.979 978.558 54.3036 978.163 52.6316C977.768 50.9596 976.093 49.924 974.421 50.3186C972.749 50.7133 971.713 52.3887 972.108 54.0607C972.503 55.7327 974.178 56.7683 975.85 56.3736Z"
            fill="white"
          />
          <path
            d="M982.674 60.6641C980.925 60.6641 979.508 62.0857 979.508 63.8341C979.508 65.5826 980.925 67 982.674 67C984.422 67 985.839 65.5826 985.839 63.8341C985.839 62.0857 984.422 60.6641 982.674 60.6641Z"
            fill="white"
          />
          <path
            d="M990.189 71.168C988.411 71.168 986.973 72.6108 986.973 74.3847C986.973 76.1586 988.411 77.6015 990.189 77.6015C991.968 77.6015 993.406 76.1586 993.406 74.3847C993.406 72.6108 991.959 71.168 990.189 71.168Z"
            fill="white"
          />
          <path
            d="M997.671 81.6621C995.859 81.6621 994.391 83.1304 994.391 84.9383C994.391 86.7461 995.859 88.206 997.671 88.206C999.483 88.206 1000.94 86.7419 1000.94 84.9383C1000.94 83.1347 999.483 81.6621 997.671 81.6621Z"
            fill="white"
          />
          <path
            d="M1005.14 92.1484C1003.29 92.1484 1001.78 93.6507 1001.78 95.501C1001.78 97.3513 1003.28 98.8536 1005.14 98.8536C1006.99 98.8536 1008.49 97.3513 1008.49 95.501C1008.49 93.6507 1006.99 92.1484 1005.14 92.1484Z"
            fill="white"
          />
          <path
            d="M1012.57 102.699C1010.69 102.699 1009.17 104.218 1009.17 106.094C1009.17 107.97 1010.69 109.485 1012.57 109.485C1014.44 109.485 1015.96 107.966 1015.96 106.094C1015.96 104.223 1014.44 102.699 1012.57 102.699Z"
            fill="white"
          />
          <path
            d="M1019.95 113.332C1018.04 113.332 1016.49 114.873 1016.49 116.778C1016.49 118.683 1018.04 120.232 1019.95 120.232C1021.85 120.232 1023.4 118.688 1023.4 116.778C1023.4 114.868 1021.85 113.332 1019.95 113.332Z"
            fill="white"
          />
          <path
            d="M1027.27 124.074C1025.34 124.074 1023.77 125.64 1023.77 127.571C1023.77 129.502 1025.34 131.076 1027.27 131.076C1029.21 131.076 1030.78 129.506 1030.78 127.571C1030.78 125.636 1029.21 124.074 1027.27 124.074Z"
            fill="white"
          />
          <path
            d="M1034.55 134.941C1032.58 134.941 1030.99 136.537 1030.99 138.502C1030.99 140.467 1032.58 142.067 1034.55 142.067C1036.52 142.067 1038.11 140.471 1038.11 138.502C1038.11 136.533 1036.52 134.941 1034.55 134.941Z"
            fill="white"
          />
          <path
            d="M1041.75 146.006C1039.76 146.006 1038.14 147.618 1038.14 149.617C1038.14 151.616 1039.76 153.224 1041.75 153.224C1043.74 153.224 1045.36 151.608 1045.36 149.617C1045.36 147.627 1043.75 146.006 1041.75 146.006Z"
            fill="white"
          />
          <path
            d="M1048.9 157.264C1046.88 157.264 1045.25 158.902 1045.25 160.918C1045.25 162.933 1046.88 164.571 1048.9 164.571C1050.92 164.571 1052.54 162.938 1052.54 160.918C1052.54 158.898 1050.91 157.264 1048.9 157.264Z"
            fill="white"
          />
          <path
            d="M1056 168.744C1053.96 168.744 1052.3 170.399 1052.3 172.44C1052.3 174.482 1053.96 176.145 1056 176.145C1058.04 176.145 1059.69 174.486 1059.69 172.44C1059.69 170.395 1058.04 168.744 1056 168.744Z"
            fill="white"
          />
          <path
            d="M1063.07 180.443C1060.99 180.443 1059.3 182.128 1059.3 184.199C1059.3 186.27 1060.98 187.963 1063.07 187.963C1065.15 187.963 1066.82 186.283 1066.82 184.199C1066.82 182.115 1065.14 180.443 1063.07 180.443Z"
            fill="white"
          />
          <path
            d="M1070.16 192.297C1068.07 192.297 1066.37 193.994 1066.37 196.087C1066.37 198.179 1068.07 199.876 1070.16 199.876C1072.26 199.876 1073.96 198.179 1073.96 196.087C1073.96 193.994 1072.26 192.297 1070.16 192.297Z"
            fill="white"
          />
          <path
            d="M1077.41 204.082C1075.29 204.082 1073.58 205.788 1073.58 207.914C1073.58 210.04 1075.3 211.742 1077.41 211.742C1079.52 211.742 1081.25 210.023 1081.25 207.914C1081.25 205.805 1079.53 204.082 1077.41 204.082Z"
            fill="white"
          />
          <path
            d="M1084.91 215.547C1082.78 215.547 1081.05 217.274 1081.05 219.409C1081.05 221.543 1082.78 223.27 1084.91 223.27C1087.05 223.27 1088.78 221.543 1088.78 219.409C1088.78 217.274 1087.05 215.547 1084.91 215.547Z"
            fill="white"
          />
          <path
            d="M1092.74 226.445C1090.57 226.445 1088.83 228.194 1088.83 230.35C1088.83 232.505 1090.57 234.262 1092.74 234.262C1094.9 234.262 1096.64 232.514 1096.64 230.35C1096.64 228.185 1094.89 226.445 1092.74 226.445Z"
            fill="white"
          />
          <path
            d="M1100.95 236.562C1098.78 236.562 1097.01 238.324 1097.01 240.496C1097.01 242.669 1098.78 244.439 1100.95 244.439C1103.13 244.439 1104.89 242.669 1104.89 240.496C1104.89 238.324 1103.13 236.562 1100.95 236.562Z"
            fill="white"
          />
          <path
            d="M1109.54 245.734C1107.34 245.734 1105.57 247.504 1105.57 249.698C1105.57 251.892 1107.34 253.674 1109.54 253.674C1111.73 253.674 1113.51 251.896 1113.51 249.698C1113.51 247.5 1111.74 245.734 1109.54 245.734Z"
            fill="white"
          />
          <path
            d="M1118.47 261.917C1120.67 261.917 1122.46 260.127 1122.46 257.919C1122.46 255.712 1120.67 253.922 1118.47 253.922C1116.26 253.922 1114.47 255.712 1114.47 257.919C1114.47 260.127 1116.26 261.917 1118.47 261.917Z"
            fill="white"
          />
          <path
            d="M1127.69 261.148C1125.45 261.148 1123.64 262.961 1123.64 265.197C1123.64 267.433 1125.45 269.246 1127.69 269.246C1129.92 269.246 1131.74 267.433 1131.74 265.197C1131.74 262.961 1129.92 261.148 1127.69 261.148Z"
            fill="white"
          />
          <path
            d="M1137.14 267.57C1134.9 267.57 1133.08 269.391 1133.08 271.627C1133.08 273.864 1134.9 275.684 1137.14 275.684C1139.37 275.684 1141.2 273.872 1141.2 271.627C1141.2 269.382 1139.39 267.57 1137.14 267.57Z"
            fill="white"
          />
          <path
            d="M1146.79 281.432C1149.05 281.432 1150.88 279.6 1150.88 277.341C1150.88 275.082 1149.05 273.25 1146.79 273.25C1144.53 273.25 1142.7 275.082 1142.7 277.341C1142.7 279.6 1144.53 281.432 1146.79 281.432Z"
            fill="white"
          />
          <path
            d="M1156.58 278.361C1154.31 278.361 1152.47 280.203 1152.47 282.474C1152.47 284.744 1154.31 286.586 1156.58 286.586C1158.85 286.586 1160.7 284.744 1160.7 282.474C1160.7 280.203 1158.85 278.361 1156.58 278.361Z"
            fill="white"
          />
          <path
            d="M1166.49 282.973C1164.21 282.973 1162.35 284.827 1162.35 287.115C1162.35 289.402 1164.2 291.256 1166.49 291.256C1168.77 291.256 1170.63 289.402 1170.63 287.115C1170.63 284.827 1168.78 282.973 1166.49 282.973Z"
            fill="white"
          />
          <path
            d="M1176.49 287.217C1174.19 287.217 1172.33 289.08 1172.33 291.371C1172.33 293.663 1174.19 295.526 1176.49 295.526C1178.79 295.526 1180.64 293.672 1180.64 291.371C1180.64 289.071 1178.78 287.217 1176.49 287.217Z"
            fill="white"
          />
          <path
            d="M1186.54 291.15C1184.25 291.15 1182.39 293.013 1182.39 295.305C1182.39 297.597 1184.25 299.46 1186.54 299.46C1188.83 299.46 1190.7 297.605 1190.7 295.305C1190.7 293.005 1188.83 291.15 1186.54 291.15Z"
            fill="white"
          />
          <path
            d="M1196.65 294.783C1194.35 294.783 1192.5 296.646 1192.5 298.938C1192.5 301.229 1194.35 303.092 1196.65 303.092C1198.95 303.092 1200.81 301.229 1200.81 298.938C1200.81 296.646 1198.94 294.783 1196.65 294.783Z"
            fill="white"
          />
          <path
            d="M1206.77 298.115C1204.48 298.115 1202.62 299.97 1202.62 302.27C1202.62 304.57 1204.48 306.425 1206.77 306.425C1209.06 306.425 1210.93 304.562 1210.93 302.27C1210.93 299.978 1209.07 298.115 1206.77 298.115Z"
            fill="white"
          />
          <path
            d="M1216.89 301.133C1214.6 301.133 1212.73 302.987 1212.73 305.287C1212.73 307.588 1214.6 309.442 1216.89 309.442C1219.18 309.442 1221.04 307.579 1221.04 305.287C1221.04 302.996 1219.18 301.133 1216.89 301.133Z"
            fill="white"
          />
          <path
            d="M1226.95 303.83C1224.66 303.83 1222.8 305.693 1222.8 307.985C1222.8 310.276 1224.66 312.139 1226.95 312.139C1229.24 312.139 1231.1 310.276 1231.1 307.985C1231.1 305.693 1229.24 303.83 1226.95 303.83Z"
            fill="white"
          />
          <path
            d="M1236.94 306.141C1234.65 306.141 1232.79 308.004 1232.79 310.295C1232.79 312.587 1234.65 314.45 1236.94 314.45C1239.23 314.45 1241.09 312.595 1241.09 310.295C1241.09 307.995 1239.23 306.141 1236.94 306.141Z"
            fill="white"
          />
          <path
            d="M1246.84 307.973C1244.55 307.973 1242.68 309.836 1242.68 312.127C1242.68 314.419 1244.55 316.282 1246.84 316.282C1249.13 316.282 1250.99 314.432 1250.99 312.127C1250.99 309.823 1249.13 307.973 1246.84 307.973Z"
            fill="white"
          />
          <path
            d="M1243.02 308.533C1240.73 308.533 1238.87 310.383 1238.87 312.688C1238.87 314.992 1240.73 316.842 1243.02 316.842C1245.31 316.842 1247.17 314.979 1247.17 312.688C1247.17 310.396 1245.32 308.533 1243.02 308.533Z"
            fill="white"
          />
          <path
            d="M1238.86 308.896C1236.57 308.896 1234.7 310.751 1234.7 313.051C1234.7 315.351 1236.57 317.206 1238.86 317.206C1241.15 317.206 1243.01 315.343 1243.01 313.051C1243.01 310.759 1241.16 308.896 1238.86 308.896Z"
            fill="white"
          />
          <path
            d="M1234.31 309.076C1232.02 309.076 1230.15 310.926 1230.15 313.227C1230.15 315.527 1232.02 317.381 1234.31 317.381C1236.6 317.381 1238.47 315.518 1238.47 313.227C1238.47 310.935 1236.61 309.076 1234.31 309.076Z"
            fill="white"
          />
          <path
            d="M1229.37 309.055C1227.07 309.055 1225.22 310.918 1225.22 313.209C1225.22 315.501 1227.07 317.364 1229.37 317.364C1231.67 317.364 1233.53 315.514 1233.53 313.209C1233.53 310.905 1231.66 309.055 1229.37 309.055Z"
            fill="white"
          />
          <path
            d="M1224.02 308.869C1221.73 308.869 1219.87 310.732 1219.87 313.024C1219.87 315.315 1221.73 317.178 1224.02 317.178C1226.32 317.178 1228.18 315.315 1228.18 313.024C1228.18 310.732 1226.32 308.869 1224.02 308.869Z"
            fill="white"
          />
          <path
            d="M1218.28 308.525C1215.98 308.525 1214.12 310.38 1214.12 312.68C1214.12 314.98 1215.98 316.835 1218.28 316.835C1220.58 316.835 1222.43 314.972 1222.43 312.68C1222.43 310.388 1220.57 308.525 1218.28 308.525Z"
            fill="white"
          />
          <path
            d="M1212.13 308.023C1209.84 308.023 1207.97 309.886 1207.97 312.178C1207.97 314.47 1209.84 316.333 1212.13 316.333C1214.42 316.333 1216.28 314.47 1216.28 312.178C1216.28 309.886 1214.43 308.023 1212.13 308.023Z"
            fill="white"
          />
          <path
            d="M1205.6 307.387C1203.3 307.387 1201.45 309.241 1201.45 311.541C1201.45 313.841 1203.3 315.696 1205.6 315.696C1207.91 315.696 1209.76 313.833 1209.76 311.541C1209.76 309.25 1207.89 307.387 1205.6 307.387Z"
            fill="white"
          />
          <path
            d="M1198.69 306.619C1196.4 306.619 1194.54 308.482 1194.54 310.774C1194.54 313.065 1196.4 314.928 1198.69 314.928C1200.98 314.928 1202.85 313.065 1202.85 310.774C1202.85 308.482 1200.98 306.619 1198.69 306.619Z"
            fill="white"
          />
          <path
            d="M1191.43 305.746C1189.13 305.746 1187.26 307.609 1187.26 309.896C1187.26 312.184 1189.13 314.051 1191.43 314.051C1193.73 314.051 1195.58 312.201 1195.58 309.896C1195.58 307.592 1193.72 305.746 1191.43 305.746Z"
            fill="white"
          />
          <path
            d="M1183.81 304.799C1181.51 304.799 1179.65 306.662 1179.65 308.953C1179.65 311.245 1181.51 313.108 1183.81 313.108C1186.11 313.108 1187.96 311.245 1187.96 308.953C1187.96 306.662 1186.1 304.799 1183.81 304.799Z"
            fill="white"
          />
          <path
            d="M1175.86 303.811C1173.56 303.811 1171.7 305.661 1171.7 307.965C1171.7 310.27 1173.55 312.12 1175.86 312.12C1178.16 312.12 1180.01 310.257 1180.01 307.965C1180.01 305.674 1178.15 303.811 1175.86 303.811Z"
            fill="white"
          />
          <path
            d="M1167.58 302.828C1165.3 302.828 1163.46 304.678 1163.46 306.962C1163.46 309.245 1165.3 311.082 1167.58 311.082C1169.86 311.082 1171.72 309.24 1171.72 306.962C1171.72 304.683 1169.87 302.828 1167.58 302.828Z"
            fill="white"
          />
          <path
            d="M1159.01 301.875C1156.74 301.875 1154.89 303.717 1154.89 305.987C1154.89 308.258 1156.74 310.099 1159.01 310.099C1161.28 310.099 1163.11 308.258 1163.11 305.987C1163.11 303.717 1161.27 301.875 1159.01 301.875Z"
            fill="white"
          />
          <path
            d="M1150.12 300.943C1147.85 300.943 1146.02 302.777 1146.02 305.034C1146.02 307.292 1147.85 309.134 1150.12 309.134C1152.39 309.134 1154.21 307.3 1154.21 305.034C1154.21 302.768 1152.38 300.943 1150.12 300.943Z"
            fill="white"
          />
          <path
            d="M1140.93 300.135C1138.69 300.135 1136.88 301.947 1136.88 304.192C1136.88 306.437 1138.69 308.24 1140.93 308.24C1143.16 308.24 1144.98 306.428 1144.98 304.192C1144.98 301.955 1143.16 300.135 1140.93 300.135Z"
            fill="white"
          />
          <path
            d="M1131.47 299.447C1129.24 299.447 1127.44 301.247 1127.44 303.466C1127.44 305.686 1129.24 307.493 1131.47 307.493C1133.7 307.493 1135.5 305.694 1135.5 303.466C1135.5 301.238 1133.7 299.447 1131.47 299.447Z"
            fill="white"
          />
          <path
            d="M1121.73 298.928C1119.53 298.928 1117.73 300.719 1117.73 302.934C1117.73 305.149 1119.53 306.94 1121.73 306.94C1123.94 306.94 1125.74 305.149 1125.74 302.934C1125.74 300.719 1123.95 298.928 1121.73 298.928Z"
            fill="white"
          />
          <path
            d="M1111.77 298.637C1109.57 298.637 1107.79 300.415 1107.79 302.613C1107.79 304.811 1109.57 306.598 1111.77 306.598C1113.96 306.598 1115.74 304.807 1115.74 302.613C1115.74 300.419 1113.96 298.637 1111.77 298.637Z"
            fill="white"
          />
          <path
            d="M1101.55 298.584C1099.38 298.584 1097.62 300.345 1097.62 302.509C1097.62 304.674 1099.38 306.443 1101.55 306.443C1103.71 306.443 1105.48 304.682 1105.48 302.509C1105.48 300.337 1103.72 298.584 1101.55 298.584Z"
            fill="white"
          />
          <path
            d="M1091.08 298.771C1088.93 298.771 1087.18 300.52 1087.18 302.676C1087.18 304.832 1088.93 306.58 1091.08 306.58C1093.24 306.58 1094.99 304.832 1094.99 302.676C1094.99 300.52 1093.24 298.771 1091.08 298.771Z"
            fill="white"
          />
          <path
            d="M1080.39 299.291C1078.26 299.291 1076.52 301.018 1076.52 303.161C1076.52 305.304 1078.26 307.023 1080.39 307.023C1082.53 307.023 1084.27 305.296 1084.27 303.161C1084.27 301.027 1082.53 299.291 1080.39 299.291Z"
            fill="white"
          />
          <path
            d="M1069.49 300.186C1067.37 300.186 1065.66 301.904 1065.66 304.026C1065.66 306.148 1067.38 307.854 1069.49 307.854C1071.6 307.854 1073.32 306.135 1073.32 304.026C1073.32 301.917 1071.6 300.186 1069.49 300.186Z"
            fill="white"
          />
          <path
            d="M1058.37 301.475C1056.29 301.475 1054.6 303.159 1054.6 305.252C1054.6 307.344 1056.29 309.041 1058.37 309.041C1060.45 309.041 1062.16 307.344 1062.16 305.252C1062.16 303.159 1060.47 301.475 1058.37 301.475Z"
            fill="white"
          />
          <path
            d="M1047.05 303.123C1044.98 303.123 1043.31 304.799 1043.31 306.87C1043.31 308.941 1044.99 310.605 1047.05 310.605C1049.11 310.605 1050.79 308.928 1050.79 306.87C1050.79 304.812 1049.12 303.123 1047.05 303.123Z"
            fill="white"
          />
          <path
            d="M1035.56 305.223C1033.52 305.223 1031.86 306.878 1031.86 308.927C1031.86 310.977 1033.52 312.624 1035.56 312.624C1037.6 312.624 1039.26 310.969 1039.26 308.927C1039.26 306.886 1037.61 305.223 1035.56 305.223Z"
            fill="white"
          />
          <path
            d="M1023.92 307.824C1021.89 307.824 1020.25 309.471 1020.25 311.487C1020.25 313.502 1021.89 315.149 1023.92 315.149C1025.95 315.149 1027.59 313.515 1027.59 311.487C1027.59 309.458 1025.94 307.824 1023.92 307.824Z"
            fill="white"
          />
          <path
            d="M1012.14 310.961C1010.14 310.961 1008.53 312.574 1008.53 314.56C1008.53 316.546 1010.14 318.171 1012.14 318.171C1014.14 318.171 1015.74 316.546 1015.74 314.56C1015.74 312.574 1014.13 310.961 1012.14 310.961Z"
            fill="white"
          />
          <path
            d="M1000.26 314.559C998.3 314.559 996.709 316.15 996.709 318.106C996.709 320.063 998.3 321.654 1000.26 321.654C1002.21 321.654 1003.8 320.063 1003.8 318.106C1003.8 316.15 1002.21 314.559 1000.26 314.559Z"
            fill="white"
          />
          <path
            d="M988.831 325.626C990.742 325.316 992.04 323.515 991.73 321.604C991.42 319.693 989.619 318.396 987.708 318.706C985.797 319.016 984.5 320.817 984.81 322.728C985.12 324.639 986.92 325.936 988.831 325.626Z"
            fill="white"
          />
          <path
            d="M976.233 323.553C974.319 323.553 972.766 325.106 972.766 327.02C972.766 328.934 974.315 330.474 976.233 330.474C978.151 330.474 979.687 328.934 979.687 327.02C979.687 325.106 978.134 323.553 976.233 323.553Z"
            fill="white"
          />
          <path
            d="M964.221 329.328C962.358 329.328 960.839 330.839 960.839 332.71C960.839 334.582 962.358 336.101 964.221 336.101C966.084 336.101 967.612 334.582 967.612 332.71C967.612 330.839 966.093 329.328 964.221 329.328Z"
            fill="white"
          />
          <path
            d="M952.221 336.135C950.379 336.135 948.881 337.633 948.881 339.475C948.881 341.316 950.379 342.814 952.221 342.814C954.063 342.814 955.561 341.316 955.561 339.475C955.561 337.633 954.063 336.135 952.221 336.135Z"
            fill="white"
          />
          <path
            d="M940.369 344.418C938.557 344.418 937.08 345.886 937.08 347.707C937.08 349.527 938.557 351.004 940.369 351.004C942.181 351.004 943.666 349.527 943.666 347.707C943.666 345.886 942.19 344.418 940.369 344.418Z"
            fill="white"
          />
          <path
            d="M928.754 354.506C926.976 354.506 925.516 355.961 925.516 357.744C925.516 359.526 926.971 360.982 928.754 360.982C930.536 360.982 932 359.535 932 357.744C932 355.953 930.545 354.506 928.754 354.506Z"
            fill="white"
          />
          <path
            d="M917.677 366.873C915.942 366.873 914.524 368.29 914.524 370.035C914.524 371.779 915.942 373.188 917.677 373.188C919.413 373.188 920.843 371.783 920.843 370.035C920.843 368.286 919.426 366.873 917.677 366.873Z"
            fill="white"
          />
          <path
            d="M907.521 381.814C905.802 381.814 904.419 383.211 904.419 384.917C904.419 386.623 905.802 388.019 907.521 388.019C909.24 388.019 910.623 386.635 910.623 384.917C910.623 383.198 909.227 381.814 907.521 381.814Z"
            fill="white"
          />
          <path
            d="M898.55 399.625C896.866 399.625 895.499 400.987 895.499 402.664C895.499 404.34 896.861 405.715 898.55 405.715C900.239 405.715 901.589 404.353 901.589 402.664C901.589 400.975 900.227 399.625 898.55 399.625Z"
            fill="white"
          />
          <path
            d="M891.671 421.145C890.016 421.145 888.675 422.486 888.675 424.132C888.675 425.779 890.016 427.12 891.671 427.12C893.326 427.12 894.658 425.787 894.658 424.132C894.658 422.477 893.317 421.145 891.671 421.145Z"
            fill="white"
          />
          <path
            d="M888.017 447.219C886.413 447.219 885.114 448.53 885.114 450.134C885.114 451.738 886.417 453.05 888.017 453.05C889.617 453.05 890.932 451.738 890.932 450.134C890.932 448.53 889.63 447.219 888.017 447.219Z"
            fill="white"
          />
          <path
            d="M888.556 478.037C886.986 478.037 885.713 479.306 885.713 480.889C885.713 482.472 886.982 483.732 888.556 483.732C890.131 483.732 891.408 482.463 891.408 480.889C891.408 479.315 890.126 478.037 888.556 478.037Z"
            fill="white"
          />
          <path
            d="M893.321 513.32C891.781 513.32 890.533 514.568 890.533 516.108C890.533 517.649 891.781 518.897 893.321 518.897C894.862 518.897 896.11 517.649 896.11 516.108C896.11 514.568 894.862 513.32 893.321 513.32Z"
            fill="white"
          />
          <path
            d="M901.117 552.734C899.607 552.734 898.389 553.961 898.389 555.463C898.389 556.965 899.607 558.192 901.117 558.192C902.628 558.192 903.846 556.974 903.846 555.463C903.846 553.952 902.628 552.734 901.117 552.734Z"
            fill="white"
          />
          <path
            d="M910.06 596.094C908.605 596.094 907.425 597.282 907.425 598.738C907.425 600.193 908.6 601.381 910.06 601.381C911.52 601.381 912.704 600.193 912.704 598.738C912.704 597.282 911.528 596.094 910.06 596.094Z"
            fill="white"
          />
          <path
            d="M918.314 643.264C916.888 643.264 915.733 644.418 915.733 645.857C915.733 647.295 916.888 648.437 918.314 648.437C919.739 648.437 920.894 647.282 920.894 645.857C920.894 644.431 919.739 643.264 918.314 643.264Z"
            fill="white"
          />
          <path
            d="M485.294 677.369C484.046 677.369 483.023 678.388 483.023 679.64C483.023 680.891 484.042 681.91 485.294 681.91C486.546 681.91 487.564 680.891 487.564 679.64C487.564 678.388 486.546 677.369 485.294 677.369Z"
            fill="white"
          />
          <path
            d="M470.305 674.383C469.057 674.383 468.047 675.393 468.047 676.64C468.047 677.888 469.057 678.911 470.305 678.911C471.552 678.911 472.575 677.892 472.575 676.64C472.575 675.389 471.556 674.383 470.305 674.383Z"
            fill="white"
          />
          <path
            d="M455.172 671.725C453.924 671.725 452.914 672.735 452.914 673.974C452.914 675.213 453.924 676.231 455.172 676.231C456.419 676.231 457.429 675.221 457.429 673.974C457.429 672.726 456.411 671.725 455.172 671.725Z"
            fill="white"
          />
          <path
            d="M439.759 668.951C438.52 668.951 437.51 669.961 437.51 671.2C437.51 672.44 438.52 673.45 439.759 673.45C440.998 673.45 442.017 672.452 442.017 671.2C442.017 669.948 441.007 668.951 439.759 668.951Z"
            fill="white"
          />
          <path
            d="M423.968 665.971C422.72 665.971 421.71 666.981 421.71 668.228C421.71 669.476 422.72 670.486 423.968 670.486C425.215 670.486 426.225 669.476 426.225 668.228C426.225 666.981 425.215 665.971 423.968 665.971Z"
            fill="white"
          />
          <path
            d="M407.786 662.881C406.538 662.881 405.528 663.899 405.528 665.151C405.528 666.403 406.538 667.409 407.786 667.409C409.034 667.409 410.044 666.399 410.044 665.151C410.044 663.904 409.034 662.881 407.786 662.881Z"
            fill="white"
          />
          <path
            d="M391.1 659.229C389.853 659.229 388.843 660.239 388.843 661.486C388.843 662.734 389.853 663.744 391.1 663.744C392.348 663.744 393.358 662.734 393.358 661.486C393.358 660.239 392.348 659.229 391.1 659.229Z"
            fill="white"
          />
          <path
            d="M373.793 654.973C372.545 654.973 371.544 655.983 371.544 657.23C371.544 658.478 372.541 659.48 373.793 659.48C375.045 659.48 376.042 658.469 376.042 657.23C376.042 655.991 375.032 654.973 373.793 654.973Z"
            fill="white"
          />
          <path
            d="M355.829 650.119C354.581 650.119 353.559 651.138 353.559 652.39C353.559 653.641 354.577 654.66 355.829 654.66C357.081 654.66 358.099 653.641 358.099 652.39C358.099 651.138 357.081 650.119 355.829 650.119Z"
            fill="white"
          />
          <path
            d="M337.035 644.217C335.787 644.217 334.765 645.227 334.765 646.474C334.765 647.722 335.783 648.732 337.035 648.732C338.287 648.732 339.293 647.722 339.293 646.474C339.293 645.227 338.283 644.217 337.035 644.217Z"
            fill="white"
          />
          <path
            d="M317.266 637.059C316.019 637.059 315.009 638.069 315.009 639.316C315.009 640.564 316.019 641.574 317.266 641.574C318.514 641.574 319.524 640.555 319.524 639.316C319.524 638.077 318.514 637.059 317.266 637.059Z"
            fill="white"
          />
          <path
            d="M296.38 628.461C295.132 628.461 294.122 629.471 294.122 630.719C294.122 631.966 295.132 632.976 296.38 632.976C297.627 632.976 298.637 631.966 298.637 630.719C298.637 629.471 297.627 628.461 296.38 628.461Z"
            fill="white"
          />
          <path
            d="M274.128 618.344C272.88 618.344 271.857 619.362 271.857 620.614C271.857 621.866 272.876 622.885 274.128 622.885C275.38 622.885 276.398 621.866 276.398 620.614C276.398 619.362 275.38 618.344 274.128 618.344Z"
            fill="white"
          />
          <path
            d="M250.22 607.281C248.972 607.281 247.949 608.3 247.949 609.552C247.949 610.804 248.968 611.822 250.22 611.822C251.472 611.822 252.49 610.812 252.49 609.552C252.49 608.291 251.472 607.281 250.22 607.281Z"
            fill="white"
          />
          <path
            d="M224.418 595.312C223.17 595.312 222.147 596.322 222.147 597.57C222.147 598.818 223.166 599.828 224.418 599.828C225.67 599.828 226.676 598.818 226.676 597.57C226.676 596.322 225.666 595.312 224.418 595.312Z"
            fill="white"
          />
          <path
            d="M211.793 586.041C210.503 586.041 209.45 587.081 209.45 588.371C209.45 589.661 210.503 590.701 211.793 590.701C213.083 590.701 214.123 589.661 214.123 588.371C214.123 587.081 213.07 586.041 211.793 586.041Z"
            fill="white"
          />
          <path
            d="M200.012 577.314C198.688 577.314 197.605 578.388 197.605 579.708C197.605 581.028 198.688 582.11 200.012 582.11C201.336 582.11 202.405 581.036 202.405 579.708C202.405 578.38 201.331 577.314 200.012 577.314Z"
            fill="white"
          />
          <path
            d="M189.873 569.387C188.511 569.387 187.407 570.49 187.407 571.844C187.407 573.198 188.511 574.301 189.873 574.301C191.235 574.301 192.33 573.21 192.33 571.844C192.33 570.477 191.227 569.387 189.873 569.387Z"
            fill="white"
          />
          <path
            d="M181.696 562.434C180.278 562.434 179.137 563.579 179.137 564.993C179.137 566.406 180.283 567.543 181.696 567.543C183.109 567.543 184.255 566.397 184.255 564.993C184.255 563.588 183.109 562.434 181.696 562.434Z"
            fill="white"
          />
          <path
            d="M175.492 556.555C174.045 556.555 172.878 557.73 172.878 559.177C172.878 560.624 174.045 561.8 175.492 561.8C176.939 561.8 178.115 560.624 178.115 559.177C178.115 557.73 176.939 556.555 175.492 556.555Z"
            fill="white"
          />
          <path
            d="M171.014 551.59C169.538 551.59 168.341 552.799 168.341 554.276C168.341 555.753 169.538 556.962 171.014 556.962C172.491 556.962 173.701 555.757 173.701 554.276C173.701 552.795 172.504 551.59 171.014 551.59Z"
            fill="white"
          />
          <path
            d="M167.903 547.375C166.384 547.375 165.153 548.601 165.153 550.112C165.153 551.623 166.38 552.849 167.903 552.849C169.427 552.849 170.64 551.623 170.64 550.112C170.64 548.601 169.414 547.375 167.903 547.375Z"
            fill="white"
          />
          <path
            d="M165.812 543.709C164.25 543.709 162.981 544.978 162.981 546.54C162.981 548.101 164.25 549.37 165.812 549.37C167.374 549.37 168.643 548.101 168.643 546.54C168.643 544.978 167.382 543.709 165.812 543.709Z"
            fill="white"
          />
          <path
            d="M164.459 540.525C162.867 540.525 161.564 541.816 161.564 543.42C161.564 545.024 162.867 546.314 164.459 546.314C166.05 546.314 167.353 545.011 167.353 543.42C167.353 541.828 166.063 540.525 164.459 540.525Z"
            fill="white"
          />
          <path
            d="M163.461 537.59C161.827 537.59 160.516 538.91 160.516 540.548C160.516 542.186 161.827 543.493 163.461 543.493C165.095 543.493 166.419 542.169 166.419 540.548C166.419 538.927 165.095 537.59 163.461 537.59Z"
            fill="white"
          />
          <path
            d="M162.565 534.771C160.902 534.771 159.557 536.125 159.557 537.789C159.557 539.452 160.898 540.798 162.565 540.798C164.233 540.798 165.574 539.444 165.574 537.789C165.574 536.134 164.233 534.771 162.565 534.771Z"
            fill="white"
          />
          <path
            d="M161.597 531.941C159.891 531.941 158.508 533.325 158.508 535.031C158.508 536.737 159.891 538.133 161.597 538.133C163.303 538.133 164.687 536.737 164.687 535.031C164.687 533.325 163.303 531.941 161.597 531.941Z"
            fill="white"
          />
          <path
            d="M160.389 529.047C158.649 529.047 157.244 530.452 157.244 532.192C157.244 533.931 158.649 535.336 160.389 535.336C162.129 535.336 163.533 533.919 163.533 532.192C163.533 530.464 162.129 529.047 160.389 529.047Z"
            fill="white"
          />
          <path
            d="M158.789 525.932C157.019 525.932 155.585 527.366 155.585 529.136C155.585 530.905 157.019 532.34 158.789 532.34C160.559 532.34 161.993 530.905 161.993 529.136C161.993 527.366 160.559 525.932 158.789 525.932Z"
            fill="white"
          />
          <path
            d="M156.798 522.627C154.999 522.627 153.552 524.083 153.552 525.873C153.552 527.664 154.999 529.12 156.798 529.12C158.598 529.12 160.036 527.673 160.036 525.873C160.036 524.074 158.589 522.627 156.798 522.627Z"
            fill="white"
          />
          <path
            d="M154.426 519.086C152.593 519.086 151.107 520.563 151.107 522.405C151.107 524.246 152.597 525.723 154.426 525.723C156.255 525.723 157.745 524.234 157.745 522.405C157.745 520.575 156.255 519.086 154.426 519.086Z"
            fill="white"
          />
          <path
            d="M151.71 515.361C149.847 515.361 148.336 516.872 148.336 518.735C148.336 520.598 149.847 522.109 151.71 522.109C153.573 522.109 155.071 520.598 155.071 518.735C155.071 516.872 153.56 515.361 151.71 515.361Z"
            fill="white"
          />
          <path
            d="M148.65 511.457C146.766 511.457 145.226 512.989 145.226 514.882C145.226 516.774 146.766 518.306 148.65 518.306C150.535 518.306 152.075 516.766 152.075 514.882C152.075 512.998 150.543 511.457 148.65 511.457Z"
            fill="white"
          />
          <path
            d="M145.277 507.395C143.363 507.395 141.81 508.948 141.81 510.862C141.81 512.776 143.359 514.337 145.277 514.337C147.195 514.337 148.752 512.788 148.752 510.862C148.752 508.935 147.203 507.395 145.277 507.395Z"
            fill="white"
          />
          <path
            d="M141.613 503.203C139.657 503.203 138.087 504.786 138.087 506.73C138.087 508.673 139.657 510.26 141.613 510.26C143.57 510.26 145.14 508.69 145.14 506.73C145.14 504.769 143.557 503.203 141.613 503.203Z"
            fill="white"
          />
          <path
            d="M137.637 498.938C135.668 498.938 134.068 500.529 134.068 502.507C134.068 504.484 135.672 506.076 137.637 506.076C139.602 506.076 141.206 504.484 141.206 502.507C141.206 500.529 139.615 498.938 137.637 498.938Z"
            fill="white"
          />
          <path
            d="M133.359 494.596C131.373 494.596 129.748 496.221 129.748 498.207C129.748 500.193 131.373 501.819 133.359 501.819C135.346 501.819 136.971 500.206 136.971 498.207C136.971 496.208 135.358 494.596 133.359 494.596Z"
            fill="white"
          />
          <path
            d="M128.772 490.211C126.752 490.211 125.118 491.858 125.118 493.865C125.118 495.872 126.752 497.519 128.772 497.519C130.792 497.519 132.426 495.885 132.426 493.865C132.426 491.845 130.792 490.211 128.772 490.211Z"
            fill="white"
          />
          <path
            d="M123.849 485.799C121.8 485.799 120.145 487.462 120.145 489.504C120.145 491.545 121.8 493.208 123.849 493.208C125.899 493.208 127.554 491.553 127.554 489.504C127.554 487.454 125.899 485.799 123.849 485.799Z"
            fill="white"
          />
          <path
            d="M118.583 481.41C116.521 481.41 114.849 483.086 114.849 485.149C114.849 487.211 116.525 488.883 118.583 488.883C120.641 488.883 122.318 487.207 122.318 485.149C122.318 483.091 120.641 481.41 118.583 481.41Z"
            fill="white"
          />
          <path
            d="M112.961 477.027C110.881 477.027 109.192 478.712 109.192 480.796C109.192 482.879 110.877 484.564 112.961 484.564C115.045 484.564 116.738 482.879 116.738 480.796C116.738 478.712 115.053 477.027 112.961 477.027Z"
            fill="white"
          />
          <path
            d="M106.985 472.699C104.884 472.699 103.187 474.397 103.187 476.489C103.187 478.581 104.884 480.287 106.985 480.287C109.085 480.287 110.774 478.59 110.774 476.489C110.774 474.388 109.077 472.699 106.985 472.699Z"
            fill="white"
          />
          <path
            d="M100.636 468.441C98.5143 468.441 96.7871 470.16 96.7871 472.282C96.7871 474.404 98.5143 476.123 100.636 476.123C102.758 476.123 104.477 474.404 104.477 472.282C104.477 470.16 102.75 468.441 100.636 468.441Z"
            fill="white"
          />
          <path
            d="M93.9055 464.33C91.7624 464.33 90.0352 466.07 90.0352 468.2C90.0352 470.331 91.7624 472.071 93.9055 472.071C96.0485 472.071 97.7758 470.335 97.7758 468.2C97.7758 466.066 96.0358 464.33 93.9055 464.33Z"
            fill="white"
          />
          <path
            d="M86.7851 460.354C84.6292 460.354 82.8936 462.102 82.8936 464.258C82.8936 466.414 84.6335 468.149 86.7851 468.149C88.9367 468.149 90.6766 466.401 90.6766 464.258C90.6766 462.115 88.9367 460.354 86.7851 460.354Z"
            fill="white"
          />
          <path
            d="M79.2809 456.377C77.1166 456.377 75.3555 458.138 75.3555 460.302C75.3555 462.467 77.1166 464.228 79.2809 464.228C81.4452 464.228 83.2149 462.467 83.2149 460.302C83.2149 458.138 81.4537 456.377 79.2809 456.377Z"
            fill="white"
          />
          <path
            d="M71.4435 452.285C69.2664 452.285 67.4883 454.055 67.4883 456.24C67.4883 458.426 69.2664 460.196 71.4435 460.196C73.6205 460.196 75.3986 458.426 75.3986 456.24C75.3986 454.055 73.629 452.285 71.4435 452.285Z"
            fill="white"
          />
          <path
            d="M63.3162 448.051C61.1307 448.051 59.3525 449.829 59.3525 452.027C59.3525 454.225 61.1307 455.991 63.3162 455.991C65.5017 455.991 67.2926 454.221 67.2926 452.027C67.2926 449.833 65.5145 448.051 63.3162 448.051Z"
            fill="white"
          />
          <path
            d="M54.9263 451.624C57.1341 451.624 58.9239 449.834 58.9239 447.627C58.9239 445.419 57.1341 443.629 54.9263 443.629C52.7185 443.629 50.9287 445.419 50.9287 447.627C50.9287 449.834 52.7185 451.624 54.9263 451.624Z"
            fill="white"
          />
          <path
            d="M46.2991 438.994C44.0923 438.994 42.293 440.794 42.293 443.013C42.293 445.232 44.0923 447.019 46.2991 447.019C48.5058 447.019 50.3179 445.22 50.3179 443.013C50.3179 440.806 48.5185 438.994 46.2991 438.994Z"
            fill="white"
          />
          <path
            d="M37.4717 434.053C35.2352 434.053 33.4316 435.865 33.4316 438.093C33.4316 440.321 35.231 442.133 37.4717 442.133C39.7124 442.133 41.5117 440.333 41.5117 438.093C41.5117 435.852 39.6997 434.053 37.4717 434.053Z"
            fill="white"
          />
          <path
            d="M28.4704 428.691C26.234 428.691 24.4219 430.512 24.4219 432.748C24.4219 434.985 26.234 436.797 28.4704 436.797C30.7069 436.797 32.5274 434.985 32.5274 432.748C32.5274 430.512 30.7154 428.691 28.4704 428.691Z"
            fill="white"
          />
          <path
            d="M19.3852 422.791C17.1487 422.791 15.3281 424.612 15.3281 426.848C15.3281 429.084 17.1487 430.897 19.3852 430.897C21.6216 430.897 23.4337 429.084 23.4337 426.848C23.4337 424.612 21.6216 422.791 19.3852 422.791Z"
            fill="white"
          />
          <path
            d="M10.2445 416.242C8.00807 416.242 6.1875 418.063 6.1875 420.312C6.1875 422.561 8.00807 424.382 10.2445 424.382C12.481 424.382 14.3143 422.561 14.3143 420.312C14.3143 418.063 12.4937 416.242 10.2445 416.242Z"
            fill="white"
          />
          <path
            d="M1.15832 409.043C-1.09935 409.043 -2.91992 410.864 -2.91992 413.121C-2.91992 415.379 -1.09935 417.191 1.15832 417.191C3.416 417.191 5.23657 415.37 5.23657 413.121C5.23657 410.872 3.40327 409.043 1.15832 409.043Z"
            fill="white"
          />
          <path
            d="M-0.942021 268.672C-3.10633 268.672 -4.87598 270.433 -4.87598 272.597C-4.87598 274.762 -3.10633 276.531 -0.942021 276.531C1.22229 276.531 2.99194 274.774 2.99194 272.597C2.99194 270.42 1.23078 268.672 -0.942021 268.672Z"
            fill="white"
          />
          <path
            d="M5.63539 256.971C3.47108 256.971 1.72266 258.719 1.72266 260.875C1.72266 263.031 3.47108 264.788 5.63539 264.788C7.79971 264.788 9.53964 263.039 9.53964 260.875C9.53964 258.711 7.79122 256.971 5.63539 256.971Z"
            fill="white"
          />
          <path
            d="M12.3791 244.783C10.236 244.783 8.49609 246.523 8.49609 248.675C8.49609 250.826 10.236 252.558 12.3791 252.558C14.5222 252.558 16.2706 250.818 16.2706 248.675C16.2706 246.532 14.5307 244.783 12.3791 244.783Z"
            fill="white"
          />
          <path
            d="M19.1853 232.43C17.0634 232.43 15.3447 234.148 15.3447 236.27C15.3447 238.392 17.0634 240.111 19.1853 240.111C21.3072 240.111 23.0259 238.384 23.0259 236.27C23.0259 234.157 21.3072 232.43 19.1853 232.43Z"
            fill="white"
          />
          <path
            d="M25.9505 220.09C23.8499 220.09 22.1396 221.796 22.1396 223.901C22.1396 226.006 23.8456 227.72 25.9505 227.72C28.0554 227.72 29.7699 226.014 29.7699 223.901C29.7699 221.787 28.0639 220.09 25.9505 220.09Z"
            fill="white"
          />
          <path
            d="M32.6139 208.014C30.5217 208.014 28.8369 209.711 28.8369 211.791C28.8369 213.87 30.5217 215.58 32.6139 215.58C34.706 215.58 36.3908 213.883 36.3908 211.791C36.3908 209.698 34.6933 208.014 32.6139 208.014Z"
            fill="white"
          />
          <path
            d="M39.1483 196.357C37.0773 196.357 35.3926 198.034 35.3926 200.105C35.3926 202.176 37.0773 203.852 39.1483 203.852C41.2192 203.852 42.8955 202.176 42.8955 200.105C42.8955 198.034 41.2108 196.357 39.1483 196.357Z"
            fill="white"
          />
          <path
            d="M45.4763 185.488C43.4265 185.488 41.7715 187.152 41.7715 189.193C41.7715 191.234 43.4265 192.898 45.4763 192.898C47.526 192.898 49.1811 191.243 49.1811 189.193C49.1811 187.143 47.526 185.488 45.4763 185.488Z"
            fill="white"
          />
          <path
            d="M51.6585 175.377C49.6384 175.377 47.9961 177.011 47.9961 179.035C47.9961 181.059 49.6427 182.693 51.6585 182.693C53.6742 182.693 55.3208 181.059 55.3208 179.035C55.3208 177.011 53.6742 175.377 51.6585 175.377Z"
            fill="white"
          />
          <path
            d="M57.7566 165.852C55.7578 165.852 54.1367 167.477 54.1367 169.484C54.1367 171.492 55.7578 173.104 57.7566 173.104C59.7554 173.104 61.3893 171.479 61.3893 169.484C61.3893 167.49 59.7639 165.852 57.7566 165.852Z"
            fill="white"
          />
          <path
            d="M63.7409 156.922C61.7633 156.922 60.1592 158.526 60.1592 160.504C60.1592 162.481 61.7633 164.077 63.7409 164.077C65.7185 164.077 67.3226 162.473 67.3226 160.504C67.3226 158.535 65.7185 156.922 63.7409 156.922Z"
            fill="white"
          />
          <path
            d="M69.5718 148.449C67.6239 148.449 66.0537 150.019 66.0537 151.967C66.0537 153.915 67.6239 155.485 69.5718 155.485C71.5197 155.485 73.0898 153.915 73.0898 151.967C73.0898 150.019 71.5197 148.449 69.5718 148.449Z"
            fill="white"
          />
          <path
            d="M75.1397 140.375C73.2258 140.375 71.6641 141.932 71.6641 143.851C71.6641 145.769 73.2258 147.326 75.1397 147.326C77.0536 147.326 78.6153 145.769 78.6153 143.851C78.6153 141.932 77.0664 140.375 75.1397 140.375Z"
            fill="white"
          />
          <path
            d="M80.3717 132.586C78.479 132.586 76.9385 134.126 76.9385 136.019C76.9385 137.912 78.479 139.444 80.3717 139.444C82.2644 139.444 83.7964 137.908 83.7964 136.019C83.7964 134.131 82.2559 132.586 80.3717 132.586Z"
            fill="white"
          />
          <path
            d="M85.1713 124.986C83.3083 124.986 81.7891 126.501 81.7891 128.373C81.7891 130.244 83.3083 131.755 85.1713 131.755C87.0343 131.755 88.5536 130.236 88.5536 128.373C88.5536 126.51 87.0428 124.986 85.1713 124.986Z"
            fill="white"
          />
          <path
            d="M89.4915 117.58C87.6582 117.58 86.1729 119.061 86.1729 120.899C86.1729 122.736 87.6624 124.213 89.4915 124.213C91.3205 124.213 92.8101 122.732 92.8101 120.899C92.8101 119.065 91.3205 117.58 89.4915 117.58Z"
            fill="white"
          />
          <path
            d="M93.311 110.453C91.5116 110.453 90.0518 111.909 90.0518 113.712C90.0518 115.516 91.5074 116.972 93.311 116.972C95.1146 116.972 96.5702 115.516 96.5702 113.712C96.5702 111.909 95.1146 110.453 93.311 110.453Z"
            fill="white"
          />
          <path
            d="M96.622 103.764C94.8524 103.764 93.4053 105.207 93.4053 106.976C93.4053 108.746 94.8524 110.193 96.622 110.193C98.3917 110.193 99.8388 108.75 99.8388 106.976C99.8388 105.202 98.3917 103.764 96.622 103.764Z"
            fill="white"
          />
          <path
            d="M99.4734 97.6074C97.7335 97.6074 96.3203 99.0248 96.3203 100.761C96.3203 102.496 97.7377 103.909 99.4734 103.909C101.209 103.909 102.627 102.5 102.627 100.761C102.627 99.0206 101.209 97.6074 99.4734 97.6074Z"
            fill="white"
          />
          <path
            d="M101.947 91.9492C100.25 91.9492 98.875 93.3242 98.875 95.0132C98.875 96.7022 100.25 98.0857 101.947 98.0857C103.645 98.0857 105.02 96.7107 105.02 95.0132C105.02 93.3157 103.645 91.9492 101.947 91.9492Z"
            fill="white"
          />
          <path
            d="M104.145 86.6348C102.482 86.6348 101.128 87.9843 101.128 89.6521C101.128 91.3199 102.482 92.6694 104.145 92.6694C105.809 92.6694 107.163 91.3156 107.163 89.6521C107.163 87.9885 105.809 86.6348 104.145 86.6348Z"
            fill="white"
          />
          <path
            d="M106.132 81.5762C104.498 81.5762 103.174 82.9002 103.174 84.5341C103.174 86.1679 104.494 87.4962 106.132 87.4962C107.77 87.4962 109.098 86.1679 109.098 84.5341C109.098 82.9002 107.766 81.5762 106.132 81.5762Z"
            fill="white"
          />
          <path
            d="M107.995 76.623C106.391 76.623 105.093 77.9259 105.093 79.5258C105.093 81.1257 106.396 82.4243 107.995 82.4243C109.595 82.4243 110.898 81.1299 110.898 79.5258C110.898 77.9216 109.595 76.623 107.995 76.623Z"
            fill="white"
          />
          <path
            d="M109.798 71.6816C108.249 71.6816 106.997 72.942 106.997 74.491C106.997 76.04 108.245 77.3004 109.798 77.3004C111.351 77.3004 112.607 76.04 112.607 74.491C112.607 72.942 111.347 71.6816 109.798 71.6816Z"
            fill="white"
          />
          <path
            d="M111.606 66.541C110.095 66.541 108.86 67.7675 108.86 69.2867C108.86 70.806 110.1 72.0324 111.606 72.0324C113.113 72.0324 114.352 70.7975 114.352 69.2867C114.352 67.7759 113.125 66.541 111.606 66.541Z"
            fill="white"
          />
          <path
            d="M113.511 61.1055C112.022 61.1055 110.825 62.3149 110.825 63.796C110.825 65.2771 112.022 66.4823 113.511 66.4823C115.001 66.4823 116.198 65.2813 116.198 63.796C116.198 62.3107 115.001 61.1055 113.511 61.1055Z"
            fill="white"
          />
          <path
            d="M115.667 55.0781C114.212 55.0781 113.036 56.2536 113.036 57.7008C113.036 59.1479 114.212 60.3276 115.667 60.3276C117.123 60.3276 118.29 59.1521 118.29 57.7008C118.29 56.2494 117.114 55.0781 115.667 55.0781Z"
            fill="white"
          />
          <path
            d="M118.333 48.0645C116.937 48.0645 115.804 49.1975 115.804 50.5937C115.804 51.9899 116.937 53.1272 118.333 53.1272C119.729 53.1272 120.871 51.9942 120.871 50.5937C120.871 49.1933 119.738 48.0645 118.333 48.0645Z"
            fill="white"
          />
          <path
            d="M121.965 39.4883C120.603 39.4883 119.508 40.5832 119.508 41.9454C119.508 43.3077 120.603 44.4025 121.965 44.4025C123.327 44.4025 124.422 43.2992 124.422 41.9454C124.422 40.5917 123.319 39.4883 121.965 39.4883Z"
            fill="white"
          />
          <path
            d="M127.168 28.7695C125.848 28.7695 124.774 29.8432 124.774 31.163C124.774 32.4828 125.848 33.5607 127.168 33.5607C128.488 33.5607 129.574 32.4828 129.574 31.163C129.574 29.8432 128.492 28.7695 127.168 28.7695Z"
            fill="white"
          />
          <path
            d="M135.015 15.0527C133.725 15.0527 132.686 16.0925 132.686 17.3826C132.686 18.6727 133.725 19.7124 135.015 19.7124C136.305 19.7124 137.345 18.6727 137.345 17.3826C137.345 16.0925 136.305 15.0527 135.015 15.0527Z"
            fill="white"
          />
          <path
            d="M146.724 -2.61914C145.485 -2.61914 144.487 -1.62186 144.487 -0.391172C144.487 0.839515 145.485 1.8368 146.724 1.8368C147.963 1.8368 148.952 0.843759 148.952 -0.391172C148.952 -1.6261 147.954 -2.61914 146.724 -2.61914Z"
            fill="white"
          />
          <path
            d="M948.207 2.34375C946.687 2.34375 945.448 3.58292 945.448 5.10643C945.448 6.62994 946.687 7.86911 948.207 7.86911C949.726 7.86911 950.974 6.62994 950.974 5.10643C950.974 3.58292 949.734 2.34375 948.207 2.34375Z"
            fill="white"
          />
          <path
            d="M955.812 13.0625C954.229 13.0625 952.96 14.3356 952.96 15.9143C952.96 17.493 954.229 18.7661 955.812 18.7661C957.395 18.7661 958.664 17.4845 958.664 15.9143C958.664 14.3441 957.382 13.0625 955.812 13.0625Z"
            fill="white"
          />
          <path
            d="M963.455 23.6543C961.842 23.6543 960.539 24.9614 960.539 26.5613C960.539 28.1612 961.842 29.4767 963.455 29.4767C965.067 29.4767 966.37 28.1739 966.37 26.5613C966.37 24.9486 965.059 23.6543 963.455 23.6543Z"
            fill="white"
          />
          <path
            d="M971.144 34.0781C969.498 34.0781 968.178 35.4064 968.178 37.0445C968.178 38.6826 969.498 40.0151 971.144 40.0151C972.791 40.0151 974.11 38.6868 974.11 37.0445C974.11 35.4022 972.786 34.0781 971.144 34.0781Z"
            fill="white"
          />
          <path
            d="M978.803 44.5C977.14 44.5 975.786 45.8495 975.786 47.5173C975.786 49.1851 977.14 50.5389 978.803 50.5389C980.467 50.5389 981.833 49.1851 981.833 47.5173C981.833 45.8495 980.48 44.5 978.803 44.5Z"
            fill="white"
          />
          <path
            d="M986.443 54.8945C984.737 54.8945 983.341 56.2822 983.341 57.9967C983.341 59.7112 984.737 61.1074 986.443 61.1074C988.149 61.1074 989.554 59.7112 989.554 57.9967C989.554 56.2822 988.158 54.8945 986.443 54.8945Z"
            fill="white"
          />
          <path
            d="M994.073 65.3066C992.324 65.3066 990.898 66.7283 990.898 68.4767C990.898 70.2251 992.324 71.6383 994.073 71.6383C995.821 71.6383 997.239 70.2209 997.239 68.4767C997.239 66.7325 995.821 65.3066 994.073 65.3066Z"
            fill="white"
          />
          <path
            d="M1001.67 75.7227C999.899 75.7227 998.465 77.1613 998.465 78.9394C998.465 80.7176 999.899 82.1562 1001.67 82.1562C1003.44 82.1562 1004.89 80.7091 1004.89 78.9394C1004.89 77.1698 1003.45 75.7227 1001.67 75.7227Z"
            fill="white"
          />
          <path
            d="M1009.28 86.0957C1007.47 86.0957 1006 87.5598 1006 89.3634C1006 91.167 1007.47 92.6438 1009.28 92.6438C1011.09 92.6438 1012.55 91.1755 1012.55 89.3634C1012.55 87.5513 1011.08 86.0957 1009.28 86.0957Z"
            fill="white"
          />
          <path
            d="M1016.84 96.4941C1014.98 96.4941 1013.48 97.9922 1013.48 99.8467C1013.48 101.701 1014.98 103.199 1016.84 103.199C1018.69 103.199 1020.19 101.701 1020.19 99.8467C1020.19 97.9922 1018.68 96.4941 1016.84 96.4941Z"
            fill="white"
          />
          <path
            d="M1024.36 106.963C1022.48 106.963 1020.96 108.482 1020.96 110.354C1020.96 112.225 1022.48 113.757 1024.36 113.757C1026.24 113.757 1027.75 112.234 1027.75 110.354C1027.75 108.474 1026.24 106.963 1024.36 106.963Z"
            fill="white"
          />
          <path
            d="M1031.85 117.475C1029.95 117.475 1028.4 119.024 1028.4 120.929C1028.4 122.834 1029.95 124.383 1031.85 124.383C1033.76 124.383 1035.3 122.834 1035.3 120.929C1035.3 119.024 1033.76 117.475 1031.85 117.475Z"
            fill="white"
          />
          <path
            d="M1039.29 128.115C1037.35 128.115 1035.79 129.685 1035.79 131.616C1035.79 133.547 1037.35 135.117 1039.29 135.117C1041.22 135.117 1042.78 133.547 1042.78 131.616C1042.78 129.685 1041.22 128.115 1039.29 128.115Z"
            fill="white"
          />
          <path
            d="M1046.65 138.877C1044.68 138.877 1043.09 140.473 1043.09 142.437C1043.09 144.402 1044.68 145.998 1046.65 145.998C1048.62 145.998 1050.21 144.407 1050.21 142.437C1050.21 140.468 1048.62 138.877 1046.65 138.877Z"
            fill="white"
          />
          <path
            d="M1053.94 149.846C1051.95 149.846 1050.34 151.458 1050.34 153.457C1050.34 155.456 1051.95 157.06 1053.94 157.06C1055.93 157.06 1057.55 155.447 1057.55 153.457C1057.55 151.467 1055.94 149.846 1053.94 149.846Z"
            fill="white"
          />
          <path
            d="M1061.13 161.084C1059.13 161.084 1057.49 162.718 1057.49 164.738C1057.49 166.758 1059.13 168.387 1061.13 168.387C1063.14 168.387 1064.79 166.749 1064.79 164.738C1064.79 162.726 1063.15 161.084 1061.13 161.084Z"
            fill="white"
          />
          <path
            d="M1068.26 172.576C1066.22 172.576 1064.57 174.231 1064.57 176.272C1064.57 178.314 1066.22 179.969 1068.26 179.969C1070.3 179.969 1071.96 178.314 1071.96 176.272C1071.96 174.231 1070.3 172.576 1068.26 172.576Z"
            fill="white"
          />
          <path
            d="M1075.37 184.24C1073.29 184.24 1071.61 185.921 1071.61 187.996C1071.61 190.071 1073.29 191.752 1075.37 191.752C1077.45 191.752 1079.11 190.067 1079.11 187.996C1079.11 185.925 1077.44 184.24 1075.37 184.24Z"
            fill="white"
          />
          <path
            d="M1082.52 196.023C1080.42 196.023 1078.73 197.717 1078.73 199.813C1078.73 201.91 1080.42 203.603 1082.52 203.603C1084.61 203.603 1086.31 201.905 1086.31 199.813C1086.31 197.721 1084.61 196.023 1082.52 196.023Z"
            fill="white"
          />
          <path
            d="M1089.83 207.658C1087.71 207.658 1086 209.364 1086 211.49C1086 213.616 1087.72 215.31 1089.83 215.31C1091.94 215.31 1093.66 213.604 1093.66 211.49C1093.66 209.377 1091.94 207.658 1089.83 207.658Z"
            fill="white"
          />
          <path
            d="M1097.4 218.9C1095.27 218.9 1093.54 220.628 1093.54 222.762C1093.54 224.897 1095.27 226.632 1097.4 226.632C1099.54 226.632 1101.27 224.905 1101.27 222.762C1101.27 220.619 1099.53 218.9 1097.4 218.9Z"
            fill="white"
          />
          <path
            d="M1105.3 229.576C1103.15 229.576 1101.4 231.325 1101.4 233.489C1101.4 235.653 1103.15 237.393 1105.3 237.393C1107.46 237.393 1109.21 235.645 1109.21 233.489C1109.21 231.333 1107.45 229.576 1105.3 229.576Z"
            fill="white"
          />
          <path
            d="M1113.56 239.498C1111.38 239.498 1109.61 241.259 1109.61 243.432C1109.61 245.605 1111.38 247.374 1113.56 247.374C1115.73 247.374 1117.49 245.605 1117.49 243.432C1117.49 241.259 1115.73 239.498 1113.56 239.498Z"
            fill="white"
          />
          <path
            d="M1122.16 248.492C1119.97 248.492 1118.19 250.27 1118.19 252.456C1118.19 254.641 1119.96 256.432 1122.16 256.432C1124.36 256.432 1126.13 254.654 1126.13 252.456C1126.13 250.258 1124.36 248.492 1122.16 248.492Z"
            fill="white"
          />
          <path
            d="M1131.1 264.53C1133.31 264.53 1135.1 262.741 1135.1 260.533C1135.1 258.325 1133.31 256.535 1131.1 256.535C1128.9 256.535 1127.11 258.325 1127.11 260.533C1127.11 262.741 1128.9 264.53 1131.1 264.53Z"
            fill="white"
          />
          <path
            d="M1140.33 263.643C1138.1 263.643 1136.29 265.455 1136.29 267.691C1136.29 269.928 1138.1 271.74 1140.33 271.74C1142.57 271.74 1144.38 269.928 1144.38 267.691C1144.38 265.455 1142.57 263.643 1140.33 263.643Z"
            fill="white"
          />
          <path
            d="M1149.81 269.99C1147.56 269.99 1145.74 271.811 1145.74 274.047C1145.74 276.284 1147.56 278.117 1149.81 278.117C1152.06 278.117 1153.88 276.296 1153.88 274.047C1153.88 271.798 1152.05 269.99 1149.81 269.99Z"
            fill="white"
          />
          <path
            d="M1159.49 283.826C1161.74 283.826 1163.58 281.995 1163.58 279.735C1163.58 277.476 1161.74 275.645 1159.49 275.645C1157.23 275.645 1155.39 277.476 1155.39 279.735C1155.39 281.995 1157.23 283.826 1159.49 283.826Z"
            fill="white"
          />
          <path
            d="M1169.31 280.746C1167.04 280.746 1165.21 282.588 1165.21 284.858C1165.21 287.129 1167.04 288.97 1169.31 288.97C1171.58 288.97 1173.42 287.129 1173.42 284.858C1173.42 282.588 1171.59 280.746 1169.31 280.746Z"
            fill="white"
          />
          <path
            d="M1179.27 285.375C1176.98 285.375 1175.13 287.225 1175.13 289.508C1175.13 291.792 1176.98 293.65 1179.27 293.65C1181.56 293.65 1183.4 291.8 1183.4 289.508C1183.4 287.217 1181.55 285.375 1179.27 285.375Z"
            fill="white"
          />
          <path
            d="M1189.32 289.609C1187.02 289.609 1185.17 291.472 1185.17 293.764C1185.17 296.056 1187.02 297.919 1189.32 297.919C1191.62 297.919 1193.48 296.064 1193.48 293.764C1193.48 291.464 1191.62 289.609 1189.32 289.609Z"
            fill="white"
          />
          <path
            d="M1199.46 293.506C1197.16 293.506 1195.3 295.356 1195.3 297.66C1195.3 299.965 1197.16 301.815 1199.46 301.815C1201.76 301.815 1203.62 299.952 1203.62 297.66C1203.62 295.369 1201.75 293.506 1199.46 293.506Z"
            fill="white"
          />
          <path
            d="M1209.65 297.031C1207.35 297.031 1205.5 298.894 1205.5 301.186C1205.5 303.477 1207.35 305.341 1209.65 305.341C1211.96 305.341 1213.81 303.486 1213.81 301.186C1213.81 298.886 1211.94 297.031 1209.65 297.031Z"
            fill="white"
          />
          <path
            d="M1219.86 300.221C1217.56 300.221 1215.71 302.075 1215.71 304.375C1215.71 306.675 1217.56 308.53 1219.86 308.53C1222.17 308.53 1224.02 306.667 1224.02 304.375C1224.02 302.084 1222.15 300.221 1219.86 300.221Z"
            fill="white"
          />
          <path
            d="M1230.06 303.027C1227.76 303.027 1225.91 304.89 1225.91 307.182C1225.91 309.474 1227.76 311.337 1230.06 311.337C1232.36 311.337 1234.21 309.482 1234.21 307.182C1234.21 304.882 1232.35 303.027 1230.06 303.027Z"
            fill="white"
          />
          <path
            d="M1240.23 305.379C1237.94 305.379 1236.07 307.242 1236.07 309.534C1236.07 311.825 1237.94 313.688 1240.23 313.688C1242.52 313.688 1244.39 311.834 1244.39 309.534C1244.39 307.233 1242.53 305.379 1240.23 305.379Z"
            fill="white"
          />
          <path
            d="M1250.34 307.223C1248.05 307.223 1246.19 309.077 1246.19 311.377C1246.19 313.677 1248.05 315.532 1250.34 315.532C1252.64 315.532 1254.5 313.669 1254.5 311.377C1254.5 309.086 1252.64 307.223 1250.34 307.223Z"
            fill="white"
          />
          <path
            d="M1260.35 308.555C1258.06 308.555 1256.19 310.409 1256.19 312.709C1256.19 315.009 1258.06 316.864 1260.35 316.864C1262.64 316.864 1264.5 315.001 1264.5 312.709C1264.5 310.418 1262.65 308.555 1260.35 308.555Z"
            fill="white"
          />
          <path
            d="M1256.59 309.336C1254.29 309.336 1252.44 311.199 1252.44 313.499C1252.44 315.799 1254.29 317.654 1256.59 317.654C1258.89 317.654 1260.75 315.791 1260.75 313.499C1260.75 311.207 1258.88 309.336 1256.59 309.336Z"
            fill="white"
          />
          <path
            d="M1252.49 309.951C1250.19 309.951 1248.34 311.806 1248.34 314.106C1248.34 316.406 1250.19 318.26 1252.49 318.26C1254.79 318.26 1256.65 316.397 1256.65 314.106C1256.65 311.814 1254.78 309.951 1252.49 309.951Z"
            fill="white"
          />
          <path
            d="M1248 310.375C1245.7 310.375 1243.85 312.225 1243.85 314.53C1243.85 316.834 1245.7 318.684 1248 318.684C1250.3 318.684 1252.16 316.821 1252.16 314.53C1252.16 312.238 1250.29 310.375 1248 310.375Z"
            fill="white"
          />
          <path
            d="M1243.11 310.617C1240.82 310.617 1238.96 312.48 1238.96 314.772C1238.96 317.063 1240.82 318.926 1243.11 318.926C1245.4 318.926 1247.26 317.076 1247.26 314.772C1247.26 312.467 1245.4 310.617 1243.11 310.617Z"
            fill="white"
          />
          <path
            d="M1237.8 310.676C1235.51 310.676 1233.65 312.539 1233.65 314.83C1233.65 317.122 1235.51 318.985 1237.8 318.985C1240.1 318.985 1241.96 317.135 1241.96 314.83C1241.96 312.526 1240.1 310.676 1237.8 310.676Z"
            fill="white"
          />
          <path
            d="M1232.08 310.541C1229.79 310.541 1227.92 312.396 1227.92 314.696C1227.92 316.996 1229.79 318.85 1232.08 318.85C1234.37 318.85 1236.23 316.987 1236.23 314.696C1236.23 312.404 1234.37 310.541 1232.08 310.541Z"
            fill="white"
          />
          <path
            d="M1225.95 310.189C1223.66 310.189 1221.8 312.052 1221.8 314.344C1221.8 316.636 1223.66 318.507 1225.95 318.507C1228.24 318.507 1230.11 316.644 1230.11 314.344C1230.11 312.044 1228.24 310.189 1225.95 310.189Z"
            fill="white"
          />
          <path
            d="M1219.43 309.68C1217.13 309.68 1215.27 311.543 1215.27 313.834C1215.27 316.126 1217.13 317.989 1219.43 317.989C1221.73 317.989 1223.58 316.139 1223.58 313.834C1223.58 311.53 1221.72 309.68 1219.43 309.68Z"
            fill="white"
          />
          <path
            d="M1212.5 309.012C1210.21 309.012 1208.35 310.875 1208.35 313.166C1208.35 315.458 1210.21 317.321 1212.5 317.321C1214.79 317.321 1216.66 315.471 1216.66 313.166C1216.66 310.862 1214.81 309.012 1212.5 309.012Z"
            fill="white"
          />
          <path
            d="M1205.22 308.201C1202.92 308.201 1201.06 310.064 1201.06 312.356C1201.06 314.647 1202.92 316.51 1205.22 316.51C1207.52 316.51 1209.37 314.656 1209.37 312.356C1209.37 310.056 1207.51 308.201 1205.22 308.201Z"
            fill="white"
          />
          <path
            d="M1197.57 307.264C1195.27 307.264 1193.42 309.127 1193.42 311.418C1193.42 313.71 1195.27 315.581 1197.57 315.581C1199.87 315.581 1201.72 313.718 1201.72 311.418C1201.72 309.118 1199.86 307.264 1197.57 307.264Z"
            fill="white"
          />
          <path
            d="M1189.57 306.232C1187.27 306.232 1185.42 308.095 1185.42 310.387C1185.42 312.679 1187.27 314.542 1189.57 314.542C1191.88 314.542 1193.73 312.691 1193.73 310.387C1193.73 308.083 1191.87 306.232 1189.57 306.232Z"
            fill="white"
          />
          <path
            d="M1181.25 305.164C1178.96 305.164 1177.11 307.014 1177.11 309.306C1177.11 311.598 1178.96 313.439 1181.25 313.439C1183.53 313.439 1185.38 311.589 1185.38 309.306C1185.38 307.023 1183.53 305.164 1181.25 305.164Z"
            fill="white"
          />
          <path
            d="M1172.61 304.082C1170.34 304.082 1168.5 305.924 1168.5 308.194C1168.5 310.465 1170.34 312.315 1172.61 312.315C1174.88 312.315 1176.72 310.473 1176.72 308.194C1176.72 305.915 1174.88 304.082 1172.61 304.082Z"
            fill="white"
          />
          <path
            d="M1163.67 303.016C1161.41 303.016 1159.57 304.849 1159.57 307.107C1159.57 309.364 1161.41 311.206 1163.67 311.206C1165.93 311.206 1167.77 309.373 1167.77 307.107C1167.77 304.84 1165.93 303.016 1163.67 303.016Z"
            fill="white"
          />
          <path
            d="M1154.44 302.02C1152.19 302.02 1150.38 303.832 1150.38 306.068C1150.38 308.305 1152.19 310.125 1154.44 310.125C1156.68 310.125 1158.48 308.305 1158.48 306.068C1158.48 303.832 1156.67 302.02 1154.44 302.02Z"
            fill="white"
          />
          <path
            d="M1144.91 301.072C1142.68 301.072 1140.87 302.884 1140.87 305.112C1140.87 307.34 1142.68 309.152 1144.91 309.152C1147.13 309.152 1148.95 307.34 1148.95 305.112C1148.95 302.884 1147.15 301.072 1144.91 301.072Z"
            fill="white"
          />
          <path
            d="M1135.11 300.277C1132.89 300.277 1131.1 302.068 1131.1 304.283C1131.1 306.499 1132.89 308.29 1135.11 308.29C1137.32 308.29 1139.12 306.49 1139.12 304.283C1139.12 302.077 1137.32 300.277 1135.11 300.277Z"
            fill="white"
          />
          <path
            d="M1125.07 299.666C1122.87 299.666 1121.08 301.444 1121.08 303.642C1121.08 305.841 1122.87 307.619 1125.07 307.619C1127.26 307.619 1129.04 305.841 1129.04 303.642C1129.04 301.444 1127.26 299.666 1125.07 299.666Z"
            fill="white"
          />
          <path
            d="M1114.77 299.303C1112.6 299.303 1110.84 301.06 1110.84 303.237C1110.84 305.414 1112.6 307.171 1114.77 307.171C1116.95 307.171 1118.71 305.414 1118.71 303.237C1118.71 301.06 1116.95 299.303 1114.77 299.303Z"
            fill="white"
          />
          <path
            d="M1104.23 299.146C1102.07 299.146 1100.32 300.903 1100.32 303.059C1100.32 305.215 1102.07 306.963 1104.23 306.963C1106.38 306.963 1108.14 305.215 1108.14 303.059C1108.14 300.903 1106.39 299.146 1104.23 299.146Z"
            fill="white"
          />
          <path
            d="M1093.45 299.281C1091.31 299.281 1089.58 301.017 1089.58 303.164C1089.58 305.312 1091.31 307.035 1093.45 307.035C1095.58 307.035 1097.33 305.307 1097.33 303.164C1097.33 301.021 1095.6 299.281 1093.45 299.281Z"
            fill="white"
          />
          <path
            d="M1082.44 299.781C1080.32 299.781 1078.61 301.487 1078.61 303.601C1078.61 305.714 1080.33 307.433 1082.44 307.433C1084.55 307.433 1086.27 305.727 1086.27 303.601C1086.27 301.475 1084.55 299.781 1082.44 299.781Z"
            fill="white"
          />
          <path
            d="M1071.22 300.664C1069.12 300.664 1067.43 302.362 1067.43 304.454C1067.43 306.546 1069.12 308.243 1071.22 308.243C1073.31 308.243 1075.01 306.546 1075.01 304.454C1075.01 302.362 1073.31 300.664 1071.22 300.664Z"
            fill="white"
          />
          <path
            d="M1059.78 301.977C1057.71 301.977 1056.04 303.653 1056.04 305.711C1056.04 307.769 1057.71 309.458 1059.78 309.458C1061.85 309.458 1063.51 307.782 1063.51 305.711C1063.51 303.64 1061.85 301.977 1059.78 301.977Z"
            fill="white"
          />
          <path
            d="M1048.14 303.674C1046.09 303.674 1044.42 305.329 1044.42 307.379C1044.42 309.428 1046.09 311.096 1048.14 311.096C1050.2 311.096 1051.86 309.433 1051.86 307.379C1051.86 305.325 1050.19 303.674 1048.14 303.674Z"
            fill="white"
          />
          <path
            d="M1036.34 305.869C1034.32 305.869 1032.68 307.516 1032.68 309.531C1032.68 311.547 1034.33 313.207 1036.34 313.207C1038.36 313.207 1040.02 311.56 1040.02 309.531C1040.02 307.503 1038.37 305.869 1036.34 305.869Z"
            fill="white"
          />
          <path
            d="M1024.38 308.639C1022.38 308.639 1020.77 310.251 1020.77 312.242C1020.77 314.232 1022.38 315.845 1024.38 315.845C1026.38 315.845 1027.99 314.232 1027.99 312.242C1027.99 310.251 1026.37 308.639 1024.38 308.639Z"
            fill="white"
          />
          <path
            d="M1012.29 311.959C1010.32 311.959 1008.73 313.55 1008.73 315.519C1008.73 317.489 1010.32 319.08 1012.29 319.08C1014.26 319.08 1015.86 317.489 1015.86 315.519C1015.86 313.55 1014.26 311.959 1012.29 311.959Z"
            fill="white"
          />
          <path
            d="M1000.09 315.818C998.139 315.818 996.568 317.389 996.568 319.336C996.568 321.284 998.139 322.855 1000.09 322.855C1002.03 322.855 1003.59 321.272 1003.59 319.336C1003.59 317.401 1002.02 315.818 1000.09 315.818Z"
            fill="white"
          />
          <path
            d="M990.969 325.128C991.701 323.359 990.861 321.331 989.092 320.598C987.323 319.865 985.295 320.705 984.562 322.474C983.829 324.244 984.669 326.272 986.439 327.005C988.208 327.737 990.236 326.897 990.969 325.128Z"
            fill="white"
          />
          <path
            d="M975.43 325.748C973.558 325.748 972.039 327.267 972.039 329.139C972.039 331.01 973.558 332.542 975.43 332.542C977.301 332.542 978.833 331.023 978.833 329.139C978.833 327.255 977.314 325.748 975.43 325.748Z"
            fill="white"
          />
          <path
            d="M963.11 332.191C961.26 332.191 959.758 333.689 959.758 335.544C959.758 337.398 961.256 338.884 963.11 338.884C964.965 338.884 966.45 337.386 966.45 335.544C966.45 333.702 964.952 332.191 963.11 332.191Z"
            fill="white"
          />
          <path
            d="M950.872 340.008C949.051 340.008 947.583 341.485 947.583 343.309C947.583 345.134 949.051 346.607 950.872 346.607C952.692 346.607 954.169 345.13 954.169 343.309C954.169 341.489 952.692 340.008 950.872 340.008Z"
            fill="white"
          />
          <path
            d="M938.891 349.697C937.1 349.697 935.653 351.144 935.653 352.935C935.653 354.726 937.1 356.182 938.891 356.182C940.682 356.182 942.129 354.726 942.129 352.935C942.129 351.144 940.682 349.697 938.891 349.697Z"
            fill="white"
          />
          <path
            d="M927.307 361.592C925.558 361.592 924.141 363.018 924.141 364.758C924.141 366.498 925.558 367.932 927.307 367.932C929.055 367.932 930.468 366.506 930.468 364.758C930.468 363.009 929.051 361.592 927.307 361.592Z"
            fill="white"
          />
          <path
            d="M916.68 376.203C914.961 376.203 913.569 377.587 913.569 379.305C913.569 381.024 914.966 382.416 916.68 382.416C918.395 382.416 919.782 381.02 919.782 379.305C919.782 377.591 918.399 376.203 916.68 376.203Z"
            fill="white"
          />
          <path
            d="M907.165 393.621C905.468 393.621 904.105 394.983 904.105 396.672C904.105 398.361 905.468 399.732 907.165 399.732C908.863 399.732 910.225 398.37 910.225 396.672C910.225 394.975 908.85 393.621 907.165 393.621Z"
            fill="white"
          />
          <path
            d="M899.556 414.631C897.892 414.631 896.547 415.972 896.547 417.627C896.547 419.282 897.888 420.636 899.556 420.636C901.224 420.636 902.552 419.295 902.552 417.627C902.552 415.959 901.211 414.631 899.556 414.631Z"
            fill="white"
          />
          <path
            d="M895.011 440.025C893.407 440.025 892.096 441.328 892.096 442.941C892.096 444.553 893.407 445.856 895.011 445.856C896.615 445.856 897.927 444.553 897.927 442.941C897.927 441.328 896.624 440.025 895.011 440.025Z"
            fill="white"
          />
          <path
            d="M894.596 469.982C893.013 469.982 891.744 471.251 891.744 472.834C891.744 474.417 893.013 475.678 894.596 475.678C896.179 475.678 897.439 474.409 897.439 472.834C897.439 471.26 896.17 469.982 894.596 469.982Z"
            fill="white"
          />
          <path
            d="M898.588 504.275C897.047 504.275 895.8 505.523 895.8 507.064C895.8 508.604 897.047 509.864 898.588 509.864C900.128 509.864 901.376 508.604 901.376 507.064C901.376 505.523 900.128 504.275 898.588 504.275Z"
            fill="white"
          />
          <path
            d="M906.126 542.545C904.607 542.545 903.389 543.771 903.389 545.282C903.389 546.793 904.607 548.019 906.126 548.019C907.645 548.019 908.855 546.793 908.855 545.282C908.855 543.771 907.637 542.545 906.126 542.545Z"
            fill="white"
          />
          <path
            d="M915.368 584.572C913.9 584.572 912.725 585.761 912.725 587.216C912.725 588.672 913.9 589.86 915.368 589.86C916.837 589.86 918.012 588.672 918.012 587.216C918.012 585.761 916.824 584.572 915.368 584.572Z"
            fill="white"
          />
          <path
            d="M924.577 630.188C923.151 630.188 921.997 631.342 921.997 632.768C921.997 634.194 923.151 635.348 924.577 635.348C926.003 635.348 927.157 634.194 927.157 632.768C927.157 631.342 926.003 630.188 924.577 630.188Z"
            fill="white"
          />
          <path
            d="M446.68 678.357C445.483 678.357 444.516 679.325 444.516 680.522C444.516 681.718 445.483 682.686 446.68 682.686C447.877 682.686 448.844 681.718 448.844 680.522C448.844 679.325 447.877 678.357 446.68 678.357Z"
            fill="white"
          />
          <path
            d="M430.881 674.484C429.684 674.484 428.717 675.452 428.717 676.649C428.717 677.845 429.684 678.805 430.881 678.805C432.078 678.805 433.045 677.837 433.045 676.649C433.045 675.46 432.078 674.484 430.881 674.484Z"
            fill="white"
          />
          <path
            d="M414.715 670.678C413.518 670.678 412.538 671.645 412.538 672.842C412.538 674.039 413.518 675.019 414.715 675.019C415.912 675.019 416.879 674.039 416.879 672.842C416.879 671.645 415.912 670.678 414.715 670.678Z"
            fill="white"
          />
          <path
            d="M398.136 666.666C396.939 666.666 395.972 667.646 395.972 668.843C395.972 670.04 396.939 671.007 398.136 671.007C399.333 671.007 400.313 670.04 400.313 668.843C400.313 667.646 399.337 666.666 398.136 666.666Z"
            fill="white"
          />
          <path
            d="M381.025 662.172C379.828 662.172 378.86 663.139 378.86 664.336C378.86 665.533 379.828 666.501 381.025 666.501C382.221 666.501 383.189 665.533 383.189 664.336C383.189 663.139 382.221 662.172 381.025 662.172Z"
            fill="white"
          />
          <path
            d="M363.334 657.301C362.145 657.301 361.178 658.268 361.178 659.465C361.178 660.662 362.145 661.621 363.334 661.621C364.522 661.621 365.498 660.653 365.498 659.465C365.498 658.277 364.53 657.301 363.334 657.301Z"
            fill="white"
          />
          <path
            d="M344.962 651.691C343.765 651.691 342.785 652.672 342.785 653.868C342.785 655.065 343.765 656.045 344.962 656.045C346.159 656.045 347.139 655.078 347.139 653.868C347.139 652.659 346.172 651.691 344.962 651.691Z"
            fill="white"
          />
          <path
            d="M325.741 644.947C324.532 644.947 323.564 645.915 323.564 647.124C323.564 648.334 324.532 649.289 325.741 649.289C326.951 649.289 327.906 648.321 327.906 647.124C327.906 645.928 326.938 644.947 325.741 644.947Z"
            fill="white"
          />
          <path
            d="M305.571 637.008C304.374 637.008 303.406 637.975 303.406 639.172C303.406 640.369 304.374 641.336 305.571 641.336C306.767 641.336 307.735 640.369 307.735 639.172C307.735 637.975 306.767 637.008 305.571 637.008Z"
            fill="white"
          />
          <path
            d="M284.234 627.465C283.037 627.465 282.069 628.445 282.069 629.642C282.069 630.839 283.037 631.806 284.234 631.806C285.43 631.806 286.398 630.839 286.398 629.642C286.398 628.445 285.43 627.465 284.234 627.465Z"
            fill="white"
          />
          <path
            d="M261.484 616.68C260.278 616.68 259.307 617.66 259.307 618.857C259.307 620.053 260.274 621.034 261.484 621.034C262.693 621.034 263.661 620.066 263.661 618.857C263.661 617.647 262.68 616.68 261.484 616.68Z"
            fill="white"
          />
          <path
            d="M236.941 604.949C235.744 604.949 234.764 605.93 234.764 607.126C234.764 608.323 235.744 609.303 236.941 609.303C238.137 609.303 239.118 608.336 239.118 607.126C239.118 605.917 238.15 604.949 236.941 604.949Z"
            fill="white"
          />
          <path
            d="M210.345 592.691C209.135 592.691 208.159 593.672 208.159 594.877C208.159 596.082 209.135 597.062 210.345 597.062C211.554 597.062 212.53 596.082 212.53 594.877C212.53 593.672 211.55 592.691 210.345 592.691Z"
            fill="white"
          />
          <path
            d="M196.91 582.76C195.65 582.76 194.64 583.778 194.64 585.039C194.64 586.299 195.65 587.318 196.91 587.318C198.17 587.318 199.189 586.299 199.189 585.039C199.189 583.778 198.17 582.76 196.91 582.76Z"
            fill="white"
          />
          <path
            d="M184.442 573.457C183.152 573.457 182.1 574.509 182.1 575.787C182.1 577.064 183.152 578.129 184.442 578.129C185.732 578.129 186.772 577.077 186.772 575.787C186.772 574.497 185.72 573.457 184.442 573.457Z"
            fill="white"
          />
          <path
            d="M173.786 565.16C172.462 565.16 171.393 566.234 171.393 567.566C171.393 568.899 172.466 569.96 173.786 569.96C175.106 569.96 176.18 568.886 176.18 567.566C176.18 566.247 175.106 565.16 173.786 565.16Z"
            fill="white"
          />
          <path
            d="M165.332 557.967C163.97 557.967 162.866 559.07 162.866 560.432C162.866 561.795 163.97 562.898 165.332 562.898C166.694 562.898 167.797 561.795 167.797 560.432C167.797 559.07 166.694 557.967 165.332 557.967Z"
            fill="white"
          />
          <path
            d="M159.047 551.84C157.63 551.84 156.488 552.986 156.488 554.399C156.488 555.812 157.634 556.958 159.047 556.958C160.46 556.958 161.598 555.812 161.598 554.399C161.598 552.986 160.452 551.84 159.047 551.84Z"
            fill="white"
          />
          <path
            d="M154.664 546.748C153.217 546.748 152.05 547.924 152.05 549.362C152.05 550.801 153.217 551.985 154.664 551.985C156.111 551.985 157.287 550.809 157.287 549.362C157.287 547.915 156.111 546.748 154.664 546.748Z"
            fill="white"
          />
          <path
            d="M151.782 542.48C150.305 542.48 149.096 543.677 149.096 545.154C149.096 546.631 150.301 547.828 151.782 547.828C153.263 547.828 154.456 546.631 154.456 545.154C154.456 543.677 153.259 542.48 151.782 542.48Z"
            fill="white"
          />
          <path
            d="M149.969 538.828C148.45 538.828 147.224 540.067 147.224 541.587C147.224 543.106 148.45 544.332 149.969 544.332C151.489 544.332 152.719 543.106 152.719 541.587C152.719 540.067 151.493 538.828 149.969 538.828Z"
            fill="white"
          />
          <path
            d="M148.929 535.646C147.359 535.646 146.086 536.915 146.086 538.49C146.086 540.064 147.355 541.333 148.929 541.333C150.504 541.333 151.76 540.052 151.76 538.49C151.76 536.928 150.491 535.646 148.929 535.646Z"
            fill="white"
          />
          <path
            d="M148.356 532.824C146.752 532.824 145.462 534.127 145.462 535.718C145.462 537.31 146.752 538.621 148.356 538.621C149.96 538.621 151.25 537.318 151.25 535.718C151.25 534.119 149.96 532.824 148.356 532.824Z"
            fill="white"
          />
          <path
            d="M147.92 530.137C146.286 530.137 144.962 531.469 144.962 533.095C144.962 534.72 146.282 536.053 147.92 536.053C149.558 536.053 150.878 534.733 150.878 533.095C150.878 531.457 149.554 530.137 147.92 530.137Z"
            fill="white"
          />
          <path
            d="M147.403 527.494C145.748 527.494 144.407 528.835 144.407 530.49C144.407 532.145 145.748 533.499 147.403 533.499C149.058 533.499 150.412 532.158 150.412 530.49C150.412 528.822 149.071 527.494 147.403 527.494Z"
            fill="white"
          />
          <path
            d="M146.672 524.734C144.966 524.734 143.583 526.118 143.583 527.824C143.583 529.53 144.966 530.926 146.672 530.926C148.378 530.926 149.775 529.543 149.775 527.824C149.775 526.105 148.378 524.734 146.672 524.734Z"
            fill="white"
          />
          <path
            d="M145.62 521.883C143.884 521.883 142.467 523.287 142.467 525.036C142.467 526.784 143.884 528.189 145.62 528.189C147.356 528.189 148.773 526.772 148.773 525.036C148.773 523.3 147.368 521.883 145.62 521.883Z"
            fill="white"
          />
          <path
            d="M144.164 518.846C142.395 518.846 140.969 520.272 140.969 522.041C140.969 523.811 142.395 525.237 144.164 525.237C145.934 525.237 147.36 523.811 147.36 522.041C147.36 520.272 145.934 518.846 144.164 518.846Z"
            fill="white"
          />
          <path
            d="M142.845 522.053C144.622 521.764 145.829 520.09 145.54 518.313C145.252 516.537 143.578 515.33 141.801 515.618C140.024 515.907 138.818 517.581 139.106 519.358C139.395 521.134 141.069 522.341 142.845 522.053Z"
            fill="white"
          />
          <path
            d="M140.065 512.143C138.231 512.143 136.746 513.632 136.746 515.461C136.746 517.29 138.236 518.78 140.065 518.78C141.894 518.78 143.383 517.29 143.383 515.461C143.383 513.632 141.894 512.143 140.065 512.143Z"
            fill="white"
          />
          <path
            d="M137.472 508.531C135.609 508.531 134.099 510.05 134.099 511.914C134.099 513.777 135.609 515.296 137.472 515.296C139.335 515.296 140.855 513.777 140.855 511.914C140.855 510.05 139.344 508.531 137.472 508.531Z"
            fill="white"
          />
          <path
            d="M134.557 504.809C132.664 504.809 131.132 506.341 131.132 508.233C131.132 510.126 132.664 511.658 134.557 511.658C136.449 511.658 137.981 510.118 137.981 508.233C137.981 506.349 136.449 504.809 134.557 504.809Z"
            fill="white"
          />
          <path
            d="M131.319 500.953C129.405 500.953 127.852 502.502 127.852 504.42C127.852 506.338 129.405 507.896 131.319 507.896C133.233 507.896 134.794 506.334 134.794 504.42C134.794 502.506 133.233 500.953 131.319 500.953Z"
            fill="white"
          />
          <path
            d="M127.771 496.988C125.814 496.988 124.244 498.571 124.244 500.515C124.244 502.458 125.814 504.041 127.771 504.041C129.727 504.041 131.297 502.458 131.297 500.515C131.297 498.571 129.714 496.988 127.771 496.988Z"
            fill="white"
          />
          <path
            d="M123.901 492.971C121.923 492.971 120.319 494.562 120.319 496.54C120.319 498.517 121.923 500.109 123.901 500.109C125.879 500.109 127.47 498.505 127.47 496.54C127.47 494.575 125.866 492.971 123.901 492.971Z"
            fill="white"
          />
          <path
            d="M119.694 488.879C117.695 488.879 116.074 490.504 116.074 492.499C116.074 494.493 117.7 496.11 119.694 496.11C121.689 496.11 123.306 494.498 123.306 492.499C123.306 490.5 121.693 488.879 119.694 488.879Z"
            fill="white"
          />
          <path
            d="M115.159 484.771C113.139 484.771 111.505 486.405 111.505 488.413C111.505 490.42 113.139 492.067 115.159 492.067C117.179 492.067 118.8 490.433 118.8 488.413C118.8 486.393 117.166 484.771 115.159 484.771Z"
            fill="white"
          />
          <path
            d="M110.265 480.609C108.216 480.609 106.561 482.264 106.561 484.314C106.561 486.364 108.216 488.019 110.265 488.019C112.315 488.019 113.97 486.355 113.97 484.314C113.97 482.273 112.307 480.609 110.265 480.609Z"
            fill="white"
          />
          <path
            d="M105.007 476.475C102.945 476.475 101.281 478.138 101.281 480.209C101.281 482.28 102.945 483.944 105.007 483.944C107.07 483.944 108.742 482.267 108.742 480.209C108.742 478.151 107.078 476.475 105.007 476.475Z"
            fill="white"
          />
          <path
            d="M99.4013 472.385C97.3218 472.385 95.6328 474.07 95.6328 476.153C95.6328 478.237 97.3176 479.922 99.4013 479.922C101.485 479.922 103.17 478.237 103.17 476.153C103.17 474.07 101.485 472.385 99.4013 472.385Z"
            fill="white"
          />
          <path
            d="M93.4134 468.357C91.3128 468.357 89.6025 470.063 89.6025 472.168C89.6025 474.273 91.3085 475.979 93.4134 475.979C95.5183 475.979 97.2243 474.273 97.2243 472.168C97.2243 470.063 95.5183 468.357 93.4134 468.357Z"
            fill="white"
          />
          <path
            d="M87.0562 464.414C84.9215 464.414 83.1943 466.141 83.1943 468.263C83.1943 470.385 84.9215 472.112 87.0562 472.112C89.1908 472.112 90.9052 470.394 90.9052 468.263C90.9052 466.133 89.178 464.414 87.0562 464.414Z"
            fill="white"
          />
          <path
            d="M80.3137 460.59C78.1791 460.59 76.4434 462.317 76.4434 464.452C76.4434 466.586 78.1833 468.322 80.3137 468.322C82.444 468.322 84.184 466.595 84.184 464.452C84.184 462.309 82.4483 460.59 80.3137 460.59Z"
            fill="white"
          />
          <path
            d="M73.205 456.826C71.0492 456.826 69.3008 458.566 69.3008 460.718C69.3008 462.869 71.0492 464.622 73.205 464.622C75.3609 464.622 77.0965 462.874 77.0965 460.718C77.0965 458.562 75.3481 456.826 73.205 456.826Z"
            fill="white"
          />
          <path
            d="M65.7096 452.965C63.5453 452.965 61.7842 454.726 61.7842 456.89C61.7842 459.055 63.5453 460.816 65.7096 460.816C67.874 460.816 69.6351 459.067 69.6351 456.89C69.6351 454.713 67.8867 452.965 65.7096 452.965Z"
            fill="white"
          />
          <path
            d="M57.8722 448.959C55.6866 448.959 53.917 450.729 53.917 452.901C53.917 455.074 55.6866 456.857 57.8722 456.857C60.0577 456.857 61.8273 455.087 61.8273 452.901C61.8273 450.716 60.0577 448.959 57.8722 448.959Z"
            fill="white"
          />
          <path
            d="M49.7235 444.795C47.5294 444.795 45.7471 446.573 45.7471 448.78C45.7471 450.987 47.5252 452.756 49.7235 452.756C51.9217 452.756 53.7083 450.978 53.7083 448.78C53.7083 446.582 51.9302 444.795 49.7235 444.795Z"
            fill="white"
          />
          <path
            d="M41.3043 448.448C43.5121 448.448 45.3019 446.659 45.3019 444.451C45.3019 442.243 43.5121 440.453 41.3043 440.453C39.0964 440.453 37.3066 442.243 37.3066 444.451C37.3066 446.659 39.0964 448.448 41.3043 448.448Z"
            fill="white"
          />
          <path
            d="M32.635 435.812C30.4198 435.812 28.6289 437.612 28.6289 439.831C28.6289 442.051 30.4198 443.837 32.635 443.837C34.8502 443.837 36.6538 442.038 36.6538 439.831C36.6538 437.625 34.8545 435.812 32.635 435.812Z"
            fill="white"
          />
          <path
            d="M23.7783 430.754C21.5504 430.754 19.7383 432.566 19.7383 434.794C19.7383 437.022 21.5504 438.834 23.7783 438.834C26.0063 438.834 27.8184 437.022 27.8184 434.794C27.8184 432.566 26.019 430.754 23.7783 430.754Z"
            fill="white"
          />
          <path
            d="M14.7858 425.217C12.5494 425.217 10.7373 427.037 10.7373 429.274C10.7373 431.51 12.5494 433.322 14.7858 433.322C17.0223 433.322 18.8429 431.51 18.8429 429.274C18.8429 427.037 17.0223 425.217 14.7858 425.217Z"
            fill="white"
          />
          <path
            d="M5.70775 419.137C3.45857 419.137 1.64648 420.957 1.64648 423.198C1.64648 425.439 3.45857 427.268 5.70775 427.268C7.95694 427.268 9.76478 425.447 9.76478 423.198C9.76478 420.949 7.94421 419.137 5.70775 419.137Z"
            fill="white"
          />
          <path
            d="M-3.39997 420.614C-1.15231 420.614 0.669785 418.792 0.669785 416.544C0.669785 414.297 -1.15231 412.475 -3.39997 412.475C-5.64763 412.475 -7.46973 414.297 -7.46973 416.544C-7.46973 418.792 -5.64763 420.614 -3.39997 420.614Z"
            fill="white"
          />
          <path
            d="M1.5652 239.385C-0.556672 239.385 -2.27539 241.103 -2.27539 243.225C-2.27539 245.347 -0.556672 247.066 1.5652 247.066C3.68708 247.066 5.4058 245.339 5.4058 243.225C5.4058 241.112 3.67859 239.385 1.5652 239.385Z"
            fill="white"
          />
          <path
            d="M8.20737 227.121C6.10672 227.121 4.39648 228.827 4.39648 230.94C4.39648 233.054 6.10247 234.751 8.20737 234.751C10.3123 234.751 12.0183 233.045 12.0183 230.94C12.0183 228.836 10.3123 227.121 8.20737 227.121Z"
            fill="white"
          />
          <path
            d="M14.8355 214.924C12.7434 214.924 11.0586 216.621 11.0586 218.701C11.0586 220.78 12.7434 222.478 14.8355 222.478C16.9277 222.478 18.6125 220.793 18.6125 218.701C18.6125 216.609 16.915 214.924 14.8355 214.924Z"
            fill="white"
          />
          <path
            d="M21.3839 202.979C19.313 202.979 17.6367 204.663 17.6367 206.726C17.6367 208.788 19.313 210.473 21.3839 210.473C23.4549 210.473 25.1312 208.797 25.1312 206.726C25.1312 204.655 23.4549 202.979 21.3839 202.979Z"
            fill="white"
          />
          <path
            d="M27.792 191.602C25.7508 191.602 24.0957 193.257 24.0957 195.298C24.0957 197.339 25.7508 198.994 27.792 198.994C29.8333 198.994 31.4968 197.339 31.4968 195.298C31.4968 193.257 29.8417 191.602 27.792 191.602Z"
            fill="white"
          />
          <path
            d="M34.1741 180.682C32.154 180.682 30.5117 182.328 30.5117 184.344C30.5117 186.36 32.1583 188.019 34.1741 188.019C36.1899 188.019 37.8364 186.373 37.8364 184.344C37.8364 182.315 36.2026 180.682 34.1741 180.682Z"
            fill="white"
          />
          <path
            d="M40.5955 170.234C38.5967 170.234 36.9756 171.86 36.9756 173.854C36.9756 175.849 38.5967 177.474 40.5955 177.474C42.5943 177.474 44.2154 175.857 44.2154 173.854C44.2154 171.851 42.5901 170.234 40.5955 170.234Z"
            fill="white"
          />
          <path
            d="M46.987 160.32C45.0094 160.32 43.4053 161.916 43.4053 163.894C43.4053 165.871 45.0094 167.475 46.987 167.475C48.9646 167.475 50.5687 165.871 50.5687 163.894C50.5687 161.916 48.9646 160.32 46.987 160.32Z"
            fill="white"
          />
          <path
            d="M53.3013 150.895C51.3534 150.895 49.7832 152.465 49.7832 154.413C49.7832 156.36 51.3534 157.931 53.3013 157.931C55.2492 157.931 56.8193 156.36 56.8193 154.413C56.8193 152.465 55.2492 150.895 53.3013 150.895Z"
            fill="white"
          />
          <path
            d="M59.4971 141.83C57.5832 141.83 56.0215 143.392 56.0215 145.318C56.0215 147.245 57.5832 148.807 59.4971 148.807C61.411 148.807 62.9855 147.245 62.9855 145.318C62.9855 143.392 61.4238 141.83 59.4971 141.83Z"
            fill="white"
          />
          <path
            d="M65.4684 133.088C63.5629 133.088 62.0352 134.628 62.0352 136.521C62.0352 138.414 63.5672 139.967 65.4684 139.967C67.3696 139.967 68.9015 138.427 68.9015 136.521C68.9015 134.616 67.3611 133.088 65.4684 133.088Z"
            fill="white"
          />
          <path
            d="M71.0698 124.6C69.1983 124.6 67.6875 126.115 67.6875 127.986C67.6875 129.858 69.1983 131.377 71.0698 131.377C72.9413 131.377 74.4605 129.858 74.4605 127.986C74.4605 126.115 72.9413 124.6 71.0698 124.6Z"
            fill="white"
          />
          <path
            d="M76.2095 116.342C74.3762 116.342 72.8994 117.823 72.8994 119.652C72.8994 121.481 74.3762 122.966 76.2095 122.966C78.0428 122.966 79.5197 121.485 79.5197 119.652C79.5197 117.819 78.0428 116.342 76.2095 116.342Z"
            fill="white"
          />
          <path
            d="M80.8224 108.316C79.0103 108.316 77.542 109.785 77.542 111.597C77.542 113.409 79.0103 114.865 80.8224 114.865C82.6345 114.865 84.0901 113.396 84.0901 111.597C84.0901 109.797 82.6218 108.316 80.8224 108.316Z"
            fill="white"
          />
          <path
            d="M84.8701 100.75C83.1004 100.75 81.6533 102.193 81.6533 103.967C81.6533 105.741 83.1004 107.179 84.8701 107.179C86.6397 107.179 88.0868 105.736 88.0868 103.967C88.0868 102.197 86.6397 100.75 84.8701 100.75Z"
            fill="white"
          />
          <path
            d="M88.41 93.7148C86.6616 93.7148 85.2441 95.1323 85.2441 96.8764C85.2441 98.6206 86.6616 100.042 88.41 100.042C90.1584 100.042 91.5631 98.6249 91.5631 96.8764C91.5631 95.128 90.1457 93.7148 88.41 93.7148Z"
            fill="white"
          />
          <path
            d="M91.4774 87.293C89.7715 87.293 88.3965 88.6679 88.3965 90.3739C88.3965 92.0799 89.7715 93.4507 91.4774 93.4507C93.1834 93.4507 94.5457 92.0714 94.5457 90.3739C94.5457 88.6764 93.1707 87.293 91.4774 87.293Z"
            fill="white"
          />
          <path
            d="M94.1521 81.3516C92.4885 81.3516 91.1348 82.7053 91.1348 84.3689C91.1348 86.0324 92.4885 87.3862 94.1521 87.3862C95.8156 87.3862 97.1694 86.0324 97.1694 84.3689C97.1694 82.7053 95.8156 81.3516 94.1521 81.3516Z"
            fill="white"
          />
          <path
            d="M96.537 75.7988C94.9032 75.7988 93.5791 77.1271 93.5791 78.761C93.5791 80.3948 94.8989 81.7189 96.537 81.7189C98.1751 81.7189 99.4949 80.3991 99.4949 78.761C99.4949 77.1229 98.1708 75.7988 96.537 75.7988Z"
            fill="white"
          />
          <path
            d="M98.7133 70.4961C97.1091 70.4961 95.8105 71.7989 95.8105 73.3988C95.8105 74.9987 97.1134 76.3015 98.7133 76.3015C100.313 76.3015 101.616 74.9987 101.616 73.3988C101.616 71.7989 100.313 70.4961 98.7133 70.4961Z"
            fill="white"
          />
          <path
            d="M100.763 65.334C99.2102 65.334 97.9541 66.5944 97.9541 68.1434C97.9541 69.6923 99.2145 70.9527 100.763 70.9527C102.312 70.9527 103.573 69.6923 103.573 68.1434C103.573 66.5944 102.312 65.334 100.763 65.334Z"
            fill="white"
          />
          <path
            d="M102.771 60.0879C101.252 60.0879 100.025 61.3143 100.025 62.8378C100.025 64.3614 101.252 65.5793 102.771 65.5793C104.29 65.5793 105.517 64.3444 105.517 62.8378C105.517 61.3313 104.29 60.0879 102.771 60.0879Z"
            fill="white"
          />
          <path
            d="M104.834 54.5996C103.357 54.5996 102.147 55.7963 102.147 57.2859C102.147 58.7755 103.357 59.9637 104.834 59.9637C106.311 59.9637 107.52 58.7627 107.52 57.2859C107.52 55.8091 106.323 54.5996 104.834 54.5996Z"
            fill="white"
          />
          <path
            d="M107.112 48.5352C105.665 48.5352 104.498 49.7064 104.498 51.1578C104.498 52.6092 105.665 53.7804 107.112 53.7804C108.559 53.7804 109.735 52.6049 109.735 51.1578C109.735 49.7107 108.568 48.5352 107.112 48.5352Z"
            fill="white"
          />
          <path
            d="M109.808 41.5918C108.411 41.5918 107.278 42.7249 107.278 44.1211C107.278 45.5173 108.411 46.6503 109.808 46.6503C111.204 46.6503 112.337 45.5173 112.337 44.1211C112.337 42.7249 111.212 41.5918 109.808 41.5918Z"
            fill="white"
          />
          <path
            d="M113.273 33.2168C111.911 33.2168 110.808 34.3202 110.808 35.6824C110.808 37.0447 111.911 38.148 113.273 38.148C114.635 38.148 115.739 37.0447 115.739 35.6824C115.739 34.3202 114.635 33.2168 113.273 33.2168Z"
            fill="white"
          />
          <path
            d="M118.091 22.8574C116.771 22.8574 115.697 23.9226 115.697 25.2467C115.697 26.5707 116.771 27.6359 118.091 27.6359C119.411 27.6359 120.484 26.5622 120.484 25.2467C120.484 23.9311 119.411 22.8574 118.091 22.8574Z"
            fill="white"
          />
          <path
            d="M125.335 9.56445C124.045 9.56445 123.005 10.6042 123.005 11.8943C123.005 13.1844 124.045 14.2241 125.335 14.2241C126.625 14.2241 127.665 13.1716 127.665 11.8943C127.665 10.6169 126.612 9.56445 125.335 9.56445Z"
            fill="white"
          />
          <path
            d="M951.899 -4.12891C950.401 -4.12891 949.191 -2.92368 949.191 -1.42139C949.191 0.0808927 950.401 1.27763 951.899 1.27763C953.397 1.27763 954.594 0.0639177 954.594 -1.42139C954.594 -2.90671 953.384 -4.12891 951.899 -4.12891Z"
            fill="white"
          />
          <path
            d="M959.437 6.81836C957.905 6.81836 956.67 8.05753 956.67 9.58528C956.67 11.113 957.909 12.3437 959.437 12.3437C960.965 12.3437 962.195 11.1088 962.195 9.58528C962.195 8.06178 960.956 6.81836 959.437 6.81836Z"
            fill="white"
          />
          <path
            d="M967.066 17.4961C965.495 17.4961 964.214 18.7777 964.214 20.3521C964.214 21.9266 965.495 23.2082 967.066 23.2082C968.636 23.2082 969.926 21.9266 969.926 20.3521C969.926 18.7777 968.644 17.4961 967.066 17.4961Z"
            fill="white"
          />
          <path
            d="M974.756 28.043C973.152 28.043 971.841 29.3458 971.841 30.9584C971.841 32.571 973.152 33.8739 974.756 33.8739C976.36 33.8739 977.68 32.571 977.68 30.9584C977.68 29.3458 976.369 28.043 974.756 28.043Z"
            fill="white"
          />
          <path
            d="M982.488 38.459C980.845 38.459 979.513 39.7915 979.513 41.4339C979.513 43.0762 980.845 44.4087 982.488 44.4087C984.13 44.4087 985.454 43.0762 985.454 41.4339C985.454 39.7915 984.121 38.459 982.488 38.459Z"
            fill="white"
          />
          <path
            d="M990.19 48.8809C988.514 48.8809 987.16 50.2346 987.16 51.9109C987.16 53.5872 988.514 54.9494 990.19 54.9494C991.867 54.9494 993.229 53.5872 993.229 51.9109C993.229 50.2346 991.867 48.8809 990.19 48.8809Z"
            fill="white"
          />
          <path
            d="M997.901 59.2422C996.182 59.2422 994.79 60.6299 994.79 62.3486C994.79 64.0673 996.186 65.455 997.901 65.455C999.615 65.455 1001.01 64.0673 1001.01 62.3486C1001.01 60.6299 999.615 59.2422 997.901 59.2422Z"
            fill="white"
          />
          <path
            d="M1005.6 69.5898C1003.85 69.5898 1002.43 71.0073 1002.43 72.7557C1002.43 74.5041 1003.85 75.93 1005.6 75.93C1007.35 75.93 1008.78 74.5084 1008.78 72.7557C1008.78 71.003 1007.35 69.5898 1005.6 69.5898Z"
            fill="white"
          />
          <path
            d="M1013.3 79.9062C1011.51 79.9062 1010.07 81.3534 1010.07 83.1442C1010.07 84.9351 1011.51 86.3695 1013.3 86.3695C1015.1 86.3695 1016.53 84.9224 1016.53 83.1442C1016.53 81.3661 1015.08 79.9062 1013.3 79.9062Z"
            fill="white"
          />
          <path
            d="M1020.98 90.248C1019.17 90.248 1017.7 91.7164 1017.7 93.5285C1017.7 95.3405 1019.17 96.8089 1020.98 96.8089C1022.79 96.8089 1024.26 95.3405 1024.26 93.5285C1024.26 91.7164 1022.79 90.248 1020.98 90.248Z"
            fill="white"
          />
          <path
            d="M1028.64 100.564C1026.8 100.564 1025.3 102.062 1025.3 103.913C1025.3 105.763 1026.8 107.257 1028.64 107.257C1030.48 107.257 1031.99 105.759 1031.99 103.913C1031.99 102.067 1030.49 100.564 1028.64 100.564Z"
            fill="white"
          />
          <path
            d="M1036.29 110.902C1034.4 110.902 1032.87 112.426 1032.87 114.31C1032.87 116.194 1034.4 117.718 1036.29 117.718C1038.17 117.718 1039.69 116.194 1039.69 114.31C1039.69 112.426 1038.16 110.902 1036.29 110.902Z"
            fill="white"
          />
          <path
            d="M1043.87 121.328C1041.97 121.328 1040.42 122.877 1040.42 124.783C1040.42 126.688 1041.97 128.241 1043.87 128.241C1045.77 128.241 1047.33 126.696 1047.33 124.783C1047.33 122.869 1045.79 121.328 1043.87 121.328Z"
            fill="white"
          />
          <path
            d="M1051.4 131.875C1049.47 131.875 1047.9 133.441 1047.9 135.372C1047.9 137.303 1049.47 138.873 1051.4 138.873C1053.32 138.873 1054.89 137.303 1054.89 135.372C1054.89 133.441 1053.33 131.875 1051.4 131.875Z"
            fill="white"
          />
          <path
            d="M1058.83 142.59C1056.85 142.59 1055.25 144.194 1055.25 146.172C1055.25 148.149 1056.85 149.741 1058.83 149.741C1060.81 149.741 1062.4 148.145 1062.4 146.172C1062.4 144.198 1060.79 142.59 1058.83 142.59Z"
            fill="white"
          />
          <path
            d="M1066.15 153.59C1064.15 153.59 1062.53 155.202 1062.53 157.201C1062.53 159.2 1064.15 160.821 1066.15 160.821C1068.14 160.821 1069.76 159.2 1069.76 157.201C1069.76 155.202 1068.15 153.59 1066.15 153.59Z"
            fill="white"
          />
          <path
            d="M1073.38 164.832C1071.36 164.832 1069.72 166.47 1069.72 168.49C1069.72 170.51 1071.36 172.144 1073.38 172.144C1075.4 172.144 1077.03 170.506 1077.03 168.49C1077.03 166.474 1075.39 164.832 1073.38 164.832Z"
            fill="white"
          />
          <path
            d="M1080.53 176.322C1078.49 176.322 1076.83 177.977 1076.83 180.019C1076.83 182.06 1078.49 183.715 1080.53 183.715C1082.57 183.715 1084.23 182.06 1084.23 180.019C1084.23 177.977 1082.57 176.322 1080.53 176.322Z"
            fill="white"
          />
          <path
            d="M1087.67 187.947C1085.6 187.947 1083.91 189.628 1083.91 191.703C1083.91 193.778 1085.6 195.459 1087.67 195.459C1089.74 195.459 1091.42 193.774 1091.42 191.703C1091.42 189.632 1089.74 187.947 1087.67 187.947Z"
            fill="white"
          />
          <path
            d="M1094.88 199.613C1092.78 199.613 1091.08 201.311 1091.08 203.411C1091.08 205.512 1092.78 207.21 1094.88 207.21C1096.97 207.21 1098.67 205.504 1098.67 203.411C1098.67 201.319 1096.98 199.613 1094.88 199.613Z"
            fill="white"
          />
          <path
            d="M1102.25 211.115C1100.14 211.115 1098.42 212.821 1098.42 214.947C1098.42 217.073 1100.14 218.775 1102.25 218.775C1104.36 218.775 1106.08 217.056 1106.08 214.947C1106.08 212.838 1104.36 211.115 1102.25 211.115Z"
            fill="white"
          />
          <path
            d="M1109.88 222.199C1107.75 222.199 1106.02 223.926 1106.02 226.061C1106.02 228.196 1107.75 229.931 1109.88 229.931C1112.02 229.931 1113.75 228.191 1113.75 226.061C1113.75 223.931 1112.01 222.199 1109.88 222.199Z"
            fill="white"
          />
          <path
            d="M1117.82 232.682C1115.66 232.682 1113.91 234.443 1113.91 236.607C1113.91 238.771 1115.66 240.52 1117.82 240.52C1119.98 240.52 1121.75 238.771 1121.75 236.607C1121.75 234.443 1119.98 232.682 1117.82 232.682Z"
            fill="white"
          />
          <path
            d="M1126.12 242.391C1123.93 242.391 1122.16 244.16 1122.16 246.346C1122.16 248.531 1123.93 250.288 1126.12 250.288C1128.3 250.288 1130.06 248.519 1130.06 246.346C1130.06 244.173 1128.29 242.391 1126.12 242.391Z"
            fill="white"
          />
          <path
            d="M1134.76 251.207C1132.55 251.207 1130.77 252.985 1130.77 255.183C1130.77 257.382 1132.55 259.16 1134.76 259.16C1136.96 259.16 1138.73 257.382 1138.73 255.183C1138.73 252.985 1136.96 251.207 1134.76 251.207Z"
            fill="white"
          />
          <path
            d="M1143.73 259.096C1141.51 259.096 1139.72 260.887 1139.72 263.102C1139.72 265.317 1141.51 267.099 1143.73 267.099C1145.94 267.099 1147.73 265.309 1147.73 263.102C1147.73 260.895 1145.94 259.096 1143.73 259.096Z"
            fill="white"
          />
          <path
            d="M1152.98 266.111C1150.75 266.111 1148.93 267.923 1148.93 270.16C1148.93 272.396 1150.75 274.208 1152.98 274.208C1155.21 274.208 1157.03 272.388 1157.03 270.16C1157.03 267.932 1155.22 266.111 1152.98 266.111Z"
            fill="white"
          />
          <path
            d="M1162.48 272.389C1160.23 272.389 1158.4 274.209 1158.4 276.458C1158.4 278.708 1160.24 280.537 1162.48 280.537C1164.73 280.537 1166.56 278.716 1166.56 276.458C1166.56 274.201 1164.73 272.389 1162.48 272.389Z"
            fill="white"
          />
          <path
            d="M1172.18 278.027C1169.93 278.027 1168.09 279.861 1168.09 282.118C1168.09 284.376 1169.93 286.209 1172.18 286.209C1174.44 286.209 1176.27 284.376 1176.27 282.118C1176.27 279.861 1174.44 278.027 1172.18 278.027Z"
            fill="white"
          />
          <path
            d="M1182.05 283.098C1179.77 283.098 1177.93 284.948 1177.93 287.218C1177.93 289.489 1179.77 291.339 1182.05 291.339C1184.33 291.339 1186.17 289.497 1186.17 287.218C1186.17 284.939 1184.33 283.098 1182.05 283.098Z"
            fill="white"
          />
          <path
            d="M1192.06 287.709C1189.77 287.709 1187.92 289.559 1187.92 291.842C1187.92 294.126 1189.77 295.984 1192.06 295.984C1194.35 295.984 1196.19 294.134 1196.19 291.842C1196.19 289.551 1194.34 287.709 1192.06 287.709Z"
            fill="white"
          />
          <path
            d="M1202.19 291.873C1199.9 291.873 1198.04 293.736 1198.04 296.028C1198.04 298.319 1199.9 300.182 1202.19 300.182C1204.48 300.182 1206.35 298.332 1206.35 296.028C1206.35 293.723 1204.49 291.873 1202.19 291.873Z"
            fill="white"
          />
          <path
            d="M1212.41 295.648C1210.12 295.648 1208.26 297.511 1208.26 299.803C1208.26 302.095 1210.12 303.958 1212.41 303.958C1214.7 303.958 1216.57 302.095 1216.57 299.803C1216.57 297.511 1214.7 295.648 1212.41 295.648Z"
            fill="white"
          />
          <path
            d="M1222.68 299.02C1220.39 299.02 1218.53 300.883 1218.53 303.174C1218.53 305.466 1220.39 307.329 1222.68 307.329C1224.98 307.329 1226.84 305.466 1226.84 303.174C1226.84 300.883 1224.98 299.02 1222.68 299.02Z"
            fill="white"
          />
          <path
            d="M1232.99 301.969C1230.7 301.969 1228.83 303.819 1228.83 306.123C1228.83 308.428 1230.7 310.278 1232.99 310.278C1235.28 310.278 1237.14 308.415 1237.14 306.123C1237.14 303.832 1235.29 301.969 1232.99 301.969Z"
            fill="white"
          />
          <path
            d="M1243.31 304.381C1241.02 304.381 1239.15 306.231 1239.15 308.535C1239.15 310.84 1241.02 312.69 1243.31 312.69C1245.6 312.69 1247.46 310.827 1247.46 308.535C1247.46 306.244 1245.61 304.381 1243.31 304.381Z"
            fill="white"
          />
          <path
            d="M1253.61 306.232C1251.31 306.232 1249.46 308.095 1249.46 310.387C1249.46 312.679 1251.31 314.542 1253.61 314.542C1255.92 314.542 1257.77 312.691 1257.77 310.387C1257.77 308.083 1255.9 306.232 1253.61 306.232Z"
            fill="white"
          />
          <path
            d="M1263.81 307.566C1261.52 307.566 1259.66 309.421 1259.66 311.721C1259.66 314.021 1261.52 315.876 1263.81 315.876C1266.1 315.876 1267.97 314.013 1267.97 311.721C1267.97 309.429 1266.12 307.566 1263.81 307.566Z"
            fill="white"
          />
          <path
            d="M1273.88 308.389C1271.58 308.389 1269.72 310.243 1269.72 312.543C1269.72 314.843 1271.58 316.698 1273.88 316.698C1276.17 316.698 1278.03 314.835 1278.03 312.543C1278.03 310.252 1276.17 308.389 1273.88 308.389Z"
            fill="white"
          />
          <path
            d="M1270.17 309.406C1267.88 309.406 1266.02 311.269 1266.02 313.557C1266.02 315.844 1267.88 317.711 1270.17 317.711C1272.46 317.711 1274.33 315.861 1274.33 313.557C1274.33 311.252 1272.46 309.406 1270.17 309.406Z"
            fill="white"
          />
          <path
            d="M1266.14 310.262C1263.84 310.262 1261.98 312.125 1261.98 314.416C1261.98 316.708 1263.83 318.571 1266.14 318.571C1268.44 318.571 1270.29 316.708 1270.29 314.416C1270.29 312.125 1268.43 310.262 1266.14 310.262Z"
            fill="white"
          />
          <path
            d="M1261.71 310.947C1259.42 310.947 1257.56 312.802 1257.56 315.102C1257.56 317.402 1259.42 319.257 1261.71 319.257C1264 319.257 1265.87 317.394 1265.87 315.102C1265.87 312.81 1264.01 310.947 1261.71 310.947Z"
            fill="white"
          />
          <path
            d="M1256.88 311.471C1254.59 311.471 1252.72 313.321 1252.72 315.625C1252.72 317.93 1254.59 319.78 1256.88 319.78C1259.17 319.78 1261.03 317.917 1261.03 315.625C1261.03 313.334 1259.17 311.471 1256.88 311.471Z"
            fill="white"
          />
          <path
            d="M1251.62 311.814C1249.33 311.814 1247.46 313.669 1247.46 315.969C1247.46 318.269 1249.33 320.124 1251.62 320.124C1253.91 320.124 1255.77 318.261 1255.77 315.969C1255.77 313.677 1253.92 311.814 1251.62 311.814Z"
            fill="white"
          />
          <path
            d="M1245.92 311.967C1243.63 311.967 1241.77 313.83 1241.77 316.121C1241.77 318.413 1243.63 320.276 1245.92 320.276C1248.21 320.276 1250.08 318.426 1250.08 316.121C1250.08 313.817 1248.21 311.967 1245.92 311.967Z"
            fill="white"
          />
          <path
            d="M1239.79 311.928C1237.5 311.928 1235.64 313.791 1235.64 316.082C1235.64 318.374 1237.5 320.237 1239.79 320.237C1242.08 320.237 1243.95 318.374 1243.95 316.082C1243.95 313.791 1242.08 311.928 1239.79 311.928Z"
            fill="white"
          />
          <path
            d="M1233.25 311.666C1230.95 311.666 1229.09 313.516 1229.09 315.821C1229.09 318.125 1230.95 319.975 1233.25 319.975C1235.54 319.975 1237.4 318.112 1237.4 315.821C1237.4 313.529 1235.55 311.666 1233.25 311.666Z"
            fill="white"
          />
          <path
            d="M1226.3 311.168C1224.01 311.168 1222.15 313.031 1222.15 315.323C1222.15 317.614 1224.01 319.477 1226.3 319.477C1228.59 319.477 1230.46 317.614 1230.46 315.323C1230.46 313.031 1228.6 311.168 1226.3 311.168Z"
            fill="white"
          />
          <path
            d="M1218.97 310.49C1216.68 310.49 1214.82 312.34 1214.82 314.645C1214.82 316.949 1216.68 318.799 1218.97 318.799C1221.27 318.799 1223.13 316.936 1223.13 314.645C1223.13 312.353 1221.27 310.49 1218.97 310.49Z"
            fill="white"
          />
          <path
            d="M1211.29 309.658C1208.99 309.658 1207.14 311.513 1207.14 313.813C1207.14 316.113 1208.99 317.967 1211.29 317.967C1213.59 317.967 1215.45 316.104 1215.45 313.813C1215.45 311.521 1213.58 309.658 1211.29 309.658Z"
            fill="white"
          />
          <path
            d="M1203.25 308.668C1200.95 308.668 1199.1 310.531 1199.1 312.823C1199.1 315.114 1200.95 316.977 1203.25 316.977C1205.56 316.977 1207.41 315.123 1207.41 312.823C1207.41 310.523 1205.54 308.668 1203.25 308.668Z"
            fill="white"
          />
          <path
            d="M1194.86 307.596C1192.58 307.596 1190.73 309.437 1190.73 311.729C1190.73 314.021 1192.58 315.863 1194.86 315.863C1197.15 315.863 1199 314.008 1199 311.729C1199 309.45 1197.15 307.596 1194.86 307.596Z"
            fill="white"
          />
          <path
            d="M1186.16 306.441C1183.89 306.441 1182.05 308.283 1182.05 310.554C1182.05 312.824 1183.89 314.666 1186.16 314.666C1188.43 314.666 1190.27 312.824 1190.27 310.554C1190.27 308.283 1188.43 306.441 1186.16 306.441Z"
            fill="white"
          />
          <path
            d="M1177.15 305.256C1174.89 305.256 1173.06 307.089 1173.06 309.347C1173.06 311.605 1174.89 313.446 1177.15 313.446C1179.41 313.446 1181.25 311.613 1181.25 309.347C1181.25 307.081 1179.41 305.256 1177.15 305.256Z"
            fill="white"
          />
          <path
            d="M1167.84 304.1C1165.61 304.1 1163.78 305.92 1163.78 308.157C1163.78 310.393 1165.6 312.226 1167.84 312.226C1170.08 312.226 1171.91 310.406 1171.91 308.157C1171.91 305.907 1170.09 304.1 1167.84 304.1Z"
            fill="white"
          />
          <path
            d="M1158.25 302.996C1156.03 302.996 1154.23 304.795 1154.23 307.023C1154.23 309.251 1156.03 311.063 1158.25 311.063C1160.48 311.063 1162.29 309.264 1162.29 307.023C1162.29 304.783 1160.5 302.996 1158.25 302.996Z"
            fill="white"
          />
          <path
            d="M1148.4 301.969C1146.19 301.969 1144.39 303.76 1144.39 305.975C1144.39 308.19 1146.19 309.981 1148.4 309.981C1150.62 309.981 1152.41 308.182 1152.41 305.975C1152.41 303.768 1150.61 301.969 1148.4 301.969Z"
            fill="white"
          />
          <path
            d="M1138.28 309.025C1140.47 309.025 1142.25 307.245 1142.25 305.049C1142.25 302.853 1140.47 301.072 1138.28 301.072C1136.08 301.072 1134.3 302.853 1134.3 305.049C1134.3 307.245 1136.08 309.025 1138.28 309.025Z"
            fill="white"
          />
          <path
            d="M1127.91 300.373C1125.73 300.373 1123.97 302.134 1123.97 304.307C1123.97 306.48 1125.74 308.241 1127.91 308.241C1130.08 308.241 1131.84 306.48 1131.84 304.307C1131.84 302.134 1130.07 300.373 1127.91 300.373Z"
            fill="white"
          />
          <path
            d="M1117.28 299.906C1115.13 299.906 1113.38 301.655 1113.38 303.811C1113.38 305.966 1115.13 307.715 1117.28 307.715C1119.44 307.715 1121.19 305.966 1121.19 303.811C1121.19 301.655 1119.45 299.906 1117.28 299.906Z"
            fill="white"
          />
          <path
            d="M1106.43 299.697C1104.28 299.697 1102.54 301.437 1102.54 303.58C1102.54 305.723 1104.28 307.451 1106.43 307.451C1108.57 307.451 1110.3 305.723 1110.3 303.58C1110.3 301.437 1108.57 299.697 1106.43 299.697Z"
            fill="white"
          />
          <path
            d="M1095.32 299.793C1093.2 299.793 1091.47 301.512 1091.47 303.642C1091.47 305.772 1093.2 307.483 1095.32 307.483C1097.44 307.483 1099.16 305.764 1099.16 303.642C1099.16 301.52 1097.44 299.793 1095.32 299.793Z"
            fill="white"
          />
          <path
            d="M1083.98 300.27C1081.89 300.27 1080.19 301.967 1080.19 304.059C1080.19 306.151 1081.89 307.849 1083.98 307.849C1086.08 307.849 1087.77 306.151 1087.77 304.059C1087.77 301.967 1086.08 300.27 1083.98 300.27Z"
            fill="white"
          />
          <path
            d="M1072.45 301.152C1070.37 301.152 1068.7 302.837 1068.7 304.908C1068.7 306.979 1070.37 308.664 1072.45 308.664C1074.53 308.664 1076.21 306.987 1076.21 304.908C1076.21 302.829 1074.52 301.152 1072.45 301.152Z"
            fill="white"
          />
          <path
            d="M1060.7 302.508C1058.65 302.508 1057 304.171 1057 306.213C1057 308.254 1058.65 309.93 1060.7 309.93C1062.75 309.93 1064.42 308.267 1064.42 306.213C1064.42 304.159 1062.75 302.508 1060.7 302.508Z"
            fill="white"
          />
          <path
            d="M1048.78 304.297C1046.75 304.297 1045.1 305.943 1045.1 307.972C1045.1 310 1046.75 311.634 1048.78 311.634C1050.8 311.634 1052.44 309.988 1052.44 307.972C1052.44 305.956 1050.79 304.297 1048.78 304.297Z"
            fill="white"
          />
          <path
            d="M1036.66 306.627C1034.66 306.627 1033.05 308.252 1033.05 310.238C1033.05 312.224 1034.66 313.85 1036.66 313.85C1038.66 313.85 1040.27 312.237 1040.27 310.238C1040.27 308.24 1038.65 306.627 1036.66 306.627Z"
            fill="white"
          />
          <path
            d="M1024.39 309.564C1022.43 309.564 1020.83 311.156 1020.83 313.125C1020.83 315.094 1022.42 316.694 1024.39 316.694C1026.36 316.694 1027.95 315.09 1027.95 313.125C1027.95 311.16 1026.36 309.564 1024.39 309.564Z"
            fill="white"
          />
          <path
            d="M1012.02 313.146C1010.07 313.146 1008.5 314.717 1008.5 316.665C1008.5 318.612 1010.07 320.191 1012.02 320.191C1013.96 320.191 1015.53 318.608 1015.53 316.665C1015.53 314.721 1013.96 313.146 1012.02 313.146Z"
            fill="white"
          />
          <path
            d="M999.475 317.34C997.561 317.34 995.999 318.889 995.999 320.815C995.999 322.742 997.561 324.283 999.475 324.283C1001.39 324.283 1002.95 322.734 1002.95 320.815C1002.95 318.897 1001.39 317.34 999.475 317.34Z"
            fill="white"
          />
          <path
            d="M986.837 322.355C984.953 322.355 983.434 323.875 983.434 325.759C983.434 327.643 984.953 329.162 986.837 329.162C988.721 329.162 990.24 327.63 990.24 325.759C990.24 323.887 988.708 322.355 986.837 322.355Z"
            fill="white"
          />
          <path
            d="M974.204 328.424C972.35 328.424 970.852 329.913 970.852 331.764C970.852 333.614 972.35 335.103 974.204 335.103C976.059 335.103 977.544 333.605 977.544 331.764C977.544 329.922 976.046 328.424 974.204 328.424Z"
            fill="white"
          />
          <path
            d="M961.556 335.789C959.736 335.789 958.268 337.266 958.268 339.091C958.268 340.915 959.736 342.388 961.556 342.388C963.377 342.388 964.858 340.911 964.858 339.091C964.858 337.27 963.381 335.789 961.556 335.789Z"
            fill="white"
          />
          <path
            d="M949.152 345.012C947.361 345.012 945.905 346.467 945.905 348.271C945.905 350.075 947.361 351.517 949.152 351.517C950.943 351.517 952.398 350.062 952.398 348.271C952.398 346.48 950.943 345.012 949.152 345.012Z"
            fill="white"
          />
          <path
            d="M937.131 356.43C935.383 356.43 933.97 357.847 933.97 359.591C933.97 361.335 935.387 362.757 937.131 362.757C938.875 362.757 940.297 361.34 940.297 359.591C940.297 357.843 938.88 356.43 937.131 356.43Z"
            fill="white"
          />
          <path
            d="M925.994 370.533C924.276 370.533 922.884 371.929 922.884 373.644C922.884 375.358 924.28 376.755 925.994 376.755C927.709 376.755 929.105 375.358 929.105 373.644C929.105 371.929 927.709 370.533 925.994 370.533Z"
            fill="white"
          />
          <path
            d="M915.962 387.539C914.265 387.539 912.902 388.914 912.902 390.599C912.902 392.284 914.265 393.659 915.962 393.659C917.66 393.659 919.022 392.296 919.022 390.599C919.022 388.901 917.647 387.539 915.962 387.539Z"
            fill="white"
          />
          <path
            d="M907.603 408.01C905.939 408.01 904.594 409.351 904.594 411.019C904.594 412.686 905.935 414.015 907.603 414.015C909.27 414.015 910.599 412.674 910.599 411.019C910.599 409.364 909.258 408.01 907.603 408.01Z"
            fill="white"
          />
          <path
            d="M902.077 432.689C900.473 432.689 899.175 433.992 899.175 435.592C899.175 437.192 900.478 438.508 902.077 438.508C903.677 438.508 904.993 437.205 904.993 435.592C904.993 433.98 903.69 432.689 902.077 432.689Z"
            fill="white"
          />
          <path
            d="M900.579 461.771C899.009 461.771 897.728 463.04 897.728 464.623C897.728 466.206 899.009 467.475 900.579 467.475C902.15 467.475 903.431 466.193 903.431 464.623C903.431 463.053 902.162 461.771 900.579 461.771Z"
            fill="white"
          />
          <path
            d="M903.638 495.041C902.097 495.041 900.85 496.289 900.85 497.842C900.85 499.395 902.097 500.643 903.638 500.643C905.178 500.643 906.439 499.382 906.439 497.842C906.439 496.301 905.191 495.041 903.638 495.041Z"
            fill="white"
          />
          <path
            d="M910.675 532.115C909.164 532.115 907.946 533.333 907.946 534.844C907.946 536.355 909.164 537.581 910.675 537.581C912.186 537.581 913.412 536.363 913.412 534.844C913.412 533.325 912.186 532.115 910.675 532.115Z"
            fill="white"
          />
          <path
            d="M920.054 572.738C918.598 572.738 917.41 573.927 917.41 575.382C917.41 576.838 918.598 578.034 920.054 578.034C921.51 578.034 922.698 576.846 922.698 575.382C922.698 573.918 921.51 572.738 920.054 572.738Z"
            fill="white"
          />
          <path
            d="M929.993 616.814C928.559 616.814 927.4 617.969 927.4 619.395C927.4 620.821 928.555 621.988 929.993 621.988C931.432 621.988 932.573 620.833 932.573 619.395C932.573 617.956 931.419 616.814 929.993 616.814Z"
            fill="white"
          />
          <path
            d="M937.933 664.139C936.536 664.139 935.416 665.263 935.416 666.659C935.416 668.056 936.541 669.189 937.933 669.189C939.324 669.189 940.462 668.056 940.462 666.659C940.462 665.263 939.329 664.139 937.933 664.139Z"
            fill="white"
          />
          <path
            d="M405.235 675.15C404.068 675.15 403.135 676.097 403.135 677.264C403.135 678.431 404.073 679.364 405.235 679.364C406.398 679.364 407.349 678.418 407.349 677.264C407.349 676.109 406.402 675.15 405.235 675.15Z"
            fill="white"
          />
          <path
            d="M388.261 670.207C387.094 670.207 386.16 671.153 386.16 672.32C386.16 673.487 387.098 674.421 388.261 674.421C389.424 674.421 390.361 673.475 390.361 672.32C390.361 671.166 389.424 670.207 388.261 670.207Z"
            fill="white"
          />
          <path
            d="M370.755 665.002C369.601 665.002 368.654 665.948 368.654 667.103C368.654 668.257 369.601 669.203 370.755 669.203C371.909 669.203 372.856 668.265 372.856 667.103C372.856 665.94 371.918 665.002 370.755 665.002Z"
            fill="white"
          />
          <path
            d="M352.706 659.488C351.539 659.488 350.605 660.426 350.605 661.589C350.605 662.752 351.543 663.69 352.706 663.69C353.869 663.69 354.807 662.743 354.807 661.589C354.807 660.435 353.86 659.488 352.706 659.488Z"
            fill="white"
          />
          <path
            d="M333.932 653.053C332.765 653.053 331.818 653.991 331.818 655.153C331.818 656.316 332.765 657.267 333.932 657.267C335.099 657.267 336.032 656.32 336.032 655.153C336.032 653.986 335.095 653.053 333.932 653.053Z"
            fill="white"
          />
          <path
            d="M314.343 645.615C313.176 645.615 312.242 646.553 312.242 647.716C312.242 648.879 313.18 649.817 314.343 649.817C315.506 649.817 316.443 648.87 316.443 647.716C316.443 646.562 315.506 645.615 314.343 645.615Z"
            fill="white"
          />
          <path
            d="M293.799 636.809C292.632 636.809 291.686 637.746 291.686 638.909C291.686 640.072 292.632 641.01 293.799 641.01C294.966 641.01 295.9 640.072 295.9 638.909C295.9 637.746 294.953 636.809 293.799 636.809Z"
            fill="white"
          />
          <path
            d="M272.046 626.496C270.879 626.496 269.933 627.442 269.933 628.609C269.933 629.777 270.879 630.723 272.046 630.723C273.213 630.723 274.159 629.777 274.159 628.609C274.159 627.442 273.213 626.496 272.046 626.496Z"
            fill="white"
          />
          <path
            d="M248.807 615.066C247.64 615.066 246.693 616.013 246.693 617.18C246.693 618.347 247.64 619.293 248.807 619.293C249.974 619.293 250.92 618.347 250.92 617.18C250.92 616.013 249.974 615.066 248.807 615.066Z"
            fill="white"
          />
          <path
            d="M223.659 602.889C222.483 602.889 221.537 603.848 221.537 605.011C221.537 606.173 222.483 607.145 223.659 607.145C224.835 607.145 225.781 606.186 225.781 605.011C225.781 603.835 224.835 602.889 223.659 602.889Z"
            fill="white"
          />
          <path
            d="M196.307 590.369C195.132 590.369 194.186 591.328 194.186 592.491C194.186 593.654 195.132 594.613 196.307 594.613C197.483 594.613 198.429 593.667 198.429 592.491C198.429 591.315 197.47 590.369 196.307 590.369Z"
            fill="white"
          />
          <path
            d="M182.019 579.836C180.809 579.836 179.833 580.816 179.833 582.021C179.833 583.227 180.813 584.207 182.019 584.207C183.224 584.207 184.204 583.227 184.204 582.021C184.204 580.816 183.224 579.836 182.019 579.836Z"
            fill="white"
          />
          <path
            d="M168.77 570.055C167.51 570.055 166.491 571.065 166.491 572.325C166.491 573.585 167.51 574.595 168.77 574.595C170.03 574.595 171.041 573.585 171.041 572.325C171.041 571.065 170.022 570.055 168.77 570.055Z"
            fill="white"
          />
          <path
            d="M157.558 561.312C156.268 561.312 155.229 562.352 155.229 563.642C155.229 564.932 156.268 565.972 157.558 565.972C158.848 565.972 159.888 564.92 159.888 563.642C159.888 562.365 158.836 561.312 157.558 561.312Z"
            fill="white"
          />
          <path
            d="M148.838 553.746C147.505 553.746 146.436 554.828 146.436 556.152C146.436 557.476 147.509 558.558 148.838 558.558C150.166 558.558 151.244 557.485 151.244 556.152C151.244 554.82 150.17 553.746 148.838 553.746Z"
            fill="white"
          />
          <path
            d="M142.479 547.383C141.117 547.383 140.014 548.486 140.014 549.848C140.014 551.211 141.117 552.314 142.479 552.314C143.842 552.314 144.945 551.211 144.945 549.848C144.945 548.486 143.842 547.383 142.479 547.383Z"
            fill="white"
          />
          <path
            d="M138.138 542.076C136.721 542.076 135.579 543.222 135.579 544.635C135.579 546.048 136.725 547.194 138.138 547.194C139.551 547.194 140.689 546.048 140.689 544.635C140.689 543.222 139.543 542.076 138.138 542.076Z"
            fill="white"
          />
          <path
            d="M135.431 537.725C133.984 537.725 132.8 538.9 132.8 540.356C132.8 541.811 133.988 542.978 135.431 542.978C136.874 542.978 138.066 541.803 138.066 540.356C138.066 538.909 136.878 537.725 135.431 537.725Z"
            fill="white"
          />
          <path
            d="M133.889 534.092C132.413 534.092 131.203 535.289 131.203 536.778C131.203 538.268 132.413 539.464 133.889 539.464C135.366 539.464 136.584 538.259 136.584 536.778C136.584 535.297 135.379 534.092 133.889 534.092Z"
            fill="white"
          />
          <path
            d="M133.13 530.951C131.611 530.951 130.385 532.178 130.385 533.697C130.385 535.216 131.611 536.443 133.13 536.443C134.65 536.443 135.876 535.216 135.876 533.697C135.876 532.178 134.65 530.951 133.13 530.951Z"
            fill="white"
          />
          <path
            d="M132.872 528.129C131.301 528.129 130.028 529.398 130.028 530.972C130.028 532.547 131.297 533.816 132.872 533.816C134.446 533.816 135.702 532.534 135.702 530.972C135.702 529.41 134.433 528.129 132.872 528.129Z"
            fill="white"
          />
          <path
            d="M132.842 525.559C131.238 525.559 129.939 526.861 129.939 528.461C129.939 530.061 131.242 531.356 132.842 531.356C134.442 531.356 135.736 530.053 135.736 528.461C135.736 526.87 134.446 525.559 132.842 525.559Z"
            fill="white"
          />
          <path
            d="M132.745 528.951C134.379 528.951 135.703 527.627 135.703 525.993C135.703 524.359 134.379 523.035 132.745 523.035C131.111 523.035 129.787 524.359 129.787 525.993C129.787 527.627 131.111 528.951 132.745 528.951Z"
            fill="white"
          />
          <path
            d="M132.443 520.471C130.78 520.471 129.435 521.824 129.435 523.48C129.435 525.135 130.776 526.497 132.443 526.497C134.111 526.497 135.461 525.143 135.461 523.48C135.461 521.816 134.107 520.471 132.443 520.471Z"
            fill="white"
          />
          <path
            d="M131.849 517.783C130.143 517.783 128.76 519.167 128.76 520.873C128.76 522.579 130.143 523.962 131.849 523.962C133.555 523.962 134.939 522.579 134.939 520.873C134.939 519.167 133.555 517.783 131.849 517.783Z"
            fill="white"
          />
          <path
            d="M130.894 514.965C129.154 514.965 127.749 516.37 127.749 518.109C127.749 519.849 129.154 521.263 130.894 521.263C132.634 521.263 134.047 519.858 134.047 518.109C134.047 516.361 132.629 514.965 130.894 514.965Z"
            fill="white"
          />
          <path
            d="M129.532 511.965C127.763 511.965 126.328 513.399 126.328 515.169C126.328 516.938 127.767 518.364 129.532 518.364C131.298 518.364 132.728 516.93 132.728 515.169C132.728 513.408 131.293 511.965 129.532 511.965Z"
            fill="white"
          />
          <path
            d="M127.771 508.805C125.972 508.805 124.512 510.26 124.512 512.064C124.512 513.868 125.967 515.31 127.771 515.31C129.575 515.31 131.03 513.855 131.03 512.064C131.03 510.273 129.575 508.805 127.771 508.805Z"
            fill="white"
          />
          <path
            d="M125.658 512.122C127.497 512.122 128.989 510.63 128.989 508.79C128.989 506.951 127.497 505.459 125.658 505.459C123.818 505.459 122.326 506.951 122.326 508.79C122.326 510.63 123.818 512.122 125.658 512.122Z"
            fill="white"
          />
          <path
            d="M123.192 502.018C121.329 502.018 119.818 503.528 119.818 505.4C119.818 507.271 121.329 508.774 123.192 508.774C125.055 508.774 126.574 507.263 126.574 505.4C126.574 503.537 125.055 502.018 123.192 502.018Z"
            fill="white"
          />
          <path
            d="M120.403 498.457C118.511 498.457 116.979 499.989 116.979 501.882C116.979 503.774 118.511 505.306 120.403 505.306C122.296 505.306 123.828 503.766 123.828 501.882C123.828 499.998 122.296 498.457 120.403 498.457Z"
            fill="white"
          />
          <path
            d="M117.28 494.805C115.366 494.805 113.812 496.354 113.812 498.272C113.812 500.19 115.361 501.739 117.28 501.739C119.198 501.739 120.747 500.177 120.747 498.272C120.747 496.366 119.194 494.805 117.28 494.805Z"
            fill="white"
          />
          <path
            d="M113.825 491.027C111.869 491.027 110.286 492.61 110.286 494.567C110.286 496.523 111.869 498.106 113.825 498.106C115.782 498.106 117.365 496.523 117.365 494.567C117.365 492.61 115.782 491.027 113.825 491.027Z"
            fill="white"
          />
          <path
            d="M110.027 487.238C108.049 487.238 106.458 488.83 106.458 490.807C106.458 492.785 108.049 494.376 110.027 494.376C112.005 494.376 113.596 492.772 113.596 490.807C113.596 488.842 111.992 487.238 110.027 487.238Z"
            fill="white"
          />
          <path
            d="M105.873 483.389C103.887 483.389 102.262 485.001 102.262 487C102.262 488.999 103.887 490.611 105.873 490.611C107.859 490.611 109.493 488.999 109.493 487C109.493 485.001 107.868 483.389 105.873 483.389Z"
            fill="white"
          />
          <path
            d="M101.379 479.514C99.3594 479.514 97.7256 481.148 97.7256 483.168C97.7256 485.188 99.3594 486.821 101.379 486.821C103.399 486.821 105.033 485.188 105.033 483.168C105.033 481.148 103.399 479.514 101.379 479.514Z"
            fill="white"
          />
          <path
            d="M96.5066 475.631C94.4653 475.631 92.8018 477.294 92.8018 479.336C92.8018 481.377 94.4653 483.04 96.5066 483.04C98.5478 483.04 100.211 481.385 100.211 479.336C100.211 477.286 98.5563 475.631 96.5066 475.631Z"
            fill="white"
          />
          <path
            d="M91.2697 471.781C89.1987 471.781 87.5225 473.466 87.5225 475.529C87.5225 477.591 89.1987 479.276 91.2697 479.276C93.3406 479.276 95.0042 477.599 95.0042 475.529C95.0042 473.458 93.3279 471.781 91.2697 471.781Z"
            fill="white"
          />
          <path
            d="M85.6519 467.982C83.5598 467.982 81.875 469.68 81.875 471.759C81.875 473.839 83.5598 475.528 85.6519 475.528C87.7441 475.528 89.4204 473.843 89.4204 471.759C89.4204 469.676 87.7356 467.982 85.6519 467.982Z"
            fill="white"
          />
          <path
            d="M79.6468 464.223C77.5461 464.223 75.8486 465.92 75.8486 468.021C75.8486 470.121 77.5461 471.832 79.6468 471.832C81.7474 471.832 83.4577 470.126 83.4577 468.021C83.4577 465.916 81.7517 464.223 79.6468 464.223Z"
            fill="white"
          />
          <path
            d="M73.2771 460.49C71.1552 460.49 69.4365 462.217 69.4365 464.339C69.4365 466.461 71.1552 468.188 73.2771 468.188C75.399 468.188 77.1262 466.461 77.1262 464.339C77.1262 462.217 75.399 460.49 73.2771 460.49Z"
            fill="white"
          />
          <path
            d="M66.5412 456.812C64.3981 456.812 62.6582 458.548 62.6582 460.696C62.6582 462.843 64.3939 464.566 66.5412 464.566C68.6886 464.566 70.4243 462.83 70.4243 460.696C70.4243 458.561 68.6843 456.812 66.5412 456.812Z"
            fill="white"
          />
          <path
            d="M59.442 453.16C57.2777 453.16 55.5293 454.921 55.5293 457.073C55.5293 459.225 57.2777 460.977 59.442 460.977C61.6063 460.977 63.3463 459.229 63.3463 457.073C63.3463 454.917 61.5979 453.16 59.442 453.16Z"
            fill="white"
          />
          <path
            d="M51.9518 449.426C49.7875 449.426 48.0264 451.187 48.0264 453.351C48.0264 455.516 49.7875 457.277 51.9518 457.277C54.1161 457.277 55.8773 455.52 55.8773 453.351C55.8773 451.183 54.1204 449.426 51.9518 449.426Z"
            fill="white"
          />
          <path
            d="M44.0926 445.512C41.907 445.512 40.1289 447.29 40.1289 449.475C40.1289 451.661 41.907 453.439 44.0926 453.439C46.2781 453.439 48.0562 451.661 48.0562 449.475C48.0562 447.29 46.2781 445.512 44.0926 445.512Z"
            fill="white"
          />
          <path
            d="M35.911 441.41C33.7169 441.41 31.9346 443.188 31.9346 445.387C31.9346 447.585 33.7127 449.371 35.911 449.371C38.1092 449.371 39.8958 447.593 39.8958 445.387C39.8958 443.18 38.105 441.41 35.911 441.41Z"
            fill="white"
          />
          <path
            d="M27.4605 445.005C29.6683 445.005 31.4581 443.215 31.4581 441.007C31.4581 438.8 29.6683 437.01 27.4605 437.01C25.2527 437.01 23.4629 438.8 23.4629 441.007C23.4629 443.215 25.2527 445.005 27.4605 445.005Z"
            fill="white"
          />
          <path
            d="M18.7786 432.221C16.5634 432.221 14.7598 434.02 14.7598 436.24C14.7598 438.459 16.5591 440.258 18.7786 440.258C20.9981 440.258 22.8059 438.459 22.8059 436.24C22.8059 434.02 21.0066 432.221 18.7786 432.221Z"
            fill="white"
          />
          <path
            d="M9.93458 426.998C7.70661 426.998 5.89453 428.81 5.89453 431.038C5.89453 433.266 7.70661 435.078 9.93458 435.078C12.1625 435.078 13.9746 433.279 13.9746 431.038C13.9746 428.797 12.1625 426.998 9.93458 426.998Z"
            fill="white"
          />
          <path
            d="M0.950881 421.314C-1.28558 421.314 -3.09766 423.127 -3.09766 425.363C-3.09766 427.599 -1.28558 429.42 0.950881 429.42C3.18734 429.42 4.99942 427.599 4.99942 425.363C4.99942 423.127 3.18734 421.314 0.950881 421.314Z"
            fill="white"
          />
          <path
            d="M-3.48475 222.096C-5.57691 222.096 -7.27441 223.793 -7.27441 225.885C-7.27441 227.978 -5.57691 229.675 -3.48475 229.675C-1.39258 229.675 0.304923 227.978 0.304923 225.885C0.304923 223.793 -1.39258 222.096 -3.48475 222.096Z"
            fill="white"
          />
          <path
            d="M3.03336 209.979C0.962414 209.979 -0.713867 211.663 -0.713867 213.726C-0.713867 215.788 0.962414 217.473 3.03336 217.473C5.10431 217.473 6.78059 215.797 6.78059 213.726C6.78059 211.655 5.09583 209.979 3.03336 209.979Z"
            fill="white"
          />
          <path
            d="M9.52736 198.127C7.48612 198.127 5.83105 199.782 5.83105 201.823C5.83105 203.864 7.48612 205.528 9.52736 205.528C11.5686 205.528 13.2237 203.864 13.2237 201.823C13.2237 199.782 11.5686 198.127 9.52736 198.127Z"
            fill="white"
          />
          <path
            d="M16.012 186.666C13.9919 186.666 12.3496 188.313 12.3496 190.328C12.3496 192.344 13.9962 193.999 16.012 193.999C18.0277 193.999 19.6743 192.361 19.6743 190.328C19.6743 188.296 18.0405 186.666 16.012 186.666Z"
            fill="white"
          />
          <path
            d="M22.6111 175.572C20.6123 175.572 18.9912 177.198 18.9912 179.192C18.9912 181.187 20.6123 182.812 22.6111 182.812C24.6099 182.812 26.231 181.187 26.231 179.192C26.231 177.198 24.6057 175.572 22.6111 175.572Z"
            fill="white"
          />
          <path
            d="M29.3109 164.822C27.3248 164.822 25.7207 166.426 25.7207 168.412C25.7207 170.399 27.3248 172.003 29.3109 172.003C31.297 172.003 32.9011 170.39 32.9011 168.412C32.9011 166.435 31.2885 164.822 29.3109 164.822Z"
            fill="white"
          />
          <path
            d="M36.0764 154.455C34.1285 154.455 32.5498 156.025 32.5498 157.973C32.5498 159.921 34.1327 161.5 36.0764 161.5C38.02 161.5 39.6029 159.921 39.6029 157.973C39.6029 156.025 38.02 154.455 36.0764 154.455Z"
            fill="white"
          />
          <path
            d="M42.8448 144.432C40.9308 144.432 39.3691 145.981 39.3691 147.907C39.3691 149.834 40.9308 151.387 42.8448 151.387C44.7587 151.387 46.3331 149.83 46.3331 147.907C46.3331 145.985 44.7714 144.432 42.8448 144.432Z"
            fill="white"
          />
          <path
            d="M49.4821 134.773C47.5766 134.773 46.0361 136.314 46.0361 138.207C46.0361 140.099 47.5766 141.648 49.4821 141.648C51.3875 141.648 52.9153 140.112 52.9153 138.207C52.9153 136.301 51.3748 134.773 49.4821 134.773Z"
            fill="white"
          />
          <path
            d="M55.8862 125.363C54.0147 125.363 52.5039 126.883 52.5039 128.758C52.5039 130.634 54.0147 132.145 55.8862 132.145C57.7577 132.145 59.2769 130.63 59.2769 128.758C59.2769 126.887 57.7577 125.363 55.8862 125.363Z"
            fill="white"
          />
          <path
            d="M61.9504 116.135C60.1171 116.135 58.6318 117.624 58.6318 119.453C58.6318 121.282 60.1214 122.764 61.9504 122.764C63.7795 122.764 65.2606 121.278 65.2606 119.453C65.2606 117.629 63.771 116.135 61.9504 116.135Z"
            fill="white"
          />
          <path
            d="M67.5011 107.121C65.7017 107.121 64.2334 108.577 64.2334 110.385C64.2334 112.192 65.7017 113.648 67.5011 113.648C69.3004 113.648 70.7603 112.192 70.7603 110.385C70.7603 108.577 69.3047 107.121 67.5011 107.121Z"
            fill="white"
          />
          <path
            d="M72.4453 98.5195C70.6671 98.5195 69.2285 99.9624 69.2285 101.741C69.2285 103.519 70.6629 104.957 72.4453 104.957C74.2277 104.957 75.662 103.51 75.662 101.741C75.662 99.9709 74.2277 98.5195 72.4453 98.5195Z"
            fill="white"
          />
          <path
            d="M76.7729 90.5391C75.0245 90.5391 73.6113 91.9565 73.6113 93.7049C73.6113 95.4533 75.0287 96.8622 76.7729 96.8622C78.5171 96.8622 79.9388 95.4448 79.9388 93.7049C79.9388 91.965 78.5213 90.5391 76.7729 90.5391Z"
            fill="white"
          />
          <path
            d="M80.5302 83.2773C78.8242 83.2773 77.4492 84.6566 77.4492 86.3541C77.4492 88.0516 78.8242 89.435 80.5302 89.435C82.2362 89.435 83.6111 88.06 83.6111 86.3541C83.6111 84.6481 82.2277 83.2773 80.5302 83.2773Z"
            fill="white"
          />
          <path
            d="M83.7966 76.6211C82.1331 76.6211 80.7793 77.9748 80.7793 79.6426C80.7793 81.3104 82.1331 82.6599 83.7966 82.6599C85.4602 82.6599 86.8266 81.3062 86.8266 79.6426C86.8266 77.9791 85.4729 76.6211 83.7966 76.6211Z"
            fill="white"
          />
          <path
            d="M86.691 70.4629C85.0571 70.4629 83.7246 71.7912 83.7246 73.4293C83.7246 75.0674 85.0571 76.3872 86.691 76.3872C88.3248 76.3872 89.6574 75.0674 89.6574 73.4293C89.6574 71.7912 88.3248 70.4629 86.691 70.4629Z"
            fill="white"
          />
          <path
            d="M89.2712 64.6836C87.6798 64.6836 86.377 65.9779 86.377 67.5821C86.377 69.1862 87.6798 70.4848 89.2712 70.4848C90.8626 70.4848 92.1739 69.182 92.1739 67.5821C92.1739 65.9822 90.8711 64.6836 89.2712 64.6836Z"
            fill="white"
          />
          <path
            d="M91.6571 59.1504C90.0954 59.1504 88.835 60.4108 88.835 61.9725C88.835 63.5342 90.0954 64.7946 91.6571 64.7946C93.2188 64.7946 94.4791 63.5299 94.4791 61.9725C94.4791 60.415 93.2103 59.1504 91.6571 59.1504Z"
            fill="white"
          />
          <path
            d="M93.9137 53.6855C92.3817 53.6855 91.1553 54.9205 91.1553 56.444C91.1553 57.9675 92.3817 59.1939 93.9137 59.1939C95.4457 59.1939 96.6594 57.9675 96.6594 56.444C96.6594 54.9205 95.433 53.6855 93.9137 53.6855Z"
            fill="white"
          />
          <path
            d="M96.1629 48.1191C94.6733 48.1191 93.4766 49.3159 93.4766 50.8012C93.4766 52.2865 94.6733 53.479 96.1629 53.479C97.6524 53.479 98.8491 52.2823 98.8491 50.8012C98.8491 49.3201 97.6397 48.1191 96.1629 48.1191Z"
            fill="white"
          />
          <path
            d="M98.5572 42.1035C97.1101 42.1035 95.9346 43.279 95.9346 44.7262C95.9346 46.1733 97.1101 47.3488 98.5572 47.3488C100.004 47.3488 101.18 46.1733 101.18 44.7262C101.18 43.279 100.004 42.1035 98.5572 42.1035Z"
            fill="white"
          />
          <path
            d="M101.265 35.332C99.8684 35.332 98.7354 36.4609 98.7354 37.8613C98.7354 39.2617 99.8684 40.3906 101.265 40.3906C102.661 40.3906 103.794 39.2617 103.794 37.8613C103.794 36.4609 102.661 35.332 101.265 35.332Z"
            fill="white"
          />
          <path
            d="M104.605 27.1953C103.242 27.1953 102.147 28.2944 102.147 29.6567C102.147 31.0189 103.242 32.1223 104.605 32.1223C105.967 32.1223 107.07 31.0189 107.07 29.6567C107.07 28.2944 105.967 27.1953 104.605 27.1953Z"
            fill="white"
          />
          <path
            d="M109.132 17.1035C107.799 17.1035 106.726 18.1772 106.726 19.5097C106.726 20.8423 107.799 21.9159 109.132 21.9159C110.464 21.9159 111.534 20.8338 111.534 19.5097C111.534 18.1857 110.452 17.1035 109.132 17.1035Z"
            fill="white"
          />
          <path
            d="M115.803 4.22461C114.513 4.22461 113.474 5.27706 113.474 6.56292C113.474 7.84877 114.513 8.90122 115.803 8.90122C117.094 8.90122 118.133 7.84877 118.133 6.56292C118.133 5.27706 117.094 4.22461 115.803 4.22461Z"
            fill="white"
          />
          <path
            d="M963.369 -0.236328C961.879 -0.236328 960.661 0.981628 960.661 2.47118C960.661 3.96074 961.879 5.1787 963.369 5.1787C964.858 5.1787 966.076 3.96923 966.076 2.47118C966.076 0.973141 964.867 -0.236328 963.369 -0.236328Z"
            fill="white"
          />
          <path
            d="M970.914 10.7109C969.382 10.7109 968.147 11.9501 968.147 13.4779C968.147 15.0056 969.387 16.2405 970.914 16.2405C972.442 16.2405 973.681 15.0014 973.681 13.4779C973.681 11.9544 972.442 10.7109 970.914 10.7109Z"
            fill="white"
          />
          <path
            d="M978.544 21.4316C976.974 21.4316 975.692 22.7048 975.692 24.2834C975.692 25.8621 976.974 27.1352 978.544 27.1352C980.114 27.1352 981.405 25.8621 981.405 24.2834C981.405 22.7048 980.123 21.4316 978.544 21.4316Z"
            fill="white"
          />
          <path
            d="M986.235 32.0273C984.622 32.0273 983.319 33.3344 983.319 34.9428C983.319 36.5512 984.622 37.8583 986.235 37.8583C987.847 37.8583 989.15 36.5554 989.15 34.9428C989.15 33.3302 987.847 32.0273 986.235 32.0273Z"
            fill="white"
          />
          <path
            d="M993.98 42.4746C992.346 42.4746 991.005 43.8071 991.005 45.4495C991.005 47.0918 992.346 48.4243 993.98 48.4243C995.614 48.4243 996.967 47.0918 996.967 45.4495C996.967 43.8071 995.626 42.4746 993.98 42.4746Z"
            fill="white"
          />
          <path
            d="M1001.74 52.8711C1000.06 52.8711 998.702 54.2333 998.702 55.9096C998.702 57.5859 1000.06 58.9481 1001.74 58.9481C1003.42 58.9481 1004.78 57.5859 1004.78 55.9096C1004.78 54.2333 1003.42 52.8711 1001.74 52.8711Z"
            fill="white"
          />
          <path
            d="M1009.52 63.207C1007.8 63.207 1006.41 64.5947 1006.41 66.3135C1006.41 68.0322 1007.8 69.4241 1009.52 69.4241C1011.23 69.4241 1012.63 68.0364 1012.63 66.3135C1012.63 64.5905 1011.23 63.207 1009.52 63.207Z"
            fill="white"
          />
          <path
            d="M1017.28 73.5352C1015.53 73.5352 1014.11 74.9611 1014.11 76.7095C1014.11 78.4579 1015.53 79.8753 1017.28 79.8753C1019.03 79.8753 1020.45 78.4579 1020.45 76.7095C1020.45 74.9611 1019.03 73.5352 1017.28 73.5352Z"
            fill="white"
          />
          <path
            d="M1025.06 83.8047C1023.28 83.8047 1021.83 85.2518 1021.83 87.0299C1021.83 88.8081 1023.28 90.2552 1025.06 90.2552C1026.83 90.2552 1028.28 88.8123 1028.28 87.0299C1028.28 85.2476 1026.83 83.8047 1025.06 83.8047Z"
            fill="white"
          />
          <path
            d="M1032.84 94.0508C1031.03 94.0508 1029.56 95.5191 1029.56 97.327C1029.56 99.1348 1031.03 100.599 1032.84 100.599C1034.66 100.599 1036.12 99.1348 1036.12 97.327C1036.12 95.5191 1034.66 94.0508 1032.84 94.0508Z"
            fill="white"
          />
          <path
            d="M1040.62 104.252C1038.76 104.252 1037.26 105.754 1037.26 107.609C1037.26 109.463 1038.76 110.961 1040.62 110.961C1042.47 110.961 1043.97 109.463 1043.97 107.609C1043.97 105.754 1042.47 104.252 1040.62 104.252Z"
            fill="white"
          />
          <path
            d="M1048.35 114.51C1046.48 114.51 1044.95 116.042 1044.95 117.917C1044.95 119.793 1046.48 121.325 1048.35 121.325C1050.22 121.325 1051.76 119.793 1051.76 117.917C1051.76 116.042 1050.23 114.51 1048.35 114.51Z"
            fill="white"
          />
          <path
            d="M1056.01 124.893C1054.11 124.893 1052.56 126.437 1052.56 128.347C1052.56 130.257 1054.11 131.801 1056.01 131.801C1057.92 131.801 1059.47 130.257 1059.47 128.347C1059.47 126.437 1057.92 124.893 1056.01 124.893Z"
            fill="white"
          />
          <path
            d="M1063.58 135.453C1061.64 135.453 1060.07 137.019 1060.07 138.954C1060.07 140.889 1061.64 142.455 1063.58 142.455C1065.51 142.455 1067.07 140.885 1067.07 138.954C1067.07 137.023 1065.51 135.453 1063.58 135.453Z"
            fill="white"
          />
          <path
            d="M1071.04 146.18C1069.06 146.18 1067.47 147.784 1067.47 149.753C1067.47 151.722 1069.06 153.326 1071.04 153.326C1073.02 153.326 1074.61 151.722 1074.61 149.753C1074.61 147.784 1073.02 146.18 1071.04 146.18Z"
            fill="white"
          />
          <path
            d="M1078.4 157.184C1076.4 157.184 1074.78 158.809 1074.78 160.804C1074.78 162.798 1076.4 164.415 1078.4 164.415C1080.39 164.415 1082.01 162.802 1082.01 160.804C1082.01 158.805 1080.4 157.184 1078.4 157.184Z"
            fill="white"
          />
          <path
            d="M1085.65 168.43C1083.63 168.43 1081.98 170.068 1081.98 172.101C1081.98 174.133 1083.63 175.763 1085.65 175.763C1087.68 175.763 1089.32 174.116 1089.32 172.101C1089.32 170.085 1087.67 168.43 1085.65 168.43Z"
            fill="white"
          />
          <path
            d="M1092.83 179.9C1090.79 179.9 1089.14 181.555 1089.14 183.597C1089.14 185.638 1090.79 187.293 1092.83 187.293C1094.87 187.293 1096.53 185.638 1096.53 183.597C1096.53 181.555 1094.87 179.9 1092.83 179.9Z"
            fill="white"
          />
          <path
            d="M1100 191.498C1097.93 191.498 1096.25 193.179 1096.25 195.254C1096.25 197.329 1097.93 199.009 1100 199.009C1102.08 199.009 1103.75 197.325 1103.75 195.254C1103.75 193.183 1102.08 191.498 1100 191.498Z"
            fill="white"
          />
          <path
            d="M1107.23 203.123C1105.12 203.123 1103.43 204.829 1103.43 206.921C1103.43 209.013 1105.13 210.719 1107.23 210.719C1109.33 210.719 1111.03 209.022 1111.03 206.921C1111.03 204.821 1109.32 203.123 1107.23 203.123Z"
            fill="white"
          />
          <path
            d="M1114.65 214.498C1112.53 214.498 1110.82 216.217 1110.82 218.33C1110.82 220.444 1112.54 222.171 1114.65 222.171C1116.76 222.171 1118.48 220.452 1118.48 218.33C1118.48 216.208 1116.76 214.498 1114.65 214.498Z"
            fill="white"
          />
          <path
            d="M1122.34 225.416C1120.21 225.416 1118.47 227.143 1118.47 229.278C1118.47 231.412 1120.21 233.14 1122.34 233.14C1124.47 233.14 1126.2 231.412 1126.2 229.278C1126.2 227.143 1124.48 225.416 1122.34 225.416Z"
            fill="white"
          />
          <path
            d="M1130.33 235.676C1128.17 235.676 1126.41 237.437 1126.41 239.601C1126.41 241.766 1128.16 243.527 1130.33 243.527C1132.5 243.527 1134.24 241.766 1134.24 239.601C1134.24 237.437 1132.5 235.676 1130.33 235.676Z"
            fill="white"
          />
          <path
            d="M1138.67 245.182C1136.49 245.182 1134.73 246.951 1134.73 249.128C1134.73 251.305 1136.5 253.084 1138.67 253.084C1140.84 253.084 1142.63 251.314 1142.63 249.128C1142.63 246.943 1140.86 245.182 1138.67 245.182Z"
            fill="white"
          />
          <path
            d="M1147.36 253.797C1145.16 253.797 1143.38 255.575 1143.38 257.782C1143.38 259.989 1145.16 261.758 1147.36 261.758C1149.57 261.758 1151.35 259.98 1151.35 257.782C1151.35 255.583 1149.56 253.797 1147.36 253.797Z"
            fill="white"
          />
          <path
            d="M1156.36 261.562C1154.15 261.562 1152.34 263.353 1152.34 265.569C1152.34 267.784 1154.14 269.575 1156.36 269.575C1158.58 269.575 1160.37 267.784 1160.37 265.569C1160.37 263.353 1158.57 261.562 1156.36 261.562Z"
            fill="white"
          />
          <path
            d="M1165.63 268.506C1163.4 268.506 1161.59 270.318 1161.59 272.554C1161.59 274.791 1163.4 276.603 1165.63 276.603C1167.87 276.603 1169.68 274.791 1169.68 272.554C1169.68 270.318 1167.87 268.506 1165.63 268.506Z"
            fill="white"
          />
          <path
            d="M1175.16 274.727C1172.91 274.727 1171.08 276.547 1171.08 278.805C1171.08 281.062 1172.91 282.875 1175.16 282.875C1177.4 282.875 1179.24 281.054 1179.24 278.805C1179.24 276.556 1177.4 274.727 1175.16 274.727Z"
            fill="white"
          />
          <path
            d="M1184.9 288.51C1187.16 288.51 1188.99 286.678 1188.99 284.419C1188.99 282.16 1187.16 280.328 1184.9 280.328C1182.64 280.328 1180.81 282.16 1180.81 284.419C1180.81 286.678 1182.64 288.51 1184.9 288.51Z"
            fill="white"
          />
          <path
            d="M1194.83 285.332C1192.55 285.332 1190.71 287.182 1190.71 289.453C1190.71 291.723 1192.55 293.573 1194.83 293.573C1197.11 293.573 1198.95 291.732 1198.95 289.453C1198.95 287.174 1197.11 285.332 1194.83 285.332Z"
            fill="white"
          />
          <path
            d="M1204.92 289.852C1202.62 289.852 1200.77 291.706 1200.77 293.993C1200.77 296.281 1202.63 298.135 1204.92 298.135C1207.2 298.135 1209.06 296.272 1209.06 293.993C1209.06 291.715 1207.21 289.852 1204.92 289.852Z"
            fill="white"
          />
          <path
            d="M1215.13 293.9C1212.83 293.9 1210.97 295.755 1210.97 298.055C1210.97 300.355 1212.83 302.21 1215.13 302.21C1217.42 302.21 1219.28 300.347 1219.28 298.055C1219.28 295.763 1217.42 293.9 1215.13 293.9Z"
            fill="white"
          />
          <path
            d="M1225.43 297.49C1223.13 297.49 1221.28 299.353 1221.28 301.645C1221.28 303.936 1223.13 305.8 1225.43 305.8C1227.73 305.8 1229.58 303.949 1229.58 301.645C1229.58 299.34 1227.72 297.49 1225.43 297.49Z"
            fill="white"
          />
          <path
            d="M1235.81 300.58C1233.51 300.58 1231.65 302.443 1231.65 304.743C1231.65 307.043 1233.51 308.894 1235.81 308.894C1238.1 308.894 1239.96 307.031 1239.96 304.743C1239.96 302.456 1238.1 300.58 1235.81 300.58Z"
            fill="white"
          />
          <path
            d="M1246.24 303.088C1243.94 303.088 1242.08 304.951 1242.08 307.243C1242.08 309.534 1243.94 311.397 1246.24 311.397C1248.53 311.397 1250.39 309.534 1250.39 307.243C1250.39 304.951 1248.54 303.088 1246.24 303.088Z"
            fill="white"
          />
          <path
            d="M1256.68 305.006C1254.38 305.006 1252.52 306.856 1252.52 309.161C1252.52 311.465 1254.38 313.315 1256.68 313.315C1258.97 313.315 1260.83 311.452 1260.83 309.161C1260.83 306.869 1258.97 305.006 1256.68 305.006Z"
            fill="white"
          />
          <path
            d="M1267.05 306.346C1264.76 306.346 1262.9 308.209 1262.9 310.5C1262.9 312.792 1264.76 314.655 1267.05 314.655C1269.34 314.655 1271.21 312.792 1271.21 310.5C1271.21 308.209 1269.36 306.346 1267.05 306.346Z"
            fill="white"
          />
          <path
            d="M1277.31 307.148C1275.01 307.148 1273.16 309.011 1273.16 311.312C1273.16 313.612 1275.01 315.466 1277.31 315.466C1279.61 315.466 1281.47 313.603 1281.47 311.312C1281.47 309.02 1279.61 307.148 1277.31 307.148Z"
            fill="white"
          />
          <path
            d="M1287.41 307.402C1285.11 307.402 1283.25 309.265 1283.25 311.557C1283.25 313.849 1285.11 315.72 1287.41 315.72C1289.71 315.72 1291.56 313.857 1291.56 311.557C1291.56 309.257 1289.7 307.402 1287.41 307.402Z"
            fill="white"
          />
          <path
            d="M1283.75 308.713C1281.45 308.713 1279.59 310.576 1279.59 312.868C1279.59 315.159 1281.44 317.022 1283.75 317.022C1286.05 317.022 1287.9 315.168 1287.9 312.868C1287.9 310.567 1286.03 308.713 1283.75 308.713Z"
            fill="white"
          />
          <path
            d="M1279.77 309.836C1277.47 309.836 1275.61 311.69 1275.61 313.991C1275.61 316.291 1277.47 318.145 1279.77 318.145C1282.07 318.145 1283.93 316.282 1283.93 313.991C1283.93 311.699 1282.06 309.836 1279.77 309.836Z"
            fill="white"
          />
          <path
            d="M1275.42 310.783C1273.12 310.783 1271.27 312.633 1271.27 314.938C1271.27 317.242 1273.12 319.092 1275.42 319.092C1277.72 319.092 1279.57 317.229 1279.57 314.938C1279.57 312.646 1277.71 310.783 1275.42 310.783Z"
            fill="white"
          />
          <path
            d="M1270.65 311.562C1268.35 311.562 1266.5 313.426 1266.5 315.726C1266.5 318.026 1268.35 319.88 1270.65 319.88C1272.95 319.88 1274.81 318.017 1274.81 315.726C1274.81 313.434 1272.94 311.562 1270.65 311.562Z"
            fill="white"
          />
          <path
            d="M1265.45 312.195C1263.15 312.195 1261.29 314.058 1261.29 316.358C1261.29 318.659 1263.15 320.513 1265.45 320.513C1267.75 320.513 1269.6 318.65 1269.6 316.358C1269.6 314.067 1267.74 312.195 1265.45 312.195Z"
            fill="white"
          />
          <path
            d="M1259.79 312.676C1257.49 312.676 1255.63 314.53 1255.63 316.83C1255.63 319.131 1257.48 320.985 1259.79 320.985C1262.09 320.985 1263.94 319.122 1263.94 316.83C1263.94 314.539 1262.08 312.676 1259.79 312.676Z"
            fill="white"
          />
          <path
            d="M1253.68 312.955C1251.38 312.955 1249.52 314.818 1249.52 317.11C1249.52 319.401 1251.37 321.264 1253.68 321.264C1255.98 321.264 1257.83 319.401 1257.83 317.11C1257.83 314.818 1255.97 312.955 1253.68 312.955Z"
            fill="white"
          />
          <path
            d="M1247.12 313.031C1244.83 313.031 1242.96 314.894 1242.96 317.186C1242.96 319.477 1244.83 321.341 1247.12 321.341C1249.41 321.341 1251.27 319.49 1251.27 317.186C1251.27 314.882 1249.41 313.031 1247.12 313.031Z"
            fill="white"
          />
          <path
            d="M1240.13 312.881C1237.84 312.881 1235.98 314.735 1235.98 317.035C1235.98 319.336 1237.84 321.19 1240.13 321.19C1242.43 321.19 1244.29 319.327 1244.29 317.035C1244.29 314.744 1242.43 312.881 1240.13 312.881Z"
            fill="white"
          />
          <path
            d="M1232.76 312.467C1230.47 312.467 1228.6 314.33 1228.6 316.621C1228.6 318.913 1230.47 320.785 1232.76 320.785C1235.05 320.785 1236.91 318.922 1236.91 316.621C1236.91 314.321 1235.05 312.467 1232.76 312.467Z"
            fill="white"
          />
          <path
            d="M1225 311.814C1222.71 311.814 1220.85 313.669 1220.85 315.969C1220.85 318.269 1222.71 320.124 1225 320.124C1227.29 320.124 1229.16 318.261 1229.16 315.969C1229.16 313.677 1227.29 311.814 1225 311.814Z"
            fill="white"
          />
          <path
            d="M1216.89 310.961C1214.59 310.961 1212.74 312.824 1212.74 315.116C1212.74 317.407 1214.59 319.27 1216.89 319.27C1219.19 319.27 1221.05 317.407 1221.05 315.116C1221.05 312.824 1219.19 310.961 1216.89 310.961Z"
            fill="white"
          />
          <path
            d="M1208.44 309.959C1206.15 309.959 1204.3 311.809 1204.3 314.101C1204.3 316.393 1206.15 318.243 1208.44 318.243C1210.73 318.243 1212.58 316.388 1212.58 314.101C1212.58 311.814 1210.73 309.959 1208.44 309.959Z"
            fill="white"
          />
          <path
            d="M1199.66 308.824C1197.39 308.824 1195.54 310.675 1195.54 312.958C1195.54 315.241 1197.4 317.078 1199.66 317.078C1201.93 317.078 1203.8 315.224 1203.8 312.958C1203.8 310.691 1201.94 308.824 1199.66 308.824Z"
            fill="white"
          />
          <path
            d="M1190.58 315.799C1192.83 315.799 1194.67 313.968 1194.67 311.708C1194.67 309.449 1192.83 307.617 1190.58 307.617C1188.32 307.617 1186.48 309.449 1186.48 311.708C1186.48 313.968 1188.32 315.799 1190.58 315.799Z"
            fill="white"
          />
          <path
            d="M1181.18 306.346C1178.93 306.346 1177.11 308.166 1177.11 310.415C1177.11 312.665 1178.93 314.485 1181.18 314.485C1183.43 314.485 1185.25 312.665 1185.25 310.415C1185.25 308.166 1183.43 306.346 1181.18 306.346Z"
            fill="white"
          />
          <path
            d="M1171.52 305.1C1169.29 305.1 1167.48 306.912 1167.48 309.14C1167.48 311.368 1169.29 313.167 1171.52 313.167C1173.74 313.167 1175.56 311.368 1175.56 309.14C1175.56 306.912 1173.74 305.1 1171.52 305.1Z"
            fill="white"
          />
          <path
            d="M1161.59 303.902C1159.37 303.902 1157.58 305.693 1157.58 307.908C1157.58 310.124 1159.37 311.915 1161.59 311.915C1163.8 311.915 1165.59 310.124 1165.59 307.908C1165.59 305.693 1163.79 303.902 1161.59 303.902Z"
            fill="white"
          />
          <path
            d="M1151.39 302.777C1149.19 302.777 1147.41 304.568 1147.41 306.762C1147.41 308.956 1149.19 310.739 1151.39 310.739C1153.59 310.739 1155.36 308.96 1155.36 306.762C1155.36 304.564 1153.59 302.777 1151.39 302.777Z"
            fill="white"
          />
          <path
            d="M1140.93 301.799C1138.75 301.799 1136.99 303.568 1136.99 305.733C1136.99 307.897 1138.75 309.675 1140.93 309.675C1143.1 309.675 1144.87 307.906 1144.87 305.733C1144.87 303.56 1143.1 301.799 1140.93 301.799Z"
            fill="white"
          />
          <path
            d="M1130.22 301.008C1128.06 301.008 1126.31 302.756 1126.31 304.912C1126.31 307.068 1128.06 308.816 1130.22 308.816C1132.37 308.816 1134.13 307.068 1134.13 304.912C1134.13 302.756 1132.38 301.008 1130.22 301.008Z"
            fill="white"
          />
          <path
            d="M1119.28 300.465C1117.14 300.465 1115.4 302.205 1115.4 304.348C1115.4 306.491 1117.13 308.218 1119.28 308.218C1121.43 308.218 1123.15 306.478 1123.15 304.348C1123.15 302.217 1121.42 300.465 1119.28 300.465Z"
            fill="white"
          />
          <path
            d="M1108.09 300.229C1105.97 300.229 1104.25 301.947 1104.25 304.069C1104.25 306.191 1105.97 307.918 1108.09 307.918C1110.21 307.918 1111.94 306.191 1111.94 304.069C1111.94 301.947 1110.21 300.229 1108.09 300.229Z"
            fill="white"
          />
          <path
            d="M1096.67 300.32C1094.58 300.32 1092.88 302.005 1092.88 304.097C1092.88 306.189 1094.58 307.887 1096.67 307.887C1098.77 307.887 1100.46 306.189 1100.46 304.097C1100.46 302.005 1098.77 300.32 1096.67 300.32Z"
            fill="white"
          />
          <path
            d="M1085.05 300.771C1082.97 300.771 1081.29 302.456 1081.29 304.527C1081.29 306.598 1082.97 308.283 1085.05 308.283C1087.13 308.283 1088.79 306.598 1088.79 304.527C1088.79 302.456 1087.12 300.771 1085.05 300.771Z"
            fill="white"
          />
          <path
            d="M1073.2 301.697C1071.15 301.697 1069.5 303.361 1069.5 305.415C1069.5 307.469 1071.15 309.12 1073.2 309.12C1075.25 309.12 1076.92 307.465 1076.92 305.415C1076.92 303.365 1075.26 301.697 1073.2 301.697Z"
            fill="white"
          />
          <path
            d="M1061.17 303.107C1059.14 303.107 1057.5 304.754 1057.5 306.782C1057.5 308.811 1059.14 310.445 1061.17 310.445C1063.2 310.445 1064.83 308.798 1064.83 306.782C1064.83 304.767 1063.19 303.107 1061.17 303.107Z"
            fill="white"
          />
          <path
            d="M1048.95 305.035C1046.95 305.035 1045.34 306.648 1045.34 308.647C1045.34 310.645 1046.95 312.25 1048.95 312.25C1050.95 312.25 1052.56 310.637 1052.56 308.647C1052.56 306.656 1050.94 305.035 1048.95 305.035Z"
            fill="white"
          />
          <path
            d="M1036.54 307.502C1034.57 307.502 1032.97 309.106 1032.97 311.071C1032.97 313.036 1034.57 314.631 1036.54 314.631C1038.5 314.631 1040.1 313.04 1040.1 311.071C1040.1 309.102 1038.5 307.502 1036.54 307.502Z"
            fill="white"
          />
          <path
            d="M1023.97 310.666C1022.04 310.666 1020.46 312.236 1020.46 314.184C1020.46 316.132 1022.04 317.702 1023.97 317.702C1025.91 317.702 1027.49 316.132 1027.49 314.184C1027.49 312.236 1025.92 310.666 1023.97 310.666Z"
            fill="white"
          />
          <path
            d="M1011.31 314.559C1009.39 314.559 1007.83 316.112 1007.83 318.034C1007.83 319.957 1009.39 321.51 1011.31 321.51C1013.22 321.51 1014.78 319.961 1014.78 318.034C1014.78 316.108 1013.23 314.559 1011.31 314.559Z"
            fill="white"
          />
          <path
            d="M998.453 319.201C996.581 319.201 995.058 320.72 995.058 322.605C995.058 324.489 996.577 326.008 998.453 326.008C1000.33 326.008 1001.86 324.489 1001.86 322.605C1001.86 320.72 1000.34 319.201 998.453 319.201Z"
            fill="white"
          />
          <path
            d="M987.909 330.542C989.218 329.233 989.218 327.111 987.909 325.801C986.599 324.492 984.477 324.492 983.168 325.801C981.858 327.11 981.858 329.233 983.168 330.543C984.477 331.852 986.6 331.852 987.909 330.542Z"
            fill="white"
          />
          <path
            d="M972.56 331.721C970.74 331.721 969.259 333.198 969.259 335.018C969.259 336.839 970.736 338.316 972.56 338.316C974.385 338.316 975.871 336.839 975.871 335.018C975.871 333.198 974.394 331.721 972.56 331.721Z"
            fill="white"
          />
          <path
            d="M959.686 340.369C957.887 340.369 956.427 341.825 956.427 343.616C956.427 345.406 957.882 346.875 959.686 346.875C961.49 346.875 962.932 345.419 962.932 343.616C962.932 341.812 961.477 340.369 959.686 340.369Z"
            fill="white"
          />
          <path
            d="M947.205 351.268C945.456 351.268 944.03 352.693 944.03 354.442C944.03 356.19 945.456 357.608 947.205 357.608C948.953 357.608 950.37 356.19 950.37 354.442C950.37 352.693 948.953 351.268 947.205 351.268Z"
            fill="white"
          />
          <path
            d="M935.433 364.725C933.706 364.725 932.31 366.121 932.31 367.848C932.31 369.575 933.706 370.959 935.433 370.959C937.16 370.959 938.556 369.562 938.556 367.848C938.556 366.134 937.152 364.725 935.433 364.725Z"
            fill="white"
          />
          <path
            d="M924.883 381.254C923.186 381.254 921.811 382.616 921.811 384.314C921.811 386.011 923.186 387.373 924.883 387.373C926.581 387.373 927.943 385.998 927.943 384.314C927.943 382.629 926.568 381.254 924.883 381.254Z"
            fill="white"
          />
          <path
            d="M915.775 401.08C914.12 401.08 912.779 402.421 912.779 404.089C912.779 405.757 914.12 407.085 915.775 407.085C917.43 407.085 918.784 405.744 918.784 404.089C918.784 402.434 917.443 401.08 915.775 401.08Z"
            fill="white"
          />
          <path
            d="M909.27 425.029C907.666 425.029 906.354 426.332 906.354 427.945C906.354 429.557 907.666 430.86 909.27 430.86C910.874 430.86 912.185 429.557 912.185 427.945C912.185 426.332 910.883 425.029 909.27 425.029Z"
            fill="white"
          />
          <path
            d="M906.635 453.316C905.065 453.316 903.783 454.598 903.783 456.177C903.783 457.755 905.065 459.029 906.635 459.029C908.205 459.029 909.495 457.747 909.495 456.177C909.495 454.607 908.214 453.316 906.635 453.316Z"
            fill="white"
          />
          <path
            d="M908.646 485.674C907.097 485.674 905.845 486.934 905.845 488.475C905.845 490.015 907.092 491.276 908.646 491.276C910.199 491.276 911.446 490.028 911.446 488.475C911.446 486.922 910.199 485.674 908.646 485.674Z"
            fill="white"
          />
          <path
            d="M915.003 521.604C913.492 521.604 912.266 522.822 912.266 524.341C912.266 525.86 913.492 527.069 915.003 527.069C916.514 527.069 917.74 525.852 917.74 524.341C917.74 522.83 916.514 521.604 915.003 521.604Z"
            fill="white"
          />
          <path
            d="M924.339 560.875C922.871 560.875 921.695 562.063 921.695 563.519C921.695 564.974 922.871 566.171 924.339 566.171C925.808 566.171 926.983 564.983 926.983 563.519C926.983 562.055 925.808 560.875 924.339 560.875Z"
            fill="white"
          />
          <path
            d="M934.664 603.324C933.238 603.324 932.071 604.479 932.071 605.917C932.071 607.356 933.238 608.51 934.664 608.51C936.09 608.51 937.257 607.343 937.257 605.917C937.257 604.491 936.103 603.324 934.664 603.324Z"
            fill="white"
          />
          <path
            d="M943.865 649.025C942.469 649.025 941.336 650.158 941.336 651.555C941.336 652.951 942.469 654.084 943.865 654.084C945.261 654.084 946.395 652.951 946.395 651.555C946.395 650.158 945.27 649.025 943.865 649.025Z"
            fill="white"
          />
          <path
            d="M378.207 673.609C377.074 673.609 376.157 674.526 376.157 675.659C376.157 676.792 377.074 677.7 378.207 677.7C379.34 677.7 380.248 676.784 380.248 675.659C380.248 674.534 379.332 673.609 378.207 673.609Z"
            fill="white"
          />
          <path
            d="M360.366 667.812C359.233 667.812 358.304 668.729 358.304 669.862C358.304 670.995 359.229 671.912 360.366 671.912C361.503 671.912 362.416 670.995 362.416 669.862C362.416 668.729 361.491 667.812 360.366 667.812Z"
            fill="white"
          />
          <path
            d="M341.944 661.557C340.811 661.557 339.895 662.473 339.895 663.606C339.895 664.739 340.811 665.648 341.944 665.648C343.077 665.648 343.994 664.731 343.994 663.606C343.994 662.482 343.077 661.557 341.944 661.557Z"
            fill="white"
          />
          <path
            d="M322.805 654.387C321.672 654.387 320.755 655.303 320.755 656.436C320.755 657.57 321.672 658.478 322.805 658.478C323.938 658.478 324.846 657.561 324.846 656.436C324.846 655.312 323.929 654.387 322.805 654.387Z"
            fill="white"
          />
          <path
            d="M302.893 646.23C301.76 646.23 300.844 647.147 300.844 648.272C300.844 649.396 301.76 650.321 302.893 650.321C304.027 650.321 304.935 649.405 304.935 648.272C304.935 647.139 304.018 646.23 302.893 646.23Z"
            fill="white"
          />
          <path
            d="M281.976 636.549C280.843 636.549 279.927 637.466 279.927 638.599C279.927 639.732 280.843 640.661 281.976 640.661C283.11 640.661 284.026 639.736 284.026 638.599C284.026 637.461 283.11 636.549 281.976 636.549Z"
            fill="white"
          />
          <path
            d="M259.857 625.658C258.724 625.658 257.808 626.575 257.808 627.721C257.808 628.866 258.724 629.77 259.857 629.77C260.99 629.77 261.92 628.854 261.92 627.721C261.92 626.588 260.995 625.658 259.857 625.658Z"
            fill="white"
          />
          <path
            d="M236.148 613.6C235.015 613.6 234.099 614.525 234.099 615.662C234.099 616.799 235.015 617.712 236.148 617.712C237.281 617.712 238.198 616.787 238.198 615.662C238.198 614.537 237.281 613.6 236.148 613.6Z"
            fill="white"
          />
          <path
            d="M210.401 601.225C209.268 601.225 208.339 602.15 208.339 603.296C208.339 604.441 209.264 605.358 210.401 605.358C211.539 605.358 212.472 604.433 212.472 603.296C212.472 602.158 211.547 601.225 210.401 601.225Z"
            fill="white"
          />
          <path
            d="M182.341 588.477C181.195 588.477 180.278 589.402 180.278 590.539C180.278 591.676 181.195 592.602 182.341 592.602C183.487 592.602 184.391 591.685 184.391 590.539C184.391 589.393 183.474 588.477 182.341 588.477Z"
            fill="white"
          />
          <path
            d="M167.136 577.449C165.969 577.449 165.022 578.396 165.022 579.563C165.022 580.73 165.969 581.684 167.136 581.684C168.303 581.684 169.258 580.738 169.258 579.563C169.258 578.387 168.311 577.449 167.136 577.449Z"
            fill="white"
          />
          <path
            d="M153.084 567.094C151.879 567.094 150.907 568.074 150.907 569.271C150.907 570.467 151.875 571.456 153.084 571.456C154.294 571.456 155.261 570.476 155.261 569.271C155.261 568.066 154.294 567.094 153.084 567.094Z"
            fill="white"
          />
          <path
            d="M141.334 557.738C140.073 557.738 139.055 558.757 139.055 560.017C139.055 561.278 140.073 562.309 141.334 562.309C142.594 562.309 143.612 561.278 143.612 560.017C143.612 558.757 142.594 557.738 141.334 557.738Z"
            fill="white"
          />
          <path
            d="M132.299 549.715C131.009 549.715 129.956 550.767 129.956 552.066C129.956 553.364 131.009 554.408 132.299 554.408C133.589 554.408 134.65 553.356 134.65 552.066C134.65 550.776 133.597 549.715 132.299 549.715Z"
            fill="white"
          />
          <path
            d="M125.865 543.064C124.541 543.064 123.472 544.138 123.472 545.458C123.472 546.778 124.545 547.864 125.865 547.864C127.185 547.864 128.271 546.79 128.271 545.458C128.271 544.125 127.198 543.064 125.865 543.064Z"
            fill="white"
          />
          <path
            d="M121.57 537.59C120.208 537.59 119.113 538.693 119.113 540.055C119.113 541.418 120.208 542.513 121.57 542.513C122.933 542.513 124.028 541.409 124.028 540.055C124.028 538.702 122.933 537.59 121.57 537.59Z"
            fill="white"
          />
          <path
            d="M118.957 533.082C117.54 533.082 116.398 534.228 116.398 535.641C116.398 537.054 117.544 538.213 118.957 538.213C120.371 538.213 121.516 537.058 121.516 535.641C121.516 534.224 120.371 533.082 118.957 533.082Z"
            fill="white"
          />
          <path
            d="M117.632 529.422C116.177 529.422 115.01 530.597 115.01 532.044C115.01 533.492 116.177 534.667 117.632 534.667C119.088 534.667 120.255 533.492 120.255 532.044C120.255 530.597 119.08 529.422 117.632 529.422Z"
            fill="white"
          />
          <path
            d="M117.136 526.297C115.646 526.297 114.449 527.506 114.449 528.992C114.449 530.477 115.646 531.678 117.136 531.678C118.625 531.678 119.822 530.468 119.822 528.992C119.822 527.515 118.625 526.297 117.136 526.297Z"
            fill="white"
          />
          <path
            d="M117.123 523.553C115.612 523.553 114.373 524.779 114.373 526.298C114.373 527.818 115.612 529.044 117.123 529.044C118.634 529.044 119.869 527.818 119.869 526.298C119.869 524.779 118.642 523.553 117.123 523.553Z"
            fill="white"
          />
          <path
            d="M117.365 521.002C115.803 521.002 114.534 522.271 114.534 523.833C114.534 525.394 115.803 526.663 117.365 526.663C118.926 526.663 120.208 525.394 120.208 523.833C120.208 522.271 118.939 521.002 117.365 521.002Z"
            fill="white"
          />
          <path
            d="M117.645 518.586C116.041 518.586 114.751 519.876 114.751 521.48C114.751 523.084 116.041 524.383 117.645 524.383C119.249 524.383 120.548 523.08 120.548 521.48C120.548 519.88 119.245 518.586 117.645 518.586Z"
            fill="white"
          />
          <path
            d="M117.738 522.066C119.372 522.066 120.696 520.742 120.696 519.108C120.696 517.475 119.372 516.15 117.738 516.15C116.105 516.15 114.78 517.475 114.78 519.108C114.78 520.742 116.105 522.066 117.738 522.066Z"
            fill="white"
          />
          <path
            d="M117.552 513.635C115.888 513.635 114.543 514.989 114.543 516.652C114.543 518.316 115.884 519.669 117.552 519.669C119.22 519.669 120.569 518.316 120.569 516.652C120.569 514.989 119.215 513.635 117.552 513.635Z"
            fill="white"
          />
          <path
            d="M117.043 510.977C115.324 510.977 113.94 512.36 113.94 514.079C113.94 515.797 115.324 517.181 117.043 517.181C118.761 517.181 120.145 515.785 120.145 514.079C120.145 512.373 118.749 510.977 117.043 510.977Z"
            fill="white"
          />
          <path
            d="M116.147 508.211C114.407 508.211 112.994 509.628 112.994 511.364C112.994 513.1 114.412 514.509 116.147 514.509C117.883 514.509 119.3 513.104 119.3 511.364C119.3 509.624 117.883 508.211 116.147 508.211Z"
            fill="white"
          />
          <path
            d="M114.856 505.273C113.087 505.273 111.652 506.708 111.652 508.49C111.652 510.273 113.091 511.694 114.856 511.694C116.622 511.694 118.073 510.26 118.073 508.49C118.073 506.721 116.639 505.273 114.856 505.273Z"
            fill="white"
          />
          <path
            d="M113.203 502.213C111.403 502.213 109.943 503.668 109.943 505.472C109.943 507.276 111.399 508.731 113.203 508.731C115.006 508.731 116.462 507.276 116.462 505.472C116.462 503.668 115.006 502.213 113.203 502.213Z"
            fill="white"
          />
          <path
            d="M114.269 503.605C114.973 501.905 114.166 499.956 112.466 499.252C110.767 498.548 108.818 499.355 108.114 501.055C107.41 502.755 108.217 504.704 109.917 505.408C111.616 506.112 113.565 505.305 114.269 503.605Z"
            fill="white"
          />
          <path
            d="M108.839 495.699C106.976 495.699 105.465 497.21 105.465 499.082C105.465 500.953 106.976 502.455 108.839 502.455C110.702 502.455 112.212 500.945 112.212 499.082C112.212 497.219 110.702 495.699 108.839 495.699Z"
            fill="white"
          />
          <path
            d="M106.144 492.305C104.251 492.305 102.711 493.837 102.711 495.729C102.711 497.622 104.251 499.163 106.144 499.163C108.037 499.163 109.577 497.622 109.577 495.729C109.577 493.837 108.037 492.305 106.144 492.305Z"
            fill="white"
          />
          <path
            d="M103.106 488.84C101.193 488.84 99.6309 490.389 99.6309 492.315C99.6309 494.242 101.193 495.791 103.106 495.791C105.02 495.791 106.582 494.229 106.582 492.315C106.582 490.402 105.029 488.84 103.106 488.84Z"
            fill="white"
          />
          <path
            d="M99.7239 485.303C97.776 485.303 96.1846 486.886 96.1846 488.842C96.1846 490.798 97.776 492.381 99.7239 492.381C101.672 492.381 103.263 490.79 103.263 488.842C103.263 486.894 101.68 485.303 99.7239 485.303Z"
            fill="white"
          />
          <path
            d="M95.986 481.742C94.0084 481.742 92.4043 483.346 92.4043 485.324C92.4043 487.301 94.0084 488.906 95.986 488.906C97.9636 488.906 99.5677 487.301 99.5677 485.324C99.5677 483.346 97.9636 481.742 95.986 481.742Z"
            fill="white"
          />
          <path
            d="M91.8849 478.152C89.8861 478.152 88.2734 479.778 88.2734 481.772C88.2734 483.767 89.8861 485.384 91.8849 485.384C93.8837 485.384 95.4963 483.758 95.4963 481.772C95.4963 479.786 93.8837 478.152 91.8849 478.152Z"
            fill="white"
          />
          <path
            d="M87.4078 474.547C85.3878 474.547 83.7539 476.181 83.7539 478.201C83.7539 480.221 85.3878 481.855 87.4078 481.855C89.4278 481.855 91.0616 480.221 91.0616 478.201C91.0616 476.181 89.4278 474.547 87.4078 474.547Z"
            fill="white"
          />
          <path
            d="M82.5486 470.906C80.4989 470.906 78.8311 472.57 78.8311 474.624C78.8311 476.678 80.4946 478.337 82.5486 478.337C84.6026 478.337 86.2661 476.674 86.2661 474.624C86.2661 472.574 84.6026 470.906 82.5486 470.906Z"
            fill="white"
          />
          <path
            d="M77.3039 467.305C75.2329 467.305 73.5566 468.981 73.5566 471.052C73.5566 473.123 75.2329 474.799 77.3039 474.799C79.3748 474.799 81.0511 473.114 81.0511 471.052C81.0511 468.989 79.3663 467.305 77.3039 467.305Z"
            fill="white"
          />
          <path
            d="M71.6724 463.691C69.5888 463.691 67.8955 465.376 67.8955 467.468C67.8955 469.561 69.593 471.237 71.6724 471.237C73.7519 471.237 75.4409 469.552 75.4409 467.468C75.4409 465.385 73.7561 463.691 71.6724 463.691Z"
            fill="white"
          />
          <path
            d="M65.6673 460.082C63.5667 460.082 61.8564 461.788 61.8564 463.893C61.8564 465.998 63.5624 467.704 65.6673 467.704C67.7722 467.704 69.4655 465.998 69.4655 463.893C69.4655 461.788 67.768 460.082 65.6673 460.082Z"
            fill="white"
          />
          <path
            d="M59.2895 456.492C57.1676 456.492 55.4404 458.219 55.4404 460.341C55.4404 462.463 57.1676 464.19 59.2895 464.19C61.4114 464.19 63.1301 462.463 63.1301 460.341C63.1301 458.219 61.4114 456.492 59.2895 456.492Z"
            fill="white"
          />
          <path
            d="M52.5422 452.973C50.3991 452.973 48.6592 454.708 48.6592 456.856C48.6592 459.003 50.3991 460.726 52.5422 460.726C54.6853 460.726 56.4125 458.99 56.4125 456.856C56.4125 454.721 54.6726 452.973 52.5422 452.973Z"
            fill="white"
          />
          <path
            d="M45.4335 449.467C43.2777 449.467 41.5293 451.215 41.5293 453.371C41.5293 455.527 43.2777 457.275 45.4335 457.275C47.5894 457.275 49.3378 455.527 49.3378 453.371C49.3378 451.215 47.5894 449.467 45.4335 449.467Z"
            fill="white"
          />
          <path
            d="M37.9225 445.807C35.7582 445.807 33.9971 447.564 33.9971 449.741C33.9971 451.918 35.754 453.666 37.9225 453.666C40.0911 453.666 41.8565 451.905 41.8565 449.741C41.8565 447.576 40.0996 445.807 37.9225 445.807Z"
            fill="white"
          />
          <path
            d="M30.0496 441.9C27.8556 441.9 26.0859 443.67 26.0859 445.856C26.0859 448.041 27.8556 449.819 30.0496 449.819C32.2436 449.819 34.0048 448.05 34.0048 445.856C34.0048 443.662 32.2351 441.9 30.0496 441.9Z"
            fill="white"
          />
          <path
            d="M21.8589 437.697C19.6522 437.697 17.874 439.475 17.874 441.682C17.874 443.889 19.6522 445.659 21.8589 445.659C24.0657 445.659 25.8353 443.88 25.8353 441.682C25.8353 439.484 24.0572 437.697 21.8589 437.697Z"
            fill="white"
          />
          <path
            d="M13.3977 433.139C11.191 433.139 9.3916 434.93 9.3916 437.145C9.3916 439.36 11.191 441.142 13.3977 441.142C15.6045 441.142 17.4038 439.351 17.4038 437.145C17.4038 434.938 15.6129 433.139 13.3977 433.139Z"
            fill="white"
          />
          <path
            d="M4.72782 428.203C2.51258 428.203 0.708984 430.002 0.708984 432.222C0.708984 434.441 2.50833 436.249 4.72782 436.249C6.9473 436.249 8.75513 434.45 8.75513 432.222C8.75513 429.994 6.95578 428.203 4.72782 428.203Z"
            fill="white"
          />
          <path
            d="M-2.87671 193.285C-4.90522 193.285 -6.53906 194.932 -6.53906 196.948C-6.53906 198.963 -4.90522 200.61 -2.87671 200.61C-0.848194 200.61 0.78565 198.976 0.78565 196.948C0.78565 194.919 -0.860926 193.285 -2.87671 193.285Z"
            fill="white"
          />
          <path
            d="M3.87484 181.572C1.86754 181.572 0.242188 183.202 0.242188 185.205C0.242188 187.208 1.86754 188.838 3.87484 188.838C5.88213 188.838 7.50749 187.208 7.50749 185.205C7.50749 183.202 5.87364 181.572 3.87484 181.572Z"
            fill="white"
          />
          <path
            d="M10.809 170.145C8.83137 170.145 7.21875 171.753 7.21875 173.731C7.21875 175.708 8.83137 177.321 10.809 177.321C12.7865 177.321 14.3992 175.717 14.3992 173.731C14.3992 171.744 12.795 170.145 10.809 170.145Z"
            fill="white"
          />
          <path
            d="M17.895 159.035C15.9471 159.035 14.377 160.618 14.377 162.562C14.377 164.505 15.9471 166.088 17.895 166.088C19.8429 166.088 21.4216 164.505 21.4216 162.562C21.4216 160.618 19.8387 159.035 17.895 159.035Z"
            fill="white"
          />
          <path
            d="M25.1485 148.145C23.2219 148.145 21.6602 149.702 21.6602 151.624C21.6602 153.547 23.2219 155.113 25.1485 155.113C27.0752 155.113 28.6241 153.551 28.6241 151.624C28.6241 149.698 27.0752 148.145 25.1485 148.145Z"
            fill="white"
          />
          <path
            d="M32.4264 137.545C30.5336 137.545 28.9932 139.085 28.9932 140.978C28.9932 142.871 30.5336 144.411 32.4264 144.411C34.3191 144.411 35.8596 142.871 35.8596 140.978C35.8596 139.085 34.3191 137.545 32.4264 137.545Z"
            fill="white"
          />
          <path
            d="M39.5854 127.207C37.7224 127.207 36.2031 128.722 36.2031 130.589C36.2031 132.457 37.7224 133.98 39.5854 133.98C41.4484 133.98 42.9762 132.461 42.9762 130.589C42.9762 128.718 41.4569 127.207 39.5854 127.207Z"
            fill="white"
          />
          <path
            d="M46.4944 117.123C44.6611 117.123 43.1758 118.613 43.1758 120.45C43.1758 122.288 44.6653 123.777 46.4944 123.777C48.3234 123.777 49.813 122.288 49.813 120.45C49.813 118.613 48.3362 117.123 46.4944 117.123Z"
            fill="white"
          />
          <path
            d="M53.0216 107.172C51.2222 107.172 49.7539 108.627 49.7539 110.431C49.7539 112.235 51.2222 113.699 53.0216 113.699C54.8209 113.699 56.2893 112.243 56.2893 110.431C56.2893 108.619 54.8209 107.172 53.0216 107.172Z"
            fill="white"
          />
          <path
            d="M59.0263 97.4336C57.2567 97.4336 55.8096 98.868 55.8096 100.65C55.8096 102.433 57.2567 103.867 59.0263 103.867C60.796 103.867 62.2431 102.424 62.2431 100.65C62.2431 98.8765 60.8087 97.4336 59.0263 97.4336Z"
            fill="white"
          />
          <path
            d="M64.3562 88.2832C62.6205 88.2832 61.2031 89.7006 61.2031 91.4406C61.2031 93.1805 62.6205 94.5979 64.3562 94.5979C66.0919 94.5979 67.5221 93.1805 67.5221 91.4406C67.5221 89.7006 66.1047 88.2832 64.3562 88.2832Z"
            fill="white"
          />
          <path
            d="M68.9862 79.957C67.2887 79.957 65.9053 81.332 65.9053 83.038C65.9053 84.744 67.2887 86.119 68.9862 86.119C70.6837 86.119 72.0672 84.7355 72.0672 83.038C72.0672 81.3405 70.6922 79.957 68.9862 79.957Z"
            fill="white"
          />
          <path
            d="M72.9753 72.4336C71.3118 72.4336 69.958 73.7874 69.958 75.4509C69.958 77.1144 71.3118 78.4725 72.9753 78.4725C74.6389 78.4725 76.0054 77.1187 76.0054 75.4509C76.0054 73.7831 74.6516 72.4336 72.9753 72.4336Z"
            fill="white"
          />
          <path
            d="M76.4381 65.6133C74.8042 65.6133 73.4717 66.9458 73.4717 68.5797C73.4717 70.2135 74.8042 71.546 76.4381 71.546C78.0719 71.546 79.4044 70.2262 79.4044 68.5797C79.4044 66.9331 78.0846 65.6133 76.4381 65.6133Z"
            fill="white"
          />
          <path
            d="M79.5121 59.3262C77.8995 59.3262 76.5967 60.629 76.5967 62.2289C76.5967 63.8288 77.8995 65.1359 79.5121 65.1359C81.1248 65.1359 82.4149 63.833 82.4149 62.2289C82.4149 60.6248 81.112 59.3262 79.5121 59.3262Z"
            fill="white"
          />
          <path
            d="M82.2908 53.3945C80.7376 53.3945 79.4814 54.6592 79.4814 56.2166C79.4814 57.7741 80.7418 59.026 82.2908 59.026C83.8398 59.026 85.1002 57.7656 85.1002 56.2166C85.1002 54.6677 83.8398 53.3945 82.2908 53.3945Z"
            fill="white"
          />
          <path
            d="M84.8795 47.5977C83.3475 47.5977 82.1211 48.8241 82.1211 50.3518C82.1211 51.8796 83.3475 53.106 84.8795 53.106C86.4115 53.106 87.6252 51.8796 87.6252 50.3518C87.6252 48.8241 86.3988 47.5977 84.8795 47.5977Z"
            fill="white"
          />
          <path
            d="M87.366 41.8008C85.8764 41.8008 84.6797 43.0102 84.6797 44.4956C84.6797 45.9809 85.8764 47.1903 87.366 47.1903C88.8555 47.1903 90.0608 45.9851 90.0608 44.4956C90.0608 43.006 88.8555 41.8008 87.366 41.8008Z"
            fill="white"
          />
          <path
            d="M89.9283 35.7441C88.4727 35.7441 87.293 36.9197 87.293 38.3753C87.293 39.8309 88.4685 40.9979 89.9283 40.9979C91.3882 40.9979 92.551 39.8224 92.551 38.3753C92.551 36.9281 91.3755 35.7441 89.9283 35.7441Z"
            fill="white"
          />
          <path
            d="M92.6872 29.1172C91.2825 29.1172 90.1494 30.2588 90.1494 31.6507C90.1494 33.0427 91.2825 34.1885 92.6872 34.1885C94.0919 34.1885 95.2249 33.0554 95.2249 31.6507C95.2249 30.246 94.0791 29.1172 92.6872 29.1172Z"
            fill="white"
          />
          <path
            d="M95.9207 21.3301C94.5585 21.3301 93.4551 22.4335 93.4551 23.7957C93.4551 25.1579 94.5585 26.2613 95.9207 26.2613C97.2829 26.2613 98.3778 25.1537 98.3778 23.7957C98.3778 22.4377 97.2745 21.3301 95.9207 21.3301Z"
            fill="white"
          />
          <path
            d="M100.169 11.6484C98.8488 11.6484 97.7666 12.7263 97.7666 14.0546C97.7666 15.3829 98.8488 16.4566 100.169 16.4566C101.488 16.4566 102.575 15.3829 102.575 14.0546C102.575 12.7263 101.501 11.6484 100.169 11.6484Z"
            fill="white"
          />
          <path
            d="M106.281 -0.746094C104.991 -0.746094 103.938 0.297869 103.938 1.59646C103.938 2.89504 104.991 3.92627 106.281 3.92627C107.571 3.92627 108.611 2.88656 108.611 1.59646C108.611 0.306356 107.571 -0.746094 106.281 -0.746094Z"
            fill="white"
          />
          <path
            d="M975.141 3.07031C973.63 3.07031 972.412 4.28827 972.412 5.78631C972.412 7.28436 973.63 8.50656 975.141 8.50656C976.652 8.50656 977.857 7.2886 977.857 5.78631C977.857 4.28403 976.639 3.07031 975.141 3.07031Z"
            fill="white"
          />
          <path
            d="M982.623 14.127C981.091 14.127 979.844 15.3704 979.844 16.9066C979.844 18.4428 981.091 19.6863 982.623 19.6863C984.155 19.6863 985.403 18.4428 985.403 16.9066C985.403 15.3704 984.164 14.127 982.623 14.127Z"
            fill="white"
          />
          <path
            d="M990.232 24.9395C988.649 24.9395 987.372 26.2211 987.372 27.7997C987.372 29.3784 988.654 30.6515 990.232 30.6515C991.811 30.6515 993.084 29.3699 993.084 27.7997C993.084 26.2296 991.803 24.9395 990.232 24.9395Z"
            fill="white"
          />
          <path
            d="M997.913 35.5957C996.301 35.5957 994.998 36.907 994.998 38.5196C994.998 40.1323 996.301 41.4351 997.913 41.4351C999.526 41.4351 1000.83 40.128 1000.83 38.5196C1000.83 36.9113 999.526 35.5957 997.913 35.5957Z"
            fill="white"
          />
          <path
            d="M1005.69 52.0298C1007.33 52.0298 1008.66 50.6979 1008.66 49.0549C1008.66 47.412 1007.33 46.0801 1005.69 46.0801C1004.05 46.0801 1002.71 47.412 1002.71 49.0549C1002.71 50.6979 1004.05 52.0298 1005.69 52.0298Z"
            fill="white"
          />
          <path
            d="M1013.48 56.4844C1011.81 56.4844 1010.45 57.8466 1010.45 59.5229C1010.45 61.1992 1011.81 62.5572 1013.48 62.5572C1015.16 62.5572 1016.51 61.1992 1016.51 59.5229C1016.51 57.8466 1015.16 56.4844 1013.48 56.4844Z"
            fill="white"
          />
          <path
            d="M1021.29 66.8223C1019.56 66.8223 1018.16 68.2185 1018.16 69.9457C1018.16 71.6729 1019.56 73.0691 1021.29 73.0691C1023.01 73.0691 1024.41 71.6729 1024.41 69.9457C1024.41 68.2185 1023.01 66.8223 1021.29 66.8223Z"
            fill="white"
          />
          <path
            d="M1029.15 77.082C1027.39 77.082 1025.97 78.5079 1025.97 80.2564C1025.97 82.0048 1027.39 83.4307 1029.15 83.4307C1030.9 83.4307 1032.31 82.0133 1032.31 80.2564C1032.31 78.4994 1030.9 77.082 1029.15 77.082Z"
            fill="white"
          />
          <path
            d="M1037.02 87.2734C1035.23 87.2734 1033.79 88.7206 1033.79 90.4987C1033.79 92.2768 1035.23 93.7367 1037.02 93.7367C1038.81 93.7367 1040.25 92.2896 1040.25 90.4987C1040.25 88.7078 1038.8 87.2734 1037.02 87.2734Z"
            fill="white"
          />
          <path
            d="M1044.91 97.4336C1043.09 97.4336 1041.62 98.9019 1041.62 100.714C1041.62 102.526 1043.09 103.986 1044.91 103.986C1046.72 103.986 1048.17 102.522 1048.17 100.714C1048.17 98.9062 1046.7 97.4336 1044.91 97.4336Z"
            fill="white"
          />
          <path
            d="M1052.75 107.559C1050.9 107.559 1049.39 109.069 1049.39 110.924C1049.39 112.778 1050.9 114.285 1052.75 114.285C1054.6 114.285 1056.11 112.783 1056.11 110.924C1056.11 109.065 1054.6 107.559 1052.75 107.559Z"
            fill="white"
          />
          <path
            d="M1060.53 117.836C1058.64 117.836 1057.11 119.359 1057.11 121.244C1057.11 123.128 1058.65 124.656 1060.53 124.656C1062.41 124.656 1063.94 123.124 1063.94 121.244C1063.94 119.364 1062.41 117.836 1060.53 117.836Z"
            fill="white"
          />
          <path
            d="M1068.23 128.23C1066.32 128.23 1064.77 129.779 1064.77 131.685C1064.77 133.59 1066.32 135.139 1068.23 135.139C1070.13 135.139 1071.68 133.59 1071.68 131.685C1071.68 129.779 1070.13 128.23 1068.23 128.23Z"
            fill="white"
          />
          <path
            d="M1075.84 138.779C1073.9 138.779 1072.33 140.349 1072.33 142.289C1072.33 144.228 1073.9 145.786 1075.84 145.786C1077.77 145.786 1079.33 144.22 1079.33 142.289C1079.33 140.358 1077.77 138.779 1075.84 138.779Z"
            fill="white"
          />
          <path
            d="M1083.33 149.533C1081.35 149.533 1079.75 151.137 1079.75 153.115C1079.75 155.093 1081.35 156.684 1083.33 156.684C1085.31 156.684 1086.9 155.088 1086.9 153.115C1086.9 151.142 1085.3 149.533 1083.33 149.533Z"
            fill="white"
          />
          <path
            d="M1090.7 160.553C1088.7 160.553 1087.09 162.17 1087.09 164.164C1087.09 166.159 1088.7 167.784 1090.7 167.784C1092.7 167.784 1094.32 166.159 1094.32 164.164C1094.32 162.17 1092.69 160.553 1090.7 160.553Z"
            fill="white"
          />
          <path
            d="M1097.96 171.824C1095.94 171.824 1094.3 173.458 1094.3 175.487C1094.3 177.515 1095.95 179.149 1097.96 179.149C1099.98 179.149 1101.63 177.502 1101.63 175.487C1101.63 173.471 1099.99 171.824 1097.96 171.824Z"
            fill="white"
          />
          <path
            d="M1105.14 183.359C1103.09 183.359 1101.44 185.014 1101.44 187.056C1101.44 189.097 1103.09 190.752 1105.14 190.752C1107.18 190.752 1108.83 189.097 1108.83 187.056C1108.83 185.014 1107.18 183.359 1105.14 183.359Z"
            fill="white"
          />
          <path
            d="M1112.31 194.967C1110.24 194.967 1108.55 196.647 1108.55 198.718C1108.55 200.789 1110.24 202.474 1112.31 202.474C1114.38 202.474 1116.06 200.798 1116.06 198.718C1116.06 196.639 1114.38 194.967 1112.31 194.967Z"
            fill="white"
          />
          <path
            d="M1119.57 206.518C1117.47 206.518 1115.77 208.215 1115.77 210.316C1115.77 212.416 1117.47 214.105 1119.57 214.105C1121.67 214.105 1123.37 212.408 1123.37 210.316C1123.37 208.224 1121.66 206.518 1119.57 206.518Z"
            fill="white"
          />
          <path
            d="M1127.05 217.713C1124.94 217.713 1123.22 219.432 1123.22 221.545C1123.22 223.658 1124.94 225.373 1127.05 225.373C1129.17 225.373 1130.9 223.654 1130.9 221.545C1130.9 219.436 1129.18 217.713 1127.05 217.713Z"
            fill="white"
          />
          <path
            d="M1134.81 228.426C1132.66 228.426 1130.94 230.153 1130.94 232.296C1130.94 234.439 1132.66 236.166 1134.81 236.166C1136.95 236.166 1138.68 234.439 1138.68 232.296C1138.68 230.153 1136.95 228.426 1134.81 228.426Z"
            fill="white"
          />
          <path
            d="M1142.88 238.469C1140.71 238.469 1138.96 240.226 1138.96 242.394C1138.96 244.563 1140.71 246.307 1142.88 246.307C1145.04 246.307 1146.8 244.559 1146.8 242.394C1146.8 240.23 1145.04 238.469 1142.88 238.469Z"
            fill="white"
          />
          <path
            d="M1151.26 255.694C1153.45 255.694 1155.22 253.923 1155.22 251.738C1155.22 249.554 1153.45 247.783 1151.26 247.783C1149.08 247.783 1147.31 249.554 1147.31 251.738C1147.31 253.923 1149.08 255.694 1151.26 255.694Z"
            fill="white"
          />
          <path
            d="M1159.97 256.266C1157.78 256.266 1156 258.056 1156 260.251C1156 262.445 1157.78 264.235 1159.97 264.235C1162.17 264.235 1163.96 262.457 1163.96 260.251C1163.96 258.044 1162.18 256.266 1159.97 256.266Z"
            fill="white"
          />
          <path
            d="M1169.01 263.926C1166.79 263.926 1164.99 265.717 1164.99 267.932C1164.99 270.147 1166.79 271.951 1169.01 271.951C1171.23 271.951 1173.01 270.16 1173.01 267.932C1173.01 265.704 1171.22 263.926 1169.01 263.926Z"
            fill="white"
          />
          <path
            d="M1178.32 270.785C1176.09 270.785 1174.28 272.597 1174.28 274.834C1174.28 277.07 1176.09 278.882 1178.32 278.882C1180.56 278.882 1182.36 277.07 1182.36 274.834C1182.36 272.597 1180.55 270.785 1178.32 270.785Z"
            fill="white"
          />
          <path
            d="M1187.9 276.926C1185.64 276.926 1183.82 278.759 1183.82 281.004C1183.82 283.249 1185.64 285.082 1187.9 285.082C1190.16 285.082 1191.97 283.249 1191.97 281.004C1191.97 278.759 1190.15 276.926 1187.9 276.926Z"
            fill="white"
          />
          <path
            d="M1197.71 282.43C1195.45 282.43 1193.61 284.263 1193.61 286.521C1193.61 288.778 1195.45 290.62 1197.71 290.62C1199.96 290.62 1201.8 288.787 1201.8 286.521C1201.8 284.254 1199.96 282.43 1197.71 282.43Z"
            fill="white"
          />
          <path
            d="M1207.7 287.346C1205.42 287.346 1203.58 289.187 1203.58 291.466C1203.58 293.745 1205.42 295.587 1207.7 295.587C1209.98 295.587 1211.82 293.733 1211.82 291.466C1211.82 289.2 1209.98 287.346 1207.7 287.346Z"
            fill="white"
          />
          <path
            d="M1217.86 291.715C1215.57 291.715 1213.71 293.569 1213.71 295.857C1213.71 298.144 1215.57 300.011 1217.86 300.011C1220.15 300.011 1222.02 298.148 1222.02 295.857C1222.02 293.565 1220.15 291.715 1217.86 291.715Z"
            fill="white"
          />
          <path
            d="M1228.16 295.564C1225.87 295.564 1224 297.427 1224 299.719C1224 302.011 1225.87 303.874 1228.16 303.874C1230.45 303.874 1232.31 302.011 1232.31 299.719C1232.31 297.427 1230.46 295.564 1228.16 295.564Z"
            fill="white"
          />
          <path
            d="M1238.58 298.844C1236.28 298.844 1234.42 300.698 1234.42 302.998C1234.42 305.298 1236.27 307.153 1238.58 307.153C1240.88 307.153 1242.73 305.29 1242.73 302.998C1242.73 300.707 1240.87 298.844 1238.58 298.844Z"
            fill="white"
          />
          <path
            d="M1249.08 301.475C1246.78 301.475 1244.92 303.325 1244.92 305.629C1244.92 307.934 1246.78 309.784 1249.08 309.784C1251.38 309.784 1253.23 307.921 1253.23 305.629C1253.23 303.338 1251.37 301.475 1249.08 301.475Z"
            fill="white"
          />
          <path
            d="M1259.61 303.475C1257.32 303.475 1255.45 305.325 1255.45 307.629C1255.45 309.934 1257.32 311.784 1259.61 311.784C1261.9 311.784 1263.76 309.921 1263.76 307.629C1263.76 305.338 1261.91 303.475 1259.61 303.475Z"
            fill="white"
          />
          <path
            d="M1270.11 304.869C1267.82 304.869 1265.96 306.732 1265.96 309.024C1265.96 311.315 1267.82 313.178 1270.11 313.178C1272.4 313.178 1274.27 311.315 1274.27 309.024C1274.27 306.732 1272.41 304.869 1270.11 304.869Z"
            fill="white"
          />
          <path
            d="M1280.53 305.682C1278.24 305.682 1276.38 307.545 1276.38 309.836C1276.38 312.128 1278.24 313.991 1280.53 313.991C1282.82 313.991 1284.69 312.141 1284.69 309.836C1284.69 307.532 1282.83 305.682 1280.53 305.682Z"
            fill="white"
          />
          <path
            d="M1290.81 305.881C1288.52 305.881 1286.66 307.735 1286.66 310.035C1286.66 312.336 1288.52 314.19 1290.81 314.19C1293.1 314.19 1294.97 312.327 1294.97 310.035C1294.97 307.744 1293.12 305.881 1290.81 305.881Z"
            fill="white"
          />
          <path
            d="M1300.91 305.486C1298.62 305.486 1296.75 307.349 1296.75 309.641C1296.75 311.933 1298.62 313.804 1300.91 313.804C1303.2 313.804 1305.06 311.941 1305.06 309.641C1305.06 307.341 1303.21 305.486 1300.91 305.486Z"
            fill="white"
          />
          <path
            d="M1297.29 307.098C1294.99 307.098 1293.13 308.961 1293.13 311.252C1293.13 313.544 1294.99 315.407 1297.29 315.407C1299.58 315.407 1301.44 313.552 1301.44 311.252C1301.44 308.952 1299.58 307.098 1297.29 307.098Z"
            fill="white"
          />
          <path
            d="M1293.36 308.525C1291.08 308.525 1289.21 310.388 1289.21 312.68C1289.21 314.972 1291.07 316.835 1293.36 316.835C1295.66 316.835 1297.52 314.984 1297.52 312.68C1297.52 310.376 1295.67 308.525 1293.36 308.525Z"
            fill="white"
          />
          <path
            d="M1289.09 309.795C1286.79 309.795 1284.93 311.658 1284.93 313.95C1284.93 316.241 1286.79 318.104 1289.09 318.104C1291.39 318.104 1293.24 316.241 1293.24 313.95C1293.24 311.658 1291.38 309.795 1289.09 309.795Z"
            fill="white"
          />
          <path
            d="M1284.38 310.904C1282.09 310.904 1280.22 312.759 1280.22 315.059C1280.22 317.359 1282.09 319.214 1284.38 319.214C1286.67 319.214 1288.54 317.351 1288.54 315.059C1288.54 312.767 1286.68 310.904 1284.38 310.904Z"
            fill="white"
          />
          <path
            d="M1279.24 311.852C1276.95 311.852 1275.08 313.715 1275.08 316.006C1275.08 318.298 1276.95 320.161 1279.24 320.161C1281.52 320.161 1283.39 318.298 1283.39 316.006C1283.39 313.715 1281.54 311.852 1279.24 311.852Z"
            fill="white"
          />
          <path
            d="M1273.64 312.633C1271.34 312.633 1269.48 314.496 1269.48 316.787C1269.48 319.079 1271.33 320.942 1273.64 320.942C1275.94 320.942 1277.79 319.079 1277.79 316.787C1277.79 314.496 1275.93 312.633 1273.64 312.633Z"
            fill="white"
          />
          <path
            d="M1267.56 313.248C1265.26 313.248 1263.4 315.098 1263.4 317.403C1263.4 319.707 1265.26 321.553 1267.56 321.553C1269.86 321.553 1271.72 319.69 1271.72 317.403C1271.72 315.115 1269.85 313.248 1267.56 313.248Z"
            fill="white"
          />
          <path
            d="M1261.01 313.676C1258.71 313.676 1256.86 315.539 1256.86 317.83C1256.86 320.122 1258.71 321.985 1261.01 321.985C1263.31 321.985 1265.17 320.122 1265.17 317.83C1265.17 315.539 1263.31 313.676 1261.01 313.676Z"
            fill="white"
          />
          <path
            d="M1254.01 313.895C1251.72 313.895 1249.86 315.749 1249.86 318.049C1249.86 320.349 1251.72 322.204 1254.01 322.204C1256.3 322.204 1258.17 320.341 1258.17 318.049C1258.17 315.758 1256.31 313.895 1254.01 313.895Z"
            fill="white"
          />
          <path
            d="M1246.58 313.863C1244.29 313.863 1242.42 315.726 1242.42 318.018C1242.42 320.31 1244.28 322.173 1246.58 322.173C1248.87 322.173 1250.73 320.31 1250.73 318.018C1250.73 315.726 1248.88 313.863 1246.58 313.863Z"
            fill="white"
          />
          <path
            d="M1238.74 313.57C1236.46 313.57 1234.59 315.425 1234.59 317.725C1234.59 320.025 1236.45 321.88 1238.74 321.88C1241.03 321.88 1242.9 320.017 1242.9 317.725C1242.9 315.433 1241.05 313.57 1238.74 313.57Z"
            fill="white"
          />
          <path
            d="M1230.54 312.977C1228.25 312.977 1226.38 314.84 1226.38 317.131C1226.38 319.423 1228.25 321.286 1230.54 321.286C1232.83 321.286 1234.69 319.423 1234.69 317.131C1234.69 314.84 1232.83 312.977 1230.54 312.977Z"
            fill="white"
          />
          <path
            d="M1222 312.143C1219.7 312.143 1217.85 313.997 1217.85 316.284C1217.85 318.572 1219.71 320.418 1222 320.418C1224.28 320.418 1226.14 318.563 1226.14 316.284C1226.14 314.006 1224.28 312.143 1222 312.143Z"
            fill="white"
          />
          <path
            d="M1213.13 311.125C1210.85 311.125 1208.99 312.98 1208.99 315.258C1208.99 317.537 1210.85 319.379 1213.13 319.379C1215.41 319.379 1217.25 317.529 1217.25 315.258C1217.25 312.988 1215.4 311.125 1213.13 311.125Z"
            fill="white"
          />
          <path
            d="M1203.94 309.973C1201.68 309.973 1199.85 311.806 1199.85 314.064C1199.85 316.321 1201.68 318.163 1203.94 318.163C1206.2 318.163 1208.04 316.33 1208.04 314.064C1208.04 311.797 1206.21 309.973 1203.94 309.973Z"
            fill="white"
          />
          <path
            d="M1194.46 308.689C1192.22 308.689 1190.4 310.51 1190.4 312.759C1190.4 315.008 1192.22 316.816 1194.46 316.816C1196.69 316.816 1198.53 314.996 1198.53 312.759C1198.53 310.523 1196.7 308.689 1194.46 308.689Z"
            fill="white"
          />
          <path
            d="M1184.69 307.357C1182.47 307.357 1180.65 309.157 1180.65 311.385C1180.65 313.613 1182.47 315.425 1184.69 315.425C1186.92 315.425 1188.73 313.613 1188.73 311.385C1188.73 309.157 1186.92 307.357 1184.69 307.357Z"
            fill="white"
          />
          <path
            d="M1174.66 305.994C1172.45 305.994 1170.64 307.793 1170.64 310.021C1170.64 312.249 1172.44 314.04 1174.66 314.04C1176.88 314.04 1178.69 312.241 1178.69 310.021C1178.69 307.802 1176.89 305.994 1174.66 305.994Z"
            fill="white"
          />
          <path
            d="M1164.38 304.713C1162.19 304.713 1160.39 306.491 1160.39 308.698C1160.39 310.905 1162.19 312.695 1164.38 312.695C1166.57 312.695 1168.38 310.905 1168.38 308.698C1168.38 306.491 1166.59 304.713 1164.38 304.713Z"
            fill="white"
          />
          <path
            d="M1153.85 303.516C1151.66 303.516 1149.9 305.285 1149.9 307.458C1149.9 309.631 1151.66 311.405 1153.85 311.405C1156.03 311.405 1157.79 309.644 1157.79 307.458C1157.79 305.273 1156.02 303.516 1153.85 303.516Z"
            fill="white"
          />
          <path
            d="M1143.04 302.443C1140.88 302.443 1139.13 304.2 1139.13 306.356C1139.13 308.512 1140.88 310.282 1143.04 310.282C1145.21 310.282 1146.95 308.52 1146.95 306.356C1146.95 304.192 1145.21 302.443 1143.04 302.443Z"
            fill="white"
          />
          <path
            d="M1131.99 301.59C1129.85 301.59 1128.12 303.317 1128.12 305.46C1128.12 307.603 1129.85 309.33 1131.99 309.33C1134.12 309.33 1135.87 307.591 1135.87 305.46C1135.87 303.33 1134.13 301.59 1131.99 301.59Z"
            fill="white"
          />
          <path
            d="M1120.73 300.996C1118.61 300.996 1116.89 302.715 1116.89 304.837C1116.89 306.959 1118.61 308.686 1120.73 308.686C1122.85 308.686 1124.57 306.959 1124.57 304.837C1124.57 302.715 1122.85 300.996 1120.73 300.996Z"
            fill="white"
          />
          <path
            d="M1109.23 300.748C1107.14 300.748 1105.45 302.446 1105.45 304.538C1105.45 306.63 1107.15 308.327 1109.23 308.327C1111.31 308.327 1113.02 306.63 1113.02 304.538C1113.02 302.446 1111.32 300.748 1109.23 300.748Z"
            fill="white"
          />
          <path
            d="M1097.52 300.811C1095.44 300.811 1093.76 302.495 1093.76 304.566C1093.76 306.637 1095.44 308.322 1097.52 308.322C1099.6 308.322 1101.27 306.637 1101.27 304.566C1101.27 302.495 1099.59 300.811 1097.52 300.811Z"
            fill="white"
          />
          <path
            d="M1085.6 301.301C1083.55 301.301 1081.89 302.964 1081.89 305.014C1081.89 307.064 1083.55 308.732 1085.6 308.732C1087.65 308.732 1089.31 307.068 1089.31 305.014C1089.31 302.96 1087.65 301.301 1085.6 301.301Z"
            fill="white"
          />
          <path
            d="M1073.49 302.27C1071.46 302.27 1069.8 303.925 1069.8 305.953C1069.8 307.982 1071.46 309.628 1073.49 309.628C1075.51 309.628 1077.16 307.982 1077.16 305.953C1077.16 303.925 1075.51 302.27 1073.49 302.27Z"
            fill="white"
          />
          <path
            d="M1061.18 303.818C1059.18 303.818 1057.57 305.431 1057.57 307.421C1057.57 309.412 1059.18 311.033 1061.18 311.033C1063.18 311.033 1064.79 309.42 1064.79 307.421C1064.79 305.422 1063.17 303.818 1061.18 303.818Z"
            fill="white"
          />
          <path
            d="M1048.68 305.859C1046.72 305.859 1045.12 307.451 1045.12 309.428C1045.12 311.406 1046.71 312.989 1048.68 312.989C1050.65 312.989 1052.25 311.397 1052.25 309.428C1052.25 307.459 1050.65 305.859 1048.68 305.859Z"
            fill="white"
          />
          <path
            d="M1035.98 308.533C1034.04 308.533 1032.47 310.103 1032.47 312.051C1032.47 313.999 1034.04 315.569 1035.98 315.569C1037.93 315.569 1039.5 313.999 1039.5 312.051C1039.5 310.103 1037.93 308.533 1035.98 308.533Z"
            fill="white"
          />
          <path
            d="M1023.17 311.979C1021.25 311.979 1019.69 313.54 1019.69 315.454C1019.69 317.368 1021.25 318.942 1023.17 318.942C1025.08 318.942 1026.65 317.381 1026.65 315.454C1026.65 313.527 1025.09 311.979 1023.17 311.979Z"
            fill="white"
          />
          <path
            d="M1010.2 316.277C1008.31 316.277 1006.79 317.809 1006.79 319.681C1006.79 321.552 1008.31 323.093 1010.2 323.093C1012.08 323.093 1013.6 321.561 1013.6 319.681C1013.6 317.801 1012.08 316.277 1010.2 316.277Z"
            fill="white"
          />
          <path
            d="M997.06 321.451C995.21 321.451 993.699 322.949 993.699 324.804C993.699 326.658 995.21 328.165 997.06 328.165C998.911 328.165 1000.42 326.667 1000.42 324.804C1000.42 322.941 998.911 321.451 997.06 321.451Z"
            fill="white"
          />
          <path
            d="M983.862 327.871C982.042 327.871 980.561 329.348 980.561 331.168C980.561 332.989 982.037 334.47 983.862 334.47C985.687 334.47 987.159 332.993 987.159 331.168C987.159 329.344 985.683 327.871 983.862 327.871Z"
            fill="white"
          />
          <path
            d="M970.593 335.896C968.794 335.896 967.334 337.344 967.334 339.143C967.334 340.942 968.79 342.402 970.593 342.402C972.397 342.402 973.84 340.947 973.84 339.143C973.84 337.339 972.393 335.896 970.593 335.896Z"
            fill="white"
          />
          <path
            d="M957.645 346.129C955.888 346.129 954.462 347.555 954.462 349.312C954.462 351.069 955.888 352.486 957.645 352.486C959.402 352.486 960.819 351.06 960.819 349.312C960.819 347.563 959.402 346.129 957.645 346.129Z"
            fill="white"
          />
          <path
            d="M945.248 358.855C943.521 358.855 942.116 360.26 942.116 361.979C942.116 363.698 943.521 365.102 945.248 365.102C946.975 365.102 948.371 363.706 948.371 361.979C948.371 360.252 946.967 358.855 945.248 358.855Z"
            fill="white"
          />
          <path
            d="M934.019 374.762C932.322 374.762 930.951 376.137 930.951 377.834C930.951 379.532 932.326 380.894 934.019 380.894C935.713 380.894 937.079 379.519 937.079 377.834C937.079 376.149 935.704 374.762 934.019 374.762Z"
            fill="white"
          />
          <path
            d="M924.153 393.9C922.49 393.9 921.145 395.241 921.145 396.909C921.145 398.577 922.485 399.918 924.153 399.918C925.821 399.918 927.149 398.564 927.149 396.909C927.149 395.254 925.808 393.9 924.153 393.9Z"
            fill="white"
          />
          <path
            d="M916.608 416.932C914.982 416.932 913.671 418.243 913.671 419.868C913.671 421.494 914.982 422.792 916.608 422.792C918.233 422.792 919.532 421.481 919.532 419.868C919.532 418.256 918.22 416.932 916.608 416.932Z"
            fill="white"
          />
          <path
            d="M912.725 444.283C911.142 444.283 909.852 445.565 909.852 447.156C909.852 448.748 911.142 450.017 912.725 450.017C914.308 450.017 915.598 448.735 915.598 447.156C915.598 445.578 914.308 444.283 912.725 444.283Z"
            fill="white"
          />
          <path
            d="M913.568 475.779C912.015 475.779 910.759 477.04 910.759 478.589C910.759 480.138 912.019 481.398 913.568 481.398C915.117 481.398 916.378 480.138 916.378 478.589C916.378 477.04 915.117 475.779 913.568 475.779Z"
            fill="white"
          />
          <path
            d="M919.158 510.799C917.639 510.799 916.399 512.038 916.399 513.557C916.399 515.077 917.639 516.303 919.158 516.303C920.677 516.303 921.916 515.077 921.916 513.557C921.916 512.038 920.677 510.799 919.158 510.799Z"
            fill="white"
          />
          <path
            d="M928.223 548.893C926.754 548.893 925.558 550.081 925.558 551.545C925.558 553.009 926.754 554.21 928.223 554.21C929.691 554.21 930.888 553.022 930.888 551.545C930.888 550.068 929.691 548.893 928.223 548.893Z"
            fill="white"
          />
          <path
            d="M938.777 589.861C937.343 589.861 936.176 591.028 936.176 592.475C936.176 593.923 937.343 595.077 938.777 595.077C940.212 595.077 941.379 593.91 941.379 592.475C941.379 591.041 940.212 589.861 938.777 589.861Z"
            fill="white"
          />
          <path
            d="M948.983 633.99C947.578 633.99 946.433 635.123 946.433 636.528C946.433 637.933 947.578 639.079 948.983 639.079C950.388 639.079 951.534 637.933 951.534 636.528C951.534 635.123 950.388 633.99 948.983 633.99Z"
            fill="white"
          />
          <path
            d="M368.077 677.078C366.974 677.078 366.091 677.965 366.091 679.064C366.091 680.163 366.974 681.063 368.077 681.063C369.18 681.063 370.076 680.168 370.076 679.064C370.076 677.961 369.18 677.078 368.077 677.078Z"
            fill="white"
          />
          <path
            d="M349.906 670.635C348.803 670.635 347.907 671.53 347.907 672.621C347.907 673.711 348.803 674.607 349.906 674.607C351.009 674.607 351.892 673.72 351.892 672.621C351.892 671.522 350.997 670.635 349.906 670.635Z"
            fill="white"
          />
          <path
            d="M331.111 663.568C330.008 663.568 329.125 664.464 329.125 665.554C329.125 666.645 330.008 667.553 331.111 667.553C332.214 667.553 333.097 666.658 333.097 665.554C333.097 664.451 332.214 663.568 331.111 663.568Z"
            fill="white"
          />
          <path
            d="M311.67 655.795C310.566 655.795 309.684 656.69 309.684 657.781C309.684 658.872 310.571 659.767 311.67 659.767C312.769 659.767 313.647 658.884 313.647 657.781C313.647 656.678 312.765 655.795 311.67 655.795Z"
            fill="white"
          />
          <path
            d="M291.414 646.82C290.319 646.82 289.428 647.716 289.428 648.819C289.428 649.922 290.323 650.805 291.414 650.805C292.504 650.805 293.413 649.918 293.413 648.819C293.413 647.72 292.517 646.82 291.414 646.82Z"
            fill="white"
          />
          <path
            d="M270.182 636.498C269.079 636.498 268.184 637.394 268.184 638.497C268.184 639.6 269.079 640.483 270.182 640.483C271.286 640.483 272.168 639.588 272.168 638.497C272.168 637.406 271.273 636.498 270.182 636.498Z"
            fill="white"
          />
          <path
            d="M247.703 624.998C246.591 624.998 245.695 625.893 245.695 626.997C245.695 628.1 246.591 629.004 247.703 629.004C248.814 629.004 249.701 628.1 249.701 626.997C249.701 625.893 248.806 624.998 247.703 624.998Z"
            fill="white"
          />
          <path
            d="M223.536 612.547C222.433 612.547 221.537 613.442 221.537 614.554C221.537 615.666 222.433 616.553 223.536 616.553C224.639 616.553 225.543 615.658 225.543 614.554C225.543 613.451 224.648 612.547 223.536 612.547Z"
            fill="white"
          />
          <path
            d="M197.224 599.977C196.121 599.977 195.226 600.872 195.226 601.975C195.226 603.079 196.121 603.974 197.224 603.974C198.328 603.974 199.223 603.079 199.223 601.975C199.223 600.872 198.328 599.977 197.224 599.977Z"
            fill="white"
          />
          <path
            d="M168.448 587.223C167.344 587.223 166.44 588.127 166.44 589.23C166.44 590.333 167.344 591.25 168.448 591.25C169.551 591.25 170.468 590.346 170.468 589.23C170.468 588.114 169.564 587.223 168.448 587.223Z"
            fill="white"
          />
          <path
            d="M152.355 579.691C153.499 579.691 154.426 578.764 154.426 577.62C154.426 576.476 153.499 575.549 152.355 575.549C151.211 575.549 150.284 576.476 150.284 577.62C150.284 578.764 151.211 579.691 152.355 579.691Z"
            fill="white"
          />
          <path
            d="M137.514 564.443C136.339 564.443 135.38 565.39 135.38 566.565C135.38 567.741 136.339 568.7 137.514 568.7C138.69 568.7 139.636 567.741 139.636 566.565C139.636 565.39 138.69 564.443 137.514 564.443Z"
            fill="white"
          />
          <path
            d="M125.199 554.41C123.99 554.41 123.014 555.39 123.014 556.596C123.014 557.801 123.994 558.781 125.199 558.781C126.404 558.781 127.385 557.801 127.385 556.596C127.385 555.39 126.404 554.41 125.199 554.41Z"
            fill="white"
          />
          <path
            d="M115.845 545.801C114.585 545.801 113.566 546.819 113.566 548.08C113.566 549.34 114.585 550.359 115.845 550.359C117.106 550.359 118.124 549.34 118.124 548.08C118.124 546.819 117.106 545.801 115.845 545.801Z"
            fill="white"
          />
          <path
            d="M109.267 538.777C107.977 538.777 106.925 539.83 106.925 541.12C106.925 542.41 107.977 543.462 109.267 543.462C110.557 543.462 111.61 542.423 111.61 541.12C111.61 539.817 110.557 538.777 109.267 538.777Z"
            fill="white"
          />
          <path
            d="M104.999 533.125C103.666 533.125 102.584 534.207 102.584 535.54C102.584 536.872 103.666 537.954 104.999 537.954C106.331 537.954 107.413 536.872 107.413 535.54C107.413 534.207 106.331 533.125 104.999 533.125Z"
            fill="white"
          />
          <path
            d="M102.461 528.559C101.098 528.559 99.9951 529.662 99.9951 531.024C99.9951 532.386 101.098 533.503 102.461 533.503C103.823 533.503 104.939 532.399 104.939 531.024C104.939 529.649 103.836 528.559 102.461 528.559Z"
            fill="white"
          />
          <path
            d="M101.23 524.791C99.8125 524.791 98.6709 525.937 98.6709 527.35C98.6709 528.763 99.8167 529.922 101.23 529.922C102.643 529.922 103.789 528.776 103.789 527.35C103.789 525.924 102.643 524.791 101.23 524.791Z"
            fill="white"
          />
          <path
            d="M100.928 521.688C99.4812 521.688 98.3057 522.863 98.3057 524.31C98.3057 525.757 99.4812 526.933 100.928 526.933C102.375 526.933 103.551 525.757 103.551 524.31C103.551 522.863 102.384 521.688 100.928 521.688Z"
            fill="white"
          />
          <path
            d="M101.159 518.959C99.6691 518.959 98.4639 520.164 98.4639 521.654C98.4639 523.143 99.6733 524.349 101.159 524.349C102.644 524.349 103.853 523.139 103.853 521.654C103.853 520.168 102.648 518.959 101.159 518.959Z"
            fill="white"
          />
          <path
            d="M101.617 516.471C100.098 516.471 98.8711 517.697 98.8711 519.229C98.8711 520.761 100.098 521.975 101.617 521.975C103.136 521.975 104.375 520.748 104.375 519.229C104.375 517.71 103.136 516.471 101.617 516.471Z"
            fill="white"
          />
          <path
            d="M102.139 514.078C100.569 514.078 99.2959 515.347 99.2959 516.921C99.2959 518.496 100.565 519.773 102.139 519.773C103.714 519.773 104.991 518.492 104.991 516.921C104.991 515.351 103.709 514.078 102.139 514.078Z"
            fill="white"
          />
          <path
            d="M102.584 511.758C100.972 511.758 99.6816 513.061 99.6816 514.661C99.6816 516.26 100.972 517.563 102.584 517.563C104.197 517.563 105.479 516.26 105.479 514.661C105.479 513.061 104.189 511.758 102.584 511.758Z"
            fill="white"
          />
          <path
            d="M102.77 509.395C101.137 509.395 99.8125 510.719 99.8125 512.352C99.8125 513.986 101.137 515.319 102.77 515.319C104.404 515.319 105.737 513.986 105.737 512.352C105.737 510.719 104.404 509.395 102.77 509.395Z"
            fill="white"
          />
          <path
            d="M102.656 506.941C100.993 506.941 99.6475 508.282 99.6475 509.95C99.6475 511.618 100.988 512.959 102.656 512.959C104.324 512.959 105.665 511.605 105.665 509.95C105.665 508.295 104.311 506.941 102.656 506.941Z"
            fill="white"
          />
          <path
            d="M102.176 504.318C100.47 504.318 99.0742 505.702 99.0742 507.421C99.0742 509.139 100.47 510.523 102.176 510.523C103.882 510.523 105.279 509.139 105.279 507.421C105.279 505.702 103.895 504.318 102.176 504.318Z"
            fill="white"
          />
          <path
            d="M101.323 501.598C99.5873 501.598 98.1699 503.015 98.1699 504.751C98.1699 506.486 99.5873 507.917 101.323 507.917C103.059 507.917 104.489 506.499 104.489 504.751C104.489 503.002 103.071 501.598 101.323 501.598Z"
            fill="white"
          />
          <path
            d="M100.097 498.758C98.327 498.758 96.8926 500.192 96.8926 501.962C96.8926 503.731 98.327 505.179 100.097 505.179C101.866 505.179 103.313 503.744 103.313 501.962C103.313 500.179 101.875 498.758 100.097 498.758Z"
            fill="white"
          />
          <path
            d="M98.5141 495.801C96.7147 495.801 95.2549 497.256 95.2549 499.06C95.2549 500.864 96.7105 502.328 98.5141 502.328C100.318 502.328 101.782 500.872 101.782 499.06C101.782 497.248 100.326 495.801 98.5141 495.801Z"
            fill="white"
          />
          <path
            d="M96.5996 492.732C94.7578 492.732 93.2598 494.23 93.2598 496.072C93.2598 497.914 94.7578 499.404 96.5996 499.404C98.4414 499.404 99.9309 497.914 99.9309 496.072C99.9309 494.23 98.4414 492.732 96.5996 492.732Z"
            fill="white"
          />
          <path
            d="M94.3295 489.609C92.4665 489.609 90.9473 491.129 90.9473 492.992C90.9473 494.855 92.4665 496.374 94.3295 496.374C96.1925 496.374 97.7118 494.863 97.7118 492.992C97.7118 491.12 96.201 489.609 94.3295 489.609Z"
            fill="white"
          />
          <path
            d="M91.7294 486.426C89.8367 486.426 88.3047 487.966 88.3047 489.851C88.3047 491.735 89.8367 493.284 91.7294 493.284C93.6221 493.284 95.1541 491.743 95.1541 489.851C95.1541 487.958 93.6221 486.426 91.7294 486.426Z"
            fill="white"
          />
          <path
            d="M88.7754 483.176C86.8615 483.176 85.2998 484.737 85.2998 486.651C85.2998 488.565 86.8615 490.127 88.7754 490.127C90.6894 490.127 92.2511 488.565 92.2511 486.651C92.2511 484.737 90.6894 483.176 88.7754 483.176Z"
            fill="white"
          />
          <path
            d="M85.4514 479.871C83.5035 479.871 81.9248 481.454 81.9248 483.41C81.9248 485.367 83.5077 486.937 85.4514 486.937C87.395 486.937 88.9779 485.354 88.9779 483.41C88.9779 481.467 87.395 479.871 85.4514 479.871Z"
            fill="white"
          />
          <path
            d="M81.7604 476.539C79.7828 476.539 78.1787 478.143 78.1787 480.121C78.1787 482.098 79.7828 483.703 81.7604 483.703C83.738 483.703 85.3422 482.098 85.3422 480.121C85.3422 478.143 83.738 476.539 81.7604 476.539Z"
            fill="white"
          />
          <path
            d="M77.6775 473.156C75.6787 473.156 74.0576 474.782 74.0576 476.776C74.0576 478.771 75.683 480.409 77.6775 480.409C79.6721 480.409 81.2975 478.783 81.2975 476.776C81.2975 474.769 79.6721 473.156 77.6775 473.156Z"
            fill="white"
          />
          <path
            d="M73.2131 469.754C71.1931 469.754 69.5508 471.4 69.5508 473.416C69.5508 475.432 71.1974 477.07 73.2131 477.07C75.2289 477.07 76.867 475.436 76.867 473.416C76.867 471.396 75.2332 469.754 73.2131 469.754Z"
            fill="white"
          />
          <path
            d="M68.3539 466.287C66.2914 466.287 64.6406 467.951 64.6406 470.005C64.6406 472.059 66.2957 473.718 68.3539 473.718C70.4121 473.718 72.0587 472.054 72.0587 470.005C72.0587 467.955 70.4036 466.287 68.3539 466.287Z"
            fill="white"
          />
          <path
            d="M63.0959 462.832C61.0249 462.832 59.3486 464.508 59.3486 466.579C59.3486 468.65 61.0249 470.314 63.0959 470.314C65.1668 470.314 66.8304 468.637 66.8304 466.579C66.8304 464.521 65.1541 462.832 63.0959 462.832Z"
            fill="white"
          />
          <path
            d="M57.4472 459.363C55.3635 459.363 53.6787 461.048 53.6787 463.132C53.6787 465.215 55.3635 466.909 57.4472 466.909C59.5308 466.909 61.2241 465.211 61.2241 463.132C61.2241 461.052 59.5266 459.363 57.4472 459.363Z"
            fill="white"
          />
          <path
            d="M51.417 455.896C49.3036 455.896 47.5977 457.602 47.5977 459.716C47.5977 461.829 49.3036 463.527 51.417 463.527C53.5304 463.527 55.2279 461.821 55.2279 459.716C55.2279 457.611 53.5219 455.896 51.417 455.896Z"
            fill="white"
          />
          <path
            d="M45.0095 452.484C42.8877 452.484 41.1689 454.212 41.1689 456.333C41.1689 458.455 42.8877 460.174 45.0095 460.174C47.1314 460.174 48.8586 458.455 48.8586 456.333C48.8586 454.212 47.1314 452.484 45.0095 452.484Z"
            fill="white"
          />
          <path
            d="M38.2443 449.104C36.1097 449.104 34.374 450.843 34.374 452.974C34.374 455.104 36.1097 456.844 38.2443 456.844C40.3789 456.844 42.1146 455.117 42.1146 452.974C42.1146 450.831 40.3874 449.104 38.2443 449.104Z"
            fill="white"
          />
          <path
            d="M31.124 453.445C33.2802 453.445 35.0282 451.697 35.0282 449.541C35.0282 447.385 33.2802 445.637 31.124 445.637C28.9677 445.637 27.2197 447.385 27.2197 449.541C27.2197 451.697 28.9677 453.445 31.124 453.445Z"
            fill="white"
          />
          <path
            d="M23.6078 441.922C21.4435 441.922 19.6738 443.683 19.6738 445.847C19.6738 448.012 21.4435 449.781 23.6078 449.781C25.7721 449.781 27.5417 448.024 27.5417 445.847C27.5417 443.67 25.7806 441.922 23.6078 441.922Z"
            fill="white"
          />
          <path
            d="M15.7312 437.896C13.5457 437.896 11.7676 439.666 11.7676 441.852C11.7676 444.037 13.5457 445.815 15.7312 445.815C17.9168 445.815 19.6949 444.046 19.6949 441.852C19.6949 439.658 17.9168 437.896 15.7312 437.896Z"
            fill="white"
          />
          <path
            d="M7.54055 433.541C5.34653 433.541 3.55566 435.332 3.55566 437.539C3.55566 439.745 5.34653 441.524 7.54055 441.524C9.73456 441.524 11.5382 439.733 11.5382 437.539C11.5382 435.345 9.7473 433.541 7.54055 433.541Z"
            fill="white"
          />
          <path
            d="M-0.90015 428.891C-3.11539 428.891 -4.90625 430.681 -4.90625 432.897C-4.90625 435.112 -3.11539 436.903 -0.90015 436.903C1.31509 436.903 3.10595 435.103 3.10595 432.897C3.10595 430.69 1.3066 428.891 -0.90015 428.891Z"
            fill="white"
          />
          <path
            d="M-1.19287 164.48C-3.14075 164.48 -4.71094 166.051 -4.71094 167.999C-4.71094 169.946 -3.14075 171.529 -1.19287 171.529C0.755013 171.529 2.33793 169.946 2.33793 167.999C2.33793 166.051 0.767744 164.48 -1.19287 164.48Z"
            fill="white"
          />
          <path
            d="M6.43755 152.844C4.51088 152.844 2.96191 154.401 2.96191 156.319C2.96191 158.238 4.51513 159.808 6.43755 159.808C8.35996 159.808 9.92591 158.246 9.92591 156.319C9.92591 154.393 8.36421 152.844 6.43755 152.844Z"
            fill="white"
          />
          <path
            d="M14.233 141.436C12.3403 141.436 10.7998 142.972 10.7998 144.864C10.7998 146.757 12.3403 148.293 14.233 148.293C16.1257 148.293 17.6662 146.761 17.6662 144.864C17.6662 142.968 16.1257 141.436 14.233 141.436Z"
            fill="white"
          />
          <path
            d="M22.1007 130.193C20.2292 130.193 18.71 131.713 18.71 133.584C18.71 135.456 20.2292 136.975 22.1007 136.975C23.9722 136.975 25.4957 135.456 25.4957 133.584C25.4957 131.713 23.9765 130.193 22.1007 130.193Z"
            fill="white"
          />
          <path
            d="M29.8635 119.193C28.0302 119.193 26.5449 120.683 26.5449 122.512C26.5449 124.341 28.0345 125.831 29.8635 125.831C31.6926 125.831 33.1821 124.341 33.1821 122.512C33.1821 120.683 31.6926 119.193 29.8635 119.193Z"
            fill="white"
          />
          <path
            d="M37.3367 108.355C35.5246 108.355 34.0605 109.82 34.0605 111.627C34.0605 113.435 35.5289 114.908 37.3367 114.908C39.1446 114.908 40.6171 113.439 40.6171 111.627C40.6171 109.815 39.1488 108.355 37.3367 108.355Z"
            fill="white"
          />
          <path
            d="M44.3642 97.6895C42.5946 97.6895 41.1475 99.1238 41.1475 100.906C41.1475 102.689 42.5946 104.123 44.3642 104.123C46.1339 104.123 47.581 102.689 47.581 100.906C47.581 99.1238 46.1466 97.6895 44.3642 97.6895Z"
            fill="white"
          />
          <path
            d="M50.7928 87.3613C49.0444 87.3613 47.627 88.783 47.627 90.5314C47.627 92.2798 49.0444 93.6972 50.7928 93.6972C52.5412 93.6972 53.9671 92.2798 53.9671 90.5314C53.9671 88.783 52.5412 87.3613 50.7928 87.3613Z"
            fill="white"
          />
          <path
            d="M56.5185 77.7578C54.821 77.7578 53.4375 79.1328 53.4375 80.8303C53.4375 82.5278 54.821 83.9112 56.5185 83.9112C58.216 83.9112 59.5994 82.5278 59.5994 80.8303C59.5994 79.1328 58.216 77.7578 56.5185 77.7578Z"
            fill="white"
          />
          <path
            d="M61.4538 69.0723C59.7903 69.0723 58.4365 70.426 58.4365 72.1023C58.4365 73.7786 59.7903 75.1323 61.4538 75.1323C63.1174 75.1323 64.4839 73.7743 64.4839 72.1023C64.4839 70.4303 63.1301 69.0723 61.4538 69.0723Z"
            fill="white"
          />
          <path
            d="M65.6763 61.334C64.0425 61.334 62.71 62.6623 62.71 64.3004C62.71 65.9385 64.0425 67.2667 65.6763 67.2667C67.3102 67.2667 68.6427 65.9342 68.6427 64.3004C68.6427 62.6665 67.3229 61.334 65.6763 61.334Z"
            fill="white"
          />
          <path
            d="M69.3422 54.373C67.7296 54.373 66.4268 55.6759 66.4268 57.2758C66.4268 58.8757 67.7296 60.1785 69.3422 60.1785C70.9548 60.1785 72.2449 58.8757 72.2449 57.2758C72.2449 55.6759 70.9421 54.373 69.3422 54.373Z"
            fill="white"
          />
          <path
            d="M72.5681 47.9844C71.0192 47.9844 69.7588 49.249 69.7588 50.8065C69.7588 52.3639 71.0192 53.6158 72.5681 53.6158C74.1171 53.6158 75.3902 52.3554 75.3902 50.8065C75.3902 49.2575 74.1214 47.9844 72.5681 47.9844Z"
            fill="white"
          />
          <path
            d="M75.5133 41.8926C73.9941 41.8926 72.7549 43.119 72.7549 44.6383C72.7549 46.1575 73.9941 47.3967 75.5133 47.3967C77.0326 47.3967 78.2718 46.1618 78.2718 44.6383C78.2718 43.1148 77.0326 41.8926 75.5133 41.8926Z"
            fill="white"
          />
          <path
            d="M78.2927 35.8984C76.8159 35.8984 75.6064 37.1037 75.6064 38.5847C75.6064 40.0658 76.8117 41.2795 78.2927 41.2795C79.7738 41.2795 80.9875 40.0743 80.9875 38.5847C80.9875 37.0952 79.7823 35.8984 78.2927 35.8984Z"
            fill="white"
          />
          <path
            d="M81.0725 29.6973C79.6169 29.6973 78.4414 30.8728 78.4414 32.3326C78.4414 33.7925 79.6169 34.9595 81.0725 34.9595C82.5281 34.9595 83.6952 33.784 83.6952 32.3326C83.6952 30.8813 82.5196 29.6973 81.0725 29.6973Z"
            fill="white"
          />
          <path
            d="M83.9538 23.0996C82.5491 23.0996 81.416 24.2327 81.416 25.6374C81.416 27.0421 82.5491 28.1709 83.9538 28.1709C85.3585 28.1709 86.483 27.0293 86.483 25.6374C86.483 24.2454 85.35 23.0996 83.9538 23.0996Z"
            fill="white"
          />
          <path
            d="M87.1922 15.5332C85.8172 15.5332 84.7139 16.6366 84.7139 18.0073C84.7139 19.378 85.8172 20.4857 87.1922 20.4857C88.5672 20.4857 89.6578 19.378 89.6578 18.0073C89.6578 16.6366 88.5545 15.5332 87.1922 15.5332Z"
            fill="white"
          />
          <path
            d="M91.2193 6.31641C89.8868 6.31641 88.8174 7.39432 88.8174 8.72261C88.8174 10.0509 89.8911 11.1161 91.2193 11.1161C92.5476 11.1161 93.6128 10.0424 93.6128 8.72261C93.6128 7.40281 92.5392 6.31641 91.2193 6.31641Z"
            fill="white"
          />
          <path
            d="M987.16 5.9043C985.662 5.9043 984.432 7.12225 984.432 8.63303C984.432 10.1438 985.658 11.349 987.16 11.349C988.663 11.349 989.889 10.1311 989.889 8.63303C989.889 7.13498 988.671 5.9043 987.16 5.9043Z"
            fill="white"
          />
          <path
            d="M994.591 17.0801C993.05 17.0801 991.803 18.3277 991.803 19.8597C991.803 21.3917 993.05 22.6479 994.591 22.6479C996.131 22.6479 997.37 21.4002 997.37 19.8597C997.37 18.3193 996.123 17.0801 994.591 17.0801Z"
            fill="white"
          />
          <path
            d="M1002.16 27.9785C1000.57 27.9785 999.289 29.2686 999.289 30.8515C999.289 32.4345 1000.57 33.7246 1002.16 33.7246C1003.75 33.7246 1005.04 32.4345 1005.04 30.8515C1005.04 29.2686 1003.75 27.9785 1002.16 27.9785Z"
            fill="white"
          />
          <path
            d="M1009.83 38.707C1008.2 38.707 1006.89 40.0183 1006.89 41.6437C1006.89 43.2691 1008.2 44.5719 1009.83 44.5719C1011.46 44.5719 1012.75 43.2563 1012.75 41.6437C1012.75 40.0311 1011.44 38.707 1009.83 38.707Z"
            fill="white"
          />
          <path
            d="M1017.58 49.2734C1015.94 49.2734 1014.61 50.606 1014.61 52.2568C1014.61 53.9076 1015.94 55.2401 1017.58 55.2401C1019.23 55.2401 1020.57 53.9076 1020.57 52.2568C1020.57 50.606 1019.23 49.2734 1017.58 49.2734Z"
            fill="white"
          />
          <path
            d="M1025.42 65.7704C1027.1 65.7704 1028.46 64.41 1028.46 62.7319C1028.46 61.0538 1027.1 59.6934 1025.42 59.6934C1023.74 59.6934 1022.38 61.0538 1022.38 62.7319C1022.38 64.41 1023.74 65.7704 1025.42 65.7704Z"
            fill="white"
          />
          <path
            d="M1033.31 69.9629C1031.58 69.9629 1030.19 71.3591 1030.19 73.0863C1030.19 74.8135 1031.58 76.2097 1033.31 76.2097C1035.04 76.2097 1036.43 74.8093 1036.43 73.0863C1036.43 71.3633 1035.04 69.9629 1033.31 69.9629Z"
            fill="white"
          />
          <path
            d="M1041.25 80.1641C1039.49 80.1641 1038.08 81.5815 1038.08 83.3341C1038.08 85.0868 1039.49 86.5042 1041.25 86.5042C1043.01 86.5042 1044.41 85.0868 1044.41 83.3341C1044.41 81.5815 1042.99 80.1641 1041.25 80.1641Z"
            fill="white"
          />
          <path
            d="M1049.2 90.2832C1047.43 90.2832 1045.98 91.7303 1045.98 93.5084C1045.98 95.2866 1047.43 96.7464 1049.2 96.7464C1050.98 96.7464 1052.44 95.2993 1052.44 93.5084C1052.44 91.7176 1050.99 90.2832 1049.2 90.2832Z"
            fill="white"
          />
          <path
            d="M1057.12 100.416C1055.3 100.416 1053.83 101.893 1053.83 103.709C1053.83 105.525 1055.3 107.002 1057.12 107.002C1058.94 107.002 1060.41 105.525 1060.41 103.709C1060.41 101.893 1058.94 100.416 1057.12 100.416Z"
            fill="white"
          />
          <path
            d="M1065 110.578C1063.15 110.578 1061.64 112.08 1061.64 113.939C1061.64 115.798 1063.15 117.304 1065 117.304C1066.85 117.304 1068.38 115.794 1068.38 113.939C1068.38 112.085 1066.87 110.578 1065 110.578Z"
            fill="white"
          />
          <path
            d="M1072.83 120.836C1070.96 120.836 1069.42 122.368 1069.42 124.252C1069.42 126.136 1070.96 127.66 1072.83 127.66C1074.7 127.66 1076.24 126.136 1076.24 124.252C1076.24 122.368 1074.71 120.836 1072.83 120.836Z"
            fill="white"
          />
          <path
            d="M1080.57 131.232C1078.67 131.232 1077.12 132.781 1077.12 134.687C1077.12 136.592 1078.67 138.141 1080.57 138.141C1082.48 138.141 1084.03 136.592 1084.03 134.687C1084.03 132.781 1082.48 131.232 1080.57 131.232Z"
            fill="white"
          />
          <path
            d="M1088.2 141.82C1086.26 141.82 1084.7 143.382 1084.7 145.317C1084.7 147.252 1086.26 148.827 1088.2 148.827C1090.14 148.827 1091.71 147.257 1091.71 145.317C1091.71 143.378 1090.14 141.82 1088.2 141.82Z"
            fill="white"
          />
          <path
            d="M1095.71 152.613C1093.73 152.613 1092.12 154.209 1092.12 156.182C1092.12 158.156 1093.73 159.764 1095.71 159.764C1097.68 159.764 1099.28 158.16 1099.28 156.182C1099.28 154.205 1097.67 152.613 1095.71 152.613Z"
            fill="white"
          />
          <path
            d="M1103.05 163.723C1101.05 163.723 1099.43 165.34 1099.43 167.343C1099.43 169.346 1101.05 170.958 1103.05 170.958C1105.05 170.958 1106.67 169.346 1106.67 167.343C1106.67 165.34 1105.05 163.723 1103.05 163.723Z"
            fill="white"
          />
          <path
            d="M1110.29 175.092C1108.27 175.092 1106.62 176.73 1106.62 178.754C1106.62 180.778 1108.27 182.417 1110.29 182.417C1112.3 182.417 1113.95 180.77 1113.95 178.754C1113.95 176.738 1112.3 175.092 1110.29 175.092Z"
            fill="white"
          />
          <path
            d="M1117.46 186.635C1115.42 186.635 1113.75 188.298 1113.75 190.34C1113.75 192.381 1115.42 194.044 1117.46 194.044C1119.5 194.044 1121.16 192.389 1121.16 190.34C1121.16 188.29 1119.51 186.635 1117.46 186.635Z"
            fill="white"
          />
          <path
            d="M1124.65 198.23C1122.57 198.23 1120.89 199.907 1120.89 201.986C1120.89 204.066 1122.57 205.733 1124.65 205.733C1126.73 205.733 1128.4 204.057 1128.4 201.986C1128.4 199.915 1126.72 198.23 1124.65 198.23Z"
            fill="white"
          />
          <path
            d="M1131.96 209.637C1129.86 209.637 1128.16 211.343 1128.16 213.435C1128.16 215.527 1129.86 217.246 1131.96 217.246C1134.05 217.246 1135.77 215.54 1135.77 213.435C1135.77 211.33 1134.06 209.637 1131.96 209.637Z"
            fill="white"
          />
          <path
            d="M1139.52 220.641C1137.41 220.641 1135.69 222.359 1135.69 224.481C1135.69 226.603 1137.41 228.309 1139.52 228.309C1141.64 228.309 1143.36 226.59 1143.36 224.481C1143.36 222.372 1141.65 220.641 1139.52 220.641Z"
            fill="white"
          />
          <path
            d="M1147.33 231.182C1145.19 231.182 1143.46 232.917 1143.46 235.052C1143.46 237.187 1145.2 238.935 1147.33 238.935C1149.46 238.935 1151.21 237.199 1151.21 235.052C1151.21 232.905 1149.47 231.182 1147.33 231.182Z"
            fill="white"
          />
          <path
            d="M1155.45 241.07C1153.28 241.07 1151.52 242.827 1151.52 244.996C1151.52 247.164 1153.28 248.921 1155.45 248.921C1157.61 248.921 1159.37 247.16 1159.37 244.996C1159.37 242.831 1157.61 241.07 1155.45 241.07Z"
            fill="white"
          />
          <path
            d="M1164.79 258.087C1166.91 257.585 1168.23 255.455 1167.73 253.329C1167.22 251.203 1165.09 249.887 1162.97 250.388C1160.84 250.89 1159.53 253.02 1160.03 255.146C1160.53 257.272 1162.66 258.589 1164.79 258.087Z"
            fill="white"
          />
          <path
            d="M1172.64 258.568C1170.45 258.568 1168.66 260.346 1168.66 262.553C1168.66 264.76 1170.45 266.538 1172.64 266.538C1174.84 266.538 1176.63 264.747 1176.63 262.553C1176.63 260.359 1174.84 258.568 1172.64 258.568Z"
            fill="white"
          />
          <path
            d="M1181.72 266.09C1179.5 266.09 1177.71 267.889 1177.71 270.109C1177.71 272.328 1179.5 274.115 1181.72 274.115C1183.93 274.115 1185.73 272.324 1185.73 270.109C1185.73 267.893 1183.94 266.09 1181.72 266.09Z"
            fill="white"
          />
          <path
            d="M1191.11 272.834C1188.87 272.834 1187.06 274.646 1187.06 276.874C1187.06 279.102 1188.87 280.923 1191.11 280.923C1193.34 280.923 1195.15 279.11 1195.15 276.874C1195.15 274.638 1193.34 272.834 1191.11 272.834Z"
            fill="white"
          />
          <path
            d="M1200.75 278.861C1198.49 278.861 1196.67 280.695 1196.67 282.94C1196.67 285.185 1198.49 287.018 1200.75 287.018C1203.01 287.018 1204.82 285.185 1204.82 282.94C1204.82 280.695 1203 278.861 1200.75 278.861Z"
            fill="white"
          />
          <path
            d="M1210.62 284.24C1208.35 284.24 1206.52 286.082 1206.52 288.352C1206.52 290.623 1208.35 292.452 1210.62 292.452C1212.89 292.452 1214.73 290.619 1214.73 288.352C1214.73 286.086 1212.89 284.24 1210.62 284.24Z"
            fill="white"
          />
          <path
            d="M1220.69 289.02C1218.41 289.02 1216.57 290.861 1216.57 293.14C1216.57 295.419 1218.41 297.252 1220.69 297.252C1222.97 297.252 1224.81 295.411 1224.81 293.14C1224.81 290.87 1222.97 289.02 1220.69 289.02Z"
            fill="white"
          />
          <path
            d="M1230.95 293.162C1228.66 293.162 1226.8 295.017 1226.8 297.304C1226.8 299.591 1228.66 301.459 1230.95 301.459C1233.23 301.459 1235.09 299.604 1235.09 297.304C1235.09 295.004 1233.23 293.162 1230.95 293.162Z"
            fill="white"
          />
          <path
            d="M1241.35 296.66C1239.06 296.66 1237.2 298.51 1237.2 300.815C1237.2 303.119 1239.06 304.969 1241.35 304.969C1243.64 304.969 1245.51 303.106 1245.51 300.815C1245.51 298.523 1243.65 296.66 1241.35 296.66Z"
            fill="white"
          />
          <path
            d="M1251.89 299.459C1249.59 299.459 1247.73 301.322 1247.73 303.614C1247.73 305.905 1249.59 307.768 1251.89 307.768C1254.18 307.768 1256.04 305.914 1256.04 303.614C1256.04 301.313 1254.19 299.459 1251.89 299.459Z"
            fill="white"
          />
          <path
            d="M1262.48 301.59C1260.19 301.59 1258.33 303.453 1258.33 305.744C1258.33 308.036 1260.19 309.895 1262.48 309.895C1264.77 309.895 1266.64 308.032 1266.64 305.744C1266.64 303.457 1264.79 301.59 1262.48 301.59Z"
            fill="white"
          />
          <path
            d="M1273.08 303.08C1270.78 303.08 1268.92 304.93 1268.92 307.23C1268.92 309.531 1270.78 311.385 1273.08 311.385C1275.38 311.385 1277.23 309.522 1277.23 307.23C1277.23 304.939 1275.37 303.08 1273.08 303.08Z"
            fill="white"
          />
          <path
            d="M1283.61 303.926C1281.32 303.926 1279.46 305.776 1279.46 308.08C1279.46 310.385 1281.32 312.231 1283.61 312.231C1285.9 312.231 1287.77 310.368 1287.77 308.08C1287.77 305.793 1285.9 303.926 1283.61 303.926Z"
            fill="white"
          />
          <path
            d="M1294.04 304.09C1291.75 304.09 1289.88 305.953 1289.88 308.244C1289.88 310.536 1291.75 312.399 1294.04 312.399C1296.33 312.399 1298.19 310.545 1298.19 308.244C1298.19 305.944 1296.34 304.09 1294.04 304.09Z"
            fill="white"
          />
          <path
            d="M1304.31 303.66C1302.01 303.66 1300.15 305.515 1300.15 307.815C1300.15 310.115 1302.01 311.969 1304.31 311.969C1306.61 311.969 1308.47 310.106 1308.47 307.815C1308.47 305.523 1306.6 303.66 1304.31 303.66Z"
            fill="white"
          />
          <path
            d="M1314.33 302.693C1312.04 302.693 1310.18 304.556 1310.18 306.848C1310.18 309.14 1312.04 311.003 1314.33 311.003C1316.62 311.003 1318.49 309.148 1318.49 306.848C1318.49 304.548 1316.63 302.693 1314.33 302.693Z"
            fill="white"
          />
          <path
            d="M1310.75 304.6C1308.46 304.6 1306.6 306.454 1306.6 308.754C1306.6 311.054 1308.46 312.909 1310.75 312.909C1313.05 312.909 1314.91 311.046 1314.91 308.754C1314.91 306.463 1313.05 304.6 1310.75 304.6Z"
            fill="white"
          />
          <path
            d="M1306.89 306.318C1304.6 306.318 1302.74 308.169 1302.74 310.473C1302.74 312.777 1304.6 314.628 1306.89 314.628C1309.18 314.628 1311.05 312.765 1311.05 310.473C1311.05 308.181 1309.18 306.318 1306.89 306.318Z"
            fill="white"
          />
          <path
            d="M1302.69 307.887C1300.39 307.887 1298.53 309.741 1298.53 312.041C1298.53 314.341 1300.39 316.196 1302.69 316.196C1304.99 316.196 1306.84 314.333 1306.84 312.041C1306.84 309.75 1304.98 307.887 1302.69 307.887Z"
            fill="white"
          />
          <path
            d="M1298.07 309.324C1295.77 309.324 1293.91 311.187 1293.91 313.479C1293.91 315.77 1295.77 317.633 1298.07 317.633C1300.36 317.633 1302.22 315.783 1302.22 313.479C1302.22 311.174 1300.37 309.324 1298.07 309.324Z"
            fill="white"
          />
          <path
            d="M1293 310.637C1290.71 310.637 1288.84 312.5 1288.84 314.791C1288.84 317.083 1290.71 318.946 1293 318.946C1295.29 318.946 1297.15 317.083 1297.15 314.791C1297.15 312.5 1295.29 310.637 1293 310.637Z"
            fill="white"
          />
          <path
            d="M1287.45 311.799C1285.15 311.799 1283.3 313.662 1283.3 315.953C1283.3 318.245 1285.15 320.108 1287.45 320.108C1289.76 320.108 1291.61 318.245 1291.61 315.953C1291.61 313.662 1289.74 311.799 1287.45 311.799Z"
            fill="white"
          />
          <path
            d="M1281.41 312.789C1279.11 312.789 1277.26 314.652 1277.26 316.944C1277.26 319.235 1279.11 321.098 1281.41 321.098C1283.72 321.098 1285.56 319.248 1285.56 316.944C1285.56 314.639 1283.7 312.789 1281.41 312.789Z"
            fill="white"
          />
          <path
            d="M1274.89 313.584C1272.58 313.584 1270.73 315.434 1270.73 317.739C1270.73 320.043 1272.58 321.889 1274.89 321.889C1277.19 321.889 1279.04 320.026 1279.04 317.739C1279.04 315.451 1277.18 313.584 1274.89 313.584Z"
            fill="white"
          />
          <path
            d="M1267.88 314.166C1265.59 314.166 1263.73 316.029 1263.73 318.321C1263.73 320.612 1265.59 322.475 1267.88 322.475C1270.17 322.475 1272.04 320.625 1272.04 318.321C1272.04 316.016 1270.17 314.166 1267.88 314.166Z"
            fill="white"
          />
          <path
            d="M1260.42 314.529C1258.13 314.529 1256.26 316.392 1256.26 318.692C1256.26 320.993 1258.13 322.847 1260.42 322.847C1262.71 322.847 1264.57 320.984 1264.57 318.692C1264.57 316.401 1262.72 314.529 1260.42 314.529Z"
            fill="white"
          />
          <path
            d="M1252.53 314.645C1250.23 314.645 1248.38 316.508 1248.38 318.799C1248.38 321.091 1250.23 322.954 1252.53 322.954C1254.83 322.954 1256.68 321.099 1256.68 318.799C1256.68 316.499 1254.82 314.645 1252.53 314.645Z"
            fill="white"
          />
          <path
            d="M1244.22 314.465C1241.93 314.465 1240.07 316.328 1240.07 318.619C1240.07 320.911 1241.93 322.783 1244.22 322.783C1246.52 322.783 1248.38 320.92 1248.38 318.619C1248.38 316.319 1246.52 314.465 1244.22 314.465Z"
            fill="white"
          />
          <path
            d="M1235.55 313.998C1233.26 313.998 1231.41 315.848 1231.41 318.14C1231.41 320.432 1233.27 322.282 1235.55 322.282C1237.84 322.282 1239.7 320.419 1239.7 318.14C1239.7 315.861 1237.85 313.998 1235.55 313.998Z"
            fill="white"
          />
          <path
            d="M1226.56 313.199C1224.28 313.199 1222.44 315.049 1222.44 317.32C1222.44 319.59 1224.28 321.453 1226.56 321.453C1228.84 321.453 1230.68 319.603 1230.68 317.32C1230.68 315.037 1228.84 313.199 1226.56 313.199Z"
            fill="white"
          />
          <path
            d="M1218.2 320.335C1220.41 319.814 1221.78 317.599 1221.26 315.388C1220.74 313.178 1218.53 311.809 1216.31 312.331C1214.1 312.852 1212.74 315.067 1213.26 317.278C1213.78 319.488 1215.99 320.857 1218.2 320.335Z"
            fill="white"
          />
          <path
            d="M1207.67 310.988C1205.42 310.988 1203.6 312.809 1203.6 315.058C1203.6 317.307 1205.42 319.115 1207.67 319.115C1209.92 319.115 1211.73 317.294 1211.73 315.058C1211.73 312.822 1209.91 310.988 1207.67 310.988Z"
            fill="white"
          />
          <path
            d="M1197.79 309.658C1195.57 309.658 1193.75 311.47 1193.75 313.698C1193.75 315.926 1195.57 317.738 1197.79 317.738C1200.02 317.738 1201.83 315.939 1201.83 313.698C1201.83 311.458 1200.02 309.658 1197.79 309.658Z"
            fill="white"
          />
          <path
            d="M1187.65 308.232C1185.43 308.232 1183.63 310.032 1183.63 312.26C1183.63 314.488 1185.43 316.279 1187.65 316.279C1189.87 316.279 1191.67 314.479 1191.67 312.26C1191.67 310.04 1189.87 308.232 1187.65 308.232Z"
            fill="white"
          />
          <path
            d="M1177.26 306.812C1175.06 306.812 1173.27 308.591 1173.27 310.797C1173.27 313.004 1175.06 314.795 1177.26 314.795C1179.47 314.795 1181.25 313.004 1181.25 310.797C1181.25 308.591 1179.46 306.812 1177.26 306.812Z"
            fill="white"
          />
          <path
            d="M1166.61 305.453C1164.43 305.453 1162.67 307.223 1162.67 309.396C1162.67 311.568 1164.43 313.338 1166.61 313.338C1168.8 313.338 1170.56 311.568 1170.56 309.396C1170.56 307.223 1168.79 305.453 1166.61 305.453Z"
            fill="white"
          />
          <path
            d="M1155.72 304.174C1153.55 304.174 1151.8 305.922 1151.8 308.087C1151.8 310.251 1153.55 311.999 1155.72 311.999C1157.88 311.999 1159.63 310.251 1159.63 308.087C1159.63 305.922 1157.88 304.174 1155.72 304.174Z"
            fill="white"
          />
          <path
            d="M1144.57 303.027C1142.43 303.027 1140.69 304.767 1140.69 306.91C1140.69 309.053 1142.43 310.793 1144.57 310.793C1146.71 310.793 1148.45 309.053 1148.45 306.91C1148.45 304.767 1146.71 303.027 1144.57 303.027Z"
            fill="white"
          />
          <path
            d="M1133.2 302.113C1131.07 302.113 1129.35 303.84 1129.35 305.962C1129.35 308.084 1131.07 309.803 1133.2 309.803C1135.32 309.803 1137.04 308.084 1137.04 305.962C1137.04 303.84 1135.32 302.113 1133.2 302.113Z"
            fill="white"
          />
          <path
            d="M1121.62 301.51C1119.53 301.51 1117.83 303.207 1117.83 305.308C1117.83 307.409 1119.53 309.098 1121.62 309.098C1123.72 309.098 1125.42 307.4 1125.42 305.308C1125.42 303.216 1123.72 301.51 1121.62 301.51Z"
            fill="white"
          />
          <path
            d="M1109.84 301.238C1107.76 301.238 1106.08 302.915 1106.08 304.994C1106.08 307.073 1107.76 308.75 1109.84 308.75C1111.92 308.75 1113.59 307.065 1113.59 304.994C1113.59 302.923 1111.91 301.238 1109.84 301.238Z"
            fill="white"
          />
          <path
            d="M1097.85 301.332C1095.8 301.332 1094.14 302.996 1094.14 305.05C1094.14 307.104 1095.8 308.767 1097.85 308.767C1099.9 308.767 1101.57 307.104 1101.57 305.05C1101.57 302.996 1099.91 301.332 1097.85 301.332Z"
            fill="white"
          />
          <path
            d="M1085.67 301.854C1083.64 301.854 1081.99 303.509 1081.99 305.537C1081.99 307.566 1083.64 309.221 1085.67 309.221C1087.7 309.221 1089.35 307.574 1089.35 305.537C1089.35 303.5 1087.71 301.854 1085.67 301.854Z"
            fill="white"
          />
          <path
            d="M1073.3 302.936C1071.3 302.936 1069.68 304.561 1069.68 306.555C1069.68 308.55 1071.3 310.175 1073.3 310.175C1075.3 310.175 1076.92 308.55 1076.92 306.555C1076.92 304.561 1075.31 302.936 1073.3 302.936Z"
            fill="white"
          />
          <path
            d="M1060.77 304.59C1058.8 304.59 1057.2 306.194 1057.2 308.159C1057.2 310.124 1058.8 311.741 1060.77 311.741C1062.73 311.741 1064.35 310.136 1064.35 308.159C1064.35 306.181 1062.75 304.59 1060.77 304.59Z"
            fill="white"
          />
          <path
            d="M1048.01 306.812C1046.06 306.812 1044.48 308.395 1044.48 310.331C1044.48 312.266 1046.06 313.857 1048.01 313.857C1049.95 313.857 1051.52 312.274 1051.52 310.331C1051.52 308.387 1049.95 306.812 1048.01 306.812Z"
            fill="white"
          />
          <path
            d="M1035.05 309.75C1033.13 309.75 1031.57 311.299 1031.57 313.226C1031.57 315.152 1033.13 316.693 1035.05 316.693C1036.96 316.693 1038.52 315.144 1038.52 313.226C1038.52 311.307 1036.96 309.75 1035.05 309.75Z"
            fill="white"
          />
          <path
            d="M1021.98 313.592C1020.09 313.592 1018.57 315.111 1018.57 316.995C1018.57 318.879 1020.09 320.399 1021.98 320.399C1023.86 320.399 1025.38 318.867 1025.38 316.995C1025.38 315.124 1023.85 313.592 1021.98 313.592Z"
            fill="white"
          />
          <path
            d="M1008.71 318.326C1006.85 318.326 1005.34 319.837 1005.34 321.687C1005.34 323.538 1006.86 325.048 1008.71 325.048C1010.56 325.048 1012.06 323.538 1012.06 321.687C1012.06 319.837 1010.56 318.326 1008.71 318.326Z"
            fill="white"
          />
          <path
            d="M995.32 324.219C993.487 324.219 992.002 325.696 992.002 327.529C992.002 329.362 993.491 330.847 995.32 330.847C997.15 330.847 998.631 329.358 998.631 327.529C998.631 325.7 997.154 324.219 995.32 324.219Z"
            fill="white"
          />
          <path
            d="M981.799 331.627C980.008 331.627 978.553 333.083 978.553 334.873C978.553 336.664 980.008 338.133 981.799 338.133C983.59 338.133 985.058 336.677 985.058 334.873C985.058 333.07 983.603 331.627 981.799 331.627Z"
            fill="white"
          />
          <path
            d="M968.427 341.09C966.666 341.09 965.24 342.516 965.24 344.273C965.24 346.03 966.666 347.447 968.427 347.447C970.188 347.447 971.602 346.021 971.602 344.273C971.602 342.524 970.184 341.09 968.427 341.09Z"
            fill="white"
          />
          <path
            d="M955.5 353.066C953.782 353.066 952.377 354.463 952.377 356.19C952.377 357.917 953.782 359.313 955.5 359.313C957.219 359.313 958.624 357.909 958.624 356.19C958.624 354.471 957.228 353.066 955.5 353.066Z"
            fill="white"
          />
          <path
            d="M943.5 368.143C941.803 368.143 940.44 369.505 940.44 371.202C940.44 372.9 941.803 374.262 943.5 374.262C945.198 374.262 946.56 372.887 946.56 371.202C946.56 369.518 945.185 368.143 943.5 368.143Z"
            fill="white"
          />
          <path
            d="M932.865 386.527C931.201 386.527 929.848 387.868 929.848 389.536C929.848 391.204 931.201 392.553 932.865 392.553C934.528 392.553 935.874 391.2 935.874 389.536C935.874 387.873 934.533 386.527 932.865 386.527Z"
            fill="white"
          />
          <path
            d="M924.234 408.625C922.621 408.625 921.31 409.936 921.31 411.549C921.31 413.162 922.621 414.486 924.234 414.486C925.846 414.486 927.17 413.174 927.17 411.549C927.17 409.924 925.859 408.625 924.234 408.625Z"
            fill="white"
          />
          <path
            d="M919.043 434.936C917.451 434.936 916.17 436.217 916.17 437.809C916.17 439.4 917.451 440.682 919.043 440.682C920.634 440.682 921.916 439.4 921.916 437.809C921.916 436.217 920.626 434.936 919.043 434.936Z"
            fill="white"
          />
          <path
            d="M918.521 465.404C916.972 465.404 915.712 466.665 915.712 468.214C915.712 469.763 916.972 471.023 918.521 471.023C920.07 471.023 921.331 469.763 921.331 468.214C921.331 466.665 920.07 465.404 918.521 465.404Z"
            fill="white"
          />
          <path
            d="M923.006 499.412C921.487 499.412 920.248 500.639 920.248 502.158C920.248 503.677 921.487 504.908 923.006 504.908C924.526 504.908 925.756 503.681 925.756 502.158C925.756 500.634 924.53 499.412 923.006 499.412Z"
            fill="white"
          />
          <path
            d="M931.592 536.457C930.124 536.457 928.927 537.654 928.927 539.122C928.927 540.59 930.124 541.787 931.592 541.787C933.06 541.787 934.257 540.599 934.257 539.122C934.257 537.645 933.06 536.457 931.592 536.457Z"
            fill="white"
          />
          <path
            d="M942.375 576.256C940.928 576.256 939.761 577.423 939.761 578.857C939.761 580.292 940.928 581.471 942.375 581.471C943.822 581.471 944.976 580.304 944.976 578.857C944.976 577.41 943.809 576.256 942.375 576.256Z"
            fill="white"
          />
          <path
            d="M953.367 618.938C951.962 618.938 950.816 620.071 950.816 621.475C950.816 622.88 951.962 624.026 953.367 624.026C954.772 624.026 955.905 622.88 955.905 621.475C955.905 620.071 954.772 618.938 953.367 618.938Z"
            fill="white"
          />
          <path
            d="M962.266 664.766C960.891 664.766 959.779 665.877 959.779 667.252C959.779 668.627 960.891 669.731 962.266 669.731C963.641 669.731 964.753 668.627 964.753 667.252C964.753 665.877 963.641 664.766 962.266 664.766Z"
            fill="white"
          />
          <path
            d="M339.435 673.508C338.374 673.508 337.521 674.361 337.521 675.413C337.521 676.466 338.374 677.327 339.435 677.327C340.496 677.327 341.341 676.474 341.341 675.413C341.341 674.352 340.488 673.508 339.435 673.508Z"
            fill="white"
          />
          <path
            d="M320.306 665.764C319.245 665.764 318.392 666.617 318.392 667.678C318.392 668.738 319.245 669.583 320.306 669.583C321.366 669.583 322.211 668.73 322.211 667.678C322.211 666.625 321.358 665.764 320.306 665.764Z"
            fill="white"
          />
          <path
            d="M300.542 657.312C299.49 657.312 298.637 658.165 298.637 659.218C298.637 660.27 299.49 661.132 300.542 661.132C301.595 661.132 302.456 660.279 302.456 659.218C302.456 658.157 301.603 657.312 300.542 657.312Z"
            fill="white"
          />
          <path
            d="M279.957 647.543C278.904 647.543 278.043 648.396 278.043 649.457C278.043 650.518 278.909 651.371 279.957 651.371C281.005 651.371 281.884 650.518 281.884 649.457C281.884 648.396 281.018 647.543 279.957 647.543Z"
            fill="white"
          />
          <path
            d="M258.423 636.693C257.362 636.693 256.509 637.546 256.509 638.607C256.509 639.668 257.362 640.513 258.423 640.513C259.484 640.513 260.337 639.66 260.337 638.607C260.337 637.555 259.471 636.693 258.423 636.693Z"
            fill="white"
          />
          <path
            d="M235.566 624.578C234.505 624.578 233.64 625.444 233.64 626.505C233.64 627.566 234.505 628.431 235.566 628.431C236.627 628.431 237.493 627.578 237.493 626.505C237.493 625.431 236.627 624.578 235.566 624.578Z"
            fill="white"
          />
          <path
            d="M210.974 611.986C209.913 611.986 209.047 612.852 209.047 613.913C209.047 614.974 209.913 615.827 210.974 615.827C212.034 615.827 212.9 614.974 212.9 613.913C212.9 612.852 212.034 611.986 210.974 611.986Z"
            fill="white"
          />
          <path
            d="M184.132 599.203C183.071 599.203 182.205 600.069 182.205 601.13C182.205 602.191 183.071 603.056 184.132 603.056C185.193 603.056 186.058 602.191 186.058 601.13C186.058 600.069 185.193 599.203 184.132 599.203Z"
            fill="white"
          />
          <path
            d="M154.706 586.578C153.632 586.578 152.771 587.452 152.771 588.513C152.771 589.574 153.636 590.448 154.706 590.448C155.775 590.448 156.632 589.583 156.632 588.513C156.632 587.444 155.767 586.578 154.706 586.578Z"
            fill="white"
          />
          <path
            d="M137.752 574.068C136.641 574.068 135.745 574.972 135.745 576.076C135.745 577.179 136.641 578.083 137.752 578.083C138.864 578.083 139.76 577.188 139.76 576.076C139.76 574.964 138.856 574.068 137.752 574.068Z"
            fill="white"
          />
          <path
            d="M122.101 561.996C120.955 561.996 120.03 562.921 120.03 564.067C120.03 565.213 120.955 566.138 122.101 566.138C123.247 566.138 124.172 565.213 124.172 564.067C124.172 562.921 123.247 561.996 122.101 561.996Z"
            fill="white"
          />
          <path
            d="M109.205 551.152C108.029 551.152 107.083 552.099 107.083 553.274C107.083 554.45 108.029 555.409 109.205 555.409C110.38 555.409 111.327 554.45 111.327 553.274C111.327 552.099 110.38 551.152 109.205 551.152Z"
            fill="white"
          />
          <path
            d="M99.5166 542.033C98.3071 542.033 97.3311 543.014 97.3311 544.219C97.3311 545.424 98.3114 546.413 99.5166 546.413C100.722 546.413 101.702 545.424 101.702 544.219C101.702 543.014 100.722 542.033 99.5166 542.033Z"
            fill="white"
          />
          <path
            d="M92.7467 534.623C91.4863 534.623 90.4551 535.654 90.4551 536.915C90.4551 538.175 91.4863 539.206 92.7467 539.206C94.0071 539.206 95.0341 538.188 95.0341 536.915C95.0341 535.642 94.0156 534.623 92.7467 534.623Z"
            fill="white"
          />
          <path
            d="M88.4389 528.783C87.1361 528.783 86.0879 529.844 86.0879 531.134C86.0879 532.424 87.1403 533.485 88.4389 533.485C89.7375 533.485 90.79 532.433 90.79 531.134C90.79 529.836 89.729 528.783 88.4389 528.783Z"
            fill="white"
          />
          <path
            d="M85.9733 524.146C84.6408 524.146 83.5586 525.229 83.5586 526.561C83.5586 527.894 84.6408 528.963 85.9733 528.963C87.3058 528.963 88.3753 527.889 88.3753 526.561C88.3753 525.233 87.2931 524.146 85.9733 524.146Z"
            fill="white"
          />
          <path
            d="M84.8065 520.363C83.4442 520.363 82.3281 521.467 82.3281 522.829C82.3281 524.191 83.44 525.307 84.8065 525.307C86.173 525.307 87.2848 524.195 87.2848 522.829C87.2848 521.462 86.173 520.363 84.8065 520.363Z"
            fill="white"
          />
          <path
            d="M84.5697 517.168C83.1523 517.168 82.0107 518.322 82.0107 519.74C82.0107 521.157 83.1566 522.311 84.5697 522.311C85.9829 522.311 87.1414 521.166 87.1414 519.74C87.1414 518.314 85.9956 517.168 84.5697 517.168Z"
            fill="white"
          />
          <path
            d="M84.9436 514.465C83.488 514.465 82.3125 515.653 82.3125 517.1C82.3125 518.547 83.488 519.744 84.9436 519.744C86.3992 519.744 87.5875 518.556 87.5875 517.1C87.5875 515.645 86.3992 514.465 84.9436 514.465Z"
            fill="white"
          />
          <path
            d="M85.6001 512.016C84.1105 512.016 82.9053 513.225 82.9053 514.71C82.9053 516.196 84.1147 517.397 85.6001 517.397C87.0854 517.397 88.2948 516.2 88.2948 514.71C88.2948 513.221 87.0896 512.016 85.6001 512.016Z"
            fill="white"
          />
          <path
            d="M86.3268 509.699C84.8075 509.699 83.5684 510.938 83.5684 512.458C83.5684 513.977 84.8075 515.203 86.3268 515.203C87.8461 515.203 89.0725 513.977 89.0725 512.458C89.0725 510.938 87.8461 509.699 86.3268 509.699Z"
            fill="white"
          />
          <path
            d="M87.0051 507.408C85.4349 507.408 84.1533 508.69 84.1533 510.26C84.1533 511.83 85.4349 513.103 87.0051 513.103C88.5753 513.103 89.8484 511.822 89.8484 510.26C89.8484 508.698 88.5796 507.408 87.0051 507.408Z"
            fill="white"
          />
          <path
            d="M87.515 505.15C85.9109 505.15 84.6123 506.453 84.6123 508.053C84.6123 509.653 85.9151 510.956 87.515 510.956C89.1149 510.956 90.4178 509.653 90.4178 508.053C90.4178 506.453 89.1149 505.15 87.515 505.15Z"
            fill="white"
          />
          <path
            d="M87.7437 502.828C86.1099 502.828 84.7773 504.152 84.7773 505.786C84.7773 507.42 86.1099 508.752 87.7437 508.752C89.3776 508.752 90.7016 507.42 90.7016 505.786C90.7016 504.152 89.3776 502.828 87.7437 502.828Z"
            fill="white"
          />
          <path
            d="M87.6374 500.4C85.9739 500.4 84.6201 501.754 84.6201 503.418C84.6201 505.081 85.9739 506.435 87.6374 506.435C89.301 506.435 90.6547 505.081 90.6547 503.418C90.6547 501.754 89.3137 500.4 87.6374 500.4Z"
            fill="white"
          />
          <path
            d="M87.192 497.85C85.4733 497.85 84.0898 499.233 84.0898 500.952C84.0898 502.67 85.4733 504.041 87.192 504.041C88.9107 504.041 90.2815 502.658 90.2815 500.952C90.2815 499.246 88.898 497.85 87.192 497.85Z"
            fill="white"
          />
          <path
            d="M86.3601 495.211C84.6244 495.211 83.207 496.628 83.207 498.364C83.207 500.1 84.6244 501.517 86.3601 501.517C88.0958 501.517 89.5132 500.112 89.5132 498.364C89.5132 496.616 88.1086 495.211 86.3601 495.211Z"
            fill="white"
          />
          <path
            d="M85.1933 492.475C83.4152 492.475 81.9766 493.909 81.9766 495.691C81.9766 497.474 83.411 498.895 85.1933 498.895C86.9757 498.895 88.4101 497.461 88.4101 495.691C88.4101 493.922 86.963 492.475 85.1933 492.475Z"
            fill="white"
          />
          <path
            d="M83.6821 489.66C81.8827 489.66 80.4229 491.129 80.4229 492.928C80.4229 494.727 81.8785 496.187 83.6821 496.187C85.4856 496.187 86.9497 494.731 86.9497 492.928C86.9497 491.124 85.4814 489.66 83.6821 489.66Z"
            fill="white"
          />
          <path
            d="M81.8535 486.758C80.0117 486.758 78.5137 488.256 78.5137 490.098C78.5137 491.939 80.0117 493.429 81.8535 493.429C83.6953 493.429 85.1848 491.939 85.1848 490.098C85.1848 488.256 83.6953 486.758 81.8535 486.758Z"
            fill="white"
          />
          <path
            d="M79.6684 483.82C77.8054 483.82 76.2861 485.331 76.2861 487.203C76.2861 489.074 77.8054 490.585 79.6684 490.585C81.5314 490.585 83.0634 489.066 83.0634 487.203C83.0634 485.34 81.5441 483.82 79.6684 483.82Z"
            fill="white"
          />
          <path
            d="M77.1386 480.826C75.2459 480.826 73.7139 482.358 73.7139 484.251C73.7139 486.144 75.2459 487.676 77.1386 487.676C79.0313 487.676 80.5633 486.144 80.5633 484.251C80.5633 482.358 79.0313 480.826 77.1386 480.826Z"
            fill="white"
          />
          <path
            d="M74.2442 477.766C72.3303 477.766 70.7686 479.315 70.7686 481.241C70.7686 483.168 72.3303 484.717 74.2442 484.717C76.1581 484.717 77.7198 483.155 77.7198 481.241C77.7198 479.327 76.1581 477.766 74.2442 477.766Z"
            fill="white"
          />
          <path
            d="M70.9641 474.625C69.0077 474.625 67.4248 476.216 67.4248 478.173C67.4248 480.129 69.0077 481.712 70.9641 481.712C72.9205 481.712 74.5119 480.129 74.5119 478.173C74.5119 476.216 72.9205 474.625 70.9641 474.625Z"
            fill="white"
          />
          <path
            d="M67.3015 471.469C65.3239 471.469 63.7197 473.06 63.7197 475.038C63.7197 477.015 65.3239 478.619 67.3015 478.619C69.279 478.619 70.8832 477.015 70.8832 475.038C70.8832 473.06 69.279 471.469 67.3015 471.469Z"
            fill="white"
          />
          <path
            d="M63.2325 468.242C61.2337 468.242 59.6211 469.868 59.6211 471.862C59.6211 473.857 61.2337 475.474 63.2325 475.474C65.2313 475.474 66.8524 473.861 66.8524 471.862C66.8524 469.863 65.2271 468.242 63.2325 468.242Z"
            fill="white"
          />
          <path
            d="M58.7551 464.965C56.7351 464.965 55.0928 466.611 55.0928 468.64C55.0928 470.668 56.7393 472.302 58.7551 472.302C60.7709 472.302 62.4302 470.656 62.4302 468.64C62.4302 466.624 60.7836 464.965 58.7551 464.965Z"
            fill="white"
          />
          <path
            d="M53.8874 461.664C51.8377 461.664 50.1699 463.328 50.1699 465.382C50.1699 467.436 51.8335 469.086 53.8874 469.086C55.9414 469.086 57.5922 467.431 57.5922 465.382C57.5922 463.332 55.9287 461.664 53.8874 461.664Z"
            fill="white"
          />
          <path
            d="M48.5998 458.354C46.5288 458.354 44.8525 460.03 44.8525 462.101C44.8525 464.172 46.5288 465.856 48.5998 465.856C50.6707 465.856 52.347 464.172 52.347 462.101C52.347 460.03 50.6707 458.354 48.5998 458.354Z"
            fill="white"
          />
          <path
            d="M42.9166 455.045C40.8244 455.045 39.1396 456.73 39.1396 458.822C39.1396 460.914 40.8244 462.599 42.9166 462.599C45.0088 462.599 46.7063 460.914 46.7063 458.822C46.7063 456.73 45.0088 455.045 42.9166 455.045Z"
            fill="white"
          />
          <path
            d="M36.848 451.713C34.7473 451.713 33.0371 453.419 33.0371 455.532C33.0371 457.646 34.7431 459.343 36.848 459.343C38.9529 459.343 40.6674 457.637 40.6674 455.532C40.6674 453.427 38.9487 451.713 36.848 451.713Z"
            fill="white"
          />
          <path
            d="M30.4067 448.387C28.2848 448.387 26.5576 450.105 26.5576 452.236C26.5576 454.366 28.2848 456.098 30.4067 456.098C32.5286 456.098 34.2685 454.37 34.2685 452.236C34.2685 450.101 32.5413 448.387 30.4067 448.387Z"
            fill="white"
          />
          <path
            d="M23.6213 445.004C21.4782 445.004 19.7383 446.74 19.7383 448.887C19.7383 451.034 21.4782 452.77 23.6213 452.77C25.7644 452.77 27.5128 451.03 27.5128 448.887C27.5128 446.744 25.7729 445.004 23.6213 445.004Z"
            fill="white"
          />
          <path
            d="M16.5 441.451C14.3441 441.451 12.5957 443.2 12.5957 445.355C12.5957 447.511 14.3441 449.26 16.5 449.26C18.6558 449.26 20.4127 447.511 20.4127 445.355C20.4127 443.2 18.6643 441.451 16.5 441.451Z"
            fill="white"
          />
          <path
            d="M8.99646 437.631C6.81941 437.631 5.0625 439.388 5.0625 441.556C5.0625 443.725 6.82366 445.49 8.99646 445.49C11.1693 445.49 12.9304 443.729 12.9304 441.556C12.9304 439.384 11.1735 437.631 8.99646 437.631Z"
            fill="white"
          />
          <path
            d="M1.11533 433.523C-1.0702 433.523 -2.83984 435.293 -2.83984 437.487C-2.83984 439.681 -1.0702 441.442 1.11533 441.442C3.30086 441.442 5.07899 439.673 5.07899 437.487C5.07899 435.302 3.30935 433.523 1.11533 433.523Z"
            fill="white"
          />
          <path
            d="M6.54208 138.995C7.25961 137.263 6.437 135.277 4.70472 134.559C2.97244 133.842 0.986471 134.664 0.268937 136.397C-0.448597 138.129 0.374017 140.115 2.1063 140.832C3.83858 141.55 5.82454 140.727 6.54208 138.995Z"
            fill="white"
          />
          <path
            d="M11.9124 122.504C10.0706 122.504 8.59375 123.981 8.59375 125.818C8.59375 127.656 10.0706 129.133 11.9124 129.133C13.7541 129.133 15.2225 127.652 15.2225 125.818C15.2225 123.985 13.7457 122.504 11.9124 122.504Z"
            fill="white"
          />
          <path
            d="M20.3107 110.762C18.5113 110.762 17.043 112.217 17.043 114.029C17.043 115.841 18.5113 117.297 20.3107 117.297C22.11 117.297 23.5911 115.829 23.5911 114.029C23.5911 112.23 22.1227 110.762 20.3107 110.762Z"
            fill="white"
          />
          <path
            d="M28.4157 99.1348C26.6249 99.1348 25.1777 100.578 25.1777 102.364C25.1777 104.151 26.6249 105.59 28.4157 105.59C30.2066 105.59 31.641 104.142 31.641 102.364C31.641 100.586 30.1938 99.1348 28.4157 99.1348Z"
            fill="white"
          />
          <path
            d="M35.9829 87.752C34.2345 87.752 32.8086 89.1694 32.8086 90.9178C32.8086 92.6662 34.2345 94.0794 35.9829 94.0794C37.7313 94.0794 39.1488 92.662 39.1488 90.9178C39.1488 89.1736 37.7313 87.752 35.9829 87.752Z"
            fill="white"
          />
          <path
            d="M42.8329 76.9277C41.1354 76.9277 39.752 78.3112 39.752 80.0129C39.752 81.7147 41.1354 83.0981 42.8329 83.0981C44.5304 83.0981 45.9224 81.7147 45.9224 80.0129C45.9224 78.3112 44.5389 76.9277 42.8329 76.9277Z"
            fill="white"
          />
          <path
            d="M48.8709 66.9707C47.2073 66.9707 45.8408 68.3287 45.8408 69.9923C45.8408 71.6558 47.2031 73.0223 48.8709 73.0223C50.5387 73.0223 51.9009 71.6685 51.9009 69.9923C51.9009 68.316 50.5471 66.9707 48.8709 66.9707Z"
            fill="white"
          />
          <path
            d="M54.0826 58.0586C52.436 58.0586 51.1162 59.3784 51.1162 61.025C51.1162 62.6716 52.436 63.9914 54.0826 63.9914C55.7292 63.9914 57.049 62.6588 57.049 61.025C57.049 59.3911 55.7164 58.0586 54.0826 58.0586Z"
            fill="white"
          />
          <path
            d="M58.5385 50.1484C56.9343 50.1484 55.6357 51.4513 55.6357 53.0512C55.6357 54.6511 56.9386 55.9539 58.5385 55.9539C60.1384 55.9539 61.4412 54.6511 61.4412 53.0512C61.4412 51.4513 60.1384 50.1484 58.5385 50.1484Z"
            fill="white"
          />
          <path
            d="M62.3787 43.041C60.817 43.041 59.5566 44.3057 59.5566 45.8674C59.5566 47.4291 60.817 48.6937 62.3787 48.6937C63.9404 48.6937 65.2093 47.4291 65.2093 45.8674C65.2093 44.3057 63.9404 43.041 62.3787 43.041Z"
            fill="white"
          />
          <path
            d="M65.7819 36.4824C64.2499 36.4824 63.0234 37.7216 63.0234 39.2409C63.0234 40.7601 64.2499 42.0035 65.7819 42.0035C67.3139 42.0035 68.5403 40.7686 68.5403 39.2409C68.5403 37.7131 67.3011 36.4824 65.7819 36.4824Z"
            fill="white"
          />
          <path
            d="M68.8842 30.2285C67.3947 30.2285 66.1895 31.438 66.1895 32.9318C66.1895 34.4256 67.3947 35.6308 68.8842 35.6308C70.3738 35.6308 71.5917 34.4213 71.5917 32.9318C71.5917 31.4422 70.3865 30.2285 68.8842 30.2285Z"
            fill="white"
          />
          <path
            d="M71.8802 23.9609C70.4245 23.9609 69.249 25.1365 69.249 26.5963C69.249 28.0562 70.4245 29.2402 71.8802 29.2402C73.3358 29.2402 74.524 28.0604 74.524 26.5963C74.524 25.1322 73.3358 23.9609 71.8802 23.9609Z"
            fill="white"
          />
          <path
            d="M74.9189 17.416C73.5227 17.416 72.3896 18.5491 72.3896 19.9538C72.3896 21.3585 73.5227 22.4873 74.9189 22.4873C76.3151 22.4873 77.4567 21.3457 77.4567 19.9538C77.4567 18.5618 76.3236 17.416 74.9189 17.416Z"
            fill="white"
          />
          <path
            d="M78.243 9.99805C76.8808 9.99805 75.7646 11.1057 75.7646 12.4722C75.7646 13.8386 76.8765 14.9505 78.243 14.9505C79.6095 14.9505 80.7214 13.8386 80.7214 12.4722C80.7214 11.1057 79.6095 9.99805 78.243 9.99805Z"
            fill="white"
          />
          <path
            d="M82.121 1.18945C80.7885 1.18945 79.7148 2.26737 79.7148 3.5999C79.7148 4.93244 80.7885 6.01035 82.121 6.01035C83.4536 6.01035 84.5357 4.93244 84.5357 3.5999C84.5357 2.26737 83.4536 1.18945 82.121 1.18945Z"
            fill="white"
          />
          <path
            d="M992.261 -3.29688C990.784 -3.29688 989.596 -2.10014 989.596 -0.631801C989.596 0.836537 990.784 2.03327 992.261 2.03327C993.738 2.03327 994.913 0.836537 994.913 -0.631801C994.913 -2.10014 993.725 -3.29688 992.261 -3.29688Z"
            fill="white"
          />
          <path
            d="M999.497 8.2168C997.999 8.2168 996.781 9.43475 996.781 10.9455C996.781 12.4563 997.999 13.6615 999.497 13.6615C1001 13.6615 1002.23 12.4436 1002.23 10.9455C1002.23 9.44748 1001.01 8.2168 999.497 8.2168Z"
            fill="white"
          />
          <path
            d="M1006.85 19.5254C1005.31 19.5254 1004.08 20.7731 1004.08 22.3135C1004.08 23.854 1005.31 25.0932 1006.85 25.0932C1008.4 25.0932 1009.63 23.8455 1009.63 22.3135C1009.63 20.7815 1008.39 19.5254 1006.85 19.5254Z"
            fill="white"
          />
          <path
            d="M1014.34 30.5703C1012.76 30.5703 1011.47 31.8519 1011.47 33.4391C1011.47 35.0262 1012.76 36.3079 1014.34 36.3079C1015.93 36.3079 1017.22 35.0262 1017.22 33.4391C1017.22 31.8519 1015.93 30.5703 1014.34 30.5703Z"
            fill="white"
          />
          <path
            d="M1021.98 41.4062C1020.36 41.4062 1019.05 42.7176 1019.05 44.3344C1019.05 45.9513 1020.36 47.2626 1021.98 47.2626C1023.59 47.2626 1024.91 45.9513 1024.91 44.3344C1024.91 42.7176 1023.6 41.4062 1021.98 41.4062Z"
            fill="white"
          />
          <path
            d="M1029.78 51.9473C1028.13 51.9473 1026.78 53.2883 1026.78 54.9391C1026.78 56.5899 1028.13 57.9309 1029.78 57.9309C1031.44 57.9309 1032.77 56.5899 1032.77 54.9391C1032.77 53.2883 1031.43 51.9473 1029.78 51.9473Z"
            fill="white"
          />
          <path
            d="M1037.66 62.3438C1035.98 62.3438 1034.63 63.706 1034.63 65.3823C1034.63 67.0586 1035.98 68.4208 1037.66 68.4208C1039.34 68.4208 1040.7 67.0586 1040.7 65.3823C1040.7 63.706 1039.34 62.3438 1037.66 62.3438Z"
            fill="white"
          />
          <path
            d="M1045.61 72.5625C1043.89 72.5625 1042.49 73.9672 1042.49 75.6944C1042.49 77.4216 1043.89 78.8178 1045.61 78.8178C1047.34 78.8178 1048.75 77.4216 1048.75 75.6944C1048.75 73.9672 1047.34 72.5625 1045.61 72.5625Z"
            fill="white"
          />
          <path
            d="M1053.6 82.7402C1051.84 82.7402 1050.41 84.1704 1050.41 85.9315C1050.41 87.6927 1051.84 89.1143 1053.6 89.1143C1055.36 89.1143 1056.78 87.6884 1056.78 85.9315C1056.78 84.1746 1055.36 82.7402 1053.6 82.7402Z"
            fill="white"
          />
          <path
            d="M1061.56 92.9141C1059.78 92.9141 1058.33 94.3569 1058.33 96.1393C1058.33 97.9217 1059.78 99.3646 1061.56 99.3646C1063.34 99.3646 1064.78 97.9174 1064.78 96.1393C1064.78 94.3612 1063.35 92.9141 1061.56 92.9141Z"
            fill="white"
          />
          <path
            d="M1069.53 103.029C1067.71 103.029 1066.24 104.506 1066.24 106.318C1066.24 108.13 1067.71 109.607 1069.53 109.607C1071.35 109.607 1072.82 108.139 1072.82 106.318C1072.82 104.498 1071.34 103.029 1069.53 103.029Z"
            fill="white"
          />
          <path
            d="M1077.46 113.176C1075.6 113.176 1074.1 114.687 1074.1 116.537C1074.1 118.387 1075.6 119.898 1077.46 119.898C1079.32 119.898 1080.81 118.387 1080.81 116.537C1080.81 114.687 1079.31 113.176 1077.46 113.176Z"
            fill="white"
          />
          <path
            d="M1085.31 123.449C1083.42 123.449 1081.89 124.981 1081.89 126.861C1081.89 128.741 1083.42 130.269 1085.31 130.269C1087.19 130.269 1088.72 128.745 1088.72 126.861C1088.72 124.977 1087.19 123.449 1085.31 123.449Z"
            fill="white"
          />
          <path
            d="M1093.06 133.877C1091.15 133.877 1089.61 135.426 1089.61 137.336C1089.61 139.245 1091.15 140.794 1093.06 140.794C1094.98 140.794 1096.52 139.245 1096.52 137.336C1096.52 135.426 1094.97 133.877 1093.06 133.877Z"
            fill="white"
          />
          <path
            d="M1103.9 149.416C1104.64 147.626 1103.79 145.573 1102 144.831C1100.21 144.089 1098.16 144.939 1097.42 146.73C1096.68 148.521 1097.53 150.574 1099.32 151.316C1101.11 152.057 1103.16 151.207 1103.9 149.416Z"
            fill="white"
          />
          <path
            d="M1108.12 155.49C1106.15 155.49 1104.55 157.086 1104.55 159.063C1104.55 161.041 1106.15 162.632 1108.12 162.632C1110.1 162.632 1111.69 161.028 1111.69 159.063C1111.69 157.099 1110.09 155.49 1108.12 155.49Z"
            fill="white"
          />
          <path
            d="M1115.46 166.682C1113.46 166.682 1111.84 168.299 1111.84 170.302C1111.84 172.305 1113.47 173.917 1115.46 173.917C1117.46 173.917 1119.08 172.3 1119.08 170.302C1119.08 168.303 1117.46 166.682 1115.46 166.682Z"
            fill="white"
          />
          <path
            d="M1122.68 178.102C1120.66 178.102 1119.02 179.748 1119.02 181.764C1119.02 183.78 1120.66 185.426 1122.68 185.426C1124.71 185.426 1126.35 183.78 1126.35 181.764C1126.35 179.748 1124.7 178.102 1122.68 178.102Z"
            fill="white"
          />
          <path
            d="M1129.85 189.652C1127.81 189.652 1126.15 191.307 1126.15 193.353C1126.15 195.398 1127.81 197.053 1129.85 197.053C1131.89 197.053 1133.56 195.398 1133.56 193.353C1133.56 191.307 1131.9 189.652 1129.85 189.652Z"
            fill="white"
          />
          <path
            d="M1137.07 201.154C1135 201.154 1133.31 202.839 1133.31 204.91C1133.31 206.981 1135 208.678 1137.07 208.678C1139.14 208.678 1140.83 206.994 1140.83 204.91C1140.83 202.826 1139.15 201.154 1137.07 201.154Z"
            fill="white"
          />
          <path
            d="M1144.44 212.457C1142.33 212.457 1140.64 214.155 1140.64 216.255C1140.64 218.356 1142.34 220.053 1144.44 220.053C1146.54 220.053 1148.24 218.356 1148.24 216.255C1148.24 214.155 1146.54 212.457 1144.44 212.457Z"
            fill="white"
          />
          <path
            d="M1152.04 223.322C1149.92 223.322 1148.2 225.049 1148.2 227.171C1148.2 229.293 1149.92 231.012 1152.04 231.012C1154.16 231.012 1155.88 229.285 1155.88 227.171C1155.88 225.058 1154.16 223.322 1152.04 223.322Z"
            fill="white"
          />
          <path
            d="M1159.91 233.719C1157.77 233.719 1156.03 235.446 1156.03 237.589C1156.03 239.732 1157.76 241.459 1159.91 241.459C1162.06 241.459 1163.78 239.732 1163.78 237.589C1163.78 235.446 1162.04 233.719 1159.91 233.719Z"
            fill="white"
          />
          <path
            d="M1168.08 243.422C1165.92 243.422 1164.16 245.183 1164.16 247.347C1164.16 249.512 1165.92 251.273 1168.08 251.273C1170.25 251.273 1172.01 249.512 1172.01 247.347C1172.01 245.183 1170.25 243.422 1168.08 243.422Z"
            fill="white"
          />
          <path
            d="M1176.58 252.406C1174.4 252.406 1172.63 254.176 1172.63 256.349C1172.63 258.521 1174.4 260.304 1176.58 260.304C1178.75 260.304 1180.53 258.534 1180.53 256.349C1180.53 254.163 1178.76 252.406 1176.58 252.406Z"
            fill="white"
          />
          <path
            d="M1185.42 260.561C1183.22 260.561 1181.44 262.339 1181.44 264.545C1181.44 266.752 1183.22 268.522 1185.42 268.522C1187.63 268.522 1189.41 266.744 1189.41 264.545C1189.41 262.347 1187.62 260.561 1185.42 260.561Z"
            fill="white"
          />
          <path
            d="M1194.58 267.941C1192.37 267.941 1190.56 269.741 1190.56 271.96C1190.56 274.18 1192.36 275.966 1194.58 275.966C1196.8 275.966 1198.59 274.175 1198.59 271.96C1198.59 269.745 1196.79 267.941 1194.58 267.941Z"
            fill="white"
          />
          <path
            d="M1204.02 274.562C1201.78 274.562 1199.96 276.375 1199.96 278.611C1199.96 280.848 1201.78 282.668 1204.02 282.668C1206.26 282.668 1208.08 280.856 1208.08 278.611C1208.08 276.366 1206.26 274.562 1204.02 274.562Z"
            fill="white"
          />
          <path
            d="M1213.73 280.475C1211.48 280.475 1209.65 282.295 1209.65 284.553C1209.65 286.811 1211.48 288.623 1213.73 288.623C1215.97 288.623 1217.81 286.802 1217.81 284.553C1217.81 282.304 1215.97 280.475 1213.73 280.475Z"
            fill="white"
          />
          <path
            d="M1223.68 285.676C1221.41 285.676 1219.58 287.518 1219.58 289.775C1219.58 292.033 1221.41 293.887 1223.68 293.887C1225.95 293.887 1227.79 292.046 1227.79 289.775C1227.79 287.505 1225.95 285.676 1223.68 285.676Z"
            fill="white"
          />
          <path
            d="M1233.85 290.195C1231.58 290.195 1229.74 292.037 1229.74 294.316C1229.74 296.595 1231.58 298.428 1233.85 298.428C1236.12 298.428 1237.97 296.586 1237.97 294.316C1237.97 292.046 1236.13 290.195 1233.85 290.195Z"
            fill="white"
          />
          <path
            d="M1244.22 293.943C1241.93 293.943 1240.07 295.806 1240.07 298.098C1240.07 300.39 1241.93 302.253 1244.22 302.253C1246.52 302.253 1248.37 300.39 1248.37 298.098C1248.37 295.806 1246.51 293.943 1244.22 293.943Z"
            fill="white"
          />
          <path
            d="M1254.75 296.969C1252.46 296.969 1250.59 298.832 1250.59 301.123C1250.59 303.415 1252.46 305.286 1254.75 305.286C1257.04 305.286 1258.9 303.423 1258.9 301.123C1258.9 298.823 1257.04 296.969 1254.75 296.969Z"
            fill="white"
          />
          <path
            d="M1265.36 299.291C1263.06 299.291 1261.2 301.146 1261.2 303.446C1261.2 305.746 1263.06 307.6 1265.36 307.6C1267.66 307.6 1269.52 305.737 1269.52 303.446C1269.52 301.154 1267.65 299.291 1265.36 299.291Z"
            fill="white"
          />
          <path
            d="M1276 300.895C1273.71 300.895 1271.85 302.758 1271.85 305.058C1271.85 307.358 1273.71 309.212 1276 309.212C1278.29 309.212 1280.16 307.349 1280.16 305.058C1280.16 302.766 1278.29 300.895 1276 300.895Z"
            fill="white"
          />
          <path
            d="M1286.62 301.799C1284.32 301.799 1282.46 303.662 1282.46 305.962C1282.46 308.262 1284.32 310.117 1286.62 310.117C1288.91 310.117 1290.77 308.254 1290.77 305.962C1290.77 303.67 1288.91 301.799 1286.62 301.799Z"
            fill="white"
          />
          <path
            d="M1297.15 301.998C1294.86 301.998 1292.99 303.861 1292.99 306.153C1292.99 308.444 1294.86 310.307 1297.15 310.307C1299.44 310.307 1301.31 308.457 1301.31 306.153C1301.31 303.848 1299.45 301.998 1297.15 301.998Z"
            fill="white"
          />
          <path
            d="M1307.55 301.561C1305.25 301.561 1303.4 303.424 1303.4 305.715C1303.4 308.007 1305.25 309.87 1307.55 309.87C1309.85 309.87 1311.7 308.007 1311.7 305.715C1311.7 303.424 1309.84 301.561 1307.55 301.561Z"
            fill="white"
          />
          <path
            d="M1317.73 300.572C1315.43 300.572 1313.56 302.435 1313.56 304.727C1313.56 307.019 1315.43 308.882 1317.73 308.882C1320.03 308.882 1321.88 307.031 1321.88 304.727C1321.88 302.423 1320.02 300.572 1317.73 300.572Z"
            fill="white"
          />
          <path
            d="M1327.64 299.123C1325.34 299.123 1323.49 300.986 1323.49 303.278C1323.49 305.569 1325.34 307.432 1327.64 307.432C1329.94 307.432 1331.8 305.569 1331.8 303.278C1331.8 300.986 1329.94 299.123 1327.64 299.123Z"
            fill="white"
          />
          <path
            d="M1324.08 301.301C1321.79 301.301 1319.93 303.164 1319.93 305.455C1319.93 307.747 1321.79 309.61 1324.08 309.61C1326.37 309.61 1328.24 307.756 1328.24 305.455C1328.24 303.155 1326.38 301.301 1324.08 301.301Z"
            fill="white"
          />
          <path
            d="M1320.29 303.287C1317.99 303.287 1316.13 305.15 1316.13 307.442C1316.13 309.733 1317.99 311.596 1320.29 311.596C1322.58 311.596 1324.44 309.746 1324.44 307.442C1324.44 305.137 1322.58 303.287 1320.29 303.287Z"
            fill="white"
          />
          <path
            d="M1316.16 305.143C1313.86 305.143 1312 307.006 1312 309.297C1312 311.589 1313.86 313.452 1316.16 313.452C1318.45 313.452 1320.31 311.589 1320.31 309.297C1320.31 307.006 1318.46 305.143 1316.16 305.143Z"
            fill="white"
          />
          <path
            d="M1311.64 306.879C1309.34 306.879 1307.47 308.742 1307.47 311.034C1307.47 313.325 1309.34 315.188 1311.64 315.188C1313.94 315.188 1315.79 313.325 1315.79 311.034C1315.79 308.742 1313.93 306.879 1311.64 306.879Z"
            fill="white"
          />
          <path
            d="M1306.65 308.525C1304.36 308.525 1302.5 310.38 1302.5 312.68C1302.5 314.98 1304.36 316.835 1306.65 316.835C1308.95 316.835 1310.82 314.972 1310.82 312.68C1310.82 310.388 1308.95 308.525 1306.65 308.525Z"
            fill="white"
          />
          <path
            d="M1301.19 310.045C1298.9 310.045 1297.03 311.908 1297.03 314.208C1297.03 316.508 1298.9 318.363 1301.19 318.363C1303.48 318.363 1305.35 316.5 1305.35 314.208C1305.35 311.916 1303.49 310.045 1301.19 310.045Z"
            fill="white"
          />
          <path
            d="M1295.21 311.447C1292.92 311.447 1291.06 313.31 1291.06 315.602C1291.06 317.894 1292.92 319.757 1295.21 319.757C1297.51 319.757 1299.37 317.894 1299.37 315.602C1299.37 313.31 1297.51 311.447 1295.21 311.447Z"
            fill="white"
          />
          <path
            d="M1288.73 312.676C1286.43 312.676 1284.57 314.539 1284.57 316.83C1284.57 319.122 1286.43 320.985 1288.73 320.985C1291.03 320.985 1292.88 319.135 1292.88 316.83C1292.88 314.526 1291.02 312.676 1288.73 312.676Z"
            fill="white"
          />
          <path
            d="M1281.73 313.707C1279.43 313.707 1277.58 315.557 1277.58 317.862C1277.58 320.166 1279.43 322.016 1281.73 322.016C1284.03 322.016 1285.89 320.153 1285.89 317.862C1285.89 315.57 1284.03 313.707 1281.73 313.707Z"
            fill="white"
          />
          <path
            d="M1274.25 314.475C1271.96 314.475 1270.1 316.329 1270.1 318.629C1270.1 320.929 1271.96 322.784 1274.25 322.784C1276.54 322.784 1278.41 320.921 1278.41 318.629C1278.41 316.338 1276.54 314.475 1274.25 314.475Z"
            fill="white"
          />
          <path
            d="M1266.31 314.996C1264.02 314.996 1262.16 316.859 1262.16 319.159C1262.16 321.459 1264.02 323.314 1266.31 323.314C1268.61 323.314 1270.47 321.451 1270.47 319.159C1270.47 316.868 1268.61 314.996 1266.31 314.996Z"
            fill="white"
          />
          <path
            d="M1257.94 315.256C1255.64 315.256 1253.79 317.119 1253.79 319.419C1253.79 321.719 1255.64 323.574 1257.94 323.574C1260.25 323.574 1262.1 321.711 1262.1 319.419C1262.1 317.127 1260.24 315.256 1257.94 315.256Z"
            fill="white"
          />
          <path
            d="M1249.17 315.225C1246.88 315.225 1245.03 317.079 1245.03 319.367C1245.03 321.654 1246.88 323.508 1249.17 323.508C1251.46 323.508 1253.3 321.658 1253.3 319.367C1253.3 317.075 1251.45 315.225 1249.17 315.225Z"
            fill="white"
          />
          <path
            d="M1240.03 314.861C1237.75 314.861 1235.91 316.703 1235.91 318.982C1235.91 321.261 1237.75 323.103 1240.03 323.103C1242.31 323.103 1244.15 321.261 1244.15 318.982C1244.15 316.703 1242.31 314.861 1240.03 314.861Z"
            fill="white"
          />
          <path
            d="M1230.57 314.123C1228.3 314.123 1226.47 315.965 1226.47 318.235C1226.47 320.506 1228.31 322.347 1230.57 322.347C1232.84 322.347 1234.69 320.506 1234.69 318.235C1234.69 315.965 1232.85 314.123 1230.57 314.123Z"
            fill="white"
          />
          <path
            d="M1220.84 313.111C1218.59 313.111 1216.77 314.932 1216.77 317.181C1216.77 319.43 1218.59 321.251 1220.84 321.251C1223.09 321.251 1224.91 319.43 1224.91 317.181C1224.91 314.932 1223.09 313.111 1220.84 313.111Z"
            fill="white"
          />
          <path
            d="M1210.84 311.887C1208.6 311.887 1206.79 313.699 1206.79 315.935C1206.79 318.172 1208.6 319.984 1210.84 319.984C1213.08 319.984 1214.89 318.172 1214.89 315.935C1214.89 313.699 1213.08 311.887 1210.84 311.887Z"
            fill="white"
          />
          <path
            d="M1200.57 310.51C1198.35 310.51 1196.55 312.309 1196.55 314.529C1196.55 316.748 1198.35 318.547 1200.57 318.547C1202.79 318.547 1204.59 316.748 1204.59 314.529C1204.59 312.309 1202.79 310.51 1200.57 310.51Z"
            fill="white"
          />
          <path
            d="M1190.04 309.02C1187.83 309.02 1186.04 310.81 1186.04 313.017C1186.04 315.224 1187.83 317.002 1190.04 317.002C1192.25 317.002 1194.03 315.224 1194.03 313.017C1194.03 310.81 1192.23 309.02 1190.04 309.02Z"
            fill="white"
          />
          <path
            d="M1179.26 307.535C1177.08 307.535 1175.31 309.305 1175.31 311.478C1175.31 313.65 1177.08 315.433 1179.26 315.433C1181.45 315.433 1183.21 313.663 1183.21 311.478C1183.21 309.292 1181.44 307.535 1179.26 307.535Z"
            fill="white"
          />
          <path
            d="M1168.24 306.074C1166.08 306.074 1164.32 307.831 1164.32 309.987C1164.32 312.143 1166.09 313.9 1168.24 313.9C1170.39 313.9 1172.15 312.151 1172.15 309.987C1172.15 307.823 1170.4 306.074 1168.24 306.074Z"
            fill="white"
          />
          <path
            d="M1156.99 304.736C1154.84 304.736 1153.1 306.476 1153.1 308.619C1153.1 310.762 1154.84 312.502 1156.99 312.502C1159.13 312.502 1160.88 310.767 1160.88 308.619C1160.88 306.472 1159.14 304.736 1156.99 304.736Z"
            fill="white"
          />
          <path
            d="M1145.51 303.547C1143.39 303.547 1141.67 305.266 1141.67 307.387C1141.67 309.509 1143.39 311.237 1145.51 311.237C1147.62 311.237 1149.36 309.509 1149.36 307.387C1149.36 305.266 1147.63 303.547 1145.51 303.547Z"
            fill="white"
          />
          <path
            d="M1133.84 302.613C1131.75 302.613 1130.04 304.311 1130.04 306.411C1130.04 308.512 1131.75 310.21 1133.84 310.21C1135.93 310.21 1137.64 308.512 1137.64 306.411C1137.64 304.311 1135.94 302.613 1133.84 302.613Z"
            fill="white"
          />
          <path
            d="M1121.97 301.99C1119.9 301.99 1118.23 303.667 1118.23 305.746C1118.23 307.825 1119.9 309.493 1121.97 309.493C1124.05 309.493 1125.73 307.817 1125.73 305.746C1125.73 303.675 1124.05 301.99 1121.97 301.99Z"
            fill="white"
          />
          <path
            d="M1109.93 301.727C1107.87 301.727 1106.21 303.39 1106.21 305.444C1106.21 307.498 1107.87 309.17 1109.93 309.17C1111.99 309.17 1113.66 307.507 1113.66 305.444C1113.66 303.382 1111.98 301.727 1109.93 301.727Z"
            fill="white"
          />
          <path
            d="M1097.71 301.861C1095.67 301.861 1094.03 303.516 1094.03 305.545C1094.03 307.573 1095.68 309.228 1097.71 309.228C1099.75 309.228 1101.39 307.573 1101.39 305.545C1101.39 303.516 1099.75 301.861 1097.71 301.861Z"
            fill="white"
          />
          <path
            d="M1087.85 308.669C1089.26 307.255 1089.26 304.963 1087.85 303.55C1086.44 302.136 1084.14 302.136 1082.73 303.55C1081.32 304.963 1081.32 307.255 1082.73 308.669C1084.14 310.083 1086.44 310.083 1087.85 308.669Z"
            fill="white"
          />
          <path
            d="M1072.69 303.674C1070.72 303.674 1069.12 305.278 1069.12 307.243C1069.12 309.208 1070.73 310.825 1072.69 310.825C1074.66 310.825 1076.27 309.22 1076.27 307.243C1076.27 305.265 1074.67 303.674 1072.69 303.674Z"
            fill="white"
          />
          <path
            d="M1059.94 305.486C1058 305.486 1056.42 307.069 1056.42 309.026C1056.42 310.982 1058 312.552 1059.94 312.552C1061.89 312.552 1063.48 310.969 1063.48 309.026C1063.48 307.082 1061.9 305.486 1059.94 305.486Z"
            fill="white"
          />
          <path
            d="M1046.95 307.953C1045.03 307.953 1043.48 309.502 1043.48 311.429C1043.48 313.355 1045.03 314.896 1046.95 314.896C1048.86 314.896 1050.42 313.347 1050.42 311.429C1050.42 309.511 1048.87 307.953 1046.95 307.953Z"
            fill="white"
          />
          <path
            d="M1033.77 311.229C1031.89 311.229 1030.36 312.748 1030.36 314.645C1030.36 316.542 1031.89 318.057 1033.77 318.057C1035.65 318.057 1037.18 316.525 1037.18 314.645C1037.18 312.765 1035.66 311.229 1033.77 311.229Z"
            fill="white"
          />
          <path
            d="M1020.43 315.484C1018.56 315.484 1017.07 316.982 1017.07 318.845C1017.07 320.708 1018.56 322.198 1020.43 322.198C1022.29 322.198 1023.79 320.7 1023.79 318.845C1023.79 316.991 1022.28 315.484 1020.43 315.484Z"
            fill="white"
          />
          <path
            d="M1006.87 320.846C1005.05 320.846 1003.56 322.323 1003.56 324.156C1003.56 325.989 1005.05 327.466 1006.87 327.466C1008.69 327.466 1010.19 325.989 1010.19 324.156C1010.19 322.323 1008.7 320.846 1006.87 320.846Z"
            fill="white"
          />
          <path
            d="M993.22 334.147C995.02 334.147 996.479 332.688 996.479 330.888C996.479 329.088 995.02 327.629 993.22 327.629C991.42 327.629 989.961 329.088 989.961 330.888C989.961 332.688 991.42 334.147 993.22 334.147Z"
            fill="white"
          />
          <path
            d="M979.491 336.248C977.734 336.248 976.309 337.674 976.309 339.431C976.309 341.188 977.734 342.618 979.491 342.618C981.248 342.618 982.678 341.192 982.678 339.431C982.678 337.67 981.253 336.248 979.491 336.248Z"
            fill="white"
          />
          <path
            d="M966.116 347.355C964.397 347.355 962.992 348.752 962.992 350.479C962.992 352.206 964.397 353.602 966.116 353.602C967.834 353.602 969.247 352.206 969.247 350.479C969.247 348.752 967.843 347.355 966.116 347.355Z"
            fill="white"
          />
          <path
            d="M953.358 361.363C951.66 361.363 950.285 362.747 950.285 364.444C950.285 366.142 951.66 367.525 953.358 367.525C955.055 367.525 956.439 366.142 956.439 364.444C956.439 362.747 955.064 361.363 953.358 361.363Z"
            fill="white"
          />
          <path
            d="M941.973 378.963C940.31 378.963 938.956 380.317 938.956 381.98C938.956 383.644 940.31 384.998 941.973 384.998C943.637 384.998 944.991 383.656 944.991 381.98C944.991 380.304 943.637 378.963 941.973 378.963Z"
            fill="white"
          />
          <path
            d="M932.314 400.156C930.688 400.156 929.377 401.468 929.377 403.08C929.377 404.693 930.688 406.017 932.314 406.017C933.939 406.017 935.238 404.706 935.238 403.08C935.238 401.455 933.926 400.156 932.314 400.156Z"
            fill="white"
          />
          <path
            d="M925.744 425.393C924.161 425.393 922.871 426.674 922.871 428.266C922.871 429.857 924.161 431.139 925.744 431.139C927.327 431.139 928.617 429.848 928.617 428.266C928.617 426.683 927.336 425.393 925.744 425.393Z"
            fill="white"
          />
          <path
            d="M923.673 454.723C922.124 454.723 920.863 455.983 920.863 457.532C920.863 459.081 922.124 460.341 923.673 460.341C925.222 460.341 926.482 459.081 926.482 457.532C926.482 455.983 925.222 454.723 923.673 454.723Z"
            fill="white"
          />
          <path
            d="M926.805 487.697C925.286 487.697 924.06 488.924 924.06 490.443C924.06 491.962 925.286 493.201 926.805 493.201C928.325 493.201 929.564 491.975 929.564 490.443C929.564 488.911 928.337 487.697 926.805 487.697Z"
            fill="white"
          />
          <path
            d="M934.652 523.688C933.176 523.688 931.987 524.884 931.987 526.361C931.987 527.838 933.176 529.026 934.652 529.026C936.129 529.026 937.317 527.829 937.317 526.361C937.317 524.893 936.129 523.688 934.652 523.688Z"
            fill="white"
          />
          <path
            d="M945.491 562.338C944.044 562.338 942.877 563.505 942.877 564.939C942.877 566.374 944.044 567.553 945.491 567.553C946.938 567.553 948.093 566.386 948.093 564.939C948.093 563.492 946.925 562.338 945.491 562.338Z"
            fill="white"
          />
          <path
            d="M957.029 603.703C955.624 603.703 954.479 604.849 954.479 606.254C954.479 607.658 955.624 608.791 957.029 608.791C958.434 608.791 959.567 607.658 959.567 606.254C959.567 604.849 958.434 603.703 957.029 603.703Z"
            fill="white"
          />
          <path
            d="M967.18 648.059C965.805 648.059 964.693 649.17 964.693 650.545C964.693 651.92 965.805 653.032 967.18 653.032C968.555 653.032 969.667 651.92 969.667 650.545C969.667 649.17 968.555 648.059 967.18 648.059Z"
            fill="white"
          />
          <path
            d="M329.048 680.222C330.076 680.222 330.911 679.388 330.911 678.359C330.911 677.33 330.076 676.496 329.048 676.496C328.019 676.496 327.185 677.33 327.185 678.359C327.185 679.388 328.019 680.222 329.048 680.222Z"
            fill="white"
          />
          <path
            d="M309.607 668.18C308.576 668.18 307.744 669.011 307.744 670.043C307.744 671.074 308.576 671.906 309.607 671.906C310.638 671.906 311.457 671.074 311.457 670.043C311.457 669.011 310.626 668.18 309.607 668.18Z"
            fill="white"
          />
          <path
            d="M289.5 658.926C288.468 658.926 287.637 659.758 287.637 660.789C287.637 661.82 288.468 662.652 289.5 662.652C290.531 662.652 291.363 661.82 291.363 660.789C291.363 659.758 290.518 658.926 289.5 658.926Z"
            fill="white"
          />
          <path
            d="M268.59 648.551C267.559 648.551 266.719 649.383 266.719 650.414C266.719 651.445 267.563 652.285 268.59 652.285C269.617 652.285 270.462 651.454 270.462 650.414C270.462 649.374 269.617 648.551 268.59 648.551Z"
            fill="white"
          />
          <path
            d="M246.714 637.102C245.683 637.102 244.843 637.933 244.843 638.965C244.843 639.996 245.687 640.84 246.714 640.84C247.741 640.84 248.577 640.009 248.577 638.965C248.577 637.921 247.745 637.102 246.714 637.102Z"
            fill="white"
          />
          <path
            d="M223.484 624.619C222.444 624.619 221.6 625.464 221.6 626.503C221.6 627.543 222.444 628.375 223.484 628.375C224.524 628.375 225.355 627.543 225.355 626.503C225.355 625.464 224.524 624.619 223.484 624.619Z"
            fill="white"
          />
          <path
            d="M198.451 611.83C197.411 611.83 196.579 612.662 196.579 613.702C196.579 614.741 197.411 615.573 198.451 615.573C199.49 615.573 200.326 614.729 200.326 613.702C200.326 612.675 199.495 611.83 198.451 611.83Z"
            fill="white"
          />
          <path
            d="M171.091 599.09C170.052 599.09 169.207 599.934 169.207 600.961C169.207 601.988 170.052 602.846 171.091 602.846C172.131 602.846 172.963 602.001 172.963 600.961C172.963 599.922 172.118 599.09 171.091 599.09Z"
            fill="white"
          />
          <path
            d="M141.053 586.35C140.013 586.35 139.169 587.194 139.169 588.234C139.169 589.274 140.013 590.118 141.053 590.118C142.093 590.118 142.937 589.274 142.937 588.234C142.937 587.194 142.093 586.35 141.053 586.35Z"
            fill="white"
          />
          <path
            d="M123.337 572.885C122.263 572.885 121.401 573.751 121.401 574.82C121.401 575.889 122.267 576.747 123.337 576.747C124.406 576.747 125.272 575.881 125.272 574.82C125.272 573.759 124.406 572.885 123.337 572.885Z"
            fill="white"
          />
          <path
            d="M106.883 559.717C105.771 559.717 104.863 560.621 104.863 561.745C104.863 562.87 105.767 563.765 106.883 563.765C107.999 563.765 108.912 562.861 108.912 561.745C108.912 560.629 108.008 559.717 106.883 559.717Z"
            fill="white"
          />
          <path
            d="M93.3841 548.029C92.2383 548.029 91.3047 548.967 91.3047 550.113C91.3047 551.259 92.2426 552.192 93.3841 552.192C94.5257 552.192 95.4636 551.267 95.4636 550.113C95.4636 548.959 94.5384 548.029 93.3841 548.029Z"
            fill="white"
          />
          <path
            d="M83.3387 538.371C82.1632 538.371 81.2041 539.33 81.2041 540.506C81.2041 541.681 82.1632 542.64 83.3387 542.64C84.5142 542.64 85.4818 541.694 85.4818 540.506C85.4818 539.317 84.5227 538.371 83.3387 538.371Z"
            fill="white"
          />
          <path
            d="M76.4001 530.66C75.1906 530.66 74.2061 531.649 74.2061 532.867C74.2061 534.085 75.1948 535.065 76.4001 535.065C77.6053 535.065 78.6068 534.076 78.6068 532.867C78.6068 531.657 77.618 530.66 76.4001 530.66Z"
            fill="white"
          />
          <path
            d="M71.9645 524.57C70.7041 524.57 69.6729 525.602 69.6729 526.862C69.6729 528.122 70.7041 529.154 71.9645 529.154C73.2249 529.154 74.2519 528.135 74.2519 526.862C74.2519 525.589 73.2334 524.57 71.9645 524.57Z"
            fill="white"
          />
          <path
            d="M69.4868 519.812C68.184 519.812 67.1357 520.865 67.1357 522.164C67.1357 523.462 68.1882 524.515 69.4868 524.515C70.7854 524.515 71.8293 523.462 71.8293 522.164C71.8293 520.865 70.7769 519.812 69.4868 519.812Z"
            fill="white"
          />
          <path
            d="M68.3753 515.984C67.0343 515.984 65.9521 517.067 65.9521 518.408C65.9521 519.749 67.0343 520.822 68.3753 520.822C69.7164 520.822 70.79 519.74 70.79 518.408C70.79 517.075 69.7079 515.984 68.3753 515.984Z"
            fill="white"
          />
          <path
            d="M68.1668 512.797C66.8046 512.797 65.6885 513.909 65.6885 515.275C65.6885 516.642 66.8003 517.762 68.1668 517.762C69.5333 517.762 70.6537 516.65 70.6537 515.275C70.6537 513.9 69.5418 512.797 68.1668 512.797Z"
            fill="white"
          />
          <path
            d="M68.5698 510.031C67.1439 510.031 65.998 511.186 65.998 512.603C65.998 514.02 67.1439 515.175 68.5698 515.175C69.9957 515.175 71.1415 514.02 71.1415 512.603C71.1415 511.186 69.9872 510.031 68.5698 510.031Z"
            fill="white"
          />
          <path
            d="M69.3434 507.596C67.8878 507.596 66.708 508.784 66.708 510.227C66.708 511.67 67.8835 512.858 69.3434 512.858C70.8032 512.858 71.966 511.682 71.966 510.227C71.966 508.771 70.7905 507.596 69.3434 507.596Z"
            fill="white"
          />
          <path
            d="M70.2251 505.316C68.7355 505.316 67.5303 506.526 67.5303 508.011C67.5303 509.496 68.7397 510.706 70.2251 510.706C71.7104 510.706 72.9198 509.501 72.9198 508.011C72.9198 506.522 71.7146 505.316 70.2251 505.316Z"
            fill="white"
          />
          <path
            d="M71.0787 503.109C69.5595 503.109 68.3203 504.349 68.3203 505.868C68.3203 507.387 69.5595 508.635 71.0787 508.635C72.598 508.635 73.8457 507.396 73.8457 505.868C73.8457 504.34 72.6065 503.109 71.0787 503.109Z"
            fill="white"
          />
          <path
            d="M71.8176 500.902C70.2474 500.902 68.9658 502.171 68.9658 503.746C68.9658 505.32 70.2474 506.597 71.8176 506.597C73.3878 506.597 74.6694 505.329 74.6694 503.746C74.6694 502.163 73.3878 500.902 71.8176 500.902Z"
            fill="white"
          />
          <path
            d="M72.3393 498.688C70.7351 498.688 69.4365 499.99 69.4365 501.603C69.4365 503.216 70.7394 504.518 72.3393 504.518C73.9391 504.518 75.2547 503.207 75.2547 501.603C75.2547 499.999 73.9519 498.688 72.3393 498.688Z"
            fill="white"
          />
          <path
            d="M72.5767 496.416C70.9429 496.416 69.6104 497.736 69.6104 499.374C69.6104 501.012 70.9429 502.34 72.5767 502.34C74.2106 502.34 75.5346 501.02 75.5346 499.374C75.5346 497.727 74.2106 496.416 72.5767 496.416Z"
            fill="white"
          />
          <path
            d="M72.4831 494.053C70.8196 494.053 69.4658 495.407 69.4658 497.07C69.4658 498.734 70.8196 500.087 72.4831 500.087C74.1467 500.087 75.5004 498.734 75.5004 497.07C75.5004 495.407 74.1467 494.053 72.4831 494.053Z"
            fill="white"
          />
          <path
            d="M72.0462 491.566C70.3275 491.566 68.9355 492.95 68.9355 494.669C68.9355 496.387 70.3317 497.779 72.0462 497.779C73.7607 497.779 75.1484 496.383 75.1484 494.669C75.1484 492.954 73.7522 491.566 72.0462 491.566Z"
            fill="white"
          />
          <path
            d="M71.2488 489.016C69.5089 489.016 68.0957 490.433 68.0957 492.169C68.0957 493.904 69.5131 495.322 71.2488 495.322C72.9845 495.322 74.4019 493.917 74.4019 492.169C74.4019 490.42 72.9845 489.016 71.2488 489.016Z"
            fill="white"
          />
          <path
            d="M70.1328 486.393C68.3546 486.393 66.916 487.84 66.916 489.609C66.916 491.379 68.3504 492.826 70.1328 492.826C71.9152 492.826 73.3368 491.379 73.3368 489.609C73.3368 487.84 71.8982 486.393 70.1328 486.393Z"
            fill="white"
          />
          <path
            d="M68.6977 483.721C66.8983 483.721 65.4385 485.189 65.4385 486.988C65.4385 488.788 66.8941 490.248 68.6977 490.248C70.5013 490.248 71.9569 488.792 71.9569 486.988C71.9569 485.185 70.5013 483.721 68.6977 483.721Z"
            fill="white"
          />
          <path
            d="M66.928 480.961C65.0862 480.961 63.5967 482.459 63.5967 484.301C63.5967 486.143 65.0862 487.632 66.928 487.632C68.7698 487.632 70.2679 486.143 70.2679 484.301C70.2679 482.459 68.7698 480.961 66.928 480.961Z"
            fill="white"
          />
          <path
            d="M64.8227 478.182C62.9512 478.182 61.4404 479.692 61.4404 481.564C61.4404 483.435 62.9512 484.946 64.8227 484.946C66.6942 484.946 68.205 483.427 68.205 481.564C68.205 479.701 66.6857 478.182 64.8227 478.182Z"
            fill="white"
          />
          <path
            d="M62.3502 475.32C60.4575 475.32 58.917 476.861 58.917 478.766C58.917 480.672 60.4575 482.199 62.3502 482.199C64.2429 482.199 65.7834 480.659 65.7834 478.766C65.7834 476.874 64.2514 475.32 62.3502 475.32Z"
            fill="white"
          />
          <path
            d="M59.4971 472.426C57.5705 472.426 56.0215 473.979 56.0215 475.901C56.0215 477.824 57.5705 479.377 59.4971 479.377C61.4238 479.377 62.9727 477.815 62.9727 475.901C62.9727 473.988 61.4195 472.426 59.4971 472.426Z"
            fill="white"
          />
          <path
            d="M56.247 469.439C54.2906 469.439 52.6992 471.031 52.6992 472.987C52.6992 474.944 54.2906 476.527 56.247 476.527C58.2034 476.527 59.7863 474.944 59.7863 472.987C59.7863 471.031 58.2034 469.439 56.247 469.439Z"
            fill="white"
          />
          <path
            d="M52.597 466.43C50.611 466.43 49.0068 468.034 49.0068 470.011C49.0068 471.989 50.611 473.602 52.597 473.602C54.5831 473.602 56.1788 471.989 56.1788 470.011C56.1788 468.034 54.5746 466.43 52.597 466.43Z"
            fill="white"
          />
          <path
            d="M48.5144 463.369C46.5156 463.369 44.8945 464.995 44.8945 466.989C44.8945 468.984 46.5199 470.601 48.5144 470.601C50.509 470.601 52.1344 468.988 52.1344 466.989C52.1344 464.99 50.509 463.369 48.5144 463.369Z"
            fill="white"
          />
          <path
            d="M44.0201 460.26C42.0001 460.26 40.3662 461.894 40.3662 463.922C40.3662 465.951 42.0001 467.576 44.0201 467.576C46.0401 467.576 47.6824 465.942 47.6824 463.922C47.6824 461.902 46.0486 460.26 44.0201 460.26Z"
            fill="white"
          />
          <path
            d="M39.1059 457.086C37.0561 457.086 35.3926 458.749 35.3926 460.803C35.3926 462.857 37.0561 464.521 39.1059 464.521C41.1556 464.521 42.8234 462.857 42.8234 460.803C42.8234 458.749 41.1598 457.086 39.1059 457.086Z"
            fill="white"
          />
          <path
            d="M33.7755 453.883C31.7046 453.883 30.0283 455.568 30.0283 457.639C30.0283 459.709 31.7046 461.386 33.7755 461.386C35.8465 461.386 37.5228 459.709 37.5228 457.639C37.5228 455.568 35.8465 453.883 33.7755 453.883Z"
            fill="white"
          />
          <path
            d="M28.0553 450.631C25.9631 450.631 24.2656 452.328 24.2656 454.421C24.2656 456.513 25.9631 458.197 28.0553 458.197C30.1475 458.197 31.8322 456.513 31.8322 454.421C31.8322 452.328 30.1347 450.631 28.0553 450.631Z"
            fill="white"
          />
          <path
            d="M21.9447 447.342C19.844 447.342 18.1338 449.048 18.1338 451.153C18.1338 453.258 19.8398 454.964 21.9447 454.964C24.0496 454.964 25.7556 453.258 25.7556 451.153C25.7556 449.048 24.0496 447.342 21.9447 447.342Z"
            fill="white"
          />
          <path
            d="M15.481 443.994C13.3463 443.994 11.6191 445.721 11.6191 447.843C11.6191 449.965 13.3463 451.705 15.481 451.705C17.6156 451.705 19.33 449.978 19.33 447.843C19.33 445.709 17.6028 443.994 15.481 443.994Z"
            fill="white"
          />
          <path
            d="M8.67405 440.547C6.53095 440.547 4.79102 442.287 4.79102 444.43C4.79102 446.573 6.53095 448.313 8.67405 448.313C10.8171 448.313 12.5571 446.573 12.5571 444.43C12.5571 442.287 10.8214 440.547 8.67405 440.547Z"
            fill="white"
          />
          <path
            d="M1.55269 436.924C-0.603138 436.924 -2.35156 438.685 -2.35156 440.837C-2.35156 442.988 -0.603138 444.749 1.55269 444.749C3.70851 444.749 5.46542 443.001 5.46542 440.837C5.46542 438.672 3.717 436.924 1.55269 436.924Z"
            fill="white"
          />
          <path
            d="M1.91027 114.385C0.110916 114.385 -1.35742 115.849 -1.35742 117.652C-1.35742 119.456 0.110916 120.92 1.91027 120.92C3.70962 120.92 5.19068 119.465 5.19068 117.652C5.19068 115.84 3.72235 114.385 1.91027 114.385Z"
            fill="white"
          />
          <path
            d="M10.9443 101.998C9.16617 101.998 7.72754 103.445 7.72754 105.223C7.72754 107.001 9.16193 108.444 10.9443 108.444C12.7267 108.444 14.1696 107.001 14.1696 105.223C14.1696 103.445 12.7224 101.998 10.9443 101.998Z"
            fill="white"
          />
          <path
            d="M19.6736 89.623C17.9252 89.623 16.5078 91.032 16.5078 92.7761C16.5078 94.5203 17.9252 95.942 19.6736 95.942C21.4221 95.942 22.8352 94.5246 22.8352 92.7761C22.8352 91.0277 21.4178 89.623 19.6736 89.623Z"
            fill="white"
          />
          <path
            d="M27.8046 77.5195C26.1071 77.5195 24.7236 78.903 24.7236 80.609C24.7236 82.315 26.1071 83.6899 27.8046 83.6899C29.5021 83.6899 30.894 82.3065 30.894 80.609C30.894 78.9115 29.5106 77.5195 27.8046 77.5195Z"
            fill="white"
          />
          <path
            d="M35.0867 66.1777C33.4104 66.1777 32.0566 67.5315 32.0566 69.1993C32.0566 70.8671 33.4104 72.2208 35.0867 72.2208C36.763 72.2208 38.1167 70.8671 38.1167 69.1993C38.1167 67.5315 36.7545 66.1777 35.0867 66.1777Z"
            fill="white"
          />
          <path
            d="M41.4055 61.9165C43.0485 61.9165 44.3804 60.5846 44.3804 58.9417C44.3804 57.2987 43.0485 55.9668 41.4055 55.9668C39.7626 55.9668 38.4307 57.2987 38.4307 58.9417C38.4307 60.5846 39.7626 61.9165 41.4055 61.9165Z"
            fill="white"
          />
          <path
            d="M46.8012 46.9512C45.1971 46.9512 43.8857 48.2625 43.8857 49.8666C43.8857 51.4708 45.1971 52.7821 46.8012 52.7821C48.4053 52.7821 49.7167 51.4793 49.7167 49.8666C49.7167 48.254 48.4138 46.9512 46.8012 46.9512Z"
            fill="white"
          />
          <path
            d="M51.4383 38.9707C49.8766 38.9707 48.6162 40.2396 48.6162 41.7928C48.6162 43.346 49.8766 44.6149 51.4383 44.6149C53 44.6149 54.2604 43.3545 54.2604 41.7928C54.2604 40.2311 52.9915 38.9707 51.4383 38.9707Z"
            fill="white"
          />
          <path
            d="M55.4574 31.7305C53.9254 31.7305 52.6904 32.9654 52.6904 34.4932C52.6904 36.0209 53.9296 37.2516 55.4574 37.2516C56.9851 37.2516 58.2158 36.0124 58.2158 34.4932C58.2158 32.9739 56.9766 31.7305 55.4574 31.7305Z"
            fill="white"
          />
          <path
            d="M59.017 24.9922C57.5275 24.9922 56.3223 26.2059 56.3223 27.6997C56.3223 29.1935 57.5317 30.3945 59.017 30.3945C60.5024 30.3945 61.7246 29.185 61.7246 27.6997C61.7246 26.2144 60.5066 24.9922 59.017 24.9922Z"
            fill="white"
          />
          <path
            d="M62.3362 18.4766C60.8806 18.4766 59.7051 19.6563 59.7051 21.1119C59.7051 22.5675 60.8806 23.7515 62.3362 23.7515C63.7918 23.7515 64.9716 22.5718 64.9716 21.1119C64.9716 19.6521 63.7961 18.4766 62.3362 18.4766Z"
            fill="white"
          />
          <path
            d="M65.5954 11.8867C64.1907 11.8867 63.0449 13.0198 63.0449 14.4245C63.0449 15.8292 64.1907 16.9707 65.5954 16.9707C67.0001 16.9707 68.1332 15.8334 68.1332 14.4245C68.1332 13.0156 67.0001 11.8867 65.5954 11.8867Z"
            fill="white"
          />
          <path
            d="M68.9859 4.69727C67.6109 4.69727 66.499 5.80913 66.499 7.1841C66.499 8.55908 67.6109 9.66245 68.9859 9.66245C70.3608 9.66245 71.4642 8.55483 71.4642 7.1841C71.4642 5.81337 70.3608 4.69727 68.9859 4.69727Z"
            fill="white"
          />
          <path
            d="M72.7753 -3.62891C71.4428 -3.62891 70.3691 -2.54675 70.3691 -1.21846C70.3691 0.109837 71.4428 1.19199 72.7753 1.19199C74.1079 1.19199 75.1816 0.109837 75.1816 -1.21846C75.1816 -2.54675 74.1079 -3.62891 72.7753 -3.62891Z"
            fill="white"
          />
          <path
            d="M1005.04 -1.72656C1003.58 -1.72656 1002.38 -0.529825 1002.38 0.938512C1002.38 2.40685 1003.58 3.60359 1005.04 3.60359C1006.51 3.60359 1007.71 2.41534 1007.71 0.938512C1007.71 -0.538313 1006.52 -1.72656 1005.04 -1.72656Z"
            fill="white"
          />
          <path
            d="M1012.16 9.98438C1010.65 9.98438 1009.43 11.2066 1009.43 12.7131C1009.43 14.2196 1010.65 15.4418 1012.16 15.4418C1013.67 15.4418 1014.89 14.2239 1014.89 12.7131C1014.89 11.2023 1013.66 9.98438 1012.16 9.98438Z"
            fill="white"
          />
          <path
            d="M1019.4 21.4863C1017.86 21.4863 1016.62 22.734 1016.62 24.2745C1016.62 25.815 1017.86 27.0584 1019.4 27.0584C1020.94 27.0584 1022.19 25.815 1022.19 24.2745C1022.19 22.734 1020.94 21.4863 1019.4 21.4863Z"
            fill="white"
          />
          <path
            d="M1026.87 32.6094C1025.28 32.6094 1023.99 33.8995 1023.99 35.4909C1023.99 37.0823 1025.28 38.3639 1026.87 38.3639C1028.46 38.3639 1029.74 37.0738 1029.74 35.4909C1029.74 33.908 1028.45 32.6094 1026.87 32.6094Z"
            fill="white"
          />
          <path
            d="M1034.49 43.4766C1032.88 43.4766 1031.57 44.7879 1031.57 46.4132C1031.57 48.0386 1032.88 49.3499 1034.49 49.3499C1036.11 49.3499 1037.43 48.0344 1037.43 46.4132C1037.43 44.7921 1036.12 43.4766 1034.49 43.4766Z"
            fill="white"
          />
          <path
            d="M1042.32 54.0293C1040.67 54.0293 1039.33 55.3703 1039.33 57.0211C1039.33 58.672 1040.67 60.013 1042.32 60.013C1043.98 60.013 1045.31 58.672 1045.31 57.0211C1045.31 55.3703 1043.97 54.0293 1042.32 54.0293Z"
            fill="white"
          />
          <path
            d="M1050.22 64.4375C1048.55 64.4375 1047.18 65.7955 1047.18 67.4718C1047.18 69.1481 1048.55 70.5061 1050.22 70.5061C1051.9 70.5061 1053.26 69.1523 1053.26 67.4718C1053.26 65.7913 1051.9 64.4375 1050.22 64.4375Z"
            fill="white"
          />
          <path
            d="M1058.16 74.7051C1056.43 74.7051 1055.04 76.1055 1055.04 77.8327C1055.04 79.5599 1056.43 80.9561 1058.16 80.9561C1059.89 80.9561 1061.28 79.5599 1061.28 77.8327C1061.28 76.1055 1059.89 74.7051 1058.16 74.7051Z"
            fill="white"
          />
          <path
            d="M1066.16 84.8887C1064.4 84.8887 1062.97 86.3146 1062.97 88.0757C1062.97 89.8369 1064.4 91.2628 1066.16 91.2628C1067.91 91.2628 1069.34 89.8369 1069.34 88.0757C1069.34 86.3146 1067.92 84.8887 1066.16 84.8887Z"
            fill="white"
          />
          <path
            d="M1074.17 95.0254C1072.38 95.0254 1070.93 96.4725 1070.93 98.2634C1070.93 100.054 1072.38 101.493 1074.17 101.493C1075.96 101.493 1077.41 100.046 1077.41 98.2634C1077.41 96.481 1075.96 95.0254 1074.17 95.0254Z"
            fill="white"
          />
          <path
            d="M1082.16 105.15C1080.35 105.15 1078.89 106.627 1078.89 108.439C1078.89 110.251 1080.36 111.728 1082.16 111.728C1083.97 111.728 1085.45 110.251 1085.45 108.439C1085.45 106.627 1083.99 105.15 1082.16 105.15Z"
            fill="white"
          />
          <path
            d="M1090.1 115.324C1088.25 115.324 1086.74 116.827 1086.74 118.685C1086.74 120.544 1088.25 122.059 1090.1 122.059C1091.95 122.059 1093.48 120.548 1093.48 118.685C1093.48 116.822 1091.97 115.324 1090.1 115.324Z"
            fill="white"
          />
          <path
            d="M1097.94 125.688C1096.06 125.688 1094.53 127.211 1094.53 129.095C1094.53 130.979 1096.06 132.503 1097.94 132.503C1099.83 132.503 1101.35 130.975 1101.35 129.095C1101.35 127.215 1099.83 125.688 1097.94 125.688Z"
            fill="white"
          />
          <path
            d="M1105.64 136.242C1103.73 136.242 1102.18 137.791 1102.18 139.709C1102.18 141.627 1103.73 143.176 1105.64 143.176C1107.56 143.176 1109.11 141.627 1109.11 139.709C1109.11 137.791 1107.56 136.242 1105.64 136.242Z"
            fill="white"
          />
          <path
            d="M1113.22 147.023C1111.29 147.023 1109.71 148.594 1109.71 150.537C1109.71 152.481 1111.28 154.051 1113.22 154.051C1115.16 154.051 1116.74 152.481 1116.74 150.537C1116.74 148.594 1115.17 147.023 1113.22 147.023Z"
            fill="white"
          />
          <path
            d="M1120.66 158.037C1118.7 158.037 1117.09 159.641 1117.09 161.606C1117.09 163.571 1118.7 165.179 1120.66 165.179C1122.63 165.179 1124.23 163.584 1124.23 161.606C1124.23 159.629 1122.64 158.037 1120.66 158.037Z"
            fill="white"
          />
          <path
            d="M1127.97 169.309C1125.97 169.309 1124.36 170.921 1124.36 172.92C1124.36 174.919 1125.97 176.54 1127.97 176.54C1129.97 176.54 1131.59 174.915 1131.59 172.92C1131.59 170.925 1129.97 169.309 1127.97 169.309Z"
            fill="white"
          />
          <path
            d="M1135.18 180.758C1133.16 180.758 1131.53 182.392 1131.53 184.42C1131.53 186.449 1133.16 188.083 1135.18 188.083C1137.2 188.083 1138.84 186.436 1138.84 184.42C1138.84 182.404 1137.21 180.758 1135.18 180.758Z"
            fill="white"
          />
          <path
            d="M1142.34 192.33C1140.3 192.33 1138.65 193.985 1138.65 196.031C1138.65 198.076 1140.3 199.731 1142.34 199.731C1144.39 199.731 1146.05 198.076 1146.05 196.031C1146.05 193.985 1144.39 192.33 1142.34 192.33Z"
            fill="white"
          />
          <path
            d="M1149.57 203.811C1147.48 203.811 1145.8 205.495 1145.8 207.579C1145.8 209.663 1147.48 211.347 1149.57 211.347C1151.65 211.347 1153.34 209.663 1153.34 207.579C1153.34 205.495 1151.65 203.811 1149.57 203.811Z"
            fill="white"
          />
          <path
            d="M1156.98 214.988C1154.89 214.988 1153.19 216.686 1153.19 218.786C1153.19 220.887 1154.89 222.585 1156.98 222.585C1159.08 222.585 1160.8 220.887 1160.8 218.786C1160.8 216.686 1159.09 214.988 1156.98 214.988Z"
            fill="white"
          />
          <path
            d="M1164.67 225.699C1162.54 225.699 1160.82 227.426 1160.82 229.548C1160.82 231.67 1162.54 233.389 1164.67 233.389C1166.79 233.389 1168.51 231.662 1168.51 229.548C1168.51 227.435 1166.79 225.699 1164.67 225.699Z"
            fill="white"
          />
          <path
            d="M1172.6 235.896C1170.46 235.896 1168.73 237.636 1168.73 239.767C1168.73 241.897 1170.46 243.637 1172.6 243.637C1174.73 243.637 1176.48 241.91 1176.48 239.767C1176.48 237.624 1174.75 235.896 1172.6 235.896Z"
            fill="white"
          />
          <path
            d="M1180.86 253.238C1183.03 253.238 1184.79 251.48 1184.79 249.312C1184.79 247.144 1183.03 245.387 1180.86 245.387C1178.69 245.387 1176.94 247.144 1176.94 249.312C1176.94 251.48 1178.69 253.238 1180.86 253.238Z"
            fill="white"
          />
          <path
            d="M1189.45 254.182C1187.27 254.182 1185.5 255.951 1185.5 258.137C1185.5 260.322 1187.27 262.092 1189.45 262.092C1191.64 262.092 1193.4 260.322 1193.4 258.137C1193.4 255.951 1191.63 254.182 1189.45 254.182Z"
            fill="white"
          />
          <path
            d="M1198.35 262.207C1196.16 262.207 1194.37 263.998 1194.37 266.192C1194.37 268.386 1196.15 270.177 1198.35 270.177C1200.55 270.177 1202.33 268.386 1202.33 266.192C1202.33 263.998 1200.56 262.207 1198.35 262.207Z"
            fill="white"
          />
          <path
            d="M1207.57 269.461C1205.36 269.461 1203.56 271.252 1203.56 273.467C1203.56 275.682 1205.36 277.486 1207.57 277.486C1209.77 277.486 1211.59 275.687 1211.59 273.467C1211.59 271.248 1209.79 269.461 1207.57 269.461Z"
            fill="white"
          />
          <path
            d="M1217.09 275.902C1214.85 275.902 1213.04 277.723 1213.04 279.964C1213.04 282.204 1214.85 284.021 1217.09 284.021C1219.33 284.021 1221.15 282.2 1221.15 279.964C1221.15 277.727 1219.34 275.902 1217.09 275.902Z"
            fill="white"
          />
          <path
            d="M1226.9 281.619C1224.65 281.619 1222.82 283.44 1222.82 285.689C1222.82 287.938 1224.65 289.767 1226.9 289.767C1229.14 289.767 1230.97 287.947 1230.97 285.689C1230.97 283.431 1229.15 281.619 1226.9 281.619Z"
            fill="white"
          />
          <path
            d="M1236.95 286.521C1234.68 286.521 1232.85 288.363 1232.85 290.634C1232.85 292.904 1234.68 294.733 1236.95 294.733C1239.22 294.733 1241.06 292.9 1241.06 290.634C1241.06 288.368 1239.22 286.521 1236.95 286.521Z"
            fill="white"
          />
          <path
            d="M1247.24 290.643C1244.97 290.643 1243.13 292.484 1243.13 294.755C1243.13 297.025 1244.97 298.875 1247.24 298.875C1249.51 298.875 1251.36 297.034 1251.36 294.755C1251.36 292.476 1249.52 290.643 1247.24 290.643Z"
            fill="white"
          />
          <path
            d="M1257.72 293.93C1255.42 293.93 1253.57 295.793 1253.57 298.084C1253.57 300.376 1255.43 302.226 1257.72 302.226C1260 302.226 1261.87 300.372 1261.87 298.084C1261.87 295.797 1260.02 293.93 1257.72 293.93Z"
            fill="white"
          />
          <path
            d="M1268.31 296.473C1266.02 296.473 1264.15 298.336 1264.15 300.627C1264.15 302.919 1266.02 304.782 1268.31 304.782C1270.6 304.782 1272.46 302.919 1272.46 300.627C1272.46 298.336 1270.61 296.473 1268.31 296.473Z"
            fill="white"
          />
          <path
            d="M1278.97 298.264C1276.67 298.264 1274.81 300.114 1274.81 302.418C1274.81 304.723 1276.66 306.569 1278.97 306.569C1281.27 306.569 1283.12 304.706 1283.12 302.418C1283.12 300.131 1281.26 298.264 1278.97 298.264Z"
            fill="white"
          />
          <path
            d="M1289.63 299.26C1287.33 299.26 1285.47 301.123 1285.47 303.423C1285.47 305.723 1287.32 307.578 1289.63 307.578C1291.93 307.578 1293.78 305.715 1293.78 303.423C1293.78 301.131 1291.92 299.26 1289.63 299.26Z"
            fill="white"
          />
          <path
            d="M1300.22 299.531C1297.93 299.531 1296.07 301.394 1296.07 303.686C1296.07 305.977 1297.93 307.841 1300.22 307.841C1302.51 307.841 1304.38 305.99 1304.38 303.686C1304.38 301.382 1302.53 299.531 1300.22 299.531Z"
            fill="white"
          />
          <path
            d="M1310.7 299.135C1308.4 299.135 1306.54 300.998 1306.54 303.289C1306.54 305.581 1308.4 307.444 1310.7 307.444C1313 307.444 1314.85 305.594 1314.85 303.289C1314.85 300.985 1312.99 299.135 1310.7 299.135Z"
            fill="white"
          />
          <path
            d="M1320.97 298.166C1318.68 298.166 1316.82 300.029 1316.82 302.321C1316.82 304.612 1318.68 306.475 1320.97 306.475C1323.26 306.475 1325.13 304.621 1325.13 302.321C1325.13 300.021 1323.27 298.166 1320.97 298.166Z"
            fill="white"
          />
          <path
            d="M1331.03 296.701C1328.74 296.701 1326.87 298.551 1326.87 300.856C1326.87 303.16 1328.74 305.01 1331.03 305.01C1333.32 305.01 1335.18 303.147 1335.18 300.856C1335.18 298.564 1333.32 296.701 1331.03 296.701Z"
            fill="white"
          />
          <path
            d="M1340.83 294.752C1338.55 294.752 1336.68 296.615 1336.68 298.915C1336.68 301.215 1338.54 303.07 1340.83 303.07C1343.13 303.07 1344.99 301.207 1344.99 298.915C1344.99 296.623 1343.13 294.752 1340.83 294.752Z"
            fill="white"
          />
          <path
            d="M1337.28 297.242C1334.99 297.242 1333.13 299.105 1333.13 301.397C1333.13 303.688 1334.99 305.551 1337.28 305.551C1339.57 305.551 1341.44 303.688 1341.44 301.397C1341.44 299.105 1339.57 297.242 1337.28 297.242Z"
            fill="white"
          />
          <path
            d="M1333.53 299.52C1331.23 299.52 1329.38 301.383 1329.38 303.674C1329.38 305.966 1331.23 307.829 1333.53 307.829C1335.83 307.829 1337.68 305.974 1337.68 303.674C1337.68 301.374 1335.82 299.52 1333.53 299.52Z"
            fill="white"
          />
          <path
            d="M1329.46 301.654C1327.16 301.654 1325.31 303.517 1325.31 305.809C1325.31 308.101 1327.16 309.964 1329.46 309.964C1331.76 309.964 1333.62 308.101 1333.62 305.809C1333.62 303.517 1331.75 301.654 1329.46 301.654Z"
            fill="white"
          />
          <path
            d="M1325.03 303.674C1322.73 303.674 1320.88 305.524 1320.88 307.828C1320.88 310.133 1322.73 311.983 1325.03 311.983C1327.33 311.983 1329.19 310.12 1329.19 307.828C1329.19 305.537 1327.33 303.674 1325.03 303.674Z"
            fill="white"
          />
          <path
            d="M1320.16 305.602C1317.86 305.602 1316 307.465 1316 309.756C1316 312.048 1317.86 313.911 1320.16 313.911C1322.46 313.911 1324.32 312.048 1324.32 309.756C1324.32 307.465 1322.45 305.602 1320.16 305.602Z"
            fill="white"
          />
          <path
            d="M1314.79 307.451C1312.5 307.451 1310.64 309.314 1310.64 311.606C1310.64 313.897 1312.5 315.76 1314.79 315.76C1317.08 315.76 1318.95 313.897 1318.95 311.606C1318.95 309.314 1317.09 307.451 1314.79 307.451Z"
            fill="white"
          />
          <path
            d="M1308.91 309.221C1306.62 309.221 1304.76 311.075 1304.76 313.375C1304.76 315.675 1306.62 317.53 1308.91 317.53C1311.2 317.53 1313.07 315.667 1313.07 313.375C1313.07 311.084 1311.21 309.221 1308.91 309.221Z"
            fill="white"
          />
          <path
            d="M1302.49 310.865C1300.2 310.865 1298.33 312.728 1298.33 315.02C1298.33 317.311 1300.2 319.174 1302.49 319.174C1304.78 319.174 1306.64 317.32 1306.64 315.02C1306.64 312.72 1304.79 310.865 1302.49 310.865Z"
            fill="white"
          />
          <path
            d="M1295.54 312.354C1293.24 312.354 1291.38 314.217 1291.38 316.508C1291.38 318.8 1293.24 320.663 1295.54 320.663C1297.84 320.663 1299.69 318.808 1299.69 316.508C1299.69 314.208 1297.83 312.354 1295.54 312.354Z"
            fill="white"
          />
          <path
            d="M1288.05 313.633C1285.77 313.633 1283.9 315.496 1283.9 317.787C1283.9 320.079 1285.76 321.942 1288.05 321.942C1290.35 321.942 1292.21 320.092 1292.21 317.787C1292.21 315.483 1290.35 313.633 1288.05 313.633Z"
            fill="white"
          />
          <path
            d="M1280.08 314.645C1277.78 314.645 1275.92 316.495 1275.92 318.799C1275.92 321.104 1277.77 322.954 1280.08 322.954C1282.38 322.954 1284.23 321.091 1284.23 318.799C1284.23 316.508 1282.37 314.645 1280.08 314.645Z"
            fill="white"
          />
          <path
            d="M1271.64 315.34C1269.35 315.34 1267.48 317.203 1267.48 319.494C1267.48 321.786 1269.35 323.649 1271.64 323.649C1273.93 323.649 1275.79 321.799 1275.79 319.494C1275.79 317.19 1273.94 315.34 1271.64 315.34Z"
            fill="white"
          />
          <path
            d="M1262.78 315.748C1260.48 315.748 1258.63 317.611 1258.63 319.903C1258.63 322.194 1260.48 324.057 1262.78 324.057C1265.09 324.057 1266.92 322.203 1266.92 319.903C1266.92 317.603 1265.07 315.748 1262.78 315.748Z"
            fill="white"
          />
          <path
            d="M1253.52 315.861C1251.25 315.861 1249.4 317.703 1249.4 319.982C1249.4 322.261 1251.25 324.103 1253.52 324.103C1255.78 324.103 1257.65 322.261 1257.65 319.982C1257.65 317.703 1255.8 315.861 1253.52 315.861Z"
            fill="white"
          />
          <path
            d="M1243.92 315.592C1241.65 315.592 1239.8 317.434 1239.8 319.704C1239.8 321.974 1241.65 323.816 1243.92 323.816C1246.19 323.816 1248.03 321.974 1248.03 319.704C1248.03 317.434 1246.19 315.592 1243.92 315.592Z"
            fill="white"
          />
          <path
            d="M1234.01 314.945C1231.75 314.945 1229.93 316.779 1229.93 319.024C1229.93 321.268 1231.75 323.102 1234.01 323.102C1236.26 323.102 1238.08 321.281 1238.08 319.024C1238.08 316.766 1236.25 314.945 1234.01 314.945Z"
            fill="white"
          />
          <path
            d="M1223.82 313.938C1221.59 313.938 1219.78 315.75 1219.78 317.986C1219.78 320.222 1221.59 322.035 1223.82 322.035C1226.06 322.035 1227.87 320.222 1227.87 317.986C1227.87 315.75 1226.06 313.938 1223.82 313.938Z"
            fill="white"
          />
          <path
            d="M1213.41 320.719C1215.63 320.719 1217.43 318.92 1217.43 316.7C1217.43 314.481 1215.63 312.682 1213.41 312.682C1211.19 312.682 1209.39 314.481 1209.39 316.7C1209.39 318.92 1211.19 320.719 1213.41 320.719Z"
            fill="white"
          />
          <path
            d="M1202.73 311.25C1200.54 311.25 1198.74 313.041 1198.74 315.248C1198.74 317.454 1200.54 319.232 1202.73 319.232C1204.92 319.232 1206.73 317.454 1206.73 315.248C1206.73 313.041 1204.94 311.25 1202.73 311.25Z"
            fill="white"
          />
          <path
            d="M1191.8 309.709C1189.62 309.709 1187.86 311.479 1187.86 313.664C1187.86 315.85 1189.63 317.607 1191.8 317.607C1193.97 317.607 1195.76 315.85 1195.76 313.664C1195.76 311.479 1193.99 309.709 1191.8 309.709Z"
            fill="white"
          />
          <path
            d="M1180.63 308.139C1178.47 308.139 1176.71 309.887 1176.71 312.051C1176.71 314.216 1178.47 315.977 1180.63 315.977C1182.8 315.977 1184.56 314.216 1184.56 312.051C1184.56 309.887 1182.8 308.139 1180.63 308.139Z"
            fill="white"
          />
          <path
            d="M1169.26 306.605C1167.1 306.605 1165.37 308.354 1165.37 310.497C1165.37 312.64 1167.11 314.389 1169.26 314.389C1171.41 314.389 1173.14 312.64 1173.14 310.497C1173.14 308.354 1171.4 306.605 1169.26 306.605Z"
            fill="white"
          />
          <path
            d="M1157.66 305.215C1155.53 305.215 1153.8 306.942 1153.8 309.077C1153.8 311.211 1155.53 312.926 1157.66 312.926C1159.8 312.926 1161.51 311.199 1161.51 309.077C1161.51 306.955 1159.79 305.215 1157.66 305.215Z"
            fill="white"
          />
          <path
            d="M1145.88 304.018C1143.78 304.018 1142.08 305.715 1142.08 307.816C1142.08 309.916 1143.78 311.614 1145.88 311.614C1147.98 311.614 1149.68 309.908 1149.68 307.816C1149.68 305.724 1147.98 304.018 1145.88 304.018Z"
            fill="white"
          />
          <path
            d="M1133.93 303.051C1131.85 303.051 1130.17 304.736 1130.17 306.819C1130.17 308.903 1131.85 310.588 1133.93 310.588C1136.02 310.588 1137.7 308.903 1137.7 306.819C1137.7 304.736 1136.02 303.051 1133.93 303.051Z"
            fill="white"
          />
          <path
            d="M1121.82 302.436C1119.76 302.436 1118.09 304.099 1118.09 306.162C1118.09 308.224 1119.76 309.888 1121.82 309.888C1123.88 309.888 1125.54 308.224 1125.54 306.162C1125.54 304.099 1123.87 302.436 1121.82 302.436Z"
            fill="white"
          />
          <path
            d="M1109.56 302.227C1107.53 302.227 1105.88 303.882 1105.88 305.91C1105.88 307.939 1107.53 309.594 1109.56 309.594C1111.59 309.594 1113.24 307.947 1113.24 305.91C1113.24 303.873 1111.59 302.227 1109.56 302.227Z"
            fill="white"
          />
          <path
            d="M1097.12 302.457C1095.11 302.457 1093.5 304.082 1093.5 306.077C1093.5 308.071 1095.11 309.697 1097.12 309.697C1099.13 309.697 1100.74 308.076 1100.74 306.077C1100.74 304.078 1099.11 302.457 1097.12 302.457Z"
            fill="white"
          />
          <path
            d="M1084.49 303.174C1082.51 303.174 1080.9 304.778 1080.9 306.756C1080.9 308.733 1082.51 310.337 1084.49 310.337C1086.46 310.337 1088.05 308.733 1088.05 306.756C1088.05 304.778 1086.46 303.174 1084.49 303.174Z"
            fill="white"
          />
          <path
            d="M1071.72 304.514C1069.76 304.514 1068.18 306.097 1068.18 308.053C1068.18 310.009 1069.76 311.584 1071.72 311.584C1073.67 311.584 1075.24 310.001 1075.24 308.053C1075.24 306.105 1073.66 304.514 1071.72 304.514Z"
            fill="white"
          />
          <path
            d="M1058.75 306.533C1056.81 306.533 1055.25 308.095 1055.25 310.022C1055.25 311.948 1056.81 313.51 1058.75 313.51C1060.68 313.51 1062.24 311.948 1062.24 310.022C1062.24 308.095 1060.67 306.533 1058.75 306.533Z"
            fill="white"
          />
          <path
            d="M1045.54 309.307C1043.66 309.307 1042.13 310.839 1042.13 312.719C1042.13 314.599 1043.66 316.135 1045.54 316.135C1047.43 316.135 1048.97 314.603 1048.97 312.719C1048.97 310.834 1047.43 309.307 1045.54 309.307Z"
            fill="white"
          />
          <path
            d="M1032.16 312.988C1030.31 312.988 1028.8 314.499 1028.8 316.349C1028.8 318.2 1030.31 319.71 1032.16 319.71C1034.02 319.71 1035.53 318.2 1035.53 316.349C1035.53 314.499 1034.03 312.988 1032.16 312.988Z"
            fill="white"
          />
          <path
            d="M1018.55 317.799C1016.72 317.799 1015.23 319.276 1015.23 321.109C1015.23 322.942 1016.72 324.419 1018.55 324.419C1020.38 324.419 1021.86 322.942 1021.86 321.109C1021.86 319.276 1020.37 317.799 1018.55 317.799Z"
            fill="white"
          />
          <path
            d="M1004.76 323.959C1002.95 323.959 1001.5 325.415 1001.5 327.227C1001.5 329.039 1002.95 330.494 1004.76 330.494C1006.57 330.494 1008.03 329.026 1008.03 327.227C1008.03 325.427 1006.56 323.959 1004.76 323.959Z"
            fill="white"
          />
          <path
            d="M990.814 331.799C989.066 331.799 987.64 333.225 987.64 334.986C987.64 336.747 989.066 338.169 990.814 338.169C992.562 338.169 994.001 336.743 994.001 334.986C994.001 333.229 992.575 331.799 990.814 331.799Z"
            fill="white"
          />
          <path
            d="M977.026 341.893C975.299 341.893 973.895 343.289 973.895 345.024C973.895 346.76 975.299 348.156 977.026 348.156C978.754 348.156 980.158 346.752 980.158 345.024C980.158 343.297 978.754 341.893 977.026 341.893Z"
            fill="white"
          />
          <path
            d="M963.671 354.799C961.973 354.799 960.59 356.182 960.59 357.88C960.59 359.577 961.973 360.961 963.671 360.961C965.368 360.961 966.76 359.586 966.76 357.88C966.76 356.174 965.377 354.799 963.671 354.799Z"
            fill="white"
          />
          <path
            d="M951.453 371.264C949.789 371.264 948.436 372.617 948.436 374.281C948.436 375.945 949.789 377.311 951.453 377.311C953.116 377.311 954.483 375.957 954.483 374.281C954.483 372.605 953.129 371.264 951.453 371.264Z"
            fill="white"
          />
          <path
            d="M940.835 391.357C939.222 391.357 937.911 392.669 937.911 394.294C937.911 395.919 939.222 397.231 940.835 397.231C942.448 397.231 943.772 395.919 943.772 394.294C943.772 392.669 942.46 391.357 940.835 391.357Z"
            fill="white"
          />
          <path
            d="M932.895 415.424C931.304 415.424 930.014 416.714 930.014 418.297C930.014 419.88 931.304 421.178 932.895 421.178C934.487 421.178 935.768 419.888 935.768 418.297C935.768 416.705 934.478 415.424 932.895 415.424Z"
            fill="white"
          />
          <path
            d="M929.19 443.711C927.629 443.711 926.368 444.971 926.368 446.52C926.368 448.069 927.629 449.342 929.19 449.342C930.752 449.342 932 448.082 932 446.52C932 444.959 930.739 443.711 929.19 443.711Z"
            fill="white"
          />
          <path
            d="M930.811 475.717C929.279 475.717 928.053 476.956 928.053 478.475C928.053 479.994 929.279 481.234 930.811 481.234C932.343 481.234 933.57 480.007 933.57 478.475C933.57 476.943 932.33 475.717 930.811 475.717Z"
            fill="white"
          />
          <path
            d="M937.651 510.717C936.183 510.717 934.986 511.914 934.986 513.39C934.986 514.867 936.183 516.064 937.651 516.064C939.12 516.064 940.325 514.867 940.325 513.39C940.325 511.914 939.128 510.717 937.651 510.717Z"
            fill="white"
          />
          <path
            d="M948.185 548.27C946.738 548.27 945.562 549.445 945.562 550.892C945.562 552.339 946.738 553.515 948.185 553.515C949.632 553.515 950.808 552.339 950.808 550.892C950.808 549.445 949.632 548.27 948.185 548.27Z"
            fill="white"
          />
          <path
            d="M960.089 588.391C958.684 588.391 957.551 589.536 957.551 590.941C957.551 592.346 958.684 593.492 960.089 593.492C961.493 593.492 962.639 592.346 962.639 590.941C962.639 589.536 961.506 588.391 960.089 588.391Z"
            fill="white"
          />
          <path
            d="M971.31 631.346C969.935 631.346 968.823 632.458 968.823 633.833C968.823 635.208 969.935 636.332 971.31 636.332C972.685 636.332 973.81 635.208 973.81 633.833C973.81 632.458 972.698 631.346 971.31 631.346Z"
            fill="white"
          />
          <path
            d="M979.936 677.922C978.604 677.922 977.521 679.004 977.521 680.337C977.521 681.669 978.604 682.751 979.936 682.751C981.269 682.751 982.351 681.669 982.351 680.337C982.351 679.004 981.269 677.922 979.936 677.922Z"
            fill="white"
          />
          <path
            d="M299.044 670.873C298.047 670.873 297.232 671.684 297.232 672.685C297.232 673.687 298.043 674.497 299.044 674.497C300.046 674.497 300.857 673.687 300.857 672.685C300.857 671.684 300.046 670.873 299.044 670.873Z"
            fill="white"
          />
          <path
            d="M278.551 660.82C277.554 660.82 276.739 661.631 276.739 662.632C276.739 663.634 277.55 664.444 278.551 664.444C279.553 664.444 280.372 663.634 280.372 662.632C280.372 661.631 279.561 660.82 278.551 660.82Z"
            fill="white"
          />
          <path
            d="M257.32 649.902C256.322 649.902 255.499 650.726 255.499 651.723C255.499 652.72 256.322 653.543 257.32 653.543C258.317 653.543 259.153 652.733 259.153 651.723C259.153 650.713 258.33 649.902 257.32 649.902Z"
            fill="white"
          />
          <path
            d="M235.066 637.818C234.056 637.818 233.232 638.629 233.232 639.639C233.232 640.649 234.056 641.46 235.066 641.46C236.076 641.46 236.886 640.649 236.886 639.639C236.886 638.629 236.063 637.818 235.066 637.818Z"
            fill="white"
          />
          <path
            d="M211.461 625.186C210.451 625.186 209.628 625.996 209.628 627.019C209.628 628.042 210.451 628.852 211.461 628.852C212.471 628.852 213.295 628.029 213.295 627.019C213.295 626.009 212.471 625.186 211.461 625.186Z"
            fill="white"
          />
          <path
            d="M185.983 612.166C184.973 612.166 184.149 612.977 184.149 613.999C184.149 615.022 184.973 615.833 185.983 615.833C186.993 615.833 187.825 615.009 187.825 613.999C187.825 612.989 187.001 612.166 185.983 612.166Z"
            fill="white"
          />
          <path
            d="M158.108 599.561C157.098 599.561 156.267 600.392 156.267 601.402C156.267 602.412 157.098 603.244 158.108 603.244C159.118 603.244 159.95 602.421 159.95 601.402C159.95 600.384 159.127 599.561 158.108 599.561Z"
            fill="white"
          />
          <path
            d="M127.512 586.436C126.493 586.436 125.67 587.259 125.67 588.277C125.67 589.296 126.493 590.111 127.512 590.111C128.53 590.111 129.345 589.287 129.345 588.277C129.345 587.267 128.522 586.436 127.512 586.436Z"
            fill="white"
          />
          <path
            d="M109.018 571.844C107.978 571.844 107.134 572.688 107.134 573.728C107.134 574.768 107.978 575.612 109.018 575.612C110.058 575.612 110.902 574.768 110.902 573.728C110.902 572.688 110.058 571.844 109.018 571.844Z"
            fill="white"
          />
          <path
            d="M91.9068 557.68C90.8332 557.68 89.9717 558.545 89.9717 559.615C89.9717 560.684 90.8374 561.563 91.9068 561.563C92.9763 561.563 93.8547 560.689 93.8547 559.615C93.8547 558.541 92.9805 557.68 91.9068 557.68Z"
            fill="white"
          />
          <path
            d="M77.8139 545.084C76.7021 545.084 75.8066 545.988 75.8066 547.104C75.8066 548.22 76.7021 549.111 77.8139 549.111C78.9258 549.111 79.834 548.216 79.834 547.104C79.834 545.992 78.93 545.084 77.8139 545.084Z"
            fill="white"
          />
          <path
            d="M67.3532 534.793C66.2074 534.793 65.2822 535.731 65.2822 536.872C65.2822 538.014 66.2074 538.943 67.3532 538.943C68.499 538.943 69.4241 538.018 69.4241 536.872C69.4241 535.727 68.499 534.793 67.3532 534.793Z"
            fill="white"
          />
          <path
            d="M60.2144 526.768C59.0261 526.768 58.0713 527.714 58.0713 528.902C58.0713 530.09 59.0304 531.037 60.2144 531.037C61.3984 531.037 62.349 530.078 62.349 528.902C62.349 527.727 61.3899 526.768 60.2144 526.768Z"
            fill="white"
          />
          <path
            d="M55.6559 520.512C54.438 520.512 53.4619 521.5 53.4619 522.706C53.4619 523.911 54.4422 524.9 55.6559 524.9C56.8696 524.9 57.8415 523.911 57.8415 522.706C57.8415 521.5 56.8612 520.512 55.6559 520.512Z"
            fill="white"
          />
          <path
            d="M53.0648 515.576C51.7959 515.576 50.7646 516.595 50.7646 517.868C50.7646 519.141 51.7959 520.168 53.0648 520.168C54.3336 520.168 55.3564 519.137 55.3564 517.868C55.3564 516.599 54.3252 515.576 53.0648 515.576Z"
            fill="white"
          />
          <path
            d="M51.9184 511.684C50.6156 511.684 49.5674 512.736 49.5674 514.035C49.5674 515.333 50.6198 516.398 51.9184 516.398C53.217 516.398 54.2695 515.337 54.2695 514.035C54.2695 512.732 53.217 511.684 51.9184 511.684Z"
            fill="white"
          />
          <path
            d="M51.7223 508.459C50.3898 508.459 49.3076 509.541 49.3076 510.882C49.3076 512.223 50.3898 513.297 51.7223 513.297C53.0548 513.297 54.1455 512.215 54.1455 510.882C54.1455 509.55 53.0633 508.459 51.7223 508.459Z"
            fill="white"
          />
          <path
            d="M52.1255 505.68C50.7505 505.68 49.6387 506.792 49.6387 508.167C49.6387 509.541 50.7505 510.645 52.1255 510.645C53.5005 510.645 54.6039 509.533 54.6039 508.167C54.6039 506.8 53.492 505.68 52.1255 505.68Z"
            fill="white"
          />
          <path
            d="M52.8976 503.172C51.4717 503.172 50.3174 504.326 50.3174 505.752C50.3174 507.178 51.4717 508.332 52.8976 508.332C54.3235 508.332 55.4778 507.178 55.4778 505.752C55.4778 504.326 54.3235 503.172 52.8976 503.172Z"
            fill="white"
          />
          <path
            d="M53.887 500.916C52.4314 500.916 51.2432 502.092 51.2432 503.56C51.2432 505.028 52.4314 506.195 53.887 506.195C55.3426 506.195 56.5181 505.02 56.5181 503.56C56.5181 502.1 55.3426 500.916 53.887 500.916Z"
            fill="white"
          />
          <path
            d="M54.8833 498.746C53.3937 498.746 52.1885 499.956 52.1885 501.454C52.1885 502.952 53.3979 504.148 54.8833 504.148C56.3686 504.148 57.5908 502.939 57.5908 501.454C57.5908 499.968 56.3813 498.746 54.8833 498.746Z"
            fill="white"
          />
          <path
            d="M55.8099 496.625C54.2779 496.625 53.043 497.864 53.043 499.383C53.043 500.903 54.2821 502.15 55.8099 502.15C57.3376 502.15 58.5683 500.911 58.5683 499.383C58.5683 497.856 57.3292 496.625 55.8099 496.625Z"
            fill="white"
          />
          <path
            d="M56.553 494.469C54.9828 494.469 53.7012 495.75 53.7012 497.321C53.7012 498.891 54.9828 500.172 56.553 500.172C58.1232 500.172 59.4048 498.891 59.4048 497.321C59.4048 495.75 58.1232 494.469 56.553 494.469Z"
            fill="white"
          />
          <path
            d="M57.0492 492.305C55.4451 492.305 54.1465 493.608 54.1465 495.207C54.1465 496.807 55.4493 498.123 57.0492 498.123C58.6491 498.123 59.9647 496.812 59.9647 495.207C59.9647 493.603 58.6618 492.305 57.0492 492.305Z"
            fill="white"
          />
          <path
            d="M57.2691 490.068C55.6268 490.068 54.3027 491.401 54.3027 493.035C54.3027 494.669 55.6268 496.001 57.2691 496.001C58.9114 496.001 60.2355 494.677 60.2355 493.035C60.2355 491.392 58.903 490.068 57.2691 490.068Z"
            fill="white"
          />
          <path
            d="M57.1628 487.766C55.4866 487.766 54.1328 489.119 54.1328 490.796C54.1328 492.472 55.4866 493.813 57.1628 493.813C58.8391 493.813 60.1802 492.459 60.1802 490.796C60.1802 489.132 58.8264 487.766 57.1628 487.766Z"
            fill="white"
          />
          <path
            d="M56.7259 485.365C55.0072 485.365 53.6152 486.749 53.6152 488.467C53.6152 490.186 55.0114 491.578 56.7259 491.578C58.4404 491.578 59.8281 490.182 59.8281 488.467C59.8281 486.753 58.4446 485.365 56.7259 485.365Z"
            fill="white"
          />
          <path
            d="M55.9448 482.908C54.2049 482.908 52.7832 484.326 52.7832 486.074C52.7832 487.822 54.2091 489.24 55.9448 489.24C57.6805 489.24 59.1106 487.822 59.1106 486.074C59.1106 484.326 57.6932 482.908 55.9448 482.908Z"
            fill="white"
          />
          <path
            d="M54.8847 480.41C53.1066 480.41 51.668 481.845 51.668 483.627C51.668 485.409 53.1024 486.844 54.8847 486.844C56.6671 486.844 58.0888 485.397 58.0888 483.627C58.0888 481.857 56.6544 480.41 54.8847 480.41Z"
            fill="white"
          />
          <path
            d="M53.5089 477.871C51.6969 477.871 50.2285 479.327 50.2285 481.139C50.2285 482.951 51.6969 484.406 53.5089 484.406C55.321 484.406 56.7766 482.951 56.7766 481.139C56.7766 479.327 55.3083 477.871 53.5089 477.871Z"
            fill="white"
          />
          <path
            d="M51.8027 475.258C49.9609 475.258 48.4629 476.756 48.4629 478.61C48.4629 480.465 49.9609 481.95 51.8027 481.95C53.6445 481.95 55.1553 480.452 55.1553 478.61C55.1553 476.769 53.6572 475.258 51.8027 475.258Z"
            fill="white"
          />
          <path
            d="M49.7534 472.635C47.8819 472.635 46.3711 474.154 46.3711 476.017C46.3711 477.88 47.8819 479.412 49.7534 479.412C51.6249 479.412 53.1441 477.893 53.1441 476.017C53.1441 474.141 51.6249 472.635 49.7534 472.635Z"
            fill="white"
          />
          <path
            d="M47.3307 469.947C45.4379 469.947 43.8975 471.479 43.8975 473.38C43.8975 475.282 45.4379 476.814 47.3307 476.814C49.2234 476.814 50.7638 475.273 50.7638 473.38C50.7638 471.488 49.2234 469.947 47.3307 469.947Z"
            fill="white"
          />
          <path
            d="M44.5089 467.203C42.5822 467.203 41.0205 468.765 41.0205 470.679C41.0205 472.593 42.5822 474.167 44.5089 474.167C46.4355 474.167 47.9845 472.605 47.9845 470.679C47.9845 468.752 46.4228 467.203 44.5089 467.203Z"
            fill="white"
          />
          <path
            d="M41.2704 464.373C39.3141 464.373 37.7227 465.956 37.7227 467.912C37.7227 469.869 39.3141 471.46 41.2704 471.46C43.2268 471.46 44.8097 469.869 44.8097 467.912C44.8097 465.956 43.2268 464.373 41.2704 464.373Z"
            fill="white"
          />
          <path
            d="M37.5954 461.486C35.6178 461.486 34.0137 463.099 34.0137 465.077C34.0137 467.054 35.6178 468.658 37.5954 468.658C39.573 468.658 41.1856 467.054 41.1856 465.077C41.1856 463.099 39.5815 461.486 37.5954 461.486Z"
            fill="white"
          />
          <path
            d="M33.4959 458.541C31.4971 458.541 29.876 460.166 29.876 462.161C29.876 464.156 31.5013 465.794 33.4959 465.794C35.4905 465.794 37.1285 464.168 37.1285 462.161C37.1285 460.154 35.5032 458.541 33.4959 458.541Z"
            fill="white"
          />
          <path
            d="M28.9595 455.516C26.9395 455.516 25.3057 457.162 25.3057 459.178C25.3057 461.194 26.9395 462.84 28.9595 462.84C30.9796 462.84 32.6219 461.194 32.6219 459.178C32.6219 457.162 30.9796 455.516 28.9595 455.516Z"
            fill="white"
          />
          <path
            d="M23.9949 452.379C21.9451 452.379 20.2773 454.042 20.2773 456.105C20.2773 458.167 21.9409 459.822 23.9949 459.822C26.0488 459.822 27.7209 458.159 27.7209 456.105C27.7209 454.051 26.0573 452.379 23.9949 452.379Z"
            fill="white"
          />
          <path
            d="M18.6125 449.195C16.5415 449.195 14.8652 450.88 14.8652 452.943C14.8652 455.005 16.5415 456.698 18.6125 456.698C20.6834 456.698 22.3682 455.013 22.3682 452.943C22.3682 450.872 20.6834 449.195 18.6125 449.195Z"
            fill="white"
          />
          <path
            d="M12.8375 445.949C10.7453 445.949 9.06055 447.634 9.06055 449.726C9.06055 451.818 10.7453 453.503 12.8375 453.503C14.9297 453.503 16.6144 451.818 16.6144 449.726C16.6144 447.634 14.9297 445.949 12.8375 445.949Z"
            fill="white"
          />
          <path
            d="M6.68784 442.66C4.58718 442.66 2.87695 444.366 2.87695 446.471C2.87695 448.576 4.58294 450.282 6.68784 450.282C8.79274 450.282 10.4987 448.576 10.4987 446.471C10.4987 444.366 8.79274 442.66 6.68784 442.66Z"
            fill="white"
          />
          <path
            d="M0.203573 439.322C-1.9183 439.322 -3.64551 441.05 -3.64551 443.171C-3.64551 445.293 -1.9183 447.033 0.203573 447.033C2.32545 447.033 4.06539 445.306 4.06539 443.171C4.06539 441.037 2.33818 439.322 0.203573 439.322Z"
            fill="white"
          />
          <path
            d="M1.83741 92.8613C0.088986 92.8613 -1.33691 94.2872 -1.33691 96.0357C-1.33691 97.7841 0.088986 99.21 1.83741 99.21C3.58584 99.21 5.01174 97.7883 5.01174 96.0357C5.01174 94.283 3.58584 92.8613 1.83741 92.8613Z"
            fill="white"
          />
          <path
            d="M11.1187 79.8633C9.41276 79.8633 8.0293 81.2467 8.0293 82.9527C8.0293 84.6587 9.41276 86.0337 11.1187 86.0337C12.8247 86.0337 14.1997 84.6545 14.1997 82.9527C14.1997 81.251 12.8247 79.8633 11.1187 79.8633Z"
            fill="white"
          />
          <path
            d="M19.7673 67.0801C18.0911 67.0801 16.7373 68.4381 16.7373 70.1144C16.7373 71.7906 18.0911 73.1486 19.7673 73.1486C21.4436 73.1486 22.8059 71.7864 22.8059 70.1144C22.8059 68.4423 21.4436 67.0801 19.7673 67.0801Z"
            fill="white"
          />
          <path
            d="M27.4485 55.2871C25.8062 55.2871 24.4736 56.6196 24.4736 58.262C24.4736 59.9043 25.8062 61.2326 27.4485 61.2326C29.0908 61.2326 30.4149 59.9043 30.4149 58.262C30.4149 56.6196 29.0908 55.2871 27.4485 55.2871Z"
            fill="white"
          />
          <path
            d="M34.018 44.8691C32.4139 44.8691 31.1025 46.172 31.1025 47.7846C31.1025 49.3972 32.4139 50.7001 34.018 50.7001C35.6221 50.7001 36.9335 49.393 36.9335 47.7846C36.9335 46.1762 35.6306 44.8691 34.018 44.8691Z"
            fill="white"
          />
          <path
            d="M39.5721 35.8223C38.0104 35.8223 36.75 37.0869 36.75 38.6444C36.75 40.2018 38.0104 41.4665 39.5721 41.4665C41.1338 41.4665 42.3942 40.2018 42.3942 38.6444C42.3942 37.0869 41.1338 35.8223 39.5721 35.8223Z"
            fill="white"
          />
          <path
            d="M44.309 27.791C42.777 27.791 41.5293 29.0302 41.5293 30.5579C41.5293 32.0857 42.777 33.3376 44.309 33.3376C45.8409 33.3376 47.0759 32.0942 47.0759 30.5579C47.0759 29.0217 45.8367 27.791 44.309 27.791Z"
            fill="white"
          />
          <path
            d="M48.4419 20.5117C46.9523 20.5117 45.7471 21.7169 45.7471 23.2065C45.7471 24.6961 46.9565 25.9013 48.4419 25.9013C49.9272 25.9013 51.1366 24.6918 51.1366 23.2065C51.1366 21.7212 49.9272 20.5117 48.4419 20.5117Z"
            fill="white"
          />
          <path
            d="M52.2184 13.5625C50.7628 13.5625 49.583 14.7423 49.583 16.2021C49.583 17.662 50.7585 18.8417 52.2184 18.8417C53.6782 18.8417 54.8622 17.6535 54.8622 16.2021C54.8622 14.7508 53.674 13.5625 52.2184 13.5625Z"
            fill="white"
          />
          <path
            d="M55.8103 6.72656C54.4056 6.72656 53.2598 7.87237 53.2598 9.27706C53.2598 10.6817 54.4056 11.8148 55.8103 11.8148C57.2149 11.8148 58.348 10.6817 58.348 9.27706C58.348 7.87237 57.2149 6.72656 55.8103 6.72656Z"
            fill="white"
          />
          <path
            d="M59.3699 -0.416016C58.0077 -0.416016 56.8916 0.695847 56.8916 2.06658C56.8916 3.43731 58.0035 4.54917 59.3699 4.54917C60.7364 4.54917 61.8568 3.43731 61.8568 2.06658C61.8568 0.695847 60.7449 -0.416016 59.3699 -0.416016Z"
            fill="white"
          />
          <path
            d="M1018.18 -0.695312C1016.7 -0.695312 1015.51 0.497181 1015.51 1.96976C1015.51 3.44234 1016.7 4.63484 1018.18 4.63484C1019.65 4.63484 1020.84 3.4381 1020.84 1.96976C1020.84 0.501425 1019.65 -0.695312 1018.18 -0.695312Z"
            fill="white"
          />
          <path
            d="M1025.18 11.1875C1023.68 11.1875 1022.46 12.4097 1022.46 13.9077C1022.46 15.4058 1023.68 16.6365 1025.18 16.6365C1026.68 16.6365 1027.91 15.4185 1027.91 13.9077C1027.91 12.397 1026.69 11.1875 1025.18 11.1875Z"
            fill="white"
          />
          <path
            d="M1032.39 22.7754C1030.85 22.7754 1029.6 24.0231 1029.6 25.5593C1029.6 27.0955 1030.85 28.3432 1032.39 28.3432C1033.93 28.3432 1035.17 27.0955 1035.17 25.5593C1035.17 24.0231 1033.92 22.7754 1032.39 22.7754Z"
            fill="white"
          />
          <path
            d="M1039.8 33.9746C1038.21 33.9746 1036.93 35.2647 1036.93 36.8476C1036.93 38.4305 1038.21 39.7249 1039.8 39.7249C1041.4 39.7249 1042.68 38.439 1042.68 36.8476C1042.68 35.2562 1041.39 33.9746 1039.8 33.9746Z"
            fill="white"
          />
          <path
            d="M1047.41 44.8984C1045.79 44.8984 1044.48 46.214 1044.48 47.8266C1044.48 49.4392 1045.79 50.7633 1047.41 50.7633C1049.04 50.7633 1050.35 49.452 1050.35 47.8266C1050.35 46.2013 1049.04 44.8984 1047.41 44.8984Z"
            fill="white"
          />
          <path
            d="M1055.19 55.5293C1053.54 55.5293 1052.2 56.8703 1052.2 58.5254C1052.2 60.1804 1053.54 61.513 1055.19 61.513C1056.83 61.513 1058.18 60.1762 1058.18 58.5254C1058.18 56.8746 1056.84 55.5293 1055.19 55.5293Z"
            fill="white"
          />
          <path
            d="M1063.07 65.9902C1061.38 65.9902 1060.02 67.3567 1060.02 69.0415C1060.02 70.7263 1061.38 72.1012 1063.07 72.1012C1064.76 72.1012 1066.12 70.7263 1066.12 69.0415C1066.12 67.3567 1064.76 65.9902 1063.07 65.9902Z"
            fill="white"
          />
          <path
            d="M1071.03 76.2598C1069.3 76.2598 1067.91 77.6645 1067.91 79.3874C1067.91 81.1104 1069.3 82.5151 1071.03 82.5151C1072.76 82.5151 1074.15 81.1104 1074.15 79.3874C1074.15 77.6645 1072.76 76.2598 1071.03 76.2598Z"
            fill="white"
          />
          <path
            d="M1079.04 86.4473C1077.28 86.4473 1075.85 87.8689 1075.85 89.6258C1075.85 91.3827 1077.28 92.8044 1079.04 92.8044C1080.8 92.8044 1082.22 91.3785 1082.22 89.6258C1082.22 87.8732 1080.8 86.4473 1079.04 86.4473Z"
            fill="white"
          />
          <path
            d="M1087.07 96.5957C1085.27 96.5957 1083.83 98.0428 1083.83 99.8337C1083.83 101.625 1085.27 103.059 1087.07 103.059C1088.86 103.059 1090.29 101.612 1090.29 99.8337C1090.29 98.0556 1088.84 96.5957 1087.07 96.5957Z"
            fill="white"
          />
          <path
            d="M1095.05 106.785C1093.23 106.785 1091.76 108.258 1091.76 110.074C1091.76 111.89 1093.23 113.363 1095.05 113.363C1096.87 113.363 1098.33 111.886 1098.33 110.074C1098.33 108.262 1096.86 106.785 1095.05 106.785Z"
            fill="white"
          />
          <path
            d="M1102.93 117.09C1101.08 117.09 1099.57 118.592 1099.57 120.451C1099.57 122.31 1101.08 123.812 1102.93 123.812C1104.78 123.812 1106.29 122.31 1106.29 120.451C1106.29 118.592 1104.79 117.09 1102.93 117.09Z"
            fill="white"
          />
          <path
            d="M1110.73 127.551C1108.85 127.551 1107.32 129.083 1107.32 130.959C1107.32 132.834 1108.85 134.366 1110.73 134.366C1112.62 134.366 1114.14 132.834 1114.14 130.959C1114.14 129.083 1112.62 127.551 1110.73 127.551Z"
            fill="white"
          />
          <path
            d="M1118.41 138.189C1116.5 138.189 1114.95 139.738 1114.95 141.657C1114.95 143.575 1116.5 145.124 1118.41 145.124C1120.33 145.124 1121.89 143.575 1121.89 141.657C1121.89 139.738 1120.33 138.189 1118.41 138.189Z"
            fill="white"
          />
          <path
            d="M1125.96 149.074C1124.02 149.074 1122.45 150.644 1122.45 152.584C1122.45 154.523 1124.02 156.098 1125.96 156.098C1127.9 156.098 1129.48 154.527 1129.48 152.584C1129.48 150.64 1127.91 149.074 1125.96 149.074Z"
            fill="white"
          />
          <path
            d="M1133.37 160.174C1131.4 160.174 1129.8 161.769 1129.8 163.743C1129.8 165.716 1131.4 167.312 1133.37 167.312C1135.33 167.312 1136.94 165.716 1136.94 163.743C1136.94 161.769 1135.35 160.174 1133.37 160.174Z"
            fill="white"
          />
          <path
            d="M1140.63 171.545C1138.64 171.545 1137.01 173.166 1137.01 175.165C1137.01 177.164 1138.64 178.781 1140.63 178.781C1142.63 178.781 1144.25 177.164 1144.25 175.165C1144.25 173.166 1142.63 171.545 1140.63 171.545Z"
            fill="white"
          />
          <path
            d="M1147.8 183.098C1145.78 183.098 1144.14 184.731 1144.14 186.756C1144.14 188.78 1145.78 190.414 1147.8 190.414C1149.81 190.414 1151.46 188.78 1151.46 186.756C1151.46 184.731 1149.81 183.098 1147.8 183.098Z"
            fill="white"
          />
          <path
            d="M1154.96 194.676C1152.91 194.676 1151.25 196.335 1151.25 198.376C1151.25 200.418 1152.91 202.081 1154.96 202.081C1157.01 202.081 1158.66 200.426 1158.66 198.376C1158.66 196.327 1157 194.676 1154.96 194.676Z"
            fill="white"
          />
          <path
            d="M1162.21 206.076C1160.14 206.076 1158.45 207.761 1158.45 209.845C1158.45 211.928 1160.14 213.613 1162.21 213.613C1164.28 213.613 1165.98 211.928 1165.98 209.845C1165.98 207.761 1164.29 206.076 1162.21 206.076Z"
            fill="white"
          />
          <path
            d="M1169.72 217.088C1167.62 217.088 1165.92 218.785 1165.92 220.886C1165.92 222.987 1167.62 224.684 1169.72 224.684C1171.82 224.684 1173.51 222.987 1173.51 220.886C1173.51 218.785 1171.82 217.088 1169.72 217.088Z"
            fill="white"
          />
          <path
            d="M1177.47 227.621C1175.35 227.621 1173.62 229.34 1173.62 231.462C1173.62 233.584 1175.35 235.311 1177.47 235.311C1179.59 235.311 1181.31 233.584 1181.31 231.462C1181.31 229.34 1179.58 227.621 1177.47 227.621Z"
            fill="white"
          />
          <path
            d="M1185.5 237.625C1183.35 237.625 1181.62 239.352 1181.62 241.495C1181.62 243.638 1183.35 245.366 1185.5 245.366C1187.64 245.366 1189.37 243.626 1189.37 241.495C1189.37 239.365 1187.63 237.625 1185.5 237.625Z"
            fill="white"
          />
          <path
            d="M1193.82 246.975C1191.66 246.975 1189.9 248.732 1189.9 250.9C1189.9 253.069 1191.66 254.826 1193.82 254.826C1195.99 254.826 1197.75 253.064 1197.75 250.9C1197.75 248.736 1195.99 246.975 1193.82 246.975Z"
            fill="white"
          />
          <path
            d="M1202.47 255.607C1200.29 255.607 1198.52 257.377 1198.52 259.563C1198.52 261.748 1200.29 263.518 1202.47 263.518C1204.65 263.518 1206.43 261.748 1206.43 259.563C1206.43 257.377 1204.66 255.607 1202.47 255.607Z"
            fill="white"
          />
          <path
            d="M1211.46 263.469C1209.27 263.469 1207.48 265.247 1207.48 267.445C1207.48 269.643 1209.27 271.43 1211.46 271.43C1213.66 271.43 1215.44 269.639 1215.44 267.445C1215.44 265.251 1213.66 263.469 1211.46 263.469Z"
            fill="white"
          />
          <path
            d="M1220.77 270.514C1218.55 270.514 1216.76 272.305 1216.76 274.52C1216.76 276.735 1218.55 278.539 1220.77 278.539C1222.98 278.539 1224.78 276.739 1224.78 274.52C1224.78 272.3 1222.99 270.514 1220.77 270.514Z"
            fill="white"
          />
          <path
            d="M1230.39 276.705C1228.16 276.705 1226.34 278.526 1226.34 280.766C1226.34 283.007 1228.16 284.823 1230.39 284.823C1232.63 284.823 1234.46 283.003 1234.46 280.766C1234.46 278.53 1232.64 276.705 1230.39 276.705Z"
            fill="white"
          />
          <path
            d="M1240.3 282.078C1238.06 282.078 1236.23 283.911 1236.23 286.169C1236.23 288.427 1238.06 290.247 1240.3 290.247C1242.55 290.247 1244.4 288.427 1244.4 286.169C1244.4 283.911 1242.56 282.078 1240.3 282.078Z"
            fill="white"
          />
          <path
            d="M1250.48 286.594C1248.21 286.594 1246.38 288.427 1246.38 290.693C1246.38 292.959 1248.21 294.805 1250.48 294.805C1252.75 294.805 1254.59 292.964 1254.59 290.693C1254.59 288.423 1252.75 286.594 1250.48 286.594Z"
            fill="white"
          />
          <path
            d="M1260.87 290.248C1258.6 290.248 1256.76 292.09 1256.76 294.369C1256.76 296.648 1258.6 298.481 1260.87 298.481C1263.14 298.481 1264.99 296.639 1264.99 294.369C1264.99 292.098 1263.15 290.248 1260.87 290.248Z"
            fill="white"
          />
          <path
            d="M1271.41 293.047C1269.12 293.047 1267.26 294.91 1267.26 297.202C1267.26 299.493 1269.12 301.343 1271.41 301.343C1273.7 301.343 1275.55 299.489 1275.55 297.202C1275.55 294.914 1273.7 293.047 1271.41 293.047Z"
            fill="white"
          />
          <path
            d="M1282.04 295.047C1279.74 295.047 1277.88 296.91 1277.88 299.201C1277.88 301.493 1279.74 303.356 1282.04 303.356C1284.34 303.356 1286.19 301.506 1286.19 299.201C1286.19 296.897 1284.33 295.047 1282.04 295.047Z"
            fill="white"
          />
          <path
            d="M1292.7 296.223C1290.41 296.223 1288.54 298.077 1288.54 300.377C1288.54 302.677 1290.41 304.532 1292.7 304.532C1294.99 304.532 1296.85 302.669 1296.85 300.377C1296.85 298.086 1295 296.223 1292.7 296.223Z"
            fill="white"
          />
          <path
            d="M1303.32 296.615C1301.03 296.615 1299.17 298.465 1299.17 300.77C1299.17 303.074 1301.03 304.925 1303.32 304.925C1305.61 304.925 1307.48 303.061 1307.48 300.77C1307.48 298.478 1305.61 296.615 1303.32 296.615Z"
            fill="white"
          />
          <path
            d="M1313.84 296.316C1311.54 296.316 1309.68 298.179 1309.68 300.471C1309.68 302.763 1311.54 304.626 1313.84 304.626C1316.14 304.626 1317.99 302.775 1317.99 300.471C1317.99 298.167 1316.13 296.316 1313.84 296.316Z"
            fill="white"
          />
          <path
            d="M1324.18 295.41C1321.88 295.41 1320.02 297.273 1320.02 299.565C1320.02 301.856 1321.88 303.719 1324.18 303.719C1326.48 303.719 1328.33 301.865 1328.33 299.565C1328.33 297.265 1326.47 295.41 1324.18 295.41Z"
            fill="white"
          />
          <path
            d="M1334.32 293.965C1332.02 293.965 1330.16 295.819 1330.16 298.119C1330.16 300.42 1332.02 302.274 1334.32 302.274C1336.61 302.274 1338.47 300.411 1338.47 298.119C1338.47 295.828 1336.62 293.965 1334.32 293.965Z"
            fill="white"
          />
          <path
            d="M1344.25 292.016C1341.95 292.016 1340.09 293.879 1340.09 296.17C1340.09 298.462 1341.94 300.325 1344.25 300.325C1346.55 300.325 1348.4 298.462 1348.4 296.17C1348.4 293.879 1346.54 292.016 1344.25 292.016Z"
            fill="white"
          />
          <path
            d="M1353.91 289.709C1351.61 289.709 1349.75 291.559 1349.75 293.864C1349.75 296.168 1351.61 298.018 1353.91 298.018C1356.2 298.018 1358.06 296.155 1358.06 293.864C1358.06 291.572 1356.21 289.709 1353.91 289.709Z"
            fill="white"
          />
          <path
            d="M1350.36 292.453C1348.07 292.453 1346.2 294.316 1346.2 296.608C1346.2 298.899 1348.07 300.762 1350.36 300.762C1352.65 300.762 1354.51 298.908 1354.51 296.608C1354.51 294.308 1352.64 292.453 1350.36 292.453Z"
            fill="white"
          />
          <path
            d="M1346.62 295.004C1344.33 295.004 1342.46 296.867 1342.46 299.159C1342.46 301.45 1344.33 303.313 1346.62 303.313C1348.91 303.313 1350.77 301.463 1350.77 299.159C1350.77 296.854 1348.91 295.004 1346.62 295.004Z"
            fill="white"
          />
          <path
            d="M1342.61 297.418C1340.31 297.418 1338.46 299.268 1338.46 301.568C1338.46 303.868 1340.31 305.723 1342.61 305.723C1344.91 305.723 1346.77 303.86 1346.77 301.568C1346.77 299.277 1344.9 297.418 1342.61 297.418Z"
            fill="white"
          />
          <path
            d="M1338.25 299.719C1335.96 299.719 1334.09 301.582 1334.09 303.873C1334.09 306.165 1335.96 308.028 1338.25 308.028C1340.54 308.028 1342.4 306.173 1342.4 303.873C1342.4 301.573 1340.54 299.719 1338.25 299.719Z"
            fill="white"
          />
          <path
            d="M1333.47 301.955C1331.17 301.955 1329.32 303.818 1329.32 306.11C1329.32 308.401 1331.17 310.264 1333.47 310.264C1335.78 310.264 1337.63 308.401 1337.63 306.11C1337.63 303.818 1335.77 301.955 1333.47 301.955Z"
            fill="white"
          />
          <path
            d="M1328.21 304.119C1325.92 304.119 1324.05 305.982 1324.05 308.274C1324.05 310.565 1325.92 312.428 1328.21 312.428C1330.5 312.428 1332.37 310.565 1332.37 308.274C1332.37 305.982 1330.51 304.119 1328.21 304.119Z"
            fill="white"
          />
          <path
            d="M1322.44 306.211C1320.14 306.211 1318.28 308.065 1318.28 310.366C1318.28 312.666 1320.14 314.52 1322.44 314.52C1324.74 314.52 1326.6 312.657 1326.6 310.366C1326.6 308.074 1324.73 306.211 1322.44 306.211Z"
            fill="white"
          />
          <path
            d="M1316.11 308.223C1313.81 308.223 1311.96 310.086 1311.96 312.377C1311.96 314.669 1313.81 316.532 1316.11 316.532C1318.42 316.532 1320.27 314.677 1320.27 312.377C1320.27 310.077 1318.41 308.223 1316.11 308.223Z"
            fill="white"
          />
          <path
            d="M1309.22 310.137C1306.93 310.137 1305.07 311.987 1305.07 314.291C1305.07 316.596 1306.93 318.446 1309.22 318.446C1311.51 318.446 1313.38 316.583 1313.38 314.291C1313.38 312 1311.52 310.137 1309.22 310.137Z"
            fill="white"
          />
          <path
            d="M1301.78 311.887C1299.49 311.887 1297.63 313.75 1297.63 316.05C1297.63 318.35 1299.49 320.204 1301.78 320.204C1304.08 320.204 1305.94 318.341 1305.94 316.05C1305.94 313.758 1304.09 311.887 1301.78 311.887Z"
            fill="white"
          />
          <path
            d="M1293.81 313.428C1291.51 313.428 1289.64 315.291 1289.64 317.582C1289.64 319.874 1291.51 321.745 1293.81 321.745C1296.11 321.745 1297.96 319.882 1297.96 317.582C1297.96 315.282 1296.1 313.428 1293.81 313.428Z"
            fill="white"
          />
          <path
            d="M1285.32 314.688C1283.03 314.688 1281.16 316.55 1281.16 318.842C1281.16 321.134 1283.03 322.997 1285.32 322.997C1287.61 322.997 1289.47 321.142 1289.47 318.842C1289.47 316.542 1287.62 314.688 1285.32 314.688Z"
            fill="white"
          />
          <path
            d="M1276.38 315.592C1274.09 315.592 1272.22 317.455 1272.22 319.746C1272.22 322.038 1274.08 323.901 1276.38 323.901C1278.67 323.901 1280.53 322.038 1280.53 319.746C1280.53 317.455 1278.67 315.592 1276.38 315.592Z"
            fill="white"
          />
          <path
            d="M1267.01 316.164C1264.73 316.164 1262.88 318.019 1262.88 320.297C1262.88 322.576 1264.73 324.431 1267.01 324.431C1269.29 324.431 1271.15 322.589 1271.15 320.297C1271.15 318.006 1269.3 316.164 1267.01 316.164Z"
            fill="white"
          />
          <path
            d="M1257.28 316.393C1255.01 316.393 1253.17 318.234 1253.17 320.505C1253.17 322.775 1255.01 324.617 1257.28 324.617C1259.55 324.617 1261.39 322.775 1261.39 320.505C1261.39 318.234 1259.55 316.393 1257.28 316.393Z"
            fill="white"
          />
          <path
            d="M1247.19 316.234C1244.94 316.234 1243.11 318.055 1243.11 320.313C1243.11 322.57 1244.95 324.391 1247.19 324.391C1249.44 324.391 1251.27 322.558 1251.27 320.313C1251.27 318.068 1249.45 316.234 1247.19 316.234Z"
            fill="white"
          />
          <path
            d="M1236.83 315.662C1234.59 315.662 1232.78 317.474 1232.78 319.711C1232.78 321.947 1234.59 323.759 1236.83 323.759C1239.06 323.759 1240.88 321.947 1240.88 319.711C1240.88 317.474 1239.06 315.662 1236.83 315.662Z"
            fill="white"
          />
          <path
            d="M1226.21 314.652C1223.99 314.652 1222.19 316.452 1222.19 318.68C1222.19 320.908 1223.99 322.698 1226.21 322.698C1228.43 322.698 1230.23 320.899 1230.23 318.68C1230.23 316.46 1228.43 314.652 1226.21 314.652Z"
            fill="white"
          />
          <path
            d="M1215.35 313.363C1213.15 313.363 1211.36 315.154 1211.36 317.361C1211.36 319.568 1213.15 321.346 1215.35 321.346C1217.56 321.346 1219.34 319.568 1219.34 317.361C1219.34 315.154 1217.56 313.363 1215.35 313.363Z"
            fill="white"
          />
          <path
            d="M1204.26 311.895C1202.08 311.895 1200.32 313.664 1200.32 315.85C1200.32 318.035 1202.09 319.796 1204.26 319.796C1206.43 319.796 1208.22 318.027 1208.22 315.85C1208.22 313.673 1206.45 311.895 1204.26 311.895Z"
            fill="white"
          />
          <path
            d="M1192.93 310.281C1190.76 310.281 1189 312.03 1189 314.194C1189 316.358 1190.76 318.119 1192.93 318.119C1195.1 318.119 1196.84 316.358 1196.84 314.194C1196.84 312.03 1195.09 310.281 1192.93 310.281Z"
            fill="white"
          />
          <path
            d="M1181.38 308.639C1179.24 308.639 1177.5 310.379 1177.5 312.53C1177.5 314.682 1179.24 316.413 1181.38 316.413C1183.53 316.413 1185.28 314.673 1185.28 312.53C1185.28 310.387 1183.54 308.639 1181.38 308.639Z"
            fill="white"
          />
          <path
            d="M1169.65 307.064C1167.52 307.064 1165.8 308.783 1165.8 310.914C1165.8 313.044 1167.52 314.775 1169.65 314.775C1171.78 314.775 1173.52 313.048 1173.52 310.914C1173.52 308.779 1171.79 307.064 1169.65 307.064Z"
            fill="white"
          />
          <path
            d="M1157.76 305.65C1155.65 305.65 1153.96 307.356 1153.96 309.461C1153.96 311.566 1155.66 313.259 1157.76 313.259C1159.86 313.259 1161.56 311.553 1161.56 309.461C1161.56 307.369 1159.86 305.65 1157.76 305.65Z"
            fill="white"
          />
          <path
            d="M1145.72 304.42C1143.64 304.42 1141.95 306.105 1141.95 308.188C1141.95 310.272 1143.63 311.957 1145.72 311.957C1147.8 311.957 1149.48 310.272 1149.48 308.188C1149.48 306.105 1147.8 304.42 1145.72 304.42Z"
            fill="white"
          />
          <path
            d="M1133.5 303.475C1131.45 303.475 1129.79 305.138 1129.79 307.201C1129.79 309.263 1131.45 310.927 1133.5 310.927C1135.56 310.927 1137.23 309.263 1137.23 307.201C1137.23 305.138 1135.57 303.475 1133.5 303.475Z"
            fill="white"
          />
          <path
            d="M1121.19 302.902C1119.16 302.902 1117.51 304.557 1117.51 306.586C1117.51 308.614 1119.16 310.269 1121.19 310.269C1123.22 310.269 1124.87 308.614 1124.87 306.586C1124.87 304.557 1123.22 302.902 1121.19 302.902Z"
            fill="white"
          />
          <path
            d="M1108.76 302.787C1106.76 302.787 1105.14 304.412 1105.14 306.407C1105.14 308.402 1106.76 310.027 1108.76 310.027C1110.75 310.027 1112.38 308.406 1112.38 306.407C1112.38 304.408 1110.75 302.787 1108.76 302.787Z"
            fill="white"
          />
          <path
            d="M1096.12 303.1C1094.14 303.1 1092.54 304.704 1092.54 306.669C1092.54 308.633 1094.14 310.25 1096.12 310.25C1098.1 310.25 1099.7 308.646 1099.7 306.669C1099.7 304.691 1098.1 303.1 1096.12 303.1Z"
            fill="white"
          />
          <path
            d="M1083.32 303.967C1081.36 303.967 1079.78 305.55 1079.78 307.493C1079.78 309.437 1081.36 311.02 1083.32 311.02C1085.28 311.02 1086.85 309.437 1086.85 307.493C1086.85 305.55 1085.26 303.967 1083.32 303.967Z"
            fill="white"
          />
          <path
            d="M1070.37 312.479C1072.3 312.479 1073.86 310.917 1073.86 308.99C1073.86 307.064 1072.3 305.502 1070.37 305.502C1068.44 305.502 1066.88 307.064 1066.88 308.99C1066.88 310.917 1068.44 312.479 1070.37 312.479Z"
            fill="white"
          />
          <path
            d="M1057.2 307.795C1055.31 307.795 1053.78 309.327 1053.78 311.22C1053.78 313.112 1055.32 314.632 1057.2 314.632C1059.08 314.632 1060.62 313.1 1060.62 311.22C1060.62 309.34 1059.09 307.795 1057.2 307.795Z"
            fill="white"
          />
          <path
            d="M1043.82 310.92C1041.96 310.92 1040.45 312.431 1040.45 314.281C1040.45 316.131 1041.96 317.655 1043.82 317.655C1045.69 317.655 1047.2 316.144 1047.2 314.281C1047.2 312.418 1045.69 310.92 1043.82 310.92Z"
            fill="white"
          />
          <path
            d="M1030.21 315.09C1028.37 315.09 1026.89 316.579 1026.89 318.408C1026.89 320.238 1028.38 321.719 1030.21 321.719C1032.04 321.719 1033.53 320.242 1033.53 318.408C1033.53 316.575 1032.04 315.09 1030.21 315.09Z"
            fill="white"
          />
          <path
            d="M1016.34 320.605C1014.53 320.605 1013.08 322.074 1013.08 323.873C1013.08 325.673 1014.53 327.141 1016.34 327.141C1018.16 327.141 1019.61 325.685 1019.61 323.873C1019.61 322.061 1018.14 320.605 1016.34 320.605Z"
            fill="white"
          />
          <path
            d="M1002.33 327.758C1000.57 327.758 999.153 329.184 999.153 330.945C999.153 332.706 1000.57 334.119 1002.33 334.119C1004.08 334.119 1005.51 332.702 1005.51 330.945C1005.51 329.188 1004.09 327.758 1002.33 327.758Z"
            fill="white"
          />
          <path
            d="M988.183 336.844C986.456 336.844 985.051 338.248 985.051 339.988C985.051 341.728 986.456 343.12 988.183 343.12C989.91 343.12 991.315 341.716 991.315 339.988C991.315 338.261 989.91 336.844 988.183 336.844Z"
            fill="white"
          />
          <path
            d="M974.382 348.668C972.684 348.668 971.301 350.043 971.301 351.74C971.301 353.438 972.684 354.821 974.382 354.821C976.079 354.821 977.463 353.446 977.463 351.74C977.463 350.034 976.079 348.668 974.382 348.668Z"
            fill="white"
          />
          <path
            d="M961.319 363.727C959.656 363.727 958.302 365.08 958.302 366.744C958.302 368.407 959.656 369.761 961.319 369.761C962.983 369.761 964.336 368.407 964.336 366.744C964.336 365.08 962.983 363.727 961.319 363.727Z"
            fill="white"
          />
          <path
            d="M949.848 382.586C948.227 382.586 946.903 383.906 946.903 385.531C946.903 387.156 948.227 388.476 949.848 388.476C951.47 388.476 952.794 387.156 952.794 385.531C952.794 383.906 951.47 382.586 949.848 382.586Z"
            fill="white"
          />
          <path
            d="M940.576 405.244C938.984 405.244 937.694 406.547 937.694 408.138C937.694 409.73 938.984 411.02 940.576 411.02C942.167 411.02 943.47 409.73 943.47 408.138C943.47 406.547 942.18 405.244 940.576 405.244Z"
            fill="white"
          />
          <path
            d="M935.165 432.199C933.603 432.199 932.343 433.468 932.343 435.03C932.343 436.591 933.603 437.852 935.165 437.852C936.727 437.852 937.987 436.591 937.987 435.03C937.987 433.468 936.727 432.199 935.165 432.199Z"
            fill="white"
          />
          <path
            d="M935.072 463.162C933.54 463.162 932.305 464.401 932.305 465.929C932.305 467.457 933.544 468.687 935.072 468.687C936.599 468.687 937.83 467.448 937.83 465.929C937.83 464.41 936.591 463.162 935.072 463.162Z"
            fill="white"
          />
          <path
            d="M940.547 497.303C939.07 497.303 937.86 498.512 937.86 499.989C937.86 501.466 939.07 502.675 940.547 502.675C942.024 502.675 943.233 501.47 943.233 499.989C943.233 498.508 942.024 497.303 940.547 497.303Z"
            fill="white"
          />
          <path
            d="M950.486 533.949C949.039 533.949 947.863 535.125 947.863 536.572C947.863 538.019 949.039 539.195 950.486 539.195C951.933 539.195 953.108 538.019 953.108 536.572C953.108 535.125 951.933 533.949 950.486 533.949Z"
            fill="white"
          />
          <path
            d="M962.681 572.998C961.264 572.998 960.122 574.144 960.122 575.557C960.122 576.97 961.268 578.116 962.681 578.116C964.094 578.116 965.24 576.97 965.24 575.557C965.24 574.144 964.094 572.998 962.681 572.998Z"
            fill="white"
          />
          <path
            d="M974.797 614.746C973.422 614.746 972.297 615.871 972.297 617.254C972.297 618.638 973.422 619.754 974.797 619.754C976.171 619.754 977.305 618.629 977.305 617.254C977.305 615.879 976.18 614.746 974.797 614.746Z"
            fill="white"
          />
          <path
            d="M984.737 659.707C983.396 659.707 982.322 660.789 982.322 662.13C982.322 663.471 983.396 664.545 984.737 664.545C986.078 664.545 987.152 663.463 987.152 662.13C987.152 660.798 986.069 659.707 984.737 659.707Z"
            fill="white"
          />
          <path
            d="M288.626 673.84C287.646 673.84 286.856 674.629 286.856 675.61C286.856 676.59 287.646 677.379 288.626 677.379C289.606 677.379 290.396 676.59 290.396 675.61C290.396 674.629 289.606 673.84 288.626 673.84Z"
            fill="white"
          />
          <path
            d="M267.768 663.152C266.78 663.152 265.99 663.954 265.99 664.93C265.99 665.907 266.78 666.709 267.768 666.709C268.757 666.709 269.538 665.919 269.538 664.93C269.538 663.942 268.749 663.152 267.768 663.152Z"
            fill="white"
          />
          <path
            d="M246.163 651.611C245.174 651.611 244.385 652.401 244.385 653.389C244.385 654.378 245.174 655.168 246.163 655.168C247.152 655.168 247.941 654.366 247.941 653.389C247.941 652.413 247.139 651.611 246.163 651.611Z"
            fill="white"
          />
          <path
            d="M223.523 639.1C222.535 639.1 221.732 639.889 221.732 640.878C221.732 641.867 222.535 642.669 223.523 642.669C224.512 642.669 225.301 641.867 225.301 640.878C225.301 639.889 224.499 639.1 223.523 639.1Z"
            fill="white"
          />
          <path
            d="M199.533 626.256C198.544 626.256 197.755 627.058 197.755 628.034C197.755 629.01 198.544 629.825 199.533 629.825C200.522 629.825 201.311 629.023 201.311 628.034C201.311 627.045 200.522 626.256 199.533 626.256Z"
            fill="white"
          />
          <path
            d="M173.659 613.256C172.67 613.256 171.868 614.058 171.868 615.047C171.868 616.036 172.67 616.846 173.659 616.846C174.648 616.846 175.458 616.044 175.458 615.047C175.458 614.049 174.648 613.256 173.659 613.256Z"
            fill="white"
          />
          <path
            d="M145.348 600.643C144.36 600.643 143.558 601.445 143.558 602.433C143.558 603.422 144.36 604.224 145.348 604.224C146.337 604.224 147.139 603.422 147.139 602.433C147.139 601.445 146.337 600.643 145.348 600.643Z"
            fill="white"
          />
          <path
            d="M114.2 586.852C113.202 586.852 112.4 587.662 112.4 588.651C112.4 589.64 113.202 590.463 114.2 590.463C115.197 590.463 115.999 589.652 115.999 588.651C115.999 587.649 115.197 586.852 114.2 586.852Z"
            fill="white"
          />
          <path
            d="M94.8174 570.967C93.7989 570.967 92.9756 571.799 92.9756 572.821C92.9756 573.844 93.7989 574.663 94.8174 574.663C95.8359 574.663 96.6719 573.84 96.6719 572.821C96.6719 571.803 95.8401 570.967 94.8174 570.967Z"
            fill="white"
          />
          <path
            d="M77.0532 555.668C76.0135 555.668 75.1689 556.512 75.1689 557.561C75.1689 558.609 76.0135 559.445 77.0532 559.445C78.0929 559.445 78.9459 558.6 78.9459 557.561C78.9459 556.521 78.1014 555.668 77.0532 555.668Z"
            fill="white"
          />
          <path
            d="M62.5016 542.273C61.4279 542.273 60.5537 543.148 60.5537 544.221C60.5537 545.295 61.4279 546.156 62.5016 546.156C63.5753 546.156 64.4367 545.291 64.4367 544.221C64.4367 543.152 63.571 542.273 62.5016 542.273Z"
            fill="white"
          />
          <path
            d="M51.6076 531.398C50.483 531.398 49.5791 532.315 49.5791 533.427C49.5791 534.539 50.483 535.455 51.6076 535.455C52.7322 535.455 53.6361 534.552 53.6361 533.427C53.6361 532.302 52.7322 531.398 51.6076 531.398Z"
            fill="white"
          />
          <path
            d="M44.1647 523.029C43.0104 523.029 42.0811 523.954 42.0811 525.113C42.0811 526.272 43.0062 527.205 44.1647 527.205C45.3233 527.205 46.2569 526.267 46.2569 525.113C46.2569 523.959 45.319 523.029 44.1647 523.029Z"
            fill="white"
          />
          <path
            d="M39.48 516.607C38.2918 516.607 37.3369 517.575 37.3369 518.751C37.3369 519.926 38.296 520.906 39.48 520.906C40.664 520.906 41.6231 519.939 41.6231 518.751C41.6231 517.562 40.664 516.607 39.48 516.607Z"
            fill="white"
          />
          <path
            d="M36.7849 511.592C35.5584 511.592 34.5781 512.581 34.5781 513.799C34.5781 515.016 35.5584 516.005 36.7849 516.005C38.0113 516.005 38.9916 515.016 38.9916 513.799C38.9916 512.581 38.0028 511.592 36.7849 511.592Z"
            fill="white"
          />
          <path
            d="M35.5159 507.553C34.2471 507.553 33.2158 508.584 33.2158 509.853C33.2158 511.122 34.2471 512.144 35.5159 512.144C36.7848 512.144 37.816 511.126 37.816 509.853C37.816 508.58 36.7848 507.553 35.5159 507.553Z"
            fill="white"
          />
          <path
            d="M35.2573 504.262C33.9545 504.262 32.9062 505.314 32.9062 506.625C32.9062 507.937 33.9587 508.977 35.2573 508.977C36.5559 508.977 37.6211 507.924 37.6211 506.625C37.6211 505.327 36.5686 504.262 35.2573 504.262Z"
            fill="white"
          />
          <path
            d="M35.6302 501.434C34.2892 501.434 33.207 502.516 33.207 503.857C33.207 505.198 34.2892 506.28 35.6302 506.28C36.9712 506.28 38.0534 505.198 38.0534 503.857C38.0534 502.516 36.9712 501.434 35.6302 501.434Z"
            fill="white"
          />
          <path
            d="M36.3902 498.924C35.0152 498.924 33.9033 500.036 33.9033 501.411C33.9033 502.786 35.0152 503.897 36.3902 503.897C37.7651 503.897 38.8685 502.786 38.8685 501.411C38.8685 500.036 37.7651 498.924 36.3902 498.924Z"
            fill="white"
          />
          <path
            d="M37.3705 496.604C35.9531 496.604 34.7988 497.749 34.7988 499.175C34.7988 500.601 35.9531 501.755 37.3705 501.755C38.788 501.755 39.9507 500.601 39.9507 499.175C39.9507 497.749 38.7964 496.604 37.3705 496.604Z"
            fill="white"
          />
          <path
            d="M38.4603 494.438C36.9919 494.438 35.8164 495.626 35.8164 497.081C35.8164 498.537 36.9919 499.725 38.4603 499.725C39.9286 499.725 41.0914 498.537 41.0914 497.081C41.0914 495.626 39.9159 494.438 38.4603 494.438Z"
            fill="white"
          />
          <path
            d="M39.4926 492.348C38.0031 492.348 36.7979 493.557 36.7979 495.055C36.7979 496.553 38.0031 497.75 39.4926 497.75C40.9822 497.75 42.2001 496.54 42.2001 495.055C42.2001 493.57 40.9949 492.348 39.4926 492.348Z"
            fill="white"
          />
          <path
            d="M40.3961 490.275C38.8769 490.275 37.6377 491.515 37.6377 493.034C37.6377 494.553 38.8769 495.792 40.3961 495.792C41.9154 495.792 43.1546 494.553 43.1546 493.034C43.1546 491.515 41.9281 490.275 40.3961 490.275Z"
            fill="white"
          />
          <path
            d="M41.1054 488.141C39.5225 488.141 38.2451 489.422 38.2451 491.001C38.2451 492.58 39.5267 493.853 41.1054 493.853C42.6841 493.853 43.9699 492.571 43.9699 491.001C43.9699 489.431 42.6883 488.141 41.1054 488.141Z"
            fill="white"
          />
          <path
            d="M41.5619 486.02C39.9493 486.02 38.6465 487.322 38.6465 488.922C38.6465 490.522 39.9493 491.838 41.5619 491.838C43.1746 491.838 44.4647 490.535 44.4647 488.922C44.4647 487.31 43.1618 486.02 41.5619 486.02Z"
            fill="white"
          />
          <path
            d="M41.7418 483.834C40.0952 483.834 38.7754 485.167 38.7754 486.8C38.7754 488.434 40.0994 489.767 41.7418 489.767C43.3841 489.767 44.7082 488.443 44.7082 486.8C44.7082 485.158 43.3756 483.834 41.7418 483.834Z"
            fill="white"
          />
          <path
            d="M41.615 481.605C39.9514 481.605 38.5977 482.959 38.5977 484.623C38.5977 486.286 39.9514 487.653 41.615 487.653C43.2785 487.653 44.645 486.299 44.645 484.623C44.645 482.946 43.2912 481.605 41.615 481.605Z"
            fill="white"
          />
          <path
            d="M41.1898 479.275C39.471 479.275 38.0791 480.672 38.0791 482.399C38.0791 484.126 39.4753 485.509 41.1898 485.509C42.9042 485.509 44.3132 484.113 44.3132 482.399C44.3132 480.684 42.917 479.275 41.1898 479.275Z"
            fill="white"
          />
          <path
            d="M40.4471 476.941C38.6987 476.941 37.2812 478.359 37.2812 480.107C37.2812 481.856 38.6987 483.269 40.4471 483.269C42.1955 483.269 43.6087 481.851 43.6087 480.107C43.6087 478.363 42.1913 476.941 40.4471 476.941Z"
            fill="white"
          />
          <path
            d="M39.442 474.582C37.6639 474.582 36.2168 476.021 36.2168 477.799C36.2168 479.577 37.6639 481.016 39.442 481.016C41.2202 481.016 42.6588 479.577 42.6588 477.799C42.6588 476.021 41.2117 474.582 39.442 474.582Z"
            fill="white"
          />
          <path
            d="M38.1166 472.188C36.3173 472.188 34.8574 473.656 34.8574 475.455C34.8574 477.255 36.313 478.723 38.1166 478.723C39.9202 478.723 41.3843 477.255 41.3843 475.455C41.3843 473.656 39.9287 472.188 38.1166 472.188Z"
            fill="white"
          />
          <path
            d="M36.4756 469.719C34.6338 469.719 33.1357 471.217 33.1357 473.059C33.1357 474.9 34.6338 476.398 36.4756 476.398C38.3174 476.398 39.8154 474.909 39.8154 473.059C39.8154 471.208 38.3258 469.719 36.4756 469.719Z"
            fill="white"
          />
          <path
            d="M34.4757 467.232C32.6042 467.232 31.085 468.752 31.085 470.615C31.085 472.478 32.6042 474.005 34.4757 474.005C36.3472 474.005 37.858 472.486 37.858 470.615C37.858 468.743 36.3387 467.232 34.4757 467.232Z"
            fill="white"
          />
          <path
            d="M32.0689 464.674C30.1762 464.674 28.6357 466.214 28.6357 468.107C28.6357 470 30.1762 471.54 32.0689 471.54C33.9616 471.54 35.5021 470.008 35.5021 468.107C35.5021 466.206 33.9701 464.674 32.0689 464.674Z"
            fill="white"
          />
          <path
            d="M29.2608 462.039C27.3341 462.039 25.7852 463.601 25.7852 465.515C25.7852 467.429 27.3384 469.003 29.2608 469.003C31.1832 469.003 32.7364 467.441 32.7364 465.515C32.7364 463.588 31.1747 462.039 29.2608 462.039Z"
            fill="white"
          />
          <path
            d="M26.0146 459.283C24.0498 459.283 22.4541 460.875 22.4541 462.844C22.4541 464.813 24.0455 466.391 26.0146 466.391C27.9837 466.391 29.5624 464.809 29.5624 462.844C29.5624 460.879 27.971 459.283 26.0146 459.283Z"
            fill="white"
          />
          <path
            d="M22.3181 456.484C20.3405 456.484 18.7363 458.088 18.7363 460.066C18.7363 462.044 20.3405 463.648 22.3181 463.648C24.2956 463.648 25.8998 462.044 25.8998 460.066C25.8998 458.088 24.2956 456.484 22.3181 456.484Z"
            fill="white"
          />
          <path
            d="M18.1756 453.559C16.1768 453.559 14.5557 455.184 14.5557 457.179C14.5557 459.173 16.181 460.811 18.1756 460.811C20.1701 460.811 21.8082 459.186 21.8082 457.179C21.8082 455.171 20.1829 453.559 18.1756 453.559Z"
            fill="white"
          />
          <path
            d="M13.5891 450.529C11.5606 450.529 9.92676 452.176 9.92676 454.204C9.92676 456.233 11.5606 457.879 13.5891 457.879C15.6176 457.879 17.2642 456.233 17.2642 454.204C17.2642 452.176 15.6176 450.529 13.5891 450.529Z"
            fill="white"
          />
          <path
            d="M8.55996 447.418C6.51023 447.418 4.84668 449.081 4.84668 451.144C4.84668 453.206 6.51023 454.861 8.55996 454.861C10.6097 454.861 12.2775 453.198 12.2775 451.144C12.2775 449.09 10.6224 447.418 8.55996 447.418Z"
            fill="white"
          />
          <path
            d="M3.11442 444.262C1.04347 444.262 -0.632812 445.938 -0.632812 448.009C-0.632812 450.08 1.04347 451.756 3.11442 451.756C5.18537 451.756 6.87014 450.08 6.87014 448.009C6.87014 445.938 5.18537 444.262 3.11442 444.262Z"
            fill="white"
          />
          <path
            d="M-2.71228 441.035C-4.80445 441.035 -6.50195 442.733 -6.50195 444.825C-6.50195 446.917 -4.80445 448.614 -2.71228 448.614C-0.620116 448.614 1.07738 446.917 1.07738 444.825C1.07738 442.733 -0.620116 441.035 -2.71228 441.035Z"
            fill="white"
          />
          <path
            d="M2.77125 69.7949C1.09497 69.7949 -0.258789 71.1529 -0.258789 72.825C-0.258789 74.497 1.09497 75.8635 2.77125 75.8635C4.44753 75.8635 5.80977 74.5012 5.80977 72.825C5.80977 71.1487 4.44753 69.7949 2.77125 69.7949Z"
            fill="white"
          />
          <path
            d="M11.8186 56.5684C10.172 56.5684 8.84375 57.9009 8.84375 59.5432C8.84375 61.1856 10.1763 62.5096 11.8186 62.5096C13.461 62.5096 14.7935 61.1771 14.7935 59.5432C14.7935 57.9094 13.461 56.5684 11.8186 56.5684Z"
            fill="white"
          />
          <path
            d="M19.8097 44.4238C18.1971 44.4238 16.8857 45.7351 16.8857 47.3478C16.8857 48.9604 18.1971 50.2717 19.8097 50.2717C21.4223 50.2717 22.7336 48.9646 22.7336 47.3478C22.7336 45.7309 21.4223 44.4238 19.8097 44.4238Z"
            fill="white"
          />
          <path
            d="M26.5952 33.873C25.0335 33.873 23.7646 35.1377 23.7646 36.7036C23.7646 38.2696 25.0335 39.5342 26.5952 39.5342C28.1569 39.5342 29.4258 38.2696 29.4258 36.7036C29.4258 35.1377 28.1569 33.873 26.5952 33.873Z"
            fill="white"
          />
          <path
            d="M32.2777 24.7207C30.7457 24.7207 29.498 25.9641 29.498 27.5004C29.498 29.0366 30.7457 30.2673 32.2777 30.2673C33.8097 30.2673 35.0446 29.0281 35.0446 27.5004C35.0446 25.9726 33.8055 24.7207 32.2777 24.7207Z"
            fill="white"
          />
          <path
            d="M37.1079 16.6777C35.6099 16.6777 34.4004 17.8957 34.4004 19.3852C34.4004 20.8748 35.6099 22.0928 37.1079 22.0928C38.6059 22.0928 39.8154 20.8833 39.8154 19.3852C39.8154 17.8872 38.5975 16.6777 37.1079 16.6777Z"
            fill="white"
          />
          <path
            d="M41.3975 9.27734C39.9291 9.27734 38.7451 10.4656 38.7451 11.9212C38.7451 13.3768 39.9334 14.5735 41.3975 14.5735C42.8616 14.5735 44.0413 13.3853 44.0413 11.9212C44.0413 10.4571 42.8531 9.27734 41.3975 9.27734Z"
            fill="white"
          />
          <path
            d="M45.362 2.19141C43.9573 2.19141 42.8115 3.33722 42.8115 4.7419C42.8115 6.14658 43.9573 7.30088 45.362 7.30088C46.7667 7.30088 47.921 6.15507 47.921 4.7419C47.921 3.32873 46.7752 2.19141 45.362 2.19141Z"
            fill="white"
          />
          <path
            d="M1031.77 -0.402344C1030.29 -0.402344 1029.08 0.798637 1029.08 2.27546C1029.08 3.75229 1030.29 4.95327 1031.77 4.95327C1033.25 4.95327 1034.44 3.75653 1034.44 2.27546C1034.44 0.794393 1033.25 -0.402344 1031.77 -0.402344Z"
            fill="white"
          />
          <path
            d="M1038.7 11.5977C1037.19 11.5977 1035.96 12.8241 1035.96 14.3349C1035.96 15.8456 1037.19 17.0763 1038.7 17.0763C1040.21 17.0763 1041.44 15.8541 1041.44 14.3349C1041.44 12.8156 1040.21 11.5977 1038.7 11.5977Z"
            fill="white"
          />
          <path
            d="M1045.82 23.3145C1044.28 23.3145 1043.03 24.5621 1043.03 26.1026C1043.03 27.6431 1044.28 28.9035 1045.82 28.9035C1047.36 28.9035 1048.62 27.6558 1048.62 26.1026C1048.62 24.5494 1047.37 23.3145 1045.82 23.3145Z"
            fill="white"
          />
          <path
            d="M1053.16 34.6621C1051.57 34.6621 1050.28 35.9522 1050.28 37.5351C1050.28 39.118 1051.57 40.4166 1053.16 40.4166C1054.75 40.4166 1056.03 39.1265 1056.03 37.5351C1056.03 35.9437 1054.74 34.6621 1053.16 34.6621Z"
            fill="white"
          />
          <path
            d="M1060.68 45.7168C1059.06 45.7168 1057.75 47.0324 1057.75 48.645C1057.75 50.2576 1059.06 51.5774 1060.68 51.5774C1062.31 51.5774 1063.61 50.2661 1063.61 48.645C1063.61 47.0239 1062.3 45.7168 1060.68 45.7168Z"
            fill="white"
          />
          <path
            d="M1068.43 56.4043C1066.78 56.4043 1065.44 57.7453 1065.44 59.3919C1065.44 61.0385 1066.78 62.388 1068.43 62.388C1070.07 62.388 1071.42 61.047 1071.42 59.3919C1071.42 57.7368 1070.08 56.4043 1068.43 56.4043Z"
            fill="white"
          />
          <path
            d="M1076.3 66.873C1074.62 66.873 1073.25 68.2353 1073.25 69.9243C1073.25 71.6133 1074.61 72.9756 1076.3 72.9756C1077.99 72.9756 1079.35 71.6133 1079.35 69.9243C1079.35 68.2353 1077.99 66.873 1076.3 66.873Z"
            fill="white"
          />
          <path
            d="M1084.26 77.1602C1082.53 77.1602 1081.13 78.5606 1081.13 80.2878C1081.13 82.015 1082.53 83.4197 1084.26 83.4197C1085.98 83.4197 1087.39 82.015 1087.39 80.2878C1087.39 78.5606 1085.99 77.1602 1084.26 77.1602Z"
            fill="white"
          />
          <path
            d="M1092.25 87.4082C1090.49 87.4082 1089.06 88.8299 1089.06 90.5868C1089.06 92.3437 1090.49 93.7653 1092.25 93.7653C1094.01 93.7653 1095.44 92.3394 1095.44 90.5868C1095.44 88.8341 1094.01 87.4082 1092.25 87.4082Z"
            fill="white"
          />
          <path
            d="M1100.21 97.6699C1098.41 97.6699 1096.97 99.117 1096.97 100.908C1096.97 102.699 1098.41 104.154 1100.21 104.154C1102.01 104.154 1103.45 102.699 1103.45 100.908C1103.45 99.117 1102 97.6699 1100.21 97.6699Z"
            fill="white"
          />
          <path
            d="M1108.14 107.973C1106.32 107.973 1104.85 109.445 1104.85 111.262C1104.85 113.078 1106.32 114.55 1108.14 114.55C1109.96 114.55 1111.43 113.082 1111.43 111.262C1111.43 109.441 1109.95 107.973 1108.14 107.973Z"
            fill="white"
          />
          <path
            d="M1116 118.35C1114.15 118.35 1112.64 119.852 1112.64 121.711C1112.64 123.569 1114.15 125.072 1116 125.072C1117.85 125.072 1119.37 123.569 1119.37 121.711C1119.37 119.852 1117.86 118.35 1116 118.35Z"
            fill="white"
          />
          <path
            d="M1123.77 128.895C1121.89 128.895 1120.36 130.427 1120.36 132.319C1120.36 134.212 1121.89 135.735 1123.77 135.735C1125.65 135.735 1127.2 134.203 1127.2 132.319C1127.2 130.435 1125.67 128.895 1123.77 128.895Z"
            fill="white"
          />
          <path
            d="M1131.43 139.656C1129.51 139.656 1127.96 141.205 1127.96 143.123C1127.96 145.042 1129.51 146.591 1131.43 146.591C1133.34 146.591 1134.89 145.033 1134.89 143.123C1134.89 141.214 1133.34 139.656 1131.43 139.656Z"
            fill="white"
          />
          <path
            d="M1138.91 157.688C1140.84 157.688 1142.41 156.119 1142.41 154.183C1142.41 152.247 1140.84 150.678 1138.91 150.678C1136.97 150.678 1135.4 152.247 1135.4 154.183C1135.4 156.119 1136.97 157.688 1138.91 157.688Z"
            fill="white"
          />
          <path
            d="M1146.24 161.938C1144.26 161.938 1142.67 163.542 1142.67 165.506C1142.67 167.471 1144.26 169.075 1146.24 169.075C1148.21 169.075 1149.81 167.484 1149.81 165.506C1149.81 163.529 1148.2 161.938 1146.24 161.938Z"
            fill="white"
          />
          <path
            d="M1153.45 173.408C1151.45 173.408 1149.83 175.034 1149.83 177.028C1149.83 179.023 1151.45 180.644 1153.45 180.644C1155.44 180.644 1157.07 179.027 1157.07 177.028C1157.07 175.029 1155.44 173.408 1153.45 173.408Z"
            fill="white"
          />
          <path
            d="M1160.61 184.994C1158.58 184.994 1156.95 186.628 1156.95 188.652C1156.95 190.677 1158.58 192.31 1160.61 192.31C1162.64 192.31 1164.26 190.677 1164.26 188.652C1164.26 186.628 1162.63 184.994 1160.61 184.994Z"
            fill="white"
          />
          <path
            d="M1167.77 196.545C1165.73 196.545 1164.07 198.204 1164.07 200.25C1164.07 202.295 1165.73 203.955 1167.77 203.955C1169.81 203.955 1171.47 202.291 1171.47 200.25C1171.47 198.208 1169.82 196.545 1167.77 196.545Z"
            fill="white"
          />
          <path
            d="M1175.09 207.838C1173.01 207.838 1171.33 209.523 1171.33 211.606C1171.33 213.69 1173.01 215.362 1175.09 215.362C1177.16 215.362 1178.85 213.677 1178.85 211.606C1178.85 209.535 1177.17 207.838 1175.09 207.838Z"
            fill="white"
          />
          <path
            d="M1182.67 218.686C1180.57 218.686 1178.87 220.383 1178.87 222.484C1178.87 224.584 1180.57 226.295 1182.67 226.295C1184.76 226.295 1186.48 224.589 1186.48 222.484C1186.48 220.379 1184.77 218.686 1182.67 218.686Z"
            fill="white"
          />
          <path
            d="M1193.18 235.657C1194.68 234.157 1194.68 231.726 1193.18 230.226C1191.68 228.726 1189.25 228.726 1187.75 230.226C1186.25 231.726 1186.25 234.157 1187.75 235.657C1189.25 237.157 1191.68 237.157 1193.18 235.657Z"
            fill="white"
          />
          <path
            d="M1198.57 238.947C1196.43 238.947 1194.7 240.674 1194.7 242.818C1194.7 244.961 1196.43 246.688 1198.57 246.688C1200.72 246.688 1202.44 244.948 1202.44 242.818C1202.44 240.687 1200.7 238.947 1198.57 238.947Z"
            fill="white"
          />
          <path
            d="M1206.98 248.105C1204.81 248.105 1203.05 249.867 1203.05 252.039C1203.05 254.212 1204.81 255.965 1206.98 255.965C1209.14 255.965 1210.91 254.204 1210.91 252.039C1210.91 249.875 1209.15 248.105 1206.98 248.105Z"
            fill="white"
          />
          <path
            d="M1215.73 256.535C1213.53 256.535 1211.76 258.313 1211.76 260.499C1211.76 262.684 1213.53 264.454 1215.73 264.454C1217.92 264.454 1219.68 262.684 1219.68 260.499C1219.68 258.313 1217.91 256.535 1215.73 256.535Z"
            fill="white"
          />
          <path
            d="M1224.81 264.154C1222.6 264.154 1220.82 265.945 1220.82 268.139C1220.82 270.333 1222.6 272.137 1224.81 272.137C1227.01 272.137 1228.8 270.346 1228.8 268.139C1228.8 265.932 1227.01 264.154 1224.81 264.154Z"
            fill="white"
          />
          <path
            d="M1234.22 270.93C1232.01 270.93 1230.22 272.721 1230.22 274.936C1230.22 277.151 1232.01 278.955 1234.22 278.955C1236.44 278.955 1238.24 277.155 1238.24 274.936C1238.24 272.716 1236.44 270.93 1234.22 270.93Z"
            fill="white"
          />
          <path
            d="M1243.97 276.777C1241.73 276.777 1239.91 278.589 1239.91 280.834C1239.91 283.079 1241.73 284.883 1243.97 284.883C1246.2 284.883 1248.02 283.071 1248.02 280.834C1248.02 278.598 1246.2 276.777 1243.97 276.777Z"
            fill="white"
          />
          <path
            d="M1253.99 281.732C1251.74 281.732 1249.91 283.566 1249.91 285.823C1249.91 288.081 1251.75 289.902 1253.99 289.902C1256.24 289.902 1258.08 288.081 1258.08 285.823C1258.08 283.566 1256.25 281.732 1253.99 281.732Z"
            fill="white"
          />
          <path
            d="M1264.26 285.783C1261.99 285.783 1260.16 287.617 1260.16 289.883C1260.16 292.149 1261.99 293.995 1264.26 293.995C1266.52 293.995 1268.37 292.153 1268.37 289.883C1268.37 287.612 1266.53 285.783 1264.26 285.783Z"
            fill="white"
          />
          <path
            d="M1274.71 288.926C1272.43 288.926 1270.59 290.78 1270.59 293.059C1270.59 295.338 1272.43 297.18 1274.71 297.18C1276.99 297.18 1278.84 295.338 1278.84 293.059C1278.84 290.78 1276.99 288.926 1274.71 288.926Z"
            fill="white"
          />
          <path
            d="M1285.28 291.172C1282.99 291.172 1281.13 293.035 1281.13 295.326C1281.13 297.618 1282.99 299.481 1285.28 299.481C1287.58 299.481 1289.43 297.618 1289.43 295.326C1289.43 293.035 1287.57 291.172 1285.28 291.172Z"
            fill="white"
          />
          <path
            d="M1295.91 292.568C1293.61 292.568 1291.76 294.431 1291.76 296.723C1291.76 299.015 1293.61 300.878 1295.91 300.878C1298.22 300.878 1300.07 299.023 1300.07 296.723C1300.07 294.423 1298.21 292.568 1295.91 292.568Z"
            fill="white"
          />
          <path
            d="M1306.51 293.15C1304.21 293.15 1302.35 295.013 1302.35 297.305C1302.35 299.597 1304.21 301.468 1306.51 301.468C1308.8 301.468 1310.67 299.605 1310.67 297.305C1310.67 295.005 1308.81 293.15 1306.51 293.15Z"
            fill="white"
          />
          <path
            d="M1317.03 293.004C1314.73 293.004 1312.88 294.867 1312.88 297.159C1312.88 299.45 1314.73 301.313 1317.03 301.313C1319.33 301.313 1321.19 299.463 1321.19 297.159C1321.19 294.854 1319.32 293.004 1317.03 293.004Z"
            fill="white"
          />
          <path
            d="M1327.39 292.217C1325.1 292.217 1323.24 294.08 1323.24 296.38C1323.24 298.68 1325.1 300.535 1327.39 300.535C1329.69 300.535 1331.55 298.672 1331.55 296.38C1331.55 294.088 1329.69 292.217 1327.39 292.217Z"
            fill="white"
          />
          <path
            d="M1337.6 290.828C1335.29 290.828 1333.44 292.691 1333.44 294.991C1333.44 297.291 1335.29 299.146 1337.6 299.146C1339.9 299.146 1341.75 297.283 1341.75 294.991C1341.75 292.7 1339.89 290.828 1337.6 290.828Z"
            fill="white"
          />
          <path
            d="M1347.59 288.955C1345.29 288.955 1343.43 290.805 1343.43 293.11C1343.43 295.414 1345.29 297.264 1347.59 297.264C1349.88 297.264 1351.74 295.401 1351.74 293.11C1351.74 290.818 1349.89 288.955 1347.59 288.955Z"
            fill="white"
          />
          <path
            d="M1357.35 286.684C1355.06 286.684 1353.2 288.547 1353.2 290.838C1353.2 293.13 1355.06 294.993 1357.35 294.993C1359.64 294.993 1361.51 293.138 1361.51 290.838C1361.51 288.538 1359.65 286.684 1357.35 286.684Z"
            fill="white"
          />
          <path
            d="M1366.87 284.17C1364.57 284.17 1362.72 286.033 1362.72 288.325C1362.72 290.616 1364.57 292.479 1366.87 292.479C1369.18 292.479 1371.03 290.616 1371.03 288.325C1371.03 286.033 1369.16 284.17 1366.87 284.17Z"
            fill="white"
          />
          <path
            d="M1363.29 287.143C1361 287.143 1359.14 288.997 1359.14 291.297C1359.14 293.597 1361 295.452 1363.29 295.452C1365.58 295.452 1367.45 293.589 1367.45 291.297C1367.45 289.006 1365.59 287.143 1363.29 287.143Z"
            fill="white"
          />
          <path
            d="M1359.57 289.916C1357.28 289.916 1355.41 291.771 1355.41 294.071C1355.41 296.371 1357.28 298.225 1359.57 298.225C1361.86 298.225 1363.72 296.362 1363.72 294.071C1363.72 291.779 1361.87 289.916 1359.57 289.916Z"
            fill="white"
          />
          <path
            d="M1355.6 292.539C1353.3 292.539 1351.45 294.402 1351.45 296.694C1351.45 298.985 1353.3 300.857 1355.6 300.857C1357.9 300.857 1359.76 298.994 1359.76 296.694C1359.76 294.394 1357.9 292.539 1355.6 292.539Z"
            fill="white"
          />
          <path
            d="M1351.3 295.09C1349.01 295.09 1347.15 296.953 1347.15 299.24C1347.15 301.528 1349.01 303.395 1351.3 303.395C1353.59 303.395 1355.46 301.545 1355.46 299.24C1355.46 296.936 1353.59 295.09 1351.3 295.09Z"
            fill="white"
          />
          <path
            d="M1346.61 297.582C1344.32 297.582 1342.46 299.445 1342.46 301.737C1342.46 304.028 1344.32 305.891 1346.61 305.891C1348.9 305.891 1350.76 304.037 1350.76 301.737C1350.76 299.437 1348.9 297.582 1346.61 297.582Z"
            fill="white"
          />
          <path
            d="M1341.44 300.049C1339.15 300.049 1337.29 301.912 1337.29 304.203C1337.29 306.495 1339.15 308.358 1341.44 308.358C1343.74 308.358 1345.6 306.504 1345.6 304.203C1345.6 301.903 1343.74 300.049 1341.44 300.049Z"
            fill="white"
          />
          <path
            d="M1335.78 302.484C1333.48 302.484 1331.62 304.347 1331.62 306.639C1331.62 308.931 1333.48 310.794 1335.78 310.794C1338.08 310.794 1339.93 308.931 1339.93 306.639C1339.93 304.347 1338.07 302.484 1335.78 302.484Z"
            fill="white"
          />
          <path
            d="M1329.54 304.857C1327.25 304.857 1325.39 306.72 1325.39 309.012C1325.39 311.304 1327.25 313.167 1329.54 313.167C1331.83 313.167 1333.7 311.316 1333.7 309.012C1333.7 306.708 1331.84 304.857 1329.54 304.857Z"
            fill="white"
          />
          <path
            d="M1322.74 307.148C1320.45 307.148 1318.59 309.003 1318.59 311.303C1318.59 313.603 1320.45 315.458 1322.74 315.458C1325.03 315.458 1326.91 313.595 1326.91 311.303C1326.91 309.011 1325.04 307.148 1322.74 307.148Z"
            fill="white"
          />
          <path
            d="M1315.38 309.324C1313.08 309.324 1311.22 311.187 1311.22 313.479C1311.22 315.77 1313.08 317.633 1315.38 317.633C1317.67 317.633 1319.53 315.77 1319.53 313.479C1319.53 311.187 1317.67 309.324 1315.38 309.324Z"
            fill="white"
          />
          <path
            d="M1307.43 311.355C1305.14 311.355 1303.28 313.206 1303.28 315.51C1303.28 317.814 1305.14 319.665 1307.43 319.665C1309.72 319.665 1311.59 317.802 1311.59 315.51C1311.59 313.218 1309.73 311.355 1307.43 311.355Z"
            fill="white"
          />
          <path
            d="M1298.95 313.156C1296.65 313.156 1294.79 315.007 1294.79 317.311C1294.79 319.615 1296.65 321.466 1298.95 321.466C1301.25 321.466 1303.11 319.603 1303.11 317.311C1303.11 315.019 1301.24 313.156 1298.95 313.156Z"
            fill="white"
          />
          <path
            d="M1289.95 314.652C1287.65 314.652 1285.79 316.515 1285.79 318.807C1285.79 321.099 1287.65 322.962 1289.95 322.962C1292.25 322.962 1294.1 321.111 1294.1 318.807C1294.1 316.503 1292.24 314.652 1289.95 314.652Z"
            fill="white"
          />
          <path
            d="M1280.49 315.799C1278.2 315.799 1276.35 317.649 1276.35 319.932C1276.35 322.215 1278.2 324.066 1280.49 324.066C1282.78 324.066 1284.62 322.224 1284.62 319.932C1284.62 317.641 1282.77 315.799 1280.49 315.799Z"
            fill="white"
          />
          <path
            d="M1270.62 316.529C1268.35 316.529 1266.51 318.371 1266.51 320.641C1266.51 322.912 1268.35 324.754 1270.62 324.754C1272.89 324.754 1274.73 322.912 1274.73 320.641C1274.73 318.371 1272.89 316.529 1270.62 316.529Z"
            fill="white"
          />
          <path
            d="M1260.4 316.881C1258.14 316.881 1256.32 318.701 1256.32 320.959C1256.32 323.217 1258.14 325.029 1260.4 325.029C1262.66 325.029 1264.48 323.208 1264.48 320.959C1264.48 318.71 1262.64 316.881 1260.4 316.881Z"
            fill="white"
          />
          <path
            d="M1249.85 316.809C1247.62 316.809 1245.8 318.621 1245.8 320.857C1245.8 323.094 1247.62 324.906 1249.85 324.906C1252.08 324.906 1253.9 323.094 1253.9 320.857C1253.9 318.621 1252.08 316.809 1249.85 316.809Z"
            fill="white"
          />
          <path
            d="M1239.02 316.266C1236.79 316.266 1235 318.078 1235 320.306C1235 322.534 1236.79 324.333 1239.02 324.333C1241.25 324.333 1243.05 322.534 1243.05 320.306C1243.05 318.078 1241.25 316.266 1239.02 316.266Z"
            fill="white"
          />
          <path
            d="M1227.95 315.268C1225.74 315.268 1223.94 317.067 1223.94 319.274C1223.94 321.48 1225.74 323.271 1227.95 323.271C1230.15 323.271 1231.94 321.48 1231.94 319.274C1231.94 317.067 1230.15 315.268 1227.95 315.268Z"
            fill="white"
          />
          <path
            d="M1216.66 313.955C1214.47 313.955 1212.7 315.725 1212.7 317.91C1212.7 320.096 1214.47 321.865 1216.66 321.865C1218.84 321.865 1220.61 320.096 1220.61 317.91C1220.61 315.725 1218.84 313.955 1216.66 313.955Z"
            fill="white"
          />
          <path
            d="M1205.14 312.408C1202.97 312.408 1201.21 314.165 1201.21 316.342C1201.21 318.519 1202.97 320.276 1205.14 320.276C1207.3 320.276 1209.07 318.506 1209.07 316.342C1209.07 314.178 1207.31 312.408 1205.14 312.408Z"
            fill="white"
          />
          <path
            d="M1193.42 310.752C1191.27 310.752 1189.53 312.492 1189.53 314.635C1189.53 316.778 1191.27 318.527 1193.42 318.527C1195.58 318.527 1197.31 316.787 1197.31 314.635C1197.31 312.483 1195.57 310.752 1193.42 310.752Z"
            fill="white"
          />
          <path
            d="M1181.53 309.055C1179.39 309.055 1177.68 310.782 1177.68 312.916C1177.68 315.051 1179.4 316.766 1181.53 316.766C1183.66 316.766 1185.39 315.038 1185.39 312.916C1185.39 310.795 1183.66 309.055 1181.53 309.055Z"
            fill="white"
          />
          <path
            d="M1169.49 307.471C1167.39 307.471 1165.69 309.168 1165.69 311.26C1165.69 313.353 1167.39 315.059 1169.49 315.059C1171.59 315.059 1173.29 313.361 1173.29 311.26C1173.29 309.16 1171.58 307.471 1169.49 307.471Z"
            fill="white"
          />
          <path
            d="M1157.33 306.025C1155.26 306.025 1153.56 307.71 1153.56 309.794C1153.56 311.878 1155.26 313.562 1157.33 313.562C1159.4 313.562 1161.1 311.878 1161.1 309.794C1161.1 307.71 1159.41 306.025 1157.33 306.025Z"
            fill="white"
          />
          <path
            d="M1145.05 304.807C1142.99 304.807 1141.32 306.47 1141.32 308.533C1141.32 310.595 1142.99 312.259 1145.05 312.259C1147.11 312.259 1148.77 310.595 1148.77 308.533C1148.77 306.47 1147.1 304.807 1145.05 304.807Z"
            fill="white"
          />
          <path
            d="M1132.63 303.891C1130.6 303.891 1128.95 305.546 1128.95 307.574C1128.95 309.603 1130.6 311.27 1132.63 311.27C1134.66 311.27 1136.33 309.615 1136.33 307.574C1136.33 305.533 1134.67 303.891 1132.63 303.891Z"
            fill="white"
          />
          <path
            d="M1120.16 303.424C1118.16 303.424 1116.54 305.049 1116.54 307.044C1116.54 309.038 1118.16 310.655 1120.16 310.655C1122.15 310.655 1123.78 309.043 1123.78 307.044C1123.78 305.045 1122.15 303.424 1120.16 303.424Z"
            fill="white"
          />
          <path
            d="M1107.56 303.381C1105.58 303.381 1103.98 304.985 1103.98 306.963C1103.98 308.94 1105.58 310.532 1107.56 310.532C1109.54 310.532 1111.14 308.94 1111.14 306.963C1111.14 304.985 1109.54 303.381 1107.56 303.381Z"
            fill="white"
          />
          <path
            d="M1094.78 303.818C1092.82 303.818 1091.24 305.401 1091.24 307.358C1091.24 309.314 1092.82 310.884 1094.78 310.884C1096.73 310.884 1098.32 309.301 1098.32 307.358C1098.32 305.414 1096.73 303.818 1094.78 303.818Z"
            fill="white"
          />
          <path
            d="M1085.08 309.705C1085.81 307.925 1084.97 305.884 1083.19 305.147C1081.41 304.41 1079.37 305.255 1078.63 307.035C1077.89 308.815 1078.74 310.855 1080.52 311.593C1082.3 312.33 1084.34 311.485 1085.08 309.705Z"
            fill="white"
          />
          <path
            d="M1068.72 306.691C1066.83 306.691 1065.3 308.223 1065.3 310.103C1065.3 311.983 1066.84 313.515 1068.72 313.515C1070.6 313.515 1072.13 311.983 1072.13 310.103C1072.13 308.223 1070.61 306.691 1068.72 306.691Z"
            fill="white"
          />
          <path
            d="M1055.35 309.271C1053.49 309.271 1051.98 310.791 1051.98 312.645C1051.98 314.5 1053.49 316.019 1055.35 316.019C1057.22 316.019 1058.73 314.508 1058.73 312.645C1058.73 310.782 1057.22 309.271 1055.35 309.271Z"
            fill="white"
          />
          <path
            d="M1041.79 312.861C1039.96 312.861 1038.48 314.338 1038.48 316.171C1038.48 318.005 1039.97 319.49 1041.79 319.49C1043.62 319.49 1045.1 318.001 1045.1 316.171C1045.1 314.342 1043.63 312.861 1041.79 312.861Z"
            fill="white"
          />
          <path
            d="M1027.9 317.641C1026.09 317.641 1024.63 319.096 1024.63 320.9C1024.63 322.703 1026.09 324.168 1027.9 324.168C1029.71 324.168 1031.17 322.712 1031.17 320.9C1031.17 319.088 1029.7 317.641 1027.9 317.641Z"
            fill="white"
          />
          <path
            d="M1013.84 324.055C1012.08 324.055 1010.65 325.481 1010.65 327.25C1010.65 329.02 1012.08 330.446 1013.84 330.446C1015.6 330.446 1017.03 329.011 1017.03 327.25C1017.03 325.489 1015.61 324.055 1013.84 324.055Z"
            fill="white"
          />
          <path
            d="M999.547 332.252C997.82 332.252 996.415 333.657 996.415 335.397C996.415 337.137 997.82 338.528 999.547 338.528C1001.27 338.528 1002.68 337.124 1002.68 335.397C1002.68 333.669 1001.28 332.252 999.547 332.252Z"
            fill="white"
          />
          <path
            d="M985.373 342.963C983.667 342.963 982.292 344.338 982.292 346.044C982.292 347.75 983.667 349.112 985.373 349.112C987.079 349.112 988.441 347.737 988.441 346.044C988.441 344.351 987.066 342.963 985.373 342.963Z"
            fill="white"
          />
          <path
            d="M971.653 356.678C969.977 356.678 968.614 358.031 968.614 359.708C968.614 361.384 969.977 362.746 971.653 362.746C973.329 362.746 974.683 361.384 974.683 359.708C974.683 358.031 973.329 356.678 971.653 356.678Z"
            fill="white"
          />
          <path
            d="M959.308 374.176C957.687 374.176 956.363 375.5 956.363 377.121C956.363 378.742 957.687 380.066 959.308 380.066C960.93 380.066 962.254 378.746 962.254 377.121C962.254 375.496 960.93 374.176 959.308 374.176Z"
            fill="white"
          />
          <path
            d="M948.893 395.326C947.302 395.326 946.012 396.629 946.012 398.22C946.012 399.812 947.302 401.102 948.893 401.102C950.485 401.102 951.775 399.812 951.775 398.22C951.775 396.629 950.485 395.326 948.893 395.326Z"
            fill="white"
          />
          <path
            d="M941.816 420.678C940.255 420.678 938.994 421.938 938.994 423.5C938.994 425.062 940.255 426.33 941.816 426.33C943.378 426.33 944.647 425.07 944.647 423.5C944.647 421.93 943.378 420.678 941.816 420.678Z"
            fill="white"
          />
          <path
            d="M939.711 450.205C938.179 450.205 936.944 451.453 936.944 452.972C936.944 454.491 938.184 455.739 939.711 455.739C941.239 455.739 942.478 454.5 942.478 452.972C942.478 451.444 941.239 450.205 939.711 450.205Z"
            fill="white"
          />
          <path
            d="M943.436 483.291C941.959 483.291 940.763 484.488 940.763 485.977C940.763 487.467 941.959 488.651 943.436 488.651C944.913 488.651 946.123 487.454 946.123 485.977C946.123 484.501 944.917 483.291 943.436 483.291Z"
            fill="white"
          />
          <path
            d="M952.472 519.086C951.025 519.086 949.85 520.261 949.85 521.709C949.85 523.156 951.025 524.331 952.472 524.331C953.919 524.331 955.095 523.156 955.095 521.709C955.095 520.261 953.928 519.086 952.472 519.086Z"
            fill="white"
          />
          <path
            d="M964.795 557.271C963.378 557.271 962.224 558.417 962.224 559.83C962.224 561.244 963.378 562.389 964.795 562.389C966.213 562.389 967.354 561.244 967.354 559.83C967.354 558.417 966.209 557.271 964.795 557.271Z"
            fill="white"
          />
          <path
            d="M977.608 597.943C976.224 597.943 975.1 599.055 975.1 600.443C975.1 601.831 976.224 602.951 977.608 602.951C978.991 602.951 980.116 601.826 980.116 600.443C980.116 599.059 978.991 597.943 977.608 597.943Z"
            fill="white"
          />
          <path
            d="M988.836 641.65C987.495 641.65 986.413 642.733 986.413 644.074C986.413 645.415 987.495 646.488 988.836 646.488C990.177 646.488 991.251 645.406 991.251 644.074C991.251 642.741 990.169 641.65 988.836 641.65Z"
            fill="white"
          />
          <path
            d="M278.415 677.277C277.469 677.277 276.696 678.045 276.696 679.005C276.696 679.964 277.464 680.723 278.415 680.723C279.366 680.723 280.134 679.955 280.134 679.005C280.134 678.054 279.374 677.277 278.415 677.277Z"
            fill="white"
          />
          <path
            d="M257.163 666C256.217 666 255.444 666.772 255.444 667.727C255.444 668.682 256.212 669.446 257.163 669.446C258.114 669.446 258.89 668.678 258.89 667.727C258.89 666.777 258.109 666 257.163 666Z"
            fill="white"
          />
          <path
            d="M235.129 653.732C234.183 653.732 233.41 654.501 233.41 655.451C233.41 656.402 234.183 657.17 235.129 657.17C236.075 657.17 236.848 656.402 236.848 655.451C236.848 654.501 236.075 653.732 235.129 653.732Z"
            fill="white"
          />
          <path
            d="M212.136 641.006C211.177 641.006 210.4 641.774 210.4 642.733C210.4 643.692 211.181 644.46 212.136 644.46C213.091 644.46 213.863 643.688 213.863 642.733C213.863 641.778 213.082 641.006 212.136 641.006Z"
            fill="white"
          />
          <path
            d="M187.773 627.908C186.814 627.908 186.046 628.676 186.046 629.635C186.046 630.595 186.814 631.354 187.773 631.354C188.732 631.354 189.492 630.582 189.492 629.635C189.492 628.689 188.724 627.908 187.773 627.908Z"
            fill="white"
          />
          <path
            d="M161.564 615.127C160.605 615.127 159.824 615.899 159.824 616.854C159.824 617.809 160.605 618.581 161.564 618.581C162.523 618.581 163.291 617.813 163.291 616.854C163.291 615.895 162.511 615.127 161.564 615.127Z"
            fill="white"
          />
          <path
            d="M132.902 602.285C131.943 602.285 131.175 603.053 131.175 604.012C131.175 604.971 131.943 605.752 132.902 605.752C133.861 605.752 134.642 604.971 134.642 604.012C134.642 603.053 133.861 602.285 132.902 602.285Z"
            fill="white"
          />
          <path
            d="M101.294 587.725C100.335 587.725 99.5537 588.505 99.5537 589.473C99.5537 590.441 100.335 591.221 101.294 591.221C102.253 591.221 103.042 590.441 103.042 589.473C103.042 588.505 102.261 587.725 101.294 587.725Z"
            fill="white"
          />
          <path
            d="M80.9458 570.344C79.957 570.344 79.1465 571.154 79.1465 572.143C79.1465 573.132 79.957 573.955 80.9458 573.955C81.9346 573.955 82.7452 573.145 82.7452 572.143C82.7452 571.142 81.9431 570.344 80.9458 570.344Z"
            fill="white"
          />
          <path
            d="M62.3359 553.746C61.3174 553.746 60.4941 554.569 60.4941 555.588C60.4941 556.606 61.3174 557.442 62.3359 557.442C63.3544 557.442 64.1904 556.619 64.1904 555.588C64.1904 554.557 63.3672 553.746 62.3359 553.746Z"
            fill="white"
          />
          <path
            d="M47.3097 539.602C46.2573 539.602 45.417 540.446 45.417 541.494C45.417 542.542 46.2615 543.379 47.3097 543.379C48.3579 543.379 49.2024 542.534 49.2024 541.494C49.2024 540.455 48.3494 539.602 47.3097 539.602Z"
            fill="white"
          />
          <path
            d="M36.1315 528.318C35.0578 528.318 34.1836 529.193 34.1836 530.266C34.1836 531.34 35.0578 532.214 36.1315 532.214C37.2051 532.214 38.0878 531.34 38.0878 530.266C38.0878 529.193 37.2136 528.318 36.1315 528.318Z"
            fill="white"
          />
          <path
            d="M28.3781 519.553C27.2535 519.553 26.3496 520.457 26.3496 521.573C26.3496 522.689 27.2535 523.601 28.3781 523.601C29.5027 523.601 30.3981 522.697 30.3981 521.573C30.3981 520.448 29.4942 519.553 28.3781 519.553Z"
            fill="white"
          />
          <path
            d="M23.4724 512.891C22.3181 512.891 21.3887 513.816 21.3887 514.97C21.3887 516.124 22.3138 517.05 23.4724 517.05C24.6309 517.05 25.5518 516.112 25.5518 514.97C25.5518 513.829 24.6139 512.891 23.4724 512.891Z"
            fill="white"
          />
          <path
            d="M20.6626 507.738C19.4871 507.738 18.5195 508.697 18.5195 509.881C18.5195 511.065 19.4871 512.025 20.6626 512.025C21.8381 512.025 22.8057 511.057 22.8057 509.881C22.8057 508.706 21.8466 507.738 20.6626 507.738Z"
            fill="white"
          />
          <path
            d="M19.2712 503.611C18.0532 503.611 17.0771 504.6 17.0771 505.805C17.0771 507.011 18.0575 508.012 19.2712 508.012C20.4849 508.012 21.4779 507.023 21.4779 505.805C21.4779 504.587 20.4891 503.611 19.2712 503.611Z"
            fill="white"
          />
          <path
            d="M18.8636 500.154C17.5947 500.154 16.5635 501.186 16.5635 502.454C16.5635 503.723 17.5947 504.763 18.8636 504.763C20.1325 504.763 21.1637 503.732 21.1637 502.454C21.1637 501.177 20.1325 500.154 18.8636 500.154Z"
            fill="white"
          />
          <path
            d="M19.144 497.248C17.8412 497.248 16.7803 498.309 16.7803 499.62C16.7803 500.932 17.8412 501.984 19.144 501.984C20.4469 501.984 21.5163 500.923 21.5163 499.62C21.5163 498.318 20.4554 497.248 19.144 497.248Z"
            fill="white"
          />
          <path
            d="M19.8519 494.689C18.5109 494.689 17.4287 495.784 17.4287 497.113C17.4287 498.441 18.5109 499.549 19.8519 499.549C21.1929 499.549 22.2751 498.454 22.2751 497.113C22.2751 495.772 21.1929 494.689 19.8519 494.689Z"
            fill="white"
          />
          <path
            d="M20.7984 492.359C19.4234 492.359 18.3115 493.471 18.3115 494.846C18.3115 496.221 19.4234 497.333 20.7984 497.333C22.1733 497.333 23.2852 496.221 23.2852 494.846C23.2852 493.471 22.1733 492.359 20.7984 492.359Z"
            fill="white"
          />
          <path
            d="M21.881 490.152C20.4551 490.152 19.3008 491.307 19.3008 492.724C19.3008 494.141 20.4551 495.304 21.881 495.304C23.3069 495.304 24.4612 494.15 24.4612 492.724C24.4612 491.298 23.3069 490.152 21.881 490.152Z"
            fill="white"
          />
          <path
            d="M22.9759 488.061C21.5203 488.061 20.332 489.249 20.332 490.704C20.332 492.16 21.5203 493.357 22.9759 493.357C24.4315 493.357 25.6282 492.169 25.6282 490.704C25.6282 489.24 24.44 488.061 22.9759 488.061Z"
            fill="white"
          />
          <path
            d="M23.9849 486.02C22.4953 486.02 21.2773 487.229 21.2773 488.727C21.2773 490.225 22.4953 491.435 23.9849 491.435C25.4744 491.435 26.7009 490.225 26.7009 488.727C26.7009 487.229 25.4829 486.02 23.9849 486.02Z"
            fill="white"
          />
          <path
            d="M24.847 483.979C23.315 483.979 22.0801 485.218 22.0801 486.745C22.0801 488.273 23.3193 489.512 24.847 489.512C26.3748 489.512 27.6139 488.273 27.6139 486.745C27.6139 485.218 26.3748 483.979 24.847 483.979Z"
            fill="white"
          />
          <path
            d="M25.4836 481.9C23.9134 481.9 22.6318 483.182 22.6318 484.761C22.6318 486.339 23.9134 487.612 25.4836 487.612C27.0538 487.612 28.3439 486.331 28.3439 484.761C28.3439 483.19 27.0623 481.9 25.4836 481.9Z"
            fill="white"
          />
          <path
            d="M25.878 479.809C24.2654 479.809 22.9541 481.111 22.9541 482.724C22.9541 484.337 24.2654 485.648 25.878 485.648C27.4907 485.648 28.7935 484.337 28.7935 482.724C28.7935 481.111 27.4822 479.809 25.878 479.809Z"
            fill="white"
          />
          <path
            d="M26.0149 483.635C27.6579 483.635 28.9898 482.303 28.9898 480.66C28.9898 479.017 27.6579 477.686 26.0149 477.686C24.3719 477.686 23.04 479.017 23.04 480.66C23.04 482.303 24.3719 483.635 26.0149 483.635Z"
            fill="white"
          />
          <path
            d="M25.8787 475.516C24.2024 475.516 22.8486 476.878 22.8486 478.554C22.8486 480.23 24.2024 481.593 25.8787 481.593C27.555 481.593 28.9172 480.23 28.9172 478.554C28.9172 476.878 27.555 475.516 25.8787 475.516Z"
            fill="white"
          />
          <path
            d="M25.4625 473.312C23.7438 473.312 22.3604 474.709 22.3604 476.423C22.3604 478.138 23.7438 479.525 25.4625 479.525C27.1813 479.525 28.5732 478.142 28.5732 476.423C28.5732 474.704 27.177 473.312 25.4625 473.312Z"
            fill="white"
          />
          <path
            d="M24.7622 471.072C23.0138 471.072 21.5879 472.49 21.5879 474.238C21.5879 475.987 23.0138 477.412 24.7622 477.412C26.5106 477.412 27.9281 475.995 27.9281 474.238C27.9281 472.481 26.5106 471.072 24.7622 471.072Z"
            fill="white"
          />
          <path
            d="M23.7949 468.822C22.0252 468.822 20.5781 470.269 20.5781 472.039C20.5781 473.809 22.0252 475.264 23.7949 475.264C25.5645 475.264 27.0201 473.817 27.0201 472.039C27.0201 470.261 25.573 468.822 23.7949 468.822Z"
            fill="white"
          />
          <path
            d="M22.547 466.545C20.7349 466.545 19.2793 468.013 19.2793 469.813C19.2793 471.612 20.7349 473.08 22.547 473.08C24.3591 473.08 25.8062 471.612 25.8062 469.813C25.8062 468.013 24.3506 466.545 22.547 466.545Z"
            fill="white"
          />
          <path
            d="M20.9433 464.193C19.1016 464.193 17.6035 465.691 17.6035 467.533C17.6035 469.375 19.1016 470.873 20.9433 470.873C22.7851 470.873 24.2832 469.375 24.2832 467.533C24.2832 465.691 22.7851 464.193 20.9433 464.193Z"
            fill="white"
          />
          <path
            d="M18.9777 461.779C17.0935 461.779 15.5742 463.299 15.5742 465.183C15.5742 467.067 17.0935 468.574 18.9777 468.574C20.8619 468.574 22.3685 467.054 22.3685 465.183C22.3685 463.311 20.8492 461.779 18.9777 461.779Z"
            fill="white"
          />
          <path
            d="M16.5924 459.301C14.687 459.301 13.1465 460.841 13.1465 462.747C13.1465 464.652 14.687 466.193 16.5924 466.193C18.4979 466.193 20.0256 464.644 20.0256 462.747C20.0256 460.85 18.4851 459.301 16.5924 459.301Z"
            fill="white"
          />
          <path
            d="M13.7755 456.721C11.8488 456.721 10.2871 458.291 10.2871 460.218C10.2871 462.144 11.8488 463.706 13.7755 463.706C15.7021 463.706 17.2638 462.144 17.2638 460.218C17.2638 458.291 15.7021 456.721 13.7755 456.721Z"
            fill="white"
          />
          <path
            d="M10.4944 454.033C8.538 454.033 6.95508 455.616 6.95508 457.572C6.95508 459.529 8.538 461.12 10.4944 461.12C12.4507 461.12 14.0421 459.537 14.0421 457.572C14.0421 455.608 12.4592 454.033 10.4944 454.033Z"
            fill="white"
          />
          <path
            d="M6.76013 451.246C4.78255 451.246 3.16992 452.859 3.16992 454.836C3.16992 456.814 4.78255 458.435 6.76013 458.435C8.73772 458.435 10.3631 456.822 10.3631 454.836C10.3631 452.85 8.75045 451.246 6.76013 451.246Z"
            fill="white"
          />
          <path
            d="M2.56328 448.373C0.564472 448.373 -1.05664 449.998 -1.05664 451.997C-1.05664 453.996 0.568715 455.63 2.56328 455.63C4.55784 455.63 6.1832 454.004 6.1832 451.997C6.1832 449.99 4.55784 448.373 2.56328 448.373Z"
            fill="white"
          />
          <path
            d="M-2.08761 445.387C-4.11612 445.387 -5.7627 447.033 -5.7627 449.049C-5.7627 451.065 -4.11612 452.724 -2.08761 452.724C-0.0590957 452.724 1.57475 451.078 1.57475 449.049C1.57475 447.021 -0.0718271 445.387 -2.08761 445.387Z"
            fill="white"
          />
          <path
            d="M3.95031 45.9258C2.33769 45.9258 1.02637 47.2329 1.02637 48.8497C1.02637 50.4666 2.33769 51.7737 3.95031 51.7737C5.56294 51.7737 6.87425 50.4666 6.87425 48.8497C6.87425 47.2329 5.56294 45.9258 3.95031 45.9258Z"
            fill="white"
          />
          <path
            d="M12.1069 33.7246C10.5368 33.7246 9.27637 34.9935 9.27637 36.5552C9.27637 38.1169 10.5368 39.3858 12.1069 39.3858C13.6771 39.3858 14.9375 38.1169 14.9375 36.5552C14.9375 34.9935 13.6686 33.7246 12.1069 33.7246Z"
            fill="white"
          />
          <path
            d="M19.0075 23.0762C17.4882 23.0762 16.249 24.3153 16.249 25.8431C16.249 27.3708 17.4882 28.6058 19.0075 28.6058C20.5267 28.6058 21.7744 27.3666 21.7744 25.8431C21.7744 24.3196 20.5352 23.0762 19.0075 23.0762Z"
            fill="white"
          />
          <path
            d="M24.8039 13.877C23.3058 13.877 22.0879 15.0822 22.0879 16.5845C22.0879 18.0868 23.3058 19.292 24.8039 19.292C26.3019 19.292 27.5114 18.074 27.5114 16.5845C27.5114 15.0949 26.2934 13.877 24.8039 13.877Z"
            fill="white"
          />
          <path
            d="M29.804 5.67383C28.3357 5.67383 27.1602 6.86208 27.1602 8.31768C27.1602 9.77329 28.3357 10.9615 29.804 10.9615C31.2724 10.9615 32.4479 9.78178 32.4479 8.31768C32.4479 6.85359 31.2596 5.67383 29.804 5.67383Z"
            fill="white"
          />
          <path
            d="M34.2683 -1.85938C32.8636 -1.85938 31.7178 -0.713563 31.7178 0.691118C31.7178 2.0958 32.8636 3.24161 34.2683 3.24161C35.6729 3.24161 36.8188 2.0958 36.8188 0.691118C36.8188 -0.713563 35.6729 -1.85938 34.2683 -1.85938Z"
            fill="white"
          />
          <path
            d="M1045.86 -0.882812C1044.39 -0.882812 1043.19 0.313925 1043.19 1.79075C1043.19 3.26757 1044.39 4.46431 1045.86 4.46431C1047.34 4.46431 1048.54 3.26757 1048.54 1.79075C1048.54 0.313925 1047.34 -0.882812 1045.86 -0.882812Z"
            fill="white"
          />
          <path
            d="M1052.68 11.2891C1051.17 11.2891 1049.94 12.5113 1049.94 14.022C1049.94 15.5328 1051.17 16.7593 1052.68 16.7593C1054.19 16.7593 1055.42 15.5328 1055.42 14.022C1055.42 12.5113 1054.19 11.2891 1052.68 11.2891Z"
            fill="white"
          />
          <path
            d="M1059.67 23.1914C1058.13 23.1914 1056.87 24.4391 1056.87 25.9838C1056.87 27.5285 1058.13 28.7762 1059.67 28.7762C1061.21 28.7762 1062.46 27.5285 1062.46 25.9838C1062.46 24.4391 1061.21 23.1914 1059.67 23.1914Z"
            fill="white"
          />
          <path
            d="M1066.93 34.6504C1065.34 34.6504 1064.04 35.9405 1064.04 37.5319C1064.04 39.1233 1065.34 40.4134 1066.93 40.4134C1068.52 40.4134 1069.81 39.1233 1069.81 37.5319C1069.81 35.9405 1068.52 34.6504 1066.93 34.6504Z"
            fill="white"
          />
          <path
            d="M1074.41 45.7637C1072.79 45.7637 1071.47 47.075 1071.47 48.7003C1071.47 50.3257 1072.79 51.6285 1074.41 51.6285C1076.04 51.6285 1077.35 50.313 1077.35 48.7003C1077.35 47.0877 1076.04 45.7637 1074.41 45.7637Z"
            fill="white"
          />
          <path
            d="M1082.12 56.5039C1080.47 56.5039 1079.13 57.8364 1079.13 59.4915C1079.13 61.1466 1080.47 62.4876 1082.12 62.4876C1083.78 62.4876 1085.11 61.1466 1085.11 59.4915C1085.11 57.8364 1083.78 56.5039 1082.12 56.5039Z"
            fill="white"
          />
          <path
            d="M1089.95 67.041C1088.27 67.041 1086.9 68.4075 1086.9 70.0838C1086.9 71.7601 1088.26 73.135 1089.95 73.135C1091.64 73.135 1093 71.7728 1093 70.0838C1093 68.3948 1091.63 67.041 1089.95 67.041Z"
            fill="white"
          />
          <path
            d="M1097.83 77.4473C1096.09 77.4473 1094.68 78.8519 1094.68 80.5792C1094.68 82.3064 1096.09 83.7238 1097.83 83.7238C1099.57 83.7238 1100.96 82.3191 1100.96 80.5792C1100.96 78.8392 1099.55 77.4473 1097.83 77.4473Z"
            fill="white"
          />
          <path
            d="M1105.74 87.8242C1103.98 87.8242 1102.55 89.2501 1102.55 91.0113C1102.55 92.7724 1103.98 94.1941 1105.74 94.1941C1107.5 94.1941 1108.92 92.7682 1108.92 91.0113C1108.92 89.2544 1107.49 87.8242 1105.74 87.8242Z"
            fill="white"
          />
          <path
            d="M1113.67 98.1562C1111.88 98.1562 1110.43 99.6034 1110.43 101.394C1110.43 103.185 1111.88 104.641 1113.67 104.641C1115.46 104.641 1116.91 103.185 1116.91 101.394C1116.91 99.6034 1115.46 98.1562 1113.67 98.1562Z"
            fill="white"
          />
          <path
            d="M1121.57 108.547C1119.75 108.547 1118.28 110.019 1118.28 111.836C1118.28 113.652 1119.75 115.125 1121.57 115.125C1123.39 115.125 1124.86 113.656 1124.86 111.836C1124.86 110.015 1123.38 108.547 1121.57 108.547Z"
            fill="white"
          />
          <path
            d="M1129.38 119.027C1127.53 119.027 1126.02 120.538 1126.02 122.388C1126.02 124.239 1127.53 125.749 1129.38 125.749C1131.23 125.749 1132.75 124.251 1132.75 122.388C1132.75 120.525 1131.25 119.027 1129.38 119.027Z"
            fill="white"
          />
          <path
            d="M1137.1 129.715C1135.2 129.715 1133.67 131.247 1133.67 133.131C1133.67 135.015 1135.2 136.552 1137.1 136.552C1138.99 136.552 1140.51 135.028 1140.51 133.131C1140.51 131.234 1138.98 129.715 1137.1 129.715Z"
            fill="white"
          />
          <path
            d="M1144.63 140.672C1142.73 140.672 1141.18 142.221 1141.18 144.131C1141.18 146.04 1142.73 147.598 1144.63 147.598C1146.53 147.598 1148.1 146.049 1148.1 144.131C1148.1 142.212 1146.55 140.672 1144.63 140.672Z"
            fill="white"
          />
          <path
            d="M1152.05 151.832C1150.12 151.832 1148.55 153.402 1148.55 155.346C1148.55 157.289 1150.12 158.855 1152.05 158.855C1153.99 158.855 1155.56 157.289 1155.56 155.346C1155.56 153.402 1154 151.832 1152.05 151.832Z"
            fill="white"
          />
          <path
            d="M1159.35 170.341C1161.33 170.341 1162.93 168.738 1162.93 166.759C1162.93 164.781 1161.33 163.178 1159.35 163.178C1157.37 163.178 1155.77 164.781 1155.77 166.759C1155.77 168.738 1157.37 170.341 1159.35 170.341Z"
            fill="white"
          />
          <path
            d="M1166.54 174.715C1164.54 174.715 1162.91 176.344 1162.91 178.343C1162.91 180.342 1164.54 181.976 1166.54 181.976C1168.55 181.976 1170.16 180.346 1170.16 178.343C1170.16 176.34 1168.54 174.715 1166.54 174.715Z"
            fill="white"
          />
          <path
            d="M1173.69 186.314C1171.67 186.314 1170.03 187.961 1170.03 189.977C1170.03 191.993 1171.67 193.639 1173.69 193.639C1175.71 193.639 1177.34 191.993 1177.34 189.977C1177.34 187.961 1175.71 186.314 1173.69 186.314Z"
            fill="white"
          />
          <path
            d="M1180.87 197.852C1178.83 197.852 1177.17 199.511 1177.17 201.552C1177.17 203.593 1178.83 205.257 1180.87 205.257C1182.92 205.257 1184.57 203.602 1184.57 201.552C1184.57 199.502 1182.92 197.852 1180.87 197.852Z"
            fill="white"
          />
          <path
            d="M1188.21 209.086C1186.13 209.086 1184.46 210.771 1184.46 212.854C1184.46 214.938 1186.13 216.623 1188.21 216.623C1190.29 216.623 1191.98 214.938 1191.98 212.854C1191.98 210.771 1190.3 209.086 1188.21 209.086Z"
            fill="white"
          />
          <path
            d="M1195.85 219.816C1193.76 219.816 1192.05 221.514 1192.05 223.615C1192.05 225.715 1193.76 227.425 1195.85 227.425C1197.94 227.425 1199.66 225.719 1199.66 223.615C1199.66 221.51 1197.95 219.816 1195.85 219.816Z"
            fill="white"
          />
          <path
            d="M1203.73 230.078C1201.61 230.078 1199.89 231.805 1199.89 233.919C1199.89 236.032 1201.61 237.759 1203.73 237.759C1205.85 237.759 1207.57 236.041 1207.57 233.919C1207.57 231.797 1205.85 230.078 1203.73 230.078Z"
            fill="white"
          />
          <path
            d="M1211.92 239.729C1209.79 239.729 1208.05 241.456 1208.05 243.599C1208.05 245.742 1209.79 247.469 1211.92 247.469C1214.06 247.469 1215.79 245.729 1215.79 243.599C1215.79 241.468 1214.07 239.729 1211.92 239.729Z"
            fill="white"
          />
          <path
            d="M1220.41 248.68C1218.25 248.68 1216.49 250.437 1216.49 252.605C1216.49 254.774 1218.24 256.531 1220.41 256.531C1222.58 256.531 1224.34 254.782 1224.34 252.605C1224.34 250.428 1222.58 248.68 1220.41 248.68Z"
            fill="white"
          />
          <path
            d="M1229.26 256.836C1227.07 256.836 1225.3 258.606 1225.3 260.791C1225.3 262.977 1227.07 264.755 1229.26 264.755C1231.44 264.755 1233.22 262.985 1233.22 260.791C1233.22 258.597 1231.44 256.836 1229.26 256.836Z"
            fill="white"
          />
          <path
            d="M1238.45 264.154C1236.24 264.154 1234.45 265.945 1234.45 268.139C1234.45 270.333 1236.24 272.137 1238.45 272.137C1240.66 272.137 1242.45 270.346 1242.45 268.139C1242.45 265.932 1240.66 264.154 1238.45 264.154Z"
            fill="white"
          />
          <path
            d="M1247.98 270.543C1245.77 270.543 1243.96 272.342 1243.96 274.57C1243.96 276.798 1245.76 278.598 1247.98 278.598C1250.2 278.598 1252.01 276.786 1252.01 274.57C1252.01 272.355 1250.21 270.543 1247.98 270.543Z"
            fill="white"
          />
          <path
            d="M1257.84 275.988C1255.6 275.988 1253.79 277.8 1253.79 280.037C1253.79 282.273 1255.6 284.098 1257.84 284.098C1260.08 284.098 1261.9 282.286 1261.9 280.037C1261.9 277.788 1260.08 275.988 1257.84 275.988Z"
            fill="white"
          />
          <path
            d="M1267.97 280.465C1265.71 280.465 1263.87 282.298 1263.87 284.556C1263.87 286.813 1265.71 288.634 1267.97 288.634C1270.22 288.634 1272.04 286.813 1272.04 284.556C1272.04 282.298 1270.21 280.465 1267.97 280.465Z"
            fill="white"
          />
          <path
            d="M1278.29 283.992C1276.03 283.992 1274.19 285.834 1274.19 288.104C1274.19 290.375 1276.03 292.204 1278.29 292.204C1280.55 292.204 1282.4 290.362 1282.4 288.104C1282.4 285.847 1280.56 283.992 1278.29 283.992Z"
            fill="white"
          />
          <path
            d="M1288.77 286.572C1286.49 286.572 1284.64 288.427 1284.64 290.706C1284.64 292.985 1286.49 294.826 1288.77 294.826C1291.05 294.826 1292.89 292.985 1292.89 290.706C1292.89 288.427 1291.05 286.572 1288.77 286.572Z"
            fill="white"
          />
          <path
            d="M1299.31 288.227C1297.02 288.227 1295.16 290.09 1295.16 292.381C1295.16 294.673 1297.02 296.536 1299.31 296.536C1301.61 296.536 1303.47 294.686 1303.47 292.381C1303.47 290.077 1301.62 288.227 1299.31 288.227Z"
            fill="white"
          />
          <path
            d="M1309.87 289.059C1307.57 289.059 1305.71 290.922 1305.71 293.213C1305.71 295.505 1307.57 297.368 1309.87 297.368C1312.16 297.368 1314.02 295.513 1314.02 293.213C1314.02 290.913 1312.16 289.059 1309.87 289.059Z"
            fill="white"
          />
          <path
            d="M1320.35 289.123C1318.05 289.123 1316.2 290.986 1316.2 293.278C1316.2 295.569 1318.05 297.432 1320.35 297.432C1322.65 297.432 1324.5 295.578 1324.5 293.278C1324.5 290.978 1322.64 289.123 1320.35 289.123Z"
            fill="white"
          />
          <path
            d="M1330.7 288.496C1328.41 288.496 1326.55 290.359 1326.55 292.651C1326.55 294.942 1328.41 296.805 1330.7 296.805C1333 296.805 1334.85 294.942 1334.85 292.651C1334.85 290.359 1333 288.496 1330.7 288.496Z"
            fill="white"
          />
          <path
            d="M1340.91 287.25C1338.62 287.25 1336.76 289.113 1336.76 291.405C1336.76 293.696 1338.62 295.559 1340.91 295.559C1343.21 295.559 1345.07 293.709 1345.07 291.405C1345.07 289.1 1343.21 287.25 1340.91 287.25Z"
            fill="white"
          />
          <path
            d="M1350.95 285.488C1348.65 285.488 1346.79 287.351 1346.79 289.643C1346.79 291.935 1348.64 293.798 1350.95 293.798C1353.25 293.798 1355.1 291.943 1355.1 289.643C1355.1 287.343 1353.24 285.488 1350.95 285.488Z"
            fill="white"
          />
          <path
            d="M1360.76 283.346C1358.47 283.346 1356.61 285.209 1356.61 287.5C1356.61 289.792 1358.47 291.655 1360.76 291.655C1363.05 291.655 1364.93 289.792 1364.93 287.5C1364.93 285.209 1363.06 283.346 1360.76 283.346Z"
            fill="white"
          />
          <path
            d="M1370.38 280.922C1368.08 280.922 1366.22 282.785 1366.22 285.077C1366.22 287.368 1368.07 289.24 1370.38 289.24C1372.68 289.24 1374.53 287.377 1374.53 285.077C1374.53 282.776 1372.67 280.922 1370.38 280.922Z"
            fill="white"
          />
          <path
            d="M1379.78 278.311C1377.49 278.311 1375.62 280.174 1375.62 282.465C1375.62 284.757 1377.49 286.628 1379.78 286.628C1382.07 286.628 1383.93 284.765 1383.93 282.465C1383.93 280.165 1382.08 278.311 1379.78 278.311Z"
            fill="white"
          />
          <path
            d="M1376.15 281.484C1373.85 281.484 1371.99 283.347 1371.99 285.639C1371.99 287.931 1373.85 289.794 1376.15 289.794C1378.45 289.794 1380.3 287.931 1380.3 285.639C1380.3 283.347 1378.44 281.484 1376.15 281.484Z"
            fill="white"
          />
          <path
            d="M1372.39 284.441C1370.1 284.441 1368.23 286.296 1368.23 288.596C1368.23 290.896 1370.1 292.751 1372.39 292.751C1374.68 292.751 1376.54 290.888 1376.54 288.596C1376.54 286.304 1374.69 284.441 1372.39 284.441Z"
            fill="white"
          />
          <path
            d="M1368.44 287.238C1366.15 287.238 1364.28 289.101 1364.28 291.393C1364.28 293.685 1366.15 295.548 1368.44 295.548C1370.73 295.548 1372.59 293.693 1372.59 291.393C1372.59 289.093 1370.74 287.238 1368.44 287.238Z"
            fill="white"
          />
          <path
            d="M1364.19 289.967C1361.89 289.967 1360.03 291.83 1360.03 294.121C1360.03 296.413 1361.88 298.276 1364.19 298.276C1366.49 298.276 1368.34 296.413 1368.34 294.121C1368.34 291.83 1366.48 289.967 1364.19 289.967Z"
            fill="white"
          />
          <path
            d="M1359.57 292.66C1357.27 292.66 1355.4 294.523 1355.4 296.815C1355.4 299.106 1357.27 300.969 1359.57 300.969C1361.87 300.969 1363.72 299.106 1363.72 296.815C1363.72 294.523 1361.86 292.66 1359.57 292.66Z"
            fill="white"
          />
          <path
            d="M1354.49 295.355C1352.2 295.355 1350.33 297.218 1350.33 299.51C1350.33 301.802 1352.2 303.665 1354.49 303.665C1356.78 303.665 1358.65 301.802 1358.65 299.51C1358.65 297.218 1356.79 295.355 1354.49 295.355Z"
            fill="white"
          />
          <path
            d="M1348.92 298.064C1346.62 298.064 1344.76 299.927 1344.76 302.219C1344.76 304.511 1346.62 306.374 1348.92 306.374C1351.22 306.374 1353.07 304.511 1353.07 302.219C1353.07 299.927 1351.21 298.064 1348.92 298.064Z"
            fill="white"
          />
          <path
            d="M1342.79 300.771C1340.5 300.771 1338.63 302.635 1338.63 304.926C1338.63 307.218 1340.5 309.081 1342.79 309.081C1345.08 309.081 1346.94 307.226 1346.94 304.926C1346.94 302.626 1345.09 300.771 1342.79 300.771Z"
            fill="white"
          />
          <path
            d="M1336.09 303.453C1333.79 303.453 1331.93 305.303 1331.93 307.608C1331.93 309.912 1333.79 311.762 1336.09 311.762C1338.38 311.762 1340.24 309.899 1340.24 307.608C1340.24 305.316 1338.38 303.453 1336.09 303.453Z"
            fill="white"
          />
          <path
            d="M1328.79 306.047C1326.5 306.047 1324.64 307.91 1324.64 310.202C1324.64 312.493 1326.5 314.356 1328.79 314.356C1331.08 314.356 1332.95 312.493 1332.95 310.202C1332.95 307.91 1331.08 306.047 1328.79 306.047Z"
            fill="white"
          />
          <path
            d="M1320.91 308.504C1318.61 308.504 1316.76 310.367 1316.76 312.659C1316.76 314.95 1318.61 316.813 1320.91 316.813C1323.21 316.813 1325.07 314.95 1325.07 312.659C1325.07 310.367 1323.2 308.504 1320.91 308.504Z"
            fill="white"
          />
          <path
            d="M1312.45 310.791C1310.16 310.791 1308.3 312.654 1308.3 314.946C1308.3 317.237 1310.16 319.109 1312.45 319.109C1314.74 319.109 1316.61 317.246 1316.61 314.946C1316.61 312.646 1314.75 310.791 1312.45 310.791Z"
            fill="white"
          />
          <path
            d="M1303.45 312.861C1301.16 312.861 1299.29 314.712 1299.29 317.016C1299.29 319.32 1301.16 321.171 1303.45 321.171C1305.74 321.171 1307.6 319.308 1307.6 317.016C1307.6 314.724 1305.74 312.861 1303.45 312.861Z"
            fill="white"
          />
          <path
            d="M1293.92 314.609C1291.64 314.609 1289.79 316.464 1289.79 318.751C1289.79 321.039 1291.64 322.893 1293.92 322.893C1296.2 322.893 1298.07 321.039 1298.07 318.751C1298.07 316.464 1296.21 314.609 1293.92 314.609Z"
            fill="white"
          />
          <path
            d="M1283.96 315.979C1281.68 315.979 1279.83 317.82 1279.83 320.099C1279.83 322.378 1281.68 324.211 1283.96 324.211C1286.23 324.211 1288.08 322.37 1288.08 320.099C1288.08 317.829 1286.22 315.979 1283.96 315.979Z"
            fill="white"
          />
          <path
            d="M1273.59 316.873C1271.34 316.873 1269.51 318.694 1269.51 320.951C1269.51 323.209 1271.34 325.03 1273.59 325.03C1275.83 325.03 1277.67 323.196 1277.67 320.951C1277.67 318.706 1275.84 316.873 1273.59 316.873Z"
            fill="white"
          />
          <path
            d="M1262.89 317.309C1260.64 317.309 1258.83 319.129 1258.83 321.366C1258.83 323.602 1260.64 325.423 1262.89 325.423C1265.13 325.423 1266.95 323.611 1266.95 321.366C1266.95 319.121 1265.13 317.309 1262.89 317.309Z"
            fill="white"
          />
          <path
            d="M1251.88 317.309C1249.65 317.309 1247.84 319.121 1247.84 321.336C1247.84 323.551 1249.65 325.376 1251.88 325.376C1254.1 325.376 1255.9 323.564 1255.9 321.336C1255.9 319.108 1254.09 317.309 1251.88 317.309Z"
            fill="white"
          />
          <path
            d="M1240.56 316.816C1238.36 316.816 1236.56 318.607 1236.56 320.814C1236.56 323.021 1238.36 324.82 1240.56 324.82C1242.77 324.82 1244.57 323.021 1244.57 320.814C1244.57 318.607 1242.78 316.816 1240.56 316.816Z"
            fill="white"
          />
          <path
            d="M1229.04 315.828C1226.86 315.828 1225.09 317.598 1225.09 319.783C1225.09 321.969 1226.86 323.738 1229.04 323.738C1231.23 323.738 1233.01 321.969 1233.01 319.783C1233.01 317.598 1231.23 315.828 1229.04 315.828Z"
            fill="white"
          />
          <path
            d="M1217.31 314.445C1215.13 314.445 1213.38 316.202 1213.38 318.371C1213.38 320.539 1215.14 322.296 1217.31 322.296C1219.48 322.296 1221.24 320.548 1221.24 318.371C1221.24 316.194 1219.48 314.445 1217.31 314.445Z"
            fill="white"
          />
          <path
            d="M1205.4 312.844C1203.25 312.844 1201.5 314.592 1201.5 316.748C1201.5 318.904 1203.25 320.64 1205.4 320.64C1207.56 320.64 1209.29 318.9 1209.29 316.748C1209.29 314.596 1207.56 312.844 1205.4 312.844Z"
            fill="white"
          />
          <path
            d="M1193.33 311.133C1191.19 311.133 1189.48 312.86 1189.48 314.982C1189.48 317.104 1191.2 318.844 1193.33 318.844C1195.46 318.844 1197.19 317.117 1197.19 314.982C1197.19 312.847 1195.46 311.133 1193.33 311.133Z"
            fill="white"
          />
          <path
            d="M1181.11 309.406C1179.01 309.406 1177.3 311.112 1177.3 313.217C1177.3 315.322 1179.01 317.028 1181.11 317.028C1183.22 317.028 1184.92 315.331 1184.92 313.217C1184.92 311.104 1183.22 309.406 1181.11 309.406Z"
            fill="white"
          />
          <path
            d="M1168.81 307.795C1166.73 307.795 1165.04 309.48 1165.04 311.563C1165.04 313.647 1166.73 315.332 1168.81 315.332C1170.89 315.332 1172.58 313.647 1172.58 311.563C1172.58 309.48 1170.89 307.795 1168.81 307.795Z"
            fill="white"
          />
          <path
            d="M1156.46 306.377C1154.39 306.377 1152.73 308.04 1152.73 310.103C1152.73 312.165 1154.39 313.829 1156.46 313.829C1158.52 313.829 1160.18 312.165 1160.18 310.103C1160.18 308.04 1158.51 306.377 1156.46 306.377Z"
            fill="white"
          />
          <path
            d="M1143.97 305.18C1141.92 305.18 1140.27 306.835 1140.27 308.876C1140.27 310.917 1141.92 312.56 1143.97 312.56C1146.01 312.56 1147.65 310.905 1147.65 308.876C1147.65 306.847 1145.99 305.18 1143.97 305.18Z"
            fill="white"
          />
          <path
            d="M1131.39 304.35C1129.38 304.35 1127.75 305.975 1127.75 307.982C1127.75 309.99 1129.38 311.615 1131.39 311.615C1133.4 311.615 1135.02 309.99 1135.02 307.982C1135.02 305.975 1133.39 304.35 1131.39 304.35Z"
            fill="white"
          />
          <path
            d="M1118.78 303.953C1116.79 303.953 1115.19 305.566 1115.19 307.543C1115.19 309.521 1116.79 311.134 1118.78 311.134C1120.77 311.134 1122.36 309.521 1122.36 307.543C1122.36 305.566 1120.76 303.953 1118.78 303.953Z"
            fill="white"
          />
          <path
            d="M1106.03 304.049C1104.07 304.049 1102.49 305.632 1102.49 307.575C1102.49 309.519 1104.07 311.115 1106.03 311.115C1107.99 311.115 1109.57 309.532 1109.57 307.575C1109.57 305.619 1107.99 304.049 1106.03 304.049Z"
            fill="white"
          />
          <path
            d="M1093.14 304.672C1091.21 304.672 1089.65 306.234 1089.65 308.148C1089.65 310.061 1091.21 311.636 1093.14 311.636C1095.06 311.636 1096.62 310.074 1096.62 308.148C1096.62 306.221 1095.06 304.672 1093.14 304.672Z"
            fill="white"
          />
          <path
            d="M1080.08 305.982C1078.2 305.982 1076.67 307.51 1076.67 309.394C1076.67 311.279 1078.2 312.819 1080.08 312.819C1081.96 312.819 1083.51 311.287 1083.51 309.394C1083.51 307.502 1081.98 305.982 1080.08 305.982Z"
            fill="white"
          />
          <path
            d="M1069.9 312.727C1070.61 311.006 1069.79 309.032 1068.07 308.319C1066.35 307.606 1064.38 308.423 1063.66 310.145C1062.95 311.866 1063.77 313.84 1065.49 314.553C1067.21 315.266 1069.18 314.448 1069.9 312.727Z"
            fill="white"
          />
          <path
            d="M1053.25 311.076C1051.41 311.076 1049.92 312.566 1049.92 314.408C1049.92 316.249 1051.41 317.726 1053.25 317.726C1055.09 317.726 1056.57 316.237 1056.57 314.408C1056.57 312.578 1055.08 311.076 1053.25 311.076Z"
            fill="white"
          />
          <path
            d="M1039.4 315.184C1037.6 315.184 1036.13 316.639 1036.13 318.451C1036.13 320.263 1037.6 321.719 1039.4 321.719C1041.2 321.719 1042.68 320.263 1042.68 318.451C1042.68 316.639 1041.21 315.184 1039.4 315.184Z"
            fill="white"
          />
          <path
            d="M1025.26 320.742C1023.51 320.742 1022.07 322.177 1022.07 323.938C1022.07 325.699 1023.5 327.133 1025.26 327.133C1027.03 327.133 1028.46 325.707 1028.46 323.938C1028.46 322.168 1027.03 320.742 1025.26 320.742Z"
            fill="white"
          />
          <path
            d="M1010.96 328.131C1009.24 328.131 1007.83 329.536 1007.83 331.263C1007.83 332.99 1009.24 334.395 1010.96 334.395C1012.69 334.395 1014.09 332.998 1014.09 331.263C1014.09 329.527 1012.7 328.131 1010.96 328.131Z"
            fill="white"
          />
          <path
            d="M997.215 343.8C998.876 343.408 999.904 341.744 999.512 340.084C999.12 338.423 997.457 337.394 995.796 337.786C994.135 338.178 993.107 339.842 993.499 341.503C993.891 343.164 995.555 344.192 997.215 343.8Z"
            fill="white"
          />
          <path
            d="M982.385 350.092C980.709 350.092 979.355 351.446 979.355 353.122C979.355 354.798 980.709 356.16 982.385 356.16C984.062 356.16 985.424 354.798 985.424 353.122C985.424 351.446 984.062 350.092 982.385 350.092Z"
            fill="white"
          />
          <path
            d="M969.175 371.937C970.801 371.937 972.12 370.619 972.12 368.992C972.12 367.365 970.801 366.047 969.175 366.047C967.548 366.047 966.229 367.365 966.229 368.992C966.229 370.619 967.548 371.937 969.175 371.937Z"
            fill="white"
          />
          <path
            d="M957.81 385.824C956.219 385.824 954.916 387.114 954.916 388.706C954.916 390.297 956.219 391.6 957.81 391.6C959.402 391.6 960.692 390.31 960.692 388.706C960.692 387.102 959.402 385.824 957.81 385.824Z"
            fill="white"
          />
          <path
            d="M949.182 409.5C947.621 409.5 946.36 410.76 946.36 412.322C946.36 413.884 947.621 415.153 949.182 415.153C950.744 415.153 952.013 413.884 952.013 412.322C952.013 410.76 950.744 409.5 949.182 409.5Z"
            fill="white"
          />
          <path
            d="M945.039 437.344C943.507 437.344 942.272 438.583 942.272 440.123C942.272 441.664 943.512 442.89 945.039 442.89C946.567 442.89 947.819 441.651 947.819 440.123C947.819 438.596 946.571 437.344 945.039 437.344Z"
            fill="white"
          />
          <path
            d="M946.781 469.064C945.291 469.064 944.095 470.261 944.095 471.751C944.095 473.24 945.291 474.437 946.781 474.437C948.271 474.437 949.455 473.228 949.455 471.751C949.455 470.274 948.258 469.064 946.781 469.064Z"
            fill="white"
          />
          <path
            d="M954.385 503.775C952.929 503.775 951.754 504.951 951.754 506.398C951.754 507.845 952.929 509.033 954.385 509.033C955.841 509.033 957.008 507.858 957.008 506.398C957.008 504.938 955.832 503.775 954.385 503.775Z"
            fill="white"
          />
          <path
            d="M966.25 540.992C964.833 540.992 963.679 542.138 963.679 543.551C963.679 544.964 964.833 546.123 966.25 546.123C967.668 546.123 968.822 544.977 968.822 543.551C968.822 542.125 967.668 540.992 966.25 540.992Z"
            fill="white"
          />
          <path
            d="M979.7 580.711C978.316 580.711 977.191 581.836 977.191 583.219C977.191 584.602 978.316 585.727 979.7 585.727C981.083 585.727 982.208 584.602 982.208 583.219C982.208 581.836 981.083 580.711 979.7 580.711Z"
            fill="white"
          />
          <path
            d="M992.167 623.322C990.834 623.322 989.752 624.404 989.752 625.737C989.752 627.069 990.834 628.16 992.167 628.16C993.499 628.16 994.581 627.065 994.581 625.737C994.581 624.409 993.499 623.322 992.167 623.322Z"
            fill="white"
          />
          <path
            d="M1001.91 669.74C1000.61 669.74 999.548 670.801 999.548 672.112C999.548 673.424 1000.61 674.476 1001.91 674.476C1003.21 674.476 1004.28 673.415 1004.28 672.112C1004.28 670.81 1003.22 669.74 1001.91 669.74Z"
            fill="white"
          />
          <path
            d="M246.795 669.354C245.87 669.354 245.11 670.113 245.11 671.038C245.11 671.963 245.87 672.736 246.795 672.736C247.72 672.736 248.48 671.976 248.48 671.038C248.48 670.1 247.729 669.354 246.795 669.354Z"
            fill="white"
          />
          <path
            d="M224.337 656.533C223.412 656.533 222.661 657.284 222.661 658.218C222.661 659.152 223.412 659.903 224.337 659.903C225.263 659.903 226.022 659.143 226.022 658.218C226.022 657.293 225.271 656.533 224.337 656.533Z"
            fill="white"
          />
          <path
            d="M200.98 643.531C200.042 643.531 199.282 644.291 199.282 645.229C199.282 646.167 200.042 646.914 200.98 646.914C201.918 646.914 202.677 646.154 202.677 645.229C202.677 644.304 201.918 643.531 200.98 643.531Z"
            fill="white"
          />
          <path
            d="M176.293 630.396C175.355 630.396 174.596 631.156 174.596 632.094C174.596 633.032 175.355 633.791 176.293 633.791C177.231 633.791 177.991 633.032 177.991 632.094C177.991 631.156 177.231 630.396 176.293 630.396Z"
            fill="white"
          />
          <path
            d="M149.818 617.711C148.88 617.711 148.12 618.471 148.12 619.417C148.12 620.363 148.88 621.114 149.818 621.114C150.755 621.114 151.524 620.355 151.524 619.417C151.524 618.479 150.764 617.711 149.818 617.711Z"
            fill="white"
          />
          <path
            d="M120.87 604.463C119.932 604.463 119.173 605.223 119.173 606.169C119.173 607.115 119.932 607.866 120.87 607.866C121.808 607.866 122.576 607.107 122.576 606.169C122.576 605.231 121.817 604.463 120.87 604.463Z"
            fill="white"
          />
          <path
            d="M88.9189 589.088C87.9725 589.088 87.2129 589.86 87.2129 590.794C87.2129 591.728 87.9725 592.513 88.9189 592.513C89.8652 592.513 90.6249 591.744 90.6249 590.794C90.6249 589.843 89.8652 589.088 88.9189 589.088Z"
            fill="white"
          />
          <path
            d="M67.5602 570.113C66.6012 570.113 65.8203 570.894 65.8203 571.853C65.8203 572.812 66.6012 573.602 67.5602 573.602C68.5193 573.602 69.3002 572.821 69.3002 571.853C69.3002 570.886 68.5193 570.113 67.5602 570.113Z"
            fill="white"
          />
          <path
            d="M47.984 552.141C46.9867 552.141 46.1719 552.951 46.1719 553.953C46.1719 554.954 46.9824 555.765 47.984 555.765C48.9855 555.765 49.8045 554.954 49.8045 553.953C49.8045 552.951 48.994 552.141 47.984 552.141Z"
            fill="white"
          />
          <path
            d="M32.2783 537.1C31.2471 537.1 30.4238 537.931 30.4238 538.95C30.4238 539.968 31.2471 540.804 32.2783 540.804C33.3096 540.804 34.1329 539.981 34.1329 538.95C34.1329 537.919 33.3011 537.1 32.2783 537.1Z"
            fill="white"
          />
          <path
            d="M20.799 525.342C19.7592 525.342 18.9062 526.195 18.9062 527.247C18.9062 528.3 19.7592 529.14 20.799 529.14C21.8387 529.14 22.7044 528.295 22.7044 527.247C22.7044 526.199 21.8514 525.342 20.799 525.342Z"
            fill="white"
          />
          <path
            d="M12.8668 516.328C11.7847 516.328 10.9189 517.202 10.9189 518.276C10.9189 519.35 11.7847 520.224 12.8668 520.224C13.949 520.224 14.8147 519.358 14.8147 518.276C14.8147 517.194 13.9405 516.328 12.8668 516.328Z"
            fill="white"
          />
          <path
            d="M7.70628 509.373C6.58169 509.373 5.66504 510.277 5.66504 511.402C5.66504 512.526 6.58169 513.443 7.70628 513.443C8.83088 513.443 9.7348 512.526 9.7348 511.402C9.7348 510.277 8.83088 509.373 7.70628 509.373Z"
            fill="white"
          />
          <path
            d="M4.71131 504.033C3.55701 504.033 2.61914 504.971 2.61914 506.125C2.61914 507.28 3.55701 508.218 4.71131 508.218C5.86561 508.218 6.80348 507.28 6.80348 506.125C6.80348 504.971 5.86561 504.033 4.71131 504.033Z"
            fill="white"
          />
          <path
            d="M3.1861 499.777C1.99785 499.777 1.03027 500.745 1.03027 501.933C1.03027 503.121 1.99785 504.089 3.1861 504.089C4.37435 504.089 5.34192 503.121 5.34192 501.933C5.34192 500.745 4.37435 499.777 3.1861 499.777Z"
            fill="white"
          />
          <path
            d="M2.62637 496.23C1.39993 496.23 0.411133 497.219 0.411133 498.45C0.411133 499.681 1.39993 500.665 2.62637 500.665C3.85281 500.665 4.84161 499.668 4.84161 498.45C4.84161 497.232 3.84433 496.23 2.62637 496.23Z"
            fill="white"
          />
          <path
            d="M2.75001 493.17C1.48113 493.17 0.441406 494.201 0.441406 495.47C0.441406 496.739 1.48113 497.779 2.75001 497.779C4.01889 497.779 5.05012 496.747 5.05012 495.47C5.05012 494.193 4.01889 493.17 2.75001 493.17Z"
            fill="white"
          />
          <path
            d="M3.35596 490.518C2.05312 490.518 0.992188 491.579 0.992188 492.881C0.992188 494.184 2.05312 495.245 3.35596 495.245C4.65879 495.245 5.72821 494.193 5.72821 492.881C5.72821 491.57 4.66727 490.518 3.35596 490.518Z"
            fill="white"
          />
          <path
            d="M4.25228 488.111C2.91126 488.111 1.8291 489.206 1.8291 490.547C1.8291 491.888 2.91126 492.97 4.25228 492.97C5.59331 492.97 6.6882 491.888 6.6882 490.547C6.6882 489.206 5.60604 488.111 4.25228 488.111Z"
            fill="white"
          />
          <path
            d="M5.30035 485.875C3.91689 485.875 2.80078 487 2.80078 488.375C2.80078 489.75 3.91264 490.874 5.30035 490.874C6.68806 490.874 7.78719 489.762 7.78719 488.375C7.78719 486.987 6.67532 485.875 5.30035 485.875Z"
            fill="white"
          />
          <path
            d="M6.38293 483.727C4.95703 483.727 3.80273 484.894 3.80273 486.319C3.80273 487.745 4.95703 488.912 6.38293 488.912C7.80883 488.912 8.97587 487.745 8.97587 486.319C8.97587 484.894 7.82157 483.727 6.38293 483.727Z"
            fill="white"
          />
          <path
            d="M7.43487 481.678C5.97927 481.678 4.79102 482.866 4.79102 484.33C4.79102 485.794 5.97927 486.974 7.43487 486.974C8.89048 486.974 10.0787 485.786 10.0787 484.33C10.0787 482.874 8.90321 481.678 7.43487 481.678Z"
            fill="white"
          />
          <path
            d="M8.37255 479.662C6.87451 479.662 5.66504 480.88 5.66504 482.378C5.66504 483.876 6.87026 485.086 8.37255 485.086C9.87484 485.086 11.0801 483.868 11.0801 482.378C11.0801 480.889 9.86211 479.662 8.37255 479.662Z"
            fill="white"
          />
          <path
            d="M9.13216 477.643C7.60017 477.643 6.36523 478.882 6.36523 480.422C6.36523 481.963 7.60441 483.202 9.13216 483.202C10.6599 483.202 11.9118 481.954 11.9118 480.422C11.9118 478.89 10.6726 477.643 9.13216 477.643Z"
            fill="white"
          />
          <path
            d="M9.69329 475.592C8.11038 475.592 6.83301 476.873 6.83301 478.452C6.83301 480.031 8.11462 481.304 9.69329 481.304C11.272 481.304 12.5451 480.022 12.5451 478.452C12.5451 476.882 11.2635 475.592 9.69329 475.592Z"
            fill="white"
          />
          <path
            d="M10.007 473.529C8.39433 473.529 7.08301 474.841 7.08301 476.453C7.08301 478.066 8.39433 479.377 10.007 479.377C11.6196 479.377 12.9309 478.066 12.9309 476.453C12.9309 474.841 11.6196 473.529 10.007 473.529Z"
            fill="white"
          />
          <path
            d="M10.0999 471.469C8.45329 471.469 7.125 472.801 7.125 474.444C7.125 476.086 8.45754 477.418 10.0999 477.418C11.7422 477.418 13.0747 476.086 13.0747 474.444C13.0747 472.801 11.7422 471.469 10.0999 471.469Z"
            fill="white"
          />
          <path
            d="M9.96333 469.389C8.28705 469.389 6.9248 470.742 6.9248 472.419C6.9248 474.095 8.28705 475.457 9.96333 475.457C11.6396 475.457 13.0019 474.103 13.0019 472.419C13.0019 470.734 11.6396 469.389 9.96333 469.389Z"
            fill="white"
          />
          <path
            d="M11.7696 472.577C12.9844 471.362 12.9844 469.392 11.7696 468.177C10.5549 466.963 8.58526 466.963 7.37047 468.177C6.15568 469.392 6.15571 471.362 7.3705 472.577C8.58529 473.791 10.5548 473.791 11.7696 472.577Z"
            fill="white"
          />
          <path
            d="M8.91163 465.133C7.1632 465.133 5.7373 466.55 5.7373 468.307C5.7373 470.064 7.1632 471.473 8.91163 471.473C10.6601 471.473 12.086 470.056 12.086 468.307C12.086 466.559 10.6601 465.133 8.91163 465.133Z"
            fill="white"
          />
          <path
            d="M8.00748 462.988C6.22935 462.988 4.78223 464.435 4.78223 466.214C4.78223 467.992 6.22935 469.439 8.00748 469.439C9.78561 469.439 11.2327 467.992 11.2327 466.214C11.2327 464.435 9.78561 462.988 8.00748 462.988Z"
            fill="white"
          />
          <path
            d="M6.79897 460.812C4.98689 460.812 3.51855 462.281 3.51855 464.089C3.51855 465.896 4.98689 467.356 6.79897 467.356C8.61105 467.356 10.0794 465.888 10.0794 464.089C10.0794 462.289 8.61105 460.812 6.79897 460.812Z"
            fill="white"
          />
          <path
            d="M5.24905 458.553C3.39877 458.553 1.89648 460.051 1.89648 461.905C1.89648 463.76 3.39453 465.258 5.24905 465.258C7.10357 465.258 8.58888 463.747 8.58888 461.905C8.58888 460.063 7.09083 458.553 5.24905 458.553Z"
            fill="white"
          />
          <path
            d="M3.29314 456.242C1.42164 456.242 -0.110352 457.761 -0.110352 459.637C-0.110352 461.513 1.42164 463.041 3.29314 463.041C5.16463 463.041 6.69662 461.521 6.69662 459.637C6.69662 457.753 5.16463 456.242 3.29314 456.242Z"
            fill="white"
          />
          <path
            d="M0.907803 453.838C-0.984909 453.838 -2.52539 455.378 -2.52539 457.284C-2.52539 459.189 -0.984909 460.717 0.907803 460.717C2.80052 460.717 4.35373 459.177 4.35373 457.284C4.35373 455.391 2.81325 453.838 0.907803 453.838Z"
            fill="white"
          />
          <path
            d="M-1.93156 451.318C-3.85822 451.318 -5.41992 452.88 -5.41992 454.807C-5.41992 456.733 -3.85822 458.304 -1.93156 458.304C-0.00489681 458.304 1.56529 456.742 1.56529 454.807C1.56529 452.872 0.00359068 451.318 -1.93156 451.318Z"
            fill="white"
          />
          <path
            d="M4.31091 23.0762C2.77043 23.0762 1.53125 24.3153 1.53125 25.8516C1.53125 27.3878 2.77043 28.627 4.31091 28.627C5.85139 28.627 7.09056 27.3878 7.09056 25.8516C7.09056 24.3153 5.8429 23.0762 4.31091 23.0762Z"
            fill="white"
          />
          <path
            d="M11.2248 12.5098C9.71405 12.5098 8.49609 13.7277 8.49609 15.2258C8.49609 16.7238 9.71405 17.9418 11.2248 17.9418C12.7356 17.9418 13.9408 16.7238 13.9408 15.2258C13.9408 13.7277 12.7229 12.5098 11.2248 12.5098Z"
            fill="white"
          />
          <path
            d="M17.1448 3.23828C15.6892 3.23828 14.501 4.42653 14.501 5.89062C14.501 7.35472 15.6892 8.54297 17.1448 8.54297C18.6004 8.54297 19.7972 7.35472 19.7972 5.89062C19.7972 4.42653 18.6089 3.23828 17.1448 3.23828Z"
            fill="white"
          />
          <path
            d="M22.3383 -5.08984C20.9209 -5.08984 19.7793 -3.94403 19.7793 -2.53086C19.7793 -1.11769 20.9251 0.0323616 22.3383 0.0323616C23.7514 0.0323616 24.8973 -1.11345 24.8973 -2.52662C24.8973 -3.93979 23.7514 -5.0856 22.3383 -5.0856V-5.08984Z"
            fill="white"
          />
          <path
            d="M1060.36 -2.04883C1058.87 -2.04883 1057.67 -0.852091 1057.67 0.624734C1057.67 2.10156 1058.87 3.30678 1060.36 3.30678C1061.85 3.30678 1063.03 2.1058 1063.03 0.624734C1063.03 -0.856335 1061.84 -2.04883 1060.36 -2.04883Z"
            fill="white"
          />
          <path
            d="M1067.09 10.252C1065.58 10.252 1064.35 11.4742 1064.35 12.9892C1064.35 14.5042 1065.58 15.7264 1067.09 15.7264C1068.61 15.7264 1069.83 14.4999 1069.83 12.9892C1069.83 11.4784 1068.61 10.252 1067.09 10.252Z"
            fill="white"
          />
          <path
            d="M1074.02 22.2324C1072.48 22.2324 1071.22 23.4801 1071.22 25.0333C1071.22 26.5865 1072.47 27.8257 1074.02 27.8257C1075.58 27.8257 1076.83 26.5738 1076.83 25.0333C1076.83 23.4928 1075.57 22.2324 1074.02 22.2324Z"
            fill="white"
          />
          <path
            d="M1081.21 33.7793C1079.61 33.7793 1078.32 35.0694 1078.32 36.6608C1078.32 38.2522 1079.61 39.5423 1081.21 39.5423C1082.8 39.5423 1084.09 38.2522 1084.09 36.6608C1084.09 35.0694 1082.8 33.7793 1081.21 33.7793Z"
            fill="white"
          />
          <path
            d="M1088.62 44.9941C1086.99 44.9941 1085.67 46.3055 1085.67 47.9351C1085.67 49.5647 1087 50.876 1088.62 50.876C1090.24 50.876 1091.56 49.5647 1091.56 47.9351C1091.56 46.3055 1090.24 44.9941 1088.62 44.9941Z"
            fill="white"
          />
          <path
            d="M1096.22 55.8848C1094.57 55.8848 1093.23 57.2215 1093.23 58.8766C1093.23 60.5317 1094.57 61.8727 1096.22 61.8727C1097.88 61.8727 1099.22 60.5317 1099.22 58.8766C1099.22 57.2215 1097.88 55.8848 1096.22 55.8848Z"
            fill="white"
          />
          <path
            d="M1103.95 66.5879C1102.26 66.5879 1100.9 67.9544 1100.9 69.6307C1100.9 71.3069 1102.26 72.6819 1103.95 72.6819C1105.64 72.6819 1106.99 71.3197 1106.99 69.6307C1106.99 67.9416 1105.62 66.5879 1103.95 66.5879Z"
            fill="white"
          />
          <path
            d="M1111.76 77.0703C1110.04 77.0703 1108.63 78.475 1108.63 80.2149C1108.63 81.9549 1110.04 83.3468 1111.76 83.3468C1113.49 83.3468 1114.91 81.9421 1114.91 80.2149C1114.91 78.4877 1113.5 77.0703 1111.76 77.0703Z"
            fill="white"
          />
          <path
            d="M1119.65 87.5215C1117.89 87.5215 1116.45 88.9474 1116.45 90.7128C1116.45 92.4782 1117.89 93.9041 1119.65 93.9041C1121.4 93.9041 1122.83 92.4782 1122.83 90.7128C1122.83 88.9474 1121.41 87.5215 1119.65 87.5215Z"
            fill="white"
          />
          <path
            d="M1127.51 97.9609C1125.74 97.9609 1124.28 99.4123 1124.28 101.203C1124.28 102.994 1125.73 104.445 1127.51 104.445C1129.3 104.445 1130.76 102.99 1130.76 101.203C1130.76 99.4165 1129.3 97.9609 1127.51 97.9609Z"
            fill="white"
          />
          <path
            d="M1135.34 108.486C1133.53 108.486 1132.05 109.959 1132.05 111.771C1132.05 113.583 1133.53 115.06 1135.34 115.06C1137.15 115.06 1138.63 113.592 1138.63 111.771C1138.63 109.95 1137.16 108.486 1135.34 108.486Z"
            fill="white"
          />
          <path
            d="M1143.05 119.168C1141.2 119.168 1139.69 120.67 1139.69 122.533C1139.69 124.396 1141.2 125.894 1143.05 125.894C1144.9 125.894 1146.41 124.384 1146.41 122.533C1146.41 120.683 1144.91 119.168 1143.05 119.168Z"
            fill="white"
          />
          <path
            d="M1150.67 130.027C1148.79 130.027 1147.26 131.559 1147.26 133.444C1147.26 135.328 1148.79 136.864 1150.67 136.864C1152.55 136.864 1154.1 135.332 1154.1 133.444C1154.1 131.555 1152.56 130.027 1150.67 130.027Z"
            fill="white"
          />
          <path
            d="M1158.73 147.932C1160.62 147.625 1161.9 145.844 1161.6 143.954C1161.29 142.064 1159.51 140.78 1157.62 141.087C1155.73 141.394 1154.45 143.175 1154.75 145.065C1155.06 146.955 1156.84 148.239 1158.73 147.932Z"
            fill="white"
          />
          <path
            d="M1165.55 152.363C1163.62 152.363 1162.05 153.933 1162.05 155.873C1162.05 157.812 1163.62 159.378 1165.55 159.378C1167.49 159.378 1169.06 157.808 1169.06 155.873C1169.06 153.938 1167.49 152.363 1165.55 152.363Z"
            fill="white"
          />
          <path
            d="M1172.81 163.791C1170.83 163.791 1169.23 165.395 1169.23 167.373C1169.23 169.35 1170.83 170.954 1172.81 170.954C1174.78 170.954 1176.39 169.35 1176.39 167.373C1176.39 165.395 1174.78 163.791 1172.81 163.791Z"
            fill="white"
          />
          <path
            d="M1179.96 175.406C1177.95 175.406 1176.33 177.032 1176.33 179.026C1176.33 181.021 1177.95 182.659 1179.96 182.659C1181.97 182.659 1183.58 181.033 1183.58 179.026C1183.58 177.019 1181.95 175.406 1179.96 175.406Z"
            fill="white"
          />
          <path
            d="M1187.07 187.07C1185.04 187.07 1183.39 188.717 1183.39 190.745C1183.39 192.774 1185.04 194.408 1187.07 194.408C1189.1 194.408 1190.73 192.77 1190.73 190.745C1190.73 188.721 1189.1 187.07 1187.07 187.07Z"
            fill="white"
          />
          <path
            d="M1194.26 198.615C1192.21 198.615 1190.55 200.27 1190.55 202.32C1190.55 204.37 1192.21 206.025 1194.26 206.025C1196.31 206.025 1197.96 204.361 1197.96 202.32C1197.96 200.279 1196.3 198.615 1194.26 198.615Z"
            fill="white"
          />
          <path
            d="M1201.66 209.764C1199.57 209.764 1197.9 211.448 1197.9 213.519C1197.9 215.59 1199.58 217.275 1201.66 217.275C1203.74 217.275 1205.41 215.599 1205.41 213.519C1205.41 211.44 1203.74 209.764 1201.66 209.764Z"
            fill="white"
          />
          <path
            d="M1209.37 220.334C1207.27 220.334 1205.56 222.04 1205.56 224.145C1205.56 226.25 1207.27 227.943 1209.37 227.943C1211.48 227.943 1213.17 226.237 1213.17 224.145C1213.17 222.053 1211.47 220.334 1209.37 220.334Z"
            fill="white"
          />
          <path
            d="M1217.31 230.432C1215.2 230.432 1213.47 232.15 1213.47 234.272C1213.47 236.394 1215.2 238.113 1217.31 238.113C1219.42 238.113 1221.15 236.394 1221.15 234.272C1221.15 232.15 1219.43 230.432 1217.31 230.432Z"
            fill="white"
          />
          <path
            d="M1225.59 239.832C1223.45 239.832 1221.71 241.572 1221.71 243.715C1221.71 245.858 1223.45 247.598 1225.59 247.598C1227.74 247.598 1229.48 245.862 1229.48 243.715C1229.48 241.568 1227.74 239.832 1225.59 239.832Z"
            fill="white"
          />
          <path
            d="M1234.17 248.531C1232.01 248.531 1230.25 250.288 1230.25 252.457C1230.25 254.625 1232.01 256.382 1234.17 256.382C1236.33 256.382 1238.1 254.634 1238.1 252.457C1238.1 250.28 1236.34 248.531 1234.17 248.531Z"
            fill="white"
          />
          <path
            d="M1243.13 256.381C1240.95 256.381 1239.18 258.151 1239.18 260.336C1239.18 262.522 1240.95 264.291 1243.13 264.291C1245.32 264.291 1247.09 262.522 1247.09 260.336C1247.09 258.151 1245.32 256.381 1243.13 256.381Z"
            fill="white"
          />
          <path
            d="M1252.44 263.312C1250.23 263.312 1248.45 265.103 1248.45 267.31C1248.45 269.517 1250.23 271.308 1252.44 271.308C1254.64 271.308 1256.43 269.517 1256.43 267.31C1256.43 265.103 1254.64 263.312 1252.44 263.312Z"
            fill="white"
          />
          <path
            d="M1262.09 269.275C1259.87 269.275 1258.07 271.075 1258.07 273.294C1258.07 275.514 1259.87 277.322 1262.09 277.322C1264.31 277.322 1266.11 275.522 1266.11 273.294C1266.11 271.066 1264.32 269.275 1262.09 269.275Z"
            fill="white"
          />
          <path
            d="M1272.03 274.219C1269.79 274.219 1267.98 276.039 1267.98 278.28C1267.98 280.521 1269.79 282.337 1272.03 282.337C1274.28 282.337 1276.08 280.516 1276.08 278.28C1276.08 276.044 1274.27 274.219 1272.03 274.219Z"
            fill="white"
          />
          <path
            d="M1282.21 278.174C1279.95 278.174 1278.12 280.007 1278.12 282.265C1278.12 284.522 1279.95 286.343 1282.21 286.343C1284.46 286.343 1286.29 284.522 1286.29 282.265C1286.29 280.007 1284.46 278.174 1282.21 278.174Z"
            fill="white"
          />
          <path
            d="M1292.55 281.141C1290.29 281.141 1288.45 282.982 1288.45 285.24C1288.45 287.498 1290.29 289.352 1292.55 289.352C1294.81 289.352 1296.65 287.511 1296.65 285.24C1296.65 282.97 1294.81 281.141 1292.55 281.141Z"
            fill="white"
          />
          <path
            d="M1302.99 283.139C1300.71 283.139 1298.85 284.989 1298.85 287.272C1298.85 289.555 1300.7 291.414 1302.99 291.414C1305.27 291.414 1307.13 289.559 1307.13 287.272C1307.13 284.985 1305.28 283.139 1302.99 283.139Z"
            fill="white"
          />
          <path
            d="M1313.46 284.25C1311.16 284.25 1309.3 286.113 1309.3 288.405C1309.3 290.696 1311.16 292.559 1313.46 292.559C1315.76 292.559 1317.61 290.709 1317.61 288.405C1317.61 286.1 1315.75 284.25 1313.46 284.25Z"
            fill="white"
          />
          <path
            d="M1323.87 284.572C1321.58 284.572 1319.72 286.435 1319.72 288.727C1319.72 291.019 1321.58 292.89 1323.87 292.89C1326.15 292.89 1328.02 291.027 1328.02 288.727C1328.02 286.427 1326.17 284.572 1323.87 284.572Z"
            fill="white"
          />
          <path
            d="M1334.18 284.178C1331.89 284.178 1330.03 286.028 1330.03 288.332C1330.03 290.637 1331.89 292.487 1334.18 292.487C1336.47 292.487 1338.33 290.624 1338.33 288.332C1338.33 286.041 1336.48 284.178 1334.18 284.178Z"
            fill="white"
          />
          <path
            d="M1344.37 283.129C1342.08 283.129 1340.21 284.992 1340.21 287.284C1340.21 289.575 1342.08 291.447 1344.37 291.447C1346.66 291.447 1348.52 289.584 1348.52 287.284C1348.52 284.983 1346.66 283.129 1344.37 283.129Z"
            fill="white"
          />
          <path
            d="M1354.39 281.568C1352.09 281.568 1350.24 283.431 1350.24 285.723C1350.24 288.015 1352.09 289.878 1354.39 289.878C1356.7 289.878 1358.55 288.027 1358.55 285.723C1358.55 283.419 1356.68 281.568 1354.39 281.568Z"
            fill="white"
          />
          <path
            d="M1364.23 279.598C1361.94 279.598 1360.08 281.461 1360.08 283.752C1360.08 286.044 1361.94 287.907 1364.23 287.907C1366.52 287.907 1368.39 286.052 1368.39 283.752C1368.39 281.452 1366.53 279.598 1364.23 279.598Z"
            fill="white"
          />
          <path
            d="M1373.89 277.342C1371.6 277.342 1369.73 279.205 1369.73 281.496C1369.73 283.788 1371.6 285.651 1373.89 285.651C1376.18 285.651 1378.04 283.797 1378.04 281.496C1378.04 279.196 1376.19 277.342 1373.89 277.342Z"
            fill="white"
          />
          <path
            d="M1383.39 274.861C1381.1 274.861 1379.24 276.724 1379.24 279.016C1379.24 281.308 1381.1 283.171 1383.39 283.171C1385.68 283.171 1387.54 281.32 1387.54 279.016C1387.54 276.712 1385.68 274.861 1383.39 274.861Z"
            fill="white"
          />
          <path
            d="M1392.73 272.273C1390.44 272.273 1388.57 274.136 1388.57 276.428C1388.57 278.72 1390.44 280.583 1392.73 280.583C1395.02 280.583 1396.89 278.728 1396.89 276.428C1396.89 274.128 1395.03 272.273 1392.73 272.273Z"
            fill="white"
          />
          <path
            d="M1388.99 275.58C1386.7 275.58 1384.83 277.443 1384.83 279.735C1384.83 282.026 1386.7 283.889 1388.99 283.889C1391.28 283.889 1393.14 282.035 1393.14 279.735C1393.14 277.435 1391.29 275.58 1388.99 275.58Z"
            fill="white"
          />
          <path
            d="M1385.17 278.695C1382.88 278.695 1381.01 280.546 1381.01 282.85C1381.01 285.154 1382.88 287.005 1385.17 287.005C1387.46 287.005 1389.33 285.142 1389.33 282.85C1389.33 280.558 1387.47 278.695 1385.17 278.695Z"
            fill="white"
          />
          <path
            d="M1381.18 281.662C1378.89 281.662 1377.03 283.517 1377.03 285.817C1377.03 288.117 1378.89 289.971 1381.18 289.971C1383.48 289.971 1385.34 288.108 1385.34 285.817C1385.34 283.525 1383.48 281.662 1381.18 281.662Z"
            fill="white"
          />
          <path
            d="M1376.94 284.535C1374.64 284.535 1372.78 286.398 1372.78 288.69C1372.78 290.981 1374.64 292.853 1376.94 292.853C1379.23 292.853 1381.09 290.99 1381.09 288.69C1381.09 286.39 1379.24 284.535 1376.94 284.535Z"
            fill="white"
          />
          <path
            d="M1372.36 287.387C1370.06 287.387 1368.2 289.241 1368.2 291.541C1368.2 293.841 1370.05 295.696 1372.36 295.696C1374.66 295.696 1376.51 293.833 1376.51 291.541C1376.51 289.25 1374.65 287.387 1372.36 287.387Z"
            fill="white"
          />
          <path
            d="M1367.35 290.238C1365.06 290.238 1363.2 292.093 1363.2 294.393C1363.2 296.693 1365.06 298.548 1367.35 298.548C1369.65 298.548 1371.51 296.685 1371.51 294.393C1371.51 292.101 1369.65 290.238 1367.35 290.238Z"
            fill="white"
          />
          <path
            d="M1361.87 293.127C1359.57 293.127 1357.71 294.977 1357.71 297.282C1357.71 299.586 1359.57 301.436 1361.87 301.436C1364.16 301.436 1366.02 299.573 1366.02 297.282C1366.02 294.99 1364.17 293.127 1361.87 293.127Z"
            fill="white"
          />
          <path
            d="M1355.84 296.074C1353.55 296.074 1351.69 297.937 1351.69 300.229C1351.69 302.52 1353.55 304.383 1355.84 304.383C1358.13 304.383 1359.99 302.529 1359.99 300.229C1359.99 297.929 1358.14 296.074 1355.84 296.074Z"
            fill="white"
          />
          <path
            d="M1349.24 299.061C1346.95 299.061 1345.09 300.924 1345.09 303.215C1345.09 305.507 1346.95 307.37 1349.24 307.37C1351.53 307.37 1353.4 305.52 1353.4 303.215C1353.4 300.911 1351.53 299.061 1349.24 299.061Z"
            fill="white"
          />
          <path
            d="M1342.03 302.049C1339.74 302.049 1337.88 303.899 1337.88 306.203C1337.88 308.508 1339.74 310.358 1342.03 310.358C1344.32 310.358 1346.19 308.495 1346.19 306.203C1346.19 303.912 1344.33 302.049 1342.03 302.049Z"
            fill="white"
          />
          <path
            d="M1334.21 304.965C1331.92 304.965 1330.06 306.828 1330.06 309.119C1330.06 311.411 1331.92 313.274 1334.21 313.274C1336.5 313.274 1338.37 311.411 1338.37 309.119C1338.37 306.828 1336.51 304.965 1334.21 304.965Z"
            fill="white"
          />
          <path
            d="M1325.8 307.723C1323.51 307.723 1321.65 309.586 1321.65 311.886C1321.65 314.186 1323.51 316.04 1325.8 316.04C1328.09 316.04 1329.96 314.177 1329.96 311.886C1329.96 309.594 1328.11 307.723 1325.8 307.723Z"
            fill="white"
          />
          <path
            d="M1316.82 310.281C1314.52 310.281 1312.67 312.144 1312.67 314.436C1312.67 316.727 1314.52 318.599 1316.82 318.599C1319.13 318.599 1320.98 316.736 1320.98 314.436C1320.98 312.136 1319.11 310.281 1316.82 310.281Z"
            fill="white"
          />
          <path
            d="M1307.29 312.613C1305.01 312.613 1303.15 314.468 1303.15 316.755C1303.15 319.043 1305.01 320.889 1307.29 320.889C1309.57 320.889 1311.43 319.038 1311.43 316.755C1311.43 314.472 1309.57 312.613 1307.29 312.613Z"
            fill="white"
          />
          <path
            d="M1297.25 314.602C1294.98 314.602 1293.13 316.452 1293.13 318.722C1293.13 320.993 1294.98 322.843 1297.25 322.843C1299.53 322.843 1301.38 321.001 1301.38 318.722C1301.38 316.443 1299.53 314.602 1297.25 314.602Z"
            fill="white"
          />
          <path
            d="M1286.77 316.184C1284.52 316.184 1282.7 318.004 1282.7 320.253C1282.7 322.503 1284.52 324.332 1286.77 324.332C1289.03 324.332 1290.85 322.511 1290.85 320.253C1290.85 317.996 1289.02 316.184 1286.77 316.184Z"
            fill="white"
          />
          <path
            d="M1275.92 317.201C1273.67 317.201 1271.86 319.022 1271.86 321.262C1271.86 323.503 1273.67 325.319 1275.92 325.319C1278.16 325.319 1279.97 323.499 1279.97 321.262C1279.97 319.026 1278.15 317.201 1275.92 317.201Z"
            fill="white"
          />
          <path
            d="M1264.73 317.734C1262.5 317.734 1260.7 319.546 1260.7 321.774C1260.7 324.002 1262.5 325.802 1264.73 325.802C1266.96 325.802 1268.76 323.99 1268.76 321.774C1268.76 319.559 1266.96 317.734 1264.73 317.734Z"
            fill="white"
          />
          <path
            d="M1253.22 317.785C1251.01 317.785 1249.22 319.576 1249.22 321.783C1249.22 323.99 1251.01 325.78 1253.22 325.78C1255.42 325.78 1257.22 323.99 1257.22 321.783C1257.22 319.576 1255.43 317.785 1253.22 317.785Z"
            fill="white"
          />
          <path
            d="M1241.46 317.316C1239.27 317.316 1237.5 319.086 1237.5 321.272C1237.5 323.457 1239.27 325.227 1241.46 325.227C1243.64 325.227 1245.42 323.457 1245.42 321.272C1245.42 319.086 1243.64 317.316 1241.46 317.316Z"
            fill="white"
          />
          <path
            d="M1229.48 316.287C1227.31 316.287 1225.55 318.044 1225.55 320.213C1225.55 322.381 1227.31 324.138 1229.48 324.138C1231.64 324.138 1233.41 322.381 1233.41 320.213C1233.41 318.044 1231.66 316.287 1229.48 316.287Z"
            fill="white"
          />
          <path
            d="M1217.35 314.852C1215.2 314.852 1213.45 316.592 1213.45 318.743C1213.45 320.895 1215.2 322.647 1217.35 322.647C1219.51 322.647 1221.25 320.899 1221.25 318.743C1221.25 316.587 1219.5 314.852 1217.35 314.852Z"
            fill="white"
          />
          <path
            d="M1205.11 313.217C1202.98 313.217 1201.25 314.944 1201.25 317.079C1201.25 319.213 1202.98 320.94 1205.11 320.94C1207.25 320.94 1208.96 319.213 1208.96 317.079C1208.96 314.944 1207.24 313.217 1205.11 313.217Z"
            fill="white"
          />
          <path
            d="M1192.72 311.471C1190.61 311.471 1188.91 313.177 1188.91 315.282C1188.91 317.386 1190.61 319.092 1192.72 319.092C1194.83 319.092 1196.52 317.386 1196.52 315.282C1196.52 313.177 1194.82 311.471 1192.72 311.471Z"
            fill="white"
          />
          <path
            d="M1180.22 309.723C1178.14 309.723 1176.45 311.407 1176.45 313.491C1176.45 315.575 1178.13 317.26 1180.22 317.26C1182.3 317.26 1183.98 315.575 1183.98 313.491C1183.98 311.407 1182.3 309.723 1180.22 309.723Z"
            fill="white"
          />
          <path
            d="M1167.72 308.109C1165.66 308.109 1163.98 309.773 1163.98 311.844C1163.98 313.915 1165.66 315.578 1167.72 315.578C1169.78 315.578 1171.45 313.902 1171.45 311.844C1171.45 309.786 1169.78 308.109 1167.72 308.109Z"
            fill="white"
          />
          <path
            d="M1155.16 306.713C1153.13 306.713 1151.47 308.368 1151.47 310.396C1151.47 312.425 1153.13 314.093 1155.16 314.093C1157.19 314.093 1158.85 312.438 1158.85 310.396C1158.85 308.355 1157.2 306.713 1155.16 306.713Z"
            fill="white"
          />
          <path
            d="M1142.53 305.602C1140.52 305.602 1138.9 307.227 1138.9 309.234C1138.9 311.242 1140.52 312.867 1142.53 312.867C1144.54 312.867 1146.16 311.242 1146.16 309.234C1146.16 307.227 1144.53 305.602 1142.53 305.602Z"
            fill="white"
          />
          <path
            d="M1129.85 304.857C1127.87 304.857 1126.27 306.462 1126.27 308.439C1126.27 310.417 1127.87 312.029 1129.85 312.029C1131.83 312.029 1133.44 310.425 1133.44 308.439C1133.44 306.453 1131.84 304.857 1129.85 304.857Z"
            fill="white"
          />
          <path
            d="M1117.09 304.578C1115.14 304.578 1113.56 306.161 1113.56 308.117C1113.56 310.074 1115.14 311.657 1117.09 311.657C1119.05 311.657 1120.64 310.074 1120.64 308.117C1120.64 306.161 1119.06 304.578 1117.09 304.578Z"
            fill="white"
          />
          <path
            d="M1104.22 304.807C1102.28 304.807 1100.72 306.368 1100.72 308.303C1100.72 310.239 1102.28 311.809 1104.22 311.809C1106.15 311.809 1107.72 310.239 1107.72 308.303C1107.72 306.368 1106.15 304.807 1104.22 304.807Z"
            fill="white"
          />
          <path
            d="M1091.23 312.531C1093.12 312.531 1094.65 310.998 1094.65 309.106C1094.65 307.215 1093.12 305.682 1091.23 305.682C1089.34 305.682 1087.8 307.215 1087.8 309.106C1087.8 310.998 1089.34 312.531 1091.23 312.531Z"
            fill="white"
          />
          <path
            d="M1078.01 307.256C1076.15 307.256 1074.64 308.767 1074.64 310.63C1074.64 312.493 1076.15 313.991 1078.01 313.991C1079.87 313.991 1081.38 312.48 1081.38 310.63C1081.38 308.779 1079.87 307.256 1078.01 307.256Z"
            fill="white"
          />
          <path
            d="M1064.53 309.723C1062.7 309.723 1061.21 311.212 1061.21 313.041C1061.21 314.87 1062.7 316.36 1064.53 316.36C1066.36 316.36 1067.86 314.87 1067.86 313.041C1067.86 311.212 1066.37 309.723 1064.53 309.723Z"
            fill="white"
          />
          <path
            d="M1050.81 313.24C1049 313.24 1047.54 314.696 1047.54 316.508C1047.54 318.32 1049 319.776 1050.81 319.776C1052.62 319.776 1054.08 318.307 1054.08 316.508C1054.08 314.709 1052.61 313.24 1050.81 313.24Z"
            fill="white"
          />
          <path
            d="M1036.66 318.027C1034.89 318.027 1033.47 319.453 1033.47 321.214C1033.47 322.976 1034.89 324.41 1036.66 324.41C1038.43 324.41 1039.85 322.984 1039.85 321.214C1039.85 319.445 1038.42 318.027 1036.66 318.027Z"
            fill="white"
          />
          <path
            d="M1022.32 324.498C1020.58 324.498 1019.17 325.903 1019.17 327.63C1019.17 329.357 1020.58 330.775 1022.32 330.775C1024.06 330.775 1025.45 329.37 1025.45 327.63C1025.45 325.89 1024.05 324.498 1022.32 324.498Z"
            fill="white"
          />
          <path
            d="M1007.75 332.982C1006.04 332.982 1004.66 334.366 1004.66 336.072C1004.66 337.778 1006.04 339.161 1007.75 339.161C1009.46 339.161 1010.84 337.778 1010.84 336.072C1010.84 334.366 1009.46 332.982 1007.75 332.982Z"
            fill="white"
          />
          <path
            d="M993.336 344.109C991.672 344.109 990.306 345.463 990.306 347.139C990.306 348.816 991.668 350.169 993.336 350.169C995.003 350.169 996.374 348.816 996.374 347.139C996.374 345.463 995.012 344.109 993.336 344.109Z"
            fill="white"
          />
          <path
            d="M979.478 358.418C977.853 358.418 976.533 359.729 976.533 361.363C976.533 362.997 977.853 364.308 979.478 364.308C981.104 364.308 982.423 362.984 982.423 361.363C982.423 359.742 981.104 358.418 979.478 358.418Z"
            fill="white"
          />
          <path
            d="M967.24 376.59C965.649 376.59 964.346 377.893 964.346 379.484C964.346 381.075 965.649 382.366 967.24 382.366C968.831 382.366 970.121 381.075 970.121 379.484C970.121 377.893 968.831 376.59 967.24 376.59Z"
            fill="white"
          />
          <path
            d="M957.271 398.58C955.709 398.58 954.44 399.849 954.44 401.411C954.44 402.972 955.709 404.241 957.271 404.241C958.833 404.241 960.102 402.972 960.102 401.411C960.102 399.849 958.833 398.58 957.271 398.58Z"
            fill="white"
          />
          <path
            d="M951.253 424.777C949.721 424.777 948.486 426.017 948.486 427.544C948.486 429.072 949.726 430.311 951.253 430.311C952.781 430.311 954.02 429.072 954.02 427.544C954.02 426.017 952.781 424.777 951.253 424.777Z"
            fill="white"
          />
          <path
            d="M950.794 454.965C949.305 454.965 948.1 456.174 948.1 457.66C948.1 459.145 949.309 460.354 950.794 460.354C952.28 460.354 953.489 459.149 953.489 457.66C953.489 456.17 952.284 454.965 950.794 454.965Z"
            fill="white"
          />
          <path
            d="M956.439 488.35C954.992 488.35 953.816 489.517 953.816 490.972C953.816 492.428 954.992 493.595 956.439 493.595C957.886 493.595 959.062 492.419 959.062 490.972C959.062 489.525 957.895 488.35 956.439 488.35Z"
            fill="white"
          />
          <path
            d="M967.355 524.404C965.938 524.404 964.783 525.559 964.783 526.976C964.783 528.393 965.938 529.556 967.355 529.556C968.772 529.556 969.927 528.402 969.927 526.976C969.927 525.55 968.781 524.404 967.355 524.404Z"
            fill="white"
          />
          <path
            d="M981.134 563.082C979.751 563.082 978.626 564.207 978.626 565.59C978.626 566.974 979.751 568.107 981.134 568.107C982.517 568.107 983.655 566.982 983.655 565.59C983.655 564.198 982.53 563.082 981.134 563.082Z"
            fill="white"
          />
          <path
            d="M994.688 604.578C993.347 604.578 992.252 605.66 992.252 607.001C992.252 608.342 993.347 609.425 994.688 609.425C996.029 609.425 997.111 608.342 997.111 607.001C997.111 605.66 996.016 604.578 994.688 604.578Z"
            fill="white"
          />
          <path
            d="M1005.8 649.484C1004.49 649.484 1003.44 650.545 1003.44 651.857C1003.44 653.168 1004.49 654.229 1005.8 654.229C1007.11 654.229 1008.17 653.168 1008.17 651.857C1008.17 650.545 1007.11 649.484 1005.8 649.484Z"
            fill="white"
          />
          <path
            d="M236.7 673.258C235.783 673.258 235.036 673.996 235.036 674.913C235.036 675.83 235.787 676.576 236.7 676.576C237.612 676.576 238.355 675.825 238.355 674.913C238.355 674 237.616 673.258 236.7 673.258Z"
            fill="white"
          />
          <path
            d="M213.864 660.09C212.947 660.09 212.209 660.828 212.209 661.745C212.209 662.662 212.947 663.4 213.864 663.4C214.781 663.4 215.519 662.649 215.519 661.745C215.519 660.841 214.768 660.09 213.864 660.09Z"
            fill="white"
          />
          <path
            d="M190.159 646.738C189.242 646.738 188.495 647.489 188.495 648.402C188.495 649.314 189.246 650.057 190.159 650.057C191.071 650.057 191.814 649.306 191.814 648.402C191.814 647.498 191.063 646.738 190.159 646.738Z"
            fill="white"
          />
          <path
            d="M165.24 633.801C164.323 633.801 163.576 634.552 163.576 635.464C163.576 636.377 164.327 637.128 165.24 637.128C166.152 637.128 166.903 636.389 166.903 635.464C166.903 634.539 166.152 633.801 165.24 633.801Z"
            fill="white"
          />
          <path
            d="M138.618 621.102C137.693 621.102 136.941 621.84 136.941 622.765C136.941 623.69 137.693 624.441 138.618 624.441C139.543 624.441 140.281 623.69 140.281 622.765C140.281 621.84 139.53 621.102 138.618 621.102Z"
            fill="white"
          />
          <path
            d="M109.494 607.355C108.569 607.355 107.817 608.107 107.817 609.032C107.817 609.957 108.569 610.695 109.494 610.695C110.419 610.695 111.157 609.944 111.157 609.032C111.157 608.119 110.406 607.355 109.494 607.355Z"
            fill="white"
          />
          <path
            d="M77.355 591.18C76.4299 591.18 75.6787 591.931 75.6787 592.856C75.6787 593.781 76.4299 594.532 77.355 594.532C78.2801 594.532 79.0313 593.781 79.0313 592.856C79.0313 591.931 78.2801 591.18 77.355 591.18Z"
            fill="white"
          />
          <path
            d="M54.7705 570.414C53.8241 570.414 53.0518 571.174 53.0518 572.12C53.0518 573.066 53.8241 573.826 54.7705 573.826C55.7168 573.826 56.4765 573.066 56.4765 572.12C56.4765 571.174 55.7168 570.414 54.7705 570.414Z"
            fill="white"
          />
          <path
            d="M34.1967 551.068C33.2291 551.068 32.4482 551.849 32.4482 552.817C32.4482 553.784 33.2291 554.578 34.1967 554.578C35.1642 554.578 35.9536 553.789 35.9536 552.817C35.9536 551.845 35.1727 551.068 34.1967 551.068Z"
            fill="white"
          />
          <path
            d="M17.6373 534.967C16.64 534.967 15.8252 535.777 15.8252 536.779C15.8252 537.78 16.6358 538.591 17.6373 538.591C18.6388 538.591 19.4494 537.78 19.4494 536.779C19.4494 535.777 18.6388 534.967 17.6373 534.967Z"
            fill="white"
          />
          <path
            d="M5.60125 522.613C4.58275 522.613 3.75098 523.445 3.75098 524.468C3.75098 525.491 4.58275 526.331 5.60125 526.331C6.61975 526.331 7.46426 525.499 7.46426 524.468C7.46426 523.437 6.63248 522.613 5.60125 522.613Z"
            fill="white"
          />
          <path
            d="M3.34473 2.07617C1.87639 2.07617 0.692383 3.26442 0.692383 4.72852C0.692383 6.19261 1.88063 7.38086 3.34473 7.38086C4.80882 7.38086 5.99707 6.19261 5.99707 4.72852C5.99707 3.26442 4.80882 2.07617 3.34473 2.07617Z"
            fill="white"
          />
          <path
            d="M1075.32 -4.02734C1073.84 -4.02734 1072.64 -2.82636 1072.64 -1.34954C1072.64 0.127287 1073.84 1.33251 1075.32 1.33251C1076.79 1.33251 1077.99 0.13153 1077.99 -1.34954C1077.99 -2.83061 1076.79 -4.02734 1075.32 -4.02734Z"
            fill="white"
          />
          <path
            d="M1082.02 8.31641C1080.51 8.31641 1079.28 9.54285 1079.28 11.0536C1079.28 12.5644 1080.51 13.7908 1082.02 13.7908C1083.53 13.7908 1084.76 12.5644 1084.76 11.0536C1084.76 9.54285 1083.53 8.31641 1082.02 8.31641Z"
            fill="white"
          />
          <path
            d="M1088.89 20.4043C1087.34 20.4043 1086.09 21.652 1086.09 23.2052C1086.09 24.7584 1087.33 26.006 1088.89 26.006C1090.44 26.006 1091.67 24.7457 1091.67 23.2052C1091.67 21.6647 1090.43 20.4043 1088.89 20.4043Z"
            fill="white"
          />
          <path
            d="M1095.96 37.8841C1097.55 37.8841 1098.84 36.594 1098.84 35.0026C1098.84 33.4112 1097.55 32.1211 1095.96 32.1211C1094.37 32.1211 1093.08 33.4112 1093.08 35.0026C1093.08 36.594 1094.37 37.8841 1095.96 37.8841Z"
            fill="white"
          />
          <path
            d="M1103.22 43.5293C1101.59 43.5293 1100.28 44.8533 1100.28 46.4745C1100.28 48.0956 1101.59 49.4154 1103.22 49.4154C1104.84 49.4154 1106.16 48.0998 1106.16 46.4745C1106.16 44.8491 1104.85 43.5293 1103.22 43.5293Z"
            fill="white"
          />
          <path
            d="M1110.75 54.541C1109.09 54.541 1107.74 55.882 1107.74 57.5371C1107.74 59.1922 1109.09 60.5459 1110.75 60.5459C1112.4 60.5459 1113.74 59.1964 1113.74 57.5371C1113.74 55.8778 1112.4 54.541 1110.75 54.541Z"
            fill="white"
          />
          <path
            d="M1118.41 65.3242C1116.72 65.3242 1115.35 66.6865 1115.35 68.3755C1115.35 70.0645 1116.72 71.4267 1118.41 71.4267C1120.09 71.4267 1121.46 70.0645 1121.46 68.3755C1121.46 66.6865 1120.09 65.3242 1118.41 65.3242Z"
            fill="white"
          />
          <path
            d="M1126.17 75.916C1124.43 75.916 1123.04 77.3207 1123.04 79.0479C1123.04 80.7751 1124.43 82.1925 1126.17 82.1925C1127.9 82.1925 1129.3 80.7878 1129.3 79.0479C1129.3 77.308 1127.9 75.916 1126.17 75.916Z"
            fill="white"
          />
          <path
            d="M1133.96 86.5059C1132.19 86.5059 1130.77 87.9318 1130.77 89.6887C1130.77 91.4456 1132.19 92.8757 1133.96 92.8757C1135.72 92.8757 1137.14 91.4498 1137.14 89.6887C1137.14 87.9275 1135.71 86.5059 1133.96 86.5059Z"
            fill="white"
          />
          <path
            d="M1141.72 97.1348C1139.93 97.1348 1138.48 98.5861 1138.48 100.377C1138.48 102.168 1139.93 103.615 1141.72 103.615C1143.51 103.615 1144.95 102.168 1144.95 100.377C1144.95 98.5861 1143.51 97.1348 1141.72 97.1348Z"
            fill="white"
          />
          <path
            d="M1149.44 107.838C1147.62 107.838 1146.14 109.315 1146.14 111.135C1146.14 112.956 1147.62 114.437 1149.44 114.437C1151.26 114.437 1152.73 112.96 1152.73 111.135C1152.73 109.31 1151.26 107.838 1149.44 107.838Z"
            fill="white"
          />
          <path
            d="M1157.1 125.376C1158.96 125.376 1160.48 123.866 1160.48 122.003C1160.48 120.139 1158.96 118.629 1157.1 118.629C1155.24 118.629 1153.73 120.139 1153.73 122.003C1153.73 123.866 1155.24 125.376 1157.1 125.376Z"
            fill="white"
          />
          <path
            d="M1164.67 129.621C1162.78 129.621 1161.26 131.153 1161.26 133.033C1161.26 134.913 1162.79 136.445 1164.67 136.445C1166.55 136.445 1168.08 134.913 1168.08 133.033C1168.08 131.153 1166.55 129.621 1164.67 129.621Z"
            fill="white"
          />
          <path
            d="M1172.12 140.799C1170.21 140.799 1168.65 142.348 1168.65 144.266C1168.65 146.184 1170.2 147.725 1172.12 147.725C1174.04 147.725 1175.57 146.176 1175.57 144.266C1175.57 142.356 1174.02 140.799 1172.12 140.799Z"
            fill="white"
          />
          <path
            d="M1179.43 159.208C1181.36 159.208 1182.93 157.639 1182.93 155.703C1182.93 153.767 1181.36 152.197 1179.43 152.197C1177.49 152.197 1175.92 153.767 1175.92 155.703C1175.92 157.639 1177.49 159.208 1179.43 159.208Z"
            fill="white"
          />
          <path
            d="M1186.6 163.791C1184.62 163.791 1183.03 165.387 1183.03 167.364C1183.03 169.342 1184.62 170.937 1186.6 170.937C1188.58 170.937 1190.18 169.333 1190.18 167.364C1190.18 165.395 1188.58 163.791 1186.6 163.791Z"
            fill="white"
          />
          <path
            d="M1193.72 175.479C1191.71 175.479 1190.08 177.104 1190.08 179.111C1190.08 181.118 1191.71 182.731 1193.72 182.731C1195.72 182.731 1197.34 181.106 1197.34 179.111C1197.34 177.117 1195.71 175.479 1193.72 175.479Z"
            fill="white"
          />
          <path
            d="M1200.84 187.158C1198.81 187.158 1197.16 188.805 1197.16 190.833C1197.16 192.862 1198.81 194.496 1200.84 194.496C1202.87 194.496 1204.5 192.858 1204.5 190.833C1204.5 188.809 1202.87 187.158 1200.84 187.158Z"
            fill="white"
          />
          <path
            d="M1208.05 198.664C1206.01 198.664 1204.34 200.319 1204.34 202.36C1204.34 204.402 1206.01 206.065 1208.05 206.065C1210.09 206.065 1211.75 204.41 1211.75 202.36C1211.75 200.311 1210.1 198.664 1208.05 198.664Z"
            fill="white"
          />
          <path
            d="M1215.49 209.709C1213.42 209.709 1211.74 211.394 1211.74 213.477C1211.74 215.561 1213.42 217.233 1215.49 217.233C1217.56 217.233 1219.26 215.548 1219.26 213.477C1219.26 211.406 1217.57 209.709 1215.49 209.709Z"
            fill="white"
          />
          <path
            d="M1223.25 220.139C1221.16 220.139 1219.45 221.845 1219.45 223.95C1219.45 226.054 1221.16 227.748 1223.25 227.748C1225.34 227.748 1227.06 226.042 1227.06 223.95C1227.06 221.857 1225.36 220.139 1223.25 220.139Z"
            fill="white"
          />
          <path
            d="M1231.28 230.027C1229.16 230.027 1227.44 231.746 1227.44 233.868C1227.44 235.99 1229.16 237.696 1231.28 237.696C1233.4 237.696 1235.11 235.977 1235.11 233.868C1235.11 231.759 1233.39 230.027 1231.28 230.027Z"
            fill="white"
          />
          <path
            d="M1239.64 239.164C1237.5 239.164 1235.76 240.904 1235.76 243.047C1235.76 245.19 1237.5 246.93 1239.64 246.93C1241.79 246.93 1243.53 245.194 1243.53 243.047C1243.53 240.9 1241.79 239.164 1239.64 239.164Z"
            fill="white"
          />
          <path
            d="M1248.33 247.562C1246.16 247.562 1244.4 249.324 1244.4 251.488C1244.4 253.652 1246.16 255.413 1248.33 255.413C1250.49 255.413 1252.25 253.665 1252.25 251.488C1252.25 249.311 1250.49 247.562 1248.33 247.562Z"
            fill="white"
          />
          <path
            d="M1257.4 255.027C1255.22 255.027 1253.44 256.797 1253.44 258.983C1253.44 261.168 1255.22 262.938 1257.4 262.938C1259.59 262.938 1261.36 261.168 1261.36 258.983C1261.36 256.797 1259.59 255.027 1257.4 255.027Z"
            fill="white"
          />
          <path
            d="M1266.8 261.535C1264.61 261.535 1262.82 263.326 1262.82 265.52C1262.82 267.714 1264.61 269.505 1266.8 269.505C1269 269.505 1270.79 267.727 1270.79 265.52C1270.79 263.313 1269.01 261.535 1266.8 261.535Z"
            fill="white"
          />
          <path
            d="M1276.53 266.986C1274.3 266.986 1272.5 268.798 1272.5 271.014C1272.5 273.229 1274.3 275.041 1276.53 275.041C1278.76 275.041 1280.55 273.242 1280.55 271.014C1280.55 268.786 1278.75 266.986 1276.53 266.986Z"
            fill="white"
          />
          <path
            d="M1286.51 271.416C1284.28 271.416 1282.47 273.228 1282.47 275.465C1282.47 277.701 1284.28 279.522 1286.51 279.522C1288.75 279.522 1290.57 277.701 1290.57 275.465C1290.57 273.228 1288.76 271.416 1286.51 271.416Z"
            fill="white"
          />
          <path
            d="M1296.69 274.811C1294.44 274.811 1292.61 276.644 1292.61 278.902C1292.61 281.159 1294.44 282.98 1296.69 282.98C1298.93 282.98 1300.78 281.159 1300.78 278.902C1300.78 276.644 1298.95 274.811 1296.69 274.811Z"
            fill="white"
          />
          <path
            d="M1307.01 277.205C1304.73 277.205 1302.89 279.047 1302.89 281.317C1302.89 283.588 1304.73 285.429 1307.01 285.429C1309.29 285.429 1311.12 283.588 1311.12 281.317C1311.12 279.047 1309.28 277.205 1307.01 277.205Z"
            fill="white"
          />
          <path
            d="M1320.26 285.739C1321.88 284.125 1321.88 281.508 1320.26 279.894C1318.65 278.279 1316.03 278.279 1314.42 279.894C1312.8 281.508 1312.8 284.125 1314.42 285.739C1316.03 287.353 1318.65 287.353 1320.26 285.739Z"
            fill="white"
          />
          <path
            d="M1327.66 279.297C1325.36 279.297 1323.5 281.16 1323.5 283.451C1323.5 285.743 1325.36 287.615 1327.66 287.615C1329.95 287.615 1331.81 285.752 1331.81 283.451C1331.81 281.151 1329.96 279.297 1327.66 279.297Z"
            fill="white"
          />
          <path
            d="M1337.9 279.193C1335.6 279.193 1333.74 281.048 1333.74 283.348C1333.74 285.648 1335.59 287.503 1337.9 287.503C1340.2 287.503 1342.05 285.64 1342.05 283.348C1342.05 281.056 1340.19 279.193 1337.9 279.193Z"
            fill="white"
          />
          <path
            d="M1348.02 278.426C1345.72 278.426 1343.87 280.28 1343.87 282.58C1343.87 284.881 1345.72 286.735 1348.02 286.735C1350.33 286.735 1352.17 284.872 1352.17 282.58C1352.17 280.289 1350.31 278.426 1348.02 278.426Z"
            fill="white"
          />
          <path
            d="M1358 277.113C1355.7 277.113 1353.85 278.976 1353.85 281.268C1353.85 283.56 1355.7 285.423 1358 285.423C1360.3 285.423 1362.16 283.56 1362.16 281.268C1362.16 278.976 1360.3 277.113 1358 277.113Z"
            fill="white"
          />
          <path
            d="M1367.83 275.385C1365.53 275.385 1363.68 277.248 1363.68 279.539C1363.68 281.831 1365.53 283.694 1367.83 283.694C1370.13 283.694 1371.98 281.84 1371.98 279.539C1371.98 277.239 1370.12 275.385 1367.83 275.385Z"
            fill="white"
          />
          <path
            d="M1377.51 273.344C1375.21 273.344 1373.35 275.207 1373.35 277.498C1373.35 279.79 1375.2 281.662 1377.51 281.662C1379.81 281.662 1381.66 279.799 1381.66 277.498C1381.66 275.198 1379.8 273.344 1377.51 273.344Z"
            fill="white"
          />
          <path
            d="M1387.05 271.088C1384.76 271.088 1382.9 272.951 1382.9 275.243C1382.9 277.534 1384.76 279.397 1387.05 279.397C1389.34 279.397 1391.21 277.534 1391.21 275.243C1391.21 272.951 1389.35 271.088 1387.05 271.088Z"
            fill="white"
          />
          <path
            d="M1396.48 268.701C1394.18 268.701 1392.33 270.564 1392.33 272.856C1392.33 275.147 1394.18 277.01 1396.48 277.01C1398.78 277.01 1400.64 275.156 1400.64 272.856C1400.64 270.556 1398.77 268.701 1396.48 268.701Z"
            fill="white"
          />
          <path
            d="M1405.78 266.33C1403.49 266.33 1401.62 268.193 1401.62 270.485C1401.62 272.776 1403.48 274.639 1405.78 274.639C1408.07 274.639 1409.93 272.776 1409.93 270.485C1409.93 268.193 1408.07 266.33 1405.78 266.33Z"
            fill="white"
          />
          <path
            d="M1401.91 269.68C1399.61 269.68 1397.75 271.543 1397.75 273.834C1397.75 276.126 1399.61 277.989 1401.91 277.989C1404.2 277.989 1406.06 276.134 1406.06 273.834C1406.06 271.534 1404.21 269.68 1401.91 269.68Z"
            fill="white"
          />
          <path
            d="M1398 272.857C1395.7 272.857 1393.85 274.72 1393.85 277.012C1393.85 279.304 1395.7 281.167 1398 281.167C1400.31 281.167 1402.16 279.312 1402.16 277.012C1402.16 274.712 1400.29 272.857 1398 272.857Z"
            fill="white"
          />
          <path
            d="M1393.94 275.902C1391.66 275.902 1389.79 277.765 1389.79 280.057C1389.79 282.349 1391.65 284.212 1393.94 284.212C1396.24 284.212 1398.1 282.361 1398.1 280.057C1398.1 277.753 1396.25 275.902 1393.94 275.902Z"
            fill="white"
          />
          <path
            d="M1389.67 278.883C1387.37 278.883 1385.51 280.746 1385.51 283.037C1385.51 285.329 1387.37 287.201 1389.67 287.201C1391.96 287.201 1393.82 285.338 1393.82 283.037C1393.82 280.737 1391.96 278.883 1389.67 278.883Z"
            fill="white"
          />
          <path
            d="M1385.08 281.848C1382.78 281.848 1380.92 283.711 1380.92 286.002C1380.92 288.294 1382.78 290.157 1385.08 290.157C1387.37 290.157 1389.23 288.302 1389.23 286.002C1389.23 283.702 1387.37 281.848 1385.08 281.848Z"
            fill="white"
          />
          <path
            d="M1380.1 284.836C1377.8 284.836 1375.94 286.699 1375.94 288.991C1375.94 291.282 1377.8 293.145 1380.1 293.145C1382.4 293.145 1384.26 291.295 1384.26 288.991C1384.26 286.686 1382.39 284.836 1380.1 284.836Z"
            fill="white"
          />
          <path
            d="M1374.66 287.881C1372.36 287.881 1370.5 289.731 1370.5 292.035C1370.5 294.34 1372.36 296.19 1374.66 296.19C1376.95 296.19 1378.81 294.327 1378.81 292.035C1378.81 289.744 1376.96 287.881 1374.66 287.881Z"
            fill="white"
          />
          <path
            d="M1368.72 290.986C1366.42 290.986 1364.56 292.849 1364.56 295.141C1364.56 297.433 1366.41 299.296 1368.72 299.296C1371.02 299.296 1372.87 297.433 1372.87 295.141C1372.87 292.849 1371.01 290.986 1368.72 290.986Z"
            fill="white"
          />
          <path
            d="M1362.2 294.172C1359.91 294.172 1358.05 296.035 1358.05 298.335C1358.05 300.635 1359.91 302.49 1362.2 302.49C1364.49 302.49 1366.36 300.627 1366.36 298.335C1366.36 296.043 1364.49 294.172 1362.2 294.172Z"
            fill="white"
          />
          <path
            d="M1355.09 297.439C1352.79 297.439 1350.93 299.302 1350.93 301.594C1350.93 303.886 1352.79 305.749 1355.09 305.749C1357.39 305.749 1359.24 303.886 1359.24 301.594C1359.24 299.302 1357.38 297.439 1355.09 297.439Z"
            fill="white"
          />
          <path
            d="M1347.36 300.729C1345.06 300.729 1343.2 302.583 1343.2 304.883C1343.2 307.183 1345.05 309.038 1347.36 309.038C1349.66 309.038 1351.51 307.175 1351.51 304.883C1351.51 302.592 1349.64 300.729 1347.36 300.729Z"
            fill="white"
          />
          <path
            d="M1339 303.953C1336.71 303.953 1334.85 305.816 1334.85 308.108C1334.85 310.399 1336.71 312.262 1339 312.262C1341.29 312.262 1343.15 310.412 1343.15 308.108C1343.15 305.803 1341.3 303.953 1339 303.953Z"
            fill="white"
          />
          <path
            d="M1330.05 307.035C1327.75 307.035 1325.9 308.898 1325.9 311.19C1325.9 313.481 1327.75 315.344 1330.05 315.344C1332.35 315.344 1334.2 313.494 1334.2 311.19C1334.2 308.885 1332.34 307.035 1330.05 307.035Z"
            fill="white"
          />
          <path
            d="M1320.53 309.887C1318.24 309.887 1316.39 311.741 1316.39 314.02C1316.39 316.299 1318.24 318.162 1320.53 318.162C1322.82 318.162 1324.66 316.312 1324.66 314.02C1324.66 311.729 1322.81 309.887 1320.53 309.887Z"
            fill="white"
          />
          <path
            d="M1310.47 312.445C1308.2 312.445 1306.35 314.287 1306.35 316.566C1306.35 318.845 1308.2 320.687 1310.47 320.687C1312.75 320.687 1314.59 318.845 1314.59 316.566C1314.59 314.287 1312.74 312.445 1310.47 312.445Z"
            fill="white"
          />
          <path
            d="M1299.93 314.666C1297.67 314.666 1295.84 316.499 1295.84 318.757C1295.84 321.015 1297.67 322.835 1299.93 322.835C1302.19 322.835 1304.02 321.015 1304.02 318.757C1304.02 316.499 1302.19 314.666 1299.93 314.666Z"
            fill="white"
          />
          <path
            d="M1288.95 316.398C1286.71 316.398 1284.89 318.211 1284.89 320.455C1284.89 322.7 1286.71 324.512 1288.95 324.512C1291.19 324.512 1293.01 322.692 1293.01 320.455C1293.01 318.219 1291.2 316.398 1288.95 316.398Z"
            fill="white"
          />
          <path
            d="M1277.6 317.568C1275.37 317.568 1273.58 319.368 1273.58 321.596C1273.58 323.824 1275.37 325.623 1277.6 325.623C1279.83 325.623 1281.63 323.824 1281.63 321.596C1281.63 319.368 1279.83 317.568 1277.6 317.568Z"
            fill="white"
          />
          <path
            d="M1265.89 318.162C1263.69 318.162 1261.9 319.953 1261.9 322.16C1261.9 324.366 1263.69 326.166 1265.89 326.166C1268.1 326.166 1269.89 324.375 1269.89 322.16C1269.89 319.945 1268.1 318.162 1265.89 318.162Z"
            fill="white"
          />
          <path
            d="M1253.93 318.242C1251.73 318.242 1249.96 320.012 1249.96 322.197C1249.96 324.383 1251.73 326.161 1253.93 326.161C1256.12 326.161 1257.88 324.383 1257.88 322.197C1257.88 320.012 1256.11 318.242 1253.93 318.242Z"
            fill="white"
          />
          <path
            d="M1241.7 317.756C1239.52 317.756 1237.76 319.504 1237.76 321.681C1237.76 323.858 1239.52 325.607 1241.7 325.607C1243.87 325.607 1245.62 323.85 1245.62 321.681C1245.62 319.513 1243.86 317.756 1241.7 317.756Z"
            fill="white"
          />
          <path
            d="M1229.3 316.674C1227.14 316.674 1225.4 318.422 1225.4 320.578C1225.4 322.734 1227.14 324.47 1229.3 324.47C1231.46 324.47 1233.19 322.721 1233.19 320.578C1233.19 318.435 1231.44 316.674 1229.3 316.674Z"
            fill="white"
          />
          <path
            d="M1216.83 315.195C1214.7 315.195 1212.97 316.935 1212.97 319.066C1212.97 321.196 1214.7 322.927 1216.83 322.927C1218.97 322.927 1220.69 321.2 1220.69 319.066C1220.69 316.931 1218.97 315.195 1216.83 315.195Z"
            fill="white"
          />
          <path
            d="M1204.28 313.539C1202.18 313.539 1200.48 315.245 1200.48 317.35C1200.48 319.455 1202.18 321.161 1204.28 321.161C1206.38 321.161 1208.09 319.455 1208.09 317.35C1208.09 315.245 1206.38 313.539 1204.28 313.539Z"
            fill="white"
          />
          <path
            d="M1191.64 311.742C1189.54 311.742 1187.86 313.44 1187.86 315.519C1187.86 317.599 1189.54 319.296 1191.64 319.296C1193.73 319.296 1195.41 317.611 1195.41 315.519C1195.41 313.427 1193.72 311.742 1191.64 311.742Z"
            fill="white"
          />
          <path
            d="M1178.95 310.002C1176.88 310.002 1175.21 311.666 1175.21 313.728C1175.21 315.79 1176.89 317.462 1178.95 317.462C1181.01 317.462 1182.69 315.786 1182.69 313.728C1182.69 311.67 1181.01 310.002 1178.95 310.002Z"
            fill="white"
          />
          <path
            d="M1166.26 308.41C1164.22 308.41 1162.56 310.065 1162.56 312.106C1162.56 314.148 1164.22 315.803 1166.26 315.803C1168.3 315.803 1169.94 314.148 1169.94 312.106C1169.94 310.065 1168.29 308.41 1166.26 308.41Z"
            fill="white"
          />
          <path
            d="M1153.53 307.078C1151.53 307.078 1149.9 308.699 1149.9 310.711C1149.9 312.722 1151.53 314.343 1153.53 314.343C1155.53 314.343 1157.17 312.718 1157.17 310.711C1157.17 308.703 1155.54 307.078 1153.53 307.078Z"
            fill="white"
          />
          <path
            d="M1140.8 306.047C1138.82 306.047 1137.22 307.651 1137.22 309.629C1137.22 311.606 1138.82 313.219 1140.8 313.219C1142.78 313.219 1144.39 311.615 1144.39 309.629C1144.39 307.643 1142.78 306.047 1140.8 306.047Z"
            fill="white"
          />
          <path
            d="M1128.04 305.422C1126.09 305.422 1124.5 307.013 1124.5 308.97C1124.5 310.926 1126.09 312.509 1128.04 312.509C1130 312.509 1131.59 310.926 1131.59 308.97C1131.59 307.013 1130 305.422 1128.04 305.422Z"
            fill="white"
          />
          <path
            d="M1115.17 305.287C1113.23 305.287 1111.67 306.857 1111.67 308.792C1111.67 310.728 1113.23 312.289 1115.17 312.289C1117.1 312.289 1118.67 310.719 1118.67 308.792C1118.67 306.866 1117.1 305.287 1115.17 305.287Z"
            fill="white"
          />
          <path
            d="M1102.18 312.603C1104.07 312.603 1105.6 311.07 1105.6 309.179C1105.6 307.287 1104.07 305.754 1102.18 305.754C1100.29 305.754 1098.75 307.287 1098.75 309.179C1098.75 311.07 1100.29 312.603 1102.18 312.603Z"
            fill="white"
          />
          <path
            d="M1089.04 306.848C1087.17 306.848 1085.65 308.367 1085.65 310.23C1085.65 312.093 1087.17 313.612 1089.04 313.612C1090.9 313.612 1092.42 312.093 1092.42 310.23C1092.42 308.367 1090.91 306.848 1089.04 306.848Z"
            fill="white"
          />
          <path
            d="M1075.62 308.754C1073.77 308.754 1072.29 310.243 1072.29 312.085C1072.29 313.927 1073.77 315.404 1075.62 315.404C1077.46 315.404 1078.94 313.914 1078.94 312.085C1078.94 310.256 1077.45 308.754 1075.62 308.754Z"
            fill="white"
          />
          <path
            d="M1061.97 311.688C1060.16 311.688 1058.69 313.156 1058.69 314.968C1058.69 316.78 1060.16 318.248 1061.97 318.248C1063.78 318.248 1065.26 316.78 1065.26 314.968C1065.26 313.156 1063.79 311.688 1061.97 311.688Z"
            fill="white"
          />
          <path
            d="M1047.94 315.799C1046.17 315.799 1044.75 317.233 1044.75 318.994C1044.75 320.756 1046.17 322.19 1047.94 322.19C1049.71 322.19 1051.14 320.764 1051.14 318.994C1051.14 317.225 1049.7 315.799 1047.94 315.799Z"
            fill="white"
          />
          <path
            d="M1033.56 321.389C1031.83 321.389 1030.42 322.806 1030.42 324.542C1030.42 326.277 1031.82 327.686 1033.56 327.686C1035.3 327.686 1036.71 326.282 1036.71 324.542C1036.71 322.802 1035.3 321.389 1033.56 321.389Z"
            fill="white"
          />
          <path
            d="M1018.97 328.926C1017.26 328.926 1015.88 330.309 1015.88 332.015C1015.88 333.721 1017.26 335.105 1018.97 335.105C1020.67 335.105 1022.06 333.721 1022.06 332.015C1022.06 330.309 1020.67 328.926 1018.97 328.926Z"
            fill="white"
          />
          <path
            d="M1004.33 338.807C1002.65 338.807 1001.29 340.16 1001.29 341.837C1001.29 343.513 1002.65 344.875 1004.33 344.875C1006 344.875 1007.36 343.513 1007.36 341.837C1007.36 340.16 1006 338.807 1004.33 338.807Z"
            fill="white"
          />
          <path
            d="M990.117 351.611C988.492 351.611 987.181 352.923 987.181 354.556C987.181 356.19 988.492 357.493 990.117 357.493C991.743 357.493 993.063 356.182 993.063 354.556C993.063 352.931 991.751 351.611 990.117 351.611Z"
            fill="white"
          />
          <path
            d="M977.056 367.963C975.452 367.963 974.153 369.253 974.153 370.857C974.153 372.461 975.456 373.751 977.056 373.751C978.656 373.751 979.95 372.461 979.95 370.857C979.95 369.253 978.66 367.963 977.056 367.963Z"
            fill="white"
          />
          <path
            d="M966.056 388.184C964.486 388.184 963.204 389.452 963.204 391.027C963.204 392.601 964.486 393.87 966.056 393.87C967.626 393.87 968.899 392.601 968.899 391.027C968.899 389.452 967.618 388.184 966.056 388.184Z"
            fill="white"
          />
          <path
            d="M958.29 412.457C956.758 412.457 955.511 413.705 955.511 415.245C955.511 416.786 956.758 418.025 958.29 418.025C959.822 418.025 961.078 416.777 961.078 415.245C961.078 413.713 959.831 412.457 958.29 412.457Z"
            fill="white"
          />
          <path
            d="M955.544 440.932C954.055 440.932 952.85 442.141 952.85 443.626C952.85 445.112 954.059 446.321 955.544 446.321C957.03 446.321 958.239 445.112 958.239 443.626C958.239 442.141 957.03 440.932 955.544 440.932Z"
            fill="white"
          />
          <path
            d="M959.049 472.979C957.593 472.979 956.418 474.154 956.418 475.61C956.418 477.065 957.593 478.241 959.049 478.241C960.505 478.241 961.693 477.065 961.693 475.61C961.693 474.154 960.505 472.979 959.049 472.979Z"
            fill="white"
          />
          <path
            d="M968.565 507.844C967.139 507.844 965.984 508.998 965.984 510.424C965.984 511.85 967.139 512.996 968.565 512.996C969.991 512.996 971.145 511.85 971.145 510.424C971.145 508.998 969.991 507.844 968.565 507.844Z"
            fill="white"
          />
          <path
            d="M982.029 545.262C980.633 545.262 979.513 546.386 979.513 547.783C979.513 549.179 980.637 550.299 982.029 550.299C983.421 550.299 984.55 549.174 984.55 547.783C984.55 546.391 983.417 545.262 982.029 545.262Z"
            fill="white"
          />
          <path
            d="M996.381 585.531C995.04 585.531 993.945 586.613 993.945 587.954C993.945 589.295 995.04 590.39 996.381 590.39C997.722 590.39 998.804 589.295 998.804 587.954C998.804 586.613 997.722 585.531 996.381 585.531Z"
            fill="white"
          />
          <path
            d="M1008.84 629.004C1007.54 629.004 1006.48 630.065 1006.48 631.376C1006.48 632.688 1007.54 633.748 1008.84 633.748C1010.14 633.748 1011.21 632.688 1011.21 631.376C1011.21 630.065 1010.15 629.004 1008.84 629.004Z"
            fill="white"
          />
          <path
            d="M1018.28 677.35C1017 677.35 1015.97 678.389 1015.97 679.671C1015.97 680.953 1017 681.98 1018.28 681.98C1019.56 681.98 1020.6 680.94 1020.6 679.671C1020.6 678.402 1019.56 677.35 1018.28 677.35Z"
            fill="white"
          />
          <path
            d="M227.011 678.021C226.115 678.021 225.377 678.751 225.377 679.655C225.377 680.559 226.115 681.281 227.011 681.281C227.906 681.281 228.636 680.551 228.636 679.655C228.636 678.76 227.906 678.021 227.011 678.021Z"
            fill="white"
          />
          <path
            d="M203.81 664.475C202.914 664.475 202.188 665.192 202.188 666.087C202.188 666.983 202.918 667.713 203.81 667.713C204.701 667.713 205.435 666.995 205.435 666.087C205.435 665.179 204.705 664.475 203.81 664.475Z"
            fill="white"
          />
          <path
            d="M179.799 650.889C178.895 650.889 178.165 651.627 178.165 652.535C178.165 653.443 178.895 654.169 179.799 654.169C180.703 654.169 181.445 653.439 181.445 652.535C181.445 651.631 180.707 650.889 179.799 650.889Z"
            fill="white"
          />
          <path
            d="M154.77 638.162C153.874 638.162 153.145 638.892 153.145 639.796C153.145 640.7 153.874 641.43 154.77 641.43C155.665 641.43 156.404 640.7 156.404 639.796C156.404 638.892 155.674 638.162 154.77 638.162Z"
            fill="white"
          />
          <path
            d="M128.127 625.373C127.223 625.373 126.48 626.103 126.48 627.02C126.48 627.936 127.219 628.666 128.127 628.666C129.035 628.666 129.774 627.928 129.774 627.02C129.774 626.111 129.035 625.373 128.127 625.373Z"
            fill="white"
          />
          <path
            d="M99.0147 611.197C98.1108 611.197 97.3682 611.927 97.3682 612.844C97.3682 613.76 98.1066 614.478 99.0147 614.478C99.9229 614.478 100.661 613.748 100.661 612.844C100.661 611.94 99.9229 611.197 99.0147 611.197Z"
            fill="white"
          />
          <path
            d="M66.9158 594.322C65.9992 594.322 65.2607 595.061 65.2607 595.977C65.2607 596.894 65.9992 597.632 66.9158 597.632C67.8325 597.632 68.5709 596.894 68.5709 595.977C68.5709 595.061 67.8325 594.322 66.9158 594.322Z"
            fill="white"
          />
          <path
            d="M42.9377 571.613C42.0126 571.613 41.2529 572.373 41.2529 573.298C41.2529 574.223 42.0126 574.974 42.9377 574.974C43.8628 574.974 44.614 574.223 44.614 573.298C44.614 572.373 43.8628 571.613 42.9377 571.613Z"
            fill="white"
          />
          <path
            d="M20.998 550.549C20.0517 550.549 19.2793 551.317 19.2793 552.268C19.2793 553.218 20.0517 553.986 20.998 553.986C21.9444 553.986 22.7167 553.218 22.7167 552.268C22.7167 551.317 21.9571 550.549 20.998 550.549Z"
            fill="white"
          />
          <path
            d="M3.52254 533.447C2.55496 533.447 1.76562 534.237 1.76562 535.208C1.76562 536.18 2.55496 536.965 3.52254 536.965C4.49011 536.965 5.28369 536.176 5.28369 535.208C5.28369 534.241 4.50284 533.447 3.52254 533.447Z"
            fill="white"
          />
          <path
            d="M1097.37 5.60938C1095.86 5.60938 1094.63 6.82733 1094.63 8.34235C1094.63 9.85737 1095.86 11.0796 1097.37 11.0796C1098.88 11.0796 1100.11 9.85737 1100.11 8.34235C1100.11 6.82733 1098.88 5.60938 1097.37 5.60938Z"
            fill="white"
          />
          <path
            d="M1104.13 17.8613C1102.58 17.8613 1101.33 19.109 1101.33 20.6622C1101.33 22.2154 1102.57 23.4503 1104.13 23.4503C1105.68 23.4503 1106.91 22.2027 1106.91 20.6622C1106.91 19.1217 1105.67 17.8613 1104.13 17.8613Z"
            fill="white"
          />
          <path
            d="M1111.11 29.707C1109.52 29.707 1108.22 30.9971 1108.22 32.5885C1108.22 34.1799 1109.52 35.4785 1111.11 35.4785C1112.7 35.4785 1113.99 34.1842 1113.99 32.5885C1113.99 30.9929 1112.7 29.707 1111.11 29.707Z"
            fill="white"
          />
          <path
            d="M1118.32 41.2051C1116.69 41.2051 1115.38 42.5249 1115.38 44.1502C1115.38 45.7756 1116.7 47.0869 1118.32 47.0869C1119.94 47.0869 1121.26 45.7756 1121.26 44.1502C1121.26 42.5249 1119.95 41.2051 1118.32 41.2051Z"
            fill="white"
          />
          <path
            d="M1125.76 52.3203C1124.11 52.3203 1122.77 53.6698 1122.77 55.3291C1122.77 56.9884 1124.11 58.3252 1125.76 58.3252C1127.42 58.3252 1128.76 56.9842 1128.76 55.3291C1128.76 53.6741 1127.42 52.3203 1125.76 52.3203Z"
            fill="white"
          />
          <path
            d="M1133.34 63.2598C1131.65 63.2598 1130.29 64.622 1130.29 66.3025C1130.29 67.9831 1131.65 69.3538 1133.34 69.3538C1135.02 69.3538 1136.39 67.9873 1136.39 66.3025C1136.39 64.6178 1135.02 63.2598 1133.34 63.2598Z"
            fill="white"
          />
          <path
            d="M1140.97 80.3185C1142.7 80.3185 1144.1 78.9163 1144.1 77.1866C1144.1 75.4569 1142.7 74.0547 1140.97 74.0547C1139.24 74.0547 1137.84 75.4569 1137.84 77.1866C1137.84 78.9163 1139.24 80.3185 1140.97 80.3185Z"
            fill="white"
          />
          <path
            d="M1148.64 84.8262C1146.87 84.8262 1145.44 86.2648 1145.44 88.0217C1145.44 89.7786 1146.87 91.2173 1148.64 91.2173C1150.41 91.2173 1151.83 89.7871 1151.83 88.0217C1151.83 86.2563 1150.4 84.8262 1148.64 84.8262Z"
            fill="white"
          />
          <path
            d="M1156.33 95.5957C1154.54 95.5957 1153.1 97.0471 1153.1 98.8337C1153.1 100.62 1154.54 102.072 1156.33 102.072C1158.12 102.072 1159.57 100.62 1159.57 98.8337C1159.57 97.0471 1158.12 95.5957 1156.33 95.5957Z"
            fill="white"
          />
          <path
            d="M1164 106.406C1162.18 106.406 1160.7 107.879 1160.7 109.699C1160.7 111.52 1162.18 112.997 1164 112.997C1165.82 112.997 1167.29 111.52 1167.29 109.699C1167.29 107.879 1165.82 106.406 1164 106.406Z"
            fill="white"
          />
          <path
            d="M1171.6 117.324C1169.74 117.324 1168.23 118.835 1168.23 120.69C1168.23 122.544 1169.74 124.063 1171.6 124.063C1173.47 124.063 1174.98 122.553 1174.98 120.69C1174.98 118.827 1173.47 117.324 1171.6 117.324Z"
            fill="white"
          />
          <path
            d="M1179.09 128.459C1177.21 128.459 1175.68 129.991 1175.68 131.871C1175.68 133.751 1177.21 135.287 1179.09 135.287C1180.97 135.287 1182.5 133.764 1182.5 131.871C1182.5 129.978 1180.97 128.459 1179.09 128.459Z"
            fill="white"
          />
          <path
            d="M1186.44 139.828C1184.53 139.828 1182.98 141.373 1182.98 143.287C1182.98 145.201 1184.52 146.754 1186.44 146.754C1188.36 146.754 1189.91 145.205 1189.91 143.287C1189.91 141.369 1188.36 139.828 1186.44 139.828Z"
            fill="white"
          />
          <path
            d="M1193.7 151.357C1191.76 151.357 1190.19 152.923 1190.19 154.859C1190.19 156.794 1191.76 158.364 1193.7 158.364C1195.63 158.364 1197.2 156.794 1197.2 154.859C1197.2 152.923 1195.63 151.357 1193.7 151.357Z"
            fill="white"
          />
          <path
            d="M1200.85 170.161C1202.82 170.161 1204.43 168.558 1204.43 166.58C1204.43 164.602 1202.82 162.998 1200.85 162.998C1198.87 162.998 1197.26 164.602 1197.26 166.58C1197.26 168.558 1198.87 170.161 1200.85 170.161Z"
            fill="white"
          />
          <path
            d="M1207.95 174.736C1205.96 174.736 1204.33 176.353 1204.33 178.365C1204.33 180.376 1205.96 181.985 1207.95 181.985C1209.95 181.985 1211.57 180.364 1211.57 178.365C1211.57 176.366 1209.95 174.736 1207.95 174.736Z"
            fill="white"
          />
          <path
            d="M1215.08 186.428C1213.05 186.428 1211.4 188.066 1211.4 190.09C1211.4 192.114 1213.05 193.765 1215.08 193.765C1217.1 193.765 1218.74 192.119 1218.74 190.09C1218.74 188.062 1217.09 186.428 1215.08 186.428Z"
            fill="white"
          />
          <path
            d="M1222.3 197.885C1220.25 197.885 1218.58 199.548 1218.58 201.602C1218.58 203.656 1220.24 205.307 1222.3 205.307C1224.35 205.307 1226 203.652 1226 201.602C1226 199.553 1224.35 197.885 1222.3 197.885Z"
            fill="white"
          />
          <path
            d="M1229.78 208.836C1227.69 208.836 1226 210.521 1226 212.604C1226 214.688 1227.69 216.373 1229.78 216.373C1231.87 216.373 1233.55 214.688 1233.55 212.604C1233.55 210.521 1231.86 208.836 1229.78 208.836Z"
            fill="white"
          />
          <path
            d="M1237.6 219.109C1235.5 219.109 1233.79 220.807 1233.79 222.908C1233.79 225.008 1235.49 226.718 1237.6 226.718C1239.7 226.718 1241.39 225.012 1241.39 222.908C1241.39 220.803 1239.69 219.109 1237.6 219.109Z"
            fill="white"
          />
          <path
            d="M1245.67 228.797C1243.56 228.797 1241.84 230.516 1241.84 232.625C1241.84 234.734 1243.56 236.465 1245.67 236.465C1247.78 236.465 1249.51 234.747 1249.51 232.625C1249.51 230.503 1247.79 228.797 1245.67 228.797Z"
            fill="white"
          />
          <path
            d="M1254.13 245.411C1256.28 245.411 1258.02 243.672 1258.02 241.528C1258.02 239.383 1256.28 237.645 1254.13 237.645C1251.99 237.645 1250.25 239.383 1250.25 241.528C1250.25 243.672 1251.99 245.411 1254.13 245.411Z"
            fill="white"
          />
          <path
            d="M1262.9 245.68C1260.73 245.68 1258.97 247.437 1258.97 249.614C1258.97 251.791 1260.73 253.539 1262.9 253.539C1265.06 253.539 1266.82 251.778 1266.82 249.614C1266.82 247.449 1265.06 245.68 1262.9 245.68Z"
            fill="white"
          />
          <path
            d="M1272.69 260.506C1274.85 260.156 1276.31 258.125 1275.96 255.969C1275.61 253.812 1273.58 252.348 1271.42 252.698C1269.27 253.048 1267.8 255.08 1268.15 257.236C1268.5 259.392 1270.54 260.856 1272.69 260.506Z"
            fill="white"
          />
          <path
            d="M1281.53 258.732C1279.33 258.732 1277.54 260.511 1277.54 262.717C1277.54 264.924 1279.33 266.702 1281.53 266.702C1283.72 266.702 1285.51 264.911 1285.51 262.717C1285.51 260.523 1283.73 258.732 1281.53 258.732Z"
            fill="white"
          />
          <path
            d="M1294.14 270.533C1295.71 268.964 1295.71 266.419 1294.14 264.85C1292.57 263.28 1290.03 263.28 1288.46 264.85C1286.89 266.419 1286.89 268.964 1288.46 270.533C1290.03 272.103 1292.57 272.103 1294.14 270.533Z"
            fill="white"
          />
          <path
            d="M1301.28 267.539C1299.05 267.539 1297.22 269.351 1297.22 271.596C1297.22 273.841 1299.04 275.666 1301.28 275.666C1303.52 275.666 1305.35 273.845 1305.35 271.596C1305.35 269.347 1303.53 267.539 1301.28 267.539Z"
            fill="white"
          />
          <path
            d="M1311.41 270.398C1309.15 270.398 1307.32 272.232 1307.32 274.489C1307.32 276.747 1309.15 278.568 1311.41 278.568C1313.67 278.568 1315.49 276.734 1315.49 274.489C1315.49 272.244 1313.65 270.398 1311.41 270.398Z"
            fill="white"
          />
          <path
            d="M1321.6 272.26C1319.33 272.26 1317.48 274.102 1317.48 276.38C1317.48 278.659 1319.33 280.493 1321.6 280.493C1323.87 280.493 1325.72 278.651 1325.72 276.38C1325.72 274.11 1323.88 272.26 1321.6 272.26Z"
            fill="white"
          />
          <path
            d="M1331.78 273.285C1329.5 273.285 1327.64 275.135 1327.64 277.419C1327.64 279.702 1329.5 281.552 1331.78 281.552C1334.06 281.552 1335.91 279.702 1335.91 277.419C1335.91 275.135 1334.07 273.285 1331.78 273.285Z"
            fill="white"
          />
          <path
            d="M1341.92 273.5C1339.62 273.5 1337.76 275.35 1337.76 277.655C1337.76 279.959 1339.62 281.809 1341.92 281.809C1344.21 281.809 1346.07 279.946 1346.07 277.655C1346.07 275.363 1344.21 273.5 1341.92 273.5Z"
            fill="white"
          />
          <path
            d="M1351.95 273.062C1349.65 273.062 1347.79 274.925 1347.79 277.217C1347.79 279.509 1349.64 281.372 1351.95 281.372C1354.25 281.372 1356.1 279.521 1356.1 277.217C1356.1 274.913 1354.24 273.062 1351.95 273.062Z"
            fill="white"
          />
          <path
            d="M1361.86 272.074C1359.57 272.074 1357.7 273.937 1357.7 276.229C1357.7 278.52 1359.57 280.383 1361.86 280.383C1364.15 280.383 1366.01 278.529 1366.01 276.229C1366.01 273.929 1364.16 272.074 1361.86 272.074Z"
            fill="white"
          />
          <path
            d="M1371.64 270.658C1369.35 270.658 1367.48 272.508 1367.48 274.813C1367.48 277.117 1369.35 278.967 1371.64 278.967C1373.93 278.967 1375.8 277.104 1375.8 274.813C1375.8 272.521 1373.94 270.658 1371.64 270.658Z"
            fill="white"
          />
          <path
            d="M1381.31 268.908C1379.01 268.908 1377.15 270.763 1377.15 273.063C1377.15 275.363 1379.01 277.217 1381.31 277.217C1383.61 277.217 1385.46 275.354 1385.46 273.063C1385.46 270.771 1383.6 268.908 1381.31 268.908Z"
            fill="white"
          />
          <path
            d="M1390.86 266.922C1388.57 266.922 1386.71 268.785 1386.71 271.077C1386.71 273.368 1388.57 275.231 1390.86 275.231C1393.16 275.231 1395.02 273.377 1395.02 271.077C1395.02 268.776 1393.17 266.922 1390.86 266.922Z"
            fill="white"
          />
          <path
            d="M1400.32 264.832C1398.03 264.832 1396.17 266.695 1396.17 268.987C1396.17 271.278 1398.03 273.141 1400.32 273.141C1402.61 273.141 1404.48 271.291 1404.48 268.987C1404.48 266.682 1402.62 264.832 1400.32 264.832Z"
            fill="white"
          />
          <path
            d="M1409.7 262.74C1407.4 262.74 1405.55 264.595 1405.55 266.895C1405.55 269.195 1407.4 271.05 1409.7 271.05C1412.01 271.05 1413.86 269.186 1413.86 266.895C1413.86 264.603 1411.99 262.74 1409.7 262.74Z"
            fill="white"
          />
          <path
            d="M1418.99 260.717C1416.7 260.717 1414.83 262.58 1414.83 264.88C1414.83 267.18 1416.7 269.035 1418.99 269.035C1421.28 269.035 1423.15 267.172 1423.15 264.88C1423.15 262.588 1421.29 260.717 1418.99 260.717Z"
            fill="white"
          />
          <path
            d="M1414.95 264.051C1412.66 264.051 1410.79 265.914 1410.79 268.205C1410.79 270.497 1412.66 272.36 1414.95 272.36C1417.24 272.36 1419.11 270.51 1419.11 268.205C1419.11 265.901 1417.25 264.051 1414.95 264.051Z"
            fill="white"
          />
          <path
            d="M1410.91 267.203C1408.61 267.203 1406.75 269.066 1406.75 271.358C1406.75 273.649 1408.61 275.512 1410.91 275.512C1413.2 275.512 1415.07 273.662 1415.07 271.358C1415.07 269.053 1413.21 267.203 1410.91 267.203Z"
            fill="white"
          />
          <path
            d="M1406.76 270.242C1404.47 270.242 1402.61 272.105 1402.61 274.397C1402.61 276.688 1404.47 278.551 1406.76 278.551C1409.06 278.551 1410.93 276.701 1410.93 274.397C1410.93 272.092 1409.07 270.242 1406.76 270.242Z"
            fill="white"
          />
          <path
            d="M1402.43 273.242C1400.14 273.242 1398.27 275.097 1398.27 277.397C1398.27 279.697 1400.14 281.551 1402.43 281.551C1404.72 281.551 1406.58 279.688 1406.58 277.397C1406.58 275.105 1404.73 273.242 1402.43 273.242Z"
            fill="white"
          />
          <path
            d="M1397.81 276.23C1395.51 276.23 1393.66 278.093 1393.66 280.385C1393.66 282.677 1395.51 284.54 1397.81 284.54C1400.11 284.54 1401.96 282.685 1401.96 280.385C1401.96 278.085 1400.1 276.23 1397.81 276.23Z"
            fill="white"
          />
          <path
            d="M1392.81 279.266C1390.52 279.266 1388.66 281.129 1388.66 283.42C1388.66 285.712 1390.52 287.575 1392.81 287.575C1395.09 287.575 1396.96 285.72 1396.96 283.42C1396.96 281.12 1395.11 279.266 1392.81 279.266Z"
            fill="white"
          />
          <path
            d="M1387.39 282.4C1385.1 282.4 1383.23 284.263 1383.23 286.555C1383.23 288.847 1385.1 290.71 1387.39 290.71C1389.68 290.71 1391.54 288.847 1391.54 286.555C1391.54 284.263 1389.68 282.4 1387.39 282.4Z"
            fill="white"
          />
          <path
            d="M1381.46 285.637C1379.18 285.637 1377.31 287.5 1377.31 289.791C1377.31 292.083 1379.17 293.946 1381.46 293.946C1383.75 293.946 1385.62 292.083 1385.62 289.791C1385.62 287.5 1383.77 285.637 1381.46 285.637Z"
            fill="white"
          />
          <path
            d="M1375 288.986C1372.71 288.986 1370.85 290.849 1370.85 293.141C1370.85 295.433 1372.71 297.296 1375 297.296C1377.29 297.296 1379.15 295.433 1379.15 293.141C1379.15 290.849 1377.3 288.986 1375 288.986Z"
            fill="white"
          />
          <path
            d="M1367.96 292.424C1365.66 292.424 1363.8 294.287 1363.8 296.587C1363.8 298.887 1365.66 300.742 1367.96 300.742C1370.26 300.742 1372.12 298.879 1372.12 296.587C1372.12 294.295 1370.26 292.424 1367.96 292.424Z"
            fill="white"
          />
          <path
            d="M1360.31 295.957C1358.02 295.957 1356.15 297.82 1356.15 300.112C1356.15 302.403 1358.01 304.266 1360.31 304.266C1362.6 304.266 1364.46 302.416 1364.46 300.112C1364.46 297.807 1362.61 295.957 1360.31 295.957Z"
            fill="white"
          />
          <path
            d="M1352.03 299.539C1349.74 299.539 1347.88 301.402 1347.88 303.694C1347.88 305.985 1349.74 307.848 1352.03 307.848C1354.32 307.848 1356.19 305.994 1356.19 303.694C1356.19 301.394 1354.33 299.539 1352.03 299.539Z"
            fill="white"
          />
          <path
            d="M1343.13 303.08C1340.83 303.08 1338.98 304.943 1338.98 307.23C1338.98 309.518 1340.83 311.385 1343.13 311.385C1345.44 311.385 1347.29 309.535 1347.29 307.23C1347.29 304.926 1345.42 303.08 1343.13 303.08Z"
            fill="white"
          />
          <path
            d="M1333.63 306.477C1331.34 306.477 1329.47 308.34 1329.47 310.631C1329.47 312.923 1331.34 314.773 1333.63 314.773C1335.92 314.773 1337.77 312.923 1337.77 310.631C1337.77 308.34 1335.92 306.477 1333.63 306.477Z"
            fill="white"
          />
          <path
            d="M1323.57 309.607C1321.3 309.607 1319.45 311.449 1319.45 313.72C1319.45 315.99 1321.3 317.84 1323.57 317.84C1325.84 317.84 1327.69 315.999 1327.69 313.72C1327.69 311.441 1325.84 309.607 1323.57 309.607Z"
            fill="white"
          />
          <path
            d="M1313 312.408C1310.75 312.408 1308.91 314.242 1308.91 316.499C1308.91 318.757 1310.75 320.577 1313 320.577C1315.26 320.577 1317.08 318.744 1317.08 316.499C1317.08 314.254 1315.25 312.408 1313 312.408Z"
            fill="white"
          />
          <path
            d="M1301.97 314.801C1299.72 314.801 1297.91 316.621 1297.91 318.858C1297.91 321.094 1299.72 322.915 1301.97 322.915C1304.21 322.915 1306.03 321.103 1306.03 318.858C1306.03 316.613 1304.21 314.801 1301.97 314.801Z"
            fill="white"
          />
          <path
            d="M1290.5 316.693C1288.27 316.693 1286.47 318.493 1286.47 320.721C1286.47 322.949 1288.27 324.748 1290.5 324.748C1292.73 324.748 1294.53 322.949 1294.53 320.721C1294.53 318.493 1292.73 316.693 1290.5 316.693Z"
            fill="white"
          />
          <path
            d="M1278.6 317.953C1276.4 317.953 1274.61 319.752 1274.61 321.959C1274.61 324.166 1276.4 325.957 1278.6 325.957C1280.81 325.957 1282.6 324.166 1282.6 321.959C1282.6 319.752 1280.81 317.953 1278.6 317.953Z"
            fill="white"
          />
          <path
            d="M1266.41 318.598C1264.22 318.598 1262.44 320.376 1262.44 322.561C1262.44 324.747 1264.22 326.538 1266.41 326.538C1268.59 326.538 1270.38 324.76 1270.38 322.561C1270.38 320.363 1268.61 318.598 1266.41 318.598Z"
            fill="white"
          />
          <path
            d="M1253.96 318.672C1251.78 318.672 1250.02 320.433 1250.02 322.606C1250.02 324.779 1251.78 326.54 1253.96 326.54C1256.13 326.54 1257.9 324.779 1257.9 322.606C1257.9 320.433 1256.13 318.672 1253.96 318.672Z"
            fill="white"
          />
          <path
            d="M1241.29 318.141C1239.14 318.141 1237.4 319.889 1237.4 322.045C1237.4 324.201 1239.14 325.936 1241.29 325.936C1243.44 325.936 1245.2 324.188 1245.2 322.045C1245.2 319.902 1243.45 318.141 1241.29 318.141Z"
            fill="white"
          />
          <path
            d="M1228.55 317.016C1226.42 317.016 1224.68 318.743 1224.68 320.877C1224.68 323.012 1226.42 324.748 1228.55 324.748C1230.69 324.748 1232.41 323.008 1232.41 320.877C1232.41 318.747 1230.69 317.016 1228.55 317.016Z"
            fill="white"
          />
          <path
            d="M1215.79 315.52C1213.69 315.52 1211.98 317.217 1211.98 319.318C1211.98 321.418 1213.69 323.129 1215.79 323.129C1217.9 323.129 1219.6 321.423 1219.6 319.318C1219.6 317.213 1217.9 315.52 1215.79 315.52Z"
            fill="white"
          />
          <path
            d="M1202.98 313.791C1200.9 313.791 1199.2 315.476 1199.2 317.559C1199.2 319.643 1200.9 321.336 1202.98 321.336C1205.06 321.336 1206.76 319.652 1206.76 317.559C1206.76 315.467 1205.06 313.791 1202.98 313.791Z"
            fill="white"
          />
          <path
            d="M1190.15 312.002C1188.08 312.002 1186.41 313.665 1186.41 315.728C1186.41 317.79 1188.08 319.467 1190.15 319.467C1192.21 319.467 1193.88 317.803 1193.88 315.728C1193.88 313.653 1192.21 312.002 1190.15 312.002Z"
            fill="white"
          />
          <path
            d="M1177.33 310.281C1175.29 310.281 1173.65 311.936 1173.65 313.978C1173.65 316.019 1175.3 317.661 1177.33 317.661C1179.37 317.661 1181.03 316.006 1181.03 313.978C1181.03 311.949 1179.38 310.281 1177.33 310.281Z"
            fill="white"
          />
          <path
            d="M1164.49 308.754C1162.48 308.754 1160.86 310.379 1160.86 312.387C1160.86 314.394 1162.48 316.019 1164.49 316.019C1166.5 316.019 1168.12 314.394 1168.12 312.387C1168.12 310.379 1166.49 308.754 1164.49 308.754Z"
            fill="white"
          />
          <path
            d="M1151.65 307.471C1149.67 307.471 1148.06 309.083 1148.06 311.061C1148.06 313.038 1149.67 314.643 1151.65 314.643C1153.62 314.643 1155.23 313.038 1155.23 311.061C1155.23 309.083 1153.62 307.471 1151.65 307.471Z"
            fill="white"
          />
          <path
            d="M1138.84 306.557C1136.89 306.557 1135.3 308.148 1135.3 310.096C1135.3 312.044 1136.89 313.644 1138.84 313.644C1140.78 313.644 1142.38 312.052 1142.38 310.096C1142.38 308.14 1140.79 306.557 1138.84 306.557Z"
            fill="white"
          />
          <path
            d="M1125.95 306.066C1124.03 306.066 1122.46 307.637 1122.46 309.576C1122.46 311.515 1124.03 313.073 1125.95 313.073C1127.88 313.073 1129.46 311.503 1129.46 309.576C1129.46 307.649 1127.89 306.066 1125.95 306.066Z"
            fill="white"
          />
          <path
            d="M1112.98 306.16C1111.09 306.16 1109.55 307.701 1109.55 309.585C1109.55 311.469 1111.09 313.018 1112.98 313.018C1114.88 313.018 1116.41 311.478 1116.41 309.585C1116.41 307.692 1114.88 306.16 1112.98 306.16Z"
            fill="white"
          />
          <path
            d="M1099.89 306.855C1098.03 306.855 1096.52 308.366 1096.52 310.229C1096.52 312.092 1098.03 313.612 1099.89 313.612C1101.75 313.612 1103.27 312.101 1103.27 310.229C1103.27 308.358 1101.75 306.855 1099.89 306.855Z"
            fill="white"
          />
          <path
            d="M1086.51 308.24C1084.68 308.24 1083.2 309.738 1083.2 311.572C1083.2 313.405 1084.69 314.903 1086.51 314.903C1088.34 314.903 1089.85 313.413 1089.85 311.572C1089.85 309.73 1088.36 308.24 1086.51 308.24Z"
            fill="white"
          />
          <path
            d="M1072.9 310.561C1071.09 310.561 1069.62 312.029 1069.62 313.841C1069.62 315.653 1071.09 317.121 1072.9 317.121C1074.71 317.121 1076.18 315.653 1076.18 313.841C1076.18 312.029 1074.71 310.561 1072.9 310.561Z"
            fill="white"
          />
          <path
            d="M1059.02 314.051C1057.25 314.051 1055.81 315.489 1055.81 317.255C1055.81 319.02 1057.25 320.459 1059.02 320.459C1060.79 320.459 1062.22 319.02 1062.22 317.255C1062.22 315.489 1060.79 314.051 1059.02 314.051Z"
            fill="white"
          />
          <path
            d="M1044.7 318.828C1042.96 318.828 1041.55 320.233 1041.55 321.973C1041.55 323.713 1042.96 325.117 1044.7 325.117C1046.44 325.117 1047.84 323.713 1047.84 321.973C1047.84 320.233 1046.44 318.828 1044.7 318.828Z"
            fill="white"
          />
          <path
            d="M1030.14 325.385C1028.43 325.385 1027.05 326.768 1027.05 328.474C1027.05 330.18 1028.43 331.564 1030.14 331.564C1031.84 331.564 1033.23 330.18 1033.23 328.474C1033.23 326.768 1031.84 325.385 1030.14 325.385Z"
            fill="white"
          />
          <path
            d="M1015.37 334.113C1013.7 334.113 1012.34 335.467 1012.34 337.143C1012.34 338.82 1013.7 340.182 1015.37 340.182C1017.04 340.182 1018.41 338.82 1018.41 337.143C1018.41 335.467 1017.04 334.113 1015.37 334.113Z"
            fill="white"
          />
          <path
            d="M1000.92 345.598C999.288 345.598 997.964 346.917 997.964 348.556C997.964 350.194 999.288 351.509 1000.92 351.509C1002.56 351.509 1003.87 350.189 1003.87 348.556C1003.87 346.922 1002.54 345.598 1000.92 345.598Z"
            fill="white"
          />
          <path
            d="M987.18 360.197C985.576 360.197 984.286 361.5 984.286 363.1C984.286 364.7 985.576 365.994 987.18 365.994C988.785 365.994 990.083 364.704 990.083 363.1C990.083 361.496 988.78 360.197 987.18 360.197Z"
            fill="white"
          />
          <path
            d="M975.371 378.631C973.801 378.631 972.527 379.9 972.527 381.474C972.527 383.049 973.796 384.317 975.371 384.317C976.945 384.317 978.214 383.049 978.214 381.474C978.214 379.9 976.945 378.631 975.371 378.631Z"
            fill="white"
          />
          <path
            d="M966.127 400.844C964.595 400.844 963.348 402.091 963.348 403.632C963.348 405.172 964.595 406.412 966.127 406.412C967.659 406.412 968.915 405.164 968.915 403.632C968.915 402.1 967.668 400.844 966.127 400.844Z"
            fill="white"
          />
          <path
            d="M961.278 427.32C959.788 427.32 958.583 428.53 958.583 430.015C958.583 431.5 959.792 432.71 961.278 432.71C962.763 432.71 963.964 431.505 963.964 430.015C963.964 428.526 962.755 427.32 961.278 427.32Z"
            fill="white"
          />
          <path
            d="M962.423 457.709C960.968 457.709 959.792 458.884 959.792 460.344C959.792 461.804 960.968 462.975 962.423 462.975C963.879 462.975 965.059 461.8 965.059 460.344C965.059 458.889 963.883 457.709 962.423 457.709Z"
            fill="white"
          />
          <path
            d="M969.917 491.242C968.491 491.242 967.337 492.397 967.337 493.822C967.337 495.248 968.491 496.403 969.917 496.403C971.343 496.403 972.497 495.248 972.497 493.822C972.497 492.397 971.343 491.242 969.917 491.242Z"
            fill="white"
          />
          <path
            d="M982.573 527.465C981.176 527.465 980.052 528.598 980.052 529.981C980.052 531.365 981.176 532.511 982.573 532.511C983.969 532.511 985.089 531.378 985.089 529.981C985.089 528.585 983.956 527.465 982.573 527.465Z"
            fill="white"
          />
          <path
            d="M997.455 566.451C996.114 566.451 995.02 567.546 995.02 568.887C995.02 570.228 996.114 571.323 997.455 571.323C998.796 571.323 999.891 570.232 999.891 568.887C999.891 567.542 998.796 566.451 997.455 566.451Z"
            fill="white"
          />
          <path
            d="M1011.09 608.438C1009.78 608.438 1008.71 609.511 1008.71 610.822C1008.71 612.134 1009.78 613.195 1011.09 613.195C1012.4 613.195 1013.46 612.134 1013.46 610.822C1013.46 609.511 1012.4 608.438 1011.09 608.438Z"
            fill="white"
          />
          <path
            d="M1021.87 654.615C1020.59 654.615 1019.55 655.655 1019.55 656.945C1019.55 658.235 1020.59 659.266 1021.87 659.266C1023.15 659.266 1024.2 658.227 1024.2 656.945C1024.2 655.663 1023.16 654.615 1021.87 654.615Z"
            fill="white"
          />
          <path
            d="M194.33 669.781C193.443 669.781 192.738 670.49 192.738 671.373C192.738 672.255 193.447 672.964 194.33 672.964C195.212 672.964 195.921 672.247 195.921 671.373C195.921 670.498 195.204 669.781 194.33 669.781Z"
            fill="white"
          />
          <path
            d="M170.141 656.219C169.259 656.219 168.537 656.936 168.537 657.823C168.537 658.71 169.254 659.414 170.141 659.414C171.028 659.414 171.733 658.697 171.733 657.823C171.733 656.949 171.015 656.219 170.141 656.219Z"
            fill="white"
          />
          <path
            d="M145.09 643.566C144.207 643.566 143.485 644.284 143.485 645.171C143.485 646.057 144.203 646.775 145.09 646.775C145.976 646.775 146.694 646.057 146.694 645.171C146.694 644.284 145.976 643.566 145.09 643.566Z"
            fill="white"
          />
          <path
            d="M118.54 630.668C117.645 630.668 116.928 631.385 116.928 632.272C116.928 633.159 117.645 633.885 118.54 633.885C119.436 633.885 120.144 633.168 120.144 632.272C120.144 631.377 119.427 630.668 118.54 630.668Z"
            fill="white"
          />
          <path
            d="M89.6364 616.191C88.7537 616.191 88.0322 616.909 88.0322 617.804C88.0322 618.699 88.7494 619.408 89.6364 619.408C90.5233 619.408 91.249 618.691 91.249 617.804C91.249 616.917 90.5318 616.191 89.6364 616.191Z"
            fill="white"
          />
          <path
            d="M57.808 598.852C56.9125 598.852 56.1826 599.581 56.1826 600.473C56.1826 601.364 56.9125 602.107 57.808 602.107C58.7034 602.107 59.4333 601.377 59.4333 600.473C59.4333 599.569 58.7034 598.852 57.808 598.852Z"
            fill="white"
          />
          <path
            d="M32.4048 574.08C31.4881 574.08 30.7412 574.831 30.7412 575.744C30.7412 576.656 31.4924 577.399 32.4048 577.399C33.3172 577.399 34.0683 576.66 34.0683 575.744C34.0683 574.827 33.3172 574.08 32.4048 574.08Z"
            fill="white"
          />
          <path
            d="M8.71605 551.008C7.77819 551.008 7.01855 551.767 7.01855 552.693C7.01855 553.618 7.77819 554.39 8.71605 554.39C9.65392 554.39 10.4136 553.63 10.4136 552.693C10.4136 551.755 9.65392 551.008 8.71605 551.008Z"
            fill="white"
          />
          <path
            d="M1113.03 2.22852C1111.52 2.22852 1110.3 3.45496 1110.3 4.97422C1110.3 6.49348 1111.52 7.72417 1113.03 7.72417C1114.54 7.72417 1115.78 6.49773 1115.78 4.97422C1115.78 3.45072 1114.55 2.22852 1113.03 2.22852Z"
            fill="white"
          />
          <path
            d="M1119.79 14.5C1118.25 14.5 1117 15.7519 1117 17.3009C1117 18.8498 1118.25 20.089 1119.79 20.089C1121.33 20.089 1122.59 18.8414 1122.59 17.3009C1122.59 15.7604 1121.34 14.5 1119.79 14.5Z"
            fill="white"
          />
          <path
            d="M1126.74 26.4062C1125.15 26.4062 1123.86 27.7006 1123.86 29.2962C1123.86 30.8919 1125.15 32.1862 1126.74 32.1862C1128.33 32.1862 1129.62 30.8919 1129.62 29.2962C1129.62 27.7006 1128.33 26.4062 1126.74 26.4062Z"
            fill="white"
          />
          <path
            d="M1133.88 38.0527C1132.26 38.0527 1130.94 39.3641 1130.94 40.9894C1130.94 42.6148 1132.26 43.9261 1133.88 43.9261C1135.51 43.9261 1136.82 42.6148 1136.82 40.9894C1136.82 39.3641 1135.51 38.0527 1133.88 38.0527Z"
            fill="white"
          />
          <path
            d="M1141.2 49.373C1139.54 49.373 1138.2 50.7141 1138.2 52.3776C1138.2 54.0412 1139.54 55.3737 1141.2 55.3737C1142.85 55.3737 1144.2 54.0327 1144.2 52.3776C1144.2 50.7226 1142.85 49.373 1141.2 49.373Z"
            fill="white"
          />
          <path
            d="M1148.64 60.5156C1146.94 60.5156 1145.58 61.8906 1145.58 63.5754C1145.58 65.2601 1146.94 66.6351 1148.64 66.6351C1150.34 66.6351 1151.7 65.2644 1151.7 63.5754C1151.7 61.8864 1150.32 60.5156 1148.64 60.5156Z"
            fill="white"
          />
          <path
            d="M1156.2 71.4512C1154.46 71.4512 1153.06 72.8559 1153.06 74.5831C1153.06 76.3103 1154.46 77.7192 1156.2 77.7192C1157.93 77.7192 1159.33 76.3188 1159.33 74.5831C1159.33 72.8474 1157.92 71.4512 1156.2 71.4512Z"
            fill="white"
          />
          <path
            d="M1163.81 82.334C1162.05 82.334 1160.62 83.7641 1160.62 85.5253C1160.62 87.2864 1162.05 88.7208 1163.81 88.7208C1165.56 88.7208 1167 87.2949 1167 85.5253C1167 83.7556 1165.58 82.334 1163.81 82.334Z"
            fill="white"
          />
          <path
            d="M1171.44 93.2266C1169.65 93.2266 1168.21 94.6737 1168.21 96.4645C1168.21 98.2554 1169.65 99.7025 1171.44 99.7025C1173.24 99.7025 1174.68 98.2469 1174.68 96.4645C1174.68 94.6822 1173.23 93.2266 1171.44 93.2266Z"
            fill="white"
          />
          <path
            d="M1179.02 104.184C1177.2 104.184 1175.73 105.66 1175.73 107.485C1175.73 109.31 1177.2 110.783 1179.02 110.783C1180.84 110.783 1182.32 109.306 1182.32 107.485C1182.32 105.665 1180.84 104.184 1179.02 104.184Z"
            fill="white"
          />
          <path
            d="M1186.51 115.303C1184.66 115.303 1183.15 116.814 1183.15 118.677C1183.15 120.54 1184.66 122.05 1186.51 122.05C1188.36 122.05 1189.89 120.54 1189.89 118.677C1189.89 116.814 1188.38 115.303 1186.51 115.303Z"
            fill="white"
          />
          <path
            d="M1193.94 126.582C1192.05 126.582 1190.52 128.114 1190.52 129.994C1190.52 131.874 1192.06 133.406 1193.94 133.406C1195.82 133.406 1197.35 131.874 1197.35 129.994C1197.35 128.114 1195.82 126.582 1193.94 126.582Z"
            fill="white"
          />
          <path
            d="M1201.26 138.02C1199.35 138.02 1197.79 139.573 1197.79 141.474C1197.79 143.375 1199.35 144.941 1201.26 144.941C1203.17 144.941 1204.72 143.392 1204.72 141.474C1204.72 139.556 1203.17 138.02 1201.26 138.02Z"
            fill="white"
          />
          <path
            d="M1208.48 149.605C1206.54 149.605 1204.97 151.176 1204.97 153.111C1204.97 155.046 1206.54 156.629 1208.48 156.629C1210.43 156.629 1212 155.059 1212 153.111C1212 151.163 1210.43 149.605 1208.48 149.605Z"
            fill="white"
          />
          <path
            d="M1215.61 161.314C1213.64 161.314 1212.04 162.919 1212.04 164.896C1212.04 166.874 1213.64 168.465 1215.61 168.465C1217.59 168.465 1219.2 166.861 1219.2 164.896C1219.2 162.931 1217.59 161.314 1215.61 161.314Z"
            fill="white"
          />
          <path
            d="M1222.7 180.329C1224.7 180.329 1226.32 178.71 1226.32 176.713C1226.32 174.716 1224.7 173.098 1222.7 173.098C1220.7 173.098 1219.08 174.716 1219.08 176.713C1219.08 178.71 1220.7 180.329 1222.7 180.329Z"
            fill="white"
          />
          <path
            d="M1229.81 184.785C1227.78 184.785 1226.14 186.432 1226.14 188.46C1226.14 190.489 1227.78 192.123 1229.81 192.123C1231.84 192.123 1233.48 190.476 1233.48 188.46C1233.48 186.444 1231.83 184.785 1229.81 184.785Z"
            fill="white"
          />
          <path
            d="M1237.04 196.221C1234.99 196.221 1233.34 197.876 1233.34 199.925C1233.34 201.975 1234.99 203.643 1237.04 203.643C1239.09 203.643 1240.76 201.979 1240.76 199.925C1240.76 197.872 1239.09 196.221 1237.04 196.221Z"
            fill="white"
          />
          <path
            d="M1244.54 207.1C1242.46 207.1 1240.77 208.784 1240.77 210.868C1240.77 212.952 1242.46 214.645 1244.54 214.645C1246.62 214.645 1248.32 212.96 1248.32 210.868C1248.32 208.776 1246.62 207.1 1244.54 207.1Z"
            fill="white"
          />
          <path
            d="M1252.39 217.236C1250.28 217.236 1248.59 218.942 1248.59 221.047C1248.59 223.152 1250.28 224.845 1252.39 224.845C1254.49 224.845 1256.2 223.139 1256.2 221.047C1256.2 218.955 1254.49 217.236 1252.39 217.236Z"
            fill="white"
          />
          <path
            d="M1260.53 226.684C1258.4 226.684 1256.69 228.402 1256.69 230.524C1256.69 232.646 1258.4 234.365 1260.53 234.365C1262.65 234.365 1264.38 232.646 1264.38 230.524C1264.38 228.402 1262.65 226.684 1260.53 226.684Z"
            fill="white"
          />
          <path
            d="M1269.05 235.209C1266.91 235.209 1265.18 236.949 1265.18 239.092C1265.18 241.235 1266.91 242.962 1269.05 242.962C1271.18 242.962 1272.93 241.222 1272.93 239.092C1272.93 236.962 1271.19 235.209 1269.05 235.209Z"
            fill="white"
          />
          <path
            d="M1277.9 242.826C1275.73 242.826 1273.97 244.587 1273.97 246.752C1273.97 248.916 1275.73 250.677 1277.9 250.677C1280.06 250.677 1281.82 248.916 1281.82 246.752C1281.82 244.587 1280.06 242.826 1277.9 242.826Z"
            fill="white"
          />
          <path
            d="M1287.12 249.383C1284.93 249.383 1283.16 251.152 1283.16 253.338C1283.16 255.523 1284.93 257.293 1287.12 257.293C1289.3 257.293 1291.08 255.523 1291.08 253.338C1291.08 251.152 1289.3 249.383 1287.12 249.383Z"
            fill="white"
          />
          <path
            d="M1296.62 254.9C1294.42 254.9 1292.63 256.691 1292.63 258.885C1292.63 261.079 1294.42 262.87 1296.62 262.87C1298.81 262.87 1300.6 261.092 1300.6 258.885C1300.6 256.679 1298.82 254.9 1296.62 254.9Z"
            fill="white"
          />
          <path
            d="M1306.37 259.326C1304.16 259.326 1302.37 261.117 1302.37 263.345C1302.37 265.573 1304.16 267.351 1306.37 267.351C1308.59 267.351 1310.39 265.56 1310.39 263.345C1310.39 261.13 1308.6 259.326 1306.37 259.326Z"
            fill="white"
          />
          <path
            d="M1316.3 262.645C1314.05 262.645 1312.23 264.465 1312.23 266.714C1312.23 268.963 1314.05 270.784 1316.3 270.784C1318.55 270.784 1320.36 268.963 1320.36 266.714C1320.36 264.465 1318.54 262.645 1316.3 262.645Z"
            fill="white"
          />
          <path
            d="M1326.29 265.031C1324.03 265.031 1322.21 266.865 1322.21 269.109C1322.21 271.354 1324.03 273.2 1326.29 273.2C1328.55 273.2 1330.37 271.367 1330.37 269.109C1330.37 266.852 1328.55 265.031 1326.29 265.031Z"
            fill="white"
          />
          <path
            d="M1336.33 266.457C1334.06 266.457 1332.21 268.299 1332.21 270.569C1332.21 272.84 1334.06 274.69 1336.33 274.69C1338.6 274.69 1340.44 272.848 1340.44 270.569C1340.44 268.29 1338.6 266.457 1336.33 266.457Z"
            fill="white"
          />
          <path
            d="M1346.31 267.111C1344.03 267.111 1342.18 268.962 1342.18 271.245C1342.18 273.528 1344.03 275.378 1346.31 275.378C1348.59 275.378 1350.44 273.528 1350.44 271.245C1350.44 268.962 1348.6 267.111 1346.31 267.111Z"
            fill="white"
          />
          <path
            d="M1356.23 267.047C1353.93 267.047 1352.08 268.91 1352.08 271.201C1352.08 273.493 1353.93 275.356 1356.23 275.356C1358.54 275.356 1360.39 273.493 1360.39 271.201C1360.39 268.91 1358.53 267.047 1356.23 267.047Z"
            fill="white"
          />
          <path
            d="M1366.05 266.445C1363.75 266.445 1361.9 268.308 1361.9 270.596C1361.9 272.883 1363.75 274.75 1366.05 274.75C1368.35 274.75 1370.2 272.9 1370.2 270.596C1370.2 268.291 1368.34 266.445 1366.05 266.445Z"
            fill="white"
          />
          <path
            d="M1375.76 265.391C1373.46 265.391 1371.61 267.241 1371.61 269.545C1371.61 271.85 1373.46 273.7 1375.76 273.7C1378.06 273.7 1379.91 271.837 1379.91 269.545C1379.91 267.254 1378.05 265.391 1375.76 265.391Z"
            fill="white"
          />
          <path
            d="M1385.38 264C1383.08 264 1381.22 265.85 1381.22 268.155C1381.22 270.459 1383.08 272.309 1385.38 272.309C1387.68 272.309 1389.53 270.446 1389.53 268.155C1389.53 265.863 1387.67 264 1385.38 264Z"
            fill="white"
          />
          <path
            d="M1394.91 262.373C1392.61 262.373 1390.75 264.223 1390.75 266.528C1390.75 268.832 1392.61 270.682 1394.91 270.682C1397.21 270.682 1399.07 268.819 1399.07 266.528C1399.07 264.236 1397.2 262.373 1394.91 262.373Z"
            fill="white"
          />
          <path
            d="M1404.37 260.625C1402.07 260.625 1400.22 262.488 1400.22 264.78C1400.22 267.071 1402.07 268.93 1404.37 268.93C1406.68 268.93 1408.53 267.067 1408.53 264.78C1408.53 262.492 1406.66 260.625 1404.37 260.625Z"
            fill="white"
          />
          <path
            d="M1413.77 258.869C1411.48 258.869 1409.62 260.732 1409.62 263.024C1409.62 265.315 1411.48 267.178 1413.77 267.178C1416.06 267.178 1417.93 265.315 1417.93 263.024C1417.93 260.732 1416.08 258.869 1413.77 258.869Z"
            fill="white"
          />
          <path
            d="M1423.14 257.18C1420.84 257.18 1418.98 259.043 1418.98 261.334C1418.98 263.626 1420.83 265.489 1423.14 265.489C1425.44 265.489 1427.29 263.626 1427.29 261.334C1427.29 259.043 1425.43 257.18 1423.14 257.18Z"
            fill="white"
          />
          <path
            d="M1432.46 255.652C1430.16 255.652 1428.31 257.503 1428.31 259.807C1428.31 262.111 1430.16 263.962 1432.46 263.962C1434.77 263.962 1436.62 262.099 1436.62 259.807C1436.62 257.515 1434.76 255.652 1432.46 255.652Z"
            fill="white"
          />
          <path
            d="M1428.2 258.869C1425.91 258.869 1424.05 260.732 1424.05 263.032C1424.05 265.332 1425.91 267.187 1428.2 267.187C1430.5 267.187 1432.36 265.324 1432.36 263.032C1432.36 260.741 1430.51 258.869 1428.2 258.869Z"
            fill="white"
          />
          <path
            d="M1424 261.949C1421.7 261.949 1419.85 263.812 1419.85 266.104C1419.85 268.395 1421.7 270.258 1424 270.258C1426.31 270.258 1428.16 268.404 1428.16 266.104C1428.16 263.804 1426.29 261.949 1424 261.949Z"
            fill="white"
          />
          <path
            d="M1419.72 264.924C1417.42 264.924 1415.57 266.787 1415.57 269.078C1415.57 271.37 1417.42 273.233 1419.72 273.233C1422.03 273.233 1423.88 271.379 1423.88 269.078C1423.88 266.778 1422.02 264.924 1419.72 264.924Z"
            fill="white"
          />
          <path
            d="M1415.29 267.85C1412.99 267.85 1411.13 269.713 1411.13 272.004C1411.13 274.296 1412.99 276.159 1415.29 276.159C1417.59 276.159 1419.44 274.296 1419.44 272.004C1419.44 269.713 1417.58 267.85 1415.29 267.85Z"
            fill="white"
          />
          <path
            d="M1410.6 270.771C1408.3 270.771 1406.44 272.635 1406.44 274.922C1406.44 277.209 1408.3 279.077 1410.6 279.077C1412.9 279.077 1414.75 277.226 1414.75 274.922C1414.75 272.618 1412.89 270.771 1410.6 270.771Z"
            fill="white"
          />
          <path
            d="M1405.56 273.771C1403.27 273.771 1401.4 275.635 1401.4 277.922C1401.4 280.209 1403.27 282.077 1405.56 282.077C1407.85 282.077 1409.71 280.214 1409.71 277.922C1409.71 275.63 1407.85 273.771 1405.56 273.771Z"
            fill="white"
          />
          <path
            d="M1400.12 276.885C1397.82 276.885 1395.96 278.739 1395.96 281.039C1395.96 283.339 1397.82 285.194 1400.12 285.194C1402.42 285.194 1404.27 283.331 1404.27 281.039C1404.27 278.748 1402.41 276.885 1400.12 276.885Z"
            fill="white"
          />
          <path
            d="M1394.19 280.143C1391.9 280.143 1390.04 282.006 1390.04 284.297C1390.04 286.589 1391.9 288.452 1394.19 288.452C1396.49 288.452 1398.35 286.589 1398.35 284.297C1398.35 282.006 1396.49 280.143 1394.19 280.143Z"
            fill="white"
          />
          <path
            d="M1387.74 283.564C1385.45 283.564 1383.58 285.427 1383.58 287.719C1383.58 290.011 1385.45 291.874 1387.74 291.874C1390.03 291.874 1391.89 290.023 1391.89 287.719C1391.89 285.415 1390.04 283.564 1387.74 283.564Z"
            fill="white"
          />
          <path
            d="M1380.72 287.158C1378.42 287.158 1376.57 289.021 1376.57 291.313C1376.57 293.604 1378.42 295.467 1380.72 295.467C1383.03 295.467 1384.88 293.613 1384.88 291.313C1384.88 289.013 1383.02 287.158 1380.72 287.158Z"
            fill="white"
          />
          <path
            d="M1373.11 290.883C1370.82 290.883 1368.95 292.733 1368.95 295.037C1368.95 297.342 1370.82 299.192 1373.11 299.192C1375.4 299.192 1377.27 297.329 1377.27 295.037C1377.27 292.746 1375.41 290.883 1373.11 290.883Z"
            fill="white"
          />
          <path
            d="M1364.9 294.68C1362.6 294.68 1360.74 296.543 1360.74 298.834C1360.74 301.126 1362.59 302.997 1364.9 302.997C1367.2 302.997 1369.05 301.134 1369.05 298.834C1369.05 296.534 1367.19 294.68 1364.9 294.68Z"
            fill="white"
          />
          <path
            d="M1356.06 298.553C1353.76 298.553 1351.91 300.416 1351.91 302.707C1351.91 304.999 1353.76 306.862 1356.06 306.862C1358.37 306.862 1360.22 305.012 1360.22 302.707C1360.22 300.403 1358.35 298.553 1356.06 298.553Z"
            fill="white"
          />
          <path
            d="M1346.6 302.393C1344.31 302.393 1342.46 304.247 1342.46 306.547C1342.46 308.847 1344.31 310.689 1346.6 310.689C1348.88 310.689 1350.75 308.835 1350.75 306.547C1350.75 304.26 1348.9 302.393 1346.6 302.393Z"
            fill="white"
          />
          <path
            d="M1336.56 306.098C1334.28 306.098 1332.43 307.939 1332.43 310.21C1332.43 312.48 1334.28 314.331 1336.56 314.331C1338.83 314.331 1340.68 312.489 1340.68 310.21C1340.68 307.931 1338.83 306.098 1336.56 306.098Z"
            fill="white"
          />
          <path
            d="M1325.97 317.66C1328.23 317.66 1330.06 315.829 1330.06 313.569C1330.06 311.31 1328.23 309.479 1325.97 309.479C1323.71 309.479 1321.88 311.31 1321.88 313.569C1321.88 315.829 1323.71 317.66 1325.97 317.66Z"
            fill="white"
          />
          <path
            d="M1314.9 312.48C1312.67 312.48 1310.85 314.301 1310.85 316.537C1310.85 318.774 1312.67 320.599 1314.9 320.599C1317.14 320.599 1318.96 318.787 1318.96 316.537C1318.96 314.288 1317.15 312.48 1314.9 312.48Z"
            fill="white"
          />
          <path
            d="M1303.38 315.039C1301.15 315.039 1299.34 316.851 1299.34 319.079C1299.34 321.307 1301.14 323.119 1303.38 323.119C1305.62 323.119 1307.42 321.307 1307.42 319.079C1307.42 316.851 1305.61 315.039 1303.38 315.039Z"
            fill="white"
          />
          <path
            d="M1291.35 317.047C1289.14 317.047 1287.33 318.846 1287.33 321.066C1287.33 323.285 1289.13 325.072 1291.35 325.072C1293.57 325.072 1295.36 323.281 1295.36 321.066C1295.36 318.85 1293.57 317.047 1291.35 317.047Z"
            fill="white"
          />
          <path
            d="M1278.95 318.398C1276.76 318.398 1274.98 320.177 1274.98 322.362C1274.98 324.548 1276.76 326.326 1278.95 326.326C1281.13 326.326 1282.91 324.556 1282.91 322.362C1282.91 320.168 1281.14 318.398 1278.95 318.398Z"
            fill="white"
          />
          <path
            d="M1266.27 319.045C1264.09 319.045 1262.34 320.815 1262.34 322.992C1262.34 325.169 1264.1 326.926 1266.27 326.926C1268.44 326.926 1270.21 325.164 1270.21 322.992C1270.21 320.819 1268.44 319.045 1266.27 319.045Z"
            fill="white"
          />
          <path
            d="M1253.35 319.088C1251.2 319.088 1249.45 320.836 1249.45 322.992C1249.45 325.148 1251.2 326.905 1253.35 326.905C1255.51 326.905 1257.27 325.156 1257.27 322.992C1257.27 320.828 1255.52 319.088 1253.35 319.088Z"
            fill="white"
          />
          <path
            d="M1240.32 318.506C1238.19 318.506 1236.45 320.233 1236.45 322.376C1236.45 324.519 1238.19 326.238 1240.32 326.238C1242.46 326.238 1244.19 324.511 1244.19 322.376C1244.19 320.242 1242.46 318.506 1240.32 318.506Z"
            fill="white"
          />
          <path
            d="M1227.29 317.316C1225.18 317.316 1223.47 319.035 1223.47 321.136C1223.47 323.236 1225.18 324.955 1227.29 324.955C1229.41 324.955 1231.11 323.249 1231.11 321.136C1231.11 319.022 1229.39 317.316 1227.29 317.316Z"
            fill="white"
          />
          <path
            d="M1214.26 315.748C1212.17 315.748 1210.48 317.446 1210.48 319.525C1210.48 321.604 1212.17 323.302 1214.26 323.302C1216.35 323.302 1218.03 321.604 1218.03 319.525C1218.03 317.446 1216.34 315.748 1214.26 315.748Z"
            fill="white"
          />
          <path
            d="M1201.26 314.008C1199.19 314.008 1197.53 315.671 1197.53 317.742C1197.53 319.813 1199.19 321.468 1201.26 321.468C1203.33 321.468 1204.99 319.805 1204.99 317.742C1204.99 315.68 1203.32 314.008 1201.26 314.008Z"
            fill="white"
          />
          <path
            d="M1188.33 312.23C1186.28 312.23 1184.62 313.886 1184.62 315.935C1184.62 317.985 1186.28 319.632 1188.33 319.632C1190.38 319.632 1192.02 317.976 1192.02 315.935C1192.02 313.894 1190.37 312.23 1188.33 312.23Z"
            fill="white"
          />
          <path
            d="M1175.38 310.574C1173.37 310.574 1171.75 312.2 1171.75 314.207C1171.75 316.214 1173.37 317.84 1175.38 317.84C1177.39 317.84 1179.01 316.206 1179.01 314.207C1179.01 312.208 1177.39 310.574 1175.38 310.574Z"
            fill="white"
          />
          <path
            d="M1162.44 309.107C1160.46 309.107 1158.86 310.712 1158.86 312.689C1158.86 314.667 1160.46 316.279 1162.44 316.279C1164.42 316.279 1166.03 314.675 1166.03 312.689C1166.03 310.703 1164.42 309.107 1162.44 309.107Z"
            fill="white"
          />
          <path
            d="M1149.53 307.938C1147.58 307.938 1145.99 309.52 1145.99 311.477C1145.99 313.433 1147.58 315.016 1149.53 315.016C1151.49 315.016 1153.08 313.433 1153.08 311.477C1153.08 309.52 1151.49 307.938 1149.53 307.938Z"
            fill="white"
          />
          <path
            d="M1136.6 307.143C1134.67 307.143 1133.1 308.713 1133.1 310.639C1133.1 312.566 1134.67 314.136 1136.6 314.136C1138.53 314.136 1140.1 312.575 1140.1 310.639C1140.1 308.704 1138.53 307.143 1136.6 307.143Z"
            fill="white"
          />
          <path
            d="M1123.59 306.848C1121.7 306.848 1120.16 308.388 1120.16 310.281C1120.16 312.174 1121.7 313.706 1123.59 313.706C1125.48 313.706 1127.01 312.174 1127.01 310.281C1127.01 308.388 1125.48 306.848 1123.59 306.848Z"
            fill="white"
          />
          <path
            d="M1110.52 307.172C1108.66 307.172 1107.14 308.683 1107.14 310.546C1107.14 312.409 1108.66 313.928 1110.52 313.928C1112.39 313.928 1113.91 312.417 1113.91 310.546C1113.91 308.674 1112.39 307.172 1110.52 307.172Z"
            fill="white"
          />
          <path
            d="M1097.25 308.139C1095.41 308.139 1093.92 309.628 1093.92 311.457C1093.92 313.286 1095.41 314.789 1097.25 314.789C1099.09 314.789 1100.57 313.299 1100.57 311.457C1100.57 309.615 1099.08 308.139 1097.25 308.139Z"
            fill="white"
          />
          <path
            d="M1083.65 309.91C1081.84 309.91 1080.37 311.378 1080.37 313.186C1080.37 314.994 1081.84 316.454 1083.65 316.454C1085.47 316.454 1086.93 314.986 1086.93 313.186C1086.93 311.387 1085.47 309.91 1083.65 309.91Z"
            fill="white"
          />
          <path
            d="M1069.84 312.758C1068.07 312.758 1066.64 314.192 1066.64 315.962C1066.64 317.731 1068.07 319.166 1069.84 319.166C1071.61 319.166 1073.04 317.731 1073.04 315.962C1073.04 314.192 1071.61 312.758 1069.84 312.758Z"
            fill="white"
          />
          <path
            d="M1055.65 316.816C1053.91 316.816 1052.5 318.221 1052.5 319.961C1052.5 321.701 1053.91 323.106 1055.65 323.106C1057.39 323.106 1058.79 321.701 1058.79 319.961C1058.79 318.221 1057.39 316.816 1055.65 316.816Z"
            fill="white"
          />
          <path
            d="M1041.15 322.447C1039.44 322.447 1038.06 323.831 1038.06 325.537C1038.06 327.243 1039.44 328.618 1041.15 328.618C1042.85 328.618 1044.24 327.243 1044.24 325.537C1044.24 323.831 1042.85 322.447 1041.15 322.447Z"
            fill="white"
          />
          <path
            d="M1026.41 330.016C1024.73 330.016 1023.37 331.378 1023.37 333.067C1023.37 334.756 1024.73 336.105 1026.41 336.105C1028.09 336.105 1029.45 334.743 1029.45 333.067C1029.45 331.391 1028.09 330.016 1026.41 330.016Z"
            fill="white"
          />
          <path
            d="M1011.78 340.176C1010.14 340.176 1008.82 341.496 1008.82 343.134C1008.82 344.772 1010.14 346.092 1011.78 346.092C1013.41 346.092 1014.73 344.768 1014.73 343.134C1014.73 341.5 1013.41 340.176 1011.78 340.176Z"
            fill="white"
          />
          <path
            d="M997.693 353.244C996.102 353.244 994.799 354.547 994.799 356.147C994.799 357.747 996.102 359.041 997.693 359.041C999.285 359.041 1000.6 357.751 1000.6 356.147C1000.6 354.543 999.293 353.244 997.693 353.244Z"
            fill="white"
          />
          <path
            d="M985.05 369.91C983.48 369.91 982.207 371.179 982.207 372.753C982.207 374.328 983.476 375.584 985.05 375.584C986.625 375.584 987.894 374.315 987.894 372.753C987.894 371.192 986.625 369.91 985.05 369.91Z"
            fill="white"
          />
          <path
            d="M974.705 390.256C973.165 390.256 971.917 391.495 971.917 393.036C971.917 394.576 973.165 395.824 974.705 395.824C976.246 395.824 977.493 394.576 977.493 393.036C977.493 391.495 976.246 390.256 974.705 390.256Z"
            fill="white"
          />
          <path
            d="M968.042 414.566C966.553 414.566 965.348 415.776 965.348 417.261C965.348 418.746 966.553 419.956 968.042 419.956C969.532 419.956 970.737 418.751 970.737 417.261C970.737 415.772 969.528 414.566 968.042 414.566Z"
            fill="white"
          />
          <path
            d="M966.7 442.932C965.245 442.932 964.057 444.12 964.057 445.563C964.057 447.006 965.245 448.207 966.7 448.207C968.156 448.207 969.332 447.018 969.332 445.563C969.332 444.107 968.143 442.932 966.7 442.932Z"
            fill="white"
          />
          <path
            d="M971.853 474.883C970.427 474.883 969.272 476.029 969.272 477.454C969.272 478.88 970.427 480.035 971.853 480.035C973.279 480.035 974.424 478.88 974.424 477.454C974.424 476.029 973.279 474.883 971.853 474.883Z"
            fill="white"
          />
          <path
            d="M983.123 509.76C981.727 509.76 980.603 510.893 980.603 512.281C980.603 513.668 981.727 514.797 983.123 514.797C984.519 514.797 985.64 513.673 985.64 512.281C985.64 510.889 984.507 509.76 983.123 509.76Z"
            fill="white"
          />
          <path
            d="M997.986 547.436C996.645 547.436 995.55 548.53 995.55 549.871C995.55 551.212 996.645 552.316 997.986 552.316C999.327 552.316 1000.43 551.225 1000.43 549.871C1000.43 548.518 999.339 547.436 997.986 547.436Z"
            fill="white"
          />
          <path
            d="M1012.64 588.018C1011.32 588.018 1010.25 589.079 1010.25 590.403C1010.25 591.727 1011.32 592.788 1012.64 592.788C1013.96 592.788 1015.02 591.727 1015.02 590.403C1015.02 589.079 1013.96 588.018 1012.64 588.018Z"
            fill="white"
          />
          <path
            d="M1024.76 632.207C1023.47 632.207 1022.43 633.247 1022.43 634.537C1022.43 635.827 1023.47 636.858 1024.76 636.858C1026.04 636.858 1027.08 635.818 1027.08 634.537C1027.08 633.255 1026.04 632.207 1024.76 632.207Z"
            fill="white"
          />
          <path
            d="M185.566 676.191C184.7 676.191 184.004 676.9 184.004 677.762C184.004 678.623 184.7 679.332 185.566 679.332C186.431 679.332 187.136 678.623 187.136 677.762C187.136 676.9 186.427 676.191 185.566 676.191Z"
            fill="white"
          />
          <path
            d="M161.317 662.754C160.443 662.754 159.734 663.45 159.734 664.324C159.734 665.198 160.443 665.894 161.317 665.894C162.192 665.894 162.887 665.198 162.887 664.324C162.887 663.45 162.179 662.754 161.317 662.754Z"
            fill="white"
          />
          <path
            d="M136.355 650.129C135.481 650.129 134.772 650.838 134.772 651.72C134.772 652.603 135.481 653.303 136.355 653.303C137.23 653.303 137.947 652.595 137.947 651.72C137.947 650.846 137.238 650.129 136.355 650.129Z"
            fill="white"
          />
          <path
            d="M110.058 637.182C109.183 637.182 108.475 637.89 108.475 638.765C108.475 639.639 109.183 640.348 110.058 640.348C110.932 640.348 111.64 639.639 111.64 638.765C111.64 637.89 110.932 637.182 110.058 637.182Z"
            fill="white"
          />
          <path
            d="M81.611 622.6C80.7283 622.6 80.0068 623.317 80.0068 624.204C80.0068 625.091 80.724 625.795 81.611 625.795C82.4979 625.795 83.2024 625.086 83.2024 624.204C83.2024 623.321 82.4852 622.6 81.611 622.6Z"
            fill="white"
          />
          <path
            d="M50.2848 605.129C49.4021 605.129 48.6807 605.838 48.6807 606.72C48.6807 607.603 49.3979 608.312 50.2848 608.312C51.1717 608.312 51.8762 607.595 51.8762 606.72C51.8762 605.846 51.159 605.129 50.2848 605.129Z"
            fill="white"
          />
          <path
            d="M23.2972 578.096C22.4145 578.096 21.6846 578.826 21.6846 579.721C21.6846 580.617 22.4145 581.334 23.2972 581.334C24.1799 581.334 24.9226 580.617 24.9226 579.721C24.9226 578.826 24.1926 578.096 23.2972 578.096Z"
            fill="white"
          />
          <path
            d="M1129.06 -1.88281C1127.54 -1.88281 1126.32 -0.647882 1126.32 0.867137C1126.32 2.38216 1127.54 3.62133 1129.06 3.62133C1130.58 3.62133 1131.81 2.3864 1131.81 0.867137C1131.81 -0.652125 1130.58 -1.88281 1129.06 -1.88281Z"
            fill="white"
          />
          <path
            d="M1135.85 10.3809C1134.3 10.3809 1133.04 11.6285 1133.04 13.1817C1133.04 14.7349 1134.3 15.9826 1135.85 15.9826C1137.4 15.9826 1138.65 14.7349 1138.65 13.1817C1138.65 11.6285 1137.39 10.3809 1135.85 10.3809Z"
            fill="white"
          />
          <path
            d="M1142.73 22.4336C1141.14 22.4336 1139.85 23.7237 1139.85 25.3109C1139.85 26.898 1141.14 28.1924 1142.73 28.1924C1144.32 28.1924 1145.61 26.9023 1145.61 25.3109C1145.61 23.7194 1144.32 22.4336 1142.73 22.4336Z"
            fill="white"
          />
          <path
            d="M1149.76 34.2676C1148.13 34.2676 1146.82 35.5831 1146.82 37.2085C1146.82 38.8339 1148.13 40.1452 1149.76 40.1452C1151.38 40.1452 1152.7 38.8339 1152.7 37.2085C1152.7 35.5831 1151.38 34.2676 1149.76 34.2676Z"
            fill="white"
          />
          <path
            d="M1157.01 51.7266C1158.66 51.7266 1160 50.3852 1160 48.7305C1160 47.0758 1158.66 45.7344 1157.01 45.7344C1155.35 45.7344 1154.01 47.0758 1154.01 48.7305C1154.01 50.3852 1155.35 51.7266 1157.01 51.7266Z"
            fill="white"
          />
          <path
            d="M1164.4 56.9766C1162.71 56.9766 1161.34 58.3431 1161.34 60.0363C1161.34 61.7296 1162.71 63.0918 1164.4 63.0918C1166.08 63.0918 1167.46 61.7253 1167.46 60.0363C1167.46 58.3473 1166.08 56.9766 1164.4 56.9766Z"
            fill="white"
          />
          <path
            d="M1171.9 74.295C1173.63 74.295 1175.04 72.8928 1175.04 71.1631C1175.04 69.4334 1173.63 68.0312 1171.9 68.0312C1170.17 68.0312 1168.77 69.4334 1168.77 71.1631C1168.77 72.8928 1170.17 74.295 1171.9 74.295Z"
            fill="white"
          />
          <path
            d="M1179.44 79.0684C1177.68 79.0684 1176.25 80.4943 1176.25 82.2554C1176.25 84.0166 1177.68 85.4425 1179.44 85.4425C1181.19 85.4425 1182.62 84.0166 1182.62 82.2554C1182.62 80.4943 1181.2 79.0684 1179.44 79.0684Z"
            fill="white"
          />
          <path
            d="M1186.95 90.1543C1185.16 90.1543 1183.71 91.6014 1183.71 93.3923C1183.71 95.1831 1185.16 96.6303 1186.95 96.6303C1188.74 96.6303 1190.19 95.1789 1190.19 93.3923C1190.19 91.6057 1188.74 90.1543 1186.95 90.1543Z"
            fill="white"
          />
          <path
            d="M1194.45 101.273C1192.63 101.273 1191.16 102.75 1191.16 104.571C1191.16 106.391 1192.63 107.864 1194.45 107.864C1196.28 107.864 1197.75 106.391 1197.75 104.571C1197.75 102.75 1196.28 101.273 1194.45 101.273Z"
            fill="white"
          />
          <path
            d="M1201.93 112.451C1200.06 112.451 1198.55 113.962 1198.55 115.825C1198.55 117.688 1200.06 119.186 1201.93 119.186C1203.79 119.186 1205.29 117.684 1205.29 115.825C1205.29 113.966 1203.78 112.451 1201.93 112.451Z"
            fill="white"
          />
          <path
            d="M1209.32 123.791C1207.44 123.791 1205.9 125.315 1205.9 127.199C1205.9 129.083 1207.43 130.611 1209.32 130.611C1211.21 130.611 1212.73 129.079 1212.73 127.199C1212.73 125.319 1211.2 123.791 1209.32 123.791Z"
            fill="white"
          />
          <path
            d="M1216.62 135.273C1214.7 135.273 1213.14 136.822 1213.14 138.741C1213.14 140.659 1214.7 142.216 1216.62 142.216C1218.53 142.216 1220.08 140.659 1220.08 138.741C1220.08 136.822 1218.53 135.273 1216.62 135.273Z"
            fill="white"
          />
          <path
            d="M1223.8 146.926C1221.87 146.926 1220.29 148.504 1220.29 150.44C1220.29 152.375 1221.87 153.958 1223.8 153.958C1225.74 153.958 1227.32 152.387 1227.32 150.44C1227.32 148.492 1225.75 146.926 1223.8 146.926Z"
            fill="white"
          />
          <path
            d="M1230.9 158.691C1228.93 158.691 1227.32 160.296 1227.32 162.273C1227.32 164.251 1228.93 165.855 1230.9 165.855C1232.88 165.855 1234.49 164.251 1234.49 162.273C1234.49 160.296 1232.88 158.691 1230.9 158.691Z"
            fill="white"
          />
          <path
            d="M1237.97 170.525C1235.96 170.525 1234.35 172.147 1234.35 174.145C1234.35 176.144 1235.96 177.765 1237.97 177.765C1239.98 177.765 1241.58 176.14 1241.58 174.145C1241.58 172.151 1239.97 170.525 1237.97 170.525Z"
            fill="white"
          />
          <path
            d="M1245.06 182.264C1243.03 182.264 1241.38 183.91 1241.38 185.926C1241.38 187.942 1243.03 189.601 1245.06 189.601C1247.08 189.601 1248.72 187.955 1248.72 185.926C1248.72 183.898 1247.07 182.264 1245.06 182.264Z"
            fill="white"
          />
          <path
            d="M1252.28 193.693C1250.23 193.693 1248.58 195.357 1248.58 197.411C1248.58 199.465 1250.23 201.116 1252.28 201.116C1254.33 201.116 1256 199.461 1256 197.411C1256 195.361 1254.33 193.693 1252.28 193.693Z"
            fill="white"
          />
          <path
            d="M1259.79 204.527C1257.69 204.527 1256.01 206.212 1256.01 208.296C1256.01 210.379 1257.69 212.073 1259.79 212.073C1261.88 212.073 1263.56 210.375 1263.56 208.296C1263.56 206.216 1261.87 204.527 1259.79 204.527Z"
            fill="white"
          />
          <path
            d="M1267.64 214.518C1265.54 214.518 1263.84 216.224 1263.84 218.316C1263.84 220.408 1265.54 222.127 1267.64 222.127C1269.74 222.127 1271.44 220.421 1271.44 218.316C1271.44 216.211 1269.74 214.518 1267.64 214.518Z"
            fill="white"
          />
          <path
            d="M1275.85 223.68C1273.72 223.68 1272 225.398 1272 227.52C1272 229.642 1273.72 231.369 1275.85 231.369C1277.97 231.369 1279.69 229.642 1279.69 227.52C1279.69 225.398 1277.97 223.68 1275.85 223.68Z"
            fill="white"
          />
          <path
            d="M1284.42 231.848C1282.29 231.848 1280.55 233.575 1280.55 235.718C1280.55 237.861 1282.29 239.588 1284.42 239.588C1286.55 239.588 1288.31 237.861 1288.31 235.718C1288.31 233.575 1286.57 231.848 1284.42 231.848Z"
            fill="white"
          />
          <path
            d="M1293.32 239.041C1291.14 239.041 1289.4 240.802 1289.4 242.966C1289.4 245.131 1291.14 246.892 1293.32 246.892C1295.5 246.892 1297.25 245.144 1297.25 242.966C1297.25 240.789 1295.49 239.041 1293.32 239.041Z"
            fill="white"
          />
          <path
            d="M1302.56 245.127C1300.38 245.127 1298.61 246.897 1298.61 249.082C1298.61 251.268 1300.38 253.037 1302.56 253.037C1304.75 253.037 1306.52 251.268 1306.52 249.082C1306.52 246.897 1304.74 245.127 1302.56 245.127Z"
            fill="white"
          />
          <path
            d="M1312.03 250.137C1309.84 250.137 1308.06 251.928 1308.06 254.122C1308.06 256.316 1309.83 258.106 1312.03 258.106C1314.23 258.106 1316.02 256.328 1316.02 254.122C1316.02 251.915 1314.24 250.137 1312.03 250.137Z"
            fill="white"
          />
          <path
            d="M1321.71 254.047C1319.5 254.047 1317.71 255.846 1317.71 258.066C1317.71 260.285 1319.5 262.085 1321.71 262.085C1323.93 262.085 1325.73 260.285 1325.73 258.066C1325.73 255.846 1323.94 254.047 1321.71 254.047Z"
            fill="white"
          />
          <path
            d="M1331.52 256.912C1329.28 256.912 1327.46 258.724 1327.46 260.969C1327.46 263.214 1329.28 265.039 1331.52 265.039C1333.76 265.039 1335.59 263.218 1335.59 260.969C1335.59 258.72 1333.77 256.912 1331.52 256.912Z"
            fill="white"
          />
          <path
            d="M1341.34 258.877C1339.09 258.877 1337.25 260.71 1337.25 262.968C1337.25 265.226 1339.09 267.059 1341.34 267.059C1343.6 267.059 1345.44 265.226 1345.44 262.968C1345.44 260.71 1343.61 258.877 1341.34 258.877Z"
            fill="white"
          />
          <path
            d="M1351.19 259.979C1348.91 259.979 1347.08 261.82 1347.08 264.091C1347.08 266.361 1348.91 268.211 1351.19 268.211C1353.47 268.211 1355.3 266.37 1355.3 264.091C1355.3 261.812 1353.46 259.979 1351.19 259.979Z"
            fill="white"
          />
          <path
            d="M1360.95 268.671C1363.23 268.671 1365.08 266.821 1365.08 264.538C1365.08 262.255 1363.23 260.404 1360.95 260.404C1358.67 260.404 1356.82 262.255 1356.82 264.538C1356.82 266.821 1358.67 268.671 1360.95 268.671Z"
            fill="white"
          />
          <path
            d="M1370.65 260.223C1368.36 260.223 1366.5 262.073 1366.5 264.377C1366.5 266.682 1368.36 268.532 1370.65 268.532C1372.94 268.532 1374.8 266.669 1374.8 264.377C1374.8 262.086 1372.95 260.223 1370.65 260.223Z"
            fill="white"
          />
          <path
            d="M1380.26 259.607C1377.97 259.607 1376.1 261.462 1376.1 263.762C1376.1 266.062 1377.97 267.917 1380.26 267.917C1382.55 267.917 1384.41 266.054 1384.41 263.762C1384.41 261.47 1382.56 259.607 1380.26 259.607Z"
            fill="white"
          />
          <path
            d="M1389.8 258.625C1387.5 258.625 1385.65 260.488 1385.65 262.78C1385.65 265.071 1387.5 266.93 1389.8 266.93C1392.1 266.93 1393.96 265.08 1393.96 262.78C1393.96 260.48 1392.09 258.625 1389.8 258.625Z"
            fill="white"
          />
          <path
            d="M1399.27 257.422C1396.98 257.422 1395.12 259.272 1395.12 261.576C1395.12 263.881 1396.98 265.731 1399.27 265.731C1401.56 265.731 1403.42 263.868 1403.42 261.576C1403.42 259.285 1401.57 257.422 1399.27 257.422Z"
            fill="white"
          />
          <path
            d="M1408.7 256.076C1406.41 256.076 1404.55 257.939 1404.55 260.231C1404.55 262.522 1406.41 264.385 1408.7 264.385C1411 264.385 1412.86 262.535 1412.86 260.231C1412.86 257.926 1411 256.076 1408.7 256.076Z"
            fill="white"
          />
          <path
            d="M1418.1 254.715C1415.81 254.715 1413.95 256.565 1413.95 258.869C1413.95 261.174 1415.81 263.024 1418.1 263.024C1420.39 263.024 1422.25 261.161 1422.25 258.869C1422.25 256.578 1420.4 254.715 1418.1 254.715Z"
            fill="white"
          />
          <path
            d="M1427.48 253.414C1425.19 253.414 1423.32 255.269 1423.32 257.569C1423.32 259.869 1425.19 261.723 1427.48 261.723C1429.77 261.723 1431.63 259.86 1431.63 257.569C1431.63 255.277 1429.78 253.414 1427.48 253.414Z"
            fill="white"
          />
          <path
            d="M1436.86 252.256C1434.57 252.256 1432.7 254.119 1432.7 256.411C1432.7 258.702 1434.57 260.565 1436.86 260.565C1439.15 260.565 1441.01 258.702 1441.01 256.411C1441.01 254.119 1439.15 252.256 1436.86 252.256Z"
            fill="white"
          />
          <path
            d="M1446.17 251.197C1443.87 251.197 1442.02 253.06 1442.02 255.352C1442.02 257.644 1443.87 259.515 1446.17 259.515C1448.47 259.515 1450.33 257.652 1450.33 255.352C1450.33 253.052 1448.47 251.197 1446.17 251.197Z"
            fill="white"
          />
          <path
            d="M1441.72 254.309C1439.42 254.309 1437.57 256.172 1437.57 258.472C1437.57 260.772 1439.42 262.626 1441.72 262.626C1444.03 262.626 1445.88 260.763 1445.88 258.472C1445.88 256.18 1444.02 254.309 1441.72 254.309Z"
            fill="white"
          />
          <path
            d="M1437.35 257.264C1435.05 257.264 1433.18 259.118 1433.18 261.418C1433.18 263.718 1435.05 265.573 1437.35 265.573C1439.65 265.573 1441.5 263.71 1441.5 261.418C1441.5 259.127 1439.64 257.264 1437.35 257.264Z"
            fill="white"
          />
          <path
            d="M1432.9 260.094C1430.61 260.094 1428.75 261.957 1428.75 264.248C1428.75 266.54 1430.61 268.403 1432.9 268.403C1435.19 268.403 1437.06 266.54 1437.06 264.248C1437.06 261.957 1435.2 260.094 1432.9 260.094Z"
            fill="white"
          />
          <path
            d="M1428.33 262.895C1426.03 262.895 1424.18 264.758 1424.18 267.049C1424.18 269.341 1426.03 271.204 1428.33 271.204C1430.64 271.204 1432.49 269.341 1432.49 267.049C1432.49 264.758 1430.62 262.895 1428.33 262.895Z"
            fill="white"
          />
          <path
            d="M1423.52 265.707C1421.23 265.707 1419.37 267.57 1419.37 269.862C1419.37 272.153 1421.23 274.025 1423.52 274.025C1425.81 274.025 1427.68 272.162 1427.68 269.862C1427.68 267.562 1425.81 265.707 1423.52 265.707Z"
            fill="white"
          />
          <path
            d="M1418.42 268.586C1416.11 268.586 1414.25 270.449 1414.25 272.741C1414.25 275.032 1416.11 276.895 1418.42 276.895C1420.72 276.895 1422.57 275.032 1422.57 272.741C1422.57 270.449 1420.71 268.586 1418.42 268.586Z"
            fill="white"
          />
          <path
            d="M1412.91 271.572C1410.61 271.572 1408.75 273.435 1408.75 275.727C1408.75 278.019 1410.61 279.89 1412.91 279.89C1415.2 279.89 1417.06 278.027 1417.06 275.727C1417.06 273.427 1415.2 271.572 1412.91 271.572Z"
            fill="white"
          />
          <path
            d="M1406.95 274.738C1404.65 274.738 1402.8 276.601 1402.8 278.901C1402.8 281.202 1404.65 283.056 1406.95 283.056C1409.25 283.056 1411.11 281.193 1411.11 278.901C1411.11 276.61 1409.24 274.738 1406.95 274.738Z"
            fill="white"
          />
          <path
            d="M1400.48 278.123C1398.19 278.123 1396.33 279.986 1396.33 282.278C1396.33 284.569 1398.19 286.432 1400.48 286.432C1402.77 286.432 1404.63 284.569 1404.63 282.278C1404.63 279.986 1402.78 278.123 1400.48 278.123Z"
            fill="white"
          />
          <path
            d="M1393.47 281.721C1391.17 281.721 1389.31 283.584 1389.31 285.884C1389.31 288.184 1391.17 290.038 1393.47 290.038C1395.77 290.038 1397.62 288.175 1397.62 285.884C1397.62 283.592 1395.76 281.721 1393.47 281.721Z"
            fill="white"
          />
          <path
            d="M1385.86 285.553C1383.56 285.553 1381.7 287.403 1381.7 289.707C1381.7 292.012 1383.55 293.862 1385.86 293.862C1388.16 293.862 1390.01 291.999 1390.01 289.707C1390.01 287.416 1388.15 285.553 1385.86 285.553Z"
            fill="white"
          />
          <path
            d="M1377.64 289.551C1375.36 289.551 1373.49 291.414 1373.49 293.705C1373.49 295.997 1375.35 297.86 1377.64 297.86C1379.94 297.86 1381.8 295.997 1381.8 293.705C1381.8 291.414 1379.94 289.551 1377.64 289.551Z"
            fill="white"
          />
          <path
            d="M1368.84 293.641C1366.54 293.641 1364.68 295.504 1364.68 297.795C1364.68 300.087 1366.54 301.95 1368.84 301.95C1371.14 301.95 1372.99 300.087 1372.99 297.795C1372.99 295.504 1371.13 293.641 1368.84 293.641Z"
            fill="white"
          />
          <path
            d="M1359.43 297.793C1357.14 297.793 1355.28 299.643 1355.28 301.935C1355.28 304.226 1357.14 306.09 1359.43 306.09C1361.72 306.09 1363.57 304.226 1363.57 301.935C1363.57 299.643 1361.72 297.793 1359.43 297.793Z"
            fill="white"
          />
          <path
            d="M1349.43 301.926C1347.15 301.926 1345.29 303.768 1345.29 306.046C1345.29 308.325 1347.15 310.18 1349.43 310.18C1351.71 310.18 1353.56 308.338 1353.56 306.046C1353.56 303.755 1351.71 301.926 1349.43 301.926Z"
            fill="white"
          />
          <path
            d="M1338.86 305.902C1336.6 305.902 1334.78 307.736 1334.78 309.993C1334.78 312.251 1336.6 314.072 1338.86 314.072C1341.11 314.072 1342.95 312.251 1342.95 309.993C1342.95 307.736 1341.11 305.902 1338.86 305.902Z"
            fill="white"
          />
          <path
            d="M1327.78 309.514C1325.53 309.514 1323.71 311.334 1323.71 313.583C1323.71 315.833 1325.53 317.653 1327.78 317.653C1330.03 317.653 1331.85 315.833 1331.85 313.583C1331.85 311.334 1330.03 309.514 1327.78 309.514Z"
            fill="white"
          />
          <path
            d="M1316.21 312.697C1313.98 312.697 1312.17 314.497 1312.17 316.737C1312.17 318.978 1313.98 320.777 1316.21 320.777C1318.44 320.777 1320.26 318.965 1320.26 316.737C1320.26 314.509 1318.44 312.697 1316.21 312.697Z"
            fill="white"
          />
          <path
            d="M1304.1 315.404C1301.89 315.404 1300.1 317.204 1300.1 319.41C1300.1 321.617 1301.89 323.429 1304.1 323.429C1306.32 323.429 1308.11 321.63 1308.11 319.41C1308.11 317.191 1306.32 315.404 1304.1 315.404Z"
            fill="white"
          />
          <path
            d="M1291.54 317.525C1289.35 317.525 1287.58 319.295 1287.58 321.489C1287.58 323.683 1289.35 325.453 1291.54 325.453C1293.72 325.453 1295.52 323.675 1295.52 321.489C1295.52 319.304 1293.74 317.525 1291.54 317.525Z"
            fill="white"
          />
          <path
            d="M1278.65 326.757C1280.83 326.757 1282.59 324.995 1282.59 322.823C1282.59 320.65 1280.83 318.889 1278.65 318.889C1276.48 318.889 1274.72 320.65 1274.72 322.823C1274.72 324.995 1276.48 326.757 1278.65 326.757Z"
            fill="white"
          />
          <path
            d="M1265.48 319.516C1263.32 319.516 1261.57 321.264 1261.57 323.42C1261.57 325.576 1263.32 327.333 1265.48 327.333C1267.63 327.333 1269.38 325.584 1269.38 323.42C1269.38 321.256 1267.63 319.516 1265.48 319.516Z"
            fill="white"
          />
          <path
            d="M1252.17 319.504C1250.03 319.504 1248.31 321.244 1248.31 323.374C1248.31 325.505 1250.03 327.236 1252.17 327.236C1254.3 327.236 1256.03 325.509 1256.03 323.374C1256.03 321.24 1254.3 319.504 1252.17 319.504Z"
            fill="white"
          />
          <path
            d="M1238.84 318.857C1236.73 318.857 1235.02 320.563 1235.02 322.677C1235.02 324.79 1236.73 326.496 1238.84 326.496C1240.96 326.496 1242.65 324.79 1242.65 322.677C1242.65 320.563 1240.95 318.857 1238.84 318.857Z"
            fill="white"
          />
          <path
            d="M1225.53 317.576C1223.44 317.576 1221.75 319.261 1221.75 321.353C1221.75 323.445 1223.44 325.122 1225.53 325.122C1227.62 325.122 1229.3 323.437 1229.3 321.353C1229.3 319.269 1227.61 317.576 1225.53 317.576Z"
            fill="white"
          />
          <path
            d="M1212.3 315.941C1210.23 315.941 1208.55 317.618 1208.55 319.689C1208.55 321.76 1210.23 323.436 1212.3 323.436C1214.36 323.436 1216.04 321.76 1216.04 319.689C1216.04 317.618 1214.37 315.941 1212.3 315.941Z"
            fill="white"
          />
          <path
            d="M1199.19 314.207C1197.15 314.207 1195.49 315.862 1195.49 317.912C1195.49 319.962 1197.15 321.608 1199.19 321.608C1201.23 321.608 1202.89 319.953 1202.89 317.912C1202.89 315.871 1201.23 314.207 1199.19 314.207Z"
            fill="white"
          />
          <path
            d="M1186.14 312.467C1184.13 312.467 1182.5 314.101 1182.5 316.108C1182.5 318.115 1184.13 319.749 1186.14 319.749C1188.15 319.749 1189.78 318.124 1189.78 316.108C1189.78 314.092 1188.15 312.467 1186.14 312.467Z"
            fill="white"
          />
          <path
            d="M1173.1 310.854C1171.12 310.854 1169.51 312.458 1169.51 314.444C1169.51 316.43 1171.12 318.034 1173.1 318.034C1175.08 318.034 1176.7 316.43 1176.7 314.444C1176.7 312.458 1175.09 310.854 1173.1 310.854Z"
            fill="white"
          />
          <path
            d="M1160.13 309.5C1158.17 309.5 1156.58 311.083 1156.58 313.039C1156.58 314.996 1158.17 316.579 1160.13 316.579C1162.09 316.579 1163.67 314.996 1163.67 313.039C1163.67 311.083 1162.09 309.5 1160.13 309.5Z"
            fill="white"
          />
          <path
            d="M1147.16 308.461C1145.23 308.461 1143.66 310.031 1143.66 311.958C1143.66 313.884 1145.23 315.467 1147.16 315.467C1149.1 315.467 1150.66 313.897 1150.66 311.958C1150.66 310.018 1149.09 308.461 1147.16 308.461Z"
            fill="white"
          />
          <path
            d="M1134.08 307.846C1132.19 307.846 1130.65 309.378 1130.65 311.27C1130.65 313.163 1132.19 314.695 1134.08 314.695C1135.97 314.695 1137.5 313.167 1137.5 311.27C1137.5 309.373 1135.97 307.846 1134.08 307.846Z"
            fill="white"
          />
          <path
            d="M1120.96 307.752C1119.08 307.752 1117.57 309.271 1117.57 311.134C1117.57 312.997 1119.08 314.508 1120.96 314.508C1122.83 314.508 1124.33 312.997 1124.33 311.134C1124.33 309.271 1122.82 307.752 1120.96 307.752Z"
            fill="white"
          />
          <path
            d="M1107.74 308.324C1105.9 308.324 1104.41 309.822 1104.41 311.664C1104.41 313.506 1105.9 314.995 1107.74 314.995C1109.58 314.995 1111.07 313.506 1111.07 311.664C1111.07 309.822 1109.58 308.324 1107.74 308.324Z"
            fill="white"
          />
          <path
            d="M1094.22 309.629C1092.42 309.629 1090.95 311.097 1090.95 312.909C1090.95 314.721 1092.42 316.177 1094.22 316.177C1096.02 316.177 1097.5 314.709 1097.5 312.909C1097.5 311.11 1096.03 309.629 1094.22 309.629Z"
            fill="white"
          />
          <path
            d="M1080.46 311.895C1078.69 311.895 1077.25 313.333 1077.25 315.099C1077.25 316.864 1078.69 318.294 1080.46 318.294C1082.23 318.294 1083.65 316.868 1083.65 315.099C1083.65 313.329 1082.23 311.895 1080.46 311.895Z"
            fill="white"
          />
          <path
            d="M1066.36 315.297C1064.62 315.297 1063.21 316.702 1063.21 318.442C1063.21 320.181 1064.62 321.595 1066.36 321.595C1068.1 321.595 1069.51 320.177 1069.51 318.442C1069.51 316.706 1068.09 315.297 1066.36 315.297Z"
            fill="white"
          />
          <path
            d="M1051.92 320.098C1050.2 320.098 1048.82 321.494 1048.82 323.2C1048.82 324.906 1050.2 326.302 1051.92 326.302C1053.64 326.302 1055.02 324.906 1055.02 323.2C1055.02 321.494 1053.63 320.098 1051.92 320.098Z"
            fill="white"
          />
          <path
            d="M1037.32 326.662C1035.63 326.662 1034.27 328.024 1034.27 329.701C1034.27 331.377 1035.63 332.739 1037.32 332.739C1039.01 332.739 1040.36 331.377 1040.36 329.701C1040.36 328.024 1038.99 326.662 1037.32 326.662Z"
            fill="white"
          />
          <path
            d="M1022.58 335.459C1020.95 335.459 1019.62 336.783 1019.62 338.417C1019.62 340.051 1020.95 341.375 1022.58 341.375C1024.2 341.375 1025.55 340.055 1025.55 338.417C1025.55 336.779 1024.21 335.459 1022.58 335.459Z"
            fill="white"
          />
          <path
            d="M1008.36 347.074C1006.77 347.074 1005.47 348.377 1005.47 349.977C1005.47 351.577 1006.77 352.871 1008.36 352.871C1009.95 352.871 1011.26 351.568 1011.26 349.977C1011.26 348.386 1009.96 347.074 1008.36 347.074Z"
            fill="white"
          />
          <path
            d="M995.048 361.873C993.478 361.873 992.205 363.142 992.205 364.716C992.205 366.291 993.474 367.56 995.048 367.56C996.623 367.56 997.892 366.291 997.892 364.716C997.892 363.142 996.623 361.873 995.048 361.873Z"
            fill="white"
          />
          <path
            d="M983.892 380.459C982.351 380.459 981.104 381.707 981.104 383.247C981.104 384.788 982.351 386.027 983.892 386.027C985.432 386.027 986.671 384.779 986.671 383.247C986.671 381.715 985.424 380.459 983.892 380.459Z"
            fill="white"
          />
          <path
            d="M975.651 402.766C974.161 402.766 972.943 403.971 972.943 405.473C972.943 406.975 974.161 408.181 975.651 408.181C977.14 408.181 978.358 406.963 978.358 405.473C978.358 403.984 977.14 402.766 975.651 402.766Z"
            fill="white"
          />
          <path
            d="M972.112 429.078C970.643 429.078 969.468 430.266 969.468 431.722C969.468 433.178 970.643 434.366 972.112 434.366C973.58 434.366 974.755 433.178 974.755 431.722C974.755 430.266 973.567 429.078 972.112 429.078Z"
            fill="white"
          />
          <path
            d="M974.806 459.137C973.38 459.137 972.213 460.304 972.213 461.73C972.213 463.156 973.38 464.323 974.806 464.323C976.232 464.323 977.399 463.168 977.399 461.73C977.399 460.291 976.244 459.137 974.806 459.137Z"
            fill="white"
          />
          <path
            d="M983.956 492.396C982.56 492.396 981.427 493.53 981.427 494.926C981.427 496.322 982.56 497.455 983.956 497.455C985.352 497.455 986.494 496.322 986.494 494.926C986.494 493.53 985.361 492.396 983.956 492.396Z"
            fill="white"
          />
          <path
            d="M998.121 528.631C996.78 528.631 995.677 529.726 995.677 531.075C995.677 532.425 996.78 533.511 998.121 533.511C999.462 533.511 1000.57 532.421 1000.57 531.075C1000.57 529.73 999.471 528.631 998.121 528.631Z"
            fill="white"
          />
          <path
            d="M1013.56 567.793C1012.24 567.793 1011.18 568.867 1011.18 570.178C1011.18 571.489 1012.24 572.563 1013.56 572.563C1014.89 572.563 1015.95 571.502 1015.95 570.178C1015.95 568.854 1014.88 567.793 1013.56 567.793Z"
            fill="white"
          />
          <path
            d="M1026.9 610.195C1025.62 610.195 1024.58 611.235 1024.58 612.517C1024.58 613.798 1025.62 614.846 1026.9 614.846C1028.18 614.846 1029.22 613.807 1029.22 612.517C1029.22 611.227 1028.18 610.195 1026.9 610.195Z"
            fill="white"
          />
          <path
            d="M1037.14 657.258C1035.88 657.258 1034.86 658.276 1034.86 659.537C1034.86 660.797 1035.88 661.816 1037.14 661.816C1038.4 661.816 1039.42 660.797 1039.42 659.537C1039.42 658.276 1038.4 657.258 1037.14 657.258Z"
            fill="white"
          />
          <path
            d="M153.53 670.656C152.665 670.656 151.969 671.352 151.969 672.218C151.969 673.084 152.665 673.78 153.53 673.78C154.396 673.78 155.092 673.084 155.092 672.218C155.092 671.352 154.396 670.656 153.53 670.656Z"
            fill="white"
          />
          <path
            d="M128.76 658.051C127.894 658.051 127.198 658.747 127.198 659.612C127.198 660.478 127.894 661.174 128.76 661.174C129.626 661.174 130.33 660.478 130.33 659.612C130.33 658.747 129.621 658.051 128.76 658.051Z"
            fill="white"
          />
          <path
            d="M102.864 645.148C101.998 645.148 101.294 645.844 101.294 646.719C101.294 647.593 102.003 648.289 102.864 648.289C103.726 648.289 104.434 647.58 104.434 646.719C104.434 645.857 103.726 645.148 102.864 645.148Z"
            fill="white"
          />
          <path
            d="M75.0858 630.73C74.2116 630.73 73.5029 631.439 73.5029 632.313C73.5029 633.188 74.2116 633.905 75.0858 633.905C75.9601 633.905 76.6688 633.188 76.6688 632.313C76.6688 631.439 75.9601 630.73 75.0858 630.73Z"
            fill="white"
          />
          <path
            d="M44.4784 613.42C43.6042 613.42 42.8955 614.129 42.8955 615.003C42.8955 615.877 43.6042 616.573 44.4784 616.573C45.3526 616.573 46.0613 615.864 46.0613 615.003C46.0613 614.141 45.3526 613.42 44.4784 613.42Z"
            fill="white"
          />
          <path
            d="M15.9469 584.092C15.0642 584.092 14.3428 584.809 14.3428 585.696C14.3428 586.583 15.06 587.309 15.9469 587.309C16.8339 587.309 17.551 586.591 17.551 585.696C17.551 584.801 16.8339 584.092 15.9469 584.092Z"
            fill="white"
          />
          <path
            d="M1152.08 5.80859C1150.54 5.80859 1149.28 7.06899 1149.28 8.61371C1149.28 10.1584 1150.53 11.4146 1152.08 11.4146C1153.64 11.4146 1154.88 10.1584 1154.88 8.61371C1154.88 7.06899 1153.62 5.80859 1152.08 5.80859Z"
            fill="white"
          />
          <path
            d="M1158.98 17.8926C1157.37 17.8926 1156.08 19.1827 1156.08 20.7868C1156.08 22.391 1157.37 23.6811 1158.98 23.6811C1160.58 23.6811 1161.87 22.3782 1161.87 20.7868C1161.87 19.1954 1160.57 17.8926 1158.98 17.8926Z"
            fill="white"
          />
          <path
            d="M1166 29.791C1164.39 29.791 1163.06 31.1023 1163.06 32.7277C1163.06 34.353 1164.38 35.6644 1166 35.6644C1167.62 35.6644 1168.94 34.353 1168.94 32.7277C1168.94 31.1023 1167.63 29.791 1166 29.791Z"
            fill="white"
          />
          <path
            d="M1173.24 41.3418C1171.58 41.3418 1170.24 42.6828 1170.24 44.3379C1170.24 45.9929 1171.58 47.3297 1173.24 47.3297C1174.89 47.3297 1176.23 45.9929 1176.23 44.3379C1176.23 42.6828 1174.89 41.3418 1173.24 41.3418Z"
            fill="white"
          />
          <path
            d="M1180.56 52.7305C1178.88 52.7305 1177.51 54.1054 1177.51 55.7902C1177.51 57.475 1178.87 58.8415 1180.56 58.8415C1182.25 58.8415 1183.61 57.4707 1183.61 55.7902C1183.61 54.1097 1182.25 52.7305 1180.56 52.7305Z"
            fill="white"
          />
          <path
            d="M1187.96 63.9922C1186.23 63.9922 1184.83 65.3926 1184.83 67.1241C1184.83 68.8555 1186.23 70.2517 1187.96 70.2517C1189.69 70.2517 1191.09 68.8513 1191.09 67.1241C1191.09 65.3969 1189.69 63.9922 1187.96 63.9922Z"
            fill="white"
          />
          <path
            d="M1195.41 75.1992C1193.64 75.1992 1192.22 76.6251 1192.22 78.382C1192.22 80.1389 1193.64 81.5691 1195.41 81.5691C1197.18 81.5691 1198.6 80.1432 1198.6 78.382C1198.6 76.6209 1197.17 75.1992 1195.41 75.1992Z"
            fill="white"
          />
          <path
            d="M1202.91 86.3301C1201.12 86.3301 1199.66 87.7814 1199.66 89.5723C1199.66 91.3632 1201.12 92.8188 1202.91 92.8188C1204.7 92.8188 1206.16 91.3674 1206.16 89.5723C1206.16 87.7772 1204.7 86.3301 1202.91 86.3301Z"
            fill="white"
          />
          <path
            d="M1210.4 97.5039C1208.58 97.5039 1207.11 98.9722 1207.11 100.793C1207.11 102.613 1208.58 104.082 1210.4 104.082C1212.22 104.082 1213.69 102.605 1213.69 100.793C1213.69 98.9807 1212.21 97.5039 1210.4 97.5039Z"
            fill="white"
          />
          <path
            d="M1217.84 108.725C1215.98 108.725 1214.47 110.235 1214.47 112.098C1214.47 113.961 1215.98 115.459 1217.84 115.459C1219.7 115.459 1221.22 113.957 1221.22 112.098C1221.22 110.24 1219.7 108.725 1217.84 108.725Z"
            fill="white"
          />
          <path
            d="M1225.21 120.102C1223.32 120.102 1221.79 121.638 1221.79 123.522C1221.79 125.406 1223.32 126.947 1225.21 126.947C1227.11 126.947 1228.62 125.415 1228.62 123.522C1228.62 121.629 1227.09 120.102 1225.21 120.102Z"
            fill="white"
          />
          <path
            d="M1232.46 131.672C1230.54 131.672 1228.99 133.229 1228.99 135.143C1228.99 137.057 1230.54 138.61 1232.46 138.61C1234.38 138.61 1235.92 137.053 1235.92 135.143C1235.92 133.234 1234.38 131.672 1232.46 131.672Z"
            fill="white"
          />
          <path
            d="M1239.6 143.414C1237.67 143.414 1236.08 144.993 1236.08 146.932C1236.08 148.872 1237.67 150.45 1239.6 150.45C1241.54 150.45 1243.12 148.872 1243.12 146.932C1243.12 144.993 1241.55 143.414 1239.6 143.414Z"
            fill="white"
          />
          <path
            d="M1246.66 155.279C1244.69 155.279 1243.09 156.883 1243.09 158.861C1243.09 160.839 1244.7 162.43 1246.66 162.43C1248.63 162.43 1250.24 160.834 1250.24 158.861C1250.24 156.888 1248.64 155.279 1246.66 155.279Z"
            fill="white"
          />
          <path
            d="M1253.7 167.182C1251.7 167.182 1250.08 168.794 1250.08 170.797C1250.08 172.8 1251.7 174.413 1253.7 174.413C1255.69 174.413 1257.31 172.796 1257.31 170.797C1257.31 168.799 1255.69 167.182 1253.7 167.182Z"
            fill="white"
          />
          <path
            d="M1260.76 178.953C1258.73 178.953 1257.1 180.6 1257.1 182.615C1257.1 184.631 1258.73 186.278 1260.76 186.278C1262.79 186.278 1264.42 184.631 1264.42 182.615C1264.42 180.6 1262.78 178.953 1260.76 178.953Z"
            fill="white"
          />
          <path
            d="M1267.98 190.361C1265.93 190.361 1264.27 192.025 1264.27 194.07C1264.27 196.116 1265.93 197.779 1267.98 197.779C1270.03 197.779 1271.69 196.12 1271.69 194.07C1271.69 192.021 1270.03 190.361 1267.98 190.361Z"
            fill="white"
          />
          <path
            d="M1275.48 201.123C1273.4 201.123 1271.71 202.808 1271.71 204.891C1271.71 206.975 1273.4 208.66 1275.48 208.66C1277.56 208.66 1279.25 206.975 1279.25 204.891C1279.25 202.808 1277.56 201.123 1275.48 201.123Z"
            fill="white"
          />
          <path
            d="M1283.36 210.969C1281.25 210.969 1279.54 212.675 1279.54 214.78C1279.54 216.885 1281.25 218.591 1283.36 218.591C1285.47 218.591 1287.17 216.885 1287.17 214.78C1287.17 212.675 1285.47 210.969 1283.36 210.969Z"
            fill="white"
          />
          <path
            d="M1291.59 219.867C1289.47 219.867 1287.74 221.586 1287.74 223.708C1287.74 225.83 1289.47 227.557 1291.59 227.557C1293.72 227.557 1295.43 225.83 1295.43 223.708C1295.43 221.586 1293.72 219.867 1291.59 219.867Z"
            fill="white"
          />
          <path
            d="M1300.19 227.693C1298.05 227.693 1296.32 229.429 1296.32 231.576C1296.32 233.724 1298.06 235.447 1300.19 235.447C1302.32 235.447 1304.07 233.711 1304.07 231.576C1304.07 229.442 1302.33 227.693 1300.19 227.693Z"
            fill="white"
          />
          <path
            d="M1309.1 234.451C1306.93 234.451 1305.17 236.212 1305.17 238.385C1305.17 240.558 1306.93 242.319 1309.1 242.319C1311.26 242.319 1313.03 240.558 1313.03 238.385C1313.03 236.212 1311.28 234.451 1309.1 234.451Z"
            fill="white"
          />
          <path
            d="M1318.32 240.061C1316.14 240.061 1314.36 241.839 1314.36 244.024C1314.36 246.21 1316.14 247.988 1318.32 247.988C1320.51 247.988 1322.28 246.218 1322.28 244.024C1322.28 241.83 1320.51 240.061 1318.32 240.061Z"
            fill="white"
          />
          <path
            d="M1327.74 252.571C1329.94 252.571 1331.73 250.782 1331.73 248.574C1331.73 246.366 1329.94 244.576 1327.74 244.576C1325.53 244.576 1323.74 246.366 1323.74 248.574C1323.74 250.782 1325.53 252.571 1327.74 252.571Z"
            fill="white"
          />
          <path
            d="M1337.3 248.062C1335.09 248.062 1333.28 249.862 1333.28 252.09C1333.28 254.318 1335.09 256.109 1337.3 256.109C1339.52 256.109 1341.33 254.309 1341.33 252.09C1341.33 249.87 1339.53 248.062 1337.3 248.062Z"
            fill="white"
          />
          <path
            d="M1346.95 250.549C1344.7 250.549 1342.88 252.369 1342.88 254.606C1342.88 256.842 1344.7 258.676 1346.95 258.676C1349.2 258.676 1351.01 256.855 1351.01 254.606C1351.01 252.357 1349.19 250.549 1346.95 250.549Z"
            fill="white"
          />
          <path
            d="M1356.58 252.234C1354.31 252.234 1352.48 254.068 1352.48 256.325C1352.48 258.583 1354.31 260.416 1356.58 260.416C1358.85 260.416 1360.67 258.583 1360.67 256.325C1360.67 254.068 1358.84 252.234 1356.58 252.234Z"
            fill="white"
          />
          <path
            d="M1366.21 253.143C1363.93 253.143 1362.09 254.984 1362.09 257.255C1362.09 259.525 1363.93 261.367 1366.21 261.367C1368.49 261.367 1370.32 259.525 1370.32 257.255C1370.32 254.984 1368.48 253.143 1366.21 253.143Z"
            fill="white"
          />
          <path
            d="M1375.74 253.475C1373.45 253.475 1371.6 255.325 1371.6 257.617C1371.6 259.908 1373.45 261.758 1375.74 261.758C1378.03 261.758 1379.88 259.908 1379.88 257.617C1379.88 255.325 1378.03 253.475 1375.74 253.475Z"
            fill="white"
          />
          <path
            d="M1385.24 253.322C1382.94 253.322 1381.09 255.185 1381.09 257.477C1381.09 259.769 1382.94 261.632 1385.24 261.632C1387.54 261.632 1389.4 259.777 1389.4 257.477C1389.4 255.177 1387.53 253.322 1385.24 253.322Z"
            fill="white"
          />
          <path
            d="M1394.67 252.842C1392.37 252.842 1390.52 254.696 1390.52 256.996C1390.52 259.297 1392.37 261.151 1394.67 261.151C1396.98 261.151 1398.83 259.288 1398.83 256.996C1398.83 254.705 1396.96 252.842 1394.67 252.842Z"
            fill="white"
          />
          <path
            d="M1404.06 252.09C1401.76 252.09 1399.91 253.953 1399.91 256.244C1399.91 258.536 1401.76 260.399 1404.06 260.399C1406.37 260.399 1408.22 258.545 1408.22 256.244C1408.22 253.944 1406.35 252.09 1404.06 252.09Z"
            fill="white"
          />
          <path
            d="M1413.43 251.207C1411.13 251.207 1409.26 253.07 1409.26 255.37C1409.26 257.67 1411.13 259.525 1413.43 259.525C1415.73 259.525 1417.58 257.662 1417.58 255.37C1417.58 253.079 1415.72 251.207 1413.43 251.207Z"
            fill="white"
          />
          <path
            d="M1422.77 250.293C1420.47 250.293 1418.61 252.156 1418.61 254.448C1418.61 256.739 1420.47 258.611 1422.77 258.611C1425.07 258.611 1426.93 256.748 1426.93 254.448C1426.93 252.148 1425.06 250.293 1422.77 250.293Z"
            fill="white"
          />
          <path
            d="M1432.12 249.426C1429.83 249.426 1427.97 251.289 1427.97 253.58C1427.97 255.872 1429.83 257.735 1432.12 257.735C1434.41 257.735 1436.28 255.881 1436.28 253.58C1436.28 251.28 1434.42 249.426 1432.12 249.426Z"
            fill="white"
          />
          <path
            d="M1441.48 248.68C1439.19 248.68 1437.32 250.543 1437.32 252.834C1437.32 255.126 1439.19 256.989 1441.48 256.989C1443.77 256.989 1445.63 255.126 1445.63 252.834C1445.63 250.543 1443.78 248.68 1441.48 248.68Z"
            fill="white"
          />
          <path
            d="M1450.78 247.908C1448.48 247.908 1446.63 249.771 1446.63 252.063C1446.63 254.354 1448.48 256.217 1450.78 256.217C1453.08 256.217 1454.94 254.354 1454.94 252.063C1454.94 249.771 1453.07 247.908 1450.78 247.908Z"
            fill="white"
          />
          <path
            d="M1455.35 250.178C1453.06 250.178 1451.2 252.041 1451.2 254.332C1451.2 256.624 1453.06 258.487 1455.35 258.487C1457.64 258.487 1459.51 256.624 1459.51 254.332C1459.51 252.041 1457.65 250.178 1455.35 250.178Z"
            fill="white"
          />
          <path
            d="M1450.82 253.051C1448.53 253.051 1446.67 254.914 1446.67 257.205C1446.67 259.497 1448.53 261.369 1450.82 261.369C1453.12 261.369 1454.99 259.506 1454.99 257.205C1454.99 254.905 1453.12 253.051 1450.82 253.051Z"
            fill="white"
          />
          <path
            d="M1446.29 255.818C1443.99 255.818 1442.13 257.681 1442.13 259.973C1442.13 262.265 1443.99 264.128 1446.29 264.128C1448.59 264.128 1450.44 262.273 1450.44 259.973C1450.44 257.673 1448.58 255.818 1446.29 255.818Z"
            fill="white"
          />
          <path
            d="M1441.6 258.512C1439.31 258.512 1437.45 260.375 1437.45 262.666C1437.45 264.958 1439.31 266.821 1441.6 266.821C1443.89 266.821 1445.76 264.958 1445.76 262.666C1445.76 260.375 1443.9 258.512 1441.6 258.512Z"
            fill="white"
          />
          <path
            d="M1436.69 261.17C1434.39 261.17 1432.53 263.033 1432.53 265.325C1432.53 267.616 1434.39 269.479 1436.69 269.479C1438.98 269.479 1440.84 267.629 1440.84 265.325C1440.84 263.02 1438.99 261.17 1436.69 261.17Z"
            fill="white"
          />
          <path
            d="M1431.46 263.863C1429.16 263.863 1427.31 265.726 1427.31 268.018C1427.31 270.31 1429.16 272.173 1431.46 272.173C1433.77 272.173 1435.62 270.31 1435.62 268.018C1435.62 265.726 1433.75 263.863 1431.46 263.863Z"
            fill="white"
          />
          <path
            d="M1425.85 266.686C1423.56 266.686 1421.7 268.549 1421.7 270.84C1421.7 273.132 1423.56 274.995 1425.85 274.995C1428.15 274.995 1430.01 273.14 1430.01 270.84C1430.01 268.54 1428.16 266.686 1425.85 266.686Z"
            fill="white"
          />
          <path
            d="M1419.82 269.691C1417.53 269.691 1415.66 271.546 1415.66 273.846C1415.66 276.146 1417.53 278.001 1419.82 278.001C1422.11 278.001 1423.97 276.138 1423.97 273.846C1423.97 271.554 1422.11 269.691 1419.82 269.691Z"
            fill="white"
          />
          <path
            d="M1413.29 272.908C1410.99 272.908 1409.14 274.763 1409.14 277.063C1409.14 279.363 1410.99 281.217 1413.29 281.217C1415.59 281.217 1417.45 279.354 1417.45 277.063C1417.45 274.771 1415.58 272.908 1413.29 272.908Z"
            fill="white"
          />
          <path
            d="M1406.23 276.383C1403.93 276.383 1402.07 278.246 1402.07 280.537C1402.07 282.829 1403.93 284.692 1406.23 284.692C1408.52 284.692 1410.38 282.838 1410.38 280.537C1410.38 278.237 1408.53 276.383 1406.23 276.383Z"
            fill="white"
          />
          <path
            d="M1398.59 280.164C1396.3 280.164 1394.44 282.014 1394.44 284.319C1394.44 286.623 1396.3 288.473 1398.59 288.473C1400.89 288.473 1402.75 286.61 1402.75 284.319C1402.75 282.027 1400.89 280.164 1398.59 280.164Z"
            fill="white"
          />
          <path
            d="M1390.38 284.199C1388.08 284.199 1386.22 286.062 1386.22 288.354C1386.22 290.645 1388.08 292.508 1390.38 292.508C1392.67 292.508 1394.53 290.654 1394.53 288.354C1394.53 286.054 1392.67 284.199 1390.38 284.199Z"
            fill="white"
          />
          <path
            d="M1381.56 288.469C1379.26 288.469 1377.4 290.332 1377.4 292.623C1377.4 294.915 1379.26 296.778 1381.56 296.778C1383.86 296.778 1385.71 294.915 1385.71 292.623C1385.71 290.332 1383.85 288.469 1381.56 288.469Z"
            fill="white"
          />
          <path
            d="M1372.15 292.848C1369.86 292.848 1367.99 294.711 1367.99 297.002C1367.99 299.294 1369.86 301.144 1372.15 301.144C1374.44 301.144 1376.29 299.29 1376.29 297.002C1376.29 294.715 1374.44 292.848 1372.15 292.848Z"
            fill="white"
          />
          <path
            d="M1362.17 297.283C1359.89 297.283 1358.05 299.125 1358.05 301.417C1358.05 303.708 1359.89 305.537 1362.17 305.537C1364.45 305.537 1366.3 303.696 1366.3 301.417C1366.3 299.138 1364.46 297.283 1362.17 297.283Z"
            fill="white"
          />
          <path
            d="M1351.65 301.697C1349.39 301.697 1347.56 303.531 1347.56 305.776C1347.56 308.02 1349.39 309.866 1351.65 309.866C1353.91 309.866 1355.73 308.033 1355.73 305.776C1355.73 303.518 1353.91 301.697 1351.65 301.697Z"
            fill="white"
          />
          <path
            d="M1340.58 305.887C1338.33 305.887 1336.51 307.707 1336.51 309.956C1336.51 312.206 1338.33 314.026 1340.58 314.026C1342.83 314.026 1344.65 312.206 1344.65 309.956C1344.65 307.707 1342.83 305.887 1340.58 305.887Z"
            fill="white"
          />
          <path
            d="M1329 309.723C1326.76 309.723 1324.95 311.535 1324.95 313.771C1324.95 316.008 1326.76 317.811 1329 317.811C1331.23 317.811 1333.04 315.999 1333.04 313.771C1333.04 311.543 1331.23 309.723 1329 309.723Z"
            fill="white"
          />
          <path
            d="M1316.82 313.072C1314.62 313.072 1312.82 314.872 1312.82 317.091C1312.82 319.311 1314.62 321.097 1316.82 321.097C1319.03 321.097 1320.83 319.298 1320.83 317.091C1320.83 314.884 1319.04 313.072 1316.82 313.072Z"
            fill="white"
          />
          <path
            d="M1304.16 315.912C1301.98 315.912 1300.2 317.69 1300.2 319.876C1300.2 322.061 1301.98 323.839 1304.16 323.839C1306.35 323.839 1308.13 322.07 1308.13 319.876C1308.13 317.682 1306.36 315.912 1304.16 315.912Z"
            fill="white"
          />
          <path
            d="M1291.11 318.07C1288.94 318.07 1287.18 319.84 1287.18 322.013C1287.18 324.186 1288.94 325.947 1291.11 325.947C1293.29 325.947 1295.05 324.186 1295.05 322.013C1295.05 319.84 1293.29 318.07 1291.11 318.07Z"
            fill="white"
          />
          <path
            d="M1277.7 319.424C1275.54 319.424 1273.79 321.172 1273.79 323.328C1273.79 325.484 1275.54 327.241 1277.7 327.241C1279.86 327.241 1281.6 325.492 1281.6 323.328C1281.6 321.164 1279.86 319.424 1277.7 319.424Z"
            fill="white"
          />
          <path
            d="M1264.09 319.99C1261.95 319.99 1260.21 321.73 1260.21 323.873C1260.21 326.016 1261.95 327.744 1264.09 327.744C1266.24 327.744 1267.96 326.016 1267.96 323.873C1267.96 321.73 1266.22 319.99 1264.09 319.99Z"
            fill="white"
          />
          <path
            d="M1250.47 319.932C1248.37 319.932 1246.65 321.65 1246.65 323.751C1246.65 325.852 1248.37 327.57 1250.47 327.57C1252.57 327.57 1254.29 325.864 1254.29 323.751C1254.29 321.638 1252.58 319.932 1250.47 319.932Z"
            fill="white"
          />
          <path
            d="M1236.86 319.172C1234.78 319.172 1233.08 320.869 1233.08 322.949C1233.08 325.028 1234.78 326.717 1236.86 326.717C1238.94 326.717 1240.63 325.033 1240.63 322.949C1240.63 320.865 1238.94 319.172 1236.86 319.172Z"
            fill="white"
          />
          <path
            d="M1223.33 317.785C1221.27 317.785 1219.59 319.461 1219.59 321.52C1219.59 323.578 1221.27 325.267 1223.33 325.267C1225.39 325.267 1227.08 323.591 1227.08 321.52C1227.08 319.449 1225.4 317.785 1223.33 317.785Z"
            fill="white"
          />
          <path
            d="M1209.99 316.143C1207.95 316.143 1206.29 317.798 1206.29 319.839C1206.29 321.88 1207.95 323.544 1209.99 323.544C1212.03 323.544 1213.68 321.889 1213.68 319.839C1213.68 317.789 1212.03 316.143 1209.99 316.143Z"
            fill="white"
          />
          <path
            d="M1196.8 314.422C1194.79 314.422 1193.16 316.043 1193.16 318.055C1193.16 320.066 1194.79 321.696 1196.8 321.696C1198.8 321.696 1200.44 320.07 1200.44 318.055C1200.44 316.039 1198.8 314.422 1196.8 314.422Z"
            fill="white"
          />
          <path
            d="M1183.64 312.709C1181.65 312.709 1180.04 314.313 1180.04 316.299C1180.04 318.285 1181.65 319.889 1183.64 319.889C1185.63 319.889 1187.23 318.285 1187.23 316.299C1187.23 314.313 1185.62 312.709 1183.64 312.709Z"
            fill="white"
          />
          <path
            d="M1170.55 311.168C1168.59 311.168 1167 312.759 1167 314.716C1167 316.672 1168.59 318.264 1170.55 318.264C1172.51 318.264 1174.1 316.672 1174.1 314.716C1174.1 312.759 1172.51 311.168 1170.55 311.168Z"
            fill="white"
          />
          <path
            d="M1157.55 316.952C1159.49 316.952 1161.06 315.383 1161.06 313.447C1161.06 311.511 1159.49 309.941 1157.55 309.941C1155.62 309.941 1154.05 311.511 1154.05 313.447C1154.05 315.383 1155.62 316.952 1157.55 316.952Z"
            fill="white"
          />
          <path
            d="M1144.45 309.064C1142.55 309.064 1141.01 310.605 1141.01 312.51C1141.01 314.416 1142.55 315.944 1144.45 315.944C1146.34 315.944 1147.89 314.403 1147.89 312.51C1147.89 310.618 1146.35 309.064 1144.45 309.064Z"
            fill="white"
          />
          <path
            d="M1131.26 308.648C1129.39 308.648 1127.88 310.159 1127.88 312.022C1127.88 313.885 1129.39 315.404 1131.26 315.404C1133.13 315.404 1134.63 313.894 1134.63 312.022C1134.63 310.151 1133.12 308.648 1131.26 308.648Z"
            fill="white"
          />
          <path
            d="M1118.02 315.487C1119.86 315.487 1121.35 313.995 1121.35 312.156C1121.35 310.316 1119.86 308.824 1118.02 308.824C1116.18 308.824 1114.69 310.316 1114.69 312.156C1114.69 313.995 1116.18 315.487 1118.02 315.487Z"
            fill="white"
          />
          <path
            d="M1104.57 309.688C1102.77 309.688 1101.3 311.156 1101.3 312.968C1101.3 314.78 1102.77 316.236 1104.57 316.236C1106.37 316.236 1107.85 314.767 1107.85 312.968C1107.85 311.169 1106.38 309.688 1104.57 309.688Z"
            fill="white"
          />
          <path
            d="M1090.86 311.404C1089.09 311.404 1087.67 312.839 1087.67 314.608C1087.67 316.378 1089.09 317.804 1090.86 317.804C1092.63 317.804 1094.07 316.378 1094.07 314.608C1094.07 312.839 1092.63 311.404 1090.86 311.404Z"
            fill="white"
          />
          <path
            d="M1076.9 314.172C1075.16 314.172 1073.75 315.589 1073.75 317.325C1073.75 319.061 1075.16 320.487 1076.9 320.487C1078.63 320.487 1080.07 319.069 1080.07 317.325C1080.07 315.581 1078.65 314.172 1076.9 314.172Z"
            fill="white"
          />
          <path
            d="M1062.55 318.234C1060.84 318.234 1059.45 319.631 1059.45 321.337C1059.45 323.043 1060.84 324.439 1062.55 324.439C1064.27 324.439 1065.64 323.055 1065.64 321.337C1065.64 319.618 1064.26 318.234 1062.55 318.234Z"
            fill="white"
          />
          <path
            d="M1048.03 323.938C1046.34 323.938 1044.98 325.3 1044.98 326.989C1044.98 328.678 1046.34 330.027 1048.03 330.027C1049.72 330.027 1051.07 328.674 1051.07 326.989C1051.07 325.304 1049.7 323.938 1048.03 323.938Z"
            fill="white"
          />
          <path
            d="M1033.33 331.605C1031.7 331.605 1030.37 332.925 1030.37 334.551C1030.37 336.176 1031.69 337.509 1033.33 337.509C1034.97 337.509 1036.29 336.184 1036.29 334.551C1036.29 332.917 1034.96 331.605 1033.33 331.605Z"
            fill="white"
          />
          <path
            d="M1018.97 341.758C1017.38 341.758 1016.07 343.048 1016.07 344.652C1016.07 346.256 1017.38 347.546 1018.97 347.546C1020.56 347.546 1021.86 346.243 1021.86 344.652C1021.86 343.061 1020.57 341.758 1018.97 341.758Z"
            fill="white"
          />
          <path
            d="M1005.37 354.852C1003.78 354.852 1002.51 356.133 1002.51 357.703C1002.51 359.274 1003.78 360.555 1005.37 360.555C1006.95 360.555 1008.22 359.286 1008.22 357.703C1008.22 356.12 1006.94 354.852 1005.37 354.852Z"
            fill="white"
          />
          <path
            d="M993.449 371.531C991.909 371.531 990.661 372.792 990.661 374.332C990.661 375.873 991.909 377.12 993.449 377.12C994.99 377.12 996.237 375.873 996.237 374.332C996.237 372.792 994.99 371.531 993.449 371.531Z"
            fill="white"
          />
          <path
            d="M984.019 391.873C982.529 391.873 981.312 393.078 981.312 394.568C981.312 396.057 982.529 397.275 984.019 397.275C985.509 397.275 986.714 396.07 986.714 394.568C986.714 393.066 985.509 391.873 984.019 391.873Z"
            fill="white"
          />
          <path
            d="M978.617 416.102C977.149 416.102 975.974 417.277 975.974 418.745C975.974 420.214 977.149 421.389 978.617 421.389C980.086 421.389 981.261 420.201 981.261 418.745C981.261 417.29 980.073 416.102 978.617 416.102Z"
            fill="white"
          />
          <path
            d="M978.804 444.223C977.378 444.223 976.211 445.39 976.211 446.816C976.211 448.241 977.378 449.409 978.804 449.409C980.23 449.409 981.397 448.241 981.397 446.816C981.397 445.39 980.23 444.223 978.804 444.223Z"
            fill="white"
          />
          <path
            d="M985.611 480.844C987.008 480.844 988.141 479.711 988.141 478.314C988.141 476.918 987.008 475.785 985.611 475.785C984.214 475.785 983.082 476.918 983.082 478.314C983.082 479.711 984.214 480.844 985.611 480.844Z"
            fill="white"
          />
          <path
            d="M998.43 510.404C997.089 510.404 995.994 511.499 995.994 512.84C995.994 514.181 997.089 515.285 998.43 515.285C999.771 515.285 1000.87 514.19 1000.87 512.84C1000.87 511.491 999.784 510.404 998.43 510.404Z"
            fill="white"
          />
          <path
            d="M1014 547.965C1012.68 547.965 1011.61 549.039 1011.61 550.358C1011.61 551.678 1012.68 552.743 1014 552.743C1015.32 552.743 1016.39 551.67 1016.39 550.358C1016.39 549.047 1015.31 547.965 1014 547.965Z"
            fill="white"
          />
          <path
            d="M1028.39 588.641C1027.1 588.641 1026.04 589.68 1026.04 590.97C1026.04 592.261 1027.1 593.313 1028.39 593.313C1029.68 593.313 1030.73 592.261 1030.73 590.97C1030.73 589.68 1029.68 588.641 1028.39 588.641Z"
            fill="white"
          />
          <path
            d="M1039.94 633.383C1038.68 633.383 1037.65 634.401 1037.65 635.662C1037.65 636.922 1038.68 637.949 1039.94 637.949C1041.2 637.949 1042.22 636.918 1042.22 635.662C1042.22 634.406 1041.2 633.383 1039.94 633.383Z"
            fill="white"
          />
          <path
            d="M122.496 667.541C121.631 667.541 120.935 668.25 120.935 669.103C120.935 669.956 121.631 670.664 122.496 670.664C123.362 670.664 124.058 669.968 124.058 669.103C124.058 668.237 123.362 667.541 122.496 667.541Z"
            fill="white"
          />
          <path
            d="M97.1095 654.793C96.2565 654.793 95.5605 655.489 95.5605 656.342C95.5605 657.195 96.2565 657.904 97.1095 657.904C97.9625 657.904 98.6712 657.208 98.6712 656.342C98.6712 655.476 97.9752 654.793 97.1095 654.793Z"
            fill="white"
          />
          <path
            d="M70.1112 640.721C69.237 640.721 68.541 641.417 68.541 642.291C68.541 643.165 69.237 643.861 70.1112 643.861C70.9854 643.861 71.6814 643.152 71.6814 642.291C71.6814 641.429 70.9727 640.721 70.1112 640.721Z"
            fill="white"
          />
          <path
            d="M40.3957 623.904C39.53 623.904 38.834 624.6 38.834 625.466C38.834 626.332 39.53 627.036 40.3957 627.036C41.2614 627.036 41.9574 626.327 41.9574 625.466C41.9574 624.604 41.2614 623.904 40.3957 623.904Z"
            fill="white"
          />
          <path
            d="M10.6939 592.553C9.81125 592.553 9.10254 593.27 9.10254 594.144C9.10254 595.018 9.81125 595.736 10.6939 595.736C11.5766 595.736 12.2854 595.027 12.2854 594.144C12.2854 593.261 11.5682 592.553 10.6939 592.553Z"
            fill="white"
          />
          <path
            d="M1168.52 0.78125C1166.98 0.78125 1165.72 2.04164 1165.72 3.58637C1165.72 5.13109 1166.98 6.38724 1168.52 6.38724C1170.06 6.38724 1171.32 5.13109 1171.32 3.58637C1171.32 2.04164 1170.07 0.78125 1168.52 0.78125Z"
            fill="white"
          />
          <path
            d="M1175.49 12.7988C1173.89 12.7988 1172.6 14.0932 1172.6 15.6888C1172.6 17.2845 1173.89 18.5831 1175.49 18.5831C1177.1 18.5831 1178.37 17.293 1178.37 15.6888C1178.37 14.0847 1177.08 12.7988 1175.49 12.7988Z"
            fill="white"
          />
          <path
            d="M1182.54 24.7324C1180.9 24.7324 1179.59 26.048 1179.59 27.6776C1179.59 29.3072 1180.9 30.6227 1182.54 30.6227C1184.17 30.6227 1185.48 29.3029 1185.48 27.6776C1185.48 26.0522 1184.16 24.7324 1182.54 24.7324Z"
            fill="white"
          />
          <path
            d="M1189.7 36.4707C1188.04 36.4707 1186.7 37.8117 1186.7 39.4668C1186.7 41.1219 1188.04 42.4629 1189.7 42.4629C1191.35 42.4629 1192.68 41.1219 1192.68 39.4668C1192.68 37.8117 1191.35 36.4707 1189.7 36.4707Z"
            fill="white"
          />
          <path
            d="M1196.96 48.0371C1195.28 48.0371 1193.9 49.4036 1193.9 51.0926C1193.9 52.7816 1195.28 54.1439 1196.96 54.1439C1198.65 54.1439 1200.01 52.7774 1200.01 51.0926C1200.01 49.4078 1198.64 48.0371 1196.96 48.0371Z"
            fill="white"
          />
          <path
            d="M1204.35 59.3574C1202.61 59.3574 1201.21 60.7621 1201.21 62.4893C1201.21 64.2165 1202.61 65.6339 1204.35 65.6339C1206.09 65.6339 1207.49 64.2292 1207.49 62.4893C1207.49 60.7494 1206.08 59.3574 1204.35 59.3574Z"
            fill="white"
          />
          <path
            d="M1211.81 70.5977C1210.05 70.5977 1208.62 72.0236 1208.62 73.7847C1208.62 75.5459 1210.05 76.9675 1211.81 76.9675C1213.57 76.9675 1214.99 75.5416 1214.99 73.7847C1214.99 72.0278 1213.56 70.5977 1211.81 70.5977Z"
            fill="white"
          />
          <path
            d="M1219.3 88.2598C1221.09 88.2598 1222.54 86.8082 1222.54 85.0176C1222.54 83.227 1221.09 81.7754 1219.3 81.7754C1217.5 81.7754 1216.05 83.227 1216.05 85.0176C1216.05 86.8082 1217.5 88.2598 1219.3 88.2598Z"
            fill="white"
          />
          <path
            d="M1226.77 92.9961C1224.95 92.9961 1223.48 94.4644 1223.48 96.285C1223.48 98.1056 1224.95 99.5697 1226.77 99.5697C1228.59 99.5697 1230.06 98.0971 1230.06 96.285C1230.06 94.4729 1228.58 92.9961 1226.77 92.9961Z"
            fill="white"
          />
          <path
            d="M1234.17 104.311C1232.31 104.311 1230.8 105.813 1230.8 107.672C1230.8 109.53 1232.31 111.033 1234.17 111.033C1236.03 111.033 1237.53 109.53 1237.53 107.672C1237.53 105.813 1236.02 104.311 1234.17 104.311Z"
            fill="white"
          />
          <path
            d="M1241.48 115.791C1239.6 115.791 1238.07 117.323 1238.07 119.211C1238.07 121.1 1239.6 122.632 1241.48 122.632C1243.36 122.632 1244.9 121.1 1244.9 119.211C1244.9 117.323 1243.37 115.791 1241.48 115.791Z"
            fill="white"
          />
          <path
            d="M1248.69 127.469C1246.78 127.469 1245.22 129.018 1245.22 130.936C1245.22 132.854 1246.78 134.403 1248.69 134.403C1250.6 134.403 1252.16 132.846 1252.16 130.936C1252.16 129.026 1250.61 127.469 1248.69 127.469Z"
            fill="white"
          />
          <path
            d="M1255.79 139.305C1253.85 139.305 1252.28 140.875 1252.28 142.81C1252.28 144.745 1253.85 146.315 1255.79 146.315C1257.73 146.315 1259.29 144.749 1259.29 142.81C1259.29 140.871 1257.72 139.305 1255.79 139.305Z"
            fill="white"
          />
          <path
            d="M1262.8 151.23C1260.82 151.23 1259.21 152.835 1259.21 154.821C1259.21 156.807 1260.82 158.402 1262.8 158.402C1264.79 158.402 1266.38 156.798 1266.38 154.821C1266.38 152.843 1264.78 151.23 1262.8 151.23Z"
            fill="white"
          />
          <path
            d="M1269.8 163.172C1267.79 163.172 1266.17 164.797 1266.17 166.8C1266.17 168.803 1267.79 170.433 1269.8 170.433C1271.8 170.433 1273.42 168.808 1273.42 166.8C1273.42 164.793 1271.79 163.172 1269.8 163.172Z"
            fill="white"
          />
          <path
            d="M1276.84 174.969C1274.82 174.969 1273.18 176.603 1273.18 178.627C1273.18 180.651 1274.83 182.285 1276.84 182.285C1278.86 182.285 1280.5 180.651 1280.5 178.627C1280.5 176.603 1278.86 174.969 1276.84 174.969Z"
            fill="white"
          />
          <path
            d="M1284.07 186.355C1282.02 186.355 1280.37 188.011 1280.37 190.06C1280.37 192.11 1282.02 193.761 1284.07 193.761C1286.12 193.761 1287.77 192.101 1287.77 190.06C1287.77 188.019 1286.11 186.355 1284.07 186.355Z"
            fill="white"
          />
          <path
            d="M1291.56 197.055C1289.49 197.055 1287.8 198.739 1287.8 200.823C1287.8 202.907 1289.49 204.579 1291.56 204.579C1293.63 204.579 1295.33 202.894 1295.33 200.823C1295.33 198.752 1293.64 197.055 1291.56 197.055Z"
            fill="white"
          />
          <path
            d="M1299.44 206.797C1297.33 206.797 1295.62 208.503 1295.62 210.616C1295.62 212.73 1297.33 214.427 1299.44 214.427C1301.55 214.427 1303.25 212.721 1303.25 210.616C1303.25 208.511 1301.55 206.797 1299.44 206.797Z"
            fill="white"
          />
          <path
            d="M1307.7 215.434C1305.57 215.434 1303.85 217.161 1303.85 219.283C1303.85 221.405 1305.57 223.123 1307.7 223.123C1309.82 223.123 1311.54 221.396 1311.54 219.283C1311.54 217.169 1309.82 215.434 1307.7 215.434Z"
            fill="white"
          />
          <path
            d="M1316.29 222.941C1314.16 222.941 1312.42 224.681 1312.42 226.824C1312.42 228.968 1314.16 230.695 1316.29 230.695C1318.42 230.695 1320.18 228.955 1320.18 226.824C1320.18 224.694 1318.44 222.941 1316.29 222.941Z"
            fill="white"
          />
          <path
            d="M1325.21 229.246C1323.03 229.246 1321.27 231.007 1321.27 233.18C1321.27 235.353 1323.04 237.114 1325.21 237.114C1327.38 237.114 1329.14 235.357 1329.14 233.18C1329.14 231.003 1327.38 229.246 1325.21 229.246Z"
            fill="white"
          />
          <path
            d="M1334.38 234.428C1332.18 234.428 1330.42 236.206 1330.42 238.391C1330.42 240.577 1332.18 242.355 1334.38 242.355C1336.57 242.355 1338.34 240.585 1338.34 238.391C1338.34 236.197 1336.56 234.428 1334.38 234.428Z"
            fill="white"
          />
          <path
            d="M1343.7 238.549C1341.5 238.549 1339.71 240.327 1339.71 242.534C1339.71 244.74 1341.5 246.531 1343.7 246.531C1345.91 246.531 1347.7 244.753 1347.7 242.534C1347.7 240.314 1345.91 238.549 1343.7 238.549Z"
            fill="white"
          />
          <path
            d="M1353.12 241.693C1350.89 241.693 1349.09 243.493 1349.09 245.721C1349.09 247.949 1350.89 249.739 1353.12 249.739C1355.34 249.739 1357.14 247.94 1357.14 245.721C1357.14 243.501 1355.34 241.693 1353.12 241.693Z"
            fill="white"
          />
          <path
            d="M1362.57 243.91C1360.34 243.91 1358.52 245.731 1358.52 247.971C1358.52 250.212 1360.34 252.041 1362.57 252.041C1364.81 252.041 1366.64 250.221 1366.64 247.971C1366.64 245.722 1364.82 243.91 1362.57 243.91Z"
            fill="white"
          />
          <path
            d="M1371.99 245.418C1369.73 245.418 1367.9 247.251 1367.9 249.509C1367.9 251.767 1369.73 253.608 1371.99 253.608C1374.25 253.608 1376.09 251.775 1376.09 249.509C1376.09 247.243 1374.26 245.418 1371.99 245.418Z"
            fill="white"
          />
          <path
            d="M1381.42 246.273C1379.14 246.273 1377.3 248.115 1377.3 250.386C1377.3 252.656 1379.14 254.498 1381.42 254.498C1383.7 254.498 1385.53 252.656 1385.53 250.386C1385.53 248.115 1383.69 246.273 1381.42 246.273Z"
            fill="white"
          />
          <path
            d="M1390.76 246.668C1388.47 246.668 1386.62 248.522 1386.62 250.81C1386.62 253.097 1388.47 254.952 1390.76 254.952C1393.05 254.952 1394.9 253.097 1394.9 250.81C1394.9 248.522 1393.04 246.668 1390.76 246.668Z"
            fill="white"
          />
          <path
            d="M1400.07 246.68C1397.78 246.68 1395.92 248.543 1395.92 250.834C1395.92 253.126 1397.78 254.989 1400.07 254.989C1402.36 254.989 1404.23 253.134 1404.23 250.834C1404.23 248.534 1402.36 246.68 1400.07 246.68Z"
            fill="white"
          />
          <path
            d="M1409.35 246.459C1407.05 246.459 1405.2 248.322 1405.2 250.609C1405.2 252.897 1407.05 254.764 1409.35 254.764C1411.65 254.764 1413.5 252.914 1413.5 250.609C1413.5 248.305 1411.64 246.459 1409.35 246.459Z"
            fill="white"
          />
          <path
            d="M1418.61 246.088C1416.31 246.088 1414.45 247.942 1414.45 250.243C1414.45 252.543 1416.31 254.397 1418.61 254.397C1420.91 254.397 1422.76 252.534 1422.76 250.243C1422.76 247.951 1420.9 246.088 1418.61 246.088Z"
            fill="white"
          />
          <path
            d="M1427.87 245.662C1425.57 245.662 1423.72 247.512 1423.72 249.817C1423.72 252.121 1425.57 253.971 1427.87 253.971C1430.17 253.971 1432.03 252.108 1432.03 249.817C1432.03 247.525 1430.16 245.662 1427.87 245.662Z"
            fill="white"
          />
          <path
            d="M1437.15 245.275C1434.85 245.275 1432.99 247.138 1432.99 249.43C1432.99 251.722 1434.85 253.585 1437.15 253.585C1439.44 253.585 1441.3 251.73 1441.3 249.43C1441.3 247.13 1439.45 245.275 1437.15 245.275Z"
            fill="white"
          />
          <path
            d="M1446.43 244.891C1444.13 244.891 1442.28 246.754 1442.28 249.045C1442.28 251.337 1444.13 253.2 1446.43 253.2C1448.73 253.2 1450.59 251.337 1450.59 249.045C1450.59 246.754 1448.72 244.891 1446.43 244.891Z"
            fill="white"
          />
          <path
            d="M1454.97 254.52C1452.67 254.52 1450.81 256.383 1450.81 258.674C1450.81 260.966 1452.67 262.829 1454.97 262.829C1457.26 262.829 1459.12 260.966 1459.12 258.674C1459.12 256.383 1457.26 254.52 1454.97 254.52Z"
            fill="white"
          />
          <path
            d="M1449.99 257.086C1447.7 257.086 1445.84 258.949 1445.84 261.241C1445.84 263.532 1447.7 265.404 1449.99 265.404C1452.28 265.404 1454.15 263.541 1454.15 261.241C1454.15 258.94 1452.29 257.086 1449.99 257.086Z"
            fill="white"
          />
          <path
            d="M1444.71 259.688C1442.42 259.688 1440.56 261.55 1440.56 263.842C1440.56 266.134 1442.42 267.997 1444.71 267.997C1447 267.997 1448.87 266.134 1448.87 263.842C1448.87 261.55 1447.01 259.688 1444.71 259.688Z"
            fill="white"
          />
          <path
            d="M1439.04 262.346C1436.75 262.346 1434.89 264.209 1434.89 266.5C1434.89 268.792 1436.75 270.655 1439.04 270.655C1441.33 270.655 1443.2 268.792 1443.2 266.5C1443.2 264.209 1441.35 262.346 1439.04 262.346Z"
            fill="white"
          />
          <path
            d="M1432.9 265.104C1430.61 265.104 1428.75 266.967 1428.75 269.258C1428.75 271.55 1430.61 273.413 1432.9 273.413C1435.19 273.413 1437.06 271.558 1437.06 269.258C1437.06 266.958 1435.2 265.104 1432.9 265.104Z"
            fill="white"
          />
          <path
            d="M1426.27 268.098C1423.97 268.098 1422.11 269.952 1422.11 272.252C1422.11 274.552 1423.97 276.407 1426.27 276.407C1428.57 276.407 1430.42 274.544 1430.42 272.252C1430.42 269.961 1428.56 268.098 1426.27 268.098Z"
            fill="white"
          />
          <path
            d="M1419.11 271.367C1416.82 271.367 1414.96 273.23 1414.96 275.53C1414.96 277.83 1416.82 279.685 1419.11 279.685C1421.4 279.685 1423.26 277.822 1423.26 275.53C1423.26 273.239 1421.4 271.367 1419.11 271.367Z"
            fill="white"
          />
          <path
            d="M1411.41 274.957C1409.11 274.957 1407.25 276.812 1407.25 279.112C1407.25 281.412 1409.1 283.266 1411.41 283.266C1413.71 283.266 1415.56 281.403 1415.56 279.112C1415.56 276.82 1413.7 274.957 1411.41 274.957Z"
            fill="white"
          />
          <path
            d="M1403.12 278.883C1400.83 278.883 1398.97 280.746 1398.97 283.037C1398.97 285.329 1400.83 287.192 1403.12 287.192C1405.41 287.192 1407.29 285.342 1407.29 283.037C1407.29 280.733 1405.42 278.883 1403.12 278.883Z"
            fill="white"
          />
          <path
            d="M1394.27 283.139C1391.99 283.139 1390.12 285.002 1390.12 287.293C1390.12 289.585 1391.98 291.448 1394.27 291.448C1396.57 291.448 1398.43 289.585 1398.43 287.293C1398.43 285.002 1396.57 283.139 1394.27 283.139Z"
            fill="white"
          />
          <path
            d="M1384.85 287.666C1382.55 287.666 1380.69 289.516 1380.69 291.808C1380.69 294.1 1382.55 295.963 1384.85 295.963C1387.14 295.963 1388.99 294.1 1388.99 291.808C1388.99 289.516 1387.13 287.666 1384.85 287.666Z"
            fill="white"
          />
          <path
            d="M1374.84 292.34C1372.56 292.34 1370.71 294.194 1370.71 296.473C1370.71 298.752 1372.56 300.594 1374.84 300.594C1377.13 300.594 1378.98 298.752 1378.98 296.473C1378.98 294.194 1377.13 292.34 1374.84 292.34Z"
            fill="white"
          />
          <path
            d="M1364.32 297.031C1362.07 297.031 1360.22 298.865 1360.22 301.131C1360.22 303.397 1362.07 305.23 1364.32 305.23C1366.58 305.23 1368.42 303.388 1368.42 301.131C1368.42 298.873 1366.59 297.031 1364.32 297.031Z"
            fill="white"
          />
          <path
            d="M1353.29 301.662C1351.04 301.662 1349.22 303.483 1349.22 305.732C1349.22 307.981 1351.04 309.802 1353.29 309.802C1355.54 309.802 1357.36 307.981 1357.36 305.732C1357.36 303.483 1355.54 301.662 1353.29 301.662Z"
            fill="white"
          />
          <path
            d="M1341.72 306.09C1339.5 306.09 1337.68 307.902 1337.68 310.13C1337.68 312.358 1339.5 314.17 1341.72 314.17C1343.95 314.17 1345.76 312.371 1345.76 310.13C1345.76 307.889 1343.95 306.09 1341.72 306.09Z"
            fill="white"
          />
          <path
            d="M1329.53 310.137C1327.31 310.137 1325.51 311.928 1325.51 314.143C1325.51 316.358 1327.31 318.149 1329.53 318.149C1331.75 318.149 1333.53 316.358 1333.53 314.143C1333.53 311.928 1331.74 310.137 1329.53 310.137Z"
            fill="white"
          />
          <path
            d="M1316.78 313.633C1314.59 313.633 1312.82 315.411 1312.82 317.596C1312.82 319.782 1314.59 321.56 1316.78 321.56C1318.97 321.56 1320.76 319.791 1320.76 317.596C1320.76 315.402 1318.98 313.633 1316.78 313.633Z"
            fill="white"
          />
          <path
            d="M1303.63 316.537C1301.45 316.537 1299.68 318.294 1299.68 320.471C1299.68 322.648 1301.45 324.405 1303.63 324.405C1305.8 324.405 1307.56 322.644 1307.56 320.471C1307.56 318.298 1305.79 316.537 1303.63 316.537Z"
            fill="white"
          />
          <path
            d="M1290.01 318.701C1287.85 318.701 1286.11 320.45 1286.11 322.614C1286.11 324.778 1287.85 326.518 1290.01 326.518C1292.17 326.518 1293.91 324.77 1293.91 322.614C1293.91 320.458 1292.17 318.701 1290.01 318.701Z"
            fill="white"
          />
          <path
            d="M1276.14 320.004C1273.99 320.004 1272.25 321.731 1272.25 323.874C1272.25 326.017 1273.99 327.745 1276.14 327.745C1278.28 327.745 1280.01 326.017 1280.01 323.874C1280.01 321.731 1278.27 320.004 1276.14 320.004Z"
            fill="white"
          />
          <path
            d="M1262.19 320.521C1260.09 320.521 1258.38 322.24 1258.38 324.341C1258.38 326.442 1260.08 328.16 1262.19 328.16C1264.29 328.16 1266.01 326.442 1266.01 324.341C1266.01 322.24 1264.3 320.521 1262.19 320.521Z"
            fill="white"
          />
          <path
            d="M1248.29 320.326C1246.19 320.326 1244.5 322.024 1244.5 324.116C1244.5 326.208 1246.19 327.893 1248.29 327.893C1250.38 327.893 1252.06 326.208 1252.06 324.116C1252.06 322.024 1250.38 320.326 1248.29 320.326Z"
            fill="white"
          />
          <path
            d="M1234.42 319.439C1232.36 319.439 1230.69 321.116 1230.69 323.174C1230.69 325.232 1232.36 326.921 1234.42 326.921C1236.48 326.921 1238.17 325.245 1238.17 323.174C1238.17 321.103 1236.49 319.439 1234.42 319.439Z"
            fill="white"
          />
          <path
            d="M1220.77 317.982C1218.72 317.982 1217.07 319.637 1217.07 321.679C1217.07 323.72 1218.72 325.375 1220.77 325.375C1222.81 325.375 1224.47 323.72 1224.47 321.679C1224.47 319.637 1222.82 317.982 1220.77 317.982Z"
            fill="white"
          />
          <path
            d="M1207.37 316.35C1205.36 316.35 1203.74 317.975 1203.74 319.982C1203.74 321.99 1205.36 323.623 1207.37 323.623C1209.38 323.623 1211 321.99 1211 319.982C1211 317.975 1209.38 316.35 1207.37 316.35Z"
            fill="white"
          />
          <path
            d="M1194.07 314.609C1192.1 314.609 1190.48 316.222 1190.48 318.2C1190.48 320.177 1192.1 321.803 1194.07 321.803C1196.05 321.803 1197.68 320.19 1197.68 318.2C1197.68 316.209 1196.06 314.609 1194.07 314.609Z"
            fill="white"
          />
          <path
            d="M1180.86 312.955C1178.9 312.955 1177.31 314.546 1177.31 316.503C1177.31 318.459 1178.9 320.051 1180.86 320.051C1182.83 320.051 1184.41 318.459 1184.41 316.503C1184.41 314.546 1182.82 312.955 1180.86 312.955Z"
            fill="white"
          />
          <path
            d="M1170.25 317.524C1171.62 316.155 1171.62 313.935 1170.25 312.566C1168.88 311.197 1166.66 311.197 1165.29 312.566C1163.92 313.935 1163.92 316.155 1165.29 317.524C1166.66 318.892 1168.88 318.892 1170.25 317.524Z"
            fill="white"
          />
          <path
            d="M1154.66 310.469C1152.77 310.469 1151.23 312.001 1151.23 313.902C1151.23 315.803 1152.77 317.327 1154.66 317.327C1156.56 317.327 1158.1 315.795 1158.1 313.902C1158.1 312.009 1156.56 310.469 1154.66 310.469Z"
            fill="white"
          />
          <path
            d="M1141.45 309.75C1139.58 309.75 1138.06 311.261 1138.06 313.132C1138.06 315.004 1139.58 316.523 1141.45 316.523C1143.32 316.523 1144.83 315.004 1144.83 313.132C1144.83 311.261 1143.31 309.75 1141.45 309.75Z"
            fill="white"
          />
          <path
            d="M1128.71 316.152C1130.52 315.857 1131.76 314.146 1131.46 312.33C1131.17 310.514 1129.46 309.281 1127.64 309.576C1125.82 309.87 1124.59 311.582 1124.89 313.398C1125.18 315.214 1126.89 316.447 1128.71 316.152Z"
            fill="white"
          />
          <path
            d="M1114.73 310.045C1112.92 310.045 1111.44 311.522 1111.44 313.334C1111.44 315.146 1112.92 316.623 1114.73 316.623C1116.54 316.623 1118.01 315.146 1118.01 313.334C1118.01 311.522 1116.54 310.045 1114.73 310.045Z"
            fill="white"
          />
          <path
            d="M1101.07 311.299C1099.3 311.299 1097.87 312.737 1097.87 314.503C1097.87 316.268 1099.3 317.698 1101.07 317.698C1102.84 317.698 1104.27 316.264 1104.27 314.503C1104.27 312.742 1102.84 311.299 1101.07 311.299Z"
            fill="white"
          />
          <path
            d="M1087.23 313.479C1085.48 313.479 1084.08 314.896 1084.08 316.632C1084.08 318.367 1085.48 319.797 1087.23 319.797C1088.98 319.797 1090.38 318.38 1090.38 316.632C1090.38 314.883 1088.97 313.479 1087.23 313.479Z"
            fill="white"
          />
          <path
            d="M1073.03 316.83C1071.32 316.83 1069.94 318.214 1069.94 319.92C1069.94 321.626 1071.32 323.022 1073.03 323.022C1074.73 323.022 1076.13 321.626 1076.13 319.92C1076.13 318.214 1074.75 316.83 1073.03 316.83Z"
            fill="white"
          />
          <path
            d="M1058.59 321.68C1056.91 321.68 1055.54 323.042 1055.54 324.718C1055.54 326.394 1056.9 327.757 1058.59 327.757C1060.28 327.757 1061.63 326.394 1061.63 324.718C1061.63 323.042 1060.27 321.68 1058.59 321.68Z"
            fill="white"
          />
          <path
            d="M1044.03 328.361C1042.4 328.361 1041.06 329.681 1041.06 331.319C1041.06 332.957 1042.4 334.286 1044.03 334.286C1045.66 334.286 1047 332.953 1047 331.319C1047 329.685 1045.66 328.361 1044.03 328.361Z"
            fill="white"
          />
          <path
            d="M1029.52 337.217C1027.91 337.217 1026.61 338.52 1026.61 340.12C1026.61 341.719 1027.91 343.035 1029.52 343.035C1031.13 343.035 1032.42 341.732 1032.42 340.12C1032.42 338.507 1031.12 337.217 1029.52 337.217Z"
            fill="white"
          />
          <path
            d="M1015.75 348.865C1014.18 348.865 1012.9 350.147 1012.9 351.717C1012.9 353.287 1014.18 354.569 1015.75 354.569C1017.32 354.569 1018.6 353.287 1018.6 351.717C1018.6 350.147 1017.32 348.865 1015.75 348.865Z"
            fill="white"
          />
          <path
            d="M1003.22 363.654C1001.68 363.654 1000.43 364.902 1000.43 366.442C1000.43 367.983 1001.68 369.231 1003.22 369.231C1004.76 369.231 1006.01 367.983 1006.01 366.442C1006.01 364.902 1004.76 363.654 1003.22 363.654Z"
            fill="white"
          />
          <path
            d="M993.013 382.078C991.524 382.078 990.306 383.283 990.306 384.786C990.306 386.288 991.524 387.493 993.013 387.493C994.503 387.493 995.721 386.275 995.721 384.786C995.721 383.296 994.511 382.078 993.013 382.078Z"
            fill="white"
          />
          <path
            d="M985.997 404.139C984.542 404.139 983.354 405.327 983.354 406.783C983.354 408.238 984.542 409.426 985.997 409.426C987.453 409.426 988.641 408.251 988.641 406.783C988.641 405.314 987.453 404.139 985.997 404.139Z"
            fill="white"
          />
          <path
            d="M983.926 430.18C982.5 430.18 981.333 431.347 981.333 432.773C981.333 434.199 982.5 435.353 983.926 435.353C985.352 435.353 986.506 434.199 986.506 432.773C986.506 431.347 985.352 430.18 983.926 430.18Z"
            fill="white"
          />
          <path
            d="M988.318 459.951C986.913 459.951 985.78 461.084 985.78 462.48C985.78 463.877 986.913 465.01 988.318 465.01C989.723 465.01 990.847 463.877 990.847 462.48C990.847 461.084 989.714 459.951 988.318 459.951Z"
            fill="white"
          />
          <path
            d="M999.194 492.928C997.841 492.928 996.75 494.031 996.75 495.372C996.75 496.713 997.845 497.817 999.194 497.817C1000.54 497.817 1001.64 496.722 1001.64 495.372C1001.64 494.023 1000.54 492.928 999.194 492.928Z"
            fill="white"
          />
          <path
            d="M1014.24 528.869C1012.92 528.869 1011.85 529.943 1011.85 531.263C1011.85 532.582 1012.92 533.656 1014.24 533.656C1015.56 533.656 1016.64 532.582 1016.64 531.263C1016.64 529.943 1015.56 528.869 1014.24 528.869Z"
            fill="white"
          />
          <path
            d="M1029.45 567.814C1028.16 567.814 1027.11 568.867 1027.11 570.157C1027.11 571.447 1028.16 572.487 1029.45 572.487C1030.74 572.487 1031.78 571.447 1031.78 570.157C1031.78 568.867 1030.74 567.814 1029.45 567.814Z"
            fill="white"
          />
          <path
            d="M1042.15 610.342C1040.89 610.342 1039.87 611.36 1039.87 612.621C1039.87 613.881 1040.89 614.912 1042.15 614.912C1043.41 614.912 1044.43 613.894 1044.43 612.621C1044.43 611.348 1043.4 610.342 1042.15 610.342Z"
            fill="white"
          />
          <path
            d="M1051.55 657.324C1050.34 657.324 1049.35 658.305 1049.35 659.531C1049.35 660.757 1050.34 661.725 1051.55 661.725C1052.77 661.725 1053.76 660.745 1053.76 659.531C1053.76 658.317 1052.77 657.324 1051.55 657.324Z"
            fill="white"
          />
          <path
            d="M117.687 678.932C116.843 678.932 116.155 679.619 116.155 680.464C116.155 681.308 116.843 682.004 117.687 682.004C118.532 682.004 119.228 681.317 119.228 680.464C119.228 679.611 118.54 678.932 117.687 678.932Z"
            fill="white"
          />
          <path
            d="M92.882 666.344C92.029 666.344 91.333 667.031 91.333 667.884C91.333 668.737 92.029 669.425 92.882 669.425C93.735 669.425 94.4225 668.737 94.4225 667.884C94.4225 667.031 93.7265 666.344 92.882 666.344Z"
            fill="white"
          />
          <path
            d="M66.6352 652.67C65.7823 652.67 65.082 653.357 65.082 654.219C65.082 655.08 65.778 655.768 66.6352 655.768C67.4925 655.768 68.1969 655.08 68.1969 654.219C68.1969 653.357 67.501 652.67 66.6352 652.67Z"
            fill="white"
          />
          <path
            d="M38.0246 636.631C37.1588 636.631 36.4756 637.327 36.4756 638.18C36.4756 639.033 37.1631 639.742 38.0246 639.742C38.886 639.742 39.5735 639.046 39.5735 638.18C39.5735 637.314 38.8775 636.631 38.0246 636.631Z"
            fill="white"
          />
          <path
            d="M7.50671 603.639C6.64099 603.639 5.93652 604.347 5.93652 605.222C5.93652 606.096 6.64523 606.792 7.50671 606.792C8.36819 606.792 9.08963 606.083 9.08963 605.222C9.08963 604.36 8.38092 603.639 7.50671 603.639Z"
            fill="white"
          />
          <path
            d="M1185.08 -4.50391C1183.54 -4.50391 1182.28 -3.25624 1182.28 -1.70728C1182.28 -0.158307 1183.54 1.0936 1185.08 1.0936C1186.62 1.0936 1187.88 -0.162551 1187.88 -1.70728C1187.88 -3.252 1186.63 -4.50391 1185.08 -4.50391Z"
            fill="white"
          />
          <path
            d="M1192.09 7.47266C1190.5 7.47266 1189.21 8.76276 1189.21 10.3626C1189.21 11.9625 1190.5 13.2526 1192.09 13.2526C1193.69 13.2526 1194.99 11.9625 1194.99 10.3626C1194.99 8.76276 1193.7 7.47266 1192.09 7.47266Z"
            fill="white"
          />
          <path
            d="M1199.15 19.4668C1197.52 19.4668 1196.2 20.7824 1196.2 22.412C1196.2 24.0416 1197.53 25.3571 1199.15 25.3571C1200.77 25.3571 1202.09 24.0331 1202.09 22.412C1202.09 20.7908 1200.77 19.4668 1199.15 19.4668Z"
            fill="white"
          />
          <path
            d="M1206.33 31.248C1204.67 31.248 1203.32 32.6018 1203.32 34.2569C1203.32 35.9119 1204.67 37.2657 1206.33 37.2657C1208 37.2657 1209.33 35.9162 1209.33 34.2569C1209.33 32.5976 1207.99 31.248 1206.33 31.248Z"
            fill="white"
          />
          <path
            d="M1213.64 42.8184C1211.95 42.8184 1210.58 44.1806 1210.58 45.8696C1210.58 47.5586 1211.95 48.9209 1213.64 48.9209C1215.32 48.9209 1216.69 47.5586 1216.69 45.8696C1216.69 44.1806 1215.32 42.8184 1213.64 42.8184Z"
            fill="white"
          />
          <path
            d="M1221.05 54.1758C1219.32 54.1758 1217.91 55.5805 1217.91 57.3119C1217.91 59.0434 1219.32 60.448 1221.05 60.448C1222.77 60.448 1224.19 59.0434 1224.19 57.3119C1224.19 55.5805 1222.79 54.1758 1221.05 54.1758Z"
            fill="white"
          />
          <path
            d="M1228.52 65.459C1226.76 65.459 1225.33 66.8849 1225.33 68.6418C1225.33 70.3987 1226.76 71.8288 1228.52 71.8288C1230.28 71.8288 1231.7 70.403 1231.7 68.6418C1231.7 66.8806 1230.28 65.459 1228.52 65.459Z"
            fill="white"
          />
          <path
            d="M1235.97 76.748C1234.18 76.748 1232.73 78.2037 1232.73 79.9903C1232.73 81.7769 1234.18 83.2282 1235.97 83.2282C1237.76 83.2282 1239.21 81.7769 1239.21 79.9903C1239.21 78.2037 1237.76 76.748 1235.97 76.748Z"
            fill="white"
          />
          <path
            d="M1243.4 88.084C1241.59 88.084 1240.11 89.5523 1240.11 91.3729C1240.11 93.1935 1241.59 94.6618 1243.4 94.6618C1245.21 94.6618 1246.69 93.185 1246.69 91.3729C1246.69 89.5608 1245.22 88.084 1243.4 88.084Z"
            fill="white"
          />
          <path
            d="M1250.77 99.502C1248.91 99.502 1247.41 101.013 1247.41 102.863C1247.41 104.713 1248.91 106.224 1250.77 106.224C1252.64 106.224 1254.14 104.726 1254.14 102.863C1254.14 101 1252.62 99.502 1250.77 99.502Z"
            fill="white"
          />
          <path
            d="M1258.04 111.092C1256.15 111.092 1254.63 112.615 1254.63 114.512C1254.63 116.409 1256.16 117.928 1258.04 117.928C1259.92 117.928 1261.45 116.396 1261.45 114.512C1261.45 112.628 1259.92 111.092 1258.04 111.092Z"
            fill="white"
          />
          <path
            d="M1265.18 129.8C1267.09 129.8 1268.64 128.247 1268.64 126.332C1268.64 124.418 1267.09 122.865 1265.18 122.865C1263.26 122.865 1261.71 124.418 1261.71 126.332C1261.71 128.247 1263.26 129.8 1265.18 129.8Z"
            fill="white"
          />
          <path
            d="M1272.21 134.793C1270.28 134.793 1268.7 136.363 1268.7 138.303C1268.7 140.242 1270.27 141.808 1272.21 141.808C1274.15 141.808 1275.72 140.242 1275.72 138.303C1275.72 136.363 1274.16 134.793 1272.21 134.793Z"
            fill="white"
          />
          <path
            d="M1279.18 146.805C1277.2 146.805 1275.59 148.409 1275.59 150.386C1275.59 152.364 1277.2 153.968 1279.18 153.968C1281.15 153.968 1282.76 152.364 1282.76 150.386C1282.76 148.409 1281.15 146.805 1279.18 146.805Z"
            fill="white"
          />
          <path
            d="M1286.14 158.797C1284.13 158.797 1282.51 160.426 1282.51 162.43C1282.51 164.433 1284.13 166.062 1286.14 166.062C1288.15 166.062 1289.76 164.433 1289.76 162.43C1289.76 160.426 1288.13 158.797 1286.14 158.797Z"
            fill="white"
          />
          <path
            d="M1293.17 170.586C1291.14 170.586 1289.5 172.233 1289.5 174.261C1289.5 176.29 1291.14 177.936 1293.17 177.936C1295.2 177.936 1296.85 176.29 1296.85 174.261C1296.85 172.233 1295.2 170.586 1293.17 170.586Z"
            fill="white"
          />
          <path
            d="M1300.4 181.941C1298.36 181.941 1296.7 183.596 1296.7 185.646C1296.7 187.696 1298.36 189.351 1300.4 189.351C1302.44 189.351 1304.1 187.687 1304.1 185.646C1304.1 183.605 1302.45 181.941 1300.4 181.941Z"
            fill="white"
          />
          <path
            d="M1307.91 192.547C1305.83 192.547 1304.14 194.232 1304.14 196.315C1304.14 198.399 1305.83 200.071 1307.91 200.071C1309.99 200.071 1311.68 198.386 1311.68 196.315C1311.68 194.244 1309.99 192.547 1307.91 192.547Z"
            fill="white"
          />
          <path
            d="M1315.79 202.164C1313.69 202.164 1311.98 203.87 1311.98 205.975C1311.98 208.08 1313.69 209.786 1315.79 209.786C1317.9 209.786 1319.6 208.088 1319.6 205.975C1319.6 203.862 1317.9 202.164 1315.79 202.164Z"
            fill="white"
          />
          <path
            d="M1324.07 210.576C1321.95 210.576 1320.23 212.295 1320.23 214.417C1320.23 216.539 1321.95 218.266 1324.07 218.266C1326.19 218.266 1327.91 216.539 1327.91 214.417C1327.91 212.295 1326.19 210.576 1324.07 210.576Z"
            fill="white"
          />
          <path
            d="M1332.66 217.787C1330.52 217.787 1328.78 219.527 1328.78 221.67C1328.78 223.813 1330.52 225.553 1332.66 225.553C1334.8 225.553 1336.55 223.817 1336.55 221.67C1336.55 219.523 1334.81 217.787 1332.66 217.787Z"
            fill="white"
          />
          <path
            d="M1341.56 223.738C1339.38 223.738 1337.62 225.499 1337.62 227.672C1337.62 229.845 1339.39 231.606 1341.56 231.606C1343.73 231.606 1345.49 229.849 1345.49 227.672C1345.49 225.495 1343.74 223.738 1341.56 223.738Z"
            fill="white"
          />
          <path
            d="M1350.65 228.59C1348.45 228.59 1346.68 230.368 1346.68 232.553C1346.68 234.739 1348.45 236.517 1350.65 236.517C1352.84 236.517 1354.61 234.748 1354.61 232.553C1354.61 230.359 1352.83 228.59 1350.65 228.59Z"
            fill="white"
          />
          <path
            d="M1359.87 240.374C1362.07 240.374 1363.86 238.584 1363.86 236.377C1363.86 234.169 1362.07 232.379 1359.87 232.379C1357.66 232.379 1355.87 234.169 1355.87 236.377C1355.87 238.584 1357.66 240.374 1359.87 240.374Z"
            fill="white"
          />
          <path
            d="M1369.12 235.273C1366.9 235.273 1365.09 237.073 1365.09 239.301C1365.09 241.529 1366.9 243.328 1369.12 243.328C1371.33 243.328 1373.15 241.516 1373.15 239.301C1373.15 237.086 1371.35 235.273 1369.12 235.273Z"
            fill="white"
          />
          <path
            d="M1378.42 237.322C1376.17 237.322 1374.35 239.143 1374.35 241.392C1374.35 243.641 1376.17 245.449 1378.42 245.449C1380.67 245.449 1382.48 243.628 1382.48 241.392C1382.48 239.156 1380.66 237.322 1378.42 237.322Z"
            fill="white"
          />
          <path
            d="M1387.66 238.799C1385.39 238.799 1383.56 240.632 1383.56 242.898C1383.56 245.164 1385.39 246.989 1387.66 246.989C1389.93 246.989 1391.75 245.156 1391.75 242.898C1391.75 240.641 1389.92 238.799 1387.66 238.799Z"
            fill="white"
          />
          <path
            d="M1396.89 239.729C1394.61 239.729 1392.77 241.57 1392.77 243.849C1392.77 246.128 1394.61 247.97 1396.89 247.97C1399.17 247.97 1401.01 246.128 1401.01 243.849C1401.01 241.57 1399.17 239.729 1396.89 239.729Z"
            fill="white"
          />
          <path
            d="M1406.04 240.32C1403.75 240.32 1401.9 242.175 1401.9 244.462C1401.9 246.75 1403.75 248.604 1406.04 248.604C1408.33 248.604 1410.18 246.75 1410.18 244.462C1410.18 242.175 1408.33 240.32 1406.04 240.32Z"
            fill="white"
          />
          <path
            d="M1415.2 240.611C1412.91 240.611 1411.04 242.474 1411.04 244.766C1411.04 247.058 1412.91 248.921 1415.2 248.921C1417.49 248.921 1419.35 247.066 1419.35 244.766C1419.35 242.466 1417.5 240.611 1415.2 240.611Z"
            fill="white"
          />
          <path
            d="M1424.33 240.775C1422.03 240.775 1420.17 242.638 1420.17 244.93C1420.17 247.222 1422.03 249.085 1424.33 249.085C1426.63 249.085 1428.49 247.222 1428.49 244.93C1428.49 242.638 1426.63 240.775 1424.33 240.775Z"
            fill="white"
          />
          <path
            d="M1433.47 240.871C1431.18 240.871 1429.32 242.734 1429.32 245.026C1429.32 247.317 1431.18 249.18 1433.47 249.18C1435.76 249.18 1437.63 247.33 1437.63 245.026C1437.63 242.721 1435.77 240.871 1433.47 240.871Z"
            fill="white"
          />
          <path
            d="M1442.64 240.963C1440.35 240.963 1438.49 242.817 1438.49 245.118C1438.49 247.418 1440.35 249.272 1442.64 249.272C1444.93 249.272 1446.8 247.409 1446.8 245.118C1446.8 242.826 1444.95 240.963 1442.64 240.963Z"
            fill="white"
          />
          <path
            d="M1451.78 240.934C1449.49 240.934 1447.63 242.788 1447.63 245.088C1447.63 247.388 1449.49 249.243 1451.78 249.243C1454.07 249.243 1455.94 247.38 1455.94 245.088C1455.94 242.797 1454.08 240.934 1451.78 240.934Z"
            fill="white"
          />
          <path
            d="M1452.33 258.396C1450.03 258.396 1448.18 260.259 1448.18 262.551C1448.18 264.843 1450.03 266.706 1452.33 266.706C1454.63 266.706 1456.49 264.851 1456.49 262.551C1456.49 260.251 1454.62 258.396 1452.33 258.396Z"
            fill="white"
          />
          <path
            d="M1446.17 261.041C1443.88 261.041 1442.02 262.904 1442.02 265.196C1442.02 267.487 1443.88 269.359 1446.17 269.359C1448.47 269.359 1450.33 267.496 1450.33 265.196C1450.33 262.896 1448.47 261.041 1446.17 261.041Z"
            fill="white"
          />
          <path
            d="M1439.49 263.842C1437.19 263.842 1435.33 265.692 1435.33 267.996C1435.33 270.301 1437.19 272.151 1439.49 272.151C1441.79 272.151 1443.64 270.288 1443.64 267.996C1443.64 265.705 1441.78 263.842 1439.49 263.842Z"
            fill="white"
          />
          <path
            d="M1432.21 266.816C1429.92 266.816 1428.06 268.679 1428.06 270.971C1428.06 273.263 1429.92 275.126 1432.21 275.126C1434.51 275.126 1436.38 273.263 1436.38 270.971C1436.38 268.679 1434.51 266.816 1432.21 266.816Z"
            fill="white"
          />
          <path
            d="M1424.39 270.139C1422.09 270.139 1420.23 272.002 1420.23 274.293C1420.23 276.585 1422.09 278.448 1424.39 278.448C1426.68 278.448 1428.54 276.593 1428.54 274.293C1428.54 271.993 1426.68 270.139 1424.39 270.139Z"
            fill="white"
          />
          <path
            d="M1416 273.832C1413.71 273.832 1411.84 275.695 1411.84 277.987C1411.84 280.278 1413.71 282.141 1416 282.141C1418.29 282.141 1420.15 280.287 1420.15 277.987C1420.15 275.687 1418.3 273.832 1416 273.832Z"
            fill="white"
          />
          <path
            d="M1407.06 277.914C1404.77 277.914 1402.9 279.769 1402.9 282.069C1402.9 284.369 1404.77 286.223 1407.06 286.223C1409.35 286.223 1411.21 284.36 1411.21 282.069C1411.21 279.777 1409.35 277.914 1407.06 277.914Z"
            fill="white"
          />
          <path
            d="M1397.56 282.367C1395.27 282.367 1393.41 284.23 1393.41 286.522C1393.41 288.813 1395.27 290.676 1397.56 290.676C1399.86 290.676 1401.72 288.813 1401.72 286.522C1401.72 284.23 1399.86 282.367 1397.56 282.367Z"
            fill="white"
          />
          <path
            d="M1387.53 287.143C1385.24 287.143 1383.4 288.997 1383.4 291.276C1383.4 293.555 1385.24 295.409 1387.53 295.409C1389.82 295.409 1391.65 293.555 1391.65 291.276C1391.65 288.997 1389.81 287.143 1387.53 287.143Z"
            fill="white"
          />
          <path
            d="M1376.97 292.088C1374.71 292.088 1372.87 293.93 1372.87 296.187C1372.87 298.445 1374.71 300.287 1376.97 300.287C1379.23 300.287 1381.07 298.454 1381.07 296.187C1381.07 293.921 1379.23 292.088 1376.97 292.088Z"
            fill="white"
          />
          <path
            d="M1365.94 297.025C1363.69 297.025 1361.87 298.846 1361.87 301.095C1361.87 303.344 1363.69 305.165 1365.94 305.165C1368.19 305.165 1369.99 303.344 1369.99 301.095C1369.99 298.846 1368.17 297.025 1365.94 297.025Z"
            fill="white"
          />
          <path
            d="M1354.39 301.875C1352.16 301.875 1350.34 303.687 1350.34 305.924C1350.34 308.16 1352.16 309.964 1354.39 309.964C1356.63 309.964 1358.43 308.151 1358.43 305.924C1358.43 303.696 1356.62 301.875 1354.39 301.875Z"
            fill="white"
          />
          <path
            d="M1342.2 306.514C1339.98 306.514 1338.18 308.313 1338.18 310.541C1338.18 312.769 1339.98 314.56 1342.2 314.56C1344.42 314.56 1346.22 312.76 1346.22 310.541C1346.22 308.322 1344.42 306.514 1342.2 306.514Z"
            fill="white"
          />
          <path
            d="M1329.41 310.74C1327.21 310.74 1325.43 312.518 1325.43 314.725C1325.43 316.932 1327.21 318.702 1329.41 318.702C1331.6 318.702 1333.39 316.923 1333.39 314.725C1333.39 312.527 1331.61 310.74 1329.41 310.74Z"
            fill="white"
          />
          <path
            d="M1316.14 314.342C1313.98 314.342 1312.21 316.103 1312.21 318.276C1312.21 320.449 1313.98 322.21 1316.14 322.21C1318.31 322.21 1320.09 320.453 1320.09 318.276C1320.09 316.099 1318.32 314.342 1316.14 314.342Z"
            fill="white"
          />
          <path
            d="M1302.41 317.287C1300.25 317.287 1298.5 319.036 1298.5 321.191C1298.5 323.347 1300.25 325.096 1302.41 325.096C1304.56 325.096 1306.32 323.347 1306.32 321.191C1306.32 319.036 1304.57 317.287 1302.41 317.287Z"
            fill="white"
          />
          <path
            d="M1288.3 319.424C1286.16 319.424 1284.43 321.151 1284.43 323.294C1284.43 325.437 1286.16 327.164 1288.3 327.164C1290.45 327.164 1292.18 325.437 1292.18 323.294C1292.18 321.151 1290.45 319.424 1288.3 319.424Z"
            fill="white"
          />
          <path
            d="M1274.05 320.635C1271.95 320.635 1270.24 322.353 1270.24 324.454C1270.24 326.555 1271.95 328.274 1274.05 328.274C1276.16 328.274 1277.87 326.555 1277.87 324.454C1277.87 322.353 1276.17 320.635 1274.05 320.635Z"
            fill="white"
          />
          <path
            d="M1259.82 321.035C1257.74 321.035 1256.04 322.733 1256.04 324.825C1256.04 326.917 1257.74 328.602 1259.82 328.602C1261.9 328.602 1263.61 326.917 1263.61 324.825C1263.61 322.733 1261.91 321.035 1259.82 321.035Z"
            fill="white"
          />
          <path
            d="M1245.63 320.713C1243.57 320.713 1241.9 322.389 1241.9 324.452C1241.9 326.514 1243.57 328.199 1245.63 328.199C1247.69 328.199 1249.38 326.523 1249.38 324.452C1249.38 322.381 1247.7 320.713 1245.63 320.713Z"
            fill="white"
          />
          <path
            d="M1231.62 319.689C1229.58 319.689 1227.94 321.345 1227.94 323.386C1227.94 325.427 1229.58 327.082 1231.62 327.082C1233.66 327.082 1235.32 325.427 1235.32 323.386C1235.32 321.345 1233.66 319.689 1231.62 319.689Z"
            fill="white"
          />
          <path
            d="M1217.93 318.199C1215.93 318.199 1214.29 319.825 1214.29 321.832C1214.29 323.839 1215.93 325.465 1217.93 325.465C1219.92 325.465 1221.57 323.839 1221.57 321.832C1221.57 319.825 1219.93 318.199 1217.93 318.199Z"
            fill="white"
          />
          <path
            d="M1204.44 316.529C1202.46 316.529 1200.85 318.133 1200.85 320.12C1200.85 322.106 1202.46 323.71 1204.44 323.71C1206.41 323.71 1208.03 322.097 1208.03 320.12C1208.03 318.142 1206.42 316.529 1204.44 316.529Z"
            fill="white"
          />
          <path
            d="M1191.07 314.82C1189.12 314.82 1187.52 316.403 1187.52 318.368C1187.52 320.333 1189.12 321.916 1191.07 321.916C1193.03 321.916 1194.62 320.324 1194.62 318.368C1194.62 316.412 1193.04 314.82 1191.07 314.82Z"
            fill="white"
          />
          <path
            d="M1177.86 313.26C1175.93 313.26 1174.36 314.83 1174.36 316.757C1174.36 318.683 1175.93 320.262 1177.86 320.262C1179.78 320.262 1181.36 318.692 1181.36 316.757C1181.36 314.821 1179.79 313.26 1177.86 313.26Z"
            fill="white"
          />
          <path
            d="M1164.72 311.988C1162.83 311.988 1161.29 313.529 1161.29 315.421C1161.29 317.314 1162.83 318.846 1164.72 318.846C1166.61 318.846 1168.14 317.318 1168.14 315.421C1168.14 313.525 1166.61 311.988 1164.72 311.988Z"
            fill="white"
          />
          <path
            d="M1151.5 311.041C1149.63 311.041 1148.11 312.552 1148.11 314.423C1148.11 316.295 1149.63 317.806 1151.5 317.806C1153.37 317.806 1154.89 316.286 1154.89 314.423C1154.89 312.56 1153.37 311.041 1151.5 311.041Z"
            fill="white"
          />
          <path
            d="M1138.96 317.18C1140.75 316.758 1141.86 314.963 1141.44 313.173C1141.02 311.382 1139.22 310.273 1137.43 310.696C1135.64 311.118 1134.53 312.913 1134.95 314.703C1135.38 316.494 1137.17 317.603 1138.96 317.18Z"
            fill="white"
          />
          <path
            d="M1124.8 310.654C1122.99 310.654 1121.51 312.123 1121.51 313.935C1121.51 315.747 1122.99 317.224 1124.8 317.224C1126.61 317.224 1128.08 315.747 1128.08 313.935C1128.08 312.123 1126.61 310.654 1124.8 310.654Z"
            fill="white"
          />
          <path
            d="M1111.15 311.479C1109.37 311.479 1107.93 312.917 1107.93 314.683C1107.93 316.448 1109.37 317.899 1111.15 317.899C1112.93 317.899 1114.35 316.465 1114.35 314.683C1114.35 312.9 1112.92 311.479 1111.15 311.479Z"
            fill="white"
          />
          <path
            d="M1097.33 313.176C1095.59 313.176 1094.17 314.593 1094.17 316.329C1094.17 318.065 1095.59 319.482 1097.33 319.482C1099.06 319.482 1100.49 318.065 1100.49 316.329C1100.49 314.593 1099.08 313.176 1097.33 313.176Z"
            fill="white"
          />
          <path
            d="M1083.29 315.891C1081.58 315.891 1080.2 317.274 1080.2 318.993C1080.2 320.712 1081.58 322.082 1083.29 322.082C1085 322.082 1086.39 320.699 1086.39 318.993C1086.39 317.287 1085.01 315.891 1083.29 315.891Z"
            fill="white"
          />
          <path
            d="M1068.97 319.92C1067.29 319.92 1065.93 321.274 1065.93 322.958C1065.93 324.643 1067.29 325.997 1068.97 325.997C1070.64 325.997 1072.01 324.635 1072.01 322.958C1072.01 321.282 1070.65 319.92 1068.97 319.92Z"
            fill="white"
          />
          <path
            d="M1054.61 325.686C1052.97 325.686 1051.64 327.01 1051.64 328.643C1051.64 330.277 1052.97 331.601 1054.61 331.601C1056.24 331.601 1057.56 330.282 1057.56 328.643C1057.56 327.005 1056.24 325.686 1054.61 325.686Z"
            fill="white"
          />
          <path
            d="M1040.14 333.375C1038.53 333.375 1037.24 334.678 1037.24 336.278C1037.24 337.878 1038.54 339.18 1040.14 339.18C1041.74 339.18 1043.04 337.878 1043.04 336.278C1043.04 334.678 1041.74 333.375 1040.14 333.375Z"
            fill="white"
          />
          <path
            d="M1026.23 343.65C1024.66 343.65 1023.38 344.919 1023.38 346.494C1023.38 348.068 1024.66 349.345 1026.23 349.345C1027.8 349.345 1029.08 348.064 1029.08 346.494C1029.08 344.923 1027.81 343.65 1026.23 343.65Z"
            fill="white"
          />
          <path
            d="M1013.25 356.805C1011.71 356.805 1010.47 358.052 1010.47 359.584C1010.47 361.116 1011.71 362.372 1013.25 362.372C1014.79 362.372 1016.04 361.125 1016.04 359.584C1016.04 358.044 1014.79 356.805 1013.25 356.805Z"
            fill="white"
          />
          <path
            d="M1002.37 373.457C1000.87 373.457 999.662 374.662 999.662 376.165C999.662 377.667 1000.87 378.859 1002.37 378.859C1003.87 378.859 1005.06 377.65 1005.06 376.165C1005.06 374.679 1003.85 373.457 1002.37 373.457Z"
            fill="white"
          />
          <path
            d="M994.146 393.473C992.69 393.473 991.515 394.648 991.515 396.117C991.515 397.585 992.69 398.76 994.146 398.76C995.601 398.76 996.79 397.572 996.79 396.117C996.79 394.661 995.614 393.473 994.146 393.473Z"
            fill="white"
          />
          <path
            d="M990.22 417.316C988.786 417.316 987.627 418.471 987.627 419.909C987.627 421.348 988.781 422.502 990.22 422.502C991.659 422.502 992.813 421.335 992.813 419.909C992.813 418.483 991.646 417.316 990.22 417.316Z"
            fill="white"
          />
          <path
            d="M992.082 445.041C990.686 445.041 989.553 446.174 989.553 447.57C989.553 448.967 990.686 450.1 992.082 450.1C993.478 450.1 994.611 448.967 994.611 447.57C994.611 446.174 993.487 445.041 992.082 445.041Z"
            fill="white"
          />
          <path
            d="M1000.75 476.297C999.391 476.297 998.296 477.392 998.296 478.741C998.296 480.091 999.391 481.198 1000.75 481.198C1002.12 481.198 1003.2 480.095 1003.2 478.741C1003.2 477.388 1002.1 476.297 1000.75 476.297Z"
            fill="white"
          />
          <path
            d="M1014.78 510.633C1013.46 510.633 1012.39 511.706 1012.39 513.026C1012.39 514.346 1013.46 515.432 1014.78 515.432C1016.1 515.432 1017.18 514.35 1017.18 513.026C1017.18 511.702 1016.1 510.633 1014.78 510.633Z"
            fill="white"
          />
          <path
            d="M1030.3 547.926C1029.01 547.926 1027.97 548.978 1027.97 550.268C1027.97 551.558 1029.01 552.611 1030.3 552.611C1031.59 552.611 1032.64 551.558 1032.64 550.268C1032.64 548.978 1031.6 547.926 1030.3 547.926Z"
            fill="white"
          />
          <path
            d="M1043.94 588.383C1042.68 588.383 1041.65 589.401 1041.65 590.674C1041.65 591.948 1042.67 592.966 1043.94 592.966C1045.22 592.966 1046.23 591.935 1046.23 590.674C1046.23 589.414 1045.21 588.383 1043.94 588.383Z"
            fill="white"
          />
          <path
            d="M1054.56 632.895C1053.34 632.895 1052.36 633.883 1052.36 635.101C1052.36 636.319 1053.34 637.308 1054.56 637.308C1055.78 637.308 1056.77 636.319 1056.77 635.101C1056.77 633.883 1055.78 632.895 1054.56 632.895Z"
            fill="white"
          />
          <path
            d="M64.6499 666.65C63.7969 666.65 63.1094 667.346 63.1094 668.199C63.1094 669.052 63.7969 669.74 64.6499 669.74C65.5028 669.74 66.1988 669.052 66.1988 668.199C66.1988 667.346 65.5028 666.65 64.6499 666.65Z"
            fill="white"
          />
          <path
            d="M37.1926 651.516C36.3268 651.516 35.6309 652.212 35.6309 653.065C35.6309 653.918 36.3268 654.614 37.1926 654.614C38.0583 654.614 38.7415 653.926 38.7415 653.065C38.7415 652.203 38.0456 651.516 37.1926 651.516Z"
            fill="white"
          />
          <path
            d="M6.36053 620.541C7.22303 620.541 7.92223 619.842 7.92223 618.98C7.92223 618.117 7.22303 617.418 6.36053 617.418C5.49802 617.418 4.79883 618.117 4.79883 618.98C4.79883 619.842 5.49802 620.541 6.36053 620.541Z"
            fill="white"
          />
          <path
            d="M1208.71 2.08789C1207.12 2.08789 1205.83 3.37799 1205.83 4.9694C1205.83 6.5608 1207.12 7.85939 1208.71 7.85939C1210.3 7.85939 1211.59 6.56505 1211.59 4.9694C1211.59 3.37375 1210.3 2.08789 1208.71 2.08789Z"
            fill="white"
          />
          <path
            d="M1215.88 13.957C1214.24 13.957 1212.93 15.2768 1212.93 16.9022C1212.93 18.5276 1214.24 19.8474 1215.88 19.8474C1217.51 19.8474 1218.81 18.5233 1218.81 16.9022C1218.81 15.2811 1217.5 13.957 1215.88 13.957Z"
            fill="white"
          />
          <path
            d="M1223.13 25.6992C1221.47 25.6992 1220.12 27.0402 1220.12 28.6953C1220.12 30.3504 1221.47 31.7041 1223.13 31.7041C1224.78 31.7041 1226.14 30.3631 1226.14 28.6953C1226.14 27.0275 1224.78 25.6992 1223.13 25.6992Z"
            fill="white"
          />
          <path
            d="M1230.49 37.2695C1228.81 37.2695 1227.45 38.6403 1227.45 40.3123C1227.45 41.9843 1228.81 43.3636 1230.49 43.3636C1232.16 43.3636 1233.54 42.0013 1233.54 40.3123C1233.54 38.6233 1232.18 37.2695 1230.49 37.2695Z"
            fill="white"
          />
          <path
            d="M1237.9 54.9982C1239.63 54.9982 1241.03 53.596 1241.03 51.8663C1241.03 50.1366 1239.63 48.7344 1237.9 48.7344C1236.17 48.7344 1234.77 50.1366 1234.77 51.8663C1234.77 53.596 1236.17 54.9982 1237.9 54.9982Z"
            fill="white"
          />
          <path
            d="M1245.35 60.1367C1243.59 60.1367 1242.16 61.5626 1242.16 63.3153C1242.16 65.068 1243.59 66.4981 1245.35 66.4981C1247.11 66.4981 1248.53 65.0722 1248.53 63.3153C1248.53 61.5584 1247.11 60.1367 1245.35 60.1367Z"
            fill="white"
          />
          <path
            d="M1255.09 77.0591C1256.35 75.7946 1256.35 73.7444 1255.09 72.4799C1253.82 71.2154 1251.77 71.2154 1250.51 72.4799C1249.24 73.7444 1249.24 75.7946 1250.51 77.0591C1251.77 78.3236 1253.82 78.3236 1255.09 77.0591Z"
            fill="white"
          />
          <path
            d="M1260.2 82.9648C1258.38 82.9648 1256.91 84.4417 1256.91 86.2665C1256.91 88.0913 1258.38 89.5596 1260.2 89.5596C1262.02 89.5596 1263.5 88.087 1263.5 86.2665C1263.5 84.4459 1262.02 82.9648 1260.2 82.9648Z"
            fill="white"
          />
          <path
            d="M1267.51 94.5195C1265.65 94.5195 1264.14 96.0345 1264.14 97.8933C1264.14 99.7521 1265.65 101.267 1267.51 101.267C1269.37 101.267 1270.88 99.7563 1270.88 97.8933C1270.88 96.0303 1269.37 94.5195 1267.51 94.5195Z"
            fill="white"
          />
          <path
            d="M1274.69 106.268C1272.81 106.268 1271.28 107.8 1271.28 109.68C1271.28 111.56 1272.81 113.092 1274.69 113.092C1276.57 113.092 1278.11 111.56 1278.11 109.68C1278.11 107.8 1276.58 106.268 1274.69 106.268Z"
            fill="white"
          />
          <path
            d="M1281.74 118.209C1279.82 118.209 1278.27 119.758 1278.27 121.668C1278.27 123.577 1279.82 125.135 1281.74 125.135C1283.65 125.135 1285.2 123.586 1285.2 121.668C1285.2 119.749 1283.65 118.209 1281.74 118.209Z"
            fill="white"
          />
          <path
            d="M1288.7 130.266C1286.76 130.266 1285.19 131.836 1285.19 133.775C1285.19 135.715 1286.76 137.281 1288.7 137.281C1290.63 137.281 1292.2 135.71 1292.2 133.775C1292.2 131.84 1290.64 130.266 1288.7 130.266Z"
            fill="white"
          />
          <path
            d="M1295.62 142.352C1293.64 142.352 1292.04 143.956 1292.04 145.933C1292.04 147.911 1293.64 149.515 1295.62 149.515C1297.6 149.515 1299.19 147.911 1299.19 145.933C1299.19 143.956 1297.59 142.352 1295.62 142.352Z"
            fill="white"
          />
          <path
            d="M1302.55 154.371C1300.54 154.371 1298.92 155.996 1298.92 157.991C1298.92 159.986 1300.54 161.619 1302.55 161.619C1304.56 161.619 1306.17 159.994 1306.17 157.991C1306.17 155.988 1304.55 154.371 1302.55 154.371Z"
            fill="white"
          />
          <path
            d="M1309.59 166.121C1307.56 166.121 1305.91 167.768 1305.91 169.796C1305.91 171.825 1307.56 173.467 1309.59 173.467C1311.62 173.467 1313.26 171.82 1313.26 169.796C1313.26 167.772 1311.62 166.121 1309.59 166.121Z"
            fill="white"
          />
          <path
            d="M1316.83 177.371C1314.78 177.371 1313.13 179.035 1313.13 181.089C1313.13 183.143 1314.78 184.798 1316.83 184.798C1318.88 184.798 1320.55 183.138 1320.55 181.089C1320.55 179.039 1318.88 177.371 1316.83 177.371Z"
            fill="white"
          />
          <path
            d="M1324.39 187.867C1322.31 187.867 1320.62 189.552 1320.62 191.631C1320.62 193.711 1322.31 195.396 1324.39 195.396C1326.47 195.396 1328.15 193.711 1328.15 191.631C1328.15 189.552 1326.46 187.867 1324.39 187.867Z"
            fill="white"
          />
          <path
            d="M1332.3 197.346C1330.2 197.346 1328.49 199.052 1328.49 201.157C1328.49 203.261 1330.2 204.967 1332.3 204.967C1334.41 204.967 1336.1 203.261 1336.1 201.157C1336.1 199.052 1334.39 197.346 1332.3 197.346Z"
            fill="white"
          />
          <path
            d="M1344.13 210.909C1344.94 208.949 1344.01 206.702 1342.05 205.891C1340.09 205.079 1337.85 206.01 1337.04 207.969C1336.22 209.929 1337.16 212.176 1339.11 212.987C1341.07 213.799 1343.32 212.868 1344.13 210.909Z"
            fill="white"
          />
          <path
            d="M1349.18 212.561C1347.03 212.561 1345.29 214.309 1345.29 216.452C1345.29 218.595 1347.03 220.335 1349.18 220.335C1351.32 220.335 1353.07 218.595 1353.07 216.452C1353.07 214.309 1351.32 212.561 1349.18 212.561Z"
            fill="white"
          />
          <path
            d="M1358.05 218.254C1355.87 218.254 1354.11 220.015 1354.11 222.188C1354.11 224.361 1355.87 226.122 1358.05 226.122C1360.22 226.122 1361.98 224.352 1361.98 222.188C1361.98 220.024 1360.22 218.254 1358.05 218.254Z"
            fill="white"
          />
          <path
            d="M1367.07 222.846C1364.88 222.846 1363.11 224.615 1363.11 226.809C1363.11 229.003 1364.88 230.765 1367.07 230.765C1369.26 230.765 1371.03 228.995 1371.03 226.809C1371.03 224.624 1369.25 222.846 1367.07 222.846Z"
            fill="white"
          />
          <path
            d="M1379.89 231.923C1380.74 229.883 1379.77 227.545 1377.73 226.7C1375.69 225.855 1373.35 226.824 1372.51 228.863C1371.66 230.903 1372.63 233.242 1374.67 234.086C1376.71 234.931 1379.05 233.963 1379.89 231.923Z"
            fill="white"
          />
          <path
            d="M1385.33 229.154C1383.1 229.154 1381.3 230.966 1381.3 233.182C1381.3 235.397 1383.1 237.209 1385.33 237.209C1387.55 237.209 1389.35 235.41 1389.35 233.182C1389.35 230.954 1387.55 229.154 1385.33 229.154Z"
            fill="white"
          />
          <path
            d="M1394.46 231.182C1392.21 231.182 1390.39 233.002 1390.39 235.251C1390.39 237.501 1392.21 239.33 1394.46 239.33C1396.71 239.33 1398.54 237.496 1398.54 235.251C1398.54 233.006 1396.72 231.182 1394.46 231.182Z"
            fill="white"
          />
          <path
            d="M1403.54 232.744C1401.27 232.744 1399.44 234.577 1399.44 236.835C1399.44 239.093 1401.27 240.935 1403.54 240.935C1405.81 240.935 1407.63 239.101 1407.63 236.835C1407.63 234.569 1405.8 232.744 1403.54 232.744Z"
            fill="white"
          />
          <path
            d="M1412.61 233.848C1410.33 233.848 1408.48 235.698 1408.48 237.968C1408.48 240.239 1410.33 242.102 1412.61 242.102C1414.88 242.102 1416.73 240.247 1416.73 237.968C1416.73 235.689 1414.88 233.848 1412.61 233.848Z"
            fill="white"
          />
          <path
            d="M1421.61 234.723C1419.33 234.723 1417.47 236.577 1417.47 238.865C1417.47 241.152 1419.33 243.006 1421.61 243.006C1423.89 243.006 1425.75 241.143 1425.75 238.865C1425.75 236.586 1423.9 234.723 1421.61 234.723Z"
            fill="white"
          />
          <path
            d="M1430.64 235.396C1428.34 235.396 1426.48 237.247 1426.48 239.551C1426.48 241.855 1428.34 243.706 1430.64 243.706C1432.94 243.706 1434.79 241.843 1434.79 239.551C1434.79 237.259 1432.93 235.396 1430.64 235.396Z"
            fill="white"
          />
          <path
            d="M1439.65 236.035C1437.35 236.035 1435.48 237.898 1435.48 240.19C1435.48 242.481 1437.35 244.344 1439.65 244.344C1441.95 244.344 1443.8 242.494 1443.8 240.19C1443.8 237.885 1441.94 236.035 1439.65 236.035Z"
            fill="white"
          />
          <path
            d="M1448.65 236.52C1446.35 236.52 1444.49 238.374 1444.49 240.674C1444.49 242.974 1446.34 244.829 1448.65 244.829C1450.95 244.829 1452.8 242.966 1452.8 240.674C1452.8 238.383 1450.94 236.52 1448.65 236.52Z"
            fill="white"
          />
          <path
            d="M1452.8 259.973C1450.5 259.973 1448.65 261.836 1448.65 264.127C1448.65 266.419 1450.5 268.29 1452.8 268.29C1455.11 268.29 1456.96 266.427 1456.96 264.127C1456.96 261.827 1455.09 259.973 1452.8 259.973Z"
            fill="white"
          />
          <path
            d="M1445.52 262.803C1443.23 262.803 1441.37 264.666 1441.37 266.957C1441.37 269.249 1443.23 271.112 1445.52 271.112C1447.81 271.112 1449.68 269.257 1449.68 266.957C1449.68 264.657 1447.81 262.803 1445.52 262.803Z"
            fill="white"
          />
          <path
            d="M1437.63 265.863C1435.33 265.863 1433.47 267.726 1433.47 270.018C1433.47 272.31 1435.33 274.173 1437.63 274.173C1439.92 274.173 1441.78 272.31 1441.78 270.018C1441.78 267.726 1439.93 265.863 1437.63 265.863Z"
            fill="white"
          />
          <path
            d="M1429.1 269.213C1426.8 269.213 1424.95 271.076 1424.95 273.368C1424.95 275.659 1426.8 277.522 1429.1 277.522C1431.4 277.522 1433.25 275.668 1433.25 273.368C1433.25 271.067 1431.39 269.213 1429.1 269.213Z"
            fill="white"
          />
          <path
            d="M1420.01 273.014C1417.71 273.014 1415.85 274.877 1415.85 277.177C1415.85 279.477 1417.71 281.331 1420.01 281.331C1422.3 281.331 1424.16 279.468 1424.16 277.177C1424.16 274.885 1422.31 273.014 1420.01 273.014Z"
            fill="white"
          />
          <path
            d="M1410.39 277.236C1408.1 277.236 1406.23 279.099 1406.23 281.391C1406.23 283.683 1408.1 285.546 1410.39 285.546C1412.68 285.546 1414.54 283.695 1414.54 281.391C1414.54 279.087 1412.69 277.236 1410.39 277.236Z"
            fill="white"
          />
          <path
            d="M1400.26 281.912C1397.97 281.912 1396.13 283.767 1396.13 286.046C1396.13 288.324 1397.97 290.179 1400.26 290.179C1402.55 290.179 1404.39 288.324 1404.39 286.046C1404.39 283.767 1402.54 281.912 1400.26 281.912Z"
            fill="white"
          />
          <path
            d="M1389.64 286.928C1387.37 286.928 1385.54 288.761 1385.54 291.019C1385.54 293.276 1387.38 295.118 1389.64 295.118C1391.91 295.118 1393.74 293.285 1393.74 291.019C1393.74 288.753 1391.9 286.928 1389.64 286.928Z"
            fill="white"
          />
          <path
            d="M1378.56 292.102C1376.31 292.102 1374.49 293.922 1374.49 296.171C1374.49 298.421 1376.31 300.241 1378.56 300.241C1380.81 300.241 1382.63 298.421 1382.63 296.171C1382.63 293.922 1380.81 292.102 1378.56 292.102Z"
            fill="white"
          />
          <path
            d="M1367.01 297.254C1364.77 297.254 1362.96 299.066 1362.96 301.302C1362.96 303.539 1364.77 305.351 1367.01 305.351C1369.24 305.351 1371.06 303.539 1371.06 301.302C1371.06 299.066 1369.24 297.254 1367.01 297.254Z"
            fill="white"
          />
          <path
            d="M1354.82 302.342C1352.59 302.342 1350.79 304.141 1350.79 306.369C1350.79 308.597 1352.59 310.388 1354.82 310.388C1357.05 310.388 1358.85 308.589 1358.85 306.369C1358.85 304.15 1357.05 302.342 1354.82 302.342Z"
            fill="white"
          />
          <path
            d="M1342.03 307.199C1339.83 307.199 1338.05 308.977 1338.05 311.176C1338.05 313.374 1339.83 315.16 1342.03 315.16C1344.23 315.16 1346.02 313.37 1346.02 311.176C1346.02 308.982 1344.23 307.199 1342.03 307.199Z"
            fill="white"
          />
          <path
            d="M1328.72 311.543C1326.53 311.543 1324.78 313.313 1324.78 315.49C1324.78 317.667 1326.53 319.432 1328.72 319.432C1330.9 319.432 1332.66 317.671 1332.66 315.49C1332.66 313.308 1330.89 311.543 1328.72 311.543Z"
            fill="white"
          />
          <path
            d="M1314.87 315.195C1312.71 315.195 1310.96 316.944 1310.96 319.108C1310.96 321.272 1312.72 323.021 1314.87 323.021C1317.02 323.021 1318.79 321.272 1318.79 319.108C1318.79 316.944 1317.04 315.195 1314.87 315.195Z"
            fill="white"
          />
          <path
            d="M1300.59 318.141C1298.46 318.141 1296.72 319.881 1296.72 322.011C1296.72 324.141 1298.46 325.881 1300.59 325.881C1302.72 325.881 1304.46 324.154 1304.46 322.011C1304.46 319.868 1302.74 318.141 1300.59 318.141Z"
            fill="white"
          />
          <path
            d="M1286.09 320.211C1283.97 320.211 1282.26 321.917 1282.26 324.03C1282.26 326.144 1283.98 327.858 1286.09 327.858C1288.19 327.858 1289.91 326.139 1289.91 324.03C1289.91 321.921 1288.2 320.211 1286.09 320.211Z"
            fill="white"
          />
          <path
            d="M1271.53 321.285C1269.43 321.285 1267.74 322.983 1267.74 325.075C1267.74 327.167 1269.43 328.852 1271.53 328.852C1273.62 328.852 1275.32 327.167 1275.32 325.075C1275.32 322.983 1273.62 321.285 1271.53 321.285Z"
            fill="white"
          />
          <path
            d="M1256.99 321.553C1254.92 321.553 1253.25 323.229 1253.25 325.291C1253.25 327.354 1254.93 329.026 1256.99 329.026C1259.04 329.026 1260.72 327.35 1260.72 325.291C1260.72 323.233 1259.04 321.553 1256.99 321.553Z"
            fill="white"
          />
          <path
            d="M1242.63 321.064C1240.58 321.064 1238.92 322.728 1238.92 324.769C1238.92 326.81 1240.58 328.474 1242.63 328.474C1244.68 328.474 1246.32 326.819 1246.32 324.769C1246.32 322.72 1244.67 321.064 1242.63 321.064Z"
            fill="white"
          />
          <path
            d="M1228.56 319.939C1226.55 319.939 1224.93 321.573 1224.93 323.581C1224.93 325.588 1226.55 327.213 1228.56 327.213C1230.57 327.213 1232.19 325.579 1232.19 323.581C1232.19 321.582 1230.57 319.939 1228.56 319.939Z"
            fill="white"
          />
          <path
            d="M1214.79 318.393C1212.81 318.393 1211.2 319.997 1211.2 321.983C1211.2 323.969 1212.81 325.573 1214.79 325.573C1216.78 325.573 1218.38 323.96 1218.38 321.983C1218.38 320.005 1216.77 318.393 1214.79 318.393Z"
            fill="white"
          />
          <path
            d="M1201.23 316.701C1199.28 316.701 1197.69 318.293 1197.69 320.249C1197.69 322.205 1199.28 323.797 1201.23 323.797C1203.19 323.797 1204.78 322.205 1204.78 320.249C1204.78 318.293 1203.2 316.701 1201.23 316.701Z"
            fill="white"
          />
          <path
            d="M1187.87 315.068C1185.93 315.068 1184.36 316.63 1184.36 318.565C1184.36 320.5 1185.93 322.062 1187.87 322.062C1189.81 322.062 1191.36 320.5 1191.36 318.565C1191.36 316.63 1189.8 315.068 1187.87 315.068Z"
            fill="white"
          />
          <path
            d="M1174.65 313.643C1172.76 313.643 1171.22 315.183 1171.22 317.067C1171.22 318.952 1172.76 320.5 1174.65 320.5C1176.54 320.5 1178.07 318.96 1178.07 317.067C1178.07 315.175 1176.54 313.643 1174.65 313.643Z"
            fill="white"
          />
          <path
            d="M1161.4 312.48C1159.54 312.48 1158.02 313.991 1158.02 315.863C1158.02 317.734 1159.54 319.245 1161.4 319.245C1163.26 319.245 1164.78 317.726 1164.78 315.863C1164.78 314 1163.27 312.48 1161.4 312.48Z"
            fill="white"
          />
          <path
            d="M1148.11 311.709C1146.27 311.709 1144.77 313.207 1144.77 315.049C1144.77 316.891 1146.27 318.389 1148.11 318.389C1149.95 318.389 1151.45 316.899 1151.45 315.049C1151.45 313.199 1149.95 311.709 1148.11 311.709Z"
            fill="white"
          />
          <path
            d="M1134.76 311.49C1132.94 311.49 1131.47 312.959 1131.47 314.771C1131.47 316.583 1132.94 318.06 1134.76 318.06C1136.57 318.06 1138.04 316.591 1138.04 314.771C1138.04 312.95 1136.57 311.49 1134.76 311.49Z"
            fill="white"
          />
          <path
            d="M1121.16 311.906C1119.39 311.906 1117.96 313.341 1117.96 315.11C1117.96 316.88 1119.4 318.327 1121.16 318.327C1122.93 318.327 1124.37 316.888 1124.37 315.11C1124.37 313.332 1122.93 311.906 1121.16 311.906Z"
            fill="white"
          />
          <path
            d="M1107.37 313.125C1105.63 313.125 1104.22 314.542 1104.22 316.278C1104.22 318.014 1105.64 319.431 1107.37 319.431C1109.11 319.431 1110.53 318.027 1110.53 316.278C1110.53 314.53 1109.11 313.125 1107.37 313.125Z"
            fill="white"
          />
          <path
            d="M1093.43 315.34C1091.72 315.34 1090.34 316.723 1090.34 318.429C1090.34 320.135 1091.72 321.531 1093.43 321.531C1095.13 321.531 1096.53 320.148 1096.53 318.429C1096.53 316.711 1095.15 315.34 1093.43 315.34Z"
            fill="white"
          />
          <path
            d="M1079.19 318.678C1077.51 318.678 1076.14 320.04 1076.14 321.729C1076.14 323.418 1077.5 324.78 1079.19 324.78C1080.88 324.78 1082.24 323.418 1082.24 321.729C1082.24 320.04 1080.88 318.678 1079.19 318.678Z"
            fill="white"
          />
          <path
            d="M1064.94 323.58C1063.31 323.58 1061.97 324.904 1061.97 326.538C1061.97 328.172 1063.31 329.496 1064.94 329.496C1066.57 329.496 1067.9 328.172 1067.9 326.538C1067.9 324.904 1066.57 323.58 1064.94 323.58Z"
            fill="white"
          />
          <path
            d="M1050.68 330.244C1049.08 330.244 1047.78 331.547 1047.78 333.147C1047.78 334.747 1049.08 336.05 1050.68 336.05C1052.28 336.05 1053.6 334.747 1053.6 333.147C1053.6 331.547 1052.29 330.244 1050.68 330.244Z"
            fill="white"
          />
          <path
            d="M1036.7 339.172C1035.13 339.172 1033.85 340.441 1033.85 342.015C1033.85 343.59 1035.13 344.867 1036.7 344.867C1038.27 344.867 1039.54 343.585 1039.54 342.015C1039.54 340.445 1038.28 339.172 1036.7 339.172Z"
            fill="white"
          />
          <path
            d="M1023.57 350.832C1022.03 350.832 1020.78 352.08 1020.78 353.62C1020.78 355.161 1022.03 356.421 1023.57 356.421C1025.11 356.421 1026.35 355.173 1026.35 353.62C1026.35 352.067 1025.11 350.832 1023.57 350.832Z"
            fill="white"
          />
          <path
            d="M1011.97 365.707C1010.48 365.707 1009.28 366.925 1009.28 368.415C1009.28 369.904 1010.49 371.109 1011.97 371.109C1013.46 371.109 1014.68 369.9 1014.68 368.415C1014.68 366.929 1013.46 365.707 1011.97 365.707Z"
            fill="white"
          />
          <path
            d="M1002.94 383.977C1001.47 383.977 1000.29 385.173 1000.29 386.642C1000.29 388.11 1001.47 389.294 1002.94 389.294C1004.4 389.294 1005.59 388.106 1005.59 386.642C1005.59 385.178 1004.4 383.977 1002.94 383.977Z"
            fill="white"
          />
          <path
            d="M997.446 405.795C996.02 405.795 994.854 406.949 994.854 408.388C994.854 409.827 996.02 410.989 997.446 410.989C998.872 410.989 1000.05 409.822 1000.05 408.388C1000.05 406.953 998.881 405.795 997.446 405.795Z"
            fill="white"
          />
          <path
            d="M997.119 431.398C995.723 431.398 994.59 432.532 994.59 433.936C994.59 435.341 995.723 436.474 997.119 436.474C998.515 436.474 999.657 435.328 999.657 433.936C999.657 432.544 998.524 431.398 997.119 431.398Z"
            fill="white"
          />
          <path
            d="M1003.48 460.748C1002.13 460.748 1001.02 461.851 1001.02 463.205C1001.02 464.559 1002.13 465.65 1003.48 465.65C1004.83 465.65 1005.94 464.555 1005.94 463.205C1005.94 461.856 1004.83 460.748 1003.48 460.748Z"
            fill="white"
          />
          <path
            d="M1015.83 493.363C1014.51 493.363 1013.44 494.437 1013.44 495.757C1013.44 497.077 1014.52 498.15 1015.83 498.15C1017.15 498.15 1018.23 497.077 1018.23 495.757C1018.23 494.437 1017.15 493.363 1015.83 493.363Z"
            fill="white"
          />
          <path
            d="M1031.07 528.975C1029.78 528.975 1028.73 530.027 1028.73 531.317C1028.73 532.607 1029.78 533.647 1031.07 533.647C1032.36 533.647 1033.4 532.607 1033.4 531.317C1033.4 530.027 1032.36 528.975 1031.07 528.975Z"
            fill="white"
          />
          <path
            d="M1045.5 567.576C1044.23 567.576 1043.21 568.607 1043.21 569.868C1043.21 571.128 1044.22 572.159 1045.5 572.159C1046.77 572.159 1047.79 571.141 1047.79 569.868C1047.79 568.595 1046.76 567.576 1045.5 567.576Z"
            fill="white"
          />
          <path
            d="M1057.14 609.771C1055.92 609.771 1054.93 610.769 1054.93 611.987C1054.93 613.205 1055.92 614.202 1057.14 614.202C1058.37 614.202 1059.36 613.213 1059.36 611.987C1059.36 610.76 1058.37 609.771 1057.14 609.771Z"
            fill="white"
          />
          <path
            d="M1065.37 655.201C1064.17 655.201 1063.2 656.169 1063.2 657.365C1063.2 658.562 1064.17 659.543 1065.37 659.543C1066.57 659.543 1067.55 658.562 1067.55 657.365C1067.55 656.169 1066.57 655.201 1065.37 655.201Z"
            fill="white"
          />
          <path
            d="M37.6925 668.436C36.8268 668.436 36.1436 669.132 36.1436 669.997C36.1436 670.863 36.831 671.546 37.6925 671.546C38.554 671.546 39.2415 670.85 39.2415 669.997C39.2415 669.144 38.5455 668.436 37.6925 668.436Z"
            fill="white"
          />
          <path
            d="M6.96765 633.625C6.10192 633.625 5.39746 634.321 5.39746 635.187C5.39746 636.052 6.10617 636.757 6.96765 636.757C7.82913 636.757 8.52935 636.048 8.52935 635.187C8.52935 634.325 7.83337 633.625 6.96765 633.625Z"
            fill="white"
          />
          <path
            d="M1225.36 2.40559C1226.95 2.40559 1228.24 1.1155 1228.24 -0.475916C1228.24 -2.06733 1226.95 -3.35742 1225.36 -3.35742C1223.77 -3.35742 1222.48 -2.06733 1222.48 -0.475916C1222.48 1.1155 1223.77 2.40559 1225.36 2.40559Z"
            fill="white"
          />
          <path
            d="M1232.63 8.36328C1231.01 8.36328 1229.7 9.67884 1229.7 11.3042C1229.7 12.9296 1231.01 14.2494 1232.63 14.2494C1234.26 14.2494 1235.58 12.9253 1235.58 11.3042C1235.58 9.68309 1234.27 8.36328 1232.63 8.36328Z"
            fill="white"
          />
          <path
            d="M1239.96 20.0684C1238.3 20.0684 1236.96 21.4094 1236.96 23.0644C1236.96 24.7195 1238.3 26.0605 1239.96 26.0605C1241.62 26.0605 1242.96 24.7195 1242.96 23.0644C1242.96 21.4094 1241.62 20.0684 1239.96 20.0684Z"
            fill="white"
          />
          <path
            d="M1247.35 31.6914C1245.66 31.6914 1244.3 33.0664 1244.3 34.7511C1244.3 36.4359 1245.66 37.8109 1247.35 37.8109C1249.04 37.8109 1250.41 36.4359 1250.41 34.7511C1250.41 33.0664 1249.05 31.6914 1247.35 31.6914Z"
            fill="white"
          />
          <path
            d="M1254.8 43.2129C1253.06 43.2129 1251.67 44.6176 1251.67 46.3448C1251.67 48.072 1253.06 49.4767 1254.8 49.4767C1256.54 49.4767 1257.93 48.072 1257.93 46.3448C1257.93 44.6176 1256.53 43.2129 1254.8 43.2129Z"
            fill="white"
          />
          <path
            d="M1262.25 54.7109C1260.5 54.7109 1259.07 56.1368 1259.07 57.9022C1259.07 59.6676 1260.5 61.0851 1262.25 61.0851C1264.01 61.0851 1265.45 59.6592 1265.45 57.9022C1265.45 56.1453 1264.01 54.7109 1262.25 54.7109Z"
            fill="white"
          />
          <path
            d="M1269.66 66.2578C1267.88 66.2578 1266.42 67.7049 1266.42 69.4958C1266.42 71.2867 1267.88 72.7338 1269.66 72.7338C1271.44 72.7338 1272.9 71.2867 1272.9 69.4958C1272.9 67.7049 1271.45 66.2578 1269.66 66.2578Z"
            fill="white"
          />
          <path
            d="M1276.99 77.8945C1275.17 77.8945 1273.7 79.3714 1273.7 81.1962C1273.7 83.021 1275.17 84.4851 1276.99 84.4851C1278.81 84.4851 1280.28 83.0082 1280.28 81.1962C1280.28 79.3841 1278.8 77.8945 1276.99 77.8945Z"
            fill="white"
          />
          <path
            d="M1284.95 96.4093C1286.77 95.9813 1287.89 94.1642 1287.46 92.3508C1287.04 90.5373 1285.22 89.4142 1283.4 89.8422C1281.59 90.2702 1280.47 92.0873 1280.9 93.9007C1281.32 95.7142 1283.14 96.8373 1284.95 96.4093Z"
            fill="white"
          />
          <path
            d="M1291.26 101.654C1289.37 101.654 1287.85 103.186 1287.85 105.066C1287.85 106.946 1289.38 108.482 1291.26 108.482C1293.14 108.482 1294.67 106.951 1294.67 105.066C1294.67 103.182 1293.14 101.654 1291.26 101.654Z"
            fill="white"
          />
          <path
            d="M1298.22 113.762C1296.32 113.762 1294.77 115.311 1294.77 117.22C1294.77 119.13 1296.32 120.679 1298.22 120.679C1300.13 120.679 1301.68 119.13 1301.68 117.22C1301.68 115.311 1300.14 113.762 1298.22 113.762Z"
            fill="white"
          />
          <path
            d="M1305.11 125.938C1303.17 125.938 1301.6 127.508 1301.6 129.443C1301.6 131.378 1303.17 132.948 1305.11 132.948C1307.04 132.948 1308.61 131.382 1308.61 129.443C1308.61 127.503 1307.04 125.938 1305.11 125.938Z"
            fill="white"
          />
          <path
            d="M1311.96 138.1C1309.98 138.1 1308.38 139.704 1308.38 141.681C1308.38 143.659 1309.98 145.255 1311.96 145.255C1313.94 145.255 1315.54 143.659 1315.54 141.681C1315.54 139.704 1313.94 138.1 1311.96 138.1Z"
            fill="white"
          />
          <path
            d="M1321.42 156.325C1322.83 154.912 1322.83 152.62 1321.42 151.206C1320.01 149.792 1317.71 149.792 1316.3 151.206C1314.89 152.62 1314.89 154.912 1316.3 156.325C1317.71 157.739 1320.01 157.739 1321.42 156.325Z"
            fill="white"
          />
          <path
            d="M1325.91 161.865C1323.88 161.865 1322.23 163.503 1322.23 165.528C1322.23 167.552 1323.88 169.203 1325.91 169.203C1327.94 169.203 1329.58 167.556 1329.58 165.528C1329.58 163.499 1327.94 161.865 1325.91 161.865Z"
            fill="white"
          />
          <path
            d="M1333.2 173.014C1331.16 173.014 1329.49 174.677 1329.49 176.731C1329.49 178.785 1331.15 180.449 1333.2 180.449C1335.26 180.449 1336.91 178.785 1336.91 176.731C1336.91 174.677 1335.25 173.014 1333.2 173.014Z"
            fill="white"
          />
          <path
            d="M1340.81 183.348C1338.73 183.348 1337.04 185.032 1337.04 187.125C1337.04 189.217 1338.73 190.893 1340.81 190.893C1342.89 190.893 1344.59 189.208 1344.59 187.125C1344.59 185.041 1342.89 183.348 1340.81 183.348Z"
            fill="white"
          />
          <path
            d="M1348.77 192.674C1346.67 192.674 1344.97 194.38 1344.97 196.476C1344.97 198.573 1346.67 200.279 1348.77 200.279C1350.87 200.279 1352.58 198.581 1352.58 196.476C1352.58 194.371 1350.88 192.674 1348.77 192.674Z"
            fill="white"
          />
          <path
            d="M1357.1 200.758C1354.98 200.758 1353.25 202.477 1353.25 204.598C1353.25 206.72 1354.98 208.447 1357.1 208.447C1359.22 208.447 1360.95 206.72 1360.95 204.598C1360.95 202.477 1359.22 200.758 1357.1 200.758Z"
            fill="white"
          />
          <path
            d="M1365.72 207.535C1363.57 207.535 1361.83 209.271 1361.83 211.418C1361.83 213.566 1363.57 215.301 1365.72 215.301C1367.86 215.301 1369.61 213.561 1369.61 211.418C1369.61 209.275 1367.87 207.535 1365.72 207.535Z"
            fill="white"
          />
          <path
            d="M1374.58 213.053C1372.41 213.053 1370.64 214.814 1370.64 216.987C1370.64 219.159 1372.41 220.921 1374.58 220.921C1376.74 220.921 1378.51 219.159 1378.51 216.987C1378.51 214.814 1376.75 213.053 1374.58 213.053Z"
            fill="white"
          />
          <path
            d="M1383.57 217.475C1381.38 217.475 1379.61 219.244 1379.61 221.438C1379.61 223.632 1381.38 225.402 1383.57 225.402C1385.76 225.402 1387.53 223.624 1387.53 221.438C1387.53 219.253 1385.75 217.475 1383.57 217.475Z"
            fill="white"
          />
          <path
            d="M1392.61 220.951C1390.41 220.951 1388.61 222.729 1388.61 224.936C1388.61 227.143 1390.41 228.934 1392.61 228.934C1394.82 228.934 1396.61 227.143 1396.61 224.936C1396.61 222.729 1394.82 220.951 1392.61 220.951Z"
            fill="white"
          />
          <path
            d="M1401.65 223.688C1399.42 223.688 1397.62 225.487 1397.62 227.706C1397.62 229.926 1399.42 231.734 1401.65 231.734C1403.87 231.734 1405.67 229.934 1405.67 227.706C1405.67 225.478 1403.87 223.688 1401.65 223.688Z"
            fill="white"
          />
          <path
            d="M1410.67 225.793C1408.42 225.793 1406.59 227.614 1406.59 229.863C1406.59 232.112 1408.43 233.932 1410.67 233.932C1412.92 233.932 1414.74 232.112 1414.74 229.863C1414.74 227.614 1412.92 225.793 1410.67 225.793Z"
            fill="white"
          />
          <path
            d="M1419.62 235.69C1421.88 235.69 1423.71 233.858 1423.71 231.599C1423.71 229.339 1421.88 227.508 1419.62 227.508C1417.36 227.508 1415.53 229.339 1415.53 231.599C1415.53 233.858 1417.36 235.69 1419.62 235.69Z"
            fill="white"
          />
          <path
            d="M1428.57 228.883C1426.29 228.883 1424.45 230.725 1424.45 233.003C1424.45 235.282 1426.29 237.124 1428.57 237.124C1430.85 237.124 1432.69 235.282 1432.69 233.003C1432.69 230.725 1430.85 228.883 1428.57 228.883Z"
            fill="white"
          />
          <path
            d="M1437.45 230.121C1435.17 230.121 1433.3 231.976 1433.3 234.263C1433.3 236.55 1435.17 238.405 1437.45 238.405C1439.73 238.405 1441.59 236.555 1441.59 234.263C1441.59 231.971 1439.74 230.121 1437.45 230.121Z"
            fill="white"
          />
          <path
            d="M1446.34 231.174C1444.05 231.174 1442.18 233.037 1442.18 235.337C1442.18 237.637 1444.05 239.492 1446.34 239.492C1448.63 239.492 1450.49 237.629 1450.49 235.337C1450.49 233.045 1448.64 231.174 1446.34 231.174Z"
            fill="white"
          />
          <path
            d="M1455.17 232.027C1452.88 232.027 1451.02 233.89 1451.02 236.19C1451.02 238.491 1452.88 240.345 1455.17 240.345C1457.46 240.345 1459.33 238.482 1459.33 236.19C1459.33 233.899 1457.47 232.027 1455.17 232.027Z"
            fill="white"
          />
          <path
            d="M1450.99 262.008C1448.7 262.008 1446.83 263.871 1446.83 266.162C1446.83 268.454 1448.7 270.317 1450.99 270.317C1453.28 270.317 1455.15 268.454 1455.15 266.162C1455.15 263.871 1453.29 262.008 1450.99 262.008Z"
            fill="white"
          />
          <path
            d="M1442.45 265.152C1440.15 265.152 1438.29 267.015 1438.29 269.307C1438.29 271.599 1440.15 273.462 1442.45 273.462C1444.75 273.462 1446.6 271.599 1446.6 269.307C1446.6 267.015 1444.74 265.152 1442.45 265.152Z"
            fill="white"
          />
          <path
            d="M1433.22 268.586C1430.93 268.586 1429.07 270.449 1429.07 272.741C1429.07 275.032 1430.93 276.895 1433.22 276.895C1435.52 276.895 1437.38 275.032 1437.38 272.741C1437.38 270.449 1435.53 268.586 1433.22 268.586Z"
            fill="white"
          />
          <path
            d="M1423.43 272.482C1421.14 272.482 1419.28 274.345 1419.28 276.637C1419.28 278.929 1421.14 280.8 1423.43 280.8C1425.72 280.8 1427.58 278.937 1427.58 276.637C1427.58 274.337 1425.72 272.482 1423.43 272.482Z"
            fill="white"
          />
          <path
            d="M1413.15 276.885C1410.86 276.885 1409.01 278.739 1409.01 281.018C1409.01 283.297 1410.86 285.152 1413.15 285.152C1415.44 285.152 1417.28 283.301 1417.28 281.018C1417.28 278.735 1415.43 276.885 1413.15 276.885Z"
            fill="white"
          />
          <path
            d="M1402.41 281.744C1400.14 281.744 1398.31 283.586 1398.31 285.844C1398.31 288.101 1400.14 289.943 1402.41 289.943C1404.67 289.943 1406.5 288.101 1406.5 285.844C1406.5 283.586 1404.66 281.744 1402.41 281.744Z"
            fill="white"
          />
          <path
            d="M1391.25 286.949C1388.99 286.949 1387.17 288.783 1387.17 291.027C1387.17 293.272 1388.99 295.106 1391.25 295.106C1393.51 295.106 1395.32 293.285 1395.32 291.027C1395.32 288.77 1393.5 286.949 1391.25 286.949Z"
            fill="white"
          />
          <path
            d="M1379.64 292.348C1377.41 292.348 1375.59 294.168 1375.59 296.405C1375.59 298.641 1377.41 300.453 1379.64 300.453C1381.88 300.453 1383.69 298.641 1383.69 296.405C1383.69 294.168 1381.88 292.348 1379.64 292.348Z"
            fill="white"
          />
          <path
            d="M1367.43 297.77C1365.22 297.77 1363.42 299.569 1363.42 301.788C1363.42 304.008 1365.21 305.807 1367.43 305.807C1369.65 305.807 1371.45 304.016 1371.45 301.788C1371.45 299.56 1369.65 297.77 1367.43 297.77Z"
            fill="white"
          />
          <path
            d="M1354.64 303.1C1352.44 303.1 1350.66 304.878 1350.66 307.076C1350.66 309.274 1352.44 311.04 1354.64 311.04C1356.83 311.04 1358.61 309.262 1358.61 307.076C1358.61 304.89 1356.83 303.1 1354.64 303.1Z"
            fill="white"
          />
          <path
            d="M1341.31 308.098C1339.12 308.098 1337.37 309.867 1337.37 312.04C1337.37 314.213 1339.12 315.983 1341.31 315.983C1343.5 315.983 1345.25 314.213 1345.25 312.04C1345.25 309.867 1343.48 308.098 1341.31 308.098Z"
            fill="white"
          />
          <path
            d="M1327.39 312.518C1325.24 312.518 1323.48 314.275 1323.48 316.43C1323.48 318.586 1325.24 320.356 1327.39 320.356C1329.55 320.356 1331.32 318.599 1331.32 316.43C1331.32 314.262 1329.56 312.518 1327.39 312.518Z"
            fill="white"
          />
          <path
            d="M1312.99 316.205C1310.85 316.205 1309.12 317.945 1309.12 320.088C1309.12 322.231 1310.85 323.958 1312.99 323.958C1315.13 323.958 1316.86 322.218 1316.86 320.088C1316.86 317.958 1315.13 316.205 1312.99 316.205Z"
            fill="white"
          />
          <path
            d="M1298.27 319.109C1296.16 319.109 1294.46 320.815 1294.46 322.929C1294.46 325.042 1296.16 326.757 1298.27 326.757C1300.39 326.757 1302.11 325.038 1302.11 322.929C1302.11 320.82 1300.39 319.109 1298.27 319.109Z"
            fill="white"
          />
          <path
            d="M1283.43 321.035C1281.34 321.035 1279.66 322.733 1279.66 324.825C1279.66 326.917 1281.34 328.602 1283.43 328.602C1285.53 328.602 1287.22 326.917 1287.22 324.825C1287.22 322.733 1285.53 321.035 1283.43 321.035Z"
            fill="white"
          />
          <path
            d="M1268.54 321.939C1266.47 321.939 1264.79 323.624 1264.79 325.687C1264.79 327.749 1266.47 329.434 1268.54 329.434C1270.6 329.434 1272.28 327.758 1272.28 325.687C1272.28 323.616 1270.61 321.939 1268.54 321.939Z"
            fill="white"
          />
          <path
            d="M1253.79 322.055C1251.75 322.055 1250.08 323.71 1250.08 325.751C1250.08 327.792 1251.75 329.456 1253.79 329.456C1255.83 329.456 1257.49 327.801 1257.49 325.751C1257.49 323.701 1255.84 322.055 1253.79 322.055Z"
            fill="white"
          />
          <path
            d="M1239.34 321.451C1237.32 321.451 1235.7 323.077 1235.7 325.092C1235.7 327.108 1237.33 328.733 1239.34 328.733C1241.36 328.733 1242.99 327.1 1242.99 325.092C1242.99 323.085 1241.35 321.451 1239.34 321.451Z"
            fill="white"
          />
          <path
            d="M1225.23 320.168C1223.24 320.168 1221.63 321.772 1221.63 323.771C1221.63 325.77 1223.24 327.37 1225.23 327.37C1227.22 327.37 1228.83 325.757 1228.83 323.771C1228.83 321.785 1227.22 320.168 1225.23 320.168Z"
            fill="white"
          />
          <path
            d="M1211.4 318.566C1209.43 318.566 1207.84 320.158 1207.84 322.127C1207.84 324.096 1209.43 325.687 1211.4 325.687C1213.37 325.687 1214.96 324.083 1214.96 322.127C1214.96 320.171 1213.37 318.566 1211.4 318.566Z"
            fill="white"
          />
          <path
            d="M1197.84 316.922C1195.9 316.922 1194.33 318.492 1194.33 320.431C1194.33 322.371 1195.9 323.928 1197.84 323.928C1199.78 323.928 1201.33 322.358 1201.33 320.431C1201.33 318.505 1199.76 316.922 1197.84 316.922Z"
            fill="white"
          />
          <path
            d="M1184.49 315.391C1182.59 315.391 1181.05 316.931 1181.05 318.824C1181.05 320.717 1182.59 322.27 1184.49 322.27C1186.4 322.27 1187.93 320.729 1187.93 318.824C1187.93 316.918 1186.39 315.391 1184.49 315.391Z"
            fill="white"
          />
          <path
            d="M1171.19 314.059C1169.32 314.059 1167.8 315.569 1167.8 317.441C1167.8 319.312 1169.32 320.823 1171.19 320.823C1173.07 320.823 1174.58 319.304 1174.58 317.441C1174.58 315.578 1173.06 314.059 1171.19 314.059Z"
            fill="white"
          />
          <path
            d="M1157.88 319.723C1159.72 319.723 1161.21 318.232 1161.21 316.392C1161.21 314.552 1159.72 313.061 1157.88 313.061C1156.04 313.061 1154.55 314.552 1154.55 316.392C1154.55 318.232 1156.04 319.723 1157.88 319.723Z"
            fill="white"
          />
          <path
            d="M1144.57 312.541C1142.76 312.541 1141.29 314.009 1141.29 315.821C1141.29 317.634 1142.76 319.098 1144.57 319.098C1146.38 319.098 1147.85 317.629 1147.85 315.821C1147.85 314.014 1146.38 312.541 1144.57 312.541Z"
            fill="white"
          />
          <path
            d="M1131.08 312.594C1129.31 312.594 1127.88 314.028 1127.88 315.811C1127.88 317.593 1129.31 319.015 1131.08 319.015C1132.85 319.015 1134.29 317.58 1134.29 315.811C1134.29 314.041 1132.85 312.594 1131.08 312.594Z"
            fill="white"
          />
          <path
            d="M1117.35 313.363C1115.62 313.363 1114.21 314.768 1114.21 316.508C1114.21 318.248 1115.61 319.661 1117.35 319.661C1119.09 319.661 1120.51 318.244 1120.51 316.508C1120.51 314.772 1119.09 313.363 1117.35 313.363Z"
            fill="white"
          />
          <path
            d="M1103.53 315.061C1101.81 315.061 1100.43 316.444 1100.43 318.163C1100.43 319.881 1101.81 321.265 1103.53 321.265C1105.25 321.265 1106.63 319.881 1106.63 318.163C1106.63 316.444 1105.24 315.061 1103.53 315.061Z"
            fill="white"
          />
          <path
            d="M1089.43 317.818C1087.74 317.818 1086.38 319.181 1086.38 320.87C1086.38 322.559 1087.74 323.921 1089.43 323.921C1091.12 323.921 1092.48 322.559 1092.48 320.87C1092.48 319.181 1091.12 317.818 1089.43 317.818Z"
            fill="white"
          />
          <path
            d="M1075.18 321.961C1073.55 321.961 1072.22 323.285 1072.22 324.919C1072.22 326.553 1073.54 327.885 1075.18 327.885C1076.82 327.885 1078.14 326.553 1078.14 324.919C1078.14 323.285 1076.81 321.961 1075.18 321.961Z"
            fill="white"
          />
          <path
            d="M1061.06 327.758C1059.45 327.758 1058.15 329.061 1058.15 330.661C1058.15 332.26 1059.46 333.563 1061.06 333.563C1062.65 333.563 1063.96 332.26 1063.96 330.661C1063.96 329.061 1062.65 327.758 1061.06 327.758Z"
            fill="white"
          />
          <path
            d="M1047.1 335.51C1045.53 335.51 1044.25 336.779 1044.25 338.353C1044.25 339.928 1045.52 341.205 1047.1 341.205C1048.67 341.205 1049.95 339.923 1049.95 338.353C1049.95 336.783 1048.67 335.51 1047.1 335.51Z"
            fill="white"
          />
          <path
            d="M1033.96 345.771C1032.4 345.771 1031.16 347.032 1031.16 348.572C1031.16 350.113 1032.4 351.373 1033.96 351.373C1035.51 351.373 1036.76 350.126 1036.76 348.572C1036.76 347.019 1035.5 345.771 1033.96 345.771Z"
            fill="white"
          />
          <path
            d="M1021.89 358.939C1020.4 358.939 1019.18 360.157 1019.18 361.647C1019.18 363.137 1020.4 364.363 1021.89 364.363C1023.38 364.363 1024.61 363.145 1024.61 361.647C1024.61 360.149 1023.39 358.939 1021.89 358.939Z"
            fill="white"
          />
          <path
            d="M1012.19 375.508C1010.73 375.508 1009.54 376.696 1009.54 378.16C1009.54 379.624 1010.73 380.812 1012.19 380.812C1013.66 380.812 1014.85 379.624 1014.85 378.16C1014.85 376.696 1013.66 375.508 1012.19 375.508Z"
            fill="white"
          />
          <path
            d="M1005.47 395.439C1004.03 395.439 1002.87 396.594 1002.87 398.032C1002.87 399.471 1004.03 400.625 1005.47 400.625C1006.9 400.625 1008.06 399.471 1008.06 398.032C1008.06 396.594 1006.91 395.439 1005.47 395.439Z"
            fill="white"
          />
          <path
            d="M1003.4 419.096C1002 419.096 1000.87 420.229 1000.87 421.633C1000.87 423.038 1002 424.171 1003.4 424.171C1004.79 424.171 1005.93 423.038 1005.93 421.633C1005.93 420.229 1004.8 419.096 1003.4 419.096Z"
            fill="white"
          />
          <path
            d="M1007.46 446.512C1006.1 446.512 1005 447.615 1005 448.969C1005 450.323 1006.1 451.413 1007.46 451.413C1008.81 451.413 1009.9 450.318 1009.9 448.969C1009.9 447.619 1008.81 446.512 1007.46 446.512Z"
            fill="white"
          />
          <path
            d="M1017.83 477.307C1016.52 477.307 1015.45 478.38 1015.45 479.7C1015.45 481.02 1016.52 482.085 1017.83 482.085C1019.15 482.085 1020.23 481.024 1020.23 479.7C1020.23 478.376 1019.15 477.307 1017.83 477.307Z"
            fill="white"
          />
          <path
            d="M1032.25 511.176C1030.95 511.176 1029.91 512.228 1029.91 513.518C1029.91 514.808 1030.95 515.861 1032.25 515.861C1033.55 515.861 1034.59 514.808 1034.59 513.518C1034.59 512.228 1033.54 511.176 1032.25 511.176Z"
            fill="white"
          />
          <path
            d="M1046.98 547.965C1045.71 547.965 1044.68 548.996 1044.68 550.256C1044.68 551.517 1045.71 552.557 1046.98 552.557C1048.24 552.557 1049.27 551.525 1049.27 550.256C1049.27 548.988 1048.25 547.965 1046.98 547.965Z"
            fill="white"
          />
          <path
            d="M1059.46 588.018C1058.23 588.018 1057.24 589.006 1057.24 590.233C1057.24 591.459 1058.23 592.448 1059.46 592.448C1060.68 592.448 1061.67 591.451 1061.67 590.233C1061.67 589.015 1060.68 588.018 1059.46 588.018Z"
            fill="white"
          />
          <path
            d="M1068.74 631.176C1067.54 631.176 1066.56 632.156 1066.56 633.353C1066.56 634.55 1067.54 635.53 1068.74 635.53C1069.93 635.53 1070.9 634.55 1070.9 633.353C1070.9 632.156 1069.93 631.176 1068.74 631.176Z"
            fill="white"
          />
          <path
            d="M1074.76 676.287C1073.59 676.287 1072.64 677.246 1072.64 678.422C1072.64 679.597 1073.59 680.544 1074.76 680.544C1075.94 680.544 1076.89 679.585 1076.89 678.422C1076.89 677.259 1075.94 676.287 1074.76 676.287Z"
            fill="white"
          />
          <path
            d="M8.85174 651.84C7.98601 651.84 7.29004 652.536 7.29004 653.402C7.29004 654.267 7.98601 654.963 8.85174 654.963C9.71746 654.963 10.4134 654.255 10.4134 653.402C10.4134 652.549 9.71746 651.84 8.85174 651.84Z"
            fill="white"
          />
          <path
            d="M1249.33 2.94727C1247.7 2.94727 1246.39 4.25858 1246.39 5.88394C1246.39 7.5093 1247.7 8.82061 1249.33 8.82061C1250.95 8.82061 1252.26 7.5093 1252.26 5.88394C1252.26 4.25858 1250.95 2.94727 1249.33 2.94727Z"
            fill="white"
          />
          <path
            d="M1256.76 20.5332C1258.41 20.5332 1259.75 19.1918 1259.75 17.5371C1259.75 15.8824 1258.41 14.541 1256.76 14.541C1255.1 14.541 1253.76 15.8824 1253.76 17.5371C1253.76 19.1918 1255.1 20.5332 1256.76 20.5332Z"
            fill="white"
          />
          <path
            d="M1264.21 26.1367C1262.53 26.1367 1261.16 27.5075 1261.16 29.1922C1261.16 30.877 1262.53 32.2477 1264.21 32.2477C1265.89 32.2477 1267.27 30.8727 1267.27 29.1922C1267.27 27.5117 1265.89 26.1367 1264.21 26.1367Z"
            fill="white"
          />
          <path
            d="M1271.68 37.7031C1269.94 37.7031 1268.55 39.1078 1268.55 40.835C1268.55 42.5622 1269.95 43.9669 1271.68 43.9669C1273.42 43.9669 1274.81 42.5622 1274.81 40.835C1274.81 39.1078 1273.41 37.7031 1271.68 37.7031Z"
            fill="white"
          />
          <path
            d="M1279.07 49.3887C1277.31 49.3887 1275.88 50.8146 1275.88 52.58C1275.88 54.3454 1277.31 55.7713 1279.07 55.7713C1280.83 55.7713 1282.27 54.3454 1282.27 52.58C1282.27 50.8146 1280.83 49.3887 1279.07 49.3887Z"
            fill="white"
          />
          <path
            d="M1286.39 61.1914C1284.6 61.1914 1283.15 62.6428 1283.15 64.4294C1283.15 66.216 1284.6 67.6674 1286.39 67.6674C1288.18 67.6674 1289.62 66.2203 1289.62 64.4294C1289.62 62.6385 1288.18 61.1914 1286.39 61.1914Z"
            fill="white"
          />
          <path
            d="M1293.6 73.1074C1291.78 73.1074 1290.3 74.5842 1290.3 76.4048C1290.3 78.2254 1291.77 79.6937 1293.6 79.6937C1295.42 79.6937 1296.89 78.2169 1296.89 76.4048C1296.89 74.5927 1295.41 73.1074 1293.6 73.1074Z"
            fill="white"
          />
          <path
            d="M1300.69 85.1367C1298.83 85.1367 1297.33 86.6475 1297.33 88.5105C1297.33 90.3735 1298.83 91.8716 1300.69 91.8716C1302.55 91.8716 1304.05 90.3608 1304.05 88.5105C1304.05 86.6602 1302.54 85.1367 1300.69 85.1367Z"
            fill="white"
          />
          <path
            d="M1307.65 97.3418C1305.76 97.3418 1304.24 98.8653 1304.24 100.754C1304.24 102.642 1305.76 104.166 1307.65 104.166C1309.54 104.166 1311.06 102.642 1311.06 100.754C1311.06 98.8653 1309.54 97.3418 1307.65 97.3418Z"
            fill="white"
          />
          <path
            d="M1314.49 109.65C1312.58 109.65 1311.02 111.199 1311.02 113.118C1311.02 115.036 1312.57 116.585 1314.49 116.585C1316.41 116.585 1317.97 115.036 1317.97 113.118C1317.97 111.199 1316.4 109.65 1314.49 109.65Z"
            fill="white"
          />
          <path
            d="M1321.27 122.047C1319.32 122.047 1317.75 123.617 1317.75 125.552C1317.75 127.487 1319.32 129.066 1321.27 129.066C1323.21 129.066 1324.78 127.496 1324.78 125.552C1324.78 123.609 1323.21 122.047 1321.27 122.047Z"
            fill="white"
          />
          <path
            d="M1328.04 134.336C1326.06 134.336 1324.46 135.94 1324.46 137.918C1324.46 139.895 1326.06 141.491 1328.04 141.491C1330.02 141.491 1331.62 139.887 1331.62 137.918C1331.62 135.949 1330.02 134.336 1328.04 134.336Z"
            fill="white"
          />
          <path
            d="M1334.92 146.42C1332.92 146.42 1331.3 148.037 1331.3 150.036C1331.3 152.034 1332.93 153.656 1334.92 153.656C1336.92 153.656 1338.54 152.039 1338.54 150.036C1338.54 148.033 1336.93 146.42 1334.92 146.42Z"
            fill="white"
          />
          <path
            d="M1342.01 158.074C1339.98 158.074 1338.33 159.708 1338.33 161.737C1338.33 163.765 1339.98 165.399 1342.01 165.399C1344.04 165.399 1345.67 163.752 1345.67 161.737C1345.67 159.721 1344.03 158.074 1342.01 158.074Z"
            fill="white"
          />
          <path
            d="M1349.36 169.1C1347.31 169.1 1345.64 170.763 1345.64 172.813C1345.64 174.863 1347.3 176.522 1349.36 176.522C1351.41 176.522 1353.07 174.863 1353.07 172.813C1353.07 170.763 1351.4 169.1 1349.36 169.1Z"
            fill="white"
          />
          <path
            d="M1357.05 179.246C1354.96 179.246 1353.27 180.931 1353.27 183.019C1353.27 185.107 1354.96 186.791 1357.05 186.791C1359.14 186.791 1360.82 185.107 1360.82 183.019C1360.82 180.931 1359.13 179.246 1357.05 179.246Z"
            fill="white"
          />
          <path
            d="M1365.09 188.375C1362.99 188.375 1361.28 190.081 1361.28 192.177C1361.28 194.274 1362.99 195.98 1365.09 195.98C1367.2 195.98 1368.89 194.278 1368.89 192.177C1368.89 190.077 1367.19 188.375 1365.09 188.375Z"
            fill="white"
          />
          <path
            d="M1373.48 196.287C1371.36 196.287 1369.63 198.014 1369.63 200.136C1369.63 202.258 1371.36 203.985 1373.48 203.985C1375.6 203.985 1377.33 202.258 1377.33 200.136C1377.33 198.014 1375.6 196.287 1373.48 196.287Z"
            fill="white"
          />
          <path
            d="M1382.16 202.943C1380.01 202.943 1378.27 204.683 1378.27 206.826C1378.27 208.969 1380.01 210.709 1382.16 210.709C1384.31 210.709 1386.05 208.969 1386.05 206.826C1386.05 204.683 1384.31 202.943 1382.16 202.943Z"
            fill="white"
          />
          <path
            d="M1391.03 208.381C1388.87 208.381 1387.1 210.138 1387.1 212.315C1387.1 214.492 1388.87 216.249 1391.03 216.249C1393.19 216.249 1394.96 214.479 1394.96 212.315C1394.96 210.15 1393.21 208.381 1391.03 208.381Z"
            fill="white"
          />
          <path
            d="M1400.01 212.74C1397.83 212.74 1396.05 214.518 1396.05 216.704C1396.05 218.889 1397.83 220.668 1400.01 220.668C1402.2 220.668 1403.98 218.889 1403.98 216.704C1403.98 214.518 1402.21 212.74 1400.01 212.74Z"
            fill="white"
          />
          <path
            d="M1409.02 216.234C1406.82 216.234 1405.03 218.025 1405.03 220.232C1405.03 222.439 1406.82 224.23 1409.02 224.23C1411.23 224.23 1413.01 222.439 1413.01 220.232C1413.01 218.025 1411.23 216.234 1409.02 216.234Z"
            fill="white"
          />
          <path
            d="M1418.01 219.037C1415.79 219.037 1413.99 220.836 1413.99 223.064C1413.99 225.292 1415.79 227.092 1418.01 227.092C1420.23 227.092 1422.03 225.292 1422.03 223.064C1422.03 220.836 1420.24 219.037 1418.01 219.037Z"
            fill="white"
          />
          <path
            d="M1426.96 221.316C1424.71 221.316 1422.89 223.15 1422.89 225.395C1422.89 227.64 1424.71 229.464 1426.96 229.464C1429.21 229.464 1431.03 227.644 1431.03 225.395C1431.03 223.145 1429.2 221.316 1426.96 221.316Z"
            fill="white"
          />
          <path
            d="M1435.85 223.281C1433.58 223.281 1431.74 225.123 1431.74 227.381C1431.74 229.638 1433.58 231.493 1435.85 231.493C1438.12 231.493 1439.95 229.651 1439.95 227.381C1439.95 225.11 1438.11 223.281 1435.85 223.281Z"
            fill="white"
          />
          <path
            d="M1444.69 224.99C1442.41 224.99 1440.56 226.841 1440.56 229.111C1440.56 231.381 1442.41 233.232 1444.69 233.232C1446.97 233.232 1448.81 231.39 1448.81 229.111C1448.81 226.832 1446.96 224.99 1444.69 224.99Z"
            fill="white"
          />
          <path
            d="M1453.45 226.402C1451.15 226.402 1449.3 228.253 1449.3 230.557C1449.3 232.861 1451.15 234.712 1453.45 234.712C1455.75 234.712 1457.61 232.849 1457.61 230.557C1457.61 228.265 1455.75 226.402 1453.45 226.402Z"
            fill="white"
          />
          <path
            d="M1446.66 264.688C1444.36 264.688 1442.51 266.55 1442.51 268.842C1442.51 271.134 1444.36 272.997 1446.66 272.997C1448.96 272.997 1450.82 271.134 1450.82 268.842C1450.82 266.55 1448.95 264.688 1446.66 264.688Z"
            fill="white"
          />
          <path
            d="M1436.76 268.242C1434.47 268.242 1432.61 270.105 1432.61 272.397C1432.61 274.688 1434.47 276.551 1436.76 276.551C1439.05 276.551 1440.91 274.701 1440.91 272.397C1440.91 270.092 1439.06 268.242 1436.76 268.242Z"
            fill="white"
          />
          <path
            d="M1426.28 272.242C1423.99 272.242 1422.14 274.097 1422.14 276.384C1422.14 278.671 1423.99 280.526 1426.28 280.526C1428.58 280.526 1430.43 278.676 1430.43 276.384C1430.43 274.092 1428.58 272.242 1426.28 272.242Z"
            fill="white"
          />
          <path
            d="M1415.35 276.818C1413.1 276.818 1411.26 278.652 1411.26 280.909C1411.26 283.167 1413.1 285.009 1415.35 285.009C1417.61 285.009 1419.45 283.176 1419.45 280.909C1419.45 278.643 1417.62 276.818 1415.35 276.818Z"
            fill="white"
          />
          <path
            d="M1404.05 281.828C1401.79 281.828 1399.96 283.661 1399.96 285.919C1399.96 288.177 1401.79 289.997 1404.05 289.997C1406.31 289.997 1408.13 288.164 1408.13 285.919C1408.13 283.674 1406.29 281.828 1404.05 281.828Z"
            fill="white"
          />
          <path
            d="M1392.34 287.25C1390.1 287.25 1388.28 289.062 1388.28 291.299C1388.28 293.535 1390.1 295.356 1392.34 295.356C1394.58 295.356 1396.39 293.543 1396.39 291.299C1396.39 289.054 1394.58 287.25 1392.34 287.25Z"
            fill="white"
          />
          <path
            d="M1380.08 292.912C1377.85 292.912 1376.05 294.711 1376.05 296.939C1376.05 299.167 1377.85 300.967 1380.08 300.967C1382.31 300.967 1384.1 299.155 1384.1 296.939C1384.1 294.724 1382.3 292.912 1380.08 292.912Z"
            fill="white"
          />
          <path
            d="M1367.9 306.42C1370.06 306.068 1371.54 304.026 1371.18 301.858C1370.83 299.69 1368.79 298.218 1366.62 298.57C1364.45 298.922 1362.98 300.964 1363.33 303.132C1363.69 305.3 1365.73 306.772 1367.9 306.42Z"
            fill="white"
          />
          <path
            d="M1353.9 304.068C1351.73 304.068 1349.96 305.838 1349.96 308.011C1349.96 310.184 1351.73 311.957 1353.9 311.957C1356.08 311.957 1357.86 310.201 1357.86 308.011C1357.86 305.821 1356.09 304.068 1353.9 304.068Z"
            fill="white"
          />
          <path
            d="M1339.99 309.199C1337.83 309.199 1336.08 310.948 1336.08 313.112C1336.08 315.276 1337.83 317.025 1339.99 317.025C1342.15 317.025 1343.9 315.276 1343.9 313.112C1343.9 310.948 1342.15 309.199 1339.99 309.199Z"
            fill="white"
          />
          <path
            d="M1325.5 313.676C1323.37 313.676 1321.63 315.416 1321.63 317.546C1321.63 319.676 1323.37 321.429 1325.5 321.429C1327.63 321.429 1329.38 319.689 1329.38 317.546C1329.38 315.403 1327.64 313.676 1325.5 313.676Z"
            fill="white"
          />
          <path
            d="M1310.63 317.348C1308.51 317.348 1306.79 319.054 1306.79 321.167C1306.79 323.28 1308.51 324.995 1310.63 324.995C1312.74 324.995 1314.45 323.276 1314.45 321.167C1314.45 319.058 1312.74 317.348 1310.63 317.348Z"
            fill="white"
          />
          <path
            d="M1295.56 320.139C1293.48 320.139 1291.78 321.836 1291.78 323.916C1291.78 325.995 1293.48 327.693 1295.56 327.693C1297.64 327.693 1299.33 325.995 1299.33 323.916C1299.33 321.836 1297.65 320.139 1295.56 320.139Z"
            fill="white"
          />
          <path
            d="M1280.35 321.875C1278.28 321.875 1276.6 323.56 1276.6 325.622C1276.6 327.685 1278.28 329.369 1280.35 329.369C1282.42 329.369 1284.1 327.693 1284.1 325.622C1284.1 323.551 1282.42 321.875 1280.35 321.875Z"
            fill="white"
          />
          <path
            d="M1265.21 322.613C1263.16 322.613 1261.5 324.268 1261.5 326.31C1261.5 328.351 1263.16 330.014 1265.21 330.014C1267.25 330.014 1268.91 328.359 1268.91 326.31C1268.91 324.26 1267.26 322.613 1265.21 322.613Z"
            fill="white"
          />
          <path
            d="M1250.36 322.574C1248.34 322.574 1246.7 324.208 1246.7 326.215C1246.7 328.223 1248.34 329.857 1250.36 329.857C1252.38 329.857 1254 328.235 1254 326.215C1254 324.195 1252.36 322.574 1250.36 322.574Z"
            fill="white"
          />
          <path
            d="M1235.86 321.795C1233.87 321.795 1232.25 323.408 1232.25 325.398C1232.25 327.388 1233.87 328.997 1235.86 328.997C1237.85 328.997 1239.46 327.384 1239.46 325.398C1239.46 323.412 1237.85 321.795 1235.86 321.795Z"
            fill="white"
          />
          <path
            d="M1221.67 320.398C1219.71 320.398 1218.13 321.99 1218.13 323.946C1218.13 325.903 1219.71 327.507 1221.67 327.507C1223.64 327.507 1225.22 325.915 1225.22 323.946C1225.22 321.977 1223.64 320.398 1221.67 320.398Z"
            fill="white"
          />
          <path
            d="M1207.83 318.785C1205.89 318.785 1204.32 320.355 1204.32 322.303C1204.32 324.251 1205.89 325.809 1207.83 325.809C1209.76 325.809 1211.33 324.238 1211.33 322.303C1211.33 320.368 1209.76 318.785 1207.83 318.785Z"
            fill="white"
          />
          <path
            d="M1194.31 317.225C1192.42 317.225 1190.88 318.765 1190.88 320.671C1190.88 322.576 1192.42 324.104 1194.31 324.104C1196.2 324.104 1197.74 322.563 1197.74 320.671C1197.74 318.778 1196.2 317.225 1194.31 317.225Z"
            fill="white"
          />
          <path
            d="M1180.92 315.77C1179.05 315.77 1177.54 317.28 1177.54 319.152C1177.54 321.023 1179.05 322.534 1180.92 322.534C1182.78 322.534 1184.3 321.015 1184.3 319.152C1184.3 317.289 1182.79 315.77 1180.92 315.77Z"
            fill="white"
          />
          <path
            d="M1169.91 320.244C1171.21 318.943 1171.21 316.834 1169.91 315.533C1168.61 314.232 1166.5 314.232 1165.2 315.533C1163.9 316.834 1163.9 318.943 1165.2 320.244C1166.5 321.545 1168.61 321.545 1169.91 320.244Z"
            fill="white"
          />
          <path
            d="M1154.24 313.77C1152.43 313.77 1150.95 315.238 1150.95 317.058C1150.95 318.879 1152.43 320.347 1154.24 320.347C1156.05 320.347 1157.54 318.879 1157.54 317.058C1157.54 315.238 1156.06 313.77 1154.24 313.77Z"
            fill="white"
          />
          <path
            d="M1140.86 313.527C1139.09 313.527 1137.66 314.962 1137.66 316.731C1137.66 318.501 1139.09 319.935 1140.86 319.935C1142.63 319.935 1144.07 318.501 1144.07 316.731C1144.07 314.962 1142.64 313.527 1140.86 313.527Z"
            fill="white"
          />
          <path
            d="M1127.26 313.871C1125.51 313.871 1124.1 315.289 1124.1 317.024C1124.1 318.76 1125.52 320.19 1127.26 320.19C1129.01 320.19 1130.42 318.773 1130.42 317.024C1130.42 315.276 1129 313.871 1127.26 313.871Z"
            fill="white"
          />
          <path
            d="M1113.52 315.068C1111.8 315.068 1110.41 316.465 1110.41 318.179C1110.41 319.894 1111.81 321.281 1113.52 321.281C1115.24 321.281 1116.62 319.885 1116.62 318.179C1116.62 316.473 1115.23 315.068 1113.52 315.068Z"
            fill="white"
          />
          <path
            d="M1099.62 317.297C1097.94 317.297 1096.58 318.659 1096.58 320.335C1096.58 322.012 1097.94 323.387 1099.62 323.387C1101.29 323.387 1102.67 322.024 1102.67 320.335C1102.67 318.646 1101.31 317.297 1099.62 317.297Z"
            fill="white"
          />
          <path
            d="M1085.48 326.654C1087.12 326.654 1088.44 325.33 1088.44 323.696C1088.44 322.063 1087.12 320.738 1085.48 320.738C1083.85 320.738 1082.53 322.063 1082.53 323.696C1082.53 325.33 1083.85 326.654 1085.48 326.654Z"
            fill="white"
          />
          <path
            d="M1071.47 325.729C1069.85 325.729 1068.55 327.031 1068.55 328.644C1068.55 330.257 1069.85 331.547 1071.47 331.547C1073.08 331.547 1074.38 330.244 1074.38 328.644C1074.38 327.044 1073.07 325.729 1071.47 325.729Z"
            fill="white"
          />
          <path
            d="M1057.54 332.516C1055.96 332.516 1054.68 333.797 1054.68 335.367C1054.68 336.938 1055.96 338.219 1057.54 338.219C1059.12 338.219 1060.39 336.938 1060.39 335.367C1060.39 333.797 1059.11 332.516 1057.54 332.516Z"
            fill="white"
          />
          <path
            d="M1044.3 341.6C1042.76 341.6 1041.5 342.847 1041.5 344.4C1041.5 345.954 1042.76 347.201 1044.3 347.201C1045.84 347.201 1047.1 345.941 1047.1 344.4C1047.1 342.86 1045.85 341.6 1044.3 341.6Z"
            fill="white"
          />
          <path
            d="M1032.08 353.287C1030.59 353.287 1029.38 354.497 1029.38 355.995C1029.38 357.493 1030.59 358.702 1032.08 358.702C1033.57 358.702 1034.8 357.493 1034.8 355.995C1034.8 354.497 1033.58 353.287 1032.08 353.287Z"
            fill="white"
          />
          <path
            d="M1021.78 368.098C1020.31 368.098 1019.12 369.286 1019.12 370.75C1019.12 372.214 1020.31 373.402 1021.78 373.402C1023.24 373.402 1024.43 372.214 1024.43 370.75C1024.43 369.286 1023.23 368.098 1021.78 368.098Z"
            fill="white"
          />
          <path
            d="M1014.19 386.26C1012.75 386.26 1011.6 387.427 1011.6 388.853C1011.6 390.279 1012.75 391.454 1014.19 391.454C1015.63 391.454 1016.79 390.287 1016.79 388.853C1016.79 387.418 1015.63 386.26 1014.19 386.26Z"
            fill="white"
          />
          <path
            d="M1010.63 408.002C1009.24 408.002 1008.1 409.135 1008.1 410.54C1008.1 411.944 1009.24 413.069 1010.63 413.069C1012.03 413.069 1013.16 411.936 1013.16 410.54C1013.16 409.144 1012.03 408.002 1010.63 408.002Z"
            fill="white"
          />
          <path
            d="M1012.68 433.541C1011.33 433.541 1010.24 434.636 1010.24 435.985C1010.24 437.335 1011.33 438.43 1012.68 438.43C1014.03 438.43 1015.13 437.339 1015.13 435.985C1015.13 434.632 1014.04 433.541 1012.68 433.541Z"
            fill="white"
          />
          <path
            d="M1021.12 462.602C1019.8 462.602 1018.73 463.675 1018.73 464.995C1018.73 466.315 1019.8 467.401 1021.12 467.401C1022.44 467.401 1023.53 466.328 1023.53 464.995C1023.53 463.663 1022.45 462.602 1021.12 462.602Z"
            fill="white"
          />
          <path
            d="M1034.17 494.732C1032.88 494.732 1031.83 495.785 1031.83 497.083C1031.83 498.382 1032.88 499.426 1034.17 499.426C1035.46 499.426 1036.52 498.374 1036.52 497.083C1036.52 495.793 1035.47 494.732 1034.17 494.732Z"
            fill="white"
          />
          <path
            d="M1048.7 529.734C1047.43 529.734 1046.41 530.753 1046.41 532.022C1046.41 533.291 1047.43 534.313 1048.7 534.313C1049.98 534.313 1050.99 533.282 1050.99 532.022C1050.99 530.761 1049.96 529.734 1048.7 529.734Z"
            fill="white"
          />
          <path
            d="M1061.79 567.742C1060.57 567.742 1059.58 568.74 1059.58 569.957C1059.58 571.175 1060.57 572.173 1061.79 572.173C1063 572.173 1064 571.184 1064 569.957C1064 568.731 1063.01 567.742 1061.79 567.742Z"
            fill="white"
          />
          <path
            d="M1071.91 608.697C1070.7 608.697 1069.73 609.678 1069.73 610.874C1069.73 612.071 1070.7 613.039 1071.91 613.039C1073.12 613.039 1074.08 612.071 1074.08 610.874C1074.08 609.678 1073.11 608.697 1071.91 608.697Z"
            fill="white"
          />
          <path
            d="M1078.83 651.756C1077.65 651.756 1076.7 652.715 1076.7 653.89C1076.7 655.066 1077.65 656.012 1078.83 656.012C1080 656.012 1080.96 655.053 1080.96 653.89C1080.96 652.728 1080 651.756 1078.83 651.756Z"
            fill="white"
          />
          <path
            d="M11.6408 671.688C10.7751 671.688 10.0791 672.383 10.0791 673.249C10.0791 674.115 10.7751 674.811 11.6408 674.811C12.5065 674.811 13.2025 674.115 13.2025 673.249C13.2025 672.383 12.5065 671.688 11.6408 671.688Z"
            fill="white"
          />
          <path
            d="M1265.95 -2.28711C1264.34 -2.28711 1263.01 -0.975791 1263.01 0.649565C1263.01 2.27492 1264.34 3.58624 1265.95 3.58624C1267.56 3.58624 1268.89 2.27492 1268.89 0.649565C1268.89 -0.975791 1267.57 -2.28711 1265.95 -2.28711Z"
            fill="white"
          />
          <path
            d="M1273.48 15.166C1275.14 15.166 1276.48 13.8246 1276.48 12.1699C1276.48 10.5152 1275.14 9.17383 1273.48 9.17383C1271.83 9.17383 1270.49 10.5152 1270.49 12.1699C1270.49 13.8246 1271.83 15.166 1273.48 15.166Z"
            fill="white"
          />
          <path
            d="M1280.97 20.7559C1279.29 20.7559 1277.92 22.1181 1277.92 23.8071C1277.92 25.4961 1279.29 26.8584 1280.97 26.8584C1282.66 26.8584 1284.03 25.4961 1284.03 23.8071C1284.03 22.1181 1282.66 20.7559 1280.97 20.7559Z"
            fill="white"
          />
          <path
            d="M1288.38 32.4863C1286.65 32.4863 1285.25 33.891 1285.25 35.614C1285.25 37.3369 1286.65 38.7416 1288.38 38.7416C1290.1 38.7416 1291.51 37.3369 1291.51 35.614C1291.51 33.891 1290.1 32.4863 1288.38 32.4863Z"
            fill="white"
          />
          <path
            d="M1295.7 44.3516C1293.94 44.3516 1292.51 45.7775 1292.51 47.5386C1292.51 49.2998 1293.94 50.7299 1295.7 50.7299C1297.46 50.7299 1298.88 49.304 1298.88 47.5386C1298.88 45.7732 1297.46 44.3516 1295.7 44.3516Z"
            fill="white"
          />
          <path
            d="M1302.93 56.3691C1301.14 56.3691 1299.68 57.8163 1299.68 59.6071C1299.68 61.398 1301.14 62.8536 1302.93 62.8536C1304.72 62.8536 1306.17 61.398 1306.17 59.6071C1306.17 57.8163 1304.72 56.3691 1302.93 56.3691Z"
            fill="white"
          />
          <path
            d="M1310 68.5703C1308.18 68.5703 1306.71 70.0471 1306.71 71.8635C1306.71 73.6798 1308.18 75.1524 1310 75.1524C1311.82 75.1524 1313.29 73.6798 1313.29 71.8635C1313.29 70.0471 1311.82 68.5703 1310 68.5703Z"
            fill="white"
          />
          <path
            d="M1316.94 80.9121C1315.07 80.9121 1313.58 82.4229 1313.58 84.2774C1313.58 86.1319 1315.07 87.6427 1316.94 87.6427C1318.8 87.6427 1320.3 86.1319 1320.3 84.2774C1320.3 82.4229 1318.79 80.9121 1316.94 80.9121Z"
            fill="white"
          />
          <path
            d="M1323.7 93.498C1321.82 93.498 1320.3 95.0215 1320.3 96.9015C1320.3 98.7815 1321.82 100.318 1323.7 100.318C1325.59 100.318 1327.11 98.7858 1327.11 96.9015C1327.11 95.0173 1325.58 93.498 1323.7 93.498Z"
            fill="white"
          />
          <path
            d="M1330.39 106.109C1328.48 106.109 1326.93 107.658 1326.93 109.577C1326.93 111.495 1328.48 113.044 1330.39 113.044C1332.31 113.044 1333.86 111.495 1333.86 109.577C1333.86 107.658 1332.31 106.109 1330.39 106.109Z"
            fill="white"
          />
          <path
            d="M1337.06 118.713C1335.12 118.713 1333.55 120.292 1333.55 122.231C1333.55 124.17 1335.12 125.736 1337.06 125.736C1339.01 125.736 1340.57 124.166 1340.57 122.231C1340.57 120.296 1339 118.713 1337.06 118.713Z"
            fill="white"
          />
          <path
            d="M1343.79 131.133C1341.81 131.133 1340.22 132.737 1340.22 134.715C1340.22 136.692 1341.81 138.284 1343.79 138.284C1345.76 138.284 1347.36 136.679 1347.36 134.715C1347.36 132.75 1345.76 131.133 1343.79 131.133Z"
            fill="white"
          />
          <path
            d="M1350.66 143.254C1348.65 143.254 1347.04 144.879 1347.04 146.874C1347.04 148.868 1348.65 150.494 1350.66 150.494C1352.67 150.494 1354.28 148.873 1354.28 146.874C1354.28 144.875 1352.65 143.254 1350.66 143.254Z"
            fill="white"
          />
          <path
            d="M1357.77 154.863C1355.74 154.863 1354.1 156.501 1354.1 158.526C1354.1 160.55 1355.74 162.188 1357.77 162.188C1359.8 162.188 1361.43 160.55 1361.43 158.526C1361.43 156.501 1359.78 154.863 1357.77 154.863Z"
            fill="white"
          />
          <path
            d="M1365.17 165.777C1363.13 165.777 1361.46 167.441 1361.46 169.495C1361.46 171.549 1363.13 173.2 1365.17 173.2C1367.21 173.2 1368.89 171.536 1368.89 169.495C1368.89 167.454 1367.22 165.777 1365.17 165.777Z"
            fill="white"
          />
          <path
            d="M1372.96 175.76C1370.87 175.76 1369.18 177.445 1369.18 179.528C1369.18 181.612 1370.87 183.305 1372.96 183.305C1375.05 183.305 1376.73 181.608 1376.73 179.528C1376.73 177.449 1375.04 175.76 1372.96 175.76Z"
            fill="white"
          />
          <path
            d="M1381.11 184.691C1379.02 184.691 1377.31 186.397 1377.31 188.502C1377.31 190.607 1379.02 192.3 1381.11 192.3C1383.2 192.3 1384.92 190.603 1384.92 188.502C1384.92 186.402 1383.22 184.691 1381.11 184.691Z"
            fill="white"
          />
          <path
            d="M1389.61 192.434C1387.48 192.434 1385.76 194.152 1385.76 196.278C1385.76 198.405 1387.48 200.123 1389.61 200.123C1391.74 200.123 1393.45 198.4 1393.45 196.278C1393.45 194.157 1391.73 192.434 1389.61 192.434Z"
            fill="white"
          />
          <path
            d="M1398.36 198.982C1396.22 198.982 1394.49 200.722 1394.49 202.865C1394.49 205.009 1396.23 206.736 1398.36 206.736C1400.49 206.736 1402.24 205.009 1402.24 202.865C1402.24 200.722 1400.5 198.982 1398.36 198.982Z"
            fill="white"
          />
          <path
            d="M1407.29 204.35C1405.11 204.35 1403.35 206.107 1403.35 208.284C1403.35 210.461 1405.11 212.226 1407.29 212.226C1409.46 212.226 1411.23 210.456 1411.23 208.284C1411.23 206.111 1409.46 204.35 1407.29 204.35Z"
            fill="white"
          />
          <path
            d="M1416.3 208.74C1414.11 208.74 1412.34 210.518 1412.34 212.717C1412.34 214.915 1414.11 216.693 1416.3 216.693C1418.49 216.693 1420.28 214.915 1420.28 212.717C1420.28 210.518 1418.5 208.74 1416.3 208.74Z"
            fill="white"
          />
          <path
            d="M1425.32 212.354C1423.12 212.354 1421.32 214.144 1421.32 216.36C1421.32 218.575 1423.12 220.357 1425.32 220.357C1427.53 220.357 1429.33 218.566 1429.33 216.36C1429.33 214.153 1427.54 212.354 1425.32 212.354Z"
            fill="white"
          />
          <path
            d="M1434.32 215.354C1432.09 215.354 1430.28 217.153 1430.28 219.381C1430.28 221.609 1432.09 223.421 1434.32 223.421C1436.54 223.421 1438.36 221.609 1438.36 219.381C1438.36 217.153 1436.54 215.354 1434.32 215.354Z"
            fill="white"
          />
          <path
            d="M1443.24 217.902C1440.99 217.902 1439.16 219.723 1439.16 221.972C1439.16 224.221 1440.99 226.05 1443.24 226.05C1445.48 226.05 1447.31 224.217 1447.31 221.972C1447.31 219.727 1445.48 217.902 1443.24 217.902Z"
            fill="white"
          />
          <path
            d="M1452.07 220.014C1449.81 220.014 1447.97 221.847 1447.97 224.113C1447.97 226.379 1449.81 228.213 1452.07 228.213C1454.33 228.213 1456.18 226.379 1456.18 224.113C1456.18 221.847 1454.34 220.014 1452.07 220.014Z"
            fill="white"
          />
          <path
            d="M1450.31 264.457C1448.01 264.457 1446.16 266.32 1446.16 268.612C1446.16 270.903 1448.01 272.766 1450.31 272.766C1452.62 272.766 1454.47 270.903 1454.47 268.612C1454.47 266.32 1452.61 264.457 1450.31 264.457Z"
            fill="white"
          />
          <path
            d="M1439.74 268.15C1437.45 268.15 1435.6 270.013 1435.6 272.305C1435.6 274.597 1437.45 276.447 1439.74 276.447C1442.02 276.447 1443.88 274.584 1443.88 272.305C1443.88 270.026 1442.03 268.15 1439.74 268.15Z"
            fill="white"
          />
          <path
            d="M1428.6 272.283C1426.33 272.283 1424.49 274.125 1424.49 276.395C1424.49 278.666 1426.33 280.495 1428.6 280.495C1430.87 280.495 1432.7 278.662 1432.7 276.395C1432.7 274.129 1430.86 272.283 1428.6 272.283Z"
            fill="white"
          />
          <path
            d="M1417.08 276.977C1414.82 276.977 1413 278.81 1413 281.068C1413 283.325 1414.82 285.146 1417.08 285.146C1419.34 285.146 1421.16 283.325 1421.16 281.068C1421.16 278.81 1419.34 276.977 1417.08 276.977Z"
            fill="white"
          />
          <path
            d="M1405.2 282.18C1402.97 282.18 1401.15 284 1401.15 286.237C1401.15 288.473 1402.97 290.285 1405.2 290.285C1407.44 290.285 1409.26 288.473 1409.26 286.237C1409.26 284 1407.44 282.18 1405.2 282.18Z"
            fill="white"
          />
          <path
            d="M1392.82 287.854C1390.59 287.854 1388.79 289.653 1388.79 291.872C1388.79 294.092 1390.59 295.9 1392.82 295.9C1395.05 295.9 1396.84 294.1 1396.84 291.872C1396.84 289.644 1395.04 287.854 1392.82 287.854Z"
            fill="white"
          />
          <path
            d="M1379.92 293.777C1377.74 293.777 1375.95 295.555 1375.95 297.754C1375.95 299.952 1377.74 301.73 1379.92 301.73C1382.11 301.73 1383.9 299.952 1383.9 297.754C1383.9 295.555 1382.12 293.777 1379.92 293.777Z"
            fill="white"
          />
          <path
            d="M1366.57 299.625C1364.39 299.625 1362.63 301.395 1362.63 303.567C1362.63 305.74 1364.39 307.514 1366.57 307.514C1368.75 307.514 1370.52 305.745 1370.52 303.567C1370.52 301.39 1368.75 299.625 1366.57 299.625Z"
            fill="white"
          />
          <path
            d="M1352.62 305.279C1350.46 305.279 1348.71 307.028 1348.71 309.192C1348.71 311.356 1350.46 313.105 1352.62 313.105C1354.79 313.105 1356.55 311.356 1356.55 309.192C1356.55 307.028 1354.79 305.279 1352.62 305.279Z"
            fill="white"
          />
          <path
            d="M1338.11 310.502C1335.97 310.502 1334.24 312.242 1334.24 314.385C1334.24 316.528 1335.97 318.268 1338.11 318.268C1340.26 318.268 1342 316.528 1342 314.385C1342 312.242 1340.26 310.502 1338.11 310.502Z"
            fill="white"
          />
          <path
            d="M1323.15 314.975C1321.05 314.975 1319.33 316.693 1319.33 318.802C1319.33 320.912 1321.05 322.622 1323.15 322.622C1325.25 322.622 1326.98 320.916 1326.98 318.802C1326.98 316.689 1325.26 314.975 1323.15 314.975Z"
            fill="white"
          />
          <path
            d="M1307.89 318.566C1305.8 318.566 1304.11 320.264 1304.11 322.356C1304.11 324.448 1305.8 326.133 1307.89 326.133C1309.98 326.133 1311.68 324.448 1311.68 322.356C1311.68 320.264 1309.98 318.566 1307.89 318.566Z"
            fill="white"
          />
          <path
            d="M1292.43 321.201C1290.36 321.201 1288.69 322.877 1288.69 324.948C1288.69 327.019 1290.36 328.696 1292.43 328.696C1294.5 328.696 1296.18 327.019 1296.18 324.948C1296.18 322.877 1294.5 321.201 1292.43 321.201Z"
            fill="white"
          />
          <path
            d="M1276.95 322.742C1274.9 322.742 1273.24 324.397 1273.24 326.438C1273.24 328.48 1274.9 330.143 1276.95 330.143C1279 330.143 1280.65 328.488 1280.65 326.438C1280.65 324.389 1278.99 322.742 1276.95 322.742Z"
            fill="white"
          />
          <path
            d="M1261.66 323.314C1259.65 323.314 1258.02 324.94 1258.02 326.956C1258.02 328.971 1259.65 330.597 1261.66 330.597C1263.67 330.597 1265.3 328.963 1265.3 326.956C1265.3 324.948 1263.67 323.314 1261.66 323.314Z"
            fill="white"
          />
          <path
            d="M1246.75 323.094C1244.77 323.094 1243.16 324.706 1243.16 326.697C1243.16 328.687 1244.77 330.3 1246.75 330.3C1248.74 330.3 1250.34 328.687 1250.34 326.697C1250.34 324.706 1248.74 323.094 1246.75 323.094Z"
            fill="white"
          />
          <path
            d="M1232.17 322.139C1230.21 322.139 1228.61 323.73 1228.61 325.686C1228.61 327.643 1230.2 329.247 1232.17 329.247C1234.14 329.247 1235.72 327.656 1235.72 325.686C1235.72 323.717 1234.13 322.139 1232.17 322.139Z"
            fill="white"
          />
          <path
            d="M1217.97 320.658C1216.03 320.658 1214.46 322.228 1214.46 324.168C1214.46 326.107 1216.03 327.673 1217.97 327.673C1219.9 327.673 1221.48 326.103 1221.48 324.168C1221.48 322.233 1219.92 320.658 1217.97 320.658Z"
            fill="white"
          />
          <path
            d="M1204.18 319.109C1202.28 319.109 1200.74 320.65 1200.74 322.543C1200.74 324.435 1202.28 325.976 1204.18 325.976C1206.07 325.976 1207.62 324.435 1207.62 322.543C1207.62 320.65 1206.08 319.109 1204.18 319.109Z"
            fill="white"
          />
          <path
            d="M1190.65 317.576C1188.78 317.576 1187.26 319.095 1187.26 320.967C1187.26 322.838 1188.78 324.349 1190.65 324.349C1192.52 324.349 1194.03 322.83 1194.03 320.967C1194.03 319.104 1192.52 317.576 1190.65 317.576Z"
            fill="white"
          />
          <path
            d="M1177.19 316.215C1175.35 316.215 1173.86 317.713 1173.86 319.546C1173.86 321.379 1175.35 322.886 1177.19 322.886C1179.03 322.886 1180.52 321.388 1180.52 319.546C1180.52 317.704 1179.03 316.215 1177.19 316.215Z"
            fill="white"
          />
          <path
            d="M1163.81 315.184C1162 315.184 1160.53 316.652 1160.53 318.472C1160.53 320.293 1162 321.761 1163.81 321.761C1165.63 321.761 1167.11 320.285 1167.11 318.472C1167.11 316.66 1165.63 315.184 1163.81 315.184Z"
            fill="white"
          />
          <path
            d="M1150.52 314.688C1148.75 314.688 1147.32 316.113 1147.32 317.892C1147.32 319.67 1148.75 321.096 1150.52 321.096C1152.29 321.096 1153.73 319.661 1153.73 317.892C1153.73 316.122 1152.29 314.688 1150.52 314.688Z"
            fill="white"
          />
          <path
            d="M1137.05 314.674C1135.31 314.674 1133.89 316.091 1133.89 317.84C1133.89 319.588 1135.31 320.993 1137.05 320.993C1138.78 320.993 1140.21 319.575 1140.21 317.84C1140.21 316.104 1138.79 314.674 1137.05 314.674Z"
            fill="white"
          />
          <path
            d="M1123.41 315.412C1121.69 315.412 1120.31 316.808 1120.31 318.514C1120.31 320.22 1121.69 321.616 1123.41 321.616C1125.13 321.616 1126.51 320.233 1126.51 318.514C1126.51 316.796 1125.11 315.412 1123.41 315.412Z"
            fill="white"
          />
          <path
            d="M1109.7 317.119C1108.03 317.119 1106.66 318.481 1106.66 320.158C1106.66 321.834 1108.03 323.209 1109.7 323.209C1111.38 323.209 1112.75 321.847 1112.75 320.158C1112.75 318.469 1111.39 317.119 1109.7 317.119Z"
            fill="white"
          />
          <path
            d="M1095.77 319.932C1094.14 319.932 1092.8 321.264 1092.8 322.898C1092.8 324.532 1094.14 325.864 1095.77 325.864C1097.4 325.864 1098.74 324.545 1098.74 322.898C1098.74 321.251 1097.42 319.932 1095.77 319.932Z"
            fill="white"
          />
          <path
            d="M1081.87 324.154C1080.26 324.154 1078.96 325.457 1078.96 327.057C1078.96 328.657 1080.26 329.972 1081.87 329.972C1083.48 329.972 1084.77 328.67 1084.77 327.057C1084.77 325.444 1083.47 324.154 1081.87 324.154Z"
            fill="white"
          />
          <path
            d="M1068.09 330.057C1066.52 330.057 1065.24 331.338 1065.24 332.908C1065.24 334.479 1066.52 335.76 1068.09 335.76C1069.66 335.76 1070.94 334.479 1070.94 332.908C1070.94 331.338 1069.66 330.057 1068.09 330.057Z"
            fill="white"
          />
          <path
            d="M1054.74 338.02C1053.2 338.02 1051.95 339.267 1051.95 340.808C1051.95 342.348 1053.2 343.596 1054.74 343.596C1056.28 343.596 1057.53 342.348 1057.53 340.808C1057.53 339.267 1056.28 338.02 1054.74 338.02Z"
            fill="white"
          />
          <path
            d="M1042.46 348.521C1040.96 348.521 1039.75 349.731 1039.75 351.229C1039.75 352.727 1040.96 353.937 1042.46 353.937C1043.96 353.937 1045.17 352.719 1045.17 351.229C1045.17 349.739 1043.96 348.521 1042.46 348.521Z"
            fill="white"
          />
          <path
            d="M1031.65 361.779C1030.18 361.779 1029 362.968 1029 364.432C1029 365.896 1030.18 367.075 1031.65 367.075C1033.11 367.075 1034.29 365.887 1034.29 364.432C1034.29 362.976 1033.1 361.779 1031.65 361.779Z"
            fill="white"
          />
          <path
            d="M1023.49 378.316C1022.06 378.316 1020.89 379.483 1020.89 380.909C1020.89 382.335 1022.06 383.502 1023.49 383.502C1024.91 383.502 1026.08 382.348 1026.08 380.909C1026.08 379.471 1024.93 378.316 1023.49 378.316Z"
            fill="white"
          />
          <path
            d="M1018.74 398.209C1017.33 398.209 1016.2 399.334 1016.2 400.738C1016.2 402.143 1017.33 403.268 1018.74 403.268C1020.14 403.268 1021.27 402.134 1021.27 400.738C1021.27 399.342 1020.13 398.209 1018.74 398.209Z"
            fill="white"
          />
          <path
            d="M1019.17 421.875C1017.8 421.875 1016.7 422.97 1016.7 424.332C1016.7 425.694 1017.8 426.789 1019.17 426.789C1020.53 426.789 1021.62 425.686 1021.62 424.332C1021.62 422.978 1020.52 421.875 1019.17 421.875Z"
            fill="white"
          />
          <path
            d="M1025.63 449.168C1024.3 449.168 1023.22 450.25 1023.22 451.574C1023.22 452.898 1024.3 453.98 1025.63 453.98C1026.96 453.98 1028.03 452.907 1028.03 451.574C1028.03 450.242 1026.95 449.168 1025.63 449.168Z"
            fill="white"
          />
          <path
            d="M1037.18 479.672C1035.89 479.672 1034.84 480.724 1034.84 482.014C1034.84 483.304 1035.89 484.357 1037.18 484.357C1038.47 484.357 1039.52 483.317 1039.52 482.014C1039.52 480.712 1038.47 479.672 1037.18 479.672Z"
            fill="white"
          />
          <path
            d="M1051.12 512.988C1049.85 512.988 1048.82 514.019 1048.82 515.288C1048.82 516.557 1049.85 517.588 1051.12 517.588C1052.39 517.588 1053.42 516.557 1053.42 515.288C1053.42 514.019 1052.39 512.988 1051.12 512.988Z"
            fill="white"
          />
          <path
            d="M1064.38 549.08C1063.14 549.08 1062.15 550.077 1062.15 551.308C1062.15 552.539 1063.14 553.536 1064.38 553.536C1065.62 553.536 1066.59 552.539 1066.59 551.308C1066.59 550.077 1065.6 549.08 1064.38 549.08Z"
            fill="white"
          />
          <path
            d="M1075.05 587.85C1073.85 587.85 1072.87 588.83 1072.87 590.027C1072.87 591.223 1073.85 592.204 1075.05 592.204C1076.24 592.204 1077.22 591.223 1077.22 590.027C1077.22 588.83 1076.24 587.85 1075.05 587.85Z"
            fill="white"
          />
          <path
            d="M1082.73 628.775C1081.55 628.775 1080.6 629.734 1080.6 630.897C1080.6 632.06 1081.55 633.032 1082.73 633.032C1083.9 633.032 1084.86 632.073 1084.86 630.897C1084.86 629.722 1083.9 628.775 1082.73 628.775Z"
            fill="white"
          />
          <path
            d="M1087.65 670.736C1086.49 670.736 1085.56 671.674 1085.56 672.837C1085.56 674 1086.49 674.929 1087.65 674.929C1088.8 674.929 1089.74 673.991 1089.74 672.837C1089.74 671.683 1088.8 670.736 1087.65 670.736Z"
            fill="white"
          />
          <path
            d="M1290.01 4.21875C1288.36 4.21875 1287.02 5.55129 1287.02 7.20635C1287.02 8.86141 1288.36 10.1939 1290.01 10.1939C1291.67 10.1939 1293 8.86141 1293 7.20635C1293 5.55129 1291.67 4.21875 1290.01 4.21875Z"
            fill="white"
          />
          <path
            d="M1297.51 15.8125C1295.82 15.8125 1294.46 17.1747 1294.46 18.8638C1294.46 20.5528 1295.82 21.915 1297.51 21.915C1299.2 21.915 1300.56 20.5528 1300.56 18.8638C1300.56 17.1747 1299.2 15.8125 1297.51 15.8125Z"
            fill="white"
          />
          <path
            d="M1304.88 27.584C1303.15 27.584 1301.75 28.9887 1301.75 30.7159C1301.75 32.4431 1303.15 33.8478 1304.88 33.8478C1306.61 33.8478 1308.01 32.4473 1308.01 30.7159C1308.01 28.9844 1306.62 27.584 1304.88 27.584Z"
            fill="white"
          />
          <path
            d="M1312.14 39.5957C1310.38 39.5957 1308.95 41.0216 1308.95 42.7828C1308.95 44.5439 1310.38 45.9571 1312.14 45.9571C1313.9 45.9571 1315.31 44.5312 1315.31 42.7828C1315.31 41.0343 1313.89 39.5957 1312.14 39.5957Z"
            fill="white"
          />
          <path
            d="M1319.2 51.8691C1317.41 51.8691 1315.97 53.3205 1315.97 55.1114C1315.97 56.9022 1317.41 58.3493 1319.2 58.3493C1320.99 58.3493 1322.45 56.9022 1322.45 55.1114C1322.45 53.3205 1320.99 51.8691 1319.2 51.8691Z"
            fill="white"
          />
          <path
            d="M1326.08 64.4414C1324.27 64.4414 1322.8 65.914 1322.8 67.7261C1322.8 69.5381 1324.27 71.015 1326.08 71.015C1327.9 71.015 1329.37 69.5381 1329.37 67.7261C1329.37 65.914 1327.9 64.4414 1326.08 64.4414Z"
            fill="white"
          />
          <path
            d="M1332.8 77.1973C1330.95 77.1973 1329.44 78.708 1329.44 80.571C1329.44 82.4341 1330.95 83.9321 1332.8 83.9321C1334.65 83.9321 1336.17 82.4213 1336.17 80.571C1336.17 78.7208 1334.66 77.1973 1332.8 77.1973Z"
            fill="white"
          />
          <path
            d="M1339.4 90.1113C1337.51 90.1113 1335.98 91.6433 1335.98 93.5233C1335.98 95.4033 1337.52 96.948 1339.4 96.948C1341.28 96.948 1342.82 95.416 1342.82 93.5233C1342.82 91.6306 1341.29 90.1113 1339.4 90.1113Z"
            fill="white"
          />
          <path
            d="M1345.94 103.051C1344.03 103.051 1342.48 104.604 1342.48 106.518C1342.48 108.432 1344.03 109.977 1345.94 109.977C1347.86 109.977 1349.4 108.432 1349.4 106.518C1349.4 104.604 1347.84 103.051 1345.94 103.051Z"
            fill="white"
          />
          <path
            d="M1352.48 115.922C1350.54 115.922 1348.97 117.492 1348.97 119.436C1348.97 121.379 1350.54 122.941 1352.48 122.941C1354.42 122.941 1355.99 121.371 1355.99 119.436C1355.99 117.501 1354.42 115.922 1352.48 115.922Z"
            fill="white"
          />
          <path
            d="M1359.13 128.508C1357.15 128.508 1355.55 130.112 1355.55 132.09C1355.55 134.067 1357.15 135.675 1359.13 135.675C1361.11 135.675 1362.71 134.067 1362.71 132.09C1362.71 130.112 1361.11 128.508 1359.13 128.508Z"
            fill="white"
          />
          <path
            d="M1365.96 140.75C1363.95 140.75 1362.32 142.371 1362.32 144.383C1362.32 146.394 1363.95 148.003 1365.96 148.003C1367.96 148.003 1369.58 146.377 1369.58 144.383C1369.58 142.388 1367.95 140.75 1365.96 140.75Z"
            fill="white"
          />
          <path
            d="M1373.09 152.355C1371.07 152.355 1369.43 154.002 1369.43 156.018C1369.43 158.034 1371.07 159.68 1373.09 159.68C1375.12 159.68 1376.76 158.042 1376.76 156.018C1376.76 153.994 1375.11 152.355 1373.09 152.355Z"
            fill="white"
          />
          <path
            d="M1380.6 163.154C1378.55 163.154 1376.9 164.814 1376.9 166.859C1376.9 168.905 1378.55 170.564 1380.6 170.564C1382.65 170.564 1384.31 168.909 1384.31 166.859C1384.31 164.809 1382.65 163.154 1380.6 163.154Z"
            fill="white"
          />
          <path
            d="M1388.5 172.953C1386.42 172.953 1384.73 174.646 1384.73 176.722C1384.73 178.797 1386.42 180.49 1388.5 180.49C1390.58 180.49 1392.27 178.805 1392.27 176.722C1392.27 174.638 1390.58 172.953 1388.5 172.953Z"
            fill="white"
          />
          <path
            d="M1396.78 181.684C1394.67 181.684 1392.96 183.39 1392.96 185.503C1392.96 187.616 1394.67 189.314 1396.78 189.314C1398.9 189.314 1400.6 187.608 1400.6 185.503C1400.6 183.398 1398.89 181.684 1396.78 181.684Z"
            fill="white"
          />
          <path
            d="M1405.38 189.258C1403.26 189.258 1401.54 190.981 1401.54 193.107C1401.54 195.233 1403.26 196.947 1405.38 196.947C1407.5 196.947 1409.23 195.229 1409.23 193.107C1409.23 190.985 1407.5 189.258 1405.38 189.258Z"
            fill="white"
          />
          <path
            d="M1414.23 195.709C1412.09 195.709 1410.34 197.453 1410.34 199.596C1410.34 201.739 1412.09 203.488 1414.23 203.488C1416.37 203.488 1418.12 201.739 1418.12 199.596C1418.12 197.453 1416.37 195.709 1414.23 195.709Z"
            fill="white"
          />
          <path
            d="M1423.24 201.094C1421.07 201.094 1419.31 202.855 1419.31 205.028C1419.31 207.201 1421.07 208.97 1423.24 208.97C1425.42 208.97 1427.19 207.201 1427.19 205.028C1427.19 202.855 1425.42 201.094 1423.24 201.094Z"
            fill="white"
          />
          <path
            d="M1432.33 205.602C1430.13 205.602 1428.35 207.371 1428.35 209.565C1428.35 211.759 1430.13 213.542 1432.33 213.542C1434.53 213.542 1436.31 211.763 1436.31 209.565C1436.31 207.367 1434.53 205.602 1432.33 205.602Z"
            fill="white"
          />
          <path
            d="M1441.41 209.387C1439.2 209.387 1437.41 211.178 1437.41 213.393C1437.41 215.608 1439.2 217.399 1441.41 217.399C1443.63 217.399 1445.41 215.6 1445.41 213.393C1445.41 211.186 1443.62 209.387 1441.41 209.387Z"
            fill="white"
          />
          <path
            d="M1450.44 212.529C1448.21 212.529 1446.41 214.341 1446.41 216.569C1446.41 218.797 1448.21 220.597 1450.44 220.597C1452.67 220.597 1454.48 218.797 1454.48 216.569C1454.48 214.341 1452.68 212.529 1450.44 212.529Z"
            fill="white"
          />
          <path
            d="M1453.43 272.749C1455.72 272.749 1457.57 270.894 1457.57 268.607C1457.57 266.319 1455.72 264.465 1453.43 264.465C1451.15 264.465 1449.29 266.319 1449.29 268.607C1449.29 270.894 1451.15 272.749 1453.43 272.749Z"
            fill="white"
          />
          <path
            d="M1442.2 268.32C1439.93 268.32 1438.11 270.162 1438.11 272.42C1438.11 274.677 1439.94 276.532 1442.2 276.532C1444.47 276.532 1446.32 274.69 1446.32 272.42C1446.32 270.149 1444.48 268.32 1442.2 268.32Z"
            fill="white"
          />
          <path
            d="M1430.44 272.555C1428.2 272.555 1426.37 274.388 1426.37 276.646C1426.37 278.903 1428.2 280.724 1430.44 280.724C1432.69 280.724 1434.54 278.891 1434.54 276.646C1434.54 274.401 1432.7 272.555 1430.44 272.555Z"
            fill="white"
          />
          <path
            d="M1418.34 277.404C1416.11 277.404 1414.28 279.225 1414.28 281.461C1414.28 283.698 1416.1 285.51 1418.34 285.51C1420.58 285.51 1422.39 283.698 1422.39 281.461C1422.39 279.225 1420.58 277.404 1418.34 277.404Z"
            fill="white"
          />
          <path
            d="M1405.78 282.816C1403.55 282.816 1401.74 284.616 1401.74 286.856C1401.74 289.097 1403.55 290.884 1405.78 290.884C1408 290.884 1409.82 289.084 1409.82 286.856C1409.82 284.628 1408 282.816 1405.78 282.816Z"
            fill="white"
          />
          <path
            d="M1392.75 288.736C1390.55 288.736 1388.76 290.527 1388.76 292.721C1388.76 294.915 1390.55 296.706 1392.75 296.706C1394.94 296.706 1396.73 294.928 1396.73 292.721C1396.73 290.514 1394.95 288.736 1392.75 288.736Z"
            fill="white"
          />
          <path
            d="M1379.3 294.877C1377.12 294.877 1375.36 296.647 1375.36 298.819C1375.36 300.992 1377.13 302.766 1379.3 302.766C1381.47 302.766 1383.24 300.996 1383.24 298.819C1383.24 296.642 1381.48 294.877 1379.3 294.877Z"
            fill="white"
          />
          <path
            d="M1365.36 300.902C1363.21 300.902 1361.45 302.664 1361.45 304.815C1361.45 306.967 1363.21 308.728 1365.36 308.728C1367.51 308.728 1369.27 306.979 1369.27 304.815C1369.27 302.651 1367.53 300.902 1365.36 300.902Z"
            fill="white"
          />
          <path
            d="M1350.84 306.699C1348.7 306.699 1346.96 308.439 1346.96 310.582C1346.96 312.725 1348.7 314.453 1350.84 314.453C1352.99 314.453 1354.72 312.713 1354.72 310.582C1354.72 308.452 1352.98 306.699 1350.84 306.699Z"
            fill="white"
          />
          <path
            d="M1335.83 311.988C1333.73 311.988 1332.02 313.694 1332.02 315.808C1332.02 317.921 1333.72 319.627 1335.83 319.627C1337.93 319.627 1339.65 317.908 1339.65 315.808C1339.65 313.707 1337.94 311.988 1335.83 311.988Z"
            fill="white"
          />
          <path
            d="M1320.47 316.371C1318.38 316.371 1316.7 318.069 1316.7 320.161C1316.7 322.253 1318.38 323.95 1320.47 323.95C1322.56 323.95 1324.26 322.253 1324.26 320.161C1324.26 318.069 1322.56 316.371 1320.47 316.371Z"
            fill="white"
          />
          <path
            d="M1304.81 319.848C1302.74 319.848 1301.06 321.524 1301.06 323.595C1301.06 325.666 1302.74 327.342 1304.81 327.342C1306.88 327.342 1308.56 325.666 1308.56 323.595C1308.56 321.524 1306.88 319.848 1304.81 319.848Z"
            fill="white"
          />
          <path
            d="M1289.03 322.291C1286.98 322.291 1285.32 323.955 1285.32 326.009C1285.32 328.063 1286.98 329.726 1289.03 329.726C1291.08 329.726 1292.75 328.063 1292.75 326.009C1292.75 323.955 1291.08 322.291 1289.03 322.291Z"
            fill="white"
          />
          <path
            d="M1273.36 323.623C1271.35 323.623 1269.72 325.257 1269.72 327.264C1269.72 329.271 1271.35 330.905 1273.36 330.905C1275.37 330.905 1277 329.28 1277 327.264C1277 325.248 1275.37 323.623 1273.36 323.623Z"
            fill="white"
          />
          <path
            d="M1258 324.01C1256.02 324.01 1254.41 325.622 1254.41 327.613C1254.41 329.603 1256.02 331.203 1258 331.203C1259.99 331.203 1261.59 329.59 1261.59 327.613C1261.59 325.635 1259.99 324.01 1258 324.01Z"
            fill="white"
          />
          <path
            d="M1243 323.602C1241.04 323.602 1239.45 325.193 1239.45 327.162C1239.45 329.131 1241.04 330.71 1243 330.71C1244.96 330.71 1246.55 329.118 1246.55 327.162C1246.55 325.206 1244.96 323.602 1243 323.602Z"
            fill="white"
          />
          <path
            d="M1228.39 322.482C1226.45 322.482 1224.88 324.053 1224.88 325.988C1224.88 327.923 1226.45 329.493 1228.39 329.493C1230.32 329.493 1231.91 327.923 1231.91 325.988C1231.91 324.053 1230.34 322.482 1228.39 322.482Z"
            fill="white"
          />
          <path
            d="M1214.23 321.014C1212.34 321.014 1210.8 322.554 1210.8 324.447C1210.8 326.34 1212.34 327.88 1214.23 327.88C1216.12 327.88 1217.66 326.34 1217.66 324.447C1217.66 322.554 1216.13 321.014 1214.23 321.014Z"
            fill="white"
          />
          <path
            d="M1200.47 319.473C1198.6 319.473 1197.08 320.992 1197.08 322.863C1197.08 324.735 1198.6 326.246 1200.47 326.246C1202.35 326.246 1203.85 324.726 1203.85 322.863C1203.85 321 1202.34 319.473 1200.47 319.473Z"
            fill="white"
          />
          <path
            d="M1186.87 318.004C1185.02 318.004 1183.53 319.502 1183.53 321.344C1183.53 323.186 1185.02 324.684 1186.87 324.684C1188.71 324.684 1190.21 323.194 1190.21 321.344C1190.21 319.493 1188.71 318.004 1186.87 318.004Z"
            fill="white"
          />
          <path
            d="M1173.4 316.797C1171.59 316.797 1170.12 318.265 1170.12 320.077C1170.12 321.889 1171.59 323.366 1173.4 323.366C1175.21 323.366 1176.69 321.889 1176.69 320.077C1176.69 318.265 1175.21 316.797 1173.4 316.797Z"
            fill="white"
          />
          <path
            d="M1160.11 316.027C1158.33 316.027 1156.89 317.466 1156.89 319.244C1156.89 321.022 1158.33 322.448 1160.11 322.448C1161.89 322.448 1163.31 321.014 1163.31 319.244C1163.31 317.474 1161.88 316.027 1160.11 316.027Z"
            fill="white"
          />
          <path
            d="M1146.75 315.734C1145 315.734 1143.59 317.152 1143.59 318.896C1143.59 320.64 1145 322.049 1146.75 322.049C1148.49 322.049 1149.9 320.632 1149.9 318.896C1149.9 317.16 1148.48 315.734 1146.75 315.734Z"
            fill="white"
          />
          <path
            d="M1133.23 316.09C1131.52 316.09 1130.14 317.473 1130.14 319.179C1130.14 320.885 1131.52 322.281 1133.23 322.281C1134.93 322.281 1136.33 320.885 1136.33 319.179C1136.33 317.473 1134.93 316.09 1133.23 316.09Z"
            fill="white"
          />
          <path
            d="M1119.7 317.297C1118.02 317.297 1116.64 318.659 1116.64 320.348C1116.64 322.037 1118.02 323.408 1119.7 323.408C1121.39 323.408 1122.76 322.033 1122.76 320.348C1122.76 318.663 1121.39 317.297 1119.7 317.297Z"
            fill="white"
          />
          <path
            d="M1105.99 319.545C1104.35 319.545 1103.02 320.865 1103.02 322.511C1103.02 324.158 1104.35 325.478 1105.99 325.478C1107.62 325.478 1108.96 324.145 1108.96 322.511C1108.96 320.877 1107.62 319.545 1105.99 319.545Z"
            fill="white"
          />
          <path
            d="M1092.23 323.051C1090.63 323.051 1089.33 324.354 1089.33 325.954C1089.33 327.553 1090.63 328.856 1092.23 328.856C1093.83 328.856 1095.13 327.553 1095.13 325.954C1095.13 324.354 1093.83 323.051 1092.23 323.051Z"
            fill="white"
          />
          <path
            d="M1078.68 328.143C1077.09 328.143 1075.82 329.424 1075.82 330.994C1075.82 332.565 1077.09 333.846 1078.68 333.846C1080.26 333.846 1081.53 332.577 1081.53 330.994C1081.53 329.411 1080.25 328.143 1078.68 328.143Z"
            fill="white"
          />
          <path
            d="M1065.35 335.086C1063.81 335.086 1062.56 336.334 1062.56 337.874C1062.56 339.415 1063.81 340.662 1065.35 340.662C1066.89 340.662 1068.13 339.415 1068.13 337.874C1068.13 336.334 1066.89 335.086 1065.35 335.086Z"
            fill="white"
          />
          <path
            d="M1053 344.43C1051.5 344.43 1050.29 345.639 1050.29 347.137C1050.29 348.635 1051.5 349.845 1053 349.845C1054.5 349.845 1055.71 348.627 1055.71 347.137C1055.71 345.648 1054.5 344.43 1053 344.43Z"
            fill="white"
          />
          <path
            d="M1041.9 356.346C1040.44 356.346 1039.25 357.534 1039.25 358.998C1039.25 360.462 1040.44 361.642 1041.9 361.642C1043.35 361.642 1044.55 360.454 1044.55 358.998C1044.55 357.542 1043.36 356.346 1041.9 356.346Z"
            fill="white"
          />
          <path
            d="M1033.22 371.43C1031.78 371.43 1030.62 372.597 1030.62 374.031C1030.62 375.465 1031.78 376.633 1033.22 376.633C1034.65 376.633 1035.82 375.465 1035.82 374.031C1035.82 372.597 1034.65 371.43 1033.22 371.43Z"
            fill="white"
          />
          <path
            d="M1027.67 389.736C1026.27 389.736 1025.12 390.869 1025.12 392.274C1025.12 393.679 1026.27 394.812 1027.67 394.812C1029.08 394.812 1030.21 393.666 1030.21 392.274C1030.21 390.882 1029.06 389.736 1027.67 389.736Z"
            fill="white"
          />
          <path
            d="M1026.77 411.615C1025.42 411.615 1024.32 412.719 1024.32 414.072C1024.32 415.426 1025.42 416.53 1026.77 416.53C1028.13 416.53 1029.23 415.426 1029.23 414.072C1029.23 412.719 1028.13 411.615 1026.77 411.615Z"
            fill="white"
          />
          <path
            d="M1031.46 437.123C1030.14 437.123 1029.05 438.197 1029.05 439.517C1029.05 440.836 1030.13 441.918 1031.46 441.918C1032.78 441.918 1033.85 440.845 1033.85 439.517C1033.85 438.188 1032.78 437.123 1031.46 437.123Z"
            fill="white"
          />
          <path
            d="M1041.41 465.971C1040.12 465.971 1039.06 467.023 1039.06 468.313C1039.06 469.603 1040.12 470.656 1041.41 470.656C1042.7 470.656 1043.75 469.603 1043.75 468.313C1043.75 467.023 1042.7 465.971 1041.41 465.971Z"
            fill="white"
          />
          <path
            d="M1054.28 497.646C1053.02 497.646 1051.99 498.665 1051.99 499.938C1051.99 501.211 1053.02 502.225 1054.28 502.225C1055.54 502.225 1056.58 501.207 1056.58 499.938C1056.58 498.669 1055.55 497.646 1054.28 497.646Z"
            fill="white"
          />
          <path
            d="M1067.33 531.957C1066.11 531.957 1065.12 532.946 1065.12 534.172C1065.12 535.399 1066.11 536.4 1067.33 536.4C1068.55 536.4 1069.56 535.403 1069.56 534.172C1069.56 532.942 1068.56 531.957 1067.33 531.957Z"
            fill="white"
          />
          <path
            d="M1078.41 568.764C1077.21 568.764 1076.23 569.744 1076.23 570.941C1076.23 572.137 1077.21 573.126 1078.41 573.126C1079.61 573.126 1080.59 572.146 1080.59 570.941C1080.59 569.735 1079.61 568.764 1078.41 568.764Z"
            fill="white"
          />
          <path
            d="M1086.59 607.51C1085.41 607.51 1084.45 608.469 1084.45 609.644C1084.45 610.82 1085.41 611.779 1086.59 611.779C1087.76 611.779 1088.72 610.82 1088.72 609.644C1088.72 608.469 1087.76 607.51 1086.59 607.51Z"
            fill="white"
          />
          <path
            d="M1092.12 647.527C1090.96 647.527 1090.02 648.465 1090.02 649.62C1090.02 650.774 1090.96 651.712 1092.12 651.712C1093.27 651.712 1094.21 650.774 1094.21 649.62C1094.21 648.465 1093.27 647.527 1092.12 647.527Z"
            fill="white"
          />
          <path
            d="M1306.31 -0.267578C1304.65 -0.267578 1303.3 1.07345 1303.3 2.72851C1303.3 4.38357 1304.64 5.7246 1306.31 5.7246C1307.98 5.7246 1309.31 4.38357 1309.31 2.72851C1309.31 1.07345 1307.97 -0.267578 1306.31 -0.267578Z"
            fill="white"
          />
          <path
            d="M1313.8 11.2949C1312.12 11.2949 1310.75 12.6572 1310.75 14.3462C1310.75 16.0352 1312.11 17.3847 1313.8 17.3847C1315.49 17.3847 1316.84 16.0225 1316.84 14.3462C1316.84 12.6699 1315.48 11.2949 1313.8 11.2949Z"
            fill="white"
          />
          <path
            d="M1321.13 23.1055C1319.4 23.1055 1318.01 24.5102 1318.01 26.2374C1318.01 27.9646 1319.4 29.3692 1321.13 29.3692C1322.86 29.3692 1324.26 27.9646 1324.26 26.2374C1324.26 24.5102 1322.86 23.1055 1321.13 23.1055Z"
            fill="white"
          />
          <path
            d="M1328.25 35.3379C1326.49 35.3379 1325.06 36.7638 1325.06 38.5122C1325.06 40.2606 1326.49 41.6993 1328.25 41.6993C1330 41.6993 1331.42 40.2734 1331.42 38.5122C1331.42 36.7511 1330 35.3379 1328.25 35.3379Z"
            fill="white"
          />
          <path
            d="M1335.14 47.9004C1333.35 47.9004 1331.9 49.3518 1331.9 51.1384C1331.9 52.925 1333.35 54.3806 1335.14 54.3806C1336.93 54.3806 1338.38 52.9292 1338.38 51.1384C1338.38 49.3475 1336.93 47.9004 1335.14 47.9004Z"
            fill="white"
          />
          <path
            d="M1341.83 60.7832C1340.02 60.7832 1338.54 62.2515 1338.54 64.0721C1338.54 65.8927 1340.02 67.3525 1341.83 67.3525C1343.64 67.3525 1345.12 65.8842 1345.12 64.0721C1345.12 62.26 1343.64 60.7832 1341.83 60.7832Z"
            fill="white"
          />
          <path
            d="M1348.35 73.8906C1346.49 73.8906 1344.98 75.3929 1344.98 77.2474C1344.98 79.102 1346.5 80.6085 1348.35 80.6085C1350.2 80.6085 1351.71 79.0977 1351.71 77.2474C1351.71 75.3972 1350.2 73.8906 1348.35 73.8906Z"
            fill="white"
          />
          <path
            d="M1354.75 87.1582C1352.86 87.1582 1351.32 88.6902 1351.32 90.5702C1351.32 92.4502 1352.86 93.9949 1354.75 93.9949C1356.64 93.9949 1358.16 92.4629 1358.16 90.5702C1358.16 88.6775 1356.63 87.1582 1354.75 87.1582Z"
            fill="white"
          />
          <path
            d="M1361.08 100.5C1359.17 100.5 1357.62 102.049 1357.62 103.967C1357.62 105.885 1359.17 107.422 1361.08 107.422C1362.98 107.422 1364.54 105.868 1364.54 103.967C1364.54 102.066 1362.99 100.5 1361.08 100.5Z"
            fill="white"
          />
          <path
            d="M1367.45 113.719C1365.52 113.719 1363.96 115.289 1363.96 117.224C1363.96 119.159 1365.52 120.729 1367.45 120.729C1369.39 120.729 1370.96 119.159 1370.96 117.224C1370.96 115.289 1369.39 113.719 1367.45 113.719Z"
            fill="white"
          />
          <path
            d="M1374.01 126.547C1372.03 126.547 1370.43 128.151 1370.43 130.133C1370.43 132.115 1372.03 133.715 1374.01 133.715C1375.99 133.715 1377.6 132.11 1377.6 130.133C1377.6 128.155 1376 126.547 1374.01 126.547Z"
            fill="white"
          />
          <path
            d="M1380.84 138.877C1378.84 138.877 1377.22 140.502 1377.22 142.497C1377.22 144.491 1378.84 146.13 1380.84 146.13C1382.83 146.13 1384.47 144.504 1384.47 142.497C1384.47 140.49 1382.85 138.877 1380.84 138.877Z"
            fill="white"
          />
          <path
            d="M1388.04 150.449C1386.01 150.449 1384.37 152.096 1384.37 154.124C1384.37 156.153 1386.01 157.799 1388.04 157.799C1390.07 157.799 1391.72 156.153 1391.72 154.124C1391.72 152.096 1390.07 150.449 1388.04 150.449Z"
            fill="white"
          />
          <path
            d="M1395.63 161.168C1393.59 161.168 1391.92 162.823 1391.92 164.873C1391.92 166.922 1393.59 168.578 1395.63 168.578C1397.67 168.578 1399.33 166.922 1399.33 164.873C1399.33 162.823 1397.68 161.168 1395.63 161.168Z"
            fill="white"
          />
          <path
            d="M1403.65 170.816C1401.56 170.816 1399.88 172.501 1399.88 174.585C1399.88 176.669 1401.56 178.353 1403.65 178.353C1405.73 178.353 1407.41 176.66 1407.41 174.585C1407.41 172.51 1405.73 170.816 1403.65 170.816Z"
            fill="white"
          />
          <path
            d="M1412.03 179.395C1409.93 179.395 1408.22 181.096 1408.22 183.197C1408.22 185.298 1409.93 187.008 1412.03 187.008C1414.14 187.008 1415.84 185.306 1415.84 183.197C1415.84 181.088 1414.14 179.395 1412.03 179.395Z"
            fill="white"
          />
          <path
            d="M1420.76 186.844C1418.64 186.844 1416.91 188.562 1416.91 190.684C1416.91 192.806 1418.64 194.533 1420.76 194.533C1422.88 194.533 1424.61 192.81 1424.61 190.684C1424.61 188.558 1422.88 186.844 1420.76 186.844Z"
            fill="white"
          />
          <path
            d="M1429.72 193.227C1427.57 193.227 1425.83 194.966 1425.83 197.11C1425.83 199.253 1427.57 201.001 1429.72 201.001C1431.86 201.001 1433.61 199.261 1433.61 197.11C1433.61 194.958 1431.87 193.227 1429.72 193.227Z"
            fill="white"
          />
          <path
            d="M1438.83 198.646C1436.66 198.646 1434.9 200.408 1434.9 202.58C1434.9 204.753 1436.66 206.514 1438.83 206.514C1441.01 206.514 1442.77 204.753 1442.77 202.58C1442.77 200.408 1441.01 198.646 1438.83 198.646Z"
            fill="white"
          />
          <path
            d="M1448.02 203.215C1445.83 203.215 1444.06 204.993 1444.06 207.191C1444.06 209.39 1445.83 211.155 1448.02 211.155C1450.22 211.155 1451.98 209.377 1451.98 207.191C1451.98 205.006 1450.21 203.215 1448.02 203.215Z"
            fill="white"
          />
          <path
            d="M1444.27 268.672C1442.02 268.672 1440.19 270.505 1440.19 272.763C1440.19 275.021 1442.02 276.841 1444.27 276.841C1446.51 276.841 1448.36 275.008 1448.36 272.763C1448.36 270.518 1446.52 268.672 1444.27 268.672Z"
            fill="white"
          />
          <path
            d="M1431.9 273.041C1429.65 273.041 1427.83 274.862 1427.83 277.111C1427.83 279.36 1429.65 281.168 1431.9 281.168C1434.15 281.168 1435.96 279.356 1435.96 277.111C1435.96 274.866 1434.14 273.041 1431.9 273.041Z"
            fill="white"
          />
          <path
            d="M1419.05 278.092C1416.82 278.092 1415.02 279.891 1415.02 282.119C1415.02 284.347 1416.82 286.146 1419.05 286.146C1421.27 286.146 1423.07 284.347 1423.07 282.119C1423.07 279.891 1421.27 278.092 1419.05 278.092Z"
            fill="white"
          />
          <path
            d="M1405.84 283.74C1403.63 283.74 1401.86 285.531 1401.86 287.725C1401.86 289.919 1403.63 291.71 1405.84 291.71C1408.05 291.71 1409.83 289.932 1409.83 287.725C1409.83 285.518 1408.03 283.74 1405.84 283.74Z"
            fill="white"
          />
          <path
            d="M1393.17 297.738C1395.29 297.236 1396.61 295.106 1396.11 292.98C1395.61 290.854 1393.48 289.537 1391.35 290.039C1389.22 290.54 1387.91 292.671 1388.41 294.797C1388.91 296.923 1391.04 298.239 1393.17 297.738Z"
            fill="white"
          />
          <path
            d="M1378.23 296.209C1376.06 296.209 1374.3 297.97 1374.3 300.134C1374.3 302.299 1376.06 304.06 1378.23 304.06C1380.39 304.06 1382.14 302.303 1382.14 300.134C1382.14 297.966 1380.39 296.209 1378.23 296.209Z"
            fill="white"
          />
          <path
            d="M1363.72 302.414C1361.58 302.414 1359.84 304.15 1359.84 306.284C1359.84 308.419 1361.58 310.167 1363.72 310.167C1365.86 310.167 1367.59 308.432 1367.59 306.284C1367.59 304.137 1365.86 302.414 1363.72 302.414Z"
            fill="white"
          />
          <path
            d="M1348.69 308.303C1346.57 308.303 1344.86 310.021 1344.86 312.135C1344.86 314.248 1346.57 315.963 1348.69 315.963C1350.8 315.963 1352.52 314.244 1352.52 312.135C1352.52 310.026 1350.8 308.303 1348.69 308.303Z"
            fill="white"
          />
          <path
            d="M1333.28 313.562C1331.18 313.562 1329.49 315.26 1329.49 317.352C1329.49 319.444 1331.18 321.129 1333.28 321.129C1335.37 321.129 1337.07 319.432 1337.07 317.352C1337.07 315.273 1335.37 313.562 1333.28 313.562Z"
            fill="white"
          />
          <path
            d="M1317.52 317.848C1315.45 317.848 1313.77 319.524 1313.77 321.595C1313.77 323.666 1315.45 325.342 1317.52 325.342C1319.59 325.342 1321.27 323.666 1321.27 321.595C1321.27 319.524 1319.58 317.848 1317.52 317.848Z"
            fill="white"
          />
          <path
            d="M1301.49 321.172C1299.44 321.172 1297.79 322.835 1297.79 324.885C1297.79 326.935 1299.44 328.603 1301.49 328.603C1303.54 328.603 1305.21 326.939 1305.21 324.885C1305.21 322.831 1303.55 321.172 1301.49 321.172Z"
            fill="white"
          />
          <path
            d="M1285.5 323.451C1283.5 323.451 1281.86 325.085 1281.86 327.084C1281.86 329.083 1283.5 330.725 1285.5 330.725C1287.51 330.725 1289.14 329.091 1289.14 327.084C1289.14 325.077 1287.5 323.451 1285.5 323.451Z"
            fill="white"
          />
          <path
            d="M1269.75 324.52C1267.75 324.52 1266.13 326.132 1266.13 328.131C1266.13 330.13 1267.75 331.734 1269.75 331.734C1271.75 331.734 1273.35 330.121 1273.35 328.131C1273.35 326.141 1271.74 324.52 1269.75 324.52Z"
            fill="white"
          />
          <path
            d="M1254.27 324.719C1252.3 324.719 1250.72 326.31 1250.72 328.279C1250.72 330.248 1252.3 331.827 1254.27 331.827C1256.23 331.827 1257.82 330.236 1257.82 328.279C1257.82 326.323 1256.23 324.719 1254.27 324.719Z"
            fill="white"
          />
          <path
            d="M1239.21 324.146C1237.27 324.146 1235.71 325.717 1235.71 327.656C1235.71 329.595 1237.27 331.153 1239.21 331.153C1241.14 331.153 1242.71 329.583 1242.71 327.656C1242.71 325.729 1241.14 324.146 1239.21 324.146Z"
            fill="white"
          />
          <path
            d="M1224.64 322.928C1222.75 322.928 1221.21 324.468 1221.21 326.361C1221.21 328.254 1222.75 329.794 1224.64 329.794C1226.53 329.794 1228.06 328.254 1228.06 326.361C1228.06 324.468 1226.53 322.928 1224.64 322.928Z"
            fill="white"
          />
          <path
            d="M1210.52 321.439C1208.65 321.439 1207.14 322.959 1207.14 324.822C1207.14 326.685 1208.65 328.212 1210.52 328.212C1212.4 328.212 1213.91 326.693 1213.91 324.822C1213.91 322.95 1212.4 321.439 1210.52 321.439Z"
            fill="white"
          />
          <path
            d="M1196.7 319.932C1194.86 319.932 1193.36 321.421 1193.36 323.271C1193.36 325.122 1194.86 326.611 1196.7 326.611C1198.55 326.611 1200.04 325.113 1200.04 323.271C1200.04 321.43 1198.55 319.932 1196.7 319.932Z"
            fill="white"
          />
          <path
            d="M1183.09 318.578C1181.27 318.578 1179.8 320.046 1179.8 321.867C1179.8 323.688 1181.27 325.147 1183.09 325.147C1184.91 325.147 1186.37 323.679 1186.37 321.867C1186.37 320.055 1184.9 318.578 1183.09 318.578Z"
            fill="white"
          />
          <path
            d="M1169.72 317.598C1167.95 317.598 1166.51 319.032 1166.51 320.802C1166.51 322.571 1167.95 324.018 1169.72 324.018C1171.49 324.018 1172.93 322.584 1172.93 320.802C1172.93 319.019 1171.5 317.598 1169.72 317.598Z"
            fill="white"
          />
          <path
            d="M1156.41 317.037C1154.66 317.037 1153.25 318.455 1153.25 320.199C1153.25 321.943 1154.66 323.352 1156.41 323.352C1158.15 323.352 1159.56 321.934 1159.56 320.199C1159.56 318.463 1158.14 317.037 1156.41 317.037Z"
            fill="white"
          />
          <path
            d="M1143 317.047C1141.28 317.047 1139.9 318.43 1139.9 320.149C1139.9 321.868 1141.28 323.251 1143 323.251C1144.72 323.251 1146.1 321.868 1146.1 320.149C1146.1 318.43 1144.72 317.047 1143 317.047Z"
            fill="white"
          />
          <path
            d="M1129.63 317.84C1127.94 317.84 1126.58 319.202 1126.58 320.891C1126.58 322.58 1127.94 323.942 1129.63 323.942C1131.32 323.942 1132.68 322.58 1132.68 320.891C1132.68 319.202 1131.32 317.84 1129.63 317.84Z"
            fill="white"
          />
          <path
            d="M1116.16 319.576C1114.51 319.576 1113.19 320.896 1113.19 322.543C1113.19 324.189 1114.51 325.509 1116.16 325.509C1117.8 325.509 1119.12 324.176 1119.12 322.543C1119.12 320.909 1117.79 319.576 1116.16 319.576Z"
            fill="white"
          />
          <path
            d="M1102.56 322.426C1100.96 322.426 1099.66 323.716 1099.66 325.328C1099.66 326.941 1100.96 328.223 1102.56 328.223C1104.16 328.223 1105.47 326.933 1105.47 325.328C1105.47 323.724 1104.16 322.426 1102.56 322.426Z"
            fill="white"
          />
          <path
            d="M1089.23 326.754C1087.66 326.754 1086.38 328.036 1086.38 329.614C1086.38 331.193 1087.66 332.474 1089.23 332.474C1090.8 332.474 1092.09 331.193 1092.09 329.614C1092.09 328.036 1090.81 326.754 1089.23 326.754Z"
            fill="white"
          />
          <path
            d="M1076.09 332.795C1074.54 332.795 1073.29 334.055 1073.29 335.596C1073.29 337.136 1074.53 338.397 1076.09 338.397C1077.64 338.397 1078.89 337.149 1078.89 335.596C1078.89 334.043 1077.63 332.795 1076.09 332.795Z"
            fill="white"
          />
          <path
            d="M1063.71 341.035C1062.22 341.035 1061 342.253 1061 343.751C1061 345.249 1062.22 346.459 1063.71 346.459C1065.21 346.459 1066.42 345.249 1066.42 343.751C1066.42 342.253 1065.22 341.035 1063.71 341.035Z"
            fill="white"
          />
          <path
            d="M1052.54 351.754C1051.07 351.754 1049.89 352.942 1049.89 354.406C1049.89 355.87 1051.08 357.059 1052.54 357.059C1054.01 357.059 1055.2 355.87 1055.2 354.406C1055.2 352.942 1054.01 351.754 1052.54 351.754Z"
            fill="white"
          />
          <path
            d="M1043.37 365.412C1041.94 365.412 1040.77 366.579 1040.77 368.014C1040.77 369.448 1041.94 370.615 1043.37 370.615C1044.81 370.615 1045.97 369.448 1045.97 368.014C1045.97 366.579 1044.81 365.412 1043.37 365.412Z"
            fill="white"
          />
          <path
            d="M1037.33 382.344C1035.93 382.344 1034.79 383.477 1034.79 384.882C1034.79 386.286 1035.94 387.419 1037.33 387.419C1038.72 387.419 1039.87 386.286 1039.87 384.882C1039.87 383.477 1038.73 382.344 1037.33 382.344Z"
            fill="white"
          />
          <path
            d="M1035.4 402.686C1034.05 402.686 1032.96 403.776 1032.96 405.13C1032.96 406.484 1034.05 407.587 1035.4 407.587C1036.76 407.587 1037.86 406.492 1037.86 405.13C1037.86 403.768 1036.76 402.686 1035.4 402.686Z"
            fill="white"
          />
          <path
            d="M1038.65 426.559C1037.33 426.559 1036.26 427.632 1036.26 428.952C1036.26 430.272 1037.33 431.346 1038.65 431.346C1039.97 431.346 1041.04 430.272 1041.04 428.952C1041.04 427.632 1039.97 426.559 1038.65 426.559Z"
            fill="white"
          />
          <path
            d="M1046.93 453.711C1045.63 453.711 1044.58 454.763 1044.58 456.062C1044.58 457.361 1045.63 458.413 1046.93 458.413C1048.23 458.413 1049.28 457.361 1049.28 456.062C1049.28 454.763 1048.23 453.711 1046.93 453.711Z"
            fill="white"
          />
          <path
            d="M1058.55 483.75C1057.28 483.75 1056.26 484.781 1056.26 486.042C1056.26 487.302 1057.27 488.342 1058.55 488.342C1059.82 488.342 1060.84 487.311 1060.84 486.042C1060.84 484.773 1059.81 483.75 1058.55 483.75Z"
            fill="white"
          />
          <path
            d="M1071.08 516.387C1069.85 516.387 1068.85 517.376 1068.85 518.602C1068.85 519.828 1069.85 520.817 1071.08 520.817C1072.31 520.817 1073.3 519.828 1073.3 518.602C1073.3 517.376 1072.3 516.387 1071.08 516.387Z"
            fill="white"
          />
          <path
            d="M1082.19 551.332C1080.98 551.332 1080.01 552.312 1080.01 553.518C1080.01 554.723 1080.99 555.695 1082.19 555.695C1083.4 555.695 1084.37 554.719 1084.37 553.518C1084.37 552.317 1083.39 551.332 1082.19 551.332Z"
            fill="white"
          />
          <path
            d="M1090.63 588.039C1089.45 588.039 1088.49 588.985 1088.49 590.161C1088.49 591.336 1089.45 592.296 1090.63 592.296C1091.8 592.296 1092.75 591.336 1092.75 590.161C1092.75 588.985 1091.8 588.039 1090.63 588.039Z"
            fill="white"
          />
          <path
            d="M1096.6 626.045C1095.45 626.045 1094.51 626.97 1094.51 628.124C1094.51 629.279 1095.45 630.217 1096.6 630.217C1097.76 630.217 1098.68 629.279 1098.68 628.124C1098.68 626.97 1097.76 626.045 1096.6 626.045Z"
            fill="white"
          />
          <path
            d="M1100.31 664.359C1099.19 664.359 1098.29 665.276 1098.29 666.401C1098.29 667.525 1099.19 668.429 1100.31 668.429C1101.44 668.429 1102.36 667.525 1102.36 666.401C1102.36 665.276 1101.44 664.359 1100.31 664.359Z"
            fill="white"
          />
          <path
            d="M1322.35 -4.27539C1320.69 -4.27539 1319.35 -2.93437 1319.35 -1.2793C1319.35 0.375759 1320.69 1.7083 1322.35 1.7083C1324 1.7083 1325.34 0.375759 1325.34 -1.2793C1325.34 -2.93437 1324 -4.27539 1322.35 -4.27539Z"
            fill="white"
          />
          <path
            d="M1329.77 7.35742C1328.09 7.35742 1326.72 8.72391 1326.72 10.4129C1326.72 12.1019 1328.08 13.4684 1329.77 13.4684C1331.46 13.4684 1332.83 12.1062 1332.83 10.4129C1332.83 8.71967 1331.47 7.35742 1329.77 7.35742Z"
            fill="white"
          />
          <path
            d="M1337 19.3301C1335.27 19.3301 1333.87 20.7263 1333.87 22.4535C1333.87 24.1807 1335.27 25.5854 1337 25.5854C1338.73 25.5854 1340.13 24.1807 1340.13 22.4535C1340.13 20.7263 1338.73 19.3301 1337 19.3301Z"
            fill="white"
          />
          <path
            d="M1343.99 31.7051C1342.23 31.7051 1340.81 33.131 1340.81 34.8879C1340.81 36.6448 1342.23 38.0749 1343.99 38.0749C1345.75 38.0749 1347.18 36.649 1347.18 34.8879C1347.18 33.1267 1345.75 31.7051 1343.99 31.7051Z"
            fill="white"
          />
          <path
            d="M1350.73 44.457C1348.95 44.457 1347.5 45.9041 1347.5 47.6908C1347.5 49.4774 1348.95 50.9287 1350.73 50.9287C1352.51 50.9287 1353.97 49.4816 1353.97 47.6908C1353.97 45.8999 1352.52 44.457 1350.73 44.457Z"
            fill="white"
          />
          <path
            d="M1357.24 57.5996C1355.42 57.5996 1353.95 59.0679 1353.95 60.8885C1353.95 62.7091 1355.42 64.1774 1357.24 64.1774C1359.05 64.1774 1360.53 62.7006 1360.53 60.8885C1360.53 59.0764 1359.06 57.5996 1357.24 57.5996Z"
            fill="white"
          />
          <path
            d="M1363.53 71.0566C1361.67 71.0566 1360.16 72.5674 1360.16 74.4304C1360.16 76.2934 1361.67 77.7915 1363.53 77.7915C1365.4 77.7915 1366.89 76.2807 1366.89 74.4304C1366.89 72.5801 1365.38 71.0566 1363.53 71.0566Z"
            fill="white"
          />
          <path
            d="M1369.67 84.7852C1367.79 84.7852 1366.26 86.3172 1366.26 88.1971C1366.26 90.0771 1367.79 91.6134 1369.67 91.6134C1371.56 91.6134 1373.09 90.0814 1373.09 88.1971C1373.09 86.3129 1371.55 84.7852 1369.67 84.7852Z"
            fill="white"
          />
          <path
            d="M1375.8 98.5137C1373.9 98.5137 1372.35 100.063 1372.35 101.981C1372.35 103.899 1373.9 105.439 1375.8 105.439C1377.71 105.439 1379.27 103.895 1379.27 101.981C1379.27 100.067 1377.72 98.5137 1375.8 98.5137Z"
            fill="white"
          />
          <path
            d="M1382.06 112.021C1380.12 112.021 1378.55 113.587 1378.55 115.523C1378.55 117.458 1380.12 119.024 1382.06 119.024C1383.99 119.024 1385.56 117.458 1385.56 115.523C1385.56 113.587 1383.99 112.021 1382.06 112.021Z"
            fill="white"
          />
          <path
            d="M1388.54 125.076C1386.56 125.076 1384.96 126.68 1384.96 128.658C1384.96 130.635 1386.56 132.231 1388.54 132.231C1390.52 132.231 1392.12 130.627 1392.12 128.658C1392.12 126.689 1390.52 125.076 1388.54 125.076Z"
            fill="white"
          />
          <path
            d="M1395.36 137.51C1393.35 137.51 1391.72 139.135 1391.72 141.138C1391.72 143.141 1393.35 144.767 1395.36 144.767C1397.36 144.767 1398.98 143.141 1398.98 141.138C1398.98 139.135 1397.35 137.51 1395.36 137.51Z"
            fill="white"
          />
          <path
            d="M1402.58 149.135C1400.55 149.135 1398.92 150.773 1398.92 152.806C1398.92 154.838 1400.55 156.468 1402.58 156.468C1404.61 156.468 1406.24 154.83 1406.24 152.806C1406.24 150.781 1404.61 149.135 1402.58 149.135Z"
            fill="white"
          />
          <path
            d="M1410.24 159.793C1408.19 159.793 1406.53 161.457 1406.53 163.506C1406.53 165.556 1408.19 167.224 1410.24 167.224C1412.29 167.224 1413.96 165.56 1413.96 163.506C1413.96 161.452 1412.3 159.793 1410.24 159.793Z"
            fill="white"
          />
          <path
            d="M1418.37 169.328C1416.28 169.328 1414.59 171.013 1414.59 173.105C1414.59 175.197 1416.28 176.882 1418.37 176.882C1420.46 176.882 1422.15 175.184 1422.15 173.105C1422.15 171.026 1420.45 169.328 1418.37 169.328Z"
            fill="white"
          />
          <path
            d="M1426.89 177.779C1424.78 177.779 1423.07 179.485 1423.07 181.59C1423.07 183.695 1424.78 185.401 1426.89 185.401C1428.99 185.401 1430.7 183.695 1430.7 181.59C1430.7 179.485 1429 177.779 1426.89 177.779Z"
            fill="white"
          />
          <path
            d="M1435.73 185.111C1433.61 185.111 1431.88 186.839 1431.88 188.969C1431.88 191.099 1433.61 192.831 1435.73 192.831C1437.85 192.831 1439.59 191.104 1439.59 188.969C1439.59 186.834 1437.87 185.111 1435.73 185.111Z"
            fill="white"
          />
          <path
            d="M1444.81 191.443C1442.66 191.443 1440.92 193.183 1440.92 195.335C1440.92 197.486 1442.66 199.218 1444.81 199.218C1446.95 199.218 1448.7 197.478 1448.7 195.335C1448.7 193.192 1446.96 191.443 1444.81 191.443Z"
            fill="white"
          />
          <path
            d="M1454.05 196.795C1451.87 196.795 1450.12 198.565 1450.12 200.742C1450.12 202.919 1451.87 204.676 1454.05 204.676C1456.23 204.676 1457.98 202.914 1457.98 200.742C1457.98 198.569 1456.22 196.795 1454.05 196.795Z"
            fill="white"
          />
          <path
            d="M1445.97 269.232C1443.74 269.232 1441.92 271.053 1441.92 273.289C1441.92 275.526 1443.74 277.359 1445.97 277.359C1448.21 277.359 1450.04 275.539 1450.04 273.289C1450.04 271.04 1448.22 269.232 1445.97 269.232Z"
            fill="white"
          />
          <path
            d="M1432.89 273.779C1430.67 273.779 1428.86 275.579 1428.86 277.807C1428.86 280.035 1430.67 281.834 1432.89 281.834C1435.1 281.834 1436.93 280.035 1436.93 277.807C1436.93 275.579 1435.12 273.779 1432.89 273.779Z"
            fill="white"
          />
          <path
            d="M1419.36 279.018C1417.16 279.018 1415.37 280.808 1415.37 283.002C1415.37 285.196 1417.16 286.987 1419.36 286.987C1421.55 286.987 1423.34 285.209 1423.34 283.002C1423.34 280.796 1421.57 279.018 1419.36 279.018Z"
            fill="white"
          />
          <path
            d="M1405.55 284.879C1403.37 284.879 1401.59 286.649 1401.59 288.834C1401.59 291.02 1403.37 292.789 1405.55 292.789C1407.72 292.789 1409.51 291.02 1409.51 288.834C1409.51 286.649 1407.73 284.879 1405.55 284.879Z"
            fill="white"
          />
          <path
            d="M1391.39 291.234C1389.23 291.234 1387.47 292.996 1387.47 295.16C1387.47 297.324 1389.23 299.073 1391.39 299.073C1393.56 299.073 1395.31 297.324 1395.31 295.16C1395.31 292.996 1393.56 291.234 1391.39 291.234Z"
            fill="white"
          />
          <path
            d="M1376.79 305.536C1378.94 305.536 1380.67 303.797 1380.67 301.653C1380.67 299.508 1378.94 297.77 1376.79 297.77C1374.65 297.77 1372.91 299.508 1372.91 301.653C1372.91 303.797 1374.65 305.536 1376.79 305.536Z"
            fill="white"
          />
          <path
            d="M1361.77 304.1C1359.66 304.1 1357.95 305.818 1357.95 307.927C1357.95 310.037 1359.66 311.76 1361.77 311.76C1363.88 311.76 1365.61 310.041 1365.61 307.927C1365.61 305.814 1363.89 304.1 1361.77 304.1Z"
            fill="white"
          />
          <path
            d="M1346.36 310.021C1344.27 310.021 1342.57 311.719 1342.57 313.811C1342.57 315.903 1344.27 317.601 1346.36 317.601C1348.45 317.601 1350.15 315.903 1350.15 313.811C1350.15 311.719 1348.45 310.021 1346.36 310.021Z"
            fill="white"
          />
          <path
            d="M1330.52 315.205C1328.45 315.205 1326.77 316.89 1326.77 318.961C1326.77 321.032 1328.45 322.717 1330.52 322.717C1332.59 322.717 1334.27 321.032 1334.27 318.961C1334.27 316.89 1332.6 315.205 1330.52 315.205Z"
            fill="white"
          />
          <path
            d="M1314.4 319.381C1312.35 319.381 1310.69 321.044 1310.69 323.098C1310.69 325.152 1312.35 326.803 1314.4 326.803C1316.44 326.803 1318.1 325.14 1318.1 323.098C1318.1 321.057 1316.44 319.381 1314.4 319.381Z"
            fill="white"
          />
          <path
            d="M1298.13 322.564C1296.12 322.564 1294.49 324.198 1294.49 326.206C1294.49 328.213 1296.12 329.847 1298.13 329.847C1300.14 329.847 1301.77 328.221 1301.77 326.206C1301.77 324.19 1300.15 322.564 1298.13 322.564Z"
            fill="white"
          />
          <path
            d="M1282.01 324.574C1280.03 324.574 1278.42 326.187 1278.42 328.186C1278.42 330.184 1280.03 331.789 1282.01 331.789C1284 331.789 1285.62 330.176 1285.62 328.186C1285.62 326.195 1284.01 324.574 1282.01 324.574Z"
            fill="white"
          />
          <path
            d="M1269.41 330.371C1270.16 328.554 1269.3 326.472 1267.49 325.719C1265.67 324.967 1263.59 325.829 1262.83 327.646C1262.08 329.463 1262.94 331.546 1264.76 332.298C1266.58 333.051 1268.66 332.188 1269.41 330.371Z"
            fill="white"
          />
          <path
            d="M1250.57 325.457C1248.64 325.457 1247.07 327.027 1247.07 328.975C1247.07 330.923 1248.64 332.485 1250.57 332.485C1252.51 332.485 1254.09 330.915 1254.09 328.975C1254.09 327.036 1252.51 325.457 1250.57 325.457Z"
            fill="white"
          />
          <path
            d="M1235.53 324.762C1233.63 324.762 1232.09 326.302 1232.09 328.195C1232.09 330.088 1233.63 331.641 1235.53 331.641C1237.44 331.641 1238.97 330.1 1238.97 328.195C1238.97 326.289 1237.43 324.762 1235.53 324.762Z"
            fill="white"
          />
          <path
            d="M1221.02 323.457C1219.14 323.457 1217.62 324.968 1217.62 326.839C1217.62 328.711 1219.14 330.222 1221.02 330.222C1222.89 330.222 1224.4 328.711 1224.4 326.839C1224.4 324.968 1222.89 323.457 1221.02 323.457Z"
            fill="white"
          />
          <path
            d="M1206.85 321.961C1205.01 321.961 1203.51 323.459 1203.51 325.301C1203.51 327.143 1205.01 328.641 1206.85 328.641C1208.69 328.641 1210.19 327.143 1210.19 325.301C1210.19 323.459 1208.69 321.961 1206.85 321.961Z"
            fill="white"
          />
          <path
            d="M1193 320.533C1191.19 320.533 1189.72 322.002 1189.72 323.814C1189.72 325.626 1191.19 327.103 1193 327.103C1194.81 327.103 1196.29 325.626 1196.29 323.814C1196.29 322.002 1194.82 320.533 1193 320.533Z"
            fill="white"
          />
          <path
            d="M1179.5 319.389C1177.73 319.389 1176.28 320.823 1176.28 322.593C1176.28 324.362 1177.73 325.797 1179.5 325.797C1181.27 325.797 1182.7 324.362 1182.7 322.593C1182.7 320.823 1181.27 319.389 1179.5 319.389Z"
            fill="white"
          />
          <path
            d="M1166.17 318.598C1164.42 318.598 1163 320.015 1163 321.751C1163 323.486 1164.42 324.912 1166.17 324.912C1167.91 324.912 1169.32 323.495 1169.32 321.751C1169.32 320.007 1167.9 318.598 1166.17 318.598Z"
            fill="white"
          />
          <path
            d="M1152.82 318.299C1151.1 318.299 1149.71 319.695 1149.71 321.41C1149.71 323.124 1151.1 324.512 1152.82 324.512C1154.53 324.512 1155.92 323.115 1155.92 321.41C1155.92 319.704 1154.53 318.299 1152.82 318.299Z"
            fill="white"
          />
          <path
            d="M1139.54 318.713C1137.87 318.713 1136.51 320.075 1136.51 321.764C1136.51 323.453 1137.87 324.803 1139.54 324.803C1141.22 324.803 1142.6 323.44 1142.6 321.764C1142.6 320.088 1141.23 318.713 1139.54 318.713Z"
            fill="white"
          />
          <path
            d="M1126.32 320.025C1124.68 320.025 1123.36 321.349 1123.36 322.983C1123.36 324.617 1124.68 325.941 1126.32 325.941C1127.96 325.941 1129.28 324.621 1129.28 322.983C1129.28 321.345 1127.95 320.025 1126.32 320.025Z"
            fill="white"
          />
          <path
            d="M1112.94 322.27C1111.34 322.27 1110.02 323.581 1110.02 325.185C1110.02 326.789 1111.34 328.1 1112.94 328.1C1114.54 328.1 1115.86 326.798 1115.86 325.185C1115.86 323.572 1114.55 322.27 1112.94 322.27Z"
            fill="white"
          />
          <path
            d="M1099.81 325.924C1098.22 325.924 1096.95 327.193 1096.95 328.776C1096.95 330.359 1098.23 331.627 1099.81 331.627C1101.38 331.627 1102.66 330.346 1102.66 328.776C1102.66 327.205 1101.38 325.924 1099.81 325.924Z"
            fill="white"
          />
          <path
            d="M1086.92 331.146C1085.37 331.146 1084.12 332.407 1084.12 333.947C1084.12 335.488 1085.37 336.748 1086.92 336.748C1088.48 336.748 1089.72 335.501 1089.72 333.947C1089.72 332.394 1088.46 331.146 1086.92 331.146Z"
            fill="white"
          />
          <path
            d="M1074.58 338.363C1073.08 338.363 1071.86 339.581 1071.86 341.079C1071.86 342.577 1073.08 343.787 1074.58 343.787C1076.08 343.787 1077.28 342.582 1077.28 341.079C1077.28 339.577 1076.08 338.363 1074.58 338.363Z"
            fill="white"
          />
          <path
            d="M1063.47 347.992C1062.01 347.992 1060.82 349.18 1060.82 350.636C1060.82 352.092 1062.01 353.288 1063.47 353.288C1064.93 353.288 1066.12 352.1 1066.12 350.636C1066.12 349.172 1064.93 347.992 1063.47 347.992Z"
            fill="white"
          />
          <path
            d="M1054.04 360.322C1052.61 360.322 1051.44 361.489 1051.44 362.924C1051.44 364.358 1052.61 365.517 1054.04 365.517C1055.48 365.517 1056.63 364.362 1056.63 362.924C1056.63 361.485 1055.47 360.322 1054.04 360.322Z"
            fill="white"
          />
          <path
            d="M1047.64 375.959C1046.24 375.959 1045.1 377.092 1045.1 378.488C1045.1 379.884 1046.24 381.026 1047.64 381.026C1049.05 381.026 1050.18 379.893 1050.18 378.488C1050.18 377.084 1049.03 375.959 1047.64 375.959Z"
            fill="white"
          />
          <path
            d="M1044.97 394.875C1043.62 394.875 1042.51 395.978 1042.51 397.332C1042.51 398.686 1043.62 399.777 1044.97 399.777C1046.32 399.777 1047.41 398.686 1047.41 397.332C1047.41 395.978 1046.32 394.875 1044.97 394.875Z"
            fill="white"
          />
          <path
            d="M1047.1 417.273C1045.77 417.273 1044.7 418.356 1044.7 419.68C1044.7 421.004 1045.77 422.086 1047.1 422.086C1048.43 422.086 1049.49 421.004 1049.49 419.68C1049.49 418.356 1048.42 417.273 1047.1 417.273Z"
            fill="white"
          />
          <path
            d="M1053.9 442.941C1052.59 442.941 1051.54 443.994 1051.54 445.292C1051.54 446.591 1052.6 447.635 1053.9 447.635C1055.19 447.635 1056.24 446.583 1056.24 445.292C1056.24 444.002 1055.19 442.941 1053.9 442.941Z"
            fill="white"
          />
          <path
            d="M1064.22 471.459C1062.96 471.459 1061.93 472.477 1061.93 473.751C1061.93 475.024 1062.97 476.042 1064.22 476.042C1065.48 476.042 1066.51 475.011 1066.51 473.751C1066.51 472.49 1065.5 471.459 1064.22 471.459Z"
            fill="white"
          />
          <path
            d="M1075.82 502.414C1074.59 502.414 1073.6 503.403 1073.6 504.629C1073.6 505.856 1074.59 506.845 1075.82 506.845C1077.04 506.845 1078.03 505.856 1078.03 504.629C1078.03 503.403 1077.03 502.414 1075.82 502.414Z"
            fill="white"
          />
          <path
            d="M1086.58 535.539C1085.37 535.539 1084.4 536.507 1084.4 537.716C1084.4 538.926 1085.37 539.893 1086.58 539.893C1087.79 539.893 1088.75 538.913 1088.75 537.716C1088.75 536.519 1087.77 535.539 1086.58 535.539Z"
            fill="white"
          />
          <path
            d="M1095.1 570.312C1093.93 570.312 1092.97 571.259 1092.97 572.447C1092.97 573.635 1093.93 574.582 1095.1 574.582C1096.28 574.582 1097.24 573.623 1097.24 572.447C1097.24 571.272 1096.28 570.312 1095.1 570.312Z"
            fill="white"
          />
          <path
            d="M1101.25 606.312C1100.1 606.312 1099.17 607.25 1099.17 608.405C1099.17 609.559 1100.1 610.497 1101.25 610.497C1102.41 610.497 1103.35 609.559 1103.35 608.405C1103.35 607.25 1102.41 606.312 1101.25 606.312Z"
            fill="white"
          />
          <path
            d="M1105.33 642.898C1104.21 642.898 1103.3 643.815 1103.3 644.927C1103.3 646.039 1104.21 646.968 1105.33 646.968C1106.46 646.968 1107.36 646.052 1107.36 644.927C1107.36 643.802 1106.46 642.898 1105.33 642.898Z"
            fill="white"
          />
          <path
            d="M1107.5 678.795C1106.39 678.795 1105.5 679.699 1105.5 680.802C1105.5 681.906 1106.39 682.809 1107.5 682.809C1108.6 682.809 1109.5 681.906 1109.5 680.802C1109.5 679.699 1108.61 678.795 1107.5 678.795Z"
            fill="white"
          />
          <path
            d="M1345.35 4.16797C1343.66 4.16797 1342.3 5.53021 1342.3 7.21922C1342.3 8.90824 1343.66 10.2705 1345.35 10.2705C1347.04 10.2705 1348.4 8.90824 1348.4 7.21922C1348.4 5.53021 1347.04 4.16797 1345.35 4.16797Z"
            fill="white"
          />
          <path
            d="M1352.48 16.1973C1350.75 16.1973 1349.35 17.5935 1349.35 19.3207C1349.35 21.0479 1350.75 22.4526 1352.48 22.4526C1354.21 22.4526 1355.61 21.0479 1355.61 19.3207C1355.61 17.5935 1354.21 16.1973 1352.48 16.1973Z"
            fill="white"
          />
          <path
            d="M1359.35 28.6836C1357.59 28.6836 1356.16 30.1095 1356.16 31.8664C1356.16 33.6233 1357.59 35.045 1359.35 35.045C1361.11 35.045 1362.53 33.6191 1362.53 31.8664C1362.53 30.1137 1361.11 28.6836 1359.35 28.6836Z"
            fill="white"
          />
          <path
            d="M1365.94 41.6445C1364.14 41.6445 1362.71 43.0917 1362.71 44.8698C1362.71 46.6479 1364.14 48.095 1365.94 48.095C1367.73 48.095 1369.16 46.6479 1369.16 44.8698C1369.16 43.0917 1367.71 41.6445 1365.94 41.6445Z"
            fill="white"
          />
          <path
            d="M1372.22 55.0996C1370.4 55.0996 1368.93 56.5679 1368.93 58.3885C1368.93 60.2091 1370.4 61.6732 1372.22 61.6732C1374.04 61.6732 1375.51 60.2006 1375.51 58.3885C1375.51 56.5764 1374.03 55.0996 1372.22 55.0996Z"
            fill="white"
          />
          <path
            d="M1378.29 68.9004C1376.44 68.9004 1374.93 70.3984 1374.93 72.2614C1374.93 74.1244 1376.44 75.6225 1378.29 75.6225C1380.14 75.6225 1381.65 74.1117 1381.65 72.2614C1381.65 70.4112 1380.15 68.9004 1378.29 68.9004Z"
            fill="white"
          />
          <path
            d="M1384.24 82.9434C1382.36 82.9434 1380.83 84.4754 1380.83 86.3553C1380.83 88.2353 1382.36 89.7631 1384.24 89.7631C1386.12 89.7631 1387.66 88.2396 1387.66 86.3553C1387.66 84.4711 1386.13 82.9434 1384.24 82.9434Z"
            fill="white"
          />
          <path
            d="M1390.21 96.9746C1388.3 96.9746 1386.75 98.5236 1386.75 100.429C1386.75 102.334 1388.3 103.883 1390.21 103.883C1392.11 103.883 1393.66 102.339 1393.66 100.429C1393.66 98.5193 1392.11 96.9746 1390.21 96.9746Z"
            fill="white"
          />
          <path
            d="M1396.32 110.756C1394.38 110.756 1392.81 112.335 1392.81 114.27C1392.81 116.205 1394.38 117.788 1396.32 117.788C1398.26 117.788 1399.83 116.209 1399.83 114.27C1399.83 112.33 1398.26 110.756 1396.32 110.756Z"
            fill="white"
          />
          <path
            d="M1402.71 124.074C1400.73 124.074 1399.13 125.678 1399.13 127.656C1399.13 129.634 1400.73 131.229 1402.71 131.229C1404.69 131.229 1406.28 129.634 1406.28 127.656C1406.28 125.678 1404.67 124.074 1402.71 124.074Z"
            fill="white"
          />
          <path
            d="M1409.48 136.678C1407.48 136.678 1405.86 138.303 1405.86 140.306C1405.86 142.309 1407.49 143.935 1409.48 143.935C1411.47 143.935 1413.11 142.309 1413.11 140.306C1413.11 138.303 1411.49 136.678 1409.48 136.678Z"
            fill="white"
          />
          <path
            d="M1416.76 148.344C1414.73 148.344 1413.08 149.99 1413.08 152.019C1413.08 154.047 1414.73 155.681 1416.76 155.681C1418.79 155.681 1420.42 154.035 1420.42 152.019C1420.42 150.003 1418.77 148.344 1416.76 148.344Z"
            fill="white"
          />
          <path
            d="M1424.52 158.945C1422.47 158.945 1420.81 160.605 1420.81 162.654C1420.81 164.704 1422.47 166.372 1424.52 166.372C1426.57 166.372 1428.22 164.708 1428.22 162.654C1428.22 160.6 1426.57 158.945 1424.52 158.945Z"
            fill="white"
          />
          <path
            d="M1432.75 168.375C1430.67 168.375 1428.98 170.068 1428.98 172.152C1428.98 174.236 1430.67 175.929 1432.75 175.929C1434.83 175.929 1436.53 174.236 1436.53 172.152C1436.53 170.068 1434.83 168.375 1432.75 168.375Z"
            fill="white"
          />
          <path
            d="M1441.38 176.717C1439.28 176.717 1437.57 178.423 1437.57 180.528C1437.57 182.633 1439.28 184.339 1441.38 184.339C1443.49 184.339 1445.19 182.633 1445.19 180.528C1445.19 178.423 1443.49 176.717 1441.38 176.717Z"
            fill="white"
          />
          <path
            d="M1450.34 183.939C1448.22 183.939 1446.49 185.662 1446.49 187.789C1446.49 189.915 1448.22 191.646 1450.34 191.646C1452.47 191.646 1454.21 189.923 1454.21 187.789C1454.21 185.654 1452.48 183.939 1450.34 183.939Z"
            fill="white"
          />
          <path
            d="M1447.31 270.014C1445.08 270.014 1443.28 271.826 1443.28 274.041C1443.28 276.256 1445.08 278.068 1447.31 278.068C1449.53 278.068 1451.33 276.269 1451.33 274.041C1451.33 271.813 1449.53 270.014 1447.31 270.014Z"
            fill="white"
          />
          <path
            d="M1433.58 274.727C1431.37 274.727 1429.59 276.517 1429.59 278.711C1429.59 280.905 1431.37 282.696 1433.58 282.696C1435.78 282.696 1437.56 280.918 1437.56 278.711C1437.56 276.505 1435.77 274.727 1433.58 274.727Z"
            fill="white"
          />
          <path
            d="M1419.46 280.131C1417.28 280.131 1415.5 281.901 1415.5 284.086C1415.5 286.272 1417.28 288.041 1419.46 288.041C1421.65 288.041 1423.42 286.272 1423.42 284.086C1423.42 281.901 1421.64 280.131 1419.46 280.131Z"
            fill="white"
          />
          <path
            d="M1405.06 286.207C1402.89 286.207 1401.13 287.955 1401.13 290.12C1401.13 292.284 1402.89 294.045 1405.06 294.045C1407.22 294.045 1408.97 292.288 1408.97 290.12C1408.97 287.951 1407.22 286.207 1405.06 286.207Z"
            fill="white"
          />
          <path
            d="M1390.29 292.785C1388.15 292.785 1386.41 294.525 1386.41 296.668C1386.41 298.811 1388.14 300.56 1390.29 300.56C1392.44 300.56 1394.18 298.811 1394.18 296.668C1394.18 294.525 1392.44 292.785 1390.29 292.785Z"
            fill="white"
          />
          <path
            d="M1375.19 299.498C1373.07 299.498 1371.36 301.204 1371.36 303.317C1371.36 305.431 1373.08 307.145 1375.19 307.145C1377.3 307.145 1379.02 305.439 1379.02 303.317C1379.02 301.196 1377.3 299.498 1375.19 299.498Z"
            fill="white"
          />
          <path
            d="M1359.76 305.881C1357.66 305.881 1355.97 307.587 1355.97 309.679C1355.97 311.771 1357.66 313.477 1359.76 313.477C1361.86 313.477 1363.56 311.78 1363.56 309.679C1363.56 307.578 1361.86 305.881 1359.76 305.881Z"
            fill="white"
          />
          <path
            d="M1343.93 311.822C1341.85 311.822 1340.18 313.499 1340.18 315.569C1340.18 317.64 1341.85 319.325 1343.93 319.325C1346.01 319.325 1347.68 317.649 1347.68 315.569C1347.68 313.49 1346 311.822 1343.93 311.822Z"
            fill="white"
          />
          <path
            d="M1327.72 316.922C1325.68 316.922 1324.01 318.577 1324.01 320.627C1324.01 322.676 1325.68 324.331 1327.72 324.331C1329.76 324.331 1331.43 322.676 1331.43 320.627C1331.43 318.577 1329.77 316.922 1327.72 316.922Z"
            fill="white"
          />
          <path
            d="M1311.33 320.971C1309.32 320.971 1307.69 322.605 1307.69 324.612C1307.69 326.619 1309.32 328.266 1311.33 328.266C1313.33 328.266 1314.98 326.632 1314.98 324.612C1314.98 322.592 1313.35 320.971 1311.33 320.971Z"
            fill="white"
          />
          <path
            d="M1294.92 323.947C1292.92 323.947 1291.31 325.56 1291.31 327.546C1291.31 329.532 1292.92 331.157 1294.92 331.157C1296.92 331.157 1298.52 329.545 1298.52 327.546C1298.52 325.547 1296.91 323.947 1294.92 323.947Z"
            fill="white"
          />
          <path
            d="M1278.65 325.736C1276.69 325.736 1275.09 327.319 1275.09 329.284C1275.09 331.249 1276.69 332.845 1278.65 332.845C1280.62 332.845 1282.2 331.253 1282.2 329.284C1282.2 327.315 1280.61 325.736 1278.65 325.736Z"
            fill="white"
          />
          <path
            d="M1262.66 326.418C1260.72 326.418 1259.15 328.001 1259.15 329.936C1259.15 331.871 1260.72 333.441 1262.66 333.441C1264.59 333.441 1266.18 331.871 1266.18 329.936C1266.18 328.001 1264.61 326.418 1262.66 326.418Z"
            fill="white"
          />
          <path
            d="M1247.1 326.311C1245.19 326.311 1243.65 327.851 1243.65 329.744C1243.65 331.636 1245.19 333.19 1247.1 333.19C1249 333.19 1250.53 331.649 1250.53 329.744C1250.53 327.838 1248.99 326.311 1247.1 326.311Z"
            fill="white"
          />
          <path
            d="M1232.1 325.457C1230.23 325.457 1228.71 326.976 1228.71 328.848C1228.71 330.719 1230.23 332.239 1232.1 332.239C1233.97 332.239 1235.49 330.719 1235.49 328.848C1235.49 326.976 1233.98 325.457 1232.1 325.457Z"
            fill="white"
          />
          <path
            d="M1217.54 324.104C1215.7 324.104 1214.2 325.593 1214.2 327.435C1214.2 329.277 1215.7 330.775 1217.54 330.775C1219.38 330.775 1220.87 329.285 1220.87 327.435C1220.87 325.585 1219.38 324.104 1217.54 324.104Z"
            fill="white"
          />
          <path
            d="M1203.33 322.635C1201.52 322.635 1200.04 324.112 1200.04 325.924C1200.04 327.736 1201.52 329.221 1203.33 329.221C1205.14 329.221 1206.63 327.744 1206.63 325.924C1206.63 324.103 1205.15 322.635 1203.33 322.635Z"
            fill="white"
          />
          <path
            d="M1189.6 321.4C1187.83 321.4 1186.4 322.826 1186.4 324.596C1186.4 326.366 1187.83 327.8 1189.6 327.8C1191.37 327.8 1192.8 326.366 1192.8 324.596C1192.8 322.826 1191.37 321.4 1189.6 321.4Z"
            fill="white"
          />
          <path
            d="M1176.18 320.418C1174.43 320.418 1173.03 321.835 1173.03 323.584C1173.03 325.332 1174.43 326.737 1176.18 326.737C1177.93 326.737 1179.33 325.32 1179.33 323.584C1179.33 321.848 1177.93 320.418 1176.18 320.418Z"
            fill="white"
          />
          <path
            d="M1162.83 319.867C1161.11 319.867 1159.72 321.251 1159.72 322.969C1159.72 324.688 1161.11 326.072 1162.83 326.072C1164.54 326.072 1165.93 324.688 1165.93 322.969C1165.93 321.251 1164.54 319.867 1162.83 319.867Z"
            fill="white"
          />
          <path
            d="M1149.59 319.932C1147.91 319.932 1146.55 321.294 1146.55 322.983C1146.55 324.672 1147.91 326.021 1149.59 326.021C1151.27 326.021 1152.64 324.659 1152.64 322.983C1152.64 321.307 1151.28 319.932 1149.59 319.932Z"
            fill="white"
          />
          <path
            d="M1136.54 320.836C1134.9 320.836 1133.58 322.168 1133.58 323.802C1133.58 325.436 1134.9 326.769 1136.54 326.769C1138.19 326.769 1139.51 325.445 1139.51 323.802C1139.51 322.16 1138.18 320.836 1136.54 320.836Z"
            fill="white"
          />
          <path
            d="M1123.42 322.627C1121.82 322.627 1120.52 323.93 1120.52 325.53C1120.52 327.13 1121.82 328.432 1123.42 328.432C1125.02 328.432 1126.34 327.13 1126.34 325.53C1126.34 323.93 1125.04 322.627 1123.42 322.627Z"
            fill="white"
          />
          <path
            d="M1110.48 325.623C1108.89 325.623 1107.62 326.892 1107.62 328.475C1107.62 330.058 1108.9 331.327 1110.48 331.327C1112.05 331.327 1113.33 330.045 1113.33 328.475C1113.33 326.905 1112.05 325.623 1110.48 325.623Z"
            fill="white"
          />
          <path
            d="M1097.88 330.131C1096.34 330.131 1095.08 331.391 1095.08 332.932C1095.08 334.472 1096.34 335.733 1097.88 335.733C1099.42 335.733 1100.68 334.472 1100.68 332.932C1100.68 331.391 1099.42 330.131 1097.88 330.131Z"
            fill="white"
          />
          <path
            d="M1085.7 336.436C1084.21 336.436 1083 337.653 1083 339.143C1083 340.633 1084.2 341.851 1085.7 341.851C1087.21 341.851 1088.41 340.645 1088.41 339.143C1088.41 337.641 1087.19 336.436 1085.7 336.436Z"
            fill="white"
          />
          <path
            d="M1074.71 345.025C1073.24 345.025 1072.06 346.214 1072.06 347.678C1072.06 349.142 1073.25 350.322 1074.71 350.322C1076.18 350.322 1077.36 349.133 1077.36 347.678C1077.36 346.222 1076.17 345.025 1074.71 345.025Z"
            fill="white"
          />
          <path
            d="M1065.26 356.189C1063.84 356.189 1062.67 357.356 1062.67 358.782C1062.67 360.208 1063.84 361.375 1065.26 361.375C1066.69 361.375 1067.85 360.221 1067.85 358.782C1067.85 357.344 1066.7 356.189 1065.26 356.189Z"
            fill="white"
          />
          <path
            d="M1058.59 370.521C1057.19 370.521 1056.05 371.667 1056.05 373.072C1056.05 374.477 1057.19 375.61 1058.59 375.61C1060 375.61 1061.14 374.477 1061.14 373.072C1061.14 371.667 1060 370.521 1058.59 370.521Z"
            fill="white"
          />
          <path
            d="M1055.47 388.176C1054.11 388.176 1053 389.279 1053 390.633C1053 391.987 1054.11 393.099 1055.47 393.099C1056.83 393.099 1057.92 391.995 1057.92 390.633C1057.92 389.271 1056.82 388.176 1055.47 388.176Z"
            fill="white"
          />
          <path
            d="M1056.64 409.197C1055.32 409.197 1054.24 410.271 1054.24 411.603C1054.24 412.936 1055.32 413.997 1056.64 413.997C1057.97 413.997 1059.04 412.923 1059.04 411.603C1059.04 410.284 1057.96 409.197 1056.64 409.197Z"
            fill="white"
          />
          <path
            d="M1062.17 433.461C1060.88 433.461 1059.83 434.513 1059.83 435.812C1059.83 437.111 1060.88 438.155 1062.17 438.155C1063.46 438.155 1064.52 437.102 1064.52 435.812C1064.52 434.522 1063.47 433.461 1062.17 433.461Z"
            fill="white"
          />
          <path
            d="M1071.17 460.539C1069.9 460.539 1068.87 461.57 1068.87 462.839C1068.87 464.108 1069.9 465.139 1071.17 465.139C1072.44 465.139 1073.46 464.108 1073.46 462.839C1073.46 461.57 1072.43 460.539 1071.17 460.539Z"
            fill="white"
          />
          <path
            d="M1081.66 489.965C1080.43 489.965 1079.43 490.962 1079.43 492.193C1079.43 493.423 1080.43 494.421 1081.66 494.421C1082.89 494.421 1083.88 493.423 1083.88 492.193C1083.88 490.962 1082.89 489.965 1081.66 489.965Z"
            fill="white"
          />
          <path
            d="M1091.82 521.396C1090.62 521.396 1089.65 522.377 1089.65 523.574C1089.65 524.77 1090.62 525.751 1091.82 525.751C1093.03 525.751 1093.99 524.783 1093.99 523.574C1093.99 522.364 1093.02 521.396 1091.82 521.396Z"
            fill="white"
          />
          <path
            d="M1100.14 554.297C1098.96 554.297 1098.02 555.243 1098.02 556.431C1098.02 557.62 1098.96 558.553 1100.14 558.553C1101.32 558.553 1102.28 557.607 1102.28 556.431C1102.28 555.256 1101.33 554.297 1100.14 554.297Z"
            fill="white"
          />
          <path
            d="M1106.23 588.285C1105.06 588.285 1104.13 589.223 1104.13 590.377C1104.13 591.532 1105.06 592.469 1106.23 592.469C1107.39 592.469 1108.32 591.532 1108.32 590.377C1108.32 589.223 1107.38 588.285 1106.23 588.285Z"
            fill="white"
          />
          <path
            d="M1110.53 623.094C1109.4 623.094 1108.48 624.01 1108.48 625.135C1108.48 626.26 1109.4 627.176 1110.53 627.176C1111.65 627.176 1112.57 626.26 1112.57 625.135C1112.57 624.01 1111.65 623.094 1110.53 623.094Z"
            fill="white"
          />
          <path
            d="M1113.01 657.623C1111.91 657.623 1111.01 658.518 1111.01 659.622C1111.01 660.725 1111.91 661.621 1113.01 661.621C1114.12 661.621 1115.01 660.725 1115.01 659.622C1115.01 658.518 1114.12 657.623 1113.01 657.623Z"
            fill="white"
          />
          <path
            d="M1360.56 1.58203C1358.88 1.58203 1357.5 2.94427 1357.5 4.63329C1357.5 6.3223 1358.88 7.68454 1360.56 7.68454C1362.23 7.68454 1363.61 6.31381 1363.61 4.63329C1363.61 2.95276 1362.24 1.58203 1360.56 1.58203Z"
            fill="white"
          />
          <path
            d="M1367.57 13.7285C1365.84 13.7285 1364.45 15.1332 1364.45 16.8519C1364.45 18.5706 1365.84 19.9796 1367.57 19.9796C1369.3 19.9796 1370.69 18.5791 1370.69 16.8519C1370.69 15.1247 1369.3 13.7285 1367.57 13.7285Z"
            fill="white"
          />
          <path
            d="M1374.26 26.4258C1372.51 26.4258 1371.08 27.8517 1371.08 29.6128C1371.08 31.374 1372.5 32.7956 1374.26 32.7956C1376.02 32.7956 1377.45 31.3697 1377.45 29.6128C1377.45 27.8559 1376.02 26.4258 1374.26 26.4258Z"
            fill="white"
          />
          <path
            d="M1380.67 39.6328C1378.88 39.6328 1377.44 41.0799 1377.44 42.8623C1377.44 44.6447 1378.88 46.0876 1380.67 46.0876C1382.47 46.0876 1383.9 44.6404 1383.9 42.8623C1383.9 41.0842 1382.45 39.6328 1380.67 39.6328Z"
            fill="white"
          />
          <path
            d="M1386.78 53.3105C1384.97 53.3105 1383.49 54.7789 1383.49 56.5952C1383.49 58.4115 1384.97 59.8799 1386.78 59.8799C1388.59 59.8799 1390.07 58.4115 1390.07 56.5952C1390.07 54.7789 1388.6 53.3105 1386.78 53.3105Z"
            fill="white"
          />
          <path
            d="M1392.7 67.3242C1390.83 67.3242 1389.34 68.8265 1389.34 70.6853C1389.34 72.544 1390.83 74.0506 1392.7 74.0506C1394.56 74.0506 1396.06 72.5398 1396.06 70.6853C1396.06 68.8308 1394.55 67.3242 1392.7 67.3242Z"
            fill="white"
          />
          <path
            d="M1398.47 81.6152C1396.59 81.6152 1395.07 83.1387 1395.07 85.023C1395.07 86.9072 1396.59 88.4392 1398.47 88.4392C1400.36 88.4392 1401.89 86.9072 1401.89 85.023C1401.89 83.1387 1400.36 81.6152 1398.47 81.6152Z"
            fill="white"
          />
          <path
            d="M1404.27 95.9375C1402.35 95.9375 1400.8 97.4865 1400.8 99.3962C1400.8 101.306 1402.35 102.863 1404.27 102.863C1406.18 102.863 1407.74 101.314 1407.74 99.3962C1407.74 97.478 1406.19 95.9375 1404.27 95.9375Z"
            fill="white"
          />
          <path
            d="M1410.23 110.045C1408.28 110.045 1406.71 111.611 1406.71 113.554C1406.71 115.498 1408.28 117.06 1410.23 117.06C1412.18 117.06 1413.74 115.49 1413.74 113.554C1413.74 111.619 1412.17 110.045 1410.23 110.045Z"
            fill="white"
          />
          <path
            d="M1416.54 123.547C1414.57 123.547 1412.97 125.143 1412.97 127.12C1412.97 129.098 1414.57 130.702 1416.54 130.702C1418.5 130.702 1420.12 129.098 1420.12 127.12C1420.12 125.143 1418.52 123.547 1416.54 123.547Z"
            fill="white"
          />
          <path
            d="M1423.34 136.242C1421.34 136.242 1419.72 137.863 1419.72 139.862C1419.72 141.861 1421.34 143.482 1423.34 143.482C1425.33 143.482 1426.96 141.857 1426.96 139.862C1426.96 137.868 1425.33 136.242 1423.34 136.242Z"
            fill="white"
          />
          <path
            d="M1430.65 147.928C1428.63 147.928 1426.99 149.574 1426.99 151.599C1426.99 153.623 1428.63 155.269 1430.65 155.269C1432.68 155.269 1434.32 153.623 1434.32 151.599C1434.32 149.574 1432.68 147.928 1430.65 147.928Z"
            fill="white"
          />
          <path
            d="M1438.5 158.484C1436.45 158.484 1434.78 160.148 1434.78 162.202C1434.78 164.256 1436.45 165.907 1438.5 165.907C1440.55 165.907 1442.21 164.252 1442.21 162.202C1442.21 160.152 1440.55 158.484 1438.5 158.484Z"
            fill="white"
          />
          <path
            d="M1446.83 167.84C1444.74 167.84 1443.05 169.537 1443.05 171.617C1443.05 173.696 1444.75 175.394 1446.83 175.394C1448.91 175.394 1450.6 173.709 1450.6 171.617C1450.6 169.525 1448.92 167.84 1446.83 167.84Z"
            fill="white"
          />
          <path
            d="M1448.41 271.002C1446.2 271.002 1444.42 272.793 1444.42 274.987C1444.42 277.181 1446.2 278.972 1448.41 278.972C1450.62 278.972 1452.39 277.194 1452.39 274.987C1452.39 272.78 1450.6 271.002 1448.41 271.002Z"
            fill="white"
          />
          <path
            d="M1434.14 275.852C1431.95 275.852 1430.18 277.621 1430.18 279.807C1430.18 281.992 1431.95 283.749 1434.14 283.749C1436.32 283.749 1438.08 281.988 1438.08 279.807C1438.08 277.625 1436.31 275.852 1434.14 275.852Z"
            fill="white"
          />
          <path
            d="M1419.45 281.41C1417.29 281.41 1415.53 283.171 1415.53 285.336C1415.53 287.5 1417.29 289.261 1419.45 289.261C1421.62 289.261 1423.37 287.5 1423.37 285.336C1423.37 283.171 1421.62 281.41 1419.45 281.41Z"
            fill="white"
          />
          <path
            d="M1404.49 287.676C1402.34 287.676 1400.59 289.416 1400.59 291.559C1400.59 293.702 1402.34 295.45 1404.49 295.45C1406.63 295.45 1408.38 293.71 1408.38 291.559C1408.38 289.407 1406.63 287.676 1404.49 287.676Z"
            fill="white"
          />
          <path
            d="M1389.22 294.461C1387.1 294.461 1385.39 296.18 1385.39 298.289C1385.39 300.398 1387.11 302.121 1389.22 302.121C1391.33 302.121 1393.05 300.402 1393.05 298.289C1393.05 296.175 1391.33 294.461 1389.22 294.461Z"
            fill="white"
          />
          <path
            d="M1373.69 301.268C1371.6 301.268 1369.89 302.974 1369.89 305.066C1369.89 307.158 1371.6 308.864 1373.69 308.864C1375.78 308.864 1377.49 307.166 1377.49 305.066C1377.49 302.965 1375.79 301.268 1373.69 301.268Z"
            fill="white"
          />
          <path
            d="M1357.84 307.742C1355.77 307.742 1354.08 309.427 1354.08 311.489C1354.08 313.552 1355.77 315.245 1357.84 315.245C1359.91 315.245 1361.59 313.56 1361.59 311.489C1361.59 309.418 1359.91 307.742 1357.84 307.742Z"
            fill="white"
          />
          <path
            d="M1341.6 313.664C1339.55 313.664 1337.9 315.328 1337.9 317.377C1337.9 319.427 1339.55 321.082 1341.6 321.082C1343.65 321.082 1345.31 319.419 1345.31 317.377C1345.31 315.336 1343.65 313.664 1341.6 313.664Z"
            fill="white"
          />
          <path
            d="M1325.11 318.672C1323.11 318.672 1321.47 320.306 1321.47 322.313C1321.47 324.32 1323.11 325.954 1325.11 325.954C1327.12 325.954 1328.77 324.329 1328.77 322.313C1328.77 320.297 1327.13 318.672 1325.11 318.672Z"
            fill="white"
          />
          <path
            d="M1308.55 322.564C1306.56 322.564 1304.95 324.177 1304.95 326.176C1304.95 328.175 1306.56 329.779 1308.55 329.779C1310.53 329.779 1312.15 328.166 1312.15 326.176C1312.15 324.186 1310.54 322.564 1308.55 322.564Z"
            fill="white"
          />
          <path
            d="M1291.97 325.373C1290.01 325.373 1288.42 326.964 1288.42 328.921C1288.42 330.877 1290.01 332.481 1291.97 332.481C1293.92 332.481 1295.53 330.89 1295.53 328.921C1295.53 326.952 1293.94 325.373 1291.97 325.373Z"
            fill="white"
          />
          <path
            d="M1275.57 326.934C1273.63 326.934 1272.06 328.504 1272.06 330.452C1272.06 332.4 1273.63 333.961 1275.57 333.961C1277.52 333.961 1279.08 332.391 1279.08 330.452C1279.08 328.512 1277.51 326.934 1275.57 326.934Z"
            fill="white"
          />
          <path
            d="M1259.55 327.52C1257.64 327.52 1256.11 329.06 1256.11 330.953C1256.11 332.845 1257.64 334.386 1259.55 334.386C1261.45 334.386 1262.97 332.845 1262.97 330.953C1262.97 329.06 1261.44 327.52 1259.55 327.52Z"
            fill="white"
          />
          <path
            d="M1244.01 327.27C1242.14 327.27 1240.62 328.789 1240.62 330.66C1240.62 332.532 1242.14 334.043 1244.01 334.043C1245.88 334.043 1247.4 332.523 1247.4 330.66C1247.4 328.797 1245.88 327.27 1244.01 327.27Z"
            fill="white"
          />
          <path
            d="M1228.96 326.301C1227.11 326.301 1225.62 327.799 1225.62 329.641C1225.62 331.482 1227.11 332.972 1228.96 332.972C1230.8 332.972 1232.3 331.482 1232.3 329.641C1232.3 327.799 1230.8 326.301 1228.96 326.301Z"
            fill="white"
          />
          <path
            d="M1214.35 324.928C1212.53 324.928 1211.06 326.405 1211.06 328.217C1211.06 330.029 1212.53 331.506 1214.35 331.506C1216.16 331.506 1217.63 330.037 1217.63 328.217C1217.63 326.396 1216.16 324.928 1214.35 324.928Z"
            fill="white"
          />
          <path
            d="M1200.25 323.615C1198.48 323.615 1197.05 325.05 1197.05 326.819C1197.05 328.589 1198.49 330.036 1200.25 330.036C1202.02 330.036 1203.47 328.602 1203.47 326.819C1203.47 325.037 1202.03 323.615 1200.25 323.615Z"
            fill="white"
          />
          <path
            d="M1186.64 322.514C1184.89 322.514 1183.47 323.931 1183.47 325.68C1183.47 327.428 1184.89 328.833 1186.64 328.833C1188.39 328.833 1189.79 327.415 1189.79 325.68C1189.79 323.944 1188.37 322.514 1186.64 322.514Z"
            fill="white"
          />
          <path
            d="M1173.21 321.76C1171.51 321.76 1170.11 323.143 1170.11 324.862C1170.11 326.581 1171.51 327.951 1173.21 327.951C1174.92 327.951 1176.32 326.568 1176.32 324.862C1176.32 323.156 1174.92 321.76 1173.21 321.76Z"
            fill="white"
          />
          <path
            d="M1159.97 321.521C1158.28 321.521 1156.92 322.884 1156.92 324.573C1156.92 326.262 1158.28 327.624 1159.97 327.624C1161.65 327.624 1163.03 326.262 1163.03 324.573C1163.03 322.884 1161.65 321.521 1159.97 321.521Z"
            fill="white"
          />
          <path
            d="M1147.01 322.062C1145.37 322.062 1144.04 323.395 1144.04 325.029C1144.04 326.663 1145.37 327.995 1147.01 327.995C1148.64 327.995 1149.97 326.675 1149.97 325.029C1149.97 323.382 1148.65 322.062 1147.01 322.062Z"
            fill="white"
          />
          <path
            d="M1134.11 323.428C1132.51 323.428 1131.21 324.731 1131.21 326.33C1131.21 327.93 1132.51 329.233 1134.11 329.233C1135.71 329.233 1137.02 327.93 1137.02 326.33C1137.02 324.731 1135.71 323.428 1134.11 323.428Z"
            fill="white"
          />
          <path
            d="M1121.36 325.863C1119.79 325.863 1118.51 327.145 1118.51 328.715C1118.51 330.285 1119.79 331.567 1121.36 331.567C1122.93 331.567 1124.21 330.298 1124.21 328.715C1124.21 327.132 1122.93 325.863 1121.36 325.863Z"
            fill="white"
          />
          <path
            d="M1109.06 329.734C1107.52 329.734 1106.27 330.982 1106.27 332.535C1106.27 334.088 1107.52 335.323 1109.06 335.323C1110.6 335.323 1111.85 334.076 1111.85 332.535C1111.85 330.995 1110.6 329.734 1109.06 329.734Z"
            fill="white"
          />
          <path
            d="M1097.16 335.25C1095.66 335.25 1094.45 336.468 1094.45 337.958C1094.45 339.447 1095.66 340.665 1097.16 340.665C1098.66 340.665 1099.87 339.456 1099.87 337.958C1099.87 336.459 1098.65 335.25 1097.16 335.25Z"
            fill="white"
          />
          <path
            d="M1086.33 342.871C1084.86 342.871 1083.68 344.059 1083.68 345.523C1083.68 346.988 1084.86 348.176 1086.33 348.176C1087.79 348.176 1088.98 346.988 1088.98 345.523C1088.98 344.059 1087.79 342.871 1086.33 342.871Z"
            fill="white"
          />
          <path
            d="M1077.1 353.008C1075.66 353.008 1074.5 354.162 1074.5 355.601C1074.5 357.039 1075.66 358.202 1077.1 358.202C1078.54 358.202 1079.7 357.035 1079.7 355.601C1079.7 354.166 1078.53 353.008 1077.1 353.008Z"
            fill="white"
          />
          <path
            d="M1070.28 366.113C1068.87 366.113 1067.73 367.246 1067.73 368.651C1067.73 370.056 1068.87 371.202 1070.28 371.202C1071.68 371.202 1072.82 370.056 1072.82 368.651C1072.82 367.246 1071.68 366.113 1070.28 366.113Z"
            fill="white"
          />
          <path
            d="M1066.87 382.574C1065.52 382.574 1064.43 383.678 1064.43 385.031C1064.43 386.385 1065.52 387.488 1066.87 387.488C1068.22 387.488 1069.33 386.385 1069.33 385.031C1069.33 383.678 1068.23 382.574 1066.87 382.574Z"
            fill="white"
          />
          <path
            d="M1067.25 402.277C1065.92 402.277 1064.85 403.351 1064.85 404.671C1064.85 405.991 1065.92 407.077 1067.25 407.077C1068.58 407.077 1069.65 406.003 1069.65 404.671C1069.65 403.338 1068.57 402.277 1067.25 402.277Z"
            fill="white"
          />
          <path
            d="M1071.7 425.205C1070.41 425.205 1069.34 426.258 1069.34 427.556C1069.34 428.855 1070.41 429.899 1071.7 429.899C1072.99 429.899 1074.05 428.846 1074.05 427.556C1074.05 426.266 1072.99 425.205 1071.7 425.205Z"
            fill="white"
          />
          <path
            d="M1079.33 450.893C1078.07 450.893 1077.03 451.924 1077.03 453.193C1077.03 454.462 1078.07 455.493 1079.33 455.493C1080.6 455.493 1081.63 454.462 1081.63 453.193C1081.63 451.924 1080.59 450.893 1079.33 450.893Z"
            fill="white"
          />
          <path
            d="M1088.68 478.898C1087.45 478.898 1086.45 479.896 1086.45 481.126C1086.45 482.357 1087.45 483.342 1088.68 483.342C1089.91 483.342 1090.89 482.353 1090.89 481.126C1090.89 479.9 1089.9 478.898 1088.68 478.898Z"
            fill="white"
          />
          <path
            d="M1098.01 508.75C1096.8 508.75 1095.82 509.726 1095.82 510.936C1095.82 512.145 1096.8 513.113 1098.01 513.113C1099.21 513.113 1100.18 512.132 1100.18 510.936C1100.18 509.739 1099.2 508.75 1098.01 508.75Z"
            fill="white"
          />
          <path
            d="M1105.82 539.889C1104.65 539.889 1103.69 540.848 1103.69 542.032C1103.69 543.216 1104.65 544.175 1105.82 544.175C1107 544.175 1107.97 543.216 1107.97 542.032C1107.97 540.848 1107.01 539.889 1105.82 539.889Z"
            fill="white"
          />
          <path
            d="M1111.7 572.012C1110.55 572.012 1109.61 572.95 1109.61 574.104C1109.61 575.258 1110.55 576.196 1111.7 576.196C1112.86 576.196 1113.79 575.258 1113.79 574.104C1113.79 572.95 1112.86 572.012 1111.7 572.012Z"
            fill="white"
          />
          <path
            d="M1115.91 604.879C1114.77 604.879 1113.87 605.796 1113.87 606.92C1113.87 608.045 1114.77 608.961 1115.91 608.961C1117.04 608.961 1117.95 608.045 1117.95 606.92C1117.95 605.796 1117.03 604.879 1115.91 604.879Z"
            fill="white"
          />
          <path
            d="M1118.6 637.881C1117.5 637.881 1116.59 638.785 1116.59 639.888C1116.59 640.992 1117.5 641.895 1118.6 641.895C1119.71 641.895 1120.61 641 1120.61 639.888C1120.61 638.776 1119.71 637.881 1118.6 637.881Z"
            fill="white"
          />
          <path
            d="M1119.77 669.998C1118.67 669.998 1117.78 670.881 1117.78 671.976C1117.78 673.07 1118.67 673.953 1119.77 673.953C1120.86 673.953 1121.75 673.07 1121.75 671.976C1121.75 670.881 1120.86 669.998 1119.77 669.998Z"
            fill="white"
          />
          <path
            d="M1375.34 -0.259766C1373.66 -0.259766 1372.31 1.09823 1372.31 2.77876C1372.31 4.45928 1373.66 5.81728 1375.34 5.81728C1377.03 5.81728 1378.38 4.45504 1378.38 2.77876C1378.38 1.10248 1377.02 -0.259766 1375.34 -0.259766Z"
            fill="white"
          />
          <path
            d="M1382.17 12.1016C1380.45 12.1016 1379.04 13.502 1379.04 15.2377C1379.04 16.9734 1380.45 18.3696 1382.17 18.3696C1383.9 18.3696 1385.3 16.9649 1385.3 15.2377C1385.3 13.5105 1383.9 12.1016 1382.17 12.1016Z"
            fill="white"
          />
          <path
            d="M1388.72 24.9922C1386.96 24.9922 1385.54 26.4096 1385.54 28.1665C1385.54 29.9234 1386.96 31.3408 1388.72 31.3408C1390.48 31.3408 1391.89 29.9192 1391.89 28.1665C1391.89 26.4138 1390.47 24.9922 1388.72 24.9922Z"
            fill="white"
          />
          <path
            d="M1394.98 38.3242C1393.2 38.3242 1391.74 39.7798 1391.74 41.5664C1391.74 43.3531 1393.19 44.8087 1394.98 44.8087C1396.76 44.8087 1398.22 43.3531 1398.22 41.5664C1398.22 39.7798 1396.77 38.3242 1394.98 38.3242Z"
            fill="white"
          />
          <path
            d="M1400.96 52.1719C1399.15 52.1719 1397.67 53.6445 1397.67 55.4565C1397.67 57.2686 1399.15 58.7327 1400.96 58.7327C1402.77 58.7327 1404.24 57.2644 1404.24 55.4565C1404.24 53.6487 1402.77 52.1719 1400.96 52.1719Z"
            fill="white"
          />
          <path
            d="M1406.71 66.4062C1404.85 66.4062 1403.34 67.917 1403.34 69.7673C1403.34 71.6176 1404.86 73.1284 1406.71 73.1284C1408.56 73.1284 1410.07 71.6303 1410.07 69.7673C1410.07 67.9043 1408.57 66.4062 1406.71 66.4062Z"
            fill="white"
          />
          <path
            d="M1412.32 80.9531C1410.43 80.9531 1408.9 82.4851 1408.9 84.3651C1408.9 86.2451 1410.43 87.7856 1412.32 87.7856C1414.22 87.7856 1415.74 86.2536 1415.74 84.3651C1415.74 82.4766 1414.2 80.9531 1412.32 80.9531Z"
            fill="white"
          />
          <path
            d="M1417.98 95.4922C1416.07 95.4922 1414.52 97.0412 1414.52 98.9593C1414.52 100.878 1416.07 102.426 1417.98 102.426C1419.9 102.426 1421.45 100.873 1421.45 98.9593C1421.45 97.0454 1419.9 95.4922 1417.98 95.4922Z"
            fill="white"
          />
          <path
            d="M1423.88 109.742C1421.93 109.742 1420.37 111.312 1420.37 113.248C1420.37 115.183 1421.93 116.757 1423.88 116.757C1425.82 116.757 1427.38 115.187 1427.38 113.248C1427.38 111.308 1425.81 109.742 1423.88 109.742Z"
            fill="white"
          />
          <path
            d="M1430.16 123.336C1428.19 123.336 1426.58 124.94 1426.58 126.922C1426.58 128.904 1428.19 130.508 1430.16 130.508C1432.14 130.508 1433.75 128.904 1433.75 126.922C1433.75 124.94 1432.14 123.336 1430.16 123.336Z"
            fill="white"
          />
          <path
            d="M1436.96 136.098C1434.96 136.098 1433.34 137.723 1433.34 139.726C1433.34 141.729 1434.96 143.354 1436.96 143.354C1438.95 143.354 1440.59 141.733 1440.59 139.726C1440.59 137.719 1438.97 136.098 1436.96 136.098Z"
            fill="white"
          />
          <path
            d="M1444.32 147.812C1442.29 147.812 1440.66 149.459 1440.66 151.483C1440.66 153.508 1442.29 155.154 1444.32 155.154C1446.35 155.154 1447.98 153.508 1447.98 151.483C1447.98 149.459 1446.35 147.812 1444.32 147.812Z"
            fill="white"
          />
          <path
            d="M1452.21 158.381C1450.17 158.381 1448.51 160.036 1448.51 162.086C1448.51 164.135 1450.17 165.799 1452.21 165.799C1454.26 165.799 1455.93 164.135 1455.93 162.086C1455.93 160.036 1454.27 158.381 1452.21 158.381Z"
            fill="white"
          />
          <path
            d="M1449.47 272.176C1447.29 272.176 1445.52 273.945 1445.52 276.131C1445.52 278.316 1447.29 280.073 1449.47 280.073C1451.65 280.073 1453.43 278.304 1453.43 276.131C1453.43 273.958 1451.66 272.176 1449.47 272.176Z"
            fill="white"
          />
          <path
            d="M1434.69 277.141C1432.52 277.141 1430.78 278.889 1430.78 281.053C1430.78 283.218 1432.52 284.979 1434.69 284.979C1436.85 284.979 1438.61 283.218 1438.61 281.053C1438.61 278.889 1436.85 277.141 1434.69 277.141Z"
            fill="white"
          />
          <path
            d="M1419.5 282.826C1417.34 282.826 1415.6 284.575 1415.6 286.718C1415.6 288.861 1417.34 290.609 1419.5 290.609C1421.65 290.609 1423.38 288.861 1423.38 286.718C1423.38 284.575 1421.64 282.826 1419.5 282.826Z"
            fill="white"
          />
          <path
            d="M1404.07 289.27C1401.96 289.27 1400.24 290.988 1400.24 293.097C1400.24 295.207 1401.96 296.929 1404.07 296.929C1406.18 296.929 1407.9 295.211 1407.9 293.097C1407.9 290.984 1406.18 289.27 1404.07 289.27Z"
            fill="white"
          />
          <path
            d="M1388.43 296.17C1386.33 296.17 1384.63 297.876 1384.63 299.968C1384.63 302.06 1386.33 303.766 1388.43 303.766C1390.52 303.766 1392.23 302.06 1392.23 299.968C1392.23 297.876 1390.52 296.17 1388.43 296.17Z"
            fill="white"
          />
          <path
            d="M1372.51 303.088C1370.43 303.088 1368.75 304.764 1368.75 306.835C1368.75 308.906 1370.43 310.582 1372.51 310.582C1374.58 310.582 1376.25 308.906 1376.25 306.835C1376.25 304.764 1374.58 303.088 1372.51 303.088Z"
            fill="white"
          />
          <path
            d="M1356.25 309.594C1354.2 309.594 1352.53 311.257 1352.53 313.311C1352.53 315.365 1354.2 317.025 1356.25 317.025C1358.3 317.025 1359.96 315.361 1359.96 313.311C1359.96 311.262 1358.3 309.594 1356.25 309.594Z"
            fill="white"
          />
          <path
            d="M1339.71 315.527C1337.69 315.527 1336.06 317.161 1336.06 319.168C1336.06 321.176 1337.69 322.81 1339.71 322.81C1341.73 322.81 1343.35 321.184 1343.35 319.168C1343.35 317.153 1341.72 315.527 1339.71 315.527Z"
            fill="white"
          />
          <path
            d="M1323.01 320.406C1321.02 320.406 1319.41 322.019 1319.41 324.009C1319.41 326 1321.02 327.599 1323.01 327.599C1325 327.599 1326.62 325.995 1326.62 324.009C1326.62 322.023 1325 320.406 1323.01 320.406Z"
            fill="white"
          />
          <path
            d="M1306.23 324.189C1304.27 324.189 1302.67 325.781 1302.67 327.75C1302.67 329.719 1304.27 331.298 1306.23 331.298C1308.2 331.298 1309.78 329.706 1309.78 327.75C1309.78 325.794 1308.19 324.189 1306.23 324.189Z"
            fill="white"
          />
          <path
            d="M1289.5 326.832C1287.57 326.832 1285.99 328.402 1285.99 330.35C1285.99 332.298 1287.56 333.855 1289.5 333.855C1291.44 333.855 1293.02 332.285 1293.02 330.35C1293.02 328.415 1291.45 326.832 1289.5 326.832Z"
            fill="white"
          />
          <path
            d="M1273.02 328.279C1271.13 328.279 1269.59 329.82 1269.59 331.713C1269.59 333.605 1271.13 335.146 1273.02 335.146C1274.92 335.146 1276.46 333.605 1276.46 331.713C1276.46 329.82 1274.92 328.279 1273.02 328.279Z"
            fill="white"
          />
          <path
            d="M1256.99 328.734C1255.12 328.734 1253.61 330.245 1253.61 332.117C1253.61 333.988 1255.12 335.507 1256.99 335.507C1258.87 335.507 1260.39 333.988 1260.39 332.117C1260.39 330.245 1258.87 328.734 1256.99 328.734Z"
            fill="white"
          />
          <path
            d="M1241.39 328.395C1239.55 328.395 1238.05 329.884 1238.05 331.734C1238.05 333.585 1239.55 335.074 1241.39 335.074C1243.24 335.074 1244.73 333.576 1244.73 331.734C1244.73 329.893 1243.24 328.395 1241.39 328.395Z"
            fill="white"
          />
          <path
            d="M1226.27 327.35C1224.45 327.35 1222.98 328.818 1222.98 330.63C1222.98 332.442 1224.45 333.919 1226.27 333.919C1228.09 333.919 1229.56 332.451 1229.56 330.63C1229.56 328.809 1228.09 327.35 1226.27 327.35Z"
            fill="white"
          />
          <path
            d="M1211.76 326.094C1209.99 326.094 1208.55 327.528 1208.55 329.298C1208.55 331.067 1209.99 332.515 1211.76 332.515C1213.53 332.515 1214.98 331.08 1214.98 329.298C1214.98 327.515 1213.54 326.094 1211.76 326.094Z"
            fill="white"
          />
          <path
            d="M1197.82 324.928C1196.08 324.928 1194.67 326.332 1194.67 328.072C1194.67 329.812 1196.08 331.225 1197.82 331.225C1199.55 331.225 1200.97 329.808 1200.97 328.072C1200.97 326.337 1199.55 324.928 1197.82 324.928Z"
            fill="white"
          />
          <path
            d="M1184.21 323.988C1182.49 323.988 1181.1 325.372 1181.1 327.09C1181.1 328.809 1182.49 330.201 1184.21 330.201C1185.92 330.201 1187.31 328.805 1187.31 327.09C1187.31 325.376 1185.93 323.988 1184.21 323.988Z"
            fill="white"
          />
          <path
            d="M1170.87 323.521C1169.2 323.521 1167.83 324.884 1167.83 326.56C1167.83 328.236 1169.2 329.611 1170.87 329.611C1172.55 329.611 1173.92 328.249 1173.92 326.56C1173.92 324.871 1172.56 323.521 1170.87 323.521Z"
            fill="white"
          />
          <path
            d="M1157.94 323.752C1156.31 323.752 1154.98 325.072 1154.98 326.706C1154.98 328.339 1156.31 329.672 1157.94 329.672C1159.58 329.672 1160.9 328.348 1160.9 326.706C1160.9 325.063 1159.58 323.752 1157.94 323.752Z"
            fill="white"
          />
          <path
            d="M1145.21 324.727C1143.6 324.727 1142.3 326.029 1142.3 327.629C1142.3 329.229 1143.61 330.532 1145.21 330.532C1146.81 330.532 1148.11 329.229 1148.11 327.629C1148.11 326.029 1146.81 324.727 1145.21 324.727Z"
            fill="white"
          />
          <path
            d="M1132.64 326.684C1131.07 326.684 1129.8 327.952 1129.8 329.527C1129.8 331.101 1131.07 332.379 1132.64 332.379C1134.22 332.379 1135.49 331.097 1135.49 329.527C1135.49 327.957 1134.22 326.684 1132.64 326.684Z"
            fill="white"
          />
          <path
            d="M1120.61 329.965C1119.07 329.965 1117.81 331.212 1117.81 332.766C1117.81 334.319 1119.07 335.567 1120.61 335.567C1122.15 335.567 1123.41 334.319 1123.41 332.766C1123.41 331.212 1122.17 329.965 1120.61 329.965Z"
            fill="white"
          />
          <path
            d="M1109.08 334.803C1107.59 334.803 1106.37 336.021 1106.37 337.519C1106.37 339.017 1107.59 340.226 1109.08 340.226C1110.57 340.226 1111.79 339.008 1111.79 337.519C1111.79 336.029 1110.58 334.803 1109.08 334.803Z"
            fill="white"
          />
          <path
            d="M1098.5 341.566C1097.05 341.566 1095.86 342.755 1095.86 344.219C1095.86 345.683 1097.05 346.871 1098.5 346.871C1099.96 346.871 1101.15 345.683 1101.15 344.219C1101.15 342.755 1099.97 341.566 1098.5 341.566Z"
            fill="white"
          />
          <path
            d="M1089.61 350.779C1088.17 350.779 1087.01 351.946 1087.01 353.381C1087.01 354.815 1088.17 355.974 1089.61 355.974C1091.04 355.974 1092.2 354.819 1092.2 353.381C1092.2 351.942 1091.03 350.779 1089.61 350.779Z"
            fill="white"
          />
          <path
            d="M1082.81 362.77C1081.41 362.77 1080.27 363.903 1080.27 365.307C1080.27 366.712 1081.41 367.837 1082.81 367.837C1084.21 367.837 1085.34 366.703 1085.34 365.307C1085.34 363.911 1084.21 362.77 1082.81 362.77Z"
            fill="white"
          />
          <path
            d="M1079.2 378.08C1077.84 378.08 1076.75 379.183 1076.75 380.537C1076.75 381.891 1077.85 382.982 1079.2 382.982C1080.55 382.982 1081.65 381.887 1081.65 380.537C1081.65 379.188 1080.55 378.08 1079.2 378.08Z"
            fill="white"
          />
          <path
            d="M1078.98 396.553C1077.66 396.553 1076.59 397.626 1076.59 398.946C1076.59 400.266 1077.66 401.34 1078.98 401.34C1080.3 401.34 1081.37 400.266 1081.37 398.946C1081.37 397.626 1080.3 396.553 1078.98 396.553Z"
            fill="white"
          />
          <path
            d="M1082.44 418.184C1081.15 418.184 1080.1 419.236 1080.1 420.526C1080.1 421.816 1081.15 422.877 1082.44 422.877C1083.73 422.877 1084.8 421.825 1084.8 420.526C1084.8 419.228 1083.74 418.184 1082.44 418.184Z"
            fill="white"
          />
          <path
            d="M1088.81 442.525C1087.54 442.525 1086.51 443.544 1086.51 444.817C1086.51 446.09 1087.54 447.109 1088.81 447.109C1090.08 447.109 1091.11 446.09 1091.11 444.817C1091.11 443.544 1090.07 442.525 1088.81 442.525Z"
            fill="white"
          />
          <path
            d="M1096.95 469.137C1095.73 469.137 1094.73 470.134 1094.73 471.365C1094.73 472.595 1095.72 473.58 1096.95 473.58C1098.19 473.58 1099.17 472.591 1099.17 471.365C1099.17 470.138 1098.17 469.137 1096.95 469.137Z"
            fill="white"
          />
          <path
            d="M1105.19 497.455C1103.98 497.455 1103.01 498.423 1103.01 499.632C1103.01 500.842 1103.98 501.809 1105.19 501.809C1106.4 501.809 1107.37 500.842 1107.37 499.632C1107.37 498.423 1106.39 497.455 1105.19 497.455Z"
            fill="white"
          />
          <path
            d="M1112.36 526.996C1111.18 526.996 1110.22 527.955 1110.22 529.131C1110.22 530.306 1111.18 531.265 1112.36 531.265C1113.53 531.265 1114.48 530.306 1114.48 529.131C1114.48 527.955 1113.53 526.996 1112.36 526.996Z"
            fill="white"
          />
          <path
            d="M1117.88 557.395C1116.72 557.395 1115.78 558.332 1115.78 559.487C1115.78 560.641 1116.72 561.579 1117.88 561.579C1119.03 561.579 1119.97 560.641 1119.97 559.487C1119.97 558.332 1119.03 557.395 1117.88 557.395Z"
            fill="white"
          />
          <path
            d="M1121.73 588.4C1120.61 588.4 1119.71 589.317 1119.71 590.442C1119.71 591.566 1120.61 592.47 1121.73 592.47C1122.86 592.47 1123.77 591.566 1123.77 590.442C1123.77 589.317 1122.86 588.4 1121.73 588.4Z"
            fill="white"
          />
          <path
            d="M1124.4 619.709C1123.3 619.709 1122.4 620.613 1122.4 621.716C1122.4 622.82 1123.3 623.724 1124.4 623.724C1125.5 623.724 1126.41 622.828 1126.41 621.716C1126.41 620.604 1125.51 619.709 1124.4 619.709Z"
            fill="white"
          />
          <path
            d="M1125.71 650.537C1124.61 650.537 1123.73 651.42 1123.73 652.515C1123.73 653.61 1124.61 654.492 1125.71 654.492C1126.8 654.492 1127.69 653.605 1127.69 652.515C1127.69 651.424 1126.8 650.537 1125.71 650.537Z"
            fill="white"
          />
          <path
            d="M1389.65 -1.28125C1387.97 -1.28125 1386.61 0.0767498 1386.61 1.76152C1386.61 3.44629 1387.97 4.80004 1389.65 4.80004C1391.32 4.80004 1392.68 3.4378 1392.68 1.76152C1392.68 0.0852373 1391.33 -1.28125 1389.65 -1.28125Z"
            fill="white"
          />
          <path
            d="M1396.33 11.2422C1394.6 11.2422 1393.19 12.6426 1393.19 14.3698C1393.19 16.097 1394.6 17.4975 1396.33 17.4975C1398.05 17.4975 1399.45 16.0928 1399.45 14.3698C1399.45 12.6469 1398.05 11.2422 1396.33 11.2422Z"
            fill="white"
          />
          <path
            d="M1402.75 24.2305C1400.99 24.2305 1399.58 25.6479 1399.58 27.4048C1399.58 29.1617 1400.99 30.5791 1402.75 30.5791C1404.51 30.5791 1405.92 29.1575 1405.92 27.4048C1405.92 25.6521 1404.51 24.2305 1402.75 24.2305Z"
            fill="white"
          />
          <path
            d="M1408.86 37.7598C1407.08 37.7598 1405.63 39.2069 1405.63 40.985C1405.63 42.7631 1407.08 44.223 1408.86 44.223C1410.64 44.223 1412.1 42.7759 1412.1 40.985C1412.1 39.1942 1410.65 37.7598 1408.86 37.7598Z"
            fill="white"
          />
          <path
            d="M1414.69 51.8125C1412.88 51.8125 1411.41 53.2808 1411.41 55.0972C1411.41 56.9135 1412.88 58.3818 1414.69 58.3818C1416.5 58.3818 1417.97 56.9135 1417.97 55.0972C1417.97 53.2808 1416.5 51.8125 1414.69 51.8125Z"
            fill="white"
          />
          <path
            d="M1420.3 66.2363C1418.44 66.2363 1416.94 67.7471 1416.94 69.6016C1416.94 71.4561 1418.45 72.9669 1420.3 72.9669C1422.15 72.9669 1423.67 71.4561 1423.67 69.6016C1423.67 67.7471 1422.16 66.2363 1420.3 66.2363Z"
            fill="white"
          />
          <path
            d="M1425.82 80.9121C1423.94 80.9121 1422.41 82.4441 1422.41 84.3283C1422.41 86.2126 1423.94 87.7403 1425.82 87.7403C1427.71 87.7403 1429.24 86.2083 1429.24 84.3283C1429.24 82.4483 1427.7 80.9121 1425.82 80.9121Z"
            fill="white"
          />
          <path
            d="M1431.43 95.5215C1429.53 95.5215 1427.98 97.0662 1427.98 98.9801C1427.98 100.894 1429.53 102.435 1431.43 102.435C1433.34 102.435 1434.9 100.886 1434.9 98.9801C1434.9 97.0747 1433.35 95.5215 1431.43 95.5215Z"
            fill="white"
          />
          <path
            d="M1437.31 109.793C1435.36 109.793 1433.79 111.363 1433.79 113.303C1433.79 115.242 1435.36 116.808 1437.31 116.808C1439.26 116.808 1440.82 115.238 1440.82 113.303C1440.82 111.367 1439.25 109.793 1437.31 109.793Z"
            fill="white"
          />
          <path
            d="M1443.59 123.438C1441.61 123.438 1440.01 125.042 1440.01 127.019C1440.01 128.997 1441.61 130.601 1443.59 130.601C1445.57 130.601 1447.17 128.997 1447.17 127.019C1447.17 125.042 1445.57 123.438 1443.59 123.438Z"
            fill="white"
          />
          <path
            d="M1450.39 136.271C1448.39 136.271 1446.77 137.897 1446.77 139.891C1446.77 141.886 1448.39 143.524 1450.39 143.524C1452.38 143.524 1454.02 141.903 1454.02 139.891C1454.02 137.88 1452.39 136.271 1450.39 136.271Z"
            fill="white"
          />
          <path
            d="M1450.64 273.531C1448.47 273.531 1446.71 275.288 1446.71 277.457C1446.71 279.625 1448.47 281.369 1450.64 281.369C1452.8 281.369 1454.55 279.621 1454.55 277.457C1454.55 275.292 1452.8 273.531 1450.64 273.531Z"
            fill="white"
          />
          <path
            d="M1435.41 278.59C1433.27 278.59 1431.53 280.33 1431.53 282.473C1431.53 284.616 1433.26 286.364 1435.41 286.364C1437.56 286.364 1439.3 284.616 1439.3 282.473C1439.3 280.33 1437.56 278.59 1435.41 278.59Z"
            fill="white"
          />
          <path
            d="M1420.42 291.943C1422.52 291.603 1423.94 289.631 1423.6 287.537C1423.26 285.443 1421.29 284.021 1419.19 284.361C1417.1 284.701 1415.68 286.674 1416.02 288.768C1416.36 290.861 1418.33 292.283 1420.42 291.943Z"
            fill="white"
          />
          <path
            d="M1404.06 290.904C1401.97 290.904 1400.27 292.602 1400.27 294.694C1400.27 296.786 1401.97 298.492 1404.06 298.492C1406.15 298.492 1407.85 296.795 1407.85 294.694C1407.85 292.593 1406.15 290.904 1404.06 290.904Z"
            fill="white"
          />
          <path
            d="M1388.08 297.898C1386 297.898 1384.32 299.575 1384.32 301.654C1384.32 303.734 1386 305.41 1388.08 305.41C1390.17 305.41 1391.84 303.725 1391.84 301.654C1391.84 299.583 1390.15 297.898 1388.08 297.898Z"
            fill="white"
          />
          <path
            d="M1371.84 304.869C1369.78 304.869 1368.12 306.524 1368.12 308.587C1368.12 310.649 1369.78 312.3 1371.84 312.3C1373.9 312.3 1375.56 310.636 1375.56 308.587C1375.56 306.537 1373.89 304.869 1371.84 304.869Z"
            fill="white"
          />
          <path
            d="M1355.32 311.436C1353.3 311.436 1351.67 313.069 1351.67 315.077C1351.67 317.084 1353.3 318.731 1355.32 318.731C1357.34 318.731 1358.97 317.097 1358.97 315.077C1358.97 313.057 1357.34 311.436 1355.32 311.436Z"
            fill="white"
          />
          <path
            d="M1338.59 317.316C1336.6 317.316 1334.97 318.929 1334.97 320.919C1334.97 322.91 1336.6 324.531 1338.59 324.531C1340.57 324.531 1342.2 322.918 1342.2 320.919C1342.2 318.921 1340.57 317.316 1338.59 317.316Z"
            fill="white"
          />
          <path
            d="M1321.68 322.127C1319.72 322.127 1318.11 323.718 1318.11 325.687C1318.11 327.657 1319.72 329.256 1321.68 329.256C1323.65 329.256 1325.24 327.665 1325.24 325.687C1325.24 323.71 1323.65 322.127 1321.68 322.127Z"
            fill="white"
          />
          <path
            d="M1304.69 325.852C1302.76 325.852 1301.19 327.413 1301.19 329.348C1301.19 331.284 1302.76 332.854 1304.69 332.854C1306.63 332.854 1308.2 331.284 1308.2 329.348C1308.2 327.413 1306.63 325.852 1304.69 325.852Z"
            fill="white"
          />
          <path
            d="M1287.83 328.424C1285.93 328.424 1284.39 329.964 1284.39 331.87C1284.39 333.775 1285.93 335.316 1287.83 335.316C1289.74 335.316 1291.28 333.767 1291.28 331.87C1291.28 329.973 1289.74 328.424 1287.83 328.424Z"
            fill="white"
          />
          <path
            d="M1271.33 329.764C1269.46 329.764 1267.93 331.283 1267.93 333.146C1267.93 335.009 1269.45 336.537 1271.33 336.537C1273.21 336.537 1274.71 335.017 1274.71 333.146C1274.71 331.274 1273.2 329.764 1271.33 329.764Z"
            fill="white"
          />
          <path
            d="M1255.19 330.15C1253.33 330.15 1251.85 331.648 1251.85 333.49C1251.85 335.332 1253.34 336.83 1255.19 336.83C1257.04 336.83 1258.53 335.341 1258.53 333.49C1258.53 331.64 1257.03 330.15 1255.19 330.15Z"
            fill="white"
          />
          <path
            d="M1239.48 329.764C1237.67 329.764 1236.19 331.24 1236.19 333.053C1236.19 334.865 1237.67 336.341 1239.48 336.341C1241.29 336.341 1242.77 334.865 1242.77 333.053C1242.77 331.24 1241.3 329.764 1239.48 329.764Z"
            fill="white"
          />
          <path
            d="M1224.43 328.789C1222.66 328.789 1221.23 330.223 1221.23 331.993C1221.23 333.763 1222.67 335.197 1224.43 335.197C1226.2 335.197 1227.64 333.763 1227.64 331.993C1227.64 330.223 1226.2 328.789 1224.43 328.789Z"
            fill="white"
          />
          <path
            d="M1210.07 327.652C1208.32 327.652 1206.91 329.07 1206.91 330.805C1206.91 332.541 1208.32 333.95 1210.07 333.95C1211.82 333.95 1213.21 332.545 1213.21 330.805C1213.21 329.066 1211.81 327.652 1210.07 327.652Z"
            fill="white"
          />
          <path
            d="M1196.15 326.633C1194.43 326.633 1193.05 328.029 1193.05 329.735C1193.05 331.441 1194.43 332.837 1196.15 332.837C1197.87 332.837 1199.25 331.454 1199.25 329.735C1199.25 328.016 1197.86 326.633 1196.15 326.633Z"
            fill="white"
          />
          <path
            d="M1182.62 325.967C1180.94 325.967 1179.57 327.329 1179.57 329.005C1179.57 330.682 1180.93 332.057 1182.62 332.057C1184.31 332.057 1185.66 330.694 1185.66 329.005C1185.66 327.316 1184.3 325.967 1182.62 325.967Z"
            fill="white"
          />
          <path
            d="M1169.61 325.924C1167.98 325.924 1166.64 327.244 1166.64 328.877C1166.64 330.511 1167.98 331.844 1169.61 331.844C1171.24 331.844 1172.57 330.511 1172.57 328.877C1172.57 327.244 1171.24 325.924 1169.61 325.924Z"
            fill="white"
          />
          <path
            d="M1156.97 326.568C1155.36 326.568 1154.06 327.871 1154.06 329.484C1154.06 331.096 1155.37 332.387 1156.97 332.387C1158.57 332.387 1159.88 331.084 1159.88 329.484C1159.88 327.884 1158.58 326.568 1156.97 326.568Z"
            fill="white"
          />
          <path
            d="M1144.59 328.111C1143.01 328.111 1141.73 329.393 1141.73 330.972C1141.73 332.55 1143.01 333.823 1144.59 333.823C1146.17 333.823 1147.44 332.542 1147.44 330.972C1147.44 329.401 1146.16 328.111 1144.59 328.111Z"
            fill="white"
          />
          <path
            d="M1132.81 330.902C1131.27 330.902 1130.01 332.15 1130.01 333.69C1130.01 335.231 1131.27 336.491 1132.81 336.491C1134.35 336.491 1135.6 335.231 1135.6 333.69C1135.6 332.15 1134.35 330.902 1132.81 330.902Z"
            fill="white"
          />
          <path
            d="M1121.69 335.158C1120.2 335.158 1118.99 336.376 1118.99 337.866C1118.99 339.355 1120.19 340.573 1121.69 340.573C1123.2 340.573 1124.4 339.364 1124.4 337.866C1124.4 336.368 1123.18 335.158 1121.69 335.158Z"
            fill="white"
          />
          <path
            d="M1111.49 341.193C1110.02 341.193 1108.83 342.382 1108.83 343.837C1108.83 345.293 1110.02 346.49 1111.49 346.49C1112.95 346.49 1114.14 345.301 1114.14 343.837C1114.14 342.373 1112.95 341.193 1111.49 341.193Z"
            fill="white"
          />
          <path
            d="M1102.94 349.57C1101.5 349.57 1100.34 350.725 1100.34 352.151C1100.34 353.576 1101.5 354.743 1102.94 354.743C1104.38 354.743 1105.53 353.589 1105.53 352.151C1105.53 350.712 1104.36 349.57 1102.94 349.57Z"
            fill="white"
          />
          <path
            d="M1096.32 360.561C1094.92 360.561 1093.79 361.694 1093.79 363.098C1093.79 364.503 1094.92 365.636 1096.32 365.636C1097.71 365.636 1098.86 364.49 1098.86 363.098C1098.86 361.706 1097.72 360.561 1096.32 360.561Z"
            fill="white"
          />
          <path
            d="M1092.54 374.748C1091.19 374.748 1090.08 375.839 1090.08 377.205C1090.08 378.572 1091.19 379.662 1092.54 379.662C1093.89 379.662 1095.01 378.572 1095.01 377.205C1095.01 375.839 1093.9 374.748 1092.54 374.748Z"
            fill="white"
          />
          <path
            d="M1091.86 392.045C1090.53 392.045 1089.46 393.119 1089.46 394.447C1089.46 395.775 1090.54 396.853 1091.86 396.853C1093.19 396.853 1094.26 395.771 1094.26 394.447C1094.26 393.123 1093.18 392.045 1091.86 392.045Z"
            fill="white"
          />
          <path
            d="M1094.37 412.383C1093.08 412.383 1092.03 413.435 1092.03 414.734C1092.03 416.032 1093.08 417.076 1094.37 417.076C1095.66 417.076 1096.72 416.024 1096.72 414.734C1096.72 413.444 1095.67 412.383 1094.37 412.383Z"
            fill="white"
          />
          <path
            d="M1099.56 435.402C1098.3 435.402 1097.28 436.421 1097.28 437.694C1097.28 438.967 1098.3 439.973 1099.56 439.973C1100.82 439.973 1101.85 438.954 1101.85 437.694C1101.85 436.434 1100.83 435.402 1099.56 435.402Z"
            fill="white"
          />
          <path
            d="M1106.38 460.613C1105.16 460.613 1104.16 461.602 1104.16 462.829C1104.16 464.055 1105.15 465.056 1106.38 465.056C1107.61 465.056 1108.61 464.059 1108.61 462.829C1108.61 461.598 1107.61 460.613 1106.38 460.613Z"
            fill="white"
          />
          <path
            d="M1113.48 487.457C1112.27 487.457 1111.31 488.425 1111.31 489.634C1111.31 490.844 1112.27 491.798 1113.48 491.798C1114.69 491.798 1115.65 490.831 1115.65 489.634C1115.65 488.437 1114.68 487.457 1113.48 487.457Z"
            fill="white"
          />
          <path
            d="M1119.83 515.463C1118.66 515.463 1117.71 516.422 1117.71 517.598C1117.71 518.773 1118.66 519.719 1119.83 519.719C1121.01 519.719 1121.97 518.773 1121.97 517.598C1121.97 516.422 1121.01 515.463 1119.83 515.463Z"
            fill="white"
          />
          <path
            d="M1124.74 544.223C1123.57 544.223 1122.64 545.16 1122.64 546.315C1122.64 547.469 1123.58 548.415 1124.74 548.415C1125.9 548.415 1126.83 547.478 1126.83 546.315C1126.83 545.152 1125.9 544.223 1124.74 544.223Z"
            fill="white"
          />
          <path
            d="M1128.23 573.559C1127.11 573.559 1126.19 574.475 1126.19 575.6C1126.19 576.724 1127.11 577.65 1128.23 577.65C1129.36 577.65 1130.28 576.733 1130.28 575.6C1130.28 574.467 1129.36 573.559 1128.23 573.559Z"
            fill="white"
          />
          <path
            d="M1130.59 603.203C1129.48 603.203 1128.59 604.107 1128.59 605.21C1128.59 606.314 1129.48 607.218 1130.59 607.218C1131.71 607.218 1132.59 606.314 1132.59 605.21C1132.59 604.107 1131.7 603.203 1130.59 603.203Z"
            fill="white"
          />
          <path
            d="M1131.91 632.637C1130.81 632.637 1129.93 633.519 1129.93 634.614C1129.93 635.709 1130.81 636.579 1131.91 636.579C1133 636.579 1133.87 635.696 1133.87 634.614C1133.87 633.532 1133 632.637 1131.91 632.637Z"
            fill="white"
          />
          <path
            d="M1132.06 661.133C1130.98 661.133 1130.11 661.999 1130.11 663.081C1130.11 664.163 1130.98 665.029 1132.06 665.029C1133.13 665.029 1134.01 664.154 1134.01 663.081C1134.01 662.007 1133.14 661.133 1132.06 661.133Z"
            fill="white"
          />
          <path
            d="M1403.53 -1.64453C1401.85 -1.64453 1400.49 -0.282288 1400.49 1.40672C1400.49 3.09574 1401.85 4.44525 1403.53 4.44525C1405.21 4.44525 1406.58 3.08301 1406.58 1.40672C1406.58 -0.269557 1405.22 -1.64453 1403.53 -1.64453Z"
            fill="white"
          />
          <path
            d="M1410.05 11.0547C1408.33 11.0547 1406.93 12.4509 1406.93 14.1781C1406.93 15.9053 1408.33 17.3057 1410.05 17.3057C1411.77 17.3057 1413.18 15.9053 1413.18 14.1781C1413.18 12.4509 1411.78 11.0547 1410.05 11.0547Z"
            fill="white"
          />
          <path
            d="M1416.32 24.2539C1414.56 24.2539 1413.15 25.6798 1413.15 27.441C1413.15 29.2021 1414.56 30.6195 1416.32 30.6195C1418.08 30.6195 1419.5 29.1979 1419.5 27.441C1419.5 25.6841 1418.08 24.2539 1416.32 24.2539Z"
            fill="white"
          />
          <path
            d="M1422.27 38.0117C1420.49 38.0117 1419.05 39.4588 1419.05 41.2412C1419.05 43.0236 1420.49 44.475 1422.27 44.475C1424.05 44.475 1425.51 43.0278 1425.51 41.2412C1425.51 39.4546 1424.06 38.0117 1422.27 38.0117Z"
            fill="white"
          />
          <path
            d="M1427.99 52.1973C1426.18 52.1973 1424.71 53.6656 1424.71 55.4862C1424.71 57.3067 1426.18 58.7751 1427.99 58.7751C1429.8 58.7751 1431.28 57.2983 1431.28 55.4862C1431.28 53.6741 1429.81 52.1973 1427.99 52.1973Z"
            fill="white"
          />
          <path
            d="M1433.55 66.6816C1431.68 66.6816 1430.17 68.1839 1430.17 70.0469C1430.17 71.9099 1431.68 73.4122 1433.55 73.4122C1435.41 73.4122 1436.91 71.9099 1436.91 70.0469C1436.91 68.1839 1435.4 66.6816 1433.55 66.6816Z"
            fill="white"
          />
          <path
            d="M1439.06 81.3398C1437.18 81.3398 1435.65 82.8633 1435.65 84.7476C1435.65 86.6318 1437.18 88.1553 1439.06 88.1553C1440.94 88.1553 1442.48 86.6318 1442.48 84.7476C1442.48 82.8633 1440.94 81.3398 1439.06 81.3398Z"
            fill="white"
          />
          <path
            d="M1444.68 95.9297C1442.77 95.9297 1441.22 97.4744 1441.22 99.3841C1441.22 101.294 1442.76 102.847 1444.68 102.847C1446.6 102.847 1448.14 101.302 1448.14 99.3841C1448.14 97.4659 1446.58 95.9297 1444.68 95.9297Z"
            fill="white"
          />
          <path
            d="M1450.54 110.232C1448.61 110.232 1447.04 111.803 1447.04 113.742C1447.04 115.681 1448.61 117.247 1450.54 117.247C1452.48 117.247 1454.06 115.677 1454.06 113.742C1454.06 111.807 1452.49 110.232 1450.54 110.232Z"
            fill="white"
          />
          <path
            d="M1452.03 275.105C1449.89 275.105 1448.15 276.841 1448.15 278.988C1448.15 281.136 1449.89 282.88 1452.03 282.88C1454.17 282.88 1455.92 281.144 1455.92 278.988C1455.92 276.833 1454.18 275.105 1452.03 275.105Z"
            fill="white"
          />
          <path
            d="M1436.5 280.215C1434.38 280.215 1432.66 281.942 1432.66 284.055C1432.66 286.169 1434.38 287.896 1436.5 287.896C1438.62 287.896 1440.34 286.177 1440.34 284.055C1440.34 281.934 1438.62 280.215 1436.5 280.215Z"
            fill="white"
          />
          <path
            d="M1420.62 286.033C1418.53 286.033 1416.83 287.731 1416.83 289.823C1416.83 291.915 1418.53 293.613 1420.62 293.613C1422.71 293.613 1424.42 291.915 1424.42 289.823C1424.42 287.731 1422.71 286.033 1420.62 286.033Z"
            fill="white"
          />
          <path
            d="M1404.6 292.568C1402.53 292.568 1400.84 294.253 1400.84 296.337C1400.84 298.42 1402.53 300.093 1404.6 300.093C1406.67 300.093 1408.37 298.408 1408.37 296.337C1408.37 294.266 1406.68 292.568 1404.6 292.568Z"
            fill="white"
          />
          <path
            d="M1388.4 299.613C1386.35 299.613 1384.68 301.277 1384.68 303.327C1384.68 305.376 1386.35 307.031 1388.4 307.031C1390.45 307.031 1392.1 305.376 1392.1 303.327C1392.1 301.277 1390.45 299.613 1388.4 299.613Z"
            fill="white"
          />
          <path
            d="M1371.97 306.641C1369.95 306.641 1368.32 308.274 1368.32 310.282C1368.32 312.289 1369.95 313.936 1371.97 313.936C1373.99 313.936 1375.62 312.302 1375.62 310.282C1375.62 308.262 1373.98 306.641 1371.97 306.641Z"
            fill="white"
          />
          <path
            d="M1355.34 313.184C1353.34 313.184 1351.73 314.796 1351.73 316.795C1351.73 318.794 1353.34 320.398 1355.34 320.398C1357.34 320.398 1358.95 318.785 1358.95 316.795C1358.95 314.805 1357.32 313.184 1355.34 313.184Z"
            fill="white"
          />
          <path
            d="M1338.47 319.064C1336.5 319.064 1334.91 320.656 1334.91 322.625C1334.91 324.594 1336.5 326.185 1338.47 326.185C1340.44 326.185 1342.03 324.594 1342.03 322.625C1342.03 320.656 1340.44 319.064 1338.47 319.064Z"
            fill="white"
          />
          <path
            d="M1321.44 323.867C1319.5 323.867 1317.93 325.437 1317.93 327.385C1317.93 329.333 1319.5 330.903 1321.44 330.903C1323.39 330.903 1324.96 329.32 1324.96 327.385C1324.96 325.45 1323.39 323.867 1321.44 323.867Z"
            fill="white"
          />
          <path
            d="M1304.36 327.6C1302.46 327.6 1300.92 329.14 1300.92 331.033C1300.92 332.926 1302.46 334.479 1304.36 334.479C1306.27 334.479 1307.81 332.938 1307.81 331.033C1307.81 329.127 1306.26 327.6 1304.36 327.6Z"
            fill="white"
          />
          <path
            d="M1287.43 330.172C1285.55 330.172 1284.04 331.683 1284.04 333.554C1284.04 335.426 1285.55 336.936 1287.43 336.936C1289.31 336.936 1290.81 335.426 1290.81 333.554C1290.81 331.683 1289.29 330.172 1287.43 330.172Z"
            fill="white"
          />
          <path
            d="M1270.76 331.492C1268.91 331.492 1267.42 332.99 1267.42 334.832C1267.42 336.674 1268.91 338.172 1270.76 338.172C1272.6 338.172 1274.1 336.674 1274.1 334.832C1274.1 332.99 1272.6 331.492 1270.76 331.492Z"
            fill="white"
          />
          <path
            d="M1254.45 331.9C1252.64 331.9 1251.16 333.369 1251.16 335.189C1251.16 337.01 1252.64 338.478 1254.45 338.478C1256.26 338.478 1257.74 337.001 1257.74 335.189C1257.74 333.377 1256.27 331.9 1254.45 331.9Z"
            fill="white"
          />
          <path
            d="M1238.77 331.598C1237 331.598 1235.57 333.032 1235.57 334.802C1235.57 336.571 1237.01 338.006 1238.77 338.006C1240.54 338.006 1241.98 336.571 1241.98 334.802C1241.98 333.032 1240.54 331.598 1238.77 331.598Z"
            fill="white"
          />
          <path
            d="M1223.85 330.723C1222.1 330.723 1220.68 332.14 1220.68 333.876C1220.68 335.611 1222.1 337.029 1223.85 337.029C1225.59 337.029 1227 335.624 1227 333.876C1227 332.127 1225.58 330.723 1223.85 330.723Z"
            fill="white"
          />
          <path
            d="M1209.49 329.744C1207.78 329.744 1206.39 331.128 1206.39 332.834C1206.39 334.54 1207.78 335.936 1209.49 335.936C1211.21 335.936 1212.58 334.552 1212.58 332.834C1212.58 331.115 1211.2 329.744 1209.49 329.744Z"
            fill="white"
          />
          <path
            d="M1195.65 328.953C1193.97 328.953 1192.6 330.315 1192.6 332.004C1192.6 333.693 1193.96 335.056 1195.65 335.056C1197.34 335.056 1198.7 333.693 1198.7 332.004C1198.7 330.315 1197.34 328.953 1195.65 328.953Z"
            fill="white"
          />
          <path
            d="M1182.47 328.703C1180.83 328.703 1179.5 330.027 1179.5 331.67C1179.5 333.312 1180.83 334.627 1182.47 334.627C1184.1 334.627 1185.43 333.303 1185.43 331.67C1185.43 330.036 1184.1 328.703 1182.47 328.703Z"
            fill="white"
          />
          <path
            d="M1169.82 329.09C1168.21 329.09 1166.9 330.393 1166.9 331.993C1166.9 333.592 1168.21 334.908 1169.82 334.908C1171.43 334.908 1172.72 333.605 1172.72 331.993C1172.72 330.38 1171.42 329.09 1169.82 329.09Z"
            fill="white"
          />
          <path
            d="M1157.58 330.285C1156 330.285 1154.73 331.567 1154.73 333.137C1154.73 334.707 1156 335.98 1157.58 335.98C1159.16 335.98 1160.42 334.711 1160.42 333.137C1160.42 331.563 1159.15 330.285 1157.58 330.285Z"
            fill="white"
          />
          <path
            d="M1146.03 332.631C1144.49 332.631 1143.24 333.879 1143.24 335.419C1143.24 336.959 1144.49 338.22 1146.03 338.22C1147.57 338.22 1148.83 336.972 1148.83 335.419C1148.83 333.866 1147.58 332.631 1146.03 332.631Z"
            fill="white"
          />
          <path
            d="M1135.32 336.404C1133.82 336.404 1132.61 337.61 1132.61 339.112C1132.61 340.614 1133.82 341.819 1135.32 341.819C1136.82 341.819 1138.03 340.601 1138.03 339.112C1138.03 337.622 1136.81 336.404 1135.32 336.404Z"
            fill="white"
          />
          <path
            d="M1125.51 347.104C1126.97 347.104 1128.16 345.92 1128.16 344.46C1128.16 343 1126.97 341.816 1125.51 341.816C1124.05 341.816 1122.87 343 1122.87 344.46C1122.87 345.92 1124.05 347.104 1125.51 347.104Z"
            fill="white"
          />
          <path
            d="M1117.29 349.426C1115.86 349.426 1114.7 350.593 1114.7 352.019C1114.7 353.445 1115.85 354.612 1117.29 354.612C1118.73 354.612 1119.88 353.457 1119.88 352.019C1119.88 350.58 1118.72 349.426 1117.29 349.426Z"
            fill="white"
          />
          <path
            d="M1110.9 359.541C1109.5 359.541 1108.36 360.674 1108.36 362.079C1108.36 363.483 1109.51 364.617 1110.9 364.617C1112.29 364.617 1113.45 363.483 1113.45 362.079C1113.45 360.674 1112.3 359.541 1110.9 359.541Z"
            fill="white"
          />
          <path
            d="M1106.94 372.654C1105.59 372.654 1104.5 373.749 1104.5 375.111C1104.5 376.474 1105.59 377.556 1106.94 377.556C1108.29 377.556 1109.4 376.461 1109.4 375.111C1109.4 373.762 1108.31 372.654 1106.94 372.654Z"
            fill="white"
          />
          <path
            d="M1105.85 388.82C1104.52 388.82 1103.45 389.902 1103.45 391.227C1103.45 392.551 1104.52 393.62 1105.85 393.62C1107.18 393.62 1108.25 392.546 1108.25 391.227C1108.25 389.907 1107.17 388.82 1105.85 388.82Z"
            fill="white"
          />
          <path
            d="M1107.44 407.879C1106.15 407.879 1105.1 408.931 1105.1 410.221C1105.1 411.512 1106.15 412.564 1107.44 412.564C1108.73 412.564 1109.79 411.512 1109.79 410.221C1109.79 408.931 1108.73 407.879 1107.44 407.879Z"
            fill="white"
          />
          <path
            d="M1111.48 429.549C1110.22 429.549 1109.18 430.567 1109.18 431.84C1109.18 433.114 1110.22 434.141 1111.48 434.141C1112.75 434.141 1113.78 433.109 1113.78 431.84C1113.78 430.572 1112.75 429.549 1111.48 429.549Z"
            fill="white"
          />
          <path
            d="M1116.92 453.309C1115.69 453.309 1114.7 454.306 1114.7 455.537C1114.7 456.767 1115.69 457.752 1116.92 457.752C1118.14 457.752 1119.14 456.763 1119.14 455.537C1119.14 454.31 1118.15 453.309 1116.92 453.309Z"
            fill="white"
          />
          <path
            d="M1122.83 478.682C1121.63 478.682 1120.65 479.649 1120.65 480.859C1120.65 482.068 1121.63 483.044 1122.83 483.044C1124.02 483.044 1125.01 482.064 1125.01 480.859C1125.01 479.653 1124.03 478.682 1122.83 478.682Z"
            fill="white"
          />
          <path
            d="M1128.16 505.137C1126.97 505.137 1126.02 506.104 1126.02 507.28C1126.02 508.455 1126.97 509.423 1128.16 509.423C1129.34 509.423 1130.29 508.464 1130.29 507.28C1130.29 506.096 1129.33 505.137 1128.16 505.137Z"
            fill="white"
          />
          <path
            d="M1132.36 532.365C1131.21 532.365 1130.26 533.303 1130.26 534.466C1130.26 535.629 1131.21 536.558 1132.36 536.558C1133.51 536.558 1134.45 535.62 1134.45 534.466C1134.45 533.312 1133.51 532.365 1132.36 532.365Z"
            fill="white"
          />
          <path
            d="M1135.4 560.166C1134.28 560.166 1133.37 561.083 1133.37 562.207C1133.37 563.332 1134.28 564.249 1135.4 564.249C1136.53 564.249 1137.44 563.332 1137.44 562.207C1137.44 561.083 1136.53 560.166 1135.4 560.166Z"
            fill="white"
          />
          <path
            d="M1137.35 588.234C1136.23 588.234 1135.34 589.138 1135.34 590.254C1135.34 591.371 1136.23 592.262 1137.35 592.262C1138.46 592.262 1139.35 591.358 1139.35 590.254C1139.35 589.151 1138.46 588.234 1137.35 588.234Z"
            fill="white"
          />
          <path
            d="M1138.46 616.293C1137.37 616.293 1136.48 617.176 1136.48 618.271C1136.48 619.365 1137.37 620.235 1138.46 620.235C1139.56 620.235 1140.43 619.361 1140.43 618.271C1140.43 617.18 1139.54 616.293 1138.46 616.293Z"
            fill="white"
          />
          <path
            d="M1138.59 643.666C1137.5 643.666 1136.64 644.54 1136.64 645.614C1136.64 646.688 1137.5 647.562 1138.59 647.562C1139.67 647.562 1140.53 646.688 1140.53 645.614C1140.53 644.54 1139.66 643.666 1138.59 643.666Z"
            fill="white"
          />
          <path
            d="M1137.84 669.896C1136.78 669.896 1135.92 670.762 1135.92 671.823C1135.92 672.884 1136.78 673.737 1137.84 673.737C1138.9 673.737 1139.75 672.871 1139.75 671.823C1139.75 670.775 1138.9 669.896 1137.84 669.896Z"
            fill="white"
          />
          <path
            d="M1416.98 -1.26953C1415.29 -1.26953 1413.92 0.092712 1413.92 1.78172C1413.92 3.47074 1415.29 4.83298 1416.98 4.83298C1418.66 4.83298 1420.03 3.47074 1420.03 1.78172C1420.03 0.092712 1418.66 -1.26953 1416.98 -1.26953Z"
            fill="white"
          />
          <path
            d="M1423.32 11.6914C1421.6 11.6914 1420.19 13.0918 1420.19 14.8148C1420.19 16.5378 1421.6 17.9382 1423.32 17.9382C1425.03 17.9382 1426.44 16.542 1426.44 14.8148C1426.44 13.0876 1425.04 11.6914 1423.32 11.6914Z"
            fill="white"
          />
          <path
            d="M1429.42 25.084C1427.67 25.084 1426.25 26.5099 1426.25 28.2668C1426.25 30.0237 1427.67 31.4454 1429.42 31.4454C1431.17 31.4454 1432.61 30.0237 1432.61 28.2668C1432.61 26.5099 1431.18 25.084 1429.42 25.084Z"
            fill="white"
          />
          <path
            d="M1435.3 38.9258C1433.5 38.9258 1432.06 40.3771 1432.06 42.1638C1432.06 43.9504 1433.5 45.4017 1435.3 45.4017C1437.09 45.4017 1438.53 43.9546 1438.53 42.1638C1438.53 40.3729 1437.08 38.9258 1435.3 38.9258Z"
            fill="white"
          />
          <path
            d="M1440.99 53.1016C1439.17 53.1016 1437.71 54.5699 1437.71 56.382C1437.71 58.1941 1439.17 59.6709 1440.99 59.6709C1442.8 59.6709 1444.28 58.2026 1444.28 56.382C1444.28 54.5614 1442.81 53.1016 1440.99 53.1016Z"
            fill="white"
          />
          <path
            d="M1446.55 67.5625C1444.7 67.5625 1443.19 69.0648 1443.19 70.9235C1443.19 72.7823 1444.69 74.2804 1446.55 74.2804C1448.4 74.2804 1449.91 72.7781 1449.91 70.9235C1449.91 69.069 1448.41 67.5625 1446.55 67.5625Z"
            fill="white"
          />
          <path
            d="M1452.07 82.207C1450.19 82.207 1448.66 83.739 1448.66 85.6148C1448.66 87.4905 1450.19 89.0225 1452.07 89.0225C1453.95 89.0225 1455.49 87.499 1455.49 85.6148C1455.49 83.7305 1453.96 82.207 1452.07 82.207Z"
            fill="white"
          />
          <path
            d="M1453.87 276.945C1451.76 276.945 1450.04 278.664 1450.04 280.786C1450.04 282.908 1451.76 284.627 1453.87 284.627C1455.98 284.627 1457.71 282.908 1457.71 280.786C1457.71 278.664 1455.99 276.945 1453.87 276.945Z"
            fill="white"
          />
          <path
            d="M1438.17 282.057C1436.08 282.057 1434.38 283.754 1434.38 285.846C1434.38 287.938 1436.08 289.636 1438.17 289.636C1440.26 289.636 1441.96 287.938 1441.96 285.846C1441.96 283.754 1440.26 282.057 1438.17 282.057Z"
            fill="white"
          />
          <path
            d="M1422.08 287.801C1420.01 287.801 1418.33 289.486 1418.33 291.557C1418.33 293.627 1420.01 295.312 1422.08 295.312C1424.16 295.312 1425.84 293.636 1425.84 291.557C1425.84 289.477 1424.16 287.801 1422.08 287.801Z"
            fill="white"
          />
          <path
            d="M1405.91 294.316C1403.86 294.316 1402.2 295.98 1402.2 298.034C1402.2 300.088 1403.86 301.751 1405.91 301.751C1407.96 301.751 1409.62 300.088 1409.62 298.034C1409.62 295.98 1407.96 294.316 1405.91 294.316Z"
            fill="white"
          />
          <path
            d="M1389.6 301.352C1387.6 301.352 1385.96 302.985 1385.96 304.993C1385.96 307 1387.6 308.647 1389.6 308.647C1391.61 308.647 1393.26 307.013 1393.26 304.993C1393.26 302.973 1391.62 301.352 1389.6 301.352Z"
            fill="white"
          />
          <path
            d="M1373.16 308.346C1371.16 308.346 1369.55 309.958 1369.55 311.957C1369.55 313.956 1371.16 315.556 1373.16 315.556C1375.16 315.556 1376.76 313.943 1376.76 311.957C1376.76 309.971 1375.15 308.346 1373.16 308.346Z"
            fill="white"
          />
          <path
            d="M1357.07 321.902C1359.01 321.587 1360.33 319.758 1360.02 317.817C1359.7 315.876 1357.87 314.558 1355.93 314.873C1353.99 315.188 1352.67 317.017 1352.99 318.958C1353.3 320.899 1355.13 322.217 1357.07 321.902Z"
            fill="white"
          />
          <path
            d="M1339.62 320.793C1337.68 320.793 1336.1 322.363 1336.1 324.298C1336.1 326.233 1337.68 327.816 1339.62 327.816C1341.55 327.816 1343.13 326.246 1343.13 324.298C1343.13 322.35 1341.56 320.793 1339.62 320.793Z"
            fill="white"
          />
          <path
            d="M1322.61 325.686C1320.71 325.686 1319.17 327.226 1319.17 329.119C1319.17 331.011 1320.71 332.552 1322.61 332.552C1324.5 332.552 1326.05 331.011 1326.05 329.119C1326.05 327.226 1324.51 325.686 1322.61 325.686Z"
            fill="white"
          />
          <path
            d="M1305.59 329.465C1303.72 329.465 1302.19 330.984 1302.19 332.856C1302.19 334.727 1303.71 336.251 1305.59 336.251C1307.47 336.251 1308.98 334.731 1308.98 332.856C1308.98 330.98 1307.47 329.465 1305.59 329.465Z"
            fill="white"
          />
          <path
            d="M1288.59 332.137C1286.74 332.137 1285.25 333.635 1285.25 335.477C1285.25 337.318 1286.74 338.808 1288.59 338.808C1290.43 338.808 1291.93 337.318 1291.93 335.477C1291.93 333.635 1290.43 332.137 1288.59 332.137Z"
            fill="white"
          />
          <path
            d="M1271.77 333.584C1269.96 333.584 1268.48 335.052 1268.48 336.873C1268.48 338.693 1269.96 340.162 1271.77 340.162C1273.58 340.162 1275.06 338.685 1275.06 336.873C1275.06 335.061 1273.59 333.584 1271.77 333.584Z"
            fill="white"
          />
          <path
            d="M1255.47 334.158C1253.69 334.158 1252.25 335.593 1252.25 337.362C1252.25 339.132 1253.68 340.579 1255.47 340.579C1257.25 340.579 1258.68 339.14 1258.68 337.362C1258.68 335.584 1257.24 334.158 1255.47 334.158Z"
            fill="white"
          />
          <path
            d="M1239.87 334.033C1238.12 334.033 1236.71 335.451 1236.71 337.199C1236.71 338.947 1238.12 340.352 1239.87 340.352C1241.61 340.352 1243.02 338.935 1243.02 337.199C1243.02 335.463 1241.6 334.033 1239.87 334.033Z"
            fill="white"
          />
          <path
            d="M1224.93 333.369C1223.22 333.369 1221.83 334.753 1221.83 336.459C1221.83 338.165 1223.22 339.561 1224.93 339.561C1226.63 339.561 1228.03 338.177 1228.03 336.459C1228.03 334.74 1226.65 333.369 1224.93 333.369Z"
            fill="white"
          />
          <path
            d="M1210.63 332.607C1208.94 332.607 1207.58 333.982 1207.58 335.654C1207.58 337.326 1208.94 338.714 1210.63 338.714C1212.32 338.714 1213.68 337.339 1213.68 335.654C1213.68 333.97 1212.32 332.607 1210.63 332.607Z"
            fill="white"
          />
          <path
            d="M1197.13 332.252C1195.5 332.252 1194.17 333.572 1194.17 335.206C1194.17 336.839 1195.5 338.172 1197.13 338.172C1198.77 338.172 1200.1 336.848 1200.1 335.206C1200.1 333.563 1198.77 332.252 1197.13 332.252Z"
            fill="white"
          />
          <path
            d="M1184.36 332.443C1182.75 332.443 1181.46 333.733 1181.46 335.338C1181.46 336.942 1182.76 338.24 1184.36 338.24C1185.96 338.24 1187.26 336.937 1187.26 335.338C1187.26 333.738 1185.96 332.443 1184.36 332.443Z"
            fill="white"
          />
          <path
            d="M1172.16 333.355C1170.59 333.355 1169.31 334.624 1169.31 336.199C1169.31 337.773 1170.59 339.051 1172.16 339.051C1173.73 339.051 1175.01 337.782 1175.01 336.199C1175.01 334.616 1173.73 333.355 1172.16 333.355Z"
            fill="white"
          />
          <path
            d="M1160.78 335.346C1159.24 335.346 1157.99 336.585 1157.99 338.125C1157.99 339.666 1159.24 340.914 1160.78 340.914C1162.32 340.914 1163.56 339.666 1163.56 338.125C1163.56 336.585 1162.32 335.346 1160.78 335.346Z"
            fill="white"
          />
          <path
            d="M1150.37 338.676C1148.87 338.676 1147.65 339.894 1147.65 341.392C1147.65 342.89 1148.87 344.108 1150.37 344.108C1151.86 344.108 1153.07 342.89 1153.07 341.392C1153.07 339.894 1151.86 338.676 1150.37 338.676Z"
            fill="white"
          />
          <path
            d="M1140.92 343.557C1139.45 343.557 1138.26 344.753 1138.26 346.209C1138.26 347.665 1139.45 348.874 1140.92 348.874C1142.38 348.874 1143.57 347.677 1143.57 346.209C1143.57 344.741 1142.38 343.557 1140.92 343.557Z"
            fill="white"
          />
          <path
            d="M1132.95 350.508C1131.51 350.508 1130.35 351.662 1130.35 353.101C1130.35 354.539 1131.52 355.694 1132.95 355.694C1134.39 355.694 1135.55 354.539 1135.55 353.101C1135.55 351.662 1134.38 350.508 1132.95 350.508Z"
            fill="white"
          />
          <path
            d="M1126.76 359.836C1125.36 359.836 1124.22 360.969 1124.22 362.374C1124.22 363.778 1125.36 364.911 1126.76 364.911C1128.17 364.911 1129.3 363.766 1129.3 362.374C1129.3 360.982 1128.15 359.836 1126.76 359.836Z"
            fill="white"
          />
          <path
            d="M1122.63 371.939C1121.28 371.939 1120.18 373.034 1120.18 374.384C1120.18 375.733 1121.28 376.841 1122.63 376.841C1123.98 376.841 1125.09 375.75 1125.09 374.384C1125.09 373.017 1123.99 371.939 1122.63 371.939Z"
            fill="white"
          />
          <path
            d="M1121.07 387C1119.75 387 1118.68 388.074 1118.68 389.393C1118.68 390.713 1119.75 391.787 1121.07 391.787C1122.39 391.787 1123.46 390.713 1123.46 389.393C1123.46 388.074 1122.39 387 1121.07 387Z"
            fill="white"
          />
          <path
            d="M1121.79 404.777C1120.49 404.777 1119.44 405.83 1119.44 407.128C1119.44 408.427 1120.49 409.471 1121.79 409.471C1123.09 409.471 1124.14 408.418 1124.14 407.128C1124.14 405.838 1123.09 404.777 1121.79 404.777Z"
            fill="white"
          />
          <path
            d="M1124.61 425.062C1123.34 425.062 1122.31 426.094 1122.31 427.354C1122.31 428.615 1123.34 429.654 1124.61 429.654C1125.87 429.654 1126.91 428.623 1126.91 427.354C1126.91 426.085 1125.87 425.062 1124.61 425.062Z"
            fill="white"
          />
          <path
            d="M1128.67 447.342C1127.44 447.342 1126.44 448.339 1126.44 449.57C1126.44 450.8 1127.44 451.798 1128.67 451.798C1129.9 451.798 1130.88 450.8 1130.88 449.57C1130.88 448.339 1129.89 447.342 1128.67 447.342Z"
            fill="white"
          />
          <path
            d="M1133.27 471.209C1132.06 471.209 1131.09 472.189 1131.09 473.386C1131.09 474.583 1132.06 475.563 1133.27 475.563C1134.48 475.563 1135.43 474.583 1135.43 473.386C1135.43 472.189 1134.47 471.209 1133.27 471.209Z"
            fill="white"
          />
          <path
            d="M1137.44 500.394C1138.62 500.394 1139.57 499.439 1139.57 498.26C1139.57 497.081 1138.62 496.125 1137.44 496.125C1136.26 496.125 1135.3 497.081 1135.3 498.26C1135.3 499.439 1136.26 500.394 1137.44 500.394Z"
            fill="white"
          />
          <path
            d="M1140.86 521.854C1139.7 521.854 1138.76 522.779 1138.76 523.937C1138.76 525.096 1139.7 526.029 1140.86 526.029C1142.01 526.029 1142.95 525.092 1142.95 523.937C1142.95 522.783 1142.01 521.854 1140.86 521.854Z"
            fill="white"
          />
          <path
            d="M1143.22 548.094C1142.1 548.094 1141.18 549.01 1141.18 550.135C1141.18 551.26 1142.1 552.163 1143.22 552.163C1144.34 552.163 1145.25 551.26 1145.25 550.135C1145.25 549.01 1144.34 548.094 1143.22 548.094Z"
            fill="white"
          />
          <path
            d="M1144.68 574.654C1143.56 574.654 1142.67 575.558 1142.67 576.662C1142.67 577.765 1143.56 578.66 1144.68 578.66C1145.79 578.66 1146.67 577.765 1146.67 576.662C1146.67 575.558 1145.78 574.654 1144.68 574.654Z"
            fill="white"
          />
          <path
            d="M1145.41 601.328C1144.32 601.328 1143.44 602.211 1143.44 603.306C1143.44 604.401 1144.32 605.292 1145.41 605.292C1146.51 605.292 1147.4 604.396 1147.4 603.306C1147.4 602.215 1146.52 601.328 1145.41 601.328Z"
            fill="white"
          />
          <path
            d="M1145.44 627.621C1144.37 627.621 1143.5 628.495 1143.5 629.577C1143.5 630.66 1144.37 631.525 1145.44 631.525C1146.52 631.525 1147.4 630.651 1147.4 629.577C1147.4 628.504 1146.53 627.621 1145.44 627.621Z"
            fill="white"
          />
          <path
            d="M1144.61 652.973C1143.56 652.973 1142.7 653.838 1142.7 654.887C1142.7 655.935 1143.56 656.8 1144.61 656.8C1145.66 656.8 1146.53 655.948 1146.53 654.887C1146.53 653.826 1145.67 652.973 1144.61 652.973Z"
            fill="white"
          />
          <path
            d="M1143.18 677.129C1142.13 677.129 1141.27 677.973 1141.27 679.022C1141.27 680.07 1142.13 680.927 1143.18 680.927C1144.23 680.927 1145.08 680.074 1145.08 679.022C1145.08 677.969 1144.23 677.129 1143.18 677.129Z"
            fill="white"
          />
          <path
            d="M1429.94 -0.0722656C1428.26 -0.0722656 1426.9 1.28998 1426.9 2.96626C1426.9 4.64254 1428.26 6.00478 1429.94 6.00478C1431.61 6.00478 1432.97 4.64254 1432.97 2.96626C1432.97 1.28998 1431.61 -0.0722656 1429.94 -0.0722656Z"
            fill="white"
          />
          <path
            d="M1436.16 12.9902C1434.43 12.9902 1433.02 14.3949 1433.02 16.1221C1433.02 17.8493 1434.43 19.254 1436.16 19.254C1437.88 19.254 1439.29 17.8493 1439.29 16.1221C1439.29 14.3949 1437.88 12.9902 1436.16 12.9902Z"
            fill="white"
          />
          <path
            d="M1442.23 26.4258C1440.46 26.4258 1439.05 27.8432 1439.05 29.6001C1439.05 31.357 1440.47 32.7744 1442.23 32.7744C1443.98 32.7744 1445.4 31.3485 1445.4 29.6001C1445.4 27.8517 1443.97 26.4258 1442.23 26.4258Z"
            fill="white"
          />
          <path
            d="M1448.07 40.248C1446.28 40.248 1444.83 41.6994 1444.83 43.486C1444.83 45.2726 1446.28 46.724 1448.07 46.724C1449.86 46.724 1451.31 45.2769 1451.31 43.486C1451.31 41.6952 1449.86 40.248 1448.07 40.248Z"
            fill="white"
          />
          <path
            d="M1453.76 54.4355C1451.94 54.4355 1450.47 55.9081 1450.47 57.7245C1450.47 59.5408 1451.94 61.0091 1453.76 61.0091C1455.57 61.0091 1457.05 59.5365 1457.05 57.7245C1457.05 55.9124 1455.57 54.4355 1453.76 54.4355Z"
            fill="white"
          />
          <path
            d="M1440.53 284.17C1438.45 284.17 1436.76 285.855 1436.76 287.926C1436.76 289.997 1438.44 291.694 1440.53 291.694C1442.61 291.694 1444.28 290.009 1444.28 287.926C1444.28 285.842 1442.6 284.17 1440.53 284.17Z"
            fill="white"
          />
          <path
            d="M1424.38 289.809C1422.33 289.809 1420.66 291.464 1420.66 293.513C1420.66 295.563 1422.32 297.231 1424.38 297.231C1426.43 297.231 1428.08 295.567 1428.08 293.513C1428.08 291.459 1426.43 289.809 1424.38 289.809Z"
            fill="white"
          />
          <path
            d="M1408.17 296.223C1406.16 296.223 1404.53 297.856 1404.53 299.877C1404.53 301.897 1406.16 303.518 1408.17 303.518C1410.18 303.518 1411.82 301.884 1411.82 299.877C1411.82 297.869 1410.19 296.223 1408.17 296.223Z"
            fill="white"
          />
          <path
            d="M1391.92 303.123C1389.94 303.123 1388.32 304.736 1388.32 306.734C1388.32 308.733 1389.94 310.337 1391.92 310.337C1393.91 310.337 1395.53 308.725 1395.53 306.734C1395.53 304.744 1393.91 303.123 1391.92 303.123Z"
            fill="white"
          />
          <path
            d="M1375.54 310.074C1373.58 310.074 1371.98 311.666 1371.98 313.635C1371.98 315.604 1373.57 317.195 1375.54 317.195C1377.51 317.195 1379.1 315.604 1379.1 313.635C1379.1 311.666 1377.5 310.074 1375.54 310.074Z"
            fill="white"
          />
          <path
            d="M1358.98 316.609C1357.05 316.609 1355.48 318.18 1355.48 320.119C1355.48 322.058 1357.05 323.637 1358.98 323.637C1360.92 323.637 1362.49 322.067 1362.49 320.119C1362.49 318.171 1360.92 316.609 1358.98 316.609Z"
            fill="white"
          />
          <path
            d="M1342.26 322.582C1340.35 322.582 1338.83 324.122 1338.83 326.015C1338.83 327.908 1340.36 329.461 1342.26 329.461C1344.16 329.461 1345.69 327.921 1345.69 326.015C1345.69 324.11 1344.15 322.582 1342.26 322.582Z"
            fill="white"
          />
          <path
            d="M1325.43 327.58C1323.56 327.58 1322.03 329.112 1322.03 330.984C1322.03 332.855 1323.55 334.374 1325.43 334.374C1327.3 334.374 1328.82 332.855 1328.82 330.984C1328.82 329.112 1327.3 327.58 1325.43 327.58Z"
            fill="white"
          />
          <path
            d="M1308.52 331.525C1306.68 331.525 1305.18 333.023 1305.18 334.865C1305.18 336.707 1306.68 338.218 1308.52 338.218C1310.36 338.218 1311.86 336.72 1311.86 334.865C1311.86 333.011 1310.37 331.525 1308.52 331.525Z"
            fill="white"
          />
          <path
            d="M1291.58 334.436C1289.77 334.436 1288.29 335.904 1288.29 337.716C1288.29 339.528 1289.77 341.005 1291.58 341.005C1293.39 341.005 1294.86 339.537 1294.86 337.716C1294.86 335.895 1293.39 334.436 1291.58 334.436Z"
            fill="white"
          />
          <path
            d="M1274.9 336.199C1273.12 336.199 1271.68 337.634 1271.68 339.416C1271.68 341.198 1273.12 342.62 1274.9 342.62C1276.68 342.62 1278.1 341.181 1278.1 339.416C1278.1 337.651 1276.66 336.199 1274.9 336.199Z"
            fill="white"
          />
          <path
            d="M1258.74 337.062C1256.99 337.062 1255.58 338.48 1255.58 340.216C1255.58 341.951 1256.99 343.369 1258.74 343.369C1260.49 343.369 1261.9 341.964 1261.9 340.216C1261.9 338.467 1260.48 337.062 1258.74 337.062Z"
            fill="white"
          />
          <path
            d="M1243.19 337.273C1241.47 337.273 1240.08 338.657 1240.08 340.376C1240.08 342.094 1241.48 343.478 1243.19 343.478C1244.91 343.478 1246.3 342.094 1246.3 340.376C1246.3 338.657 1244.9 337.273 1243.19 337.273Z"
            fill="white"
          />
          <path
            d="M1228.3 336.959C1226.62 336.959 1225.25 338.321 1225.25 340.01C1225.25 341.699 1226.62 343.061 1228.3 343.061C1229.98 343.061 1231.35 341.699 1231.35 340.01C1231.35 338.321 1229.99 336.959 1228.3 336.959Z"
            fill="white"
          />
          <path
            d="M1214.34 336.688C1212.7 336.688 1211.38 338.007 1211.38 339.645C1211.38 341.283 1212.7 342.603 1214.34 342.603C1215.97 342.603 1217.3 341.279 1217.3 339.645C1217.3 338.012 1215.97 336.688 1214.34 336.688Z"
            fill="white"
          />
          <path
            d="M1201.26 336.791C1199.66 336.791 1198.36 338.094 1198.36 339.694C1198.36 341.294 1199.66 342.588 1201.26 342.588C1202.86 342.588 1204.16 341.298 1204.16 339.694C1204.16 338.09 1202.87 336.791 1201.26 336.791Z"
            fill="white"
          />
          <path
            d="M1188.93 337.51C1187.36 337.51 1186.08 338.791 1186.08 340.362C1186.08 341.932 1187.36 343.213 1188.93 343.213C1190.5 343.213 1191.78 341.932 1191.78 340.362C1191.78 338.791 1190.5 337.51 1188.93 337.51Z"
            fill="white"
          />
          <path
            d="M1177.52 339.193C1175.97 339.193 1174.72 340.441 1174.72 341.981C1174.72 343.522 1175.97 344.782 1177.52 344.782C1179.07 344.782 1180.32 343.535 1180.32 341.981C1180.32 340.428 1179.06 339.193 1177.52 339.193Z"
            fill="white"
          />
          <path
            d="M1167.21 342.172C1165.71 342.172 1164.5 343.381 1164.5 344.879C1164.5 346.377 1165.71 347.587 1167.21 347.587C1168.71 347.587 1169.92 346.382 1169.92 344.879C1169.92 343.377 1168.71 342.172 1167.21 342.172Z"
            fill="white"
          />
          <path
            d="M1157.94 346.588C1156.49 346.588 1155.3 347.776 1155.3 349.24C1155.3 350.704 1156.49 351.884 1157.94 351.884C1159.4 351.884 1160.6 350.696 1160.6 349.24C1160.6 347.785 1159.41 346.588 1157.94 346.588Z"
            fill="white"
          />
          <path
            d="M1150.09 352.912C1148.66 352.912 1147.49 354.066 1147.49 355.505C1147.49 356.944 1148.66 358.098 1150.09 358.098C1151.51 358.098 1152.69 356.944 1152.69 355.505C1152.69 354.066 1151.52 352.912 1150.09 352.912Z"
            fill="white"
          />
          <path
            d="M1143.94 361.508C1142.53 361.508 1141.4 362.641 1141.4 364.037C1141.4 365.433 1142.53 366.566 1143.94 366.566C1145.34 366.566 1146.47 365.433 1146.47 364.037C1146.47 362.641 1145.33 361.508 1143.94 361.508Z"
            fill="white"
          />
          <path
            d="M1139.59 372.67C1138.23 372.67 1137.14 373.765 1137.14 375.114C1137.14 376.464 1138.24 377.559 1139.59 377.559C1140.94 377.559 1142.03 376.464 1142.03 375.114C1142.03 373.765 1140.93 372.67 1139.59 372.67Z"
            fill="white"
          />
          <path
            d="M1137.46 386.605C1136.13 386.605 1135.05 387.688 1135.05 389.012C1135.05 390.336 1136.13 391.414 1137.46 391.414C1138.79 391.414 1139.87 390.34 1139.87 389.012C1139.87 387.683 1138.79 386.605 1137.46 386.605Z"
            fill="white"
          />
          <path
            d="M1137.32 403.152C1136.03 403.152 1134.97 404.192 1134.97 405.495C1134.97 406.798 1136.03 407.837 1137.32 407.837C1138.61 407.837 1139.66 406.785 1139.66 405.495C1139.66 404.205 1138.61 403.152 1137.32 403.152Z"
            fill="white"
          />
          <path
            d="M1138.92 422.02C1137.65 422.02 1136.63 423.051 1136.63 424.311C1136.63 425.572 1137.65 426.599 1138.92 426.599C1140.19 426.599 1141.21 425.58 1141.21 424.311C1141.21 423.042 1140.18 422.02 1138.92 422.02Z"
            fill="white"
          />
          <path
            d="M1141.64 442.836C1140.41 442.836 1139.42 443.825 1139.42 445.043C1139.42 446.261 1140.41 447.258 1141.64 447.258C1142.86 447.258 1143.85 446.269 1143.85 445.043C1143.85 443.816 1142.86 442.836 1141.64 442.836Z"
            fill="white"
          />
          <path
            d="M1144.82 465.119C1143.62 465.119 1142.64 466.087 1142.64 467.296C1142.64 468.506 1143.62 469.46 1144.82 469.46C1146.02 469.46 1147 468.493 1147 467.296C1147 466.099 1146.03 465.119 1144.82 465.119Z"
            fill="white"
          />
          <path
            d="M1147.82 488.498C1146.64 488.498 1145.69 489.444 1145.69 490.62C1145.69 491.795 1146.64 492.755 1147.82 492.755C1148.99 492.755 1149.95 491.795 1149.95 490.62C1149.95 489.444 1148.99 488.498 1147.82 488.498Z"
            fill="white"
          />
          <path
            d="M1150.24 512.662C1149.09 512.662 1148.15 513.6 1148.15 514.754C1148.15 515.909 1149.09 516.846 1150.24 516.846C1151.4 516.846 1152.34 515.909 1152.34 514.754C1152.34 513.6 1151.4 512.662 1150.24 512.662Z"
            fill="white"
          />
          <path
            d="M1151.83 537.383C1150.71 537.383 1149.79 538.299 1149.79 539.424C1149.79 540.549 1150.71 541.474 1151.83 541.474C1152.96 541.474 1153.88 540.557 1153.88 539.424C1153.88 538.291 1152.97 537.383 1151.83 537.383Z"
            fill="white"
          />
          <path
            d="M1152.73 562.51C1151.63 562.51 1150.72 563.405 1150.72 564.509C1150.72 565.612 1151.63 566.516 1152.73 566.516C1153.83 566.516 1154.73 565.62 1154.73 564.509C1154.73 563.397 1153.83 562.51 1152.73 562.51Z"
            fill="white"
          />
          <path
            d="M1152.94 587.754C1151.84 587.754 1150.97 588.637 1150.97 589.732C1150.97 590.826 1151.84 591.701 1152.94 591.701C1154.03 591.701 1154.92 590.814 1154.92 589.732C1154.92 588.649 1154.03 587.754 1152.94 587.754Z"
            fill="white"
          />
          <path
            d="M1152.64 612.869C1151.56 612.869 1150.69 613.735 1150.69 614.817C1150.69 615.899 1151.56 616.765 1152.64 616.765C1153.71 616.765 1154.58 615.891 1154.58 614.817C1154.58 613.743 1153.72 612.869 1152.64 612.869Z"
            fill="white"
          />
          <path
            d="M1151.73 637.352C1150.67 637.352 1149.81 638.217 1149.81 639.278C1149.81 640.339 1150.67 641.205 1151.73 641.205C1152.79 641.205 1153.66 640.339 1153.66 639.278C1153.66 638.217 1152.79 637.352 1151.73 637.352Z"
            fill="white"
          />
          <path
            d="M1150.16 660.811C1149.11 660.811 1148.25 661.664 1148.25 662.716C1148.25 663.768 1149.11 664.609 1150.16 664.609C1151.21 664.609 1152.05 663.764 1152.05 662.716C1152.05 661.668 1151.2 660.811 1150.16 660.811Z"
            fill="white"
          />
          <path
            d="M1442.58 1.58203C1440.89 1.58203 1439.53 2.94427 1439.53 4.63329C1439.53 6.3223 1440.89 7.68454 1442.58 7.68454C1444.27 7.68454 1445.63 6.3223 1445.63 4.63329C1445.63 2.94427 1444.27 1.58203 1442.58 1.58203Z"
            fill="white"
          />
          <path
            d="M1448.78 14.6562C1447.05 14.6562 1445.65 16.0609 1445.65 17.7881C1445.65 19.5153 1447.05 20.9115 1448.78 20.9115C1450.51 20.9115 1451.9 19.5111 1451.9 17.7881C1451.9 16.0652 1450.51 14.6562 1448.78 14.6562Z"
            fill="white"
          />
          <path
            d="M1443.71 286.75C1441.66 286.75 1440 288.414 1440 290.476C1440 292.538 1441.66 294.194 1443.71 294.194C1445.77 294.194 1447.44 292.53 1447.44 290.476C1447.44 288.422 1445.78 286.75 1443.71 286.75Z"
            fill="white"
          />
          <path
            d="M1427.64 292.225C1425.63 292.225 1423.99 293.858 1423.99 295.866C1423.99 297.873 1425.63 299.52 1427.64 299.52C1429.64 299.52 1431.29 297.886 1431.29 295.866C1431.29 293.846 1429.66 292.225 1427.64 292.225Z"
            fill="white"
          />
          <path
            d="M1411.54 298.408C1409.55 298.408 1407.93 300.021 1407.93 302.02C1407.93 304.018 1409.55 305.623 1411.54 305.623C1413.53 305.623 1415.15 304.01 1415.15 302.02C1415.15 300.029 1413.53 298.408 1411.54 298.408Z"
            fill="white"
          />
          <path
            d="M1395.42 305.107C1393.47 305.107 1391.87 306.699 1391.87 308.668C1391.87 310.637 1393.47 312.228 1395.42 312.228C1397.38 312.228 1398.98 310.637 1398.98 308.668C1398.98 306.699 1397.39 305.107 1395.42 305.107Z"
            fill="white"
          />
          <path
            d="M1379.25 311.959C1377.31 311.959 1375.74 313.529 1375.74 315.477C1375.74 317.425 1377.31 318.987 1379.25 318.987C1381.18 318.987 1382.75 317.416 1382.75 315.477C1382.75 313.538 1381.18 311.959 1379.25 311.959Z"
            fill="white"
          />
          <path
            d="M1365.4 324.376C1366.74 323.03 1366.74 320.849 1365.4 319.503C1364.05 318.157 1361.87 318.157 1360.53 319.503C1359.18 320.849 1359.18 323.03 1360.53 324.376C1361.87 325.722 1364.05 325.722 1365.4 324.376Z"
            fill="white"
          />
          <path
            d="M1346.54 324.51C1344.66 324.51 1343.15 326.029 1343.15 327.905C1343.15 329.781 1344.67 331.287 1346.54 331.287C1348.41 331.287 1349.93 329.768 1349.93 327.905C1349.93 326.042 1348.41 324.51 1346.54 324.51Z"
            fill="white"
          />
          <path
            d="M1329.96 329.713C1328.11 329.713 1326.61 331.202 1326.61 333.053C1326.61 334.903 1328.11 336.393 1329.96 336.393C1331.82 336.393 1333.3 334.895 1333.3 333.053C1333.3 331.211 1331.81 329.713 1329.96 329.713Z"
            fill="white"
          />
          <path
            d="M1313.26 333.896C1311.45 333.896 1309.99 335.373 1309.99 337.185C1309.99 338.997 1311.45 340.474 1313.26 340.474C1315.07 340.474 1316.55 338.997 1316.55 337.185C1316.55 335.373 1315.08 333.896 1313.26 333.896Z"
            fill="white"
          />
          <path
            d="M1296.68 337.174C1294.9 337.174 1293.46 338.608 1293.46 340.391C1293.46 342.173 1294.9 343.595 1296.68 343.595C1298.46 343.595 1299.89 342.156 1299.89 340.391C1299.89 338.625 1298.45 337.174 1296.68 337.174Z"
            fill="white"
          />
          <path
            d="M1280.38 339.414C1278.64 339.414 1277.23 340.831 1277.23 342.58C1277.23 344.328 1278.65 345.733 1280.38 345.733C1282.12 345.733 1283.55 344.316 1283.55 342.58C1283.55 340.844 1282.13 339.414 1280.38 339.414Z"
            fill="white"
          />
          <path
            d="M1264.44 340.727C1262.72 340.727 1261.33 342.11 1261.33 343.829C1261.33 345.547 1262.72 346.931 1264.44 346.931C1266.15 346.931 1267.54 345.547 1267.54 343.829C1267.54 342.11 1266.16 340.727 1264.44 340.727Z"
            fill="white"
          />
          <path
            d="M1249.03 341.451C1247.36 341.451 1246 342.813 1246 344.49C1246 346.166 1247.36 347.541 1249.03 347.541C1250.71 347.541 1252.08 346.179 1252.08 344.49C1252.08 342.801 1250.72 341.451 1249.03 341.451Z"
            fill="white"
          />
          <path
            d="M1234.54 341.838C1232.91 341.838 1231.58 343.17 1231.58 344.813C1231.58 346.455 1232.91 347.779 1234.54 347.779C1236.18 347.779 1237.51 346.447 1237.51 344.813C1237.51 343.179 1236.19 341.838 1234.54 341.838Z"
            fill="white"
          />
          <path
            d="M1220.99 342.139C1219.38 342.139 1218.07 343.442 1218.07 345.041C1218.07 346.641 1219.38 347.944 1220.99 347.944C1222.59 347.944 1223.89 346.641 1223.89 345.041C1223.89 343.442 1222.59 342.139 1220.99 342.139Z"
            fill="white"
          />
          <path
            d="M1208.29 342.84C1206.72 342.84 1205.44 344.121 1205.44 345.692C1205.44 347.262 1206.72 348.543 1208.29 348.543C1209.86 348.543 1211.14 347.262 1211.14 345.692C1211.14 344.121 1209.87 342.84 1208.29 342.84Z"
            fill="white"
          />
          <path
            d="M1196.66 344.348C1195.12 344.348 1193.87 345.595 1193.87 347.136C1193.87 348.676 1195.12 349.924 1196.66 349.924C1198.2 349.924 1199.45 348.676 1199.45 347.136C1199.45 345.595 1198.2 344.348 1196.66 344.348Z"
            fill="white"
          />
          <path
            d="M1186.24 347.031C1184.74 347.031 1183.54 348.241 1183.54 349.739C1183.54 351.237 1184.74 352.446 1186.24 352.446C1187.75 352.446 1188.95 351.228 1188.95 349.739C1188.95 348.249 1187.73 347.031 1186.24 347.031Z"
            fill="white"
          />
          <path
            d="M1176.95 351.051C1175.49 351.051 1174.3 352.239 1174.3 353.695C1174.3 355.15 1175.49 356.347 1176.95 356.347C1178.4 356.347 1179.6 355.159 1179.6 353.695C1179.6 352.231 1178.41 351.051 1176.95 351.051Z"
            fill="white"
          />
          <path
            d="M1169 356.828C1167.57 356.828 1166.42 357.995 1166.42 359.421C1166.42 360.847 1167.57 362.001 1169 362.001C1170.42 362.001 1171.59 360.847 1171.59 359.421C1171.59 357.995 1170.43 356.828 1169 356.828Z"
            fill="white"
          />
          <path
            d="M1162.65 364.693C1161.25 364.693 1160.11 365.839 1160.11 367.244C1160.11 368.649 1161.26 369.782 1162.65 369.782C1164.04 369.782 1165.2 368.649 1165.2 367.244C1165.2 365.839 1164.05 364.693 1162.65 364.693Z"
            fill="white"
          />
          <path
            d="M1157.9 374.947C1156.54 374.947 1155.45 376.051 1155.45 377.404C1155.45 378.758 1156.54 379.862 1157.9 379.862C1159.26 379.862 1160.36 378.758 1160.36 377.404C1160.36 376.051 1159.26 374.947 1157.9 374.947Z"
            fill="white"
          />
          <path
            d="M1155.05 387.781C1153.73 387.781 1152.66 388.855 1152.66 390.175C1152.66 391.495 1153.73 392.568 1155.05 392.568C1156.37 392.568 1157.45 391.495 1157.45 390.175C1157.45 388.855 1156.38 387.781 1155.05 387.781Z"
            fill="white"
          />
          <path
            d="M1153.96 403.037C1152.66 403.037 1151.62 404.077 1151.62 405.38C1151.62 406.682 1152.66 407.722 1153.96 407.722C1155.26 407.722 1156.29 406.67 1156.29 405.38C1156.29 404.09 1155.25 403.037 1153.96 403.037Z"
            fill="white"
          />
          <path
            d="M1154.25 420.428C1152.98 420.428 1151.95 421.459 1151.95 422.728C1151.95 423.997 1152.98 425.028 1154.25 425.028C1155.52 425.028 1156.55 423.997 1156.55 422.728C1156.55 421.459 1155.52 420.428 1154.25 420.428Z"
            fill="white"
          />
          <path
            d="M1155.61 439.715C1154.38 439.715 1153.4 440.712 1153.4 441.943C1153.4 443.173 1154.38 444.158 1155.61 444.158C1156.84 444.158 1157.84 443.169 1157.84 441.943C1157.84 440.716 1156.84 439.715 1155.61 439.715Z"
            fill="white"
          />
          <path
            d="M1157.38 460.395C1156.17 460.395 1155.2 461.375 1155.2 462.572C1155.2 463.768 1156.17 464.749 1157.38 464.749C1158.59 464.749 1159.56 463.781 1159.56 462.572C1159.56 461.362 1158.58 460.395 1157.38 460.395Z"
            fill="white"
          />
          <path
            d="M1159.19 482.221C1158.02 482.221 1157.06 483.18 1157.06 484.355C1157.06 485.531 1158.02 486.49 1159.19 486.49C1160.37 486.49 1161.33 485.531 1161.33 484.355C1161.33 483.18 1160.37 482.221 1159.19 482.221Z"
            fill="white"
          />
          <path
            d="M1160.55 504.836C1159.39 504.836 1158.45 505.774 1158.45 506.928C1158.45 508.082 1159.39 509.02 1160.55 509.02C1161.7 509.02 1162.64 508.082 1162.64 506.928C1162.64 505.774 1161.7 504.836 1160.55 504.836Z"
            fill="white"
          />
          <path
            d="M1161.38 528.109C1160.25 528.109 1159.34 529.026 1159.34 530.151C1159.34 531.275 1160.25 532.192 1161.38 532.192C1162.5 532.192 1163.42 531.275 1163.42 530.151C1163.42 529.026 1162.5 528.109 1161.38 528.109Z"
            fill="white"
          />
          <path
            d="M1161.57 551.777C1160.46 551.777 1159.56 552.681 1159.56 553.785C1159.56 554.888 1160.46 555.805 1161.57 555.805C1162.67 555.805 1163.58 554.901 1163.58 553.785C1163.58 552.669 1162.68 551.777 1161.57 551.777Z"
            fill="white"
          />
          <path
            d="M1161.17 575.629C1160.08 575.629 1159.19 576.516 1159.19 577.598C1159.19 578.68 1160.08 579.576 1161.17 579.576C1162.26 579.576 1163.13 578.693 1163.13 577.598C1163.13 576.503 1162.25 575.629 1161.17 575.629Z"
            fill="white"
          />
          <path
            d="M1160.37 599.498C1159.29 599.498 1158.42 600.364 1158.42 601.446C1158.42 602.528 1159.29 603.394 1160.37 603.394C1161.44 603.394 1162.32 602.52 1162.32 601.446C1162.32 600.372 1161.45 599.498 1160.37 599.498Z"
            fill="white"
          />
          <path
            d="M1159.17 622.998C1158.11 622.998 1157.25 623.851 1157.25 624.912C1157.25 625.973 1158.11 626.826 1159.17 626.826C1160.23 626.826 1161.09 625.973 1161.09 624.912C1161.09 623.851 1160.22 622.998 1159.17 622.998Z"
            fill="white"
          />
          <path
            d="M1157.44 645.738C1156.4 645.738 1155.55 646.583 1155.55 647.631C1155.55 648.679 1156.4 649.524 1157.44 649.524C1158.48 649.524 1159.34 648.671 1159.34 647.631C1159.34 646.591 1158.49 645.738 1157.44 645.738Z"
            fill="white"
          />
          <path
            d="M1155.31 667.504C1154.28 667.504 1153.43 668.348 1153.43 669.388C1153.43 670.428 1154.28 671.272 1155.31 671.272C1156.34 671.272 1157.19 670.428 1157.19 669.388C1157.19 668.348 1156.35 667.504 1155.31 667.504Z"
            fill="white"
          />
          <path
            d="M1447.84 290.09C1445.82 290.09 1444.19 291.732 1444.19 293.752C1444.19 295.772 1445.82 297.406 1447.84 297.406C1449.86 297.406 1451.5 295.759 1451.5 293.752C1451.5 291.745 1449.86 290.09 1447.84 290.09Z"
            fill="white"
          />
          <path
            d="M1431.96 295.285C1429.97 295.285 1428.35 296.906 1428.35 298.897C1428.35 300.887 1429.97 302.508 1431.96 302.508C1433.96 302.508 1435.58 300.895 1435.58 298.897C1435.58 296.898 1433.95 295.285 1431.96 295.285Z"
            fill="white"
          />
          <path
            d="M1416.04 301.166C1414.07 301.166 1412.48 302.757 1412.48 304.727C1412.48 306.696 1414.07 308.296 1416.04 308.296C1418.01 308.296 1419.61 306.691 1419.61 304.727C1419.61 302.762 1418 301.166 1416.04 301.166Z"
            fill="white"
          />
          <path
            d="M1400.99 314.571C1402.88 314.126 1404.04 312.238 1403.6 310.354C1403.16 308.47 1401.27 307.303 1399.38 307.748C1397.5 308.192 1396.33 310.08 1396.78 311.964C1397.22 313.849 1399.11 315.015 1400.99 314.571Z"
            fill="white"
          />
          <path
            d="M1384.35 314.279C1382.44 314.279 1380.9 315.82 1380.9 317.725C1380.9 319.631 1382.44 321.171 1384.35 321.171C1386.25 321.171 1387.78 319.622 1387.78 317.725C1387.78 315.828 1386.24 314.279 1384.35 314.279Z"
            fill="white"
          />
          <path
            d="M1368.43 320.764C1366.56 320.764 1365.05 322.283 1365.05 324.154C1365.05 326.026 1366.56 327.537 1368.43 327.537C1370.31 327.537 1371.82 326.026 1371.82 324.154C1371.82 322.283 1370.31 320.764 1368.43 320.764Z"
            fill="white"
          />
          <path
            d="M1352.39 326.799C1350.54 326.799 1349.05 328.288 1349.05 330.139C1349.05 331.989 1350.54 333.47 1352.39 333.47C1354.23 333.47 1355.73 331.98 1355.73 330.139C1355.73 328.297 1354.23 326.799 1352.39 326.799Z"
            fill="white"
          />
          <path
            d="M1336.17 332.215C1334.35 332.215 1332.88 333.692 1332.88 335.504C1332.88 337.316 1334.35 338.805 1336.17 338.805C1337.99 338.805 1339.47 337.329 1339.47 335.504C1339.47 333.679 1337.99 332.215 1336.17 332.215Z"
            fill="white"
          />
          <path
            d="M1319.98 336.779C1318.21 336.779 1316.77 338.214 1316.77 339.983C1316.77 341.753 1318.21 343.187 1319.98 343.187C1321.75 343.187 1323.18 341.753 1323.18 339.983C1323.18 338.214 1321.75 336.779 1319.98 336.779Z"
            fill="white"
          />
          <path
            d="M1303.91 340.455C1302.17 340.455 1300.76 341.872 1300.76 343.621C1300.76 345.369 1302.18 346.774 1303.91 346.774C1305.65 346.774 1307.08 345.357 1307.08 343.621C1307.08 341.885 1305.66 340.455 1303.91 340.455Z"
            fill="white"
          />
          <path
            d="M1288.07 343.307C1286.37 343.307 1284.99 344.69 1284.99 346.409C1284.99 348.128 1286.37 349.498 1288.07 349.498C1289.78 349.498 1291.18 348.115 1291.18 346.409C1291.18 344.703 1289.79 343.307 1288.07 343.307Z"
            fill="white"
          />
          <path
            d="M1272.56 345.283C1270.88 345.283 1269.52 346.645 1269.52 348.322C1269.52 349.998 1270.88 351.373 1272.56 351.373C1274.23 351.373 1275.61 350.011 1275.61 348.322C1275.61 346.633 1274.25 345.283 1272.56 345.283Z"
            fill="white"
          />
          <path
            d="M1257.66 346.775C1256.03 346.775 1254.7 348.095 1254.7 349.742C1254.7 351.388 1256.03 352.7 1257.66 352.7C1259.29 352.7 1260.63 351.38 1260.63 349.742C1260.63 348.104 1259.3 346.775 1257.66 346.775Z"
            fill="white"
          />
          <path
            d="M1243.61 347.979C1242.01 347.979 1240.71 349.281 1240.71 350.881C1240.71 352.481 1242.01 353.784 1243.61 353.784C1245.21 353.784 1246.53 352.481 1246.53 350.881C1246.53 349.281 1245.22 347.979 1243.61 347.979Z"
            fill="white"
          />
          <path
            d="M1230.49 349.154C1228.92 349.154 1227.64 350.423 1227.64 351.998C1227.64 353.572 1228.91 354.849 1230.49 354.849C1232.06 354.849 1233.34 353.568 1233.34 351.998C1233.34 350.427 1232.06 349.154 1230.49 349.154Z"
            fill="white"
          />
          <path
            d="M1218.44 350.736C1216.9 350.736 1215.65 351.984 1215.65 353.524C1215.65 355.065 1216.9 356.313 1218.44 356.313C1219.98 356.313 1221.22 355.065 1221.22 353.524C1221.22 351.984 1219.98 350.736 1218.44 350.736Z"
            fill="white"
          />
          <path
            d="M1207.59 353.268C1206.1 353.268 1204.89 354.477 1204.89 355.962C1204.89 357.448 1206.1 358.657 1207.59 358.657C1209.08 358.657 1210.28 357.452 1210.28 355.962C1210.28 354.473 1209.07 353.268 1207.59 353.268Z"
            fill="white"
          />
          <path
            d="M1197.95 356.949C1196.49 356.949 1195.31 358.137 1195.31 359.602C1195.31 361.066 1196.49 362.245 1197.95 362.245C1199.41 362.245 1200.6 361.057 1200.6 359.602C1200.6 358.146 1199.41 356.949 1197.95 356.949Z"
            fill="white"
          />
          <path
            d="M1189.66 362.238C1188.23 362.238 1187.07 363.405 1187.07 364.84C1187.07 366.274 1188.23 367.433 1189.66 367.433C1191.08 367.433 1192.25 366.266 1192.25 364.84C1192.25 363.414 1191.1 362.238 1189.66 362.238Z"
            fill="white"
          />
          <path
            d="M1182.9 369.473C1181.51 369.473 1180.37 370.606 1180.37 372.01C1180.37 373.415 1181.51 374.54 1182.9 374.54C1184.3 374.54 1185.44 373.407 1185.44 372.01C1185.44 370.614 1184.31 369.473 1182.9 369.473Z"
            fill="white"
          />
          <path
            d="M1177.63 378.883C1176.27 378.883 1175.17 379.973 1175.17 381.327C1175.17 382.681 1176.27 383.772 1177.63 383.772C1178.98 383.772 1180.07 382.681 1180.07 381.327C1180.07 379.973 1178.97 378.883 1177.63 378.883Z"
            fill="white"
          />
          <path
            d="M1173.92 390.6C1172.61 390.6 1171.53 391.673 1171.53 392.985C1171.53 394.296 1172.61 395.378 1173.92 395.378C1175.23 395.378 1176.31 394.304 1176.31 392.985C1176.31 391.665 1175.24 390.6 1173.92 390.6Z"
            fill="white"
          />
          <path
            d="M1171.73 404.535C1170.44 404.535 1169.39 405.588 1169.39 406.878C1169.39 408.168 1170.44 409.229 1171.73 409.229C1173.02 409.229 1174.08 408.176 1174.08 406.878C1174.08 405.579 1173.03 404.535 1171.73 404.535Z"
            fill="white"
          />
          <path
            d="M1170.67 420.428C1169.4 420.428 1168.38 421.459 1168.38 422.719C1168.38 423.98 1169.4 425.011 1170.67 425.011C1171.95 425.011 1172.96 423.992 1172.96 422.719C1172.96 421.446 1171.93 420.428 1170.67 420.428Z"
            fill="white"
          />
          <path
            d="M1170.59 438.111C1169.37 438.111 1168.38 439.1 1168.38 440.327C1168.38 441.553 1169.37 442.542 1170.59 442.542C1171.82 442.542 1172.81 441.553 1172.81 440.327C1172.81 439.1 1171.82 438.111 1170.59 438.111Z"
            fill="white"
          />
          <path
            d="M1170.93 457.148C1169.73 457.148 1168.76 458.116 1168.76 459.325C1168.76 460.535 1169.73 461.503 1170.93 461.503C1172.14 461.503 1173.11 460.522 1173.11 459.325C1173.11 458.129 1172.13 457.148 1170.93 457.148Z"
            fill="white"
          />
          <path
            d="M1171.47 481.619C1172.64 481.619 1173.6 480.663 1173.6 479.484C1173.6 478.305 1172.64 477.35 1171.47 477.35C1170.29 477.35 1169.33 478.305 1169.33 479.484C1169.33 480.663 1170.29 481.619 1171.47 481.619Z"
            fill="white"
          />
          <path
            d="M1171.73 498.395C1170.57 498.395 1169.63 499.332 1169.63 500.487C1169.63 501.641 1170.57 502.579 1171.73 502.579C1172.88 502.579 1173.82 501.641 1173.82 500.487C1173.82 499.332 1172.88 498.395 1171.73 498.395Z"
            fill="white"
          />
          <path
            d="M1171.68 520.176C1170.57 520.176 1169.65 521.092 1169.65 522.204C1169.65 523.316 1170.57 524.233 1171.68 524.233C1172.79 524.233 1173.72 523.329 1173.72 522.204C1173.72 521.08 1172.81 520.176 1171.68 520.176Z"
            fill="white"
          />
          <path
            d="M1171.14 542.396C1170.03 542.396 1169.14 543.292 1169.14 544.404C1169.14 545.516 1170.03 546.403 1171.14 546.403C1172.25 546.403 1173.14 545.507 1173.14 544.404C1173.14 543.3 1172.25 542.396 1171.14 542.396Z"
            fill="white"
          />
          <path
            d="M1170.17 564.945C1169.08 564.945 1168.2 565.828 1168.2 566.923C1168.2 568.018 1169.08 568.901 1170.17 568.901C1171.27 568.901 1172.15 568.014 1172.15 566.923C1172.15 565.832 1171.27 564.945 1170.17 564.945Z"
            fill="white"
          />
          <path
            d="M1168.79 587.539C1167.71 587.539 1166.83 588.413 1166.83 589.495C1166.83 590.578 1167.71 591.443 1168.79 591.443C1169.87 591.443 1170.74 590.569 1170.74 589.495C1170.74 588.422 1169.86 587.539 1168.79 587.539Z"
            fill="white"
          />
          <path
            d="M1167.1 609.975C1166.05 609.975 1165.19 610.828 1165.19 611.889C1165.19 612.949 1166.06 613.802 1167.1 613.802C1168.15 613.802 1169.02 612.937 1169.02 611.889C1169.02 610.84 1168.16 609.975 1167.1 609.975Z"
            fill="white"
          />
          <path
            d="M1165.13 631.898C1164.07 631.898 1163.23 632.751 1163.23 633.791C1163.23 634.831 1164.08 635.697 1165.13 635.697C1166.18 635.697 1167.03 634.844 1167.03 633.791C1167.03 632.739 1166.18 631.898 1165.13 631.898Z"
            fill="white"
          />
          <path
            d="M1162.73 653.037C1161.69 653.037 1160.85 653.869 1160.85 654.909C1160.85 655.948 1161.69 656.793 1162.73 656.793C1163.77 656.793 1164.6 655.948 1164.6 654.909C1164.6 653.869 1163.76 653.037 1162.73 653.037Z"
            fill="white"
          />
          <path
            d="M1160.17 677.076C1161.2 677.076 1162.04 676.242 1162.04 675.213C1162.04 674.184 1161.2 673.35 1160.17 673.35C1159.14 673.35 1158.31 674.184 1158.31 675.213C1158.31 676.242 1159.14 677.076 1160.17 677.076Z"
            fill="white"
          />
          <path
            d="M1452.96 294.516C1450.96 294.516 1449.35 296.128 1449.35 298.127C1449.35 300.126 1450.96 301.738 1452.96 301.738C1454.96 301.738 1456.57 300.126 1456.57 298.127C1456.57 296.128 1454.96 294.516 1452.96 294.516Z"
            fill="white"
          />
          <path
            d="M1437.37 299.459C1435.41 299.459 1433.8 301.05 1433.8 303.019C1433.8 304.989 1435.41 306.588 1437.37 306.588C1439.34 306.588 1440.93 304.984 1440.93 303.019C1440.93 301.055 1439.34 299.459 1437.37 299.459Z"
            fill="white"
          />
          <path
            d="M1421.71 304.92C1419.78 304.92 1418.21 306.49 1418.21 308.425C1418.21 310.36 1419.78 311.943 1421.71 311.943C1423.65 311.943 1425.23 310.373 1425.23 308.425C1425.23 306.477 1423.66 304.92 1421.71 304.92Z"
            fill="white"
          />
          <path
            d="M1406.18 311.012C1404.29 311.012 1402.75 312.552 1402.75 314.458C1402.75 316.363 1404.29 317.891 1406.18 317.891C1408.07 317.891 1409.63 316.35 1409.63 314.458C1409.63 312.565 1408.09 311.012 1406.18 311.012Z"
            fill="white"
          />
          <path
            d="M1390.73 324.188C1392.6 324.188 1394.12 322.668 1394.12 320.793C1394.12 318.918 1392.6 317.398 1390.73 317.398C1388.85 317.398 1387.33 318.918 1387.33 320.793C1387.33 322.668 1388.85 324.188 1390.73 324.188Z"
            fill="white"
          />
          <path
            d="M1375.24 323.793C1373.4 323.793 1371.9 325.291 1371.9 327.133C1371.9 328.975 1373.4 330.473 1375.24 330.473C1377.08 330.473 1378.58 328.975 1378.58 327.133C1378.58 325.291 1377.08 323.793 1375.24 323.793Z"
            fill="white"
          />
          <path
            d="M1359.63 329.828C1357.82 329.828 1356.34 331.305 1356.34 333.126C1356.34 334.946 1357.82 336.414 1359.63 336.414C1361.44 336.414 1362.92 334.938 1362.92 333.126C1362.92 331.313 1361.45 329.828 1359.63 329.828Z"
            fill="white"
          />
          <path
            d="M1344.02 335.438C1342.24 335.438 1340.8 336.885 1340.8 338.654C1340.8 340.424 1342.23 341.871 1344.02 341.871C1345.8 341.871 1347.23 340.437 1347.23 338.654C1347.23 336.872 1345.79 335.438 1344.02 335.438Z"
            fill="white"
          />
          <path
            d="M1328.45 340.369C1326.71 340.369 1325.3 341.787 1325.3 343.522C1325.3 345.258 1326.71 346.675 1328.45 346.675C1330.19 346.675 1331.6 345.258 1331.6 343.522C1331.6 341.787 1330.19 340.369 1328.45 340.369Z"
            fill="white"
          />
          <path
            d="M1312.98 344.512C1311.28 344.512 1309.88 345.908 1309.88 347.614C1309.88 349.32 1311.28 350.716 1312.98 350.716C1314.69 350.716 1316.08 349.333 1316.08 347.614C1316.08 345.895 1314.7 344.512 1312.98 344.512Z"
            fill="white"
          />
          <path
            d="M1297.71 348.014C1296.03 348.014 1294.66 349.376 1294.66 351.065C1294.66 352.754 1296.02 354.116 1297.71 354.116C1299.4 354.116 1300.76 352.741 1300.76 351.065C1300.76 349.389 1299.4 348.014 1297.71 348.014Z"
            fill="white"
          />
          <path
            d="M1282.91 350.916C1281.28 350.916 1279.95 352.24 1279.95 353.874C1279.95 355.508 1281.28 356.84 1282.91 356.84C1284.55 356.84 1285.87 355.508 1285.87 353.874C1285.87 352.24 1284.55 350.916 1282.91 350.916Z"
            fill="white"
          />
          <path
            d="M1268.69 353.258C1267.08 353.258 1265.78 354.561 1265.78 356.161C1265.78 357.76 1267.09 359.063 1268.69 359.063C1270.29 359.063 1271.59 357.76 1271.59 356.161C1271.59 354.561 1270.29 353.258 1268.69 353.258Z"
            fill="white"
          />
          <path
            d="M1255.12 355.422C1253.55 355.422 1252.27 356.691 1252.27 358.265C1252.27 359.84 1253.55 361.117 1255.12 361.117C1256.69 361.117 1257.97 359.835 1257.97 358.265C1257.97 356.695 1256.7 355.422 1255.12 355.422Z"
            fill="white"
          />
          <path
            d="M1242.54 357.723C1241 357.723 1239.75 358.97 1239.75 360.524C1239.75 362.077 1241 363.312 1242.54 363.312C1244.08 363.312 1245.34 362.064 1245.34 360.524C1245.34 358.983 1244.09 357.723 1242.54 357.723Z"
            fill="white"
          />
          <path
            d="M1231.2 360.533C1229.7 360.533 1228.49 361.751 1228.49 363.249C1228.49 364.747 1229.7 365.957 1231.2 365.957C1232.69 365.957 1233.9 364.739 1233.9 363.249C1233.9 361.76 1232.7 360.533 1231.2 360.533Z"
            fill="white"
          />
          <path
            d="M1221.03 364.172C1219.57 364.172 1218.38 365.36 1218.38 366.816C1218.38 368.271 1219.57 369.468 1221.03 369.468C1222.48 369.468 1223.68 368.28 1223.68 366.816C1223.68 365.352 1222.49 364.172 1221.03 364.172Z"
            fill="white"
          />
          <path
            d="M1212.09 369.117C1210.67 369.117 1209.5 370.272 1209.5 371.71C1209.5 373.149 1210.67 374.29 1212.09 374.29C1213.52 374.29 1214.69 373.136 1214.69 371.71C1214.69 370.284 1213.53 369.117 1212.09 369.117Z"
            fill="white"
          />
          <path
            d="M1204.58 375.729C1203.19 375.729 1202.05 376.862 1202.05 378.258C1202.05 379.654 1203.19 380.787 1204.58 380.787C1205.98 380.787 1207.11 379.654 1207.11 378.258C1207.11 376.862 1205.98 375.729 1204.58 375.729Z"
            fill="white"
          />
          <path
            d="M1198.48 384.301C1197.13 384.301 1196.04 385.396 1196.04 386.745C1196.04 388.095 1197.13 389.181 1198.48 389.181C1199.83 389.181 1200.92 388.086 1200.92 386.745C1200.92 385.404 1199.82 384.301 1198.48 384.301Z"
            fill="white"
          />
          <path
            d="M1193.76 394.889C1192.44 394.889 1191.36 395.962 1191.36 397.291C1191.36 398.619 1192.44 399.684 1193.76 399.684C1195.08 399.684 1196.15 398.61 1196.15 397.291C1196.15 395.971 1195.08 394.889 1193.76 394.889Z"
            fill="white"
          />
          <path
            d="M1190.4 407.535C1189.11 407.535 1188.05 408.588 1188.05 409.886C1188.05 411.185 1189.11 412.229 1190.4 412.229C1191.69 412.229 1192.75 411.176 1192.75 409.886C1192.75 408.596 1191.69 407.535 1190.4 407.535Z"
            fill="white"
          />
          <path
            d="M1188.02 421.969C1186.76 421.969 1185.75 422.987 1185.75 424.248C1185.75 425.508 1186.76 426.539 1188.02 426.539C1189.29 426.539 1190.31 425.521 1190.31 424.248C1190.31 422.975 1189.28 421.969 1188.02 421.969Z"
            fill="white"
          />
          <path
            d="M1186.52 438.049C1185.3 438.049 1184.31 439.038 1184.31 440.264C1184.31 441.49 1185.3 442.471 1186.52 442.471C1187.74 442.471 1188.73 441.482 1188.73 440.264C1188.73 439.046 1187.74 438.049 1186.52 438.049Z"
            fill="white"
          />
          <path
            d="M1185.5 455.451C1184.3 455.451 1183.33 456.431 1183.33 457.628C1183.33 458.825 1184.3 459.793 1185.5 459.793C1186.69 459.793 1187.67 458.825 1187.67 457.628C1187.67 456.431 1186.69 455.451 1185.5 455.451Z"
            fill="white"
          />
          <path
            d="M1184.68 473.988C1183.51 473.988 1182.56 474.947 1182.56 476.11C1182.56 477.273 1183.52 478.245 1184.68 478.245C1185.84 478.245 1186.82 477.286 1186.82 476.11C1186.82 474.935 1185.86 473.988 1184.68 473.988Z"
            fill="white"
          />
          <path
            d="M1183.86 493.463C1182.71 493.463 1181.78 494.388 1181.78 495.542C1181.78 496.697 1182.71 497.626 1183.86 497.626C1185.02 497.626 1185.94 496.701 1185.94 495.542C1185.94 494.384 1185.02 493.463 1183.86 493.463Z"
            fill="white"
          />
          <path
            d="M1182.82 513.672C1181.69 513.672 1180.78 514.576 1180.78 515.7C1180.78 516.825 1181.69 517.742 1182.82 517.742C1183.94 517.742 1184.86 516.838 1184.86 515.7C1184.86 514.563 1183.94 513.672 1182.82 513.672Z"
            fill="white"
          />
          <path
            d="M1181.48 534.436C1180.37 534.436 1179.49 535.331 1179.49 536.434C1179.49 537.538 1180.37 538.433 1181.48 538.433C1182.58 538.433 1183.48 537.538 1183.48 536.434C1183.48 535.331 1182.58 534.436 1181.48 534.436Z"
            fill="white"
          />
          <path
            d="M1179.84 555.615C1178.76 555.615 1177.88 556.498 1177.88 557.58C1177.88 558.662 1178.76 559.558 1179.84 559.558C1180.93 559.558 1181.82 558.675 1181.82 557.58C1181.82 556.485 1180.94 555.615 1179.84 555.615Z"
            fill="white"
          />
          <path
            d="M1177.85 576.932C1176.77 576.932 1175.9 577.806 1175.9 578.88C1175.9 579.953 1176.77 580.836 1177.85 580.836C1178.92 580.836 1179.79 579.962 1179.79 578.88C1179.79 577.797 1178.92 576.932 1177.85 576.932Z"
            fill="white"
          />
          <path
            d="M1175.67 598.309C1174.61 598.309 1173.76 599.162 1173.76 600.214C1173.76 601.266 1174.61 602.119 1175.67 602.119C1176.72 602.119 1177.57 601.266 1177.57 600.214C1177.57 599.162 1176.72 598.309 1175.67 598.309Z"
            fill="white"
          />
          <path
            d="M1173.24 619.322C1172.19 619.322 1171.35 620.175 1171.35 621.228C1171.35 622.28 1172.2 623.12 1173.24 623.12C1174.29 623.12 1175.15 622.267 1175.15 621.228C1175.15 620.188 1174.3 619.322 1173.24 619.322Z"
            fill="white"
          />
          <path
            d="M1170.61 639.797C1169.57 639.797 1168.73 640.641 1168.73 641.681C1168.73 642.721 1169.57 643.574 1170.61 643.574C1171.65 643.574 1172.5 642.721 1172.5 641.681C1172.5 640.641 1171.65 639.797 1170.61 639.797Z"
            fill="white"
          />
          <path
            d="M1167.7 663.265C1168.73 663.265 1169.56 662.431 1169.56 661.402C1169.56 660.373 1168.73 659.539 1167.7 659.539C1166.67 659.539 1165.83 660.373 1165.83 661.402C1165.83 662.431 1166.67 663.265 1167.7 663.265Z"
            fill="white"
          />
          <path
            d="M1164.77 678.609C1163.74 678.609 1162.91 679.433 1162.91 680.46C1162.91 681.487 1163.74 682.314 1164.77 682.314C1165.8 682.314 1166.62 681.482 1166.62 680.46C1166.62 679.437 1165.79 678.609 1164.77 678.609Z"
            fill="white"
          />
          <path
            d="M1443.86 305.215C1441.92 305.215 1440.35 306.785 1440.35 308.724C1440.35 310.664 1441.92 312.242 1443.86 312.242C1445.79 312.242 1447.38 310.672 1447.38 308.724C1447.38 306.777 1445.81 305.215 1443.86 305.215Z"
            fill="white"
          />
          <path
            d="M1428.52 310.273C1426.63 310.273 1425.08 311.814 1425.08 313.707C1425.08 315.599 1426.63 317.153 1428.52 317.153C1430.41 317.153 1431.96 315.612 1431.96 313.707C1431.96 311.801 1430.42 310.273 1428.52 310.273Z"
            fill="white"
          />
          <path
            d="M1415.71 321.704C1417.04 320.38 1417.04 318.233 1415.71 316.909C1414.39 315.585 1412.24 315.585 1410.92 316.909C1409.59 318.233 1409.59 320.38 1410.92 321.704C1412.24 323.028 1414.39 323.028 1415.71 321.704Z"
            fill="white"
          />
          <path
            d="M1398.22 321.939C1396.37 321.939 1394.87 323.437 1394.87 325.279C1394.87 327.121 1396.37 328.632 1398.22 328.632C1400.08 328.632 1401.56 327.134 1401.56 325.279C1401.56 323.425 1400.06 321.939 1398.22 321.939Z"
            fill="white"
          />
          <path
            d="M1383.14 328.123C1381.32 328.123 1379.85 329.6 1379.85 331.412C1379.85 333.224 1381.32 334.701 1383.14 334.701C1384.96 334.701 1386.43 333.233 1386.43 331.412C1386.43 329.591 1384.95 328.123 1383.14 328.123Z"
            fill="white"
          />
          <path
            d="M1368.11 334.178C1366.34 334.178 1364.91 335.612 1364.91 337.382C1364.91 339.151 1366.35 340.586 1368.11 340.586C1369.88 340.586 1371.32 339.151 1371.32 337.382C1371.32 335.612 1369.88 334.178 1368.11 334.178Z"
            fill="white"
          />
          <path
            d="M1353.13 339.852C1351.4 339.852 1349.98 341.256 1349.98 343.005C1349.98 344.753 1351.4 346.158 1353.13 346.158C1354.87 346.158 1356.28 344.74 1356.28 343.005C1356.28 341.269 1354.87 339.852 1353.13 339.852Z"
            fill="white"
          />
          <path
            d="M1338.22 345.098C1336.5 345.098 1335.11 346.481 1335.11 348.2C1335.11 349.919 1336.51 351.302 1338.22 351.302C1339.93 351.302 1341.32 349.906 1341.32 348.2C1341.32 346.494 1339.93 345.098 1338.22 345.098Z"
            fill="white"
          />
          <path
            d="M1323.39 349.77C1321.7 349.77 1320.34 351.132 1320.34 352.821C1320.34 354.51 1321.7 355.872 1323.39 355.872C1325.08 355.872 1326.44 354.497 1326.44 352.821C1326.44 351.145 1325.08 349.77 1323.39 349.77Z"
            fill="white"
          />
          <path
            d="M1308.87 353.934C1307.24 353.934 1305.91 355.266 1305.91 356.9C1305.91 358.534 1307.24 359.854 1308.87 359.854C1310.5 359.854 1311.83 358.521 1311.83 356.9C1311.83 355.279 1310.5 353.934 1308.87 353.934Z"
            fill="white"
          />
          <path
            d="M1294.79 357.65C1293.18 357.65 1291.87 358.962 1291.87 360.566C1291.87 362.17 1293.18 363.481 1294.79 363.481C1296.4 363.481 1297.69 362.17 1297.69 360.566C1297.69 358.962 1296.39 357.65 1294.79 357.65Z"
            fill="white"
          />
          <path
            d="M1281.21 361.055C1279.63 361.055 1278.36 362.324 1278.36 363.907C1278.36 365.489 1279.63 366.75 1281.21 366.75C1282.8 366.75 1284.06 365.481 1284.06 363.907C1284.06 362.332 1282.79 361.055 1281.21 361.055Z"
            fill="white"
          />
          <path
            d="M1268.34 364.301C1266.79 364.301 1265.54 365.561 1265.54 367.102C1265.54 368.642 1266.79 369.903 1268.34 369.903C1269.9 369.903 1271.13 368.642 1271.13 367.102C1271.13 365.561 1269.88 364.301 1268.34 364.301Z"
            fill="white"
          />
          <path
            d="M1256.38 367.826C1254.89 367.826 1253.68 369.044 1253.68 370.534C1253.68 372.023 1254.89 373.241 1256.38 373.241C1257.87 373.241 1259.09 372.023 1259.09 370.534C1259.09 369.044 1257.87 367.826 1256.38 367.826Z"
            fill="white"
          />
          <path
            d="M1245.51 371.896C1244.06 371.896 1242.87 373.085 1242.87 374.54C1242.87 375.996 1244.06 377.193 1245.51 377.193C1246.97 377.193 1248.17 376.004 1248.17 374.54C1248.17 373.076 1246.98 371.896 1245.51 371.896Z"
            fill="white"
          />
          <path
            d="M1235.85 376.883C1234.41 376.883 1233.25 378.05 1233.25 379.476C1233.25 380.902 1234.41 382.056 1235.85 382.056C1237.29 382.056 1238.43 380.902 1238.43 379.476C1238.43 378.05 1237.27 376.883 1235.85 376.883Z"
            fill="white"
          />
          <path
            d="M1227.5 388.217C1228.9 388.217 1230.03 387.084 1230.03 385.687C1230.03 384.291 1228.9 383.158 1227.5 383.158C1226.1 383.158 1224.97 384.291 1224.97 385.687C1224.97 387.084 1226.1 388.217 1227.5 388.217Z"
            fill="white"
          />
          <path
            d="M1220.41 391.016C1219.05 391.016 1217.96 392.119 1217.96 393.473C1217.96 394.827 1219.05 395.93 1220.41 395.93C1221.78 395.93 1222.87 394.827 1222.87 393.473C1222.87 392.119 1221.77 391.016 1220.41 391.016Z"
            fill="white"
          />
          <path
            d="M1214.47 400.561C1213.15 400.561 1212.08 401.634 1212.08 402.954C1212.08 404.274 1213.15 405.347 1214.47 405.347C1215.79 405.347 1216.87 404.274 1216.87 402.954C1216.87 401.634 1215.79 400.561 1214.47 400.561Z"
            fill="white"
          />
          <path
            d="M1209.8 411.895C1208.51 411.895 1207.45 412.934 1207.45 414.237C1207.45 415.54 1208.51 416.567 1209.8 416.567C1211.09 416.567 1212.13 415.527 1212.13 414.237C1212.13 412.947 1211.09 411.895 1209.8 411.895Z"
            fill="white"
          />
          <path
            d="M1206.06 424.854C1204.79 424.854 1203.77 425.872 1203.77 427.145C1203.77 428.418 1204.79 429.437 1206.06 429.437C1207.33 429.437 1208.35 428.418 1208.35 427.145C1208.35 425.872 1207.33 424.854 1206.06 424.854Z"
            fill="white"
          />
          <path
            d="M1203.15 439.338C1201.92 439.338 1200.92 440.335 1200.92 441.566C1200.92 442.797 1201.92 443.781 1203.15 443.781C1204.38 443.781 1205.36 442.792 1205.36 441.566C1205.36 440.339 1204.36 439.338 1203.15 439.338Z"
            fill="white"
          />
          <path
            d="M1200.82 455.172C1199.63 455.172 1198.65 456.152 1198.65 457.349C1198.65 458.546 1199.63 459.526 1200.82 459.526C1202.02 459.526 1203 458.546 1203 457.349C1203 456.152 1202.02 455.172 1200.82 455.172Z"
            fill="white"
          />
          <path
            d="M1198.75 472.092C1197.58 472.092 1196.62 473.038 1196.62 474.214C1196.62 475.389 1197.58 476.348 1198.75 476.348C1199.93 476.348 1200.88 475.389 1200.88 474.214C1200.88 473.038 1199.93 472.092 1198.75 472.092Z"
            fill="white"
          />
          <path
            d="M1196.88 490.018C1195.71 490.018 1194.78 490.955 1194.78 492.11C1194.78 493.264 1195.72 494.202 1196.88 494.202C1198.04 494.202 1198.97 493.264 1198.97 492.11C1198.97 490.955 1198.04 490.018 1196.88 490.018Z"
            fill="white"
          />
          <path
            d="M1194.85 508.705C1193.72 508.705 1192.82 509.609 1192.82 510.734C1192.82 511.858 1193.72 512.762 1194.85 512.762C1195.97 512.762 1196.88 511.858 1196.88 510.734C1196.88 509.609 1195.97 508.705 1194.85 508.705Z"
            fill="white"
          />
          <path
            d="M1192.68 527.996C1191.57 527.996 1190.68 528.892 1190.68 530.003C1190.68 531.115 1191.57 532.011 1192.68 532.011C1193.8 532.011 1194.69 531.115 1194.69 530.003C1194.69 528.892 1193.79 527.996 1192.68 527.996Z"
            fill="white"
          />
          <path
            d="M1190.26 547.74C1189.17 547.74 1188.29 548.623 1188.29 549.705C1188.29 550.787 1189.17 551.67 1190.26 551.67C1191.35 551.67 1192.22 550.787 1192.22 549.705C1192.22 548.623 1191.34 547.74 1190.26 547.74Z"
            fill="white"
          />
          <path
            d="M1187.64 567.783C1186.56 567.783 1185.69 568.649 1185.69 569.718C1185.69 570.788 1186.56 571.666 1187.64 571.666C1188.71 571.666 1189.57 570.792 1189.57 569.718C1189.57 568.645 1188.71 567.783 1187.64 567.783Z"
            fill="white"
          />
          <path
            d="M1184.83 587.934C1183.77 587.934 1182.92 588.787 1182.92 589.848C1182.92 590.908 1183.77 591.761 1184.83 591.761C1185.89 591.761 1186.74 590.908 1186.74 589.848C1186.74 588.787 1185.89 587.934 1184.83 587.934Z"
            fill="white"
          />
          <path
            d="M1181.91 608.023C1180.86 608.023 1180.02 608.868 1180.02 609.916C1180.02 610.964 1180.86 611.809 1181.91 611.809C1182.96 611.809 1183.8 610.956 1183.8 609.916C1183.8 608.876 1182.95 608.023 1181.91 608.023Z"
            fill="white"
          />
          <path
            d="M1178.88 627.75C1177.84 627.75 1177 628.595 1177 629.622C1177 630.648 1177.84 631.506 1178.88 631.506C1179.92 631.506 1180.77 630.661 1180.77 629.622C1180.77 628.582 1179.92 627.75 1178.88 627.75Z"
            fill="white"
          />
          <path
            d="M1175.67 646.916C1174.64 646.916 1173.8 647.748 1173.8 648.779C1173.8 649.81 1174.64 650.655 1175.67 650.655C1176.7 650.655 1177.54 649.823 1177.54 648.779C1177.54 647.735 1176.71 646.916 1175.67 646.916Z"
            fill="white"
          />
          <path
            d="M1172.39 665.484C1171.37 665.484 1170.54 666.316 1170.54 667.335C1170.54 668.353 1171.37 669.189 1172.39 669.189C1173.41 669.189 1174.24 668.357 1174.24 667.335C1174.24 666.312 1173.41 665.484 1172.39 665.484Z"
            fill="white"
          />
          <path
            d="M1451.43 313.104C1449.52 313.104 1447.98 314.652 1447.98 316.558C1447.98 318.463 1449.52 320.004 1451.43 320.004C1453.33 320.004 1454.87 318.455 1454.87 316.558C1454.87 314.661 1453.33 313.104 1451.43 313.104Z"
            fill="white"
          />
          <path
            d="M1436.43 317.805C1434.55 317.805 1433.03 319.324 1433.03 321.195C1433.03 323.067 1434.55 324.59 1436.43 324.59C1438.3 324.59 1439.82 323.071 1439.82 321.195C1439.82 319.32 1438.3 317.805 1436.43 317.805Z"
            fill="white"
          />
          <path
            d="M1421.46 322.918C1419.61 322.918 1418.12 324.408 1418.12 326.258C1418.12 328.108 1419.61 329.598 1421.46 329.598C1423.31 329.598 1424.8 328.1 1424.8 326.258C1424.8 324.416 1423.3 322.918 1421.46 322.918Z"
            fill="white"
          />
          <path
            d="M1406.64 328.539C1404.83 328.539 1403.36 330.007 1403.36 331.819C1403.36 333.632 1404.83 335.1 1406.64 335.1C1408.45 335.1 1409.92 333.632 1409.92 331.819C1409.92 330.007 1408.45 328.539 1406.64 328.539Z"
            fill="white"
          />
          <path
            d="M1392 334.428C1390.23 334.428 1388.79 335.862 1388.79 337.632C1388.79 339.401 1390.23 340.836 1392 340.836C1393.76 340.836 1395.21 339.401 1395.21 337.632C1395.21 335.862 1393.78 334.428 1392 334.428Z"
            fill="white"
          />
          <path
            d="M1377.52 340.352C1375.77 340.352 1374.35 341.769 1374.35 343.505C1374.35 345.24 1375.77 346.666 1377.52 346.666C1379.27 346.666 1380.67 345.249 1380.67 343.505C1380.67 341.76 1379.26 340.352 1377.52 340.352Z"
            fill="white"
          />
          <path
            d="M1363.1 346.086C1361.39 346.086 1360 347.482 1360 349.197C1360 350.911 1361.39 352.299 1363.1 352.299C1364.82 352.299 1366.21 350.903 1366.21 349.197C1366.21 347.491 1364.82 346.086 1363.1 346.086Z"
            fill="white"
          />
          <path
            d="M1348.75 351.539C1347.07 351.539 1345.72 352.901 1345.72 354.578C1345.72 356.254 1347.07 357.629 1348.75 357.629C1350.44 357.629 1351.79 356.267 1351.79 354.578C1351.79 352.889 1350.43 351.539 1348.75 351.539Z"
            fill="white"
          />
          <path
            d="M1334.64 356.691C1332.99 356.691 1331.67 358.024 1331.67 359.658C1331.67 361.292 1332.99 362.624 1334.64 362.624C1336.28 362.624 1337.6 361.3 1337.6 359.658C1337.6 358.015 1336.27 356.691 1334.64 356.691Z"
            fill="white"
          />
          <path
            d="M1320.82 361.479C1319.2 361.479 1317.9 362.781 1317.9 364.381C1317.9 365.981 1319.2 367.284 1320.82 367.284C1322.43 367.284 1323.72 365.981 1323.72 364.381C1323.72 362.781 1322.42 361.479 1320.82 361.479Z"
            fill="white"
          />
          <path
            d="M1307.33 365.963C1305.76 365.963 1304.49 367.232 1304.49 368.806C1304.49 370.381 1305.76 371.65 1307.33 371.65C1308.91 371.65 1310.17 370.381 1310.17 368.806C1310.17 367.232 1308.91 365.963 1307.33 365.963Z"
            fill="white"
          />
          <path
            d="M1294.39 370.314C1292.85 370.314 1291.6 371.562 1291.6 373.103C1291.6 374.643 1292.85 375.891 1294.39 375.891C1295.93 375.891 1297.18 374.643 1297.18 373.103C1297.18 371.562 1295.93 370.314 1294.39 370.314Z"
            fill="white"
          />
          <path
            d="M1282.19 374.762C1280.7 374.762 1279.49 375.971 1279.49 377.469C1279.49 378.967 1280.7 380.164 1282.19 380.164C1283.69 380.164 1284.89 378.955 1284.89 377.469C1284.89 375.984 1283.68 374.762 1282.19 374.762Z"
            fill="white"
          />
          <path
            d="M1270.79 379.434C1269.32 379.434 1268.13 380.622 1268.13 382.086C1268.13 383.55 1269.32 384.738 1270.79 384.738C1272.25 384.738 1273.44 383.55 1273.44 382.086C1273.44 380.622 1272.25 379.434 1270.79 379.434Z"
            fill="white"
          />
          <path
            d="M1260.27 384.666C1258.83 384.666 1257.67 385.833 1257.67 387.267C1257.67 388.702 1258.83 389.86 1260.27 389.86C1261.7 389.86 1262.86 388.693 1262.86 387.267C1262.86 385.842 1261.69 384.666 1260.27 384.666Z"
            fill="white"
          />
          <path
            d="M1250.94 390.877C1249.53 390.877 1248.4 392.01 1248.4 393.415C1248.4 394.819 1249.53 395.944 1250.94 395.944C1252.34 395.944 1253.47 394.811 1253.47 393.415C1253.47 392.019 1252.34 390.877 1250.94 390.877Z"
            fill="white"
          />
          <path
            d="M1242.81 398.352C1241.46 398.352 1240.37 399.442 1240.37 400.796C1240.37 402.15 1241.46 403.24 1242.81 403.24C1244.16 403.24 1245.26 402.145 1245.26 400.796C1245.26 399.446 1244.16 398.352 1242.81 398.352Z"
            fill="white"
          />
          <path
            d="M1235.74 407.115C1234.42 407.115 1233.35 408.176 1233.35 409.5C1233.35 410.824 1234.42 411.894 1235.74 411.894C1237.06 411.894 1238.14 410.82 1238.14 409.5C1238.14 408.18 1237.06 407.115 1235.74 407.115Z"
            fill="white"
          />
          <path
            d="M1229.8 417.348C1228.5 417.348 1227.46 418.4 1227.46 419.69C1227.46 420.98 1228.5 422.033 1229.8 422.033C1231.1 422.033 1232.14 420.98 1232.14 419.69C1232.14 418.4 1231.09 417.348 1229.8 417.348Z"
            fill="white"
          />
          <path
            d="M1224.73 428.975C1223.47 428.975 1222.44 430.006 1222.44 431.262C1222.44 432.518 1223.47 433.554 1224.73 433.554C1225.99 433.554 1227.03 432.535 1227.03 431.262C1227.03 429.989 1225.99 428.975 1224.73 428.975Z"
            fill="white"
          />
          <path
            d="M1220.39 441.943C1219.17 441.943 1218.18 442.941 1218.18 444.159C1218.18 445.377 1219.17 446.374 1220.39 446.374C1221.61 446.374 1222.61 445.377 1222.61 444.159C1222.61 442.941 1221.62 441.943 1220.39 441.943Z"
            fill="white"
          />
          <path
            d="M1216.78 456.219C1215.58 456.219 1214.6 457.186 1214.6 458.383C1214.6 459.58 1215.58 460.56 1216.78 460.56C1217.98 460.56 1218.94 459.58 1218.94 458.383C1218.94 457.186 1217.98 456.219 1216.78 456.219Z"
            fill="white"
          />
          <path
            d="M1213.5 471.561C1212.32 471.561 1211.38 472.52 1211.38 473.695C1211.38 474.871 1212.32 475.817 1213.5 475.817C1214.68 475.817 1215.63 474.871 1215.63 473.695C1215.63 472.52 1214.68 471.561 1213.5 471.561Z"
            fill="white"
          />
          <path
            d="M1210.56 487.967C1209.4 487.967 1208.48 488.905 1208.48 490.046C1208.48 491.188 1209.4 492.138 1210.56 492.138C1211.71 492.138 1212.63 491.201 1212.63 490.046C1212.63 488.892 1211.71 487.967 1210.56 487.967Z"
            fill="white"
          />
          <path
            d="M1207.62 505.16C1206.5 505.16 1205.59 506.077 1205.59 507.201C1205.59 508.326 1206.5 509.23 1207.62 509.23C1208.75 509.23 1209.65 508.313 1209.65 507.201C1209.65 506.09 1208.73 505.16 1207.62 505.16Z"
            fill="white"
          />
          <path
            d="M1204.66 523.051C1203.56 523.051 1202.67 523.946 1202.67 525.058C1202.67 526.17 1203.56 527.057 1204.66 527.057C1205.77 527.057 1206.66 526.161 1206.66 525.058C1206.66 523.955 1205.77 523.051 1204.66 523.051Z"
            fill="white"
          />
          <path
            d="M1201.49 541.387C1200.39 541.387 1199.51 542.269 1199.51 543.364C1199.51 544.459 1200.39 545.342 1201.49 545.342C1202.58 545.342 1203.47 544.459 1203.47 543.364C1203.47 542.269 1202.58 541.387 1201.49 541.387Z"
            fill="white"
          />
          <path
            d="M1198.18 560.111C1197.11 560.111 1196.23 560.986 1196.23 562.068C1196.23 563.15 1197.11 564.016 1198.18 564.016C1199.25 564.016 1200.14 563.141 1200.14 562.068C1200.14 560.994 1199.26 560.111 1198.18 560.111Z"
            fill="white"
          />
          <path
            d="M1194.67 579.006C1193.62 579.006 1192.76 579.859 1192.76 580.92C1192.76 581.981 1193.63 582.825 1194.67 582.825C1195.72 582.825 1196.58 581.972 1196.58 580.92C1196.58 579.867 1195.73 579.006 1194.67 579.006Z"
            fill="white"
          />
          <path
            d="M1191.2 598.029C1190.16 598.029 1189.31 598.882 1189.31 599.922C1189.31 600.962 1190.16 601.815 1191.2 601.815C1192.24 601.815 1193.1 600.97 1193.1 599.922C1193.1 598.874 1192.25 598.029 1191.2 598.029Z"
            fill="white"
          />
          <path
            d="M1187.63 616.889C1186.59 616.889 1185.75 617.733 1185.75 618.773C1185.75 619.813 1186.59 620.649 1187.63 620.649C1188.67 620.649 1189.5 619.817 1189.5 618.773C1189.5 617.729 1188.67 616.889 1187.63 616.889Z"
            fill="white"
          />
          <path
            d="M1184.1 635.445C1183.07 635.445 1182.24 636.29 1182.24 637.317C1182.24 638.344 1183.07 639.18 1184.1 639.18C1185.13 639.18 1185.96 638.348 1185.96 637.317C1185.96 636.286 1185.13 635.445 1184.1 635.445Z"
            fill="white"
          />
          <path
            d="M1180.39 653.473C1179.36 653.473 1178.53 654.304 1178.53 655.336C1178.53 656.367 1179.36 657.186 1180.39 657.186C1181.43 657.186 1182.26 656.354 1182.26 655.336C1182.26 654.317 1181.43 653.473 1180.39 653.473Z"
            fill="white"
          />
          <path
            d="M1176.83 671.082C1175.82 671.082 1174.99 671.905 1174.99 672.924C1174.99 673.942 1175.82 674.778 1176.83 674.778C1177.85 674.778 1178.68 673.955 1178.68 672.924C1178.68 671.893 1177.86 671.082 1176.83 671.082Z"
            fill="white"
          />
          <path
            d="M1445.35 327.986C1443.5 327.986 1442.01 329.484 1442.01 331.326C1442.01 333.168 1443.5 334.666 1445.35 334.666C1447.2 334.666 1448.69 333.176 1448.69 331.326C1448.69 329.476 1447.19 327.986 1445.35 327.986Z"
            fill="white"
          />
          <path
            d="M1430.55 332.574C1428.73 332.574 1427.26 334.043 1427.26 335.863C1427.26 337.684 1428.73 339.152 1430.55 339.152C1432.37 339.152 1433.83 337.684 1433.83 335.863C1433.83 334.043 1432.37 332.574 1430.55 332.574Z"
            fill="white"
          />
          <path
            d="M1415.99 337.709C1414.22 337.709 1412.78 339.156 1412.78 340.926C1412.78 342.695 1414.22 344.142 1415.99 344.142C1417.76 344.142 1419.2 342.708 1419.2 340.926C1419.2 339.143 1417.76 337.709 1415.99 337.709Z"
            fill="white"
          />
          <path
            d="M1401.7 343.234C1399.96 343.234 1398.54 344.652 1398.54 346.387C1398.54 348.123 1399.96 349.553 1401.7 349.553C1403.43 349.553 1404.86 348.136 1404.86 346.387C1404.86 344.639 1403.45 343.234 1401.7 343.234Z"
            fill="white"
          />
          <path
            d="M1387.57 348.924C1385.86 348.924 1384.47 350.307 1384.47 352.026C1384.47 353.745 1385.86 355.115 1387.57 355.115C1389.29 355.115 1390.66 353.732 1390.66 352.026C1390.66 350.32 1389.28 348.924 1387.57 348.924Z"
            fill="white"
          />
          <path
            d="M1373.57 354.621C1371.88 354.621 1370.51 355.983 1370.51 357.672C1370.51 359.361 1371.88 360.724 1373.57 360.724C1375.25 360.724 1376.62 359.361 1376.62 357.672C1376.62 355.983 1375.24 354.621 1373.57 354.621Z"
            fill="white"
          />
          <path
            d="M1359.76 360.262C1358.13 360.262 1356.81 361.586 1356.81 363.22C1356.81 364.853 1358.13 366.186 1359.76 366.186C1361.4 366.186 1362.73 364.853 1362.73 363.22C1362.73 361.586 1361.4 360.262 1359.76 360.262Z"
            fill="white"
          />
          <path
            d="M1346.19 365.691C1344.59 365.691 1343.29 366.994 1343.29 368.607C1343.29 370.22 1344.59 371.51 1346.19 371.51C1347.79 371.51 1349.1 370.207 1349.1 368.607C1349.1 367.007 1347.79 365.691 1346.19 365.691Z"
            fill="white"
          />
          <path
            d="M1332.86 370.973C1331.29 370.973 1330.01 372.242 1330.01 373.816C1330.01 375.39 1331.29 376.668 1332.86 376.668C1334.43 376.668 1335.7 375.386 1335.7 373.816C1335.7 372.246 1334.42 370.973 1332.86 370.973Z"
            fill="white"
          />
          <path
            d="M1319.91 376.123C1318.37 376.123 1317.11 377.371 1317.11 378.924C1317.11 380.477 1318.37 381.712 1319.91 381.712C1321.45 381.712 1322.7 380.464 1322.7 378.924C1322.7 377.383 1321.45 376.123 1319.91 376.123Z"
            fill="white"
          />
          <path
            d="M1307.52 381.326C1306.03 381.326 1304.81 382.544 1304.81 384.034C1304.81 385.523 1306.03 386.741 1307.52 386.741C1309.01 386.741 1310.22 385.532 1310.22 384.034C1310.22 382.536 1309.01 381.326 1307.52 381.326Z"
            fill="white"
          />
          <path
            d="M1295.76 386.664C1294.29 386.664 1293.11 387.852 1293.11 389.316C1293.11 390.78 1294.29 391.969 1295.76 391.969C1297.22 391.969 1298.41 390.78 1298.41 389.316C1298.41 387.852 1297.22 386.664 1295.76 386.664Z"
            fill="white"
          />
          <path
            d="M1284.7 392.381C1283.28 392.381 1282.11 393.548 1282.11 394.974C1282.11 396.4 1283.28 397.567 1284.7 397.567C1286.13 397.567 1287.3 396.412 1287.3 394.974C1287.3 393.535 1286.13 392.381 1284.7 392.381Z"
            fill="white"
          />
          <path
            d="M1274.58 398.738C1273.19 398.738 1272.06 399.871 1272.06 401.268C1272.06 402.664 1273.19 403.797 1274.58 403.797C1275.98 403.797 1277.11 402.664 1277.11 401.268C1277.11 399.871 1275.98 398.738 1274.58 398.738Z"
            fill="white"
          />
          <path
            d="M1265.41 405.918C1264.05 405.918 1262.96 407.013 1262.96 408.362C1262.96 409.712 1264.05 410.798 1265.41 410.798C1266.76 410.798 1267.84 409.703 1267.84 408.362C1267.84 407.021 1266.75 405.918 1265.41 405.918Z"
            fill="white"
          />
          <path
            d="M1257.16 414.051C1255.84 414.051 1254.76 415.124 1254.76 416.444C1254.76 417.764 1255.84 418.85 1257.16 418.85C1258.49 418.85 1259.56 417.768 1259.56 416.444C1259.56 415.12 1258.48 414.051 1257.16 414.051Z"
            fill="white"
          />
          <path
            d="M1250 423.406C1248.71 423.406 1247.66 424.446 1247.66 425.736C1247.66 427.026 1248.71 428.079 1250 428.079C1251.29 428.079 1252.33 427.026 1252.33 425.736C1252.33 424.446 1251.29 423.406 1250 423.406Z"
            fill="white"
          />
          <path
            d="M1243.74 433.939C1242.48 433.939 1241.45 434.958 1241.45 436.231C1241.45 437.504 1242.48 438.51 1243.74 438.51C1244.99 438.51 1246.02 437.491 1246.02 436.231C1246.02 434.971 1245 433.939 1243.74 433.939Z"
            fill="white"
          />
          <path
            d="M1238.18 445.637C1236.95 445.637 1235.96 446.626 1235.96 447.843C1235.96 449.061 1236.95 450.05 1238.18 450.05C1239.4 450.05 1240.38 449.061 1240.38 447.843C1240.38 446.626 1239.4 445.637 1238.18 445.637Z"
            fill="white"
          />
          <path
            d="M1233.35 458.51C1232.15 458.51 1231.18 459.49 1231.18 460.674C1231.18 461.858 1232.15 462.838 1233.35 462.838C1234.55 462.838 1235.51 461.871 1235.51 460.674C1235.51 459.477 1234.55 458.51 1233.35 458.51Z"
            fill="white"
          />
          <path
            d="M1228.94 472.406C1227.77 472.406 1226.82 473.353 1226.82 474.528C1226.82 475.704 1227.78 476.65 1228.94 476.65C1230.1 476.65 1231.06 475.691 1231.06 474.528C1231.06 473.365 1230.11 472.406 1228.94 472.406Z"
            fill="white"
          />
          <path
            d="M1224.91 487.301C1223.76 487.301 1222.83 488.239 1222.83 489.38C1222.83 490.522 1223.77 491.46 1224.91 491.46C1226.05 491.46 1226.99 490.522 1226.99 489.38C1226.99 488.239 1226.07 487.301 1224.91 487.301Z"
            fill="white"
          />
          <path
            d="M1221.07 503.037C1219.94 503.037 1219.04 503.954 1219.04 505.078C1219.04 506.203 1219.94 507.107 1221.07 507.107C1222.19 507.107 1223.11 506.203 1223.11 505.078C1223.11 503.954 1222.19 503.037 1221.07 503.037Z"
            fill="white"
          />
          <path
            d="M1217.28 519.504C1216.18 519.504 1215.28 520.387 1215.28 521.49C1215.28 522.593 1216.18 523.489 1217.28 523.489C1218.38 523.489 1219.27 522.593 1219.27 521.49C1219.27 520.387 1218.37 519.504 1217.28 519.504Z"
            fill="white"
          />
          <path
            d="M1213.42 536.5C1212.32 536.5 1211.45 537.383 1211.45 538.465C1211.45 539.547 1212.32 540.434 1213.42 540.434C1214.51 540.434 1215.38 539.56 1215.38 538.465C1215.38 537.37 1214.5 536.5 1213.42 536.5Z"
            fill="white"
          />
          <path
            d="M1209.43 553.91C1208.36 553.91 1207.48 554.784 1207.48 555.858C1207.48 556.932 1208.36 557.806 1209.43 557.806C1210.5 557.806 1211.38 556.932 1211.38 555.858C1211.38 554.784 1210.5 553.91 1209.43 553.91Z"
            fill="white"
          />
          <path
            d="M1205.31 571.602C1204.26 571.602 1203.4 572.455 1203.4 573.515C1203.4 574.576 1204.26 575.429 1205.31 575.429C1206.36 575.429 1207.24 574.576 1207.24 573.515C1207.24 572.455 1206.37 571.602 1205.31 571.602Z"
            fill="white"
          />
          <path
            d="M1201.14 589.443C1200.1 589.443 1199.25 590.288 1199.25 591.336C1199.25 592.384 1200.1 593.229 1201.14 593.229C1202.18 593.229 1203.04 592.376 1203.04 591.336C1203.04 590.296 1202.19 589.443 1201.14 589.443Z"
            fill="white"
          />
          <path
            d="M1197.03 607.344C1195.99 607.344 1195.14 608.188 1195.14 609.228C1195.14 610.268 1195.99 611.112 1197.03 611.112C1198.07 611.112 1198.91 610.268 1198.91 609.228C1198.91 608.188 1198.07 607.344 1197.03 607.344Z"
            fill="white"
          />
          <path
            d="M1192.95 625.113C1191.91 625.113 1191.07 625.958 1191.07 626.989C1191.07 628.02 1191.9 628.86 1192.95 628.86C1193.99 628.86 1194.81 628.016 1194.81 626.989C1194.81 625.962 1193.98 625.113 1192.95 625.113Z"
            fill="white"
          />
          <path
            d="M1188.94 642.627C1187.92 642.627 1187.09 643.459 1187.09 644.481C1187.09 645.504 1187.92 646.332 1188.94 646.332C1189.96 646.332 1190.79 645.5 1190.79 644.481C1190.79 643.463 1189.96 642.627 1188.94 642.627Z"
            fill="white"
          />
          <path
            d="M1184.88 659.717C1183.86 659.717 1183.04 660.54 1183.04 661.559C1183.04 662.577 1183.86 663.413 1184.88 663.413C1185.9 663.413 1186.74 662.581 1186.74 661.559C1186.74 660.536 1185.9 659.717 1184.88 659.717Z"
            fill="white"
          />
          <path
            d="M1181.07 676.527C1180.05 676.527 1179.23 677.351 1179.23 678.369C1179.23 679.388 1180.05 680.224 1181.07 680.224C1182.09 680.224 1182.92 679.392 1182.92 678.369C1182.92 677.346 1182.09 676.527 1181.07 676.527Z"
            fill="white"
          />
          <path
            d="M1440.66 345.291C1438.89 345.291 1437.46 346.738 1437.46 348.508C1437.46 350.277 1438.89 351.725 1440.66 351.725C1442.43 351.725 1443.88 350.286 1443.88 348.508C1443.88 346.73 1442.45 345.291 1440.66 345.291Z"
            fill="white"
          />
          <path
            d="M1426.27 349.854C1424.53 349.854 1423.12 351.258 1423.12 353.007C1423.12 354.755 1424.53 356.16 1426.27 356.16C1428 356.16 1429.42 354.742 1429.42 353.007C1429.42 351.271 1428 349.854 1426.27 349.854Z"
            fill="white"
          />
          <path
            d="M1412.12 354.879C1410.4 354.879 1409 356.275 1409 357.99C1409 359.704 1410.4 361.092 1412.12 361.092C1413.83 361.092 1415.23 359.708 1415.23 357.99C1415.23 356.271 1413.83 354.879 1412.12 354.879Z"
            fill="white"
          />
          <path
            d="M1398.16 360.217C1396.47 360.217 1395.11 361.579 1395.11 363.268C1395.11 364.957 1396.47 366.319 1398.16 366.319C1399.85 366.319 1401.2 364.944 1401.2 363.268C1401.2 361.592 1399.83 360.217 1398.16 360.217Z"
            fill="white"
          />
          <path
            d="M1384.46 365.787C1382.83 365.787 1381.51 367.111 1381.51 368.745C1381.51 370.379 1382.83 371.711 1384.46 371.711C1386.09 371.711 1387.43 370.379 1387.43 368.745C1387.43 367.111 1386.09 365.787 1384.46 365.787Z"
            fill="white"
          />
          <path
            d="M1371 371.408C1369.4 371.408 1368.09 372.711 1368.09 374.311C1368.09 375.911 1369.4 377.226 1371 377.226C1372.61 377.226 1373.92 375.924 1373.92 374.311C1373.92 372.698 1372.61 371.408 1371 371.408Z"
            fill="white"
          />
          <path
            d="M1357.72 377.006C1356.15 377.006 1354.88 378.275 1354.88 379.858C1354.88 381.441 1356.15 382.701 1357.72 382.701C1359.3 382.701 1360.58 381.432 1360.58 379.858C1360.58 378.283 1359.31 377.006 1357.72 377.006Z"
            fill="white"
          />
          <path
            d="M1344.75 382.586C1343.2 382.586 1341.96 383.834 1341.96 385.374C1341.96 386.915 1343.2 388.162 1344.75 388.162C1346.29 388.162 1347.55 386.915 1347.55 385.374C1347.55 383.834 1346.3 382.586 1344.75 382.586Z"
            fill="white"
          />
          <path
            d="M1332.22 388.277C1330.72 388.277 1329.51 389.487 1329.51 390.985C1329.51 392.483 1330.72 393.68 1332.22 393.68C1333.71 393.68 1334.91 392.47 1334.91 390.985C1334.91 389.5 1333.7 388.277 1332.22 388.277Z"
            fill="white"
          />
          <path
            d="M1320.15 394.096C1318.7 394.096 1317.51 395.271 1317.51 396.74C1317.51 398.208 1318.7 399.383 1320.15 399.383C1321.61 399.383 1322.79 398.195 1322.79 396.74C1322.79 395.284 1321.61 394.096 1320.15 394.096Z"
            fill="white"
          />
          <path
            d="M1308.64 400.143C1307.21 400.143 1306.06 401.297 1306.06 402.723C1306.06 404.149 1307.21 405.303 1308.64 405.303C1310.07 405.303 1311.22 404.149 1311.22 402.723C1311.22 401.297 1310.07 400.143 1308.64 400.143Z"
            fill="white"
          />
          <path
            d="M1297.89 406.629C1296.49 406.629 1295.36 407.762 1295.36 409.158C1295.36 410.554 1296.49 411.687 1297.89 411.687C1299.28 411.687 1300.42 410.554 1300.42 409.158C1300.42 407.762 1299.28 406.629 1297.89 406.629Z"
            fill="white"
          />
          <path
            d="M1287.93 413.715C1286.59 413.715 1285.48 414.818 1285.48 416.159C1285.48 417.5 1286.59 418.604 1287.93 418.604C1289.27 418.604 1290.38 417.513 1290.38 416.159C1290.38 414.805 1289.28 413.715 1287.93 413.715Z"
            fill="white"
          />
          <path
            d="M1278.73 421.445C1277.42 421.445 1276.34 422.519 1276.34 423.839C1276.34 425.159 1277.42 426.224 1278.73 426.224C1280.04 426.224 1281.12 425.163 1281.12 423.839C1281.12 422.515 1280.05 421.445 1278.73 421.445Z"
            fill="white"
          />
          <path
            d="M1270.42 430.045C1269.13 430.045 1268.08 431.085 1268.08 432.375C1268.08 433.665 1269.13 434.717 1270.42 434.717C1271.71 434.717 1272.75 433.665 1272.75 432.375C1272.75 431.085 1271.71 430.045 1270.42 430.045Z"
            fill="white"
          />
          <path
            d="M1262.98 439.602C1261.71 439.602 1260.69 440.633 1260.69 441.893C1260.69 443.154 1261.71 444.185 1262.98 444.185C1264.26 444.185 1265.26 443.154 1265.26 441.893C1265.26 440.633 1264.24 439.602 1262.98 439.602Z"
            fill="white"
          />
          <path
            d="M1256.27 450.164C1255.04 450.164 1254.05 451.153 1254.05 452.379C1254.05 453.606 1255.04 454.586 1256.27 454.586C1257.5 454.586 1258.48 453.597 1258.48 452.379C1258.48 451.161 1257.49 450.164 1256.27 450.164Z"
            fill="white"
          />
          <path
            d="M1250.34 461.799C1249.14 461.799 1248.17 462.779 1248.17 463.976C1248.17 465.173 1249.14 466.14 1250.34 466.14C1251.53 466.14 1252.51 465.173 1252.51 463.976C1252.51 462.779 1251.53 461.799 1250.34 461.799Z"
            fill="white"
          />
          <path
            d="M1244.94 474.426C1243.77 474.426 1242.82 475.372 1242.82 476.548C1242.82 477.723 1243.77 478.682 1244.94 478.682C1246.12 478.682 1247.06 477.723 1247.06 476.548C1247.06 475.372 1246.12 474.426 1244.94 474.426Z"
            fill="white"
          />
          <path
            d="M1239.94 487.967C1238.78 487.967 1237.86 488.892 1237.86 490.046C1237.86 491.201 1238.78 492.126 1239.94 492.126C1241.09 492.126 1242.02 491.201 1242.02 490.046C1242.02 488.892 1241.08 487.967 1239.94 487.967Z"
            fill="white"
          />
          <path
            d="M1235.19 502.326C1234.08 502.326 1233.16 503.243 1233.16 504.355C1233.16 505.467 1234.08 506.383 1235.19 506.383C1236.3 506.383 1237.22 505.479 1237.22 504.355C1237.22 503.23 1236.31 502.326 1235.19 502.326Z"
            fill="white"
          />
          <path
            d="M1230.54 517.348C1229.44 517.348 1228.54 518.243 1228.54 519.346C1228.54 520.45 1229.44 521.354 1230.54 521.354C1231.64 521.354 1232.55 520.458 1232.55 519.346C1232.55 518.235 1231.64 517.348 1230.54 517.348Z"
            fill="white"
          />
          <path
            d="M1225.98 533.031C1224.89 533.031 1224.02 533.905 1224.02 534.988C1224.02 536.07 1224.89 536.952 1225.98 536.952C1227.07 536.952 1227.94 536.078 1227.94 534.988C1227.94 533.897 1227.06 533.031 1225.98 533.031Z"
            fill="white"
          />
          <path
            d="M1221.3 549.104C1220.22 549.104 1219.35 549.978 1219.35 551.06C1219.35 552.142 1220.22 553.008 1221.3 553.008C1222.37 553.008 1223.24 552.134 1223.24 551.06C1223.24 549.986 1222.37 549.104 1221.3 549.104Z"
            fill="white"
          />
          <path
            d="M1216.6 565.605C1215.55 565.605 1214.7 566.458 1214.7 567.519C1214.7 568.58 1215.55 569.433 1216.6 569.433C1217.65 569.433 1218.52 568.568 1218.52 567.519C1218.52 566.471 1217.66 565.605 1216.6 565.605Z"
            fill="white"
          />
          <path
            d="M1211.75 582.264C1210.71 582.264 1209.87 583.117 1209.87 584.156C1209.87 585.196 1210.71 586.041 1211.75 586.041C1212.79 586.041 1213.64 585.196 1213.64 584.156C1213.64 583.117 1212.8 582.264 1211.75 582.264Z"
            fill="white"
          />
          <path
            d="M1207.06 599.162C1206.03 599.162 1205.19 599.994 1205.19 601.034C1205.19 602.073 1206.03 602.909 1207.06 602.909C1208.09 602.909 1208.94 602.065 1208.94 601.034C1208.94 600.002 1208.1 599.162 1207.06 599.162Z"
            fill="white"
          />
          <path
            d="M1202.36 616.016C1201.32 616.016 1200.48 616.86 1200.48 617.887C1200.48 618.914 1201.32 619.75 1202.36 619.75C1203.4 619.75 1204.22 618.918 1204.22 617.887C1204.22 616.856 1203.39 616.016 1202.36 616.016Z"
            fill="white"
          />
          <path
            d="M1197.88 632.844C1196.86 632.844 1196.03 633.676 1196.03 634.707C1196.03 635.738 1196.86 636.557 1197.88 636.557C1198.9 636.557 1199.74 635.725 1199.74 634.707C1199.74 633.688 1198.91 632.844 1197.88 632.844Z"
            fill="white"
          />
          <path
            d="M1193.44 649.434C1192.42 649.434 1191.58 650.257 1191.58 651.275C1191.58 652.294 1192.41 653.13 1193.44 653.13C1194.46 653.13 1195.29 652.298 1195.29 651.275C1195.29 650.253 1194.45 649.434 1193.44 649.434Z"
            fill="white"
          />
          <path
            d="M1189.16 665.793C1188.14 665.793 1187.32 666.625 1187.32 667.635C1187.32 668.645 1188.14 669.485 1189.16 669.485C1190.18 669.485 1191.01 668.653 1191.01 667.635C1191.01 666.616 1190.18 665.793 1189.16 665.793Z"
            fill="white"
          />
          <path
            d="M1451.65 360.883C1449.9 360.883 1448.48 362.3 1448.48 364.049C1448.48 365.797 1449.9 367.21 1451.65 367.21C1453.4 367.21 1454.81 365.793 1454.81 364.049C1454.81 362.304 1453.39 360.883 1451.65 360.883Z"
            fill="white"
          />
          <path
            d="M1437.33 364.924C1435.61 364.924 1434.23 366.32 1434.23 368.026C1434.23 369.732 1435.61 371.128 1437.33 371.128C1439.05 371.128 1440.43 369.745 1440.43 368.026C1440.43 366.307 1439.05 364.924 1437.33 364.924Z"
            fill="white"
          />
          <path
            d="M1423.16 369.348C1421.48 369.348 1420.12 370.71 1420.12 372.386C1420.12 374.062 1421.48 375.437 1423.16 375.437C1424.83 375.437 1426.2 374.075 1426.2 372.386C1426.2 370.697 1424.84 369.348 1423.16 369.348Z"
            fill="white"
          />
          <path
            d="M1409.34 374.311C1407.69 374.311 1406.37 375.643 1406.37 377.277C1406.37 378.911 1407.69 380.243 1409.34 380.243C1410.98 380.243 1412.3 378.923 1412.3 377.277C1412.3 375.63 1410.97 374.311 1409.34 374.311Z"
            fill="white"
          />
          <path
            d="M1395.76 379.568C1394.15 379.568 1392.85 380.871 1392.85 382.471C1392.85 384.071 1394.16 385.374 1395.76 385.374C1397.36 385.374 1398.66 384.071 1398.66 382.471C1398.66 380.871 1397.36 379.568 1395.76 379.568Z"
            fill="white"
          />
          <path
            d="M1382.36 384.967C1380.79 384.967 1379.51 386.248 1379.51 387.819C1379.51 389.389 1380.79 390.67 1382.36 390.67C1383.93 390.67 1385.21 389.389 1385.21 387.819C1385.21 386.248 1383.93 384.967 1382.36 384.967Z"
            fill="white"
          />
          <path
            d="M1369.27 390.6C1367.73 390.6 1366.48 391.847 1366.48 393.388C1366.48 394.928 1367.73 396.176 1369.27 396.176C1370.81 396.176 1372.05 394.928 1372.05 393.388C1372.05 391.847 1370.81 390.6 1369.27 390.6Z"
            fill="white"
          />
          <path
            d="M1356.54 396.43C1355.05 396.43 1353.83 397.639 1353.83 399.137C1353.83 400.635 1355.05 401.853 1356.54 401.853C1358.03 401.853 1359.25 400.635 1359.25 399.137C1359.25 397.639 1358.03 396.43 1356.54 396.43Z"
            fill="white"
          />
          <path
            d="M1344.17 402.369C1342.71 402.369 1341.52 403.557 1341.52 405.013C1341.52 406.469 1342.71 407.665 1344.17 407.665C1345.64 407.665 1346.82 406.477 1346.82 405.013C1346.82 403.549 1345.63 402.369 1344.17 402.369Z"
            fill="white"
          />
          <path
            d="M1332.22 408.482C1330.78 408.482 1329.62 409.649 1329.62 411.084C1329.62 412.518 1330.78 413.677 1332.22 413.677C1333.65 413.677 1334.81 412.51 1334.81 411.084C1334.81 409.658 1333.65 408.482 1332.22 408.482Z"
            fill="white"
          />
          <path
            d="M1320.88 414.945C1319.48 414.945 1318.35 416.078 1318.35 417.475C1318.35 418.871 1319.48 420.012 1320.88 420.012C1322.28 420.012 1323.41 418.879 1323.41 417.475C1323.41 416.07 1322.28 414.945 1320.88 414.945Z"
            fill="white"
          />
          <path
            d="M1310.2 421.832C1308.86 421.832 1307.76 422.927 1307.76 424.276C1307.76 425.626 1308.86 426.721 1310.2 426.721C1311.54 426.721 1312.65 425.626 1312.65 424.276C1312.65 422.927 1311.55 421.832 1310.2 421.832Z"
            fill="white"
          />
          <path
            d="M1300.18 429.184C1298.86 429.184 1297.79 430.245 1297.79 431.569C1297.79 432.893 1298.86 433.954 1300.18 433.954C1301.5 433.954 1302.56 432.88 1302.56 431.569C1302.56 430.257 1301.49 429.184 1300.18 429.184Z"
            fill="white"
          />
          <path
            d="M1290.96 437.195C1289.67 437.195 1288.61 438.235 1288.61 439.538C1288.61 440.841 1289.67 441.868 1290.96 441.868C1292.25 441.868 1293.3 440.828 1293.3 439.538C1293.3 438.248 1292.25 437.195 1290.96 437.195Z"
            fill="white"
          />
          <path
            d="M1282.52 445.99C1281.26 445.99 1280.25 447.009 1280.25 448.269C1280.25 449.53 1281.26 450.548 1282.52 450.548C1283.79 450.548 1284.8 449.53 1284.8 448.269C1284.8 447.009 1283.79 445.99 1282.52 445.99Z"
            fill="white"
          />
          <path
            d="M1274.74 455.545C1273.52 455.545 1272.54 456.542 1272.54 457.76C1272.54 458.978 1273.52 459.967 1274.74 459.967C1275.96 459.967 1276.96 458.978 1276.96 457.76C1276.96 456.542 1275.96 455.545 1274.74 455.545Z"
            fill="white"
          />
          <path
            d="M1267.73 466.037C1266.53 466.037 1265.56 467.005 1265.56 468.193C1265.56 469.381 1266.53 470.357 1267.73 470.357C1268.92 470.357 1269.89 469.39 1269.89 468.193C1269.89 466.996 1268.92 466.037 1267.73 466.037Z"
            fill="white"
          />
          <path
            d="M1261.33 477.434C1260.16 477.434 1259.21 478.38 1259.21 479.555C1259.21 480.731 1260.16 481.669 1261.33 481.669C1262.51 481.669 1263.46 480.722 1263.46 479.555C1263.46 478.388 1262.51 477.434 1261.33 477.434Z"
            fill="white"
          />
          <path
            d="M1255.39 489.682C1254.25 489.682 1253.32 490.62 1253.32 491.765C1253.32 492.911 1254.25 493.857 1255.39 493.857C1256.54 493.857 1257.48 492.92 1257.48 491.765C1257.48 490.611 1256.55 489.682 1255.39 489.682Z"
            fill="white"
          />
          <path
            d="M1249.83 502.797C1248.72 502.797 1247.81 503.701 1247.81 504.825C1247.81 505.95 1248.72 506.845 1249.83 506.845C1250.95 506.845 1251.86 505.941 1251.86 504.825C1251.86 503.709 1250.96 502.797 1249.83 502.797Z"
            fill="white"
          />
          <path
            d="M1244.4 516.523C1243.3 516.523 1242.4 517.419 1242.4 518.522C1242.4 519.626 1243.3 520.508 1244.4 520.508C1245.51 520.508 1246.4 519.626 1246.4 518.522C1246.4 517.419 1245.51 516.523 1244.4 516.523Z"
            fill="white"
          />
          <path
            d="M1239.11 530.887C1238.02 530.887 1237.14 531.769 1237.14 532.852C1237.14 533.934 1238.02 534.816 1239.11 534.816C1240.19 534.816 1241.07 533.934 1241.07 532.852C1241.07 531.769 1240.19 530.887 1239.11 530.887Z"
            fill="white"
          />
          <path
            d="M1233.75 545.678C1232.67 545.678 1231.8 546.552 1231.8 547.626C1231.8 548.699 1232.67 549.561 1233.75 549.561C1234.82 549.561 1235.68 548.695 1235.68 547.626C1235.68 546.556 1234.82 545.678 1233.75 545.678Z"
            fill="white"
          />
          <path
            d="M1228.44 560.969C1227.39 560.969 1226.54 561.822 1226.54 562.874C1226.54 563.927 1227.39 564.78 1228.44 564.78C1229.49 564.78 1230.34 563.927 1230.34 562.874C1230.34 561.822 1229.5 560.969 1228.44 560.969Z"
            fill="white"
          />
          <path
            d="M1223.06 576.504C1222 576.504 1221.16 577.348 1221.16 578.397C1221.16 579.445 1222.01 580.289 1223.06 580.289C1224.1 580.289 1224.94 579.436 1224.94 578.397C1224.94 577.357 1224.1 576.504 1223.06 576.504Z"
            fill="white"
          />
          <path
            d="M1217.71 592.295C1216.67 592.295 1215.83 593.139 1215.83 594.171C1215.83 595.202 1216.66 596.042 1217.71 596.042C1218.75 596.042 1219.58 595.198 1219.58 594.171C1219.58 593.144 1218.73 592.295 1217.71 592.295Z"
            fill="white"
          />
          <path
            d="M1212.46 611.976C1213.49 611.976 1214.32 611.142 1214.32 610.113C1214.32 609.084 1213.49 608.25 1212.46 608.25C1211.43 608.25 1210.6 609.084 1210.6 610.113C1210.6 611.142 1211.43 611.976 1212.46 611.976Z"
            fill="white"
          />
          <path
            d="M1207.32 624.227C1206.3 624.227 1205.47 625.05 1205.47 626.077C1205.47 627.104 1206.3 627.931 1207.32 627.931C1208.34 627.931 1209.17 627.1 1209.17 626.077C1209.17 625.054 1208.34 624.227 1207.32 624.227Z"
            fill="white"
          />
          <path
            d="M1202.48 640.213C1201.46 640.213 1200.62 641.036 1200.62 642.055C1200.62 643.073 1201.46 643.905 1202.48 643.905C1203.5 643.905 1204.32 643.073 1204.32 642.055C1204.32 641.036 1203.5 640.213 1202.48 640.213Z"
            fill="white"
          />
          <path
            d="M1197.67 656.039C1196.65 656.039 1195.82 656.862 1195.82 657.881C1195.82 658.899 1196.65 659.731 1197.67 659.731C1198.69 659.731 1199.51 658.899 1199.51 657.881C1199.51 656.862 1198.69 656.039 1197.67 656.039Z"
            fill="white"
          />
          <path
            d="M1193.26 671.861C1192.24 671.861 1191.42 672.685 1191.42 673.703C1191.42 674.722 1192.24 675.545 1193.26 675.545C1194.28 675.545 1195.1 674.722 1195.1 673.703C1195.1 672.685 1194.28 671.861 1193.26 671.861Z"
            fill="white"
          />
          <path
            d="M1448.81 382.213C1447.13 382.213 1445.76 383.575 1445.76 385.26C1445.76 386.945 1447.12 388.311 1448.81 388.311C1450.5 388.311 1451.87 386.949 1451.87 385.26C1451.87 383.571 1450.5 382.213 1448.81 382.213Z"
            fill="white"
          />
          <path
            d="M1434.73 386.205C1433.1 386.205 1431.77 387.538 1431.77 389.171C1431.77 390.805 1433.1 392.138 1434.73 392.138C1436.37 392.138 1437.7 390.805 1437.7 389.171C1437.7 387.538 1436.37 386.205 1434.73 386.205Z"
            fill="white"
          />
          <path
            d="M1420.88 390.648C1419.28 390.648 1417.98 391.951 1417.98 393.551C1417.98 395.151 1419.28 396.467 1420.88 396.467C1422.48 396.467 1423.78 395.164 1423.78 393.551C1423.78 391.939 1422.48 390.648 1420.88 390.648Z"
            fill="white"
          />
          <path
            d="M1407.25 395.521C1405.66 395.521 1404.39 396.79 1404.39 398.373C1404.39 399.956 1405.66 401.225 1407.25 401.225C1408.83 401.225 1410.1 399.943 1410.1 398.373C1410.1 396.803 1408.82 395.521 1407.25 395.521Z"
            fill="white"
          />
          <path
            d="M1393.89 400.736C1392.35 400.736 1391.09 401.997 1391.09 403.537C1391.09 405.078 1392.35 406.325 1393.89 406.325C1395.43 406.325 1396.68 405.078 1396.68 403.537C1396.68 401.997 1395.43 400.736 1393.89 400.736Z"
            fill="white"
          />
          <path
            d="M1380.85 406.262C1379.35 406.262 1378.14 407.471 1378.14 408.969C1378.14 410.467 1379.35 411.677 1380.85 411.677C1382.35 411.677 1383.55 410.467 1383.55 408.969C1383.55 407.471 1382.34 406.262 1380.85 406.262Z"
            fill="white"
          />
          <path
            d="M1368.09 411.959C1366.64 411.959 1365.45 413.147 1365.45 414.603C1365.45 416.058 1366.64 417.247 1368.09 417.247C1369.55 417.247 1370.74 416.071 1370.74 414.603C1370.74 413.134 1369.56 411.959 1368.09 411.959Z"
            fill="white"
          />
          <path
            d="M1355.66 417.824C1354.23 417.824 1353.07 418.979 1353.07 420.417C1353.07 421.856 1354.23 422.997 1355.66 422.997C1357.09 422.997 1358.24 421.843 1358.24 420.417C1358.24 418.991 1357.09 417.824 1355.66 417.824Z"
            fill="white"
          />
          <path
            d="M1343.74 423.988C1342.34 423.988 1341.21 425.113 1341.21 426.509C1341.21 427.905 1342.34 429.038 1343.74 429.038C1345.13 429.038 1346.26 427.905 1346.26 426.509C1346.26 425.113 1345.13 423.988 1343.74 423.988Z"
            fill="white"
          />
          <path
            d="M1332.35 430.494C1331 430.494 1329.91 431.589 1329.91 432.939C1329.91 434.288 1331 435.383 1332.35 435.383C1333.7 435.383 1334.81 434.288 1334.81 432.939C1334.81 431.589 1333.7 430.494 1332.35 430.494Z"
            fill="white"
          />
          <path
            d="M1321.54 437.354C1320.22 437.354 1319.14 438.427 1319.14 439.747C1319.14 441.067 1320.22 442.14 1321.54 442.14C1322.86 442.14 1323.93 441.067 1323.93 439.747C1323.93 438.427 1322.86 437.354 1321.54 437.354Z"
            fill="white"
          />
          <path
            d="M1311.45 444.773C1310.16 444.773 1309.12 445.813 1309.12 447.103C1309.12 448.393 1310.16 449.433 1311.45 449.433C1312.74 449.433 1313.79 448.393 1313.79 447.103C1313.79 445.813 1312.74 444.773 1311.45 444.773Z"
            fill="white"
          />
          <path
            d="M1302.14 452.82C1300.87 452.82 1299.83 453.852 1299.83 455.108C1299.83 456.364 1300.87 457.408 1302.14 457.408C1303.4 457.408 1304.43 456.377 1304.43 455.108C1304.43 453.839 1303.4 452.82 1302.14 452.82Z"
            fill="white"
          />
          <path
            d="M1293.48 461.58C1292.26 461.58 1291.26 462.569 1291.26 463.795C1291.26 465.022 1292.26 466.011 1293.48 466.011C1294.7 466.011 1295.69 465.013 1295.69 463.795C1295.69 462.577 1294.7 461.58 1293.48 461.58Z"
            fill="white"
          />
          <path
            d="M1285.55 471.115C1284.34 471.115 1283.37 472.083 1283.37 473.28C1283.37 474.476 1284.34 475.444 1285.55 475.444C1286.76 475.444 1287.71 474.476 1287.71 473.28C1287.71 472.083 1286.74 471.115 1285.55 471.115Z"
            fill="white"
          />
          <path
            d="M1278.18 481.389C1277.01 481.389 1276.06 482.335 1276.06 483.511C1276.06 484.686 1277.01 485.624 1278.18 485.624C1279.34 485.624 1280.3 484.678 1280.3 483.511C1280.3 482.344 1279.35 481.389 1278.18 481.389Z"
            fill="white"
          />
          <path
            d="M1271.3 492.396C1270.14 492.396 1269.2 493.334 1269.2 494.489C1269.2 495.643 1270.14 496.581 1271.3 496.581C1272.45 496.581 1273.39 495.643 1273.39 494.489C1273.39 493.334 1272.45 492.396 1271.3 492.396Z"
            fill="white"
          />
          <path
            d="M1264.9 504.275C1263.77 504.275 1262.87 505.192 1262.87 506.304C1262.87 507.416 1263.77 508.332 1264.9 508.332C1266.02 508.332 1266.92 507.429 1266.92 506.304C1266.92 505.179 1266.01 504.275 1264.9 504.275Z"
            fill="white"
          />
          <path
            d="M1258.7 516.766C1257.6 516.766 1256.71 517.661 1256.71 518.752C1256.71 519.842 1257.6 520.751 1258.7 520.751C1259.81 520.751 1260.69 519.855 1260.69 518.752C1260.69 517.648 1259.8 516.766 1258.7 516.766Z"
            fill="white"
          />
          <path
            d="M1252.69 529.877C1251.6 529.877 1250.72 530.76 1250.72 531.842C1250.72 532.924 1251.6 533.811 1252.69 533.811C1253.77 533.811 1254.66 532.928 1254.66 531.842C1254.66 530.755 1253.77 529.877 1252.69 529.877Z"
            fill="white"
          />
          <path
            d="M1246.73 543.514C1245.65 543.514 1244.79 544.379 1244.79 545.449C1244.79 546.518 1245.66 547.384 1246.73 547.384C1247.79 547.384 1248.65 546.51 1248.65 545.449C1248.65 544.388 1247.79 543.514 1246.73 543.514Z"
            fill="white"
          />
          <path
            d="M1240.73 557.543C1239.68 557.543 1238.82 558.396 1238.82 559.448C1238.82 560.501 1239.68 561.354 1240.73 561.354C1241.78 561.354 1242.64 560.501 1242.64 559.448C1242.64 558.396 1241.79 557.543 1240.73 557.543Z"
            fill="white"
          />
          <path
            d="M1234.83 571.988C1233.78 571.988 1232.94 572.833 1232.94 573.881C1232.94 574.929 1233.78 575.765 1234.83 575.765C1235.88 575.765 1236.71 574.921 1236.71 573.881C1236.71 572.841 1235.87 571.988 1234.83 571.988Z"
            fill="white"
          />
          <path
            d="M1228.84 586.672C1227.81 586.672 1226.97 587.504 1226.97 588.548C1226.97 589.592 1227.82 590.432 1228.84 590.432C1229.87 590.432 1230.73 589.587 1230.73 588.548C1230.73 587.508 1229.88 586.672 1228.84 586.672Z"
            fill="white"
          />
          <path
            d="M1223.12 601.711C1222.09 601.711 1221.26 602.543 1221.26 603.574C1221.26 604.605 1222.09 605.445 1223.12 605.445C1224.15 605.445 1224.98 604.601 1224.98 603.574C1224.98 602.547 1224.15 601.711 1223.12 601.711Z"
            fill="white"
          />
          <path
            d="M1217.38 616.846C1216.37 616.846 1215.54 617.669 1215.54 618.687C1215.54 619.706 1216.37 620.542 1217.38 620.542C1218.4 620.542 1219.24 619.71 1219.24 618.687C1219.24 617.665 1218.41 616.846 1217.38 616.846Z"
            fill="white"
          />
          <path
            d="M1211.97 632.072C1210.94 632.072 1210.12 632.904 1210.12 633.927C1210.12 634.95 1210.94 635.777 1211.97 635.777C1213 635.777 1213.83 634.945 1213.83 633.927C1213.83 632.908 1213 632.072 1211.97 632.072Z"
            fill="white"
          />
          <path
            d="M1206.75 647.332C1205.73 647.332 1204.91 648.164 1204.91 649.187C1204.91 650.209 1205.73 651.028 1206.75 651.028C1207.77 651.028 1208.59 650.197 1208.59 649.187C1208.59 648.177 1207.77 647.332 1206.75 647.332Z"
            fill="white"
          />
          <path
            d="M1201.74 662.598C1200.71 662.598 1199.89 663.429 1199.89 664.452C1199.89 665.475 1200.71 666.307 1201.74 666.307C1202.77 666.307 1203.59 665.475 1203.59 664.452C1203.59 663.429 1202.76 662.598 1201.74 662.598Z"
            fill="white"
          />
          <path
            d="M1197.18 678.002C1196.16 678.002 1195.33 678.834 1195.33 679.865C1195.33 680.896 1196.16 681.715 1197.18 681.715C1198.2 681.715 1199.05 680.883 1199.05 679.865C1199.05 678.846 1198.21 678.002 1197.18 678.002Z"
            fill="white"
          />
          <path
            d="M1446.34 404.434C1444.72 404.434 1443.42 405.736 1443.42 407.349C1443.42 408.962 1444.72 410.252 1446.34 410.252C1447.95 410.252 1449.24 408.949 1449.24 407.349C1449.24 405.749 1447.94 404.434 1446.34 404.434Z"
            fill="white"
          />
          <path
            d="M1432.38 408.41C1430.81 408.41 1429.53 409.679 1429.53 411.262C1429.53 412.845 1430.81 414.105 1432.38 414.105C1433.95 414.105 1435.22 412.836 1435.22 411.262C1435.22 409.688 1433.96 408.41 1432.38 408.41Z"
            fill="white"
          />
          <path
            d="M1418.66 412.83C1417.12 412.83 1415.88 414.078 1415.88 415.631C1415.88 417.184 1417.12 418.419 1418.66 418.419C1420.2 418.419 1421.45 417.171 1421.45 415.631C1421.45 414.09 1420.2 412.83 1418.66 412.83Z"
            fill="white"
          />
          <path
            d="M1405.22 417.703C1403.73 417.703 1402.53 418.921 1402.53 420.411C1402.53 421.9 1403.73 423.105 1405.22 423.105C1406.71 423.105 1407.93 421.896 1407.93 420.411C1407.93 418.925 1406.73 417.703 1405.22 417.703Z"
            fill="white"
          />
          <path
            d="M1392.01 422.779C1390.55 422.779 1389.36 423.968 1389.36 425.432C1389.36 426.896 1390.55 428.084 1392.01 428.084C1393.47 428.084 1394.67 426.896 1394.67 425.432C1394.67 423.968 1393.48 422.779 1392.01 422.779Z"
            fill="white"
          />
          <path
            d="M1379.06 428.123C1377.62 428.123 1376.47 429.277 1376.47 430.716C1376.47 432.155 1377.62 433.309 1379.06 433.309C1380.5 433.309 1381.65 432.155 1381.65 430.716C1381.65 429.277 1380.5 428.123 1379.06 428.123Z"
            fill="white"
          />
          <path
            d="M1366.55 433.77C1365.15 433.77 1364.01 434.903 1364.01 436.307C1364.01 437.712 1365.15 438.845 1366.55 438.845C1367.96 438.845 1369.08 437.699 1369.08 436.307C1369.08 434.915 1367.95 433.77 1366.55 433.77Z"
            fill="white"
          />
          <path
            d="M1354.48 439.746C1353.12 439.746 1352.03 440.841 1352.03 442.19C1352.03 443.54 1353.13 444.635 1354.48 444.635C1355.83 444.635 1356.92 443.54 1356.92 442.19C1356.92 440.841 1355.83 439.746 1354.48 439.746Z"
            fill="white"
          />
          <path
            d="M1342.88 445.99C1341.56 445.99 1340.5 447.064 1340.5 448.384C1340.5 449.704 1341.56 450.769 1342.88 450.769C1344.21 450.769 1345.28 449.708 1345.28 448.384C1345.28 447.06 1344.2 445.99 1342.88 445.99Z"
            fill="white"
          />
          <path
            d="M1331.96 452.736C1330.67 452.736 1329.62 453.789 1329.62 455.079C1329.62 456.369 1330.67 457.421 1331.96 457.421C1333.25 457.421 1334.31 456.369 1334.31 455.079C1334.31 453.789 1333.25 452.736 1331.96 452.736Z"
            fill="white"
          />
          <path
            d="M1321.78 460.061C1320.52 460.061 1319.49 461.092 1319.49 462.352C1319.49 463.613 1320.52 464.631 1321.78 464.631C1323.04 464.631 1324.07 463.613 1324.07 462.352C1324.07 461.092 1323.04 460.061 1321.78 460.061Z"
            fill="white"
          />
          <path
            d="M1312.28 468.012C1311.06 468.012 1310.08 469.001 1310.08 470.218C1310.08 471.436 1311.06 472.434 1312.28 472.434C1313.5 472.434 1314.5 471.445 1314.5 470.218C1314.5 468.992 1313.51 468.012 1312.28 468.012Z"
            fill="white"
          />
          <path
            d="M1303.49 476.641C1302.29 476.641 1301.32 477.608 1301.32 478.805C1301.32 480.002 1302.29 480.969 1303.49 480.969C1304.69 480.969 1305.67 480.002 1305.67 478.805C1305.67 477.608 1304.69 476.641 1303.49 476.641Z"
            fill="white"
          />
          <path
            d="M1295.32 485.977C1294.15 485.977 1293.2 486.923 1293.2 488.098C1293.2 489.274 1294.15 490.22 1295.32 490.22C1296.5 490.22 1297.44 489.274 1297.44 488.098C1297.44 486.923 1296.5 485.977 1295.32 485.977Z"
            fill="white"
          />
          <path
            d="M1287.6 495.957C1286.45 495.957 1285.52 496.895 1285.52 498.036C1285.52 499.178 1286.45 500.116 1287.6 500.116C1288.74 500.116 1289.67 499.178 1289.67 498.036C1289.67 496.895 1288.75 495.957 1287.6 495.957Z"
            fill="white"
          />
          <path
            d="M1280.34 506.656C1279.23 506.656 1278.32 507.56 1278.32 508.685C1278.32 509.809 1279.23 510.713 1280.34 510.713C1281.46 510.713 1282.37 509.797 1282.37 508.685C1282.37 507.573 1281.47 506.656 1280.34 506.656Z"
            fill="white"
          />
          <path
            d="M1273.4 517.961C1272.3 517.961 1271.4 518.856 1271.4 519.96C1271.4 521.063 1272.3 521.959 1273.4 521.959C1274.5 521.959 1275.39 521.063 1275.39 519.96C1275.39 518.856 1274.5 517.961 1273.4 517.961Z"
            fill="white"
          />
          <path
            d="M1266.67 529.865C1265.57 529.865 1264.7 530.752 1264.7 531.843C1264.7 532.933 1265.57 533.812 1266.67 533.812C1267.76 533.812 1268.63 532.929 1268.63 531.843C1268.63 530.756 1267.75 529.865 1266.67 529.865Z"
            fill="white"
          />
          <path
            d="M1260.09 542.346C1259.01 542.346 1258.14 543.22 1258.14 544.294C1258.14 545.367 1259.01 546.241 1260.09 546.241C1261.16 546.241 1262.04 545.376 1262.04 544.294C1262.04 543.211 1261.16 542.346 1260.09 542.346Z"
            fill="white"
          />
          <path
            d="M1253.46 555.223C1252.41 555.223 1251.55 556.076 1251.55 557.128C1251.55 558.181 1252.41 559.034 1253.46 559.034C1254.51 559.034 1255.36 558.181 1255.36 557.128C1255.36 556.076 1254.51 555.223 1253.46 555.223Z"
            fill="white"
          />
          <path
            d="M1247 568.574C1245.94 568.574 1245.1 569.427 1245.1 570.467C1245.1 571.507 1245.95 572.36 1247 572.36C1248.04 572.36 1248.89 571.515 1248.89 570.467C1248.89 569.419 1248.04 568.574 1247 568.574Z"
            fill="white"
          />
          <path
            d="M1240.46 582.221C1239.42 582.221 1238.58 583.065 1238.58 584.092C1238.58 585.119 1239.42 585.968 1240.46 585.968C1241.49 585.968 1242.33 585.123 1242.33 584.092C1242.33 583.061 1241.48 582.221 1240.46 582.221Z"
            fill="white"
          />
          <path
            d="M1234.14 596.26C1233.11 596.26 1232.28 597.092 1232.28 598.123C1232.28 599.154 1233.11 599.986 1234.14 599.986C1235.17 599.986 1236 599.154 1236 598.123C1236 597.092 1235.17 596.26 1234.14 596.26Z"
            fill="white"
          />
          <path
            d="M1228 610.59C1226.97 610.59 1226.15 611.413 1226.15 612.44C1226.15 613.467 1226.97 614.282 1228 614.282C1229.03 614.282 1229.84 613.459 1229.84 612.44C1229.84 611.422 1229.02 610.59 1228 610.59Z"
            fill="white"
          />
          <path
            d="M1221.96 625.059C1220.94 625.059 1220.11 625.882 1220.11 626.9C1220.11 627.919 1220.94 628.742 1221.96 628.742C1222.99 628.742 1223.8 627.919 1223.8 626.9C1223.8 625.882 1222.98 625.059 1221.96 625.059Z"
            fill="white"
          />
          <path
            d="M1216.31 639.703C1215.3 639.703 1214.46 640.526 1214.46 641.553C1214.46 642.58 1215.29 643.395 1216.31 643.395C1217.34 643.395 1218.16 642.572 1218.16 641.553C1218.16 640.535 1217.33 639.703 1216.31 639.703Z"
            fill="white"
          />
          <path
            d="M1210.74 654.369C1209.72 654.369 1208.9 655.192 1208.9 656.211C1208.9 657.229 1209.72 658.065 1210.74 658.065C1211.76 658.065 1212.58 657.234 1212.58 656.211C1212.58 655.188 1211.76 654.369 1210.74 654.369Z"
            fill="white"
          />
          <path
            d="M1205.67 669.252C1204.65 669.252 1203.82 670.075 1203.82 671.094C1203.82 672.112 1204.65 672.948 1205.67 672.948C1206.69 672.948 1207.52 672.125 1207.52 671.094C1207.52 670.062 1206.69 669.252 1205.67 669.252Z"
            fill="white"
          />
          <path
            d="M1443.23 425.953C1441.69 425.953 1440.45 427.201 1440.45 428.741C1440.45 430.282 1441.69 431.529 1443.23 431.529C1444.77 431.529 1446.02 430.282 1446.02 428.741C1446.02 427.201 1444.77 425.953 1443.23 425.953Z"
            fill="white"
          />
          <path
            d="M1429.39 429.941C1427.9 429.941 1426.68 431.159 1426.68 432.649C1426.68 434.138 1427.9 435.356 1429.39 435.356C1430.88 435.356 1432.1 434.151 1432.1 432.649C1432.1 431.147 1430.89 429.941 1429.39 429.941Z"
            fill="white"
          />
          <path
            d="M1415.75 434.279C1414.29 434.279 1413.11 435.468 1413.11 436.932C1413.11 438.396 1414.29 439.575 1415.75 439.575C1417.2 439.575 1418.4 438.387 1418.4 436.932C1418.4 435.476 1417.21 434.279 1415.75 434.279Z"
            fill="white"
          />
          <path
            d="M1402.31 438.936C1400.89 438.936 1399.73 440.103 1399.73 441.528C1399.73 442.954 1400.89 444.121 1402.31 444.121C1403.74 444.121 1404.91 442.954 1404.91 441.528C1404.91 440.103 1403.75 438.936 1402.31 438.936Z"
            fill="white"
          />
          <path
            d="M1389.21 443.922C1387.81 443.922 1386.68 445.055 1386.68 446.451C1386.68 447.847 1387.81 448.98 1389.21 448.98C1390.61 448.98 1391.75 447.847 1391.75 446.451C1391.75 445.055 1390.61 443.922 1389.21 443.922Z"
            fill="white"
          />
          <path
            d="M1376.5 449.268C1375.16 449.268 1374.06 450.362 1374.06 451.712C1374.06 453.061 1375.15 454.148 1376.5 454.148C1377.84 454.148 1378.94 453.053 1378.94 451.712C1378.94 450.371 1377.85 449.268 1376.5 449.268Z"
            fill="white"
          />
          <path
            d="M1364.21 454.889C1362.88 454.889 1361.82 455.962 1361.82 457.282C1361.82 458.602 1362.89 459.676 1364.21 459.676C1365.53 459.676 1366.6 458.602 1366.6 457.282C1366.6 455.962 1365.53 454.889 1364.21 454.889Z"
            fill="white"
          />
          <path
            d="M1352.5 460.926C1351.21 460.926 1350.16 461.978 1350.16 463.268C1350.16 464.558 1351.21 465.598 1352.5 465.598C1353.79 465.598 1354.83 464.546 1354.83 463.268C1354.83 461.991 1353.79 460.926 1352.5 460.926Z"
            fill="white"
          />
          <path
            d="M1341.46 467.484C1340.21 467.484 1339.19 468.503 1339.19 469.763C1339.19 471.024 1340.21 472.042 1341.46 472.042C1342.71 472.042 1343.74 471.024 1343.74 469.763C1343.74 468.503 1342.72 467.484 1341.46 467.484Z"
            fill="white"
          />
          <path
            d="M1331.12 474.643C1329.9 474.643 1328.93 475.631 1328.93 476.837C1328.93 478.042 1329.91 479.043 1331.12 479.043C1332.33 479.043 1333.33 478.055 1333.33 476.837C1333.33 475.619 1332.34 474.643 1331.12 474.643Z"
            fill="white"
          />
          <path
            d="M1321.52 482.439C1320.33 482.439 1319.36 483.407 1319.36 484.595C1319.36 485.784 1320.33 486.76 1321.52 486.76C1322.72 486.76 1323.68 485.792 1323.68 484.595C1323.68 483.399 1322.71 482.439 1321.52 482.439Z"
            fill="white"
          />
          <path
            d="M1312.57 490.891C1311.39 490.891 1310.44 491.837 1310.44 493.004C1310.44 494.171 1311.39 495.126 1312.57 495.126C1313.74 495.126 1314.68 494.18 1314.68 493.004C1314.68 491.828 1313.73 490.891 1312.57 490.891Z"
            fill="white"
          />
          <path
            d="M1304.06 499.904C1302.92 499.904 1301.99 500.829 1301.99 501.975C1301.99 503.121 1302.92 504.055 1304.06 504.055C1305.21 504.055 1306.14 503.13 1306.14 501.975C1306.14 500.821 1305.2 499.904 1304.06 499.904Z"
            fill="white"
          />
          <path
            d="M1296.06 509.602C1294.93 509.602 1294.03 510.505 1294.03 511.63C1294.03 512.755 1294.93 513.659 1296.06 513.659C1297.18 513.659 1298.09 512.742 1298.09 511.63C1298.09 510.518 1297.18 509.602 1296.06 509.602Z"
            fill="white"
          />
          <path
            d="M1288.38 519.889C1287.29 519.889 1286.4 520.771 1286.4 521.875C1286.4 522.978 1287.29 523.861 1288.38 523.861C1289.48 523.861 1290.38 522.965 1290.38 521.875C1290.38 520.784 1289.49 519.889 1288.38 519.889Z"
            fill="white"
          />
          <path
            d="M1280.93 530.66C1279.84 530.66 1278.96 531.534 1278.96 532.617C1278.96 533.699 1279.84 534.581 1280.93 534.581C1282.01 534.581 1282.88 533.699 1282.88 532.617C1282.88 531.534 1282.01 530.66 1280.93 530.66Z"
            fill="white"
          />
          <path
            d="M1273.74 542.053C1272.67 542.053 1271.8 542.918 1271.8 543.988C1271.8 545.057 1272.67 545.923 1273.74 545.923C1274.82 545.923 1275.68 545.057 1275.68 543.988C1275.68 542.918 1274.81 542.053 1273.74 542.053Z"
            fill="white"
          />
          <path
            d="M1266.56 553.867C1265.51 553.867 1264.64 554.72 1264.64 555.781C1264.64 556.842 1265.51 557.695 1266.56 557.695C1267.61 557.695 1268.47 556.829 1268.47 555.781C1268.47 554.733 1267.62 553.867 1266.56 553.867Z"
            fill="white"
          />
          <path
            d="M1259.52 566.172C1258.48 566.172 1257.63 567.016 1257.63 568.065C1257.63 569.113 1258.48 569.949 1259.52 569.949C1260.56 569.949 1261.41 569.104 1261.41 568.065C1261.41 567.025 1260.56 566.172 1259.52 566.172Z"
            fill="white"
          />
          <path
            d="M1252.52 578.848C1251.49 578.848 1250.65 579.679 1250.65 580.719C1250.65 581.759 1251.49 582.595 1252.52 582.595C1253.55 582.595 1254.41 581.75 1254.41 580.719C1254.41 579.688 1253.56 578.848 1252.52 578.848Z"
            fill="white"
          />
          <path
            d="M1245.55 591.838C1244.52 591.838 1243.69 592.67 1243.69 593.701C1243.69 594.732 1244.52 595.572 1245.55 595.572C1246.58 595.572 1247.42 594.728 1247.42 593.701C1247.42 592.674 1246.59 591.838 1245.55 591.838Z"
            fill="white"
          />
          <path
            d="M1238.93 605.303C1237.91 605.303 1237.07 606.126 1237.07 607.157C1237.07 608.188 1237.91 608.999 1238.93 608.999C1239.95 608.999 1240.78 608.176 1240.78 607.157C1240.78 606.139 1239.95 605.303 1238.93 605.303Z"
            fill="white"
          />
          <path
            d="M1232.37 619.002C1231.35 619.002 1230.53 619.825 1230.53 620.844C1230.53 621.862 1231.35 622.686 1232.37 622.686C1233.39 622.686 1234.21 621.862 1234.21 620.844C1234.21 619.825 1233.39 619.002 1232.37 619.002Z"
            fill="white"
          />
          <path
            d="M1226.22 633.002C1225.21 633.002 1224.38 633.825 1224.38 634.844C1224.38 635.862 1225.21 636.686 1226.22 636.686C1227.23 636.686 1228.07 635.862 1228.07 634.844C1228.07 633.825 1227.24 633.002 1226.22 633.002Z"
            fill="white"
          />
          <path
            d="M1220.33 647.164C1219.31 647.164 1218.49 647.996 1218.49 649.014C1218.49 650.033 1219.31 650.869 1220.33 650.869C1221.35 650.869 1222.18 650.037 1222.18 649.014C1222.18 647.992 1221.36 647.164 1220.33 647.164Z"
            fill="white"
          />
          <path
            d="M1214.62 661.457C1213.61 661.457 1212.77 662.289 1212.77 663.32C1212.77 664.351 1213.61 665.183 1214.62 665.183C1215.64 665.183 1216.49 664.351 1216.49 663.32C1216.49 662.289 1215.66 661.457 1214.62 661.457Z"
            fill="white"
          />
          <path
            d="M1209.51 676.076C1208.47 676.076 1207.64 676.908 1207.64 677.939C1207.64 678.97 1208.47 679.811 1209.51 679.811C1210.55 679.811 1211.37 678.979 1211.37 677.939C1211.37 676.899 1210.54 676.076 1209.51 676.076Z"
            fill="white"
          />
          <path
            d="M1452.9 441.754C1451.41 441.754 1450.2 442.963 1450.2 444.461C1450.2 445.959 1451.41 447.156 1452.9 447.156C1454.39 447.156 1455.61 445.947 1455.61 444.461C1455.61 442.976 1454.4 441.754 1452.9 441.754Z"
            fill="white"
          />
          <path
            d="M1438.96 450.747C1440.42 450.747 1441.6 449.563 1441.6 448.103C1441.6 446.643 1440.42 445.459 1438.96 445.459C1437.5 445.459 1436.31 446.643 1436.31 448.103C1436.31 449.563 1437.5 450.747 1438.96 450.747Z"
            fill="white"
          />
          <path
            d="M1425.09 449.375C1423.67 449.375 1422.5 450.529 1422.5 451.968C1422.5 453.407 1423.67 454.561 1425.09 454.561C1426.52 454.561 1427.69 453.407 1427.69 451.968C1427.69 450.529 1426.53 449.375 1425.09 449.375Z"
            fill="white"
          />
          <path
            d="M1411.54 453.746C1410.15 453.746 1409 454.879 1409 456.284C1409 457.689 1410.15 458.822 1411.54 458.822C1412.93 458.822 1414.08 457.676 1414.08 456.284C1414.08 454.892 1412.95 453.746 1411.54 453.746Z"
            fill="white"
          />
          <path
            d="M1398.27 458.469C1396.92 458.469 1395.83 459.564 1395.83 460.913C1395.83 462.263 1396.92 463.358 1398.27 463.358C1399.63 463.358 1400.72 462.263 1400.72 460.913C1400.72 459.564 1399.61 458.469 1398.27 458.469Z"
            fill="white"
          />
          <path
            d="M1385.32 463.455C1384.01 463.455 1382.93 464.529 1382.93 465.849C1382.93 467.168 1384.01 468.234 1385.32 468.234C1386.63 468.234 1387.71 467.16 1387.71 465.849C1387.71 464.537 1386.64 463.455 1385.32 463.455Z"
            fill="white"
          />
          <path
            d="M1372.91 468.9C1371.62 468.9 1370.58 469.94 1370.58 471.23C1370.58 472.52 1371.62 473.56 1372.91 473.56C1374.2 473.56 1375.25 472.52 1375.25 471.23C1375.25 469.94 1374.2 468.9 1372.91 468.9Z"
            fill="white"
          />
          <path
            d="M1361.13 474.791C1359.87 474.791 1358.83 475.81 1358.83 477.07C1358.83 478.33 1359.87 479.361 1361.13 479.361C1362.39 479.361 1363.41 478.33 1363.41 477.07C1363.41 475.81 1362.39 474.791 1361.13 474.791Z"
            fill="white"
          />
          <path
            d="M1349.96 481.17C1348.74 481.17 1347.75 482.159 1347.75 483.377C1347.75 484.595 1348.74 485.592 1349.96 485.592C1351.18 485.592 1352.16 484.595 1352.16 483.377C1352.16 482.159 1351.18 481.17 1349.96 481.17Z"
            fill="white"
          />
          <path
            d="M1339.53 488.152C1338.33 488.152 1337.37 489.12 1337.37 490.317C1337.37 491.513 1338.33 492.481 1339.53 492.481C1340.73 492.481 1341.7 491.513 1341.7 490.317C1341.7 489.12 1340.73 488.152 1339.53 488.152Z"
            fill="white"
          />
          <path
            d="M1329.8 495.791C1328.63 495.791 1327.68 496.737 1327.68 497.913C1327.68 499.088 1328.64 500.035 1329.8 500.035C1330.96 500.035 1331.92 499.076 1331.92 497.913C1331.92 496.75 1330.98 495.791 1329.8 495.791Z"
            fill="white"
          />
          <path
            d="M1320.59 503.982C1319.44 503.982 1318.51 504.92 1318.51 506.062C1318.51 507.203 1319.45 508.146 1320.59 508.146C1321.73 508.146 1322.67 507.22 1322.67 506.062C1322.67 504.903 1321.74 503.982 1320.59 503.982Z"
            fill="white"
          />
          <path
            d="M1311.89 512.811C1310.78 512.811 1309.87 513.714 1309.87 514.831C1309.87 515.947 1310.77 516.851 1311.89 516.851C1313 516.851 1313.91 515.947 1313.91 514.831C1313.91 513.714 1313 512.811 1311.89 512.811Z"
            fill="white"
          />
          <path
            d="M1303.55 522.154C1302.45 522.154 1301.55 523.037 1301.55 524.14C1301.55 525.244 1302.45 526.139 1303.55 526.139C1304.66 526.139 1305.55 525.244 1305.55 524.14C1305.55 523.037 1304.66 522.154 1303.55 522.154Z"
            fill="white"
          />
          <path
            d="M1295.4 531.949C1294.32 531.949 1293.43 532.823 1293.43 533.914C1293.43 535.005 1294.31 535.883 1295.4 535.883C1296.49 535.883 1297.37 534.996 1297.37 533.914C1297.37 532.832 1296.48 531.949 1295.4 531.949Z"
            fill="white"
          />
          <path
            d="M1287.59 542.357C1286.51 542.357 1285.64 543.223 1285.64 544.293C1285.64 545.362 1286.51 546.24 1287.59 546.24C1288.66 546.24 1289.54 545.366 1289.54 544.293C1289.54 543.219 1288.66 542.357 1287.59 542.357Z"
            fill="white"
          />
          <path
            d="M1279.88 553.223C1278.82 553.223 1277.97 554.076 1277.97 555.128C1277.97 556.181 1278.82 557.034 1279.88 557.034C1280.95 557.034 1281.79 556.181 1281.79 555.128C1281.79 554.076 1280.94 553.223 1279.88 553.223Z"
            fill="white"
          />
          <path
            d="M1272.26 564.516C1271.21 564.516 1270.37 565.36 1270.37 566.408C1270.37 567.457 1271.22 568.301 1272.26 568.301C1273.31 568.301 1274.15 567.448 1274.15 566.408C1274.15 565.369 1273.3 564.516 1272.26 564.516Z"
            fill="white"
          />
          <path
            d="M1264.85 576.34C1263.82 576.34 1262.99 577.172 1262.99 578.203C1262.99 579.234 1263.82 580.074 1264.85 580.074C1265.88 580.074 1266.73 579.23 1266.73 578.203C1266.73 577.176 1265.88 576.34 1264.85 576.34Z"
            fill="white"
          />
          <path
            d="M1257.38 592.146C1258.41 592.146 1259.24 591.312 1259.24 590.283C1259.24 589.254 1258.41 588.42 1257.38 588.42C1256.35 588.42 1255.52 589.254 1255.52 590.283C1255.52 591.312 1256.35 592.146 1257.38 592.146Z"
            fill="white"
          />
          <path
            d="M1250.21 600.988C1249.19 600.988 1248.35 601.812 1248.35 602.843C1248.35 603.874 1249.19 604.697 1250.21 604.697C1251.23 604.697 1252.06 603.866 1252.06 602.843C1252.06 601.82 1251.23 600.988 1250.21 600.988Z"
            fill="white"
          />
          <path
            d="M1243.23 613.893C1242.21 613.893 1241.38 614.724 1241.38 615.747C1241.38 616.77 1242.21 617.597 1243.23 617.597C1244.25 617.597 1245.08 616.766 1245.08 615.747C1245.08 614.729 1244.25 613.893 1243.23 613.893Z"
            fill="white"
          />
          <path
            d="M1236.45 627.119C1235.43 627.119 1234.61 627.951 1234.61 628.974C1234.61 629.996 1235.43 630.815 1236.45 630.815C1237.47 630.815 1238.3 629.992 1238.3 628.974C1238.3 627.955 1237.47 627.119 1236.45 627.119Z"
            fill="white"
          />
          <path
            d="M1230.19 640.764C1229.17 640.764 1228.35 641.587 1228.35 642.605C1228.35 643.624 1229.17 644.46 1230.19 644.46C1231.21 644.46 1232.04 643.628 1232.04 642.605C1232.04 641.583 1231.21 640.764 1230.19 640.764Z"
            fill="white"
          />
          <path
            d="M1224.05 654.564C1223.04 654.564 1222.2 655.396 1222.2 656.419C1222.2 657.442 1223.03 658.269 1224.05 658.269C1225.08 658.269 1225.92 657.446 1225.92 656.419C1225.92 655.392 1225.09 654.564 1224.05 654.564Z"
            fill="white"
          />
          <path
            d="M1218.44 668.707C1217.4 668.707 1216.57 669.539 1216.57 670.57C1216.57 671.601 1217.4 672.433 1218.44 672.433C1219.47 672.433 1220.29 671.601 1220.29 670.57C1220.29 669.539 1219.45 668.707 1218.44 668.707Z"
            fill="white"
          />
          <path
            d="M1447.17 458.668C1445.73 458.668 1444.57 459.822 1444.57 461.261C1444.57 462.7 1445.73 463.854 1447.17 463.854C1448.6 463.854 1449.76 462.687 1449.76 461.261C1449.76 459.835 1448.59 458.668 1447.17 458.668Z"
            fill="white"
          />
          <path
            d="M1433.21 462.467C1431.82 462.467 1430.68 463.591 1430.68 464.996C1430.68 466.401 1431.82 467.525 1433.21 467.525C1434.61 467.525 1435.75 466.392 1435.75 464.996C1435.75 463.6 1434.62 462.467 1433.21 462.467Z"
            fill="white"
          />
          <path
            d="M1419.5 466.629C1418.14 466.629 1417.04 467.732 1417.04 469.086C1417.04 470.44 1418.14 471.543 1419.5 471.543C1420.85 471.543 1421.95 470.44 1421.95 469.086C1421.95 467.732 1420.85 466.629 1419.5 466.629Z"
            fill="white"
          />
          <path
            d="M1406.07 471.158C1404.75 471.158 1403.67 472.232 1403.67 473.552C1403.67 474.871 1404.75 475.945 1406.07 475.945C1407.39 475.945 1408.46 474.871 1408.46 473.552C1408.46 472.232 1407.39 471.158 1406.07 471.158Z"
            fill="white"
          />
          <path
            d="M1393.03 476.047C1391.74 476.047 1390.68 477.087 1390.68 478.377C1390.68 479.667 1391.74 480.719 1393.03 480.719C1394.32 480.719 1395.36 479.667 1395.36 478.377C1395.36 477.087 1394.32 476.047 1393.03 476.047Z"
            fill="white"
          />
          <path
            d="M1380.53 481.367C1379.26 481.367 1378.24 482.398 1378.24 483.659C1378.24 484.919 1379.26 485.95 1380.53 485.95C1381.8 485.95 1382.82 484.932 1382.82 483.659C1382.82 482.386 1381.79 481.367 1380.53 481.367Z"
            fill="white"
          />
          <path
            d="M1368.65 487.207C1367.45 487.207 1366.46 488.196 1366.46 489.414C1366.46 490.632 1367.45 491.612 1368.65 491.612C1369.86 491.612 1370.86 490.632 1370.86 489.414C1370.86 488.196 1369.87 487.207 1368.65 487.207Z"
            fill="white"
          />
          <path
            d="M1357.5 493.543C1356.31 493.543 1355.34 494.511 1355.34 495.707C1355.34 496.904 1356.31 497.863 1357.5 497.863C1358.7 497.863 1359.66 496.896 1359.66 495.707C1359.66 494.519 1358.69 493.543 1357.5 493.543Z"
            fill="white"
          />
          <path
            d="M1347 500.434C1345.84 500.434 1344.89 501.38 1344.89 502.555C1344.89 503.731 1345.84 504.669 1347 504.669C1348.17 504.669 1349.12 503.722 1349.12 502.555C1349.12 501.388 1348.17 500.434 1347 500.434Z"
            fill="white"
          />
          <path
            d="M1337.05 507.867C1335.9 507.867 1334.97 508.792 1334.97 509.938C1334.97 511.084 1335.89 512.018 1337.05 512.018C1338.21 512.018 1339.12 511.08 1339.12 509.938C1339.12 508.797 1338.2 507.867 1337.05 507.867Z"
            fill="white"
          />
          <path
            d="M1327.64 515.891C1326.53 515.891 1325.62 516.795 1325.62 517.919C1325.62 519.044 1326.53 519.948 1327.64 519.948C1328.76 519.948 1329.67 519.044 1329.67 517.919C1329.67 516.795 1328.77 515.891 1327.64 515.891Z"
            fill="white"
          />
          <path
            d="M1318.72 524.496C1317.62 524.496 1316.74 525.391 1316.74 526.482C1316.74 527.573 1317.62 528.468 1318.72 528.468C1319.83 528.468 1320.71 527.586 1320.71 526.482C1320.71 525.379 1319.81 524.496 1318.72 524.496Z"
            fill="white"
          />
          <path
            d="M1310 533.512C1308.92 533.512 1308.05 534.399 1308.05 535.481C1308.05 536.563 1308.92 537.437 1310 537.437C1311.08 537.437 1311.97 536.563 1311.97 535.481C1311.97 534.399 1311.08 533.512 1310 533.512Z"
            fill="white"
          />
          <path
            d="M1301.58 543.043C1300.52 543.043 1299.65 543.909 1299.65 544.978C1299.65 546.048 1300.52 546.913 1301.58 546.913C1302.64 546.913 1303.53 546.048 1303.53 544.978C1303.53 543.909 1302.66 543.043 1301.58 543.043Z"
            fill="white"
          />
          <path
            d="M1293.35 553.057C1292.3 553.057 1291.45 553.91 1291.45 554.962C1291.45 556.015 1292.3 556.876 1293.35 556.876C1294.4 556.876 1295.26 556.023 1295.26 554.962C1295.26 553.901 1294.41 553.057 1293.35 553.057Z"
            fill="white"
          />
          <path
            d="M1285.16 563.453C1284.12 563.453 1283.28 564.298 1283.28 565.337C1283.28 566.377 1284.12 567.222 1285.16 567.222C1286.2 567.222 1287.04 566.377 1287.04 565.337C1287.04 564.298 1286.2 563.453 1285.16 563.453Z"
            fill="white"
          />
          <path
            d="M1277.29 574.404C1276.25 574.404 1275.41 575.249 1275.41 576.288C1275.41 577.328 1276.25 578.16 1277.29 578.16C1278.33 578.16 1279.17 577.328 1279.17 576.288C1279.17 575.249 1278.32 574.404 1277.29 574.404Z"
            fill="white"
          />
          <path
            d="M1269.45 585.746C1268.42 585.746 1267.59 586.591 1267.59 587.618C1267.59 588.645 1268.42 589.481 1269.45 589.481C1270.49 589.481 1271.33 588.649 1271.33 587.618C1271.33 586.586 1270.49 585.746 1269.45 585.746Z"
            fill="white"
          />
          <path
            d="M1261.77 597.508C1260.75 597.508 1259.92 598.34 1259.92 599.362C1259.92 600.385 1260.75 601.204 1261.77 601.204C1262.8 601.204 1263.63 600.381 1263.63 599.362C1263.63 598.344 1262.8 597.508 1261.77 597.508Z"
            fill="white"
          />
          <path
            d="M1254.41 609.707C1253.4 609.707 1252.57 610.53 1252.57 611.549C1252.57 612.567 1253.4 613.391 1254.41 613.391C1255.43 613.391 1256.26 612.567 1256.26 611.549C1256.26 610.53 1255.43 609.707 1254.41 609.707Z"
            fill="white"
          />
          <path
            d="M1247.11 622.176C1246.09 622.176 1245.26 622.999 1245.26 624.018C1245.26 625.036 1246.09 625.872 1247.11 625.872C1248.13 625.872 1248.95 625.04 1248.95 624.018C1248.95 622.995 1248.13 622.176 1247.11 622.176Z"
            fill="white"
          />
          <path
            d="M1240.3 635.104C1239.29 635.104 1238.45 635.927 1238.45 636.954C1238.45 637.981 1239.29 638.808 1240.3 638.808C1241.32 638.808 1242.16 637.977 1242.16 636.954C1242.16 635.931 1241.33 635.104 1240.3 635.104Z"
            fill="white"
          />
          <path
            d="M1233.86 648.402C1232.84 648.402 1232.01 649.234 1232.01 650.265C1232.01 651.297 1232.84 652.12 1233.86 652.12C1234.88 652.12 1235.72 651.297 1235.72 650.265C1235.72 649.234 1234.89 648.402 1233.86 648.402Z"
            fill="white"
          />
          <path
            d="M1227.7 662.059C1226.67 662.059 1225.84 662.903 1225.84 663.922C1225.84 664.94 1226.67 665.785 1227.7 665.785C1228.73 665.785 1229.56 664.953 1229.56 663.922C1229.56 662.89 1228.73 662.059 1227.7 662.059Z"
            fill="white"
          />
          <path
            d="M1222.16 676.141C1221.13 676.141 1220.29 676.985 1220.29 678.012C1220.29 679.039 1221.13 679.884 1222.16 679.884C1223.19 679.884 1224.03 679.039 1224.03 678.012C1224.03 676.985 1223.19 676.141 1222.16 676.141Z"
            fill="white"
          />
          <path
            d="M1440.03 473.416C1438.68 473.416 1437.59 474.511 1437.59 475.86C1437.59 477.21 1438.68 478.318 1440.03 478.318C1441.38 478.318 1442.49 477.214 1442.49 475.86C1442.49 474.507 1441.39 473.416 1440.03 473.416Z"
            fill="white"
          />
          <path
            d="M1426.14 477.441C1424.81 477.441 1423.74 478.515 1423.74 479.826C1423.74 481.138 1424.82 482.22 1426.14 482.22C1427.46 482.22 1428.52 481.146 1428.52 479.826C1428.52 478.507 1427.45 477.441 1426.14 477.441Z"
            fill="white"
          />
          <path
            d="M1412.64 481.961C1411.34 481.961 1410.29 483.001 1410.29 484.303C1410.29 485.606 1411.34 486.646 1412.64 486.646C1413.94 486.646 1414.98 485.594 1414.98 484.303C1414.98 483.013 1413.93 481.961 1412.64 481.961Z"
            fill="white"
          />
          <path
            d="M1399.58 486.895C1398.32 486.895 1397.28 487.913 1397.28 489.186C1397.28 490.459 1398.32 491.478 1399.58 491.478C1400.84 491.478 1401.87 490.447 1401.87 489.186C1401.87 487.926 1400.85 486.895 1399.58 486.895Z"
            fill="white"
          />
          <path
            d="M1387 492.223C1385.78 492.223 1384.79 493.211 1384.79 494.429C1384.79 495.647 1385.78 496.636 1387 496.636C1388.22 496.636 1389.21 495.647 1389.21 494.429C1389.21 493.211 1388.22 492.223 1387 492.223Z"
            fill="white"
          />
          <path
            d="M1375.16 498.072C1373.96 498.072 1372.99 499.04 1372.99 500.237C1372.99 501.433 1373.96 502.401 1375.16 502.401C1376.36 502.401 1377.32 501.433 1377.32 500.237C1377.32 499.04 1376.36 498.072 1375.16 498.072Z"
            fill="white"
          />
          <path
            d="M1364.03 504.471C1362.86 504.471 1361.91 505.417 1361.91 506.593C1361.91 507.768 1362.87 508.714 1364.03 508.714C1365.19 508.714 1366.15 507.768 1366.15 506.593C1366.15 505.417 1365.21 504.471 1364.03 504.471Z"
            fill="white"
          />
          <path
            d="M1353.44 511.332C1352.29 511.332 1351.37 512.257 1351.37 513.416C1351.37 514.574 1352.29 515.487 1353.44 515.487C1354.58 515.487 1355.52 514.561 1355.52 513.416C1355.52 512.27 1354.59 511.332 1353.44 511.332Z"
            fill="white"
          />
          <path
            d="M1343.34 518.68C1342.23 518.68 1341.32 519.584 1341.32 520.708C1341.32 521.833 1342.23 522.728 1343.34 522.728C1344.46 522.728 1345.37 521.824 1345.37 520.708C1345.37 519.592 1344.45 518.68 1343.34 518.68Z"
            fill="white"
          />
          <path
            d="M1333.79 526.59C1332.68 526.59 1331.79 527.485 1331.79 528.589C1331.79 529.692 1332.68 530.587 1333.79 530.587C1334.89 530.587 1335.78 529.692 1335.78 528.589C1335.78 527.485 1334.89 526.59 1333.79 526.59Z"
            fill="white"
          />
          <path
            d="M1324.53 534.967C1323.44 534.967 1322.57 535.841 1322.57 536.932C1322.57 538.022 1323.44 538.901 1324.53 538.901C1325.62 538.901 1326.5 538.014 1326.5 536.932C1326.5 535.849 1325.62 534.967 1324.53 534.967Z"
            fill="white"
          />
          <path
            d="M1315.57 543.803C1314.5 543.803 1313.62 544.677 1313.62 545.751C1313.62 546.824 1314.5 547.698 1315.57 547.698C1316.64 547.698 1317.52 546.824 1317.52 545.751C1317.52 544.677 1316.64 543.803 1315.57 543.803Z"
            fill="white"
          />
          <path
            d="M1306.9 553.172C1305.85 553.172 1305.01 554.025 1305.01 555.077C1305.01 556.13 1305.85 556.983 1306.9 556.983C1307.95 556.983 1308.81 556.13 1308.81 555.077C1308.81 554.025 1307.96 553.172 1306.9 553.172Z"
            fill="white"
          />
          <path
            d="M1298.24 562.832C1297.2 562.832 1296.36 563.685 1296.36 564.725C1296.36 565.764 1297.2 566.617 1298.24 566.617C1299.28 566.617 1300.14 565.773 1300.14 564.725C1300.14 563.677 1299.29 562.832 1298.24 562.832Z"
            fill="white"
          />
          <path
            d="M1289.85 572.998C1288.81 572.998 1287.97 573.843 1287.97 574.874C1287.97 575.905 1288.81 576.745 1289.85 576.745C1290.88 576.745 1291.72 575.914 1291.72 574.874C1291.72 573.834 1290.89 572.998 1289.85 572.998Z"
            fill="white"
          />
          <path
            d="M1281.64 583.625C1280.61 583.625 1279.78 584.457 1279.78 585.488C1279.78 586.519 1280.61 587.343 1281.64 587.343C1282.67 587.343 1283.51 586.511 1283.51 585.488C1283.51 584.465 1282.67 583.625 1281.64 583.625Z"
            fill="white"
          />
          <path
            d="M1273.48 594.627C1272.46 594.627 1271.63 595.459 1271.63 596.477C1271.63 597.496 1272.46 598.332 1273.48 598.332C1274.5 598.332 1275.33 597.5 1275.33 596.477C1275.33 595.454 1274.51 594.627 1273.48 594.627Z"
            fill="white"
          />
          <path
            d="M1265.75 606.176C1264.73 606.176 1263.89 606.999 1263.89 608.018C1263.89 609.036 1264.73 609.859 1265.75 609.859C1266.77 609.859 1267.59 609.036 1267.59 608.018C1267.59 606.999 1266.77 606.176 1265.75 606.176Z"
            fill="white"
          />
          <path
            d="M1258.14 618.055C1257.12 618.055 1256.29 618.886 1256.29 619.905C1256.29 620.923 1257.12 621.759 1258.14 621.759C1259.16 621.759 1259.99 620.928 1259.99 619.905C1259.99 618.882 1259.16 618.055 1258.14 618.055Z"
            fill="white"
          />
          <path
            d="M1250.78 630.324C1249.77 630.324 1248.94 631.147 1248.94 632.166C1248.94 633.184 1249.77 634.008 1250.78 634.008C1251.79 634.008 1252.64 633.184 1252.64 632.166C1252.64 631.147 1251.8 630.324 1250.78 630.324Z"
            fill="white"
          />
          <path
            d="M1243.94 643.043C1242.93 643.043 1242.09 643.875 1242.09 644.897C1242.09 645.92 1242.92 646.748 1243.94 646.748C1244.97 646.748 1245.8 645.916 1245.8 644.897C1245.8 643.879 1244.97 643.043 1243.94 643.043Z"
            fill="white"
          />
          <path
            d="M1237.3 656.117C1236.29 656.117 1235.45 656.949 1235.45 657.98C1235.45 659.011 1236.29 659.83 1237.3 659.83C1238.32 659.83 1239.17 658.999 1239.17 657.98C1239.17 656.962 1238.34 656.117 1237.3 656.117Z"
            fill="white"
          />
          <path
            d="M1231.31 669.717C1230.27 669.717 1229.43 670.561 1229.43 671.601C1229.43 672.641 1230.27 673.477 1231.31 673.477C1232.35 673.477 1233.19 672.632 1233.19 671.601C1233.19 670.57 1232.34 669.717 1231.31 669.717Z"
            fill="white"
          />
          <path
            d="M1445.46 482.271C1444.14 482.271 1443.07 483.345 1443.07 484.665C1443.07 485.985 1444.14 487.071 1445.46 487.071C1446.78 487.071 1447.87 485.997 1447.87 484.665C1447.87 483.332 1446.8 482.271 1445.46 482.271Z"
            fill="white"
          />
          <path
            d="M1431.55 486.447C1430.26 486.447 1429.21 487.487 1429.21 488.777C1429.21 490.067 1430.26 491.12 1431.55 491.12C1432.84 491.12 1433.88 490.067 1433.88 488.777C1433.88 487.487 1432.84 486.447 1431.55 486.447Z"
            fill="white"
          />
          <path
            d="M1417.96 491.016C1416.7 491.016 1415.68 492.034 1415.68 493.295C1415.68 494.555 1416.7 495.573 1417.96 495.573C1419.22 495.573 1420.24 494.555 1420.24 493.295C1420.24 492.034 1419.22 491.016 1417.96 491.016Z"
            fill="white"
          />
          <path
            d="M1404.88 496.051C1403.66 496.051 1402.67 497.04 1402.67 498.266C1402.67 499.492 1403.66 500.473 1404.88 500.473C1406.1 500.473 1407.1 499.484 1407.1 498.266C1407.1 497.048 1406.11 496.051 1404.88 496.051Z"
            fill="white"
          />
          <path
            d="M1392.45 501.559C1391.25 501.559 1390.29 502.526 1390.29 503.714C1390.29 504.903 1391.25 505.879 1392.45 505.879C1393.64 505.879 1394.61 504.911 1394.61 503.714C1394.61 502.518 1393.64 501.559 1392.45 501.559Z"
            fill="white"
          />
          <path
            d="M1380.67 507.531C1379.5 507.531 1378.55 508.478 1378.55 509.645C1378.55 510.812 1379.5 511.767 1380.67 511.767C1381.85 511.767 1382.79 510.82 1382.79 509.645C1382.79 508.469 1381.84 507.531 1380.67 507.531Z"
            fill="white"
          />
          <path
            d="M1369.48 513.975C1368.33 513.975 1367.4 514.9 1367.4 516.054C1367.4 517.208 1368.33 518.138 1369.48 518.138C1370.62 518.138 1371.57 517.213 1371.57 516.054C1371.57 514.896 1370.63 513.975 1369.48 513.975Z"
            fill="white"
          />
          <path
            d="M1358.83 520.895C1357.7 520.895 1356.8 521.798 1356.8 522.923C1356.8 524.048 1357.7 524.952 1358.83 524.952C1359.95 524.952 1360.86 524.048 1360.86 522.923C1360.86 521.798 1359.95 520.895 1358.83 520.895Z"
            fill="white"
          />
          <path
            d="M1348.75 528.336C1347.65 528.336 1346.77 529.223 1346.77 530.322C1346.77 531.421 1347.65 532.308 1348.75 532.308C1349.86 532.308 1350.73 531.413 1350.73 530.322C1350.73 529.231 1349.84 528.336 1348.75 528.336Z"
            fill="white"
          />
          <path
            d="M1338.96 536.164C1337.88 536.164 1337 537.038 1337 538.12C1337 539.203 1337.88 540.085 1338.96 540.085C1340.04 540.085 1340.91 539.203 1340.91 538.12C1340.91 537.038 1340.04 536.164 1338.96 536.164Z"
            fill="white"
          />
          <path
            d="M1329.44 544.43C1328.37 544.43 1327.51 545.295 1327.51 546.365C1327.51 547.434 1328.37 548.3 1329.44 548.3C1330.51 548.3 1331.38 547.434 1331.38 546.365C1331.38 545.295 1330.51 544.43 1329.44 544.43Z"
            fill="white"
          />
          <path
            d="M1320.35 553.232C1319.3 553.232 1318.44 554.085 1318.44 555.138C1318.44 556.19 1319.3 557.052 1320.35 557.052C1321.4 557.052 1322.25 556.186 1322.25 555.138C1322.25 554.09 1321.4 553.232 1320.35 553.232Z"
            fill="white"
          />
          <path
            d="M1311.35 562.395C1310.31 562.395 1309.46 563.239 1309.46 564.279C1309.46 565.319 1310.31 566.163 1311.35 566.163C1312.39 566.163 1313.23 565.319 1313.23 564.279C1313.23 563.239 1312.39 562.395 1311.35 562.395Z"
            fill="white"
          />
          <path
            d="M1302.51 571.947C1301.47 571.947 1300.62 572.792 1300.62 573.832C1300.62 574.871 1301.47 575.707 1302.51 575.707C1303.55 575.707 1304.38 574.863 1304.38 573.832C1304.38 572.8 1303.54 571.947 1302.51 571.947Z"
            fill="white"
          />
          <path
            d="M1293.95 581.979C1292.93 581.979 1292.1 582.81 1292.1 583.833C1292.1 584.856 1292.93 585.696 1293.95 585.696C1294.97 585.696 1295.8 584.864 1295.8 583.833C1295.8 582.802 1294.97 581.979 1293.95 581.979Z"
            fill="white"
          />
          <path
            d="M1285.39 592.324C1284.37 592.324 1283.54 593.147 1283.54 594.166C1283.54 595.184 1284.37 596.008 1285.39 596.008C1286.41 596.008 1287.23 595.184 1287.23 594.166C1287.23 593.147 1286.41 592.324 1285.39 592.324Z"
            fill="white"
          />
          <path
            d="M1277.18 603.16C1276.16 603.16 1275.33 603.983 1275.33 605.01C1275.33 606.037 1276.16 606.852 1277.18 606.852C1278.2 606.852 1279.03 606.029 1279.03 605.01C1279.03 603.992 1278.21 603.16 1277.18 603.16Z"
            fill="white"
          />
          <path
            d="M1269.3 618.191C1270.31 618.191 1271.14 617.367 1271.14 616.35C1271.14 615.332 1270.31 614.508 1269.3 614.508C1268.28 614.508 1267.46 615.332 1267.46 616.35C1267.46 617.367 1268.28 618.191 1269.3 618.191Z"
            fill="white"
          />
          <path
            d="M1261.52 626.203C1260.5 626.203 1259.67 627.035 1259.67 628.053C1259.67 629.072 1260.5 629.908 1261.52 629.908C1262.54 629.908 1263.38 629.076 1263.38 628.053C1263.38 627.031 1262.54 626.203 1261.52 626.203Z"
            fill="white"
          />
          <path
            d="M1254.29 638.412C1253.26 638.412 1252.43 639.244 1252.43 640.275C1252.43 641.306 1253.26 642.138 1254.29 642.138C1255.32 642.138 1256.15 641.294 1256.15 640.275C1256.15 639.257 1255.32 638.412 1254.29 638.412Z"
            fill="white"
          />
          <path
            d="M1247.37 651.016C1246.34 651.016 1245.5 651.847 1245.5 652.879C1245.5 653.91 1246.34 654.754 1247.37 654.754C1248.4 654.754 1249.23 653.91 1249.23 652.879C1249.23 651.847 1248.4 651.016 1247.37 651.016Z"
            fill="white"
          />
          <path
            d="M1240.78 664.047C1239.75 664.047 1238.91 664.891 1238.91 665.918C1238.91 666.945 1239.76 667.794 1240.78 667.794C1241.81 667.794 1242.66 666.95 1242.66 665.918C1242.66 664.887 1241.82 664.047 1240.78 664.047Z"
            fill="white"
          />
          <path
            d="M1234.89 677.566C1233.85 677.566 1233 678.419 1233 679.459C1233 680.499 1233.85 681.352 1234.89 681.352C1235.93 681.352 1236.78 680.499 1236.78 679.459C1236.78 678.419 1235.94 677.566 1234.89 677.566Z"
            fill="white"
          />
          <path
            d="M1449.61 489.494C1448.32 489.494 1447.26 490.547 1447.26 491.837C1447.26 493.127 1448.32 494.179 1449.61 494.179C1450.9 494.179 1451.95 493.14 1451.95 491.837C1451.95 490.534 1450.9 489.494 1449.61 489.494Z"
            fill="white"
          />
          <path
            d="M1435.73 493.93C1434.46 493.93 1433.44 494.961 1433.44 496.221C1433.44 497.482 1434.46 498.513 1435.73 498.513C1437.01 498.513 1438.02 497.482 1438.02 496.221C1438.02 494.961 1436.99 493.93 1435.73 493.93Z"
            fill="white"
          />
          <path
            d="M1422.09 498.604C1420.87 498.604 1419.88 499.592 1419.88 500.819C1419.88 502.045 1420.87 503.025 1422.09 503.025C1423.3 503.025 1424.29 502.037 1424.29 500.819C1424.29 499.601 1423.3 498.604 1422.09 498.604Z"
            fill="white"
          />
          <path
            d="M1409.13 503.826C1407.93 503.826 1406.96 504.794 1406.96 505.99C1406.96 507.187 1407.93 508.155 1409.13 508.155C1410.32 508.155 1411.29 507.187 1411.29 505.99C1411.29 504.794 1410.32 503.826 1409.13 503.826Z"
            fill="white"
          />
          <path
            d="M1396.88 509.564C1395.7 509.564 1394.75 510.524 1394.75 511.686C1394.75 512.849 1395.7 513.808 1396.88 513.808C1398.05 513.808 1399 512.862 1399 511.686C1399 510.511 1398.04 509.564 1396.88 509.564Z"
            fill="white"
          />
          <path
            d="M1385.14 515.713C1383.99 515.713 1383.07 516.638 1383.07 517.792C1383.07 518.947 1383.99 519.863 1385.14 519.863C1386.28 519.863 1387.22 518.938 1387.22 517.792C1387.22 516.647 1386.29 515.713 1385.14 515.713Z"
            fill="white"
          />
          <path
            d="M1373.91 522.291C1372.8 522.291 1371.89 523.195 1371.89 524.311C1371.89 525.427 1372.79 526.34 1373.91 526.34C1375.02 526.34 1375.93 525.436 1375.93 524.311C1375.93 523.186 1375.02 522.291 1373.91 522.291Z"
            fill="white"
          />
          <path
            d="M1363.34 529.377C1362.24 529.377 1361.34 530.264 1361.34 531.363C1361.34 532.462 1362.24 533.349 1363.34 533.349C1364.45 533.349 1365.33 532.466 1365.33 531.363C1365.33 530.26 1364.43 529.377 1363.34 529.377Z"
            fill="white"
          />
          <path
            d="M1353.15 536.871C1352.07 536.871 1351.2 537.754 1351.2 538.836C1351.2 539.918 1352.07 540.805 1353.15 540.805C1354.24 540.805 1355.12 539.931 1355.12 538.836C1355.12 537.741 1354.25 536.871 1353.15 536.871Z"
            fill="white"
          />
          <path
            d="M1343.22 544.762C1342.14 544.762 1341.27 545.627 1341.27 546.697C1341.27 547.766 1342.14 548.645 1343.22 548.645C1344.29 548.645 1345.15 547.771 1345.15 546.697C1345.15 545.623 1344.28 544.762 1343.22 544.762Z"
            fill="white"
          />
          <path
            d="M1333.68 553.129C1332.63 553.129 1331.78 553.982 1331.78 555.034C1331.78 556.087 1332.63 556.94 1333.68 556.94C1334.74 556.94 1335.59 556.087 1335.59 555.034C1335.59 553.982 1334.74 553.129 1333.68 553.129Z"
            fill="white"
          />
          <path
            d="M1324.33 561.871C1323.29 561.871 1322.45 562.724 1322.45 563.764C1322.45 564.804 1323.29 565.648 1324.33 565.648C1325.37 565.648 1326.23 564.804 1326.23 563.764C1326.23 562.724 1325.38 561.871 1324.33 561.871Z"
            fill="white"
          />
          <path
            d="M1315.11 570.986C1314.07 570.986 1313.24 571.831 1313.24 572.858C1313.24 573.885 1314.07 574.734 1315.11 574.734C1316.15 574.734 1316.98 573.902 1316.98 572.858C1316.98 571.814 1316.14 570.986 1315.11 570.986Z"
            fill="white"
          />
          <path
            d="M1306.25 580.574C1305.23 580.574 1304.4 581.406 1304.4 582.425C1304.4 583.443 1305.23 584.287 1306.25 584.287C1307.27 584.287 1308.11 583.456 1308.11 582.425C1308.11 581.393 1307.28 580.574 1306.25 580.574Z"
            fill="white"
          />
          <path
            d="M1297.45 590.475C1296.43 590.475 1295.6 591.306 1295.6 592.325C1295.6 593.343 1296.43 594.179 1297.45 594.179C1298.47 594.179 1299.3 593.348 1299.3 592.325C1299.3 591.302 1298.47 590.475 1297.45 590.475Z"
            fill="white"
          />
          <path
            d="M1288.81 600.744C1287.8 600.744 1286.96 601.567 1286.96 602.586C1286.96 603.604 1287.8 604.428 1288.81 604.428C1289.83 604.428 1290.66 603.604 1290.66 602.586C1290.66 601.567 1289.82 600.744 1288.81 600.744Z"
            fill="white"
          />
          <path
            d="M1280.57 611.484C1279.55 611.484 1278.72 612.308 1278.72 613.335C1278.72 614.362 1279.55 615.176 1280.57 615.176C1281.59 615.176 1282.42 614.353 1282.42 613.335C1282.42 612.316 1281.59 611.484 1280.57 611.484Z"
            fill="white"
          />
          <path
            d="M1272.44 622.635C1271.42 622.635 1270.6 623.458 1270.6 624.477C1270.6 625.495 1271.42 626.318 1272.44 626.318C1273.46 626.318 1274.28 625.495 1274.28 624.477C1274.28 623.458 1273.46 622.635 1272.44 622.635Z"
            fill="white"
          />
          <path
            d="M1264.8 634.336C1263.77 634.336 1262.94 635.168 1262.94 636.186C1262.94 637.205 1263.77 638.049 1264.8 638.049C1265.83 638.049 1266.65 637.217 1266.65 636.186C1266.65 635.155 1265.82 634.336 1264.8 634.336Z"
            fill="white"
          />
          <path
            d="M1257.62 646.551C1256.59 646.551 1255.76 647.383 1255.76 648.414C1255.76 649.445 1256.59 650.268 1257.62 650.268C1258.65 650.268 1259.49 649.437 1259.49 648.414C1259.49 647.391 1258.65 646.551 1257.62 646.551Z"
            fill="white"
          />
          <path
            d="M1250.64 659.121C1249.61 659.121 1248.76 659.966 1248.76 661.005C1248.76 662.045 1249.61 662.881 1250.64 662.881C1251.67 662.881 1252.52 662.037 1252.52 661.005C1252.52 659.974 1251.68 659.121 1250.64 659.121Z"
            fill="white"
          />
          <path
            d="M1244.32 672.205C1243.28 672.205 1242.43 673.05 1242.43 674.098C1242.43 675.146 1243.28 675.982 1244.32 675.982C1245.36 675.982 1246.21 675.137 1246.21 674.098C1246.21 673.058 1245.36 672.205 1244.32 672.205Z"
            fill="white"
          />
          <path
            d="M1452.52 495.5C1451.25 495.5 1450.23 496.519 1450.23 497.792C1450.23 499.065 1451.25 500.083 1452.52 500.083C1453.79 500.083 1454.81 499.065 1454.81 497.792C1454.81 496.519 1453.79 495.5 1452.52 495.5Z"
            fill="white"
          />
          <path
            d="M1438.67 500.215C1437.45 500.215 1436.45 501.212 1436.45 502.43C1436.45 503.648 1437.45 504.645 1438.67 504.645C1439.88 504.645 1440.88 503.657 1440.88 502.43C1440.88 501.204 1439.88 500.215 1438.67 500.215Z"
            fill="white"
          />
          <path
            d="M1425.22 505.115C1424.02 505.115 1423.06 506.083 1423.06 507.271C1423.06 508.459 1424.02 509.435 1425.22 509.435C1426.42 509.435 1427.38 508.468 1427.38 507.271C1427.38 506.074 1426.41 505.115 1425.22 505.115Z"
            fill="white"
          />
          <path
            d="M1412.44 510.561C1411.27 510.561 1410.33 511.507 1410.33 512.674C1410.33 513.841 1411.27 514.787 1412.44 514.787C1413.61 514.787 1414.56 513.841 1414.56 512.674C1414.56 511.507 1413.62 510.561 1412.44 510.561Z"
            fill="white"
          />
          <path
            d="M1400.27 516.486C1399.12 516.486 1398.19 517.424 1398.19 518.578C1398.19 519.733 1399.12 520.658 1400.27 520.658C1401.43 520.658 1402.36 519.72 1402.36 518.578C1402.36 517.437 1401.42 516.486 1400.27 516.486Z"
            fill="white"
          />
          <path
            d="M1388.61 522.863C1387.48 522.863 1386.58 523.78 1386.58 524.892C1386.58 526.004 1387.48 526.92 1388.61 526.92C1389.73 526.92 1390.63 526.016 1390.63 524.892C1390.63 523.767 1389.72 522.863 1388.61 522.863Z"
            fill="white"
          />
          <path
            d="M1377.56 529.701C1376.46 529.701 1375.57 530.584 1375.57 531.679C1375.57 532.774 1376.47 533.665 1377.56 533.665C1378.65 533.665 1379.54 532.782 1379.54 531.679C1379.54 530.575 1378.65 529.701 1377.56 529.701Z"
            fill="white"
          />
          <path
            d="M1366.97 536.936C1365.88 536.936 1365.01 537.818 1365.01 538.905C1365.01 539.991 1365.88 540.861 1366.97 540.861C1368.05 540.861 1368.92 539.987 1368.92 538.905C1368.92 537.822 1368.05 536.936 1366.97 536.936Z"
            fill="white"
          />
          <path
            d="M1356.64 544.574C1355.58 544.574 1354.71 545.44 1354.71 546.509C1354.71 547.579 1355.58 548.445 1356.64 548.445C1357.7 548.445 1358.58 547.57 1358.58 546.509C1358.58 545.448 1357.71 544.574 1356.64 544.574Z"
            fill="white"
          />
          <path
            d="M1346.8 552.67C1345.74 552.67 1344.88 553.523 1344.88 554.575C1344.88 555.628 1345.74 556.489 1346.8 556.489C1347.86 556.489 1348.7 555.636 1348.7 554.575C1348.7 553.514 1347.85 552.67 1346.8 552.67Z"
            fill="white"
          />
          <path
            d="M1337.2 561.164C1336.16 561.164 1335.32 562.009 1335.32 563.048C1335.32 564.088 1336.16 564.933 1337.2 564.933C1338.24 564.933 1339.08 564.088 1339.08 563.048C1339.08 562.009 1338.24 561.164 1337.2 561.164Z"
            fill="white"
          />
          <path
            d="M1327.64 569.961C1326.61 569.961 1325.77 570.805 1325.77 571.845C1325.77 572.885 1326.61 573.721 1327.64 573.721C1328.68 573.721 1329.52 572.876 1329.52 571.845C1329.52 570.814 1328.68 569.961 1327.64 569.961Z"
            fill="white"
          />
          <path
            d="M1318.48 579.199C1317.44 579.199 1316.61 580.031 1316.61 581.062C1316.61 582.093 1317.44 582.934 1318.48 582.934C1319.52 582.934 1320.34 582.102 1320.34 581.062C1320.34 580.023 1319.51 579.199 1318.48 579.199Z"
            fill="white"
          />
          <path
            d="M1309.47 588.82C1308.45 588.82 1307.63 589.644 1307.63 590.662C1307.63 591.681 1308.45 592.504 1309.47 592.504C1310.49 592.504 1311.31 591.681 1311.31 590.662C1311.31 589.644 1310.49 588.82 1309.47 588.82Z"
            fill="white"
          />
          <path
            d="M1300.51 598.688C1299.49 598.688 1298.67 599.519 1298.67 600.542C1298.67 601.565 1299.49 602.392 1300.51 602.392C1301.53 602.392 1302.36 601.561 1302.36 600.542C1302.36 599.524 1301.54 598.688 1300.51 598.688Z"
            fill="white"
          />
          <path
            d="M1291.98 609.021C1290.97 609.021 1290.13 609.845 1290.13 610.863C1290.13 611.882 1290.97 612.705 1291.98 612.705C1292.99 612.705 1293.82 611.873 1293.82 610.863C1293.82 609.853 1292.99 609.021 1291.98 609.021Z"
            fill="white"
          />
          <path
            d="M1283.62 619.697C1282.59 619.697 1281.77 620.529 1281.77 621.56C1281.77 622.592 1282.59 623.411 1283.62 623.411C1284.65 623.411 1285.47 622.579 1285.47 621.56C1285.47 620.542 1284.64 619.697 1283.62 619.697Z"
            fill="white"
          />
          <path
            d="M1275.5 630.834C1274.47 630.834 1273.64 631.666 1273.64 632.697C1273.64 633.728 1274.47 634.552 1275.5 634.552C1276.53 634.552 1277.35 633.72 1277.35 632.697C1277.35 631.674 1276.52 630.834 1275.5 630.834Z"
            fill="white"
          />
          <path
            d="M1267.99 642.564C1266.96 642.564 1266.12 643.396 1266.12 644.427C1266.12 645.459 1266.96 646.29 1267.99 646.29C1269.01 646.29 1269.85 645.459 1269.85 644.427C1269.85 643.396 1269.01 642.564 1267.99 642.564Z"
            fill="white"
          />
          <path
            d="M1260.75 654.785C1259.72 654.785 1258.88 655.63 1258.88 656.657C1258.88 657.684 1259.73 658.528 1260.75 658.528C1261.78 658.528 1262.64 657.696 1262.64 656.657C1262.64 655.617 1261.79 654.785 1260.75 654.785Z"
            fill="white"
          />
          <path
            d="M1254.04 667.484C1252.99 667.484 1252.13 668.337 1252.13 669.39C1252.13 670.442 1252.99 671.283 1254.04 671.283C1255.09 671.283 1255.93 670.43 1255.93 669.39C1255.93 668.35 1255.08 667.484 1254.04 667.484Z"
            fill="white"
          />
          <path
            d="M1440.64 505.66C1439.45 505.66 1438.48 506.628 1438.48 507.824C1438.48 509.021 1439.45 509.989 1440.64 509.989C1441.84 509.989 1442.81 509.021 1442.81 507.824C1442.81 506.628 1441.84 505.66 1440.64 505.66Z"
            fill="white"
          />
          <path
            d="M1427.48 510.82C1426.31 510.82 1425.37 511.767 1425.37 512.942C1425.37 514.118 1426.31 515.064 1427.48 515.064C1428.65 515.064 1429.6 514.105 1429.6 512.942C1429.6 511.779 1428.65 510.82 1427.48 510.82Z"
            fill="white"
          />
          <path
            d="M1414.84 516.486C1413.69 516.486 1412.77 517.411 1412.77 518.557C1412.77 519.703 1413.69 520.637 1414.84 520.637C1415.99 520.637 1416.92 519.712 1416.92 518.557C1416.92 517.403 1415.98 516.486 1414.84 516.486Z"
            fill="white"
          />
          <path
            d="M1402.73 522.643C1401.62 522.643 1400.71 523.546 1400.71 524.663C1400.71 525.779 1401.61 526.691 1402.73 526.691C1403.84 526.691 1404.75 525.787 1404.75 524.663C1404.75 523.538 1403.84 522.643 1402.73 522.643Z"
            fill="white"
          />
          <path
            d="M1391.32 529.297C1390.22 529.297 1389.32 530.18 1389.32 531.283C1389.32 532.386 1390.22 533.269 1391.32 533.269C1392.43 533.269 1393.31 532.374 1393.31 531.283C1393.31 530.192 1392.41 529.297 1391.32 529.297Z"
            fill="white"
          />
          <path
            d="M1380.4 536.361C1379.31 536.361 1378.44 537.244 1378.44 538.326C1378.44 539.408 1379.31 540.295 1380.4 540.295C1381.49 540.295 1382.36 539.413 1382.36 538.326C1382.36 537.24 1381.48 536.361 1380.4 536.361Z"
            fill="white"
          />
          <path
            d="M1369.73 543.814C1368.66 543.814 1367.8 544.689 1367.8 545.762C1367.8 546.836 1368.66 547.697 1369.73 547.697C1370.8 547.697 1371.67 546.832 1371.67 545.762C1371.67 544.693 1370.8 543.814 1369.73 543.814Z"
            fill="white"
          />
          <path
            d="M1359.55 551.734C1358.49 551.734 1357.64 552.579 1357.64 553.627C1357.64 554.675 1358.49 555.533 1359.55 555.533C1360.6 555.533 1361.45 554.68 1361.45 553.627C1361.45 552.575 1360.6 551.734 1359.55 551.734Z"
            fill="white"
          />
          <path
            d="M1349.72 560.039C1348.68 560.039 1347.84 560.892 1347.84 561.932C1347.84 562.971 1348.68 563.816 1349.72 563.816C1350.76 563.816 1351.61 562.971 1351.61 561.932C1351.61 560.892 1350.76 560.039 1349.72 560.039Z"
            fill="white"
          />
          <path
            d="M1339.98 568.688C1338.95 568.688 1338.1 569.532 1338.1 570.559C1338.1 571.586 1338.95 572.43 1339.98 572.43C1341.01 572.43 1341.85 571.599 1341.85 570.559C1341.85 569.519 1341 568.688 1339.98 568.688Z"
            fill="white"
          />
          <path
            d="M1330.57 577.744C1329.55 577.744 1328.71 578.576 1328.71 579.599C1328.71 580.621 1329.55 581.462 1330.57 581.462C1331.59 581.462 1332.43 580.63 1332.43 579.599C1332.43 578.567 1331.6 577.744 1330.57 577.744Z"
            fill="white"
          />
          <path
            d="M1321.41 587.143C1320.39 587.143 1319.56 587.974 1319.56 588.993C1319.56 590.011 1320.39 590.847 1321.41 590.847C1322.43 590.847 1323.26 590.016 1323.26 588.993C1323.26 587.97 1322.43 587.143 1321.41 587.143Z"
            fill="white"
          />
          <path
            d="M1312.23 596.789C1311.21 596.789 1310.38 597.621 1310.38 598.644C1310.38 599.666 1311.21 600.498 1312.23 600.498C1313.25 600.498 1314.08 599.666 1314.08 598.644C1314.08 597.621 1313.25 596.789 1312.23 596.789Z"
            fill="white"
          />
          <path
            d="M1303.44 606.834C1302.42 606.834 1301.6 607.657 1301.6 608.676C1301.6 609.694 1302.42 610.53 1303.44 610.53C1304.46 610.53 1305.29 609.707 1305.29 608.676C1305.29 607.645 1304.46 606.834 1303.44 606.834Z"
            fill="white"
          />
          <path
            d="M1294.88 617.23C1293.86 617.23 1293.04 618.062 1293.04 619.072C1293.04 620.082 1293.86 620.914 1294.88 620.914C1295.9 620.914 1296.72 620.091 1296.72 619.072C1296.72 618.054 1295.9 617.23 1294.88 617.23Z"
            fill="white"
          />
          <path
            d="M1286.45 627.98C1285.43 627.98 1284.6 628.804 1284.6 629.831C1284.6 630.858 1285.43 631.685 1286.45 631.685C1287.47 631.685 1288.3 630.853 1288.3 629.831C1288.3 628.808 1287.47 627.98 1286.45 627.98Z"
            fill="white"
          />
          <path
            d="M1278.58 639.275C1277.56 639.275 1276.73 640.107 1276.73 641.13C1276.73 642.153 1277.56 642.993 1278.58 642.993C1279.61 642.993 1280.45 642.161 1280.45 641.13C1280.45 640.099 1279.61 639.275 1278.58 639.275Z"
            fill="white"
          />
          <path
            d="M1271.1 651.037C1270.06 651.037 1269.22 651.882 1269.22 652.921C1269.22 653.961 1270.06 654.806 1271.1 654.806C1272.14 654.806 1272.98 653.961 1272.98 652.921C1272.98 651.882 1272.14 651.037 1271.1 651.037Z"
            fill="white"
          />
          <path
            d="M1263.96 663.309C1262.92 663.309 1262.07 664.162 1262.07 665.201C1262.07 666.241 1262.92 667.086 1263.96 667.086C1265 667.086 1265.84 666.241 1265.84 665.201C1265.84 664.162 1265 663.309 1263.96 663.309Z"
            fill="white"
          />
          <path
            d="M1257.55 676.172C1256.49 676.172 1255.64 677.025 1255.64 678.086C1255.64 679.147 1256.49 679.991 1257.55 679.991C1258.6 679.991 1259.46 679.138 1259.46 678.086C1259.46 677.033 1258.61 676.172 1257.55 676.172Z"
            fill="white"
          />
          <path
            d="M1441.88 510.539C1440.71 510.539 1439.75 511.485 1439.75 512.661C1439.75 513.836 1440.71 514.783 1441.88 514.783C1443.06 514.783 1444 513.836 1444 512.661C1444 511.485 1443.04 510.539 1441.88 510.539Z"
            fill="white"
          />
          <path
            d="M1428.9 515.943C1427.76 515.943 1426.83 516.881 1426.83 518.035C1426.83 519.19 1427.76 520.119 1428.9 520.119C1430.05 520.119 1430.98 519.181 1430.98 518.035C1430.98 516.89 1430.06 515.943 1428.9 515.943Z"
            fill="white"
          />
          <path
            d="M1416.39 521.844C1415.27 521.844 1414.37 522.76 1414.37 523.872C1414.37 524.984 1415.27 525.901 1416.39 525.901C1417.52 525.901 1418.41 524.997 1418.41 523.872C1418.41 522.748 1417.51 521.844 1416.39 521.844Z"
            fill="white"
          />
          <path
            d="M1404.57 528.268C1403.47 528.268 1402.57 529.163 1402.57 530.266C1402.57 531.37 1403.47 532.274 1404.57 532.274C1405.67 532.274 1406.57 531.37 1406.57 530.266C1406.57 529.163 1405.67 528.268 1404.57 528.268Z"
            fill="white"
          />
          <path
            d="M1393.33 535.174C1392.23 535.174 1391.36 536.061 1391.36 537.151C1391.36 538.242 1392.24 539.121 1393.33 539.121C1394.42 539.121 1395.29 538.238 1395.29 537.151C1395.29 536.065 1394.41 535.174 1393.33 535.174Z"
            fill="white"
          />
          <path
            d="M1382.41 542.512C1381.34 542.512 1380.46 543.377 1380.46 544.46C1380.46 545.542 1381.34 546.395 1382.41 546.395C1383.48 546.395 1384.36 545.529 1384.36 544.46C1384.36 543.39 1383.48 542.512 1382.41 542.512Z"
            fill="white"
          />
          <path
            d="M1371.95 550.299C1370.9 550.299 1370.05 551.152 1370.05 552.204C1370.05 553.257 1370.9 554.11 1371.95 554.11C1373.01 554.11 1373.86 553.257 1373.86 552.204C1373.86 551.152 1373.01 550.299 1371.95 550.299Z"
            fill="white"
          />
          <path
            d="M1361.91 558.498C1360.87 558.498 1360.02 559.343 1360.02 560.382C1360.02 561.422 1360.87 562.266 1361.91 562.266C1362.95 562.266 1363.79 561.422 1363.79 560.382C1363.79 559.343 1362.95 558.498 1361.91 558.498Z"
            fill="white"
          />
          <path
            d="M1352 567.045C1350.96 567.045 1350.12 567.889 1350.12 568.921C1350.12 569.952 1350.96 570.805 1352 570.805C1353.04 570.805 1353.88 569.96 1353.88 568.921C1353.88 567.881 1353.03 567.045 1352 567.045Z"
            fill="white"
          />
          <path
            d="M1342.4 575.996C1341.37 575.996 1340.54 576.828 1340.54 577.851C1340.54 578.873 1341.37 579.714 1342.4 579.714C1343.44 579.714 1344.27 578.882 1344.27 577.851C1344.27 576.819 1343.44 575.996 1342.4 575.996Z"
            fill="white"
          />
          <path
            d="M1333.13 585.311C1332.1 585.311 1331.27 586.142 1331.27 587.165C1331.27 588.188 1332.1 589.028 1333.13 589.028C1334.16 589.028 1334.99 588.196 1334.99 587.165C1334.99 586.134 1334.15 585.311 1333.13 585.311Z"
            fill="white"
          />
          <path
            d="M1323.86 594.885C1322.83 594.885 1322 595.708 1322 596.727C1322 597.745 1322.83 598.581 1323.86 598.581C1324.89 598.581 1325.7 597.749 1325.7 596.727C1325.7 595.704 1324.88 594.885 1323.86 594.885Z"
            fill="white"
          />
          <path
            d="M1314.87 604.773C1313.86 604.773 1313.02 605.605 1313.02 606.615C1313.02 607.625 1313.86 608.457 1314.87 608.457C1315.88 608.457 1316.71 607.634 1316.71 606.615C1316.71 605.597 1315.88 604.773 1314.87 604.773Z"
            fill="white"
          />
          <path
            d="M1306.16 614.996C1305.14 614.996 1304.31 615.828 1304.31 616.846C1304.31 617.865 1305.14 618.701 1306.16 618.701C1307.19 618.701 1308.03 617.869 1308.03 616.846C1308.03 615.824 1307.19 614.996 1306.16 614.996Z"
            fill="white"
          />
          <path
            d="M1297.55 625.529C1296.52 625.529 1295.68 626.361 1295.68 627.392C1295.68 628.424 1296.52 629.247 1297.55 629.247C1298.58 629.247 1299.4 628.415 1299.4 627.392C1299.4 626.37 1298.57 625.529 1297.55 625.529Z"
            fill="white"
          />
          <path
            d="M1289.41 636.527C1288.38 636.527 1287.54 637.359 1287.54 638.39C1287.54 639.422 1288.38 640.253 1289.41 640.253C1290.44 640.253 1291.27 639.422 1291.27 638.39C1291.27 637.359 1290.44 636.527 1289.41 636.527Z"
            fill="white"
          />
          <path
            d="M1281.68 647.986C1280.65 647.986 1279.81 648.831 1279.81 649.858C1279.81 650.885 1280.66 651.742 1281.68 651.742C1282.71 651.742 1283.56 650.898 1283.56 649.858C1283.56 648.818 1282.71 647.986 1281.68 647.986Z"
            fill="white"
          />
          <path
            d="M1274.22 659.875C1273.18 659.875 1272.33 660.719 1272.33 661.768C1272.33 662.816 1273.18 663.66 1274.22 663.66C1275.26 663.66 1276.11 662.807 1276.11 661.768C1276.11 660.728 1275.27 659.875 1274.22 659.875Z"
            fill="white"
          />
          <path
            d="M1267.45 672.332C1266.4 672.332 1265.54 673.185 1265.54 674.246C1265.54 675.307 1266.41 676.16 1267.45 676.16C1268.5 676.16 1269.37 675.294 1269.37 674.246C1269.37 673.198 1268.52 672.332 1267.45 672.332Z"
            fill="white"
          />
          <path
            d="M1442.4 515.037C1441.26 515.037 1440.32 515.975 1440.32 517.129C1440.32 518.284 1441.26 519.221 1442.4 519.221C1443.55 519.221 1444.5 518.284 1444.5 517.129C1444.5 515.975 1443.56 515.037 1442.4 515.037Z"
            fill="white"
          />
          <path
            d="M1429.56 520.699C1428.43 520.699 1427.53 521.603 1427.53 522.728C1427.53 523.852 1428.43 524.756 1429.56 524.756C1430.68 524.756 1431.59 523.852 1431.59 522.728C1431.59 521.603 1430.68 520.699 1429.56 520.699Z"
            fill="white"
          />
          <path
            d="M1417.39 526.861C1416.29 526.861 1415.4 527.757 1415.4 528.847C1415.4 529.938 1416.29 530.838 1417.39 530.838C1418.49 530.838 1419.38 529.955 1419.38 528.847C1419.38 527.74 1418.5 526.861 1417.39 526.861Z"
            fill="white"
          />
          <path
            d="M1405.83 533.562C1404.75 533.562 1403.87 534.437 1403.87 535.527C1403.87 536.618 1404.75 537.484 1405.83 537.484C1406.91 537.484 1407.8 536.61 1407.8 535.527C1407.8 534.445 1406.92 533.562 1405.83 533.562Z"
            fill="white"
          />
          <path
            d="M1394.64 540.734C1393.57 540.734 1392.69 541.609 1392.69 542.682C1392.69 543.756 1393.57 544.617 1394.64 544.617C1395.71 544.617 1396.58 543.752 1396.58 542.682C1396.58 541.613 1395.71 540.734 1394.64 540.734Z"
            fill="white"
          />
          <path
            d="M1383.92 548.395C1382.86 548.395 1382.01 549.248 1382.01 550.3C1382.01 551.352 1382.86 552.214 1383.92 552.214C1384.98 552.214 1385.83 551.361 1385.83 550.3C1385.83 549.239 1384.97 548.395 1383.92 548.395Z"
            fill="white"
          />
          <path
            d="M1373.7 556.514C1372.65 556.514 1371.81 557.358 1371.81 558.398C1371.81 559.438 1372.65 560.291 1373.7 560.291C1374.75 560.291 1375.59 559.446 1375.59 558.398C1375.59 557.35 1374.74 556.514 1373.7 556.514Z"
            fill="white"
          />
          <path
            d="M1363.67 565.018C1362.63 565.018 1361.79 565.849 1361.79 566.893C1361.79 567.937 1362.63 568.778 1363.67 568.778C1364.71 568.778 1365.55 567.933 1365.55 566.893C1365.55 565.854 1364.71 565.018 1363.67 565.018Z"
            fill="white"
          />
          <path
            d="M1353.91 573.924C1352.88 573.924 1352.05 574.756 1352.05 575.778C1352.05 576.801 1352.88 577.641 1353.91 577.641C1354.94 577.641 1355.77 576.81 1355.77 575.778C1355.77 574.747 1354.94 573.924 1353.91 573.924Z"
            fill="white"
          />
          <path
            d="M1344.55 583.23C1343.53 583.23 1342.7 584.054 1342.7 585.072C1342.7 586.091 1343.53 586.927 1344.55 586.927C1345.56 586.927 1346.39 586.095 1346.39 585.072C1346.39 584.05 1345.56 583.23 1344.55 583.23Z"
            fill="white"
          />
          <path
            d="M1335.23 592.793C1334.21 592.793 1333.38 593.625 1333.38 594.647C1333.38 595.67 1334.21 596.502 1335.23 596.502C1336.26 596.502 1337.08 595.67 1337.08 594.647C1337.08 593.625 1336.26 592.793 1335.23 592.793Z"
            fill="white"
          />
          <path
            d="M1326.15 602.658C1325.13 602.658 1324.29 603.49 1324.29 604.513C1324.29 605.535 1325.12 606.363 1326.15 606.363C1327.17 606.363 1328 605.54 1328 604.513C1328 603.486 1327.16 602.658 1326.15 602.658Z"
            fill="white"
          />
          <path
            d="M1317.37 612.838C1316.34 612.838 1315.51 613.67 1315.51 614.701C1315.51 615.732 1316.34 616.564 1317.37 616.564C1318.41 616.564 1319.23 615.732 1319.23 614.701C1319.23 613.67 1318.41 612.838 1317.37 612.838Z"
            fill="white"
          />
          <path
            d="M1308.66 623.309C1307.64 623.309 1306.8 624.14 1306.8 625.172C1306.8 626.203 1307.64 627.026 1308.66 627.026C1309.68 627.026 1310.52 626.194 1310.52 625.172C1310.52 624.149 1309.69 623.309 1308.66 623.309Z"
            fill="white"
          />
          <path
            d="M1300.34 634.156C1299.3 634.156 1298.47 635.001 1298.47 636.028C1298.47 637.055 1299.3 637.899 1300.34 637.899C1301.39 637.899 1302.22 637.067 1302.22 636.028C1302.22 634.988 1301.37 634.156 1300.34 634.156Z"
            fill="white"
          />
          <path
            d="M1292.46 645.436C1291.42 645.436 1290.58 646.28 1290.58 647.32C1290.58 648.359 1291.42 649.191 1292.46 649.191C1293.5 649.191 1294.34 648.359 1294.34 647.32C1294.34 646.28 1293.5 645.436 1292.46 645.436Z"
            fill="white"
          />
          <path
            d="M1284.81 657.107C1283.77 657.107 1282.92 657.952 1282.92 658.992C1282.92 660.031 1283.77 660.884 1284.81 660.884C1285.85 660.884 1286.69 660.031 1286.69 658.992C1286.69 657.952 1285.85 657.107 1284.81 657.107Z"
            fill="white"
          />
          <path
            d="M1277.76 669.252C1276.7 669.252 1275.83 670.118 1275.83 671.179C1275.83 672.24 1276.7 673.105 1277.76 673.105C1278.82 673.105 1279.67 672.24 1279.67 671.179C1279.67 670.118 1278.82 669.252 1277.76 669.252Z"
            fill="white"
          />
          <path
            d="M1442.27 519.324C1441.14 519.324 1440.23 520.228 1440.23 521.353C1440.23 522.477 1441.14 523.394 1442.27 523.394C1443.39 523.394 1444.31 522.49 1444.31 521.353C1444.31 520.215 1443.39 519.324 1442.27 519.324Z"
            fill="white"
          />
          <path
            d="M1429.8 525.234C1428.7 525.234 1427.8 526.13 1427.8 527.233C1427.8 528.337 1428.7 529.232 1429.8 529.232C1430.9 529.232 1431.79 528.337 1431.79 527.233C1431.79 526.13 1430.9 525.234 1429.8 525.234Z"
            fill="white"
          />
          <path
            d="M1417.91 531.656C1416.83 531.656 1415.94 532.539 1415.94 533.621C1415.94 534.703 1416.83 535.599 1417.91 535.599C1418.99 535.599 1419.89 534.716 1419.89 533.621C1419.89 532.526 1419.01 531.656 1417.91 531.656Z"
            fill="white"
          />
          <path
            d="M1406.46 538.633C1405.39 538.633 1404.51 539.507 1404.51 540.581C1404.51 541.654 1405.39 542.529 1406.46 542.529C1407.54 542.529 1408.41 541.654 1408.41 540.581C1408.41 539.507 1407.54 538.633 1406.46 538.633Z"
            fill="white"
          />
          <path
            d="M1395.48 546.137C1394.43 546.137 1393.57 547.002 1393.57 548.063C1393.57 549.124 1394.44 549.977 1395.48 549.977C1396.53 549.977 1397.41 549.112 1397.41 548.063C1397.41 547.015 1396.55 546.137 1395.48 546.137Z"
            fill="white"
          />
          <path
            d="M1385.07 554.162C1384.03 554.162 1383.17 555.007 1383.17 556.055C1383.17 557.103 1384.03 557.948 1385.07 557.948C1386.11 557.948 1386.96 557.095 1386.96 556.055C1386.96 555.015 1386.12 554.162 1385.07 554.162Z"
            fill="white"
          />
          <path
            d="M1374.92 562.623C1373.89 562.623 1373.05 563.468 1373.05 564.499C1373.05 565.53 1373.89 566.375 1374.92 566.375C1375.95 566.375 1376.79 565.543 1376.79 564.499C1376.79 563.455 1375.96 562.623 1374.92 562.623Z"
            fill="white"
          />
          <path
            d="M1365.04 575.236C1366.07 575.236 1366.9 574.402 1366.9 573.373C1366.9 572.344 1366.07 571.51 1365.04 571.51C1364.01 571.51 1363.18 572.344 1363.18 573.373C1363.18 574.402 1364.01 575.236 1365.04 575.236Z"
            fill="white"
          />
          <path
            d="M1355.61 580.832C1354.58 580.832 1353.76 581.664 1353.76 582.687C1353.76 583.709 1354.58 584.537 1355.61 584.537C1356.64 584.537 1357.46 583.714 1357.46 582.687C1357.46 581.66 1356.63 580.832 1355.61 580.832Z"
            fill="white"
          />
          <path
            d="M1346.31 590.492C1345.29 590.492 1344.46 591.316 1344.46 592.334C1344.46 593.353 1345.29 594.189 1346.31 594.189C1347.33 594.189 1348.15 593.357 1348.15 592.334C1348.15 591.311 1347.33 590.492 1346.31 590.492Z"
            fill="white"
          />
          <path
            d="M1337.18 600.424C1336.16 600.424 1335.33 601.256 1335.33 602.274C1335.33 603.293 1336.16 604.129 1337.18 604.129C1338.2 604.129 1339.03 603.305 1339.03 602.274C1339.03 601.243 1338.2 600.424 1337.18 600.424Z"
            fill="white"
          />
          <path
            d="M1328.4 610.684C1327.38 610.684 1326.55 611.515 1326.55 612.525C1326.55 613.535 1327.38 614.376 1328.4 614.376C1329.41 614.376 1330.24 613.544 1330.24 612.525C1330.24 611.507 1329.41 610.684 1328.4 610.684Z"
            fill="white"
          />
          <path
            d="M1319.7 621.197C1318.69 621.197 1317.85 622.029 1317.85 623.06C1317.85 624.092 1318.68 624.915 1319.7 624.915C1320.73 624.915 1321.56 624.083 1321.56 623.06C1321.56 622.038 1320.74 621.197 1319.7 621.197Z"
            fill="white"
          />
          <path
            d="M1311.33 632.053C1310.3 632.053 1309.46 632.885 1309.46 633.916C1309.46 634.947 1310.3 635.792 1311.33 635.792C1312.36 635.792 1313.19 634.947 1313.19 633.916C1313.19 632.885 1312.36 632.053 1311.33 632.053Z"
            fill="white"
          />
          <path
            d="M1303.37 643.271C1302.33 643.271 1301.49 644.116 1301.49 645.156C1301.49 646.195 1302.33 647.04 1303.37 647.04C1304.41 647.04 1305.26 646.195 1305.26 645.156C1305.26 644.116 1304.41 643.271 1303.37 643.271Z"
            fill="white"
          />
          <path
            d="M1295.64 654.844C1294.6 654.844 1293.75 655.688 1293.75 656.736C1293.75 657.785 1294.6 658.629 1295.64 658.629C1296.68 658.629 1297.54 657.776 1297.54 656.736C1297.54 655.697 1296.69 654.844 1295.64 654.844Z"
            fill="white"
          />
          <path
            d="M1288.43 666.838C1287.37 666.838 1286.5 667.704 1286.5 668.765C1286.5 669.826 1287.37 670.679 1288.43 670.679C1289.49 670.679 1290.35 669.826 1290.35 668.765C1290.35 667.704 1289.49 666.838 1288.43 666.838Z"
            fill="white"
          />
          <path
            d="M1441.79 523.5C1440.69 523.5 1439.79 524.395 1439.79 525.507C1439.79 526.619 1440.69 527.506 1441.79 527.506C1442.89 527.506 1443.79 526.611 1443.79 525.507C1443.79 524.404 1442.89 523.5 1441.79 523.5Z"
            fill="white"
          />
          <path
            d="M1429.67 529.678C1428.57 529.678 1427.69 530.56 1427.69 531.655C1427.69 532.75 1428.57 533.633 1429.67 533.633C1430.76 533.633 1431.63 532.75 1431.63 531.655C1431.63 530.56 1430.75 529.678 1429.67 529.678Z"
            fill="white"
          />
          <path
            d="M1417.92 536.371C1416.85 536.371 1415.97 537.245 1415.97 538.327C1415.97 539.41 1416.85 540.275 1417.92 540.275C1419 540.275 1419.88 539.401 1419.88 538.327C1419.88 537.254 1419 536.371 1417.92 536.371Z"
            fill="white"
          />
          <path
            d="M1406.68 543.688C1405.63 543.688 1404.78 544.54 1404.78 545.593C1404.78 546.645 1405.63 547.507 1406.68 547.507C1407.74 547.507 1408.6 546.654 1408.6 545.593C1408.6 544.532 1407.75 543.688 1406.68 543.688Z"
            fill="white"
          />
          <path
            d="M1396.06 551.559C1395 551.559 1394.16 552.403 1394.16 553.451C1394.16 554.5 1395.01 555.357 1396.06 555.357C1397.1 555.357 1397.96 554.504 1397.96 553.451C1397.96 552.399 1397.11 551.559 1396.06 551.559Z"
            fill="white"
          />
          <path
            d="M1385.77 559.957C1384.74 559.957 1383.9 560.802 1383.9 561.833C1383.9 562.864 1384.75 563.704 1385.77 563.704C1386.8 563.704 1387.65 562.86 1387.65 561.833C1387.65 560.806 1386.81 559.957 1385.77 559.957Z"
            fill="white"
          />
          <path
            d="M1375.78 568.822C1374.75 568.822 1373.91 569.654 1373.91 570.685C1373.91 571.717 1374.75 572.561 1375.78 572.561C1376.81 572.561 1377.64 571.717 1377.64 570.685C1377.64 569.654 1376.81 568.822 1375.78 568.822Z"
            fill="white"
          />
          <path
            d="M1366.28 578.18C1365.26 578.18 1364.43 579.011 1364.43 580.043C1364.43 581.074 1365.26 581.906 1366.28 581.906C1367.3 581.906 1368.14 581.074 1368.14 580.043C1368.14 579.011 1367.31 578.18 1366.28 578.18Z"
            fill="white"
          />
          <path
            d="M1357.01 587.953C1355.99 587.953 1355.15 588.785 1355.15 589.808C1355.15 590.83 1355.98 591.658 1357.01 591.658C1358.03 591.658 1358.86 590.826 1358.86 589.808C1358.86 588.789 1358.04 587.953 1357.01 587.953Z"
            fill="white"
          />
          <path
            d="M1347.91 598.029C1346.89 598.029 1346.05 598.861 1346.05 599.892C1346.05 600.924 1346.88 601.743 1347.91 601.743C1348.93 601.743 1349.77 600.911 1349.77 599.892C1349.77 598.874 1348.94 598.029 1347.91 598.029Z"
            fill="white"
          />
          <path
            d="M1339.19 608.438C1338.16 608.438 1337.34 609.269 1337.34 610.288C1337.34 611.306 1338.16 612.151 1339.19 612.151C1340.21 612.151 1341.04 611.319 1341.04 610.288C1341.04 609.257 1340.21 608.438 1339.19 608.438Z"
            fill="white"
          />
          <path
            d="M1330.6 619.117C1329.57 619.117 1328.74 619.949 1328.74 620.98C1328.74 622.011 1329.57 622.843 1330.6 622.843C1331.63 622.843 1332.46 622.011 1332.46 620.98C1332.46 619.949 1331.62 619.117 1330.6 619.117Z"
            fill="white"
          />
          <path
            d="M1322.28 630.096C1321.25 630.096 1320.41 630.927 1320.41 631.959C1320.41 632.99 1321.24 633.83 1322.28 633.83C1323.33 633.83 1324.15 632.998 1324.15 631.959C1324.15 630.919 1323.32 630.096 1322.28 630.096Z"
            fill="white"
          />
          <path
            d="M1314.37 641.4C1313.34 641.4 1312.5 642.245 1312.5 643.285C1312.5 644.324 1313.35 645.169 1314.37 645.169C1315.4 645.169 1316.26 644.324 1316.26 643.285C1316.26 642.245 1315.41 641.4 1314.37 641.4Z"
            fill="white"
          />
          <path
            d="M1306.68 653.002C1305.64 653.002 1304.79 653.855 1304.79 654.907C1304.79 655.96 1305.64 656.8 1306.68 656.8C1307.72 656.8 1308.59 655.947 1308.59 654.907C1308.59 653.868 1307.74 653.002 1306.68 653.002Z"
            fill="white"
          />
          <path
            d="M1299.44 664.975C1298.38 664.975 1297.51 665.828 1297.51 666.901C1297.51 667.975 1298.38 668.815 1299.44 668.815C1300.5 668.815 1301.37 667.962 1301.37 666.901C1301.37 665.84 1300.5 664.975 1299.44 664.975Z"
            fill="white"
          />
          <path
            d="M1292.75 677.326C1291.67 677.326 1290.8 678.2 1290.8 679.283C1290.8 680.365 1291.67 681.23 1292.75 681.23C1293.83 681.23 1294.7 680.356 1294.7 679.283C1294.7 678.209 1293.82 677.326 1292.75 677.326Z"
            fill="white"
          />
          <path
            d="M1453.25 521.479C1452.13 521.479 1451.24 522.374 1451.24 523.486C1451.24 524.598 1452.13 525.493 1453.25 525.493C1454.36 525.493 1455.25 524.589 1455.25 523.486C1455.25 522.382 1454.35 521.479 1453.25 521.479Z"
            fill="white"
          />
          <path
            d="M1441.04 527.68C1439.95 527.68 1439.06 528.562 1439.06 529.666C1439.06 530.769 1439.95 531.643 1441.04 531.643C1442.13 531.643 1443.02 530.761 1443.02 529.666C1443.02 528.571 1442.13 527.68 1441.04 527.68Z"
            fill="white"
          />
          <path
            d="M1429.1 534.156C1428.03 534.156 1427.15 535.022 1427.15 536.091C1427.15 537.161 1428.03 538.039 1429.1 538.039C1430.17 538.039 1431.05 537.174 1431.05 536.091C1431.05 535.009 1430.17 534.156 1429.1 534.156Z"
            fill="white"
          />
          <path
            d="M1417.58 541.172C1416.52 541.172 1415.66 542.025 1415.66 543.086C1415.66 544.147 1416.53 545 1417.58 545C1418.63 545 1419.5 544.147 1419.5 543.086C1419.5 542.025 1418.64 541.172 1417.58 541.172Z"
            fill="white"
          />
          <path
            d="M1406.73 548.852C1405.67 548.852 1404.83 549.696 1404.83 550.744C1404.83 551.793 1405.68 552.637 1406.73 552.637C1407.77 552.637 1408.62 551.784 1408.62 550.744C1408.62 549.705 1407.77 548.852 1406.73 548.852Z"
            fill="white"
          />
          <path
            d="M1396.29 557.129C1395.25 557.129 1394.4 557.982 1394.4 559.022C1394.4 560.061 1395.25 560.906 1396.29 560.906C1397.33 560.906 1398.17 560.061 1398.17 559.022C1398.17 557.982 1397.33 557.129 1396.29 557.129Z"
            fill="white"
          />
          <path
            d="M1386.18 565.963C1385.15 565.963 1384.3 566.807 1384.3 567.834C1384.3 568.861 1385.15 569.71 1386.18 569.71C1387.21 569.71 1388.05 568.878 1388.05 567.834C1388.05 566.79 1387.21 565.963 1386.18 565.963Z"
            fill="white"
          />
          <path
            d="M1376.61 579.087C1377.64 579.087 1378.48 578.253 1378.48 577.224C1378.48 576.195 1377.64 575.361 1376.61 575.361C1375.58 575.361 1374.75 576.195 1374.75 577.224C1374.75 578.253 1375.58 579.087 1376.61 579.087Z"
            fill="white"
          />
          <path
            d="M1367.37 585.246C1366.34 585.246 1365.51 586.078 1365.51 587.109C1365.51 588.14 1366.34 588.964 1367.37 588.964C1368.4 588.964 1369.22 588.132 1369.22 587.109C1369.22 586.086 1368.39 585.246 1367.37 585.246Z"
            fill="white"
          />
          <path
            d="M1358.35 595.52C1357.33 595.52 1356.49 596.343 1356.49 597.37C1356.49 598.397 1357.32 599.224 1358.35 599.224C1359.37 599.224 1360.2 598.393 1360.2 597.37C1360.2 596.347 1359.37 595.52 1358.35 595.52Z"
            fill="white"
          />
          <path
            d="M1349.74 609.853C1350.77 609.853 1351.6 609.019 1351.6 607.99C1351.6 606.961 1350.77 606.127 1349.74 606.127C1348.71 606.127 1347.88 606.961 1347.88 607.99C1347.88 609.019 1348.71 609.853 1349.74 609.853Z"
            fill="white"
          />
          <path
            d="M1341.32 617.045C1340.29 617.045 1339.46 617.877 1339.46 618.908C1339.46 619.939 1340.29 620.779 1341.32 620.779C1342.35 620.779 1343.19 619.935 1343.19 618.908C1343.19 617.881 1342.35 617.045 1341.32 617.045Z"
            fill="white"
          />
          <path
            d="M1333.18 628.254C1332.14 628.254 1331.3 629.086 1331.3 630.125C1331.3 631.165 1332.14 632.001 1333.18 632.001C1334.22 632.001 1335.05 631.169 1335.05 630.125C1335.05 629.081 1334.21 628.254 1333.18 628.254Z"
            fill="white"
          />
          <path
            d="M1325.45 639.754C1324.41 639.754 1323.57 640.598 1323.57 641.638C1323.57 642.678 1324.41 643.522 1325.45 643.522C1326.49 643.522 1327.33 642.678 1327.33 641.638C1327.33 640.598 1326.49 639.754 1325.45 639.754Z"
            fill="white"
          />
          <path
            d="M1317.94 651.516C1316.88 651.516 1316.03 652.381 1316.03 653.43C1316.03 654.478 1316.88 655.335 1317.94 655.335C1319 655.335 1319.85 654.482 1319.85 653.43C1319.85 652.377 1319 651.516 1317.94 651.516Z"
            fill="white"
          />
          <path
            d="M1310.83 663.6C1309.77 663.6 1308.91 664.465 1308.91 665.526C1308.91 666.587 1309.77 667.461 1310.83 667.461C1311.9 667.461 1312.76 666.596 1312.76 665.526C1312.76 664.457 1311.9 663.6 1310.83 663.6Z"
            fill="white"
          />
          <path
            d="M1304.23 675.996C1303.15 675.996 1302.28 676.87 1302.28 677.952C1302.28 679.035 1303.15 679.909 1304.23 679.909C1305.3 679.909 1306.18 679.035 1306.18 677.952C1306.18 676.87 1305.31 675.996 1304.23 675.996Z"
            fill="white"
          />
          <path
            d="M1451.99 525.516C1450.89 525.516 1450.01 526.403 1450.01 527.485C1450.01 528.567 1450.89 529.462 1451.99 529.462C1453.08 529.462 1453.96 528.58 1453.96 527.485C1453.96 526.39 1453.08 525.516 1451.99 525.516Z"
            fill="white"
          />
          <path
            d="M1440 531.98C1438.92 531.98 1438.05 532.855 1438.05 533.928C1438.05 535.002 1438.92 535.885 1440 535.885C1441.07 535.885 1441.95 535.01 1441.95 533.928C1441.95 532.846 1441.08 531.98 1440 531.98Z"
            fill="white"
          />
          <path
            d="M1428.28 538.764C1427.22 538.764 1426.37 539.617 1426.37 540.678C1426.37 541.739 1427.22 542.591 1428.28 542.591C1429.34 542.591 1430.19 541.739 1430.19 540.678C1430.19 539.617 1429.34 538.764 1428.28 538.764Z"
            fill="white"
          />
          <path
            d="M1417.16 546.166C1416.11 546.166 1415.27 547.019 1415.27 548.071C1415.27 549.124 1416.11 549.964 1417.16 549.964C1418.21 549.964 1419.07 549.12 1419.07 548.071C1419.07 547.023 1418.21 546.166 1417.16 546.166Z"
            fill="white"
          />
          <path
            d="M1406.56 554.297C1405.52 554.297 1404.66 555.141 1404.66 556.181C1404.66 557.221 1405.52 558.065 1406.56 558.065C1407.6 558.065 1408.44 557.221 1408.44 556.181C1408.44 555.141 1407.6 554.297 1406.56 554.297Z"
            fill="white"
          />
          <path
            d="M1396.32 563.049C1395.28 563.049 1394.44 563.893 1394.44 564.925C1394.44 565.956 1395.28 566.809 1396.32 566.809C1397.36 566.809 1398.19 565.964 1398.19 564.925C1398.19 563.885 1397.36 563.049 1396.32 563.049Z"
            fill="white"
          />
          <path
            d="M1386.67 572.447C1385.65 572.447 1384.81 573.279 1384.81 574.31C1384.81 575.342 1385.64 576.173 1386.67 576.173C1387.69 576.173 1388.53 575.342 1388.53 574.31C1388.53 573.279 1387.7 572.447 1386.67 572.447Z"
            fill="white"
          />
          <path
            d="M1377.46 582.449C1376.43 582.449 1375.59 583.281 1375.59 584.312C1375.59 585.343 1376.43 586.175 1377.46 586.175C1378.49 586.175 1379.32 585.331 1379.32 584.312C1379.32 583.294 1378.49 582.449 1377.46 582.449Z"
            fill="white"
          />
          <path
            d="M1368.54 592.92C1367.52 592.92 1366.68 593.743 1366.68 594.77C1366.68 595.797 1367.51 596.633 1368.54 596.633C1369.56 596.633 1370.4 595.801 1370.4 594.77C1370.4 593.739 1369.57 592.92 1368.54 592.92Z"
            fill="white"
          />
          <path
            d="M1360.11 603.795C1359.08 603.795 1358.25 604.627 1358.25 605.645C1358.25 606.664 1359.08 607.5 1360.11 607.5C1361.14 607.5 1361.96 606.676 1361.96 605.645C1361.96 604.614 1361.13 603.795 1360.11 603.795Z"
            fill="white"
          />
          <path
            d="M1351.93 615.016C1350.9 615.016 1350.06 615.847 1350.06 616.879C1350.06 617.91 1350.9 618.729 1351.93 618.729C1352.96 618.729 1353.79 617.897 1353.79 616.879C1353.79 615.86 1352.96 615.016 1351.93 615.016Z"
            fill="white"
          />
          <path
            d="M1344.08 626.527C1343.04 626.527 1342.2 627.372 1342.2 628.412C1342.2 629.451 1343.04 630.296 1344.08 630.296C1345.12 630.296 1345.96 629.451 1345.96 628.412C1345.96 627.372 1345.12 626.527 1344.08 626.527Z"
            fill="white"
          />
          <path
            d="M1336.67 638.35C1335.63 638.35 1334.79 639.194 1334.79 640.234C1334.79 641.274 1335.63 642.127 1336.67 642.127C1337.71 642.127 1338.56 641.274 1338.56 640.234C1338.56 639.194 1337.72 638.35 1336.67 638.35Z"
            fill="white"
          />
          <path
            d="M1329.48 650.402C1328.43 650.402 1327.57 651.255 1327.57 652.308C1327.57 653.36 1328.43 654.201 1329.48 654.201C1330.53 654.201 1331.37 653.348 1331.37 652.308C1331.37 651.268 1330.53 650.402 1329.48 650.402Z"
            fill="white"
          />
          <path
            d="M1322.66 662.682C1321.58 662.682 1320.72 663.556 1320.72 664.617C1320.72 665.678 1321.59 666.552 1322.66 666.552C1323.73 666.552 1324.59 665.686 1324.59 664.617C1324.59 663.547 1323.72 662.682 1322.66 662.682Z"
            fill="white"
          />
          <path
            d="M1316.3 675.242C1315.23 675.242 1314.35 676.116 1314.35 677.199C1314.35 678.281 1315.23 679.146 1316.3 679.146C1317.37 679.146 1318.25 678.272 1318.25 677.199C1318.25 676.125 1317.37 675.242 1316.3 675.242Z"
            fill="white"
          />
          <path
            d="M1450.57 529.713C1449.5 529.713 1448.62 530.587 1448.62 531.669C1448.62 532.751 1449.5 533.626 1450.57 533.626C1451.65 533.626 1452.53 532.751 1452.53 531.669C1452.53 530.587 1451.65 529.713 1450.57 529.713Z"
            fill="white"
          />
          <path
            d="M1438.81 536.486C1437.75 536.486 1436.89 537.352 1436.89 538.413C1436.89 539.474 1437.75 540.348 1438.81 540.348C1439.87 540.348 1440.75 539.482 1440.75 538.413C1440.75 537.344 1439.88 536.486 1438.81 536.486Z"
            fill="white"
          />
          <path
            d="M1427.51 543.658C1426.46 543.658 1425.6 544.511 1425.6 545.564C1425.6 546.616 1426.46 547.469 1427.51 547.469C1428.56 547.469 1429.41 546.616 1429.41 545.564C1429.41 544.511 1428.56 543.658 1427.51 543.658Z"
            fill="white"
          />
          <path
            d="M1416.69 551.547C1415.65 551.547 1414.8 552.391 1414.8 553.44C1414.8 554.488 1415.65 555.332 1416.69 555.332C1417.73 555.332 1418.59 554.479 1418.59 553.44C1418.59 552.4 1417.74 551.547 1416.69 551.547Z"
            fill="white"
          />
          <path
            d="M1406.31 560.188C1405.28 560.188 1404.43 561.019 1404.43 562.063C1404.43 563.107 1405.28 563.935 1406.31 563.935C1407.34 563.935 1408.18 563.09 1408.18 562.063C1408.18 561.036 1407.35 560.188 1406.31 560.188Z"
            fill="white"
          />
          <path
            d="M1396.57 569.545C1395.54 569.545 1394.71 570.377 1394.71 571.408C1394.71 572.439 1395.54 573.271 1396.57 573.271C1397.61 573.271 1398.45 572.439 1398.45 571.408C1398.45 570.377 1397.6 569.545 1396.57 569.545Z"
            fill="white"
          />
          <path
            d="M1387.39 579.629C1386.37 579.629 1385.53 580.461 1385.53 581.492C1385.53 582.523 1386.37 583.346 1387.39 583.346C1388.41 583.346 1389.25 582.515 1389.25 581.492C1389.25 580.469 1388.42 579.629 1387.39 579.629Z"
            fill="white"
          />
          <path
            d="M1378.6 594.023C1379.63 594.023 1380.47 593.189 1380.47 592.16C1380.47 591.131 1379.63 590.297 1378.6 590.297C1377.58 590.297 1376.74 591.131 1376.74 592.16C1376.74 593.189 1377.58 594.023 1378.6 594.023Z"
            fill="white"
          />
          <path
            d="M1370.4 601.473C1369.37 601.473 1368.54 602.304 1368.54 603.327C1368.54 604.35 1369.37 605.19 1370.4 605.19C1371.43 605.19 1372.25 604.358 1372.25 603.327C1372.25 602.296 1371.42 601.473 1370.4 601.473Z"
            fill="white"
          />
          <path
            d="M1362.53 613.049C1361.5 613.049 1360.66 613.881 1360.66 614.912C1360.66 615.943 1361.5 616.783 1362.53 616.783C1363.56 616.783 1364.4 615.952 1364.4 614.912C1364.4 613.872 1363.56 613.049 1362.53 613.049Z"
            fill="white"
          />
          <path
            d="M1355.08 624.979C1354.04 624.979 1353.2 625.81 1353.2 626.854C1353.2 627.898 1354.04 628.726 1355.08 628.726C1356.12 628.726 1356.95 627.881 1356.95 626.854C1356.95 625.827 1356.11 624.979 1355.08 624.979Z"
            fill="white"
          />
          <path
            d="M1348.12 637.172C1347.06 637.172 1346.22 638.016 1346.22 639.065C1346.22 640.113 1347.07 640.957 1348.12 640.957C1349.16 640.957 1350.01 640.104 1350.01 639.065C1350.01 638.025 1349.16 637.172 1348.12 637.172Z"
            fill="white"
          />
          <path
            d="M1341.41 649.635C1340.35 649.635 1339.5 650.488 1339.5 651.54C1339.5 652.593 1340.35 653.446 1341.41 653.446C1342.46 653.446 1343.31 652.593 1343.31 651.54C1343.31 650.488 1342.46 649.635 1341.41 649.635Z"
            fill="white"
          />
          <path
            d="M1335.12 662.318C1334.04 662.318 1333.18 663.184 1333.18 664.245C1333.18 665.306 1334.05 666.172 1335.12 666.172C1336.19 666.172 1337.04 665.306 1337.04 664.245C1337.04 663.184 1336.18 662.318 1335.12 662.318Z"
            fill="white"
          />
          <path
            d="M1329.2 675.15C1328.12 675.15 1327.25 676.025 1327.25 677.107C1327.25 678.189 1328.12 679.063 1329.2 679.063C1330.27 679.063 1331.15 678.189 1331.15 677.107C1331.15 676.025 1330.28 675.15 1329.2 675.15Z"
            fill="white"
          />
          <path
            d="M1449.16 534.186C1448.08 534.186 1447.22 535.051 1447.22 536.112C1447.22 537.173 1448.09 538.047 1449.16 538.047C1450.23 538.047 1451.08 537.182 1451.08 536.112C1451.08 535.043 1450.22 534.186 1449.16 534.186Z"
            fill="white"
          />
          <path
            d="M1437.81 541.338C1436.76 541.338 1435.91 542.191 1435.91 543.252C1435.91 544.313 1436.76 545.157 1437.81 545.157C1438.86 545.157 1439.73 544.304 1439.73 543.252C1439.73 542.199 1438.87 541.338 1437.81 541.338Z"
            fill="white"
          />
          <path
            d="M1426.86 549.029C1425.81 549.029 1424.97 549.874 1424.97 550.914C1424.97 551.953 1425.82 552.798 1426.86 552.798C1427.91 552.798 1428.75 551.953 1428.75 550.914C1428.75 549.874 1427.9 549.029 1426.86 549.029Z"
            fill="white"
          />
          <path
            d="M1416.32 557.471C1415.29 557.471 1414.45 558.302 1414.45 559.346C1414.45 560.39 1415.29 561.218 1416.32 561.218C1417.35 561.218 1418.2 560.386 1418.2 559.346C1418.2 558.307 1417.36 557.471 1416.32 557.471Z"
            fill="white"
          />
          <path
            d="M1406.51 566.742C1405.47 566.742 1404.63 567.574 1404.63 568.614C1404.63 569.653 1405.48 570.477 1406.51 570.477C1407.53 570.477 1408.38 569.645 1408.38 568.614C1408.38 567.582 1407.53 566.742 1406.51 566.742Z"
            fill="white"
          />
          <path
            d="M1397.31 576.883C1396.3 576.883 1395.45 577.715 1395.45 578.746C1395.45 579.777 1396.3 580.609 1397.31 580.609C1398.33 580.609 1399.18 579.777 1399.18 578.746C1399.18 577.715 1398.35 576.883 1397.31 576.883Z"
            fill="white"
          />
          <path
            d="M1388.68 587.746C1387.65 587.746 1386.8 588.578 1386.8 589.609C1386.8 590.64 1387.65 591.472 1388.68 591.472C1389.71 591.472 1390.54 590.64 1390.54 589.609C1390.54 588.578 1389.71 587.746 1388.68 587.746Z"
            fill="white"
          />
          <path
            d="M1380.75 599.227C1379.71 599.227 1378.88 600.058 1378.88 601.09C1378.88 602.121 1379.71 602.953 1380.75 602.953C1381.78 602.953 1382.6 602.121 1382.6 601.09C1382.6 600.058 1381.76 599.227 1380.75 599.227Z"
            fill="white"
          />
          <path
            d="M1373.29 611.213C1372.26 611.213 1371.42 612.045 1371.42 613.084C1371.42 614.124 1372.26 614.96 1373.29 614.96C1374.31 614.96 1375.16 614.116 1375.16 613.084C1375.16 612.053 1374.31 611.213 1373.29 611.213Z"
            fill="white"
          />
          <path
            d="M1366.39 623.645C1365.35 623.645 1364.5 624.489 1364.5 625.516C1364.5 626.543 1365.35 627.4 1366.39 627.4C1367.42 627.4 1368.27 626.556 1368.27 625.516C1368.27 624.476 1367.42 623.645 1366.39 623.645Z"
            fill="white"
          />
          <path
            d="M1360.04 636.363C1358.98 636.363 1358.14 637.208 1358.14 638.256C1358.14 639.304 1358.99 640.161 1360.04 640.161C1361.09 640.161 1361.94 639.308 1361.94 638.256C1361.94 637.204 1361.09 636.363 1360.04 636.363Z"
            fill="white"
          />
          <path
            d="M1353.96 649.316C1352.9 649.316 1352.05 650.169 1352.05 651.222C1352.05 652.274 1352.9 653.136 1353.96 653.136C1355.01 653.136 1355.87 652.283 1355.87 651.222C1355.87 650.161 1355.02 649.316 1353.96 649.316Z"
            fill="white"
          />
          <path
            d="M1348.36 662.467C1347.28 662.467 1346.42 663.332 1346.42 664.402C1346.42 665.471 1347.29 666.337 1348.36 666.337C1349.43 666.337 1350.29 665.463 1350.29 664.402C1350.29 663.341 1349.42 662.467 1348.36 662.467Z"
            fill="white"
          />
          <path
            d="M1343.12 679.671C1344.2 679.671 1345.08 678.795 1345.08 677.714C1345.08 676.634 1344.2 675.758 1343.12 675.758C1342.04 675.758 1341.17 676.634 1341.17 677.714C1341.17 678.795 1342.04 679.671 1343.12 679.671Z"
            fill="white"
          />
          <path
            d="M1448.09 539.049C1447.02 539.049 1446.17 539.902 1446.17 540.963C1446.17 542.024 1447.02 542.877 1448.09 542.877C1449.15 542.877 1450 542.011 1450 540.963C1450 539.915 1449.15 539.049 1448.09 539.049Z"
            fill="white"
          />
          <path
            d="M1437.14 546.73C1436.1 546.73 1435.25 547.575 1435.25 548.623C1435.25 549.671 1436.1 550.507 1437.14 550.507C1438.18 550.507 1439.03 549.663 1439.03 548.623C1439.03 547.583 1438.18 546.73 1437.14 546.73Z"
            fill="white"
          />
          <path
            d="M1426.52 555.014C1425.48 555.014 1424.63 555.858 1424.63 556.898C1424.63 557.938 1425.48 558.782 1426.52 558.782C1427.56 558.782 1428.4 557.938 1428.4 556.898C1428.4 555.858 1427.56 555.014 1426.52 555.014Z"
            fill="white"
          />
          <path
            d="M1416.6 564.15C1415.57 564.15 1414.73 564.995 1414.73 566.026C1414.73 567.057 1415.57 567.91 1416.6 567.91C1417.63 567.91 1418.49 567.066 1418.49 566.026C1418.49 564.986 1417.64 564.15 1416.6 564.15Z"
            fill="white"
          />
          <path
            d="M1407.44 574.297C1406.41 574.297 1405.57 575.129 1405.57 576.16C1405.57 577.191 1406.42 578.023 1407.44 578.023C1408.47 578.023 1409.31 577.191 1409.31 576.16C1409.31 575.129 1408.47 574.297 1407.44 574.297Z"
            fill="white"
          />
          <path
            d="M1398.99 585.361C1397.96 585.361 1397.12 586.193 1397.12 587.237C1397.12 588.281 1397.96 589.109 1398.99 589.109C1400.02 589.109 1400.87 588.264 1400.87 587.237C1400.87 586.21 1400.02 585.361 1398.99 585.361Z"
            fill="white"
          />
          <path
            d="M1391.4 597.197C1390.37 597.197 1389.54 598.029 1389.54 599.06C1389.54 600.092 1390.37 600.932 1391.4 600.932C1392.43 600.932 1393.27 600.087 1393.27 599.06C1393.27 598.033 1392.43 597.197 1391.4 597.197Z"
            fill="white"
          />
          <path
            d="M1384.42 609.645C1383.39 609.645 1382.55 610.489 1382.55 611.516C1382.55 612.543 1383.39 613.4 1384.42 613.4C1385.45 613.4 1386.3 612.556 1386.3 611.516C1386.3 610.476 1385.46 609.645 1384.42 609.645Z"
            fill="white"
          />
          <path
            d="M1378.17 622.611C1377.13 622.611 1376.29 623.456 1376.29 624.496C1376.29 625.535 1377.13 626.388 1378.17 626.388C1379.21 626.388 1380.07 625.544 1380.07 624.496C1380.07 623.447 1379.21 622.611 1378.17 622.611Z"
            fill="white"
          />
          <path
            d="M1372.64 635.963C1371.58 635.963 1370.74 636.816 1370.74 637.856C1370.74 638.895 1371.59 639.748 1372.64 639.748C1373.69 639.748 1374.53 638.904 1374.53 637.856C1374.53 636.807 1373.68 635.963 1372.64 635.963Z"
            fill="white"
          />
          <path
            d="M1367.48 649.621C1366.42 649.621 1365.56 650.474 1365.56 651.535C1365.56 652.596 1366.43 653.449 1367.48 653.449C1368.52 653.449 1369.4 652.596 1369.4 651.535C1369.4 650.474 1368.54 649.621 1367.48 649.621Z"
            fill="white"
          />
          <path
            d="M1362.86 663.434C1361.78 663.434 1360.91 664.299 1360.91 665.369C1360.91 666.438 1361.78 667.304 1362.86 667.304C1363.93 667.304 1364.79 666.438 1364.79 665.369C1364.79 664.299 1363.92 663.434 1362.86 663.434Z"
            fill="white"
          />
          <path
            d="M1358.44 677.213C1357.35 677.213 1356.48 678.1 1356.48 679.182C1356.48 680.264 1357.35 681.147 1358.44 681.147C1359.53 681.147 1360.4 680.264 1360.4 679.182C1360.4 678.1 1359.52 677.213 1358.44 677.213Z"
            fill="white"
          />
          <path
            d="M1447.52 544.512C1446.47 544.512 1445.62 545.356 1445.62 546.404C1445.62 547.453 1446.47 548.297 1447.52 548.297C1448.58 548.297 1449.42 547.453 1449.42 546.404C1449.42 545.356 1448.56 544.512 1447.52 544.512Z"
            fill="white"
          />
          <path
            d="M1437.01 552.859C1435.96 552.859 1435.12 553.704 1435.12 554.744C1435.12 555.783 1435.96 556.636 1437.01 556.636C1438.06 556.636 1438.89 555.783 1438.89 554.744C1438.89 553.704 1438.05 552.859 1437.01 552.859Z"
            fill="white"
          />
          <path
            d="M1427.13 561.957C1426.1 561.957 1425.26 562.802 1425.26 563.829C1425.26 564.856 1426.1 565.713 1427.13 565.713C1428.17 565.713 1429.02 564.868 1429.02 563.829C1429.02 562.789 1428.17 561.957 1427.13 561.957Z"
            fill="white"
          />
          <path
            d="M1417.99 572.039C1416.95 572.039 1416.11 572.884 1416.11 573.915C1416.11 574.946 1416.96 575.786 1417.99 575.786C1419.01 575.786 1419.86 574.942 1419.86 573.915C1419.86 572.888 1419.03 572.039 1417.99 572.039Z"
            fill="white"
          />
          <path
            d="M1409.74 583.281C1408.71 583.281 1407.88 584.113 1407.88 585.144C1407.88 586.175 1408.71 587.007 1409.74 587.007C1410.78 587.007 1411.62 586.175 1411.62 585.144C1411.62 584.113 1410.77 583.281 1409.74 583.281Z"
            fill="white"
          />
          <path
            d="M1402.61 595.479C1401.58 595.479 1400.74 596.323 1400.74 597.35C1400.74 598.377 1401.57 599.226 1402.61 599.226C1403.66 599.226 1404.49 598.394 1404.49 597.35C1404.49 596.306 1403.64 595.479 1402.61 595.479Z"
            fill="white"
          />
          <path
            d="M1396.3 608.51C1395.26 608.51 1394.41 609.354 1394.41 610.394C1394.41 611.434 1395.26 612.278 1396.3 612.278C1397.34 612.278 1398.17 611.434 1398.17 610.394C1398.17 609.354 1397.34 608.51 1396.3 608.51Z"
            fill="white"
          />
          <path
            d="M1390.94 622.184C1389.9 622.184 1389.04 623.037 1389.04 624.076C1389.04 625.116 1389.9 625.969 1390.94 625.969C1391.98 625.969 1392.83 625.124 1392.83 624.076C1392.83 623.028 1391.98 622.184 1390.94 622.184Z"
            fill="white"
          />
          <path
            d="M1386.39 636.279C1385.33 636.279 1384.48 637.124 1384.48 638.172C1384.48 639.22 1385.33 640.077 1386.39 640.077C1387.44 640.077 1388.28 639.224 1388.28 638.172C1388.28 637.12 1387.43 636.279 1386.39 636.279Z"
            fill="white"
          />
          <path
            d="M1382.29 650.658C1381.23 650.658 1380.37 651.511 1380.37 652.572C1380.37 653.633 1381.23 654.499 1382.29 654.499C1383.35 654.499 1384.21 653.633 1384.21 652.572C1384.21 651.511 1383.35 650.658 1382.29 650.658Z"
            fill="white"
          />
          <path
            d="M1378.93 665.275C1377.84 665.275 1376.97 666.15 1376.97 667.232C1376.97 668.314 1377.84 669.18 1378.93 669.18C1380.01 669.18 1380.87 668.305 1380.87 667.232C1380.87 666.158 1380 665.275 1378.93 665.275Z"
            fill="white"
          />
          <path
            d="M1447.78 550.859C1446.74 550.859 1445.89 551.712 1445.89 552.752C1445.89 553.792 1446.74 554.636 1447.78 554.636C1448.82 554.636 1449.67 553.792 1449.67 552.752C1449.67 551.712 1448.82 550.859 1447.78 550.859Z"
            fill="white"
          />
          <path
            d="M1438.15 560.082C1437.11 560.082 1436.26 560.927 1436.26 561.966C1436.26 563.006 1437.11 563.85 1438.15 563.85C1439.19 563.85 1440.03 563.006 1440.03 561.966C1440.03 560.927 1439.19 560.082 1438.15 560.082Z"
            fill="white"
          />
          <path
            d="M1429.29 570.334C1428.25 570.334 1427.42 571.179 1427.42 572.218C1427.42 573.258 1428.25 574.094 1429.29 574.094C1430.33 574.094 1431.18 573.262 1431.18 572.218C1431.18 571.174 1430.33 570.334 1429.29 570.334Z"
            fill="white"
          />
          <path
            d="M1421.37 581.762C1420.33 581.762 1419.48 582.606 1419.48 583.646C1419.48 584.686 1420.33 585.53 1421.37 585.53C1422.41 585.53 1423.25 584.686 1423.25 583.646C1423.25 582.606 1422.41 581.762 1421.37 581.762Z"
            fill="white"
          />
          <path
            d="M1414.79 594.375C1413.76 594.375 1412.92 595.22 1412.92 596.259C1412.92 597.299 1413.76 598.135 1414.79 598.135C1415.82 598.135 1416.67 597.303 1416.67 596.259C1416.67 595.215 1415.83 594.375 1414.79 594.375Z"
            fill="white"
          />
          <path
            d="M1409.25 607.99C1408.21 607.99 1407.37 608.843 1407.37 609.883C1407.37 610.923 1408.21 611.767 1409.25 611.767C1410.29 611.767 1411.14 610.923 1411.14 609.883C1411.14 608.843 1410.3 607.99 1409.25 607.99Z"
            fill="white"
          />
          <path
            d="M1405.06 622.508C1404.01 622.508 1403.15 623.352 1403.15 624.401C1403.15 625.449 1404.01 626.293 1405.06 626.293C1406.11 626.293 1406.95 625.449 1406.95 624.401C1406.95 623.352 1406.1 622.508 1405.06 622.508Z"
            fill="white"
          />
          <path
            d="M1401.88 637.59C1400.82 637.59 1399.97 638.443 1399.97 639.495C1399.97 640.548 1400.82 641.401 1401.88 641.401C1402.93 641.401 1403.78 640.548 1403.78 639.495C1403.78 638.443 1402.93 637.59 1401.88 637.59Z"
            fill="white"
          />
          <path
            d="M1399.23 652.965C1398.18 652.965 1397.32 653.831 1397.32 654.891C1397.32 655.952 1398.18 656.805 1399.23 656.805C1400.28 656.805 1401.15 655.94 1401.15 654.891C1401.15 653.843 1400.29 652.965 1399.23 652.965Z"
            fill="white"
          />
          <path
            d="M1397.26 668.451C1396.19 668.451 1395.31 669.325 1395.31 670.408C1395.31 671.49 1396.19 672.355 1397.26 672.355C1398.34 672.355 1399.22 671.481 1399.22 670.408C1399.22 669.334 1398.34 668.451 1397.26 668.451Z"
            fill="white"
          />
          <path
            d="M1449.79 558.582C1448.75 558.582 1447.9 559.427 1447.9 560.475C1447.9 561.523 1448.75 562.367 1449.79 562.367C1450.83 562.367 1451.68 561.514 1451.68 560.475C1451.68 559.435 1450.83 558.582 1449.79 558.582Z"
            fill="white"
          />
          <path
            d="M1441.34 569.066C1440.3 569.066 1439.47 569.911 1439.47 570.938C1439.47 571.965 1440.3 572.822 1441.34 572.822C1442.39 572.822 1443.23 571.978 1443.23 570.938C1443.23 569.898 1442.38 569.066 1441.34 569.066Z"
            fill="white"
          />
          <path
            d="M1434.11 580.959C1433.08 580.959 1432.24 581.791 1432.24 582.835C1432.24 583.879 1433.08 584.706 1434.11 584.706C1435.13 584.706 1435.99 583.874 1435.99 582.835C1435.99 581.795 1435.15 580.959 1434.11 580.959Z"
            fill="white"
          />
          <path
            d="M1428.52 594.23C1427.48 594.23 1426.63 595.075 1426.63 596.115C1426.63 597.154 1427.48 597.999 1428.52 597.999C1429.56 597.999 1430.4 597.154 1430.4 596.115C1430.4 595.075 1429.56 594.23 1428.52 594.23Z"
            fill="white"
          />
          <path
            d="M1424.16 608.654C1423.11 608.654 1422.27 609.499 1422.27 610.547C1422.27 611.595 1423.11 612.44 1424.16 612.44C1425.21 612.44 1426.05 611.587 1426.05 610.547C1426.05 609.507 1425.2 608.654 1424.16 608.654Z"
            fill="white"
          />
          <path
            d="M1421.41 624.111C1420.36 624.111 1419.5 624.964 1419.5 626.017C1419.5 627.069 1420.36 627.922 1421.41 627.922C1422.46 627.922 1423.32 627.069 1423.32 626.017C1423.32 624.964 1422.46 624.111 1421.41 624.111Z"
            fill="white"
          />
          <path
            d="M1419.72 640.148C1418.66 640.148 1417.81 641.014 1417.81 642.062C1417.81 643.111 1418.66 643.976 1419.72 643.976C1420.79 643.976 1421.63 643.111 1421.63 642.062C1421.63 641.014 1420.78 640.148 1419.72 640.148Z"
            fill="white"
          />
          <path
            d="M1418.83 656.686C1417.76 656.686 1416.89 657.551 1416.89 658.612C1416.89 659.673 1417.76 660.547 1418.83 660.547C1419.9 660.547 1420.76 659.682 1420.76 658.612C1420.76 657.543 1419.9 656.686 1418.83 656.686Z"
            fill="white"
          />
          <path
            d="M1418.59 673.361C1417.51 673.361 1416.63 674.236 1416.63 675.318C1416.63 676.4 1417.51 677.274 1418.59 677.274C1419.67 677.274 1420.54 676.4 1420.54 675.318C1420.54 674.236 1419.67 673.361 1418.59 673.361Z"
            fill="white"
          />
          <path
            d="M1448.28 580.932C1447.23 580.932 1446.39 581.785 1446.39 582.837C1446.39 583.89 1447.23 584.73 1448.28 584.73C1449.33 584.73 1450.17 583.877 1450.17 582.837C1450.17 581.797 1449.33 580.932 1448.28 580.932Z"
            fill="white"
          />
          <path
            d="M1443.91 594.969C1442.87 594.969 1442.02 595.813 1442.02 596.861C1442.02 597.91 1442.87 598.746 1443.91 598.746C1444.95 598.746 1445.8 597.901 1445.8 596.861C1445.8 595.822 1444.95 594.969 1443.91 594.969Z"
            fill="white"
          />
          <path
            d="M1441.15 610.445C1440.1 610.445 1439.25 611.298 1439.25 612.351C1439.25 613.403 1440.1 614.243 1441.15 614.243C1442.2 614.243 1443.04 613.399 1443.04 612.351C1443.04 611.303 1442.2 610.445 1441.15 610.445Z"
            fill="white"
          />
          <path
            d="M1440.34 627.184C1439.29 627.184 1438.44 628.049 1438.44 629.098C1438.44 630.146 1439.29 631.011 1440.34 631.011C1441.39 631.011 1442.25 630.146 1442.25 629.098C1442.25 628.049 1441.4 627.184 1440.34 627.184Z"
            fill="white"
          />
          <path
            d="M1440.32 644.377C1439.27 644.377 1438.41 645.23 1438.41 646.291C1438.41 647.352 1439.27 648.205 1440.32 648.205C1441.37 648.205 1442.23 647.352 1442.23 646.291C1442.23 645.23 1441.38 644.377 1440.32 644.377Z"
            fill="white"
          />
          <path
            d="M1441.02 661.996C1439.96 661.996 1439.09 662.862 1439.09 663.923C1439.09 664.984 1439.96 665.849 1441.02 665.849C1442.08 665.849 1442.95 664.984 1442.95 663.923C1442.95 662.862 1442.08 661.996 1441.02 661.996Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
};

export default SalesmateBGIcon;
